/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 970);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Public interface
var S = function S(fn, value) {
    var node = new ComputationNode(fn, value);
    return function computation() {
        return node.current();
    };
};
// compatibility with commonjs systems that expect default export to be at require('s.js').default rather than just require('s-js')
Object.defineProperty(S, 'default', { value: S });
/* harmony default export */ __webpack_exports__["default"] = (S);
S.root = function root(fn) {
    var owner = Owner, root = fn.length === 0 ? UNOWNED : new ComputationNode(null, null), result = undefined, disposer = fn.length === 0 ? null : function _dispose() {
        if (RunningClock !== null) {
            RootClock.disposes.add(root);
        }
        else {
            dispose(root);
        }
    };
    Owner = root;
    if (RunningClock === null) {
        result = topLevelRoot(fn, disposer, owner);
    }
    else {
        result = disposer === null ? fn() : fn(disposer);
        Owner = owner;
    }
    return result;
};
function topLevelRoot(fn, disposer, owner) {
    try {
        return disposer === null ? fn() : fn(disposer);
    }
    finally {
        Owner = owner;
    }
}
S.on = function on(ev, fn, seed, onchanges) {
    if (Array.isArray(ev))
        ev = callAll(ev);
    onchanges = !!onchanges;
    return S(on, seed);
    function on(value) {
        var running = RunningNode;
        ev();
        if (onchanges)
            onchanges = false;
        else {
            RunningNode = null;
            value = fn(value);
            RunningNode = running;
        }
        return value;
    }
};
function callAll(ss) {
    return function all() {
        for (var i = 0; i < ss.length; i++)
            ss[i]();
    };
}
S.effect = function effect(fn, value) {
    new ComputationNode(fn, value);
};
S.data = function data(value) {
    var node = new DataNode(value);
    return function data(value) {
        if (arguments.length === 0) {
            return node.current();
        }
        else {
            return node.next(value);
        }
    };
};
S.value = function value(current, eq) {
    var data = S.data(current), age = -1;
    return function value(update) {
        if (arguments.length === 0) {
            return data();
        }
        else {
            var same = eq ? eq(current, update) : current === update;
            if (!same) {
                var time = RootClock.time;
                if (age === time)
                    throw new Error("conflicting values: " + update + " is not the same as " + current);
                age = time;
                current = update;
                data(update);
            }
            return update;
        }
    };
};
S.freeze = function freeze(fn) {
    var result = undefined;
    if (RunningClock !== null) {
        result = fn();
    }
    else {
        RunningClock = RootClock;
        RunningClock.changes.reset();
        try {
            result = fn();
            event();
        }
        finally {
            RunningClock = null;
        }
    }
    return result;
};
S.sample = function sample(fn) {
    var result, running = RunningNode;
    if (running !== null) {
        RunningNode = null;
        result = fn();
        RunningNode = running;
    }
    else {
        result = fn();
    }
    return result;
};
S.cleanup = function cleanup(fn) {
    if (Owner !== null) {
        if (Owner.cleanups === null)
            Owner.cleanups = [fn];
        else
            Owner.cleanups.push(fn);
    }
    else {
        console.warn("cleanups created without a root or parent will never be run");
    }
};
// experimental : exposing node constructors and some state
S.makeDataNode = function makeDataNode(value) {
    return new DataNode(value);
};
S.makeComputationNode = function makeComputationNode(fn, seed) {
    return new ComputationNode(fn, seed);
};
S.isFrozen = function isFrozen() {
    return RunningClock !== null;
};
S.isListening = function isListening() {
    return RunningNode !== null;
};
// Internal implementation
/// Graph classes and operations
var Clock = /** @class */ (function () {
    function Clock() {
        this.time = 0;
        this.changes = new Queue(); // batched changes to data nodes
        this.updates = new Queue(); // computations to update
        this.disposes = new Queue(); // disposals to run after current batch of updates finishes
    }
    return Clock;
}());
var RootClockProxy = {
    time: function () { return RootClock.time; }
};
var DataNode = /** @class */ (function () {
    function DataNode(value) {
        this.value = value;
        this.pending = NOTPENDING;
        this.log = null;
    }
    DataNode.prototype.current = function () {
        if (RunningNode !== null) {
            logDataRead(this, RunningNode);
        }
        return this.value;
    };
    DataNode.prototype.next = function (value) {
        if (RunningClock !== null) {
            if (this.pending !== NOTPENDING) { // value has already been set once, check for conflicts
                if (value !== this.pending) {
                    throw new Error("conflicting changes: " + value + " !== " + this.pending);
                }
            }
            else { // add to list of changes
                this.pending = value;
                RootClock.changes.add(this);
            }
        }
        else { // not batching, respond to change now
            if (this.log !== null) {
                this.pending = value;
                RootClock.changes.add(this);
                event();
            }
            else {
                this.value = value;
            }
        }
        return value;
    };
    DataNode.prototype.clock = function () {
        return RootClockProxy;
    };
    return DataNode;
}());
var ComputationNode = /** @class */ (function () {
    function ComputationNode(fn, value) {
        this.state = CURRENT;
        this.source1 = null;
        this.source1slot = 0;
        this.sources = null;
        this.sourceslots = null;
        this.log = null;
        this.owned = null;
        this.cleanups = null;
        this.fn = fn;
        this.value = value;
        this.age = RootClock.time;
        if (fn === null)
            return;
        var owner = Owner, running = RunningNode;
        if (owner === null)
            console.warn("computations created without a root or parent will never be disposed");
        Owner = RunningNode = this;
        if (RunningClock === null) {
            toplevelComputation(this);
        }
        else {
            this.value = this.fn(this.value);
        }
        if (owner && owner !== UNOWNED) {
            if (owner.owned === null)
                owner.owned = [this];
            else
                owner.owned.push(this);
        }
        Owner = owner;
        RunningNode = running;
    }
    ComputationNode.prototype.current = function () {
        if (RunningNode !== null) {
            if (this.age === RootClock.time) {
                if (this.state === RUNNING)
                    throw new Error("circular dependency");
                else
                    updateNode(this); // checks for state === STALE internally, so don't need to check here
            }
            logComputationRead(this, RunningNode);
        }
        return this.value;
    };
    ComputationNode.prototype.clock = function () {
        return RootClockProxy;
    };
    return ComputationNode;
}());
var Log = /** @class */ (function () {
    function Log() {
        this.node1 = null;
        this.node1slot = 0;
        this.nodes = null;
        this.nodeslots = null;
    }
    return Log;
}());
var Queue = /** @class */ (function () {
    function Queue() {
        this.items = [];
        this.count = 0;
    }
    Queue.prototype.reset = function () {
        this.count = 0;
    };
    Queue.prototype.add = function (item) {
        this.items[this.count++] = item;
    };
    Queue.prototype.run = function (fn) {
        var items = this.items;
        for (var i = 0; i < this.count; i++) {
            fn(items[i]);
            items[i] = null;
        }
        this.count = 0;
    };
    return Queue;
}());
// Constants
var NOTPENDING = {}, CURRENT = 0, STALE = 1, RUNNING = 2;
// "Globals" used to keep track of current system state
var RootClock = new Clock(), RunningClock = null, // currently running clock 
RunningNode = null, // currently running computation
Owner = null, // owner for new computations
UNOWNED = new ComputationNode(null, null);
// Functions
function logRead(from, to) {
    var fromslot, toslot = to.source1 === null ? -1 : to.sources === null ? 0 : to.sources.length;
    if (from.node1 === null) {
        from.node1 = to;
        from.node1slot = toslot;
        fromslot = -1;
    }
    else if (from.nodes === null) {
        from.nodes = [to];
        from.nodeslots = [toslot];
        fromslot = 0;
    }
    else {
        fromslot = from.nodes.length;
        from.nodes.push(to);
        from.nodeslots.push(toslot);
    }
    if (to.source1 === null) {
        to.source1 = from;
        to.source1slot = fromslot;
    }
    else if (to.sources === null) {
        to.sources = [from];
        to.sourceslots = [fromslot];
    }
    else {
        to.sources.push(from);
        to.sourceslots.push(fromslot);
    }
}
function logDataRead(data, to) {
    if (data.log === null)
        data.log = new Log();
    logRead(data.log, to);
}
function logComputationRead(node, to) {
    if (node.log === null)
        node.log = new Log();
    logRead(node.log, to);
}
function event() {
    // b/c we might be under a top level S.root(), have to preserve current root
    var owner = Owner;
    RootClock.updates.reset();
    RootClock.time++;
    try {
        run(RootClock);
    }
    finally {
        RunningClock = RunningNode = null;
        Owner = owner;
    }
}
function toplevelComputation(node) {
    RunningClock = RootClock;
    RootClock.changes.reset();
    RootClock.updates.reset();
    try {
        node.value = node.fn(node.value);
        if (RootClock.changes.count > 0 || RootClock.updates.count > 0) {
            RootClock.time++;
            run(RootClock);
        }
    }
    finally {
        RunningClock = Owner = RunningNode = null;
    }
}
function run(clock) {
    var running = RunningClock, count = 0;
    RunningClock = clock;
    clock.disposes.reset();
    // for each batch ...
    while (clock.changes.count !== 0 || clock.updates.count !== 0 || clock.disposes.count !== 0) {
        if (count > 0) // don't tick on first run, or else we expire already scheduled updates
            clock.time++;
        clock.changes.run(applyDataChange);
        clock.updates.run(updateNode);
        clock.disposes.run(dispose);
        // if there are still changes after excessive batches, assume runaway            
        if (count++ > 1e5) {
            throw new Error("Runaway clock detected");
        }
    }
    RunningClock = running;
}
function applyDataChange(data) {
    data.value = data.pending;
    data.pending = NOTPENDING;
    if (data.log)
        markComputationsStale(data.log);
}
function markComputationsStale(log) {
    var node1 = log.node1, nodes = log.nodes;
    // mark all downstream nodes stale which haven't been already
    if (node1 !== null)
        markNodeStale(node1);
    if (nodes !== null) {
        for (var i = 0, len = nodes.length; i < len; i++) {
            markNodeStale(nodes[i]);
        }
    }
}
function markNodeStale(node) {
    var time = RootClock.time;
    if (node.age < time) {
        node.age = time;
        node.state = STALE;
        RootClock.updates.add(node);
        if (node.owned !== null)
            markOwnedNodesForDisposal(node.owned);
        if (node.log !== null)
            markComputationsStale(node.log);
    }
}
function markOwnedNodesForDisposal(owned) {
    for (var i = 0; i < owned.length; i++) {
        var child = owned[i];
        child.age = RootClock.time;
        child.state = CURRENT;
        if (child.owned !== null)
            markOwnedNodesForDisposal(child.owned);
    }
}
function updateNode(node) {
    if (node.state === STALE) {
        var owner = Owner, running = RunningNode;
        Owner = RunningNode = node;
        node.state = RUNNING;
        cleanup(node, false);
        node.value = node.fn(node.value);
        node.state = CURRENT;
        Owner = owner;
        RunningNode = running;
    }
}
function cleanup(node, final) {
    var source1 = node.source1, sources = node.sources, sourceslots = node.sourceslots, cleanups = node.cleanups, owned = node.owned, i, len;
    if (cleanups !== null) {
        for (i = 0; i < cleanups.length; i++) {
            cleanups[i](final);
        }
        node.cleanups = null;
    }
    if (owned !== null) {
        for (i = 0; i < owned.length; i++) {
            dispose(owned[i]);
        }
        node.owned = null;
    }
    if (source1 !== null) {
        cleanupSource(source1, node.source1slot);
        node.source1 = null;
    }
    if (sources !== null) {
        for (i = 0, len = sources.length; i < len; i++) {
            cleanupSource(sources.pop(), sourceslots.pop());
        }
    }
}
function cleanupSource(source, slot) {
    var nodes = source.nodes, nodeslots = source.nodeslots, last, lastslot;
    if (slot === -1) {
        source.node1 = null;
    }
    else {
        last = nodes.pop();
        lastslot = nodeslots.pop();
        if (slot !== nodes.length) {
            nodes[slot] = last;
            nodeslots[slot] = lastslot;
            if (lastslot === -1) {
                last.source1slot = slot;
            }
            else {
                last.sourceslots[lastslot] = slot;
            }
        }
    }
}
function dispose(node) {
    node.fn = null;
    node.log = null;
    cleanup(node, true);
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonableObservable = void 0;
// add a .toJSON() to an observable so that it will serialize its value to JSON
function jsonableObservable(obs) {
    if (typeof obs !== 'function')
        throw "jsonable: must be a function";
    obs.toJSON = toJSON;
    return obs;
}
exports.jsonableObservable = jsonableObservable;
function toJSON() {
    var json = this();
    // if we shadowed the value's own toJSON, call it now
    if (json && json.toJSON)
        json = json.toJSON();
    return json;
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(126);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = SArray;
/* harmony export (immutable) */ __webpack_exports__["lift"] = lift;
/* harmony export (immutable) */ __webpack_exports__["mapS"] = mapS;
/* harmony export (immutable) */ __webpack_exports__["mapSample"] = mapSample;
/* harmony export (immutable) */ __webpack_exports__["mapSequentially"] = mapSequentially;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (immutable) */ __webpack_exports__["combine"] = combine;
/* harmony export (immutable) */ __webpack_exports__["map"] = map;
/* harmony export (immutable) */ __webpack_exports__["find"] = find;
/* harmony export (immutable) */ __webpack_exports__["includes"] = includes;
/* harmony export (immutable) */ __webpack_exports__["sort"] = sort;
/* harmony export (immutable) */ __webpack_exports__["orderBy"] = orderBy;
/* harmony export (immutable) */ __webpack_exports__["filter"] = filter;
/* harmony export (immutable) */ __webpack_exports__["concat"] = concat;
/* harmony export (immutable) */ __webpack_exports__["reduce"] = reduce;
/* harmony export (immutable) */ __webpack_exports__["reduceRight"] = reduceRight;
/* harmony export (immutable) */ __webpack_exports__["every"] = every;
/* harmony export (immutable) */ __webpack_exports__["some"] = some;
/* harmony export (immutable) */ __webpack_exports__["reverse"] = reverse;
/* harmony export (immutable) */ __webpack_exports__["slice"] = slice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_s_js__ = __webpack_require__(0);
// synchronous array signals for S.js

function SArray(values) {
    if (!Array.isArray(values))
        throw new Error("SArray must be initialized with an array");
    var dirty = __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].data(false), mutations = [], mutcount = 0, pops = 0, shifts = 0, data = __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].root(function () { return __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].on(dirty, update, values, true); });
    // add mutators
    var array = function array(newvalues) {
        if (arguments.length > 0) {
            mutation(function array() { values = newvalues; });
            return newvalues;
        }
        else {
            return data();
        }
    };
    array.push = push;
    array.pop = pop;
    array.unshift = unshift;
    array.shift = shift;
    array.splice = splice;
    // not ES5
    array.remove = remove;
    array.removeAll = removeAll;
    lift(array);
    return array;
    function mutation(m) {
        mutations[mutcount++] = m;
        dirty(true);
    }
    function update() {
        if (pops)
            values.splice(values.length - pops, pops);
        if (shifts)
            values.splice(0, shifts);
        pops = 0;
        shifts = 0;
        for (var i = 0; i < mutcount; i++) {
            mutations[i]();
            mutations[i] = null;
        }
        mutcount = 0;
        return values;
    }
    // mutators
    function push(item) {
        mutation(function push() { values.push(item); });
        return array;
    }
    function pop() {
        array();
        if ((pops + shifts) < values.length) {
            var value = values[values.length - ++pops];
            dirty(true);
            return value;
        }
    }
    function unshift(item) {
        mutation(function unshift() { values.unshift(item); });
        return array;
    }
    function shift() {
        array();
        if ((pops + shifts) < values.length) {
            var value = values[shifts++];
            dirty(true);
            return value;
        }
    }
    function splice( /* arguments */) {
        var args = Array.prototype.slice.call(arguments);
        mutation(function splice() { Array.prototype.splice.apply(values, args); });
        return array;
    }
    function remove(item) {
        mutation(function remove() {
            for (var i = 0; i < values.length; i++) {
                if (values[i] === item) {
                    values.splice(i, 1);
                    break;
                }
            }
        });
        return array;
    }
    function removeAll(item) {
        mutation(function removeAll() {
            for (var i = 0; i < values.length;) {
                if (values[i] === item) {
                    values.splice(i, 1);
                }
                else {
                    i++;
                }
            }
        });
        return array;
    }
}
// util to add transformer methods
function lift(seq) {
    var _seq = seq;
    _seq.concat = chainConcat;
    _seq.every = chainEvery;
    _seq.filter = chainFilter;
    _seq.find = chainFind;
    //s.findIndex = findIndex;
    _seq.forEach = chainForEach;
    _seq.includes = chainIncludes;
    //s.indexOf   = indexOf;
    //s.join      = join;
    //s.lastIndexOf = lastIndexOf;
    _seq.map = chainMap;
    _seq.sort = chainSort;
    _seq.reduce = chainReduce;
    _seq.reduceRight = chainReduceRight;
    _seq.reverse = chainReverse;
    _seq.slice = chainSlice;
    _seq.some = chainSome;
    // non-ES5 transformers
    _seq.mapS = chainMapS;
    _seq.mapSample = chainMapSample;
    _seq.mapSequentially = chainMapSequentially;
    _seq.orderBy = chainOrderBy;
    return _seq;
}
function mapS(seq, enter, exit, move) {
    var items = [], mapped = [], disposers = [], len = 0;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function () { __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].cleanup(function () { disposers.forEach(function (d) { d(); }); }); });
    return __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].on(seq, function mapS() {
        var new_items = seq(), new_len = new_items.length, temp = new Array(new_len), tempdisposers = new Array(new_len), from = null, to = null, i, j, k, item;
        if (move)
            from = [], to = [];
        // 1) step through all old items and see if they can be found in the new set; if so, save them in a temp array and mark them moved; if not, exit them
        NEXT: for (i = 0, k = 0; i < len; i++) {
            item = items[i];
            for (j = 0; j < new_len; j++, k = (k + 1) % new_len) {
                if (item === new_items[k] && !temp.hasOwnProperty(k.toString())) {
                    temp[k] = mapped[i];
                    tempdisposers[k] = disposers[i];
                    if (move && i !== k) {
                        from.push(i);
                        to.push(k);
                    }
                    k = (k + 1) % new_len;
                    continue NEXT;
                }
            }
            if (exit)
                exit(item, mapped[i](), i);
            disposers[i]();
        }
        if (move && from.length)
            move(items, mapped, from, to);
        // 2) set all the new values, pulling from the temp array if copied, otherwise entering the new value
        for (i = 0; i < new_len; i++) {
            if (temp.hasOwnProperty(i.toString())) {
                mapped[i] = temp[i];
                disposers[i] = tempdisposers[i];
            }
            else {
                mapped[i] = __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].root(mapper);
            }
        }
        // 3) in case the new set is shorter than the old, set the length of the mapped array
        len = mapped.length = new_len;
        // 4) save a copy of the mapped items for the next update
        items = new_items.slice();
        return mapped;
        function mapper(disposer) {
            disposers[i] = disposer;
            var _item = new_items[i], _i = i;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function (value) { return enter(_item, value, _i); }, undefined);
        }
    });
}
function chainMapS(enter, exit, move) {
    var r = lift(mapS(this, enter, exit, move));
    r.combine = chainCombine;
    return r;
}
function mapSample(seq, enter, exit, move) {
    var items = [], mapped = [], disposers = [], len = 0;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function () { __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].cleanup(function () { disposers.forEach(function (d) { d(); }); }); });
    return __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].on(seq, function mapSample() {
        var new_items = seq(), new_len = new_items.length, new_indices, new_indices_next, temp, tempdisposers, from = null, to = null, i, j, start, end, new_end, item;
        // fast path for empty arrays
        if (new_len === 0) {
            if (len !== 0) {
                if (exit !== undefined) {
                    for (i = 0; i < len; i++) {
                        item = items[i];
                        exit(item, mapped[i], i);
                        disposers[i]();
                    }
                }
                else {
                    for (i = 0; i < len; i++) {
                        disposers[i]();
                    }
                }
                items = [];
                mapped = [];
                disposers = [];
                len = 0;
            }
        }
        else if (len === 0) {
            for (j = 0; j < new_len; j++) {
                items[j] = new_items[j];
                mapped[j] = __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].root(mapper);
            }
            len = new_len;
        }
        else {
            new_indices = new Map();
            temp = new Array(new_len);
            tempdisposers = new Array(new_len);
            if (move)
                from = [], to = [];
            // skip common prefix and suffix
            for (start = 0, end = Math.min(len, new_len); start < end && items[start] === new_items[start]; start++)
                ;
            for (end = len - 1, new_end = new_len - 1; end >= 0 && new_end >= 0 && items[end] === new_items[new_end]; end--, new_end--) {
                temp[new_end] = mapped[end];
                tempdisposers[new_end] = disposers[end];
            }
            // 0) prepare a map of all indices in new_items, scanning backwards so we encounter them in natural order
            new_indices_next = new Array(new_end + 1);
            for (j = new_end; j >= start; j--) {
                item = new_items[j];
                i = new_indices.get(item);
                new_indices_next[j] = i === undefined ? -1 : i;
                new_indices.set(item, j);
            }
            // 1) step through all old items and see if they can be found in the new set; if so, save them in a temp array and mark them moved; if not, exit them
            for (i = start; i <= end; i++) {
                item = items[i];
                j = new_indices.get(item);
                if (j !== undefined && j !== -1) {
                    temp[j] = mapped[i];
                    tempdisposers[j] = disposers[i];
                    if (move && i !== j) {
                        from.push(i);
                        to.push(j);
                    }
                    j = new_indices_next[j];
                    new_indices.set(item, j);
                }
                else {
                    if (exit)
                        exit(item, mapped[i], i);
                    disposers[i]();
                }
            }
            if (move && (from.length !== 0 || end !== len - 1)) {
                end++, new_end++;
                while (end < len) {
                    from.push(end++);
                    to.push(new_end++);
                }
                move(items, mapped, from, to);
            }
            // 2) set all the new values, pulling from the temp array if copied, otherwise entering the new value
            for (j = start; j < new_len; j++) {
                if (temp.hasOwnProperty(j)) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                }
                else {
                    mapped[j] = __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].root(mapper);
                }
            }
            // 3) in case the new set is shorter than the old, set the length of the mapped array
            len = mapped.length = new_len;
            // 4) save a copy of the mapped items for the next update
            items = new_items.slice();
        }
        return mapped;
        function mapper(disposer) {
            disposers[j] = disposer;
            return enter(new_items[j], mapped[j], j);
        }
    });
}
function chainMapSample(enter, exit, move) {
    return lift(mapSample(this, enter, exit, move));
}
function mapSequentially(seq, update) {
    var mapped = [];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function mapSequentially() {
        var s = seq();
        for (var i = 0; i < s.length; i++) {
            mapped[i] = update(s[i], mapped[i], i);
        }
        if (mapped.length > s.length)
            mapped.length = s.length;
        return mapped;
    });
}
function chainMapSequentially(enter) {
    return lift(mapSequentially(this, enter));
}
function forEach(seq, enter, exit, move) {
    var items = [], len = 0;
    return __WEBPACK_IMPORTED_MODULE_0_s_js__["default"].on(seq, function forEach() {
        var new_items = seq(), new_len = new_items.length, found = new Array(new_len), from = [], to = [], i, j, k, item;
        // 1) step through all old items and see if they can be found in the new set; if so, save them in a temp array and mark them moved; if not, exit them
        NEXT: for (i = 0, k = 0; i < len; i++) {
            item = items[i];
            for (j = 0; j < new_len; j++, k = (k + 1) % new_len) {
                if (item === new_items[k] && !found[k]) {
                    found[k] = true;
                    if (i !== k) {
                        from.push(i);
                        to.push(k);
                    }
                    k = (k + 1) % new_len;
                    continue NEXT;
                }
            }
            if (exit)
                exit(item, i);
        }
        if (move && from.length)
            move(from, to);
        // 2) set all the new values, pulling from the temp array if copied, otherwise entering the new value
        for (var i = 0; i < new_len; i++) {
            if (!found[i])
                enter(new_items[i], i);
        }
        // 3) in case the new set is shorter than the old, set the length of the mapped array
        len = new_len;
        // 4) save a copy of the mapped items for the next update
        items = new_items.slice();
        return items;
    });
}
function chainForEach(enter, exit, move) {
    return lift(forEach(this, enter, exit, move));
}
function combine(seq) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function combine() {
        var s = seq(), result = new Array(s.length);
        for (var i = 0; i < s.length; i++) {
            result[i] = s[i]();
        }
        return result;
    });
}
function chainCombine() {
    return lift(combine(this));
}
function map(seq, enter, exit, move) {
    return combine(mapS(seq, enter, exit, move == undefined ? undefined :
        function (items, mapped, from, to) { move(items, mapped.map(function (s) { return s(); }), from, to); }));
}
function chainMap(enter, exit, move) {
    return lift(map(this, enter, exit, move));
}
function find(seq, pred) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function find() {
        var s = seq(), i, item;
        for (i = 0; i < s.length; i++) {
            item = s[i];
            if (pred(item))
                return item;
        }
        return undefined;
    });
}
function chainFind(pred) {
    return find(this, pred);
}
function includes(seq, o) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function find() {
        var s = seq();
        for (var i = 0; i < s.length; i++) {
            if (s[i] === o)
                return true;
        }
        return false;
    });
}
function chainIncludes(o) {
    return includes(this, o);
}
function sort(seq, fn) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function sort() {
        var copy = seq().slice(0);
        if (fn)
            copy.sort(fn);
        else
            copy.sort();
        return copy;
    });
}
function chainSort(fn) {
    return lift(sort(this, fn));
}
function orderBy(seq, by) {
    var key, fn;
    if (typeof by !== 'function') {
        key = by;
        fn = function (o) { return o[key]; };
    }
    else {
        fn = by;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function orderBy() {
        var copy = seq().slice(0);
        copy.sort(function (a, b) {
            a = fn(a);
            b = fn(b);
            return a < b ? -1 : a > b ? 1 : 0;
        });
        return copy;
    });
}
function chainOrderBy(by) {
    return lift(orderBy(this, by));
}
function filter(seq, predicate) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function filter() {
        var s = seq(), result = [], i, v;
        for (i = 0; i < s.length; i++) {
            v = s[i];
            if (predicate(v))
                result.push(v);
        }
        return result;
    });
}
function chainFilter(predicate) {
    return lift(filter(this, predicate));
}
function concat(seq) {
    var others = [];
    for (var _a = 1; _a < arguments.length; _a++) {
        others[_a - 1] = arguments[_a];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function concat() {
        var s = seq();
        for (var i = 0; i < others.length; i++) {
            s = s.concat(others[i]());
        }
        return s;
    });
}
function chainConcat() {
    var others = [];
    for (var _a = 0; _a < arguments.length; _a++) {
        others[_a] = arguments[_a];
    }
    return lift(concat.apply(void 0, [this].concat(others)));
}
function reduce(seq, fn, seed) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function reduce() {
        var s = seq(), result = seed instanceof Function ? seed() : seed;
        for (var i = 0; i < s.length; i++) {
            result = fn(result, s[i], i, s);
        }
        return result;
    });
}
function chainReduce(fn, seed) {
    return reduce(this, fn, seed);
}
function reduceRight(seq, fn, seed) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function reduceRight() {
        var s = seq(), result = seed instanceof Function ? seed() : seed;
        for (var i = s.length - 1; i >= 0; i--) {
            result = fn(result, s[i], i, s);
        }
        return result;
    });
}
function chainReduceRight(fn, seed) {
    return reduceRight(this, fn, seed);
}
function every(seq, fn) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function every() {
        var s = seq();
        for (var i = 0; i < s.length; i++) {
            if (!fn(s[i]))
                return false;
        }
        return true;
    });
}
function chainEvery(fn) {
    return every(this, fn);
}
function some(seq, fn) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function some() {
        var s = seq();
        if (fn === undefined)
            return s.length !== 0;
        for (var i = 0; i < s.length; i++) {
            if (fn(s[i]))
                return true;
        }
        return false;
    });
}
function chainSome(fn) {
    return some(this, fn);
}
function reverse(seq) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function () {
        var copy = seq().slice(0);
        copy.reverse();
        return copy;
    });
}
function chainReverse() {
    return lift(reverse(this));
}
function slice(seq, s, e) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_s_js__["default"])(function () {
        return seq().slice(s, e);
    });
}
function chainSlice(s, e) {
    return lift(slice(this, s, e));
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperCriticalReference = exports.SuperCriticalComponent = void 0;
var s_js_1 = __webpack_require__(0);
var React = __webpack_require__(2);
function SuperCritical(render) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.srender = function (props) {
            return render(props);
        };
        return class_1;
    }(SuperCriticalComponent));
}
exports.default = SuperCritical;
;
var SuperCriticalComponent = /** @class */ (function (_super) {
    __extends(SuperCriticalComponent, _super);
    function SuperCriticalComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { view: null };
        _this._sprops = s_js_1.default.data(props);
        _this.sprops = function () { return _this._sprops(); };
        var isMounted = false;
        var mountedEv = s_js_1.default.data(null);
        // Avoiding a normal S.value to work-around a subtle timing bug: It can be the case that a component
        // receives a componentWillUnmount event immediately after a componentWillReceiveProps event but
        // BEFORE S has re-run our srender computation below in response to the props change. If that happens,
        // we wanna let readers, including our srender computation below, know that the component is being
        // unmounted as soon as we do, even in situations where a normal S.value would hold of on notifying
        // users of the new value until the next tick of S's clock. Otherwise, calling certain methods like
        // setState on an already-unmounting component produces noisy React warnings in the dev console.
        _this._smounted = function (val) { return val === undefined ?
            (mountedEv(), isMounted) :
            (isMounted = val, mountedEv(null), isMounted); };
        _this.smounted = function () { return _this._smounted(); };
        s_js_1.default.root(function () { return s_js_1.default(function () { return _this.smounted() && _this.setState({ view: _this.srender(_this.sprops()) }); }); });
        return _this;
    }
    SuperCriticalComponent.prototype.componentWillMount = function () {
        this._smounted(true);
    };
    SuperCriticalComponent.prototype.componentWillReceiveProps = function (props) {
        if (!propsEq(this.props, props))
            this._sprops(props);
    };
    SuperCriticalComponent.prototype.componentWillUnmount = function () {
        this._smounted(false);
    };
    SuperCriticalComponent.prototype.render = function () {
        return this.state.view;
    };
    return SuperCriticalComponent;
}(React.Component));
exports.SuperCriticalComponent = SuperCriticalComponent;
var SuperCriticalReference = function (cmp, init, destroy) {
    var el = null, event = s_js_1.default.data(null), ref = function (_el) { el = _el; event(null); };
    s_js_1.default.root(function () { return s_js_1.default(function (prevEl) {
        event();
        if (el)
            init(cmp.sprops(), el);
        else if (prevEl && destroy)
            destroy(prevEl);
        return el;
    }, null); });
    return ref;
};
exports.SuperCriticalReference = SuperCriticalReference;
function propsEq(a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key) && a[key] !== b[key])
            return false;
    }
    return true;
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(44);
var hide = __webpack_require__(47);
var redefine = __webpack_require__(50);
var ctx = __webpack_require__(53);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(625)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.4';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)(module)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// Typescript es5 bug workaround
// The Date object doesn't follow Typescript's expectations about how a super class behaves.
// In particulary, TS, when targetting es5, transpiles inheritance into a call to super.call(this).  
// Date returns a *string* in that scenario, not a Date object, which causes problems down the line.
// _Date intercepts the call to super() and returns null, which causes TS's transpiled code to revert to the actual 'this'
// object instead of hte string returned by null.
var _Date = /** @class */ (function (_super) {
    __extends(_Date, _super);
    function _Date() {
        var _this = _super.call(this) || this;
        return null;
    }
    return _Date;
}(Date));
var TZDate = /** @class */ (function (_super) {
    __extends(TZDate, _super);
    function TZDate(arg1, arg2) {
        var _this = _super.call(this) || this;
        var local, utc, offset, d, str, m, secs, msecs;
        if (arguments.length === 0) {
            msecs = Date.now();
            utc = new Date(msecs);
            offset = utc.getTimezoneOffset();
            local = new Date(msecs - offset * 60000);
        }
        else if (arguments.length === 1 && arg1 instanceof TZDate) {
            d = arg1;
            local = new Date(d._local.getTime());
            utc = new Date(d._utc.getTime());
            offset = d._offset;
        }
        else if (arguments.length === 1 && typeof arg1 === 'number') {
            msecs = arg1;
            utc = new Date(msecs);
            offset = utc.getTimezoneOffset();
            local = new Date(msecs - offset * 60000);
        }
        else if (arguments.length === 1 && typeof arg1 === 'string') {
            str = arg1;
            if (m = ISO8601ZPattern.exec(str)) {
                // ISO8601 time string ending in 'Z' for UTC time
                secs = +m[6] || 0;
                msecs = Math.round((secs - Math.floor(secs)) * 1000);
                secs = Math.floor(secs);
                utc = new Date(Date.UTC(+m[1] || 0, (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, secs, msecs));
                local = new Date(+utc);
                offset = 0;
            }
            else if (m = ISO8601OffsetPattern.exec(str)) {
                // time string ends in a numeric offset, like "+05:00"
                secs = +m[6] || 0;
                msecs = Math.round((secs - Math.floor(secs)) * 1000);
                secs = Math.floor(secs);
                local = new Date(Date.UTC(+m[1] || 0, (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, secs, msecs));
                offset = (m[7] === '-' ? 1 : -1) * (+m[8] * 60 + (+m[9] || 0));
                utc = new Date(+local + offset * 60000);
            }
            else if (m = DotNetOffsetPattern.exec(str)) {
                utc = new Date(+m[1]);
                offset = +m[2] || 0;
                local = new Date(+utc - offset * 60000);
            }
            else {
                // no timezone info in string, use ambient timezone
                local = new Date(str);
                offset = local.getTimezoneOffset();
                utc = new Date(+local + offset * 60000);
            }
        }
        else if (arguments.length === 2 && typeof arg1 === 'number' && typeof arg2 === 'number') {
            msecs = arg1;
            utc = new Date(msecs);
            offset = arg2;
            local = new Date(msecs - offset * 60000);
        }
        else {
            throw new Error("TZDate: unrecognized parameters");
        }
        _this._local = local;
        _this._utc = utc;
        _this._offset = offset;
        return _this;
    }
    TZDate.prototype.getDate = function () { return this._local.getUTCDate(); };
    ;
    TZDate.prototype.getDay = function () { return this._local.getUTCDay(); };
    ;
    TZDate.prototype.getFullYear = function () { return this._local.getUTCFullYear(); };
    ;
    TZDate.prototype.getHours = function () { return this._local.getUTCHours(); };
    ;
    TZDate.prototype.getMilliseconds = function () { return this._local.getUTCMilliseconds(); };
    ;
    TZDate.prototype.getMinutes = function () { return this._local.getUTCMinutes(); };
    ;
    TZDate.prototype.getMonth = function () { return this._local.getUTCMonth(); };
    ;
    TZDate.prototype.getSeconds = function () { return this._local.getUTCSeconds(); };
    ;
    TZDate.prototype.getYear = function () { return this._local.getUTCFullYear() - 1900; };
    ;
    TZDate.prototype.getUTCDate = function () { return this._utc.getUTCDate(); };
    ;
    TZDate.prototype.getUTCDay = function () { return this._utc.getUTCDay(); };
    ;
    TZDate.prototype.getUTCFullYear = function () { return this._utc.getUTCFullYear(); };
    ;
    TZDate.prototype.getUTCHours = function () { return this._utc.getUTCHours(); };
    ;
    TZDate.prototype.getUTCMilliseconds = function () { return this._utc.getUTCMilliseconds(); };
    ;
    TZDate.prototype.getUTCMinutes = function () { return this._utc.getUTCMinutes(); };
    ;
    TZDate.prototype.getUTCMonth = function () { return this._utc.getUTCMonth(); };
    ;
    TZDate.prototype.getUTCSeconds = function () { return this._utc.getUTCSeconds(); };
    ;
    TZDate.prototype.setDate = function (n) { this._local.setUTCDate(n); return this.syncDates(false); };
    TZDate.prototype.setFullYear = function (n) { this._local.setUTCFullYear(n); return this.syncDates(false); };
    TZDate.prototype.setHours = function (n) { this._local.setUTCHours(n); return this.syncDates(false); };
    TZDate.prototype.setMilliseconds = function (n) { this._local.setUTCMilliseconds(n); return this.syncDates(false); };
    TZDate.prototype.setMinutes = function (n) { this._local.setUTCMinutes(n); return this.syncDates(false); };
    TZDate.prototype.setMonth = function (n) { this._local.setUTCMonth(n); return this.syncDates(false); };
    TZDate.prototype.setSeconds = function (n) { this._local.setUTCSeconds(n); return this.syncDates(false); };
    TZDate.prototype.setYear = function (n) { this._local.setUTCFullYear(n + 1900); return this.syncDates(false); };
    TZDate.prototype.setUTCDate = function (n) { this._utc.setUTCDate(n); return this.syncDates(true); };
    TZDate.prototype.setUTCFullYear = function (n) { this._utc.setUTCFullYear(n); return this.syncDates(true); };
    TZDate.prototype.setUTCHours = function (n) { this._utc.setUTCHours(n); return this.syncDates(true); };
    TZDate.prototype.setUTCMilliseconds = function (n) { this._utc.setUTCMilliseconds(n); return this.syncDates(true); };
    TZDate.prototype.setUTCMinutes = function (n) { this._utc.setUTCMinutes(n); return this.syncDates(true); };
    TZDate.prototype.setUTCMonth = function (n) { this._utc.setUTCMonth(n); return this.syncDates(true); };
    TZDate.prototype.setUTCSeconds = function (n) { this._utc.setUTCSeconds(n); return this.syncDates(true); };
    TZDate.prototype.getTime = function () { return this._utc.getTime(); };
    TZDate.prototype.setTime = function (n) { this._utc.setTime(n); return this.syncDates(true); };
    TZDate.prototype.getTimezoneOffset = function () { return this._offset; };
    TZDate.prototype.setTimezoneOffset = function (n, changeUtc) {
        if (changeUtc === void 0) { changeUtc = false; }
        this._offset = n;
        this.syncDates(!changeUtc);
        return this;
    };
    TZDate.prototype.toBrowserLocalDate = function () { return new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds()); };
    TZDate.prototype.toBrowserUTCDate = function () { return this._utc; };
    TZDate.prototype.toDateString = function () {
        return this.getFullYear()
            + '/' + pad(this.getMonth() + 1, 2, '0')
            + '/' + pad(this.getDate(), 2, '0');
    };
    TZDate.prototype.toISOString = function () {
        var o = this.getTimezoneOffset(), s = this.getFullYear()
            + '-' + pad(this.getMonth() + 1, 2, '0')
            + '-' + pad(this.getDate(), 2, '0')
            + 'T' + pad(this.getHours(), 2, '0')
            + ':' + pad(this.getMinutes(), 2, '0')
            + ':' + pad(this.getSeconds(), 2, '0');
        if (this.getMilliseconds()) {
            s += (this.getMilliseconds() / 1000).toFixed(3).substr(1);
        }
        if (o === 0) {
            s += 'Z';
        }
        else {
            var neg = o < 0, h = Math.floor(Math.abs(o) / 60), m = Math.abs(o) % 60;
            s += (neg ? '+' : '-')
                + pad(h, 2, '0')
                + ':' + pad(m, 2, '0');
        }
        return s;
    };
    TZDate.prototype.toJSON = function () { return this.toISOString(); };
    TZDate.prototype.toLocaleDateString = function () { return this.toDateString(); };
    TZDate.prototype.toLocaleString = function () { return this.toString(); };
    TZDate.prototype.toLocaleTimeString = function () { return this.toTimeString(); };
    TZDate.prototype.toString = function () { return this.toDateString() + ' ' + this.toTimeString(); };
    TZDate.prototype.toTimeString = function () {
        var h = ((this.getHours() + 11) % 12) + 1, pm = this.getHours() > 11;
        return pad(h, 2, '0')
            + ':' + pad(this.getMinutes(), 2, '0')
            + ':' + pad(this.getSeconds(), 2, '0')
            + ' ' + (pm ? 'PM' : 'AM');
    };
    TZDate.prototype.toUTCString = function () { return this._utc.toUTCString(); };
    TZDate.prototype.valueOf = function () { return this._utc.valueOf(); };
    // when a change is made to one date, make a parallel change for the same amount of seconds to the other date
    // parameter is:
    //  d - the date (local or UTC) that is to be synched
    TZDate.prototype.syncDates = function (local) {
        if (local)
            this._local.setTime(this._utc.getTime() - this._offset * 60000);
        else
            this._utc.setTime(this._local.getTime() + this._offset * 60000);
        return +this._utc;
    };
    TZDate.eq = function (a, b) {
        return a.getTime() === b.getTime() && a.getTimezoneOffset() === b.getTimezoneOffset();
    };
    TZDate.nullableEq = function (a, b) {
        return a && b && TZDate.eq(a, b) || !a && !b;
    };
    return TZDate;
}(_Date));
exports.default = TZDate;
// Date match patterns.  Exposed on constructor so other modules may use them if they desire.
var ISO8601ZPattern = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d(?:\.\d+)?))?Z$/, ISO8601OffsetPattern = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d(?:\.\d+)?))?(\+|-| )(\d\d):?(\d\d)?$/, DotNetOffsetPattern = /^Date((\d+)(\+|\-)(\d+))$/;
// pad the given string-convertible item to the given length using the given pad character
function pad(s, len, c) {
    s = s.toString();
    while (s.length < len)
        s = c + s;
    return s;
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.noPropagation = exports.noDefault = void 0;
exports.noDefault = eventWrapper(function (e) { return e.preventDefault(); });
exports.noPropagation = eventWrapper(function (e) { return e.stopPropagation(); });
function eventWrapper(aspect) {
    return function (action) { return function (e) {
        aspect(e);
        action(e);
    }; };
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.tzmomentMod = exports.momentToTZDate = exports.tzmoment = void 0;
var moment = __webpack_require__(6);
var TZDate_1 = __webpack_require__(7);
// Convert a TZDate to a moment object while preserving offset. Suitable for formatting/display.
function tzmoment(date) {
    var json = date instanceof TZDate_1.default ? date.toJSON() : date, 
    // TH 05/02/2017 -- UPDATE: Moment has fixed my bugs w/ parseZone! See:
    // https://github.com/moment/moment/issues/3520
    // https://github.com/moment/moment/pull/3523
    // https://github.com/moment/moment/pull/3643
    m = moment.parseZone(json);
    return m;
}
exports.tzmoment = tzmoment;
// Convert a moment object to a TZDate. Assumes moment object has had offset set correctly.
function momentToTZDate(m) {
    return new TZDate_1.default(+m, -m.utcOffset());
}
exports.momentToTZDate = momentToTZDate;
// Use moment to modify a TZDate and get back a TZDate with the proper offset for the timezone and new date
function tzmomentMod(tzutils, date, operator) {
    var json = date.toJSON(), m = moment.parseZone(json).tz(tzutils.timezone); // tell moment about the timezone, so that operations like .add(1, 'day') can account for DST
    return tzutils.newDate(+operator(m));
}
exports.tzmomentMod = tzmomentMod;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableNullableMeasurement = exports.ImmutableMeasurement = exports.NullableMeasurement = exports.Measurement = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(1498);
/// <summary>
/// Create a Measurement, which is a combination of a number and a unit of measure.
/// Throws an error if the supplied UOM is not recognized, as defined by the UOM module.
/// </summary>
var Measurement = /** @class */ (function (_super) {
    __extends(Measurement, _super);
    function Measurement(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { UOM: UOM_1.default.Foot }) || this;
        if (data && data.UOM !== undefined)
            checkUOM(data.UOM);
        var _UOM = _this.UOM;
        _this.UOM = jsonableObservable_1.jsonableObservable(function (v) {
            return arguments.length > 0 ? (checkUOM(v), _UOM(v)) : _UOM();
        });
        return _this;
    }
    /// <summary>
    /// Add the given measurement to this measurement, returning a new measurement value
    /// If the given value is in an incompatible unit, throws an error.
    /// </summary>
    Measurement.prototype.add = function (m) {
        var _this = this;
        return new ImmutableMeasurement({
            Num: function () { return _this.Num() + conversion(_this.UOM(), m.UOM()) * m.Num(); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by subtracting the given value, where the value may be:
    /// - a value and UOM - foo.subtract(100, UOM.Foot)
    /// - another Measurement object - foo.subtract(bar)
    /// - a number, which is assumed to be in the current UOM - foo.subtract(200)
    /// If the given value is in an incompatible unit, throws an error.
    /// </summary>
    Measurement.prototype.subtract = function (m) {
        var _this = this;
        return new ImmutableMeasurement({
            Num: function () { return _this.Num() - conversion(_this.UOM(), m.UOM()) * m.Num(); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by converting it into the given UOM. 
    /// Throws an error if the given UOM is not compatible with the current one.
    /// </summary>
    Measurement.prototype.convert = function (uom) {
        var _this = this;
        return new ImmutableMeasurement({
            Num: function () { return _this.Num() * conversion(uom, _this.UOM()); },
            UOM: function () { return uom; }
        });
    };
    /// <summary>
    /// Modify the measurement by rounding its Num to the nearest given unit amount.
    /// -- rounding - Number. The unit amount to round to. E.g. 1 to round to nearest whole unit, 10 to round to the nearest 10 units, .01 to round to the nearest 1/100th of a unit, etc.
    /// </summary>
    Measurement.prototype.roundToNearest = function (rounding) {
        var _this = this;
        return new ImmutableMeasurement({
            Num: function () {
                var num = Math.round(_this.Num() / rounding) * rounding, 
                // due to floating point errors, our result might have more decimal places than our
                // rounding number, so fix that here
                roundingDigits = rounding.toString(), decimal = roundingDigits.lastIndexOf('.');
                if (decimal !== -1) {
                    var places = roundingDigits.length - decimal;
                    num = parseFloat(num.toFixed(places));
                }
                return num;
            },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by rounding its number to the number of decimal places given
    /// -- places - Integer. The number of decimal places to round to. Must be between 0 and 20. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed.
    /// Returns -- the original Measurement for chaining
    /// </summary>
    Measurement.prototype.roundToNPlaces = function (places) {
        var _this = this;
        return new ImmutableMeasurement({
            Num: function () { return parseFloat(_this.Num().toFixed(places)); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Set this measurement to the num and UOM of the supplied measurement.
    /// </summary>
    Measurement.prototype.set = function (m) {
        this.Num(+s_js_1.default.sample(m.Num));
        this.UOM(s_js_1.default.sample(m.UOM));
    };
    /// <summary>
    /// Create a readable version of this measurement.  Uses short form of units (ft, not feet).
    /// </summary>
    Measurement.prototype.toString = function (opts) {
        opts = opts || {};
        var units = opts.units !== undefined ? opts.units : true, places = opts.places !== undefined ? opts.places : -1; // -1 === don't do any rounding, display all decimal places in num
        var num = this.Num(), uom = this.UOM();
        if (uom === UOM_1.default.Foot && units)
            return formatFeetAndInches(num, places);
        if (places >= 0)
            num = parseFloat(num.toFixed(places));
        return num.toLocaleString() + (units ? " " + uom : "");
    };
    return Measurement;
}(Measurement_1.Measurement));
exports.Measurement = Measurement;
/// <summary>
/// Create a Measurement, which is a combination of a number and a unit of measure.
/// Throws an error if the supplied UOM is not recognized, as defined by the UOM module.
/// </summary>
var NullableMeasurement = /** @class */ (function (_super) {
    __extends(NullableMeasurement, _super);
    function NullableMeasurement(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || {}) || this;
        if (data && data.UOM !== undefined && data.UOM !== null)
            checkUOM(data.UOM);
        var _UOM = _this.UOM;
        _this.UOM = jsonableObservable_1.jsonableObservable(function (v) {
            return arguments.length > 0 ? (v === null || checkUOM(v), _UOM(v)) : _UOM();
        });
        return _this;
    }
    /// <summary>
    /// Add the given measurement to this measurement, returning a new measurement value
    /// If the given value is in an incompatible unit, throws an error.
    /// </summary>
    NullableMeasurement.prototype.add = function (m) {
        var _this = this;
        return new ImmutableNullableMeasurement({
            Num: function () { return _this.Num() === null || m.Num() === null || _this.UOM() === null || m.UOM() === null ? null : _this.Num() + conversion(_this.UOM(), m.UOM()) * m.Num(); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by subtracting the given value, where the value may be:
    /// - a value and UOM - foo.subtract(100, UOM.Foot)
    /// - another Measurement object - foo.subtract(bar)
    /// - a number, which is assumed to be in the current UOM - foo.subtract(200)
    /// If the given value is in an incompatible unit, throws an error.
    /// </summary>
    NullableMeasurement.prototype.subtract = function (m) {
        var _this = this;
        return new ImmutableNullableMeasurement({
            Num: function () { return _this.Num() === null || m.Num() === null || _this.UOM() === null || m.UOM() === null ? null : _this.Num() - conversion(_this.UOM(), m.UOM()) * m.Num(); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by converting it into the given UOM. 
    /// Throws an error if the given UOM is not compatible with the current one.
    /// </summary>
    NullableMeasurement.prototype.convert = function (uom) {
        var _this = this;
        return new ImmutableNullableMeasurement({
            Num: function () { return _this.Num() === null || _this.UOM() === null || uom === null ? null : _this.Num() * conversion(uom, _this.UOM()); },
            UOM: function () { return uom; }
        });
    };
    /// <summary>
    /// Modify the measurement by rounding its Num to the nearest given unit amount.
    /// -- rounding - Number. The unit amount to round to. E.g. 1 to round to nearest whole unit, 10 to round to the nearest 10 units, .01 to round to the nearest 1/100th of a unit, etc.
    /// </summary>
    NullableMeasurement.prototype.roundToNearest = function (rounding) {
        var _this = this;
        return new ImmutableNullableMeasurement({
            Num: function () {
                var orig = _this.Num(), num = orig === null ? null : Math.round(orig / rounding) * rounding, 
                // due to floating point errors, our result might have more decimal places than our
                // rounding number, so fix that here
                roundingDigits = rounding.toString(), decimal = roundingDigits.lastIndexOf('.');
                if (decimal !== -1 && num !== null) {
                    var places = roundingDigits.length - decimal;
                    num = parseFloat(num.toFixed(places));
                }
                return num;
            },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Modify the measurement by rounding its number to the number of decimal places given
    /// -- places - Integer. The number of decimal places to round to. Must be between 0 and 20. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed.
    /// Returns -- the original Measurement for chaining
    /// </summary>
    NullableMeasurement.prototype.roundToNPlaces = function (places) {
        var _this = this;
        return new ImmutableNullableMeasurement({
            Num: function () { return _this.Num() === null ? null : parseFloat(_this.Num().toFixed(places)); },
            UOM: this.UOM
        });
    };
    /// <summary>
    /// Set this measurement to the num and UOM of the supplied measurement.
    /// </summary>
    NullableMeasurement.prototype.set = function (m) {
        this.Num(s_js_1.default.sample(m.Num));
        this.UOM(s_js_1.default.sample(m.UOM));
    };
    /// <summary>
    /// Create a readable version of this measurement.  Uses short form of units (ft, not feet).
    /// </summary>
    NullableMeasurement.prototype.toString = function (opts) {
        opts = opts || {};
        var units = opts.units !== undefined ? opts.units : true, places = opts.places !== undefined ? opts.places : -1; // -1 === don't do any rounding, display all decimal places in num
        var num = this.Num(), uom = this.UOM();
        if (uom === UOM_1.default.Foot && units)
            return formatFeetAndInches(num, places);
        if (places >= 0 && num !== null)
            num = parseFloat(num.toFixed(places));
        return (num === null ? '--' : num.toLocaleString()) + (units && uom !== null ? " " + uom : "");
    };
    return NullableMeasurement;
}(Measurement_1.NullableMeasurement));
exports.NullableMeasurement = NullableMeasurement;
var ImmutableMeasurement = /** @class */ (function (_super) {
    __extends(ImmutableMeasurement, _super);
    function ImmutableMeasurement(data) {
        var _this = _super.call(this) || this;
        _this.Num = immutable(data.Num, "Num");
        _this.UOM = immutable(data.UOM, "UOM");
        return _this;
    }
    return ImmutableMeasurement;
}(Measurement));
exports.ImmutableMeasurement = ImmutableMeasurement;
var ImmutableNullableMeasurement = /** @class */ (function (_super) {
    __extends(ImmutableNullableMeasurement, _super);
    function ImmutableNullableMeasurement(data) {
        var _this = _super.call(this) || this;
        _this.Num = immutable(data.Num, "Num");
        _this.UOM = immutable(data.UOM, "UOM");
        return _this;
    }
    return ImmutableNullableMeasurement;
}(NullableMeasurement));
exports.ImmutableNullableMeasurement = ImmutableNullableMeasurement;
function conversion(toUom, fromUom) {
    var table = UOM_1.default.Conversion[toUom], ratio = table && table[fromUom];
    if (ratio === undefined)
        throw new Error("Cannot convert units of measure '" + fromUom + "' to ones of '" + toUom + "'.");
    return ratio;
}
function immutable(val, name) {
    return function () {
        if (arguments.length === 0)
            return val();
        else
            throw new Error("Cannot modify " + name + " of an immutable measurement");
    };
}
// format a double representing feet into string like 12' 5"
// negatices are written like -12' 5"
// this is for display only: see MeasurementInFeetAndInches for a read-writable functionality
function formatFeetAndInches(feet, places) {
    var str = "";
    if (feet === null) {
        str += places === 0 ? "--'" : "--' --\"";
    }
    else {
        var feetWhole = feet >= 0 ? Math.floor(feet) : Math.ceil(feet);
        str += feetWhole.toLocaleString() + "'";
        if (places > 0) {
            var inches = Math.abs(feet - feetWhole) * UOM_1.default.Conversion[UOM_1.default.Inch][UOM_1.default.Foot];
            str += " " + inches.toFixed(places - 1) + "\"";
        }
    }
    return str;
}
function checkUOM(uom) {
    if (!(uom in UOM_1.default.Name)) {
        throw new Error("'" + uom + "' is not a recognized unit of measure");
    }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AppWrapperView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(1117);
var view_2 = __webpack_require__(969);
var view_3 = __webpack_require__(1191);
exports.AppWrapperView = supercritical_1.default(function (_a) {
    var m = _a.model, navbarTab = _a.navbarTab, children = _a.children;
    return (React.createElement("div", { className: "app-body " + m.UITheme.CssClasses() },
        React.createElement(view_3.UIThemeSetterView, { model: m.UITheme }),
        React.createElement(view_1.NavbarView, { tab: navbarTab, model: m.Navbar }),
        React.createElement(view_2.AjaxErrorsView, { model: m.AjaxErrors }),
        children));
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryResultRelationship = exports.QueryResultsRelationship = exports.SharedKeyRelationship = exports.OneToOneRelationship = exports.ForeignKeyRelationship = exports.DataCacheCollection = exports.DataCache = void 0;
var s_js_1 = __webpack_require__(0);
var SynchronousIndex_1 = __webpack_require__(1382);
var Monitorable_1 = __webpack_require__(596);
var SynchronousSet_1 = __webpack_require__(597);
var DataCache = /** @class */ (function () {
    function DataCache() {
    }
    return DataCache;
}());
exports.DataCache = DataCache;
var DataCacheCollection = /** @class */ (function () {
    function DataCacheCollection(Model, updateItem, key, dataKey, options) {
        this.Model = Model;
        this.updateItem = updateItem;
        this.key = key;
        this.dataKey = dataKey;
        this.index = SynchronousIndex_1.SynchronousUniqueIndex(this.key);
        this._items = Monitorable_1.Monitorable(SynchronousSet_1.SynchronousSet(), [this.index]);
        this.items = this._items; // public version doesn't allow mutation
        this.timestamps = {};
        this.tempcachedirty = s_js_1.default.data(true);
        this.tempcache = s_js_1.default.on(this.tempcachedirty, function () { return ({}); });
        this.relationships = [];
        this.expectEmptyIds = !!(options && options.expectEmptyIds);
    }
    DataCacheCollection.prototype.update1 = function (timestamp, update, template) {
        if (template === void 0) { template = null; }
        return this.update(timestamp || new Date(0), [update], [], [template])[0];
    };
    DataCacheCollection.prototype.update = function (timestamp, updates, deletes, templates) {
        var _this = this;
        if (templates === void 0) { templates = []; }
        return s_js_1.default.freeze(function () {
            var updated = [], tempcache = s_js_1.default.sample(_this.tempcache), data, id, ts, item, template, i, j;
            for (i = 0; i < updates.length; i++) {
                data = updates[i];
                id = _this.dataKey(data);
                // TH: Providing a way to disable this warning on a collection by collection basis.
                // This makes the warning more meaningful, since otherwise certain types will always trigger it.
                if (!_this.expectEmptyIds && (id === 0 || id === ''))
                    console.warn("DataCacheCollection: possible unset id - " + id);
                ts = _this.timestamps[id];
                item = s_js_1.default.sample(_this.index(id)) || tempcache[id] || null;
                template = templates[i];
                if (item && template && item !== template) {
                    throw new Error("DataCacheCollection: cannot used supplied template, as entity is already in cache as a different object");
                }
                if (!ts || ts <= timestamp) {
                    _this.timestamps[id] = timestamp;
                    if (item) {
                        _this.updateItem(item, data);
                    }
                    else {
                        if (template)
                            _this.updateItem(item = template, data);
                        else
                            item = new _this.Model(data);
                        _this._items.add(item);
                        tempcache[id] = item;
                        _this.tempcachedirty(true);
                        for (j = 0; j < _this.relationships.length; j++) {
                            _this.relationships[j].attach(item);
                        }
                    }
                }
                if (item) {
                    for (j = 0; j < _this.relationships.length; j++) {
                        _this.relationships[j].update(item, data, timestamp);
                    }
                    updated.push(item);
                }
            }
            for (i = 0; i < deletes.length; i++) {
                id = deletes[i];
                ts = _this.timestamps[id];
                item = s_js_1.default.sample(_this.index(id));
                if (item && (!ts || ts <= timestamp)) {
                    _this.timestamps[id] = timestamp;
                    for (j = 0; j < _this.relationships.length; j++) {
                        _this.relationships[j].detach(item);
                    }
                    _this._items.delete(item);
                }
            }
            return updated;
        });
    };
    DataCacheCollection.prototype.attach = function (item, refs, autoDetach) {
        var _this = this;
        if (autoDetach === void 0) { autoDetach = true; }
        var relationships = this.refRelationships(item, refs);
        for (var i = 0; i < relationships.length; i++) {
            relationships[i].attach(item);
        }
        if (autoDetach)
            s_js_1.default.cleanup(function () { return _this.detach(item, refs); });
    };
    DataCacheCollection.prototype.detach = function (item, refs) {
        var relationships = this.refRelationships(item, refs);
        for (var i = 0; i < relationships.length; i++) {
            relationships[i].detach(item);
        }
    };
    DataCacheCollection.prototype.refRelationships = function (item, refs) {
        if (!refs)
            return this.relationships;
        var rels = [];
        for (var i = 0; i < this.relationships.length; i++) {
            var relationship = this.relationships[i];
            if (refs.indexOf(relationship.ref(item)) !== -1)
                rels.push(relationship);
        }
        return rels;
    };
    DataCacheCollection.prototype.timestamp = function (key) {
        return this.timestamps[key];
    };
    return DataCacheCollection;
}());
exports.DataCacheCollection = DataCacheCollection;
var Relationship = /** @class */ (function () {
    function Relationship(from, to, ref) {
        this.from = from;
        this.to = to;
        this.ref = ref;
        from.relationships.push(this);
    }
    return Relationship;
}());
var DataCacheDisposers = new WeakMap();
var IndexRelationship = /** @class */ (function (_super) {
    __extends(IndexRelationship, _super);
    function IndexRelationship(from, to, ref, key, index) {
        var _this = _super.call(this, from, to, ref) || this;
        _this.key = key;
        _this.index = index;
        return _this;
    }
    IndexRelationship.prototype.attach = function (item) {
        var ref = this.ref(item), index = this.index, key = this.key;
        s_js_1.default.root(function (dispose) {
            DataCacheDisposers.set(ref, dispose);
            return s_js_1.default(function () {
                var values = index(key(item))();
                return ref(values);
            });
        });
    };
    IndexRelationship.prototype.detach = function (item) {
        var ref = this.ref(item), disposer = DataCacheDisposers.get(ref);
        if (disposer) {
            disposer();
            DataCacheDisposers.delete(ref);
        }
    };
    return IndexRelationship;
}(Relationship));
var SingleRelationship = /** @class */ (function (_super) {
    __extends(SingleRelationship, _super);
    function SingleRelationship() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleRelationship.prototype.update = function (item, data, timestamp) {
        var refData = this.ref(data); // NOT typesafe -- applying model ref selector to data to see if we can get ref data
        if (refData === undefined || refData === null)
            return;
        this.to.update1(timestamp, refData);
    };
    return SingleRelationship;
}(IndexRelationship));
var MultiRelationship = /** @class */ (function (_super) {
    __extends(MultiRelationship, _super);
    function MultiRelationship() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiRelationship.prototype.update = function (item, data, timestamp) {
        var updates = this.ref(data); // NOT typesafe -- applying model ref selector to data to see if we can get ref data
        if (!Array.isArray(updates))
            return;
        var updatesIds = {}, id;
        for (var i = 0; i < updates.length; i++) {
            id = this.to.dataKey(updates[i]);
            updatesIds[id] = true;
        }
        var current = s_js_1.default.sample(this.ref(item)), deletes = [];
        for (i = 0; i < current.length; i++) {
            id = this.to.key(current[i]);
            if (!updatesIds[id]) {
                deletes.push(id);
            }
        }
        if (updates.length || deletes.length)
            this.to.update(timestamp, updates, deletes);
    };
    return MultiRelationship;
}(IndexRelationship));
var ForeignKeyRelationship = /** @class */ (function () {
    function ForeignKeyRelationship(parent, children, childrenRef, parentRef, parentId) {
        this.parentToChild = null;
        this.childToParent = null;
        if (childrenRef) {
            var parentChildren_1 = SynchronousIndex_1.SynchronousNonuniqueIndex(parentId, children.items);
            Monitorable_1.Monitor(children.items, parentChildren_1);
            this.parentToChild = new MultiRelationship(parent, children, childrenRef, parent.key, function (id) { return function () { return Array.from(parentChildren_1(id)()); }; });
        }
        if (parentRef)
            this.childToParent = new SingleRelationship(children, parent, parentRef, parentId, onNullKey(parent.index, returnNull));
    }
    return ForeignKeyRelationship;
}());
exports.ForeignKeyRelationship = ForeignKeyRelationship;
var OneToOneRelationship = /** @class */ (function () {
    function OneToOneRelationship(dependent, master, masterRef, dependentRef, masterId) {
        this.dependent = null;
        this.master = null;
        if (masterRef)
            this.dependent = new SingleRelationship(dependent, master, masterRef, masterId, onNullKey(master.index, returnNull));
        if (dependentRef) {
            var dependentForMaster = void 0;
            if (masterId === dependent.key) {
                dependentForMaster = dependent.index;
            }
            else {
                dependentForMaster = SynchronousIndex_1.SynchronousUniqueIndex(masterId, dependent.items);
                Monitorable_1.Monitor(dependent.items, dependentForMaster);
            }
            this.master = new SingleRelationship(master, dependent, dependentRef, master.key, dependentForMaster);
        }
    }
    return OneToOneRelationship;
}());
exports.OneToOneRelationship = OneToOneRelationship;
var SharedKeyRelationship = /** @class */ (function (_super) {
    __extends(SharedKeyRelationship, _super);
    function SharedKeyRelationship(dependent, master, masterRef, dependentRef) {
        return _super.call(this, dependent, master, masterRef, dependentRef, dependent.key) || this;
    }
    return SharedKeyRelationship;
}(OneToOneRelationship));
exports.SharedKeyRelationship = SharedKeyRelationship;
var QueryResultsRelationship = /** @class */ (function (_super) {
    __extends(QueryResultsRelationship, _super);
    function QueryResultsRelationship(query, results, resultsRef) {
        return _super.call(this, query, results, resultsRef) || this;
    }
    QueryResultsRelationship.prototype.attach = function (item) { };
    QueryResultsRelationship.prototype.detach = function (item) { };
    QueryResultsRelationship.prototype.update = function (item, data, timestamp) {
        var updateData = this.ref(data); // NOT typesafe -- applying model ref selector to data to see if we can get ref data
        if (!Array.isArray(updateData))
            return;
        var updates = this.to.update(timestamp, updateData, []), ref = this.ref(item), current = s_js_1.default.sample(ref);
        if (!arrayEq(current, updates))
            ref(updates);
    };
    return QueryResultsRelationship;
}(Relationship));
exports.QueryResultsRelationship = QueryResultsRelationship;
var QueryResultRelationship = /** @class */ (function (_super) {
    __extends(QueryResultRelationship, _super);
    function QueryResultRelationship(query, result, ref) {
        return _super.call(this, query, result, ref) || this;
    }
    QueryResultRelationship.prototype.attach = function (item) { };
    QueryResultRelationship.prototype.detach = function (item) { };
    QueryResultRelationship.prototype.update = function (item, data, timestamp) {
        var updateData = this.ref(data); // NOT typesafe -- applying model ref selector to data to see if we can get ref data
        if (updateData === undefined || updateData === null)
            return;
        var update = this.to.update1(timestamp, updateData), ref = this.ref(item), current = s_js_1.default.sample(ref);
        if (current !== update)
            ref(update);
    };
    return QueryResultRelationship;
}(Relationship));
exports.QueryResultRelationship = QueryResultRelationship;
function arrayEq(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
// Add handling for null keys to a unique index that expects keys to be non-null.
function onNullKey(index, whenNull) {
    return function (key) { return key === null ? whenNull : index(key); };
}
function returnNull() { return null; }


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCCache = exports.PCCollection = void 0;
var DataCache_1 = __webpack_require__(15);
var s_js_1 = __webpack_require__(0);
var AgencyCode_1 = __webpack_require__(555);
var ApprovalOfCharges_1 = __webpack_require__(1222);
var ApprovedCharge_1 = __webpack_require__(1223);
var AutomationSystem_1 = __webpack_require__(1225);
var Barge_1 = __webpack_require__(1226);
var Berth_1 = __webpack_require__(107);
var BerthAmenity_1 = __webpack_require__(557);
var BerthAmenityType_1 = __webpack_require__(558);
var BerthCapability_1 = __webpack_require__(559);
var BerthCapabilityAssignment_1 = __webpack_require__(560);
var BerthClosure_1 = __webpack_require__(561);
var BerthRelevance_1 = __webpack_require__(1230);
var BerthReservation_1 = __webpack_require__(79);
var BerthReservationSelf_1 = __webpack_require__(1232);
var BerthReservationVersion_1 = __webpack_require__(1233);
var BerthReservationPIT_1 = __webpack_require__(1231);
var Bill_1 = __webpack_require__(1234);
var BillCoverage_1 = __webpack_require__(1235);
var BillExportPayloadAssignment_1 = __webpack_require__(1237);
var BillingSystem_1 = __webpack_require__(1239);
var BillItem_1 = __webpack_require__(1238);
var BollardPosition_1 = __webpack_require__(563);
var CargoActivity_1 = __webpack_require__(564);
var CargoActivityType_1 = __webpack_require__(280);
var CargoCategory_1 = __webpack_require__(281);
var Change_1 = __webpack_require__(1242);
var Comment_1 = __webpack_require__(282);
var Coordination_1 = __webpack_require__(200);
var CoordinationAltStatusLabel_1 = __webpack_require__(568);
var CoordinationCard_1 = __webpack_require__(109);
var CoordinationCardPIT_1 = __webpack_require__(1244);
var CoordinationCardRelevance_1 = __webpack_require__(1245);
var CoordinationCardSelf_1 = __webpack_require__(1246);
var CoordinationCardStatus_1 = __webpack_require__(1247);
var CoordinationCardVersion_1 = __webpack_require__(1249);
var CoordinationLocation_1 = __webpack_require__(569);
var CoordinationMilestoneType_1 = __webpack_require__(570);
var CoordinationProvider_1 = __webpack_require__(201);
var Country_1 = __webpack_require__(283);
var CruiseActivity_1 = __webpack_require__(571);
var DefaultImage_1 = __webpack_require__(1252);
var DispatchEvent_1 = __webpack_require__(573);
var Domain_1 = __webpack_require__(1255);
var DomainRelevance_1 = __webpack_require__(1256);
var DomainSettings_1 = __webpack_require__(574);
var EnhancedEstimate_1 = __webpack_require__(1261);
var EnhancedEstimateQuery_1 = __webpack_require__(1262);
var Event_1 = __webpack_require__(1263);
var ExportDelivery_1 = __webpack_require__(1264);
var ExportPayload_1 = __webpack_require__(1265);
var GeoActivity_1 = __webpack_require__(1266);
var Issue_1 = __webpack_require__(157);
var ItineraryPoint_1 = __webpack_require__(69);
var ItineraryPointSelf_1 = __webpack_require__(1272);
var ItineraryPointVersion_1 = __webpack_require__(1273);
var ItineraryPointPIT_1 = __webpack_require__(1271);
var JobOrder_1 = __webpack_require__(576);
var JobOrderSelf_1 = __webpack_require__(1275);
var JobOrderVersion_1 = __webpack_require__(1276);
var JobOrderPIT_1 = __webpack_require__(1274);
var LineHandlingCompany_1 = __webpack_require__(1278);
var LloydResult_1 = __webpack_require__(1279);
var LloydServiceVessel_1 = __webpack_require__(1281);
var Location_1 = __webpack_require__(1282);
var LogEvent_1 = __webpack_require__(1283);
var MarineTrafficResult_1 = __webpack_require__(1286);
var MarineTrafficServiceVessel_1 = __webpack_require__(1288);
var MilestoneType_1 = __webpack_require__(1290);
var Notification_1 = __webpack_require__(1293);
var Organization_1 = __webpack_require__(1295);
var OverrideServiceVessel_1 = __webpack_require__(578);
var PCUser_1 = __webpack_require__(1298);
var PCUserPortCallEditor_1 = __webpack_require__(579);
var PhoneNumber_1 = __webpack_require__(287);
var PierGroup_1 = __webpack_require__(1307);
var Pilot_1 = __webpack_require__(1309);
var PilotAgency_1 = __webpack_require__(1310);
var PilotAssignment_1 = __webpack_require__(582);
var PilotJobOrder_1 = __webpack_require__(160);
var PilotJobOrderCancellation_1 = __webpack_require__(1311);
var PilotJobOrderChange_1 = __webpack_require__(1312);
var PilotJobOrderPIT_1 = __webpack_require__(1315);
var PilotJobOrderRelevance_1 = __webpack_require__(1316);
var PilotJobOrderUserPreferences_1 = __webpack_require__(583);
var PilotJobOrderVersion_1 = __webpack_require__(1317);
var PilotSection_1 = __webpack_require__(1318);
var PilotShiphandlingNote_1 = __webpack_require__(584);
var PortCall_1 = __webpack_require__(161);
var PortCallSelf_1 = __webpack_require__(1329);
var PortCallChange_1 = __webpack_require__(585);
var PortCallDeletion_1 = __webpack_require__(1324);
var PortCallPIT_1 = __webpack_require__(1325);
var PortCallVersion_1 = __webpack_require__(1330);
var Port_1 = __webpack_require__(1323);
var PostalAddress_1 = __webpack_require__(586);
var PSixServiceVessel_1 = __webpack_require__(580);
var PSixVesselDimension_1 = __webpack_require__(1300);
var PSixVesselParticular_1 = __webpack_require__(1301);
var PSixVesselResult_1 = __webpack_require__(1302);
var PSixVesselTonnage_1 = __webpack_require__(1303);
var Rate_1 = __webpack_require__(1334);
var RecurringBatch_1 = __webpack_require__(288);
var RecurringBatchChange_1 = __webpack_require__(1335);
var RecurringBatchDeletion_1 = __webpack_require__(1336);
var RecurringBatchPIT_1 = __webpack_require__(1337);
var RecurringBatchSelf_1 = __webpack_require__(1339);
var RecurringBatchVersion_1 = __webpack_require__(1340);
var Role_1 = __webpack_require__(1344);
var ScheduleDateEntity_1 = __webpack_require__(289);
var ScheduleDateEvent_1 = __webpack_require__(290);
var ScheduleDatePIT_1 = __webpack_require__(1347);
var ScheduleDateSelf_1 = __webpack_require__(1348);
var ScheduleDateVersion_1 = __webpack_require__(1349);
var Share_1 = __webpack_require__(1353);
var SharingToken_1 = __webpack_require__(1354);
var StandardItem_1 = __webpack_require__(1355);
var StandardItemType_1 = __webpack_require__(1356);
var TaggedCommentUser_1 = __webpack_require__(588);
var TopicCard_1 = __webpack_require__(589);
var TopicCardAvailableAttachment_1 = __webpack_require__(1357);
var TopicCardChange_1 = __webpack_require__(1358);
var TopicCardOption_1 = __webpack_require__(1359);
var TopicCardSelectedOption_1 = __webpack_require__(590);
var TopicCardTemplate_1 = __webpack_require__(1360);
var TopicCardTemplateAttachment_1 = __webpack_require__(1361);
var TopicCardTemplateOption_1 = __webpack_require__(591);
var TopicCardTemplateUserAssignment_1 = __webpack_require__(592);
var TopicCardUserAssignment_1 = __webpack_require__(1364);
var TradeRoute_1 = __webpack_require__(292);
var TugCompany_1 = __webpack_require__(1365);
var UITheme_1 = __webpack_require__(1366);
var UnlistedBerthReservation_1 = __webpack_require__(1367);
var User_1 = __webpack_require__(1368);
var UserRole_1 = __webpack_require__(594);
var Vessel_1 = __webpack_require__(1370);
var VesselChange_1 = __webpack_require__(1371);
var DataCacheUpdate_1 = __webpack_require__(572);
var PilotsDataCacheUpdateEntities_1 = __webpack_require__(1319);
var WartsilaDataCacheUpdateEntities_1 = __webpack_require__(1377);
// shorthand for making a collection from our TS models, which have a common structure
var PCCollection = function (Model, options) { return new DataCache_1.DataCacheCollection(Model, Model.update, Model.key, Model.dataKey, options); };
exports.PCCollection = PCCollection;
var PCCache = /** @class */ (function (_super) {
    __extends(PCCache, _super);
    function PCCache() {
        var _this = _super.call(this) || this;
        _this.AgencyCodes = exports.PCCollection(AgencyCode_1.AgencyCode);
        _this.ApprovalsOfCharges = exports.PCCollection(ApprovalOfCharges_1.ApprovalOfCharges);
        _this.ApprovedCharges = exports.PCCollection(ApprovedCharge_1.ApprovedCharge);
        _this.AutomationSystems = exports.PCCollection(AutomationSystem_1.AutomationSystem);
        _this.Barges = exports.PCCollection(Barge_1.Barge);
        _this.BerthAmenities = exports.PCCollection(BerthAmenity_1.BerthAmenity);
        _this.BerthAmenityTypes = exports.PCCollection(BerthAmenityType_1.BerthAmenityType);
        _this.BerthCapabilities = exports.PCCollection(BerthCapability_1.BerthCapability);
        _this.BerthCapabilityAssignments = exports.PCCollection(BerthCapabilityAssignment_1.BerthCapabilityAssignment);
        _this.BerthClosures = exports.PCCollection(BerthClosure_1.BerthClosure);
        _this.BerthRelevances = exports.PCCollection(BerthRelevance_1.BerthRelevance);
        _this.BerthReservations = exports.PCCollection(BerthReservation_1.BerthReservation);
        _this.BerthReservationSelves = exports.PCCollection(BerthReservationSelf_1.BerthReservationSelf);
        _this.BerthReservationVersions = exports.PCCollection(BerthReservationVersion_1.BerthReservationVersion);
        _this.BerthReservationPITs = new DataCache_1.DataCacheCollection(BerthReservation_1.BerthReservation, BerthReservation_1.BerthReservation.update, BerthReservationPIT_1.BerthReservationPITKey, BerthReservationPIT_1.BerthReservationPITDataKey);
        _this.Berths = exports.PCCollection(Berth_1.Berth);
        _this.Bills = exports.PCCollection(Bill_1.Bill);
        _this.BillCoverages = exports.PCCollection(BillCoverage_1.BillCoverage);
        _this.BillExportPayloadAssignments = exports.PCCollection(BillExportPayloadAssignment_1.BillExportPayloadAssignment);
        _this.BillingSystems = exports.PCCollection(BillingSystem_1.BillingSystem);
        _this.BillItems = exports.PCCollection(BillItem_1.BillItem);
        _this.BollardPositions = exports.PCCollection(BollardPosition_1.BollardPosition);
        _this.CargoActivities = exports.PCCollection(CargoActivity_1.CargoActivity);
        _this.CargoActivityTypes = exports.PCCollection(CargoActivityType_1.CargoActivityType);
        _this.CargoCategories = exports.PCCollection(CargoCategory_1.CargoCategory);
        _this.Changes = exports.PCCollection(Change_1.Change);
        _this.Comments = exports.PCCollection(Comment_1.Comment);
        _this.Coordinations = exports.PCCollection(Coordination_1.Coordination);
        _this.CoordinationAltStatusLabels = exports.PCCollection(CoordinationAltStatusLabel_1.CoordinationAltStatusLabel);
        _this.CoordinationCards = exports.PCCollection(CoordinationCard_1.CoordinationCard);
        _this.CoordinationCardPITs = new DataCache_1.DataCacheCollection(CoordinationCard_1.CoordinationCard, CoordinationCard_1.CoordinationCard.update, CoordinationCardPIT_1.CoordinationCardPITKey, CoordinationCardPIT_1.CoordinationCardPITDataKey);
        _this.CoordinationCardRelevances = exports.PCCollection(CoordinationCardRelevance_1.CoordinationCardRelevance);
        _this.CoordinationCardSelves = exports.PCCollection(CoordinationCardSelf_1.CoordinationCardSelf);
        _this.CoordinationCardStatuses = exports.PCCollection(CoordinationCardStatus_1.CoordinationCardStatus, { expectEmptyIds: true });
        _this.CoordinationCardVersions = exports.PCCollection(CoordinationCardVersion_1.CoordinationCardVersion);
        _this.CoordinationLocations = exports.PCCollection(CoordinationLocation_1.CoordinationLocation);
        _this.CoordinationMilestoneTypes = exports.PCCollection(CoordinationMilestoneType_1.CoordinationMilestoneType);
        _this.CoordinationProviders = exports.PCCollection(CoordinationProvider_1.CoordinationProvider);
        _this.Countries = exports.PCCollection(Country_1.Country, { expectEmptyIds: true });
        _this.CruiseActivities = exports.PCCollection(CruiseActivity_1.CruiseActivity);
        _this.DefaultImages = exports.PCCollection(DefaultImage_1.DefaultImage);
        _this.DispatchEvents = exports.PCCollection(DispatchEvent_1.DispatchEvent);
        _this.Domains = exports.PCCollection(Domain_1.Domain);
        _this.DomainRelevances = exports.PCCollection(DomainRelevance_1.DomainRelevance);
        _this.DomainSettings = exports.PCCollection(DomainSettings_1.DomainSettings);
        _this.Events = exports.PCCollection(Event_1.Event);
        _this.ExportDeliveries = exports.PCCollection(ExportDelivery_1.ExportDelivery);
        _this.ExportPayloads = exports.PCCollection(ExportPayload_1.ExportPayload);
        _this.GeoActivities = exports.PCCollection(GeoActivity_1.GeoActivity);
        _this.Issues = exports.PCCollection(Issue_1.Issue);
        _this.ItineraryPoints = exports.PCCollection(ItineraryPoint_1.ItineraryPoint);
        _this.ItineraryPointSelves = exports.PCCollection(ItineraryPointSelf_1.ItineraryPointSelf);
        _this.ItineraryPointVersions = exports.PCCollection(ItineraryPointVersion_1.ItineraryPointVersion);
        _this.ItineraryPointPITs = new DataCache_1.DataCacheCollection(ItineraryPoint_1.ItineraryPoint, ItineraryPoint_1.ItineraryPoint.update, ItineraryPointPIT_1.ItineraryPointPITKey, ItineraryPointPIT_1.ItineraryPointPITDataKey);
        _this.JobOrders = exports.PCCollection(JobOrder_1.JobOrder);
        _this.JobOrderSelves = exports.PCCollection(JobOrderSelf_1.JobOrderSelf);
        _this.JobOrderVersions = exports.PCCollection(JobOrderVersion_1.JobOrderVersion);
        _this.JobOrderPITs = new DataCache_1.DataCacheCollection(JobOrder_1.JobOrder, JobOrder_1.JobOrder.update, JobOrderPIT_1.JobOrderPITKey, JobOrderPIT_1.JobOrderPITDataKey);
        _this.LineHandlingCompanies = exports.PCCollection(LineHandlingCompany_1.LineHandlingCompany);
        _this.LloydResults = exports.PCCollection(LloydResult_1.LloydResult);
        _this.LloydServiceVessels = exports.PCCollection(LloydServiceVessel_1.LloydServiceVessel);
        _this.Locations = exports.PCCollection(Location_1.Location);
        _this.LogEvents = exports.PCCollection(LogEvent_1.LogEvent);
        _this.MarineTrafficResults = exports.PCCollection(MarineTrafficResult_1.MarineTrafficResult);
        _this.MarineTrafficServiceVessels = exports.PCCollection(MarineTrafficServiceVessel_1.MarineTrafficServiceVessel);
        _this.MilestoneTypes = exports.PCCollection(MilestoneType_1.MilestoneType);
        _this.Notifications = exports.PCCollection(Notification_1.Notification);
        _this.Organizations = exports.PCCollection(Organization_1.Organization);
        _this.OverrideServiceVessels = exports.PCCollection(OverrideServiceVessel_1.OverrideServiceVessel);
        _this.PCUsers = exports.PCCollection(PCUser_1.PCUser);
        _this.PierGroups = exports.PCCollection(PierGroup_1.PierGroup);
        _this.Pilots = exports.PCCollection(Pilot_1.Pilot);
        _this.PilotAgencies = exports.PCCollection(PilotAgency_1.PilotAgency);
        _this.PilotAssignments = exports.PCCollection(PilotAssignment_1.PilotAssignment);
        _this.PilotJobOrders = exports.PCCollection(PilotJobOrder_1.PilotJobOrder);
        _this.PilotJobOrderCancellations = exports.PCCollection(PilotJobOrderCancellation_1.PilotJobOrderCancellation);
        _this.PilotJobOrderChanges = exports.PCCollection(PilotJobOrderChange_1.PilotJobOrderChange);
        _this.PilotJobOrderPITs = new DataCache_1.DataCacheCollection(PilotJobOrder_1.PilotJobOrder, PilotJobOrder_1.PilotJobOrder.update, PilotJobOrderPIT_1.PilotJobOrderPITKey, PilotJobOrderPIT_1.PilotJobOrderPITDataKey);
        _this.PilotJobOrderRelevances = exports.PCCollection(PilotJobOrderRelevance_1.PilotJobOrderRelevance);
        _this.PilotJobOrderUserPreferenceses = exports.PCCollection(PilotJobOrderUserPreferences_1.PilotJobOrderUserPreferences);
        _this.PilotJobOrderVersions = exports.PCCollection(PilotJobOrderVersion_1.PilotJobOrderVersion);
        _this.PilotSections = exports.PCCollection(PilotSection_1.PilotSection);
        _this.PilotShiphandlingNotes = exports.PCCollection(PilotShiphandlingNote_1.PilotShiphandlingNote);
        _this.PhoneNumbers = exports.PCCollection(PhoneNumber_1.PhoneNumber);
        _this.Ports = exports.PCCollection(Port_1.Port);
        _this.PortCalls = exports.PCCollection(PortCall_1.PortCall);
        _this.PortCallChanges = exports.PCCollection(PortCallChange_1.PortCallChange);
        _this.PortCallDeletions = exports.PCCollection(PortCallDeletion_1.PortCallDeletion);
        _this.PortCallPITs = new DataCache_1.DataCacheCollection(PortCall_1.PortCall, PortCall_1.PortCall.update, PortCallPIT_1.PortCallPITKey, PortCallPIT_1.PortCallPITDataKey);
        _this.PortCallSelves = exports.PCCollection(PortCallSelf_1.PortCallSelf);
        _this.PortCallVersions = exports.PCCollection(PortCallVersion_1.PortCallVersion);
        _this.PCUserPortCallEditors = exports.PCCollection(PCUserPortCallEditor_1.PCUserPortCallEditor);
        _this.PostalAddresses = exports.PCCollection(PostalAddress_1.PostalAddress);
        _this.PSixServiceVessels = exports.PCCollection(PSixServiceVessel_1.PSixServiceVessel);
        _this.PSixVesselDimensions = exports.PCCollection(PSixVesselDimension_1.PSixVesselDimension);
        _this.PSixVesselParticulars = exports.PCCollection(PSixVesselParticular_1.PSixVesselParticular);
        _this.PSixVesselResults = exports.PCCollection(PSixVesselResult_1.PSixVesselResult);
        _this.PSixVesselTonnages = exports.PCCollection(PSixVesselTonnage_1.PSixVesselTonnage);
        _this.Rates = exports.PCCollection(Rate_1.Rate);
        _this.RecurringBatches = exports.PCCollection(RecurringBatch_1.RecurringBatch);
        _this.RecurringBatchChanges = exports.PCCollection(RecurringBatchChange_1.RecurringBatchChange);
        _this.RecurringBatchDeletions = exports.PCCollection(RecurringBatchDeletion_1.RecurringBatchDeletion);
        _this.RecurringBatchPITs = new DataCache_1.DataCacheCollection(RecurringBatch_1.RecurringBatch, RecurringBatch_1.RecurringBatch.update, RecurringBatchPIT_1.RecurringBatchPITKey, RecurringBatchPIT_1.RecurringBatchPITDataKey);
        _this.RecurringBatchSelves = exports.PCCollection(RecurringBatchSelf_1.RecurringBatchSelf);
        _this.RecurringBatchVersions = exports.PCCollection(RecurringBatchVersion_1.RecurringBatchVersion);
        _this.Roles = exports.PCCollection(Role_1.Role);
        _this.ScheduleDates = exports.PCCollection(ScheduleDateEntity_1.ScheduleDateEntity);
        _this.ScheduleDateEvents = exports.PCCollection(ScheduleDateEvent_1.ScheduleDateEvent);
        _this.ScheduleDatePITs = new DataCache_1.DataCacheCollection(ScheduleDateEntity_1.ScheduleDateEntity, ScheduleDateEntity_1.ScheduleDateEntity.update, ScheduleDatePIT_1.ScheduleDatePITKey, ScheduleDatePIT_1.ScheduleDatePITDataKey);
        _this.ScheduleDateSelves = exports.PCCollection(ScheduleDateSelf_1.ScheduleDateSelf);
        _this.ScheduleDateVersions = exports.PCCollection(ScheduleDateVersion_1.ScheduleDateVersion);
        _this.SharingTokens = exports.PCCollection(SharingToken_1.SharingToken);
        _this.Shares = exports.PCCollection(Share_1.Share);
        _this.StandardItems = exports.PCCollection(StandardItem_1.StandardItem);
        _this.StandardItemTypes = exports.PCCollection(StandardItemType_1.StandardItemType);
        _this.TaggedCommentUsers = exports.PCCollection(TaggedCommentUser_1.TaggedCommentUser);
        _this.TopicCards = exports.PCCollection(TopicCard_1.TopicCard);
        _this.TopicCardAvailableAttachments = exports.PCCollection(TopicCardAvailableAttachment_1.TopicCardAvailableAttachment);
        _this.TopicCardChanges = exports.PCCollection(TopicCardChange_1.TopicCardChange);
        _this.TopicCardOptions = exports.PCCollection(TopicCardOption_1.TopicCardOption);
        _this.TopicCardSelectedOptions = exports.PCCollection(TopicCardSelectedOption_1.TopicCardSelectedOption);
        _this.TopicCardTemplates = exports.PCCollection(TopicCardTemplate_1.TopicCardTemplate);
        _this.TopicCardTemplateAttachments = exports.PCCollection(TopicCardTemplateAttachment_1.TopicCardTemplateAttachment);
        _this.TopicCardTemplateOptions = exports.PCCollection(TopicCardTemplateOption_1.TopicCardTemplateOption);
        _this.TopicCardTemplateUserAssignments = exports.PCCollection(TopicCardTemplateUserAssignment_1.TopicCardTemplateUserAssignment);
        _this.TopicCardUserAssignments = exports.PCCollection(TopicCardUserAssignment_1.TopicCardUserAssignment);
        _this.TradeRoutes = exports.PCCollection(TradeRoute_1.TradeRoute);
        _this.TugCompanies = exports.PCCollection(TugCompany_1.TugCompany);
        _this.UIThemes = exports.PCCollection(UITheme_1.UITheme);
        _this.UnlistedBerthReservations = exports.PCCollection(UnlistedBerthReservation_1.UnlistedBerthReservation);
        _this.Users = exports.PCCollection(User_1.User);
        _this.UserRoles = exports.PCCollection(UserRole_1.UserRole);
        _this.Vessels = exports.PCCollection(Vessel_1.Vessel);
        _this.VesselChanges = exports.PCCollection(VesselChange_1.VesselChange);
        _this.WartsilaEnhancedEstimates = exports.PCCollection(EnhancedEstimate_1.EnhancedEstimate);
        _this.WartsilaEnhancedEstimateQueries = exports.PCCollection(EnhancedEstimateQuery_1.EnhancedEstimateQuery);
        // list should be alphabetical by first collection
        new DataCache_1.ForeignKeyRelationship(_this.ApprovalsOfCharges, _this.ApprovedCharges, function (ac) { return ac.Charges; }, function (c) { return c.Approval; }, function (c) { return c.ApprovalId(); });
        // TODO: (12/20/2020) I've now fixed the underlying limitation in OneToOneRelationship, so we should be able
        // to ditch this workaround now.
        // TH 05/08/2017 -- I originally tried to have ApprovalOfCharges properties on our auto-generated
        // DispatchEvent, JobOrder, and PilotJobOrder models that would contain a single ApprovalOfCharges or null.
        // I was then gonna do OneToOneRelationships to wire those up as commented out below.
        // But that ran into a problem, in that the OneToOneRelationship was really designed to handle
        // our Event relationships where the FK runs from each concrete eventable type (PortCallChange, Post, etc.)
        // to its Event.
        // But w/ ApprovalsOfCharges the FK runs the other direction -- from the ApprovalOfCharges to the entity
        // whose charges were approved (JobOrder, DispatchEvent, etc.).
        // This caused the OneToOneRelationship to throw an exception -- it constructs a uniqueIndex on the
        // masterId property, assuming that masterId will always be unique.
        // But for ApprovalsOfCharges, each FK to the concrete billable entity is only unique so long as it's
        // non-NULL. But there can be multiple ApprovalsOfCharges w/ a NULL DispatchEventId, say, or NULL
        // JobOrderId. Those duplicate unset FKs were causing the uniqueness checker in the uniqueIndex to throw.
        // So for now, my workaround is to serialize ApprovalsOfCharges as array-valued _approvalsOfCharges
        // properties. I wire up the appropriate ForeignKeyRelationships for those in alphabetical order below.
        // Then I added custom properties in data/models to convert back to a property that holds a single
        // ApprovalOfCharges or null.
        //
        // new OneToOneRelationship  (this.ApprovalsOfCharges, this.DispatchEvents,             ac => ac.DispatchEvent, de => de.ApprovalOfCharges, ac => ac.DispatchEventId());
        // new OneToOneRelationship  (this.ApprovalsOfCharges, this.JobOrders,                  ac => ac.JobOrder,      jo => jo.ApprovalOfCharges, ac => ac.JobOrderId());
        // new OneToOneRelationship  (this.ApprovalsOfCharges, this.PilotJobOrders,             null,                   pjo => pjo.ApprovalOfCharges, ac => ac.JobOrderId());
        new DataCache_1.ForeignKeyRelationship(_this.AutomationSystems, _this.Events, null, function (e) { return e.Automation; }, function (e) { return e.AutomationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.AutomationSystems, _this.WartsilaEnhancedEstimateQueries, null, function (q) { return q.Automation; }, function (q) { return q.AutomationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Barges, _this.PortCalls, function (b) { return b.PortCalls; }, function (pc) { return pc.Barge; }, function (pc) { return pc.BargeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Barges, _this.PortCallChanges, null, function (pcc) { return pcc.NewBarge; }, function (pcc) { return pcc.NewBargeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.BerthAmenities, function (b) { return b.Amenities; }, function (a) { return a.Berth; }, function (a) { return a.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.BerthCapabilityAssignments, function (b) { return b.Capabilities; }, function (c) { return c.Berth; }, function (c) { return c.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.BerthClosures, function (b) { return b.Closures; }, function (cl) { return cl.Berth; }, function (cl) { return cl.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.BerthRelevances, function (b) { return b.Stream; }, function (e) { return e.Berth; }, function (e) { return e.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.BollardPositions, function (b) { return b.BollardPositions; }, function (bol) { return bol.Berth; }, function (bol) { return bol.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.Issues, function (b) { return b.Issues; }, function (i) { return i.Berth; }, function (i) { return i.BerthId(); });
        new DataCache_1.SharedKeyRelationship(_this.Berths, _this.Locations, function (b) { return b.Location; }, function (l) { return l.Berth; });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.PortCallChanges, null, function (c) { return c.Berth; }, function (c) { return c.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.PortCallChanges, null, function (c) { return c.NewBerth; }, function (c) { return c.NewBerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.PortCallChanges, null, function (c) { return c.OldBerth; }, function (c) { return c.OldBerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.TopicCards, function (b) { return b.TopicCards; }, function (c) { return c.Berth; }, function (c) { return c.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Berths, _this.UnlistedBerthReservations, function (b) { return b.UnlistedReservations; }, function (u) { return u.Berth; }, function (u) { return u.BerthId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthAmenityTypes, _this.BerthAmenities, function (t) { return t.Berths; }, function (a) { return a.Amenity; }, function (a) { return a.AmenityId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthAmenityTypes, _this.TopicCards, function (a) { return a.TopicCards; }, function (c) { return c.AmenityType; }, function (c) { return c.AmenityTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthAmenityTypes, _this.TopicCardTemplates, function (a) { return a.TopicCardTemplates; }, function (t) { return t.AmenityType; }, function (t) { return t.AmenityTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthCapabilities, _this.BerthCapabilityAssignments, function (c) { return c.Berths; }, function (a) { return a.Capability; }, function (a) { return a.CapabilityId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthClosures, _this.Issues, function (cl) { return cl.Issues; }, function (i) { return i.BerthClosure; }, function (i) { return i.BerthClosureId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthClosures, _this.Issues, function (cl) { return cl.OthersIssues; }, function (i) { return i.OtherClosure; }, function (i) { return i.OtherClosureId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthClosures, _this.Issues, function (cl) { return cl.ReservationIssues; }, function (i) { return i.BerthReservationBerthClosure; }, function (i) { return i.BerthReservationBerthClosureId(); });
        new DataCache_1.SharedKeyRelationship(_this.BerthReservations, _this.BerthReservationSelves, function (r) { return r.Self; }, function (s) { return s.Live; });
        new DataCache_1.OneToOneRelationship(_this.BerthReservations, _this.BerthReservationVersions, function (r) { return r.Version; }, null, function (r) { return BerthReservationVersion_1.BerthReservationVersion.dataKey({ Id: r.Id(), ChangeId: r.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservations, _this.Issues, function (r) { return r.Issues; }, function (i) { return i.BerthReservation; }, function (i) { return i.BerthReservationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservations, _this.Issues, function (r) { return r.OthersIssues; }, function (i) { return i.OtherReservation; }, function (i) { return i.OtherReservationId(); });
        new DataCache_1.SharedKeyRelationship(_this.BerthReservations, _this.ItineraryPoints, function (r) { return r.Itinerary; }, function (p) { return p.BerthReservation; });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservations, _this.PortCallChanges, null, function (pcc) { return pcc.Reservation; }, function (pcc) { return pcc.ReservationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservations, _this.CargoActivities, function (r) { return r.CargoActivities; }, function (a) { return a.Reservation; }, function (a) { return a.ReservationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservations, _this.CruiseActivities, function (r) { return r.CruiseActivities; }, function (a) { return a.Reservation; }, function (a) { return a.ReservationId(); });
        new DataCache_1.SharedKeyRelationship(_this.BerthReservationPITs, _this.ItineraryPointPITs, function (r) { return r.Itinerary; }, function (p) { return p.BerthReservation; });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservationSelves, _this.BerthReservationVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservationSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.BerthReservation; }, function (e) { return e.BerthReservationId(); });
        new DataCache_1.SharedKeyRelationship(_this.BerthReservationSelves, _this.ItineraryPointSelves, function (s) { return s.Itinerary; }, function (s) { return s.BerthReservation; });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservationVersions, _this.BerthReservationVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : BerthReservationVersion_1.BerthReservationVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservationVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.BerthReservationVersion; }, function (e) { return e.BerthReservationId() === null ? null : BerthReservationVersion_1.BerthReservationVersion.dataKey({ Id: e.BerthReservationId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.BerthReservationVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.BerthReservationReferenceVersion; }, function (e) { return e.BerthReservationId() === null || e.ReferenceId() === null ? null : BerthReservationVersion_1.BerthReservationVersion.dataKey({ Id: e.BerthReservationId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.Bills, _this.BillItems, function (b) { return b.Items; }, function (i) { return i.Bill; }, function (i) { return i.BillId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Bills, _this.BillCoverages, function (b) { return b.Coverage; }, function (c) { return c.Bill; }, function (c) { return c.BillId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Bills, _this.BillExportPayloadAssignments, function (b) { return b.ExportPayloads; }, function (a) { return a.Bill; }, function (a) { return a.BillId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BillingSystems, _this.ApprovalsOfCharges, function (sys) { return sys.ApprovalsOfCharges; }, function (ac) { return ac.BillingSystem; }, function (ac) { return ac.BillingSystemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BillingSystems, _this.Bills, function (sys) { return sys.Bills; }, function (b) { return b.BillingSystem; }, function (b) { return b.BillingSystemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BillingSystems, _this.ExportPayloads, function (sys) { return sys.ExportPayloads; }, function (p) { return p.BillingSystem; }, function (p) { return p.BillingSystemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BillingSystems, _this.Rates, function (sys) { return sys.SpecialRates; }, function (r) { return r.BillingSystem; }, function (r) { return r.BillingSystemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.BillingSystems, _this.StandardItems, function (sys) { return sys.StandardItems; }, function (i) { return i.BillingSystem; }, function (i) { return i.BillingSystemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CargoActivityTypes, _this.CargoActivities, null, function (a) { return a.ActivityType; }, function (a) { return a.ActivityTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CargoCategories, _this.CargoActivities, null, function (a) { return a.CargoCategory; }, function (a) { return a.CargoCategoryId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.BerthReservations, null, function (r) { return r.Change; }, function (r) { return r.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.BerthReservationPITs, null, function (r) { return r.Change; }, function (r) { return r.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.BerthReservationVersions, function (c) { return c.BerthReservationVersions; }, function (r) { return r.Change; }, function (r) { return r.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.BerthReservationVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.CoordinationCards, null, function (c) { return c.Change; }, function (c) { return c.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.CoordinationCardPITs, null, function (c) { return c.Change; }, function (c) { return c.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.CoordinationCardVersions, function (c) { return c.CoordinationCardVersions; }, function (v) { return v.Change; }, function (v) { return v.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.CoordinationCardVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.Events, function (c) { return c.EventsCreated; }, function (e) { return e.Created; }, function (c) { return c.CreatedId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.Events, function (c) { return c.EventsAbout; }, function (e) { return e.About; }, function (c) { return c.AboutId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.Events, function (c) { return c.EventsReferencing; }, function (e) { return e.Reference; }, function (c) { return c.ReferenceId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ItineraryPoints, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ItineraryPointPITs, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ItineraryPointVersions, function (c) { return c.ItineraryPointVersions; }, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ItineraryPointVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.JobOrders, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.JobOrderPITs, null, function (o) { return o.Change; }, function (o) { return o.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.JobOrderVersions, function (c) { return c.JobOrderVersions; }, function (o) { return o.Change; }, function (o) { return o.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.JobOrderVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PilotJobOrders, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PilotJobOrderPITs, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PilotJobOrderVersions, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PilotJobOrderVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PortCalls, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PortCallPITs, null, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PortCallVersions, function (c) { return c.PortCallVersions; }, function (p) { return p.Change; }, function (p) { return p.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.PortCallVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.RecurringBatches, null, function (b) { return b.Change; }, function (b) { return b.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.RecurringBatchPITs, null, function (b) { return b.Change; }, function (b) { return b.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.RecurringBatchVersions, function (c) { return c.RecurringBatchVersions; }, function (v) { return v.Change; }, function (v) { return v.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.RecurringBatchVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ScheduleDates, null, function (d) { return d.Change; }, function (d) { return d.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ScheduleDatePITs, null, function (d) { return d.Change; }, function (d) { return d.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ScheduleDateVersions, function (c) { return c.ScheduleDateVersions; }, function (v) { return v.Change; }, function (v) { return v.ChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Changes, _this.ScheduleDateVersions, null, function (v) { return v.PrevChange; }, function (v) { return v.PrevChangeId(); });
        new DataCache_1.OneToOneRelationship(_this.Comments, _this.Events, function (c) { return c.Event; }, function (e) { return e.Comment; }, function (c) { return c.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Comments, _this.TaggedCommentUsers, function (c) { return c.TaggedUsers; }, function (t) { return t.Comment; }, function (t) { return t.CommentId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationAltStatusLabels, function (c) { return c.AltStatusLabels; }, function (l) { return l.Coordination; }, function (l) { return l.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationCards, function (c) { return c.Cards; }, function (c) { return c.Coordination; }, function (c) { return c.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationCardPITs, null, function (c) { return c.Coordination; }, function (c) { return c.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationCardVersions, null, function (v) { return v.Coordination; }, function (v) { return v.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationLocations, function (c) { return c.Locations; }, function (l) { return l.Coordination; }, function (l) { return l.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationMilestoneTypes, function (c) { return c.MilestoneTypes; }, function (t) { return t.Coordination; }, function (t) { return t.CoordinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Coordinations, _this.CoordinationProviders, function (c) { return c.Providers; }, function (p) { return p.Coordination; }, function (p) { return p.CoordinationId(); });
        new DataCache_1.OneToOneRelationship(_this.CoordinationCards, _this.CoordinationCardSelves, function (c) { return c.Self; }, function (s) { return s.Live; }, function (c) { return c.Id(); });
        new DataCache_1.OneToOneRelationship(_this.CoordinationCards, _this.CoordinationCardVersions, function (c) { return c.Version; }, null, function (c) { return CoordinationCardVersion_1.CoordinationCardVersion.dataKey({ Id: c.Id(), ChangeId: c.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardSelves, _this.Comments, function (s) { return s.Comments; }, function (c) { return c.SubjectCoordinationCard; }, function (c) { return c.SubjectCoordinationCardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardSelves, _this.CoordinationCardRelevances, function (s) { return s.Log; }, function (r) { return r.CoordinationCard; }, function (r) { return r.CoordinationCardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardSelves, _this.CoordinationCardVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.CoordinationCard; }, function (e) { return e.CoordinationCardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardStatuses, _this.CoordinationAltStatusLabels, null, function (l) { return l.Status; }, function (l) { return l.StatusId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardStatuses, _this.CoordinationCards, null, function (c) { return c.Status; }, function (c) { return c.StatusId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardStatuses, _this.CoordinationCardPITs, null, function (c) { return c.Status; }, function (c) { return c.StatusId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardStatuses, _this.CoordinationCardVersions, null, function (v) { return v.Status; }, function (v) { return v.StatusId(); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardVersions, _this.CoordinationCardVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : CoordinationCardVersion_1.CoordinationCardVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.CoordinationCardVersion; }, function (e) { return e.CoordinationCardId() === null ? null : CoordinationCardVersion_1.CoordinationCardVersion.dataKey({ Id: e.CoordinationCardId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationCardVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.CoordinationCardReferenceVersion; }, function (e) { return e.CoordinationCardId() === null || e.ReferenceId() === null ? null : CoordinationCardVersion_1.CoordinationCardVersion.dataKey({ Id: e.CoordinationCardId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationProviders, _this.CoordinationCards, function (p) { return p.CardsAsProvider; }, function (c) { return c.Provider; }, function (c) { return CoordinationProvider_1.CoordinationProvider.dataKey({ ProviderId: c.ProviderId(), CoordinationId: c.CoordinationId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationProviders, _this.CoordinationCardPITs, null, function (c) { return c.Provider; }, function (c) { return CoordinationProvider_1.CoordinationProvider.dataKey({ ProviderId: c.ProviderId(), CoordinationId: c.CoordinationId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.CoordinationProviders, _this.CoordinationCardVersions, null, function (v) { return v.Provider; }, function (v) { return CoordinationProvider_1.CoordinationProvider.dataKey({ ProviderId: v.ProviderId(), CoordinationId: v.CoordinationId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.LloydServiceVessels, null, function (v) { return v.Flag; }, function (v) { return v.FlagId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.MarineTrafficServiceVessels, null, function (v) { return v.Flag; }, function (v) { return v.FlagId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.OverrideServiceVessels, null, function (o) { return o.Flag; }, function (o) { return o.FlagId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.PostalAddresses, null, function (p) { return p.Country; }, function (p) { return p.CountryId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.PSixServiceVessels, null, function (v) { return v.Flag; }, function (v) { return v.FlagId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Countries, _this.Vessels, null, function (v) { return v.Flag; }, function (v) { return v.FlagId(); });
        new DataCache_1.ForeignKeyRelationship(_this.DispatchEvents, _this.ApprovalsOfCharges, function (de) { return de._approvalsOfCharges; }, function (ac) { return ac.DispatchEvent; }, function (ac) { return ac.DispatchEventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.DispatchEvents, _this.BillCoverages, function (de) { return de.Bills; }, function (c) { return c.DispatchEvent; }, function (c) { return c.DispatchEventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.AutomationSystems, function (d) { return d.AutomationSystems; }, function (a) { return a.Domain; }, function (a) { return a.DomainId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.BerthCapabilities, function (d) { return d.BerthCapabilities; }, function (c) { return c.Domain; }, function (c) { return c.DomainId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.Coordinations, function (d) { return d.Coordinations; }, function (c) { return c.Domain; }, function (c) { return c.DomainId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.DomainRelevances, function (d) { return d.Stream; }, function (e) { return e.Domain; }, function (e) { return e.DomainId(); });
        new DataCache_1.SharedKeyRelationship(_this.Domains, _this.DomainSettings, function (d) { return d.Settings; }, null);
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.Organizations, function (d) { return d.Organizations; }, function (o) { return o.Domain; }, function (o) { return o.DomainId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Domains, _this.Ports, function (d) { return d.Ports; }, function (p) { return p.Domain; }, function (p) { return p.DomainId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.BerthRelevances, function (e) { return e.Berths; }, function (b) { return b.Event; }, function (b) { return b.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.Comments, function (e) { return e.Comments; }, function (c) { return c.SubjectEvent; }, function (c) { return c.SubjectEventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.CoordinationCardRelevances, function (e) { return e.CoordinationCards; }, function (r) { return r.Event; }, function (r) { return r.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.DomainRelevances, function (e) { return e.Domains; }, function (d) { return d.Event; }, function (d) { return d.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.LogEvents, function (e) { return e.PortCalls; }, function (le) { return le.Event; }, function (le) { return le.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.Notifications, function (e) { return e.Notifications; }, function (n) { return n.Event; }, function (n) { return n.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.PilotJobOrderRelevances, function (e) { return e.PilotJobOrders; }, function (r) { return r.Event; }, function (r) { return r.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Events, _this.TopicCardChanges, null, function (c) { return c.OriginalCommentEvent; }, function (c) { return c.OriginalCommentEventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ExportPayloads, _this.BillExportPayloadAssignments, function (p) { return p.Bills; }, function (a) { return a.ExportPayload; }, function (a) { return a.ExportPayloadId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ExportPayloads, _this.ExportDeliveries, function (p) { return p.Deliveries; }, function (d) { return d.ExportPayload; }, function (d) { return d.ExportPayloadId(); });
        new DataCache_1.OneToOneRelationship(_this.GeoActivities, _this.Events, function (ga) { return ga.Event; }, function (e) { return e.GeoActivity; }, function (ga) { return ga.EventId(); });
        new DataCache_1.SharedKeyRelationship(_this.ItineraryPoints, _this.ItineraryPointSelves, function (pt) { return pt.Self; }, function (s) { return s.Live; });
        new DataCache_1.OneToOneRelationship(_this.ItineraryPoints, _this.ItineraryPointVersions, function (pt) { return pt.Version; }, null, function (pt) { return ItineraryPointVersion_1.ItineraryPointVersion.dataKey({ Id: pt.Id(), ChangeId: pt.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPoints, _this.PilotJobOrders, function (pt) { return pt.DeparturePilotJobOrders; }, function (pjo) { return pjo.FromPoint; }, function (pjo) { return pjo.FromPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPoints, _this.PilotJobOrders, function (pt) { return pt.ArrivalPilotJobOrders; }, function (pjo) { return pjo.ToPoint; }, function (pjo) { return pjo.ToPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPoints, _this.ScheduleDates, function (pt) { return pt.Schedule; }, function (d) { return d.ItineraryPoint; }, function (d) { return d.ItineraryPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointPITs, _this.PilotJobOrderPITs, function (pt) { return pt.DeparturePilotJobOrders; }, function (pjo) { return pjo.FromPoint; }, function (pjo) { return ItineraryPointPIT_1.ItineraryPointPITDataKey({ Id: pjo.FromPointId(), ChangeId: pjo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointPITs, _this.PilotJobOrderPITs, function (pt) { return pt.ArrivalPilotJobOrders; }, function (pjo) { return pjo.ToPoint; }, function (pjo) { return ItineraryPointPIT_1.ItineraryPointPITDataKey({ Id: pjo.ToPointId(), ChangeId: pjo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointPITs, _this.ScheduleDatePITs, function (pt) { return pt.Schedule; }, function (sd) { return sd.ItineraryPoint; }, function (sd) { return ItineraryPointPIT_1.ItineraryPointPITDataKey({ Id: sd.ItineraryPointId(), ChangeId: sd.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointSelves, _this.ItineraryPointVersions, function (pt) { return pt.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.ItineraryPoint; }, function (e) { return e.ItineraryPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointSelves, _this.PilotJobOrderVersions, null, function (v) { return v.FromPoint; }, function (v) { return v.FromPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointSelves, _this.PilotJobOrderVersions, null, function (v) { return v.ToPoint; }, function (v) { return v.ToPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointSelves, _this.ScheduleDateVersions, null, function (v) { return v.ItineraryPoint; }, function (v) { return v.ItineraryPointId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.ItineraryPointVersion; }, function (e) { return e.ItineraryPointId() === null ? null : ItineraryPointVersion_1.ItineraryPointVersion.dataKey({ Id: e.ItineraryPointId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.ItineraryPointReferenceVersion; }, function (e) { return e.ItineraryPointId() === null || e.ReferenceId() === null ? null : ItineraryPointVersion_1.ItineraryPointVersion.dataKey({ Id: e.ItineraryPointId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ItineraryPointVersions, _this.ItineraryPointVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : ItineraryPointVersion_1.ItineraryPointVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrders, _this.ApprovalsOfCharges, function (jo) { return jo._approvalsOfCharges; }, function (ac) { return ac.JobOrder; }, function (ac) { return ac.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrders, _this.BillCoverages, function (jo) { return jo.Bills; }, function (c) { return c.JobOrder; }, function (c) { return c.JobOrderId(); });
        new DataCache_1.SharedKeyRelationship(_this.JobOrders, _this.JobOrderSelves, function (jo) { return jo.Self; }, function (s) { return s.Live; });
        new DataCache_1.OneToOneRelationship(_this.JobOrders, _this.JobOrderVersions, function (jo) { return jo.Version; }, null, function (jo) { return JobOrderVersion_1.JobOrderVersion.dataKey({ Id: jo.Id(), ChangeId: jo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrders, _this.ScheduleDates, function (jo) { return jo.Schedule; }, function (d) { return d.JobOrder; }, function (d) { return d.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderPITs, _this.ScheduleDatePITs, function (jo) { return jo.Schedule; }, function (d) { return d.JobOrder; }, function (d) { return JobOrderPIT_1.JobOrderPITDataKey({ Id: d.JobOrderId(), ChangeId: d.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderSelves, _this.Comments, function (s) { return s.Comments; }, function (c) { return c.SubjectJobOrder; }, function (c) { return c.SubjectJobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.JobOrder; }, function (e) { return e.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderSelves, _this.JobOrderVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderSelves, _this.PilotJobOrderVersions, null, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderSelves, _this.ScheduleDateVersions, null, function (v) { return v.JobOrder; }, function (v) { return v.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.JobOrderVersion; }, function (e) { return e.JobOrderId() === null ? null : JobOrderVersion_1.JobOrderVersion.dataKey({ Id: e.JobOrderId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.JobOrderReferenceVersion; }, function (e) { return e.JobOrderId() === null || e.ReferenceId() === null ? null : JobOrderVersion_1.JobOrderVersion.dataKey({ Id: e.JobOrderId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.JobOrderVersions, _this.JobOrderVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : JobOrderVersion_1.JobOrderVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.LineHandlingCompanies, _this.PilotJobOrders, function (lh) { return lh.PilotJobOrders; }, function (pjo) { return pjo.LineHandlingCompany; }, function (pjo) { return pjo.LineHandlingCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.LineHandlingCompanies, _this.PilotJobOrderChanges, null, function (c) { return c.NewLineHandlingCompany; }, function (c) { return c.NewLineHandlingCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.LineHandlingCompanies, _this.PilotJobOrderChanges, null, function (c) { return c.OldLineHandlingCompany; }, function (c) { return c.OldLineHandlingCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.LineHandlingCompanies, _this.PilotJobOrderPITs, null, function (pjo) { return pjo.LineHandlingCompany; }, function (pjo) { return pjo.LineHandlingCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.LloydResults, _this.LloydServiceVessels, function (r) { return r.ServiceVessels; }, function (sv) { return sv.VesselResult; }, function (sv) { return sv.VesselResultId(); });
        new DataCache_1.ForeignKeyRelationship(_this.LloydServiceVessels, _this.Vessels, null, function (v) { return v.LloydServiceVessel; }, function (v) { return v.LloydServiceVesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.CoordinationLocations, null, function (cl) { return cl.Location; }, function (cl) { return cl.LocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.GeoActivities, function (l) { return l.GeoActivities; }, function (ga) { return ga.PortLocation; }, function (ga) { return ga.LocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.ItineraryPoints, function (l) { return l.Itinerary; }, function (pt) { return pt.Location; }, function (pt) { return pt.LocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.ItineraryPointPITs, null, function (pt) { return pt.Location; }, function (pt) { return pt.LocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.Locations, null, function (l) { return l.ContainingLocation; }, function (l) { return l.ContainingLocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.PilotJobOrderChanges, null, function (c) { return c.FromLocation; }, function (c) { return c.FromLocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.PilotJobOrderChanges, null, function (c) { return c.ToLocation; }, function (c) { return c.ToLocationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Locations, _this.WartsilaEnhancedEstimateQueries, null, function (q) { return q.Destination; }, function (q) { return q.DestinationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.MarineTrafficResults, _this.MarineTrafficServiceVessels, function (r) { return r.ServiceVessels; }, function (sv) { return sv.VesselResult; }, function (sv) { return sv.VesselResultId(); });
        new DataCache_1.ForeignKeyRelationship(_this.MarineTrafficServiceVessels, _this.Vessels, null, function (v) { return v.MarineTrafficServiceVessel; }, function (v) { return v.MarineTrafficServiceVesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.MilestoneTypes, _this.CoordinationMilestoneTypes, function (mt) { return mt.Coordinations; }, function (c) { return c.MilestoneType; }, function (c) { return c.MilestoneTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.MilestoneTypes, _this.ScheduleDates, null, function (d) { return d.MilestoneType; }, function (d) { return d.MilestoneTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.MilestoneTypes, _this.ScheduleDatePITs, null, function (d) { return d.MilestoneType; }, function (d) { return d.MilestoneTypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.AgencyCodes, function (o) { return o.AgencyCodesAsCodedOrganization; }, function (c) { return c.CodedOrganization; }, function (c) { return c.CodedOrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.Berths, function (o) { return o.ManagedBerths; }, function (b) { return b.SchedulingAuthority; }, function (b) { return b.SchedulingAuthorityId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.BerthAmenityTypes, function (o) { return o.BerthAmenityTypes; }, function (a) { return a.Organization; }, function (a) { return a.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.Bills, function (o) { return o.BillsAsCustomer; }, function (b) { return b.To; }, function (b) { return b.ToId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.BillingSystems, function (o) { return o.BillingSystems; }, function (sys) { return sys.Organization; }, function (sys) { return sys.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.CargoActivityTypes, function (o) { return o.CargoActivityTypes; }, function (t) { return t.Organization; }, function (t) { return t.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.CargoCategories, function (o) { return o.CargoCategories; }, function (c) { return c.Organization; }, function (c) { return c.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.CoordinationProviders, function (o) { return o.CoordinationsProvided; }, function (c) { return c.Provider; }, function (c) { return c.ProviderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.PCUsers, function (o) { return o.Users; }, function (u) { return u.Organization; }, function (u) { return u.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.PhoneNumbers, function (o) { return o.PhoneNumbers; }, null, function (pn) { return pn.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.PostalAddresses, function (o) { return o.PostalAddresses; }, null, function (a) { return a.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.Shares, function (o) { return o.Shares; }, function (s) { return s.Organization; }, function (s) { return s.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.TopicCardTemplates, function (o) { return o.TopicCardTemplates; }, function (t) { return t.Organization; }, function (t) { return t.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Organizations, _this.TradeRoutes, function (o) { return o.TradeRoutes; }, function (t) { return t.Organization; }, function (t) { return t.OrganizationId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.Events, null, function (e) { return e.User; }, function (e) { return e.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.Notifications, function (pu) { return pu.Notifications; }, function (n) { return n.User; }, function (n) { return n.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PhoneNumbers, function (pu) { return pu.PhoneNumbers; }, null, function (pn) { return pn.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PCUserPortCallEditors, function (pu) { return pu.PortCallEditors; }, function (pce) { return pce.PortCallOwner; }, function (pce) { return pce.PortCallOwnerId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PCUserPortCallEditors, null, function (pce) { return pce.PortCallEditor; }, function (pce) { return pce.PortCallEditorId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PilotJobOrderChanges, null, function (c) { return c.Agent; }, function (c) { return c.AgentId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PilotJobOrderUserPreferenceses, null, function (up) { return up.User; }, function (up) { return up.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PilotShiphandlingNotes, null, function (n) { return n.Noter; }, function (n) { return n.NoterId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCalls, function (pu) { return pu.PortCallsAsAgent; }, function (pc) { return pc.Agent; }, function (pc) { return pc.AgentId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCalls, function (pu) { return pu.PortCallsAsRequestor; }, function (pc) { return pc.Requestor; }, function (pc) { return pc.RequestorId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCallChanges, null, function (pcc) { return pcc.NewAgent; }, function (pcc) { return pcc.NewAgentId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCallChanges, null, function (pcc) { return pcc.InvitedEditor; }, function (pcc) { return pcc.InvitedEditorId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCallChanges, null, function (pcc) { return pcc.Watcher; }, function (pcc) { return pcc.WatcherId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCallPITs, null, function (pc) { return pc.Agent; }, function (pc) { return pc.AgentId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.PortCallPITs, null, function (pc) { return pc.Requestor; }, function (pc) { return pc.RequestorId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.Shares, function (u) { return u.Shares; }, function (s) { return s.User; }, function (s) { return s.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.TaggedCommentUsers, function (u) { return u.CommentsTaggedIn; }, function (t) { return t.User; }, function (t) { return t.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.TopicCards, function (u) { return u.AnsweredTopicCards; }, function (c) { return c.AnsweredBy; }, function (c) { return c.AnsweredById(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.TopicCardTemplateUserAssignments, function (pu) { return pu.TopicCardTemplates; }, function (a) { return a.User; }, function (a) { return a.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PCUsers, _this.TopicCardUserAssignments, function (pu) { return pu.TopicCards; }, function (a) { return a.User; }, function (a) { return a.UserId(); });
        new DataCache_1.SharedKeyRelationship(_this.PCUsers, _this.Users, function (pu) { return pu.User; }, function (u) { return u.PCUser; });
        new DataCache_1.ForeignKeyRelationship(_this.PierGroups, _this.Berths, function (g) { return g.Berths; }, function (b) { return b.PierGroup; }, function (b) { return b.PierGroupId(); });
        new DataCache_1.SharedKeyRelationship(_this.Pilots, _this.PCUsers, function (p) { return p.User; }, null);
        new DataCache_1.ForeignKeyRelationship(_this.Pilots, _this.PilotAssignments, function (p) { return p.PilotJobOrders; }, function (pa) { return pa.Pilot; }, function (pa) { return pa.PilotId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Pilots, _this.PilotJobOrderChanges, null, function (c) { return c.Pilot; }, function (c) { return c.PilotId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.AgencyCodes, function (pa) { return pa.AgencyCodes; }, function (c) { return c.PilotAgency; }, function (c) { return c.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.DispatchEvents, function (pa) { return pa.DispatchEvents; }, function (d) { return d.PilotAgency; }, function (d) { return d.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.LineHandlingCompanies, function (pa) { return pa.LineHandlingCompanies; }, function (l) { return l.PilotAgency; }, function (l) { return l.PilotAgencyId(); });
        new DataCache_1.SharedKeyRelationship(_this.PilotAgencies, _this.Organizations, function (pa) { return pa.Organization; }, function (o) { return o.PilotAgency; });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.PilotJobOrders, function (pa) { return pa.JobOrders; }, function (pjo) { return pjo.PilotAgency; }, function (pjo) { return pjo.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.PilotJobOrderPITs, null, function (pit) { return pit.PilotAgency; }, function (pit) { return pit.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.PilotSections, function (pa) { return pa.Sections; }, function (s) { return s.PilotAgency; }, function (s) { return s.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotAgencies, _this.TugCompanies, function (pa) { return pa.TugCompanies; }, function (t) { return t.PilotAgency; }, function (t) { return t.PilotAgencyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.ApprovalsOfCharges, function (pjo) { return pjo._approvalsOfCharges; }, null, function (ac) { return ac.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.BillCoverages, function (pjo) { return pjo.Bills; }, null, function (c) { return c.JobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.Issues, function (pjo) { return pjo.Issues; }, function (i) { return i.PilotJobOrder; }, function (i) { return i.PilotJobOrderId(); });
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrders, _this.JobOrders, function (pjo) { return pjo.JobOrder; }, function (jo) { return jo.PilotJobOrder; });
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrders, _this.JobOrderSelves, function (pjo) { return pjo.Self; }, null);
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.PilotAssignments, function (pjo) { return pjo.Pilots; }, function (pa) { return pa.PilotJobOrder; }, function (pa) { return pa.PilotJobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.PilotJobOrderChanges, function (pjo) { return pjo.Changes; }, function (c) { return c.PilotJobOrder; }, function (c) { return c.PilotJobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.PilotJobOrderRelevances, function (pjo) { return pjo.Log; }, function (r) { return r.PilotJobOrder; }, function (r) { return r.PilotJobOrderId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.PilotJobOrderUserPreferenceses, function (pjo) { return pjo.UserPreferences; }, function (up) { return up.PilotJobOrder; }, function (up) { return up.PilotJobOrderId(); });
        new DataCache_1.OneToOneRelationship(_this.PilotJobOrders, _this.PilotJobOrderVersions, function (pjo) { return pjo.Version; }, null, function (pjo) { return PilotJobOrderVersion_1.PilotJobOrderVersion.dataKey({ Id: pjo.Id(), ChangeId: pjo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrders, _this.ScheduleDates, function (pjo) { return pjo.Schedule; }, null, function (d) { return d.JobOrderId(); });
        new DataCache_1.OneToOneRelationship(_this.PilotJobOrderCancellations, _this.Events, function (c) { return c.Event; }, function (e) { return e.PilotJobOrderCancellation; }, function (c) { return c.EventId(); });
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrderCancellations, _this.PilotJobOrders, function (c) { return c.PilotJobOrder; }, function (pjo) { return pjo.Cancellation; });
        new DataCache_1.OneToOneRelationship(_this.PilotJobOrderChanges, _this.Events, function (p) { return p.Event; }, function (e) { return e.PilotJobOrderChange; }, function (p) { return p.EventId(); });
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrderPITs, _this.JobOrderPITs, function (pjo) { return pjo.JobOrder; }, function (jo) { return jo.PilotJobOrder; });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrderPITs, _this.PilotJobOrderCancellations, null, function (c) { return c.PointInTime; }, function (c) { return PilotJobOrderPIT_1.PilotJobOrderPITDataKey({ Id: c.Id(), ChangeId: c.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrderPITs, _this.ScheduleDatePITs, function (pjo) { return pjo.Schedule; }, null, function (d) { return PilotJobOrderPIT_1.PilotJobOrderPITDataKey({ Id: d.JobOrderId(), ChangeId: d.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotJobOrderVersions, _this.PilotJobOrderVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : PilotJobOrderVersion_1.PilotJobOrderVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PilotSections, _this.Pilots, function (s) { return s.Pilots; }, function (p) { return p.Section; }, function (p) { return p.SectionId(); });
        new DataCache_1.OneToOneRelationship(_this.PilotShiphandlingNotes, _this.Events, function (s) { return s.Event; }, function (e) { return e.PilotShiphandlingNote; }, function (s) { return s.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.Locations, function (p) { return p.Locations; }, function (l) { return l.Port; }, function (l) { return l.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.PierGroups, function (p) { return p.PierGroups; }, function (pg) { return pg.Port; }, function (pg) { return pg.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.PortCalls, function (p) { return p.PortCalls; }, function (pc) { return pc.Port; }, function (pc) { return pc.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.PortCallPITs, null, function (pc) { return pc.Port; }, function (pc) { return pc.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.RecurringBatches, function (p) { return p.RecurringBatches; }, function (b) { return b.Port; }, function (b) { return b.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Ports, _this.RecurringBatchPITs, null, function (b) { return b.Port; }, function (b) { return b.PortId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.GeoActivities, function (pc) { return pc.GeoActivities; }, function (ga) { return ga.PortCall; }, function (ga) { return ga.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.ItineraryPoints, function (pc) { return pc.Itinerary; }, function (pt) { return pt.PortCall; }, function (pt) { return pt.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.JobOrders, function (pc) { return pc.JobOrders; }, function (jo) { return jo.PortCall; }, function (jo) { return jo.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.LogEvents, function (pc) { return pc.Log; }, function (e) { return e.PortCall; }, function (e) { return e.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.PilotJobOrders, null, function (pjo) { return pjo.PortCall; }, function (pjo) { return pjo.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.PortCallChanges, function (pc) { return pc.Changes; }, function (c) { return c.PortCall; }, function (c) { return c.PortCallId(); });
        new DataCache_1.SharedKeyRelationship(_this.PortCalls, _this.PortCallSelves, function (pc) { return pc.Self; }, function (s) { return s.Live; });
        new DataCache_1.OneToOneRelationship(_this.PortCalls, _this.PortCallVersions, function (pc) { return pc.Version; }, null, function (pc) { return PortCallVersion_1.PortCallVersion.dataKey({ Id: pc.Id(), ChangeId: pc.ChangeId() }); });
        new DataCache_1.OneToOneRelationship(_this.PortCalls, _this.SharingTokens, function (pc) { return pc.Sharing; }, null, function (pc) { return pc.SharingId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.ScheduleDates, function (pc) { return pc.Schedule; }, function (d) { return d.PortCall; }, function (d) { return d.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCalls, _this.TopicCards, function (pc) { return pc.TopicCards; }, function (tc) { return tc.PortCall; }, function (tc) { return tc.PortCallId(); });
        new DataCache_1.OneToOneRelationship(_this.PortCallChanges, _this.Events, function (pcc) { return pcc.Event; }, function (e) { return e.PortCallChange; }, function (pcc) { return pcc.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallChanges, _this.ScheduleDateEvents, function (pcc) { return pcc.ScheduleEvents; }, function (e) { return e.ScheduleChange; }, function (c) { return c.ScheduleChangeId(); });
        new DataCache_1.OneToOneRelationship(_this.PortCallDeletions, _this.Events, function (p) { return p.Event; }, function (e) { return e.PortCallDeletion; }, function (p) { return p.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallPITs, _this.ItineraryPointPITs, function (pc) { return pc.Itinerary; }, function (pt) { return pt.PortCall; }, function (pt) { return PortCallPIT_1.PortCallPITDataKey({ Id: pt.PortCallId(), ChangeId: pt.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallPITs, _this.JobOrderPITs, function (pc) { return pc.JobOrders; }, function (jo) { return jo.PortCall; }, function (jo) { return PortCallPIT_1.PortCallPITDataKey({ Id: jo.PortCallId(), ChangeId: jo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallPITs, _this.PilotJobOrderPITs, null, function (pjo) { return pjo.PortCall; }, function (pjo) { return PortCallPIT_1.PortCallPITDataKey({ Id: pjo.PortCallId(), ChangeId: pjo.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallPITs, _this.ScheduleDatePITs, function (pc) { return pc.Schedule; }, function (sd) { return sd.PortCall; }, function (sd) { return PortCallPIT_1.PortCallPITDataKey({ Id: sd.PortCallId(), ChangeId: sd.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.Comments, function (s) { return s.Comments; }, function (c) { return c.SubjectPortCall; }, function (c) { return c.SubjectPortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.PortCall; }, function (e) { return e.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.ItineraryPointVersions, null, function (v) { return v.PortCall; }, function (v) { return v.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.JobOrderVersions, null, function (v) { return v.PortCall; }, function (v) { return v.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.PilotJobOrderVersions, null, function (v) { return v.PortCall; }, function (v) { return v.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.PortCallVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.ScheduleDateVersions, null, function (v) { return v.PortCall; }, function (v) { return v.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallSelves, _this.WartsilaEnhancedEstimateQueries, null, function (q) { return q.PortCallSelf; }, function (q) { return q.PortCallSelfId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.PortCallVersion; }, function (e) { return e.PortCallId() === null ? null : PortCallVersion_1.PortCallVersion.dataKey({ Id: e.PortCallId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.PortCallReferenceVersion; }, function (e) { return e.PortCallId() === null || e.ReferenceId() === null ? null : PortCallVersion_1.PortCallVersion.dataKey({ Id: e.PortCallId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PortCallVersions, _this.PortCallVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : PortCallVersion_1.PortCallVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.PostalAddresses, _this.Berths, null, function (b) { return b.PostalAddress; }, function (b) { return b.PostalAddressId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PSixVesselResults, _this.PSixServiceVessels, function (r) { return r.ServiceVessels; }, function (sv) { return sv.VesselResult; }, function (sv) { return sv.VesselResultId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PSixVesselResults, _this.PSixVesselDimensions, function (r) { return r.Dimensions; }, function (d) { return d.VesselResult; }, function (d) { return d.VesselResultId(); });
        new DataCache_1.SharedKeyRelationship(_this.PSixVesselResults, _this.PSixVesselParticulars, function (r) { return r.PSixVesselParticulars; }, function (p) { return p.VesselResult; });
        new DataCache_1.ForeignKeyRelationship(_this.PSixVesselResults, _this.PSixVesselTonnages, function (r) { return r.Tonnages; }, function (t) { return t.VesselResult; }, function (t) { return t.VesselResultId(); });
        new DataCache_1.ForeignKeyRelationship(_this.PSixServiceVessels, _this.Vessels, null, function (v) { return v.PSixServiceVessel; }, function (v) { return v.PSixServiceVesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Rates, _this.ApprovedCharges, null, function (c) { return c.StandardRate; }, function (c) { return c.StandardRateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Rates, _this.BillItems, null, function (i) { return i.StandardRate; }, function (i) { return i.StandardRateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatches, _this.PortCalls, function (b) { return b.PortCalls; }, function (pc) { return pc.Batch; }, function (pc) { return pc.BatchId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatches, _this.RecurringBatchChanges, function (b) { return b.Changes; }, function (c) { return c.Batch; }, function (c) { return c.BatchId(); });
        new DataCache_1.SharedKeyRelationship(_this.RecurringBatches, _this.RecurringBatchSelves, function (b) { return b.Self; }, function (s) { return s.Live; });
        new DataCache_1.OneToOneRelationship(_this.RecurringBatches, _this.RecurringBatchVersions, function (b) { return b.Version; }, null, function (b) { return RecurringBatchVersion_1.RecurringBatchVersion.dataKey({ Id: b.Id(), ChangeId: b.ChangeId() }); });
        new DataCache_1.OneToOneRelationship(_this.RecurringBatchChanges, _this.Events, function (c) { return c.Event; }, function (e) { return e.RecurringBatchChange; }, function (c) { return c.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchChanges, _this.PortCallChanges, function (c) { return c.ReservationChanges; }, function (c) { return c.RecurringBatchChange; }, function (c) { return c.RecurringBatchChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchChanges, _this.PortCallDeletions, function (c) { return c.PortCallDeletions; }, function (d) { return d.RecurringBatchChange; }, function (d) { return d.RecurringBatchChangeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchDeletions, _this.PortCallDeletions, function (d) { return d.PortCallDeletions; }, function (d) { return d.RecurringBatchDeletion; }, function (d) { return d.RecurringBatchDeletionId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchPITs, _this.PortCallPITs, function (b) { return b.PortCalls; }, function (pc) { return pc.Batch; }, function (pc) { return pc.BatchId() === null ? null : RecurringBatchPIT_1.RecurringBatchPITDataKey({ Id: pc.BatchId(), ChangeId: pc.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchSelves, _this.Events, function (s) { return s.Events; }, function (e) { return e.RecurringBatch; }, function (e) { return e.RecurringBatchId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchSelves, _this.PortCallVersions, null, function (v) { return v.Batch; }, function (v) { return v.BatchId(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchSelves, _this.RecurringBatchVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchVersions, _this.Events, function (v) { return v.EventsAbout; }, function (e) { return e.RecurringBatchVersion; }, function (e) { return e.RecurringBatchId() === null ? null : RecurringBatchVersion_1.RecurringBatchVersion.dataKey({ Id: e.RecurringBatchId(), ChangeId: e.AboutId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchVersions, _this.Events, function (v) { return v.EventsReferencing; }, function (e) { return e.RecurringBatchReferenceVersion; }, function (e) { return e.RecurringBatchId() === null || e.ReferenceId() === null ? null : RecurringBatchVersion_1.RecurringBatchVersion.dataKey({ Id: e.RecurringBatchId(), ChangeId: e.ReferenceId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.RecurringBatchVersions, _this.RecurringBatchVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : RecurringBatchVersion_1.RecurringBatchVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.Roles, _this.UserRoles, function (r) { return r.Users; }, function (ur) { return ur.Role; }, function (ur) { return ur.RoleId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDates, _this.CoordinationCards, function (d) { return d.CoordinationCards; }, function (c) { return c.ScheduleDate; }, function (c) { return c.ScheduleDateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDates, _this.Issues, function (d) { return d.Issues; }, function (i) { return i.ScheduleDate; }, function (i) { return i.ScheduleDateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDates, _this.ScheduleDateEvents, function (d) { return d.Events; }, function (e) { return e.ScheduleDate; }, function (e) { return e.ScheduleDateId(); });
        new DataCache_1.OneToOneRelationship(_this.ScheduleDates, _this.ScheduleDateSelves, function (d) { return d.Self; }, function (s) { return s.Live; }, function (d) { return d.Id(); });
        new DataCache_1.OneToOneRelationship(_this.ScheduleDates, _this.ScheduleDateVersions, function (d) { return d.Version; }, null, function (d) { return ScheduleDateVersion_1.ScheduleDateVersion.dataKey({ Id: d.Id(), ChangeId: d.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDateEvents, _this.Issues, function (e) { return e.ScheduleDateIssues; }, function (i) { return i.EnteredDate; }, function (i) { return i.EnteredDateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDatePITs, _this.CoordinationCardPITs, function (sd) { return sd.CoordinationCards; }, function (cc) { return cc.ScheduleDate; }, function (cc) { return ScheduleDatePIT_1.ScheduleDatePITDataKey({ Id: cc.ScheduleDateId(), ChangeId: cc.ChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDateSelves, _this.CoordinationCardVersions, function (s) { return s.CoordinationCardVersions; }, function (v) { return v.ScheduleDate; }, function (v) { return v.ScheduleDateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDateSelves, _this.CoordinationCardVersions, function (s) { return s.DeletedCoordinationCardVersions; }, null, function (v) { return v.Deleted() ? v.ScheduleDateId() : null; });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDateSelves, _this.ScheduleDateVersions, function (s) { return s.Versions; }, function (v) { return v.Self; }, function (v) { return v.Id(); });
        new DataCache_1.ForeignKeyRelationship(_this.ScheduleDateVersions, _this.ScheduleDateVersions, function (v) { return v.NextVersion; }, function (v) { return v.PrevVersion; }, function (v) { return v.PrevChangeId() === null ? null : ScheduleDateVersion_1.ScheduleDateVersion.dataKey({ Id: v.Id(), ChangeId: v.PrevChangeId() }); });
        new DataCache_1.ForeignKeyRelationship(_this.SharingTokens, _this.Shares, function (t) { return t.Shares; }, function (s) { return s.Token; }, function (s) { return s.TokenId(); });
        new DataCache_1.ForeignKeyRelationship(_this.StandardItems, _this.ApprovedCharges, null, function (c) { return c.StandardItem; }, function (c) { return c.StandardItemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.StandardItems, _this.BillItems, null, function (i) { return i.StandardItem; }, function (i) { return i.StandardItemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.StandardItems, _this.Rates, function (i) { return i.Rates; }, function (r) { return r.StandardItem; }, function (r) { return r.StandardItemId(); });
        new DataCache_1.ForeignKeyRelationship(_this.StandardItemTypes, _this.StandardItems, function (t) { return t.Items; }, function (i) { return i.Type; }, function (i) { return i.TypeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCards, _this.TopicCardChanges, function (c) { return c.Changes; }, function (c) { return c.Card; }, function (c) { return c.CardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCards, _this.Comments, function (tc) { return tc.Comments; }, function (c) { return c.SubjectTopicCard; }, function (c) { return c.SubjectTopicCardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCards, _this.TopicCardAvailableAttachments, function (c) { return c.AvailableAttachments; }, function (a) { return a.Card; }, function (a) { return a.CardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCards, _this.TopicCardOptions, function (tc) { return tc.Options; }, function (o) { return o.Card; }, function (o) { return o.CardId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCards, _this.TopicCardUserAssignments, function (tc) { return tc.People; }, function (a) { return a.Card; }, function (a) { return a.CardId(); });
        new DataCache_1.OneToOneRelationship(_this.TopicCardChanges, _this.Events, function (c) { return c.Event; }, function (e) { return e.TopicCardChange; }, function (c) { return c.EventId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardOptions, _this.TopicCardSelectedOptions, null, function (s) { return s.Option; }, function (s) { return s.OptionId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardOptions, _this.TopicCardChanges, null, function (c) { return c.NewSelectedOption; }, function (c) { return c.NewSelectedOptionId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardOptions, _this.TopicCardChanges, null, function (c) { return c.OldSelectedOption; }, function (c) { return c.OldSelectedOptionId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardOptions, _this.TopicCardChanges, null, function (c) { return c.OriginalSelectedOption; }, function (c) { return c.OriginalSelectedOptionId(); });
        new DataCache_1.SharedKeyRelationship(_this.TopicCardSelectedOptions, _this.TopicCards, function (o) { return o.Card; }, function (c) { return c.SelectedOption; });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardTemplates, _this.TopicCards, null, function (c) { return c.Template; }, function (c) { return c.TemplateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardTemplates, _this.TopicCardTemplateAttachments, function (t) { return t.Attachments; }, function (a) { return a.Template; }, function (a) { return a.TemplateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardTemplates, _this.TopicCardTemplateOptions, function (t) { return t.Options; }, function (o) { return o.Template; }, function (o) { return o.TemplateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardTemplates, _this.TopicCardTemplateUserAssignments, function (t) { return t.People; }, function (a) { return a.Template; }, function (a) { return a.TemplateId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TradeRoutes, _this.CargoActivities, null, function (a) { return a.TradeRoute; }, function (a) { return a.TradeRouteId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TugCompanies, _this.PilotJobOrders, function (t) { return t.PilotJobOrders; }, function (pjo) { return pjo.TugCompany; }, function (pjo) { return pjo.TugCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TugCompanies, _this.PilotJobOrderChanges, null, function (c) { return c.NewTugCompany; }, function (c) { return c.NewTugCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TugCompanies, _this.PilotJobOrderChanges, null, function (c) { return c.OldTugCompany; }, function (c) { return c.OldTugCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TugCompanies, _this.PilotJobOrderPITs, null, function (pjo) { return pjo.TugCompany; }, function (pjo) { return pjo.TugCompanyId(); });
        new DataCache_1.ForeignKeyRelationship(_this.UIThemes, _this.DomainSettings, null, function (u) { return u.DefaultUITheme; }, function (u) { return u.DefaultUIThemeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.UIThemes, _this.Organizations, null, function (u) { return u.UITheme; }, function (u) { return u.UIThemeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.UIThemes, _this.PCUsers, null, function (u) { return u.UITheme; }, function (u) { return u.UIThemeId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Users, _this.UserRoles, function (u) { return u.Roles; }, function (ur) { return ur.User; }, function (r) { return r.UserId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.GeoActivities, null, function (ga) { return ga.Vessel; }, function (ga) { return ga.VesselId(); });
        new DataCache_1.SharedKeyRelationship(_this.Vessels, _this.OverrideServiceVessels, function (v) { return v.OverrideServiceVessel; }, function (o) { return o.Vessel; });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PilotJobOrders, null, function (pjo) { return pjo.Vessel; }, function (pjo) { return pjo.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PilotJobOrderChanges, null, function (c) { return c.Vessel; }, function (c) { return c.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PilotJobOrderPITs, null, function (pjo) { return pjo.Vessel; }, function (pjo) { return pjo.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PilotShiphandlingNotes, function (v) { return v.PilotShiphandlingNotes; }, function (n) { return n.Vessel; }, function (n) { return n.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PortCalls, function (v) { return v.PortCalls; }, function (pc) { return pc.Vessel; }, function (pc) { return pc.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PortCallChanges, null, function (pcc) { return pcc.NewVessel; }, function (pcc) { return pcc.NewVesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PortCallChanges, null, function (pcc) { return pcc.OldVessel; }, function (pcc) { return pcc.OldVesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.PortCallPITs, null, function (pc) { return pc.Vessel; }, function (pc) { return pc.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.VesselChanges, function (v) { return v.Changes; }, function (c) { return c.Vessel; }, function (c) { return c.VesselId(); });
        new DataCache_1.ForeignKeyRelationship(_this.Vessels, _this.WartsilaEnhancedEstimateQueries, null, function (q) { return q.Vessel; }, function (q) { return q.VesselId(); });
        new DataCache_1.OneToOneRelationship(_this.VesselChanges, _this.Events, function (c) { return c.Event; }, function (e) { return e.VesselChange; }, function (c) { return c.EventId(); });
        new DataCache_1.SharedKeyRelationship(_this.WartsilaEnhancedEstimates, _this.WartsilaEnhancedEstimateQueries, function (e) { return e.Query; }, function (q) { return q.Result; });
        return _this;
    }
    PCCache.prototype.update = function (timestamp, data) {
        var _this = this;
        var result = new DataCacheUpdate_1.DataCacheUpdateEntities(), pilotEntities = new PilotsDataCacheUpdateEntities_1.PilotsDataCacheUpdateEntities(), wartsilaEntities = new WartsilaDataCacheUpdateEntities_1.WartsilaDataCacheUpdateEntities();
        s_js_1.default.freeze(function () {
            // Berths Module
            result.BerthCapabilities(updateCollection(_this.BerthCapabilities, function (d) { return d.BerthCapabilities; }));
            result.BerthCapabilityAssignments(updateCollection(_this.BerthCapabilityAssignments, function (d) { return d.BerthCapabilityAssignments; }));
            result.BerthClosures(updateCollection(_this.BerthClosures, function (d) { return d.BerthClosures; }));
            result.BerthReservations(updateCollection(_this.BerthReservations, function (d) { return d.BerthReservations; }));
            result.BerthReservationVersions(updateCollection(_this.BerthReservationVersions, function (d) { return d.BerthReservationVersions; }));
            result.Berths(updateCollection(_this.Berths, function (d) { return d.Berths; }));
            result.CargoActivities(updateCollection(_this.CargoActivities, function (d) { return d.CargoActivities; }));
            result.Comments(updateCollection(_this.Comments, function (d) { return d.Comments; }));
            result.CoordinationCards(updateCollection(_this.CoordinationCards, function (d) { return d.CoordinationCards; }));
            result.CoordinationCardRelevances(updateCollection(_this.CoordinationCardRelevances, function (d) { return d.CoordinationCardRelevances; }));
            result.CoordinationCardSelves(updateCollection(_this.CoordinationCardSelves, function (d) { return d.CoordinationCardSelves; }));
            result.CoordinationCardVersions(updateCollection(_this.CoordinationCardVersions, function (d) { return d.CoordinationCardVersions; }));
            result.Countries(updateCollection(_this.Countries, function (d) { return d.Countries; }));
            result.CruiseActivities(updateCollection(_this.CruiseActivities, function (d) { return d.CruiseActivities; }));
            result.Events(updateCollection(_this.Events, function (d) { return d.Events; }));
            result.Issues(updateCollection(_this.Issues, function (d) { return d.Issues; }));
            result.ItineraryPoints(updateCollection(_this.ItineraryPoints, function (d) { return d.ItineraryPoints; }));
            result.ItineraryPointVersions(updateCollection(_this.ItineraryPointVersions, function (d) { return d.ItineraryPointVersions; }));
            result.Locations(updateCollection(_this.Locations, function (d) { return d.Locations; }));
            result.LogEvents(updateCollection(_this.LogEvents, function (d) { return d.LogEvents; }));
            result.Organizations(updateCollection(_this.Organizations, function (d) { return d.Organizations; }));
            result.OverrideServiceVessels(updateCollection(_this.OverrideServiceVessels, function (d) { return d.OverrideServiceVessels; }));
            result.PierGroups(updateCollection(_this.PierGroups, function (d) { return d.PierGroups; }));
            result.PortCallChanges(updateCollection(_this.PortCallChanges, function (d) { return d.PortCallChanges; }));
            result.PortCalls(updateCollection(_this.PortCalls, function (d) { return d.PortCalls; }));
            result.PortCallVersions(updateCollection(_this.PortCallVersions, function (d) { return d.PortCallVersions; }));
            result.Ports(updateCollection(_this.Ports, function (d) { return d.Ports; }));
            result.RecurringBatches(updateCollection(_this.RecurringBatches, function (d) { return d.RecurringBatches; }));
            result.ScheduleDates(updateCollection(_this.ScheduleDates, function (d) { return d.ScheduleDates; }));
            result.ScheduleDateEvents(updateCollection(_this.ScheduleDateEvents, function (d) { return d.ScheduleDateEvents; }));
            result.Shares(updateCollection(_this.Shares, function (d) { return d.Shares; }));
            result.TaggedCommentUsers(updateCollection(_this.TaggedCommentUsers, function (d) { return d.TaggedCommentUsers; }));
            result.TopicCardAvailableAttachments(updateCollection(_this.TopicCardAvailableAttachments, function (d) { return d.TopicCardAvailableAttachments; }));
            result.TopicCardChanges(updateCollection(_this.TopicCardChanges, function (d) { return d.TopicCardChanges; }));
            result.TopicCardOptions(updateCollection(_this.TopicCardOptions, function (d) { return d.TopicCardOptions; }));
            result.TopicCardSelectedOptions(updateCollection(_this.TopicCardSelectedOptions, function (d) { return d.TopicCardSelectedOptions; }));
            result.TopicCards(updateCollection(_this.TopicCards, function (d) { return d.TopicCards; }));
            result.Users(updateCollection(_this.PCUsers, function (d) { return d.Users; }));
            result.Vessels(updateCollection(_this.Vessels, function (d) { return d.Vessels; }));
            result.VesselChanges(updateCollection(_this.VesselChanges, function (d) { return d.VesselChanges; }));
            // Pilots Module
            pilotEntities.Pilots(updateCollection(_this.Pilots, function (d) { return d.PilotEntities && d.PilotEntities.Pilots; }));
            pilotEntities.PilotAgencies(updateCollection(_this.PilotAgencies, function (d) { return d.PilotEntities && d.PilotEntities.PilotAgencies; }));
            pilotEntities.PilotAssignments(updateCollection(_this.PilotAssignments, function (d) { return d.PilotEntities && d.PilotEntities.PilotAssignments; }));
            pilotEntities.PilotJobOrders(updateCollection(_this.PilotJobOrders, function (d) { return d.PilotEntities && d.PilotEntities.PilotJobOrders; }));
            pilotEntities.PilotJobOrderVersions(updateCollection(_this.PilotJobOrderVersions, function (d) { return d.PilotEntities && d.PilotEntities.PilotJobOrderVersions; }));
            pilotEntities.PilotJobOrderChanges(updateCollection(_this.PilotJobOrderChanges, function (d) { return d.PilotEntities && d.PilotEntities.PilotJobOrderChanges; }));
            pilotEntities.PilotJobOrderRelevances(updateCollection(_this.PilotJobOrderRelevances, function (d) { return d.PilotEntities && d.PilotEntities.PilotJobOrderRelevances; }));
            pilotEntities.PilotSections(updateCollection(_this.PilotSections, function (d) { return d.PilotEntities && d.PilotEntities.PilotSections; }));
            pilotEntities.PilotShiphandlingNotes(updateCollection(_this.PilotShiphandlingNotes, function (d) { return d.PilotEntities && d.PilotEntities.PilotShiphandlingNotes; }));
            result.PilotEntities(pilotEntities);
            // Wartsila
            wartsilaEntities.EnhancedEstimates(updateCollection(_this.WartsilaEnhancedEstimates, function (d) { return d.WartsilaEntities && d.WartsilaEntities.EnhancedEstimates; }));
            wartsilaEntities.EnhancedEstimateQueries(updateCollection(_this.WartsilaEnhancedEstimateQueries, function (d) { return d.WartsilaEntities && d.WartsilaEntities.EnhancedEstimateQueries; }));
            result.WartsilaEntities(wartsilaEntities);
        });
        return result;
        function updateCollection(col, d) {
            return col.update(timestamp, d(data.Updates || {}) || [], (d(data.Deletes || {}) || []).map(col.dataKey));
        }
    };
    return PCCache;
}(DataCache_1.DataCache));
exports.PCCache = PCCache;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(58);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCModal = void 0;
var React = __webpack_require__(2);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
__webpack_require__(603);
var PCModal = /** @class */ (function (_super) {
    __extends(PCModal, _super);
    function PCModal(props) {
        var _this = _super.call(this, props) || this;
        _this.modalref = supercritical_1.SuperCriticalReference(_this, function (props, el) { return $(el).modal(props.shown() ? 'show' : 'hide'); }, function (el) {
            // No matter what, always hide modal when removing from DOM.
            // W/o this Bootstrap leaves the backdrop in the DOM. So if you, say, link to another
            // page from inside an open modal, you'll land on the new page w/ the backdrop still in
            // place and unable to be dismissed.
            // For testing if a modal is shown, see https://stackoverflow.com/a/21341587
            var modal = $(el).data('bs.modal');
            if (modal && modal.isShown)
                modal.hide();
        });
        return _this;
    }
    PCModal.prototype.srender = function (props) {
        return (React.createElement("div", { className: 'pcmodal modal fade ' + (props.className ? props.className : ''), role: "dialog", "data-backdrop": "static", "aria-hidden": "true", ref: this.modalref },
            React.createElement("div", { className: "modal-dialog" }, props.children),
            React.createElement("div", { className: "backdrop-click-zone", onClick: props.onBackDropClick })));
    };
    return PCModal;
}(supercritical_1.SuperCriticalComponent));
exports.PCModal = PCModal;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mapErrorKeys = exports.filterErrors = exports.mergeErrors = exports.parseModelStateErrors = exports.ValidationWatcher = void 0;
var s_js_1 = __webpack_require__(0);
function ValidationWatcher(client) {
    var validation = s_js_1.default.data({});
    s_js_1.default.on(client.LastResponse, function () {
        var res = client.LastResponse();
        validation(res !== null && res.Status === 400 ? parseModelStateErrors(res.Data) : {});
    }, null, true);
    return validation;
}
exports.ValidationWatcher = ValidationWatcher;
function parseModelStateErrors(data) {
    var parsed = {};
    for (var field in data.ModelState) {
        var errors = data.ModelState[field];
        var dot = field.indexOf('.');
        if (dot !== -1)
            field = field.substr(dot + 1);
        parsed[field] = Error(field, errors);
    }
    return parsed;
}
exports.parseModelStateErrors = parseModelStateErrors;
function Error(field, errors) {
    var errorTexts = errors.map(function (err) { return translateText(field, err); });
    return {
        Field: field,
        RawErrors: errors,
        ErrorTexts: errorTexts,
        ErrorText: errorTexts[0] || ""
    };
}
function mergeErrors() {
    var _a;
    var errors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        errors[_i] = arguments[_i];
    }
    var merged = {};
    for (var _b = 0, errors_1 = errors; _b < errors_1.length; _b++) {
        var errs = errors_1[_b];
        for (var key in errs) {
            merged[key] = (_a = merged[key]) !== null && _a !== void 0 ? _a : {
                Field: key,
                RawErrors: [],
                ErrorTexts: [],
                ErrorText: ""
            };
            merged[key].RawErrors = merged[key].RawErrors.concat(errs[key].RawErrors);
            merged[key].ErrorTexts = merged[key].ErrorTexts.concat(errs[key].ErrorTexts);
            merged[key].ErrorText = merged[key].ErrorText || errs[key].ErrorText;
        }
    }
    return merged;
}
exports.mergeErrors = mergeErrors;
/**
 * Filter an errors collection by error key, returning a new errors collection.
 * @param errors The errors collection to filter.
 * @param keyFilterFn A function to determine which error keys to keep. Avoid modifying the provided errors
 * collection from this keyFilter function, as that may cause unexpected behavior or JS exceptions.
 */
function filterErrors(errors, keyFilterFn) {
    var out = {};
    for (var key in errors) {
        if (keyFilterFn(key)) {
            out[key] = errors[key];
        }
    }
    return out;
}
exports.filterErrors = filterErrors;
/**
 * Produce a new errors collection based on another errors collection but with keys transformed.
 * @param errors The errors collection to base the new collection off of.
 * @param keyMapper A function to perform the key transformations. Avoid modifying the provided errors
 * collection from this keyMapper function, as that may cause unexpected behavior or JS exceptions.
 */
function mapErrorKeys(errors, keyMapper) {
    var out = {};
    for (var key in errors) {
        out[keyMapper(key)] = errors[key];
    }
    return out;
}
exports.mapErrorKeys = mapErrorKeys;
var CAMEL_CASE_BOUNDARY = /([a-z])([A-Z])/g;
var REQUIRED = /required/i;
var INTEGER = /integer/i;
var DOUBLE = /double/i;
var MAXIMUM_LENGTH_OF = /maximum length of (\d+)/;
var MINIMUM_LENGTH_OF = /minimum length of (\d+)/;
function translateText(field, error) {
    var dot = field.indexOf('.');
    // for complex fields, return original error unchanged
    if (dot !== -1)
        return error;
    // convert from camel case to capitalized text with spaces
    field = field.replace(CAMEL_CASE_BOUNDARY, "$1 $2");
    if (REQUIRED.test(error)) {
        return field + " is required.";
    }
    else if (INTEGER.test(error)) {
        return field + " must be an integer.";
    }
    else if (DOUBLE.test(error)) {
        return field + " must be a number.";
    }
    var maxLengthMatch = MAXIMUM_LENGTH_OF.exec(error);
    var minLengthMatch = MINIMUM_LENGTH_OF.exec(error);
    if (minLengthMatch && maxLengthMatch)
        return field + " must be between " + minLengthMatch[1]
            + " and " + maxLengthMatch[1] + " characters.";
    if (maxLengthMatch)
        return field + " cannot be more than " + maxLengthMatch[1] + " characters.";
    if (minLengthMatch)
        return field + " must be at least " + minLengthMatch[1] + " characters.";
    return error;
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(180)('wks');
var uid = __webpack_require__(103);
var Symbol = __webpack_require__(16).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/// <summary>
/// Reference list of codes identifying standard units of measure, as well as their English names and, when appropriate, conversion factors between them.
/// Uses consistent UOM codes with the server-side UOM utility class.
/// </summary>
var UOM = {
    // imperial weight
    Ounce: "oz",
    Pound: "lb",
    ShortTon: "ton",
    LongTon: "lton",
    // metric mass
    Gram: "g",
    Kilogram: "kg",
    MetricTon: "mton",
    Inch: "in",
    Foot: "ft",
    Yard: "yd",
    Mile: "mi",
    Centimeter: "cm",
    Meter: "m",
    Kilometer: "km",
    Each: "ea",
    Head: "head",
    Gallon: "gal",
    Barrel: "bbl",
    GrossRegisterTon: "grt",
    // TH 11/15/2016 -- This is NOT the same thing as GrossRegisterTon.
    // GrossRegisterTon is a pure unit of volume - it equals 100 cubic feet.
    // GrossTonnage is a more recent way of measuring the same thing. It's a nonlinear function of total enclosed volume that uses a logarithmic formula.
    // So in theory, one can be derived from the other, but not via a linear conversion.
    // See https://en.wikipedia.org/wiki/Gross_tonnage and https://www.dco.uscg.mil/Portals/9/DCO%20Documents/Marine%20Safety%20Center/Tonnage/TM%20Convention%20-%20Draft%20Text%20Version%20With%20Figures%20TM.5-Circ.6.pdf (search "Regulation 3")
    GrossTonnage: "gt",
    // TH: See http://www.rapidtables.com/convert/power/hp-to-kw.htm and https://en.wikipedia.org/wiki/Horsepower for discussion of the various horsepower units
    Horsepower: "hp",
    ElectricalHorsepower: "hpE",
    MetricHorsepower: "hpM",
    Watt: "W",
    Kilowatt: "kW",
    Name: {},
    Conversion: {}
};
UOM.Name[UOM.Ounce] = "ounces";
UOM.Name[UOM.Pound] = "pounds";
UOM.Name[UOM.ShortTon] = "tons (US)";
UOM.Name[UOM.LongTon] = "tons (UK)";
UOM.Name[UOM.Gram] = "grams";
UOM.Name[UOM.Kilogram] = "kilograms";
UOM.Name[UOM.MetricTon] = "tons (Metric)";
UOM.Name[UOM.Inch] = "inches";
UOM.Name[UOM.Foot] = "feet";
UOM.Name[UOM.Yard] = "yards";
UOM.Name[UOM.Mile] = "mile";
UOM.Name[UOM.Centimeter] = "centimeters";
UOM.Name[UOM.Meter] = "meters";
UOM.Name[UOM.Kilometer] = "kilometer";
UOM.Name[UOM.Each] = "each";
UOM.Name[UOM.Head] = "head";
UOM.Name[UOM.Gallon] = "gallons";
UOM.Name[UOM.Barrel] = "barrels";
UOM.Name[UOM.GrossRegisterTon] = "Gross Register Tons";
UOM.Name[UOM.GrossTonnage] = "gross tonnage";
UOM.Name[UOM.Horsepower] = "horsepower";
UOM.Name[UOM.ElectricalHorsepower] = "electrical horsepower";
UOM.Name[UOM.MetricHorsepower] = "metric horsepower";
UOM.Name[UOM.Watt] = "watts";
UOM.Name[UOM.Kilowatt] = "kilowatts";
// Conversion Factors
// Weight
var OuncesPerPound = 16;
var OuncesPerShortTon = 32000;
var OuncesPerLongTon = 35840;
var OuncesPerGram = 0.03527396195;
var OuncesPerKilogram = 35.27396195;
var OuncesPerMetricTon = 35273.96195;
var PoundsPerOunce = 1 / OuncesPerPound;
var PoundsPerShortTon = 2000;
var PoundsPerLongTon = 2240;
var PoundsPerGram = 0.0022046226218;
var PoundsPerKilogram = 2.2046226218;
var PoundsPerMetricTon = 2204.6226218;
var ShortTonsPerOunce = 1 / OuncesPerShortTon;
var ShortTonsPerPound = 1 / PoundsPerShortTon;
var ShortTonsPerLongTon = 1.12;
var ShortTonsPerGram = 0.0000011023113109;
var ShortTonsPerKilogram = 0.0011023113109;
var ShortTonsPerMetricTon = 1.1023113109;
var LongTonsPerOunce = 1 / OuncesPerShortTon;
var LongTonsPerPound = 1 / PoundsPerShortTon;
var LongTonsPerShortTon = 1 / ShortTonsPerLongTon;
var LongTonsPerGram = 9.8420652761e-7;
var LongTonsPerKilogram = 9.8420652761e-4;
var LongTonsPerMetricTon = 0.984206527589;
var GramsPerOunce = 1 / OuncesPerGram;
var GramsPerPound = 1 / PoundsPerGram;
var GramsPerShortTon = 1 / ShortTonsPerGram;
var GramsPerLongTon = 1 / LongTonsPerGram;
var GramsPerKilogram = 1000;
var GramsPerMetricTon = 1000000;
var KilogramsPerOunce = 1 / OuncesPerKilogram;
var KilogramsPerPound = 1 / PoundsPerKilogram;
var KilogramsPerShortTon = 1 / ShortTonsPerKilogram;
var KilogramsPerLongTon = 1 / LongTonsPerKilogram;
var KilogramsPerGram = 1 / GramsPerKilogram;
var KilogramsPerMetricTon = 1000;
var MetricTonsPerOunce = 1 / OuncesPerMetricTon;
var MetricTonsPerPound = 1 / PoundsPerMetricTon;
var MetricTonsPerShortTon = 1 / ShortTonsPerMetricTon;
var MetricTonsPerLongTon = 1 / LongTonsPerMetricTon;
var MetricTonsPerGram = 1 / GramsPerMetricTon;
var MetricTonsPerKilogram = 1 / KilogramsPerMetricTon;
// Length
var InchesPerFoot = 12;
var InchesPerYard = 36;
var InchesPerMile = 63360;
var InchesPerCentimeter = 0.3937007874;
var InchesPerMeter = 39.37007874;
var InchesPerKilometer = 39370.07874;
var FeetPerInch = 1 / InchesPerFoot;
var FeetPerYard = 3;
var FeetPerMile = 5280;
var FeetPerCentimeter = 0.03280839895;
var FeetPerMeter = 3.280839895;
var FeetPerKilometer = 3280.839895;
var YardsPerInch = 1 / InchesPerYard;
var YardsPerFoot = 1 / FeetPerYard;
var YardsPerMile = 1760;
var YardsPerCentimeter = 0.010936132983;
var YardsPerMeter = 1.0936132983;
var YardsPerKilometer = 1093.6132983;
var MilesPerInch = 1 / InchesPerMile;
var MilesPerFoot = 1 / FeetPerMile;
var MilesPerYard = 1 / YardsPerMile;
var MilesPerCentimeter = 0.0000062137119224;
var MilesPerMeter = 0.00062137119224;
var MilesPerKilometer = 0.62137119224;
var CentimetersPerInch = 1 / InchesPerCentimeter;
var CentimetersPerFoot = 1 / FeetPerCentimeter;
var CentimetersPerYard = 1 / YardsPerCentimeter;
var CentimetersPerMile = 1 / MilesPerCentimeter;
var CentimetersPerMeter = 100;
var CentimetersPerKilometer = 100000;
var MetersPerInch = 1 / InchesPerMeter;
var MetersPerFoot = 1 / FeetPerMeter;
var MetersPerYard = 1 / YardsPerMeter;
var MetersPerMile = 1 / MilesPerMeter;
var MetersPerCentimeter = 1 / CentimetersPerMeter;
var MetersPerKilometer = 1000;
var KilometersPerInch = 1 / InchesPerKilometer;
var KilometersPerFoot = 1 / FeetPerKilometer;
var KilometersPerYard = 1 / YardsPerKilometer;
var KilometersPerMile = 1 / MilesPerKilometer;
var KilometersPerCentimeter = 1 / CentimetersPerKilometer;
var KilometersPerMeter = 1 / MetersPerKilometer;
var GallonsPerBarrel = 42;
var GallonsPerGrossRegisterTon = 748.052;
var BarrelsPerGallon = 1 / GallonsPerBarrel;
var BarrelsPerGrossRegisterTon = 17.8107619047619;
var GrossRegisterTonsPerGallon = 1 / GallonsPerGrossRegisterTon;
var GrossRegisterTonsPerBarrel = 1 / BarrelsPerGrossRegisterTon;
// Power
var WattsPerHorsepower = 745.69987158227;
var WattsPerElectricalHorsepower = 746;
var WattsPerMetricHorsepower = 735.49875;
var WattsPerKilowatt = 1000;
var KilowattsPerHorsepower = WattsPerHorsepower / WattsPerKilowatt;
var KilowattsPerElectricalHorsepower = WattsPerElectricalHorsepower / WattsPerKilowatt;
var KilowattsPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerKilowatt;
var KilowattsPerWatt = 1 / WattsPerKilowatt;
var HorsepowerPerElectricalHorsepower = WattsPerElectricalHorsepower / WattsPerHorsepower;
var HorsepowerPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerHorsepower;
var HorsepowerPerWatt = 1 / WattsPerHorsepower;
var HorsepowerPerKilowatt = 1 / KilowattsPerHorsepower;
var ElectricalHorsepowerPerHorsepower = 1 / HorsepowerPerElectricalHorsepower;
var ElectricalHorsepowerPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerElectricalHorsepower;
var ElectricalHorsepowerPerWatt = 1 / WattsPerElectricalHorsepower;
var ElectricalHorsepowerPerKilowatt = 1 / KilowattsPerElectricalHorsepower;
var MetricHorsepowerPerHorsepower = 1 / HorsepowerPerMetricHorsepower;
var MetricHorsepowerPerElectricalHorsepower = 1 / ElectricalHorsepowerPerMetricHorsepower;
var MetricHorsepowerPerWatt = 1 / WattsPerMetricHorsepower;
var MetricHorsepowerPerKilowatt = 1 / KilowattsPerMetricHorsepower;
UOM.Conversion[UOM.Ounce] = {};
UOM.Conversion[UOM.Ounce][UOM.Ounce] = 1.0;
UOM.Conversion[UOM.Ounce][UOM.Pound] = OuncesPerPound;
UOM.Conversion[UOM.Ounce][UOM.ShortTon] = OuncesPerShortTon;
UOM.Conversion[UOM.Ounce][UOM.LongTon] = OuncesPerLongTon;
UOM.Conversion[UOM.Ounce][UOM.Gram] = OuncesPerGram;
UOM.Conversion[UOM.Ounce][UOM.Kilogram] = OuncesPerKilogram;
UOM.Conversion[UOM.Ounce][UOM.MetricTon] = OuncesPerMetricTon;
UOM.Conversion[UOM.Pound] = {};
UOM.Conversion[UOM.Pound][UOM.Ounce] = PoundsPerOunce;
UOM.Conversion[UOM.Pound][UOM.Pound] = 1.0;
UOM.Conversion[UOM.Pound][UOM.ShortTon] = PoundsPerShortTon;
UOM.Conversion[UOM.Pound][UOM.LongTon] = PoundsPerLongTon;
UOM.Conversion[UOM.Pound][UOM.Gram] = PoundsPerGram;
UOM.Conversion[UOM.Pound][UOM.Kilogram] = PoundsPerKilogram;
UOM.Conversion[UOM.Pound][UOM.MetricTon] = PoundsPerMetricTon;
UOM.Conversion[UOM.ShortTon] = {};
UOM.Conversion[UOM.ShortTon][UOM.Ounce] = ShortTonsPerOunce;
UOM.Conversion[UOM.ShortTon][UOM.Pound] = ShortTonsPerPound;
UOM.Conversion[UOM.ShortTon][UOM.ShortTon] = 1.0;
UOM.Conversion[UOM.ShortTon][UOM.LongTon] = ShortTonsPerLongTon;
UOM.Conversion[UOM.ShortTon][UOM.Gram] = ShortTonsPerGram;
UOM.Conversion[UOM.ShortTon][UOM.Kilogram] = ShortTonsPerKilogram;
UOM.Conversion[UOM.ShortTon][UOM.MetricTon] = ShortTonsPerMetricTon;
UOM.Conversion[UOM.LongTon] = {};
UOM.Conversion[UOM.LongTon][UOM.Ounce] = LongTonsPerOunce;
UOM.Conversion[UOM.LongTon][UOM.Pound] = LongTonsPerPound;
UOM.Conversion[UOM.LongTon][UOM.ShortTon] = LongTonsPerShortTon;
UOM.Conversion[UOM.LongTon][UOM.LongTon] = 1.0;
UOM.Conversion[UOM.LongTon][UOM.Gram] = LongTonsPerGram;
UOM.Conversion[UOM.LongTon][UOM.Kilogram] = LongTonsPerKilogram;
UOM.Conversion[UOM.LongTon][UOM.MetricTon] = LongTonsPerMetricTon;
UOM.Conversion[UOM.Gram] = {};
UOM.Conversion[UOM.Gram][UOM.Ounce] = GramsPerOunce;
UOM.Conversion[UOM.Gram][UOM.Pound] = GramsPerPound;
UOM.Conversion[UOM.Gram][UOM.ShortTon] = GramsPerShortTon;
UOM.Conversion[UOM.Gram][UOM.LongTon] = GramsPerLongTon;
UOM.Conversion[UOM.Gram][UOM.Gram] = 1.0;
UOM.Conversion[UOM.Gram][UOM.Kilogram] = GramsPerKilogram;
UOM.Conversion[UOM.Gram][UOM.MetricTon] = GramsPerMetricTon;
UOM.Conversion[UOM.Kilogram] = {};
UOM.Conversion[UOM.Kilogram][UOM.Ounce] = KilogramsPerOunce;
UOM.Conversion[UOM.Kilogram][UOM.Pound] = KilogramsPerPound;
UOM.Conversion[UOM.Kilogram][UOM.ShortTon] = KilogramsPerShortTon;
UOM.Conversion[UOM.Kilogram][UOM.LongTon] = KilogramsPerLongTon;
UOM.Conversion[UOM.Kilogram][UOM.Gram] = KilogramsPerGram;
UOM.Conversion[UOM.Kilogram][UOM.Kilogram] = 1.0;
UOM.Conversion[UOM.Kilogram][UOM.MetricTon] = KilogramsPerMetricTon;
UOM.Conversion[UOM.MetricTon] = {};
UOM.Conversion[UOM.MetricTon][UOM.Ounce] = MetricTonsPerOunce;
UOM.Conversion[UOM.MetricTon][UOM.Pound] = MetricTonsPerPound;
UOM.Conversion[UOM.MetricTon][UOM.ShortTon] = MetricTonsPerShortTon;
UOM.Conversion[UOM.MetricTon][UOM.LongTon] = MetricTonsPerLongTon;
UOM.Conversion[UOM.MetricTon][UOM.Gram] = MetricTonsPerGram;
UOM.Conversion[UOM.MetricTon][UOM.Kilogram] = MetricTonsPerKilogram;
UOM.Conversion[UOM.MetricTon][UOM.MetricTon] = 1.0;
UOM.Conversion[UOM.Inch] = {};
UOM.Conversion[UOM.Inch][UOM.Inch] = 1.0;
UOM.Conversion[UOM.Inch][UOM.Foot] = InchesPerFoot;
UOM.Conversion[UOM.Inch][UOM.Yard] = InchesPerYard;
UOM.Conversion[UOM.Inch][UOM.Mile] = InchesPerMile;
UOM.Conversion[UOM.Inch][UOM.Centimeter] = InchesPerCentimeter;
UOM.Conversion[UOM.Inch][UOM.Meter] = InchesPerMeter;
UOM.Conversion[UOM.Inch][UOM.Kilometer] = InchesPerKilometer;
UOM.Conversion[UOM.Foot] = {};
UOM.Conversion[UOM.Foot][UOM.Inch] = FeetPerInch;
UOM.Conversion[UOM.Foot][UOM.Foot] = 1.0;
UOM.Conversion[UOM.Foot][UOM.Yard] = FeetPerYard;
UOM.Conversion[UOM.Foot][UOM.Mile] = FeetPerMile;
UOM.Conversion[UOM.Foot][UOM.Centimeter] = FeetPerCentimeter;
UOM.Conversion[UOM.Foot][UOM.Meter] = FeetPerMeter;
UOM.Conversion[UOM.Foot][UOM.Kilometer] = FeetPerKilometer;
UOM.Conversion[UOM.Yard] = {};
UOM.Conversion[UOM.Yard][UOM.Inch] = YardsPerInch;
UOM.Conversion[UOM.Yard][UOM.Foot] = YardsPerFoot;
UOM.Conversion[UOM.Yard][UOM.Yard] = 1.0;
UOM.Conversion[UOM.Yard][UOM.Mile] = YardsPerMile;
UOM.Conversion[UOM.Yard][UOM.Centimeter] = YardsPerCentimeter;
UOM.Conversion[UOM.Yard][UOM.Meter] = YardsPerMeter;
UOM.Conversion[UOM.Yard][UOM.Kilometer] = YardsPerKilometer;
UOM.Conversion[UOM.Mile] = {};
UOM.Conversion[UOM.Mile][UOM.Inch] = MilesPerInch;
UOM.Conversion[UOM.Mile][UOM.Foot] = MilesPerFoot;
UOM.Conversion[UOM.Mile][UOM.Yard] = MilesPerYard;
UOM.Conversion[UOM.Mile][UOM.Mile] = 1.0;
UOM.Conversion[UOM.Mile][UOM.Centimeter] = MilesPerCentimeter;
UOM.Conversion[UOM.Mile][UOM.Meter] = MilesPerMeter;
UOM.Conversion[UOM.Mile][UOM.Kilometer] = MilesPerKilometer;
UOM.Conversion[UOM.Centimeter] = {};
UOM.Conversion[UOM.Centimeter][UOM.Inch] = CentimetersPerInch;
UOM.Conversion[UOM.Centimeter][UOM.Foot] = CentimetersPerFoot;
UOM.Conversion[UOM.Centimeter][UOM.Yard] = CentimetersPerYard;
UOM.Conversion[UOM.Centimeter][UOM.Mile] = CentimetersPerMile;
UOM.Conversion[UOM.Centimeter][UOM.Centimeter] = 1.0;
UOM.Conversion[UOM.Centimeter][UOM.Meter] = CentimetersPerMeter;
UOM.Conversion[UOM.Centimeter][UOM.Kilometer] = CentimetersPerKilometer;
UOM.Conversion[UOM.Meter] = {};
UOM.Conversion[UOM.Meter][UOM.Inch] = MetersPerInch;
UOM.Conversion[UOM.Meter][UOM.Foot] = MetersPerFoot;
UOM.Conversion[UOM.Meter][UOM.Yard] = MetersPerYard;
UOM.Conversion[UOM.Meter][UOM.Mile] = MetersPerMile;
UOM.Conversion[UOM.Meter][UOM.Centimeter] = MetersPerCentimeter;
UOM.Conversion[UOM.Meter][UOM.Meter] = 1.0;
UOM.Conversion[UOM.Meter][UOM.Kilometer] = MetersPerKilometer;
UOM.Conversion[UOM.Kilometer] = {};
UOM.Conversion[UOM.Kilometer][UOM.Inch] = KilometersPerInch;
UOM.Conversion[UOM.Kilometer][UOM.Foot] = KilometersPerFoot;
UOM.Conversion[UOM.Kilometer][UOM.Yard] = KilometersPerYard;
UOM.Conversion[UOM.Kilometer][UOM.Mile] = KilometersPerMile;
UOM.Conversion[UOM.Kilometer][UOM.Centimeter] = KilometersPerCentimeter;
UOM.Conversion[UOM.Kilometer][UOM.Meter] = KilometersPerMeter;
UOM.Conversion[UOM.Kilometer][UOM.Kilometer] = 1.0;
UOM.Conversion[UOM.Each] = {};
UOM.Conversion[UOM.Each][UOM.Each] = 1.0;
UOM.Conversion[UOM.Head] = {};
UOM.Conversion[UOM.Head][UOM.Head] = 1.0;
UOM.Conversion[UOM.Gallon] = {};
UOM.Conversion[UOM.Gallon][UOM.Gallon] = 1.0;
UOM.Conversion[UOM.Gallon][UOM.Barrel] = GallonsPerBarrel;
UOM.Conversion[UOM.Gallon][UOM.GrossRegisterTon] = GallonsPerGrossRegisterTon;
UOM.Conversion[UOM.Barrel] = {};
UOM.Conversion[UOM.Barrel][UOM.Barrel] = 1.0;
UOM.Conversion[UOM.Barrel][UOM.Gallon] = BarrelsPerGallon;
UOM.Conversion[UOM.Barrel][UOM.GrossRegisterTon] = BarrelsPerGrossRegisterTon;
UOM.Conversion[UOM.GrossRegisterTon] = {};
UOM.Conversion[UOM.GrossRegisterTon][UOM.GrossRegisterTon] = 1.0;
UOM.Conversion[UOM.GrossRegisterTon][UOM.Gallon] = GrossRegisterTonsPerGallon;
UOM.Conversion[UOM.GrossRegisterTon][UOM.Barrel] = GrossRegisterTonsPerBarrel;
UOM.Conversion[UOM.GrossTonnage] = {};
UOM.Conversion[UOM.GrossTonnage][UOM.GrossTonnage] = 1.0;
UOM.Conversion[UOM.Watt] = {};
UOM.Conversion[UOM.Watt][UOM.Horsepower] = WattsPerHorsepower;
UOM.Conversion[UOM.Watt][UOM.ElectricalHorsepower] = WattsPerElectricalHorsepower;
UOM.Conversion[UOM.Watt][UOM.MetricHorsepower] = WattsPerMetricHorsepower;
UOM.Conversion[UOM.Watt][UOM.Watt] = 1.0;
UOM.Conversion[UOM.Watt][UOM.Kilowatt] = WattsPerKilowatt;
UOM.Conversion[UOM.Kilowatt] = {};
UOM.Conversion[UOM.Kilowatt][UOM.Horsepower] = KilowattsPerHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.ElectricalHorsepower] = KilowattsPerElectricalHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.MetricHorsepower] = KilowattsPerMetricHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.Watt] = KilowattsPerWatt;
UOM.Conversion[UOM.Kilowatt][UOM.Kilowatt] = 1.0;
UOM.Conversion[UOM.Horsepower] = {};
UOM.Conversion[UOM.Horsepower][UOM.Horsepower] = 1.0;
UOM.Conversion[UOM.Horsepower][UOM.ElectricalHorsepower] = HorsepowerPerElectricalHorsepower;
UOM.Conversion[UOM.Horsepower][UOM.MetricHorsepower] = HorsepowerPerMetricHorsepower;
UOM.Conversion[UOM.Horsepower][UOM.Watt] = HorsepowerPerWatt;
UOM.Conversion[UOM.Horsepower][UOM.Kilowatt] = HorsepowerPerKilowatt;
UOM.Conversion[UOM.ElectricalHorsepower] = {};
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Horsepower] = ElectricalHorsepowerPerHorsepower;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.ElectricalHorsepower] = 1.0;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.MetricHorsepower] = ElectricalHorsepowerPerMetricHorsepower;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Watt] = ElectricalHorsepowerPerWatt;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Kilowatt] = ElectricalHorsepowerPerKilowatt;
UOM.Conversion[UOM.MetricHorsepower] = {};
UOM.Conversion[UOM.MetricHorsepower][UOM.Horsepower] = MetricHorsepowerPerHorsepower;
UOM.Conversion[UOM.MetricHorsepower][UOM.ElectricalHorsepower] = MetricHorsepowerPerElectricalHorsepower;
UOM.Conversion[UOM.MetricHorsepower][UOM.MetricHorsepower] = 1.0;
UOM.Conversion[UOM.MetricHorsepower][UOM.Watt] = MetricHorsepowerPerWatt;
UOM.Conversion[UOM.MetricHorsepower][UOM.Kilowatt] = MetricHorsepowerPerKilowatt;
exports.default = UOM;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(315);
var toPrimitive = __webpack_require__(65);
var dP = Object.defineProperty;

exports.f = __webpack_require__(30) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ListErrors = exports.ErrorModal = exports.LightErrorView = exports.ValidationErrorView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
exports.ValidationErrorView = supercritical_1.default(function (_a) {
    var error = _a.error;
    return React.createElement("div", null, error() &&
        React.createElement("div", { className: "validationerror alert alert-danger" }, error().ErrorText));
});
/**
 * Alternate "lighter" validation error display. Inline by default (though of course you can
 * apply display: block or display: inline-block in your .less to override). Displays w/o
 * the surrounding background color or border of ValidationErrorView.
 */
exports.LightErrorView = supercritical_1.default(function (_a) {
    var _b;
    var error = _a.error;
    return React.createElement("span", { className: "validationerror-light" }, (_b = error()) === null || _b === void 0 ? void 0 : _b.ErrorText);
});
exports.ErrorModal = supercritical_1.default(function (_a) {
    var errors = _a.errors, shown = _a.shown, title = _a.title;
    return React.createElement(view_1.PCModal, { className: "validationerror-modal", shown: shown, onBackDropClick: function () { return shown(false); } },
        React.createElement("div", { className: "modal-content pc-card profile-body" },
            React.createElement("div", { className: "pc-card-header pc-card-title" },
                React.createElement("span", null, title),
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return shown(false); }) }, "Close")),
            React.createElement("div", { className: "modal-body" }, ListErrors(errors()))));
});
function ListErrors(errors) {
    return Object.values(errors).map(function (err) { return err.ErrorTexts.map(function (text, i) {
        return React.createElement("div", { key: err.Field + "-" + i, className: "alert alert-warning" }, text);
    }); });
}
exports.ListErrors = ListErrors;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSavingDraftObject = exports.DraftAutoSaver = exports.SaveDraftObject = exports.AutoSaver = void 0;
// CD.AutoSave - utilities for working with objects that are automatically saved when changed
var s_js_1 = __webpack_require__(0);
var _ = __webpack_require__(67);
var requestQueue_1 = __webpack_require__(300);
var draftSignals_1 = __webpack_require__(37);
var DEFAULT_SAVE_DELAY = 300;
/**
 * An AutoSaver debounces and serializes calls to a given save function when triggered by the
 * given trigger.
 * @param trigger Trigger that indicates that a save is needed.
 * @param save Function that performs a single save.
 * @param delay Debounce delay. A save won't be enqueued until this many ms of quiet after the
 * trigger has fired.
 * @param onchanges Should a save be enqueued immediately (false) or only after the trigger
 * has fired (true). Defaults to true.
 */
function AutoSaver(trigger, save, delay, onchanges) {
    if (delay === void 0) { delay = DEFAULT_SAVE_DELAY; }
    if (onchanges === void 0) { onchanges = true; }
    var queue = new requestQueue_1.RequestQueue(function () { return save(); }), debouncedSaver = _.debounce(Save, delay);
    // Note: debouncedSaver will still run even if this computation is disposed, since it's been queued by _.debounce()
    s_js_1.default.on(trigger, debouncedSaver, null, onchanges);
    return { Save: Save };
    function Save() {
        queue.enqueueRequest();
        return queue.mostRecentRequest();
    }
}
exports.AutoSaver = AutoSaver;
/**
 * Save the given draft object using the given client.
 */
function SaveDraftObject(draft, client) {
    var checkpoint = draft.methods.checkpoint(), req = client.Put(draft.object);
    return req.then(function () {
        var resp = req.Response();
        if (resp === null || resp === void 0 ? void 0 : resp.UsedCache) {
            // if we updated the cache directly, then revert our changes, so that we show latest from server
            checkpoint.revert();
        }
        else {
            // if we didn't use cache, then assume our changes stuck, since the request succeeded, and commit them
            checkpoint.commit();
        }
        return resp;
    });
}
exports.SaveDraftObject = SaveDraftObject;
/**
 * A DraftAutoSaver watches for changes in the given DraftObject and fires an http PUT request
 * to the given client when a change is detected. If the PUT is successful, DraftAutoSaver triggers
 * a commit on the draft object to update the underlying model object with the newly saved values.
 *
 * In order to avoid spamming the server, DraftAutoSaver waits for 300 ms of quiet before sending out
 * the PUT request.
 *
 * To avoid a situation where save requests reach the server out of order, DraftAutoSaver serializes
 * its requests, not sending the next until it hears that the former completed.
 *
 * @param draft The draft object to be changed
 * @param client Client to send the PUT request
 */
function DraftAutoSaver(draft, client) {
    return AutoSaver(draft.methods.onWrite, function () { return SaveDraftObject(draft, client); });
}
exports.DraftAutoSaver = DraftAutoSaver;
/**
 * AutoSavingDraftObject is a short-hand method whidh constructs a DraftObject from the given object
 * and wires up a DraftAutoSaver to it. It saves a few lines of code in cases where the client does
 * not need access to the saver's interface.
 * @param obj The object from which to create the draft
 * @param client Client to send the PUT request
 * @param props Specific list of properties to watch. Defaults to all.
 */
function AutoSavingDraftObject(obj, client, props) {
    var draft = draftSignals_1.DraftObject(obj, props);
    DraftAutoSaver(draft, client);
    return draft.object;
}
exports.AutoSavingDraftObject = AutoSavingDraftObject;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(64);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var DOMProperty = __webpack_require__(124);
var ReactDOMComponentFlags = __webpack_require__(470);

var invariant = __webpack_require__(13);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var Location = /** @class */ (function () {
    function Location(name, params) {
        this.name = name;
        this.params = params;
    }
    Location.prototype.eq = function (loc) {
        if (this.name !== loc.name)
            return false;
        var keys = Object.keys(this.params);
        if (keys.length !== Object.keys(loc.params).length)
            return false;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (this.params[k] !== loc.params[k])
                return false;
        }
        return true;
    };
    return Location;
}());
exports.Location = Location;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCDismissible = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var PCDismissible = /** @class */ (function (_super) {
    __extends(PCDismissible, _super);
    function PCDismissible(props) {
        var _this = _super.call(this, props) || this;
        _this.propagationStopped = false;
        _this.ref = supercritical_1.SuperCriticalReference(_this, function (props, el) {
            var dismissibleWhen = props.dismissibleWhen || (function () { return true; });
            if (dismissibleWhen()) {
                var onDocumentClick_1 = function () {
                    var propagationStopped = _this.propagationStopped;
                    _this.propagationStopped = false;
                    if (!propagationStopped)
                        props.onDismiss();
                };
                var onDivClick_1 = function () {
                    // TH: We've gotta be careful here b/c React delegates its events to the document.
                    // A couple things that won't work:
                    // 
                    // -- Instead of setting a propagationStopped flag we could've just called e.stopPropagation().
                    //    But that's bad b/c it means the click event never reaches the document, which is where React's
                    //    onClick handlers are waiting to catch it. So React onClick handlers inside the dismissible element never fire.
                    // 
                    // -- Instead of adding a native click event to the div element, we could've added a React onClick handler in our
                    //    srender method below. That would work, but it would have the counterintuitive effect that any React onClick handlers
                    //    inside the dismissible element can't call React's stopPropagation method, otherwise our handler will never fire to set the
                    //    propagationStopped flag, and the document dismiss handler WILL fire.
                    // 
                    // This is all b/c React's stopPropagation method can't stop propagation to native click handlers.
                    // See http://stackoverflow.com/a/24421834
                    _this.propagationStopped = true;
                };
                document.addEventListener('click', onDocumentClick_1);
                el.addEventListener('click', onDivClick_1);
                s_js_1.default.cleanup(function () {
                    _this.propagationStopped = false;
                    document.removeEventListener('click', onDocumentClick_1);
                    el.removeEventListener('click', onDivClick_1);
                });
            }
        });
        return _this;
    }
    PCDismissible.prototype.srender = function (props) {
        return (React.createElement("div", { className: 'pc-dismissible ' + (props.className ? props.className : ''), ref: this.ref }, props.children));
    };
    return PCDismissible;
}(supercritical_1.SuperCriticalComponent));
exports.PCDismissible = PCDismissible;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(62);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDraftMethods = exports.DraftObject = exports.DraftSignal = void 0;
var s_js_1 = __webpack_require__(0);
function DraftSignal(original, eq) {
    var isCaching = s_js_1.default.value(false), cachedValue = s_js_1.default.data(s_js_1.default.sample(original)), areEqual = eq || (function (v1, v2) { return v1 === v2; });
    var version = 0, committedVersion = version;
    var draft = function (value) {
        if (arguments.length === 0) {
            return isCaching() ? cachedValue() : original();
        }
        else {
            if (!areEqual(value, s_js_1.default.sample(draft))) {
                s_js_1.default.freeze(function () {
                    version++;
                    cachedValue(value);
                    isCaching(true);
                });
            }
            return value;
        }
    };
    draft.isCaching = function () { return isCaching(); };
    draft.onWrite = function () { cachedValue(); };
    draft.checkpoint = function () {
        var checkpointValue = s_js_1.default.sample(draft), checkpointVersion = version;
        return { commit: commit, revert: revert };
        function commit() {
            s_js_1.default.freeze(function () {
                if (committedVersion < checkpointVersion) {
                    committedVersion = checkpointVersion;
                    original(checkpointValue);
                }
                if (checkpointVersion === version) {
                    isCaching(false);
                }
            });
        }
        ;
        function revert() {
            if (checkpointVersion === version) {
                isCaching(false);
            }
        }
    };
    // carry over JSON behavior
    if (original.toJSON)
        draft.toJSON = original.toJSON;
    return draft;
}
exports.DraftSignal = DraftSignal;
// TH TODO -- I added an optional eq param to DraftSignal above, mainly thinking about TZDates.
// Might be worth exposing as an option here somehow...
function DraftObject(original, props) {
    var object = clone(original), signals = [];
    props = props || allObservables(original);
    props.forEach(makeDraftObservable);
    var methods = mergeDraftMethods.apply(void 0, signals);
    return { object: object, methods: methods };
    function makeDraftObservable(prop) {
        var path = prop.split('.'), i = 0, part = path[i], propObject = object, signal;
        while (i < path.length - 1) {
            propObject[part] = clone(propObject[part]);
            i++;
            propObject = propObject[part];
            part = path[i];
        }
        if (isObservable(propObject[part])) {
            signal = DraftSignal(propObject[part]);
            propObject[part] = signal;
            signals.push(signal);
        }
    }
    function allObservables(object) {
        return Object.keys(object).filter(function (p) { return isObservable(object[p]); });
    }
}
exports.DraftObject = DraftObject;
/// Given two or more draft methods (or observables holding draft methods), construct
/// a new draft methods object that merges the draft methods' signals.  I.e., isCaching()
/// is true if any of the given drafts are caching, onWrite() fires when any of the drafts
/// is written, and checkpoint checkpoints all the drafts, then commits or reverts them as
/// as well.
function mergeDraftMethods() {
    var drafts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        drafts[_i] = arguments[_i];
    }
    return {
        isCaching: function () { return unwrap(drafts).some(function (d) { return d.isCaching(); }); },
        onWrite: function () { unwrap(drafts).forEach(function (d) { return d.onWrite(); }); },
        checkpoint: function () {
            var checkpoints = unwrap(drafts).map(function (d) { return d.checkpoint(); });
            return {
                commit: function () { return s_js_1.default.freeze(function () { return checkpoints.forEach(function (s) { return s.commit(); }); }); },
                revert: function () { return s_js_1.default.freeze(function () { return checkpoints.forEach(function (s) { return s.revert(); }); }); }
            };
        }
    };
    function unwrap(drafts) {
        var flattened = [];
        for (var _i = 0, drafts_1 = drafts; _i < drafts_1.length; _i++) {
            var _draft = drafts_1[_i];
            var draft = isDraftMethods(_draft) ? _draft : _draft();
            if (draft)
                flattened.push(draft);
        }
        return flattened;
    }
}
exports.mergeDraftMethods = mergeDraftMethods;
/// utils
function isDraftMethods(obj) {
    return obj.checkpoint && obj.checkpoint instanceof Function
        && obj.isCaching && obj.isCaching instanceof Function
        && obj.onWrite && obj.onWrite instanceof Function;
}
function isObservable(obj) {
    return obj instanceof Function;
}
function clone(obj) {
    var clone = Object.create(obj);
    // JSON.stringify looks at Liskov and starts to laugh.
    // By definition, it doesn't pick up inherited properties, so we use a flat copy for serialization, unless the object already has a custom serialization defined
    if (!('toJSON' in clone))
        clone.toJSON = flatCopyForJSON;
    return clone;
}
function flatCopyForJSON() {
    var copy = {};
    for (var prop in this) {
        copy[prop] = this[prop];
    }
    return copy;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselSides = exports.VesselSideDisplayName = exports.VesselSide = exports.BerthReservationStatuses = exports.BerthReservationStatusDisplayName = exports.BerthReservationStatus = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\BerthReservation.cs
var BerthReservationStatus;
(function (BerthReservationStatus) {
    BerthReservationStatus[BerthReservationStatus["Requested"] = 0] = "Requested";
    BerthReservationStatus[BerthReservationStatus["Booked"] = 1] = "Booked";
    BerthReservationStatus[BerthReservationStatus["Cancelled"] = 2] = "Cancelled";
    BerthReservationStatus[BerthReservationStatus["Conflicted"] = 3] = "Conflicted";
})(BerthReservationStatus = exports.BerthReservationStatus || (exports.BerthReservationStatus = {}));
exports.BerthReservationStatusDisplayName = {
    0: 'Requested',
    1: 'Booked',
    2: 'Cancelled',
    3: 'Conflicted'
};
exports.BerthReservationStatuses = [
    { Id: BerthReservationStatus.Requested, Name: 'Requested' },
    { Id: BerthReservationStatus.Booked, Name: 'Booked' },
    { Id: BerthReservationStatus.Cancelled, Name: 'Cancelled' },
    { Id: BerthReservationStatus.Conflicted, Name: 'Conflicted' }
];
var VesselSide;
(function (VesselSide) {
    VesselSide[VesselSide["Starboard"] = 0] = "Starboard";
    VesselSide[VesselSide["Port"] = 10] = "Port";
    VesselSide[VesselSide["SternTo"] = 20] = "SternTo";
    VesselSide[VesselSide["TBD"] = 30] = "TBD";
})(VesselSide = exports.VesselSide || (exports.VesselSide = {}));
exports.VesselSideDisplayName = {
    0: 'Starboard side-to',
    10: 'Port side-to',
    20: 'Stern to',
    30: 'TBD'
};
exports.VesselSides = [
    { Id: VesselSide.Starboard, Name: 'Starboard side-to' },
    { Id: VesselSide.Port, Name: 'Port side-to' },
    { Id: VesselSide.SternTo, Name: 'Stern to' },
    { Id: VesselSide.TBD, Name: 'TBD' }
];


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoadingIndicator = exports.ActionLoadingIndicator = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.ActionLoadingIndicator = supercritical_1.default(function (_a) {
    var loading = _a.loading;
    return loading()
        ? React.createElement("div", { className: "actionloadingindicator pc-card" },
            React.createElement("div", { className: "loading-indicator" }),
            React.createElement("div", { className: "loading-text" }, "Loading ..."))
        : null;
});
// TH 05/10/2017 -- The large loading clock used on Reservations Dashboard, Batches Dashboard, elsewhere.
exports.PageLoadingIndicator = supercritical_1.default(function (_a) {
    var loading = _a.loading;
    return loading() ? React.createElement("span", { className: "pageloadingindicator" }) : null;
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2017 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.1
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    var self = this;
    setTimeout(function() {
        self._notifyUnhandledRejection();
    }, 1);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.1";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(143), __webpack_require__(86), __webpack_require__(493).setImmediate))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseInsensitiveStartsWith = exports.CaseInsensitiveContains = exports.LatinLower = exports.Latinize = void 0;
var _ = __webpack_require__(67);
// Map between Latin characters and each possible diacritical representation
// Currently only supports Hawaiian diacriticals
// More support can be added as needed
var diacriticals = {
    '': ['\'', '\u02BB', '\u2018', '\u0304', '\u00AF', '\u02C9', '\u0331', '\u02CD'],
    'A': ['\u0100'],
    'a': ['\u0101'],
    'E': ['\u0112'],
    'e': ['\u0113'],
    'I': ['\u012A'],
    'i': ['\u012B'],
    'O': ['\u014C'],
    'o': ['\u014D'],
    'U': ['\u016A'],
    'u': ['\u016B']
};
var diacriticalKVPs = _.pairs(diacriticals), latinCharacters = {};
for (var i = 0; i < diacriticalKVPs.length; i++) {
    var val = diacriticalKVPs[i][1];
    for (var j = 0; j < val.length; j++) {
        latinCharacters[val[j]] = diacriticalKVPs[i][0];
    }
}
/**
* Remove/replace diacriticals.
*
* NOTE: Only setup for Hawaiian diacriticals currently.
*/
function Latinize(str) {
    return str.replace(/[^\u0000-\u007E]|'/g, function (match) {
        var replacement = latinCharacters[match];
        if (replacement === undefined)
            replacement = match;
        return replacement;
    });
}
exports.Latinize = Latinize;
/**
 * Remove/replace diacrticals and convert to lower case
 *
 * NOTE: Only setup for Hawaiian diacrticals currently.
 */
function LatinLower(str) {
    return Latinize(str.toLowerCase());
}
exports.LatinLower = LatinLower;
function CaseInsensitiveContains(str, query) {
    // special behavior: if query ends in a space, it must be a full-word match
    if (query.length > 0 && query[query.length - 1] === " ") {
        if (query[0] !== " ")
            query = " " + query;
        if (str.length > 0) {
            if (str[0] !== " ")
                str = " " + str;
            if (str[str.length - 1] !== " ")
                str += " ";
        }
    }
    return LatinLower(str).indexOf(LatinLower(query)) >= 0;
}
exports.CaseInsensitiveContains = CaseInsensitiveContains;
function CaseInsensitiveStartsWith(str, query) {
    return LatinLower(str).indexOf(LatinLower(query)) === 0;
}
exports.CaseInsensitiveStartsWith = CaseInsensitiveStartsWith;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(139);
var defined = __webpack_require__(62);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.2' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var createDesc = __webpack_require__(85);
module.exports = __webpack_require__(30) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(140);
var createDesc = __webpack_require__(85);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(65);
var has = __webpack_require__(45);
var IE8_DOM_DEFINE = __webpack_require__(315);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(30) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(45);
var toObject = __webpack_require__(36);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var has = __webpack_require__(45);
var SRC = __webpack_require__(103)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(44).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var fails = __webpack_require__(19);
var defined = __webpack_require__(62);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCTooltip = exports.TimeAgoTooltip = exports.MaxLengthTooltip = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var moment_custom_locales_1 = __webpack_require__(1393);
__webpack_require__(603);
exports.MaxLengthTooltip = supercritical_1.default(function (_a) {
    var maxLength = _a.maxLength, text = _a.text, className = _a.className;
    return React.createElement(PCTooltip, { className: className, title: text, shown: function () { return text().length > maxLength; } }, text());
});
var TOOLTIP_DATE_FORMAT = 'MM/DD/YY [at] HH:mm';
exports.TimeAgoTooltip = supercritical_1.default(function (_a) {
    var className = _a.className, date = _a.date, now = _a.now, useAbbreviatedTimeAgo = _a.useAbbreviatedTimeAgo;
    return React.createElement(PCTooltip, { className: className, title: function () { return tzmoment_1.tzmoment(date()).format(TOOLTIP_DATE_FORMAT); } }, setLocale(date(), useAbbreviatedTimeAgo).from(now()));
});
function setLocale(date, useAbbreviatedTimeAgo) {
    var m = tzmoment_1.tzmoment(date);
    if (useAbbreviatedTimeAgo)
        m.locale(moment_custom_locales_1.EN_DURATIONS_ABBR_LOCALE);
    return m;
}
var PCTooltip = /** @class */ (function (_super) {
    __extends(PCTooltip, _super);
    function PCTooltip(props) {
        var _this = _super.call(this, props) || this;
        var el = null;
        var event = s_js_1.default.data(null);
        // TH 1/3/2017 -- BUGFIX. Previously, we used a SuperCriticalReference here.
        // That had the side effect that changing props would cause the tooltip to be
        // destroyed and reconstructed. That had the undesirable effect that time ago
        // tooltips would get destroyed whenever their clock ticked.
        // So manually construct a ref that doesn't subscribe to this.state.props.
        s_js_1.default.root(function () { return s_js_1.default(function () {
            event();
            if (el) {
                var $el_1 = $(el);
                $el_1.tooltip({
                    // TH 1/3/2017 -- NOTE: Bootstrap only calls this title function when hovering into a tooltip.
                    // That means the tooltip text won't update if the title or shown props change during a hover.
                    // The update will only become visible on the next hover.
                    title: function () { return s_js_1.default.sample(function () { return _this.sprops().shown && !_this.sprops().shown() ? '' : _this.sprops().title(); }); }
                });
                s_js_1.default.cleanup(function () { return $el_1.tooltip('destroy'); });
            }
        }); });
        _this.tooltipRef = function (_el) { el = _el; event(null); };
        return _this;
    }
    PCTooltip.prototype.srender = function (props) {
        return (React.createElement("div", { className: props.className, ref: this.tooltipRef }, props.children));
    };
    return PCTooltip;
}(supercritical_1.SuperCriticalComponent));
exports.PCTooltip = PCTooltip;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(39);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsMenuButton = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
// Common DOM/styling for the Actions button we use at the top right of several pages
exports.ActionsMenuButton = supercritical_1.default(function (_a) {
    var onClick = _a.onClick, hidden = _a.hidden, className = _a.className;
    return React.createElement("button", { className: cx('actionsmenubtncomponent pc-actions-menu-btn actions-menu-btn pc-button', className), onClick: onClick, hidden: hidden },
        React.createElement("span", { className: "stack-icon fa fa-bars" }),
        React.createElement("span", { className: "actions-text" }, "Actions"));
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableIntegerInput = exports.IntegerInput = exports.NullableNumericInput = exports.NumericInput = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var NumericInputBase = /** @class */ (function (_super) {
    __extends(NumericInputBase, _super);
    function NumericInputBase(props) {
        var _this = _super.call(this, props) || this;
        _this.writtenValue = s_js_1.default.data('');
        _this.dirty = s_js_1.default.data(false);
        s_js_1.default.root(function () { return s_js_1.default.on(_this.writtenValue, function () {
            var num = _this.numberify(_this.writtenValue());
            if (num !== null && !isNaN(num) || num === null && _this.allowNullSets) {
                _this.sprops().value(num);
            }
        }, null, true); });
        return _this;
    }
    NumericInputBase.prototype.srender = function (props) {
        var _this = this;
        return (React.createElement("input", { ref: props.inputRef, className: props.className, value: this.dirty() ? this.writtenValue() : this.stringify(props.value()), onChange: function (e) { return s_js_1.default.freeze(function () {
                _this.dirty(true);
                _this.writtenValue(e.currentTarget.value);
            }); }, disabled: props.disabled, tabIndex: props.tabindex, onFocus: props.onFocus, onBlur: function () { return s_js_1.default.freeze(function () {
                _this.dirty(false);
                props.onBlur && props.onBlur();
            }); }, placeholder: props.placeholder, autoFocus: props.autoFocus }));
    };
    return NumericInputBase;
}(supercritical_1.SuperCriticalComponent));
var NumericInput = /** @class */ (function (_super) {
    __extends(NumericInput, _super);
    function NumericInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowNullSets = false;
        return _this;
    }
    NumericInput.prototype.stringify = function (val) {
        return '' + val;
    };
    NumericInput.prototype.numberify = function (val) {
        return parseFloat(val);
    };
    return NumericInput;
}(NumericInputBase));
exports.NumericInput = NumericInput;
var NullableNumericInput = /** @class */ (function (_super) {
    __extends(NullableNumericInput, _super);
    function NullableNumericInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowNullSets = true;
        return _this;
    }
    NullableNumericInput.prototype.stringify = function (val) {
        return val === null ? '' : '' + val;
    };
    NullableNumericInput.prototype.numberify = function (val) {
        return val === '' ? null : parseFloat(val);
    };
    return NullableNumericInput;
}(NumericInputBase));
exports.NullableNumericInput = NullableNumericInput;
var IntegerInput = /** @class */ (function (_super) {
    __extends(IntegerInput, _super);
    function IntegerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowNullSets = false;
        return _this;
    }
    IntegerInput.prototype.stringify = function (val) {
        return '' + val;
    };
    IntegerInput.prototype.numberify = function (val) {
        return parseInt(val);
    };
    return IntegerInput;
}(NumericInputBase));
exports.IntegerInput = IntegerInput;
var NullableIntegerInput = /** @class */ (function (_super) {
    __extends(NullableIntegerInput, _super);
    function NullableIntegerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowNullSets = true;
        return _this;
    }
    NullableIntegerInput.prototype.stringify = function (val) {
        return val === null ? '' : '' + val;
    };
    NullableIntegerInput.prototype.numberify = function (val) {
        return val === '' ? null : parseInt(val);
    };
    return NullableIntegerInput;
}(NumericInputBase));
exports.NullableIntegerInput = NullableIntegerInput;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(19);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgInitDateTimePicker = exports.NullableDateTimePicker = exports.DateTimePicker = exports.NullableTimePicker = exports.TimePicker = exports.NullableDatePicker = exports.DatePicker = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var $ = __webpack_require__(27);
var TZDate_1 = __webpack_require__(7);
var supercritical_1 = __webpack_require__(4);
__webpack_require__(296);
var PickerKind;
(function (PickerKind) {
    PickerKind[PickerKind["Date"] = 0] = "Date";
    PickerKind[PickerKind["Time"] = 1] = "Time";
})(PickerKind || (PickerKind = {}));
var SinglePickerBase = /** @class */ (function (_super) {
    __extends(SinglePickerBase, _super);
    function SinglePickerBase(props, pickerKind, allowNullSets) {
        var _this = _super.call(this, props) || this;
        _this.pickerKind = pickerKind;
        _this.allowNullSets = allowNullSets;
        var opts = {
            pickerKind: _this.pickerKind,
            allowNullSets: _this.allowNullSets
        };
        _this.ref = supercritical_1.SuperCriticalReference(_this, function (props, el) { return InitPicker(props, el, opts); });
        return _this;
    }
    SinglePickerBase.prototype.srender = function (props) {
        var _this = this;
        var ref = function (e) {
            _this.ref(e);
            props.inputRef && props.inputRef(e);
        };
        return (React.createElement("input", { className: this.pickerKind === PickerKind.Date ? 'portcall-datepicker' : 'portcall-timepicker', tabIndex: props.tabindex, ref: ref, autoFocus: props.autofocus }));
    };
    return SinglePickerBase;
}(supercritical_1.SuperCriticalComponent));
var InternalDatePicker = /** @class */ (function (_super) {
    __extends(InternalDatePicker, _super);
    function InternalDatePicker(props) {
        return _super.call(this, props, PickerKind.Date, false) || this;
    }
    return InternalDatePicker;
}(SinglePickerBase));
var InternalNullableDatePicker = /** @class */ (function (_super) {
    __extends(InternalNullableDatePicker, _super);
    function InternalNullableDatePicker(props) {
        return _super.call(this, props, PickerKind.Date, true) || this;
    }
    return InternalNullableDatePicker;
}(SinglePickerBase));
var InternalTimePicker = /** @class */ (function (_super) {
    __extends(InternalTimePicker, _super);
    function InternalTimePicker(props) {
        return _super.call(this, props, PickerKind.Time, false) || this;
    }
    return InternalTimePicker;
}(SinglePickerBase));
var InternalNullableTimePicker = /** @class */ (function (_super) {
    __extends(InternalNullableTimePicker, _super);
    function InternalNullableTimePicker(props) {
        return _super.call(this, props, PickerKind.Time, true) || this;
    }
    return InternalNullableTimePicker;
}(SinglePickerBase));
// TH 05/09/2017 -- BUGFIX. I stumbled on something brittle in our DatePicker and TimePicker controls.
// The issue is that Kendo adds its own DOM wrapper around whichever element you initialize the
// Date(Time)Picker on. This means that the actual DOM contains an extra wrapper layer that doesn't
// correspond to any node in React's virtual DOM.
// That's fine for most use cases, but it's a problem if you transition your view state in such a
// way that React tries to unmount the Date(Time)Picker node from its parent.
//
// So before my bugfix below, calling code could expose the bug by doing something like
//
//   <div>
//       {showDatePicker() && <DatePicker value={value} localization={localization} />}
//   </div>
//
// As long as the user performed a sequence of actions that caused showDatePicker to flip to
// true and then back to false, that'd expose this bug.
// (NOTE: The above calling code is now safe, due to my bugfix below.)
//
// Internally, React would end up calling parentNode.removeChild(childNode), where parentNode
// was the original parent, and childNode was the node that we initialized the Date(Time)Picker
// on. At that point, childNode wouldn't be a child of parentNode anymore but rather a
// great-grandchild (Kendo adds a lot of wrapping). So the removeChild call would throw
//
//   Uncaught DOMException: Failed to execute 'removeChild' on 'Node':
//   The node to be removed is not a child of this node.
//
// That'd leave the DOM in a dirty state.
//
// E.g. I was running into a case on the PendingExports page's ExportConfirmationPopup where the
// effect was that you could open the popup once w/o issue, but cancelling the popup would throw
// the DOMException, and after that, any subsequent time the user tried to open the popup, React
// would fail to reinitialize the DatePicker and it'd be left in a state where it wouldn't respond
// to click events.
//
// The fix is to add our own extra wrapper layer around the Kendo Date(Time)Picker.
// That way, there's an extra DOM layer between the node that React tries to remove and the
// node that Kendo adds its wrapping to.
//
// So before my bugfix, calling code could avoid the buggy behavior by doing
//
//   <div>
//       {showDatePicker() && <span><DatePicker value={value} localization={localization} /></span>}
//   </div>
//
// Just the extra <span> is enough to avoid the bug.
//
// But rather than forcing calling code to be aware of this bug and the need for an extra
// <span>, I'm gonna change our API so that every component this module exports comes wrapped
// up in the extra <span> already. That avoids this bug, even in the first code example above.
//
// Note that our DateTimePicker component was already just a wrapper <span> around a DatePicker
// and a TimePicker. So it was already safe from this bug.
// That probably helps explain why we're just seeing this now.
var DatePicker = function (props) {
    return React.createElement("span", { className: "portcall-datepicker-wrapper" },
        React.createElement(InternalDatePicker, __assign({}, props)));
};
exports.DatePicker = DatePicker;
var NullableDatePicker = function (props) {
    return React.createElement("span", { className: "portcall-datepicker-wrapper" },
        React.createElement(InternalNullableDatePicker, __assign({}, props)));
};
exports.NullableDatePicker = NullableDatePicker;
var TimePicker = function (props) {
    return React.createElement("span", { className: "portcall-timepicker-wrapper" },
        React.createElement(InternalTimePicker, __assign({}, props)));
};
exports.TimePicker = TimePicker;
var NullableTimePicker = function (props) {
    return React.createElement("span", { className: "portcall-timepicker-wrapper" },
        React.createElement(InternalNullableTimePicker, __assign({}, props)));
};
exports.NullableTimePicker = NullableTimePicker;
var DateTimePicker = function (_a) {
    var tabindex = _a.tabindex, inputRef = _a.inputRef, autofocus = _a.autofocus, rest = __rest(_a, ["tabindex", "inputRef", "autofocus"]);
    return React.createElement("span", { className: "portcall-datetimepicker" },
        React.createElement(InternalDatePicker, __assign({ tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.date, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.date, autofocus: autofocus === null || autofocus === void 0 ? void 0 : autofocus.date }, rest)),
        React.createElement(InternalTimePicker, __assign({ tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.time, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.time }, rest)));
};
exports.DateTimePicker = DateTimePicker;
var NullableDateTimePicker = function (_a) {
    var tabindex = _a.tabindex, inputRef = _a.inputRef, autofocus = _a.autofocus, rest = __rest(_a, ["tabindex", "inputRef", "autofocus"]);
    return React.createElement("span", { className: "portcall-datetimepicker" },
        React.createElement(InternalNullableDatePicker, __assign({ tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.date, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.date, autofocus: autofocus === null || autofocus === void 0 ? void 0 : autofocus.date }, rest)),
        React.createElement(InternalNullableTimePicker, __assign({ tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.time, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.time }, rest)));
};
exports.NullableDateTimePicker = NullableDateTimePicker;
var ProgInitDateTimePicker = function (_a) {
    var value = _a.value, tabindex = _a.tabindex, inputRef = _a.inputRef, autofocus = _a.autofocus, rest = __rest(_a, ["value", "tabindex", "inputRef", "autofocus"]);
    return React.createElement("span", { className: "portcall-datetimepicker" },
        React.createElement(InternalNullableDatePicker, __assign({ value: value.DatePortion, tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.date, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.date, autofocus: autofocus === null || autofocus === void 0 ? void 0 : autofocus.date }, rest)),
        React.createElement(InternalNullableTimePicker, __assign({ value: value.TimePortion, tabindex: tabindex === null || tabindex === void 0 ? void 0 : tabindex.time, inputRef: inputRef === null || inputRef === void 0 ? void 0 : inputRef.time }, rest)));
};
exports.ProgInitDateTimePicker = ProgInitDateTimePicker;
function InitPicker(props, el, _a) {
    var pickerKind = _a.pickerKind, allowNullSets = _a.allowNullSets;
    var value = props.value, min = props.min, max = props.max, disabled = props.disabled, _b = props.localization, tzutils = _b.tzutils, formatDefaults = _b.DateFormatDefaults;
    // TH: Currently not supporting overrides, but could add those here...
    var format = pickerKind === PickerKind.Date ? formatDefaults.dateFormat : formatDefaults.timeFormat, parseFormats = pickerKind === PickerKind.Date ? formatDefaults.dateParseFormats : formatDefaults.timeParseFormats;
    var setting = false;
    var options = {
        change: function () {
            var 
            // Kendo's value
            kVal = this.value(), curr = s_js_1.default.sample(value);
            var val;
            if (kVal) {
                val = new TZDate_1.default(0);
                // Use Kendo's value to construct a new TZDate instance. But be careful b/c in general Kendo
                // date-only pickers can't be trusted to preserve time info and vice versa for time-only pickers.
                // In particular:
                // - Date-only pickers set the time portion of their value to 00:00 seemingly anytime the user
                //   modifies the date, or even if the user just opens and closes the calendar widget w/o making
                //   changes.
                // - Time-only pickers set the date portion of their value to today's date when transitioning
                //   from an unset time value to a populated time value.
                // Our policy will be that date-only pickers will modify only the date portion of their value
                // and will leave the time portion as is, and likewise time-only pickers will modify
                // only the time portion of their value. This is especially important for our combined date/time
                // picker since we construct separate date and time pickers internally.
                // Our usual trick for setting month and date together. See e.g. tzutils.tzify method.
                val.setDate(1);
                val.setFullYear(pickerKind === PickerKind.Time && curr ? curr.getFullYear() : kVal.getFullYear());
                val.setMonth(pickerKind === PickerKind.Time && curr ? curr.getMonth() : kVal.getMonth());
                val.setDate(pickerKind === PickerKind.Time && curr ? curr.getDate() : kVal.getDate());
                val.setHours(pickerKind === PickerKind.Date && curr ? curr.getHours() : kVal.getHours());
                val.setMinutes(pickerKind === PickerKind.Date && curr ? curr.getMinutes() : kVal.getMinutes());
                val.setSeconds(pickerKind === PickerKind.Date && curr ? curr.getSeconds() : kVal.getSeconds());
                val.setMilliseconds(pickerKind === PickerKind.Date && curr ? curr.getMilliseconds() : kVal.getMilliseconds());
                // IMPORTANT: Set timezone offset when done, making sure to preserve walltime.
                tzutils.setTimezoneOffset(val, true);
            }
            else {
                val = null;
            }
            if (!val && !allowNullSets) {
                // Tell kendo to go back to displaying the current value.
                picker.value(curr && tzutils.localify(curr));
                return;
            }
            ;
            // BUGFIX: Kendo fires change event even if user just blurs datepicker w/o making changes.
            // Don't write to backing value in this case.
            if (TZDate_1.default.nullableEq(val, curr))
                return;
            setting = true;
            var acceptedVal;
            try {
                acceptedVal = value(val);
            }
            finally {
                setting = false;
            }
            if (!TZDate_1.default.nullableEq(acceptedVal, val)) {
                // The model didn't like the value we tried to write. Say that the model wins
                // and go ahead and update our picker.
                picker.value(acceptedVal && tzutils.localify(acceptedVal));
            }
        },
        open: function (e) {
            // TH: 5/2/2016 -- Bugfix. On FF and IE, Kendo calendar and time popups were getting their z-index set to 11. Whereas in Chrome it gets set to 10002.
            // That means that on FF and IE, calendar and time popups weren't visible when launched from an element w/ a z-index higher than 11.
            // Fix is to default to the Chrome behavior, w/ an option to specify a different z-index or to let Kendo set it itself.
            var zIndex = props.popupZIndex !== undefined ? props.popupZIndex : 10002;
            // Passing 'kendo' for the popupZIndex prop means let kendo set the z-index, i.e. don't override
            if (zIndex !== 'kendo') {
                var popupView_1 = pickerKind === PickerKind.Time || e.view === 'time' ? this.timeView : this.dateView;
                // At the time this open event fires, Kendo hasn't applied its z-index yet (or necessarily even created the wrapper element). Hence the timeout.
                setTimeout(function () {
                    popupView_1.popup.wrapper.css('z-index', zIndex);
                }, 0);
            }
            // Do time correction if this is a time picker, or if this is the time view of a datetime picker
            // NOTE: Kendo doesn't populate e.view for time-only pickers
            if (pickerKind === PickerKind.Time || e.view === 'time') {
                // TH: Set time to the nearest Kendo dropdown option.
                // The old implementation assumed hours were in 12-hour display. It broke when I switched to 24-hour display.
                var currVal = s_js_1.default.sample(value);
                if (currVal) {
                    var mins = currVal.getMinutes(), 
                    // Property of kendo time picker that says how far apart dropdown options are in mins.
                    // Default is 30 mins.
                    interval = this.options.interval, roundedMins = Math.round(mins / interval) * interval, newVal = new TZDate_1.default(currVal);
                    newVal.setMinutes(roundedMins);
                    // TH: 2/12/16 - This auto-rounding when we open the time dropdown was sometimes causing the date to change. E.g. if the datetime value was 2016/02/11 23:59 and the user clicked the
                    // clock button, then the time would automatically jump to 2016/02/12 00:00. That means no matter what time the user picked from the dropdown, the date would now be on 2016/02/12.
                    // BB and DC never want the date to change when you open the time dropdown.
                    // For now, solve this by turning off rounding completely. In the future, we may instead implement special handling for times between 23:45 and 23:59, e.g. 2016/02/11 23:59 might
                    // round to 2016/02/11 00:00 or 2016/02/11 23:30 instead.
                    // m.value(newVal);
                }
            }
        }
    };
    var $el = $(el);
    var picker;
    if (pickerKind === PickerKind.Time) {
        picker = $el.kendoTimePicker(options).data("kendoTimePicker");
    }
    else if (pickerKind === PickerKind.Date) {
        picker = $el.kendoDatePicker(options).data("kendoDatePicker");
    }
    else {
        throw new Error('Unrecognized PickerKind: ' + pickerKind);
    }
    s_js_1.default.cleanup(function () { return picker.destroy(); });
    // TH: Annoyingly, Kendo sets some "width: 100%" style attributes that make its widgets hard to customize.
    // Override those style attributes here.
    $el.css('width', '');
    $el.closest('span.k-widget.k-header.k-input').css('width', '');
    s_js_1.default(function () {
        var val = value();
        if (!setting)
            picker.value(val && tzutils.localify(val));
    });
    // format -- display for the text input portion of the date/time picker
    s_js_1.default(function () { return picker.setOptions({ format: format() }); });
    // parseFormats -- other possible formats for user direct entry into the input portion of the date/time picker
    // Display will be converted to the official format on blur.
    s_js_1.default(function () { return picker.setOptions({ parseFormats: parseFormats() }); });
    if (min)
        s_js_1.default(function () { return picker.min(tzutils.localify(min())); });
    if (max)
        s_js_1.default(function () { return picker.max(tzutils.localify(max())); });
    // Kendo bug fix: if we specify readonly: true in the options, it doesn't make the widget fully readonly.  it disables typing in thefield, but not the dropdown selectors.  yay.
    // Also note: We make sure to set the readonly state of the Kendo picker EVERY time we init it, not just when disabled is set to true. That's b/c if you don't explicitly set
    // the picker to readonly, Kendo will infer the readonly state based on the input element's readonly attribute. But Kendo sets the readonly attribute itself when you explicitly
    // set the readonly state of the picker, and it doesn't clear the readonly attribute when you destory the picker. So if you destroy a readonly picker, Kendo will default the next
    // picker init'ed on that same DOM element to readonly. We want our disabled prop to be definitive no matter what state the DOM was in beforehand.
    picker.readonly(disabled !== null && disabled !== void 0 ? disabled : false);
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(53);
var IObject = __webpack_require__(139);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var asc = __webpack_require__(212);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(5);
var core = __webpack_require__(44);
var fails = __webpack_require__(19);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var CallbackQueue = __webpack_require__(468);
var PooledClass = __webpack_require__(104);
var ReactFeatureFlags = __webpack_require__(473);
var ReactReconciler = __webpack_require__(125);
var Transaction = __webpack_require__(187);

var invariant = __webpack_require__(13);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDisagreesWithEnteredDateDescription = exports.IssueDescriptionForTooltip = exports.IssueDescription = exports.IssuesShortSummary = exports.ConflictReasonText = exports.IssueSummary = exports.IssueCountPillBadgeWithTooltip = exports.IssueCountPillBadge = exports.SmallConflictCountBadgeWithTooltip = exports.SmallConflictCountBadge = exports.IssueCountBadge = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var Issue_1 = __webpack_require__(157);
var Issue_2 = __webpack_require__(135);
var IssueType_1 = __webpack_require__(112);
var ScheduleDateType_1 = __webpack_require__(80);
var ScheduleDateEventType_1 = __webpack_require__(291);
var view_1 = __webpack_require__(534);
var 
// TH 11/18/2016 -- More discursive than some of the other displays here.
// Picks the highest priority issue type. Suitable for insertion into "This reservation is in conflict because it..."
ConflictReasonText = function (issues) {
    var top = Issue_1.Issue.TopIssue(issues().filter(function (i) { return i.Severity() >= Issue_2.IssueSeverity.Conflict; }));
    if (!top)
        return '';
    return (top.Type() === IssueType_1.IssueType.ReservationExceedsBerthLength ?
        'exceeds the berth\'s max length' :
        top.Type() === IssueType_1.IssueType.ReservationExceedsBerthDepth ?
            'exceeds the berth\'s max depth' :
            top.Type() === IssueType_1.IssueType.ReservationLacksKnownVessel ?
                'requires a vessel at this location' :
                top.Type() === IssueType_1.IssueType.ReservationOverlapsOther ?
                    'overlaps an existing reservation' :
                    top.Type() === IssueType_1.IssueType.ReservationOverlapsShift ?
                        'overlaps a reservation in this portcall' :
                        top.Type() === IssueType_1.IssueType.ReservationOverlapsVesselSchedule ?
                            'overlaps same vessel at another location' :
                            top.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure ?
                                'overlaps a berth closure' :
                                '');
}, 
/**
 * Get a medium-length string description of a ScheduleDisagreesWithEnteredDate Issue.
 */
ScheduleDisagreesWithEnteredDateDescription = function (issue) {
    var ed = issue.EnteredDate(), edsd = ed && ed.ScheduleDate(), sd = issue.ScheduleDate(), evt = ed && ed.ScheduleChange() && ed.ScheduleChange().Event(), enteredName = ed && edsd ?
        ed.Type() === ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered &&
            edsd.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ?
            // special case -- 'ETA' instead of 'estimated arrival'
            'ETA' :
            // Otherwise -- '{estimated/actual} {arrival/departure/start/end}'
            (ed.Type() === ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered ? 'estimated' : 'actual')
                + ' '
                + ScheduleDateName(edsd) :
        '', scheduledName = sd ?
        // '{estimated/actual} {arrival/departure/start/end}'
        (issue.DiscrepantDateField() === Issue_2.DiscrepantScheduleDateField.Estimated ? 'estimated' : 'actual')
            + ' '
            + ScheduleDateName(sd) :
        '', sourceName = evt && (evt.User() && evt.User().FullName() ||
        evt.Automation() && evt.Automation().Name()) || '', entryAction = evt && ed ?
        evt.User() ? 'entered' :
            ed.Type() === ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered ? 'forecasted' :
                'provided' :
        '', sVal = sd && (issue.DiscrepantDateField() === Issue_2.DiscrepantScheduleDateField.Estimated ?
        sd.Estimated() :
        sd.Actual()), eVal = ed && ed.Date(), deltaHours = sVal && eVal && tzmoment_1.tzmoment(eVal).diff(tzmoment_1.tzmoment(sVal), 'hours'), deltaText = deltaHours !== null ?
        Math.abs(deltaHours) + " hour" + (deltaHours === 1 || deltaHours === -1 ? '' : 's') + " " + (deltaHours >= 0 ? 'after' : 'before') :
        '';
    return "The " + enteredName + " " + entryAction + " by " + sourceName + " is more than " + deltaText + " the current " + scheduledName + ".";
};
exports.IssueCountBadge = supercritical_1.default(function (_a) {
    var issues = _a.issues, onClick = _a.onClick;
    return React.createElement(view_1.PCBadge, { className: "issue-count-badge" + (issues().some(function (i) { return i.Severity() >= Issue_2.IssueSeverity.Conflict; }) ? ' has-conflicts' : ''), visible: issues().length > 0, onClick: onClick }, issues().length || null);
}), exports.SmallConflictCountBadge = supercritical_1.default(function (_a) {
    var conflictCount = _a.conflictCount;
    return conflictCount() ? React.createElement("span", { className: "small-conflict-count-badge" }, conflictCount()) : null;
}), exports.SmallConflictCountBadgeWithTooltip = supercritical_1.default(function (_a) {
    var conflicts = _a.conflicts;
    return (React.createElement("div", null, conflicts().length ? React.createElement("div", { className: "small-conflict-count-badge issue-badge-with-tooltip" },
        conflicts().length,
        React.createElement("div", { className: "tooltip-popup" },
            React.createElement("div", { className: "tooltip-caret" }),
            React.createElement("div", { className: "tooltip-text" }, conflicts().map(function (i) { return React.createElement(exports.IssueDescriptionForTooltip, { key: i.Id(), issue: i }); })))) : null));
}), exports.IssueCountPillBadge = supercritical_1.default(function (_a) {
    var className = _a.className, issues = _a.issues;
    return issues().length > 0 ?
        React.createElement("span", { className: cx('issue-count-pill-badge', { 'issue-count-pill-badge--has-conflicts': issues().some(function (i) { return i.Severity() >= Issue_2.IssueSeverity.Conflict; }) }, className) }, issues().length) :
        null;
}), exports.IssueCountPillBadgeWithTooltip = supercritical_1.default(function (_a) {
    var className = _a.className, issues = _a.issues;
    return issues().length > 0 ?
        React.createElement("span", { className: cx('issue-badge-with-tooltip', className) },
            React.createElement(exports.IssueCountPillBadge, { issues: issues }),
            React.createElement("div", { className: "tooltip-popup" },
                React.createElement("div", { className: "tooltip-caret" }),
                React.createElement("div", { className: "tooltip-text" }, issues().map(function (i) { return React.createElement(exports.IssueDescriptionForTooltip, { key: i.Id(), issue: i }); })))) :
        null;
}), exports.IssueSummary = supercritical_1.default(function (_a) {
    var _b = _a.issue, Severity = _b.Severity, Type = _b.Type, className = _a.className, onClick = _a.onClick;
    return React.createElement("span", { className: "issue-summary " + (className || '') + (onClick ? ' has-click' : '') + (Severity() >= Issue_2.IssueSeverity.Conflict ? ' conflict' : ''), onClick: onClick }, Type() === IssueType_1.IssueType.ReservationOverlapsOther ?
        "Overlaps existing reservation" :
        Type() === IssueType_1.IssueType.ReservationOverlapsShift ?
            "Overlaps a reservation in this portcall" :
            Type() === IssueType_1.IssueType.ReservationOverlapsVesselSchedule ?
                "Overlaps same vessel at another location" :
                Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure ?
                    "Overlaps berth closure" :
                    Type() === IssueType_1.IssueType.ReservationExceedsBerthDepth ?
                        "Exceeds berth's max. depth" :
                        Type() === IssueType_1.IssueType.ReservationExceedsBerthLength ?
                            "Exceeds berth's max. length" :
                            Type() === IssueType_1.IssueType.ReservationLacksKnownVessel ?
                                "Requires a vessel at this location" :
                                Type() === IssueType_1.IssueType.ScheduleDisagreesWithEnteredDate ?
                                    "Schedule differs from the forecasted ETA" :
                                    null);
}), 
// TH 11/18/2016 -- More discursive than some of the other displays here.
// Picks the highest priority issue type. Suitable for insertion into "This reservation is in conflict because it..."
exports.ConflictReasonText = ConflictReasonText, exports.IssuesShortSummary = supercritical_1.default(function (_a) {
    var issues = _a.issues, className = _a.className, onClick = _a.onClick;
    var top = Issue_1.Issue.TopIssue(issues());
    return top === null ? null : React.createElement(exports.IssueSummary, { issue: top, className: className, onClick: onClick });
}), exports.IssueDescription = supercritical_1.default(function (_a) {
    var _b;
    var issue = _a.issue;
    var res = issue.BerthReservation(), other = issue.OtherReservation(), otherpc = other && other.Itinerary() && other.Itinerary().PortCall(), berth = res ? (res.Itinerary() && res.Itinerary().Location() && res.Itinerary().Location().Berth()) : issue.Berth(), loc = berth && berth.Location(), brbcl = issue.BerthReservationBerthClosure();
    return (React.createElement("div", { className: "issue-description alert alert-" + (issue.Severity() >= Issue_2.IssueSeverity.Warning ? "warning" : "info") }, issue.Type() === IssueType_1.IssueType.ReservationOverlapsOther ?
        React.createElement("span", null,
            "Reservation",
            loc && (' at ' + loc.Name()),
            " overlaps with an existing reservation",
            otherpc && ': ',
            otherpc && React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
            ".",
            ' ',
            React.createElement("span", { className: "issue-description-follow-up" }, "This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
        issue.Type() === IssueType_1.IssueType.ReservationOverlapsShift ?
            React.createElement("span", null,
                "Times for reservation",
                loc && (' at ' + loc.Name()),
                " overlap with another reservation for the same PortCall",
                otherpc && ': ',
                otherpc && React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
                ".",
                ' ',
                React.createElement("span", { className: "issue-description-follow-up" }, "This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
            issue.Type() === IssueType_1.IssueType.ReservationOverlapsVesselSchedule ?
                React.createElement("span", null,
                    "Times for reservation",
                    loc && (' at ' + loc.Name()),
                    " overlap with an existing reservation for the same vessel",
                    otherpc && ': ',
                    otherpc && React.createElement("span", null,
                        React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
                        " at ", (_b = otherpc.Port()) === null || _b === void 0 ? void 0 :
                        _b.Name()),
                    ".",
                    ' ',
                    React.createElement("span", { className: "issue-description-follow-up" }, "This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
                issue.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure ?
                    React.createElement("span", null,
                        "Reservation",
                        loc && (' at ' + loc.Name()),
                        " overlaps with an existing reservation",
                        brbcl && ': ',
                        brbcl && React.createElement("span", { className: "issue-descr-closure" },
                            "Closure \u2014 ",
                            brbcl.Title()),
                        ".",
                        ' ',
                        React.createElement("span", { className: "issue-description-follow-up" }, " This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
                    issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthDepth ?
                        React.createElement("span", null,
                            "This vessel exceeds the max. draft allowed",
                            loc && (' at ' + loc.Name()),
                            ".",
                            ' ',
                            React.createElement("span", { className: "issue-description-follow-up" }, "This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
                        issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthLength ?
                            React.createElement("span", null,
                                "This vessel exceeds the max. length allowed",
                                loc && (' at ' + loc.Name()),
                                ".",
                                ' ',
                                React.createElement("span", { className: "issue-description-follow-up" }, "This reservation may be booked, changed or cancelled after a berth manager reviews it.")) :
                            issue.Type() === IssueType_1.IssueType.ReservationLacksKnownVessel ?
                                React.createElement("span", null,
                                    loc ? loc.Name() : 'This berth',
                                    " requires reservations to have a vessel listed.",
                                    ' ',
                                    React.createElement("span", { className: "issue-description-follow-up" }, "This reservation will not be reviewed until a vessel is entered.")) :
                                issue.Type() === IssueType_1.IssueType.ScheduleDisagreesWithEnteredDate ?
                                    React.createElement("span", null, exports.ScheduleDisagreesWithEnteredDateDescription(issue)) :
                                    null));
}), exports.IssueDescriptionForTooltip = supercritical_1.default(function (_a) {
    var _b;
    var issue = _a.issue;
    var res = issue.BerthReservation(), other = issue.OtherReservation(), otherpc = other && other.Itinerary() && other.Itinerary().PortCall(), berth = res ? (res.Itinerary() && res.Itinerary().Location() && res.Itinerary().Location().Berth()) : issue.Berth(), loc = berth && berth.Location(), brbcl = issue.BerthReservationBerthClosure();
    return (React.createElement("div", { className: "issue-description" }, issue.Type() === IssueType_1.IssueType.ReservationOverlapsOther ?
        React.createElement("div", { className: "tooltip-issues" },
            "Reservation",
            loc && (' at ' + loc.Name()),
            " overlaps with an existing reservation",
            otherpc && ': ',
            otherpc && React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
            ".") :
        issue.Type() === IssueType_1.IssueType.ReservationOverlapsShift ?
            React.createElement("div", { className: "tooltip-issues" },
                "Times for reservation",
                loc && (' at ' + loc.Name()),
                " overlap with another reservation for the same PortCall",
                otherpc && ': ',
                otherpc && React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
                ".") :
            issue.Type() === IssueType_1.IssueType.ReservationOverlapsVesselSchedule ?
                React.createElement("div", { className: "tooltip-issues" },
                    "Times for reservation",
                    loc && (' at ' + loc.Name()),
                    " overlap with an existing reservation for the same vessel",
                    otherpc && ': ',
                    otherpc && React.createElement("span", null,
                        React.createElement("span", { className: "issue-descr-vessel" }, otherpc.DisplayVesselIdentifier()),
                        " at ", (_b = otherpc.Port()) === null || _b === void 0 ? void 0 :
                        _b.Name()),
                    ".") :
                issue.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure ?
                    React.createElement("div", { className: "tooltip-issues" },
                        "Reservation",
                        loc && (' at ' + loc.Name()),
                        " overlaps with an existing reservation",
                        brbcl && ': ',
                        brbcl && React.createElement("span", { className: "issue-descr-closure" },
                            "Closure \u2014 ",
                            brbcl.Title()),
                        ".") :
                    issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthDepth ?
                        React.createElement("div", { className: "tooltip-issues" },
                            "This vessel exceeds the max. draft allowed",
                            loc && (' at ' + loc.Name()),
                            ".") :
                        issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthLength ?
                            React.createElement("div", { className: "tooltip-issues" },
                                "This vessel exceeds the max. length allowed",
                                loc && (' at ' + loc.Name()),
                                ".") :
                            issue.Type() === IssueType_1.IssueType.ReservationLacksKnownVessel ?
                                React.createElement("div", { className: "tooltip-issues" },
                                    loc ? loc.Name() : 'This berth',
                                    " requires reservations to have a vessel listed. Enter a vessel for this PortCall or select a different location.") :
                                issue.Type() === IssueType_1.IssueType.PilotJobOrderExceedsBerthDepth ?
                                    React.createElement("div", { className: "tooltip-issues" }, "This vessel exceeds the max. draft allowed for this movement.") :
                                    issue.Type() === IssueType_1.IssueType.ScheduleDisagreesWithEnteredDate ?
                                        React.createElement("div", { className: "tooltip-issues" }, exports.ScheduleDisagreesWithEnteredDateDescription(issue)) :
                                        null));
}), 
/**
 * Get a medium-length string description of a ScheduleDisagreesWithEnteredDate Issue.
 */
exports.ScheduleDisagreesWithEnteredDateDescription = ScheduleDisagreesWithEnteredDateDescription;
function ScheduleDateName(sd) {
    return (sd.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ?
        'arrival' :
        sd.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ?
            'departure' :
            sd.Type() === ScheduleDateType_1.ScheduleDateType.PJOStart ?
                'start' :
                sd.Type() === ScheduleDateType_1.ScheduleDateType.PJOEnd ?
                    'end' :
                    '');
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPoint = void 0;
var NullableComparer_1 = __webpack_require__(1381);
var ItineraryPoint_1 = __webpack_require__(1479);
var ScheduleDateType_1 = __webpack_require__(80);
var ItineraryPoint = /** @class */ (function (_super) {
    __extends(ItineraryPoint, _super);
    function ItineraryPoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItineraryPoint.prototype.ArrivalEntity = function () {
        return this.Schedule().find(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival; }) || null;
    };
    ItineraryPoint.prototype.DepartureEntity = function () {
        return this.Schedule().find(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture; }) || null;
    };
    ItineraryPoint.prototype.IsMovementPoint = function () {
        return this.IsPortArrival() || this.IsPortDeparture() || (this.BerthReservation() !== null && this.BerthReservation().CancelledDate() === null);
    };
    ItineraryPoint.prototype.NextMovementPoint = function () {
        var pc = this.PortCall(), series = pc && pc.MovementSeries(), pos = series && series.indexOf(this);
        return pos === null || pos === -1 || pos === series.length - 1 ? null : series[pos + 1];
    };
    ItineraryPoint.prototype.PreviousMovementPoint = function () {
        var pc = this.PortCall(), series = pc && pc.MovementSeries(), pos = series && series.indexOf(this);
        return pos === null || pos === -1 || pos === 0 ? null : series[pos - 1];
    };
    // TS port of the PortCallExtensions static class in PortCall.Models\PortCall\PortCall.cs.
    ItineraryPoint.EffectiveOrder = function (pt1, pt2) {
        return pt1.Arrival.Effective() < pt2.Arrival.Effective() ? -1
            : pt1.Arrival.Effective() > pt2.Arrival.Effective() ? 1
                : pt1.Departure.Effective() < pt2.Departure.Effective() ? -1
                    : pt1.Departure.Effective() > pt2.Departure.Effective() ? 1
                        : pt1.Id() < pt2.Id() ? -1
                            : pt1.Id() > pt2.Id() ? 1
                                : 0;
    };
    ItineraryPoint.EstimatedOrder = function (pt1, pt2) {
        return pt1.Arrival.Estimated() < pt2.Arrival.Estimated() ? -1
            : pt1.Arrival.Estimated() > pt2.Arrival.Estimated() ? 1
                : pt1.Departure.Estimated() < pt2.Departure.Estimated() ? -1
                    : pt1.Departure.Estimated() > pt2.Departure.Estimated() ? 1
                        : pt1.Id() < pt2.Id() ? -1
                            : pt1.Id() > pt2.Id() ? 1
                                : 0;
    };
    ItineraryPoint.ActualOrder = function (pt1, pt2) {
        var arrivalCompare = NullableComparer_1.NullableComparer(pt1.Arrival.Actual(), pt2.Arrival.Actual());
        if (arrivalCompare !== 0)
            return arrivalCompare;
        var departureCompare = NullableComparer_1.NullableComparer(pt1.Departure.Actual(), pt2.Departure.Actual());
        if (departureCompare !== 0)
            return departureCompare;
        return pt1.Id() < pt2.Id() ? -1 : pt1.Id() > pt2.Id() ? 1 : 0;
    };
    return ItineraryPoint;
}(ItineraryPoint_1.ItineraryPoint));
exports.ItineraryPoint = ItineraryPoint;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var s_js_1 = __webpack_require__(0);
var UNSET = {};
function uniqueIndex(array, keyFn) {
    var index = {}, 
    // how many items have this key.  must be 0 or 1 at end of update
    slotCounts = {}, 
    // change data: which keys, items and how many are changing
    changeKeys = [], changeItems = [], // parallel to changeKeys
    changeCount = 0, incKey = function (item, key) {
        if (key in slotCounts)
            slotCounts[key]++;
        else
            slotCounts[key] = 1;
        changeKeys[changeCount] = key;
        changeItems[changeCount] = item;
        changeCount++;
    }, decKey = function (item, key) {
        slotCounts[key]--;
        changeKeys[changeCount] = key;
        changeItems[changeCount] = UNSET;
        changeCount++;
    }, changeBuilder = array.map(function (item, oldkey) {
        var key = keyFn(item);
        if (key !== oldkey) {
            if (oldkey !== undefined)
                decKey(item, oldkey);
            incKey(item, key);
        }
        return key;
    }, decKey), updater = s_js_1.default.on(changeBuilder, function () {
        var errors = "";
        while (changeCount) {
            changeCount--;
            var key = changeKeys[changeCount], item = changeItems[changeCount], slotCount = slotCounts[key], _slot = slot(key);
            changeItems[changeCount] = UNSET; // memory safe: remove ref to item
            if (slotCount === 0) {
                _slot(null);
            }
            else if (slotCount === 1) {
                if (item !== UNSET)
                    _slot(item);
            }
            else {
                if (item !== UNSET)
                    errors += "key: " + key + ", item: " + item + ". ";
                slotCounts[key] = 1; // restore sane state
            }
        }
        if (errors)
            throw new Error("UniqueIndex collision(s): " + errors);
    });
    return indexRef;
    function indexRef(id) {
        return typeof id === 'function'
            ? function () {
                return slot(id())();
            }
            : slot(id);
    }
    function slot(id) {
        return id in index ? index[id] : index[id] = s_js_1.default.data(null);
    }
}
exports.default = uniqueIndex;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(336);
var $export = __webpack_require__(5);
var shared = __webpack_require__(180)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(339))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(14);
var dPs = __webpack_require__(322);
var enumBugKeys = __webpack_require__(215);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(214)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(217).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(324);
var enumBugKeys = __webpack_require__(215);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(30)) {
  var LIBRARY = __webpack_require__(98);
  var global = __webpack_require__(16);
  var fails = __webpack_require__(19);
  var $export = __webpack_require__(5);
  var $typed = __webpack_require__(182);
  var $buffer = __webpack_require__(236);
  var ctx = __webpack_require__(53);
  var anInstance = __webpack_require__(95);
  var propertyDesc = __webpack_require__(85);
  var hide = __webpack_require__(47);
  var redefineAll = __webpack_require__(100);
  var toInteger = __webpack_require__(64);
  var toLength = __webpack_require__(32);
  var toIndex = __webpack_require__(333);
  var toAbsoluteIndex = __webpack_require__(102);
  var toPrimitive = __webpack_require__(65);
  var has = __webpack_require__(45);
  var classof = __webpack_require__(96);
  var isObject = __webpack_require__(18);
  var toObject = __webpack_require__(36);
  var isArrayIter = __webpack_require__(220);
  var create = __webpack_require__(72);
  var getPrototypeOf = __webpack_require__(49);
  var gOPN = __webpack_require__(99).f;
  var getIterFn = __webpack_require__(141);
  var uid = __webpack_require__(103);
  var wks = __webpack_require__(24);
  var createArrayMethod = __webpack_require__(61);
  var createArrayIncludes = __webpack_require__(167);
  var speciesConstructor = __webpack_require__(181);
  var ArrayIterators = __webpack_require__(238);
  var Iterators = __webpack_require__(97);
  var $iterDetect = __webpack_require__(175);
  var setSpecies = __webpack_require__(101);
  var arrayFill = __webpack_require__(211);
  var arrayCopyWithin = __webpack_require__(307);
  var $DP = __webpack_require__(26);
  var $GOPD = __webpack_require__(48);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var PooledClass = __webpack_require__(104);

var emptyFunction = __webpack_require__(58);
var warning = __webpack_require__(20);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDate = exports.parseDate = exports.parsePortCallUserRole = void 0;
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var PortCallUserRole_1 = __webpack_require__(136);
// Standard utilities for parsing/serializing query string params
function parsePortCallUserRole(role) {
    role = role.toLowerCase();
    for (var i = 0; i < PortCallUserRole_1.PortCallUserRoles.length; i++) {
        if (role === PortCallUserRole_1.PortCallUserRoleDisplayName[PortCallUserRole_1.PortCallUserRoles[i].Id].toLowerCase()) {
            return PortCallUserRole_1.PortCallUserRoles[i].Id;
        }
    }
    throw new Error('Unknown role string: ' + role);
}
exports.parsePortCallUserRole = parsePortCallUserRole;
function parseDate(str, tzutils) {
    return tzutils.setTimezoneOffset(new TZDate_1.default(str + 'T00:00:00Z'), true);
}
exports.parseDate = parseDate;
function serializeDate(date) {
    return tzmoment_1.tzmoment(date).format('YYYY-MM-DD');
}
exports.serializeDate = serializeDate;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FullProfileLink = exports.ContactsView = exports.EmailView = exports.OrganizationNameView = exports.UserNameView = exports.ProfileDetails = exports.PersonProfilePopupView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(52);
var view_2 = __webpack_require__(275);
var view_3 = __webpack_require__(1126);
var view_4 = __webpack_require__(35);
// character limits at which tooltips will be enabled
var MAX_NAME_CHARS = 20, MAX_ORG_CHARS = 28, MAX_EMAIL_CHARS = 25;
exports.PersonProfilePopupView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer, boundingContainer = _a.boundingContainer, boundingPadding = _a.boundingPadding;
    var m = modelContainer();
    if (!m)
        return null;
    return (React.createElement(view_3.PCBounded, { className: "personprofilepopup pc-card", container: boundingContainer || '.pc-page-fixedwidth', padding: boundingPadding !== undefined ? boundingPadding : 10 },
        React.createElement(view_4.PCDismissible, { onDismiss: m.HidePopup },
            React.createElement("img", { className: "profile-image", src: m.User() && m.User().Model.Image.ProfileUrl() || '' }),
            React.createElement("div", { className: "right-side" },
                React.createElement("a", { href: "", className: "dismiss-btn", onClick: eventWrappers_1.noDefault(m.HidePopup) },
                    React.createElement("span", { className: "pc-close-icon" })),
                React.createElement(exports.ProfileDetails, { model: m }),
                React.createElement(exports.FullProfileLink, { model: m })))));
});
exports.ProfileDetails = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "profile-details" },
        React.createElement(exports.UserNameView, { model: m }),
        React.createElement(exports.OrganizationNameView, { model: m }),
        React.createElement(exports.EmailView, { model: m }),
        React.createElement(exports.ContactsView, { model: m }));
});
exports.UserNameView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "name" }, (function (user) { return user &&
        React.createElement(view_1.MaxLengthTooltip, { className: "name-text pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: function () { return user.Model.FullName(); }, maxLength: MAX_NAME_CHARS }); })(m.User()));
});
exports.OrganizationNameView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var org = m.User() && m.User().Model.Organization();
    if (!org)
        return null;
    return (React.createElement(view_1.MaxLengthTooltip, { className: "organization pc-text-fixedwidth pc-text-fixedwidth-tooltip pc-text-smalllabel", text: function () { return org.Name() || ''; }, maxLength: MAX_ORG_CHARS }));
});
exports.EmailView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var pcuser = m.User(), user = pcuser && pcuser.Model.User(), email = user && user.Email() || '';
    return !email ? null :
        React.createElement("div", { className: "email" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "email"),
            React.createElement("a", { href: "mailto:" + email },
                React.createElement(view_1.MaxLengthTooltip, { className: "email-text pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: function () { return email || ''; }, maxLength: MAX_EMAIL_CHARS })));
});
exports.ContactsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var user = m.User();
    if (!user)
        return null;
    return (React.createElement("div", { className: "contacts pc-show-viewcontrols" },
        user.OtherNumbers().length > 0 &&
            React.createElement("a", { href: "", className: "more-btn", onClick: eventWrappers_1.noDefault(user.ToggleMoreNumbers) }, "more"),
        React.createElement("div", { className: "main-number" }, user.MainNumber() && React.createElement(view_2.PhoneNumberView, { model: user.MainNumber() })),
        user.OtherNumbers().length > 0 &&
            React.createElement("div", { className: "other-numbers pc-card", hidden: !user.ShowMoreNumbers() }, user.OtherNumbers().map(function (pn) {
                return React.createElement(view_2.PhoneNumberView, { model: pn, key: pn.Model.Id() });
            }))));
});
exports.FullProfileLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    if (!m.Model.CanEdit())
        return null;
    return (React.createElement("div", { className: "view-full-profile" },
        React.createElement("a", { href: '#!personprofilepage?id=' + m.UserId }, "View full profile")));
});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservation = void 0;
var BerthReservation_1 = __webpack_require__(1428);
var BerthReservation_2 = __webpack_require__(38);
var EndMark_1 = __webpack_require__(1260);
var Issue_1 = __webpack_require__(135);
var PierMark_1 = __webpack_require__(159);
var BerthReservation = /** @class */ (function (_super) {
    __extends(BerthReservation, _super);
    function BerthReservation(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.PierMark = new PierMark_1.PierMark(_this.Footmark, function () { return _this.Berth(); });
        return _this;
    }
    Object.defineProperty(BerthReservation.prototype, "EndMark", {
        // aah: we re-create the EndMark object on each access so that we can capture the 'this' instance used to access it.
        // this is important b/c the access may have been to a BerthReservation draft object which may have overridden 
        // the original instance's signals with draft signals, and we want EndMark to reference those draft signals
        // not the underlying model's signals.
        // TODO: we should be able to move PierMark to the same process, but that would take further review, as its
        // usage is more embedded than EndMark.
        get: function () {
            return new EndMark_1.EndMark(this);
        },
        enumerable: false,
        configurable: true
    });
    BerthReservation.prototype.Berth = function () {
        var pt = this.Itinerary(), loc = pt && pt.Location();
        return loc && loc.Berth();
    };
    BerthReservation.prototype.PortCall = function () { return this.Itinerary() && this.Itinerary().PortCall(); };
    BerthReservation.prototype.Status = function () {
        // Status field is derived from other fields
        return this.CancelledDate() !== null ? BerthReservation_2.BerthReservationStatus.Cancelled :
            this.ConflictCount() > 0 ? BerthReservation_2.BerthReservationStatus.Conflicted :
                this.ApprovedDate() !== null ? BerthReservation_2.BerthReservationStatus.Booked :
                    BerthReservation_2.BerthReservationStatus.Requested;
    };
    BerthReservation.prototype.Bookable = function () {
        // TODO: This isn't entirely accurate. The check on issue severity depends upon Issues being loaded.
        // proposal: switch from persisting ConflictCount to MaxIssueSeverity, which will let us calculate both Status and Bookable
        return (this.Status() === BerthReservation_2.BerthReservationStatus.Requested || this.Status() === BerthReservation_2.BerthReservationStatus.Conflicted)
            && this.Issues().every(function (i) { return i.Severity() < Issue_1.IssueSeverity.Error; });
    };
    BerthReservation.prototype.Unbookable = function () {
        return this.Status() === BerthReservation_2.BerthReservationStatus.Booked;
    };
    BerthReservation.prototype.Cancellable = function () {
        return this.Status() !== BerthReservation_2.BerthReservationStatus.Cancelled;
    };
    /**
     * Calculate the reservation length for the given inputs.
     * @param vesselLength The vessel length, or null if this reservation is length-only
     * @param vesselBeam The vessel beam, or null if this reservation is length-only
     * @param lengthOnlyLength The length of this length-only reservation, or null if this
     * reservation has a known vessel.
     * @param sideTo The reservation's SideTo value.
     * @param uom The target UOM.
     */
    BerthReservation.calculateLength = function (vesselLength, vesselBeam, lengthOnlyLength, sideTo, uom) {
        var _a, _b;
        var source = ((_a = lengthOnlyLength === null || lengthOnlyLength === void 0 ? void 0 : lengthOnlyLength.Num()) !== null && _a !== void 0 ? _a : null) === null ?
            sideTo === BerthReservation_2.VesselSide.SternTo ?
                vesselBeam :
                vesselLength :
            // For length-only reservations, use the user-provided length regardless of sideTo
            lengthOnlyLength;
        return (_b = source === null || source === void 0 ? void 0 : source.convert(uom)) !== null && _b !== void 0 ? _b : null;
    };
    return BerthReservation;
}(BerthReservation_1.BerthReservation));
exports.BerthReservation = BerthReservation;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateType = void 0;
// ScheduleDateType values, hand-synched w/ PortCall.Models\Schedule\ScheduleDateEntity.cs.
var ScheduleDateType;
(function (ScheduleDateType) {
    ScheduleDateType["IPArrival"] = "IA";
    ScheduleDateType["IPDeparture"] = "ID";
    ScheduleDateType["PJOStart"] = "PS";
    ScheduleDateType["PJOEnd"] = "PE";
})(ScheduleDateType = exports.ScheduleDateType || (exports.ScheduleDateType = {}));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.debounceSignal = void 0;
var s_js_1 = __webpack_require__(0);
/**
 * Return a signal that mirrors the provided signal except that it won't report a new value until the given
 * delay has passed since the last update to the provided signal.
 * @param signal The signal to debounce
 * @param delayMs Optional. The delay after which to report changes. Defaults to 300 ms.
 * @param eq Optional. A comparison function that will be passed to `S.value` internally.
 */
function debounceSignal(signal, delayMs, eq) {
    if (delayMs === void 0) { delayMs = 300; }
    var debounced = s_js_1.default.value(s_js_1.default.sample(signal), eq);
    s_js_1.default.on(signal, function () {
        var timeoutId = window.setTimeout(function () { return debounced(signal()); }, delayMs);
        s_js_1.default.cleanup(function () { return window.clearTimeout(timeoutId); });
    }, undefined, true);
    return function () { return debounced(); };
}
exports.debounceSignal = debounceSignal;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(24)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(47)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var call = __webpack_require__(317);
var isArrayIter = __webpack_require__(220);
var anObject = __webpack_require__(14);
var toLength = __webpack_require__(32);
var getIterFn = __webpack_require__(141);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(103)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(45);
var setDesc = __webpack_require__(26).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.outboundDateRangeParams = exports.parseDateRange = exports.serializeDateRange = void 0;
var routeParams_1 = __webpack_require__(77);
// Standard utilities for parsing/serializing the DateRange enum
function serializeDateRange(range) {
    if (range === 0 /* AllDates */)
        return 'alldates';
    if (range === 1 /* ThisWeek */)
        return 'thisweek';
    if (range === 2 /* LastWeek */)
        return 'lastweek';
    if (range === 3 /* ThisMonth */)
        return 'thismonth';
    if (range === 4 /* LastMonth */)
        return 'lastmonth';
    if (range === 5 /* ThisYear */)
        return 'thisyear';
    if (range === 6 /* LastYear */)
        return 'lastyear';
    if (range === 7 /* Custom */)
        return 'custom';
    throw new Error('Unknown range value: ' + range);
}
exports.serializeDateRange = serializeDateRange;
var allDateRanges = [
    0 /* AllDates */,
    1 /* ThisWeek */,
    2 /* LastWeek */,
    3 /* ThisMonth */,
    4 /* LastMonth */,
    5 /* ThisYear */,
    6 /* LastYear */,
    7 /* Custom */
];
function parseDateRange(range) {
    range = range.toLowerCase();
    for (var i = 0; i < allDateRanges.length; i++) {
        if (range === serializeDateRange(allDateRanges[i])) {
            return allDateRanges[i];
        }
    }
    throw new Error('Unknown range string: ' + range);
}
exports.parseDateRange = parseDateRange;
function outboundDateRangeParams(m, params, defaultRange, keys) {
    if (m.Range() !== defaultRange)
        params[keys.range] = serializeDateRange(m.Range());
    if (m.Range() === 7 /* Custom */) {
        params[keys.from] = routeParams_1.serializeDate(m.FromDate());
        params[keys.to] = routeParams_1.serializeDate(m.ToDate());
    }
}
exports.outboundDateRangeParams = outboundDateRangeParams;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InPortOpsSummaryText = exports.PortCallScheduleHeaderView = exports.PortCallScheduleView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var notNullish_1 = __webpack_require__(94);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var BerthReservation_1 = __webpack_require__(38);
var CoordinationCardStatuses_1 = __webpack_require__(110);
var MilestoneTypes_1 = __webpack_require__(158);
var ScheduleDateType_1 = __webpack_require__(80);
var model_1 = __webpack_require__(538);
var view_1 = __webpack_require__(1037);
var view_2 = __webpack_require__(195);
var view_3 = __webpack_require__(150);
var cancelledview_1 = __webpack_require__(1066);
var view_4 = __webpack_require__(267);
var view_5 = __webpack_require__(60);
var view_6 = __webpack_require__(68);
var view_7 = __webpack_require__(29);
exports.PortCallScheduleView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "portcall-schedule" },
        React.createElement(MainHeader, { model: model.Header }),
        React.createElement(SecondaryHeader, { model: model }),
        React.createElement(EditStateInstructions, { model: model }),
        React.createElement(view_2.MetroMapFrameworkView, { model: model.Framework, ctrl: {
                milestoneContent: function (m) { return React.createElement(MilestoneContent, { milestone: m }); },
                milestoneHasClassname: function (m, classname) {
                    // Override the default logic for ...has-actual styling so that we base it on the draft
                    // state (e.g. are we logging/clearing actual right now) rather than the committed state.
                    return classname === 'portcall-milestone--has-actual' ? !m.DisplayDateIsEstimated() :
                        undefined;
                }
            } }),
        React.createElement(LoadingIcon, { model: model }));
});
/**
 * A reusable version of the `<PortCallScheduleView />` component's header, for other components that want to
 * reuse that header styling.
 */
exports.PortCallScheduleHeaderView = supercritical_1.default(function (_a) {
    var m = _a.model, className = _a.className, _b = _a.includeItinerary, includeItinerary = _b === void 0 ? true : _b;
    return React.createElement("div", { className: cx("portcall-schedule-standalone-header", className) },
        React.createElement(MainHeader, { model: m }),
        React.createElement("div", { className: "portcall-schedule__header-secondary" },
            React.createElement(SecondaryHeaderAgentInfo, { model: m }),
            includeItinerary && React.createElement(ItineraryDatesOverall, { model: m })));
});
var MainHeader = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", { className: "portcall-schedule__header-main" },
        React.createElement("div", { className: "vessel-name" }, m.PortCall.DisplayVesselIdentifier()),
        React.createElement("div", { className: "vessel-info" },
            React.createElement("span", { className: "vessel-length" }, m.PortCall.VesselLength.toString({ places: 0 })),
            ((_b = m.PortCall.Vessel()) === null || _b === void 0 ? void 0 : _b.VesselType()) &&
                React.createElement("span", null,
                    React.createElement("span", { className: "vessel-length-separator" }, "|"),
                    React.createElement("span", { className: "vessel-type" }, (_c = m.PortCall.Vessel()) === null || _c === void 0 ? void 0 : _c.VesselType()))));
});
var SecondaryHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    // Secondary header disappears to make space for the instructions when we're in an edit state.
    return m.CurrentEditState() ? null :
        React.createElement("div", { className: "portcall-schedule__header-secondary" },
            React.createElement(SecondaryHeaderAgentInfo, { model: m.Header }),
            React.createElement(MovePortCallLink, { model: m }),
            React.createElement(ItineraryDatesOverall, { model: m.Header }));
});
var SecondaryHeaderAgentInfo = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "agent-info" },
        "Agent:",
        m.PortCall.Agent() ? " " + m.PortCall.Agent().AbbreviatedName() + ", " + ((_b = m.PortCall.Agent().Organization()) === null || _b === void 0 ? void 0 : _b.Name()) : '');
});
var MovePortCallLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.CanMovePortCall() ?
        React.createElement("a", { className: "move-portcall-link", href: "", onClick: eventWrappers_1.noDefault(m.MovePortCall) }, "Move PortCall") :
        null;
});
// MomentJS format strings used below
var DAY_MONTH = 'DD MMM', DAY_MONTH_YEAR = DAY_MONTH + " YYYY";
var ItineraryDatesOverall = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var m = _a.model;
    var startDate = m.FirstMilestone() && tzmoment_1.tzmomentMod(m.TZUtils, m.FirstMilestone().Date.Effective(), function (d) { return d.startOf('day'); }), endDate = m.LastMilestone() && tzmoment_1.tzmomentMod(m.TZUtils, m.LastMilestone().Date.Effective(), function (d) { return d.startOf('day'); }), formattedDateRange = startDate && endDate ?
        TZDate_1.default.eq(startDate, endDate) ?
            tzmoment_1.tzmoment(startDate).format(DAY_MONTH_YEAR) :
            tzmoment_1.tzmoment(startDate).format(startDate.getFullYear() === endDate.getFullYear() ? DAY_MONTH : DAY_MONTH_YEAR) + " - " + tzmoment_1.tzmoment(endDate).format(DAY_MONTH_YEAR) : (_b = (startDate !== null && startDate !== void 0 ? startDate : endDate)) === null || _b === void 0 ? void 0 : _b.format(DAY_MONTH_YEAR);
    return (React.createElement("div", { className: "itinerary-dates-overall" },
        React.createElement("span", { className: "itinerary-dates-label" }, "Itinerary:"),
        React.createElement("span", { className: "itinerary-dates-range" }, formattedDateRange),
        React.createElement("span", { className: "itinerary-spacer" },
            ' ',
            "|",
            ' '),
        React.createElement("span", { className: "itinerary-port" }, (_d = (_c = m.PortCall.Port()) === null || _c === void 0 ? void 0 : _c.Name()) !== null && _d !== void 0 ? _d : 'loading...')));
});
var EditStateInstructions = supercritical_1.default(function (_a) {
    var model = _a.model;
    var edit = model.CurrentEditState();
    if (edit === null)
        return null;
    var date = edit.Date, pt = date.ItineraryPoint(), loc = pt === null || pt === void 0 ? void 0 : pt.Location(), next = pt === null || pt === void 0 ? void 0 : pt.NextMovementPoint(), nextLoc = next === null || next === void 0 ? void 0 : next.Location();
    return edit && (edit.Type === model_1.EditType.Move ?
        React.createElement("div", { className: "portcall-schedule__instructions" },
            React.createElement("h4", null, "Move Entire PortCall"),
            React.createElement("p", null, "Enter a new arrival time and all other times will adjust.")) :
        edit.Type === model_1.EditType.EditFirstArrival ?
            React.createElement("div", { className: "portcall-schedule__instructions" },
                React.createElement("h4", null,
                    "Update ",
                    date.Actual() ? 'Actual' : 'Estimated',
                    " Arrival - ", loc === null || loc === void 0 ? void 0 :
                    loc.Name()),
                React.createElement("p", null, "Enter a new time and other times will adjust as indicated."),
                React.createElement("p", null, "Departure times will not change.")) :
            edit.Type === model_1.EditType.EditBerthArrival ||
                edit.Type === model_1.EditType.EditActual && date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ?
                React.createElement("div", { className: "portcall-schedule__instructions" },
                    React.createElement("h4", null,
                        "Update ", loc === null || loc === void 0 ? void 0 :
                        loc.Name(),
                        " Arrival"),
                    React.createElement("p", null, "All other times are anchored.")) :
                edit.Type === model_1.EditType.EditShiftDeparture ||
                    edit.Type === model_1.EditType.EditActual && date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ?
                    React.createElement("div", { className: "portcall-schedule__instructions" },
                        React.createElement("h4", null,
                            "Update ", loc === null || loc === void 0 ? void 0 :
                            loc.Name(),
                            " Departure"),
                        React.createElement("p", null,
                            "Enter a new time and arrival time ",
                            nextLoc && "at " + nextLoc.Name(),
                            "will adjust as indicated to preserve transit.")) :
                    edit.Type === model_1.EditType.EditFinalDeparture ?
                        React.createElement("div", { className: "portcall-schedule__instructions" },
                            React.createElement("h4", null,
                                "Update Final Departure ",
                                loc && "from " + loc.Name()),
                            React.createElement("p", null, "Enter a new time and outbound transit time will adjust as indicated to preserve transit.")) :
                        edit.Type === model_1.EditType.LogActual ?
                            React.createElement("div", { className: "portcall-schedule__instructions" },
                                React.createElement("h4", null,
                                    "Log ",
                                    actualLabel(date),
                                    " at ", loc === null || loc === void 0 ? void 0 :
                                    loc.Name()),
                                React.createElement("p", null,
                                    "Mark ",
                                    actualLabel(date),
                                    " complete at the given time.")) :
                            edit.Type === model_1.EditType.ClearActual ?
                                React.createElement("div", { className: "portcall-schedule__instructions" },
                                    React.createElement("h4", null,
                                        "Undo Log ",
                                        actualLabel(date),
                                        " at ", loc === null || loc === void 0 ? void 0 :
                                        loc.Name()),
                                    React.createElement("p", null, "Time will revert back to Estimated.")) :
                                null);
});
function actualLabel(d) {
    return (d.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FirstArrival ? 'Arrival' :
        d.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.BerthArrival ? 'First Line' :
            'Last Line');
}
var LoadingIcon = supercritical_1.default(function (_a) {
    var model = _a.model;
    return model.Loading() ? React.createElement("div", { className: "loading-icon" }) : null;
});
var MilestoneContent = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", null,
        React.createElement(MilestoneHeaderRow, { milestone: m }),
        React.createElement(MilestoneScheduleDetailsRow, { milestone: m }),
        React.createElement(MilestoneActionConfirmRow, { milestone: m }),
        React.createElement(MilestoneCoordinationsRow, { milestone: m }));
});
var MilestoneHeaderRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row portcall-milestone__header-row" },
        React.createElement(MilestoneHeaderRowLabel, { milestone: m }),
        React.createElement(MilestoneHeaderRowBody, { milestone: m }));
});
var MilestoneHeaderRowLabel = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: cx('portcall-milestone-row-label', {
            'portcall-milestone-header-row-label--date-entry-rejected': m.DateEntryWasRejected()
        }) },
        React.createElement(EditScopeIndicator, { milestone: m, type: "date" }),
        m.DateEntry() && m.DateEntry()() !== null && m.GlobalEditPhase() === model_1.EditPhase.Editing ?
            React.createElement(view_5.DateTimePicker, { value: m.DateEntry(), localization: m.Localization }) :
            React.createElement("span", { className: cx(TextInEditScope(m, 'date'), TextNeedsReview(m, function () { return view_2.MilestoneHeaderDateText(m.DisplayDate()) !== view_2.MilestoneHeaderDateText(m); }), { 'portcall-milestone__clickable': m.CanEdit() }), onClick: m.EditDate }, view_2.MilestoneHeaderDateText(m.DisplayDate())));
});
var MilestoneHeaderRowBody = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-body" },
        React.createElement(EditScopeIndicator, { milestone: m, type: "log-or-clear-actual" }),
        React.createElement("span", { className: cx(TextInEditScope(m, 'log-or-clear-actual'), TextNeedsReview(m, function () { return DateTypeParticiple(m) !== view_2.DateTypeParticiple(m); })) }, DateTypeParticiple(m)),
        ' ',
        React.createElement("span", { className: "portcall-milestone__header-berth-name" }, (_c = (_b = m.Date.ItineraryPoint()) === null || _b === void 0 ? void 0 : _b.Location()) === null || _c === void 0 ? void 0 : _c.Name()),
        m.CanClearActual() &&
            React.createElement("a", { className: "portcall-milestone__undo-log-actual-link", href: "#", onClick: eventWrappers_1.noDefault(m.ClearActual) },
                React.createElement("i", { className: "icon-undo-circle" })),
        m.CanLogActual() && m.Date.MilestoneTypeId() !== MilestoneTypes_1.MilestoneTypes.FirstArrival &&
            React.createElement("a", { className: "portcall-milestone__log-actual-link", href: "#", onClick: eventWrappers_1.noDefault(m.LogActual) }, "Log " + actualLabel(m.Date)));
});
function DateTypeParticiple(m) {
    return (m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ?
        m.DisplayDateIsEstimated() ? 'Arriving' : 'Arrived' :
        m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ?
            m.DisplayDateIsEstimated() ? 'Departing' : 'Departed' :
            '');
}
var MilestoneScheduleDetailsRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row portcall-milestone__schedule-details-row" },
        React.createElement(view_2.MilestoneScheduleDetailsRowLabel, { milestone: m }),
        React.createElement(MilestoneScheduleDetailsRowBody, { milestone: m }));
});
var MilestoneScheduleDetailsRowBody = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return m.Date.IsMovementStartDate() ?
        React.createElement("div", { className: "portcall-milestone-row-body" },
            m.DisplayDateIsEstimated() && React.createElement(EditScopeIndicator, { milestone: m, type: "duration" }),
            React.createElement("span", null,
                view_2.MovementTypeParticiple(m),
                ' ',
                m.DisplayDateIsEstimated() && view_2.MovementToLocationText(m),
                ' ',
                "\u2014"),
            ' ',
            m.DisplayDateIsEstimated() ?
                React.createElement("span", { className: cx(TextInEditScope(m, 'duration'), TextNeedsReview(m, function () { return view_2.MovementTransitDurationText(m.DisplayDate(), m.SegmentEndDate()) !== view_2.MovementTransitDurationText(m); }), 'pc-text-smalllabel') }, view_2.MovementTransitDurationText(m.DisplayDate(), m.SegmentEndDate())) :
                React.createElement("span", { className: "portcall-milestone__log-actual-attribution" }, m.ChangedActual() === null && view_2.LogActualAttributionText(m))) :
        React.createElement("div", { className: "portcall-milestone-row-body" },
            React.createElement("span", { className: "portcall-milestone__log-actual-attribution" }, m.ChangedActual() === null && view_2.LogActualAttributionText(m)));
});
var MilestoneActionConfirmRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    var edit = m.DateHasEditFocus();
    return edit && (React.createElement("div", { className: "portcall-milestone-row portcall-milestone__action-confirm-row" }, edit.Phase() === model_1.EditPhase.Editing ? [
        React.createElement("div", { className: "portcall-milestone-row-label update-button-shell", key: "label" },
            React.createElement("button", { className: "pc-button", onClick: m.ReviewChanges }, "Update")),
        React.createElement("div", { className: "portcall-milestone-row-body", key: "body" },
            React.createElement("button", { className: "pc-button", onClick: edit.Cancel },
                React.createElement("i", { className: "icon-undo-circle" }),
                " keep ",
                view_2.MilestoneHeaderDateText(m)))
    ] :
        edit.Phase() === model_1.EditPhase.Reviewing || edit.Phase() === model_1.EditPhase.Committing ? [
            React.createElement("div", { className: "portcall-milestone-row-label", key: "label" }),
            React.createElement("div", { className: "portcall-milestone-row-body", key: "body" },
                React.createElement("div", { className: "pc-confirm" },
                    edit.Type === model_1.EditType.ClearActual ?
                        React.createElement("span", { className: "pc-confirm-question" },
                            React.createElement("b", null,
                                "Undo Log ",
                                actualLabel(edit.Date),
                                "?"),
                            " Will revert back to Estimated.") :
                        React.createElement("span", { className: "pc-confirm-question" },
                            React.createElement("b", null, "Are you sure?"),
                            " All changes are highlighted."),
                    React.createElement("button", { disabled: edit.Phase() === model_1.EditPhase.Committing, className: "pc-confirm-button pc-confirm-button-primary", onClick: edit.Commit }, "Yup"),
                    React.createElement("button", { disabled: edit.Phase() === model_1.EditPhase.Committing, className: "pc-confirm-button", onClick: edit.Cancel },
                        "Nope",
                        edit.Type !== model_1.EditType.ClearActual ? '.  Undo all.' : '')))
        ] :
            edit.Phase() === model_1.EditPhase.CommitErrors ? [
                React.createElement("div", { className: "portcall-milestone-row-label", key: "label" },
                    React.createElement("button", { className: "pc-button", onClick: edit.Cancel },
                        React.createElement("i", { className: "icon-undo-circle" }),
                        " revert")),
                React.createElement("div", { className: "portcall-milestone-row-body", key: "body" }, view_7.ListErrors(edit.CommitErrors()))
            ] :
                null));
});
var MilestoneCoordinationsRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    var numObsolete = m.ObsoleteCoordinationCards().length;
    return (React.createElement("div", { className: "portcall-milestone-row portcall-milestone__coordinations-row" },
        React.createElement(MilestoneCoordinationsRowLabel, { milestone: m }),
        React.createElement("div", { className: "portcall-milestone-row-body" },
            React.createElement(BerthAssignmentView, { milestone: m }),
            m.VisibleCoordinationCards().map(function (ccard) {
                return ccard.Currency === model_1.CCardCurrency.Current ?
                    React.createElement(CurrentCCardView, { ccard: ccard, key: ccard.Model.Id() }) :
                    React.createElement(CancelledCCardView, { ccard: ccard, key: ccard.Model.Id() });
            }),
            numObsolete > 0 && (React.createElement("div", { className: "obsolete-cards-toggle-shell" },
                React.createElement("a", { className: "obsolete-cards-toggle", href: "", onClick: eventWrappers_1.noDefault(function () { return m.ShowObsoleteCoordinations(!m.ShowObsoleteCoordinations()); }) }, m.ShowObsoleteCoordinations() ?
                    "Hide " + numObsolete + " obsolete " + (numObsolete === 1 ? 'card' : 'cards') :
                    "Show " + numObsolete + " more obsolete " + (numObsolete === 1 ? 'card' : 'cards')))))));
});
var MilestoneCoordinationsRowLabel = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-label" }, m.Date.IsBerthArrivalDate() &&
        React.createElement("span", null,
            React.createElement(EditScopeIndicator, { milestone: m, type: "duration" }),
            React.createElement("span", { className: cx(TextInEditScope(m, 'duration'), TextNeedsReview(m, function () { return view_2.BerthStayDurationText(m.DisplayDate(), m.SegmentEndDate()) !== view_2.BerthStayDurationText(m); })) }, view_2.BerthStayDurationText(m.DisplayDate(), m.SegmentEndDate()))));
});
var BerthAssignmentView = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return m.BerthAssignment() &&
        // We borrow C-Card styling for berth assignments
        React.createElement("div", { className: "portcall-milestone__coordination-card" },
            React.createElement(BerthAssignmentHeader, { assignment: m.BerthAssignment() }),
            React.createElement(InPortOpsSummary, { assignment: m.BerthAssignment() }),
            m.BerthAssignment().Details() && React.createElement(view_1.BerthAssignmentDetailsView, { model: m.BerthAssignment().Details() }));
});
var BerthAssignmentHeader = supercritical_1.default(function (_a) {
    var a = _a.assignment;
    return React.createElement("div", { className: "coordination-card-header" },
        React.createElement("span", { className: "coordination-card-hitbox", onClick: a.ToggleDetails },
            a.BerthReservation.Status() === BerthReservation_1.BerthReservationStatus.Cancelled ?
                // TODO: This would be simpler if we just add support for cancelled C-Cards to our <CCardStatusIndicator />.
                React.createElement("span", { className: "cancelled-coordination-indicator pc-breaker-light pc-breaker-active" }) :
                React.createElement(view_3.CCardStatusIndicator, { statusId: equivBerthAssignmentCCardStatus(a.BerthReservation.Status()) }),
            React.createElement("span", { className: "coordination-card-summary" },
                React.createElement("span", { className: "coordination-title" }, "Berth Assignment"),
                ' ',
                React.createElement("span", { className: "coordination-status-text" },
                    "(",
                    berthAssignmentStatusText(a.BerthReservation.Status()),
                    ")"))),
        ' ',
        React.createElement(view_6.IssueCountPillBadgeWithTooltip, { className: "coordination-issue-count", issues: a.Issues }),
        React.createElement("span", { className: "coordination-card-header-right-side" },
            React.createElement(BookUnbookLink, { assignment: a })));
});
function equivBerthAssignmentCCardStatus(status) {
    if (status === BerthReservation_1.BerthReservationStatus.Booked)
        return CoordinationCardStatuses_1.CoordinationCardStatuses.Accepted;
    // TODO: For now, just returning a dummy value for cancelled reservations. Once we add support
    // for cancelled C-Cards to our <CCardStatusIndicator />, we can wire up to that here.
    else if (status === BerthReservation_1.BerthReservationStatus.Cancelled)
        return -Infinity;
    else if (status === BerthReservation_1.BerthReservationStatus.Conflicted)
        return CoordinationCardStatuses_1.CoordinationCardStatuses.Denied;
    else if (status === BerthReservation_1.BerthReservationStatus.Requested)
        return CoordinationCardStatuses_1.CoordinationCardStatuses.Acknowledged;
    else
        throw new Error("Unknown berth reservation status " + status);
}
function berthAssignmentStatusText(status) {
    var _a, _b;
    // TODO: Support alt labels for berth reservation status, probably configured at the domain level.
    return (_b = (_a = BerthReservation_1.BerthReservationStatusDisplayName[status]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '--';
}
var BookUnbookLink = supercritical_1.default(function (_a) {
    var a = _a.assignment;
    return a.CanBook() ?
        React.createElement("a", { className: "book-unbook-link", href: "", onClick: eventWrappers_1.noDefault(a.Book) }, "Book") :
        a.CanUnbook() ?
            React.createElement("a", { className: "book-unbook-link", href: "", onClick: eventWrappers_1.noDefault(a.Unbook) }, "Unbook") :
            null;
});
var InPortOpsSummary = supercritical_1.default(function (_a) {
    var a = _a.assignment;
    return React.createElement("div", { className: "in-port-ops-summary pc-text-tinylabel" }, InPortOpsSummaryText(a.BerthReservation));
});
var EM_DASH = "\u2014";
function InPortOpsSummaryText(br) {
    if (br.HasLayOpsOnly()) {
        return "Lay Only";
    }
    else {
        var cargoText = null, cruiseText = null;
        if (br.CargoActivities().length > 0) {
            var acts = br.CargoActivities().slice();
            acts.sort(function (a1, a2) { return a1.Id() - a2.Id(); });
            var knownCargoText = acts
                .filter(function (a) { return a.CargoCategory() !== null; })
                .map(function (a) {
                return a.CargoCategory().Name()
                    + (a.ActivityType() === null ? "" : " (" + a.ActivityType().Name() + ")")
                    + ": "
                    + a.Quantity.toString();
            })
                .join(" " + EM_DASH + " ");
            cargoText = knownCargoText || "Unknown cargo";
        }
        if (br.CruiseActivities().length > 0) {
            var acts = br.CruiseActivities().slice();
            acts.sort(function (a1, a2) { return a1.Id() - a2.Id(); });
            var knownCruiseText = acts
                .filter(function (a) {
                var _a, _b, _c;
                return ((_a = a.Disembark()) !== null && _a !== void 0 ? _a : 0) !== 0
                    || ((_b = a.Embark()) !== null && _b !== void 0 ? _b : 0) !== 0
                    || ((_c = a.InTransit()) !== null && _c !== void 0 ? _c : 0) !== 0;
            })
                .map(function (a) {
                var _a, _b, _c;
                return [
                    ((_a = a.Disembark()) !== null && _a !== void 0 ? _a : 0) !== 0 ? "Disembark: " + a.Disembark() : null,
                    ((_b = a.Embark()) !== null && _b !== void 0 ? _b : 0) !== 0 ? "Embark: " + a.Embark() : null,
                    ((_c = a.InTransit()) !== null && _c !== void 0 ? _c : 0) !== 0 ? "In Transit: " + a.InTransit() : null
                ].filter(notNullish_1.notNullish).join(" " + EM_DASH + " ");
            })
                .join(" " + EM_DASH + " ");
            cruiseText = knownCruiseText || "Unknown cruise";
        }
        return [cargoText, cruiseText].filter(notNullish_1.notNullish).join(" " + EM_DASH + " ") || "No ops listed";
    }
}
exports.InPortOpsSummaryText = InPortOpsSummaryText;
var CurrentCCardView = supercritical_1.default(function (_a) {
    var ccard = _a.ccard;
    return React.createElement("div", { className: "portcall-milestone__coordination-card" },
        React.createElement(CurrentCCardHeader, { ccard: ccard }),
        ccard.Details() && React.createElement(view_4.CoordinationCardDetailsView, { model: ccard.Details() }));
});
var CurrentCCardHeader = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e;
    var ccard = _a.ccard;
    return React.createElement("div", { className: "coordination-card-header" },
        React.createElement("span", { className: "coordination-card-hitbox", onClick: ccard.ToggleDetails },
            React.createElement(view_3.CCardStatusIndicator, { statusId: ccard.Model.StatusId() }),
            React.createElement("span", { className: "coordination-card-summary" },
                React.createElement("span", { className: "coordination-title" }, (_b = ccard.Model.Coordination()) === null || _b === void 0 ? void 0 : _b.Title()),
                React.createElement("span", { className: "coordination-title-separator" }, "|"),
                React.createElement("span", { className: "coordination-provider" }, (_d = (_c = ccard.Model.Provider()) === null || _c === void 0 ? void 0 : _c.Provider()) === null || _d === void 0 ? void 0 : _d.Name()),
                ' ',
                React.createElement("span", { className: "coordination-status-text" },
                    "(", (_e = ccard.Model.EffectiveStatusLabel()) !== null && _e !== void 0 ? _e : 'loading...',
                    ")"))));
});
var CancelledCCardView = supercritical_1.default(function (_a) {
    var ccard = _a.ccard;
    return React.createElement("div", { className: "portcall-milestone__coordination-card portcall-milestone__coordination-card-cancelled" },
        React.createElement(CancelledCCardHeader, { ccard: ccard }),
        ccard.Details() && React.createElement(cancelledview_1.CancelledCoordinationCardDetailsView, { model: ccard.Details() }));
});
var CancelledCCardHeader = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var ccard = _a.ccard;
    return React.createElement("div", { className: "coordination-card-header" },
        React.createElement("span", { className: "coordination-card-hitbox", onClick: ccard.ToggleDetails },
            React.createElement("span", { className: "cancelled-coordination-indicator pc-breaker-light pc-breaker-active" }),
            React.createElement("span", { className: "coordination-card-summary" },
                React.createElement("span", { className: "coordination-title" }, (_b = ccard.Model.Coordination()) === null || _b === void 0 ? void 0 : _b.Title()),
                React.createElement("span", { className: "coordination-title-separator" }, "|"),
                React.createElement("span", { className: "coordination-provider" }, (_d = (_c = ccard.Model.Provider()) === null || _c === void 0 ? void 0 : _c.Provider()) === null || _d === void 0 ? void 0 : _d.Name()),
                ' ',
                "cancelled")));
});
var EditScopeIndicator = supercritical_1.default(function (_a) {
    var m = _a.milestone, type = _a.type;
    return ShowEditScopeIndicator(m, type) ?
        React.createElement("i", { className: cx('portcall-milestone__edit-scope-indicator', {
                'portcall-milestone__edit-scope-indicator-emphasized': EmphasizeEditScopeIndicator(m, type)
            }) },
            React.createElement("span", { className: "fa fa-caret-left" }),
            React.createElement("span", { className: "fa fa-caret-right" })) :
        null;
});
function ShowEditScopeIndicator(m, type) {
    var _a, _b;
    return m.GlobalEditPhase() === model_1.EditPhase.Editing && (type === 'date' && m.DateIsInEditScope()
        || type === 'duration' && m.DurationIsInEditScope()
        || type === 'log-or-clear-actual' && (((_a = m.DateHasEditFocus()) === null || _a === void 0 ? void 0 : _a.Type) === model_1.EditType.LogActual || ((_b = m.DateHasEditFocus()) === null || _b === void 0 ? void 0 : _b.Type) === model_1.EditType.ClearActual));
}
function EmphasizeEditScopeIndicator(m, type) {
    return (type === 'date' && m.DateHasEditFocus() !== null);
}
function TextInEditScope(m, type) {
    return { 'portcall-milestone__text-in-edit-scope': ShowEditScopeIndicator(m, type) };
}
function TextNeedsReview(m, hasPendingChange) {
    var phase = m.GlobalEditPhase();
    return {
        'portcall-milestone__text-needs-review': (phase === model_1.EditPhase.Reviewing
            || phase === model_1.EditPhase.Committing
            || phase === model_1.EditPhase.CommitErrors) && hasPendingChange()
    };
}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var idGen = 0;
var ToggleButton = /** @class */ (function (_super) {
    __extends(ToggleButton, _super);
    function ToggleButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputId = '__toggle_button_' + idGen++;
        return _this;
    }
    ToggleButton.prototype.srender = function (_a) {
        var checked = _a.checked, onLabel = _a.onLabel, offLabel = _a.offLabel, className = _a.className, selectedLabelClassName = _a.selectedLabelClassName, disabled = _a.disabled;
        return (React.createElement("span", { className: cx('togglebuttoncomponent', className) },
            React.createElement("span", { className: cx('pc-text-smalllabel', checked() ? selectedLabelClassName : undefined) }, onLabel),
            ' ',
            React.createElement("input", { className: "toggle-input", type: "checkbox", id: this.inputId, checked: checked(), onChange: function (e) { return checked(e.currentTarget.checked); }, disabled: disabled }),
            React.createElement("label", { className: "toggle-label", htmlFor: this.inputId }),
            ' ',
            React.createElement("span", { className: cx('pc-text-smalllabel', !checked() ? selectedLabelClassName : undefined) }, offLabel)));
    };
    return ToggleButton;
}(supercritical_1.SuperCriticalComponent));
exports.ToggleButton = ToggleButton;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Typeahead = void 0;
__webpack_require__(631);
var Typeahead = /** @class */ (function () {
    function Typeahead(options) {
        this.requestQueue = null;
        this.searchUrl = options.searchUrl || null;
        this.typeaheadOptions = options.typeaheadOptions;
        this.displayKey = options.displayKey;
        this.templates = options.templates;
        this.data = options.observable;
        this.collection = options.collection || null;
        this.matchFn = options.matchFn || null;
        this.onSearchResults = options.onSearchResults || null;
        this.serverSideSearch = options.serverSideSearch || null;
        this.onSelect = options.onSelect || null;
        // if searchUrl option is present, do server-side search instead of client-side
        if (this.searchUrl && !!this.serverSideSearch) {
            var apiConventions = this.serverSideSearch.ApiConventions(this.searchUrl);
            this.requestQueue = this.serverSideSearch.RequestQueue(apiConventions);
        }
    }
    return Typeahead;
}());
exports.Typeahead = Typeahead;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeaheadInput = void 0;
var React = __webpack_require__(2);
var $ = __webpack_require__(27);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var TypeaheadInput = /** @class */ (function (_super) {
    __extends(TypeaheadInput, _super);
    function TypeaheadInput(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = supercritical_1.SuperCriticalReference(_this, function (props, el) {
            initTypeahead(props, el);
            // If calling code supplies an inputRef, call it. But run in its own computation
            // so that whatever calling code does is decoupled from re-initing the typeahead.
            s_js_1.default(function () { var _a; return (_a = props.inputRef) === null || _a === void 0 ? void 0 : _a.call(props, el); });
        });
        return _this;
    }
    TypeaheadInput.prototype.srender = function (_a) {
        var model = _a.model, className = _a.className, disabled = _a.disabled, tabIndex = _a.tabIndex, placeholder = _a.placeholder, specificInput = _a.specificInput;
        return (
        // FIXME: This is inherently bug-prone b/c we're initializing our Twitter Typeahead on the top-level
        // element we return from our render method, but Twitter Typeahead then wraps our <input> in extra
        // DOM layers that don't correspond to any node in React's virtual DOM. This is precisely the same
        // bug that we had in our kendo date/time pickers. See comment in ../datetimepicker/view.tsx. As in
        // that case, our behavior is fine for most cases but can lead to a thrown error like
        //
        //   NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child
        //   of this node
        //
        // if we transition our view state in such a way that React tries to unmount the <TypeaheadInput />
        // component from its parent node, as React issues a removeChild call for a "child" node that's no
        // longer a true child of the parent node (it's a nested descendant instead).
        //
        // The REAL fix, as with our date/time pickers, is to add a wrapper element here, so that our
        // returned DOM looks something like <span><input /></span> instead of JUST our typeahead <input />.
        // And if we go that far, we could even move our className from the <input /> to the wrapper <span />,
        // which might make it easier to target typeahead inputs via LESS. But not doing any of that for now
        // b/c of the regression risk of changing up DOM that's used in several places.
        React.createElement("input", { id: specificInput, className: className, placeholder: placeholder, disabled: disabled, tabIndex: tabIndex, value: model.data(), onChange: function (e) { return model.data(e.currentTarget.value); }, ref: this.inputRef }));
    };
    return TypeaheadInput;
}(supercritical_1.SuperCriticalComponent));
exports.TypeaheadInput = TypeaheadInput;
function initTypeahead(_a, el) {
    var model = _a.model;
    var $el = $(el);
    $el.typeahead(model.typeaheadOptions, {
        source: model.requestQueue ? serverSideSource : clientSideSource,
        displayKey: model.displayKey,
        templates: model.templates
    })
        .on('typeahead:opened', loadDefault)
        .on('typeahead:selected', update);
    // DC 07/14/21 -- Auto-focuses the vessel input field only on Add PortCall
    $("#addPortCall").focus();
    s_js_1.default.cleanup(function () {
        $el.off('typeahead:opened', loadDefault);
        $el.off('typeahead:selected', update);
        $el.typeahead('destroy');
    });
    s_js_1.default(function () {
        // Notify the typeahead lib of any value changes that might be applied by external code. Otherwise the
        // typeahead can be left in an inconsistent state where one value is shown in the input element, but the
        // dropdown menu acts as if a different value is selected.
        if (model.data() !== $el.typeahead('val')) {
            $el.typeahead('val', model.data());
        }
    });
    function update(evt, item) {
        model.data(model.displayKey(item));
        if (model.onSelect)
            model.onSelect(item);
    }
    function loadDefault() {
        // If the dropdown is empty when the typeahead is opened, simulate the user pressing the down arrow to
        // trigger the typeahead to load search results for the empty string, if any.
        // CAUTION: This is digging into typeahead internals (the .data('ttTypeahead') bit) to detect whether
        // the dropdown is empty or not. I haven't found another way to detect this yet. MAKE SURE TO RE_TEST if
        // we ever upgrade our copy of the typeahead lib. The check to ensure the dropdown is empty is needed to
        // prevent the following undesirable UX:
        // 1. The user selects an item from the typeahead dropdown.
        // 2. That triggers some upstream code to clear the typeahead's value by setting model.data() to the
        //    empty string. E.g. the recipient selector for new PC log comments does this. We pick that up
        //    above and effectively call $el.typeahead('val', '');
        // 3. The typehead input remains focused through steps 1 and 2. The user starts typing a new search
        //    query into the typeahead input WITHOUT BLURRING THE INPUT FIRST. E.g. the user starts typing the
        //    name of the next intended recipient for a PC log comment.
        // 4. The user's first keystroke causes the typeahead to fire its 'typeahead:opened' event, for which
        //    this loadDefault function is a handler. If we were to fire a synthetic down arrow press at this
        //    point, the typeahead would think the user was trying to highlight the next item from the
        //    still-populated dropdownt list, causing the typeahead to overwrite the input's value with the text
        //    of that next item. That's annoying b/c it clobbers the user's first keystroke and means the user
        //    has to clear the input and start typing AGAIN before the typeahead will honor their typing.
        // It turns out that how the typeahead lib interprets down arrow presses depends on the state of the
        // dropdown list at the time -- If the dropdown list's isEmpty flag is set, then the typeahead lib
        // interprets a down arrow press as "update the dropdown list w/o trying to update the input's value,"
        // which is exactly the behavior we want here. If the dropdown list's isEmpty flag is NOT set and the
        // entered search query matches the typeahead's minLength option (for which we often pass 0), then the
        // typeahead treats a down arrow press as "highlight the next dropdown list item and update the input's
        // value," which is the behavior we wanna avoid.
        if ($el.data('ttTypeahead').dropdown.isEmpty) {
            var ev = $.Event("keydown");
            // keyCode 40 == down arrow
            ev.keyCode = ev.which = 40;
            $el.trigger(ev);
            // after typeahead opens, select all text in input
            setTimeout(function () { return $el.select(); }, 60);
            return true;
        }
    }
    function clientSideSource(query, cb) {
        var col = model.collection(), matches = col.filter(function (item) { return !query || model.matchFn(item, query); });
        cb(matches);
    }
    function serverSideSource(query, cb) {
        // TODO: Cache results?
        model.requestQueue.add(query, function (data) {
            cb(data);
            model.onSearchResults && model.onSearchResults(data);
        });
    }
}


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Utilities related to our point-in-time entity snapshots. The idea is that these snapshots adhere to the
// same interface as the corresponding live entity, just with a different keying strategy that includes
// ChangeId in the key.
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePITDataKey = exports.makePITKey = exports.CHANGE_ID_KEY = void 0;
exports.CHANGE_ID_KEY = "ChangeId";
function makePITKey(upstreamKey) {
    return function (obj) { return upstreamKey(obj) + '\u2618' + obj[exports.CHANGE_ID_KEY](); };
}
exports.makePITKey = makePITKey;
function makePITDataKey(upstreamKey) {
    return function (obj) { return upstreamKey(obj) + '\u2618' + obj[exports.CHANGE_ID_KEY]; };
}
exports.makePITDataKey = makePITDataKey;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectiveDate = exports.ScheduleDate = void 0;
var s_js_1 = __webpack_require__(0);
var ScheduleDate_1 = __webpack_require__(1571);
var ScheduleDate = /** @class */ (function (_super) {
    __extends(ScheduleDate, _super);
    function ScheduleDate(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || {}) || this;
        _this.Effective = EffectiveDate(_this);
        return _this;
    }
    return ScheduleDate;
}(ScheduleDate_1.ScheduleDate));
exports.ScheduleDate = ScheduleDate;
// create a computed Effective data signal with a function that proxies to the ScheduleDate'S Estimated and Actual times
function EffectiveDate(sched) {
    return function (v) {
        return arguments.length === 0 ? sched.Actual() || sched.Estimated() :
            s_js_1.default.sample(sched.Actual) ? sched.Actual(v) : // '!' is safe, as call signatures of DataSignal insure that if we have an argument, it's a TZDate
                sched.Estimated(v);
    };
}
exports.EffectiveDate = EffectiveDate;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.notNullish = void 0;
/**
 * A really simple utility function that returns true if the provided item is not null or undefined. Mainly
 * useful to get better typescript type inference for some Array.prototype.filter calls.
 * @param item The item to test for nullish-ness.
 */
function notNullish(item) {
    return item !== null && item !== undefined;
}
exports.notNullish = notNullish;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(56);
var TAG = __webpack_require__(24)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(324);
var hiddenKeys = __webpack_require__(215).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(50);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var dP = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(30);
var SPECIES = __webpack_require__(24)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(64);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadLink = exports.DownloadDataLink = void 0;
var React = __webpack_require__(2);
var downloadData_1 = __webpack_require__(260);
function DownloadDataLink(_a) {
    var data = _a.data, filename = _a.filename, className = _a.className, _onClick = _a.onClick, hidden = _a.hidden, children = _a.children;
    var onClick = function (e) {
        e.preventDefault();
        downloadData_1.downloadData(data(), filename);
        _onClick && _onClick(e);
    };
    return (React.createElement("a", { href: "", className: className, hidden: hidden, onClick: onClick }, children));
}
exports.DownloadDataLink = DownloadDataLink;
var DATA = /^data:/i;
// TH 05/16/2017 -- A link for downloading a file, via an http/https URI or data URI.
// Provides IE 10+ and Edge support for downloading files, including via data URIs.
// NOTE: This is a purely functional React component. Calling code can call it like a normal
// React component:
//
//   <DownloadLink href={...}></DownloadLink>
function DownloadLink(_a) {
    var href = _a.href, download = _a.download, className = _a.className, _onClick = _a.onClick, hidden = _a.hidden, children = _a.children;
    var onClick = function (e) {
        _onClick && _onClick(e);
    };
    return (React.createElement("a", { href: href, className: className, download: download || 'attachment', 
        // TH 05/16/2017 -- target="_blank" is for the benefit of browsers that ignore the
        // download attribute, like IE and Edge.
        target: "_blank", hidden: hidden, onClick: onClick }, children));
}
exports.DownloadLink = DownloadLink;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandCollapseLink = exports.RowSelectorView = exports.GridDivRowCells = exports.GridDivHeaderCells = exports.GridTableRowCells = exports.GridTableHeaderCells = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
/*
 * GridTableHeaderCells and GridTableRowCells --
 * Functions for producing the core header and row cells in a sortable grid.
 */
function GridTableHeaderCells(columns, m, additionalClassName) {
    return columns.map(function (col) {
        return React.createElement("th", { className: cx('gridheadercell', col.ClassName, additionalClassName), onClick: function () { return m.OnSortClick(col); }, key: col.Title },
            col.Title,
            React.createElement("i", { className: cx('gridheadercell-icon glyphicon', {
                    'glyphicon-chevron-down': m.SortColumn() === col && !m.SortReversed(),
                    'glyphicon-chevron-up': m.SortColumn() === col && m.SortReversed()
                }) }));
    });
}
exports.GridTableHeaderCells = GridTableHeaderCells;
function GridTableRowCells(columns, row, additionalClassName) {
    return columns.map(function (_a) {
        var Title = _a.Title, ClassName = _a.ClassName, DisplayValue = _a.DisplayValue;
        return React.createElement("td", { className: cx(ClassName, additionalClassName), key: Title }, DisplayValue(row));
    });
}
exports.GridTableRowCells = GridTableRowCells;
/* End GridTableHeaderCells and GridTableRowCells */
/*
 * GridDivHeaderCells and GridDivRowCells --
 * Identical to GridTableHeaderCells and GridTableRowCells except they return <div>'s instead
 * <tr>'s and <td>'s.
 * For use in grids that aren't HTML tables (e.g. our grids w/ expandable nested tables work this way).
 */
function GridDivHeaderCells(columns, m, additionalClassName) {
    return columns.map(function (col) {
        return React.createElement("div", { className: cx('gridheadercell', col.ClassName, additionalClassName), onClick: function () { return m.OnSortClick(col); }, key: col.Title },
            col.Title,
            React.createElement("i", { className: cx('gridheadercell-icon glyphicon', {
                    'glyphicon-chevron-down': m.SortColumn() === col && !m.SortReversed(),
                    'glyphicon-chevron-up': m.SortColumn() === col && m.SortReversed()
                }) }));
    });
}
exports.GridDivHeaderCells = GridDivHeaderCells;
function GridDivRowCells(columns, row, additionalClassName) {
    return columns.map(function (_a) {
        var Title = _a.Title, ClassName = _a.ClassName, DisplayValue = _a.DisplayValue;
        return React.createElement("div", { className: cx(ClassName, additionalClassName), key: Title }, DisplayValue(row));
    });
}
exports.GridDivRowCells = GridDivRowCells;
/* End GridDivHeaderCells and GridDivRowCells */
/* RowSelectorView -- A none/some/all selector for a list of rows */
exports.RowSelectorView = supercritical_1.default(function (_a) {
    var m = _a.model, className = _a.className;
    return React.createElement("span", { className: cx('rowselectorview', className) },
        "All",
        ' ',
        React.createElement("input", { type: "checkbox", className: "rowselectorview-checkbox", checked: m.RowSelectionStatus() === 2 /* All */, onChange: function (e) { return m.RowSelectionStatus(e.currentTarget.checked ? 2 /* All */ : 0 /* None */); } }));
});
/* End RowSelectorView */
/* ExpandCollapseLink -- A Collapse All/Expand All link for grids w/ expandable rows */
exports.ExpandCollapseLink = supercritical_1.default(function (_a) {
    var m = _a.model, _actionWrapper = _a.actionWrapper;
    var actionWrapper = _actionWrapper || (function (action) { return action; });
    return (React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(actionWrapper(function () { return m.ExpansionMode(m.AllCurrentlyExpanded() ? 0 /* AutoCollapse */ : 1 /* AutoExpand */); })) }, m.AllCurrentlyExpanded() ? 'Collapse All' : 'Expand All'));
});
/* End ExpandCollapseLink */ 


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Berth = void 0;
var s_array_1 = __webpack_require__(3);
var Berth_1 = __webpack_require__(1418);
var Berth = /** @class */ (function (_super) {
    __extends(Berth, _super);
    function Berth(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.UnlistedReservations = s_array_1.default([]);
        return _this;
    }
    Berth.prototype.Reservations = function () {
        var loc = this.Location(), pts = loc && loc.Itinerary() || [], reses = [];
        for (var _i = 0, pts_1 = pts; _i < pts_1.length; _i++) {
            var pt = pts_1[_i];
            var res = pt.BerthReservation();
            if (res)
                reses.push(res);
        }
        return reses;
    };
    Berth.StartMarkOrder = function (b1, b2) {
        var b2StartMark = b2.StartMark.convert(b1.StartMark.UOM());
        var b2Length;
        return b1.StartMark.Num() < b2StartMark.Num() ? -1 :
            b1.StartMark.Num() > b2StartMark.Num() ? 1 :
                b1.Length.Num() < (b2Length = b2.Length.convert(b1.Length.UOM())).Num() ? -1 :
                    b1.Length.Num() > b2Length.Num() ? 1 :
                        b1.Id() < b2.Id() ? -1 :
                            b1.Id() > b2.Id() ? 1 :
                                0;
    };
    return Berth;
}(Berth_1.Berth));
exports.Berth = Berth;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalPriceForCharges = exports.TotalPriceForCharge = exports.NumberOfUnits = void 0;
var s_js_1 = __webpack_require__(0);
var Price_1 = __webpack_require__(162);
// TH 05/01/2017 -- Common model-layer functionality for working w/ charges and groups of charges.
function NumberOfUnits(_a) {
    var Quantity = _a.Quantity, Unit = _a.Unit;
    var quantity = Quantity.convert(Unit.UOM());
    return quantity.Num() / Unit.Num();
}
exports.NumberOfUnits = NumberOfUnits;
function TotalPriceForCharge(_a) {
    var Quantity = _a.Quantity, Unit = _a.Unit, UnitPrice = _a.UnitPrice;
    return new Price_1.ImmutablePrice({
        Num: function () { return NumberOfUnits({ Quantity: Quantity, Unit: Unit }) * UnitPrice.Num(); },
        Cur: UnitPrice.Cur
    });
}
exports.TotalPriceForCharge = TotalPriceForCharge;
// defaultCurrency -- Currency to use when list of charges is empty.
// places -- Rounding to apply. Note that rounding is applied to individual charges before summing to total.
//           This is for applications where it's important to make sure that a bill/invoice balances.
function TotalPriceForCharges(charges, defaultCurrency, places) {
    var subtotals = places === undefined ? charges.map(function (c) { return c.Total; }) : charges.map(function (c) { return c.Total.roundToNPlaces(places); }), total = s_js_1.default(function () {
        var subs = subtotals(), t = subs.length === 0 ? new Price_1.ImmutablePrice({
            Num: function () { return 0; },
            Cur: defaultCurrency
        }) : subs[0];
        for (var i = 1; i < subs.length; i++) {
            // TH 05/01/2017 -- NOTE: This will throw if the currencies don't all match.
            // That's intentional.
            t = t.add(subs[i]);
        }
        return t;
    });
    return new Price_1.ImmutablePrice({
        Num: function () { return total().Num(); },
        Cur: function () { return total().Cur(); }
    });
}
exports.TotalPriceForCharges = TotalPriceForCharges;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCard = void 0;
var Coordination_1 = __webpack_require__(200);
var CoordinationCard_1 = __webpack_require__(616);
var CoordinationCardStatuses_1 = __webpack_require__(110);
var CoordinationProvider_1 = __webpack_require__(201);
__exportStar(__webpack_require__(616), exports);
var CoordinationCard = /** @class */ (function (_super) {
    __extends(CoordinationCard, _super);
    function CoordinationCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for two C-Cards (or C-Card-like objects) belonging to the same milestone date. */
    CoordinationCard.DisplayOrder = function (ccard1, ccard2) {
        var coord1, coord2, provider1, provider2;
        return ((coord1 = ccard1.Coordination()) ?
            (coord2 = ccard2.Coordination()) ?
                coord1 === coord2 ?
                    // If C-Cards have the same Coordination, sort by Provider.
                    (provider1 = ccard1.Provider()) ?
                        (provider2 = ccard2.Provider()) ?
                            provider1 === provider2 ?
                                // If C-Cards also have the same Provider, fallback to sorting by C-Card
                                // Id for a deterministic sort.
                                ccard1.Id() - ccard2.Id() :
                                // If providers are distinct, sort by CoordinationProvider.DisplayOrder...
                                CoordinationProvider_1.CoordinationProvider.DisplayOrder(provider1, provider2) :
                            -1 /* Sort C-Cards w/ missing Provider last among C-Cards for that Coordination */ :
                        ccard2.Provider() ?
                            1 /* Sort C-Cards w/ missing Provider last among C-Cards for that Coordination */ :
                            0 :
                    // If coordinations are distinct, sort by Coordination.DisplayOrder...
                    Coordination_1.Coordination.DisplayOrder(coord1, coord2) :
                -1 /* Sort C-Cards w/ missing Coordination last among C-Cards for this milestone date */ :
            ccard2.Coordination() ?
                1 /* Sort C-Cards w/ missing Coordination last among C-Cards for this milestone date */ :
                0);
    };
    CoordinationCard.prototype.EffectiveStatusLabel = function (bypassAltPendingLabel) {
        return CoordinationCard.EffectiveStatusLabelImpl(this, bypassAltPendingLabel);
    };
    CoordinationCard.EffectiveStatusLabelImpl = function (ccard, bypassAltPendingLabel) {
        var _a, _b, _c, _d, _e, _f, _g;
        return bypassAltPendingLabel && ccard.StatusId() === CoordinationCardStatuses_1.CoordinationCardStatuses.Pending ? (_b = (_a = ccard.Status()) === null || _a === void 0 ? void 0 : _a.DefaultLabel()) !== null && _b !== void 0 ? _b : null : (_g = (_e = (_d = (_c = ccard.Coordination()) === null || _c === void 0 ? void 0 : _c.AltStatusLabels().find(function (l) { return l.StatusId() === ccard.StatusId(); })) === null || _d === void 0 ? void 0 : _d.Label()) !== null && _e !== void 0 ? _e : (_f = ccard.Status()) === null || _f === void 0 ? void 0 : _f.DefaultLabel()) !== null && _g !== void 0 ? _g : null;
    };
    return CoordinationCard;
}(CoordinationCard_1.CoordinationCard));
exports.CoordinationCard = CoordinationCard;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardStatuses = void 0;
// Values hand-synched with PortCall.Models.CoordinationCards.CoordinationCardStatuses class.
var CoordinationCardStatuses;
(function (CoordinationCardStatuses) {
    CoordinationCardStatuses[CoordinationCardStatuses["Accepted"] = 0] = "Accepted";
    CoordinationCardStatuses[CoordinationCardStatuses["Acknowledged"] = 10] = "Acknowledged";
    CoordinationCardStatuses[CoordinationCardStatuses["Pending"] = 20] = "Pending";
    CoordinationCardStatuses[CoordinationCardStatuses["Denied"] = 30] = "Denied";
})(CoordinationCardStatuses = exports.CoordinationCardStatuses || (exports.CoordinationCardStatuses = {}));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
// EventType values, hand-synched w/ PortCall.Models\Events\Event.cs.
var EventType;
(function (EventType) {
    EventType["Comment"] = "CO00";
    EventType["GeoActivity"] = "GA00";
    EventType["PortCallChange"] = "PC00";
    EventType["PortCallDeletion"] = "PC01";
    EventType["TopicCardChange"] = "TC00";
    EventType["RecurringBatchChange"] = "RB00";
    EventType["RecurringBatchDeletion"] = "RB01";
    EventType["PilotJobOrderChange"] = "PJ00";
    EventType["PilotJobOrderCancellation"] = "PJ01";
    EventType["PilotShiphandlingNote"] = "SN00";
    EventType["VesselChange"] = "VS00";
    EventType["PortCallAgentChanged"] = "PCAG";
    EventType["PortCallVesselChanged"] = "PCVS";
    EventType["PortCallFirstReminderReady"] = "PCR1";
    EventType["PortCallFinalReminderReady"] = "PCR2";
    EventType["IPLocationChanged"] = "IPLC";
    EventType["IPArrivalEffDateChanged"] = "IPAC";
    EventType["IPDepartureEffDateChanged"] = "IPDC";
    EventType["IPBothEffDatesChanged"] = "IPBC";
    EventType["IPArrivalLogged"] = "IPAL";
    EventType["IPDepartureLogged"] = "IPDL";
    EventType["IPArrivalUnlogged"] = "IPAU";
    EventType["IPDepartureUnlogged"] = "IPDU";
    EventType["ReservationFootmarkChanged"] = "BRFM";
    EventType["ReservationStatusChanged"] = "BRST";
    EventType["ReservationConflictCountChanged"] = "BRCC";
    EventType["ReservationSideToChanged"] = "BRSI";
    EventType["BatchBooked"] = "RBBO";
    EventType["BatchUnbooked"] = "RBUN";
    EventType["BatchCancelled"] = "RBCN";
    EventType["CCardRequested"] = "CCRQ";
    EventType["CCardCancelled"] = "CCCN";
    EventType["CCardStatusUpdate"] = "CCST";
    EventType["CCardProviderChanged"] = "CCPR";
    EventType["PJOEstDateChanged"] = "PJED";
    EventType["PJOActualDateChanged"] = "PJAD";
    EventType["PJOTugCompanyChangedEvent"] = "PJTU";
    EventType["PJOLineHandlerChangedEvent"] = "PJLH";
    EventType["PJOLaborStartChangedEvent"] = "PJLA";
    EventType["PJOAirDraftChangedEvent"] = "PJAD";
    EventType["PJODeepDraftChangedEvent"] = "PJDD";
    EventType["PJOBowThrusterChangedEvent"] = "PJBT";
})(EventType = exports.EventType || (exports.EventType = {}));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueType = void 0;
// IssueType values, hand-synched with PortCall.Models.Issues.Issue
var IssueType;
(function (IssueType) {
    IssueType["ReservationOverlapsOther"] = "OO";
    IssueType["ReservationOverlapsShift"] = "OS";
    IssueType["ReservationOverlapsVesselSchedule"] = "OV";
    IssueType["ReservationOverlapsBerthClosure"] = "OC";
    IssueType["ReservationExceedsBerthDepth"] = "BD";
    IssueType["ReservationExceedsBerthLength"] = "BL";
    IssueType["ReservationLacksKnownVessel"] = "KV";
    IssueType["PilotJobOrderExceedsBerthDepth"] = "PD";
    IssueType["ScheduleDisagreesWithEnteredDate"] = "SD";
    IssueType["BerthClosureOverlapsOther"] = "CO";
})(IssueType = exports.IssueType || (exports.IssueType = {}));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksInventoryItemTrackingWithDefaults = void 0;
__exportStar(__webpack_require__(1556), exports);
function QuickBooksInventoryItemTrackingWithDefaults(overrides, defaults) {
    return {
        Name: function () { return overrides.Name() || (defaults() ? defaults().Name() : null); },
        Account: function () { return overrides.Account() || (defaults() ? defaults().Account() : null); }
    };
}
exports.QuickBooksInventoryItemTrackingWithDefaults = QuickBooksInventoryItemTrackingWithDefaults;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1557), exports);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parseZoneCoordinates = exports.LatLong = exports.PolygonCoords = exports.CircleCoords = exports.ZONE_TYPE_POLYGON = exports.ZONE_TYPE_CIRCLE = void 0;
var L = __webpack_require__(142);
// TH: Longterm, it'd be great to make these an enum. But in the meantime...
exports.ZONE_TYPE_CIRCLE = 'circle';
exports.ZONE_TYPE_POLYGON = 'polygon';
var CircleCoords = /** @class */ (function () {
    // NOTE: radius in meters
    function CircleCoords(latLong, radius) {
        this.latLong = latLong;
        this.radius = radius;
    }
    CircleCoords.prototype.toString = function () {
        // compact format for DB storage
        return this.latLong.toString('C') + '~' + this.radius.toFixed(5);
    };
    CircleCoords.fromLeaflet = function (circle) {
        return new CircleCoords(LatLong.fromLeaflet(circle.getLatLng()), circle.getRadius());
    };
    CircleCoords.prototype.toLeaflet = function (options) {
        return L.circle(LatLong.toLeaflet(this.latLong), this.radius, options);
    };
    return CircleCoords;
}());
exports.CircleCoords = CircleCoords;
var PolygonCoords = /** @class */ (function () {
    function PolygonCoords(coords) {
        this.coords = coords;
    }
    PolygonCoords.prototype.toString = function () {
        // compact format for DB storage
        return this.coords.map(function (latLong) { return latLong.toString('C'); }).join('~');
    };
    PolygonCoords.fromLeaflet = function (polygon) {
        return new PolygonCoords(polygon.getLatLngs().map(LatLong.fromLeaflet));
    };
    PolygonCoords.prototype.toLeaflet = function (options) {
        return L.polygon(this.coords.map(LatLong.toLeaflet), options);
    };
    return PolygonCoords;
}());
exports.PolygonCoords = PolygonCoords;
var LatLong = /** @class */ (function () {
    function LatLong(lat, long) {
        this.lat = lat;
        this.long = long;
    }
    LatLong.prototype.toString = function (specifier) {
        if (specifier === void 0) { specifier = 'P'; }
        if (specifier === 'P') {
            // pretty format for display
            var northSouth = this.lat >= 0 ? 'N' : 'S', eastWest = this.long >= 0 ? 'E' : 'W';
            // \u00B0 = degree symbol
            return Math.abs(this.lat) + "\u00B0 " + northSouth + ", " + Math.abs(this.long) + "\u00B0 " + eastWest;
        }
        if (specifier === 'C') {
            // compact format for DB storage
            return this.lat.toFixed(5) + ',' + this.long.toFixed(5);
        }
        throw new Error('Unknown format specifier ' + specifier);
    };
    // Parse string formatted as '{latitude},{longitude}', e.g. '-28,-62'
    LatLong.parse = function (latLong) {
        var split = latLong.split(','), lat = +split[0], long = +split[1];
        if (isNaN(lat) || isNaN(long))
            throw new Error('Unparseable lat/long string ' + latLong);
        return new LatLong(lat, long);
    };
    LatLong.fromLeaflet = function (latLong) {
        return new LatLong(latLong.lat, latLong.lng);
    };
    LatLong.toLeaflet = function (latLong) {
        return L.latLng(latLong.lat, latLong.long);
    };
    return LatLong;
}());
exports.LatLong = LatLong;
// Parse from DB storage
function parseZoneCoordinates(zoneCoords, zoneType) {
    if (!zoneCoords)
        return null;
    var coords = zoneCoords.split('~');
    if (zoneType === exports.ZONE_TYPE_CIRCLE) {
        var radius = +coords[1];
        if (isNaN(radius))
            throw new Error('Unparsedable zone coordinates: ' + zoneCoords);
        return new CircleCoords(LatLong.parse(coords[0]), radius);
    }
    else if (zoneType === exports.ZONE_TYPE_POLYGON) {
        return new PolygonCoords(coords.map(LatLong.parse));
    }
    else {
        throw new Error('Unrecognized ZoneType: ' + zoneType);
    }
}
exports.parseZoneCoordinates = parseZoneCoordinates;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertedMeasurement = void 0;
var s_js_1 = __webpack_require__(0);
var Measurement_1 = __webpack_require__(11);
var ConvertibleMeasurement_1 = __webpack_require__(163);
var idGen = 1;
;
/// <summary>
/// Create a ConvertedMeasurement, which takes a backing Measurement instance, and provides a display in an independent UOM, rounded to a specified number of decimal places.
/// 
/// -- backingMeasurement - Measurement or ConvertibleMeasurement that backs this ConvertedMeasurement
/// -- uom                - String (not observable). The UOM for this ConvertedMeasurement.
/// -- decimalPlaces      - Integer between 0 and 20 inclusive. The number of decimal places value should be rounded to
/// -- precision          - Number. Optional. An extra precision parameter to specify more fine-grained rounding. E.g. to round to nearest half unit, specify 1 for the decimal places and .5 for the precision.
///
/// ConvertedMeasurement is readable and writable.
/// For reads, backingMeasurement can be a plain Measurement instance, a ConvertibleMeasurement, or a Measurement-like object w/ Num and UOM observables.
/// For writes, backingMeasurement must be a ConvertibleMeasurement.
/// </summary>
var ConvertedMeasurement = /** @class */ (function (_super) {
    __extends(ConvertedMeasurement, _super);
    function ConvertedMeasurement(backingMeasurement, uom, decimalPlaces, precision) {
        var _this = _super.call(this) || this;
        // last raw value passed to the write method. Used to prevent clobbering user edits due to rounding.
        var lastWrite = s_js_1.default.data(s_js_1.default.sample(backingMeasurement.Num));
        // generate a unique id for each ConvertedMeasurement constructed, so we can track who wrote to a given ConvertibleMeasurement.
        var id = _this._measurement_id = 'ConvertedMeasurement_' + idGen++;
        _this._backingMeasurement = backingMeasurement;
        var bindingMode = _this.BindingMode = function () {
            // TH: Important: We're assuming writes to the ConvertibleMeasurement are only made via one or more ConvertedMeasurements.
            // If that isn't the case, other writers need to set the LastWriter flag before they write. Any LastWriter value that doesn't start with 'ConvertedMeasurement_' will do.
            // That way other writers can update appropriately.
            if (isConvertible(backingMeasurement) && backingMeasurement.LastWriter() === id)
                return 2 /* WRITE */;
            return 1 /* READ */;
        };
        _this.Num = function (val) {
            if (arguments.length === 0 || val === undefined) {
                if (bindingMode() === 2 /* WRITE */)
                    return lastWrite();
                return _convert(backingMeasurement, uom, decimalPlaces, precision);
            }
            else {
                if (!isConvertible(backingMeasurement)) {
                    throw new Error('Can\'t write to a ConvertedMeasurement unless its backingMeasurement is a ConvertibleMeasurement or NullableConvertibleMeasurement');
                }
                lastWrite(val);
                if (val !== null && isNaN(val))
                    val = null;
                // TH: 4/25/2016 -- We used to do the check for a genuine value change before setting LastWriter.
                // But that causes problems for MeasurementInFeetAndInches instances, b/c there the internal composition of the field (its split into Feet and Inches)
                // can change w/o its overall value changing (e.g. if the field goes from { feet: 0, inches: 0 } to { feet: 0, inches: null } the overall value remains 0).
                // The overall effect was that updates weren't getting picked up when nulling out the feet and inches side of a feetinchesmetersedit or toggleablemeasurement.
                // 
                // (Original comment) For writes, we require that backingMeasurement be a ConvertibleMeasurement
                // Set LastWriter first. This protects this ConvertedMeasurement from modifications due to rounding.
                backingMeasurement.LastWriter(id);
                // TH: 4/15/2016 -- Bugfix. Don't write to the backingMeasurement unless the numeric value of this ConvertibleMeasurement is changing.
                // That prevents accidental changes caused by tabbing through a field or using arrow keys w/ in a field.
                // This comes up when there are multiple displays for the same backingMeasurement w/ a precision mismatch between the displays
                if (val !== s_js_1.default.sample(function () { return _convert(backingMeasurement, uom, decimalPlaces, precision); })) {
                    // TH: No rounding on writes. backingMeasurement may acquire many decimal places.
                    // For now, my thought is that we should always plan to round to the appropriate decimal places at display time.
                    // Can revise if that presents problems.
                    var tmp = new Measurement_1.NullableMeasurement({ Num: val, UOM: uom }), backingNum = s_js_1.default.sample(tmp.convert(s_js_1.default.sample(backingMeasurement.UOM)).Num);
                    if (backingNum !== null || backingMeasurement instanceof ConvertibleMeasurement_1.NullableConvertibleMeasurement) {
                        backingMeasurement.Num(backingNum);
                    }
                }
                return val;
            }
        };
        // UOM doesn't change.
        _this.UOM = function () { return uom; };
        return _this;
    }
    ConvertedMeasurement.prototype.set = function (m) {
        throw new Error("Cannot set a ConvertedMeasurement");
    };
    // If this ConvertedMeasurement currently has LastWriter, then set LastWriter to null
    ConvertedMeasurement.prototype.RelinquishWriter = function () {
        if (isConvertible(this._backingMeasurement) && s_js_1.default.sample(this._backingMeasurement.LastWriter) === this._measurement_id)
            this._backingMeasurement.LastWriter(null);
    };
    return ConvertedMeasurement;
}(Measurement_1.NullableMeasurement));
exports.ConvertedMeasurement = ConvertedMeasurement;
function _convert(m, uom, places, precision) {
    var out = new Measurement_1.NullableMeasurement({ Num: m.Num(), UOM: m.UOM() }).convert(uom);
    if (precision !== undefined)
        out = out.roundToNearest(precision);
    out = out.roundToNPlaces(places);
    return s_js_1.default.sample(out.Num);
}
function isConvertible(measurement) {
    return measurement instanceof ConvertibleMeasurement_1.ConvertibleMeasurement || measurement instanceof ConvertibleMeasurement_1.NullableConvertibleMeasurement;
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var s_array_1 = __webpack_require__(3);
function nonuniqueIndex(array, keyFn) {
    var index = {}, map = array.map(function (item, _s) {
        var key = keyFn(item), s = slot(key);
        if (s !== _s) {
            if (_s)
                _s.remove(item);
            s.push(item);
        }
        return s;
    }, function (item, s) {
        s.remove(item);
    });
    return indexRef;
    function indexRef(id) {
        return typeof id === 'function'
            ? function () { return slot(id())(); }
            : slot(id);
    }
    function slot(id) {
        return id in index ? index[id] : index[id] = s_array_1.default([]);
    }
}
exports.default = nonuniqueIndex;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrderRightsDisplayName = exports.JobOrderRights = exports.EventRightses = exports.EventRightsDisplayName = exports.EventRights = exports.TopicCardTemplateUserAssignmentRightses = exports.TopicCardTemplateUserAssignmentRightsDisplayName = exports.TopicCardTemplateUserAssignmentRights = exports.PortCallTopicCardTemplateRightses = exports.PortCallTopicCardTemplateRightsDisplayName = exports.PortCallTopicCardTemplateRights = exports.TopicCardRightses = exports.TopicCardRightsDisplayName = exports.TopicCardRights = exports.SharingRightses = exports.SharingRightsDisplayName = exports.SharingRights = exports.TrafficRightses = exports.TrafficRightsDisplayName = exports.TrafficRights = exports.VesselRightses = exports.VesselRightsDisplayName = exports.VesselRights = exports.DomainRightses = exports.DomainRightsDisplayName = exports.DomainRights = exports.OrganizationRightses = exports.OrganizationRightsDisplayName = exports.OrganizationRights = exports.BerthClosureRightses = exports.BerthClosureRightsDisplayName = exports.BerthClosureRights = exports.RecurringBatchRightses = exports.RecurringBatchRightsDisplayName = exports.RecurringBatchRights = exports.PortCallRightses = exports.PortCallRightsDisplayName = exports.PortCallRights = exports.PierGroupRightses = exports.PierGroupRightsDisplayName = exports.PierGroupRights = exports.BerthRightses = exports.BerthRightsDisplayName = exports.BerthRights = exports.PortRightses = exports.PortRightsDisplayName = exports.PortRights = exports.UserProfileRightses = exports.UserProfileRightsDisplayName = exports.UserProfileRights = void 0;
exports.CoordinationCardSelfRightses = exports.CoordinationCardSelfRightsDisplayName = exports.CoordinationCardSelfRights = exports.CoordinationCardRightses = exports.CoordinationCardRightsDisplayName = exports.CoordinationCardRights = exports.JobOrderRightses = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Rights.cs
var UserProfileRights;
(function (UserProfileRights) {
    UserProfileRights[UserProfileRights["View"] = 1] = "View";
    UserProfileRights[UserProfileRights["Edit"] = 2] = "Edit";
    UserProfileRights[UserProfileRights["EditRoles"] = 4] = "EditRoles";
    UserProfileRights[UserProfileRights["MarkNotificationsAsViewed"] = 8] = "MarkNotificationsAsViewed";
    UserProfileRights[UserProfileRights["ViewContactInfo"] = 16] = "ViewContactInfo";
    UserProfileRights[UserProfileRights["None"] = 0] = "None";
})(UserProfileRights = exports.UserProfileRights || (exports.UserProfileRights = {}));
exports.UserProfileRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'EditRoles',
    8: 'MarkNotificationsAsViewed',
    16: 'ViewContactInfo',
    0: 'None'
};
exports.UserProfileRightses = [
    { Id: UserProfileRights.View, Name: 'View' },
    { Id: UserProfileRights.Edit, Name: 'Edit' },
    { Id: UserProfileRights.EditRoles, Name: 'EditRoles' },
    { Id: UserProfileRights.MarkNotificationsAsViewed, Name: 'MarkNotificationsAsViewed' },
    { Id: UserProfileRights.ViewContactInfo, Name: 'ViewContactInfo' },
    { Id: UserProfileRights.None, Name: 'None' }
];
var PortRights;
(function (PortRights) {
    PortRights[PortRights["View"] = 1] = "View";
    PortRights[PortRights["Edit"] = 2] = "Edit";
    PortRights[PortRights["None"] = 0] = "None";
})(PortRights = exports.PortRights || (exports.PortRights = {}));
exports.PortRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    0: 'None'
};
exports.PortRightses = [
    { Id: PortRights.View, Name: 'View' },
    { Id: PortRights.Edit, Name: 'Edit' },
    { Id: PortRights.None, Name: 'None' }
];
var BerthRights;
(function (BerthRights) {
    BerthRights[BerthRights["View"] = 1] = "View";
    BerthRights[BerthRights["Edit"] = 2] = "Edit";
    BerthRights[BerthRights["Reserve"] = 4] = "Reserve";
    BerthRights[BerthRights["EditSchedulingAuthority"] = 8] = "EditSchedulingAuthority";
    BerthRights[BerthRights["AddClosure"] = 16] = "AddClosure";
    BerthRights[BerthRights["None"] = 0] = "None";
})(BerthRights = exports.BerthRights || (exports.BerthRights = {}));
exports.BerthRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'Reserve',
    8: 'EditSchedulingAuthority',
    16: 'AddClosure',
    0: 'None'
};
exports.BerthRightses = [
    { Id: BerthRights.View, Name: 'View' },
    { Id: BerthRights.Edit, Name: 'Edit' },
    { Id: BerthRights.Reserve, Name: 'Reserve' },
    { Id: BerthRights.EditSchedulingAuthority, Name: 'EditSchedulingAuthority' },
    { Id: BerthRights.AddClosure, Name: 'AddClosure' },
    { Id: BerthRights.None, Name: 'None' }
];
var PierGroupRights;
(function (PierGroupRights) {
    PierGroupRights[PierGroupRights["View"] = 1] = "View";
    PierGroupRights[PierGroupRights["Edit"] = 2] = "Edit";
    PierGroupRights[PierGroupRights["EditOrder"] = 4] = "EditOrder";
    PierGroupRights[PierGroupRights["EditPort"] = 8] = "EditPort";
    PierGroupRights[PierGroupRights["Delete"] = 16] = "Delete";
    PierGroupRights[PierGroupRights["IgnorePreventAgentOverlaps"] = 32] = "IgnorePreventAgentOverlaps";
    PierGroupRights[PierGroupRights["IgnoreRequireKnownVessels"] = 64] = "IgnoreRequireKnownVessels";
    PierGroupRights[PierGroupRights["IgnoreAgentChangeWindow"] = 128] = "IgnoreAgentChangeWindow";
    PierGroupRights[PierGroupRights["None"] = 0] = "None";
})(PierGroupRights = exports.PierGroupRights || (exports.PierGroupRights = {}));
exports.PierGroupRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'EditOrder',
    8: 'EditPort',
    16: 'Delete',
    32: 'IgnorePreventAgentOverlaps',
    64: 'IgnoreRequireKnownVessels',
    128: 'IgnoreAgentChangeWindow',
    0: 'None'
};
exports.PierGroupRightses = [
    { Id: PierGroupRights.View, Name: 'View' },
    { Id: PierGroupRights.Edit, Name: 'Edit' },
    { Id: PierGroupRights.EditOrder, Name: 'EditOrder' },
    { Id: PierGroupRights.EditPort, Name: 'EditPort' },
    { Id: PierGroupRights.Delete, Name: 'Delete' },
    { Id: PierGroupRights.IgnorePreventAgentOverlaps, Name: 'IgnorePreventAgentOverlaps' },
    { Id: PierGroupRights.IgnoreRequireKnownVessels, Name: 'IgnoreRequireKnownVessels' },
    { Id: PierGroupRights.IgnoreAgentChangeWindow, Name: 'IgnoreAgentChangeWindow' },
    { Id: PierGroupRights.None, Name: 'None' }
];
var PortCallRights;
(function (PortCallRights) {
    PortCallRights[PortCallRights["View"] = 1] = "View";
    PortCallRights[PortCallRights["Edit"] = 2] = "Edit";
    PortCallRights[PortCallRights["EditActuals"] = 4] = "EditActuals";
    PortCallRights[PortCallRights["EditUnlistedOverride"] = 8] = "EditUnlistedOverride";
    PortCallRights[PortCallRights["EditRafting"] = 16] = "EditRafting";
    PortCallRights[PortCallRights["Book"] = 32] = "Book";
    PortCallRights[PortCallRights["Cancel"] = 64] = "Cancel";
    PortCallRights[PortCallRights["Delete"] = 128] = "Delete";
    PortCallRights[PortCallRights["None"] = 0] = "None";
})(PortCallRights = exports.PortCallRights || (exports.PortCallRights = {}));
exports.PortCallRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'EditActuals',
    8: 'EditUnlistedOverride',
    16: 'EditRafting',
    32: 'Book',
    64: 'Cancel',
    128: 'Delete',
    0: 'None'
};
exports.PortCallRightses = [
    { Id: PortCallRights.View, Name: 'View' },
    { Id: PortCallRights.Edit, Name: 'Edit' },
    { Id: PortCallRights.EditActuals, Name: 'EditActuals' },
    { Id: PortCallRights.EditUnlistedOverride, Name: 'EditUnlistedOverride' },
    { Id: PortCallRights.EditRafting, Name: 'EditRafting' },
    { Id: PortCallRights.Book, Name: 'Book' },
    { Id: PortCallRights.Cancel, Name: 'Cancel' },
    { Id: PortCallRights.Delete, Name: 'Delete' },
    { Id: PortCallRights.None, Name: 'None' }
];
var RecurringBatchRights;
(function (RecurringBatchRights) {
    RecurringBatchRights[RecurringBatchRights["View"] = 1] = "View";
    RecurringBatchRights[RecurringBatchRights["Delete"] = 2] = "Delete";
    RecurringBatchRights[RecurringBatchRights["None"] = 0] = "None";
})(RecurringBatchRights = exports.RecurringBatchRights || (exports.RecurringBatchRights = {}));
exports.RecurringBatchRightsDisplayName = {
    1: 'View',
    2: 'Delete',
    0: 'None'
};
exports.RecurringBatchRightses = [
    { Id: RecurringBatchRights.View, Name: 'View' },
    { Id: RecurringBatchRights.Delete, Name: 'Delete' },
    { Id: RecurringBatchRights.None, Name: 'None' }
];
var BerthClosureRights;
(function (BerthClosureRights) {
    BerthClosureRights[BerthClosureRights["View"] = 1] = "View";
    BerthClosureRights[BerthClosureRights["Edit"] = 2] = "Edit";
    BerthClosureRights[BerthClosureRights["None"] = 0] = "None";
})(BerthClosureRights = exports.BerthClosureRights || (exports.BerthClosureRights = {}));
exports.BerthClosureRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    0: 'None'
};
exports.BerthClosureRightses = [
    { Id: BerthClosureRights.View, Name: 'View' },
    { Id: BerthClosureRights.Edit, Name: 'Edit' },
    { Id: BerthClosureRights.None, Name: 'None' }
];
var OrganizationRights;
(function (OrganizationRights) {
    OrganizationRights[OrganizationRights["View"] = 1] = "View";
    OrganizationRights[OrganizationRights["Edit"] = 2] = "Edit";
    OrganizationRights[OrganizationRights["ManageUsers"] = 4] = "ManageUsers";
    OrganizationRights[OrganizationRights["ManageBerths"] = 8] = "ManageBerths";
    OrganizationRights[OrganizationRights["AddManagedBerth"] = 16] = "AddManagedBerth";
    OrganizationRights[OrganizationRights["ManageBills"] = 32] = "ManageBills";
    OrganizationRights[OrganizationRights["None"] = 0] = "None";
})(OrganizationRights = exports.OrganizationRights || (exports.OrganizationRights = {}));
exports.OrganizationRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'ManageUsers',
    8: 'ManageBerths',
    16: 'AddManagedBerth',
    32: 'ManageBills',
    0: 'None'
};
exports.OrganizationRightses = [
    { Id: OrganizationRights.View, Name: 'View' },
    { Id: OrganizationRights.Edit, Name: 'Edit' },
    { Id: OrganizationRights.ManageUsers, Name: 'ManageUsers' },
    { Id: OrganizationRights.ManageBerths, Name: 'ManageBerths' },
    { Id: OrganizationRights.AddManagedBerth, Name: 'AddManagedBerth' },
    { Id: OrganizationRights.ManageBills, Name: 'ManageBills' },
    { Id: OrganizationRights.None, Name: 'None' }
];
var DomainRights;
(function (DomainRights) {
    DomainRights[DomainRights["View"] = 1] = "View";
    DomainRights[DomainRights["Edit"] = 2] = "Edit";
    DomainRights[DomainRights["ManageOrgs"] = 4] = "ManageOrgs";
    DomainRights[DomainRights["AddUnmanagedBerth"] = 8] = "AddUnmanagedBerth";
    DomainRights[DomainRights["AddVessel"] = 16] = "AddVessel";
    DomainRights[DomainRights["IgnorePreventAgentDoubleBookings"] = 32] = "IgnorePreventAgentDoubleBookings";
    DomainRights[DomainRights["ConfigureCoordinations"] = 64] = "ConfigureCoordinations";
    DomainRights[DomainRights["None"] = 0] = "None";
})(DomainRights = exports.DomainRights || (exports.DomainRights = {}));
exports.DomainRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'ManageOrgs',
    8: 'AddUnmanagedBerth',
    16: 'AddVessel',
    32: 'IgnorePreventAgentDoubleBookings',
    64: 'ConfigureCoordinations',
    0: 'None'
};
exports.DomainRightses = [
    { Id: DomainRights.View, Name: 'View' },
    { Id: DomainRights.Edit, Name: 'Edit' },
    { Id: DomainRights.ManageOrgs, Name: 'ManageOrgs' },
    { Id: DomainRights.AddUnmanagedBerth, Name: 'AddUnmanagedBerth' },
    { Id: DomainRights.AddVessel, Name: 'AddVessel' },
    { Id: DomainRights.IgnorePreventAgentDoubleBookings, Name: 'IgnorePreventAgentDoubleBookings' },
    { Id: DomainRights.ConfigureCoordinations, Name: 'ConfigureCoordinations' },
    { Id: DomainRights.None, Name: 'None' }
];
var VesselRights;
(function (VesselRights) {
    VesselRights[VesselRights["View"] = 1] = "View";
    VesselRights[VesselRights["Edit"] = 2] = "Edit";
    VesselRights[VesselRights["EditDOS"] = 4] = "EditDOS";
    VesselRights[VesselRights["AddShiphandlingNote"] = 8] = "AddShiphandlingNote";
    VesselRights[VesselRights["None"] = 0] = "None";
})(VesselRights = exports.VesselRights || (exports.VesselRights = {}));
exports.VesselRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'EditDOS',
    8: 'AddShiphandlingNote',
    0: 'None'
};
exports.VesselRightses = [
    { Id: VesselRights.View, Name: 'View' },
    { Id: VesselRights.Edit, Name: 'Edit' },
    { Id: VesselRights.EditDOS, Name: 'EditDOS' },
    { Id: VesselRights.AddShiphandlingNote, Name: 'AddShiphandlingNote' },
    { Id: VesselRights.None, Name: 'None' }
];
var TrafficRights;
(function (TrafficRights) {
    TrafficRights[TrafficRights["View"] = 1] = "View";
    TrafficRights[TrafficRights["None"] = 0] = "None";
})(TrafficRights = exports.TrafficRights || (exports.TrafficRights = {}));
exports.TrafficRightsDisplayName = {
    1: 'View',
    0: 'None'
};
exports.TrafficRightses = [
    { Id: TrafficRights.View, Name: 'View' },
    { Id: TrafficRights.None, Name: 'None' }
];
var SharingRights;
(function (SharingRights) {
    SharingRights[SharingRights["View"] = 1] = "View";
    SharingRights[SharingRights["Edit"] = 2] = "Edit";
    SharingRights[SharingRights["None"] = 0] = "None";
})(SharingRights = exports.SharingRights || (exports.SharingRights = {}));
exports.SharingRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    0: 'None'
};
exports.SharingRightses = [
    { Id: SharingRights.View, Name: 'View' },
    { Id: SharingRights.Edit, Name: 'Edit' },
    { Id: SharingRights.None, Name: 'None' }
];
var TopicCardRights;
(function (TopicCardRights) {
    TopicCardRights[TopicCardRights["View"] = 1] = "View";
    TopicCardRights[TopicCardRights["Edit"] = 2] = "Edit";
    TopicCardRights[TopicCardRights["Confirm"] = 4] = "Confirm";
    TopicCardRights[TopicCardRights["None"] = 0] = "None";
})(TopicCardRights = exports.TopicCardRights || (exports.TopicCardRights = {}));
exports.TopicCardRightsDisplayName = {
    1: 'View',
    2: 'Edit',
    4: 'Confirm',
    0: 'None'
};
exports.TopicCardRightses = [
    { Id: TopicCardRights.View, Name: 'View' },
    { Id: TopicCardRights.Edit, Name: 'Edit' },
    { Id: TopicCardRights.Confirm, Name: 'Confirm' },
    { Id: TopicCardRights.None, Name: 'None' }
];
var PortCallTopicCardTemplateRights;
(function (PortCallTopicCardTemplateRights) {
    PortCallTopicCardTemplateRights[PortCallTopicCardTemplateRights["AnswerTemplate"] = 1] = "AnswerTemplate";
    PortCallTopicCardTemplateRights[PortCallTopicCardTemplateRights["None"] = 0] = "None";
})(PortCallTopicCardTemplateRights = exports.PortCallTopicCardTemplateRights || (exports.PortCallTopicCardTemplateRights = {}));
exports.PortCallTopicCardTemplateRightsDisplayName = {
    1: 'AnswerTemplate',
    0: 'None'
};
exports.PortCallTopicCardTemplateRightses = [
    { Id: PortCallTopicCardTemplateRights.AnswerTemplate, Name: 'AnswerTemplate' },
    { Id: PortCallTopicCardTemplateRights.None, Name: 'None' }
];
var TopicCardTemplateUserAssignmentRights;
(function (TopicCardTemplateUserAssignmentRights) {
    TopicCardTemplateUserAssignmentRights[TopicCardTemplateUserAssignmentRights["CanAssign"] = 1] = "CanAssign";
    TopicCardTemplateUserAssignmentRights[TopicCardTemplateUserAssignmentRights["None"] = 0] = "None";
})(TopicCardTemplateUserAssignmentRights = exports.TopicCardTemplateUserAssignmentRights || (exports.TopicCardTemplateUserAssignmentRights = {}));
exports.TopicCardTemplateUserAssignmentRightsDisplayName = {
    1: 'CanAssign',
    0: 'None'
};
exports.TopicCardTemplateUserAssignmentRightses = [
    { Id: TopicCardTemplateUserAssignmentRights.CanAssign, Name: 'CanAssign' },
    { Id: TopicCardTemplateUserAssignmentRights.None, Name: 'None' }
];
var EventRights;
(function (EventRights) {
    EventRights[EventRights["ViewComments"] = 1] = "ViewComments";
    EventRights[EventRights["Comment"] = 2] = "Comment";
    EventRights[EventRights["None"] = 0] = "None";
})(EventRights = exports.EventRights || (exports.EventRights = {}));
exports.EventRightsDisplayName = {
    1: 'ViewComments',
    2: 'Comment',
    0: 'None'
};
exports.EventRightses = [
    { Id: EventRights.ViewComments, Name: 'ViewComments' },
    { Id: EventRights.Comment, Name: 'Comment' },
    { Id: EventRights.None, Name: 'None' }
];
var JobOrderRights;
(function (JobOrderRights) {
    JobOrderRights[JobOrderRights["ViewComments"] = 1] = "ViewComments";
    JobOrderRights[JobOrderRights["Comment"] = 2] = "Comment";
    JobOrderRights[JobOrderRights["None"] = 0] = "None";
})(JobOrderRights = exports.JobOrderRights || (exports.JobOrderRights = {}));
exports.JobOrderRightsDisplayName = {
    1: 'ViewComments',
    2: 'Comment',
    0: 'None'
};
exports.JobOrderRightses = [
    { Id: JobOrderRights.ViewComments, Name: 'ViewComments' },
    { Id: JobOrderRights.Comment, Name: 'Comment' },
    { Id: JobOrderRights.None, Name: 'None' }
];
var CoordinationCardRights;
(function (CoordinationCardRights) {
    CoordinationCardRights[CoordinationCardRights["View"] = 1] = "View";
    CoordinationCardRights[CoordinationCardRights["EditStatus"] = 2] = "EditStatus";
    CoordinationCardRights[CoordinationCardRights["Cancel"] = 4] = "Cancel";
    CoordinationCardRights[CoordinationCardRights["ChangeProvider"] = 8] = "ChangeProvider";
    CoordinationCardRights[CoordinationCardRights["None"] = 0] = "None";
})(CoordinationCardRights = exports.CoordinationCardRights || (exports.CoordinationCardRights = {}));
exports.CoordinationCardRightsDisplayName = {
    1: 'View',
    2: 'EditStatus',
    4: 'Cancel',
    8: 'ChangeProvider',
    0: 'None'
};
exports.CoordinationCardRightses = [
    { Id: CoordinationCardRights.View, Name: 'View' },
    { Id: CoordinationCardRights.EditStatus, Name: 'EditStatus' },
    { Id: CoordinationCardRights.Cancel, Name: 'Cancel' },
    { Id: CoordinationCardRights.ChangeProvider, Name: 'ChangeProvider' },
    { Id: CoordinationCardRights.None, Name: 'None' }
];
var CoordinationCardSelfRights;
(function (CoordinationCardSelfRights) {
    CoordinationCardSelfRights[CoordinationCardSelfRights["View"] = 1] = "View";
    CoordinationCardSelfRights[CoordinationCardSelfRights["Comment"] = 2] = "Comment";
    CoordinationCardSelfRights[CoordinationCardSelfRights["None"] = 0] = "None";
})(CoordinationCardSelfRights = exports.CoordinationCardSelfRights || (exports.CoordinationCardSelfRights = {}));
exports.CoordinationCardSelfRightsDisplayName = {
    1: 'View',
    2: 'Comment',
    0: 'None'
};
exports.CoordinationCardSelfRightses = [
    { Id: CoordinationCardSelfRights.View, Name: 'View' },
    { Id: CoordinationCardSelfRights.Comment, Name: 'Comment' },
    { Id: CoordinationCardSelfRights.None, Name: 'None' }
];


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(26).f;
var has = __webpack_require__(45);
var TAG = __webpack_require__(24)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var defined = __webpack_require__(62);
var fails = __webpack_require__(19);
var spaces = __webpack_require__(234);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(27) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

$.ui = $.ui || {};

return $.ui.version = "1.12.1";

} ) );


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(244);
var setInnerHTML = __webpack_require__(189);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(252);
var setTextContent = __webpack_require__(486);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(925);
var ReactInstrumentation = __webpack_require__(59);

var warning = __webpack_require__(20);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var ReactBaseClasses = __webpack_require__(488);
var ReactChildren = __webpack_require__(954);
var ReactDOMFactories = __webpack_require__(955);
var ReactElement = __webpack_require__(127);
var ReactPropTypes = __webpack_require__(956);
var ReactVersion = __webpack_require__(957);

var createReactClass = __webpack_require__(958);
var onlyChild = __webpack_require__(962);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var ReactCurrentOwner = __webpack_require__(76);

var warning = __webpack_require__(20);
var canDefineProperty = __webpack_require__(492);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(490);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeSelectorView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(60);
function dateRangeName(range) {
    if (range === 0 /* AllDates */)
        return 'All Dates';
    if (range === 1 /* ThisWeek */)
        return 'This Week';
    if (range === 2 /* LastWeek */)
        return 'Last Week';
    if (range === 3 /* ThisMonth */)
        return 'This Month';
    if (range === 4 /* LastMonth */)
        return 'Last Month';
    if (range === 5 /* ThisYear */)
        return 'This Year';
    if (range === 6 /* LastYear */)
        return 'Last Year';
    if (range === 7 /* Custom */)
        return 'Custom';
    throw new Error('Unknown date range: ' + range);
}
exports.DateRangeSelectorView = supercritical_1.default(function (_a) {
    var m = _a.model;
    // <span className="date-range-selector">
    return React.createElement("span", { className: cx('date-range-selector', {
            'date-range-custom': m.Range() === 7 /* Custom */
        }) },
        React.createElement("select", { className: "range pc-select", value: m.Range(), onChange: function (e) { return m.Range(+e.currentTarget.value); } }, m.AllowedRanges.map(function (r) {
            return React.createElement("option", { value: r, key: r }, dateRangeName(r));
        })),
        React.createElement("span", { className: "pc-select-chevron" }),
        m.Range() === 7 /* Custom */ &&
            React.createElement("span", null,
                React.createElement("div", { className: "datepicker-container" },
                    React.createElement(view_1.DatePicker, { value: m.FromDate, localization: m.Localization })),
                React.createElement("div", { className: "text" }, "to"),
                React.createElement("div", { className: "datepicker-container" },
                    React.createElement(view_1.DatePicker, { value: m.CustomToDate, localization: m.Localization }))));
});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RowExpander = exports.RowSelector = exports.RowSorter = void 0;
var s_js_1 = __webpack_require__(0);
function RowSorter(initialColumn, initialSortReversed) {
    if (initialSortReversed === void 0) { initialSortReversed = false; }
    var sortColumn = s_js_1.default.data(initialColumn), sortReversed = s_js_1.default.data(initialSortReversed);
    return {
        SortColumn: sortColumn,
        SortReversed: sortReversed,
        RowOrder: RowOrder,
        OnSortClick: OnSortClick
    };
    function RowOrder(row1, row2) {
        var sortFn = sortColumn().SortValue, order = sortReversed() ? -1 : 1, r1 = sortFn(row1), r2 = sortFn(row2);
        return r1 < r2 ? -order : r1 > r2 ? order : 0;
    }
    function OnSortClick(col) {
        s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
            if (sortColumn() === col) {
                sortReversed(!sortReversed());
            }
            else {
                sortColumn(col);
                sortReversed(false);
            }
        }); });
    }
}
exports.RowSorter = RowSorter;
function RowSelector(rows, selectionProperty) {
    var allRowsSelected = rows.every(function (row) { return selectionProperty(row)(); }), someRowsSelected = rows.some(function (row) { return selectionProperty(row)(); }), rowSelectionStatus = function (status) {
        if (arguments.length === 0) {
            return allRowsSelected() ? 2 /* All */
                : someRowsSelected() ? 1 /* Some */
                    : 0 /* None */;
        }
        s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
            if (status === 0 /* None */) {
                rows().forEach(function (row) {
                    if (selectionProperty(row)())
                        selectionProperty(row)(false);
                });
            }
            else if (status === 2 /* All */) {
                rows().forEach(function (row) {
                    if (!selectionProperty(row)())
                        selectionProperty(row)(true);
                });
            }
            else {
                throw new Error('Invalid selection status ' + status + '. Only SelectionStatus.All or SelectionStatus.None allowed.');
            }
        }); });
        return status;
    };
    return {
        RowSelectionStatus: rowSelectionStatus
    };
}
exports.RowSelector = RowSelector;
function RowExpander(expansionMode, allRows, filteredRows, expansionProperty) {
    var allCurrentlyExpanded = filteredRows.every(function (r) { return expansionProperty(r)(); });
    s_js_1.default.on(expansionMode, function () { return allRows().forEach(function (r) {
        return expansionProperty(r)(expansionMode() === 1 /* AutoExpand */);
    }); }, null, true);
    return {
        // TH 05/05/2017 -- Global expansion mode.
        // Calling MUST construct this as an S.data, not an S.value, and should use it as the
        // default if new rows are discovered.
        // Setting this will change the expansion status of every row.
        // Users can still expand or collapse individual rows w/o changing this value.
        ExpansionMode: expansionMode,
        // TH 05/05/2017 -- Current expansion status of visible rows.
        // This determines whether we show the Expand All or Collapse All link.
        // Note: it's important that ExpansionMode be an S.data and not an S.value.
        // Clicking Expand All a second time is not necessarily idempotent.
        AllCurrentlyExpanded: allCurrentlyExpanded
    };
}
exports.RowExpander = RowExpander;
/* End RowExpander */


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var $ = __webpack_require__(27);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
var LoginView = /** @class */ (function (_super) {
    __extends(LoginView, _super);
    function LoginView(props) {
        var _this = _super.call(this, props) || this;
        _this.userNameRef = supercritical_1.SuperCriticalReference(_this, function (props, el) {
            // focus username input when modal opens
            var $modal = $(el).closest('.modal'), focus = function () { return el.focus(); };
            $modal.on('shown.bs.modal', focus);
            s_js_1.default.cleanup(function () { return $modal.off('shown.bs.modal', focus); });
        });
        return _this;
    }
    LoginView.prototype.srender = function (_a) {
        var _this = this;
        var _b;
        var modelContainer = _a.modelContainer;
        return (React.createElement(view_1.PCModal, { className: "login", shown: function () { return !!modelContainer(); }, onBackDropClick: (_b = modelContainer()) === null || _b === void 0 ? void 0 : _b.HidePopup },
            React.createElement("div", { className: "modal-content" },
                React.createElement("div", { className: "modal-header" },
                    (function (m) { return m &&
                        React.createElement("button", { className: "close", onClick: m.HidePopup },
                            React.createElement("span", { className: "pc-close-icon", "aria-hidden": "true" }),
                            React.createElement("span", { className: "sr-only" }, "Close")); })(modelContainer()),
                    React.createElement("h2", { className: "modal-title" }, "Log in")),
                (function (m) { return m &&
                    React.createElement("div", { className: "modal-body" },
                        m.LoginError() &&
                            React.createElement("div", { className: "alert alert-danger" }, "Incorrect Email or Password. Please try again."),
                        React.createElement("form", { onSubmit: eventWrappers_1.noDefault(m.Login) },
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { className: "form-control username", placeholder: "Username", value: m.LoginRequest.UserName(), onChange: function (e) { return m.LoginRequest.UserName(e.target.value); }, ref: _this.userNameRef })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { type: "password", className: "form-control password", placeholder: "Password", value: m.LoginRequest.Password(), onChange: function (e) { return m.LoginRequest.Password(e.target.value); } })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("button", { type: "submit", className: "pc-button login-button" }, "Login")),
                            React.createElement("div", { className: "form-group forgotPassword" },
                                React.createElement("a", { href: "", className: "forgot-password", onClick: eventWrappers_1.noDefault(m.ForgotPassword) }, "Forgot Password?")))); })(modelContainer()))));
    };
    return LoginView;
}(supercritical_1.SuperCriticalComponent));
exports.LoginView = LoginView;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgHeaderView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.OrgHeaderView = supercritical_1.default(function (_a) {
    var org = _a.organization;
    return React.createElement("div", { className: "org-profile-header" },
        React.createElement("img", { src: org.Image.ProfileUrl() || '' }),
        React.createElement("div", { className: "profile-header-details" },
            React.createElement("div", { className: "profile-name pc-text-fixedwidth" }, org.Name())));
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCSortable = void 0;
var s_js_1 = __webpack_require__(0);
var React = __webpack_require__(2);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
__webpack_require__(1391);
var STASHED_PROPS_DATA_KEY = '__pc_sortable_stashed_props', JQUERY_UI_SORTABLE_KEY = 'ui-sortable';
var PCSortable = /** @class */ (function (_super) {
    __extends(PCSortable, _super);
    function PCSortable(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, InitializeSortable);
        return _this;
    }
    PCSortable.prototype.srender = function (_a) {
        var items = _a.items, rowFactory = _a.rowFactory, className = _a.className;
        return (React.createElement("ul", { className: className, ref: this.ref }, items().map(rowFactory)));
    };
    return PCSortable;
}(supercritical_1.SuperCriticalComponent));
exports.PCSortable = PCSortable;
function InitializeSortable(props, el) {
    var $el = $(el);
    // TH 12/14/2016 -- Use jquery data API to support connected lists.
    $el.data(STASHED_PROPS_DATA_KEY, props);
    s_js_1.default.cleanup(function () { return $el.removeData(STASHED_PROPS_DATA_KEY); });
    var items = props.items, disabled = props.disabled, connectWith = props.connectWith;
    var deferredCallbacks = [], startIndex = 0, // index of dragged item in source list
    draggedItem = null;
    s_js_1.default.cleanup(function () {
        deferredCallbacks = [];
        draggedItem = null;
    });
    // TH 12/14/2016 -- NOTE: References to KO in comments are from original knockout-sortable-binding implementation.
    $el.sortable({
        // For connected lists, fires on the source list
        start: function (event, ui) {
            // start event. jQuery UI fires this when drag gesture starts.
            // By default, when you drag a sortable item, jQuery UI rearranges the DOM to match the outcome of your sort.
            // It does this before firing the beforeStop, stop, update, or receive events.
            // This leads to corrupt state if KO later tries to update the DOM itself (duplicated items and other weirdness).
            // The fix is to set the _noFinalSort flag. That causes jQuery UI not to rearrange the DOM.
            // As a side effect, it also means jQuery UI will never fire the update event. That's OK b/c we'll listen for beforeStop instead.
            // NOTE: _noFinalSort flag supported as of jQuery UI v1.11
            var sortable = $el.data(JQUERY_UI_SORTABLE_KEY);
            sortable._noFinalSort = true;
            startIndex = $el.children().index(ui.item);
            draggedItem = items()[startIndex];
        },
        // For connected lists, fires on the source list
        beforeStop: function (event, ui) {
            // beforeStop event. jQuery UI fires this after user has completed their drag gesture, but while jQuery UI's helper and placeholder elements are still in the DOM.
            // We'll use the position of the placeholder element to determine the user's intended sort position.
            // (B/c we set the _noFinalSort flag above, the dragged element itself will still be in its original position).
            // Based on that new position, we'll fire the target list's sort callback w/ the appropriate data.
            // jQuery UI will remove the helper and placeholder elements for us after this event fires.
            var targetList = ui.placeholder.parent(), targetListProps = targetList.data(STASHED_PROPS_DATA_KEY);
            if (!targetListProps || !draggedItem)
                return;
            var targetItems = targetListProps.items, onSort = targetListProps.onSort, item = ui.item[0], placeholder = ui.placeholder[0], targetChildren = targetList.children(), targetChildrenData = targetItems().filter(function (item) { return item !== draggedItem; }), sourceChildrenData = targetList[0] === $el[0] ? null : items().filter(function (item) { return item !== draggedItem; });
            var newIndex = 0;
            for (var i = 0; i < targetChildren.length; i++) {
                if (targetChildren[i] === placeholder) {
                    break;
                }
                if (targetChildren[i] !== item)
                    newIndex++;
            }
            targetChildrenData.splice(newIndex, 0, draggedItem);
            // Queue callback on the target list. Fire with following arguments:
            //   1) itemData           -- {Object} The KO viewModel object for the dragged item.
            //   2) targetChildrenData -- {Array} A plain JS array containing the KO viewModels for the target list's children.
            //                            Lists children data in up-to-date sort order. Includes dragged item in its correct sort order.
            //   3) sourceChildrenData -- {Array or Null} Null if the sort started and ended on the same list.
            //                            Otherwise, if sort dragged item from one connected list to another, will be a plain JS array containing
            //                            the KO viewModels for the source list's children, in up-to-date sort order. I.e., will be same as the children
            //                            list from before the sort, except w/ the dragged item removed.
            deferredCallbacks.push(function () { return draggedItem && onSort(draggedItem, targetChildrenData, sourceChildrenData); });
        },
        // For connected lists, fires on the source list
        stop: function (event, ui) {
            // stop event. jQuery UI fires this event after the user has completed their drag and the placeholder and helper elements have been removed.
            // Fire the callbacks queued in the beforeStop event.
            // We do this here instead of in beforeStop to prevent KO-triggered DOM manipulations from interfering w/ jQuery UI's DOM clean up.
            deferredCallbacks.map(function (callback) { return callback(); });
            deferredCallbacks = [];
            startIndex = 0;
            draggedItem = null;
        },
        // Tells jQuery UI to make a placeholder element w/ the specified CSS class. Otherwise, there'd be no placeholder element at all.
        // We need this for our beforeStop handler to work.
        placeholder: 'sortable-placeholder'
    });
    s_js_1.default.cleanup(function () { return $el.sortable('destroy'); });
    if (connectWith)
        s_js_1.default(function () { return $el.sortable('option', 'connectWith', connectWith()); });
    if (disabled)
        s_js_1.default(function () { return disabled() ? $el.sortable('disable') : $el.sortable('enable'); });
}


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportGroupList = exports.FilterData = exports.Columns = exports.PRICE_PRECISION = void 0;
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var Currency_1 = __webpack_require__(164);
var objectCreate_1 = __webpack_require__(298);
var Charge_1 = __webpack_require__(108);
var model_1 = __webpack_require__(129);
// TH 05/03/2017 -- For now, rounding all prices to nearest cent.
// This aligns w/ what QuickBooks requires.
// In the future, I could see needing to make this configurable.
exports.PRICE_PRECISION = 2;
var emDash = '\u2014';
var InvoiceNumber = {
    Title: 'Invoice Number',
    DisplayValue: function (g) { return g.InvoiceNumber(); },
    SortValue: function (g) { return g.InvoiceNumber(); },
    ClassName: 'invoice-number'
}, VesselName = {
    Title: 'Vessel',
    DisplayValue: function (g) { return g.VesselName() || emDash; },
    SortValue: function (g) { return g.VesselName() || ''; },
    ClassName: 'vessel'
}, QBCustomerId = {
    Title: 'Customer ID',
    DisplayValue: function (g) { return g.QBCustomerId(); },
    SortValue: function (g) { return g.QBCustomerId(); },
    ClassName: 'customer'
}, InvoiceDate = {
    Title: 'Invoice Date',
    DisplayValue: function (g) { return g.InvoiceDate() ? tzmoment_1.tzmoment(g.InvoiceDate()).format('M/D/YY') : emDash + "/" + emDash + "/" + emDash; },
    SortValue: function (g) { return g.InvoiceDate() || new TZDate_1.default(0); },
    ClassName: 'invoice-date'
}, ExportDate = {
    Title: 'Export Date',
    DisplayValue: function (g) { return g.ExportDate() ? tzmoment_1.tzmoment(g.ExportDate()).format('M/D/YY') : emDash + "/" + emDash + "/" + emDash; },
    SortValue: function (g) { return g.ExportDate() || new TZDate_1.default(0); },
    ClassName: 'export-date'
}, InvoiceTotal = {
    Title: 'Invoice Total',
    DisplayValue: function (g) { return g.InvoiceTotal.toString({ places: exports.PRICE_PRECISION }); },
    // TH 05/05/2017 -- Our expectation is that all charges generated for a BillingSystem
    // will be in a uniform currency. So it should be safe to compare on Num alone.
    SortValue: function (g) { return g.InvoiceTotal.Num(); },
    ClassName: 'invoice-total'
};
var DefaultSortColumn = InvoiceDate;
exports.Columns = [
    InvoiceNumber,
    VesselName,
    QBCustomerId,
    InvoiceDate,
    ExportDate,
    InvoiceTotal
];
var FilterData = function (g) {
    return g.InvoiceNumber() + ' ' +
        (g.VesselName() || '') + ' ' +
        g.QBCustomerId();
};
exports.FilterData = FilterData;
function ExportGroupList(_a) {
    var BillingSystem = _a.BillingSystem, groupOptions = _a.ExportGroups, ShowGroupSelectors = _a.ShowGroupSelectors;
    var rowSorter = model_1.RowSorter(DefaultSortColumn), exportGroups = groupOptions
        .map(function (g) { return ExportGroup(BillingSystem, g); })
        .sort(rowSorter.RowOrder);
    return {
        RowSorter: rowSorter,
        ExportGroups: exportGroups,
        ShowGroupSelectors: ShowGroupSelectors
    };
}
exports.ExportGroupList = ExportGroupList;
function ExportGroup(billingSystem, data) {
    var defaultCurrency = function () { return billingSystem.Currency() || Currency_1.default.USD; }, invoiceTotal = Charge_1.TotalPriceForCharges(data.Charges, defaultCurrency, exports.PRICE_PRECISION);
    return Object.assign(objectCreate_1.default(data), {
        InvoiceTotal: invoiceTotal
    });
}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementInFeetAndInches = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var ConvertibleMeasurement_1 = __webpack_require__(163);
var ConvertedMeasurement_1 = __webpack_require__(116);
var FEET_UNITS = {
    ticks: '\'',
    "pretty-ticks": '\u2019',
    abbrev: 'ft',
    "abbrev-period": 'ft.',
    full: 'feet'
};
var INCHES_UNITS = {
    ticks: '"',
    "pretty-ticks": '\u201D',
    abbrev: 'in',
    "abbrev-period": 'in.',
    full: 'inches'
};
var SPACE_BEFORE_UNITS = {
    ticks: '',
    "pretty-ticks": '',
    abbrev: ' ',
    "abbrev-period": ' ',
    full: ' ',
};
var SPACE_AFTER_FT_UNITS = {
    ticks: '',
    "pretty-ticks": ' ',
    abbrev: ' ',
    "abbrev-period": ' ',
    full: ' ',
};
/// <summary>
/// Like a ConvertedMeasurement, but w/ Feet and Inches observables instead of standard Num and UOM.
///
/// Like ConvertedMeasurement, for reads backingMeasurement can be a plain Measurement instance, a ConvertibleMeasurement, or a Measurement-like object w/ Num and UOM observables.
/// For writes, backingMeasurement must be a ConvertibleMeasurement.
/// </summary>
var MeasurementInFeetAndInches = /** @class */ (function () {
    function MeasurementInFeetAndInches(backingMeasurement, decimalPlaces) {
        decimalPlaces = decimalPlaces || 0;
        var converted = this._converted = new ConvertedMeasurement_1.ConvertedMeasurement(backingMeasurement, UOM_1.default.Foot, 20);
        var lastWrite = s_js_1.default.data(null);
        var feetAndInchesObj = function (obj) {
            if (obj === undefined) {
                if (converted.BindingMode() === 2 /* WRITE */)
                    return lastWrite();
                return _split(converted.Num(), decimalPlaces);
            }
            else {
                lastWrite(obj);
                var curr = _split(s_js_1.default.sample(converted.Num), decimalPlaces);
                // TH: 4/15/2016 -- Bugfix. Don't write to the backingMeasurement if the numeric value of the feet and inches fields are staying the same.
                // That prevents accidental changes caused by tabbing through a field or using arrow keys w/ in a field.
                // This comes up when there are multiple displays for the same backingMeasurement w/ a precision mismatch between the displays
                if (curr.feet !== obj.feet || curr.inches !== obj.inches) {
                    converted.Num(_join(obj.feet, obj.inches));
                }
                return obj;
            }
        };
        this.Feet = computedFeetOrInches('feet');
        this.Inches = computedFeetOrInches('inches');
        function computedFeetOrInches(key) {
            return function (val) {
                if (val === undefined) {
                    var obj = feetAndInchesObj();
                    return !obj ? null : key === 'feet' ? obj.feet : obj.inches;
                }
                else {
                    if (!(backingMeasurement instanceof ConvertibleMeasurement_1.ConvertibleMeasurement
                        || backingMeasurement instanceof ConvertibleMeasurement_1.NullableConvertibleMeasurement)) {
                        throw new Error('Can\'t write to a MeasurementInFeetAndInches unless its backingMeasurement is a ConvertibleMeasurement or NullableConvertibleMeasurement');
                    }
                    var obj = s_js_1.default.sample(feetAndInchesObj);
                    obj = obj || { feet: null, inches: null };
                    key === 'feet' ? obj.feet = val : obj.inches = val;
                    feetAndInchesObj(obj);
                    return val;
                }
            };
        }
    }
    MeasurementInFeetAndInches.prototype.toString = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.unitsStyle, unitsStyle = _c === void 0 ? 'ticks' : _c, _d = _b.padInchesLeft, padInchesLeft = _d === void 0 ? true : _d;
        var feet = this.Feet(), inches = this.Inches(), strInches;
        if (feet === null && inches === null)
            return '--';
        feet = feet || 0;
        inches = inches || 0;
        if (inches < 0 || inches - Math.floor(inches) > 0) {
            // Don't even bother trying to pretty-format negative or fractional inches
            // These can only happen as a result of direct user input to the inches field
            strInches = inches.toString();
        }
        else if (padInchesLeft) {
            // Pad inches to two digits
            strInches = ('00' + inches).substr(-2);
        }
        else {
            strInches = inches.toString();
        }
        return feet.toLocaleString() +
            SPACE_BEFORE_UNITS[unitsStyle] +
            FEET_UNITS[unitsStyle] +
            SPACE_AFTER_FT_UNITS[unitsStyle] +
            strInches +
            SPACE_BEFORE_UNITS[unitsStyle] +
            INCHES_UNITS[unitsStyle];
    };
    MeasurementInFeetAndInches.prototype.RelinquishWriter = function () {
        this._converted.RelinquishWriter();
    };
    return MeasurementInFeetAndInches;
}());
exports.MeasurementInFeetAndInches = MeasurementInFeetAndInches;
// Split number of feet into an object w/ (whole) feet and (possibly fractional) inches.
// NOTE: Handling negative values:
//   The idea is to support UX conventions where a negative feet value makes the whole value negative. E.g.:
//      -22 ft. 6 in. would mean -(22'6")
//   So -22.5 would split as { feet: -22, inches: 6 } b/c that's what needs to go in the input boxes.
//   This is admittedly counterintuitive. Hopefully negatives will hardly ever come up.
function _split(feet, places) {
    if (feet === null)
        return { feet: null, inches: null };
    var totalInches = feet * UOM_1.default.Conversion[UOM_1.default.Inch][UOM_1.default.Foot], 
    // Apply rounding to total inches before splitting into feet and inches. This handles
    // cases like _split(10.99, 0) which should be 11'0" and NOT 10'12"
    roundedTotalInches = parseFloat(totalInches.toFixed(places)), roundedFeet = roundedTotalInches * UOM_1.default.Conversion[UOM_1.default.Foot][UOM_1.default.Inch], feetWhole = roundedFeet >= 0 ? Math.floor(roundedFeet) : Math.ceil(roundedFeet), delta = roundedFeet >= 0 ? 1 : -1, inches = delta * (roundedFeet - feetWhole) * UOM_1.default.Conversion[UOM_1.default.Inch][UOM_1.default.Foot];
    return {
        feet: feetWhole,
        // Re-round inches before returning. This corrects floating point errors.
        inches: parseFloat(inches.toFixed(places))
    };
}
// Join a number of feet and inches into a single number of feet.
// NOTE: Handling of negative values:
//   The idea is to support UX conventions where a negative feet value makes the whole value negative. E.g.:
//      -22 ft. 6 in. would mean -(22'6")
//   So _join(-22, 6) would come out as -22.5.
//   Essentially, the sign of the second argument flips from what you'd expect if the first argument is negative.
//   Oddly, this makes _join(-22, -6) come to -21.5. Again, hopefully negatives will hardly ever come up.
function _join(feet, inches) {
    if (feet === null && inches === null)
        return null;
    feet = feet || 0;
    inches = inches || 0;
    var delta = feet >= 0 ? 1 : -1;
    return feet + delta * inches * UOM_1.default.Conversion[UOM_1.default.Foot][UOM_1.default.Inch];
}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscrepantScheduleDateFields = exports.DiscrepantScheduleDateFieldDisplayName = exports.DiscrepantScheduleDateField = exports.IssueSeveritys = exports.IssueSeverityDisplayName = exports.IssueSeverity = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Issues\Issue.cs
var IssueSeverity;
(function (IssueSeverity) {
    IssueSeverity[IssueSeverity["Information"] = 0] = "Information";
    IssueSeverity[IssueSeverity["Warning"] = 1] = "Warning";
    IssueSeverity[IssueSeverity["Conflict"] = 2] = "Conflict";
    IssueSeverity[IssueSeverity["Error"] = 3] = "Error";
})(IssueSeverity = exports.IssueSeverity || (exports.IssueSeverity = {}));
exports.IssueSeverityDisplayName = {
    0: 'Information',
    1: 'Warning',
    2: 'Conflict',
    3: 'Error'
};
exports.IssueSeveritys = [
    { Id: IssueSeverity.Information, Name: 'Information' },
    { Id: IssueSeverity.Warning, Name: 'Warning' },
    { Id: IssueSeverity.Conflict, Name: 'Conflict' },
    { Id: IssueSeverity.Error, Name: 'Error' }
];
var DiscrepantScheduleDateField;
(function (DiscrepantScheduleDateField) {
    DiscrepantScheduleDateField[DiscrepantScheduleDateField["Estimated"] = 0] = "Estimated";
    DiscrepantScheduleDateField[DiscrepantScheduleDateField["Actual"] = 10] = "Actual";
})(DiscrepantScheduleDateField = exports.DiscrepantScheduleDateField || (exports.DiscrepantScheduleDateField = {}));
exports.DiscrepantScheduleDateFieldDisplayName = {
    0: 'Estimated',
    10: 'Actual'
};
exports.DiscrepantScheduleDateFields = [
    { Id: DiscrepantScheduleDateField.Estimated, Name: 'Estimated' },
    { Id: DiscrepantScheduleDateField.Actual, Name: 'Actual' }
];


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallUserRoles = exports.PortCallUserRoleDisplayName = exports.PortCallUserRole = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Services\PortCallUsers\PortCallUserService.cs
var PortCallUserRole;
(function (PortCallUserRole) {
    PortCallUserRole[PortCallUserRole["Agent"] = 1] = "Agent";
    PortCallUserRole[PortCallUserRole["Requestor"] = 2] = "Requestor";
    PortCallUserRole[PortCallUserRole["SchedulingAuthority"] = 4] = "SchedulingAuthority";
    PortCallUserRole[PortCallUserRole["AgentEditor"] = 8] = "AgentEditor";
    PortCallUserRole[PortCallUserRole["InvitedEditor"] = 16] = "InvitedEditor";
    PortCallUserRole[PortCallUserRole["Watcher"] = 32] = "Watcher";
    PortCallUserRole[PortCallUserRole["Any"] = 65535] = "Any";
    PortCallUserRole[PortCallUserRole["None"] = 0] = "None";
})(PortCallUserRole = exports.PortCallUserRole || (exports.PortCallUserRole = {}));
exports.PortCallUserRoleDisplayName = {
    1: 'Agent',
    2: 'Requestor',
    4: 'SchedulingAuthority',
    8: 'AgentEditor',
    16: 'InvitedEditor',
    32: 'Watcher',
    65535: 'Any',
    0: 'None'
};
exports.PortCallUserRoles = [
    { Id: PortCallUserRole.Agent, Name: 'Agent' },
    { Id: PortCallUserRole.Requestor, Name: 'Requestor' },
    { Id: PortCallUserRole.SchedulingAuthority, Name: 'SchedulingAuthority' },
    { Id: PortCallUserRole.AgentEditor, Name: 'AgentEditor' },
    { Id: PortCallUserRole.InvitedEditor, Name: 'InvitedEditor' },
    { Id: PortCallUserRole.Watcher, Name: 'Watcher' },
    { Id: PortCallUserRole.Any, Name: 'Any' },
    { Id: PortCallUserRole.None, Name: 'None' }
];


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardStatuses = exports.TopicCardStatusDisplayName = exports.TopicCardStatus = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\TopicCards\TopicCard.cs
var TopicCardStatus;
(function (TopicCardStatus) {
    TopicCardStatus[TopicCardStatus["PendingReview"] = 0] = "PendingReview";
    TopicCardStatus[TopicCardStatus["Confirmed"] = 1] = "Confirmed";
    TopicCardStatus[TopicCardStatus["Denied"] = 2] = "Denied";
})(TopicCardStatus = exports.TopicCardStatus || (exports.TopicCardStatus = {}));
exports.TopicCardStatusDisplayName = {
    0: 'Pending Review',
    1: 'Confirmed',
    2: 'Denied'
};
exports.TopicCardStatuses = [
    { Id: TopicCardStatus.PendingReview, Name: 'Pending Review' },
    { Id: TopicCardStatus.Confirmed, Name: 'Confirmed' },
    { Id: TopicCardStatus.Denied, Name: 'Denied' }
];


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselStatuses = exports.VesselStatusDisplayName = exports.VesselStatus = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Vessels\Vessel.cs
var VesselStatus;
(function (VesselStatus) {
    VesselStatus[VesselStatus["Active"] = 0] = "Active";
    VesselStatus[VesselStatus["Pending"] = 10] = "Pending";
    VesselStatus[VesselStatus["Inactive"] = 20] = "Inactive";
})(VesselStatus = exports.VesselStatus || (exports.VesselStatus = {}));
exports.VesselStatusDisplayName = {
    0: 'Active',
    10: 'Pending',
    20: 'Inactive'
};
exports.VesselStatuses = [
    { Id: VesselStatus.Active, Name: 'Active' },
    { Id: VesselStatus.Pending, Name: 'Pending' },
    { Id: VesselStatus.Inactive, Name: 'Inactive' }
];


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(56);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(96);
var ITERATOR = __webpack_require__(24)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Leaflet, a JavaScript library for mobile-friendly interactive maps. http://leafletjs.com
 (c) 2010-2013, Vladimir Agafonkin
 (c) 2010-2011, CloudMade
*/
(function (window, document, undefined) {
var oldL = window.L,
    L = {};

L.version = '0.7.7';

// define Leaflet for Node module pattern loaders, including Browserify
if (typeof module === 'object' && typeof module.exports === 'object') {
	module.exports = L;

// define Leaflet as an AMD module
} else if (true) {
	!(__WEBPACK_AMD_DEFINE_FACTORY__ = (L),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

// define Leaflet as a global L variable, saving the original L to restore later if needed

L.noConflict = function () {
	window.L = oldL;
	return this;
};

window.L = L;


/*
 * L.Util contains various utility functions used throughout Leaflet code.
 */

L.Util = {
	extend: function (dest) { // (Object[, Object, ...]) ->
		var sources = Array.prototype.slice.call(arguments, 1),
		    i, j, len, src;

		for (j = 0, len = sources.length; j < len; j++) {
			src = sources[j] || {};
			for (i in src) {
				if (src.hasOwnProperty(i)) {
					dest[i] = src[i];
				}
			}
		}
		return dest;
	},

	bind: function (fn, obj) { // (Function, Object) -> Function
		var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
		return function () {
			return fn.apply(obj, args || arguments);
		};
	},

	stamp: (function () {
		var lastId = 0,
		    key = '_leaflet_id';
		return function (obj) {
			obj[key] = obj[key] || ++lastId;
			return obj[key];
		};
	}()),

	invokeEach: function (obj, method, context) {
		var i, args;

		if (typeof obj === 'object') {
			args = Array.prototype.slice.call(arguments, 3);

			for (i in obj) {
				method.apply(context, [i, obj[i]].concat(args));
			}
			return true;
		}

		return false;
	},

	limitExecByInterval: function (fn, time, context) {
		var lock, execOnUnlock;

		return function wrapperFn() {
			var args = arguments;

			if (lock) {
				execOnUnlock = true;
				return;
			}

			lock = true;

			setTimeout(function () {
				lock = false;

				if (execOnUnlock) {
					wrapperFn.apply(context, args);
					execOnUnlock = false;
				}
			}, time);

			fn.apply(context, args);
		};
	},

	falseFn: function () {
		return false;
	},

	formatNum: function (num, digits) {
		var pow = Math.pow(10, digits || 5);
		return Math.round(num * pow) / pow;
	},

	trim: function (str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	},

	splitWords: function (str) {
		return L.Util.trim(str).split(/\s+/);
	},

	setOptions: function (obj, options) {
		obj.options = L.extend({}, obj.options, options);
		return obj.options;
	},

	getParamString: function (obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	},
	template: function (str, data) {
		return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
			var value = data[key];
			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);
			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	},

	isArray: Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	},

	emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
};

(function () {

	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

	function getPrefixed(name) {
		var i, fn,
		    prefixes = ['webkit', 'moz', 'o', 'ms'];

		for (i = 0; i < prefixes.length && !fn; i++) {
			fn = window[prefixes[i] + name];
		}

		return fn;
	}

	var lastTime = 0;

	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));

		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}

	var requestFn = window.requestAnimationFrame ||
	        getPrefixed('RequestAnimationFrame') || timeoutDefer;

	var cancelFn = window.cancelAnimationFrame ||
	        getPrefixed('CancelAnimationFrame') ||
	        getPrefixed('CancelRequestAnimationFrame') ||
	        function (id) { window.clearTimeout(id); };


	L.Util.requestAnimFrame = function (fn, context, immediate, element) {
		fn = L.bind(fn, context);

		if (immediate && requestFn === timeoutDefer) {
			fn();
		} else {
			return requestFn.call(window, fn, element);
		}
	};

	L.Util.cancelAnimFrame = function (id) {
		if (id) {
			cancelFn.call(window, id);
		}
	};

}());

// shortcuts for most used utility functions
L.extend = L.Util.extend;
L.bind = L.Util.bind;
L.stamp = L.Util.stamp;
L.setOptions = L.Util.setOptions;


/*
 * L.Class powers the OOP facilities of the library.
 * Thanks to John Resig and Dean Edwards for inspiration!
 */

L.Class = function () {};

L.Class.extend = function (props) {

	// extended class with the new prototype
	var NewClass = function () {

		// call the constructor
		if (this.initialize) {
			this.initialize.apply(this, arguments);
		}

		// call all constructor hooks
		if (this._initHooks) {
			this.callInitHooks();
		}
	};

	// instantiate class without calling constructor
	var F = function () {};
	F.prototype = this.prototype;

	var proto = new F();
	proto.constructor = NewClass;

	NewClass.prototype = proto;

	//inherit parent's statics
	for (var i in this) {
		if (this.hasOwnProperty(i) && i !== 'prototype') {
			NewClass[i] = this[i];
		}
	}

	// mix static properties into the class
	if (props.statics) {
		L.extend(NewClass, props.statics);
		delete props.statics;
	}

	// mix includes into the prototype
	if (props.includes) {
		L.Util.extend.apply(null, [proto].concat(props.includes));
		delete props.includes;
	}

	// merge options
	if (props.options && proto.options) {
		props.options = L.extend({}, proto.options, props.options);
	}

	// mix given properties into the prototype
	L.extend(proto, props);

	proto._initHooks = [];

	var parent = this;
	// jshint camelcase: false
	NewClass.__super__ = parent.prototype;

	// add method for calling all hooks
	proto.callInitHooks = function () {

		if (this._initHooksCalled) { return; }

		if (parent.prototype.callInitHooks) {
			parent.prototype.callInitHooks.call(this);
		}

		this._initHooksCalled = true;

		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
			proto._initHooks[i].call(this);
		}
	};

	return NewClass;
};


// method for adding properties to prototype
L.Class.include = function (props) {
	L.extend(this.prototype, props);
};

// merge new default options to the Class
L.Class.mergeOptions = function (options) {
	L.extend(this.prototype.options, options);
};

// add a constructor hook
L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
	var args = Array.prototype.slice.call(arguments, 1);

	var init = typeof fn === 'function' ? fn : function () {
		this[fn].apply(this, args);
	};

	this.prototype._initHooks = this.prototype._initHooks || [];
	this.prototype._initHooks.push(init);
};


/*
 * L.Mixin.Events is used to add custom events functionality to Leaflet classes.
 */

var eventsKey = '_leaflet_events';

L.Mixin = {};

L.Mixin.Events = {

	addEventListener: function (types, fn, context) { // (String, Function[, Object]) or (Object[, Object])

		// types can be a map of types/handlers
		if (L.Util.invokeEach(types, this.addEventListener, this, fn, context)) { return this; }

		var events = this[eventsKey] = this[eventsKey] || {},
		    contextId = context && context !== this && L.stamp(context),
		    i, len, event, type, indexKey, indexLenKey, typeIndex;

		// types can be a string of space-separated words
		types = L.Util.splitWords(types);

		for (i = 0, len = types.length; i < len; i++) {
			event = {
				action: fn,
				context: context || this
			};
			type = types[i];

			if (contextId) {
				// store listeners of a particular context in a separate hash (if it has an id)
				// gives a major performance boost when removing thousands of map layers

				indexKey = type + '_idx';
				indexLenKey = indexKey + '_len';

				typeIndex = events[indexKey] = events[indexKey] || {};

				if (!typeIndex[contextId]) {
					typeIndex[contextId] = [];

					// keep track of the number of keys in the index to quickly check if it's empty
					events[indexLenKey] = (events[indexLenKey] || 0) + 1;
				}

				typeIndex[contextId].push(event);


			} else {
				events[type] = events[type] || [];
				events[type].push(event);
			}
		}

		return this;
	},

	hasEventListeners: function (type) { // (String) -> Boolean
		var events = this[eventsKey];
		return !!events && ((type in events && events[type].length > 0) ||
		                    (type + '_idx' in events && events[type + '_idx_len'] > 0));
	},

	removeEventListener: function (types, fn, context) { // ([String, Function, Object]) or (Object[, Object])

		if (!this[eventsKey]) {
			return this;
		}

		if (!types) {
			return this.clearAllEventListeners();
		}

		if (L.Util.invokeEach(types, this.removeEventListener, this, fn, context)) { return this; }

		var events = this[eventsKey],
		    contextId = context && context !== this && L.stamp(context),
		    i, len, type, listeners, j, indexKey, indexLenKey, typeIndex, removed;

		types = L.Util.splitWords(types);

		for (i = 0, len = types.length; i < len; i++) {
			type = types[i];
			indexKey = type + '_idx';
			indexLenKey = indexKey + '_len';

			typeIndex = events[indexKey];

			if (!fn) {
				// clear all listeners for a type if function isn't specified
				delete events[type];
				delete events[indexKey];
				delete events[indexLenKey];

			} else {
				listeners = contextId && typeIndex ? typeIndex[contextId] : events[type];

				if (listeners) {
					for (j = listeners.length - 1; j >= 0; j--) {
						if ((listeners[j].action === fn) && (!context || (listeners[j].context === context))) {
							removed = listeners.splice(j, 1);
							// set the old action to a no-op, because it is possible
							// that the listener is being iterated over as part of a dispatch
							removed[0].action = L.Util.falseFn;
						}
					}

					if (context && typeIndex && (listeners.length === 0)) {
						delete typeIndex[contextId];
						events[indexLenKey]--;
					}
				}
			}
		}

		return this;
	},

	clearAllEventListeners: function () {
		delete this[eventsKey];
		return this;
	},

	fireEvent: function (type, data) { // (String[, Object])
		if (!this.hasEventListeners(type)) {
			return this;
		}

		var event = L.Util.extend({}, data, { type: type, target: this });

		var events = this[eventsKey],
		    listeners, i, len, typeIndex, contextId;

		if (events[type]) {
			// make sure adding/removing listeners inside other listeners won't cause infinite loop
			listeners = events[type].slice();

			for (i = 0, len = listeners.length; i < len; i++) {
				listeners[i].action.call(listeners[i].context, event);
			}
		}

		// fire event for the context-indexed listeners as well
		typeIndex = events[type + '_idx'];

		for (contextId in typeIndex) {
			listeners = typeIndex[contextId].slice();

			if (listeners) {
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].action.call(listeners[i].context, event);
				}
			}
		}

		return this;
	},

	addOneTimeEventListener: function (types, fn, context) {

		if (L.Util.invokeEach(types, this.addOneTimeEventListener, this, fn, context)) { return this; }

		var handler = L.bind(function () {
			this
			    .removeEventListener(types, fn, context)
			    .removeEventListener(types, handler, context);
		}, this);

		return this
		    .addEventListener(types, fn, context)
		    .addEventListener(types, handler, context);
	}
};

L.Mixin.Events.on = L.Mixin.Events.addEventListener;
L.Mixin.Events.off = L.Mixin.Events.removeEventListener;
L.Mixin.Events.once = L.Mixin.Events.addOneTimeEventListener;
L.Mixin.Events.fire = L.Mixin.Events.fireEvent;


/*
 * L.Browser handles different browser and feature detections for internal Leaflet use.
 */

(function () {

	var ie = 'ActiveXObject' in window,
		ielt9 = ie && !document.addEventListener,

	    // terrible browser detection to work around Safari / iOS / Android browser bugs
	    ua = navigator.userAgent.toLowerCase(),
	    webkit = ua.indexOf('webkit') !== -1,
	    chrome = ua.indexOf('chrome') !== -1,
	    phantomjs = ua.indexOf('phantom') !== -1,
	    android = ua.indexOf('android') !== -1,
	    android23 = ua.search('android [23]') !== -1,
		gecko = ua.indexOf('gecko') !== -1,

	    mobile = typeof orientation !== undefined + '',
	    msPointer = !window.PointerEvent && window.MSPointerEvent,
		pointer = (window.PointerEvent && window.navigator.pointerEnabled) ||
				  msPointer,
	    retina = ('devicePixelRatio' in window && window.devicePixelRatio > 1) ||
	             ('matchMedia' in window && window.matchMedia('(min-resolution:144dpi)') &&
	              window.matchMedia('(min-resolution:144dpi)').matches),

	    doc = document.documentElement,
	    ie3d = ie && ('transition' in doc.style),
	    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
	    gecko3d = 'MozPerspective' in doc.style,
	    opera3d = 'OTransition' in doc.style,
	    any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d || opera3d) && !phantomjs;

	var touch = !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window ||
		(window.DocumentTouch && document instanceof window.DocumentTouch));

	L.Browser = {
		ie: ie,
		ielt9: ielt9,
		webkit: webkit,
		gecko: gecko && !webkit && !window.opera && !ie,

		android: android,
		android23: android23,

		chrome: chrome,

		ie3d: ie3d,
		webkit3d: webkit3d,
		gecko3d: gecko3d,
		opera3d: opera3d,
		any3d: any3d,

		mobile: mobile,
		mobileWebkit: mobile && webkit,
		mobileWebkit3d: mobile && webkit3d,
		mobileOpera: mobile && window.opera,

		touch: touch,
		msPointer: msPointer,
		pointer: pointer,

		retina: retina
	};

}());


/*
 * L.Point represents a point with x and y coordinates.
 */

L.Point = function (/*Number*/ x, /*Number*/ y, /*Boolean*/ round) {
	this.x = (round ? Math.round(x) : x);
	this.y = (round ? Math.round(y) : y);
};

L.Point.prototype = {

	clone: function () {
		return new L.Point(this.x, this.y);
	},

	// non-destructive, returns a new point
	add: function (point) {
		return this.clone()._add(L.point(point));
	},

	// destructive, used directly for performance in situations where it's safe to modify existing point
	_add: function (point) {
		this.x += point.x;
		this.y += point.y;
		return this;
	},

	subtract: function (point) {
		return this.clone()._subtract(L.point(point));
	},

	_subtract: function (point) {
		this.x -= point.x;
		this.y -= point.y;
		return this;
	},

	divideBy: function (num) {
		return this.clone()._divideBy(num);
	},

	_divideBy: function (num) {
		this.x /= num;
		this.y /= num;
		return this;
	},

	multiplyBy: function (num) {
		return this.clone()._multiplyBy(num);
	},

	_multiplyBy: function (num) {
		this.x *= num;
		this.y *= num;
		return this;
	},

	round: function () {
		return this.clone()._round();
	},

	_round: function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	},

	floor: function () {
		return this.clone()._floor();
	},

	_floor: function () {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		return this;
	},

	distanceTo: function (point) {
		point = L.point(point);

		var x = point.x - this.x,
		    y = point.y - this.y;

		return Math.sqrt(x * x + y * y);
	},

	equals: function (point) {
		point = L.point(point);

		return point.x === this.x &&
		       point.y === this.y;
	},

	contains: function (point) {
		point = L.point(point);

		return Math.abs(point.x) <= Math.abs(this.x) &&
		       Math.abs(point.y) <= Math.abs(this.y);
	},

	toString: function () {
		return 'Point(' +
		        L.Util.formatNum(this.x) + ', ' +
		        L.Util.formatNum(this.y) + ')';
	}
};

L.point = function (x, y, round) {
	if (x instanceof L.Point) {
		return x;
	}
	if (L.Util.isArray(x)) {
		return new L.Point(x[0], x[1]);
	}
	if (x === undefined || x === null) {
		return x;
	}
	return new L.Point(x, y, round);
};


/*
 * L.Bounds represents a rectangular area on the screen in pixel coordinates.
 */

L.Bounds = function (a, b) { //(Point, Point) or Point[]
	if (!a) { return; }

	var points = b ? [a, b] : a;

	for (var i = 0, len = points.length; i < len; i++) {
		this.extend(points[i]);
	}
};

L.Bounds.prototype = {
	// extend the bounds to contain the given point
	extend: function (point) { // (Point)
		point = L.point(point);

		if (!this.min && !this.max) {
			this.min = point.clone();
			this.max = point.clone();
		} else {
			this.min.x = Math.min(point.x, this.min.x);
			this.max.x = Math.max(point.x, this.max.x);
			this.min.y = Math.min(point.y, this.min.y);
			this.max.y = Math.max(point.y, this.max.y);
		}
		return this;
	},

	getCenter: function (round) { // (Boolean) -> Point
		return new L.Point(
		        (this.min.x + this.max.x) / 2,
		        (this.min.y + this.max.y) / 2, round);
	},

	getBottomLeft: function () { // -> Point
		return new L.Point(this.min.x, this.max.y);
	},

	getTopRight: function () { // -> Point
		return new L.Point(this.max.x, this.min.y);
	},

	getSize: function () {
		return this.max.subtract(this.min);
	},

	contains: function (obj) { // (Bounds) or (Point) -> Boolean
		var min, max;

		if (typeof obj[0] === 'number' || obj instanceof L.Point) {
			obj = L.point(obj);
		} else {
			obj = L.bounds(obj);
		}

		if (obj instanceof L.Bounds) {
			min = obj.min;
			max = obj.max;
		} else {
			min = max = obj;
		}

		return (min.x >= this.min.x) &&
		       (max.x <= this.max.x) &&
		       (min.y >= this.min.y) &&
		       (max.y <= this.max.y);
	},

	intersects: function (bounds) { // (Bounds) -> Boolean
		bounds = L.bounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

		return xIntersects && yIntersects;
	},

	isValid: function () {
		return !!(this.min && this.max);
	}
};

L.bounds = function (a, b) { // (Bounds) or (Point, Point) or (Point[])
	if (!a || a instanceof L.Bounds) {
		return a;
	}
	return new L.Bounds(a, b);
};


/*
 * L.Transformation is an utility class to perform simple point transformations through a 2d-matrix.
 */

L.Transformation = function (a, b, c, d) {
	this._a = a;
	this._b = b;
	this._c = c;
	this._d = d;
};

L.Transformation.prototype = {
	transform: function (point, scale) { // (Point, Number) -> Point
		return this._transform(point.clone(), scale);
	},

	// destructive transform (faster)
	_transform: function (point, scale) {
		scale = scale || 1;
		point.x = scale * (this._a * point.x + this._b);
		point.y = scale * (this._c * point.y + this._d);
		return point;
	},

	untransform: function (point, scale) {
		scale = scale || 1;
		return new L.Point(
		        (point.x / scale - this._b) / this._a,
		        (point.y / scale - this._d) / this._c);
	}
};


/*
 * L.DomUtil contains various utility functions for working with DOM.
 */

L.DomUtil = {
	get: function (id) {
		return (typeof id === 'string' ? document.getElementById(id) : id);
	},

	getStyle: function (el, style) {

		var value = el.style[style];

		if (!value && el.currentStyle) {
			value = el.currentStyle[style];
		}

		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}

		return value === 'auto' ? null : value;
	},

	getViewportOffset: function (element) {

		var top = 0,
		    left = 0,
		    el = element,
		    docBody = document.body,
		    docEl = document.documentElement,
		    pos;

		do {
			top  += el.offsetTop  || 0;
			left += el.offsetLeft || 0;

			//add borders
			top += parseInt(L.DomUtil.getStyle(el, 'borderTopWidth'), 10) || 0;
			left += parseInt(L.DomUtil.getStyle(el, 'borderLeftWidth'), 10) || 0;

			pos = L.DomUtil.getStyle(el, 'position');

			if (el.offsetParent === docBody && pos === 'absolute') { break; }

			if (pos === 'fixed') {
				top  += docBody.scrollTop  || docEl.scrollTop  || 0;
				left += docBody.scrollLeft || docEl.scrollLeft || 0;
				break;
			}

			if (pos === 'relative' && !el.offsetLeft) {
				var width = L.DomUtil.getStyle(el, 'width'),
				    maxWidth = L.DomUtil.getStyle(el, 'max-width'),
				    r = el.getBoundingClientRect();

				if (width !== 'none' || maxWidth !== 'none') {
					left += r.left + el.clientLeft;
				}

				//calculate full y offset since we're breaking out of the loop
				top += r.top + (docBody.scrollTop  || docEl.scrollTop  || 0);

				break;
			}

			el = el.offsetParent;

		} while (el);

		el = element;

		do {
			if (el === docBody) { break; }

			top  -= el.scrollTop  || 0;
			left -= el.scrollLeft || 0;

			el = el.parentNode;
		} while (el);

		return new L.Point(left, top);
	},

	documentIsLtr: function () {
		if (!L.DomUtil._docIsLtrCached) {
			L.DomUtil._docIsLtrCached = true;
			L.DomUtil._docIsLtr = L.DomUtil.getStyle(document.body, 'direction') === 'ltr';
		}
		return L.DomUtil._docIsLtr;
	},

	create: function (tagName, className, container) {

		var el = document.createElement(tagName);
		el.className = className;

		if (container) {
			container.appendChild(el);
		}

		return el;
	},

	hasClass: function (el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = L.DomUtil._getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	},

	addClass: function (el, name) {
		if (el.classList !== undefined) {
			var classes = L.Util.splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!L.DomUtil.hasClass(el, name)) {
			var className = L.DomUtil._getClass(el);
			L.DomUtil._setClass(el, (className ? className + ' ' : '') + name);
		}
	},

	removeClass: function (el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			L.DomUtil._setClass(el, L.Util.trim((' ' + L.DomUtil._getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	},

	_setClass: function (el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	},

	_getClass: function (el) {
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	},

	setOpacity: function (el, value) {

		if ('opacity' in el.style) {
			el.style.opacity = value;

		} else if ('filter' in el.style) {

			var filter = false,
			    filterName = 'DXImageTransform.Microsoft.Alpha';

			// filters collection throws an error if we try to retrieve a filter that doesn't exist
			try {
				filter = el.filters.item(filterName);
			} catch (e) {
				// don't set opacity to 1 if we haven't already set an opacity,
				// it isn't needed and breaks transparent pngs.
				if (value === 1) { return; }
			}

			value = Math.round(value * 100);

			if (filter) {
				filter.Enabled = (value !== 100);
				filter.Opacity = value;
			} else {
				el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
			}
		}
	},

	testProp: function (props) {

		var style = document.documentElement.style;

		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	},

	getTranslateString: function (point) {
		// on WebKit browsers (Chrome/Safari/iOS Safari/Android) using translate3d instead of translate
		// makes animation smoother as it ensures HW accel is used. Firefox 13 doesn't care
		// (same speed either way), Opera 12 doesn't support translate3d

		var is3d = L.Browser.webkit3d,
		    open = 'translate' + (is3d ? '3d' : '') + '(',
		    close = (is3d ? ',0' : '') + ')';

		return open + point.x + 'px,' + point.y + 'px' + close;
	},

	getScaleString: function (scale, origin) {

		var preTranslateStr = L.DomUtil.getTranslateString(origin.add(origin.multiplyBy(-1 * scale))),
		    scaleStr = ' scale(' + scale + ') ';

		return preTranslateStr + scaleStr;
	},

	setPosition: function (el, point, disable3D) { // (HTMLElement, Point[, Boolean])

		// jshint camelcase: false
		el._leaflet_pos = point;

		if (!disable3D && L.Browser.any3d) {
			el.style[L.DomUtil.TRANSFORM] =  L.DomUtil.getTranslateString(point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	},

	getPosition: function (el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance

		// jshint camelcase: false
		return el._leaflet_pos;
	}
};


// prefix style property names

L.DomUtil.TRANSFORM = L.DomUtil.testProp(
        ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);

// webkitTransition comes first because some browser versions that drop vendor prefix don't do
// the same for the transitionend event, in particular the Android 4.1 stock browser

L.DomUtil.TRANSITION = L.DomUtil.testProp(
        ['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

L.DomUtil.TRANSITION_END =
        L.DomUtil.TRANSITION === 'webkitTransition' || L.DomUtil.TRANSITION === 'OTransition' ?
        L.DomUtil.TRANSITION + 'End' : 'transitionend';

(function () {
    if ('onselectstart' in document) {
        L.extend(L.DomUtil, {
            disableTextSelection: function () {
                L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
            },

            enableTextSelection: function () {
                L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
            }
        });
    } else {
        var userSelectProperty = L.DomUtil.testProp(
            ['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

        L.extend(L.DomUtil, {
            disableTextSelection: function () {
                if (userSelectProperty) {
                    var style = document.documentElement.style;
                    this._userSelect = style[userSelectProperty];
                    style[userSelectProperty] = 'none';
                }
            },

            enableTextSelection: function () {
                if (userSelectProperty) {
                    document.documentElement.style[userSelectProperty] = this._userSelect;
                    delete this._userSelect;
                }
            }
        });
    }

	L.extend(L.DomUtil, {
		disableImageDrag: function () {
			L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
		},

		enableImageDrag: function () {
			L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
		}
	});
})();


/*
 * L.LatLng represents a geographical point with latitude and longitude coordinates.
 */

L.LatLng = function (lat, lng, alt) { // (Number, Number, Number)
	lat = parseFloat(lat);
	lng = parseFloat(lng);

	if (isNaN(lat) || isNaN(lng)) {
		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	}

	this.lat = lat;
	this.lng = lng;

	if (alt !== undefined) {
		this.alt = parseFloat(alt);
	}
};

L.extend(L.LatLng, {
	DEG_TO_RAD: Math.PI / 180,
	RAD_TO_DEG: 180 / Math.PI,
	MAX_MARGIN: 1.0E-9 // max margin of error for the "equals" check
});

L.LatLng.prototype = {
	equals: function (obj) { // (LatLng) -> Boolean
		if (!obj) { return false; }

		obj = L.latLng(obj);

		var margin = Math.max(
		        Math.abs(this.lat - obj.lat),
		        Math.abs(this.lng - obj.lng));

		return margin <= L.LatLng.MAX_MARGIN;
	},

	toString: function (precision) { // (Number) -> String
		return 'LatLng(' +
		        L.Util.formatNum(this.lat, precision) + ', ' +
		        L.Util.formatNum(this.lng, precision) + ')';
	},

	// Haversine distance formula, see http://en.wikipedia.org/wiki/Haversine_formula
	// TODO move to projection code, LatLng shouldn't know about Earth
	distanceTo: function (other) { // (LatLng) -> Number
		other = L.latLng(other);

		var R = 6378137, // earth radius in meters
		    d2r = L.LatLng.DEG_TO_RAD,
		    dLat = (other.lat - this.lat) * d2r,
		    dLon = (other.lng - this.lng) * d2r,
		    lat1 = this.lat * d2r,
		    lat2 = other.lat * d2r,
		    sin1 = Math.sin(dLat / 2),
		    sin2 = Math.sin(dLon / 2);

		var a = sin1 * sin1 + sin2 * sin2 * Math.cos(lat1) * Math.cos(lat2);

		return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	},

	wrap: function (a, b) { // (Number, Number) -> LatLng
		var lng = this.lng;

		a = a || -180;
		b = b ||  180;

		lng = (lng + b) % (b - a) + (lng < a || lng === b ? b : a);

		return new L.LatLng(this.lat, lng);
	}
};

L.latLng = function (a, b) { // (LatLng) or ([Number, Number]) or (Number, Number)
	if (a instanceof L.LatLng) {
		return a;
	}
	if (L.Util.isArray(a)) {
		if (typeof a[0] === 'number' || typeof a[0] === 'string') {
			return new L.LatLng(a[0], a[1], a[2]);
		} else {
			return null;
		}
	}
	if (a === undefined || a === null) {
		return a;
	}
	if (typeof a === 'object' && 'lat' in a) {
		return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon);
	}
	if (b === undefined) {
		return null;
	}
	return new L.LatLng(a, b);
};



/*
 * L.LatLngBounds represents a rectangular area on the map in geographical coordinates.
 */

L.LatLngBounds = function (southWest, northEast) { // (LatLng, LatLng) or (LatLng[])
	if (!southWest) { return; }

	var latlngs = northEast ? [southWest, northEast] : southWest;

	for (var i = 0, len = latlngs.length; i < len; i++) {
		this.extend(latlngs[i]);
	}
};

L.LatLngBounds.prototype = {
	// extend the bounds to contain the given point or bounds
	extend: function (obj) { // (LatLng) or (LatLngBounds)
		if (!obj) { return this; }

		var latLng = L.latLng(obj);
		if (latLng !== null) {
			obj = latLng;
		} else {
			obj = L.latLngBounds(obj);
		}

		if (obj instanceof L.LatLng) {
			if (!this._southWest && !this._northEast) {
				this._southWest = new L.LatLng(obj.lat, obj.lng);
				this._northEast = new L.LatLng(obj.lat, obj.lng);
			} else {
				this._southWest.lat = Math.min(obj.lat, this._southWest.lat);
				this._southWest.lng = Math.min(obj.lng, this._southWest.lng);

				this._northEast.lat = Math.max(obj.lat, this._northEast.lat);
				this._northEast.lng = Math.max(obj.lng, this._northEast.lng);
			}
		} else if (obj instanceof L.LatLngBounds) {
			this.extend(obj._southWest);
			this.extend(obj._northEast);
		}
		return this;
	},

	// extend the bounds by a percentage
	pad: function (bufferRatio) { // (Number) -> LatLngBounds
		var sw = this._southWest,
		    ne = this._northEast,
		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

		return new L.LatLngBounds(
		        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
		        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	},

	getCenter: function () { // -> LatLng
		return new L.LatLng(
		        (this._southWest.lat + this._northEast.lat) / 2,
		        (this._southWest.lng + this._northEast.lng) / 2);
	},

	getSouthWest: function () {
		return this._southWest;
	},

	getNorthEast: function () {
		return this._northEast;
	},

	getNorthWest: function () {
		return new L.LatLng(this.getNorth(), this.getWest());
	},

	getSouthEast: function () {
		return new L.LatLng(this.getSouth(), this.getEast());
	},

	getWest: function () {
		return this._southWest.lng;
	},

	getSouth: function () {
		return this._southWest.lat;
	},

	getEast: function () {
		return this._northEast.lng;
	},

	getNorth: function () {
		return this._northEast.lat;
	},

	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
		if (typeof obj[0] === 'number' || obj instanceof L.LatLng) {
			obj = L.latLng(obj);
		} else {
			obj = L.latLngBounds(obj);
		}

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof L.LatLngBounds) {
			sw2 = obj.getSouthWest();
			ne2 = obj.getNorthEast();
		} else {
			sw2 = ne2 = obj;
		}

		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	},

	intersects: function (bounds) { // (LatLngBounds)
		bounds = L.latLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

		return latIntersects && lngIntersects;
	},

	toBBoxString: function () {
		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	},

	equals: function (bounds) { // (LatLngBounds)
		if (!bounds) { return false; }

		bounds = L.latLngBounds(bounds);

		return this._southWest.equals(bounds.getSouthWest()) &&
		       this._northEast.equals(bounds.getNorthEast());
	},

	isValid: function () {
		return !!(this._southWest && this._northEast);
	}
};

//TODO International date line?

L.latLngBounds = function (a, b) { // (LatLngBounds) or (LatLng, LatLng)
	if (!a || a instanceof L.LatLngBounds) {
		return a;
	}
	return new L.LatLngBounds(a, b);
};


/*
 * L.Projection contains various geographical projections used by CRS classes.
 */

L.Projection = {};


/*
 * Spherical Mercator is the most popular map projection, used by EPSG:3857 CRS used by default.
 */

L.Projection.SphericalMercator = {
	MAX_LATITUDE: 85.0511287798,

	project: function (latlng) { // (LatLng) -> Point
		var d = L.LatLng.DEG_TO_RAD,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    x = latlng.lng * d,
		    y = lat * d;

		y = Math.log(Math.tan((Math.PI / 4) + (y / 2)));

		return new L.Point(x, y);
	},

	unproject: function (point) { // (Point, Boolean) -> LatLng
		var d = L.LatLng.RAD_TO_DEG,
		    lng = point.x * d,
		    lat = (2 * Math.atan(Math.exp(point.y)) - (Math.PI / 2)) * d;

		return new L.LatLng(lat, lng);
	}
};


/*
 * Simple equirectangular (Plate Carree) projection, used by CRS like EPSG:4326 and Simple.
 */

L.Projection.LonLat = {
	project: function (latlng) {
		return new L.Point(latlng.lng, latlng.lat);
	},

	unproject: function (point) {
		return new L.LatLng(point.y, point.x);
	}
};


/*
 * L.CRS is a base object for all defined CRS (Coordinate Reference Systems) in Leaflet.
 */

L.CRS = {
	latLngToPoint: function (latlng, zoom) { // (LatLng, Number) -> Point
		var projectedPoint = this.projection.project(latlng),
		    scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	pointToLatLng: function (point, zoom) { // (Point, Number[, Boolean]) -> LatLng
		var scale = this.scale(zoom),
		    untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	project: function (latlng) {
		return this.projection.project(latlng);
	},

	scale: function (zoom) {
		return 256 * Math.pow(2, zoom);
	},

	getSize: function (zoom) {
		var s = this.scale(zoom);
		return L.point(s, s);
	}
};


/*
 * A simple CRS that can be used for flat non-Earth maps like panoramas or game maps.
 */

L.CRS.Simple = L.extend({}, L.CRS, {
	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1, 0, -1, 0),

	scale: function (zoom) {
		return Math.pow(2, zoom);
	}
});


/*
 * L.CRS.EPSG3857 (Spherical Mercator) is the most common CRS for web mapping
 * and is used by Leaflet by default.
 */

L.CRS.EPSG3857 = L.extend({}, L.CRS, {
	code: 'EPSG:3857',

	projection: L.Projection.SphericalMercator,
	transformation: new L.Transformation(0.5 / Math.PI, 0.5, -0.5 / Math.PI, 0.5),

	project: function (latlng) { // (LatLng) -> Point
		var projectedPoint = this.projection.project(latlng),
		    earthRadius = 6378137;
		return projectedPoint.multiplyBy(earthRadius);
	}
});

L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
	code: 'EPSG:900913'
});


/*
 * L.CRS.EPSG4326 is a CRS popular among advanced GIS specialists.
 */

L.CRS.EPSG4326 = L.extend({}, L.CRS, {
	code: 'EPSG:4326',

	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1 / 360, 0.5, -1 / 360, 0.5)
});


/*
 * L.Map is the central class of the API - it is used to create a map.
 */

L.Map = L.Class.extend({

	includes: L.Mixin.Events,

	options: {
		crs: L.CRS.EPSG3857,

		/*
		center: LatLng,
		zoom: Number,
		layers: Array,
		*/

		fadeAnimation: L.DomUtil.TRANSITION && !L.Browser.android23,
		trackResize: true,
		markerZoomAnimation: L.DomUtil.TRANSITION && L.Browser.any3d
	},

	initialize: function (id, options) { // (HTMLElement or String, Object)
		options = L.setOptions(this, options);


		this._initContainer(id);
		this._initLayout();

		// hack for https://github.com/Leaflet/Leaflet/issues/1980
		this._onResize = L.bind(this._onResize, this);

		this._initEvents();

		if (options.maxBounds) {
			this.setMaxBounds(options.maxBounds);
		}

		if (options.center && options.zoom !== undefined) {
			this.setView(L.latLng(options.center), options.zoom, {reset: true});
		}

		this._handlers = [];

		this._layers = {};
		this._zoomBoundLayers = {};
		this._tileLayersNum = 0;

		this.callInitHooks();

		this._addLayers(options.layers);
	},


	// public methods that modify map state

	// replaced by animation-powered implementation in Map.PanAnimation.js
	setView: function (center, zoom) {
		zoom = zoom === undefined ? this.getZoom() : zoom;
		this._resetView(L.latLng(center), this._limitZoom(zoom));
		return this;
	},

	setZoom: function (zoom, options) {
		if (!this._loaded) {
			this._zoom = this._limitZoom(zoom);
			return this;
		}
		return this.setView(this.getCenter(), zoom, {zoom: options});
	},

	zoomIn: function (delta, options) {
		return this.setZoom(this._zoom + (delta || 1), options);
	},

	zoomOut: function (delta, options) {
		return this.setZoom(this._zoom - (delta || 1), options);
	},

	setZoomAround: function (latlng, zoom, options) {
		var scale = this.getZoomScale(zoom),
		    viewHalf = this.getSize().divideBy(2),
		    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),

		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

		return this.setView(newCenter, zoom, {zoom: options});
	},

	fitBounds: function (bounds, options) {

		options = options || {};
		bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);

		var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
		    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),

		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

		zoom = (options.maxZoom) ? Math.min(options.maxZoom, zoom) : zoom;

		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

		    swPoint = this.project(bounds.getSouthWest(), zoom),
		    nePoint = this.project(bounds.getNorthEast(), zoom),
		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

		return this.setView(center, zoom, options);
	},

	fitWorld: function (options) {
		return this.fitBounds([[-90, -180], [90, 180]], options);
	},

	panTo: function (center, options) { // (LatLng)
		return this.setView(center, this._zoom, {pan: options});
	},

	panBy: function (offset) { // (Point)
		// replaced with animated panBy in Map.PanAnimation.js
		this.fire('movestart');

		this._rawPanBy(L.point(offset));

		this.fire('move');
		return this.fire('moveend');
	},

	setMaxBounds: function (bounds) {
		bounds = L.latLngBounds(bounds);

		this.options.maxBounds = bounds;

		if (!bounds) {
			return this.off('moveend', this._panInsideMaxBounds, this);
		}

		if (this._loaded) {
			this._panInsideMaxBounds();
		}

		return this.on('moveend', this._panInsideMaxBounds, this);
	},

	panInsideBounds: function (bounds, options) {
		var center = this.getCenter(),
			newCenter = this._limitCenter(center, this._zoom, bounds);

		if (center.equals(newCenter)) { return this; }

		return this.panTo(newCenter, options);
	},

	addLayer: function (layer) {
		// TODO method is too big, refactor

		var id = L.stamp(layer);

		if (this._layers[id]) { return this; }

		this._layers[id] = layer;

		// TODO getMaxZoom, getMinZoom in ILayer (instead of options)
		if (layer.options && (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom))) {
			this._zoomBoundLayers[id] = layer;
			this._updateZoomLevels();
		}

		// TODO looks ugly, refactor!!!
		if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
			this._tileLayersNum++;
			this._tileLayersToLoad++;
			layer.on('load', this._onTileLayerLoad, this);
		}

		if (this._loaded) {
			this._layerAdd(layer);
		}

		return this;
	},

	removeLayer: function (layer) {
		var id = L.stamp(layer);

		if (!this._layers[id]) { return this; }

		if (this._loaded) {
			layer.onRemove(this);
		}

		delete this._layers[id];

		if (this._loaded) {
			this.fire('layerremove', {layer: layer});
		}

		if (this._zoomBoundLayers[id]) {
			delete this._zoomBoundLayers[id];
			this._updateZoomLevels();
		}

		// TODO looks ugly, refactor
		if (this.options.zoomAnimation && L.TileLayer && (layer instanceof L.TileLayer)) {
			this._tileLayersNum--;
			this._tileLayersToLoad--;
			layer.off('load', this._onTileLayerLoad, this);
		}

		return this;
	},

	hasLayer: function (layer) {
		if (!layer) { return false; }

		return (L.stamp(layer) in this._layers);
	},

	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	invalidateSize: function (options) {
		if (!this._loaded) { return this; }

		options = L.extend({
			animate: false,
			pan: true
		}, options === true ? {animate: true} : options);

		var oldSize = this.getSize();
		this._sizeChanged = true;
		this._initialCenter = null;

		var newSize = this.getSize(),
		    oldCenter = oldSize.divideBy(2).round(),
		    newCenter = newSize.divideBy(2).round(),
		    offset = oldCenter.subtract(newCenter);

		if (!offset.x && !offset.y) { return this; }

		if (options.animate && options.pan) {
			this.panBy(offset);

		} else {
			if (options.pan) {
				this._rawPanBy(offset);
			}

			this.fire('move');

			if (options.debounceMoveend) {
				clearTimeout(this._sizeTimer);
				this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
			} else {
				this.fire('moveend');
			}
		}

		return this.fire('resize', {
			oldSize: oldSize,
			newSize: newSize
		});
	},

	// TODO handler.addTo
	addHandler: function (name, HandlerClass) {
		if (!HandlerClass) { return this; }

		var handler = this[name] = new HandlerClass(this);

		this._handlers.push(handler);

		if (this.options[name]) {
			handler.enable();
		}

		return this;
	},

	remove: function () {
		if (this._loaded) {
			this.fire('unload');
		}

		this._initEvents('off');

		try {
			// throws error in IE6-8
			delete this._container._leaflet;
		} catch (e) {
			this._container._leaflet = undefined;
		}

		this._clearPanes();
		if (this._clearControlPos) {
			this._clearControlPos();
		}

		this._clearHandlers();

		return this;
	},


	// public methods for getting map state

	getCenter: function () { // (Boolean) -> LatLng
		this._checkIfLoaded();

		if (this._initialCenter && !this._moved()) {
			return this._initialCenter;
		}
		return this.layerPointToLatLng(this._getCenterLayerPoint());
	},

	getZoom: function () {
		return this._zoom;
	},

	getBounds: function () {
		var bounds = this.getPixelBounds(),
		    sw = this.unproject(bounds.getBottomLeft()),
		    ne = this.unproject(bounds.getTopRight());

		return new L.LatLngBounds(sw, ne);
	},

	getMinZoom: function () {
		return this.options.minZoom === undefined ?
			(this._layersMinZoom === undefined ? 0 : this._layersMinZoom) :
			this.options.minZoom;
	},

	getMaxZoom: function () {
		return this.options.maxZoom === undefined ?
			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
			this.options.maxZoom;
	},

	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
		bounds = L.latLngBounds(bounds);

		var zoom = this.getMinZoom() - (inside ? 1 : 0),
		    maxZoom = this.getMaxZoom(),
		    size = this.getSize(),

		    nw = bounds.getNorthWest(),
		    se = bounds.getSouthEast(),

		    zoomNotFound = true,
		    boundsSize;

		padding = L.point(padding || [0, 0]);

		do {
			zoom++;
			boundsSize = this.project(se, zoom).subtract(this.project(nw, zoom)).add(padding);
			zoomNotFound = !inside ? size.contains(boundsSize) : boundsSize.x < size.x || boundsSize.y < size.y;

		} while (zoomNotFound && zoom <= maxZoom);

		if (zoomNotFound && inside) {
			return null;
		}

		return inside ? zoom : zoom - 1;
	},

	getSize: function () {
		if (!this._size || this._sizeChanged) {
			this._size = new L.Point(
				this._container.clientWidth,
				this._container.clientHeight);

			this._sizeChanged = false;
		}
		return this._size.clone();
	},

	getPixelBounds: function () {
		var topLeftPoint = this._getTopLeftPoint();
		return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	},

	getPixelOrigin: function () {
		this._checkIfLoaded();
		return this._initialTopLeftPoint;
	},

	getPanes: function () {
		return this._panes;
	},

	getContainer: function () {
		return this._container;
	},


	// TODO replace with universal implementation after refactoring projections

	getZoomScale: function (toZoom) {
		var crs = this.options.crs;
		return crs.scale(toZoom) / crs.scale(this._zoom);
	},

	getScaleZoom: function (scale) {
		return this._zoom + (Math.log(scale) / Math.LN2);
	},


	// conversion methods

	project: function (latlng, zoom) { // (LatLng[, Number]) -> Point
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
	},

	unproject: function (point, zoom) { // (Point[, Number]) -> LatLng
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.pointToLatLng(L.point(point), zoom);
	},

	layerPointToLatLng: function (point) { // (Point)
		var projectedPoint = L.point(point).add(this.getPixelOrigin());
		return this.unproject(projectedPoint);
	},

	latLngToLayerPoint: function (latlng) { // (LatLng)
		var projectedPoint = this.project(L.latLng(latlng))._round();
		return projectedPoint._subtract(this.getPixelOrigin());
	},

	containerPointToLayerPoint: function (point) { // (Point)
		return L.point(point).subtract(this._getMapPanePos());
	},

	layerPointToContainerPoint: function (point) { // (Point)
		return L.point(point).add(this._getMapPanePos());
	},

	containerPointToLatLng: function (point) {
		var layerPoint = this.containerPointToLayerPoint(L.point(point));
		return this.layerPointToLatLng(layerPoint);
	},

	latLngToContainerPoint: function (latlng) {
		return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
	},

	mouseEventToContainerPoint: function (e) { // (MouseEvent)
		return L.DomEvent.getMousePosition(e, this._container);
	},

	mouseEventToLayerPoint: function (e) { // (MouseEvent)
		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	},

	mouseEventToLatLng: function (e) { // (MouseEvent)
		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	},


	// map initialization methods

	_initContainer: function (id) {
		var container = this._container = L.DomUtil.get(id);

		if (!container) {
			throw new Error('Map container not found.');
		} else if (container._leaflet) {
			throw new Error('Map container is already initialized.');
		}

		container._leaflet = true;
	},

	_initLayout: function () {
		var container = this._container;

		L.DomUtil.addClass(container, 'leaflet-container' +
			(L.Browser.touch ? ' leaflet-touch' : '') +
			(L.Browser.retina ? ' leaflet-retina' : '') +
			(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
			(this.options.fadeAnimation ? ' leaflet-fade-anim' : ''));

		var position = L.DomUtil.getStyle(container, 'position');

		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
			container.style.position = 'relative';
		}

		this._initPanes();

		if (this._initControlPos) {
			this._initControlPos();
		}
	},

	_initPanes: function () {
		var panes = this._panes = {};

		this._mapPane = panes.mapPane = this._createPane('leaflet-map-pane', this._container);

		this._tilePane = panes.tilePane = this._createPane('leaflet-tile-pane', this._mapPane);
		panes.objectsPane = this._createPane('leaflet-objects-pane', this._mapPane);
		panes.shadowPane = this._createPane('leaflet-shadow-pane');
		panes.overlayPane = this._createPane('leaflet-overlay-pane');
		panes.markerPane = this._createPane('leaflet-marker-pane');
		panes.popupPane = this._createPane('leaflet-popup-pane');

		var zoomHide = ' leaflet-zoom-hide';

		if (!this.options.markerZoomAnimation) {
			L.DomUtil.addClass(panes.markerPane, zoomHide);
			L.DomUtil.addClass(panes.shadowPane, zoomHide);
			L.DomUtil.addClass(panes.popupPane, zoomHide);
		}
	},

	_createPane: function (className, container) {
		return L.DomUtil.create('div', className, container || this._panes.objectsPane);
	},

	_clearPanes: function () {
		this._container.removeChild(this._mapPane);
	},

	_addLayers: function (layers) {
		layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];

		for (var i = 0, len = layers.length; i < len; i++) {
			this.addLayer(layers[i]);
		}
	},


	// private methods that modify map state

	_resetView: function (center, zoom, preserveMapOffset, afterZoomAnim) {

		var zoomChanged = (this._zoom !== zoom);

		if (!afterZoomAnim) {
			this.fire('movestart');

			if (zoomChanged) {
				this.fire('zoomstart');
			}
		}

		this._zoom = zoom;
		this._initialCenter = center;

		this._initialTopLeftPoint = this._getNewTopLeftPoint(center);

		if (!preserveMapOffset) {
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
		} else {
			this._initialTopLeftPoint._add(this._getMapPanePos());
		}

		this._tileLayersToLoad = this._tileLayersNum;

		var loading = !this._loaded;
		this._loaded = true;

		this.fire('viewreset', {hard: !preserveMapOffset});

		if (loading) {
			this.fire('load');
			this.eachLayer(this._layerAdd, this);
		}

		this.fire('move');

		if (zoomChanged || afterZoomAnim) {
			this.fire('zoomend');
		}

		this.fire('moveend', {hard: !preserveMapOffset});
	},

	_rawPanBy: function (offset) {
		L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	},

	_getZoomSpan: function () {
		return this.getMaxZoom() - this.getMinZoom();
	},

	_updateZoomLevels: function () {
		var i,
			minZoom = Infinity,
			maxZoom = -Infinity,
			oldZoomSpan = this._getZoomSpan();

		for (i in this._zoomBoundLayers) {
			var layer = this._zoomBoundLayers[i];
			if (!isNaN(layer.options.minZoom)) {
				minZoom = Math.min(minZoom, layer.options.minZoom);
			}
			if (!isNaN(layer.options.maxZoom)) {
				maxZoom = Math.max(maxZoom, layer.options.maxZoom);
			}
		}

		if (i === undefined) { // we have no tilelayers
			this._layersMaxZoom = this._layersMinZoom = undefined;
		} else {
			this._layersMaxZoom = maxZoom;
			this._layersMinZoom = minZoom;
		}

		if (oldZoomSpan !== this._getZoomSpan()) {
			this.fire('zoomlevelschange');
		}
	},

	_panInsideMaxBounds: function () {
		this.panInsideBounds(this.options.maxBounds);
	},

	_checkIfLoaded: function () {
		if (!this._loaded) {
			throw new Error('Set map center and zoom first.');
		}
	},

	// map events

	_initEvents: function (onOff) {
		if (!L.DomEvent) { return; }

		onOff = onOff || 'on';

		L.DomEvent[onOff](this._container, 'click', this._onMouseClick, this);

		var events = ['dblclick', 'mousedown', 'mouseup', 'mouseenter',
		              'mouseleave', 'mousemove', 'contextmenu'],
		    i, len;

		for (i = 0, len = events.length; i < len; i++) {
			L.DomEvent[onOff](this._container, events[i], this._fireMouseEvent, this);
		}

		if (this.options.trackResize) {
			L.DomEvent[onOff](window, 'resize', this._onResize, this);
		}
	},

	_onResize: function () {
		L.Util.cancelAnimFrame(this._resizeRequest);
		this._resizeRequest = L.Util.requestAnimFrame(
		        function () { this.invalidateSize({debounceMoveend: true}); }, this, false, this._container);
	},

	_onMouseClick: function (e) {
		if (!this._loaded || (!e._simulated &&
		        ((this.dragging && this.dragging.moved()) ||
		         (this.boxZoom  && this.boxZoom.moved()))) ||
		            L.DomEvent._skipped(e)) { return; }

		this.fire('preclick');
		this._fireMouseEvent(e);
	},

	_fireMouseEvent: function (e) {
		if (!this._loaded || L.DomEvent._skipped(e)) { return; }

		var type = e.type;

		type = (type === 'mouseenter' ? 'mouseover' : (type === 'mouseleave' ? 'mouseout' : type));

		if (!this.hasEventListeners(type)) { return; }

		if (type === 'contextmenu') {
			L.DomEvent.preventDefault(e);
		}

		var containerPoint = this.mouseEventToContainerPoint(e),
		    layerPoint = this.containerPointToLayerPoint(containerPoint),
		    latlng = this.layerPointToLatLng(layerPoint);

		this.fire(type, {
			latlng: latlng,
			layerPoint: layerPoint,
			containerPoint: containerPoint,
			originalEvent: e
		});
	},

	_onTileLayerLoad: function () {
		this._tileLayersToLoad--;
		if (this._tileLayersNum && !this._tileLayersToLoad) {
			this.fire('tilelayersload');
		}
	},

	_clearHandlers: function () {
		for (var i = 0, len = this._handlers.length; i < len; i++) {
			this._handlers[i].disable();
		}
	},

	whenReady: function (callback, context) {
		if (this._loaded) {
			callback.call(context || this, this);
		} else {
			this.on('load', callback, context);
		}
		return this;
	},

	_layerAdd: function (layer) {
		layer.onAdd(this);
		this.fire('layeradd', {layer: layer});
	},


	// private methods for getting map state

	_getMapPanePos: function () {
		return L.DomUtil.getPosition(this._mapPane);
	},

	_moved: function () {
		var pos = this._getMapPanePos();
		return pos && !pos.equals([0, 0]);
	},

	_getTopLeftPoint: function () {
		return this.getPixelOrigin().subtract(this._getMapPanePos());
	},

	_getNewTopLeftPoint: function (center, zoom) {
		var viewHalf = this.getSize()._divideBy(2);
		// TODO round on display, not calculation to increase precision?
		return this.project(center, zoom)._subtract(viewHalf)._round();
	},

	_latLngToNewLayerPoint: function (latlng, newZoom, newCenter) {
		var topLeft = this._getNewTopLeftPoint(newCenter, newZoom).add(this._getMapPanePos());
		return this.project(latlng, newZoom)._subtract(topLeft);
	},

	// layer point of the current center
	_getCenterLayerPoint: function () {
		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	},

	// offset of the specified place to the current center in pixels
	_getCenterOffset: function (latlng) {
		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	},

	// adjust center for view to get inside bounds
	_limitCenter: function (center, zoom, bounds) {

		if (!bounds) { return center; }

		var centerPoint = this.project(center, zoom),
		    viewHalf = this.getSize().divideBy(2),
		    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

		return this.unproject(centerPoint.add(offset), zoom);
	},

	// adjust offset for view to get inside bounds
	_limitOffset: function (offset, bounds) {
		if (!bounds) { return offset; }

		var viewBounds = this.getPixelBounds(),
		    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

		return offset.add(this._getBoundsOffset(newBounds, bounds));
	},

	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
		var nwOffset = this.project(maxBounds.getNorthWest(), zoom).subtract(pxBounds.min),
		    seOffset = this.project(maxBounds.getSouthEast(), zoom).subtract(pxBounds.max),

		    dx = this._rebound(nwOffset.x, -seOffset.x),
		    dy = this._rebound(nwOffset.y, -seOffset.y);

		return new L.Point(dx, dy);
	},

	_rebound: function (left, right) {
		return left + right > 0 ?
			Math.round(left - right) / 2 :
			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	},

	_limitZoom: function (zoom) {
		var min = this.getMinZoom(),
		    max = this.getMaxZoom();

		return Math.max(min, Math.min(max, zoom));
	}
});

L.map = function (id, options) {
	return new L.Map(id, options);
};


/*
 * Mercator projection that takes into account that the Earth is not a perfect sphere.
 * Less popular than spherical mercator; used by projections like EPSG:3395.
 */

L.Projection.Mercator = {
	MAX_LATITUDE: 85.0840591556,

	R_MINOR: 6356752.314245179,
	R_MAJOR: 6378137,

	project: function (latlng) { // (LatLng) -> Point
		var d = L.LatLng.DEG_TO_RAD,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    r = this.R_MAJOR,
		    r2 = this.R_MINOR,
		    x = latlng.lng * d * r,
		    y = lat * d,
		    tmp = r2 / r,
		    eccent = Math.sqrt(1.0 - tmp * tmp),
		    con = eccent * Math.sin(y);

		con = Math.pow((1 - con) / (1 + con), eccent * 0.5);

		var ts = Math.tan(0.5 * ((Math.PI * 0.5) - y)) / con;
		y = -r * Math.log(ts);

		return new L.Point(x, y);
	},

	unproject: function (point) { // (Point, Boolean) -> LatLng
		var d = L.LatLng.RAD_TO_DEG,
		    r = this.R_MAJOR,
		    r2 = this.R_MINOR,
		    lng = point.x * d / r,
		    tmp = r2 / r,
		    eccent = Math.sqrt(1 - (tmp * tmp)),
		    ts = Math.exp(- point.y / r),
		    phi = (Math.PI / 2) - 2 * Math.atan(ts),
		    numIter = 15,
		    tol = 1e-7,
		    i = numIter,
		    dphi = 0.1,
		    con;

		while ((Math.abs(dphi) > tol) && (--i > 0)) {
			con = eccent * Math.sin(phi);
			dphi = (Math.PI / 2) - 2 * Math.atan(ts *
			            Math.pow((1.0 - con) / (1.0 + con), 0.5 * eccent)) - phi;
			phi += dphi;
		}

		return new L.LatLng(phi * d, lng);
	}
};



L.CRS.EPSG3395 = L.extend({}, L.CRS, {
	code: 'EPSG:3395',

	projection: L.Projection.Mercator,

	transformation: (function () {
		var m = L.Projection.Mercator,
		    r = m.R_MAJOR,
		    scale = 0.5 / (Math.PI * r);

		return new L.Transformation(scale, 0.5, -scale, 0.5);
	}())
});


/*
 * L.TileLayer is used for standard xyz-numbered tile layers.
 */

L.TileLayer = L.Class.extend({
	includes: L.Mixin.Events,

	options: {
		minZoom: 0,
		maxZoom: 18,
		tileSize: 256,
		subdomains: 'abc',
		errorTileUrl: '',
		attribution: '',
		zoomOffset: 0,
		opacity: 1,
		/*
		maxNativeZoom: null,
		zIndex: null,
		tms: false,
		continuousWorld: false,
		noWrap: false,
		zoomReverse: false,
		detectRetina: false,
		reuseTiles: false,
		bounds: false,
		*/
		unloadInvisibleTiles: L.Browser.mobile,
		updateWhenIdle: L.Browser.mobile
	},

	initialize: function (url, options) {
		options = L.setOptions(this, options);

		// detecting retina displays, adjusting tileSize and zoom levels
		if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {

			options.tileSize = Math.floor(options.tileSize / 2);
			options.zoomOffset++;

			if (options.minZoom > 0) {
				options.minZoom--;
			}
			this.options.maxZoom--;
		}

		if (options.bounds) {
			options.bounds = L.latLngBounds(options.bounds);
		}

		this._url = url;

		var subdomains = this.options.subdomains;

		if (typeof subdomains === 'string') {
			this.options.subdomains = subdomains.split('');
		}
	},

	onAdd: function (map) {
		this._map = map;
		this._animated = map._zoomAnimated;

		// create a container div for tiles
		this._initContainer();

		// set up events
		map.on({
			'viewreset': this._reset,
			'moveend': this._update
		}, this);

		if (this._animated) {
			map.on({
				'zoomanim': this._animateZoom,
				'zoomend': this._endZoomAnim
			}, this);
		}

		if (!this.options.updateWhenIdle) {
			this._limitedUpdate = L.Util.limitExecByInterval(this._update, 150, this);
			map.on('move', this._limitedUpdate, this);
		}

		this._reset();
		this._update();
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	onRemove: function (map) {
		this._container.parentNode.removeChild(this._container);

		map.off({
			'viewreset': this._reset,
			'moveend': this._update
		}, this);

		if (this._animated) {
			map.off({
				'zoomanim': this._animateZoom,
				'zoomend': this._endZoomAnim
			}, this);
		}

		if (!this.options.updateWhenIdle) {
			map.off('move', this._limitedUpdate, this);
		}

		this._container = null;
		this._map = null;
	},

	bringToFront: function () {
		var pane = this._map._panes.tilePane;

		if (this._container) {
			pane.appendChild(this._container);
			this._setAutoZIndex(pane, Math.max);
		}

		return this;
	},

	bringToBack: function () {
		var pane = this._map._panes.tilePane;

		if (this._container) {
			pane.insertBefore(this._container, pane.firstChild);
			this._setAutoZIndex(pane, Math.min);
		}

		return this;
	},

	getAttribution: function () {
		return this.options.attribution;
	},

	getContainer: function () {
		return this._container;
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	setZIndex: function (zIndex) {
		this.options.zIndex = zIndex;
		this._updateZIndex();

		return this;
	},

	setUrl: function (url, noRedraw) {
		this._url = url;

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	},

	redraw: function () {
		if (this._map) {
			this._reset({hard: true});
			this._update();
		}
		return this;
	},

	_updateZIndex: function () {
		if (this._container && this.options.zIndex !== undefined) {
			this._container.style.zIndex = this.options.zIndex;
		}
	},

	_setAutoZIndex: function (pane, compare) {

		var layers = pane.children,
		    edgeZIndex = -compare(Infinity, -Infinity), // -Infinity for max, Infinity for min
		    zIndex, i, len;

		for (i = 0, len = layers.length; i < len; i++) {

			if (layers[i] !== this._container) {
				zIndex = parseInt(layers[i].style.zIndex, 10);

				if (!isNaN(zIndex)) {
					edgeZIndex = compare(edgeZIndex, zIndex);
				}
			}
		}

		this.options.zIndex = this._container.style.zIndex =
		        (isFinite(edgeZIndex) ? edgeZIndex : 0) + compare(1, -1);
	},

	_updateOpacity: function () {
		var i,
		    tiles = this._tiles;

		if (L.Browser.ielt9) {
			for (i in tiles) {
				L.DomUtil.setOpacity(tiles[i], this.options.opacity);
			}
		} else {
			L.DomUtil.setOpacity(this._container, this.options.opacity);
		}
	},

	_initContainer: function () {
		var tilePane = this._map._panes.tilePane;

		if (!this._container) {
			this._container = L.DomUtil.create('div', 'leaflet-layer');

			this._updateZIndex();

			if (this._animated) {
				var className = 'leaflet-tile-container';

				this._bgBuffer = L.DomUtil.create('div', className, this._container);
				this._tileContainer = L.DomUtil.create('div', className, this._container);

			} else {
				this._tileContainer = this._container;
			}

			tilePane.appendChild(this._container);

			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
		}
	},

	_reset: function (e) {
		for (var key in this._tiles) {
			this.fire('tileunload', {tile: this._tiles[key]});
		}

		this._tiles = {};
		this._tilesToLoad = 0;

		if (this.options.reuseTiles) {
			this._unusedTiles = [];
		}

		this._tileContainer.innerHTML = '';

		if (this._animated && e && e.hard) {
			this._clearBgBuffer();
		}

		this._initContainer();
	},

	_getTileSize: function () {
		var map = this._map,
		    zoom = map.getZoom() + this.options.zoomOffset,
		    zoomN = this.options.maxNativeZoom,
		    tileSize = this.options.tileSize;

		if (zoomN && zoom > zoomN) {
			tileSize = Math.round(map.getZoomScale(zoom) / map.getZoomScale(zoomN) * tileSize);
		}

		return tileSize;
	},

	_update: function () {

		if (!this._map) { return; }

		var map = this._map,
		    bounds = map.getPixelBounds(),
		    zoom = map.getZoom(),
		    tileSize = this._getTileSize();

		if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
			return;
		}

		var tileBounds = L.bounds(
		        bounds.min.divideBy(tileSize)._floor(),
		        bounds.max.divideBy(tileSize)._floor());

		this._addTilesFromCenterOut(tileBounds);

		if (this.options.unloadInvisibleTiles || this.options.reuseTiles) {
			this._removeOtherTiles(tileBounds);
		}
	},

	_addTilesFromCenterOut: function (bounds) {
		var queue = [],
		    center = bounds.getCenter();

		var j, i, point;

		for (j = bounds.min.y; j <= bounds.max.y; j++) {
			for (i = bounds.min.x; i <= bounds.max.x; i++) {
				point = new L.Point(i, j);

				if (this._tileShouldBeLoaded(point)) {
					queue.push(point);
				}
			}
		}

		var tilesToLoad = queue.length;

		if (tilesToLoad === 0) { return; }

		// load tiles in order of their distance to center
		queue.sort(function (a, b) {
			return a.distanceTo(center) - b.distanceTo(center);
		});

		var fragment = document.createDocumentFragment();

		// if its the first batch of tiles to load
		if (!this._tilesToLoad) {
			this.fire('loading');
		}

		this._tilesToLoad += tilesToLoad;

		for (i = 0; i < tilesToLoad; i++) {
			this._addTile(queue[i], fragment);
		}

		this._tileContainer.appendChild(fragment);
	},

	_tileShouldBeLoaded: function (tilePoint) {
		if ((tilePoint.x + ':' + tilePoint.y) in this._tiles) {
			return false; // already loaded
		}

		var options = this.options;

		if (!options.continuousWorld) {
			var limit = this._getWrapTileNum();

			// don't load if exceeds world bounds
			if ((options.noWrap && (tilePoint.x < 0 || tilePoint.x >= limit.x)) ||
				tilePoint.y < 0 || tilePoint.y >= limit.y) { return false; }
		}

		if (options.bounds) {
			var tileSize = this._getTileSize(),
			    nwPoint = tilePoint.multiplyBy(tileSize),
			    sePoint = nwPoint.add([tileSize, tileSize]),
			    nw = this._map.unproject(nwPoint),
			    se = this._map.unproject(sePoint);

			// TODO temporary hack, will be removed after refactoring projections
			// https://github.com/Leaflet/Leaflet/issues/1618
			if (!options.continuousWorld && !options.noWrap) {
				nw = nw.wrap();
				se = se.wrap();
			}

			if (!options.bounds.intersects([nw, se])) { return false; }
		}

		return true;
	},

	_removeOtherTiles: function (bounds) {
		var kArr, x, y, key;

		for (key in this._tiles) {
			kArr = key.split(':');
			x = parseInt(kArr[0], 10);
			y = parseInt(kArr[1], 10);

			// remove tile if it's out of bounds
			if (x < bounds.min.x || x > bounds.max.x || y < bounds.min.y || y > bounds.max.y) {
				this._removeTile(key);
			}
		}
	},

	_removeTile: function (key) {
		var tile = this._tiles[key];

		this.fire('tileunload', {tile: tile, url: tile.src});

		if (this.options.reuseTiles) {
			L.DomUtil.removeClass(tile, 'leaflet-tile-loaded');
			this._unusedTiles.push(tile);

		} else if (tile.parentNode === this._tileContainer) {
			this._tileContainer.removeChild(tile);
		}

		// for https://github.com/CloudMade/Leaflet/issues/137
		if (!L.Browser.android) {
			tile.onload = null;
			tile.src = L.Util.emptyImageUrl;
		}

		delete this._tiles[key];
	},

	_addTile: function (tilePoint, container) {
		var tilePos = this._getTilePos(tilePoint);

		// get unused tile - or create a new tile
		var tile = this._getTile();

		/*
		Chrome 20 layouts much faster with top/left (verify with timeline, frames)
		Android 4 browser has display issues with top/left and requires transform instead
		(other browsers don't currently care) - see debug/hacks/jitter.html for an example
		*/
		L.DomUtil.setPosition(tile, tilePos, L.Browser.chrome);

		this._tiles[tilePoint.x + ':' + tilePoint.y] = tile;

		this._loadTile(tile, tilePoint);

		if (tile.parentNode !== this._tileContainer) {
			container.appendChild(tile);
		}
	},

	_getZoomForUrl: function () {

		var options = this.options,
		    zoom = this._map.getZoom();

		if (options.zoomReverse) {
			zoom = options.maxZoom - zoom;
		}

		zoom += options.zoomOffset;

		return options.maxNativeZoom ? Math.min(zoom, options.maxNativeZoom) : zoom;
	},

	_getTilePos: function (tilePoint) {
		var origin = this._map.getPixelOrigin(),
		    tileSize = this._getTileSize();

		return tilePoint.multiplyBy(tileSize).subtract(origin);
	},

	// image-specific code (override to implement e.g. Canvas or SVG tile layer)

	getTileUrl: function (tilePoint) {
		return L.Util.template(this._url, L.extend({
			s: this._getSubdomain(tilePoint),
			z: tilePoint.z,
			x: tilePoint.x,
			y: tilePoint.y
		}, this.options));
	},

	_getWrapTileNum: function () {
		var crs = this._map.options.crs,
		    size = crs.getSize(this._map.getZoom());
		return size.divideBy(this._getTileSize())._floor();
	},

	_adjustTilePoint: function (tilePoint) {

		var limit = this._getWrapTileNum();

		// wrap tile coordinates
		if (!this.options.continuousWorld && !this.options.noWrap) {
			tilePoint.x = ((tilePoint.x % limit.x) + limit.x) % limit.x;
		}

		if (this.options.tms) {
			tilePoint.y = limit.y - tilePoint.y - 1;
		}

		tilePoint.z = this._getZoomForUrl();
	},

	_getSubdomain: function (tilePoint) {
		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
		return this.options.subdomains[index];
	},

	_getTile: function () {
		if (this.options.reuseTiles && this._unusedTiles.length > 0) {
			var tile = this._unusedTiles.pop();
			this._resetTile(tile);
			return tile;
		}
		return this._createTile();
	},

	// Override if data stored on a tile needs to be cleaned up before reuse
	_resetTile: function (/*tile*/) {},

	_createTile: function () {
		var tile = L.DomUtil.create('img', 'leaflet-tile');
		tile.style.width = tile.style.height = this._getTileSize() + 'px';
		tile.galleryimg = 'no';

		tile.onselectstart = tile.onmousemove = L.Util.falseFn;

		if (L.Browser.ielt9 && this.options.opacity !== undefined) {
			L.DomUtil.setOpacity(tile, this.options.opacity);
		}
		// without this hack, tiles disappear after zoom on Chrome for Android
		// https://github.com/Leaflet/Leaflet/issues/2078
		if (L.Browser.mobileWebkit3d) {
			tile.style.WebkitBackfaceVisibility = 'hidden';
		}
		return tile;
	},

	_loadTile: function (tile, tilePoint) {
		tile._layer  = this;
		tile.onload  = this._tileOnLoad;
		tile.onerror = this._tileOnError;

		this._adjustTilePoint(tilePoint);
		tile.src     = this.getTileUrl(tilePoint);

		this.fire('tileloadstart', {
			tile: tile,
			url: tile.src
		});
	},

	_tileLoaded: function () {
		this._tilesToLoad--;

		if (this._animated) {
			L.DomUtil.addClass(this._tileContainer, 'leaflet-zoom-animated');
		}

		if (!this._tilesToLoad) {
			this.fire('load');

			if (this._animated) {
				// clear scaled tiles after all new tiles are loaded (for performance)
				clearTimeout(this._clearBgBufferTimer);
				this._clearBgBufferTimer = setTimeout(L.bind(this._clearBgBuffer, this), 500);
			}
		}
	},

	_tileOnLoad: function () {
		var layer = this._layer;

		//Only if we are loading an actual image
		if (this.src !== L.Util.emptyImageUrl) {
			L.DomUtil.addClass(this, 'leaflet-tile-loaded');

			layer.fire('tileload', {
				tile: this,
				url: this.src
			});
		}

		layer._tileLoaded();
	},

	_tileOnError: function () {
		var layer = this._layer;

		layer.fire('tileerror', {
			tile: this,
			url: this.src
		});

		var newUrl = layer.options.errorTileUrl;
		if (newUrl) {
			this.src = newUrl;
		}

		layer._tileLoaded();
	}
});

L.tileLayer = function (url, options) {
	return new L.TileLayer(url, options);
};


/*
 * L.TileLayer.WMS is used for putting WMS tile layers on the map.
 */

L.TileLayer.WMS = L.TileLayer.extend({

	defaultWmsParams: {
		service: 'WMS',
		request: 'GetMap',
		version: '1.1.1',
		layers: '',
		styles: '',
		format: 'image/jpeg',
		transparent: false
	},

	initialize: function (url, options) { // (String, Object)

		this._url = url;

		var wmsParams = L.extend({}, this.defaultWmsParams),
		    tileSize = options.tileSize || this.options.tileSize;

		if (options.detectRetina && L.Browser.retina) {
			wmsParams.width = wmsParams.height = tileSize * 2;
		} else {
			wmsParams.width = wmsParams.height = tileSize;
		}

		for (var i in options) {
			// all keys that are not TileLayer options go to WMS params
			if (!this.options.hasOwnProperty(i) && i !== 'crs') {
				wmsParams[i] = options[i];
			}
		}

		this.wmsParams = wmsParams;

		L.setOptions(this, options);
	},

	onAdd: function (map) {

		this._crs = this.options.crs || map.options.crs;

		this._wmsVersion = parseFloat(this.wmsParams.version);

		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
		this.wmsParams[projectionKey] = this._crs.code;

		L.TileLayer.prototype.onAdd.call(this, map);
	},

	getTileUrl: function (tilePoint) { // (Point, Number) -> String

		var map = this._map,
		    tileSize = this.options.tileSize,

		    nwPoint = tilePoint.multiplyBy(tileSize),
		    sePoint = nwPoint.add([tileSize, tileSize]),

		    nw = this._crs.project(map.unproject(nwPoint, tilePoint.z)),
		    se = this._crs.project(map.unproject(sePoint, tilePoint.z)),
		    bbox = this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
		        [se.y, nw.x, nw.y, se.x].join(',') :
		        [nw.x, se.y, se.x, nw.y].join(','),

		    url = L.Util.template(this._url, {s: this._getSubdomain(tilePoint)});

		return url + L.Util.getParamString(this.wmsParams, url, true) + '&BBOX=' + bbox;
	},

	setParams: function (params, noRedraw) {

		L.extend(this.wmsParams, params);

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	}
});

L.tileLayer.wms = function (url, options) {
	return new L.TileLayer.WMS(url, options);
};


/*
 * L.TileLayer.Canvas is a class that you can use as a base for creating
 * dynamically drawn Canvas-based tile layers.
 */

L.TileLayer.Canvas = L.TileLayer.extend({
	options: {
		async: false
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	redraw: function () {
		if (this._map) {
			this._reset({hard: true});
			this._update();
		}

		for (var i in this._tiles) {
			this._redrawTile(this._tiles[i]);
		}
		return this;
	},

	_redrawTile: function (tile) {
		this.drawTile(tile, tile._tilePoint, this._map._zoom);
	},

	_createTile: function () {
		var tile = L.DomUtil.create('canvas', 'leaflet-tile');
		tile.width = tile.height = this.options.tileSize;
		tile.onselectstart = tile.onmousemove = L.Util.falseFn;
		return tile;
	},

	_loadTile: function (tile, tilePoint) {
		tile._layer = this;
		tile._tilePoint = tilePoint;

		this._redrawTile(tile);

		if (!this.options.async) {
			this.tileDrawn(tile);
		}
	},

	drawTile: function (/*tile, tilePoint*/) {
		// override with rendering code
	},

	tileDrawn: function (tile) {
		this._tileOnLoad.call(tile);
	}
});


L.tileLayer.canvas = function (options) {
	return new L.TileLayer.Canvas(options);
};


/*
 * L.ImageOverlay is used to overlay images over the map (to specific geographical bounds).
 */

L.ImageOverlay = L.Class.extend({
	includes: L.Mixin.Events,

	options: {
		opacity: 1
	},

	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
		this._url = url;
		this._bounds = L.latLngBounds(bounds);

		L.setOptions(this, options);
	},

	onAdd: function (map) {
		this._map = map;

		if (!this._image) {
			this._initImage();
		}

		map._panes.overlayPane.appendChild(this._image);

		map.on('viewreset', this._reset, this);

		if (map.options.zoomAnimation && L.Browser.any3d) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this._reset();
	},

	onRemove: function (map) {
		map.getPanes().overlayPane.removeChild(this._image);

		map.off('viewreset', this._reset, this);

		if (map.options.zoomAnimation) {
			map.off('zoomanim', this._animateZoom, this);
		}
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		this._updateOpacity();
		return this;
	},

	// TODO remove bringToFront/bringToBack duplication from TileLayer/Path
	bringToFront: function () {
		if (this._image) {
			this._map._panes.overlayPane.appendChild(this._image);
		}
		return this;
	},

	bringToBack: function () {
		var pane = this._map._panes.overlayPane;
		if (this._image) {
			pane.insertBefore(this._image, pane.firstChild);
		}
		return this;
	},

	setUrl: function (url) {
		this._url = url;
		this._image.src = this._url;
	},

	getAttribution: function () {
		return this.options.attribution;
	},

	_initImage: function () {
		this._image = L.DomUtil.create('img', 'leaflet-image-layer');

		if (this._map.options.zoomAnimation && L.Browser.any3d) {
			L.DomUtil.addClass(this._image, 'leaflet-zoom-animated');
		} else {
			L.DomUtil.addClass(this._image, 'leaflet-zoom-hide');
		}

		this._updateOpacity();

		//TODO createImage util method to remove duplication
		L.extend(this._image, {
			galleryimg: 'no',
			onselectstart: L.Util.falseFn,
			onmousemove: L.Util.falseFn,
			onload: L.bind(this._onImageLoad, this),
			src: this._url
		});
	},

	_animateZoom: function (e) {
		var map = this._map,
		    image = this._image,
		    scale = map.getZoomScale(e.zoom),
		    nw = this._bounds.getNorthWest(),
		    se = this._bounds.getSouthEast(),

		    topLeft = map._latLngToNewLayerPoint(nw, e.zoom, e.center),
		    size = map._latLngToNewLayerPoint(se, e.zoom, e.center)._subtract(topLeft),
		    origin = topLeft._add(size._multiplyBy((1 / 2) * (1 - 1 / scale)));

		image.style[L.DomUtil.TRANSFORM] =
		        L.DomUtil.getTranslateString(origin) + ' scale(' + scale + ') ';
	},

	_reset: function () {
		var image   = this._image,
		    topLeft = this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
		    size = this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(topLeft);

		L.DomUtil.setPosition(image, topLeft);

		image.style.width  = size.x + 'px';
		image.style.height = size.y + 'px';
	},

	_onImageLoad: function () {
		this.fire('load');
	},

	_updateOpacity: function () {
		L.DomUtil.setOpacity(this._image, this.options.opacity);
	}
});

L.imageOverlay = function (url, bounds, options) {
	return new L.ImageOverlay(url, bounds, options);
};


/*
 * L.Icon is an image-based icon class that you can use with L.Marker for custom markers.
 */

L.Icon = L.Class.extend({
	options: {
		/*
		iconUrl: (String) (required)
		iconRetinaUrl: (String) (optional, used for retina devices if detected)
		iconSize: (Point) (can be set through CSS)
		iconAnchor: (Point) (centered by default, can be set in CSS with negative margins)
		popupAnchor: (Point) (if not specified, popup opens in the anchor point)
		shadowUrl: (String) (no shadow by default)
		shadowRetinaUrl: (String) (optional, used for retina devices if detected)
		shadowSize: (Point)
		shadowAnchor: (Point)
		*/
		className: ''
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	createIcon: function (oldIcon) {
		return this._createIcon('icon', oldIcon);
	},

	createShadow: function (oldIcon) {
		return this._createIcon('shadow', oldIcon);
	},

	_createIcon: function (name, oldIcon) {
		var src = this._getIconUrl(name);

		if (!src) {
			if (name === 'icon') {
				throw new Error('iconUrl not set in Icon options (see the docs).');
			}
			return null;
		}

		var img;
		if (!oldIcon || oldIcon.tagName !== 'IMG') {
			img = this._createImg(src);
		} else {
			img = this._createImg(src, oldIcon);
		}
		this._setIconStyles(img, name);

		return img;
	},

	_setIconStyles: function (img, name) {
		var options = this.options,
		    size = L.point(options[name + 'Size']),
		    anchor;

		if (name === 'shadow') {
			anchor = L.point(options.shadowAnchor || options.iconAnchor);
		} else {
			anchor = L.point(options.iconAnchor);
		}

		if (!anchor && size) {
			anchor = size.divideBy(2, true);
		}

		img.className = 'leaflet-marker-' + name + ' ' + options.className;

		if (anchor) {
			img.style.marginLeft = (-anchor.x) + 'px';
			img.style.marginTop  = (-anchor.y) + 'px';
		}

		if (size) {
			img.style.width  = size.x + 'px';
			img.style.height = size.y + 'px';
		}
	},

	_createImg: function (src, el) {
		el = el || document.createElement('img');
		el.src = src;
		return el;
	},

	_getIconUrl: function (name) {
		if (L.Browser.retina && this.options[name + 'RetinaUrl']) {
			return this.options[name + 'RetinaUrl'];
		}
		return this.options[name + 'Url'];
	}
});

L.icon = function (options) {
	return new L.Icon(options);
};


/*
 * L.Icon.Default is the blue marker icon used by default in Leaflet.
 */

L.Icon.Default = L.Icon.extend({

	options: {
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],

		shadowSize: [41, 41]
	},

	_getIconUrl: function (name) {
		var key = name + 'Url';

		if (this.options[key]) {
			return this.options[key];
		}

		if (L.Browser.retina && name === 'icon') {
			name += '-2x';
		}

		var path = L.Icon.Default.imagePath;

		if (!path) {
			throw new Error('Couldn\'t autodetect L.Icon.Default.imagePath, set it manually.');
		}

		return path + '/marker-' + name + '.png';
	}
});

L.Icon.Default.imagePath = (function () {
	var scripts = document.getElementsByTagName('script'),
	    leafletRe = /[\/^]leaflet[\-\._]?([\w\-\._]*)\.js\??/;

	var i, len, src, matches, path;

	for (i = 0, len = scripts.length; i < len; i++) {
		src = scripts[i].src;
		matches = src.match(leafletRe);

		if (matches) {
			path = src.split(leafletRe)[0];
			return (path ? path + '/' : '') + 'images';
		}
	}
}());


/*
 * L.Marker is used to display clickable/draggable icons on the map.
 */

L.Marker = L.Class.extend({

	includes: L.Mixin.Events,

	options: {
		icon: new L.Icon.Default(),
		title: '',
		alt: '',
		clickable: true,
		draggable: false,
		keyboard: true,
		zIndexOffset: 0,
		opacity: 1,
		riseOnHover: false,
		riseOffset: 250
	},

	initialize: function (latlng, options) {
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);
	},

	onAdd: function (map) {
		this._map = map;

		map.on('viewreset', this.update, this);

		this._initIcon();
		this.update();
		this.fire('add');

		if (map.options.zoomAnimation && map.options.markerZoomAnimation) {
			map.on('zoomanim', this._animateZoom, this);
		}
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	onRemove: function (map) {
		if (this.dragging) {
			this.dragging.disable();
		}

		this._removeIcon();
		this._removeShadow();

		this.fire('remove');

		map.off({
			'viewreset': this.update,
			'zoomanim': this._animateZoom
		}, this);

		this._map = null;
	},

	getLatLng: function () {
		return this._latlng;
	},

	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);

		this.update();

		return this.fire('move', { latlng: this._latlng });
	},

	setZIndexOffset: function (offset) {
		this.options.zIndexOffset = offset;
		this.update();

		return this;
	},

	setIcon: function (icon) {

		this.options.icon = icon;

		if (this._map) {
			this._initIcon();
			this.update();
		}

		if (this._popup) {
			this.bindPopup(this._popup);
		}

		return this;
	},

	update: function () {
		if (this._icon) {
			this._setPos(this._map.latLngToLayerPoint(this._latlng).round());
		}
		return this;
	},

	_initIcon: function () {
		var options = this.options,
		    map = this._map,
		    animation = (map.options.zoomAnimation && map.options.markerZoomAnimation),
		    classToAdd = animation ? 'leaflet-zoom-animated' : 'leaflet-zoom-hide';

		var icon = options.icon.createIcon(this._icon),
			addIcon = false;

		// if we're not reusing the icon, remove the old one and init new one
		if (icon !== this._icon) {
			if (this._icon) {
				this._removeIcon();
			}
			addIcon = true;

			if (options.title) {
				icon.title = options.title;
			}

			if (options.alt) {
				icon.alt = options.alt;
			}
		}

		L.DomUtil.addClass(icon, classToAdd);

		if (options.keyboard) {
			icon.tabIndex = '0';
		}

		this._icon = icon;

		this._initInteraction();

		if (options.riseOnHover) {
			L.DomEvent
				.on(icon, 'mouseover', this._bringToFront, this)
				.on(icon, 'mouseout', this._resetZIndex, this);
		}

		var newShadow = options.icon.createShadow(this._shadow),
			addShadow = false;

		if (newShadow !== this._shadow) {
			this._removeShadow();
			addShadow = true;
		}

		if (newShadow) {
			L.DomUtil.addClass(newShadow, classToAdd);
		}
		this._shadow = newShadow;


		if (options.opacity < 1) {
			this._updateOpacity();
		}


		var panes = this._map._panes;

		if (addIcon) {
			panes.markerPane.appendChild(this._icon);
		}

		if (newShadow && addShadow) {
			panes.shadowPane.appendChild(this._shadow);
		}
	},

	_removeIcon: function () {
		if (this.options.riseOnHover) {
			L.DomEvent
			    .off(this._icon, 'mouseover', this._bringToFront)
			    .off(this._icon, 'mouseout', this._resetZIndex);
		}

		this._map._panes.markerPane.removeChild(this._icon);

		this._icon = null;
	},

	_removeShadow: function () {
		if (this._shadow) {
			this._map._panes.shadowPane.removeChild(this._shadow);
		}
		this._shadow = null;
	},

	_setPos: function (pos) {
		L.DomUtil.setPosition(this._icon, pos);

		if (this._shadow) {
			L.DomUtil.setPosition(this._shadow, pos);
		}

		this._zIndex = pos.y + this.options.zIndexOffset;

		this._resetZIndex();
	},

	_updateZIndex: function (offset) {
		this._icon.style.zIndex = this._zIndex + offset;
	},

	_animateZoom: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

		this._setPos(pos);
	},

	_initInteraction: function () {

		if (!this.options.clickable) { return; }

		// TODO refactor into something shared with Map/Path/etc. to DRY it up

		var icon = this._icon,
		    events = ['dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];

		L.DomUtil.addClass(icon, 'leaflet-clickable');
		L.DomEvent.on(icon, 'click', this._onMouseClick, this);
		L.DomEvent.on(icon, 'keypress', this._onKeyPress, this);

		for (var i = 0; i < events.length; i++) {
			L.DomEvent.on(icon, events[i], this._fireMouseEvent, this);
		}

		if (L.Handler.MarkerDrag) {
			this.dragging = new L.Handler.MarkerDrag(this);

			if (this.options.draggable) {
				this.dragging.enable();
			}
		}
	},

	_onMouseClick: function (e) {
		var wasDragged = this.dragging && this.dragging.moved();

		if (this.hasEventListeners(e.type) || wasDragged) {
			L.DomEvent.stopPropagation(e);
		}

		if (wasDragged) { return; }

		if ((!this.dragging || !this.dragging._enabled) && this._map.dragging && this._map.dragging.moved()) { return; }

		this.fire(e.type, {
			originalEvent: e,
			latlng: this._latlng
		});
	},

	_onKeyPress: function (e) {
		if (e.keyCode === 13) {
			this.fire('click', {
				originalEvent: e,
				latlng: this._latlng
			});
		}
	},

	_fireMouseEvent: function (e) {

		this.fire(e.type, {
			originalEvent: e,
			latlng: this._latlng
		});

		// TODO proper custom event propagation
		// this line will always be called if marker is in a FeatureGroup
		if (e.type === 'contextmenu' && this.hasEventListeners(e.type)) {
			L.DomEvent.preventDefault(e);
		}
		if (e.type !== 'mousedown') {
			L.DomEvent.stopPropagation(e);
		} else {
			L.DomEvent.preventDefault(e);
		}
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	_updateOpacity: function () {
		L.DomUtil.setOpacity(this._icon, this.options.opacity);
		if (this._shadow) {
			L.DomUtil.setOpacity(this._shadow, this.options.opacity);
		}
	},

	_bringToFront: function () {
		this._updateZIndex(this.options.riseOffset);
	},

	_resetZIndex: function () {
		this._updateZIndex(0);
	}
});

L.marker = function (latlng, options) {
	return new L.Marker(latlng, options);
};


/*
 * L.DivIcon is a lightweight HTML-based icon class (as opposed to the image-based L.Icon)
 * to use with L.Marker.
 */

L.DivIcon = L.Icon.extend({
	options: {
		iconSize: [12, 12], // also can be set through CSS
		/*
		iconAnchor: (Point)
		popupAnchor: (Point)
		html: (String)
		bgPos: (Point)
		*/
		className: 'leaflet-div-icon',
		html: false
	},

	createIcon: function (oldIcon) {
		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
		    options = this.options;

		if (options.html !== false) {
			div.innerHTML = options.html;
		} else {
			div.innerHTML = '';
		}

		if (options.bgPos) {
			div.style.backgroundPosition =
			        (-options.bgPos.x) + 'px ' + (-options.bgPos.y) + 'px';
		}

		this._setIconStyles(div, 'icon');
		return div;
	},

	createShadow: function () {
		return null;
	}
});

L.divIcon = function (options) {
	return new L.DivIcon(options);
};


/*
 * L.Popup is used for displaying popups on the map.
 */

L.Map.mergeOptions({
	closePopupOnClick: true
});

L.Popup = L.Class.extend({
	includes: L.Mixin.Events,

	options: {
		minWidth: 50,
		maxWidth: 300,
		// maxHeight: null,
		autoPan: true,
		closeButton: true,
		offset: [0, 7],
		autoPanPadding: [5, 5],
		// autoPanPaddingTopLeft: null,
		// autoPanPaddingBottomRight: null,
		keepInView: false,
		className: '',
		zoomAnimation: true
	},

	initialize: function (options, source) {
		L.setOptions(this, options);

		this._source = source;
		this._animated = L.Browser.any3d && this.options.zoomAnimation;
		this._isOpen = false;
	},

	onAdd: function (map) {
		this._map = map;

		if (!this._container) {
			this._initLayout();
		}

		var animFade = map.options.fadeAnimation;

		if (animFade) {
			L.DomUtil.setOpacity(this._container, 0);
		}
		map._panes.popupPane.appendChild(this._container);

		map.on(this._getEvents(), this);

		this.update();

		if (animFade) {
			L.DomUtil.setOpacity(this._container, 1);
		}

		this.fire('open');

		map.fire('popupopen', {popup: this});

		if (this._source) {
			this._source.fire('popupopen', {popup: this});
		}
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	openOn: function (map) {
		map.openPopup(this);
		return this;
	},

	onRemove: function (map) {
		map._panes.popupPane.removeChild(this._container);

		L.Util.falseFn(this._container.offsetWidth); // force reflow

		map.off(this._getEvents(), this);

		if (map.options.fadeAnimation) {
			L.DomUtil.setOpacity(this._container, 0);
		}

		this._map = null;

		this.fire('close');

		map.fire('popupclose', {popup: this});

		if (this._source) {
			this._source.fire('popupclose', {popup: this});
		}
	},

	getLatLng: function () {
		return this._latlng;
	},

	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		if (this._map) {
			this._updatePosition();
			this._adjustPan();
		}
		return this;
	},

	getContent: function () {
		return this._content;
	},

	setContent: function (content) {
		this._content = content;
		this.update();
		return this;
	},

	update: function () {
		if (!this._map) { return; }

		this._container.style.visibility = 'hidden';

		this._updateContent();
		this._updateLayout();
		this._updatePosition();

		this._container.style.visibility = '';

		this._adjustPan();
	},

	_getEvents: function () {
		var events = {
			viewreset: this._updatePosition
		};

		if (this._animated) {
			events.zoomanim = this._zoomAnimation;
		}
		if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
			events.preclick = this._close;
		}
		if (this.options.keepInView) {
			events.moveend = this._adjustPan;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closePopup(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-popup',
			containerClass = prefix + ' ' + this.options.className + ' leaflet-zoom-' +
			        (this._animated ? 'animated' : 'hide'),
			container = this._container = L.DomUtil.create('div', containerClass),
			closeButton;

		if (this.options.closeButton) {
			closeButton = this._closeButton =
			        L.DomUtil.create('a', prefix + '-close-button', container);
			closeButton.href = '#close';
			closeButton.innerHTML = '&#215;';
			L.DomEvent.disableClickPropagation(closeButton);

			L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
		}

		var wrapper = this._wrapper =
		        L.DomUtil.create('div', prefix + '-content-wrapper', container);
		L.DomEvent.disableClickPropagation(wrapper);

		this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);

		L.DomEvent.disableScrollPropagation(this._contentNode);
		L.DomEvent.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);

		this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
		this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
	},

	_updateContent: function () {
		if (!this._content) { return; }

		if (typeof this._content === 'string') {
			this._contentNode.innerHTML = this._content;
		} else {
			while (this._contentNode.hasChildNodes()) {
				this._contentNode.removeChild(this._contentNode.firstChild);
			}
			this._contentNode.appendChild(this._content);
		}
		this.fire('contentupdate');
	},

	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			L.DomUtil.addClass(container, scrolledClass);
		} else {
			L.DomUtil.removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},

	_updatePosition: function () {
		if (!this._map) { return; }

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    animated = this._animated,
		    offset = L.point(this.options.offset);

		if (animated) {
			L.DomUtil.setPosition(this._container, pos);
		}

		this._containerBottom = -offset.y - (animated ? 0 : pos.y);
		this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x + (animated ? 0 : pos.x);

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = this._containerBottom + 'px';
		this._container.style.left = this._containerLeft + 'px';
	},

	_zoomAnimation: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center);

		L.DomUtil.setPosition(this._container, pos);
	},

	_adjustPan: function () {
		if (!this.options.autoPan) { return; }

		var map = this._map,
		    containerHeight = this._container.offsetHeight,
		    containerWidth = this._containerWidth,

		    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);

		if (this._animated) {
			layerPos._add(L.DomUtil.getPosition(this._container));
		}

		var containerPos = map.layerPointToContainerPoint(layerPos),
		    padding = L.point(this.options.autoPanPadding),
		    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
		    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
		    size = map.getSize(),
		    dx = 0,
		    dy = 0;

		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
		}
		if (containerPos.x - dx - paddingTL.x < 0) { // left
			dx = containerPos.x - paddingTL.x;
		}
		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
		}
		if (containerPos.y - dy - paddingTL.y < 0) { // top
			dy = containerPos.y - paddingTL.y;
		}

		if (dx || dy) {
			map
			    .fire('autopanstart')
			    .panBy([dx, dy]);
		}
	},

	_onCloseButtonClick: function (e) {
		this._close();
		L.DomEvent.stop(e);
	}
});

L.popup = function (options, source) {
	return new L.Popup(options, source);
};


L.Map.include({
	openPopup: function (popup, latlng, options) { // (Popup) or (String || HTMLElement, LatLng[, Object])
		this.closePopup();

		if (!(popup instanceof L.Popup)) {
			var content = popup;

			popup = new L.Popup(options)
			    .setLatLng(latlng)
			    .setContent(content);
		}
		popup._isOpen = true;

		this._popup = popup;
		return this.addLayer(popup);
	},

	closePopup: function (popup) {
		if (!popup || popup === this._popup) {
			popup = this._popup;
			this._popup = null;
		}
		if (popup) {
			this.removeLayer(popup);
			popup._isOpen = false;
		}
		return this;
	}
});


/*
 * Popup extension to L.Marker, adding popup-related methods.
 */

L.Marker.include({
	openPopup: function () {
		if (this._popup && this._map && !this._map.hasLayer(this._popup)) {
			this._popup.setLatLng(this._latlng);
			this._map.openPopup(this._popup);
		}

		return this;
	},

	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	togglePopup: function () {
		if (this._popup) {
			if (this._popup._isOpen) {
				this.closePopup();
			} else {
				this.openPopup();
			}
		}
		return this;
	},

	bindPopup: function (content, options) {
		var anchor = L.point(this.options.icon.options.popupAnchor || [0, 0]);

		anchor = anchor.add(L.Popup.prototype.options.offset);

		if (options && options.offset) {
			anchor = anchor.add(options.offset);
		}

		options = L.extend({offset: anchor}, options);

		if (!this._popupHandlersAdded) {
			this
			    .on('click', this.togglePopup, this)
			    .on('remove', this.closePopup, this)
			    .on('move', this._movePopup, this);
			this._popupHandlersAdded = true;
		}

		if (content instanceof L.Popup) {
			L.setOptions(content, options);
			this._popup = content;
			content._source = this;
		} else {
			this._popup = new L.Popup(options, this)
				.setContent(content);
		}

		return this;
	},

	setPopupContent: function (content) {
		if (this._popup) {
			this._popup.setContent(content);
		}
		return this;
	},

	unbindPopup: function () {
		if (this._popup) {
			this._popup = null;
			this
			    .off('click', this.togglePopup, this)
			    .off('remove', this.closePopup, this)
			    .off('move', this._movePopup, this);
			this._popupHandlersAdded = false;
		}
		return this;
	},

	getPopup: function () {
		return this._popup;
	},

	_movePopup: function (e) {
		this._popup.setLatLng(e.latlng);
	}
});


/*
 * L.LayerGroup is a class to combine several layers into one so that
 * you can manipulate the group (e.g. add/remove it) as one layer.
 */

L.LayerGroup = L.Class.extend({
	initialize: function (layers) {
		this._layers = {};

		var i, len;

		if (layers) {
			for (i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		}
	},

	addLayer: function (layer) {
		var id = this.getLayerId(layer);

		this._layers[id] = layer;

		if (this._map) {
			this._map.addLayer(layer);
		}

		return this;
	},

	removeLayer: function (layer) {
		var id = layer in this._layers ? layer : this.getLayerId(layer);

		if (this._map && this._layers[id]) {
			this._map.removeLayer(this._layers[id]);
		}

		delete this._layers[id];

		return this;
	},

	hasLayer: function (layer) {
		if (!layer) { return false; }

		return (layer in this._layers || this.getLayerId(layer) in this._layers);
	},

	clearLayers: function () {
		this.eachLayer(this.removeLayer, this);
		return this;
	},

	invoke: function (methodName) {
		var args = Array.prototype.slice.call(arguments, 1),
		    i, layer;

		for (i in this._layers) {
			layer = this._layers[i];

			if (layer[methodName]) {
				layer[methodName].apply(layer, args);
			}
		}

		return this;
	},

	onAdd: function (map) {
		this._map = map;
		this.eachLayer(map.addLayer, map);
	},

	onRemove: function (map) {
		this.eachLayer(map.removeLayer, map);
		this._map = null;
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	getLayer: function (id) {
		return this._layers[id];
	},

	getLayers: function () {
		var layers = [];

		for (var i in this._layers) {
			layers.push(this._layers[i]);
		}
		return layers;
	},

	setZIndex: function (zIndex) {
		return this.invoke('setZIndex', zIndex);
	},

	getLayerId: function (layer) {
		return L.stamp(layer);
	}
});

L.layerGroup = function (layers) {
	return new L.LayerGroup(layers);
};


/*
 * L.FeatureGroup extends L.LayerGroup by introducing mouse events and additional methods
 * shared between a group of interactive layers (like vectors or markers).
 */

L.FeatureGroup = L.LayerGroup.extend({
	includes: L.Mixin.Events,

	statics: {
		EVENTS: 'click dblclick mouseover mouseout mousemove contextmenu popupopen popupclose'
	},

	addLayer: function (layer) {
		if (this.hasLayer(layer)) {
			return this;
		}

		if ('on' in layer) {
			layer.on(L.FeatureGroup.EVENTS, this._propagateEvent, this);
		}

		L.LayerGroup.prototype.addLayer.call(this, layer);

		if (this._popupContent && layer.bindPopup) {
			layer.bindPopup(this._popupContent, this._popupOptions);
		}

		return this.fire('layeradd', {layer: layer});
	},

	removeLayer: function (layer) {
		if (!this.hasLayer(layer)) {
			return this;
		}
		if (layer in this._layers) {
			layer = this._layers[layer];
		}

		if ('off' in layer) {
			layer.off(L.FeatureGroup.EVENTS, this._propagateEvent, this);
		}

		L.LayerGroup.prototype.removeLayer.call(this, layer);

		if (this._popupContent) {
			this.invoke('unbindPopup');
		}

		return this.fire('layerremove', {layer: layer});
	},

	bindPopup: function (content, options) {
		this._popupContent = content;
		this._popupOptions = options;
		return this.invoke('bindPopup', content, options);
	},

	openPopup: function (latlng) {
		// open popup on the first layer
		for (var id in this._layers) {
			this._layers[id].openPopup(latlng);
			break;
		}
		return this;
	},

	setStyle: function (style) {
		return this.invoke('setStyle', style);
	},

	bringToFront: function () {
		return this.invoke('bringToFront');
	},

	bringToBack: function () {
		return this.invoke('bringToBack');
	},

	getBounds: function () {
		var bounds = new L.LatLngBounds();

		this.eachLayer(function (layer) {
			bounds.extend(layer instanceof L.Marker ? layer.getLatLng() : layer.getBounds());
		});

		return bounds;
	},

	_propagateEvent: function (e) {
		e = L.extend({
			layer: e.target,
			target: this
		}, e);
		this.fire(e.type, e);
	}
});

L.featureGroup = function (layers) {
	return new L.FeatureGroup(layers);
};


/*
 * L.Path is a base class for rendering vector paths on a map. Inherited by Polyline, Circle, etc.
 */

L.Path = L.Class.extend({
	includes: [L.Mixin.Events],

	statics: {
		// how much to extend the clip area around the map view
		// (relative to its size, e.g. 0.5 is half the screen in each direction)
		// set it so that SVG element doesn't exceed 1280px (vectors flicker on dragend if it is)
		CLIP_PADDING: (function () {
			var max = L.Browser.mobile ? 1280 : 2000,
			    target = (max / Math.max(window.outerWidth, window.outerHeight) - 1) / 2;
			return Math.max(0, Math.min(0.5, target));
		})()
	},

	options: {
		stroke: true,
		color: '#0033ff',
		dashArray: null,
		lineCap: null,
		lineJoin: null,
		weight: 5,
		opacity: 0.5,

		fill: false,
		fillColor: null, //same as color by default
		fillOpacity: 0.2,

		clickable: true
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	onAdd: function (map) {
		this._map = map;

		if (!this._container) {
			this._initElements();
			this._initEvents();
		}

		this.projectLatlngs();
		this._updatePath();

		if (this._container) {
			this._map._pathRoot.appendChild(this._container);
		}

		this.fire('add');

		map.on({
			'viewreset': this.projectLatlngs,
			'moveend': this._updatePath
		}, this);
	},

	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	onRemove: function (map) {
		map._pathRoot.removeChild(this._container);

		// Need to fire remove event before we set _map to null as the event hooks might need the object
		this.fire('remove');
		this._map = null;

		if (L.Browser.vml) {
			this._container = null;
			this._stroke = null;
			this._fill = null;
		}

		map.off({
			'viewreset': this.projectLatlngs,
			'moveend': this._updatePath
		}, this);
	},

	projectLatlngs: function () {
		// do all projection stuff here
	},

	setStyle: function (style) {
		L.setOptions(this, style);

		if (this._container) {
			this._updateStyle();
		}

		return this;
	},

	redraw: function () {
		if (this._map) {
			this.projectLatlngs();
			this._updatePath();
		}
		return this;
	}
});

L.Map.include({
	_updatePathViewport: function () {
		var p = L.Path.CLIP_PADDING,
		    size = this.getSize(),
		    panePos = L.DomUtil.getPosition(this._mapPane),
		    min = panePos.multiplyBy(-1)._subtract(size.multiplyBy(p)._round()),
		    max = min.add(size.multiplyBy(1 + p * 2)._round());

		this._pathViewport = new L.Bounds(min, max);
	}
});


/*
 * Extends L.Path with SVG-specific rendering code.
 */

L.Path.SVG_NS = 'http://www.w3.org/2000/svg';

L.Browser.svg = !!(document.createElementNS && document.createElementNS(L.Path.SVG_NS, 'svg').createSVGRect);

L.Path = L.Path.extend({
	statics: {
		SVG: L.Browser.svg
	},

	bringToFront: function () {
		var root = this._map._pathRoot,
		    path = this._container;

		if (path && root.lastChild !== path) {
			root.appendChild(path);
		}
		return this;
	},

	bringToBack: function () {
		var root = this._map._pathRoot,
		    path = this._container,
		    first = root.firstChild;

		if (path && first !== path) {
			root.insertBefore(path, first);
		}
		return this;
	},

	getPathString: function () {
		// form path string here
	},

	_createElement: function (name) {
		return document.createElementNS(L.Path.SVG_NS, name);
	},

	_initElements: function () {
		this._map._initPathRoot();
		this._initPath();
		this._initStyle();
	},

	_initPath: function () {
		this._container = this._createElement('g');

		this._path = this._createElement('path');

		if (this.options.className) {
			L.DomUtil.addClass(this._path, this.options.className);
		}

		this._container.appendChild(this._path);
	},

	_initStyle: function () {
		if (this.options.stroke) {
			this._path.setAttribute('stroke-linejoin', 'round');
			this._path.setAttribute('stroke-linecap', 'round');
		}
		if (this.options.fill) {
			this._path.setAttribute('fill-rule', 'evenodd');
		}
		if (this.options.pointerEvents) {
			this._path.setAttribute('pointer-events', this.options.pointerEvents);
		}
		if (!this.options.clickable && !this.options.pointerEvents) {
			this._path.setAttribute('pointer-events', 'none');
		}
		this._updateStyle();
	},

	_updateStyle: function () {
		if (this.options.stroke) {
			this._path.setAttribute('stroke', this.options.color);
			this._path.setAttribute('stroke-opacity', this.options.opacity);
			this._path.setAttribute('stroke-width', this.options.weight);
			if (this.options.dashArray) {
				this._path.setAttribute('stroke-dasharray', this.options.dashArray);
			} else {
				this._path.removeAttribute('stroke-dasharray');
			}
			if (this.options.lineCap) {
				this._path.setAttribute('stroke-linecap', this.options.lineCap);
			}
			if (this.options.lineJoin) {
				this._path.setAttribute('stroke-linejoin', this.options.lineJoin);
			}
		} else {
			this._path.setAttribute('stroke', 'none');
		}
		if (this.options.fill) {
			this._path.setAttribute('fill', this.options.fillColor || this.options.color);
			this._path.setAttribute('fill-opacity', this.options.fillOpacity);
		} else {
			this._path.setAttribute('fill', 'none');
		}
	},

	_updatePath: function () {
		var str = this.getPathString();
		if (!str) {
			// fix webkit empty string parsing bug
			str = 'M0 0';
		}
		this._path.setAttribute('d', str);
	},

	// TODO remove duplication with L.Map
	_initEvents: function () {
		if (this.options.clickable) {
			if (L.Browser.svg || !L.Browser.vml) {
				L.DomUtil.addClass(this._path, 'leaflet-clickable');
			}

			L.DomEvent.on(this._container, 'click', this._onMouseClick, this);

			var events = ['dblclick', 'mousedown', 'mouseover',
			              'mouseout', 'mousemove', 'contextmenu'];
			for (var i = 0; i < events.length; i++) {
				L.DomEvent.on(this._container, events[i], this._fireMouseEvent, this);
			}
		}
	},

	_onMouseClick: function (e) {
		if (this._map.dragging && this._map.dragging.moved()) { return; }

		this._fireMouseEvent(e);
	},

	_fireMouseEvent: function (e) {
		if (!this._map || !this.hasEventListeners(e.type)) { return; }

		var map = this._map,
		    containerPoint = map.mouseEventToContainerPoint(e),
		    layerPoint = map.containerPointToLayerPoint(containerPoint),
		    latlng = map.layerPointToLatLng(layerPoint);

		this.fire(e.type, {
			latlng: latlng,
			layerPoint: layerPoint,
			containerPoint: containerPoint,
			originalEvent: e
		});

		if (e.type === 'contextmenu') {
			L.DomEvent.preventDefault(e);
		}
		if (e.type !== 'mousemove') {
			L.DomEvent.stopPropagation(e);
		}
	}
});

L.Map.include({
	_initPathRoot: function () {
		if (!this._pathRoot) {
			this._pathRoot = L.Path.prototype._createElement('svg');
			this._panes.overlayPane.appendChild(this._pathRoot);

			if (this.options.zoomAnimation && L.Browser.any3d) {
				L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-animated');

				this.on({
					'zoomanim': this._animatePathZoom,
					'zoomend': this._endPathZoom
				});
			} else {
				L.DomUtil.addClass(this._pathRoot, 'leaflet-zoom-hide');
			}

			this.on('moveend', this._updateSvgViewport);
			this._updateSvgViewport();
		}
	},

	_animatePathZoom: function (e) {
		var scale = this.getZoomScale(e.zoom),
		    offset = this._getCenterOffset(e.center)._multiplyBy(-scale)._add(this._pathViewport.min);

		this._pathRoot.style[L.DomUtil.TRANSFORM] =
		        L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ') ';

		this._pathZooming = true;
	},

	_endPathZoom: function () {
		this._pathZooming = false;
	},

	_updateSvgViewport: function () {

		if (this._pathZooming) {
			// Do not update SVGs while a zoom animation is going on otherwise the animation will break.
			// When the zoom animation ends we will be updated again anyway
			// This fixes the case where you do a momentum move and zoom while the move is still ongoing.
			return;
		}

		this._updatePathViewport();

		var vp = this._pathViewport,
		    min = vp.min,
		    max = vp.max,
		    width = max.x - min.x,
		    height = max.y - min.y,
		    root = this._pathRoot,
		    pane = this._panes.overlayPane;

		// Hack to make flicker on drag end on mobile webkit less irritating
		if (L.Browser.mobileWebkit) {
			pane.removeChild(root);
		}

		L.DomUtil.setPosition(root, min);
		root.setAttribute('width', width);
		root.setAttribute('height', height);
		root.setAttribute('viewBox', [min.x, min.y, width, height].join(' '));

		if (L.Browser.mobileWebkit) {
			pane.appendChild(root);
		}
	}
});


/*
 * Popup extension to L.Path (polylines, polygons, circles), adding popup-related methods.
 */

L.Path.include({

	bindPopup: function (content, options) {

		if (content instanceof L.Popup) {
			this._popup = content;
		} else {
			if (!this._popup || options) {
				this._popup = new L.Popup(options, this);
			}
			this._popup.setContent(content);
		}

		if (!this._popupHandlersAdded) {
			this
			    .on('click', this._openPopup, this)
			    .on('remove', this.closePopup, this);

			this._popupHandlersAdded = true;
		}

		return this;
	},

	unbindPopup: function () {
		if (this._popup) {
			this._popup = null;
			this
			    .off('click', this._openPopup)
			    .off('remove', this.closePopup);

			this._popupHandlersAdded = false;
		}
		return this;
	},

	openPopup: function (latlng) {

		if (this._popup) {
			// open the popup from one of the path's points if not specified
			latlng = latlng || this._latlng ||
			         this._latlngs[Math.floor(this._latlngs.length / 2)];

			this._openPopup({latlng: latlng});
		}

		return this;
	},

	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	_openPopup: function (e) {
		this._popup.setLatLng(e.latlng);
		this._map.openPopup(this._popup);
	}
});


/*
 * Vector rendering for IE6-8 through VML.
 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
 */

L.Browser.vml = !L.Browser.svg && (function () {
	try {
		var div = document.createElement('div');
		div.innerHTML = '<v:shape adj="1"/>';

		var shape = div.firstChild;
		shape.style.behavior = 'url(#default#VML)';

		return shape && (typeof shape.adj === 'object');

	} catch (e) {
		return false;
	}
}());

L.Path = L.Browser.svg || !L.Browser.vml ? L.Path : L.Path.extend({
	statics: {
		VML: true,
		CLIP_PADDING: 0.02
	},

	_createElement: (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement(
				        '<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	}()),

	_initPath: function () {
		var container = this._container = this._createElement('shape');

		L.DomUtil.addClass(container, 'leaflet-vml-shape' +
			(this.options.className ? ' ' + this.options.className : ''));

		if (this.options.clickable) {
			L.DomUtil.addClass(container, 'leaflet-clickable');
		}

		container.coordsize = '1 1';

		this._path = this._createElement('path');
		container.appendChild(this._path);

		this._map._pathRoot.appendChild(container);
	},

	_initStyle: function () {
		this._updateStyle();
	},

	_updateStyle: function () {
		var stroke = this._stroke,
		    fill = this._fill,
		    options = this.options,
		    container = this._container;

		container.stroked = options.stroke;
		container.filled = options.fill;

		if (options.stroke) {
			if (!stroke) {
				stroke = this._stroke = this._createElement('stroke');
				stroke.endcap = 'round';
				container.appendChild(stroke);
			}
			stroke.weight = options.weight + 'px';
			stroke.color = options.color;
			stroke.opacity = options.opacity;

			if (options.dashArray) {
				stroke.dashStyle = L.Util.isArray(options.dashArray) ?
				    options.dashArray.join(' ') :
				    options.dashArray.replace(/( *, *)/g, ' ');
			} else {
				stroke.dashStyle = '';
			}
			if (options.lineCap) {
				stroke.endcap = options.lineCap.replace('butt', 'flat');
			}
			if (options.lineJoin) {
				stroke.joinstyle = options.lineJoin;
			}

		} else if (stroke) {
			container.removeChild(stroke);
			this._stroke = null;
		}

		if (options.fill) {
			if (!fill) {
				fill = this._fill = this._createElement('fill');
				container.appendChild(fill);
			}
			fill.color = options.fillColor || options.color;
			fill.opacity = options.fillOpacity;

		} else if (fill) {
			container.removeChild(fill);
			this._fill = null;
		}
	},

	_updatePath: function () {
		var style = this._container.style;

		style.display = 'none';
		this._path.v = this.getPathString() + ' '; // the space fixes IE empty path string bug
		style.display = '';
	}
});

L.Map.include(L.Browser.svg || !L.Browser.vml ? {} : {
	_initPathRoot: function () {
		if (this._pathRoot) { return; }

		var root = this._pathRoot = document.createElement('div');
		root.className = 'leaflet-vml-container';
		this._panes.overlayPane.appendChild(root);

		this.on('moveend', this._updatePathViewport);
		this._updatePathViewport();
	}
});


/*
 * Vector rendering for all browsers that support canvas.
 */

L.Browser.canvas = (function () {
	return !!document.createElement('canvas').getContext;
}());

L.Path = (L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? L.Path : L.Path.extend({
	statics: {
		//CLIP_PADDING: 0.02, // not sure if there's a need to set it to a small value
		CANVAS: true,
		SVG: false
	},

	redraw: function () {
		if (this._map) {
			this.projectLatlngs();
			this._requestUpdate();
		}
		return this;
	},

	setStyle: function (style) {
		L.setOptions(this, style);

		if (this._map) {
			this._updateStyle();
			this._requestUpdate();
		}
		return this;
	},

	onRemove: function (map) {
		map
		    .off('viewreset', this.projectLatlngs, this)
		    .off('moveend', this._updatePath, this);

		if (this.options.clickable) {
			this._map.off('click', this._onClick, this);
			this._map.off('mousemove', this._onMouseMove, this);
		}

		this._requestUpdate();
		
		this.fire('remove');
		this._map = null;
	},

	_requestUpdate: function () {
		if (this._map && !L.Path._updateRequest) {
			L.Path._updateRequest = L.Util.requestAnimFrame(this._fireMapMoveEnd, this._map);
		}
	},

	_fireMapMoveEnd: function () {
		L.Path._updateRequest = null;
		this.fire('moveend');
	},

	_initElements: function () {
		this._map._initPathRoot();
		this._ctx = this._map._canvasCtx;
	},

	_updateStyle: function () {
		var options = this.options;

		if (options.stroke) {
			this._ctx.lineWidth = options.weight;
			this._ctx.strokeStyle = options.color;
		}
		if (options.fill) {
			this._ctx.fillStyle = options.fillColor || options.color;
		}

		if (options.lineCap) {
			this._ctx.lineCap = options.lineCap;
		}
		if (options.lineJoin) {
			this._ctx.lineJoin = options.lineJoin;
		}
	},

	_drawPath: function () {
		var i, j, len, len2, point, drawMethod;

		this._ctx.beginPath();

		for (i = 0, len = this._parts.length; i < len; i++) {
			for (j = 0, len2 = this._parts[i].length; j < len2; j++) {
				point = this._parts[i][j];
				drawMethod = (j === 0 ? 'move' : 'line') + 'To';

				this._ctx[drawMethod](point.x, point.y);
			}
			// TODO refactor ugly hack
			if (this instanceof L.Polygon) {
				this._ctx.closePath();
			}
		}
	},

	_checkIfEmpty: function () {
		return !this._parts.length;
	},

	_updatePath: function () {
		if (this._checkIfEmpty()) { return; }

		var ctx = this._ctx,
		    options = this.options;

		this._drawPath();
		ctx.save();
		this._updateStyle();

		if (options.fill) {
			ctx.globalAlpha = options.fillOpacity;
			ctx.fill(options.fillRule || 'evenodd');
		}

		if (options.stroke) {
			ctx.globalAlpha = options.opacity;
			ctx.stroke();
		}

		ctx.restore();

		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	},

	_initEvents: function () {
		if (this.options.clickable) {
			this._map.on('mousemove', this._onMouseMove, this);
			this._map.on('click dblclick contextmenu', this._fireMouseEvent, this);
		}
	},

	_fireMouseEvent: function (e) {
		if (this._containsPoint(e.layerPoint)) {
			this.fire(e.type, e);
		}
	},

	_onMouseMove: function (e) {
		if (!this._map || this._map._animatingZoom) { return; }

		// TODO don't do on each move
		if (this._containsPoint(e.layerPoint)) {
			this._ctx.canvas.style.cursor = 'pointer';
			this._mouseInside = true;
			this.fire('mouseover', e);

		} else if (this._mouseInside) {
			this._ctx.canvas.style.cursor = '';
			this._mouseInside = false;
			this.fire('mouseout', e);
		}
	}
});

L.Map.include((L.Path.SVG && !window.L_PREFER_CANVAS) || !L.Browser.canvas ? {} : {
	_initPathRoot: function () {
		var root = this._pathRoot,
		    ctx;

		if (!root) {
			root = this._pathRoot = document.createElement('canvas');
			root.style.position = 'absolute';
			ctx = this._canvasCtx = root.getContext('2d');

			ctx.lineCap = 'round';
			ctx.lineJoin = 'round';

			this._panes.overlayPane.appendChild(root);

			if (this.options.zoomAnimation) {
				this._pathRoot.className = 'leaflet-zoom-animated';
				this.on('zoomanim', this._animatePathZoom);
				this.on('zoomend', this._endPathZoom);
			}
			this.on('moveend', this._updateCanvasViewport);
			this._updateCanvasViewport();
		}
	},

	_updateCanvasViewport: function () {
		// don't redraw while zooming. See _updateSvgViewport for more details
		if (this._pathZooming) { return; }
		this._updatePathViewport();

		var vp = this._pathViewport,
		    min = vp.min,
		    size = vp.max.subtract(min),
		    root = this._pathRoot;

		//TODO check if this works properly on mobile webkit
		L.DomUtil.setPosition(root, min);
		root.width = size.x;
		root.height = size.y;
		root.getContext('2d').translate(-min.x, -min.y);
	}
});


/*
 * L.LineUtil contains different utility functions for line segments
 * and polylines (clipping, simplification, distances, etc.)
 */

/*jshint bitwise:false */ // allow bitwise operations for this file

L.LineUtil = {

	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.

	simplify: function (/*Point[]*/ points, /*Number*/ tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}

		var sqTolerance = tolerance * tolerance;

		// stage 1: vertex reduction
		points = this._reducePoints(points, sqTolerance);

		// stage 2: Douglas-Peucker simplification
		points = this._simplifyDP(points, sqTolerance);

		return points;
	},

	// distance from a point to a segment between two points
	pointToSegmentDistance:  function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
		return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
	},

	closestPointOnSegment: function (/*Point*/ p, /*Point*/ p1, /*Point*/ p2) {
		return this._sqClosestPointOnSegment(p, p1, p2);
	},

	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	_simplifyDP: function (points, sqTolerance) {

		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);

		markers[0] = markers[len - 1] = 1;

		this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

		var i,
		    newPoints = [];

		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}

		return newPoints;
	},

	_simplifyDPStep: function (points, markers, sqTolerance, first, last) {

		var maxSqDist = 0,
		    index, i, sqDist;

		for (i = first + 1; i <= last - 1; i++) {
			sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);

			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}

		if (maxSqDist > sqTolerance) {
			markers[index] = 1;

			this._simplifyDPStep(points, markers, sqTolerance, first, index);
			this._simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	},

	// reduce points that are too close to each other to a single point
	_reducePoints: function (points, sqTolerance) {
		var reducedPoints = [points[0]];

		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (this._sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	},

	// Cohen-Sutherland line clipping algorithm.
	// Used to avoid rendering parts of a polyline that are not currently visible.

	clipSegment: function (a, b, bounds, useLastCode) {
		var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
		    codeB = this._getBitCode(b, bounds),

		    codeOut, p, newCode;

		// save 2nd code to avoid calculating it on the next segment
		this._lastCode = codeB;

		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			// if a,b is outside the clip window (trivial reject)
			} else if (codeA & codeB) {
				return false;
			// other cases
			} else {
				codeOut = codeA || codeB;
				p = this._getEdgeIntersection(a, b, codeOut, bounds);
				newCode = this._getBitCode(p, bounds);

				if (codeOut === codeA) {
					a = p;
					codeA = newCode;
				} else {
					b = p;
					codeB = newCode;
				}
			}
		}
	},

	_getEdgeIntersection: function (a, b, code, bounds) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max;

		if (code & 8) { // top
			return new L.Point(a.x + dx * (max.y - a.y) / dy, max.y);
		} else if (code & 4) { // bottom
			return new L.Point(a.x + dx * (min.y - a.y) / dy, min.y);
		} else if (code & 2) { // right
			return new L.Point(max.x, a.y + dy * (max.x - a.x) / dx);
		} else if (code & 1) { // left
			return new L.Point(min.x, a.y + dy * (min.x - a.x) / dx);
		}
	},

	_getBitCode: function (/*Point*/ p, bounds) {
		var code = 0;

		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}
		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}

		return code;
	},

	// square distance (to avoid unnecessary Math.sqrt calls)
	_sqDist: function (p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	},

	// return closest point on segment or distance to that point
	_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;

		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}

		dx = p.x - x;
		dy = p.y - y;

		return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
	}
};


/*
 * L.Polyline is used to display polylines on a map.
 */

L.Polyline = L.Path.extend({
	initialize: function (latlngs, options) {
		L.Path.prototype.initialize.call(this, options);

		this._latlngs = this._convertLatLngs(latlngs);
	},

	options: {
		// how much to simplify the polyline on each zoom level
		// more = better performance and smoother look, less = more accurate
		smoothFactor: 1.0,
		noClip: false
	},

	projectLatlngs: function () {
		this._originalPoints = [];

		for (var i = 0, len = this._latlngs.length; i < len; i++) {
			this._originalPoints[i] = this._map.latLngToLayerPoint(this._latlngs[i]);
		}
	},

	getPathString: function () {
		for (var i = 0, len = this._parts.length, str = ''; i < len; i++) {
			str += this._getPathPartStr(this._parts[i]);
		}
		return str;
	},

	getLatLngs: function () {
		return this._latlngs;
	},

	setLatLngs: function (latlngs) {
		this._latlngs = this._convertLatLngs(latlngs);
		return this.redraw();
	},

	addLatLng: function (latlng) {
		this._latlngs.push(L.latLng(latlng));
		return this.redraw();
	},

	spliceLatLngs: function () { // (Number index, Number howMany)
		var removed = [].splice.apply(this._latlngs, arguments);
		this._convertLatLngs(this._latlngs, true);
		this.redraw();
		return removed;
	},

	closestLayerPoint: function (p) {
		var minDistance = Infinity, parts = this._parts, p1, p2, minPoint = null;

		for (var j = 0, jLen = parts.length; j < jLen; j++) {
			var points = parts[j];
			for (var i = 1, len = points.length; i < len; i++) {
				p1 = points[i - 1];
				p2 = points[i];
				var sqDist = L.LineUtil._sqClosestPointOnSegment(p, p1, p2, true);
				if (sqDist < minDistance) {
					minDistance = sqDist;
					minPoint = L.LineUtil._sqClosestPointOnSegment(p, p1, p2);
				}
			}
		}
		if (minPoint) {
			minPoint.distance = Math.sqrt(minDistance);
		}
		return minPoint;
	},

	getBounds: function () {
		return new L.LatLngBounds(this.getLatLngs());
	},

	_convertLatLngs: function (latlngs, overwrite) {
		var i, len, target = overwrite ? latlngs : [];

		for (i = 0, len = latlngs.length; i < len; i++) {
			if (L.Util.isArray(latlngs[i]) && typeof latlngs[i][0] !== 'number') {
				return;
			}
			target[i] = L.latLng(latlngs[i]);
		}
		return target;
	},

	_initEvents: function () {
		L.Path.prototype._initEvents.call(this);
	},

	_getPathPartStr: function (points) {
		var round = L.Path.VML;

		for (var j = 0, len2 = points.length, str = '', p; j < len2; j++) {
			p = points[j];
			if (round) {
				p._round();
			}
			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
		}
		return str;
	},

	_clipPoints: function () {
		var points = this._originalPoints,
		    len = points.length,
		    i, k, segment;

		if (this.options.noClip) {
			this._parts = [points];
			return;
		}

		this._parts = [];

		var parts = this._parts,
		    vp = this._map._pathViewport,
		    lu = L.LineUtil;

		for (i = 0, k = 0; i < len - 1; i++) {
			segment = lu.clipSegment(points[i], points[i + 1], vp, i);
			if (!segment) {
				continue;
			}

			parts[k] = parts[k] || [];
			parts[k].push(segment[0]);

			// if segment goes out of screen, or it's the last one, it's the end of the line part
			if ((segment[1] !== points[i + 1]) || (i === len - 2)) {
				parts[k].push(segment[1]);
				k++;
			}
		}
	},

	// simplify each clipped part of the polyline
	_simplifyPoints: function () {
		var parts = this._parts,
		    lu = L.LineUtil;

		for (var i = 0, len = parts.length; i < len; i++) {
			parts[i] = lu.simplify(parts[i], this.options.smoothFactor);
		}
	},

	_updatePath: function () {
		if (!this._map) { return; }

		this._clipPoints();
		this._simplifyPoints();

		L.Path.prototype._updatePath.call(this);
	}
});

L.polyline = function (latlngs, options) {
	return new L.Polyline(latlngs, options);
};


/*
 * L.PolyUtil contains utility functions for polygons (clipping, etc.).
 */

/*jshint bitwise:false */ // allow bitwise operations here

L.PolyUtil = {};

/*
 * Sutherland-Hodgeman polygon clipping algorithm.
 * Used to avoid rendering parts of a polygon that are not currently visible.
 */
L.PolyUtil.clipPolygon = function (points, bounds) {
	var clippedPoints,
	    edges = [1, 4, 2, 8],
	    i, j, k,
	    a, b,
	    len, edge, p,
	    lu = L.LineUtil;

	for (i = 0, len = points.length; i < len; i++) {
		points[i]._code = lu._getBitCode(points[i], bounds);
	}

	// for each edge (left, bottom, right, top)
	for (k = 0; k < 4; k++) {
		edge = edges[k];
		clippedPoints = [];

		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
			a = points[i];
			b = points[j];

			// if a is inside the clip window
			if (!(a._code & edge)) {
				// if b is outside the clip window (a->b goes out of screen)
				if (b._code & edge) {
					p = lu._getEdgeIntersection(b, a, edge, bounds);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
				clippedPoints.push(a);

			// else if b is inside the clip window (a->b enters the screen)
			} else if (!(b._code & edge)) {
				p = lu._getEdgeIntersection(b, a, edge, bounds);
				p._code = lu._getBitCode(p, bounds);
				clippedPoints.push(p);
			}
		}
		points = clippedPoints;
	}

	return points;
};


/*
 * L.Polygon is used to display polygons on a map.
 */

L.Polygon = L.Polyline.extend({
	options: {
		fill: true
	},

	initialize: function (latlngs, options) {
		L.Polyline.prototype.initialize.call(this, latlngs, options);
		this._initWithHoles(latlngs);
	},

	_initWithHoles: function (latlngs) {
		var i, len, hole;
		if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
			this._latlngs = this._convertLatLngs(latlngs[0]);
			this._holes = latlngs.slice(1);

			for (i = 0, len = this._holes.length; i < len; i++) {
				hole = this._holes[i] = this._convertLatLngs(this._holes[i]);
				if (hole[0].equals(hole[hole.length - 1])) {
					hole.pop();
				}
			}
		}

		// filter out last point if its equal to the first one
		latlngs = this._latlngs;

		if (latlngs.length >= 2 && latlngs[0].equals(latlngs[latlngs.length - 1])) {
			latlngs.pop();
		}
	},

	projectLatlngs: function () {
		L.Polyline.prototype.projectLatlngs.call(this);

		// project polygon holes points
		// TODO move this logic to Polyline to get rid of duplication
		this._holePoints = [];

		if (!this._holes) { return; }

		var i, j, len, len2;

		for (i = 0, len = this._holes.length; i < len; i++) {
			this._holePoints[i] = [];

			for (j = 0, len2 = this._holes[i].length; j < len2; j++) {
				this._holePoints[i][j] = this._map.latLngToLayerPoint(this._holes[i][j]);
			}
		}
	},

	setLatLngs: function (latlngs) {
		if (latlngs && L.Util.isArray(latlngs[0]) && (typeof latlngs[0][0] !== 'number')) {
			this._initWithHoles(latlngs);
			return this.redraw();
		} else {
			return L.Polyline.prototype.setLatLngs.call(this, latlngs);
		}
	},

	_clipPoints: function () {
		var points = this._originalPoints,
		    newParts = [];

		this._parts = [points].concat(this._holePoints);

		if (this.options.noClip) { return; }

		for (var i = 0, len = this._parts.length; i < len; i++) {
			var clipped = L.PolyUtil.clipPolygon(this._parts[i], this._map._pathViewport);
			if (clipped.length) {
				newParts.push(clipped);
			}
		}

		this._parts = newParts;
	},

	_getPathPartStr: function (points) {
		var str = L.Polyline.prototype._getPathPartStr.call(this, points);
		return str + (L.Browser.svg ? 'z' : 'x');
	}
});

L.polygon = function (latlngs, options) {
	return new L.Polygon(latlngs, options);
};


/*
 * Contains L.MultiPolyline and L.MultiPolygon layers.
 */

(function () {
	function createMulti(Klass) {

		return L.FeatureGroup.extend({

			initialize: function (latlngs, options) {
				this._layers = {};
				this._options = options;
				this.setLatLngs(latlngs);
			},

			setLatLngs: function (latlngs) {
				var i = 0,
				    len = latlngs.length;

				this.eachLayer(function (layer) {
					if (i < len) {
						layer.setLatLngs(latlngs[i++]);
					} else {
						this.removeLayer(layer);
					}
				}, this);

				while (i < len) {
					this.addLayer(new Klass(latlngs[i++], this._options));
				}

				return this;
			},

			getLatLngs: function () {
				var latlngs = [];

				this.eachLayer(function (layer) {
					latlngs.push(layer.getLatLngs());
				});

				return latlngs;
			}
		});
	}

	L.MultiPolyline = createMulti(L.Polyline);
	L.MultiPolygon = createMulti(L.Polygon);

	L.multiPolyline = function (latlngs, options) {
		return new L.MultiPolyline(latlngs, options);
	};

	L.multiPolygon = function (latlngs, options) {
		return new L.MultiPolygon(latlngs, options);
	};
}());


/*
 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
 */

L.Rectangle = L.Polygon.extend({
	initialize: function (latLngBounds, options) {
		L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	},

	setBounds: function (latLngBounds) {
		this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	},

	_boundsToLatLngs: function (latLngBounds) {
		latLngBounds = L.latLngBounds(latLngBounds);
		return [
			latLngBounds.getSouthWest(),
			latLngBounds.getNorthWest(),
			latLngBounds.getNorthEast(),
			latLngBounds.getSouthEast()
		];
	}
});

L.rectangle = function (latLngBounds, options) {
	return new L.Rectangle(latLngBounds, options);
};


/*
 * L.Circle is a circle overlay (with a certain radius in meters).
 */

L.Circle = L.Path.extend({
	initialize: function (latlng, radius, options) {
		L.Path.prototype.initialize.call(this, options);

		this._latlng = L.latLng(latlng);
		this._mRadius = radius;
	},

	options: {
		fill: true
	},

	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		return this.redraw();
	},

	setRadius: function (radius) {
		this._mRadius = radius;
		return this.redraw();
	},

	projectLatlngs: function () {
		var lngRadius = this._getLngRadius(),
		    latlng = this._latlng,
		    pointLeft = this._map.latLngToLayerPoint([latlng.lat, latlng.lng - lngRadius]);

		this._point = this._map.latLngToLayerPoint(latlng);
		this._radius = Math.max(this._point.x - pointLeft.x, 1);
	},

	getBounds: function () {
		var lngRadius = this._getLngRadius(),
		    latRadius = (this._mRadius / 40075017) * 360,
		    latlng = this._latlng;

		return new L.LatLngBounds(
		        [latlng.lat - latRadius, latlng.lng - lngRadius],
		        [latlng.lat + latRadius, latlng.lng + lngRadius]);
	},

	getLatLng: function () {
		return this._latlng;
	},

	getPathString: function () {
		var p = this._point,
		    r = this._radius;

		if (this._checkIfEmpty()) {
			return '';
		}

		if (L.Browser.svg) {
			return 'M' + p.x + ',' + (p.y - r) +
			       'A' + r + ',' + r + ',0,1,1,' +
			       (p.x - 0.1) + ',' + (p.y - r) + ' z';
		} else {
			p._round();
			r = Math.round(r);
			return 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r + ' 0,' + (65535 * 360);
		}
	},

	getRadius: function () {
		return this._mRadius;
	},

	// TODO Earth hardcoded, move into projection code!

	_getLatRadius: function () {
		return (this._mRadius / 40075017) * 360;
	},

	_getLngRadius: function () {
		return this._getLatRadius() / Math.cos(L.LatLng.DEG_TO_RAD * this._latlng.lat);
	},

	_checkIfEmpty: function () {
		if (!this._map) {
			return false;
		}
		var vp = this._map._pathViewport,
		    r = this._radius,
		    p = this._point;

		return p.x - r > vp.max.x || p.y - r > vp.max.y ||
		       p.x + r < vp.min.x || p.y + r < vp.min.y;
	}
});

L.circle = function (latlng, radius, options) {
	return new L.Circle(latlng, radius, options);
};


/*
 * L.CircleMarker is a circle overlay with a permanent pixel radius.
 */

L.CircleMarker = L.Circle.extend({
	options: {
		radius: 10,
		weight: 2
	},

	initialize: function (latlng, options) {
		L.Circle.prototype.initialize.call(this, latlng, null, options);
		this._radius = this.options.radius;
	},

	projectLatlngs: function () {
		this._point = this._map.latLngToLayerPoint(this._latlng);
	},

	_updateStyle : function () {
		L.Circle.prototype._updateStyle.call(this);
		this.setRadius(this.options.radius);
	},

	setLatLng: function (latlng) {
		L.Circle.prototype.setLatLng.call(this, latlng);
		if (this._popup && this._popup._isOpen) {
			this._popup.setLatLng(latlng);
		}
		return this;
	},

	setRadius: function (radius) {
		this.options.radius = this._radius = radius;
		return this.redraw();
	},

	getRadius: function () {
		return this._radius;
	}
});

L.circleMarker = function (latlng, options) {
	return new L.CircleMarker(latlng, options);
};


/*
 * Extends L.Polyline to be able to manually detect clicks on Canvas-rendered polylines.
 */

L.Polyline.include(!L.Path.CANVAS ? {} : {
	_containsPoint: function (p, closed) {
		var i, j, k, len, len2, dist, part,
		    w = this.options.weight / 2;

		if (L.Browser.touch) {
			w += 10; // polyline click tolerance on touch devices
		}

		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) {
					continue;
				}

				dist = L.LineUtil.pointToSegmentDistance(p, part[k], part[j]);

				if (dist <= w) {
					return true;
				}
			}
		}
		return false;
	}
});


/*
 * Extends L.Polygon to be able to manually detect clicks on Canvas-rendered polygons.
 */

L.Polygon.include(!L.Path.CANVAS ? {} : {
	_containsPoint: function (p) {
		var inside = false,
		    part, p1, p2,
		    i, j, k,
		    len, len2;

		// TODO optimization: check if within bounds first

		if (L.Polyline.prototype._containsPoint.call(this, p, true)) {
			// click on polygon border
			return true;
		}

		// ray casting algorithm for detecting if point is in polygon

		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];

			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];

				if (((p1.y > p.y) !== (p2.y > p.y)) &&
						(p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}

		return inside;
	}
});


/*
 * Extends L.Circle with Canvas-specific code.
 */

L.Circle.include(!L.Path.CANVAS ? {} : {
	_drawPath: function () {
		var p = this._point;
		this._ctx.beginPath();
		this._ctx.arc(p.x, p.y, this._radius, 0, Math.PI * 2, false);
	},

	_containsPoint: function (p) {
		var center = this._point,
		    w2 = this.options.stroke ? this.options.weight / 2 : 0;

		return (p.distanceTo(center) <= this._radius + w2);
	}
});


/*
 * CircleMarker canvas specific drawing parts.
 */

L.CircleMarker.include(!L.Path.CANVAS ? {} : {
	_updateStyle: function () {
		L.Path.prototype._updateStyle.call(this);
	}
});


/*
 * L.GeoJSON turns any GeoJSON data into a Leaflet layer.
 */

L.GeoJSON = L.FeatureGroup.extend({

	initialize: function (geojson, options) {
		L.setOptions(this, options);

		this._layers = {};

		if (geojson) {
			this.addData(geojson);
		}
	},

	addData: function (geojson) {
		var features = L.Util.isArray(geojson) ? geojson : geojson.features,
		    i, len, feature;

		if (features) {
			for (i = 0, len = features.length; i < len; i++) {
				// Only add this if geometry or geometries are set and not null
				feature = features[i];
				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
					this.addData(features[i]);
				}
			}
			return this;
		}

		var options = this.options;

		if (options.filter && !options.filter(geojson)) { return; }

		var layer = L.GeoJSON.geometryToLayer(geojson, options.pointToLayer, options.coordsToLatLng, options);
		layer.feature = L.GeoJSON.asFeature(geojson);

		layer.defaultOptions = layer.options;
		this.resetStyle(layer);

		if (options.onEachFeature) {
			options.onEachFeature(geojson, layer);
		}

		return this.addLayer(layer);
	},

	resetStyle: function (layer) {
		var style = this.options.style;
		if (style) {
			// reset any custom styles
			L.Util.extend(layer.options, layer.defaultOptions);

			this._setLayerStyle(layer, style);
		}
	},

	setStyle: function (style) {
		this.eachLayer(function (layer) {
			this._setLayerStyle(layer, style);
		}, this);
	},

	_setLayerStyle: function (layer, style) {
		if (typeof style === 'function') {
			style = style(layer.feature);
		}
		if (layer.setStyle) {
			layer.setStyle(style);
		}
	}
});

L.extend(L.GeoJSON, {
	geometryToLayer: function (geojson, pointToLayer, coordsToLatLng, vectorOptions) {
		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry.coordinates,
		    layers = [],
		    latlng, latlngs, i, len;

		coordsToLatLng = coordsToLatLng || this.coordsToLatLng;

		switch (geometry.type) {
		case 'Point':
			latlng = coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);

		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
			}
			return new L.FeatureGroup(layers);

		case 'LineString':
			latlngs = this.coordsToLatLngs(coords, 0, coordsToLatLng);
			return new L.Polyline(latlngs, vectorOptions);

		case 'Polygon':
			if (coords.length === 2 && !coords[1].length) {
				throw new Error('Invalid GeoJSON object.');
			}
			latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
			return new L.Polygon(latlngs, vectorOptions);

		case 'MultiLineString':
			latlngs = this.coordsToLatLngs(coords, 1, coordsToLatLng);
			return new L.MultiPolyline(latlngs, vectorOptions);

		case 'MultiPolygon':
			latlngs = this.coordsToLatLngs(coords, 2, coordsToLatLng);
			return new L.MultiPolygon(latlngs, vectorOptions);

		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {

				layers.push(this.geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, pointToLayer, coordsToLatLng, vectorOptions));
			}
			return new L.FeatureGroup(layers);

		default:
			throw new Error('Invalid GeoJSON object.');
		}
	},

	coordsToLatLng: function (coords) { // (Array[, Boolean]) -> LatLng
		return new L.LatLng(coords[1], coords[0], coords[2]);
	},

	coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) { // (Array[, Number, Function]) -> Array
		var latlng, i, len,
		    latlngs = [];

		for (i = 0, len = coords.length; i < len; i++) {
			latlng = levelsDeep ?
			        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
			        (coordsToLatLng || this.coordsToLatLng)(coords[i]);

			latlngs.push(latlng);
		}

		return latlngs;
	},

	latLngToCoords: function (latlng) {
		var coords = [latlng.lng, latlng.lat];

		if (latlng.alt !== undefined) {
			coords.push(latlng.alt);
		}
		return coords;
	},

	latLngsToCoords: function (latLngs) {
		var coords = [];

		for (var i = 0, len = latLngs.length; i < len; i++) {
			coords.push(L.GeoJSON.latLngToCoords(latLngs[i]));
		}

		return coords;
	},

	getFeature: function (layer, newGeometry) {
		return layer.feature ? L.extend({}, layer.feature, {geometry: newGeometry}) : L.GeoJSON.asFeature(newGeometry);
	},

	asFeature: function (geoJSON) {
		if (geoJSON.type === 'Feature') {
			return geoJSON;
		}

		return {
			type: 'Feature',
			properties: {},
			geometry: geoJSON
		};
	}
});

var PointToGeoJSON = {
	toGeoJSON: function () {
		return L.GeoJSON.getFeature(this, {
			type: 'Point',
			coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
		});
	}
};

L.Marker.include(PointToGeoJSON);
L.Circle.include(PointToGeoJSON);
L.CircleMarker.include(PointToGeoJSON);

L.Polyline.include({
	toGeoJSON: function () {
		return L.GeoJSON.getFeature(this, {
			type: 'LineString',
			coordinates: L.GeoJSON.latLngsToCoords(this.getLatLngs())
		});
	}
});

L.Polygon.include({
	toGeoJSON: function () {
		var coords = [L.GeoJSON.latLngsToCoords(this.getLatLngs())],
		    i, len, hole;

		coords[0].push(coords[0][0]);

		if (this._holes) {
			for (i = 0, len = this._holes.length; i < len; i++) {
				hole = L.GeoJSON.latLngsToCoords(this._holes[i]);
				hole.push(hole[0]);
				coords.push(hole);
			}
		}

		return L.GeoJSON.getFeature(this, {
			type: 'Polygon',
			coordinates: coords
		});
	}
});

(function () {
	function multiToGeoJSON(type) {
		return function () {
			var coords = [];

			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON().geometry.coordinates);
			});

			return L.GeoJSON.getFeature(this, {
				type: type,
				coordinates: coords
			});
		};
	}

	L.MultiPolyline.include({toGeoJSON: multiToGeoJSON('MultiLineString')});
	L.MultiPolygon.include({toGeoJSON: multiToGeoJSON('MultiPolygon')});

	L.LayerGroup.include({
		toGeoJSON: function () {

			var geometry = this.feature && this.feature.geometry,
				jsons = [],
				json;

			if (geometry && geometry.type === 'MultiPoint') {
				return multiToGeoJSON('MultiPoint').call(this);
			}

			var isGeometryCollection = geometry && geometry.type === 'GeometryCollection';

			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					json = layer.toGeoJSON();
					jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
				}
			});

			if (isGeometryCollection) {
				return L.GeoJSON.getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}

			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
}());

L.geoJson = function (geojson, options) {
	return new L.GeoJSON(geojson, options);
};


/*
 * L.DomEvent contains functions for working with DOM events.
 */

L.DomEvent = {
	/* inspired by John Resig, Dean Edwards and YUI addEvent implementations */
	addListener: function (obj, type, fn, context) { // (HTMLElement, String, Function[, Object])

		var id = L.stamp(fn),
		    key = '_leaflet_' + type + id,
		    handler, originalHandler, newType;

		if (obj[key]) { return this; }

		handler = function (e) {
			return fn.call(context || obj, e || L.DomEvent._getEvent());
		};

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			return this.addPointerListener(obj, type, handler, id);
		}
		if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener) {
			this.addDoubleTapListener(obj, handler, id);
		}

		if ('addEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.addEventListener('DOMMouseScroll', handler, false);
				obj.addEventListener(type, handler, false);

			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {

				originalHandler = handler;
				newType = (type === 'mouseenter' ? 'mouseover' : 'mouseout');

				handler = function (e) {
					if (!L.DomEvent._checkMouse(obj, e)) { return; }
					return originalHandler(e);
				};

				obj.addEventListener(newType, handler, false);

			} else if (type === 'click' && L.Browser.android) {
				originalHandler = handler;
				handler = function (e) {
					return L.DomEvent._filterClick(e, originalHandler);
				};

				obj.addEventListener(type, handler, false);
			} else {
				obj.addEventListener(type, handler, false);
			}

		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}

		obj[key] = handler;

		return this;
	},

	removeListener: function (obj, type, fn) {  // (HTMLElement, String, Function)

		var id = L.stamp(fn),
		    key = '_leaflet_' + type + id,
		    handler = obj[key];

		if (!handler) { return this; }

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			this.removePointerListener(obj, type, id);
		} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
			this.removeDoubleTapListener(obj, id);

		} else if ('removeEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.removeEventListener('DOMMouseScroll', handler, false);
				obj.removeEventListener(type, handler, false);

			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				obj.removeEventListener((type === 'mouseenter' ? 'mouseover' : 'mouseout'), handler, false);
			} else {
				obj.removeEventListener(type, handler, false);
			}
		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}

		obj[key] = null;

		return this;
	},

	stopPropagation: function (e) {

		if (e.stopPropagation) {
			e.stopPropagation();
		} else {
			e.cancelBubble = true;
		}
		L.DomEvent._skipped(e);

		return this;
	},

	disableScrollPropagation: function (el) {
		var stop = L.DomEvent.stopPropagation;

		return L.DomEvent
			.on(el, 'mousewheel', stop)
			.on(el, 'MozMousePixelScroll', stop);
	},

	disableClickPropagation: function (el) {
		var stop = L.DomEvent.stopPropagation;

		for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
			L.DomEvent.on(el, L.Draggable.START[i], stop);
		}

		return L.DomEvent
			.on(el, 'click', L.DomEvent._fakeStop)
			.on(el, 'dblclick', stop);
	},

	preventDefault: function (e) {

		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	},

	stop: function (e) {
		return L.DomEvent
			.preventDefault(e)
			.stopPropagation(e);
	},

	getMousePosition: function (e, container) {
		if (!container) {
			return new L.Point(e.clientX, e.clientY);
		}

		var rect = container.getBoundingClientRect();

		return new L.Point(
			e.clientX - rect.left - container.clientLeft,
			e.clientY - rect.top - container.clientTop);
	},

	getWheelDelta: function (e) {

		var delta = 0;

		if (e.wheelDelta) {
			delta = e.wheelDelta / 120;
		}
		if (e.detail) {
			delta = -e.detail / 3;
		}
		return delta;
	},

	_skipEvents: {},

	_fakeStop: function (e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
		L.DomEvent._skipEvents[e.type] = true;
	},

	_skipped: function (e) {
		var skipped = this._skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		this._skipEvents[e.type] = false;
		return skipped;
	},

	// check if element really left/entered the event target (for mouseenter/mouseleave)
	_checkMouse: function (el, e) {

		var related = e.relatedTarget;

		if (!related) { return true; }

		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	},

	_getEvent: function () { // evil magic for IE
		/*jshint noarg:false */
		var e = window.event;
		if (!e) {
			var caller = arguments.callee.caller;
			while (caller) {
				e = caller['arguments'][0];
				if (e && window.Event === e.constructor) {
					break;
				}
				caller = caller.caller;
			}
		}
		return e;
	},

	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	_filterClick: function (e, handler) {
		var timeStamp = (e.timeStamp || e.originalEvent.timeStamp),
			elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);

		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events

		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			L.DomEvent.stop(e);
			return;
		}
		L.DomEvent._lastClick = timeStamp;

		return handler(e);
	}
};

L.DomEvent.on = L.DomEvent.addListener;
L.DomEvent.off = L.DomEvent.removeListener;


/*
 * L.Draggable allows you to add dragging capabilities to any element. Supports mobile devices too.
 */

L.Draggable = L.Class.extend({
	includes: L.Mixin.Events,

	statics: {
		START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
		END: {
			mousedown: 'mouseup',
			touchstart: 'touchend',
			pointerdown: 'touchend',
			MSPointerDown: 'touchend'
		},
		MOVE: {
			mousedown: 'mousemove',
			touchstart: 'touchmove',
			pointerdown: 'touchmove',
			MSPointerDown: 'touchmove'
		}
	},

	initialize: function (element, dragStartTarget) {
		this._element = element;
		this._dragStartTarget = dragStartTarget || element;
	},

	enable: function () {
		if (this._enabled) { return; }

		for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
			L.DomEvent.on(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
		}

		this._enabled = true;
	},

	disable: function () {
		if (!this._enabled) { return; }

		for (var i = L.Draggable.START.length - 1; i >= 0; i--) {
			L.DomEvent.off(this._dragStartTarget, L.Draggable.START[i], this._onDown, this);
		}

		this._enabled = false;
		this._moved = false;
	},

	_onDown: function (e) {
		this._moved = false;

		if (e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }

		L.DomEvent.stopPropagation(e);

		if (L.Draggable._disabled) { return; }

		L.DomUtil.disableImageDrag();
		L.DomUtil.disableTextSelection();

		if (this._moving) { return; }

		var first = e.touches ? e.touches[0] : e;

		this._startPoint = new L.Point(first.clientX, first.clientY);
		this._startPos = this._newPos = L.DomUtil.getPosition(this._element);

		L.DomEvent
		    .on(document, L.Draggable.MOVE[e.type], this._onMove, this)
		    .on(document, L.Draggable.END[e.type], this._onUp, this);
	},

	_onMove: function (e) {
		if (e.touches && e.touches.length > 1) {
			this._moved = true;
			return;
		}

		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
		    newPoint = new L.Point(first.clientX, first.clientY),
		    offset = newPoint.subtract(this._startPoint);

		if (!offset.x && !offset.y) { return; }
		if (L.Browser.touch && Math.abs(offset.x) + Math.abs(offset.y) < 3) { return; }

		L.DomEvent.preventDefault(e);

		if (!this._moved) {
			this.fire('dragstart');

			this._moved = true;
			this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);

			L.DomUtil.addClass(document.body, 'leaflet-dragging');
			this._lastTarget = e.target || e.srcElement;
			L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
		}

		this._newPos = this._startPos.add(offset);
		this._moving = true;

		L.Util.cancelAnimFrame(this._animRequest);
		this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true, this._dragStartTarget);
	},

	_updatePosition: function () {
		this.fire('predrag');
		L.DomUtil.setPosition(this._element, this._newPos);
		this.fire('drag');
	},

	_onUp: function () {
		L.DomUtil.removeClass(document.body, 'leaflet-dragging');

		if (this._lastTarget) {
			L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
			this._lastTarget = null;
		}

		for (var i in L.Draggable.MOVE) {
			L.DomEvent
			    .off(document, L.Draggable.MOVE[i], this._onMove)
			    .off(document, L.Draggable.END[i], this._onUp);
		}

		L.DomUtil.enableImageDrag();
		L.DomUtil.enableTextSelection();

		if (this._moved && this._moving) {
			// ensure drag is not fired after dragend
			L.Util.cancelAnimFrame(this._animRequest);

			this.fire('dragend', {
				distance: this._newPos.distanceTo(this._startPos)
			});
		}

		this._moving = false;
	}
});


/*
	L.Handler is a base class for handler classes that are used internally to inject
	interaction features like dragging to classes like Map and Marker.
*/

L.Handler = L.Class.extend({
	initialize: function (map) {
		this._map = map;
	},

	enable: function () {
		if (this._enabled) { return; }

		this._enabled = true;
		this.addHooks();
	},

	disable: function () {
		if (!this._enabled) { return; }

		this._enabled = false;
		this.removeHooks();
	},

	enabled: function () {
		return !!this._enabled;
	}
});


/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */

L.Map.mergeOptions({
	dragging: true,

	inertia: !L.Browser.android23,
	inertiaDeceleration: 3400, // px/s^2
	inertiaMaxSpeed: Infinity, // px/s
	inertiaThreshold: L.Browser.touch ? 32 : 18, // ms
	easeLinearity: 0.25,

	// TODO refactor, move to CRS
	worldCopyJump: false
});

L.Map.Drag = L.Handler.extend({
	addHooks: function () {
		if (!this._draggable) {
			var map = this._map;

			this._draggable = new L.Draggable(map._mapPane, map._container);

			this._draggable.on({
				'dragstart': this._onDragStart,
				'drag': this._onDrag,
				'dragend': this._onDragEnd
			}, this);

			if (map.options.worldCopyJump) {
				this._draggable.on('predrag', this._onPreDrag, this);
				map.on('viewreset', this._onViewReset, this);

				map.whenReady(this._onViewReset, this);
			}
		}
		this._draggable.enable();
	},

	removeHooks: function () {
		this._draggable.disable();
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		var map = this._map;

		if (map._panAnim) {
			map._panAnim.stop();
		}

		map
		    .fire('movestart')
		    .fire('dragstart');

		if (map.options.inertia) {
			this._positions = [];
			this._times = [];
		}
	},

	_onDrag: function () {
		if (this._map.options.inertia) {
			var time = this._lastTime = +new Date(),
			    pos = this._lastPos = this._draggable._newPos;

			this._positions.push(pos);
			this._times.push(time);

			if (time - this._times[0] > 200) {
				this._positions.shift();
				this._times.shift();
			}
		}

		this._map
		    .fire('move')
		    .fire('drag');
	},

	_onViewReset: function () {
		// TODO fix hardcoded Earth values
		var pxCenter = this._map.getSize()._divideBy(2),
		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
		this._worldWidth = this._map.project([0, 180]).x;
	},

	_onPreDrag: function () {
		// TODO refactor to be able to adjust map pane position after zoom
		var worldWidth = this._worldWidth,
		    halfWidth = Math.round(worldWidth / 2),
		    dx = this._initialWorldOffset,
		    x = this._draggable._newPos.x,
		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

		this._draggable._newPos.x = newX;
	},

	_onDragEnd: function (e) {
		var map = this._map,
		    options = map.options,
		    delay = +new Date() - this._lastTime,

		    noInertia = !options.inertia || delay > options.inertiaThreshold || !this._positions[0];

		map.fire('dragend', e);

		if (noInertia) {
			map.fire('moveend');

		} else {

			var direction = this._lastPos.subtract(this._positions[0]),
			    duration = (this._lastTime + delay - this._times[0]) / 1000,
			    ease = options.easeLinearity,

			    speedVector = direction.multiplyBy(ease / duration),
			    speed = speedVector.distanceTo([0, 0]),

			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

			if (!offset.x || !offset.y) {
				map.fire('moveend');

			} else {
				offset = map._limitOffset(offset, map.options.maxBounds);

				L.Util.requestAnimFrame(function () {
					map.panBy(offset, {
						duration: decelerationDuration,
						easeLinearity: ease,
						noMoveStart: true
					});
				});
			}
		}
	}
});

L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);


/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */

L.Map.mergeOptions({
	doubleClickZoom: true
});

L.Map.DoubleClickZoom = L.Handler.extend({
	addHooks: function () {
		this._map.on('dblclick', this._onDoubleClick, this);
	},

	removeHooks: function () {
		this._map.off('dblclick', this._onDoubleClick, this);
	},

	_onDoubleClick: function (e) {
		var map = this._map,
		    zoom = map.getZoom() + (e.originalEvent.shiftKey ? -1 : 1);

		if (map.options.doubleClickZoom === 'center') {
			map.setZoom(zoom);
		} else {
			map.setZoomAround(e.containerPoint, zoom);
		}
	}
});

L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);


/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

L.Map.mergeOptions({
	scrollWheelZoom: true
});

L.Map.ScrollWheelZoom = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
		L.DomEvent.on(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
		this._delta = 0;
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll);
		L.DomEvent.off(this._map._container, 'MozMousePixelScroll', L.DomEvent.preventDefault);
	},

	_onWheelScroll: function (e) {
		var delta = L.DomEvent.getWheelDelta(e);

		this._delta += delta;
		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

		if (!this._startTime) {
			this._startTime = +new Date();
		}

		var left = Math.max(40 - (+new Date() - this._startTime), 0);

		clearTimeout(this._timer);
		this._timer = setTimeout(L.bind(this._performZoom, this), left);

		L.DomEvent.preventDefault(e);
		L.DomEvent.stopPropagation(e);
	},

	_performZoom: function () {
		var map = this._map,
		    delta = this._delta,
		    zoom = map.getZoom();

		delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
		delta = Math.max(Math.min(delta, 4), -4);
		delta = map._limitZoom(zoom + delta) - zoom;

		this._delta = 0;
		this._startTime = null;

		if (!delta) { return; }

		if (map.options.scrollWheelZoom === 'center') {
			map.setZoom(zoom + delta);
		} else {
			map.setZoomAround(this._lastMousePos, zoom + delta);
		}
	}
});

L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);


/*
 * Extends the event handling code with double tap support for mobile browsers.
 */

L.extend(L.DomEvent, {

	_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
	_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',

	// inspired by Zepto touch code by Thomas Fuchs
	addDoubleTapListener: function (obj, handler, id) {
		var last,
		    doubleTap = false,
		    delay = 250,
		    touch,
		    pre = '_leaflet_',
		    touchstart = this._touchstart,
		    touchend = this._touchend,
		    trackedTouches = [];

		function onTouchStart(e) {
			var count;

			if (L.Browser.pointer) {
				trackedTouches.push(e.pointerId);
				count = trackedTouches.length;
			} else {
				count = e.touches.length;
			}
			if (count > 1) {
				return;
			}

			var now = Date.now(),
				delta = now - (last || now);

			touch = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}

		function onTouchEnd(e) {
			if (L.Browser.pointer) {
				var idx = trackedTouches.indexOf(e.pointerId);
				if (idx === -1) {
					return;
				}
				trackedTouches.splice(idx, 1);
			}

			if (doubleTap) {
				if (L.Browser.pointer) {
					// work around .type being readonly with MSPointer* events
					var newTouch = { },
						prop;

					// jshint forin:false
					for (var i in touch) {
						prop = touch[i];
						if (typeof prop === 'function') {
							newTouch[i] = prop.bind(touch);
						} else {
							newTouch[i] = prop;
						}
					}
					touch = newTouch;
				}
				touch.type = 'dblclick';
				handler(touch);
				last = null;
			}
		}
		obj[pre + touchstart + id] = onTouchStart;
		obj[pre + touchend + id] = onTouchEnd;

		// on pointer we need to listen on the document, otherwise a drag starting on the map and moving off screen
		// will not come through to us, so we will lose track of how many touches are ongoing
		var endElement = L.Browser.pointer ? document.documentElement : obj;

		obj.addEventListener(touchstart, onTouchStart, false);
		endElement.addEventListener(touchend, onTouchEnd, false);

		if (L.Browser.pointer) {
			endElement.addEventListener(L.DomEvent.POINTER_CANCEL, onTouchEnd, false);
		}

		return this;
	},

	removeDoubleTapListener: function (obj, id) {
		var pre = '_leaflet_';

		obj.removeEventListener(this._touchstart, obj[pre + this._touchstart + id], false);
		(L.Browser.pointer ? document.documentElement : obj).removeEventListener(
		        this._touchend, obj[pre + this._touchend + id], false);

		if (L.Browser.pointer) {
			document.documentElement.removeEventListener(L.DomEvent.POINTER_CANCEL, obj[pre + this._touchend + id],
				false);
		}

		return this;
	}
});


/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */

L.extend(L.DomEvent, {

	//static
	POINTER_DOWN: L.Browser.msPointer ? 'MSPointerDown' : 'pointerdown',
	POINTER_MOVE: L.Browser.msPointer ? 'MSPointerMove' : 'pointermove',
	POINTER_UP: L.Browser.msPointer ? 'MSPointerUp' : 'pointerup',
	POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',

	_pointers: [],
	_pointerDocumentListener: false,

	// Provides a touch events wrapper for (ms)pointer events.
	// Based on changes by veproza https://github.com/CloudMade/Leaflet/pull/1019
	//ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

	addPointerListener: function (obj, type, handler, id) {

		switch (type) {
		case 'touchstart':
			return this.addPointerListenerStart(obj, type, handler, id);
		case 'touchend':
			return this.addPointerListenerEnd(obj, type, handler, id);
		case 'touchmove':
			return this.addPointerListenerMove(obj, type, handler, id);
		default:
			throw 'Unknown touch event type';
		}
	},

	addPointerListenerStart: function (obj, type, handler, id) {
		var pre = '_leaflet_',
		    pointers = this._pointers;

		var cb = function (e) {
			if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				L.DomEvent.preventDefault(e);
			}

			var alreadyInArray = false;
			for (var i = 0; i < pointers.length; i++) {
				if (pointers[i].pointerId === e.pointerId) {
					alreadyInArray = true;
					break;
				}
			}
			if (!alreadyInArray) {
				pointers.push(e);
			}

			e.touches = pointers.slice();
			e.changedTouches = [e];

			handler(e);
		};

		obj[pre + 'touchstart' + id] = cb;
		obj.addEventListener(this.POINTER_DOWN, cb, false);

		// need to also listen for end events to keep the _pointers list accurate
		// this needs to be on the body and never go away
		if (!this._pointerDocumentListener) {
			var internalCb = function (e) {
				for (var i = 0; i < pointers.length; i++) {
					if (pointers[i].pointerId === e.pointerId) {
						pointers.splice(i, 1);
						break;
					}
				}
			};
			//We listen on the documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(this.POINTER_UP, internalCb, false);
			document.documentElement.addEventListener(this.POINTER_CANCEL, internalCb, false);

			this._pointerDocumentListener = true;
		}

		return this;
	},

	addPointerListenerMove: function (obj, type, handler, id) {
		var pre = '_leaflet_',
		    touches = this._pointers;

		function cb(e) {

			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }

			for (var i = 0; i < touches.length; i++) {
				if (touches[i].pointerId === e.pointerId) {
					touches[i] = e;
					break;
				}
			}

			e.touches = touches.slice();
			e.changedTouches = [e];

			handler(e);
		}

		obj[pre + 'touchmove' + id] = cb;
		obj.addEventListener(this.POINTER_MOVE, cb, false);

		return this;
	},

	addPointerListenerEnd: function (obj, type, handler, id) {
		var pre = '_leaflet_',
		    touches = this._pointers;

		var cb = function (e) {
			for (var i = 0; i < touches.length; i++) {
				if (touches[i].pointerId === e.pointerId) {
					touches.splice(i, 1);
					break;
				}
			}

			e.touches = touches.slice();
			e.changedTouches = [e];

			handler(e);
		};

		obj[pre + 'touchend' + id] = cb;
		obj.addEventListener(this.POINTER_UP, cb, false);
		obj.addEventListener(this.POINTER_CANCEL, cb, false);

		return this;
	},

	removePointerListener: function (obj, type, id) {
		var pre = '_leaflet_',
		    cb = obj[pre + type + id];

		switch (type) {
		case 'touchstart':
			obj.removeEventListener(this.POINTER_DOWN, cb, false);
			break;
		case 'touchmove':
			obj.removeEventListener(this.POINTER_MOVE, cb, false);
			break;
		case 'touchend':
			obj.removeEventListener(this.POINTER_UP, cb, false);
			obj.removeEventListener(this.POINTER_CANCEL, cb, false);
			break;
		}

		return this;
	}
});


/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */

L.Map.mergeOptions({
	touchZoom: L.Browser.touch && !L.Browser.android23,
	bounceAtZoomLimits: true
});

L.Map.TouchZoom = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	_onTouchStart: function (e) {
		var map = this._map;

		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

		var p1 = map.mouseEventToLayerPoint(e.touches[0]),
		    p2 = map.mouseEventToLayerPoint(e.touches[1]),
		    viewCenter = map._getCenterLayerPoint();

		this._startCenter = p1.add(p2)._divideBy(2);
		this._startDist = p1.distanceTo(p2);

		this._moved = false;
		this._zooming = true;

		this._centerOffset = viewCenter.subtract(this._startCenter);

		if (map._panAnim) {
			map._panAnim.stop();
		}

		L.DomEvent
		    .on(document, 'touchmove', this._onTouchMove, this)
		    .on(document, 'touchend', this._onTouchEnd, this);

		L.DomEvent.preventDefault(e);
	},

	_onTouchMove: function (e) {
		var map = this._map;

		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

		var p1 = map.mouseEventToLayerPoint(e.touches[0]),
		    p2 = map.mouseEventToLayerPoint(e.touches[1]);

		this._scale = p1.distanceTo(p2) / this._startDist;
		this._delta = p1._add(p2)._divideBy(2)._subtract(this._startCenter);

		if (this._scale === 1) { return; }

		if (!map.options.bounceAtZoomLimits) {
			if ((map.getZoom() === map.getMinZoom() && this._scale < 1) ||
			    (map.getZoom() === map.getMaxZoom() && this._scale > 1)) { return; }
		}

		if (!this._moved) {
			L.DomUtil.addClass(map._mapPane, 'leaflet-touching');

			map
			    .fire('movestart')
			    .fire('zoomstart');

			this._moved = true;
		}

		L.Util.cancelAnimFrame(this._animRequest);
		this._animRequest = L.Util.requestAnimFrame(
		        this._updateOnMove, this, true, this._map._container);

		L.DomEvent.preventDefault(e);
	},

	_updateOnMove: function () {
		var map = this._map,
		    origin = this._getScaleOrigin(),
		    center = map.layerPointToLatLng(origin),
		    zoom = map.getScaleZoom(this._scale);

		map._animateZoom(center, zoom, this._startCenter, this._scale, this._delta, false, true);
	},

	_onTouchEnd: function () {
		if (!this._moved || !this._zooming) {
			this._zooming = false;
			return;
		}

		var map = this._map;

		this._zooming = false;
		L.DomUtil.removeClass(map._mapPane, 'leaflet-touching');
		L.Util.cancelAnimFrame(this._animRequest);

		L.DomEvent
		    .off(document, 'touchmove', this._onTouchMove)
		    .off(document, 'touchend', this._onTouchEnd);

		var origin = this._getScaleOrigin(),
		    center = map.layerPointToLatLng(origin),

		    oldZoom = map.getZoom(),
		    floatZoomDelta = map.getScaleZoom(this._scale) - oldZoom,
		    roundZoomDelta = (floatZoomDelta > 0 ?
		            Math.ceil(floatZoomDelta) : Math.floor(floatZoomDelta)),

		    zoom = map._limitZoom(oldZoom + roundZoomDelta),
		    scale = map.getZoomScale(zoom) / this._scale;

		map._animateZoom(center, zoom, origin, scale);
	},

	_getScaleOrigin: function () {
		var centerOffset = this._centerOffset.subtract(this._delta).divideBy(this._scale);
		return this._startCenter.add(centerOffset);
	}
});

L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);


/*
 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
 */

L.Map.mergeOptions({
	tap: true,
	tapTolerance: 15
});

L.Map.Tap = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
	},

	_onDown: function (e) {
		if (!e.touches) { return; }

		L.DomEvent.preventDefault(e);

		this._fireClick = true;

		// don't simulate click or track longpress if more than 1 touch
		if (e.touches.length > 1) {
			this._fireClick = false;
			clearTimeout(this._holdTimeout);
			return;
		}

		var first = e.touches[0],
		    el = first.target;

		this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);

		// if touching a link, highlight it
		if (el.tagName && el.tagName.toLowerCase() === 'a') {
			L.DomUtil.addClass(el, 'leaflet-active');
		}

		// simulate long hold but setting a timeout
		this._holdTimeout = setTimeout(L.bind(function () {
			if (this._isTapValid()) {
				this._fireClick = false;
				this._onUp();
				this._simulateEvent('contextmenu', first);
			}
		}, this), 1000);

		L.DomEvent
			.on(document, 'touchmove', this._onMove, this)
			.on(document, 'touchend', this._onUp, this);
	},

	_onUp: function (e) {
		clearTimeout(this._holdTimeout);

		L.DomEvent
			.off(document, 'touchmove', this._onMove, this)
			.off(document, 'touchend', this._onUp, this);

		if (this._fireClick && e && e.changedTouches) {

			var first = e.changedTouches[0],
			    el = first.target;

			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.removeClass(el, 'leaflet-active');
			}

			// simulate click if the touch didn't move too much
			if (this._isTapValid()) {
				this._simulateEvent('click', first);
			}
		}
	},

	_isTapValid: function () {
		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	},

	_onMove: function (e) {
		var first = e.touches[0];
		this._newPos = new L.Point(first.clientX, first.clientY);
	},

	_simulateEvent: function (type, e) {
		var simulatedEvent = document.createEvent('MouseEvents');

		simulatedEvent._simulated = true;
		e.target._simulatedClick = true;

		simulatedEvent.initMouseEvent(
		        type, true, true, window, 1,
		        e.screenX, e.screenY,
		        e.clientX, e.clientY,
		        false, false, false, false, 0, null);

		e.target.dispatchEvent(simulatedEvent);
	}
});

if (L.Browser.touch && !L.Browser.pointer) {
	L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
}


/*
 * L.Handler.ShiftDragZoom is used to add shift-drag zoom interaction to the map
  * (zoom to a selected bounding box), enabled by default.
 */

L.Map.mergeOptions({
	boxZoom: true
});

L.Map.BoxZoom = L.Handler.extend({
	initialize: function (map) {
		this._map = map;
		this._container = map._container;
		this._pane = map._panes.overlayPane;
		this._moved = false;
	},

	addHooks: function () {
		L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._container, 'mousedown', this._onMouseDown);
		this._moved = false;
	},

	moved: function () {
		return this._moved;
	},

	_onMouseDown: function (e) {
		this._moved = false;

		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

		L.DomUtil.disableTextSelection();
		L.DomUtil.disableImageDrag();

		this._startLayerPoint = this._map.mouseEventToLayerPoint(e);

		L.DomEvent
		    .on(document, 'mousemove', this._onMouseMove, this)
		    .on(document, 'mouseup', this._onMouseUp, this)
		    .on(document, 'keydown', this._onKeyDown, this);
	},

	_onMouseMove: function (e) {
		if (!this._moved) {
			this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._pane);
			L.DomUtil.setPosition(this._box, this._startLayerPoint);

			//TODO refactor: move cursor to styles
			this._container.style.cursor = 'crosshair';
			this._map.fire('boxzoomstart');
		}

		var startPoint = this._startLayerPoint,
		    box = this._box,

		    layerPoint = this._map.mouseEventToLayerPoint(e),
		    offset = layerPoint.subtract(startPoint),

		    newPos = new L.Point(
		        Math.min(layerPoint.x, startPoint.x),
		        Math.min(layerPoint.y, startPoint.y));

		L.DomUtil.setPosition(box, newPos);

		this._moved = true;

		// TODO refactor: remove hardcoded 4 pixels
		box.style.width  = (Math.max(0, Math.abs(offset.x) - 4)) + 'px';
		box.style.height = (Math.max(0, Math.abs(offset.y) - 4)) + 'px';
	},

	_finish: function () {
		if (this._moved) {
			this._pane.removeChild(this._box);
			this._container.style.cursor = '';
		}

		L.DomUtil.enableTextSelection();
		L.DomUtil.enableImageDrag();

		L.DomEvent
		    .off(document, 'mousemove', this._onMouseMove)
		    .off(document, 'mouseup', this._onMouseUp)
		    .off(document, 'keydown', this._onKeyDown);
	},

	_onMouseUp: function (e) {

		this._finish();

		var map = this._map,
		    layerPoint = map.mouseEventToLayerPoint(e);

		if (this._startLayerPoint.equals(layerPoint)) { return; }

		var bounds = new L.LatLngBounds(
		        map.layerPointToLatLng(this._startLayerPoint),
		        map.layerPointToLatLng(layerPoint));

		map.fitBounds(bounds);

		map.fire('boxzoomend', {
			boxZoomBounds: bounds
		});
	},

	_onKeyDown: function (e) {
		if (e.keyCode === 27) {
			this._finish();
		}
	}
});

L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);


/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */

L.Map.mergeOptions({
	keyboard: true,
	keyboardPanOffset: 80,
	keyboardZoomOffset: 1
});

L.Map.Keyboard = L.Handler.extend({

	keyCodes: {
		left:    [37],
		right:   [39],
		down:    [40],
		up:      [38],
		zoomIn:  [187, 107, 61, 171],
		zoomOut: [189, 109, 173]
	},

	initialize: function (map) {
		this._map = map;

		this._setPanOffset(map.options.keyboardPanOffset);
		this._setZoomOffset(map.options.keyboardZoomOffset);
	},

	addHooks: function () {
		var container = this._map._container;

		// make the container focusable by tabbing
		if (container.tabIndex === -1) {
			container.tabIndex = '0';
		}

		L.DomEvent
		    .on(container, 'focus', this._onFocus, this)
		    .on(container, 'blur', this._onBlur, this)
		    .on(container, 'mousedown', this._onMouseDown, this);

		this._map
		    .on('focus', this._addHooks, this)
		    .on('blur', this._removeHooks, this);
	},

	removeHooks: function () {
		this._removeHooks();

		var container = this._map._container;

		L.DomEvent
		    .off(container, 'focus', this._onFocus, this)
		    .off(container, 'blur', this._onBlur, this)
		    .off(container, 'mousedown', this._onMouseDown, this);

		this._map
		    .off('focus', this._addHooks, this)
		    .off('blur', this._removeHooks, this);
	},

	_onMouseDown: function () {
		if (this._focused) { return; }

		var body = document.body,
		    docEl = document.documentElement,
		    top = body.scrollTop || docEl.scrollTop,
		    left = body.scrollLeft || docEl.scrollLeft;

		this._map._container.focus();

		window.scrollTo(left, top);
	},

	_onFocus: function () {
		this._focused = true;
		this._map.fire('focus');
	},

	_onBlur: function () {
		this._focused = false;
		this._map.fire('blur');
	},

	_setPanOffset: function (pan) {
		var keys = this._panKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.left.length; i < len; i++) {
			keys[codes.left[i]] = [-1 * pan, 0];
		}
		for (i = 0, len = codes.right.length; i < len; i++) {
			keys[codes.right[i]] = [pan, 0];
		}
		for (i = 0, len = codes.down.length; i < len; i++) {
			keys[codes.down[i]] = [0, pan];
		}
		for (i = 0, len = codes.up.length; i < len; i++) {
			keys[codes.up[i]] = [0, -1 * pan];
		}
	},

	_setZoomOffset: function (zoom) {
		var keys = this._zoomKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
			keys[codes.zoomIn[i]] = zoom;
		}
		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
			keys[codes.zoomOut[i]] = -zoom;
		}
	},

	_addHooks: function () {
		L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
	},

	_removeHooks: function () {
		L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
	},

	_onKeyDown: function (e) {
		var key = e.keyCode,
		    map = this._map;

		if (key in this._panKeys) {

			if (map._panAnim && map._panAnim._inProgress) { return; }

			map.panBy(this._panKeys[key]);

			if (map.options.maxBounds) {
				map.panInsideBounds(map.options.maxBounds);
			}

		} else if (key in this._zoomKeys) {
			map.setZoom(map.getZoom() + this._zoomKeys[key]);

		} else {
			return;
		}

		L.DomEvent.stop(e);
	}
});

L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);


/*
 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
 */

L.Handler.MarkerDrag = L.Handler.extend({
	initialize: function (marker) {
		this._marker = marker;
	},

	addHooks: function () {
		var icon = this._marker._icon;
		if (!this._draggable) {
			this._draggable = new L.Draggable(icon, icon);
		}

		this._draggable
			.on('dragstart', this._onDragStart, this)
			.on('drag', this._onDrag, this)
			.on('dragend', this._onDragEnd, this);
		this._draggable.enable();
		L.DomUtil.addClass(this._marker._icon, 'leaflet-marker-draggable');
	},

	removeHooks: function () {
		this._draggable
			.off('dragstart', this._onDragStart, this)
			.off('drag', this._onDrag, this)
			.off('dragend', this._onDragEnd, this);

		this._draggable.disable();
		L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		this._marker
		    .closePopup()
		    .fire('movestart')
		    .fire('dragstart');
	},

	_onDrag: function () {
		var marker = this._marker,
		    shadow = marker._shadow,
		    iconPos = L.DomUtil.getPosition(marker._icon),
		    latlng = marker._map.layerPointToLatLng(iconPos);

		// update shadow position
		if (shadow) {
			L.DomUtil.setPosition(shadow, iconPos);
		}

		marker._latlng = latlng;

		marker
		    .fire('move', {latlng: latlng})
		    .fire('drag');
	},

	_onDragEnd: function (e) {
		this._marker
		    .fire('moveend')
		    .fire('dragend', e);
	}
});


/*
 * L.Control is a base class for implementing map controls. Handles positioning.
 * All other controls extend from this class.
 */

L.Control = L.Class.extend({
	options: {
		position: 'topright'
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	getPosition: function () {
		return this.options.position;
	},

	setPosition: function (position) {
		var map = this._map;

		if (map) {
			map.removeControl(this);
		}

		this.options.position = position;

		if (map) {
			map.addControl(this);
		}

		return this;
	},

	getContainer: function () {
		return this._container;
	},

	addTo: function (map) {
		this._map = map;

		var container = this._container = this.onAdd(map),
		    pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		L.DomUtil.addClass(container, 'leaflet-control');

		if (pos.indexOf('bottom') !== -1) {
			corner.insertBefore(container, corner.firstChild);
		} else {
			corner.appendChild(container);
		}

		return this;
	},

	removeFrom: function (map) {
		var pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		corner.removeChild(this._container);
		this._map = null;

		if (this.onRemove) {
			this.onRemove(map);
		}

		return this;
	},

	_refocusOnMap: function () {
		if (this._map) {
			this._map.getContainer().focus();
		}
	}
});

L.control = function (options) {
	return new L.Control(options);
};


// adds control-related methods to L.Map

L.Map.include({
	addControl: function (control) {
		control.addTo(this);
		return this;
	},

	removeControl: function (control) {
		control.removeFrom(this);
		return this;
	},

	_initControlPos: function () {
		var corners = this._controlCorners = {},
		    l = 'leaflet-',
		    container = this._controlContainer =
		            L.DomUtil.create('div', l + 'control-container', this._container);

		function createCorner(vSide, hSide) {
			var className = l + vSide + ' ' + l + hSide;

			corners[vSide + hSide] = L.DomUtil.create('div', className, container);
		}

		createCorner('top', 'left');
		createCorner('top', 'right');
		createCorner('bottom', 'left');
		createCorner('bottom', 'right');
	},

	_clearControlPos: function () {
		this._container.removeChild(this._controlContainer);
	}
});


/*
 * L.Control.Zoom is used for the default zoom buttons on the map.
 */

L.Control.Zoom = L.Control.extend({
	options: {
		position: 'topleft',
		zoomInText: '+',
		zoomInTitle: 'Zoom in',
		zoomOutText: '-',
		zoomOutTitle: 'Zoom out'
	},

	onAdd: function (map) {
		var zoomName = 'leaflet-control-zoom',
		    container = L.DomUtil.create('div', zoomName + ' leaflet-bar');

		this._map = map;

		this._zoomInButton  = this._createButton(
		        this.options.zoomInText, this.options.zoomInTitle,
		        zoomName + '-in',  container, this._zoomIn,  this);
		this._zoomOutButton = this._createButton(
		        this.options.zoomOutText, this.options.zoomOutTitle,
		        zoomName + '-out', container, this._zoomOut, this);

		this._updateDisabled();
		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

		return container;
	},

	onRemove: function (map) {
		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	},

	_zoomIn: function (e) {
		this._map.zoomIn(e.shiftKey ? 3 : 1);
	},

	_zoomOut: function (e) {
		this._map.zoomOut(e.shiftKey ? 3 : 1);
	},

	_createButton: function (html, title, className, container, fn, context) {
		var link = L.DomUtil.create('a', className, container);
		link.innerHTML = html;
		link.href = '#';
		link.title = title;

		var stop = L.DomEvent.stopPropagation;

		L.DomEvent
		    .on(link, 'click', stop)
		    .on(link, 'mousedown', stop)
		    .on(link, 'dblclick', stop)
		    .on(link, 'click', L.DomEvent.preventDefault)
		    .on(link, 'click', fn, context)
		    .on(link, 'click', this._refocusOnMap, context);

		return link;
	},

	_updateDisabled: function () {
		var map = this._map,
			className = 'leaflet-disabled';

		L.DomUtil.removeClass(this._zoomInButton, className);
		L.DomUtil.removeClass(this._zoomOutButton, className);

		if (map._zoom === map.getMinZoom()) {
			L.DomUtil.addClass(this._zoomOutButton, className);
		}
		if (map._zoom === map.getMaxZoom()) {
			L.DomUtil.addClass(this._zoomInButton, className);
		}
	}
});

L.Map.mergeOptions({
	zoomControl: true
});

L.Map.addInitHook(function () {
	if (this.options.zoomControl) {
		this.zoomControl = new L.Control.Zoom();
		this.addControl(this.zoomControl);
	}
});

L.control.zoom = function (options) {
	return new L.Control.Zoom(options);
};



/*
 * L.Control.Attribution is used for displaying attribution on the map (added by default).
 */

L.Control.Attribution = L.Control.extend({
	options: {
		position: 'bottomright',
		prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	},

	initialize: function (options) {
		L.setOptions(this, options);

		this._attributions = {};
	},

	onAdd: function (map) {
		this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
		L.DomEvent.disableClickPropagation(this._container);

		for (var i in map._layers) {
			if (map._layers[i].getAttribution) {
				this.addAttribution(map._layers[i].getAttribution());
			}
		}
		
		map
		    .on('layeradd', this._onLayerAdd, this)
		    .on('layerremove', this._onLayerRemove, this);

		this._update();

		return this._container;
	},

	onRemove: function (map) {
		map
		    .off('layeradd', this._onLayerAdd)
		    .off('layerremove', this._onLayerRemove);

	},

	setPrefix: function (prefix) {
		this.options.prefix = prefix;
		this._update();
		return this;
	},

	addAttribution: function (text) {
		if (!text) { return; }

		if (!this._attributions[text]) {
			this._attributions[text] = 0;
		}
		this._attributions[text]++;

		this._update();

		return this;
	},

	removeAttribution: function (text) {
		if (!text) { return; }

		if (this._attributions[text]) {
			this._attributions[text]--;
			this._update();
		}

		return this;
	},

	_update: function () {
		if (!this._map) { return; }

		var attribs = [];

		for (var i in this._attributions) {
			if (this._attributions[i]) {
				attribs.push(i);
			}
		}

		var prefixAndAttribs = [];

		if (this.options.prefix) {
			prefixAndAttribs.push(this.options.prefix);
		}
		if (attribs.length) {
			prefixAndAttribs.push(attribs.join(', '));
		}

		this._container.innerHTML = prefixAndAttribs.join(' | ');
	},

	_onLayerAdd: function (e) {
		if (e.layer.getAttribution) {
			this.addAttribution(e.layer.getAttribution());
		}
	},

	_onLayerRemove: function (e) {
		if (e.layer.getAttribution) {
			this.removeAttribution(e.layer.getAttribution());
		}
	}
});

L.Map.mergeOptions({
	attributionControl: true
});

L.Map.addInitHook(function () {
	if (this.options.attributionControl) {
		this.attributionControl = (new L.Control.Attribution()).addTo(this);
	}
});

L.control.attribution = function (options) {
	return new L.Control.Attribution(options);
};


/*
 * L.Control.Scale is used for displaying metric/imperial scale on the map.
 */

L.Control.Scale = L.Control.extend({
	options: {
		position: 'bottomleft',
		maxWidth: 100,
		metric: true,
		imperial: true,
		updateWhenIdle: false
	},

	onAdd: function (map) {
		this._map = map;

		var className = 'leaflet-control-scale',
		    container = L.DomUtil.create('div', className),
		    options = this.options;

		this._addScales(options, className, container);

		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		map.whenReady(this._update, this);

		return container;
	},

	onRemove: function (map) {
		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	},

	_addScales: function (options, className, container) {
		if (options.metric) {
			this._mScale = L.DomUtil.create('div', className + '-line', container);
		}
		if (options.imperial) {
			this._iScale = L.DomUtil.create('div', className + '-line', container);
		}
	},

	_update: function () {
		var bounds = this._map.getBounds(),
		    centerLat = bounds.getCenter().lat,
		    halfWorldMeters = 6378137 * Math.PI * Math.cos(centerLat * Math.PI / 180),
		    dist = halfWorldMeters * (bounds.getNorthEast().lng - bounds.getSouthWest().lng) / 180,

		    size = this._map.getSize(),
		    options = this.options,
		    maxMeters = 0;

		if (size.x > 0) {
			maxMeters = dist * (options.maxWidth / size.x);
		}

		this._updateScales(options, maxMeters);
	},

	_updateScales: function (options, maxMeters) {
		if (options.metric && maxMeters) {
			this._updateMetric(maxMeters);
		}

		if (options.imperial && maxMeters) {
			this._updateImperial(maxMeters);
		}
	},

	_updateMetric: function (maxMeters) {
		var meters = this._getRoundNum(maxMeters);

		this._mScale.style.width = this._getScaleWidth(meters / maxMeters) + 'px';
		this._mScale.innerHTML = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	},

	_updateImperial: function (maxMeters) {
		var maxFeet = maxMeters * 3.2808399,
		    scale = this._iScale,
		    maxMiles, miles, feet;

		if (maxFeet > 5280) {
			maxMiles = maxFeet / 5280;
			miles = this._getRoundNum(maxMiles);

			scale.style.width = this._getScaleWidth(miles / maxMiles) + 'px';
			scale.innerHTML = miles + ' mi';

		} else {
			feet = this._getRoundNum(maxFeet);

			scale.style.width = this._getScaleWidth(feet / maxFeet) + 'px';
			scale.innerHTML = feet + ' ft';
		}
	},

	_getScaleWidth: function (ratio) {
		return Math.round(this.options.maxWidth * ratio) - 10;
	},

	_getRoundNum: function (num) {
		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
		    d = num / pow10;

		d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;

		return pow10 * d;
	}
});

L.control.scale = function (options) {
	return new L.Control.Scale(options);
};


/*
 * L.Control.Layers is a control to allow users to switch between different layers on the map.
 */

L.Control.Layers = L.Control.extend({
	options: {
		collapsed: true,
		position: 'topright',
		autoZIndex: true
	},

	initialize: function (baseLayers, overlays, options) {
		L.setOptions(this, options);

		this._layers = {};
		this._lastZIndex = 0;
		this._handlingClick = false;

		for (var i in baseLayers) {
			this._addLayer(baseLayers[i], i);
		}

		for (i in overlays) {
			this._addLayer(overlays[i], i, true);
		}
	},

	onAdd: function (map) {
		this._initLayout();
		this._update();

		map
		    .on('layeradd', this._onLayerChange, this)
		    .on('layerremove', this._onLayerChange, this);

		return this._container;
	},

	onRemove: function (map) {
		map
		    .off('layeradd', this._onLayerChange, this)
		    .off('layerremove', this._onLayerChange, this);
	},

	addBaseLayer: function (layer, name) {
		this._addLayer(layer, name);
		this._update();
		return this;
	},

	addOverlay: function (layer, name) {
		this._addLayer(layer, name, true);
		this._update();
		return this;
	},

	removeLayer: function (layer) {
		var id = L.stamp(layer);
		delete this._layers[id];
		this._update();
		return this;
	},

	_initLayout: function () {
		var className = 'leaflet-control-layers',
		    container = this._container = L.DomUtil.create('div', className);

		//Makes this work on IE10 Touch devices by stopping it from firing a mouseout event when the touch is released
		container.setAttribute('aria-haspopup', true);

		if (!L.Browser.touch) {
			L.DomEvent
				.disableClickPropagation(container)
				.disableScrollPropagation(container);
		} else {
			L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation);
		}

		var form = this._form = L.DomUtil.create('form', className + '-list');

		if (this.options.collapsed) {
			if (!L.Browser.android) {
				L.DomEvent
				    .on(container, 'mouseover', this._expand, this)
				    .on(container, 'mouseout', this._collapse, this);
			}
			var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';

			if (L.Browser.touch) {
				L.DomEvent
				    .on(link, 'click', L.DomEvent.stop)
				    .on(link, 'click', this._expand, this);
			}
			else {
				L.DomEvent.on(link, 'focus', this._expand, this);
			}
			//Work around for Firefox android issue https://github.com/Leaflet/Leaflet/issues/2033
			L.DomEvent.on(form, 'click', function () {
				setTimeout(L.bind(this._onInputClick, this), 0);
			}, this);

			this._map.on('click', this._collapse, this);
			// TODO keyboard accessibility
		} else {
			this._expand();
		}

		this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
		this._separator = L.DomUtil.create('div', className + '-separator', form);
		this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);

		container.appendChild(form);
	},

	_addLayer: function (layer, name, overlay) {
		var id = L.stamp(layer);

		this._layers[id] = {
			layer: layer,
			name: name,
			overlay: overlay
		};

		if (this.options.autoZIndex && layer.setZIndex) {
			this._lastZIndex++;
			layer.setZIndex(this._lastZIndex);
		}
	},

	_update: function () {
		if (!this._container) {
			return;
		}

		this._baseLayersList.innerHTML = '';
		this._overlaysList.innerHTML = '';

		var baseLayersPresent = false,
		    overlaysPresent = false,
		    i, obj;

		for (i in this._layers) {
			obj = this._layers[i];
			this._addItem(obj);
			overlaysPresent = overlaysPresent || obj.overlay;
			baseLayersPresent = baseLayersPresent || !obj.overlay;
		}

		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	},

	_onLayerChange: function (e) {
		var obj = this._layers[L.stamp(e.layer)];

		if (!obj) { return; }

		if (!this._handlingClick) {
			this._update();
		}

		var type = obj.overlay ?
			(e.type === 'layeradd' ? 'overlayadd' : 'overlayremove') :
			(e.type === 'layeradd' ? 'baselayerchange' : null);

		if (type) {
			this._map.fire(type, obj);
		}
	},

	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	_createRadioElement: function (name, checked) {

		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"';
		if (checked) {
			radioHtml += ' checked="checked"';
		}
		radioHtml += '/>';

		var radioFragment = document.createElement('div');
		radioFragment.innerHTML = radioHtml;

		return radioFragment.firstChild;
	},

	_addItem: function (obj) {
		var label = document.createElement('label'),
		    input,
		    checked = this._map.hasLayer(obj.layer);

		if (obj.overlay) {
			input = document.createElement('input');
			input.type = 'checkbox';
			input.className = 'leaflet-control-layers-selector';
			input.defaultChecked = checked;
		} else {
			input = this._createRadioElement('leaflet-base-layers', checked);
		}

		input.layerId = L.stamp(obj.layer);

		L.DomEvent.on(input, 'click', this._onInputClick, this);

		var name = document.createElement('span');
		name.innerHTML = ' ' + obj.name;

		label.appendChild(input);
		label.appendChild(name);

		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
		container.appendChild(label);

		return label;
	},

	_onInputClick: function () {
		var i, input, obj,
		    inputs = this._form.getElementsByTagName('input'),
		    inputsLen = inputs.length;

		this._handlingClick = true;

		for (i = 0; i < inputsLen; i++) {
			input = inputs[i];
			obj = this._layers[input.layerId];

			if (input.checked && !this._map.hasLayer(obj.layer)) {
				this._map.addLayer(obj.layer);

			} else if (!input.checked && this._map.hasLayer(obj.layer)) {
				this._map.removeLayer(obj.layer);
			}
		}

		this._handlingClick = false;

		this._refocusOnMap();
	},

	_expand: function () {
		L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
	},

	_collapse: function () {
		this._container.className = this._container.className.replace(' leaflet-control-layers-expanded', '');
	}
});

L.control.layers = function (baseLayers, overlays, options) {
	return new L.Control.Layers(baseLayers, overlays, options);
};


/*
 * L.PosAnimation is used by Leaflet internally for pan animations.
 */

L.PosAnimation = L.Class.extend({
	includes: L.Mixin.Events,

	run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._newPos = newPos;

		this.fire('start');

		el.style[L.DomUtil.TRANSITION] = 'all ' + (duration || 0.25) +
		        's cubic-bezier(0,0,' + (easeLinearity || 0.5) + ',1)';

		L.DomEvent.on(el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);
		L.DomUtil.setPosition(el, newPos);

		// toggle reflow, Chrome flickers for some reason if you don't do this
		L.Util.falseFn(el.offsetWidth);

		// there's no native way to track value updates of transitioned properties, so we imitate this
		this._stepTimer = setInterval(L.bind(this._onStep, this), 50);
	},

	stop: function () {
		if (!this._inProgress) { return; }

		// if we just removed the transition property, the element would jump to its final position,
		// so we need to make it stay at the current position

		L.DomUtil.setPosition(this._el, this._getPos());
		this._onTransitionEnd();
		L.Util.falseFn(this._el.offsetWidth); // force reflow in case we are about to start a new animation
	},

	_onStep: function () {
		var stepPos = this._getPos();
		if (!stepPos) {
			this._onTransitionEnd();
			return;
		}
		// jshint camelcase: false
		// make L.DomUtil.getPosition return intermediate position value during animation
		this._el._leaflet_pos = stepPos;

		this.fire('step');
	},

	// you can't easily get intermediate values of properties animated with CSS3 Transitions,
	// we need to parse computed style (in case of transform it returns matrix string)

	_transformRe: /([-+]?(?:\d*\.)?\d+)\D*, ([-+]?(?:\d*\.)?\d+)\D*\)/,

	_getPos: function () {
		var left, top, matches,
		    el = this._el,
		    style = window.getComputedStyle(el);

		if (L.Browser.any3d) {
			matches = style[L.DomUtil.TRANSFORM].match(this._transformRe);
			if (!matches) { return; }
			left = parseFloat(matches[1]);
			top  = parseFloat(matches[2]);
		} else {
			left = parseFloat(style.left);
			top  = parseFloat(style.top);
		}

		return new L.Point(left, top, true);
	},

	_onTransitionEnd: function () {
		L.DomEvent.off(this._el, L.DomUtil.TRANSITION_END, this._onTransitionEnd, this);

		if (!this._inProgress) { return; }
		this._inProgress = false;

		this._el.style[L.DomUtil.TRANSITION] = '';

		// jshint camelcase: false
		// make sure L.DomUtil.getPosition returns the final position value after animation
		this._el._leaflet_pos = this._newPos;

		clearInterval(this._stepTimer);

		this.fire('step').fire('end');
	}

});


/*
 * Extends L.Map to handle panning animations.
 */

L.Map.include({

	setView: function (center, zoom, options) {

		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
		center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
		options = options || {};

		if (this._panAnim) {
			this._panAnim.stop();
		}

		if (this._loaded && !options.reset && options !== true) {

			if (options.animate !== undefined) {
				options.zoom = L.extend({animate: options.animate}, options.zoom);
				options.pan = L.extend({animate: options.animate}, options.pan);
			}

			// try animating pan or zoom
			var animated = (this._zoom !== zoom) ?
				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
				this._tryAnimatedPan(center, options.pan);

			if (animated) {
				// prevent resize handler call, the view will refresh after animation anyway
				clearTimeout(this._sizeTimer);
				return this;
			}
		}

		// animation didn't start, just reset the map view
		this._resetView(center, zoom);

		return this;
	},

	panBy: function (offset, options) {
		offset = L.point(offset).round();
		options = options || {};

		if (!offset.x && !offset.y) {
			return this;
		}

		if (!this._panAnim) {
			this._panAnim = new L.PosAnimation();

			this._panAnim.on({
				'step': this._onPanTransitionStep,
				'end': this._onPanTransitionEnd
			}, this);
		}

		// don't fire movestart if animating inertia
		if (!options.noMoveStart) {
			this.fire('movestart');
		}

		// animate pan unless animate: false specified
		if (options.animate !== false) {
			L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');

			var newPos = this._getMapPanePos().subtract(offset);
			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
		} else {
			this._rawPanBy(offset);
			this.fire('move').fire('moveend');
		}

		return this;
	},

	_onPanTransitionStep: function () {
		this.fire('move');
	},

	_onPanTransitionEnd: function () {
		L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
		this.fire('moveend');
	},

	_tryAnimatedPan: function (center, options) {
		// difference between the new and current centers in pixels
		var offset = this._getCenterOffset(center)._floor();

		// don't animate too far unless animate: true specified in options
		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

		this.panBy(offset, options);

		return true;
	}
});


/*
 * L.PosAnimation fallback implementation that powers Leaflet pan animations
 * in browsers that don't support CSS3 Transitions.
 */

L.PosAnimation = L.DomUtil.TRANSITION ? L.PosAnimation : L.PosAnimation.extend({

	run: function (el, newPos, duration, easeLinearity) { // (HTMLElement, Point[, Number, Number])
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._duration = duration || 0.25;
		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

		this._startPos = L.DomUtil.getPosition(el);
		this._offset = newPos.subtract(this._startPos);
		this._startTime = +new Date();

		this.fire('start');

		this._animate();
	},

	stop: function () {
		if (!this._inProgress) { return; }

		this._step();
		this._complete();
	},

	_animate: function () {
		// animation loop
		this._animId = L.Util.requestAnimFrame(this._animate, this);
		this._step();
	},

	_step: function () {
		var elapsed = (+new Date()) - this._startTime,
		    duration = this._duration * 1000;

		if (elapsed < duration) {
			this._runFrame(this._easeOut(elapsed / duration));
		} else {
			this._runFrame(1);
			this._complete();
		}
	},

	_runFrame: function (progress) {
		var pos = this._startPos.add(this._offset.multiplyBy(progress));
		L.DomUtil.setPosition(this._el, pos);

		this.fire('step');
	},

	_complete: function () {
		L.Util.cancelAnimFrame(this._animId);

		this._inProgress = false;
		this.fire('end');
	},

	_easeOut: function (t) {
		return 1 - Math.pow(1 - t, this._easeOutPower);
	}
});


/*
 * Extends L.Map to handle zoom animations.
 */

L.Map.mergeOptions({
	zoomAnimation: true,
	zoomAnimationThreshold: 4
});

if (L.DomUtil.TRANSITION) {

	L.Map.addInitHook(function () {
		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
		this._zoomAnimated = this.options.zoomAnimation && L.DomUtil.TRANSITION &&
				L.Browser.any3d && !L.Browser.android23 && !L.Browser.mobileOpera;

		// zoom transitions run with the same duration for all layers, so if one of transitionend events
		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
		if (this._zoomAnimated) {
			L.DomEvent.on(this._mapPane, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
		}
	});
}

L.Map.include(!L.DomUtil.TRANSITION ? {} : {

	_catchTransitionEnd: function (e) {
		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
			this._onZoomTransitionEnd();
		}
	},

	_nothingToAnimate: function () {
		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	},

	_tryAnimatedZoom: function (center, zoom, options) {

		if (this._animatingZoom) { return true; }

		options = options || {};

		// don't animate if disabled, not supported or zoom difference is too large
		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

		// offset is the pixel coords of the zoom origin relative to the current center
		var scale = this.getZoomScale(zoom),
		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale),
			origin = this._getCenterLayerPoint()._add(offset);

		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

		this
		    .fire('movestart')
		    .fire('zoomstart');

		this._animateZoom(center, zoom, origin, scale, null, true);

		return true;
	},

	_animateZoom: function (center, zoom, origin, scale, delta, backwards, forTouchZoom) {

		if (!forTouchZoom) {
			this._animatingZoom = true;
		}

		// put transform transition on all layers with leaflet-zoom-animated class
		L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');

		// remember what center/zoom to set after animation
		this._animateToCenter = center;
		this._animateToZoom = zoom;

		// disable any dragging during animation
		if (L.Draggable) {
			L.Draggable._disabled = true;
		}

		L.Util.requestAnimFrame(function () {
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				origin: origin,
				scale: scale,
				delta: delta,
				backwards: backwards
			});
			// horrible hack to work around a Chrome bug https://github.com/Leaflet/Leaflet/issues/3689
			setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
		}, this);
	},

	_onZoomTransitionEnd: function () {
		if (!this._animatingZoom) { return; }

		this._animatingZoom = false;

		L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');

		L.Util.requestAnimFrame(function () {
			this._resetView(this._animateToCenter, this._animateToZoom, true, true);

			if (L.Draggable) {
				L.Draggable._disabled = false;
			}
		}, this);
	}
});


/*
	Zoom animation logic for L.TileLayer.
*/

L.TileLayer.include({
	_animateZoom: function (e) {
		if (!this._animating) {
			this._animating = true;
			this._prepareBgBuffer();
		}

		var bg = this._bgBuffer,
		    transform = L.DomUtil.TRANSFORM,
		    initialTransform = e.delta ? L.DomUtil.getTranslateString(e.delta) : bg.style[transform],
		    scaleStr = L.DomUtil.getScaleString(e.scale, e.origin);

		bg.style[transform] = e.backwards ?
				scaleStr + ' ' + initialTransform :
				initialTransform + ' ' + scaleStr;
	},

	_endZoomAnim: function () {
		var front = this._tileContainer,
		    bg = this._bgBuffer;

		front.style.visibility = '';
		front.parentNode.appendChild(front); // Bring to fore

		// force reflow
		L.Util.falseFn(bg.offsetWidth);

		var zoom = this._map.getZoom();
		if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
			this._clearBgBuffer();
		}

		this._animating = false;
	},

	_clearBgBuffer: function () {
		var map = this._map;

		if (map && !map._animatingZoom && !map.touchZoom._zooming) {
			this._bgBuffer.innerHTML = '';
			this._bgBuffer.style[L.DomUtil.TRANSFORM] = '';
		}
	},

	_prepareBgBuffer: function () {

		var front = this._tileContainer,
		    bg = this._bgBuffer;

		// if foreground layer doesn't have many tiles but bg layer does,
		// keep the existing bg layer and just zoom it some more

		var bgLoaded = this._getLoadedTilesPercentage(bg),
		    frontLoaded = this._getLoadedTilesPercentage(front);

		if (bg && bgLoaded > 0.5 && frontLoaded < 0.5) {

			front.style.visibility = 'hidden';
			this._stopLoadingImages(front);
			return;
		}

		// prepare the buffer to become the front tile pane
		bg.style.visibility = 'hidden';
		bg.style[L.DomUtil.TRANSFORM] = '';

		// switch out the current layer to be the new bg layer (and vice-versa)
		this._tileContainer = bg;
		bg = this._bgBuffer = front;

		this._stopLoadingImages(bg);

		//prevent bg buffer from clearing right after zoom
		clearTimeout(this._clearBgBufferTimer);
	},

	_getLoadedTilesPercentage: function (container) {
		var tiles = container.getElementsByTagName('img'),
		    i, len, count = 0;

		for (i = 0, len = tiles.length; i < len; i++) {
			if (tiles[i].complete) {
				count++;
			}
		}
		return count / len;
	},

	// stops loading all tiles in the background layer
	_stopLoadingImages: function (container) {
		var tiles = Array.prototype.slice.call(container.getElementsByTagName('img')),
		    i, len, tile;

		for (i = 0, len = tiles.length; i < len; i++) {
			tile = tiles[i];

			if (!tile.complete) {
				tile.onload = L.Util.falseFn;
				tile.onerror = L.Util.falseFn;
				tile.src = L.Util.emptyImageUrl;

				tile.parentNode.removeChild(tile);
			}
		}
	}
});


/*
 * Provides L.Map with convenient shortcuts for using browser geolocation features.
 */

L.Map.include({
	_defaultLocateOptions: {
		watch: false,
		setView: false,
		maxZoom: Infinity,
		timeout: 10000,
		maximumAge: 0,
		enableHighAccuracy: false
	},

	locate: function (/*Object*/ options) {

		options = this._locateOptions = L.extend(this._defaultLocateOptions, options);

		if (!navigator.geolocation) {
			this._handleGeolocationError({
				code: 0,
				message: 'Geolocation not supported.'
			});
			return this;
		}

		var onResponse = L.bind(this._handleGeolocationResponse, this),
			onError = L.bind(this._handleGeolocationError, this);

		if (options.watch) {
			this._locationWatchId =
			        navigator.geolocation.watchPosition(onResponse, onError, options);
		} else {
			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
		}
		return this;
	},

	stopLocate: function () {
		if (navigator.geolocation) {
			navigator.geolocation.clearWatch(this._locationWatchId);
		}
		if (this._locateOptions) {
			this._locateOptions.setView = false;
		}
		return this;
	},

	_handleGeolocationError: function (error) {
		var c = error.code,
		    message = error.message ||
		            (c === 1 ? 'permission denied' :
		            (c === 2 ? 'position unavailable' : 'timeout'));

		if (this._locateOptions.setView && !this._loaded) {
			this.fitWorld();
		}

		this.fire('locationerror', {
			code: c,
			message: 'Geolocation error: ' + message + '.'
		});
	},

	_handleGeolocationResponse: function (pos) {
		var lat = pos.coords.latitude,
		    lng = pos.coords.longitude,
		    latlng = new L.LatLng(lat, lng),

		    latAccuracy = 180 * pos.coords.accuracy / 40075017,
		    lngAccuracy = latAccuracy / Math.cos(L.LatLng.DEG_TO_RAD * lat),

		    bounds = L.latLngBounds(
		            [lat - latAccuracy, lng - lngAccuracy],
		            [lat + latAccuracy, lng + lngAccuracy]),

		    options = this._locateOptions;

		if (options.setView) {
			var zoom = Math.min(this.getBoundsZoom(bounds), options.maxZoom);
			this.setView(latlng, zoom);
		}

		var data = {
			latlng: latlng,
			bounds: bounds,
			timestamp: pos.timestamp
		};

		for (var i in pos.coords) {
			if (typeof pos.coords[i] === 'number') {
				data[i] = pos.coords[i];
			}
		}

		this.fire('locationfound', data);
	}
});


}(window, document));

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var EventPluginRegistry = __webpack_require__(245);
var EventPluginUtils = __webpack_require__(246);
var ReactErrorUtils = __webpack_require__(250);

var accumulateInto = __webpack_require__(479);
var forEachAccumulated = __webpack_require__(480);
var invariant = __webpack_require__(13);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(144);
var EventPluginUtils = __webpack_require__(246);

var accumulateInto = __webpack_require__(479);
var forEachAccumulated = __webpack_require__(480);
var warning = __webpack_require__(20);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

var getEventTarget = __webpack_require__(255);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcelDateTimeFormat = exports.ExcelTimeFormat = exports.ExcelDateFormat = exports.toCSVDataUri = exports.toCSVBlob = exports.toCSV = void 0;
// TH 12/20/2016 -- Using json2csv. See https://github.com/zemirco/json2csv
// json2csv seems pretty solid, but one weirdness I noticed is that it internally calls
// JSON.stringify to escape data, so some characters get replaced w/ their JSON escapes.
// E.g., embedded new lines inside a value get converted into '\\n' (prints as a backslash + n),
// so that's what you see if you open the file in Excel.
// As an alternative, I tried papaparse (https://github.com/mholt/PapaParse).
// That produced the CSV I was expecting for new lines (as described in http://stackoverflow.com/a/566059).
// But I found that Excel 2016 didn't display the CSV as I expected -- for new lines, I'd only see the first line of each cell.
// So bottom line, papaparse gave no better results than json2csv when importing into Excel.
// And for data w/o new lines (which is our expected case), their output was nearly identical.
// Meanwhile papaparse is no longer actively maintained.
// So sticking w/ json2csv for now.
var json2csv = __webpack_require__(875);
/**
 * Format the given rows and fields as a CSV string.
 * @param rows The rows of data
 * @param fields The CSV fields
 */
function toCSV(rows, fields) {
    return json2csv({
        data: rows,
        fields: fields.map(function (f) { return ({
            label: f.name,
            value: f.formatter
        }); })
    });
}
exports.toCSV = toCSV;
/**
 * Format the given rows and fields as a CSV Blob
 * @param rows The rows of data
 * @param fields The CSV fields
 */
function toCSVBlob(rows, fields) {
    var csv = toCSV(rows, fields);
    return new Blob([csv], { type: 'text/csv' });
}
exports.toCSVBlob = toCSVBlob;
/**
 * Format the given rows and fields as a CSV data URI
 * @deprcated Data URIs have length restrictions on some browsers (notably Chrome).
 * For more reliable support of large data, use `toCSV` or `toCSVBlob` instead.
 * @param rows The rows of data
 * @param fields The CSV fields
 */
function toCSVDataUri(rows, fields) {
    var csv = toCSV(rows, fields);
    return 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
}
exports.toCSVDataUri = toCSVDataUri;
// TH 02/15/2017 -- Date formatting functions optimized for importing CSV into Excel.
// I've found that the best practice is to do date and time as separate columns and use the
// formats below. That'll cause Excel to format the incoming columns as date and time and apply
// region specific formatting.
function ExcelDateFormat(date) {
    return date.toJSON().substr(0, 10); // YYYY-MM-DD
}
exports.ExcelDateFormat = ExcelDateFormat;
function ExcelTimeFormat(date) {
    return date.toJSON().substr(11, 5); // HH:mm
}
exports.ExcelTimeFormat = ExcelTimeFormat;
function ExcelDateTimeFormat(date) {
    return ExcelDateFormat(date) + ' ' + ExcelTimeFormat(date);
}
exports.ExcelDateTimeFormat = ExcelDateTimeFormat;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CCardStatusIndicator = exports.CCardStatusClassname = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var CoordinationCardStatuses_1 = __webpack_require__(110);
function CCardStatusClassname(statusId) {
    var _a, _b;
    // NOTE: Matches the conventions in @ccard-statuses variable in variables.less and
    // #ccard-status-colors.apply-to(...) mixin in mixins.less. Keep in sync.
    return "status-" + ((_b = (_a = CoordinationCardStatuses_1.CoordinationCardStatuses[statusId]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '');
}
exports.CCardStatusClassname = CCardStatusClassname;
function CCardStatusIndicator(_a) {
    var statusId = _a.statusId;
    return (React.createElement("span", { className: cx('ccardstatusindicator', CCardStatusClassname(statusId)) }));
}
exports.CCardStatusIndicator = CCardStatusIndicator;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleableMeasurement = void 0;
var Measurement_1 = __webpack_require__(11);
var ConvertibleMeasurement_1 = __webpack_require__(163);
var ConvertedMeasurement_1 = __webpack_require__(116);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var UOM_1 = __webpack_require__(25);
function ToggleableMeasurement(params) {
    var convertible = params.backingMeasurement instanceof Measurement_1.Measurement
        ? new ConvertibleMeasurement_1.ConvertibleMeasurement(params.backingMeasurement)
        : params.backingMeasurement instanceof Measurement_1.NullableMeasurement
            ? new ConvertibleMeasurement_1.NullableConvertibleMeasurement(params.backingMeasurement)
            : params.backingMeasurement;
    var conversions = params.conversions.map(function (conversion) { return ConversionViewModel(convertible, conversion); });
    return {
        uom: params.uom,
        conversions: conversions
    };
}
exports.ToggleableMeasurement = ToggleableMeasurement;
function ConversionViewModel(convertible, opts) {
    var feetAndInches = opts.uom === UOM_1.default.Foot && opts.feetAndInches ?
        new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(convertible, opts.decimalPlaces) : null;
    var converted = feetAndInches ? null : new ConvertedMeasurement_1.ConvertedMeasurement(convertible, opts.uom, opts.decimalPlaces, opts.precision);
    return {
        uom: opts.uom,
        feetAndInches: feetAndInches,
        converted: converted
    };
}
// TH: Thin viewModel
function ToggleableMeasurementViewModel(params) {
    return {
        model: params.model,
        disable: params.disable,
        textonly: params.textonly,
        tabindex: params.tabindex
    };
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleableMeasurementView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(511);
var view_2 = __webpack_require__(520);
exports.ToggleableMeasurementView = supercritical_1.default(function (_a) {
    var model = _a.model, _b = _a.textonly, textonly = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, placeholder = _a.placeholder, tabindex = _a.tabindex;
    return React.createElement("span", { className: "toggleablemeasurement" }, model.conversions.map(function (conversion) {
        return React.createElement("span", { hidden: conversion.uom !== model.uom(), key: conversion.uom }, textonly ?
            [React.createElement("span", { className: "toggleablemeasurement-value", key: "feetandinches" }, conversion.feetAndInches ? conversion.feetAndInches.toString() : ''),
                React.createElement("span", { className: "toggleablemeasurement-value", key: "converted" }, conversion.converted ? conversion.converted.toString() : '')]
            :
                [conversion.feetAndInches ?
                        React.createElement(view_2.FeetAndInches, { key: "feetandinches", model: conversion.feetAndInches, disabled: disabled, placeholder: placeholder, tabindex: { feet: tabindex && tabindex._, inches: tabindex && tabindex.inches } })
                        : null,
                    conversion.converted ?
                        React.createElement(view_1.ConvertedMeasurementView, { key: "converted", model: conversion.converted, disabled: disabled, placeholder: placeholder, tabindex: tabindex && tabindex._ })
                        : null]);
    }));
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSelector = void 0;
var s_js_1 = __webpack_require__(0);
var model_1 = __webpack_require__(90);
var diacriticals_1 = __webpack_require__(42);
var escapeHtml_1 = __webpack_require__(293);
function UserSelector(opts) {
    var userId = opts.UserId || s_js_1.default.data(0), users = opts.Users, initialUser = s_js_1.default.sample(function () { return users().find(function (u) { return u.Id() === userId(); }); });
    var query = s_js_1.default.data(initialUser ? s_js_1.default.sample(function () { return initialUser.FullName(); }) : ''), typeahead = new model_1.Typeahead({
        collection: users,
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        observable: query,
        matchFn: function (user, query) {
            return diacriticals_1.CaseInsensitiveContains(user.FullName(), query)
                || user.Organization() !== null && diacriticals_1.CaseInsensitiveContains(user.Organization() && user.Organization().Name() || '', query);
        },
        displayKey: function (u) { return u.FullName(); },
        templates: {
            suggestion: formatSuggestion,
            footer: formatFooter
        },
        onSelect: function (u) { return userId(u.Id()); }
    });
    var lastOrg = null;
    return typeahead;
    function formatSuggestion(user) {
        var header = '', item = '<div class="user">' + escapeHtml_1.default(user.FullName()) + '</div>';
        if (user.Organization() && user.Organization() !== lastOrg) {
            header = '<div class="org">' + escapeHtml_1.default(user.Organization().Name()) + "</div>";
        }
        lastOrg = user.Organization();
        return header + item;
    }
    function formatFooter() {
        lastOrg = null;
        return '';
    }
}
exports.UserSelector = UserSelector;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSelectorView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(91);
exports.UserSelectorView = supercritical_1.default(function (params) {
    return React.createElement("div", { className: "user-selector" },
        React.createElement(view_1.TypeaheadInput, __assign({}, params)));
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1436), exports);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1457), exports);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Issue = void 0;
var Issue_1 = __webpack_require__(1478);
var IssueType_1 = __webpack_require__(112);
var Issue = /** @class */ (function (_super) {
    __extends(Issue, _super);
    function Issue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Use this precedence to sort issues that have the same Severity.
    // Greater number means higher precedence.
    Issue.IssuePrecedence = function (issue) {
        return (issue.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure ? 6 :
            issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthLength ? 5 :
                issue.Type() === IssueType_1.IssueType.ReservationExceedsBerthDepth ? 4 :
                    issue.Type() === IssueType_1.IssueType.ReservationOverlapsOther ? 3 :
                        issue.Type() === IssueType_1.IssueType.ReservationOverlapsShift ? 2 :
                            issue.Type() === IssueType_1.IssueType.ReservationOverlapsVesselSchedule ? 1 :
                                issue.Type() === IssueType_1.IssueType.ReservationLacksKnownVessel ? 0 :
                                    -1);
    };
    /** Sort issues by Severity, then by Precedence, from lowest severity/precedence to highest. */
    Issue.PrecedenceOrder = function (issue1, issue2) {
        return (issue1.Severity() - issue2.Severity() ||
            Issue.IssuePrecedence(issue1) - Issue.IssuePrecedence(issue2) ||
            0);
    };
    /** Sort issues by Severity, then by Precedence, from highest severity/precedence to lowest. */
    Issue.ReversePrecedenceOrder = function (issue1, issue2) {
        return Issue.PrecedenceOrder(issue2, issue1);
    };
    // Highest priority issue out of a list of issues, or null if list is empty.
    Issue.TopIssue = function (issues) {
        var top = null;
        issues.forEach(function (i) { return top = (top === null || Issue.PrecedenceOrder(i, top) > 0 ? i : top); });
        return top;
    };
    return Issue;
}(Issue_1.Issue));
exports.Issue = Issue;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneTypes = void 0;
// MilestoneTypes values, hand-synched w/ PortCall.Models\Schedule\MilestoneType.cs.
var MilestoneTypes;
(function (MilestoneTypes) {
    MilestoneTypes[MilestoneTypes["FirstArrival"] = 10] = "FirstArrival";
    MilestoneTypes[MilestoneTypes["FinalDeparture"] = 20] = "FinalDeparture";
    MilestoneTypes[MilestoneTypes["BerthArrival"] = 30] = "BerthArrival";
    MilestoneTypes[MilestoneTypes["ShiftDeparture"] = 40] = "ShiftDeparture";
})(MilestoneTypes = exports.MilestoneTypes || (exports.MilestoneTypes = {}));
;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PierMark = void 0;
var s_js_1 = __webpack_require__(0);
var Measurement_1 = __webpack_require__(11);
// PierMark was a computed field in C#, but with the C# -> JSON -> observable mapping, we lost that
// we create functions here to convert them back, extending Measurement to get its methods
var PierMark = /** @class */ (function (_super) {
    __extends(PierMark, _super);
    function PierMark(footmark, berth) {
        var _this = _super.call(this) || this;
        _this.Num = function (v) {
            if (v === undefined) {
                var b = berth();
                return b ? b.PierMark.subtract(b.StartMark).add(footmark).Num() : footmark.Num();
            }
            else {
                s_js_1.default.sample(function () {
                    var b = berth();
                    footmark.Num(b ?
                        new Measurement_1.Measurement({ Num: v, UOM: b.PierMark.UOM() })
                            .subtract(b.PierMark)
                            .add(b.StartMark)
                            .convert(footmark.UOM())
                            .Num() :
                        v);
                });
                return v;
            }
        };
        _this.UOM = function () { var _a, _b; return (_b = (_a = berth()) === null || _a === void 0 ? void 0 : _a.PierMark.UOM()) !== null && _b !== void 0 ? _b : footmark.UOM(); };
        return _this;
    }
    return PierMark;
}(Measurement_1.Measurement));
exports.PierMark = PierMark;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectiveDeepDraft = exports.EffectiveAirDraft = exports.EffectiveDraft = exports.EffectiveLength = exports.PilotJobOrder = void 0;
var s_js_1 = __webpack_require__(0);
var Measurement_1 = __webpack_require__(11);
var PortCall_1 = __webpack_require__(161);
var ScheduleDateType_1 = __webpack_require__(80);
var PilotJobOrder_1 = __webpack_require__(1528);
var PilotJobOrder = /** @class */ (function (_super) {
    __extends(PilotJobOrder, _super);
    function PilotJobOrder(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.EffectiveLength = EffectiveLength(_this);
        _this.EffectiveAirDraft = EffectiveAirDraft(_this);
        _this.EffectiveDeepDraft = EffectiveDeepDraft(_this);
        return _this;
    }
    PilotJobOrder.prototype.StartEntity = function () {
        return this.Schedule().find(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.PJOStart; }) || null;
    };
    PilotJobOrder.prototype.EndEntity = function () {
        return this.Schedule().find(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.PJOEnd; }) || null;
    };
    PilotJobOrder.prototype.EffectivePortCall = function () {
        return this.Cancellation() ? this.Cancellation().PointInTime() && this.Cancellation().PointInTime().PortCall() : this.PortCall();
    };
    PilotJobOrder.prototype.EffectiveFromPoint = function () {
        return this.Cancellation() ? this.Cancellation().PointInTime() && this.Cancellation().PointInTime().FromPoint() : this.FromPoint();
    };
    PilotJobOrder.prototype.EffectiveToPoint = function () {
        return this.Cancellation() ? this.Cancellation().PointInTime() && this.Cancellation().PointInTime().ToPoint() : this.ToPoint();
    };
    PilotJobOrder.prototype.DisplayVesselIdentifier = function () {
        var _this = this;
        return PortCall_1.VesselIdentifier(function () { return _this.EffectiveVessel(); }, function () { return _this.EffectivePortCall() && _this.EffectivePortCall().Agent(); }, new Measurement_1.Measurement({
            Num: this.EffectiveLength.Num(),
            UOM: this.EffectiveLength.UOM()
        }));
    };
    PilotJobOrder.prototype.EffectiveVessel = function () {
        // TH 03/10/2017 -- Use Length.Num to test if the Vessel has been "locked".
        // We use Length.Num instead of testing VesselId b/c in theory the Vessel could've been
        // locked at a time when the PortCall Vessel was still null.
        return this.Length.Num() !== null ? this.Vessel() : this.EffectivePortCall() ? this.EffectivePortCall().Vessel() : null;
    };
    PilotJobOrder.prototype.ApprovalOfCharges = function () {
        return this._approvalsOfCharges().length === 0 ? null : this._approvalsOfCharges()[0];
    };
    return PilotJobOrder;
}(PilotJobOrder_1.PilotJobOrder));
exports.PilotJobOrder = PilotJobOrder;
function EffectiveLength(pjo) {
    var effective = function () {
        var _a, _b;
        return pjo.Length.Num() !== null ? pjo.Length : (_b = (_a = pjo.EffectivePortCall()) === null || _a === void 0 ? void 0 : _a.VesselLength) !== null && _b !== void 0 ? _b : new Measurement_1.Measurement();
    };
    return {
        Num: function (val) {
            var _a;
            if (val === undefined)
                return (_a = effective().Num()) !== null && _a !== void 0 ? _a : 0;
            pjo.Length.set(new Measurement_1.Measurement({ Num: val, UOM: s_js_1.default.sample(function () { var _a; return (_a = effective().UOM()) !== null && _a !== void 0 ? _a : ''; }) }));
            return val;
        },
        UOM: function () { var _a; return (_a = effective().UOM()) !== null && _a !== void 0 ? _a : ''; }
    };
}
exports.EffectiveLength = EffectiveLength;
function EffectiveDraft(pjo, pjoDraft, pcDraft) {
    var effective = function () {
        // TH 02/03/2017 -- If pjoDraft is non-null or someone has set DeepDraftConfirmed,
        // then the pjoDraft takes precedence...
        return pjoDraft.Num() !== null || pjo.DeepDraftConfirmed() ? pjoDraft :
            // ...else if PortCall is populated, fall through to PortCall draft...
            pjo.EffectivePortCall() ? pcDraft(pjo.EffectivePortCall()) :
                // ...else use a dummy measurement as a final fallback.
                new Measurement_1.NullableMeasurement();
    };
    return {
        Num: function (val) {
            if (val === undefined)
                return effective().Num();
            pjoDraft.set(new Measurement_1.NullableMeasurement({ Num: val, UOM: s_js_1.default.sample(function () { return effective().UOM(); }) }));
            return val;
        },
        UOM: function () { return effective().UOM(); },
        // TH 02/03/2017 -- To be called when setting DeepDraftConfirmed, to persist the
        // current effective value.
        Lock: function () { return pjoDraft.set(effective()); }
    };
}
exports.EffectiveDraft = EffectiveDraft;
function EffectiveAirDraft(pjo) {
    return EffectiveDraft(pjo, pjo.AirDraft, function (pc) { return pc.AirDraft; });
}
exports.EffectiveAirDraft = EffectiveAirDraft;
function EffectiveDeepDraft(pjo) {
    return EffectiveDraft(pjo, pjo.DeepDraft, function (pc) { return pc.DeepDraft; });
}
exports.EffectiveDeepDraft = EffectiveDeepDraft;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselIdentifier = exports.PortCall = void 0;
var notNullish_1 = __webpack_require__(94);
var PortCall_1 = __webpack_require__(1543);
var BerthReservation_1 = __webpack_require__(38);
var ItineraryPoint_1 = __webpack_require__(69);
var Measurement_1 = __webpack_require__(11);
var PortCall = /** @class */ (function (_super) {
    __extends(PortCall, _super);
    function PortCall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PortCall.prototype.Reservations = function () {
        var pts = this.Itinerary(), reses = [];
        for (var _i = 0, pts_1 = pts; _i < pts_1.length; _i++) {
            var pt = pts_1[_i];
            var res = pt.BerthReservation();
            if (res)
                reses.push(res);
        }
        reses.sort(function (a, b) { return a.Itinerary() && b.Itinerary() ? ItineraryPoint_1.ItineraryPoint.EstimatedOrder(a.Itinerary(), b.Itinerary()) : 0; });
        return reses;
    };
    PortCall.prototype.ActiveReservations = function () {
        return this.Reservations().filter(function (r) { return r.Status() !== BerthReservation_1.BerthReservationStatus.Cancelled; });
    };
    PortCall.prototype.Booked = function () {
        var reses = this.Reservations();
        return reses.every(function (r) { return r.Status() === BerthReservation_1.BerthReservationStatus.Booked || r.Status() === BerthReservation_1.BerthReservationStatus.Cancelled; })
            && reses.some(function (r) { return r.Status() !== BerthReservation_1.BerthReservationStatus.Cancelled; });
    };
    PortCall.prototype.Cancelled = function () {
        var reses = this.Reservations();
        return reses.length > 0 && reses.every(function (res) { return res.CancelledDate() !== null; });
    };
    PortCall.prototype.DisplayVesselIdentifier = function () {
        var _this = this;
        return VesselIdentifier(function () { return _this.Vessel(); }, function () { return _this.Agent(); }, this.LengthOnlyLength);
    };
    Object.defineProperty(PortCall.prototype, "VesselLength", {
        get: function () {
            var _this = this;
            return new Measurement_1.ImmutableNullableMeasurement({
                Num: function () {
                    var _a, _b;
                    return _this.VesselId() === null ?
                        _this.LengthOnlyLength.Num() : (_b = (_a = _this.Vessel()) === null || _a === void 0 ? void 0 : _a.Length.Num()) !== null && _b !== void 0 ? _b : null;
                },
                UOM: function () {
                    var _a, _b;
                    return _this.VesselId() === null ?
                        _this.LengthOnlyLength.UOM() : (_b = (_a = _this.Vessel()) === null || _a === void 0 ? void 0 : _a.Length.UOM()) !== null && _b !== void 0 ? _b : null;
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    PortCall.prototype.MovementSeries = function () {
        var itn = this.Itinerary(), 
        // HACK: currently, you can't re-order shifts, so creation order = shift order, 
        // allowing us to order on Id
        // if we don't have an Id yet, we assume that it's a new point and use its position in
        // this.Itinerary()
        // finally, we keep the port arrival/departure at the ends
        order = function (pt) {
            return pt.IsPortArrival() && Number.MIN_SAFE_INTEGER ||
                pt.IsPortDeparture() && Number.MAX_SAFE_INTEGER ||
                pt.Id() ||
                Number.MAX_SAFE_INTEGER - itn.length + itn.indexOf(pt);
        };
        return itn.filter(function (pt) { return pt.IsMovementPoint(); })
            .sort(function (a, b) { return order(a) - order(b); });
    };
    PortCall.prototype.MovementSchedule = function () {
        var out = [];
        for (var _i = 0, _a = this.MovementSeries(); _i < _a.length; _i++) {
            var pt = _a[_i];
            out.push(pt.ArrivalEntity());
            out.push(pt.DepartureEntity());
        }
        return out;
    };
    PortCall.prototype.MilestoneDates = function () {
        return this
            .MovementSchedule()
            .filter(notNullish_1.notNullish)
            .filter(function (d) { return d.MilestoneTypeId() !== null; });
    };
    return PortCall;
}(PortCall_1.PortCall));
exports.PortCall = PortCall;
function VesselIdentifier(vessel, agent, lengthOnlyLength) {
    if (vessel())
        return vessel().Name();
    var org = agent() && agent().Organization();
    return (org ? org.Name() + " - " : "") + new Measurement_1.NullableMeasurement({
        Num: lengthOnlyLength.Num(),
        UOM: lengthOnlyLength.UOM()
    }).toString({ units: true, places: 1 });
}
exports.VesselIdentifier = VesselIdentifier;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableNullablePrice = exports.ImmutablePrice = exports.NullablePrice = exports.Price = void 0;
var s_js_1 = __webpack_require__(0);
var Currency_1 = __webpack_require__(164);
var jsonableObservable_1 = __webpack_require__(1);
var Price_1 = __webpack_require__(1552);
var Price = /** @class */ (function (_super) {
    __extends(Price, _super);
    function Price(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Cur: Currency_1.default.USD }) || this;
        if (data && data.Cur !== undefined)
            checkCur(data.Cur);
        var _Cur = _this.Cur;
        _this.Cur = jsonableObservable_1.jsonableObservable(function (v) {
            return arguments.length > 0 ? (checkCur(v), _Cur(v)) : _Cur();
        });
        return _this;
    }
    Price.prototype.add = function (p) {
        var _this = this;
        return new ImmutablePrice({
            Num: function () {
                var num = p instanceof Price ? (checkCompatibility(_this.Cur(), p.Cur()), p.Num()) : p;
                return _this.Num() + num;
            },
            Cur: this.Cur
        });
    };
    Price.prototype.subtract = function (p) {
        var _this = this;
        return new ImmutablePrice({
            Num: function () {
                var num = p instanceof Price ? (checkCompatibility(_this.Cur(), p.Cur()), p.Num()) : p;
                return _this.Num() - num;
            },
            Cur: this.Cur
        });
    };
    Price.prototype.roundToNearest = function (rounding) {
        var _this = this;
        return new ImmutablePrice({
            Num: function () {
                var num = Math.round(_this.Num() / rounding) * rounding, 
                // due to floating point errors, our result might have more decimal places than our
                // rounding number, so fix that here
                roundingDigits = rounding.toString(), decimal = roundingDigits.lastIndexOf('.');
                if (decimal !== -1) {
                    var places = roundingDigits.length - decimal;
                    num = parseFloat(num.toFixed(places));
                }
                return num;
            },
            Cur: this.Cur
        });
    };
    Price.prototype.roundToNPlaces = function (places) {
        var _this = this;
        return new ImmutablePrice({
            Num: function () { return parseFloat(_this.Num().toFixed(places)); },
            Cur: this.Cur
        });
    };
    Price.prototype.set = function (p) {
        this.Num(s_js_1.default.sample(p.Num));
        this.Cur(s_js_1.default.sample(p.Cur));
    };
    Price.prototype.toString = function (opts) {
        opts = opts || {};
        var currency = opts.currency !== undefined ? opts.currency : 'symbol', places = opts.places !== undefined ? opts.places : -1; // -1 === don't do any rounding
        var num = this.Num(), cur = this.Cur();
        if (places >= 0)
            num = parseFloat(num.toFixed(places));
        // TH 05/04/2017 -- Using the options parameter to toLocaleString.
        // This seems to be well-supported on modern desktop browsers.
        // On older browsers, the rounding is less predictable.
        // E.g., on IE <= 10, the behavior of toLocaleString seems to be to always
        // round to 2 decimal places regardless of any options passed.
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
        var numStr = num.toLocaleString(undefined, { minimumFractionDigits: places >= 0 ? places : undefined });
        return (
        // TH 05/04/2017 -- TODO: toLocaleString supports a lot of these formatting options
        // natively. That might not give us as much control as we need though, and might
        // degrade less gracefully on older browsers.
        currency === 'full' ? numStr + ' ' + cur :
            // TH 05/01/2017 -- TODO: Localization to determine placement of symbol.
            // As I understand it, whether to place symbol before or after the number is more
            // a function of the desired locale than of the currency being used.
            // See: https://ux.stackexchange.com/a/22589
            currency === 'symbol' ? Currency_1.default.Symbol[cur] + numStr :
                numStr);
    };
    return Price;
}(Price_1.Price));
exports.Price = Price;
var NullablePrice = /** @class */ (function (_super) {
    __extends(NullablePrice, _super);
    function NullablePrice(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || {}) || this;
        if (data && data.Cur !== undefined && data.Cur !== null)
            checkCur(data.Cur);
        var _Cur = _this.Cur;
        _this.Cur = jsonableObservable_1.jsonableObservable(function (v) {
            return arguments.length > 0 ? (v === null || checkCur(v), _Cur(v)) : _Cur();
        });
        return _this;
    }
    NullablePrice.prototype.add = function (p) {
        var _this = this;
        return new ImmutableNullablePrice({
            Num: function () {
                if (_this.Num() === null || _this.Cur() === null || p === null || p instanceof NullablePrice && (p.Num() === null || p.Cur() === null))
                    return null;
                var num = p instanceof NullablePrice ? (checkCompatibility(_this.Cur(), p.Cur()), p.Num()) : p;
                return _this.Num() + num;
            },
            Cur: this.Cur
        });
    };
    NullablePrice.prototype.subtract = function (p) {
        var _this = this;
        return new ImmutableNullablePrice({
            Num: function () {
                if (_this.Num() === null || _this.Cur() === null || p === null || p instanceof ImmutableNullablePrice && (p.Num() === null || p.Cur() === null))
                    return null;
                var num = p instanceof NullablePrice ? (checkCompatibility(_this.Cur(), p.Cur()), p.Num()) : p;
                return _this.Num() - num;
            },
            Cur: this.Cur
        });
    };
    NullablePrice.prototype.roundToNearest = function (rounding) {
        var _this = this;
        return new ImmutableNullablePrice({
            Num: function () {
                var orig = _this.Num(), num = orig === null ? null : Math.round(orig / rounding) * rounding, 
                // due to floating point errors, our result might have more decimal places than our
                // rounding number, so fix that here
                roundingDigits = rounding.toString(), decimal = roundingDigits.lastIndexOf('.');
                if (decimal !== -1 && num !== null) {
                    var places = roundingDigits.length - decimal;
                    num = parseFloat(num.toFixed(places));
                }
                return num;
            },
            Cur: this.Cur
        });
    };
    NullablePrice.prototype.roundToNPlaces = function (places) {
        var _this = this;
        return new ImmutableNullablePrice({
            Num: function () { return _this.Num() === null ? null : parseFloat(_this.Num().toFixed(places)); },
            Cur: this.Cur
        });
    };
    NullablePrice.prototype.set = function (p) {
        this.Num(s_js_1.default.sample(p.Num));
        this.Cur(s_js_1.default.sample(p.Cur));
    };
    NullablePrice.prototype.toString = function (opts) {
        opts = opts || {};
        var currency = opts.currency !== undefined ? opts.currency : 'symbol', places = opts.places !== undefined ? opts.places : -1; // -1 === don't do any rounding
        var num = this.Num(), cur = this.Cur();
        if (places >= 0 && num !== null)
            num = parseFloat(num.toFixed(places));
        // TH 05/04/2017 -- Using the options parameter to toLocaleString.
        // This seems to be well-supported on modern desktop browsers.
        // On older browsers, the rounding is less predictable.
        // E.g., on IE <= 10, the behavior of toLocaleString seems to be to always
        // round to 2 decimal places regardless of any options passed.
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
        var numStr = num === null ? '--' : num.toLocaleString(undefined, { minimumFractionDigits: places >= 0 ? places : undefined });
        return (
        // TH 05/04/2017 -- TODO: toLocaleString supports a lot of these formatting options
        // natively. That might not give us as much control as we need though, and might
        // degrade less gracefully on older browsers.
        currency === 'full' ? numStr + (cur === null ? '' : ' ' + cur) :
            // TH 05/01/2017 -- TODO: Localization to determine placement of symbol.
            // As I understand it, whether to place symbol before or after the number is more
            // a function of the desired locale than of the currency being used.
            // See: https://ux.stackexchange.com/a/22589
            currency === 'symbol' ? (cur === null ? '' : Currency_1.default.Symbol[cur]) + numStr :
                numStr);
    };
    return NullablePrice;
}(Price_1.NullablePrice));
exports.NullablePrice = NullablePrice;
var ImmutablePrice = /** @class */ (function (_super) {
    __extends(ImmutablePrice, _super);
    function ImmutablePrice(data) {
        var _this = _super.call(this) || this;
        _this.Num = immutable(data.Num, "Num");
        _this.Cur = immutable(data.Cur, "Cur");
        return _this;
    }
    return ImmutablePrice;
}(Price));
exports.ImmutablePrice = ImmutablePrice;
var ImmutableNullablePrice = /** @class */ (function (_super) {
    __extends(ImmutableNullablePrice, _super);
    function ImmutableNullablePrice(data) {
        var _this = _super.call(this) || this;
        _this.Num = immutable(data.Num, "Num");
        _this.Cur = immutable(data.Cur, "Cur");
        return _this;
    }
    return ImmutableNullablePrice;
}(NullablePrice));
exports.ImmutableNullablePrice = ImmutableNullablePrice;
function checkCompatibility(cur1, cur2) {
    if (cur1 !== cur2)
        throw new Error('Cannot combine prices of different currencies');
}
function immutable(val, name) {
    return function () {
        if (arguments.length === 0)
            return val();
        throw new Error("Cannot modify " + name + " of an immutable price");
    };
}
function checkCur(cur) {
    if (!(cur in Currency_1.default.Symbol)) {
        throw new Error("'" + cur + "' is not a recognized currency");
    }
}


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableConvertibleMeasurement = exports.ConvertibleMeasurement = void 0;
var s_js_1 = __webpack_require__(0);
var Measurement_1 = __webpack_require__(11);
/// <summary>
/// Extend a normal Measurement instance by adding a LastWriter property.
/// This is required to support writable ConvertedMeasurements.
///
/// Constructs a new object that aliases the Num and UOM observables of the backing Measurement.
/// backingMeasurement can be a plain Measurement instance or a Measurement-like object w/ Num and UOM observables.
/// </summary>
var ConvertibleMeasurement = /** @class */ (function (_super) {
    __extends(ConvertibleMeasurement, _super);
    function ConvertibleMeasurement(backingMeasurement) {
        var _this = _super.call(this) || this;
        _this.LastWriter = s_js_1.default.data(null);
        _this.Num = backingMeasurement.Num;
        _this.UOM = backingMeasurement.UOM;
        return _this;
    }
    return ConvertibleMeasurement;
}(Measurement_1.Measurement));
exports.ConvertibleMeasurement = ConvertibleMeasurement;
var NullableConvertibleMeasurement = /** @class */ (function (_super) {
    __extends(NullableConvertibleMeasurement, _super);
    function NullableConvertibleMeasurement(backingMeasurement) {
        var _this = _super.call(this) || this;
        _this.LastWriter = s_js_1.default.data(null);
        _this.Num = backingMeasurement.Num;
        _this.UOM = backingMeasurement.UOM;
        return _this;
    }
    return NullableConvertibleMeasurement;
}(Measurement_1.NullableMeasurement));
exports.NullableConvertibleMeasurement = NullableConvertibleMeasurement;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Currency = {
    USD: 'USD',
    Symbol: {}
};
Currency.Symbol[Currency.USD] = '$';
exports.default = Currency;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.callAll = void 0;
/** Return a function that when called calls all of the provided functions. */
// NOTE: Mainly intend this as a convenience when wanting to pass multiple signals as the 1st param to `S.on`.
// There's an inconsistency in the current version of S (0.4.9 as of this writing) in that the runtime supports
// an array as the 1st param to `S.on`, in which case it behaves exactly as using this `callAll` util would,
// but the TS typings only allow a signal as the 1st param to `S.on`, not an array. Using `callAll` to avoid
// depending on the undocumented array behavior.
var callAll = function () {
    var callees = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        callees[_i] = arguments[_i];
    }
    return function () {
        for (var _i = 0, callees_1 = callees; _i < callees_1.length; _i++) {
            var callee = callees_1[_i];
            callee();
        }
    };
};
exports.callAll = callAll;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(102);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(50);
var redefineAll = __webpack_require__(100);
var meta = __webpack_require__(84);
var forOf = __webpack_require__(83);
var anInstance = __webpack_require__(95);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(19);
var $iterDetect = __webpack_require__(175);
var setToStringTag = __webpack_require__(119);
var inheritIfRequired = __webpack_require__(218);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(47);
var redefine = __webpack_require__(50);
var fails = __webpack_require__(19);
var defined = __webpack_require__(62);
var wks = __webpack_require__(24);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(14);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(56);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(18);
var cof = __webpack_require__(56);
var MATCH = __webpack_require__(24)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(72);
var descriptor = __webpack_require__(85);
var setToStringTag = __webpack_require__(119);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(47)(IteratorPrototype, __webpack_require__(24)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(98);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(50);
var hide = __webpack_require__(47);
var has = __webpack_require__(45);
var Iterators = __webpack_require__(97);
var $iterCreate = __webpack_require__(173);
var setToStringTag = __webpack_require__(119);
var getPrototypeOf = __webpack_require__(49);
var ITERATOR = __webpack_require__(24)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(24)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(98) || !__webpack_require__(19)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(16)[K];
});


/***/ }),
/* 177 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(5);
var aFunction = __webpack_require__(39);
var ctx = __webpack_require__(53);
var forOf = __webpack_require__(83);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(5);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(14);
var aFunction = __webpack_require__(39);
var SPECIES = __webpack_require__(24)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var uid = __webpack_require__(103);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expression; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maptype__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variable__ = __webpack_require__(241);
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/


/**
 * An expression of variable terms and a constant.
 *
 * The constructor accepts an arbitrary number of parameters,
 * each of which must be one of the following types:
 *  - number
 *  - Variable
 *  - Expression
 *  - 2-tuple of [number, Variable|Expression]
 *
 * The parameters are summed. The tuples are multiplied.
 *
 * @class
 * @param {...(number|Variable|Expression|Array)} args
 */
var Expression = /** @class */ (function () {
    function Expression() {
        var parsed = parseArgs(arguments);
        this._terms = parsed.terms;
        this._constant = parsed.constant;
    }
    /**
     * Returns the mapping of terms in the expression.
     *
     * This *must* be treated as const.
     * @private
     */
    Expression.prototype.terms = function () {
        return this._terms;
    };
    /**
     * Returns the constant of the expression.
     * @private
     */
    Expression.prototype.constant = function () {
        return this._constant;
    };
    /**
     * Returns the computed value of the expression.
     *
     * @private
     * @return {Number} computed value of the expression
     */
    Expression.prototype.value = function () {
        var result = this._constant;
        for (var i = 0, n = this._terms.size(); i < n; i++) {
            var pair = this._terms.itemAt(i);
            result += pair.first.value() * pair.second;
        }
        return result;
    };
    /**
     * Creates a new Expression by adding a number, variable or expression
     * to the expression.
     *
     * @param {Number|Variable|Expression} value Value to add.
     * @return {Expression} expression
     */
    Expression.prototype.plus = function (value) {
        return new Expression(this, value);
    };
    /**
     * Creates a new Expression by substracting a number, variable or expression
     * from the expression.
     *
     * @param {Number|Variable|Expression} value Value to substract.
     * @return {Expression} expression
     */
    Expression.prototype.minus = function (value) {
        return new Expression(this, typeof value === "number" ? -value : [-1, value]);
    };
    /**
     * Creates a new Expression by multiplying with a fixed number.
     *
     * @param {Number} coefficient Coefficient to multiply with.
     * @return {Expression} expression
     */
    Expression.prototype.multiply = function (coefficient) {
        return new Expression([coefficient, this]);
    };
    /**
     * Creates a new Expression by dividing with a fixed number.
     *
     * @param {Number} coefficient Coefficient to divide by.
     * @return {Expression} expression
     */
    Expression.prototype.divide = function (coefficient) {
        return new Expression([1 / coefficient, this]);
    };
    Expression.prototype.isConstant = function () {
        return this._terms.size() == 0;
    };
    Expression.prototype.toString = function () {
        var result = this._terms.array.map(function (pair, idx) {
            return (pair.second + "*" + pair.first.toString());
        }).join(" + ");
        if (!this.isConstant() && this._constant !== 0) {
            result += " + ";
        }
        result += this._constant;
        return result;
    };
    return Expression;
}());

/**
 * An internal argument parsing function.
 * @private
 */
function parseArgs(args) {
    var constant = 0.0;
    var factory = function () { return 0.0; };
    var terms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__maptype__["a" /* createMap */])(__WEBPACK_IMPORTED_MODULE_1__variable__["a" /* Variable */].Compare);
    for (var i = 0, n = args.length; i < n; ++i) {
        var item = args[i];
        if (typeof item === "number") {
            constant += item;
        }
        else if (item instanceof __WEBPACK_IMPORTED_MODULE_1__variable__["a" /* Variable */]) {
            terms.setDefault(item, factory).second += 1.0;
        }
        else if (item instanceof Expression) {
            constant += item.constant();
            var terms2 = item.terms();
            for (var j = 0, k = terms2.size(); j < k; j++) {
                var termPair = terms2.itemAt(j);
                terms.setDefault(termPair.first, factory).second += termPair.second;
            }
        }
        else if (item instanceof Array) {
            if (item.length !== 2) {
                throw new Error("array must have length 2");
            }
            var value = item[0];
            var value2 = item[1];
            if (typeof value !== "number") {
                throw new Error("array item 0 must be a number");
            }
            if (value2 instanceof __WEBPACK_IMPORTED_MODULE_1__variable__["a" /* Variable */]) {
                terms.setDefault(value2, factory).second += value;
            }
            else if (value2 instanceof Expression) {
                constant += (value2.constant() * value);
                var terms2 = value2.terms();
                for (var j = 0, k = terms2.size(); j < k; j++) {
                    var termPair = terms2.itemAt(j);
                    terms.setDefault(termPair.first, factory).second += (termPair.second * value);
                }
            }
            else {
                throw new Error("array item 1 must be a variable or expression");
            }
        }
        else {
            throw new Error("invalid Expression argument: " + item);
        }
    }
    return { terms: terms, constant: constant };
}


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var EventPluginRegistry = __webpack_require__(245);
var ReactEventEmitterMixin = __webpack_require__(917);
var ViewportMetrics = __webpack_require__(478);

var getVendorPrefixedEventName = __webpack_require__(949);
var isEventSupported = __webpack_require__(256);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(147);
var ViewportMetrics = __webpack_require__(478);

var getEventModifierState = __webpack_require__(254);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);
var DOMNamespaces = __webpack_require__(244);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(252);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEventKey = exports.eventKey = exports.ScheduleChangeEngine = exports.DEFAULT_DATE_PRECISION = exports.ScheduleRules = exports.ScheduleGoal = exports.ScheduleRule = exports.Rel = exports.ScheduleRel = void 0;
var kiwi_js_1 = __webpack_require__(876);
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var ScheduleDateEvent_1 = __webpack_require__(290);
var ScheduleDateEventType_1 = __webpack_require__(291);
var PortCallChange_1 = __webpack_require__(585);
var PortCallChangeType_1 = __webpack_require__(209);
var Rel;
(function (Rel) {
    Rel["Eq"] = "eq";
    Rel["LEq"] = "leq";
})(Rel = exports.Rel || (exports.Rel = {}));
exports.ScheduleRel = Rel;
var Rule = /** @class */ (function () {
    function Rule(a, op, b, offset) {
        if (offset === void 0) { offset = 0; }
        this.a = a;
        this.op = op;
        this.b = b;
        this.offset = offset;
    }
    /**
     * Is this rule satisfied? Intended for consumers who want to query this rule outside of the context of a
     * `ScheduleChangeEngine` instance.
     */
    Rule.prototype.isSatisfied = function () {
        var a = +this.a.Estimated() + this.offset, b = this.b instanceof TZDate_1.default ? +this.b : +this.b.Estimated(), op = this.op;
        return (op === Rel.Eq ? Math.abs(a - b) < exports.DEFAULT_DATE_PRECISION :
            op === Rel.LEq ? a < b + exports.DEFAULT_DATE_PRECISION :
                null);
    };
    Rule.isRule = function (rule) {
        return rule instanceof Rule;
    };
    return Rule;
}());
exports.ScheduleRule = Rule;
var Goal = /** @class */ (function () {
    function Goal(weight, a, op, b, offset) {
        if (offset === void 0) { offset = 0; }
        this.weight = weight;
        this.rule = new Rule(a, op, b, offset);
    }
    return Goal;
}());
exports.ScheduleGoal = Goal;
var Rules = /** @class */ (function () {
    function Rules() {
        this.requirements = [];
        this.goals = [];
        this.defaults = [];
    }
    return Rules;
}());
exports.ScheduleRules = Rules;
var DEFAULT = kiwi_js_1.Strength.weak, ENTRY = kiwi_js_1.Strength.medium, RULE = kiwi_js_1.Strength.strong;
exports.DEFAULT_DATE_PRECISION = 60 * 1000; // 1 minute increments
function ScheduleChangeEngine(tzutils, _a) {
    var PortCall = _a.PortCall, Policy = _a.Policy;
    var ScheduleChange = new PortCallChange_1.PortCallChange({ Id: 0, Type: PortCallChangeType_1.PortCallChangeType.Schedule }), events = ScheduleChange.ScheduleEvents, eventIndex = s_js_1.default(function () { return events().reduce(function (idx, e) { return (idx[eventKey(e)] = e, idx); }, {}); }), rules = Policy(PortCall).filter(Rule.isRule);
    ScheduleChange.PortCallId(PortCall.Id());
    ScheduleChange.PortCall(PortCall);
    var solver = new kiwi_js_1.Solver(), dates = PortCall.Schedule(), dateVars = [], date2var = new Map(), var2date = new Map(), varStrength = new Map(), 
    // I could MAYBE imagine making datePrecision a configurable param, but for now just setting it to the
    // default value.
    datePrecision = exports.DEFAULT_DATE_PRECISION, dateBase = Date.UTC(2010, 0, 1) / datePrecision, date2num = function (d) { return Math.round(+d / datePrecision - dateBase); }, num2date = function (n) { return tzutils.newDate(Math.round(n + dateBase) * datePrecision); };
    for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
        var date = dates_1[_i];
        var dateVar = new kiwi_js_1.Variable(), strength = DEFAULT;
        dateVars.push(dateVar);
        date2var.set(date, dateVar);
        var2date.set(dateVar, date);
        varStrength.set(dateVar, strength);
        // All dates default to their current estimated value, even if they have an actual value too. The idea is
        // that our solver operates on the estimated schedule ONLY. Estimates never alter actuals of course, and
        // actuals never cascade into estimates either. While it might sound nice to fine-tune the remaining
        // estimates as actuals come in, in practice that ends up leading to a lot of small tweaks to the
        // estimated schedule once the vessel actually arrives, which isn't desirable. In general, the expectation
        // is that if the vessel is gonna be well ahead of or behind schedule, either the agent or the berth mgr
        // should be using Move PortCall ahead of time to reflect that.
        solver.addEditVariable(dateVar, strength);
        solver.suggestValue(dateVar, date2num(date.Estimated()));
    }
    for (var _b = 0, rules_1 = rules; _b < rules_1.length; _b++) {
        var rule = rules_1[_b];
        var a = date2var.get(rule.a), b = rule.b instanceof TZDate_1.default ? date2num(rule.b) : date2var.get(rule.b), op = rule.op === Rel.Eq ? kiwi_js_1.Operator.Eq : kiwi_js_1.Operator.Le;
        solver.addConstraint(new kiwi_js_1.Constraint(a.plus(rule.offset / datePrecision), op, b, RULE));
    }
    s_js_1.default(function () {
        var entries = events().filter(isEnteredEvent), changes = events().filter(isChangedEvent);
        // In theory, calling code might specify more than one ...Entered event for a given date entity. We
        // won't make any effort to support two ...Entered events of the SAME TYPE; in practice, the logic below
        // does last one wins for those, which is fine by us. But there is one case we DO wanna support, which
        // is if calling code provides both an ActualDateEntered event and an EstimatedDateEntered event for
        // the same date entity AND the ActualDateEntered event is a clear actual (has Date() === null). That
        // allows calling code to both clear the actual and suggest a new estimate all at the same time. To
        // handle that, we'll input ...Entered events into our solver in a fixed order: First, clear actuals,
        // then estimates, then log/update actuals.
        var entryOrder = function (entry) { return isActualEnteredEvent(entry) ? entry.Date() === null ? 0 : 2 : 1; };
        entries.sort(function (entry1, entry2) { return entryOrder(entry1) - entryOrder(entry2); });
        // first suggest values to solver for all entered dates
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            var date = entry.ScheduleDate(), dateVar = date2var.get(date), isLogOrEditActual = isActualEnteredEvent(entry) && entry.Date() !== null, 
            // Tell our solver to treat the provided entry with a strength in between DEFAULT (mere
            // suggestions that the solver can disregard as needed) and RULE (rules we need the solver to
            // honor always). Unless this is a log/update actual -- in that case, we just wanna UNDO any
            // previous entered estimates we might've already inputted into our solver for this date.
            strength = isLogOrEditActual ? DEFAULT : ENTRY, 
            // If this is an entered estimate, then the value we input into our solver is just the entered
            // date. Otherwise, if this is an entered actual, we wanna input the current ESTIMATE into our
            // solver. For clear actuals, that makes sense -- we're defaulting back to the estimated value,
            // and if calling code is ALSO proposing a new estimate, we'll handle that when we process
            // estimates next. For log/update actuals, the idea is to avoid cascading the actual value into
            // other estimated dates, and also to ignore any estimates calling code might've entered for
            // this same date (the entered actual renders any entered estimates irrelevant).
            value = isActualEnteredEvent(entry) ? date.Estimated() : entry.Date();
            if (varStrength.get(dateVar) !== strength) {
                solver.removeEditVariable(dateVar);
                solver.addEditVariable(dateVar, strength);
                varStrength.set(dateVar, strength);
            }
            solver.suggestValue(dateVar, date2num(value));
        }
        // run solver
        solver.updateVariables();
        // now record all changes, keeping track of them so that we can clear out 
        // any stale changes that are no longer present
        var changedSet = new Set(), recordChangeEvent = function (date, type, val) {
            var changedKey = buildEventKey(date.Id(), type);
            var change = eventIndex()[changedKey] || null;
            if (change === null) {
                change = new ScheduleDateEvent_1.ScheduleDateEvent({
                    Id: 0,
                    Type: type,
                    ScheduleDateId: date.Id()
                });
                change.ScheduleChange(ScheduleChange);
                change.ScheduleDate(date);
                events.push(change);
            }
            change.Date(val);
            changedSet.add(changedKey);
        };
        var actualEntriesByDate = new Map();
        for (var _a = 0, _b = entries.filter(isActualEnteredEvent); _a < _b.length; _a++) {
            var entry = _b[_a];
            // Again, we're not trying to support MULTIPLE ActualDateEntered events per date entity, so last one
            // wins is just fine here.
            actualEntriesByDate.set(entry.ScheduleDate(), entry);
        }
        // Create/update ...Changed events...
        for (var _c = 0, dateVars_1 = dateVars; _c < dateVars_1.length; _c++) {
            var v = dateVars_1[_c];
            var date = var2date.get(v), actualEntry = actualEntriesByDate.get(date);
            // Entered actuals, including clears, go directly to ActualDateChanged events, no matter what the
            // solver found. This makes good on our guarantee that we'll respect entered actuals no matter
            // what the estimated schedule is telling us.
            if (actualEntry)
                recordChangeEvent(date, ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged, actualEntry.Date());
            // In addition, if the resulting state is that there's no actual for this date, AND the solver found
            // a value for this date that differs from the current estimate, then turn that into an
            // EstimatedDateChanged event.
            var newActual = actualEntry ? actualEntry.Date() : date.Actual();
            if (newActual === null && date2num(date.Estimated()) !== v.value()) {
                recordChangeEvent(date, ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged, num2date(v.value()));
            }
        }
        // remove stale ...Changed events
        for (var _d = 0, changes_1 = changes; _d < changes_1.length; _d++) {
            var change = changes_1[_d];
            if (!changedSet.has(eventKey(change))) {
                events.remove(change);
            }
        }
    });
    // testing engine which just assumes all entries were atomic and OK
    //S(() => {
    //    for (let i = 0; i < events().length; i++) {
    //        let event = events()[i],
    //            match = eventIndex()[matchingChangeEventKey(event)] || null;
    //        if (isEnteredEvent(event)) {
    //            if (match === null) {
    //                match = new DateEvent({ Id: 0, 
    //                    Type: matchingEventType[event.Type()!], 
    //                    ScheduleDateId: event.ScheduleDateId() 
    //                });
    //                match.ScheduleChange(ScheduleChange);
    //                match.ScheduleDate(event.ScheduleDate());
    //                events.push(match);
    //            }
    //            match.Date(event.Date());
    //        } else {
    //            if (match === null) {
    //                events.remove(event);
    //            }
    //        }
    //    }
    //});
    return { ScheduleChange: ScheduleChange };
}
exports.ScheduleChangeEngine = ScheduleChangeEngine;
var isEnteredEvent = function (sde) {
    return sde.Type() === ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered ||
        sde.Type() === ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered;
}, isChangedEvent = function (sde) {
    return sde.Type() === ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged ||
        sde.Type() === ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged;
}, isActualEnteredEvent = function (sde) {
    return sde.Type() === ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered;
}, buildEventKey = function (id, type) { return id + ":" + type; }, eventKey = function (sde) { return buildEventKey(sde.ScheduleDateId(), sde.Type()); }, matchingEventType = (_a = {},
    _a[ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered] = ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged,
    _a[ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged] = ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered,
    _a[ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered] = ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged,
    _a[ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged] = ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered,
    _a), matchingChangeEventKey = function (sde) {
    return buildEventKey(sde.ScheduleDateId(), matchingEventType[sde.Type()]);
};
exports.buildEventKey = buildEventKey;
exports.eventKey = eventKey;
/*

type Pred = (a : DateVar, i : number, dates : DateVar[]) => boolean;
type PairPred = (a : DateVar, b : DateVar, ai : number, bi : number, dates : DateVar[]) => boolean;
type Pattern = (pc : PortCall) => Rule[];

type DateReducer<Acc> = Reducer<Acc, [DateVar, number, DateVar[]]>;
type PairedDateReducer = Reducer<Rule[], [DateVar, DateVar, number, number, DateVar[]]>;
type DateTransducer<Acc> = Transducer<Acc, [DateVar, number, DateVar[]], [DateVar, number, DateVar[]]>;
type DateJoinTransducer = Transducer<Rule[], [DateVar, DateVar, number, number, DateVar[], DateVar[]], [DateVar, number, DateVar[]]>;
type PairedDateTransducer = Transducer<Rule[], [DateVar, DateVar, number, number, DateVar[]], [DateVar, DateVar, number, number, DateVar[]]>;
type PatternTransducer = Transducer<Rule[], [Rule], [DateVar, number, DateVar[]]>;

const
    join3 = (filter : DateTransducer<DateVar[]>) : DateJoinTransducer => {
        let filtered = null as null | DateVar[];
        return joinArray<Rule[], DateVar, DateVar>((a, ai, as) =>
            filtered || (filtered = as.reduce(filter(collect), [] as DateVar[]))
        );
    },
    join2 = (tx : DateTransducer) : DateJoinTransducer =>
        selectMany((a, ai, dates) => (step, acc) => dates.reduce(tx((acc, b, bi) => step(acc, a, b, ai, bi, dates)), acc)),
    join = (tx : DateTransducer) =>
        (step : PairedDateReducer) : DateReducer<Rule[]> =>
            (acc, a, ai, dates) =>
                dates.reduce(tx((acc, b, bi) => step(acc, a, b, ai, bi, dates)), acc),
    isType = (t : SDType) : Pred => a => a.Type() === t,
    isIPArrival = isType(SDType.IPArrival),
    isIPDeparture = isType(SDType.IPDeparture),
    isPJOStart = isType(SDType.PJOStart),
    isPJOEnd = isType(SDType.PJOEnd),
    and = <T extends any[]>(...preds : ((...args: T) => boolean)[]) : (...args : T) => boolean => (...args) => preds.reduce((r, p) => r && p(...args), true),
    or  = <T extends any[]>(...preds : ((...args: T) => boolean)[]) : (...args : T) => boolean => (...args) => preds.reduce((r, p) => r || p(...args), false),
    fst = (...preds : Pred[]) : PairPred => (a, b, ai, bi, dates) => and(...preds)(a, ai, dates),
    snd = (...preds : Pred[]) : PairPred => (a, b, ai, bi, dates) => and(...preds)(b, bi, dates),
    allDatePairsWhere = (fst : Pred | null, snd : Pred | null, combo : PairPred | null, rule : (fst : DateVar, snd : DateVar) => Rule) => (dates : DateVar[]) => {
        const left = fst ? dates.filter(fst) : dates,
            right = snd ? dates.filter(snd) : dates,
            pairs = left.map((a, ai) =>
                (combo ? right.filter((b, bi) => combo(a, b, ai, bi, dates)) : right)
                    .map(((b, bi) => rule(a, b))));
            return pairs.reduce((a, b) => a.concat(b), []);
    },
    datePJO = (pjoDate : DateVar) => pjoDate.JobOrder() && pjoDate.JobOrder()!.PilotJobOrder();

//const allDates = (tx : PatternTransducer) => (pc : PortCall) => pc.Schedule().reduce(tx((rs, r) => (rs.push(r), rs)), []);

var sync : PatternTransducer =
    compose(
        where(isIPDeparture),
        join3(where(isPJOStart)),
        where((ip, pjo) => ip.ItineraryPointId() === datePJO(pjo)!.FromPointId()),
        select((a, b) => new Rule(a, Op.Eq, b))
    );

const foo = compose(
    x => x() + 1,
    compose
);

const addRequirements : (...p : Parameters<typeof compose>) => Rule[] = compose(
    (tx : DateTransducer<Rule[]>) : Pattern => (pc : PortCall) => into([] as Rule[], tx, pc.Schedule()),
    compose
)

var addGoal: Pattern,
    allDates! : (pc : PortCall) => DateVar[],
    hasEntry! : (d : DateVar) => boolean,
    CurrentBestEntry : (d : DateVar) => DateEvent,
    ConcurentTime : (d : DateVar, e : DateEvent) => DateEvent,
    DateDiff : (a : DateEvent, b: DateEvent) => number,
    EntryTime : (e : DateEvent) => number,
    ItineraryPoint : (d : DateVar) => ItineraryPoint,
    ItineraryArrival : (ip : ItineraryPoint) => DateVar;

var anchors =
    addGoal(
        select(allDates),
        where(and(isIPDeparture, hasEntry)),
        join((d) => ItineraryArrival(ItineraryPoint(d))),
        join((d, a) => CurrentBestEntry(d)),
        join((d, a, dt) => ConcurentTime(a, dt)),
        select((d, a, dt, at) => new Goal(EntryTime(at), a, Op.LEq, d, DateDiff(dt, at)))
    );

{
    const select1 = allDates,
        where2 = (d : DateVar) => and(isIPDeparture, hasEntry)(d, 0, []),
        join3 = (d : DateVar) => ItineraryArrival(ItineraryPoint(d)),
        join4 = (d : DateVar, a : DateVar) => CurrentBestEntry(d),
        join5 = (d : DateVar, a : DateVar, dt : DateEvent) => ConcurentTime(a, dt),
        select6 = (d : DateVar, a : DateVar, dt : DateEvent, at : DateEvent) => new Goal(EntryTime(at), a, Op.LEq, d, DateDiff(dt, at));

    const anch = (result, p1) => {
        let p2, p3, p4, p5;
        p1 = select1(p1);
        if (where2(p1)) return;
        p2 = join3(p1);
        p3 = join4(p1, p2);
        p4 = join5(p1, p2, p3);
        p5 = select6(p1, p2, p3, p4);
        result(p5);
    }

    const anchtx = compose(
        ((step : Reducer<Goal[], [DateVar]>)                                => (acc : Goal[], p1 : PortCall) => { for (var p2 of select1(p1)) step(acc, p2); }),
        ((step : Reducer<Goal[], [DateVar]>)                                => (acc : Goal[], p1 : DateVar) => where2(p1) ? step(acc, p1) : acc),
        ((step : Reducer<Goal[], [DateVar, DateVar]>)                       => (acc : Goal[], p1 : DateVar) => step(acc, p1, join3(p1))),
        ((step : Reducer<Goal[], [DateVar, DateVar, DateEvent]>)            => (acc : Goal[], p1 : DateVar, p2 : DateVar) => step(acc, p1, p2, join4(p1, p2))),
        ((step : Reducer<Goal[], [DateVar, DateVar, DateEvent, DateEvent]>) => (acc : Goal[], p1 : DateVar, p2 : DateVar, p3 : DateEvent) => step(acc, p1, p2, p3, join5(p1, p2, p3))),
        ((step : Reducer<Goal[], [Goal]>)                                   => (acc : Goal[], p1 : DateVar, p2 : DateVar, p3 : DateEvent, p4 : DateEvent) => step(acc, select6(p1, p2, p3, p4)))
    )
}

{
    const select1 = allDates,
        where2 = and(isIPDeparture, hasEntry),
        join3 = (d) => ItineraryArrival(ItineraryPoint(d)),
        join4 = (d, a) => CurrentBestEntry(d),
        join5 = (d, a, dt) => ConcurentTime(a, dt),
        select6 = (d, a, dt, at) => new Goal(EntryTime(at), a, Op.LEq, d, DateDiff(dt, at)),

    const anch = (result, p1) => {
        let p2, p3, p4, p5;
        p1 = select1(p1);
        if (where2(p1)) return;
        p2 = join3(p1);
        p3 = join4(p1, p2);
        p4 = join5(p1, p2, p3);
        p5 = select6(p1, p2, p3, p4);
        result(p5);
    }
}

var dates = [] as DateVar[];
var sel : Transducer<Rule[], [Rule], [DateVar]> = select((a : DateVar) => new Rule(a, Op.Eq, a));
var collect = <T>(acc : T[], x : T) => (acc.push(x), acc);
var lred = (acc : Rule[], x : Rule) => (acc.push(x), acc);
var rules = dates.reduce(sel(lred), []);

var syncPJOStartWithIPDeparture = allDatePairsWhere(
    isIPDeparture,
    isPJOStart,
    null,
    (a, b) => new Rule(a, Op.Eq, b)
);
*/ 


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TH 02/13/2017 -- Not really a service. Just a place to hold some common values used for
// scheduling.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIFFERENT_PIERGROUP_TRANSIT_MINS = exports.SAME_PIERGROUP_TRANSIT_MINS = exports.MINIMUM_RES_DURATION_MINS = exports.DEFAULT_NEW_SHIFT_DURATION_MINS = void 0;
exports.DEFAULT_NEW_SHIFT_DURATION_MINS = 6 * 60, exports.MINIMUM_RES_DURATION_MINS = 15, exports.SAME_PIERGROUP_TRANSIT_MINS = 0, exports.DIFFERENT_PIERGROUP_TRANSIT_MINS = 15;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleAlreadyActive = exports.VALIDATION_DEACTIVATED_USER = exports.VALIDATION_DEACTIVATED_ORG = exports.VALIDATION_TOKEN = exports.VALIDATION_ALREADY_ACTIVE = void 0;
var UserSummary_1 = __webpack_require__(203);
exports.VALIDATION_ALREADY_ACTIVE = 'AlreadyActive', exports.VALIDATION_TOKEN = 'Token', exports.VALIDATION_DEACTIVATED_ORG = 'DeactivatedOrganization', exports.VALIDATION_DEACTIVATED_USER = 'DeactivatedUser';
// TH 12/15/2016 -- Common error handling functionality used by both
// AcceptInvitation and RestoreAccount pages.
function HandleAlreadyActive(validationObj, user) {
    if (validationObj[exports.VALIDATION_ALREADY_ACTIVE]) {
        var userSummary = JSON.parse(validationObj[exports.VALIDATION_ALREADY_ACTIVE].RawErrors[1]);
        user(new UserSummary_1.UserSummary(userSummary));
    }
}
exports.HandleAlreadyActive = HandleAlreadyActive;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthManagerDashboard = exports.Tab = void 0;
var s_js_1 = __webpack_require__(0);
var Tab;
(function (Tab) {
    Tab[Tab["Activity"] = 0] = "Activity";
    Tab[Tab["Services"] = 1] = "Services";
})(Tab = exports.Tab || (exports.Tab = {}));
var BerthManagerDashboard = function (params, ActivityFeed, OperationsForecast, ServicesDashboard) {
    var CurrentTab = s_js_1.default.value(params.tab);
    return { Id: params.id, CurrentTab: CurrentTab, ActivityFeed: ActivityFeed, OperationsForecast: OperationsForecast(CurrentTab), ServicesDashboard: ServicesDashboard };
};
exports.BerthManagerDashboard = BerthManagerDashboard;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewCommentView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(78);
var view_2 = __webpack_require__(198);
var view_3 = __webpack_require__(154);
exports.NewCommentView = supercritical_1.default(function (_a) {
    var m = _a.model, topLevel = _a.topLevel, _b = _a.allowTaggingUsers, allowTaggingUsers = _b === void 0 ? true : _b;
    return React.createElement("div", { className: cx("newcomment", { "top-level": topLevel }) },
        React.createElement(CommentMainRow, { model: m, allowTaggingUsers: allowTaggingUsers }),
        React.createElement("div", { className: "clearfix" },
            React.createElement(RecipientSelectorView, { model: m }),
            React.createElement(AddedAttachmentView, { model: m })),
        React.createElement(RecipientsView, { model: m }));
});
var CommentMainRow = supercritical_1.default(function (_a) {
    var m = _a.model, allowTaggingUsers = _a.allowTaggingUsers;
    return React.createElement("div", { className: "newcomment-main-row" },
        React.createElement(CommentMessageView, { model: m }),
        React.createElement(CommentActions, { model: m, allowTaggingUsers: allowTaggingUsers }));
});
var CommentMessageView = /** @class */ (function (_super) {
    __extends(CommentMessageView, _super);
    function CommentMessageView(props) {
        var _this = _super.call(this, props) || this;
        _this.messageRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var model = _a.model;
            return model.MessageFocusTriggered() && el.focus();
        });
        return _this;
    }
    CommentMessageView.prototype.srender = function (_a) {
        var _b;
        var m = _a.model;
        return (React.createElement("textarea", { className: "message-input", rows: 1, placeholder: "Add Comment...", value: (_b = m.NewComment().Message()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.NewComment().Message(e.currentTarget.value); }, ref: this.messageRef }));
    };
    return CommentMessageView;
}(supercritical_1.SuperCriticalComponent));
var CommentActions = supercritical_1.default(function (_a) {
    var m = _a.model, allowTaggingUsers = _a.allowTaggingUsers;
    return React.createElement("span", { className: "newcomment-actions" },
        allowTaggingUsers && React.createElement(RecipientsIcon, { model: m }),
        React.createElement(AttachmentIcon, { model: m }),
        React.createElement(PostButton, { model: m }),
        React.createElement(view_2.UploadFileView, { model: m.FileUploader }));
});
var RecipientsIcon = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("button", { className: "pc-button small-button", onClick: eventWrappers_1.noDefault(m.RecipientSelector().Focus) },
        React.createElement("i", { className: "fa fa-user" }));
});
var AttachmentIcon = supercritical_1.default(function (_a) {
    var m = _a.model;
    var hasAttachment = !!m.NewComment().AttachmentUrl();
    return (React.createElement("label", { 
        // "Disable" attachment icon if we already have an attachment
        className: cx("pc-button small-button", {
            "pc-button-disabled": hasAttachment
        }), htmlFor: hasAttachment ? undefined : m.FileUploader.FileInputId() },
        React.createElement("i", { className: "fa fa-paperclip" })));
});
var PostButton = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("button", { className: "pc-button post-button", disabled: !m.CanSubmit(), onClick: eventWrappers_1.noDefault(m.Submit) }, "Post");
});
var AddedAttachmentView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.NewComment().AttachmentUrl() ?
        React.createElement("div", { className: "attachment-filename-shell" },
            React.createElement("span", { className: "attachment-filename pc-text-fixedwidth" }, m.NewComment().AttachmentFileName()),
            React.createElement("a", { href: "", className: "fa fa-remove", onClick: eventWrappers_1.noDefault(function () { return m.NewComment().AttachmentUrl(null); }) })) :
        null;
});
var RecipientSelectorView = /** @class */ (function (_super) {
    __extends(RecipientSelectorView, _super);
    function RecipientSelectorView(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var model = _a.model;
            return model.RecipientSelector().SelectorFocusTriggered() && el.focus();
        });
        return _this;
    }
    RecipientSelectorView.prototype.srender = function (_a) {
        var m = _a.model;
        return m.RecipientSelector().IsVisible() ?
            React.createElement(view_3.UserSelectorView, { model: m.RecipientSelector().Selector, placeholder: "Add a recipient", inputRef: this.inputRef }) :
            null;
    };
    return RecipientSelectorView;
}(supercritical_1.SuperCriticalComponent));
var RecipientsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Recipients().length > 0 ?
        React.createElement("div", { className: "recipients" }, m.Recipients().map(function (r) { return React.createElement(RecipientView, { recipient: r, key: r.User.Id() }); })) :
        null;
});
var RecipientView = supercritical_1.default(function (_a) {
    var recipient = _a.recipient;
    return React.createElement("div", { className: "recipient-shell" },
        React.createElement("a", { href: "", className: "recipient-name pc-text-fixedwidth", onClick: eventWrappers_1.noDefault(recipient.ToggleProfile) }, recipient.User.FullName()),
        React.createElement("a", { href: "", className: "fa fa-remove", onClick: eventWrappers_1.noDefault(recipient.Delete) }),
        React.createElement(view_1.PersonProfilePopupView, { modelContainer: recipient.ProfilePopup }));
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthStayDurationText = exports.LogActualAttributionText = exports.MovementTransitDurationText = exports.MovementToLocationText = exports.MovementTypeParticiple = exports.MilestoneScheduleDetailsRowBody = exports.MilestoneScheduleDetailsRowLabel = exports.MilestoneScheduleDetailsRow = exports.DateTypeParticiple = exports.MilestoneHeaderRowBody = exports.MilestoneHeaderDateText = exports.MilestoneHeaderRowLabel = exports.MilestoneHeaderRow = exports.MilestoneView = exports.MetroMapFrameworkView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var formatInterval_1 = __webpack_require__(1387);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var MilestoneTypes_1 = __webpack_require__(158);
var ScheduleDateType_1 = __webpack_require__(80);
/**
 * Basic scaffolding for any variation on our "metro map" UI concept. Displays UI for all
 * milestones in a PortCall in a single linked timeline. This component is concerned w/ the
 * overall structure of the timeline and the presentation of the line that runs down the
 * timeline's center but is generic over the content renderered alongside the timeline (the
 * actual "stops" on the metro map).
 */
var MetroMapFrameworkView = /** @class */ (function (_super) {
    __extends(MetroMapFrameworkView, _super);
    function MetroMapFrameworkView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetroMapFrameworkView.prototype.srender = function (_a) {
        var model = _a.model, ctrl = _a.ctrl;
        return (React.createElement("div", { className: "portcall-schedule__milestones" }, model.Milestones().map(function (m) {
            return React.createElement(MilestoneView, { milestone: m, ctrl: ctrl, key: MilestoneKey(m) });
        })));
    };
    return MetroMapFrameworkView;
}(supercritical_1.SuperCriticalComponent));
exports.MetroMapFrameworkView = MetroMapFrameworkView;
var nextMilestoneKey = 0;
var MILESTONE_KEYS = new WeakMap();
function MilestoneKey(m) {
    // To handle both persisted and non-persisted date entities, use a keying strategy based on DateEntity
    // object identity.
    var id = MILESTONE_KEYS.get(m.Date);
    if (id === undefined) {
        id = nextMilestoneKey++;
        MILESTONE_KEYS.set(m.Date, id);
    }
    return id;
}
/**
 * Generic UI component that renders a single milestone (aka "stop") on a metro map timeline.
 * Renders the line UI spanning from the passed-in milestone up to (and possibly including) the
 * next milestone. Calls the provided @see MilestoneController to determine which content to
 * display alongside the timeline for this milestone.
 */
var MilestoneView = /** @class */ (function (_super) {
    __extends(MilestoneView, _super);
    function MilestoneView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MilestoneView.prototype.srender = function (_a) {
        var m = _a.milestone, ctrl = _a.ctrl, standalone = _a.standalone;
        return (React.createElement("div", __assign({}, milestoneElementProps(m, ctrl, standalone)),
            MilestoneLine(m),
            ctrl.milestoneContent(m)));
    };
    return MilestoneView;
}(supercritical_1.SuperCriticalComponent));
exports.MilestoneView = MilestoneView;
function milestoneElementProps(m, ctrl, standalone) {
    var _a, _b, _c;
    var provided = (_a = ctrl.milestoneElementProps) === null || _a === void 0 ? void 0 : _a.call(ctrl, m), hasActual = (_c = (_b = ctrl.milestoneHasClassname) === null || _b === void 0 ? void 0 : _b.call(ctrl, m, 'portcall-milestone--has-actual')) !== null && _c !== void 0 ? _c : m.Date.Actual() !== null;
    return __assign(__assign({}, provided), { className: cx(provided === null || provided === void 0 ? void 0 : provided.className, 'portcall-milestone', "portcall-milestone--" + (standalone || !m.Date.NextMilestoneDate() ? 'has-line-cap' : 'has-no-line-cap'), "portcall-milestone--" + (m.Date.IsMovementStartDate() ? 'movement' : 'inport'), "portcall-milestone--" + (hasActual ? 'has-actual' : 'has-no-actual')) });
}
var MilestoneLine = function (m) {
    return [
        m.Date.IsMovementStartDate() ? MilestoneLineMovement : MilestoneLineInPort,
        /* since the next movement icon is usualy displayed by the next movement, we need
        to add a "cap" that shows it for the last movement */
        m.Date.IsMovementStartDate() ? MilestoneLineMovementCap : MilestoneLineInPortCap
    ];
}, MilestoneLineMovement = (React.createElement("svg", { className: "portcall-milestone__movement-line", key: "line" },
    React.createElement("rect", { x: "9", y: "6", width: "2", height: "100%" }),
    React.createElement("circle", { cx: "10", cy: "8", r: "5" }),
    React.createElement("circle", { cx: "10", cy: "8", r: "2.5" }))), MilestoneLineMovementCap = (React.createElement("svg", { className: "portcall-milestone__movement-line-cap", key: "line-cap" },
    React.createElement("rect", { x: "5", y: "4", width: "10", height: "2" }))), MilestoneLineInPort = (React.createElement("svg", { className: "portcall-milestone__inport-line", key: "line" },
    React.createElement("rect", { x: "6", y: "6", width: "8", height: "100%" }),
    React.createElement("rect", { x: "5", y: "6", width: "10", height: "2" }))), MilestoneLineInPortCap = (React.createElement("svg", { className: "portcall-milestone__inport-line-cap", key: "line-cap" },
    React.createElement("circle", { cx: "10", cy: "5", r: "5" }),
    React.createElement("circle", { cx: "10", cy: "5", r: "2.5" })));
exports.MilestoneHeaderRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row portcall-milestone__header-row" },
        React.createElement(exports.MilestoneHeaderRowLabel, { milestone: m }),
        React.createElement(exports.MilestoneHeaderRowBody, { milestone: m }));
});
exports.MilestoneHeaderRowLabel = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-label" }, MilestoneHeaderDateText(m));
});
function MilestoneHeaderDateText(m) {
    var d = m instanceof TZDate_1.default ? m : m.Date.Effective();
    return tzmoment_1.tzmoment(d).format('DD MMM - HH:mm');
}
exports.MilestoneHeaderDateText = MilestoneHeaderDateText;
exports.MilestoneHeaderRowBody = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-body" },
        React.createElement("span", null, DateTypeParticiple(m)),
        ' ',
        React.createElement("span", { className: "portcall-milestone__header-berth-name" }, (_c = (_b = m.Date.ItineraryPoint()) === null || _b === void 0 ? void 0 : _b.Location()) === null || _c === void 0 ? void 0 : _c.Name()));
});
function DateTypeParticiple(m) {
    return (m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ?
        m.Date.Actual() === null ? 'Arriving' : 'Arrived' :
        m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ?
            m.Date.Actual() === null ? 'Departing' : 'Departed' :
            '');
}
exports.DateTypeParticiple = DateTypeParticiple;
exports.MilestoneScheduleDetailsRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row portcall-milestone__schedule-details-row" },
        React.createElement(exports.MilestoneScheduleDetailsRowLabel, { milestone: m }),
        React.createElement(exports.MilestoneScheduleDetailsRowBody, { milestone: m }));
});
// Don't currently need the milestone prop, but including as future-proofing.
exports.MilestoneScheduleDetailsRowLabel = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-label" }, m.Date.IsMovementStartDate() ? 'Movement' : '');
});
exports.MilestoneScheduleDetailsRowBody = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return m.Date.IsMovementStartDate() ?
        React.createElement("div", { className: "portcall-milestone-row-body" },
            React.createElement("span", null,
                MovementTypeParticiple(m),
                ' ',
                m.Date.Actual() === null && MovementToLocationText(m),
                ' ',
                "\u2014"),
            ' ',
            m.Date.Actual() === null ?
                React.createElement("span", { className: "pc-text-smalllabel" }, MovementTransitDurationText(m)) :
                React.createElement("span", { className: "portcall-milestone__log-actual-attribution" }, LogActualAttributionText(m))) :
        React.createElement("div", { className: "portcall-milestone-row-body" },
            React.createElement("span", { className: "portcall-milestone__log-actual-attribution" }, LogActualAttributionText(m)));
});
// TODO: Update me for the new IN/OUT/SHIFT/AREA movement categorization scheme used on the
// homepage's Traffic Schedule tab?
function MovementTypeParticiple(m) {
    return (m.Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FirstArrival ? 'Inbound' :
        m.Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.ShiftDeparture ? 'Shifting' :
            m.Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FinalDeparture ? 'Outbound' :
                '');
}
exports.MovementTypeParticiple = MovementTypeParticiple;
function MovementToLocationText(m) {
    var _a, _b, _c, _d;
    return (m.Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FirstArrival ||
        m.Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.ShiftDeparture ?
        "to " + ((_d = (_c = (_b = (_a = m.NextDate()) === null || _a === void 0 ? void 0 : _a.ItineraryPoint()) === null || _b === void 0 ? void 0 : _b.Location()) === null || _c === void 0 ? void 0 : _c.Name()) !== null && _d !== void 0 ? _d : '(loading...)') :
        '');
}
exports.MovementToLocationText = MovementToLocationText;
function MovementTransitDurationText(from, to) {
    var _a;
    if (!(from instanceof TZDate_1.default)) {
        to = (_a = from.NextDate()) === null || _a === void 0 ? void 0 : _a.Effective();
        from = from.Date.Effective();
    }
    if (to === undefined || to === null)
        return '';
    return formatInterval_1.formatInterval(from, to) + " transit";
}
exports.MovementTransitDurationText = MovementTransitDurationText;
function LogActualAttributionText(m) {
    var loggedTime = m.Date.Actual(), ev = m.ActualLoggedEvent();
    if (loggedTime === null || ev === null)
        return null;
    var lineTimeText = m.Date.IsBerthArrivalDate() ?
        m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ? 'First line' :
            m.Date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ? 'Last line' :
                '' :
        '', dateFormat = ev.Date().getFullYear() === loggedTime.getFullYear() ?
        ev.Date().getMonth() === loggedTime.getMonth() &&
            ev.Date().getDate() === loggedTime.getDate() ?
            'HH:mm' :
            'HH:mm [on] DD MMM' :
        'HH:mm [on] DD MMM YYYY';
    return (lineTimeText ? lineTimeText + " logged" : 'Logged') + " by " + ev.ActorAbbreviatedName() + " at " + tzmoment_1.tzmoment(ev.Date()).format(dateFormat);
}
exports.LogActualAttributionText = LogActualAttributionText;
function BerthStayDurationText(from, to) {
    var _a;
    if (!(from instanceof TZDate_1.default)) {
        to = (_a = from.NextDate()) === null || _a === void 0 ? void 0 : _a.Effective();
        from = from.Date.Effective();
    }
    if (to === undefined || to === null)
        return '';
    // From the spec: "Reservation Duration in nights. For a portcall with no overnight stay, show hours. 
    // Examples: 1 night stay with 12 hour duration = “Overnight”. Multiple nights = “3 nights”, 
    // No overnight stay with 12 hour reservation = “12 hours”. 
    var fromM = tzmoment_1.tzmoment(from), toM = tzmoment_1.tzmoment(to), daysDiff = toM.dayOfYear() - fromM.dayOfYear(), hoursDiff = toM.diff(fromM, 'hours');
    return daysDiff > 1 ? daysDiff + " nights" :
        daysDiff === 1 ? 'Overnight' :
            hoursDiff === 1 ? '1 hour' :
                hoursDiff + " hours";
}
exports.BerthStayDurationText = BerthStayDurationText;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PCTabStrip = exports.TabStateEq = void 0;
var s_js_1 = __webpack_require__(0);
// NOTE: Keep in sync w/ ./view.less (search "animation-duration").
var TAB_ANIMATION_DURATION_MS = 500;
function TabStateEq(state1, state2) {
    return (state1.state === 'settled-on-front' && state2.state === 'settled-on-front'
        || state1.state === 'settled-on-back' && state2.state === 'settled-on-back' && state1.tab === state2.tab
        || state1.state === 'flipping-to-front' && state2.state === 'flipping-to-front' && state1.fromTab === state2.fromTab
        || state1.state === 'flipping-to-back' && state2.state === 'flipping-to-back' && state1.toTab === state2.toTab);
}
exports.TabStateEq = TabStateEq;
/**
 * Construct a new `PCTabStrip` instance.
 * @param FrontTab The tab instance representing the front tab.
 * @param BackTabs A function that returns an array of tab instances representing back tabs that should be
 * displayed as clickable buttons to the user, in presentation order. You can also programmatically navigate
 * to tabs other than those specified here by calling the `FlipToTab` method.
 */
function PCTabStrip(FrontTab, BackTabs, initState) {
    if (initState === void 0) { initState = { state: 'settled-on-front' }; }
    var State = s_js_1.default.value(initState, TabStateEq), CheckedBackTabs = s_js_1.default(function () {
        var known = new Set([FrontTab]), backTabs = BackTabs();
        var valid = true;
        for (var i = 0; i < backTabs.length; i++) {
            if (known.has(backTabs[i])) {
                valid = false;
                console.warn("Back tab at index " + i + " equals the front tab or another back tab. As a result, this PCTabStrip won't render any back tab buttons.");
            }
            known.add(backTabs[i]);
        }
        return valid ? backTabs : [];
    });
    s_js_1.default(function () {
        // If in one of the flipping states, set a timeout to switch to one of the settled states after an
        // appropriate delay.
        var s = State();
        if (s.state === 'flipping-to-front' || s.state === 'flipping-to-back') {
            var nextState_1 = s.state === 'flipping-to-front' ? { state: 'settled-on-front' } : { state: 'settled-on-back', tab: s.toTab }, timeoutId_1 = setTimeout(function () { return State(nextState_1); }, TAB_ANIMATION_DURATION_MS);
            s_js_1.default.cleanup(function () { return clearTimeout(timeoutId_1); });
        }
    });
    return {
        FrontTab: FrontTab,
        BackTabs: CheckedBackTabs,
        State: function () { return State(); },
        FlipToTab: FlipToTab
    };
    function FlipToTab(tab) {
        var s = s_js_1.default.sample(State);
        if (tab === FrontTab) {
            if (s.state === 'settled-on-front') {
                // Nothing to do. We're already there.
            }
            else if (s.state === 'flipping-to-front') {
                // Also nothing to do. We're already on our way.
            }
            else if (s.state === 'flipping-to-back') {
                // We were flipping to the back but got a contradictory instruction to flip to the front before
                // we even made it there. Say we're flipping from whatever back tab we were trying to get to.
                State({ state: 'flipping-to-front', fromTab: s.toTab });
            }
            else if (s.state === 'settled-on-back') {
                State({ state: 'flipping-to-front', fromTab: s.tab });
            }
        }
        else {
            // Treat any other tab as a back tab, whether it's known to us already or not.
            if (s.state === 'settled-on-back') {
                // Already on a back tab (might be same or might be different) -- say we're on the new back tab
                // w/o going through our flip animation. Jumping straight from one back tab to another isn't
                // something our tab strip UI currently allows but IS something calling code might choose to do
                // by calling this FlipToTab method itself.
                State({ state: 'settled-on-back', tab: tab });
            }
            else {
                // Otherwise, whatever was going on before, just say we're now flipping to the specified back tab.
                State({ state: 'flipping-to-back', toTab: tab });
            }
        }
    }
}
exports.PCTabStrip = PCTabStrip;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCTabContents = exports.TitledTabContentsController = exports.PCTabStripView = exports.TitledTabStripViewController = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var TitledTabStripViewController = /** @class */ (function () {
    function TitledTabStripViewController() {
    }
    TitledTabStripViewController.prototype.renderTabButtonContents = function (tab) {
        return React.createElement("span", null, tab.Title);
    };
    return TitledTabStripViewController;
}());
exports.TitledTabStripViewController = TitledTabStripViewController;
var PCTabStripView = /** @class */ (function (_super) {
    __extends(PCTabStripView, _super);
    function PCTabStripView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PCTabStripView.prototype.srender = function (_a) {
        var m = _a.model, ctrl = _a.ctrl, extraContents = _a.extraContents;
        var s = m.State();
        return (React.createElement("div", { className: "pctabstrip" },
            React.createElement("span", { className: "anchor-tab" },
                React.createElement(TabButton, { model: m, ctrl: ctrl, tab: s.state === 'settled-on-front' ? m.FrontTab :
                        s.state === 'settled-on-back' ? s.tab :
                            s.state === 'flipping-to-front' ? s.fromTab :
                                s.state === 'flipping-to-back' ? m.FrontTab :
                                    null, active: true })),
            React.createElement("span", { className: "remaining-tabs" }, (s.state === 'settled-on-front' || s.state === 'flipping-to-back') && m.BackTabs().map(function (t, i) {
                return React.createElement(TabButton, { key: i, model: m, ctrl: ctrl, tab: t });
            })),
            React.createElement("span", { className: "extra-content" }, extraContents === null || extraContents === void 0 ? void 0 : extraContents())));
    };
    return PCTabStripView;
}(supercritical_1.SuperCriticalComponent));
exports.PCTabStripView = PCTabStripView;
var TabButton = /** @class */ (function (_super) {
    __extends(TabButton, _super);
    function TabButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabButton.prototype.srender = function (_a) {
        var m = _a.model, t = _a.tab, ctrl = _a.ctrl, active = _a.active;
        return (React.createElement("button", { className: cx("tab-btn", { "tab-btn-active": active }), onClick: eventWrappers_1.noDefault(function () { return m.FlipToTab(t); }) }, ctrl.renderTabButtonContents(t)));
    };
    return TabButton;
}(supercritical_1.SuperCriticalComponent));
var TitledTabContentsController = /** @class */ (function () {
    function TitledTabContentsController() {
    }
    TitledTabContentsController.prototype.renderBackToFrontLinkContents = function (frontTab) {
        return React.createElement("span", null,
            React.createElement("span", { className: "fa fa-arrow-left" }),
            " back to ",
            frontTab.Title);
    };
    return TitledTabContentsController;
}());
exports.TitledTabContentsController = TitledTabContentsController;
var PCTabContents = /** @class */ (function (_super) {
    __extends(PCTabContents, _super);
    function PCTabContents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PCTabContents.prototype.srender = function (_a) {
        var m = _a.model, ctrl = _a.ctrl;
        var s = m.State();
        return (React.createElement("div", { className: "pctabcontents" },
            React.createElement("div", { className: cx('flip-container', {
                    flipping: s.state === 'flipping-to-back' || s.state === 'flipping-to-front',
                    'reverse-flip': s.state === 'flipping-to-front'
                }) },
                s.state !== 'settled-on-back' &&
                    React.createElement("div", { className: "flip-face-front" }, ctrl.renderTabContents(m.FrontTab)),
                s.state !== 'settled-on-front' &&
                    React.createElement("div", { className: "flip-face-back" },
                        React.createElement("div", { className: "back-to-front-shell" },
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.FlipToTab(m.FrontTab); }) }, ctrl.renderBackToFrontLinkContents(m.FrontTab))),
                        React.createElement("div", null, ctrl.renderTabContents(s.state === 'flipping-to-back' ? s.toTab :
                            s.state === 'flipping-to-front' ? s.fromTab :
                                s.tab))))));
    };
    return PCTabContents;
}(supercritical_1.SuperCriticalComponent));
exports.PCTabContents = PCTabContents;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFileView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(549);
var view_1 = __webpack_require__(22);
exports.UploadFileView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "uploadfile" },
        React.createElement("input", { type: "file", className: "uploadfile-file-input", key: m.FileInputId(), id: m.FileInputId(), accept: m.AllowedExtensions(), onChange: function (e) { return m.UploadFile(e.target.files[0]); } }),
        React.createElement(ValidationModal, { model: m }));
});
var ValidationModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.PCModal, { className: "validationmodal", shown: function () { return !!(m.Validation()['ImageSize'] || m.Validation()['InvalidExtension'] || m.Validation()['FileTooBig']); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body" },
                React.createElement("div", { className: "clearfix" },
                    React.createElement("div", null, ['ImageSize', model_1.INVALID_EXTENSION, model_1.FILE_TOO_BIG].map(function (errorKey) {
                        return m.Validation()[errorKey] &&
                            React.createElement("span", { key: errorKey }, m.Validation()[errorKey].ErrorText);
                    })),
                    React.createElement("div", { className: "actions-container" },
                        React.createElement("button", { className: "pc-button pc-button-primary", onClick: m.ResetValidation }, "OK"))))));
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1403), exports);


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coordination = void 0;
var Coordination_1 = __webpack_require__(615);
var CoordinationLocationType_1 = __webpack_require__(606);
__exportStar(__webpack_require__(615), exports);
var Coordination = /** @class */ (function (_super) {
    __extends(Coordination, _super);
    function Coordination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for Coordinations. */
    Coordination.DisplayOrder = function (c1, c2) {
        var cmp;
        return (cmp = c1.DisplayOrder() - c2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            c1.Id() - c2.Id() :
            cmp;
    };
    // NOTE: AppliesToScheduleDate and all the various MatchesOn... methods are all mirrored in C# in
    // PortCall.Models\CoordinationCards\Coordination.cs. Keep in sync.
    Coordination.prototype.AppliesToScheduleDate = function (scheduleDate) {
        return (this.MatchesOnMilestoneType(scheduleDate) &&
            this.MatchesOnLocation(scheduleDate));
    };
    Coordination.prototype.MatchesOnMilestoneType = function (scheduleDate) {
        return this.MilestoneTypes().some(function (mt) { return scheduleDate.MilestoneTypeId() === mt.MilestoneTypeId(); });
    };
    Coordination.prototype.MatchesOnLocation = function (scheduleDate) {
        return (this.MatchesOnMainLocation(scheduleDate) &&
            this.MatchesOnRelatedLocation(scheduleDate));
    };
    Coordination.prototype.MatchesOnMainLocation = function (scheduleDate) {
        if (this.IsScopedByMainLocation()) {
            var loc_1 = scheduleDate.CoordinationsMainLocation();
            return !!loc_1 && this.Locations().some(function (cl) { return cl.Type() === CoordinationLocationType_1.CoordinationLocationType.Main && cl.LocationId() === loc_1.Id(); });
        }
        else {
            return true;
        }
    };
    Coordination.prototype.MatchesOnRelatedLocation = function (scheduleDate) {
        if (this.IsScopedByRelatedLocation()) {
            var loc_2 = scheduleDate.CoordinationsRelatedLocation();
            return !!loc_2 && this.Locations().some(function (cl) { return cl.Type() === CoordinationLocationType_1.CoordinationLocationType.Related && cl.LocationId() === loc_2.Id(); });
        }
        else {
            return true;
        }
    };
    Coordination.prototype.EffectiveStatusLabel = function (status) {
        var _a, _b;
        return (_b = (_a = this.AltStatusLabels().find(function (l) { return l.Status() === status; })) === null || _a === void 0 ? void 0 : _a.Label()) !== null && _b !== void 0 ? _b : status.DefaultLabel();
    };
    return Coordination;
}(Coordination_1.Coordination));
exports.Coordination = Coordination;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationProvider = void 0;
var CoordinationProvider_1 = __webpack_require__(618);
__exportStar(__webpack_require__(618), exports);
var CoordinationProvider = /** @class */ (function (_super) {
    __extends(CoordinationProvider, _super);
    function CoordinationProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for two CoordinationProviders belonging to the same Coordination. */
    // NOTE: Keep in sync with PortCall.Models\CoordinationCards\CoordinationProvider.cs (search
    // "DisplayOrderExtensions").
    CoordinationProvider.DisplayOrder = function (p1, p2) {
        var cmp;
        return (cmp = p1.DisplayOrder() - p2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to ProviderId for a deterministic sort.
            p1.ProviderId() - p2.ProviderId() :
            cmp;
    };
    return CoordinationProvider;
}(CoordinationProvider_1.CoordinationProvider));
exports.CoordinationProvider = CoordinationProvider;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Utilities related to our entity version's ...VersionExtraData and ...DataSnapshot types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIfNonNull = void 0;
/**** PARSING ExtraDataJSON ****/
/**
 * JSON parse the provided `json` and cast as the given `TOutput` type, unless the `json` is
 * `null`, in which case return `null`.
 */
function parseIfNonNull(json) {
    return json === null ? null : JSON.parse(json);
}
exports.parseIfNonNull = parseIfNonNull;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1604), exports);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mutex = void 0;
var Promise = __webpack_require__(41);
// Symbols for use w/in this module only
var MUTEX_CURRENT_GUARD = Symbol('mutexCurrentGuard'), MUTEX_RELEASE = Symbol('mutexRelease');
/**
 * A mutually exclusive lock for synchronizing concurrent async actions. E.g., say your UI can trigger two kinds
 * of network requests, either request A or request B, but you wanna make sure to avoid sending a request of
 * either type until all requests of the other type have received a response. This utility can help manage that.
 */
var Mutex = /** @class */ (function () {
    function Mutex() {
        // Queue of waiting consumers
        this.waiting = [];
        this[_a] = null;
    }
    // TODO: Could switch from taking a timeout as a param to taking something like a cancellation token, to
    // support aborting the wait for reasons other than a timeout expiring. But the timeout-based API should be
    // plenty for now.
    /**
     * Acquire the @see Mutex, returning a promise that resolves with a @see MutexGuard either on the next tick
     * of the event loop (if the @see Mutex is not being held by any other consumers) or when the @see Mutex
     * is released (if the @see Mutex is currently being held by another consumer).
     * @param timeoutMs An optional timeout after which to give up waiting to acquire the @see Mutex. If this
     * timeout is reached before the @see Mutex can be acquired, then the returned promise is rejected with a
     * standard JS error object. Omitting the timeout or passing undefined means "no timeout", i.e. the returned
     * promise will never be rejected but may stay unresolved indefinitely.
     */
    Mutex.prototype.acquire = function (timeoutMs) {
        var _this = this;
        return this[MUTEX_CURRENT_GUARD] ?
            new Promise(function (resolve, reject) { return _this.waiting.push(new WaitingConsumer(resolve, reject, timeoutMs)); }) :
            Promise.resolve(new Guard(this));
    };
    Mutex.prototype[(_a = MUTEX_CURRENT_GUARD, MUTEX_RELEASE)] = function () {
        this[MUTEX_CURRENT_GUARD] = null;
        var waiting;
        do {
            waiting = this.waiting.shift();
        } while (waiting === null || waiting === void 0 ? void 0 : waiting.hasGivenUp);
        waiting === null || waiting === void 0 ? void 0 : waiting.resolve(new Guard(this));
    };
    return Mutex;
}());
exports.Mutex = Mutex;
var Guard = /** @class */ (function () {
    function Guard(mutex) {
        this.mutex = mutex;
        mutex[MUTEX_CURRENT_GUARD] = this;
    }
    Guard.prototype.release = function () {
        var _b;
        if (((_b = this.mutex) === null || _b === void 0 ? void 0 : _b[MUTEX_CURRENT_GUARD]) === this) {
            this.mutex[MUTEX_RELEASE]();
            this.mutex = null;
        }
    };
    return Guard;
}());
var WaitingConsumer = /** @class */ (function () {
    function WaitingConsumer(resolve, reject, timeoutMs) {
        var _this = this;
        this.hasGivenUp = false;
        this._resolve = resolve;
        this._reject = reject;
        this.timeoutId = timeoutMs === undefined ? undefined : setTimeout(function () { return _this.giveUp(); }, timeoutMs);
    }
    WaitingConsumer.prototype.resolve = function (guard) {
        this._resolve.call(null, guard);
        clearTimeout(this.timeoutId);
        this._resolve = null;
        this._reject = null;
    };
    WaitingConsumer.prototype.giveUp = function () {
        this.hasGivenUp = true;
        this._reject.call(null, new Error("Mutex could not be acquired within the specified timeout."));
        this._resolve = null;
        this._reject = null;
    };
    return WaitingConsumer;
}());


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCurrencys = exports.CoordinationCurrencyDisplayName = exports.CoordinationCurrency = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationCurrency.cs
var CoordinationCurrency;
(function (CoordinationCurrency) {
    CoordinationCurrency[CoordinationCurrency["Current"] = 0] = "Current";
    CoordinationCurrency[CoordinationCurrency["Deprecated"] = 10] = "Deprecated";
})(CoordinationCurrency = exports.CoordinationCurrency || (exports.CoordinationCurrency = {}));
exports.CoordinationCurrencyDisplayName = {
    0: 'Current',
    10: 'Deprecated'
};
exports.CoordinationCurrencys = [
    { Id: CoordinationCurrency.Current, Name: 'Current' },
    { Id: CoordinationCurrency.Deprecated, Name: 'Deprecated' }
];


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationProviderCurrencys = exports.CoordinationProviderCurrencyDisplayName = exports.CoordinationProviderCurrency = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationProviderCurrency.cs
var CoordinationProviderCurrency;
(function (CoordinationProviderCurrency) {
    CoordinationProviderCurrency[CoordinationProviderCurrency["Current"] = 0] = "Current";
    CoordinationProviderCurrency[CoordinationProviderCurrency["Deprecated"] = 10] = "Deprecated";
})(CoordinationProviderCurrency = exports.CoordinationProviderCurrency || (exports.CoordinationProviderCurrency = {}));
exports.CoordinationProviderCurrencyDisplayName = {
    0: 'Current',
    10: 'Deprecated'
};
exports.CoordinationProviderCurrencys = [
    { Id: CoordinationProviderCurrency.Current, Name: 'Current' },
    { Id: CoordinationProviderCurrency.Deprecated, Name: 'Deprecated' }
];


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboardTabs = exports.DispatchDashboardTabDisplayName = exports.DispatchDashboardTab = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchDashboardController.cs
var DispatchDashboardTab;
(function (DispatchDashboardTab) {
    DispatchDashboardTab[DispatchDashboardTab["New"] = 0] = "New";
    DispatchDashboardTab[DispatchDashboardTab["Movements"] = 1] = "Movements";
    DispatchDashboardTab[DispatchDashboardTab["Search"] = 2] = "Search";
    DispatchDashboardTab[DispatchDashboardTab["BillingWorklist"] = 3] = "BillingWorklist";
})(DispatchDashboardTab = exports.DispatchDashboardTab || (exports.DispatchDashboardTab = {}));
exports.DispatchDashboardTabDisplayName = {
    0: 'New',
    1: 'Movements',
    2: 'Search',
    3: 'BillingWorklist'
};
exports.DispatchDashboardTabs = [
    { Id: DispatchDashboardTab.New, Name: 'New' },
    { Id: DispatchDashboardTab.Movements, Name: 'Movements' },
    { Id: DispatchDashboardTab.Search, Name: 'Search' },
    { Id: DispatchDashboardTab.BillingWorklist, Name: 'BillingWorklist' }
];


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberKinds = exports.PhoneNumberKindDisplayName = exports.PhoneNumberKind = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Users\PhoneNumber.cs
var PhoneNumberKind;
(function (PhoneNumberKind) {
    PhoneNumberKind[PhoneNumberKind["Office"] = 0] = "Office";
    PhoneNumberKind[PhoneNumberKind["Mobile"] = 10] = "Mobile";
    PhoneNumberKind[PhoneNumberKind["Fax"] = 20] = "Fax";
    PhoneNumberKind[PhoneNumberKind["Home"] = 30] = "Home";
    PhoneNumberKind[PhoneNumberKind["TwentyFourSeven"] = 31] = "TwentyFourSeven";
    PhoneNumberKind[PhoneNumberKind["Other"] = 40] = "Other";
})(PhoneNumberKind = exports.PhoneNumberKind || (exports.PhoneNumberKind = {}));
exports.PhoneNumberKindDisplayName = {
    0: 'Office',
    10: 'Mobile',
    20: 'Fax',
    30: 'Home',
    31: '24/7',
    40: 'Other'
};
exports.PhoneNumberKinds = [
    { Id: PhoneNumberKind.Office, Name: 'Office' },
    { Id: PhoneNumberKind.Mobile, Name: 'Mobile' },
    { Id: PhoneNumberKind.Fax, Name: 'Fax' },
    { Id: PhoneNumberKind.Home, Name: 'Home' },
    { Id: PhoneNumberKind.TwentyFourSeven, Name: '24/7' },
    { Id: PhoneNumberKind.Other, Name: 'Other' }
];


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallChangeTypes = exports.PortCallChangeTypeDisplayName = exports.PortCallChangeType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\PortCallChange\ApiPortCallChange.cs
var PortCallChangeType;
(function (PortCallChangeType) {
    PortCallChangeType[PortCallChangeType["Berth"] = 1] = "Berth";
    PortCallChangeType[PortCallChangeType["LineTime"] = 2] = "LineTime";
    PortCallChangeType[PortCallChangeType["Vessel"] = 3] = "Vessel";
    PortCallChangeType[PortCallChangeType["LineTimeActual"] = 4] = "LineTimeActual";
    PortCallChangeType[PortCallChangeType["AttendingAgent"] = 5] = "AttendingAgent";
    PortCallChangeType[PortCallChangeType["Footmark"] = 6] = "Footmark";
    PortCallChangeType[PortCallChangeType["InvitedEditor"] = 7] = "InvitedEditor";
    PortCallChangeType[PortCallChangeType["ShiftAdded"] = 8] = "ShiftAdded";
    PortCallChangeType[PortCallChangeType["ReservationStatus"] = 9] = "ReservationStatus";
    PortCallChangeType[PortCallChangeType["Watcher"] = 10] = "Watcher";
    PortCallChangeType[PortCallChangeType["Creation"] = 11] = "Creation";
    PortCallChangeType[PortCallChangeType["SideTo"] = 12] = "SideTo";
    PortCallChangeType[PortCallChangeType["Barge"] = 13] = "Barge";
    PortCallChangeType[PortCallChangeType["Berth_DEPRECATED_20170306"] = 14] = "Berth_DEPRECATED_20170306";
    PortCallChangeType[PortCallChangeType["LineTime_DEPRECATED_20170308"] = 15] = "LineTime_DEPRECATED_20170308";
    PortCallChangeType[PortCallChangeType["Footmark_DEPRECATED_20170306"] = 16] = "Footmark_DEPRECATED_20170306";
    PortCallChangeType[PortCallChangeType["Creation_DEPRECATED_20170302"] = 17] = "Creation_DEPRECATED_20170302";
    PortCallChangeType[PortCallChangeType["ApprovalCard_DEPRECATED_20161125"] = 18] = "ApprovalCard_DEPRECATED_20161125";
    PortCallChangeType[PortCallChangeType["ShiftAdded_DEPRECATED_20161117"] = 19] = "ShiftAdded_DEPRECATED_20161117";
    PortCallChangeType[PortCallChangeType["ReservationStatus_DEPRECATED_20161117"] = 20] = "ReservationStatus_DEPRECATED_20161117";
    PortCallChangeType[PortCallChangeType["SideTo_DEPRECATED_20170306"] = 21] = "SideTo_DEPRECATED_20170306";
    PortCallChangeType[PortCallChangeType["Schedule"] = 22] = "Schedule";
})(PortCallChangeType = exports.PortCallChangeType || (exports.PortCallChangeType = {}));
exports.PortCallChangeTypeDisplayName = {
    1: 'Berth',
    2: 'LineTime',
    3: 'Vessel',
    4: 'LineTimeActual',
    5: 'AttendingAgent',
    6: 'Footmark',
    7: 'InvitedEditor',
    8: 'ShiftAdded',
    9: 'ReservationStatus',
    10: 'Watcher',
    11: 'Creation',
    12: 'SideTo',
    13: 'Barge',
    14: 'Berth_DEPRECATED_20170306',
    15: 'LineTime_DEPRECATED_20170308',
    16: 'Footmark_DEPRECATED_20170306',
    17: 'Creation_DEPRECATED_20170302',
    18: 'ApprovalCard_DEPRECATED_20161125',
    19: 'ShiftAdded_DEPRECATED_20161117',
    20: 'ReservationStatus_DEPRECATED_20161117',
    21: 'SideTo_DEPRECATED_20170306',
    22: 'Schedule'
};
exports.PortCallChangeTypes = [
    { Id: PortCallChangeType.Berth, Name: 'Berth' },
    { Id: PortCallChangeType.LineTime, Name: 'LineTime' },
    { Id: PortCallChangeType.Vessel, Name: 'Vessel' },
    { Id: PortCallChangeType.LineTimeActual, Name: 'LineTimeActual' },
    { Id: PortCallChangeType.AttendingAgent, Name: 'AttendingAgent' },
    { Id: PortCallChangeType.Footmark, Name: 'Footmark' },
    { Id: PortCallChangeType.InvitedEditor, Name: 'InvitedEditor' },
    { Id: PortCallChangeType.ShiftAdded, Name: 'ShiftAdded' },
    { Id: PortCallChangeType.ReservationStatus, Name: 'ReservationStatus' },
    { Id: PortCallChangeType.Watcher, Name: 'Watcher' },
    { Id: PortCallChangeType.Creation, Name: 'Creation' },
    { Id: PortCallChangeType.SideTo, Name: 'SideTo' },
    { Id: PortCallChangeType.Barge, Name: 'Barge' },
    { Id: PortCallChangeType.Berth_DEPRECATED_20170306, Name: 'Berth_DEPRECATED_20170306' },
    { Id: PortCallChangeType.LineTime_DEPRECATED_20170308, Name: 'LineTime_DEPRECATED_20170308' },
    { Id: PortCallChangeType.Footmark_DEPRECATED_20170306, Name: 'Footmark_DEPRECATED_20170306' },
    { Id: PortCallChangeType.Creation_DEPRECATED_20170302, Name: 'Creation_DEPRECATED_20170302' },
    { Id: PortCallChangeType.ApprovalCard_DEPRECATED_20161125, Name: 'ApprovalCard_DEPRECATED_20161125' },
    { Id: PortCallChangeType.ShiftAdded_DEPRECATED_20161117, Name: 'ShiftAdded_DEPRECATED_20161117' },
    { Id: PortCallChangeType.ReservationStatus_DEPRECATED_20161117, Name: 'ReservationStatus_DEPRECATED_20161117' },
    { Id: PortCallChangeType.SideTo_DEPRECATED_20170306, Name: 'SideTo_DEPRECATED_20170306' },
    { Id: PortCallChangeType.Schedule, Name: 'Schedule' }
];


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardQuestionTypes = exports.TopicCardQuestionTypeDisplayName = exports.TopicCardQuestionType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\TopicCards\TopicCardTemplate.cs
var TopicCardQuestionType;
(function (TopicCardQuestionType) {
    TopicCardQuestionType[TopicCardQuestionType["YesNo"] = 1] = "YesNo";
    TopicCardQuestionType[TopicCardQuestionType["MultipleChoice"] = 2] = "MultipleChoice";
})(TopicCardQuestionType = exports.TopicCardQuestionType || (exports.TopicCardQuestionType = {}));
exports.TopicCardQuestionTypeDisplayName = {
    1: 'YesNo',
    2: 'MultipleChoice'
};
exports.TopicCardQuestionTypes = [
    { Id: TopicCardQuestionType.YesNo, Name: 'YesNo' },
    { Id: TopicCardQuestionType.MultipleChoice, Name: 'MultipleChoice' }
];


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(102);
var toLength = __webpack_require__(32);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(645);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(26);
var createDesc = __webpack_require__(85);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var document = __webpack_require__(16).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(24)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(16).document;
module.exports = document && document.documentElement;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var setPrototypeOf = __webpack_require__(229).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(97);
var ITERATOR = __webpack_require__(24)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var macrotask = __webpack_require__(235).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(56)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(39);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(73);
var gOPS = __webpack_require__(177);
var pIE = __webpack_require__(140);
var toObject = __webpack_require__(36);
var IObject = __webpack_require__(139);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(99);
var gOPS = __webpack_require__(177);
var anObject = __webpack_require__(14);
var Reflect = __webpack_require__(16).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(14);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(53)(Function.call, __webpack_require__(48).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(180)('keys');
var uid = __webpack_require__(103);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(64);
var defined = __webpack_require__(62);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(172);
var defined = __webpack_require__(62);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(64);
var defined = __webpack_require__(62);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var invoke = __webpack_require__(219);
var html = __webpack_require__(217);
var cel = __webpack_require__(214);
var global = __webpack_require__(16);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(56)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(30);
var LIBRARY = __webpack_require__(98);
var $typed = __webpack_require__(182);
var hide = __webpack_require__(47);
var redefineAll = __webpack_require__(100);
var fails = __webpack_require__(19);
var anInstance = __webpack_require__(95);
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(32);
var toIndex = __webpack_require__(333);
var gOPN = __webpack_require__(99).f;
var dP = __webpack_require__(26).f;
var arrayFill = __webpack_require__(211);
var setToStringTag = __webpack_require__(119);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(98);
var wksExt = __webpack_require__(334);
var defineProperty = __webpack_require__(26).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(82);
var step = __webpack_require__(221);
var Iterators = __webpack_require__(97);
var toIObject = __webpack_require__(43);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(174)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Strength; });
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/
/**
 * @class Strength
 */
var Strength = /** @class */ (function () {
    function Strength() {
    }
    /**
     * Create a new symbolic strength.
     *
     * @param {Number} a strong
     * @param {Number} b medium
     * @param {Number} c weak
     * @param {Number} [w] weight
     * @return {Number} strength
    */
    Strength.create = function (a, b, c, w) {
        if (w === void 0) { w = 1.0; }
        var result = 0.0;
        result += Math.max(0.0, Math.min(1000.0, a * w)) * 1000000.0;
        result += Math.max(0.0, Math.min(1000.0, b * w)) * 1000.0;
        result += Math.max(0.0, Math.min(1000.0, c * w));
        return result;
    };
    /**
     * Clip a symbolic strength to the allowed min and max.
     * @private
     */
    Strength.clip = function (value) {
        return Math.max(0.0, Math.min(Strength.required, value));
    };
    /**
     * The 'required' symbolic strength.
     */
    Strength.required = Strength.create(1000.0, 1000.0, 1000.0);
    /**
     * The 'strong' symbolic strength.
     */
    Strength.strong = Strength.create(1.0, 0.0, 0.0);
    /**
     * The 'medium' symbolic strength.
     */
    Strength.medium = Strength.create(0.0, 1.0, 0.0);
    /**
     * The 'weak' symbolic strength.
     */
    Strength.weak = Strength.create(0.0, 0.0, 1.0);
    return Strength;
}());



/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Variable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expression__ = __webpack_require__(184);
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/

/**
 * The primary user constraint variable.
 *
 * @class
 * @param {String} [name=""] The name to associated with the variable.
 */
var Variable = /** @class */ (function () {
    function Variable(name) {
        if (name === void 0) { name = ""; }
        this._value = 0.0;
        this._context = null;
        this._id = VarId++;
        this._name = name;
    }
    /**
     * A static variable comparison function.
     * @private
     */
    Variable.Compare = function (a, b) {
        return a.id() - b.id();
    };
    /**
     * Returns the unique id number of the variable.
     * @private
     */
    Variable.prototype.id = function () {
        return this._id;
    };
    /**
     * Returns the name of the variable.
     *
     * @return {String} name of the variable
     */
    Variable.prototype.name = function () {
        return this._name;
    };
    /**
     * Set the name of the variable.
     *
     * @param {String} name Name of the variable
     */
    Variable.prototype.setName = function (name) {
        this._name = name;
    };
    /**
     * Returns the user context object of the variable.
     * @private
     */
    Variable.prototype.context = function () {
        return this._context;
    };
    /**
     * Set the user context object of the variable.
     * @private
     */
    Variable.prototype.setContext = function (context) {
        this._context = context;
    };
    /**
     * Returns the value of the variable.
     *
     * @return {Number} Calculated value
     */
    Variable.prototype.value = function () {
        return this._value;
    };
    /**
     * Set the value of the variable.
     * @private
     */
    Variable.prototype.setValue = function (value) {
        this._value = value;
    };
    /**
     * Creates a new Expression by adding a number, variable or expression
     * to the variable.
     *
     * @param {Number|Variable|Expression} value Value to add.
     * @return {Expression} expression
     */
    Variable.prototype.plus = function (value) {
        return new __WEBPACK_IMPORTED_MODULE_0__expression__["a" /* Expression */](this, value);
    };
    /**
     * Creates a new Expression by substracting a number, variable or expression
     * from the variable.
     *
     * @param {Number|Variable|Expression} value Value to substract.
     * @return {Expression} expression
     */
    Variable.prototype.minus = function (value) {
        return new __WEBPACK_IMPORTED_MODULE_0__expression__["a" /* Expression */](this, typeof value === "number" ? -value : [-1, value]);
    };
    /**
     * Creates a new Expression by multiplying with a fixed number.
     *
     * @param {Number} coefficient Coefficient to multiply with.
     * @return {Expression} expression
     */
    Variable.prototype.multiply = function (coefficient) {
        return new __WEBPACK_IMPORTED_MODULE_0__expression__["a" /* Expression */]([coefficient, this]);
    };
    /**
     * Creates a new Expression by dividing with a fixed number.
     *
     * @param {Number} coefficient Coefficient to divide by.
     * @return {Expression} expression
     */
    Variable.prototype.divide = function (coefficient) {
        return new __WEBPACK_IMPORTED_MODULE_0__expression__["a" /* Expression */]([1 / coefficient, this]);
    };
    /**
     * Returns the JSON representation of the variable.
     * @private
     */
    Variable.prototype.toJSON = function () {
        return {
            name: this._name,
            value: this._value,
        };
    };
    Variable.prototype.toString = function () {
        return this._context + "[" + this._name + ":" + this._value + "]";
    };
    return Variable;
}());

/**
 * The internal variable id counter.
 * @private
 */
var VarId = 0;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(142)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof modules === 'object' && module.exports) {
		// define a Common JS module that relies on 'leaflet'
		module.exports = factory(require('leaflet'));
	} else {
		// Assume Leaflet is loaded into global object L already
		factory(L);
	}
}(this, function (L) {
	'use strict';

	L.TileLayer.Provider = L.TileLayer.extend({
		initialize: function (arg, options) {
			var providers = L.TileLayer.Provider.providers;

			var parts = arg.split('.');

			var providerName = parts[0];
			var variantName = parts[1];

			if (!providers[providerName]) {
				throw 'No such provider (' + providerName + ')';
			}

			var provider = {
				url: providers[providerName].url,
				options: providers[providerName].options
			};

			// overwrite values in provider from variant.
			if (variantName && 'variants' in providers[providerName]) {
				if (!(variantName in providers[providerName].variants)) {
					throw 'No such variant of ' + providerName + ' (' + variantName + ')';
				}
				var variant = providers[providerName].variants[variantName];
				var variantOptions;
				if (typeof variant === 'string') {
					variantOptions = {
						variant: variant
					};
				} else {
					variantOptions = variant.options;
				}
				provider = {
					url: variant.url || provider.url,
					options: L.Util.extend({}, provider.options, variantOptions)
				};
			}

			var forceHTTP = window.location.protocol === 'file:' || provider.options.forceHTTP;
			if (provider.url.indexOf('//') === 0 && forceHTTP) {
				provider.url = 'http:' + provider.url;
			}

			// If retina option is set
			if (provider.options.retina) {
				// Check retina screen
				if (options.detectRetina && L.Browser.retina) {
					// The retina option will be active now
					// But we need to prevent Leaflet retina mode
					options.detectRetina = false;
				} else {
					// No retina, remove option
					provider.options.retina = '';
				}
			}

			// replace attribution placeholders with their values from toplevel provider attribution,
			// recursively
			var attributionReplacer = function (attr) {
				if (attr.indexOf('{attribution.') === -1) {
					return attr;
				}
				return attr.replace(/\{attribution.(\w*)\}/,
					function (match, attributionName) {
						return attributionReplacer(providers[attributionName].options.attribution);
					}
				);
			};
			provider.options.attribution = attributionReplacer(provider.options.attribution);

			// Compute final options combining provider options with any user overrides
			var layerOpts = L.Util.extend({}, provider.options, options);
			L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
		}
	});

	/**
	 * Definition of providers.
	 * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
	 */

	L.TileLayer.Provider.providers = {
		OpenStreetMap: {
			url: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			options: {
				maxZoom: 19,
				attribution:
					'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			},
			variants: {
				Mapnik: {},
				BlackAndWhite: {
					url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
					options: {
						maxZoom: 18
					}
				},
				DE: {
					url: '//{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png',
					options: {
						maxZoom: 18
					}
				},
				France: {
					url: '//{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
					options: {
						maxZoom: 20,
						attribution: '&copy; Openstreetmap France | {attribution.OpenStreetMap}'
					}
				},
				HOT: {
					url: '//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
					options: {
						attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
					}
				},
				BZH: {
					url: 'http://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
					options: {
						attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
						bounds: [[46.2, -5.5], [50, 0.7]]
					}
				}
			}
		},
		OpenSeaMap: {
			url: 'http://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
			options: {
				attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
			}
		},
		OpenTopoMap: {
			url: '//{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
			options: {
				maxZoom: 17,
				attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
			}
		},
		Thunderforest: {
			url: '//{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
			options: {
				attribution:
					'&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
				variant: 'cycle',
				apikey: '<insert your api key here>',
				maxZoom: 22
			},
			variants: {
				OpenCycleMap: 'cycle',
				Transport: {
					options: {
						variant: 'transport'
					}
				},
				TransportDark: {
					options: {
						variant: 'transport-dark'
					}
				},
				SpinalMap: {
					options: {
						variant: 'spinal-map'
					}
				},
				Landscape: 'landscape',
				Outdoors: 'outdoors',
				Pioneer: 'pioneer'
			}
		},
		OpenMapSurfer: {
			url: 'http://korona.geog.uni-heidelberg.de/tiles/{variant}/x={x}&y={y}&z={z}',
			options: {
				maxZoom: 20,
				variant: 'roads',
				attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> &mdash; Map data {attribution.OpenStreetMap}'
			},
			variants: {
				Roads: 'roads',
				AdminBounds: {
					options: {
						variant: 'adminb',
						maxZoom: 19
					}
				},
				Grayscale: {
					options: {
						variant: 'roadsg',
						maxZoom: 19
					}
				}
			}
		},
		Hydda: {
			url: '//{s}.tile.openstreetmap.se/hydda/{variant}/{z}/{x}/{y}.png',
			options: {
				maxZoom: 18,
				variant: 'full',
				attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data {attribution.OpenStreetMap}'
			},
			variants: {
				Full: 'full',
				Base: 'base',
				RoadsAndLabels: 'roads_and_labels'
			}
		},
		MapBox: {
			url: '//api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}',
			options: {
				attribution:
					'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' +
					'Map data {attribution.OpenStreetMap}',
				subdomains: 'abcd',
				id: 'streets',
				accessToken: '<insert your access token here>',
			}
		},
		Stamen: {
			url: '//stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}',
			options: {
				attribution:
					'Map tiles by <a href="http://stamen.com">Stamen Design</a>, ' +
					'<a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; ' +
					'Map data {attribution.OpenStreetMap}',
				subdomains: 'abcd',
				minZoom: 0,
				maxZoom: 20,
				variant: 'toner',
				ext: 'png'
			},
			variants: {
				Toner: 'toner',
				TonerBackground: 'toner-background',
				TonerHybrid: 'toner-hybrid',
				TonerLines: 'toner-lines',
				TonerLabels: 'toner-labels',
				TonerLite: 'toner-lite',
				Watercolor: {
					options: {
						variant: 'watercolor',
						minZoom: 1,
						maxZoom: 16
					}
				},
				Terrain: {
					options: {
						variant: 'terrain',
						minZoom: 0,
						maxZoom: 18
					}
				},
				TerrainBackground: {
					options: {
						variant: 'terrain-background',
						minZoom: 0,
						maxZoom: 18
					}
				},
				TopOSMRelief: {
					options: {
						variant: 'toposm-color-relief',
						ext: 'jpg',
						bounds: [[22, -132], [51, -56]]
					}
				},
				TopOSMFeatures: {
					options: {
						variant: 'toposm-features',
						bounds: [[22, -132], [51, -56]],
						opacity: 0.9
					}
				}
			}
		},
		Esri: {
			url: '//server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
			options: {
				variant: 'World_Street_Map',
				attribution: 'Tiles &copy; Esri'
			},
			variants: {
				WorldStreetMap: {
					options: {
						attribution:
							'{attribution.Esri} &mdash; ' +
							'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
					}
				},
				DeLorme: {
					options: {
						variant: 'Specialty/DeLorme_World_Base_Map',
						minZoom: 1,
						maxZoom: 11,
						attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
					}
				},
				WorldTopoMap: {
					options: {
						variant: 'World_Topo_Map',
						attribution:
							'{attribution.Esri} &mdash; ' +
							'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
					}
				},
				WorldImagery: {
					options: {
						variant: 'World_Imagery',
						attribution:
							'{attribution.Esri} &mdash; ' +
							'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
					}
				},
				WorldTerrain: {
					options: {
						variant: 'World_Terrain_Base',
						maxZoom: 13,
						attribution:
							'{attribution.Esri} &mdash; ' +
							'Source: USGS, Esri, TANA, DeLorme, and NPS'
					}
				},
				WorldShadedRelief: {
					options: {
						variant: 'World_Shaded_Relief',
						maxZoom: 13,
						attribution: '{attribution.Esri} &mdash; Source: Esri'
					}
				},
				WorldPhysical: {
					options: {
						variant: 'World_Physical_Map',
						maxZoom: 8,
						attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
					}
				},
				OceanBasemap: {
					options: {
						variant: 'Ocean_Basemap',
						maxZoom: 13,
						attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
					}
				},
				NatGeoWorldMap: {
					options: {
						variant: 'NatGeo_World_Map',
						maxZoom: 16,
						attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
					}
				},
				WorldGrayCanvas: {
					options: {
						variant: 'Canvas/World_Light_Gray_Base',
						maxZoom: 16,
						attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
					}
				}
			}
		},
		OpenWeatherMap: {
			url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png',
			options: {
				maxZoom: 19,
				attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
				opacity: 0.5
			},
			variants: {
				Clouds: 'clouds',
				CloudsClassic: 'clouds_cls',
				Precipitation: 'precipitation',
				PrecipitationClassic: 'precipitation_cls',
				Rain: 'rain',
				RainClassic: 'rain_cls',
				Pressure: 'pressure',
				PressureContour: 'pressure_cntr',
				Wind: 'wind',
				Temperature: 'temp',
				Snow: 'snow'
			}
		},
		HERE: {
			/*
			 * HERE maps, formerly Nokia maps.
			 * These basemaps are free, but you need an API key. Please sign up at
			 * http://developer.here.com/getting-started
			 *
			 * Note that the base urls contain '.cit' whichs is HERE's
			 * 'Customer Integration Testing' environment. Please remove for production
			 * envirionments.
			 */
			url:
				'//{s}.{base}.maps.cit.api.here.com/maptile/2.1/' +
				'{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
				'app_id={app_id}&app_code={app_code}&lg={language}',
			options: {
				attribution:
					'Map &copy; 1987-2014 <a href="http://developer.here.com">HERE</a>',
				subdomains: '1234',
				mapID: 'newest',
				'app_id': '<insert your app_id here>',
				'app_code': '<insert your app_code here>',
				base: 'base',
				variant: 'normal.day',
				maxZoom: 20,
				type: 'maptile',
				language: 'eng',
				format: 'png8',
				size: '256'
			},
			variants: {
				normalDay: 'normal.day',
				normalDayCustom: 'normal.day.custom',
				normalDayGrey: 'normal.day.grey',
				normalDayMobile: 'normal.day.mobile',
				normalDayGreyMobile: 'normal.day.grey.mobile',
				normalDayTransit: 'normal.day.transit',
				normalDayTransitMobile: 'normal.day.transit.mobile',
				normalNight: 'normal.night',
				normalNightMobile: 'normal.night.mobile',
				normalNightGrey: 'normal.night.grey',
				normalNightGreyMobile: 'normal.night.grey.mobile',

				basicMap: {
					options: {
						type: 'basetile'
					}
				},
				mapLabels: {
					options: {
						type: 'labeltile',
						format: 'png'
					}
				},
				trafficFlow: {
					options: {
						base: 'traffic',
						type: 'flowtile'
					}
				},
				carnavDayGrey: 'carnav.day.grey',
				hybridDay: {
					options: {
						base: 'aerial',
						variant: 'hybrid.day'
					}
				},
				hybridDayMobile: {
					options: {
						base: 'aerial',
						variant: 'hybrid.day.mobile'
					}
				},
				pedestrianDay: 'pedestrian.day',
				pedestrianNight: 'pedestrian.night',
				satelliteDay: {
					options: {
						base: 'aerial',
						variant: 'satellite.day'
					}
				},
				terrainDay: {
					options: {
						base: 'aerial',
						variant: 'terrain.day'
					}
				},
				terrainDayMobile: {
					options: {
						base: 'aerial',
						variant: 'terrain.day.mobile'
					}
				}
			}
		},
		FreeMapSK: {
			url: 'http://t{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
			options: {
				minZoom: 8,
				maxZoom: 16,
				subdomains: '1234',
				bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
				attribution:
					'{attribution.OpenStreetMap}, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
			}
		},
		MtbMap: {
			url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
			options: {
				attribution:
					'{attribution.OpenStreetMap} &amp; USGS'
			}
		},
		CartoDB: {
			url: 'http://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}.png',
			options: {
				attribution: '{attribution.OpenStreetMap} &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
				subdomains: 'abcd',
				maxZoom: 19,
				variant: 'light_all'
			},
			variants: {
				Positron: 'light_all',
				PositronNoLabels: 'light_nolabels',
				PositronOnlyLabels: 'light_only_labels',
				DarkMatter: 'dark_all',
				DarkMatterNoLabels: 'dark_nolabels',
				DarkMatterOnlyLabels: 'dark_only_labels'
			}
		},
		HikeBike: {
			url: 'http://{s}.tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
			options: {
				maxZoom: 19,
				attribution: '{attribution.OpenStreetMap}',
				variant: 'hikebike'
			},
			variants: {
				HikeBike: {},
				HillShading: {
					options: {
						maxZoom: 15,
						variant: 'hillshading'
					}
				}
			}
		},
		BasemapAT: {
			url: 'https://maps{s}.wien.gv.at/basemap/{variant}/normal/google3857/{z}/{y}/{x}.{format}',
			options: {
				maxZoom: 19,
				attribution: 'Datenquelle: <a href="www.basemap.at">basemap.at</a>',
				subdomains: ['', '1', '2', '3', '4'],
				format: 'png',
				bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
				variant: 'geolandbasemap'
			},
			variants: {
				basemap: {
					options: {
						maxZoom: 20, // currently only in Vienna
						variant: 'geolandbasemap'
					}
				},
				grau: 'bmapgrau',
				overlay: 'bmapoverlay',
				highdpi: {
					options: {
						variant: 'bmaphidpi',
						format: 'jpeg'
					}
				},
				orthofoto: {
					options: {
						maxZoom: 20, // currently only in Vienna
						variant: 'bmaporthofoto30cm',
						format: 'jpeg'
					}
				}
			}
		},
		nlmaps: {
			url: 'https://geodata.nationaalgeoregister.nl/tiles/service/wmts/{variant}/EPSG:3857/{z}/{x}/{y}.png',
			options: {
				minZoom: 6,
				maxZoom: 19,
				bounds: [[50.5, 3.25], [54, 7.6]],
				attribution: 'Kaartgegevens &copy; <a href="kadaster.nl">Kadaster</a>'
			},
			variants: {
				'standaard': 'brtachtergrondkaart',
				'pastel': 'brtachtergrondkaartpastel',
				'grijs': 'brtachtergrondkaartgrijs',
				'luchtfoto': {
					'url': 'https://geodata.nationaalgeoregister.nl/luchtfoto/rgb/wmts/1.0.0/2016_ortho25/EPSG:3857/{z}/{x}/{y}.png',
				}
			}
		},
		NASAGIBS: {
			url: '//map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
			options: {
				attribution:
					'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' +
					'(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
				bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
				minZoom: 1,
				maxZoom: 9,
				format: 'jpg',
				time: '',
				tilematrixset: 'GoogleMapsCompatible_Level'
			},
			variants: {
				ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
				ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
				ViirsEarthAtNight2012: {
					options: {
						variant: 'VIIRS_CityLights_2012',
						maxZoom: 8
					}
				},
				ModisTerraLSTDay: {
					options: {
						variant: 'MODIS_Terra_Land_Surface_Temp_Day',
						format: 'png',
						maxZoom: 7,
						opacity: 0.75
					}
				},
				ModisTerraSnowCover: {
					options: {
						variant: 'MODIS_Terra_Snow_Cover',
						format: 'png',
						maxZoom: 8,
						opacity: 0.75
					}
				},
				ModisTerraAOD: {
					options: {
						variant: 'MODIS_Terra_Aerosol',
						format: 'png',
						maxZoom: 6,
						opacity: 0.75
					}
				},
				ModisTerraChlorophyll: {
					options: {
						variant: 'MODIS_Terra_Chlorophyll_A',
						format: 'png',
						maxZoom: 7,
						opacity: 0.75
					}
				}
			}
		},
		NLS: {
			// NLS maps are copyright National library of Scotland.
			// http://maps.nls.uk/projects/api/index.html
			// Please contact NLS for anything other than non-commercial low volume usage
			//
			// Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
			//   z0-9  - 1:1m
			//  z10-11 - quarter inch (1:253440)
			//  z12-18 - one inch (1:63360)
			url: '//nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
			options: {
				attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
				bounds: [[49.6, -12], [61.7, 3]],
				minZoom: 1,
				maxZoom: 18,
				subdomains: '0123',
			}
		},
		JusticeMap: {
			// Justice Map (http://www.justicemap.org/)
			// Visualize race and income data for your community, county and country.
			// Includes tools for data journalists, bloggers and community activists.
			url: 'http://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
			options: {
				attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
				// one of 'county', 'tract', 'block'
				size: 'county',
				// Bounds for USA, including Alaska and Hawaii
				bounds: [[14, -180], [72, -56]]
			},
			variants: {
				income: 'income',
				americanIndian: 'indian',
				asian: 'asian',
				black: 'black',
				hispanic: 'hispanic',
				multi: 'multi',
				nonWhite: 'nonwhite',
				white: 'white',
				plurality: 'plural'
			}
		}
	};

	L.tileLayer.provider = function (provider, options) {
		return new L.TileLayer.Provider(provider, options);
	};

	return L;
}));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(123);
var Danger = __webpack_require__(894);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(59);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(252);
var setInnerHTML = __webpack_require__(189);
var setTextContent = __webpack_require__(486);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactErrorUtils = __webpack_require__(250);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactPropTypesSecret = __webpack_require__(923);
var propTypesFactory = __webpack_require__(466);

var React = __webpack_require__(126);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(76);
var ReactInstanceMap = __webpack_require__(146);
var ReactInstrumentation = __webpack_require__(59);
var ReactUpdates = __webpack_require__(66);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var emptyFunction = __webpack_require__(58);
var warning = __webpack_require__(20);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.agentRestrictionErrors = exports.AGENT_RESTRICTIONS_VALIDATION_PREFIX = void 0;
var validationWatcher_1 = __webpack_require__(23);
// Keep in sync w/ server-side value in PortCall.EndPoints\Infra\AgentRestrictions\AgentRestrictionConstants.cs
exports.AGENT_RESTRICTIONS_VALIDATION_PREFIX = "agent-restriction-";
/**
 * Filter an errors dictionary to just errors representing violations of agent restrictions.
 */
function agentRestrictionErrors(errors) {
    return validationWatcher_1.filterErrors(errors, function (key) { return key.indexOf(exports.AGENT_RESTRICTIONS_VALIDATION_PREFIX) === 0; });
}
exports.agentRestrictionErrors = agentRestrictionErrors;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadDataUri = exports.downloadData = void 0;
/**
 * Trigger download of a Blob of data.
 * @param data The data as a Blob
 * @param filename (optional) The suggested filename (browsers may allow users to select a different filename)
 */
function downloadData(data, filename) {
    var a = document.createElement('a'), url = URL.createObjectURL(data);
    a.href = url;
    a.download = filename || 'attachment';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
exports.downloadData = downloadData;
// TH 05/05/2017 -- Inspired by http://stackoverflow.com/a/37068362
/**
 * Trigger download of a data URI.
 * @deprcated Data URIs have length restrictions on some browsers (notably Chrome).
 * For more reliable support of large data, use `downloadData` instead.
 * @param dataUri The data to download as a data URI
 * @param filename (optional) The suggested filename (browsers may allow users to select a different filename)
 */
function downloadDataUri(dataUri, filename) {
    var a = document.createElement('a');
    a.href = dataUri;
    a.target = '_blank';
    a.download = filename || 'attachment';
    document.body.appendChild(a);
    a.click();
    // TH 05/09/2017 -- Alternative routine for firing the click event.
    // Might have better browser coverage?
    // TODO -- Cross-browser testing.
    //
    // const evt = document.createEvent('Event');
    // evt.initEvent('click', true, true);
    // a.dispatchEvent(evt);
    document.body.removeChild(a);
}
exports.downloadDataUri = downloadDataUri;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fileNameFromUrl = void 0;
function fileNameFromUrl(url) {
    var segments = url.split('/');
    return decodeURIComponent(segments[segments.length - 1]);
}
exports.fileNameFromUrl = fileNameFromUrl;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboard = exports.internalDateFormat = exports.MAX_SEARCH_RESULTS_SHOWN = exports.INTERNAL_DATE_FORMAT = exports.ROLLING_EXPORT_HOURS = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var moment = __webpack_require__(6);
var _ = __webpack_require__(67);
var Promise = __webpack_require__(41);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var tzmoment_1 = __webpack_require__(9);
var pollster_1 = __webpack_require__(299);
var uniqueIndex_1 = __webpack_require__(70);
var UOM_1 = __webpack_require__(25);
var ConvertedMeasurement_1 = __webpack_require__(116);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var groupBy_1 = __webpack_require__(295);
var AcknowledgePilotJobOrdersRequest_1 = __webpack_require__(1217);
var DispatchDashboardTab_1 = __webpack_require__(207);
var Issue_1 = __webpack_require__(157);
var Issue_2 = __webpack_require__(135);
var IssueType_1 = __webpack_require__(112);
var ItineraryPoint_1 = __webpack_require__(69);
var BerthReservation_1 = __webpack_require__(38);
var csvExport_1 = __webpack_require__(149);
var routeParams_1 = __webpack_require__(77);
var routeParams_2 = __webpack_require__(87);
var csvExport_2 = __webpack_require__(983);
var DASHBOARD_REFRESH_SECONDS = 30;
// Length of time to show in the "Rolling" export option.
exports.ROLLING_EXPORT_HOURS = 12;
// TH 01/23/2017 -- Date format as a Momentjs template string.
// NOTE: This constant needs to agree w/ internalDateFormat below
exports.INTERNAL_DATE_FORMAT = 'YYYY-MM-DD';
// Max number of items to show in the browser UI in search/billing worklist tabs. We
// cap this to conserve browser memory (b/c rendering every DOM node can blow up memory
// for large searches).
exports.MAX_SEARCH_RESULTS_SHOWN = 700;
// TH: Using native Date methods instead of Momentjs to speed up indexing by date
function internalDateFormat(date) {
    return date.toJSON().substr(0, 10); // YYYY-MM-DD
}
exports.internalDateFormat = internalDateFormat;
// TH 04/12/2017 -- The name of this tab got changed from History to Search.
// But I'm still gonna leave this localStorage key as is to preserve any previously saved searches.
var filterStorageKey = 'portcall.dispatchdashboard.historical.filter';
;
function ColumnNames(settings) {
    return {
        MovementType: 'Type',
        EstimatedTime: 'Est.',
        ActualTime: 'Time',
        VesselName: 'Vessel',
        Location: 'Location',
        AgencyCode: 'Agent',
        GrossTonnage: 'Tonnage',
        Length: "Length (" + settings.DefaultLengthUOM() + ")",
        Beam: "Beam (" + settings.DefaultLengthUOM() + ")",
        DeepDraft: "Draft (" + settings.DefaultDepthUOM() + ")",
        TugCompany: 'Tug Co',
        SideTo: 'Side',
        Pilot: 'Pilot'
    };
}
function DispatchDashboard(loader, pjoLoader, pjoCache, ajax, entrypoints, data, tzutils, pierSettings, dateRangeSelectorModel, addDispatchEventModel, dispatchEventDetailsModel, addPilotJobOrderModel, pjoDetailsModel, pjoPrefsModel, params) {
    var initialLoad = true;
    var id = params.id, pjoId = params.pjoId, dispatchEventId = params.dispatchEventId, tab = params.tab, searchParams = params.tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || params.tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ?
        params.searchParams : null, dateRangeSelector = searchParams && dateRangeSelectorModel({
        range: searchParams.range,
        from: searchParams.from,
        to: searchParams.to,
        allowedRanges: tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ? [
            0 /* AllDates */,
            1 /* ThisWeek */,
            2 /* LastWeek */,
            3 /* ThisMonth */,
            4 /* LastMonth */,
            5 /* ThisYear */,
            6 /* LastYear */,
            7 /* Custom */
        ] : undefined
    }), filter = searchParams && s_js_1.default.data(searchParams.filter || localStorage[filterStorageKey] || ''), draftModelKey = s_js_1.default(function () { return ({
        Id: id,
        Tab: tab,
        From: dateRangeSelector && dateRangeSelector.FromDate().toJSON(),
        To: dateRangeSelector && dateRangeSelector.ToDate().toJSON(),
        // Convert empty filter to null to account for the fact that our WebAPI controller sees null when we pass it an empty
        // query string value.
        SearchQuery: filter && filter() ? filter() : null,
        // TH 10/20/2017 -- Seed navbar too, so it can load w/ default values as soon as possible
        Navbar: { Id: id }
    }); }), 
    // NOTE: Intentionally an S.data and NOT an S.value, so that setting the model key
    // always triggers a refresh of data, even w/ no change to its value.
    modelKey = s_js_1.default.data(s_js_1.default.sample(draftModelKey)), modelKeyDirty = function () {
        return draftModelKey().From !== modelKey().From ||
            draftModelKey().To !== modelKey().To ||
            draftModelKey().SearchQuery !== modelKey().SearchQuery;
    }, modelLoader = s_js_1.default(function () {
        var initial = initialLoad;
        initialLoad = false;
        // Just landing on page, we'll tolerate slightly stale data. But if user explicitly
        // triggers a search, we'll always send a new request.
        return loader(modelKey(), initial ? 30 : 0);
    }), model = function () { return modelLoader().model; }, 
    // TH 01/23/2017 -- Basing this on the modelLoader computation - desired effect is
    // that this triggers when the modelKey changes (i.e. when user changes date selection in historical mode)
    // but not when we poll in non-historical mode.
    modelLoading = function () { return modelLoader().loading(); }, pilotAgency = function () { return model().PilotAgency(); };
    // Store filter whenever user executes their new search
    filter && s_js_1.default.on(modelKey, function () {
        localStorage[filterStorageKey] = filter();
    });
    // Prevent searches that we think are overly broad and likely to crash the browser
    var searchSelectionIsInvalid = function () {
        return !!dateRangeSelector &&
            !!filter &&
            // Invalid if text filter is short or missing, and...
            filter().trim().length < 4 &&
            // ...selected date range > 1 yr (w/ a couple days forgiveness to allow leap
            // years plus general fuzziness).
            +dateRangeSelector.ToDate() - +dateRangeSelector.FromDate() > 367 * 24 * 60 * 60 * 1000;
    }, showInvalidSearchMsg = s_js_1.default.value(false);
    var selectedItemKey = s_js_1.default.data(pjoId ? { pjoId: pjoId } : dispatchEventId ? { dispatchEventId: dispatchEventId } : null);
    var showAddDispatchEventModal = s_js_1.default.data(false), dispatchEventsUrl = function () { return model().PilotAgency() && model().PilotAgency().DispatchEventsUrl() || ''; }, onAddDispatchEvent = function (event) { return s_js_1.default.freeze(function () {
        // TH 01/26/2017 -- The AddDispatchEvent component takes care of adding the new event
        // to the PCCache. But that still doesn't update the DispatchEvents collection in our model
        // b/c we use a QueryResultsRelationship. So we need to update that collection too.
        //
        // TH: 5/2/2016 -- This adds the new dispatch event to the page whether or not it fits
        // in the current date range (next two weeks for Movements view, range determined by dropdown and date inputs for History view).
        // Is that OK? Alternative would be to save the new DispatchEvent in the Db but not show it on the page if it isn't w/in the specified date range.
        //
        // TH 01/26/2017 -- One consequence is that if you add an event outside the specified date range for the page,
        // you'll only see it on the page till the next poll request, after which it'll fall off again...
        model().DispatchEvents.push(event);
        showAddDispatchEventModal(false);
    }); }, addDispatchEvent = s_js_1.default(function () { return showAddDispatchEventModal() ? addDispatchEventModel({
        url: dispatchEventsUrl,
        canManageBills: function () { return model().CanManageBills(); },
        onAddDispatchEvent: onAddDispatchEvent,
        onCancel: function () { return showAddDispatchEventModal(false); }
    }) : null; });
    var addPilotJobOrderPopupParams = s_js_1.default.value(null), addPilotJobOrder = s_js_1.default(function () {
        var params = addPilotJobOrderPopupParams();
        if (!params)
            return null;
        var from = params.from ? params.from : params.to ?
            tzmoment_1.tzmomentMod(tzutils, params.to, function (m) { return m.subtract(2, 'weeks'); }) :
            tzmoment_1.tzmomentMod(tzutils, tzutils.now(), function (m) { return m.startOf('day'); }), to = params.to ? params.to :
            tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.add(2, 'weeks'); });
        return addPilotJobOrderModel({
            pilotAgencyId: id,
            from: from,
            to: to,
            portCallId: params.portCallId || null,
            template: params.template,
            onAddPilotJobOrder: onAddPilotJobOrder,
            onCancel: function () { return addPilotJobOrderPopupParams(null); }
        });
    });
    var showRollingWindowOnly = s_js_1.default.data(false), 
    // TH 02/15/2017 -- Clock for updating the "Rolling 12 hours" export option in the Movements tab.
    // I figure every 60 secs is plenty often.
    // Also, we don't currently need a clock for this, since we only show the rolling
    // window for a split second (just long enough to call window.print).
    // But the clock puts us in good shape if we ever decide to turn the rolling
    // window into a toggleable view state.
    rollingClock = s_js_1.default(function () { return showRollingWindowOnly() ? tzutils.clock(60 * 1000) : null; });
    var showActionsMenu = s_js_1.default.data(false), agencyCodes = s_array_1.lift(function () { return pilotAgency() ? pilotAgency().AgencyCodes() : []; }), agencyCodesByOrg = uniqueIndex_1.default(agencyCodes, function (ac) { return ac.CodedOrganizationId(); }), organizationModel = function (org) { return OrganizationViewModel(org, agencyCodesByOrg); }, agentModel = function (u) { return AgentViewModel(u, organizationModel); }, vesselModel = function (v) { return VesselViewModel(v, pierSettings); }, portCallModel = function (pc) { return PortCallViewModel(pc, pierSettings, agentModel); };
    var pilotJobOrders = s_array_1.lift(function () { return model().JobOrders(); })
        .map(function (pjo) { return PilotJobOrderViewModel(pjo, ajax, data, pierSettings, portCallModel, ItineraryPointViewModel, vesselModel, pjoPrefsModel, selectedItemKey); }), dispatchEvents = s_array_1.lift(function () { return model().DispatchEvents(); })
        .map(function (de) { return DispatchEventViewModel(de, ajax, data, model, selectedItemKey); }), dispatchEventsById = uniqueIndex_1.default(dispatchEvents, function (de) { return de.Model.Id(); }), selectedDispatchEvent = s_js_1.default(function () {
        var key = selectedItemKey(), event = key && key.dispatchEventId ? dispatchEventsById(key.dispatchEventId)() : null;
        return event ? dispatchEventDetailsModel({
            event: event,
            canEdit: function () { return model().CanManageDispatchEvents(); },
            canManageBills: function () { return model().CanManageBills(); }
        }) : null;
    });
    var dashboardItems = pilotJobOrders
        .concat(dispatchEvents)
        .sort(dashboardItemOrder);
    // TH 05/16/2017 -- Roll items off of the BillingWorklist tab as user toggles Billable off or Approves for Export.
    // We could also filter for Pilot Complete and that Events are in the past here.
    // But we don't currently expect those to be the main actions for removing items from this tab.
    if (tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist)
        dashboardItems = dashboardItems
            .filter(function (item) { return item.Model.Billable() && item.Model.ApprovalOfCharges() === null; });
    dashboardItems = dashboardItems
        // TH 02/15/2017 -- Apply extra filter for "Rolling" print option.
        // Note that comparing dates as numbers (by using the + operator) is apparently a performance optimization in Chrome.
        // Was seeing "Not optimized: Unsupported non-primitive compare" when I compared dates directly.
        .filter(function (item) { return !rollingClock() ||
        (+item.DashboardSort.Date() < +tzmoment_1.tzmomentMod(tzutils, rollingClock().now(), function (m) { return m.add(exports.ROLLING_EXPORT_HOURS, 'hours'); })
            // aah 20171017 - don't include completed movements in rolling display
            && (item.ItemType === 'Event' || item.Model.End.Actual() === null)); });
    var displayedDashboardItems = s_array_1.lift(function () {
        return tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ?
            dashboardItems().slice(0, exports.MAX_SEARCH_RESULTS_SHOWN) :
            dashboardItems();
    });
    var resultSetIsTruncated = function () { return displayedDashboardItems().length < dashboardItems().length; };
    var dayViewModels = groupBy_1.groupBy(displayedDashboardItems, function (item) { return internalDateFormat(item.DashboardSort.Date()); })
        // NOTE: Even though we keep the dashboardItems collection above in sort order,
        // the groupBy call above does NOT guarantee that sort order will be preserved.
        // groupBy uses nonuniqueIndex internally, and nonuniqueIndex doesn't respond
        // to changes in the ordering of the input ArraySignal after it's been
        // initialized. So groupBy doesn't either. The problem shows up if you, say,
        // edit PJO dates after the page has loaded such that ordering of PJOs changes.
        // Hence why we re-sort again before passing to DashboardDayViewModel.
        .map(function (_a) {
        var date = _a.key, items = _a.items;
        return DashboardDayViewModel(date, items.sort(dashboardItemOrder));
    });
    var pjoFlip = params.pjoFlip;
    var canAcknowledgeIds = s_array_1.lift(function () { return model().CanAcknowledgeIds(); }), canAcknowledgeLookup = uniqueIndex_1.default(canAcknowledgeIds, function (_id) { return _id; }), canAcknowledgePJO = function (pjo) { return canAcknowledgeLookup(pjo.Id())() !== null; }, debouncedPjoLoader = _.debounce(function () {
        var pjoId = selectedItemKey() && selectedItemKey().pjoId;
        if (pjoId)
            pjoLoader({ Id: pjoId }, 30000);
        // TH 04/14/2017 -- For now, the overlapping PJO details popup is really only a concern
        // on the New tab. So don't make the other tabs pay a penalty.
    }, tab === DispatchDashboardTab_1.DispatchDashboardTab.New ? 500 : 0), pjoDetails = s_js_1.default(function () {
        var pjoId = selectedItemKey() && selectedItemKey().pjoId;
        if (pjoId) {
            var pjo_1 = data.PilotJobOrders.update1(null, { Id: pjoId }), serverPJODetails = pjoCache.PilotJobOrderDetailses.update1(null, { Id: pjoId });
            // aah 20171016: if this pjoId is for a deleted PJO, then pjo will be undefined, so return null
            if (pjo_1) {
                // TH 04/14/2017 -- W/ the Acknowledge workflow for new PJOs, I implemented a feature
                // where we auto select the next PJO in the list when a user hits Acknowledge.
                // It's a nice UX for quickly Acknowledging several PJOs, but it made it really easy
                // for users to send off a ton of overlapping requests to the PilotJobOrderDetails endpoint.
                // So... Moving request initiation for the PJO details popup up to the DDash so we can
                // put a debounce on it.
                debouncedPjoLoader();
                return pjoDetailsModel({
                    pjo: pjo_1,
                    model: serverPJODetails,
                    flip: pjoFlip,
                    onDelete: function () { return onDeletePilotJobOrder(pjo_1); },
                    onReorder: function () { return onReorderPilotJobOrder(pjo_1); },
                    onAddShift: onAddShift,
                    onAcknowledge: function () { return onAcknowledge(pjo_1); },
                    canAcknowledge: function () { return canAcknowledgePJO(pjo_1); },
                    corePermissions: function () { return model().CorePermissions(); }
                });
            }
            else {
                selectedItemKey(null);
            }
        }
        // TH 05/04/2017 -- The pjoFlip param only matters for the initial load of the dashboard.
        // Null it out after that so that we don't influence subsequent PJO popups.
        pjoFlip = null;
        return null;
    });
    var acknowledgementRequest = new AcknowledgePilotJobOrdersRequest_1.AcknowledgePilotJobOrdersRequest(), acknowledgementClient = ajax.Url(entrypoints.AcknowledgePilotJobOrders, { useCache: true }), 
    // TH 10/21/2017 -- A count of how many acknowledgement requests are either pending
    // (b/c the user has hit acknowledge and our debounce timer is running) or in flight.
    // B/c of how acknowledgement requests are serialized, we expect this to only ever be
    // 0, 1, or 2.
    pendingAckRequestCount = s_js_1.default.data(0);
    var oldAckIdCount = 0;
    s_js_1.default(function () {
        var newAckIdCount = acknowledgementRequest.PilotJobOrderIds().length;
        if (oldAckIdCount === 0 && newAckIdCount > 0) {
            // TH 10/21/2017 -- Increment pendingAckRequestCount as soon as we push an Id.
            pendingAckRequestCount(s_js_1.default.sample(pendingAckRequestCount) + 1);
        }
        oldAckIdCount = newAckIdCount;
    });
    // TH 04/17/2017 -- AutoSave PJO acknowledgements.
    // This has the effect of debouncing and serializing these requests.
    autoSave_1.AutoSaver(acknowledgementRequest.PilotJobOrderIds, function () {
        if (acknowledgementRequest.PilotJobOrderIds().length > 0) {
            var req = acknowledgementClient.Post(acknowledgementRequest);
            acknowledgementRequest.PilotJobOrderIds([]);
            // TH 10/21/2017 -- Decrement pendingAckRequestCount after we get a response.
            return req.then(function () { }).finally(function () { return pendingAckRequestCount(Math.max(pendingAckRequestCount() - 1, 0)); });
        }
        else {
            return Promise.resolve();
        }
    });
    var csvItems = dashboardItems.filter(function (i) { return i.ItemType === "PJO"; }), 
    // NOTE: A plain lambda and NOT an S(() => ...) computation. We'll only construct the
    // CSV payload when the user clicks the CSV export link. That makes that action slightly
    // slower, but avoids the memory and CPU overhead of keeping our CSV payload up-to-date
    // as data loads or is edited.
    csvData = function () { return csvExport_1.toCSVBlob(csvItems(), csvExport_2.CSVColumns(pierSettings)); };
    // TH 05/16/2017 -- Links for navigating to/from Billing Worklist.
    // My thought is to preserve as much of the current page filters as possible.
    // Update these whenever the user executes their new search.
    var viewBillingWorklistLink = s_js_1.default.on(modelKey, function () {
        var 
        // TH 05/16/2017 -- ThisMonth is default for Search tab, so we'll treat that as unset
        range = dateRangeSelector && dateRangeSelector.Range() !== 3 /* ThisMonth */ ?
            dateRangeSelector.Range() : undefined, fromDate = dateRangeSelector && dateRangeSelector.Range() === 7 /* Custom */ ?
            dateRangeSelector.FromDate() : undefined, toDate = dateRangeSelector && dateRangeSelector.Range() === 7 /* Custom */ ?
            dateRangeSelector.ToDate() : undefined, _filter = filter ? filter() : undefined;
        return "#!dispatchdashboard?id=" + id + "&tab=" + DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist
            + (range !== undefined ? "&range=" + routeParams_2.serializeDateRange(range) : '')
            + (fromDate !== undefined ? "&from=" + routeParams_1.serializeDate(fromDate) : '')
            + (toDate !== undefined ? "&to=" + routeParams_1.serializeDate(toDate) : '')
            + (_filter ? "&filter=" + encodeURIComponent(_filter) : '');
    }), backToFullSearchLink = tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ? s_js_1.default.on(modelKey, function () {
        var 
        // TH 05/16/2017 -- AllDates is default for BillingWorklist tab, so we'll treat that as unset.
        // It's also not a legal option for the Search tab.
        range = dateRangeSelector.Range() !== 0 /* AllDates */ ?
            dateRangeSelector.Range() : undefined, fromDate = dateRangeSelector.Range() === 7 /* Custom */ ?
            dateRangeSelector.FromDate() : undefined, toDate = dateRangeSelector.Range() === 7 /* Custom */ ?
            dateRangeSelector.ToDate() : undefined, _filter = filter();
        return "#!dispatchdashboard?id=" + id + "&tab=" + DispatchDashboardTab_1.DispatchDashboardTab.Search
            + (range !== undefined ? "&range=" + routeParams_2.serializeDateRange(range) : '')
            + (fromDate !== undefined ? "&from=" + routeParams_1.serializeDate(fromDate) : '')
            + (toDate !== undefined ? "&to=" + routeParams_1.serializeDate(toDate) : '')
            + (_filter ? "&filter=" + encodeURIComponent(_filter) : '');
    }) : null;
    var billingSystems = function () { return model().PilotAgency() && model().PilotAgency().Organization() ?
        model().PilotAgency().Organization().BillingSystems() : []; }, 
    // TH 05/09/2017 -- As in other spots, just assume there's at most one BillingSystem for now.
    billingSystem = s_js_1.default(function () { return billingSystems().length > 0 ? billingSystems()[0] : null; });
    // Start polling
    // UPDATE: 4/12/2017 -- But only poll in New and Movements tabs
    if (tab === DispatchDashboardTab_1.DispatchDashboardTab.New || tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements) {
        var pollster_2 = new pollster_1.Pollster(function () { return loader(modelKey()).task; }, DASHBOARD_REFRESH_SECONDS * 1000);
        // TH 05/04/2017 -- Pause polling while the PJO Details or Dispatch Event details are open.
        // This is to minimize the possibility of race conditions from editing data while polling for
        // the same data. This problem is better than it used to be since AH's change to populate
        // the response date and pass it through to the DataCache.
        // But I'm still noticing it often enough in development that I think users might hit it.
        // One spot that I'm leaving broken is the Remarks hide/show button -- it's still the case
        // that polling can sometimes clobber users' edits to hide/show Remarks for a PJO.
        // I figure that's not a critical piece of data -- I'm much more concerned about users
        // editing key PJO fields like times, air/deep draft, and billing data and then seeing their
        // edits disappear.
        //
        // TH 10/20/2017 -- UPDATE: Also pause while any Acknowledge requests are pending or in flight.
        // Previously, if you acknowledged through to the end of the list, that'd dismiss the PJO
        // details popup and immediately trigger a poll request.
        // It'd also trigger an acknowledgement request, but that was behind a debounce of 300 ms.
        // So it'd be a race btwn the poll request and the ack request, and the poll request had a
        // 300 ms head start.
        // If the poll request read from the Db before the ack request made its changes, then
        // you'd see your acknowledged PJOs reappear on the page.
        // On my environment, that happened pretty much every time.
        s_js_1.default(function (initialPass) {
            if (!selectedItemKey() && pendingAckRequestCount() === 0) {
                // TH 05/04/2017 -- For initial construction of the view model, don't fire an immediate request
                // since there's already a request in flight. After that, do always fire off an immediate
                // request, say if we've just closed the PJO details popup.
                pollster_2.start(initialPass ? pollster_1.PollsterStartupBehavior.Lazy : pollster_1.PollsterStartupBehavior.Default);
            }
            else {
                pollster_2.stop();
            }
            return false;
        }, true);
    }
    return {
        Id: id,
        Tab: tab,
        Model: model,
        ModelLoading: modelLoading,
        ModelKey: function () { return modelKey(); },
        ModelKeyDirty: modelKeyDirty,
        UpdateModelKey: UpdateModelKey,
        ShowInvalidSearchMsg: showInvalidSearchMsg,
        Filter: filter,
        SelectedItemKey: selectedItemKey,
        SelectedDispatchEvent: selectedDispatchEvent,
        PrintPage: PrintPage,
        PrintRollingWindow: PrintRollingWindow,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu,
        DateRangeSelector: dateRangeSelector,
        Days: dayViewModels,
        ResultSetIsTruncated: resultSetIsTruncated,
        MenuAction: MenuAction,
        ShowAddPilotJobOrderModal: ShowAddPilotJobOrderModal,
        AddPilotJobOrder: addPilotJobOrder,
        ShowAddDispatchEventModal: showAddDispatchEventModal,
        AddDispatchEvent: addDispatchEvent,
        ColumnNames: function () { return ColumnNames(pierSettings); },
        CSVData: csvData,
        ViewBillingWorklistLink: viewBillingWorklistLink,
        BackToFullSearchLink: backToFullSearchLink,
        PilotJobOrderDetails: pjoDetails,
        BillingSystem: billingSystem,
        // Allow child content to "take over" the entire page. This will cause most standard
        // content on this page to be hidden, including headers, the main page body, and
        // the PJO details and Dispatch Event popups
        AllowFullPageTakeOver: function () {
            return !!pjoDetails() && pjoDetails().IsRequestingFullPageTakeOver();
        }
    };
    function UpdateModelKey() {
        if (searchSelectionIsInvalid()) {
            showInvalidSearchMsg(true);
        }
        else {
            modelKey(draftModelKey());
        }
    }
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function PrintPage() {
        window.print();
    }
    function PrintRollingWindow() {
        showRollingWindowOnly(true);
        // TH 02/15/2017 -- window.requestAnimationFrame to give DOM a chance to update
        // before printing.
        // This also guarantees that the two sets to showRollingWindowOnly happen in
        // different ticks, even when we run this function inside an S.freeze.
        window.requestAnimationFrame(function () {
            window.print();
            showRollingWindowOnly(false);
        });
    }
    function ShowAddPilotJobOrderModal() {
        addPilotJobOrderPopupParams({ from: model().From(), to: model().To() });
    }
    function onAddPilotJobOrder(pjo) {
        s_js_1.default.freeze(function () {
            addPilotJobOrderPopupParams(null);
            // TH 01/26/2017 -- The AddPilotJobOrder takes care of adding the new PJO to the
            // PCCache (and also removing the old MissingPilotJobOrder from the query cache and from our
            // model's MissingPJOs collection).
            // But we still need to add the new PJO to our model's JobOrders collection b/c
            // it uses a QueryResultsRelationship.
            // That way the new PJO is visible before the next poll update.
            model().JobOrders.push(pjo);
            selectedItemKey({ pjoId: pjo.Id() });
        });
    }
    function onDeletePilotJobOrder(pjo) {
        s_js_1.default.freeze(function () {
            // The PilotJobOrderDetails model takes care of updating the PCCache, but we still have to update our QueryResultsRelationship.
            model().JobOrders.remove(pjo);
            if (selectedItemKey() && selectedItemKey().pjoId === pjo.Id()) {
                selectedItemKey(null);
            }
        });
    }
    function onReorderPilotJobOrder(pjo) {
        s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
            // Reordering a PJO just means opening the Add PJO popup with special filters and with the given PJO as a template
            var itinerary = pjo.PortCall() ? pjo.PortCall().Itinerary().slice().sort(ItineraryPoint_1.ItineraryPoint.EstimatedOrder) : [], from = itinerary.length ? itinerary[0].Arrival.Estimated() : null, to = itinerary.length ? itinerary[itinerary.length - 1].Departure.Estimated() : null;
            addPilotJobOrderPopupParams({
                from: from,
                to: to,
                portCallId: pjo.PortCallId(),
                template: pjo
            });
            if (selectedItemKey() && selectedItemKey().pjoId === pjo.Id())
                selectedItemKey(null);
        }); });
    }
    function onAddShift(pjo) {
        // TH 02/13/2017 -- AddShift from PJO details popup.
        // Select the new PJO and add it to the QueryResultsRelationship.
        s_js_1.default.freeze(function () {
            selectedItemKey({ pjoId: pjo.Id() });
            model().JobOrders.push(pjo);
        });
    }
    function onAcknowledge(pjo) {
        s_js_1.default.freeze(function () {
            var key = selectedItemKey();
            if (key && key.pjoId === pjo.Id()) {
                // TH 02/18/2019 -- We now DO keep dashboardItems in sort order once again.
                // So perhaps this could be simplified. But leaving as is for now...
                // TH 04/14/2017 -- Try to select the next PJO in order.
                // This is a little tricky b/c we don't keep the dashboardItems collection in sorted order.
                // So instead loop through the dayViewModels collection and then through each day's DashboardItems.
                var currentDate = internalDateFormat(pjo.Start.Effective()), days = dayViewModels();
                var nextPJO = void 0, foundCurrent = false;
                FIND_NEXT_PJO: for (var i = 0; i < days.length; i++) {
                    var day = days[i];
                    if (!foundCurrent && day.Date !== currentDate)
                        continue;
                    var itemsForDay = day.DashboardItems();
                    for (var j = 0; j < itemsForDay.length; j++) {
                        var item = itemsForDay[j];
                        if (item.ItemType === 'PJO') {
                            if (!foundCurrent) {
                                if (item.Model.Id() === pjo.Id()) {
                                    foundCurrent = true;
                                }
                            }
                            else {
                                nextPJO = item;
                                break FIND_NEXT_PJO;
                            }
                        }
                    }
                }
                // TH 04/12/2017 -- Keep rolling down the list as long as there's a nextPJO to select.
                // Otherwise, dismiss the details popup.
                selectedItemKey(nextPJO ? { pjoId: nextPJO.Model.Id() } : null);
            }
            model().JobOrders.remove(pjo);
            // TH 10/21/2017 -- Also decrement the navbar's count of new PJOs.
            if (model().Navbar()) {
                var navbarAckCount = model().Navbar().AcknowledgeCount();
                model().Navbar().AcknowledgeCount(Math.max(navbarAckCount - 1, 0));
            }
            // TH 04/14/2017 -- Now initiating PJO Acknowledgements request from the DDash.
            // That's so we can debounce these requests to avoid crashing the server w/ multiple overlapping requests.
            acknowledgementRequest.PilotJobOrderIds.push(pjo.Id());
        });
    }
}
exports.DispatchDashboard = DispatchDashboard;
function DashboardDayViewModel(date, items) {
    return {
        Date: date,
        DateMoment: moment(date, exports.INTERNAL_DATE_FORMAT),
        DashboardItems: items
    };
}
// Sort dashboard items (PJOs and DispatchEvents) by (most significant to least significant):
//   1. Time (PJO.EffectiveStart or DispatchEvent.Start)
//   2. Item type (IN > OUT > SHIFT > DispatchEvent)
//   3. Id (to always have an unambiguous sort)
function dashboardItemOrder(a, b) {
    return (a.DashboardSort.Date().getTime() - b.DashboardSort.Date().getTime())
        || (a.DashboardSort.ItemOrder() - b.DashboardSort.ItemOrder())
        || (a.DashboardSort.Unique() - b.DashboardSort.Unique());
}
function DispatchEventViewModel(dispatchEvent, ajax, data, model, selectedItemKey) {
    // TH: Auto-save and validation are for consumption by the dispatcheventdetails component
    var client = ajax.Url(function () { return dispatchEvent.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(dispatchEvent, client, [
        'Billable',
        'Description',
        'QBTracking.Customer',
        'Start'
    ]), validation = validationWatcher_1.ValidationWatcher(client), getIsSelected = function () { return !!selectedItemKey() && selectedItemKey().dispatchEventId === dispatchEvent.Id(); }, 
    // TH 01/25/2017 -- Selected row performance optimization. See PilotJobOrderViewModel below.
    selected = s_js_1.default.value(s_js_1.default.sample(getIsSelected));
    s_js_1.default(function () { return selected(getIsSelected()); });
    var dashboardSort = {
        Date: draft.Start,
        ItemOrder: function () { return 3 /* Event */; },
        Unique: draft.Id
    };
    return {
        Model: draft,
        Persisted: dispatchEvent,
        Validation: validation,
        Selected: selected,
        Delete: Delete,
        DashboardSort: dashboardSort,
        ItemType: 'Event'
    };
    // TH: Delete method is for consumption by the dispatcheventdetails component
    function Delete() {
        var id = draft.Id(), req = client.Delete();
        req.then(function () { return s_js_1.default.freeze(function () {
            data.DispatchEvents.update(req.Date, [], [id]);
            // TH 01/26/2017 -- We've updated the PCCache, but still have to update our
            // model's DispatchEvents collection since it uses a QueryResultsRelationship.
            model().DispatchEvents.remove(dispatchEvent);
            selectedItemKey(null);
        }); });
    }
}
function PilotJobOrderViewModel(jobOrder, ajax, data, pierSettings, portCallModel, itineraryPointModel, vesselModel, pjoPrefsModel, selectedItemKey) {
    var draftPreferences = pjoPrefsModel({ pjo: jobOrder }).draftPreferences, remarksVisible = function () { return !!jobOrder.Remarks() && draftPreferences.RemarksVisible(); }, airDraftDisplay = displayDraft(jobOrder.EffectiveAirDraft), deepDraftDisplay = displayDraft(jobOrder.EffectiveDeepDraft), pilots = jobOrder.Pilots.orderBy(function (pa) { return pa.AssignmentOrder(); }), portcall = s_js_1.default(function () { return jobOrder.EffectivePortCall() && portCallModel(jobOrder.EffectivePortCall()); }), fromPoint = s_js_1.default(function () { return jobOrder.EffectiveFromPoint() && itineraryPointModel(jobOrder.EffectiveFromPoint()); }), toPoint = s_js_1.default(function () { return jobOrder.EffectiveToPoint() && itineraryPointModel(jobOrder.EffectiveToPoint()); }), effectiveVessel = s_js_1.default(function () { return jobOrder.EffectiveVessel() && vesselModel(jobOrder.EffectiveVessel()); }), 
    // Lengths rounds to whole foot or whole meter
    effectiveLength = new ConvertedMeasurement_1.ConvertedMeasurement(jobOrder.EffectiveLength, pierSettings.DefaultLengthUOM() || UOM_1.default.Foot, 0), 
    // Ignore conflicts for CNX PJOs...
    pjoIssues = s_array_1.lift(function () { return !jobOrder.Cancellation() ? jobOrder.Issues() : []; }), allConflicts = pjoIssues
        .concat(function () { return !jobOrder.Cancellation() && jobOrder.EffectiveFromPoint() && jobOrder.EffectiveFromPoint().BerthReservation() ? jobOrder.EffectiveFromPoint().BerthReservation().Issues() : []; })
        .concat(function () { return !jobOrder.Cancellation() && jobOrder.EffectiveToPoint() && jobOrder.EffectiveToPoint().BerthReservation() ? jobOrder.EffectiveToPoint().BerthReservation().Issues() : []; })
        .filter(function (i) { return i.Severity() >= Issue_2.IssueSeverity.Conflict; })
        .sort(Issue_1.Issue.ReversePrecedenceOrder), hasDraftConflict = pjoIssues.some(
    // TH 04/11/2017 -- NOTE: Intentionally ignoring any ReservationExceedsBerthDepth issues from either BerthReservation.
    // This drives styling on the Draft column, so our focus is just whether the PJO effective draft conflicts.
    function (i) { return i.Type() === IssueType_1.IssueType.PilotJobOrderExceedsBerthDepth && i.Severity() >= Issue_2.IssueSeverity.Conflict; }), getIsSelected = function () { return !!selectedItemKey() && selectedItemKey().pjoId === jobOrder.Id(); }, 
    // TH 01/25/2017 -- I was seeing significant performance bottlenecks just selecting
    // PJOs and DispatchEvents when I had a large number of rows on screen.
    // E.g., was seeing 300+ ms to change the selected row in Chrome on my machine.
    // Traced it down to the fact that the old logic required React to rerender each row
    // every time the selected row changed -- just the calls to update props on each row and all its children
    // became expensive, even though very little was actually changing.
    // This approach using an S.value to hold the current selected status cuts down the time to about
    // 20 ms per selection change.
    selected = s_js_1.default.value(s_js_1.default.sample(getIsSelected));
    s_js_1.default(function () { return selected(getIsSelected()); });
    var dashboardSort = {
        Date: function () { return jobOrder.Start.Effective(); },
        ItemOrder: function () {
            return jobOrder.EffectiveToPoint() && jobOrder.EffectiveToPoint().BerthReservation() ?
                jobOrder.EffectiveFromPoint() && jobOrder.EffectiveFromPoint().BerthReservation() ?
                    2 /* PjoShift */ :
                    0 /* PjoIn */ :
                1 /* PjoOut */;
        },
        Unique: jobOrder.Id
    };
    return {
        Model: jobOrder,
        Pilots: pilots,
        Selected: selected,
        FromPoint: fromPoint,
        ToPoint: toPoint,
        EffectiveVessel: effectiveVessel,
        AllConflicts: allConflicts,
        HasDraftConflict: hasDraftConflict,
        RemarksVisible: remarksVisible,
        ToggleRemarksVisible: function () { return draftPreferences.RemarksVisible(!draftPreferences.RemarksVisible()); },
        MovementTypeText: MovementTypeText,
        VesselNameText: VesselNameText,
        LocationText: LocationText,
        AgencyCodeText: AgencyCodeText,
        GrossTonnageText: GrossTonnageText,
        LengthText: LengthText,
        BeamText: BeamText,
        AirDraftText: AirDraftText,
        DeepDraftText: DeepDraftText,
        TugCompanyText: TugCompanyText,
        SideToText: SideToText,
        DashboardSort: dashboardSort,
        ItemType: 'PJO'
    };
    function displayDraft(pjoDraft) {
        var uom = function () { return pierSettings.DefaultDepthUOM() || UOM_1.default.Foot; };
        // Drafts round to feet and inches or to tenths of a meter
        return function () { return uom() === UOM_1.default.Foot ? {
            Type: 'inches',
            Display: new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(pjoDraft, 0)
        } : {
            Type: 'meters',
            Display: new ConvertedMeasurement_1.ConvertedMeasurement(pjoDraft, uom(), 1)
        }; };
    }
    // TODO: Do we wanna update this text to align w/ our new movement type labeling on the homepage's
    // Traffic Schedule tab? There, we now use AREA for movement's btwn port-external locations and reserve
    // IN for movements from a port-external location to a port-internal one and OUT for movements from a
    // port-internal location to a port-external one.
    function MovementTypeText() {
        return (jobOrder.Cancellation() ?
            'CNX' :
            jobOrder.EffectiveToPoint() && jobOrder.EffectiveToPoint().BerthReservation() ?
                jobOrder.EffectiveFromPoint() && jobOrder.EffectiveFromPoint().BerthReservation() ?
                    'SHIFT' :
                    'IN' :
                'OUT');
    }
    function VesselNameText() {
        return jobOrder.DisplayVesselIdentifier() || '';
    }
    function LocationText() {
        return LocationName(function () { return jobOrder.EffectiveFromPoint(); }) + ' to ' + LocationName(function () { return jobOrder.EffectiveToPoint(); });
    }
    function AgencyCodeText() {
        return (portcall() &&
            portcall().Agent() &&
            portcall().Agent().Organization() &&
            portcall().Agent().Organization().EffectiveAgencyCode() || '');
    }
    function GrossTonnageText() {
        return effectiveVessel() ?
            effectiveVessel().Model.GrossTonnage.toString({ units: false }) : '--';
    }
    function LengthText() {
        return effectiveLength.toString({ units: false });
    }
    function BeamText() {
        return effectiveVessel() ?
            effectiveVessel().Beam.toString({ units: false }) : '--';
    }
    function AirDraftText() {
        var draft = airDraftDisplay();
        return draft.Type === 'inches' ? draft.Display.toString() : draft.Display.toString({ units: false });
    }
    function DeepDraftText() {
        var draft = deepDraftDisplay();
        return draft.Type === 'inches' ? draft.Display.toString() : draft.Display.toString({ units: false });
    }
    function TugCompanyText() {
        return jobOrder.TugCompany() ? jobOrder.TugCompany().Code() : '--';
    }
    function SideToText() {
        return toPoint() && toPoint().BerthReservation() ?
            toPoint().BerthReservation().SideToText() :
            fromPoint() && fromPoint().BerthReservation() ?
                fromPoint().BerthReservation().SideToText() :
                '';
    }
    function LocationName(pt) {
        return pt() && pt().Location() && pt().Location().Name() || '';
    }
}
function OrganizationViewModel(organization, agencyCodesByOrg) {
    var code = agencyCodesByOrg(organization.Id), effectiveAgencyCode = function () {
        if (code())
            return code().Code();
        var wordsInName = organization.Name().split(/\s+/), first3Words = wordsInName.slice(0, 3), firstLetters = first3Words.map(function (w) { return w.substr(0, 1); });
        return firstLetters.join('').toUpperCase();
    };
    return {
        Model: organization,
        EffectiveAgencyCode: effectiveAgencyCode
    };
}
function ItineraryPointViewModel(itineraryPoint) {
    return {
        Model: itineraryPoint,
        BerthReservation: s_js_1.default(function () { return itineraryPoint.BerthReservation() && ReservationViewModel(itineraryPoint.BerthReservation()); })
    };
}
function ReservationViewModel(reservation) {
    return {
        Model: reservation,
        SideToText: function () {
            return reservation.SideTo() === BerthReservation_1.VesselSide.Starboard ? 'S' :
                reservation.SideTo() === BerthReservation_1.VesselSide.Port ? 'P' :
                    reservation.SideTo() === BerthReservation_1.VesselSide.SternTo ? 'Ste' :
                        BerthReservation_1.VesselSideDisplayName[reservation.SideTo()];
        }
    };
}
function PortCallViewModel(portcall, pierSettings, agentModel) {
    return {
        Model: portcall,
        Agent: s_js_1.default(function () { return portcall.Agent() && agentModel(portcall.Agent()); })
    };
}
function AgentViewModel(agent, organizationModel) {
    return {
        Model: agent,
        Organization: s_js_1.default(function () { return agent.Organization() && organizationModel(agent.Organization()); })
    };
}
function VesselViewModel(vessel, pierSettings) {
    return {
        Model: vessel,
        // Beam rounds to whole foot or whole meter
        Beam: new ConvertedMeasurement_1.ConvertedMeasurement(vessel.Beam, pierSettings.DefaultLengthUOM() || UOM_1.default.Foot, 0)
    };
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageLink = exports.ProfileAndLandingPageLinks = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
// TH 12/15/2016 -- Common links used by both AcceptInvitation and
// RestoreAccount pages.
exports.ProfileAndLandingPageLinks = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "link-shell" },
            React.createElement("a", { href: "#!mepage" }, "View my profile")),
        React.createElement("div", { className: "link-shell" },
            React.createElement("a", { href: m.User() && m.User().LandingPage() || '#' }, "View my landing page")));
});
exports.HomepageLink = supercritical_1.default(function () {
    return React.createElement("div", { className: "link-shell" },
        React.createElement("a", { href: "#" }, "Back to homepage"));
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchesDashboard = exports.DefaultRole = exports.Columns = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var debounceSignal_1 = __webpack_require__(81);
var tzmoment_1 = __webpack_require__(9);
var diacriticals_1 = __webpack_require__(42);
var PortCallUserRole_1 = __webpack_require__(136);
var csvExport_1 = __webpack_require__(149);
var model_1 = __webpack_require__(129);
// TODO: Localization!!
var DATE_FORMAT = 'MM/DD/YYYY', DATE_TIME_FORMAT = 'MM/DD/YYYY [at] HH:mm';
var VesselName = {
    Title: 'Vessel',
    DisplayValue: function (batch) { return batch.VesselName(); },
    SortValue: function (batch) { return batch.VesselName(); },
    ClassName: 'vessel'
}, BerthName = {
    Title: 'Berth',
    DisplayValue: function (batch) { return batch.BerthName(); },
    SortValue: function (batch) { return batch.BerthName(); },
    ClassName: 'berth'
}, PortName = {
    Title: 'Port/Region',
    DisplayValue: function (batch) { return batch.PortName(); },
    SortValue: function (batch) { return batch.PortName(); },
    ClassName: 'port'
}, RequestDate = {
    Title: 'Date Ordered',
    DisplayValue: function (batch) { return batch.DateOrderedDisplay(); },
    SortValue: function (batch) { return batch.Model.RequestDate(); },
    ClassName: 'date-ordered'
}, FirstReservationDate = {
    Title: 'First Reservation',
    DisplayValue: function (batch) { return batch.FirstReservationDateDisplay(); },
    SortValue: function (batch) { return batch.FirstReservationDate() || new TZDate_1.default(0); },
    ClassName: 'first-reservation'
}, LastReservationDate = {
    Title: 'Last Reservation',
    DisplayValue: function (batch) { return batch.LastReservationDateDisplay(); },
    SortValue: function (batch) { return batch.LastReservationDate() || new TZDate_1.default(0); },
    ClassName: 'last-reservation'
}, Count = {
    Title: 'Count',
    DisplayValue: function (batch) { return batch.Model.PortCalls().length + ''; },
    SortValue: function (batch) { return batch.Model.PortCalls().length; },
    ClassName: 'count'
}, ReferenceNumber = {
    Title: 'Reference #',
    DisplayValue: function (batch) { return batch.Model.ReferenceNumber(); },
    SortValue: function (batch) { return batch.Model.ReferenceNumber(); },
    ClassName: 'reference-number'
};
var DefaultSortColumn = FirstReservationDate;
exports.Columns = [
    VesselName,
    BerthName,
    PortName,
    RequestDate,
    FirstReservationDate,
    LastReservationDate,
    Count,
    ReferenceNumber
];
var CSVColumns = [{
        name: VesselName.Title,
        formatter: VesselName.DisplayValue
    }, {
        name: BerthName.Title,
        formatter: BerthName.DisplayValue
    }, {
        name: PortName.Title,
        formatter: PortName.DisplayValue
    }, {
        name: RequestDate.Title,
        formatter: function (batch) { return csvExport_1.ExcelDateFormat(batch.Model.RequestDate()); }
    }, {
        name: 'First Reservation (Date)',
        formatter: function (batch) { return batch.FirstReservationDate() ? csvExport_1.ExcelDateFormat(batch.FirstReservationDate()) : ''; }
    }, {
        name: 'First Reservation (Time)',
        formatter: function (batch) { return batch.FirstReservationDate() ? csvExport_1.ExcelTimeFormat(batch.FirstReservationDate()) : ''; }
    }, {
        name: 'Last Reservation (Date)',
        formatter: function (batch) { return batch.LastReservationDate() ? csvExport_1.ExcelDateFormat(batch.LastReservationDate()) : ''; }
    }, {
        name: 'Last Reservation (Time)',
        formatter: function (batch) { return batch.LastReservationDate() ? csvExport_1.ExcelTimeFormat(batch.LastReservationDate()) : ''; }
    }, {
        name: Count.Title,
        formatter: Count.DisplayValue
    }, {
        name: ReferenceNumber.Title,
        formatter: ReferenceNumber.DisplayValue
    }];
exports.DefaultRole = PortCallUserRole_1.PortCallUserRole.Any;
var filterStorageKey = 'portcall.batchesdashboard.filter';
function BatchesDashboard(ajax, entrypoints, cache, user, dateRangeSelectorModel, _a) {
    var _orgId = _a.orgId, range = _a.range, from = _a.from, to = _a.to, _role = _a.role, _filter = _a.filter;
    var orgId = _orgId !== undefined ? _orgId : user() ? user().OrganizationId() : 0, role = s_js_1.default.data(_role !== undefined ? _role : exports.DefaultRole), dateRangeSelector = dateRangeSelectorModel({ range: range, from: from, to: to }), loading = s_js_1.default.data(true), key = function () { return ({
        OrganizationId: orgId,
        FromDate: dateRangeSelector.FromDate().toJSON(),
        ToDate: dateRangeSelector.ToDate().toJSON(),
        Role: role()
    }); }, model = s_js_1.default(function () { return cache.BatchesDashboards.update1(null, key()); }), rowSorter = model_1.RowSorter(DefaultSortColumn), filter = s_js_1.default.data(_filter || localStorage[filterStorageKey] || ''), debouncedFilter = debounceSignal_1.debounceSignal(filter), batches = s_array_1.default([]), sortedBatches = batches.map(BatchViewModel)
        .filter(function (batch) { return diacriticals_1.CaseInsensitiveContains(batch.FilterData(), debouncedFilter()); })
        .sort(rowSorter.RowOrder), showActionsMenu = s_js_1.default.data(false), csvExportLink = s_js_1.default(function () { return csvExport_1.toCSVDataUri(sortedBatches(), CSVColumns); });
    // Store filter
    s_js_1.default(function () {
        localStorage[filterStorageKey] = filter();
    });
    // Fetch data
    s_js_1.default(function () {
        loading(true);
        var req = ajax.Url(entrypoints.BatchesDashboard(key())).Get();
        req.then(function (json) { return cache.BatchesDashboards.update1(req.Date, json); })
            .finally(function () { return loading(false); });
    });
    s_js_1.default(function () { return batches(model().Batches()); });
    return {
        OrgId: orgId,
        Role: role,
        Organization: function () { return model().Organization(); },
        Batches: sortedBatches,
        DateRangeSelector: dateRangeSelector,
        Filter: filter,
        Loading: loading,
        RowSorter: rowSorter,
        ShowActionsMenu: showActionsMenu,
        CSVExportLink: csvExportLink,
        GoBack: function () { return window.history.back(); }
    };
    function BatchViewModel(batch) {
        var firstPoint = s_js_1.default(function () { return batch.FirstReservationPoint(); }), lastPoint = s_js_1.default(function () { return batch.LastReservationPoint(); }), firstPortCall = s_js_1.default(function () { return batch.FirstPortCall(); }), vesselName = function () { return firstPortCall() && firstPortCall().DisplayVesselIdentifier() || '--'; }, berthName = function () { return firstPoint() && firstPoint().Location() && firstPoint().Location().Name() || '--'; }, portName = function () { return firstPortCall() && firstPortCall().Port() && firstPortCall().Port().Name() || '--'; }, dateOrderedDisplay = function () { return tzmoment_1.tzmoment(batch.RequestDate()).format(DATE_FORMAT); }, firstReservationDate = function () { return firstPoint() && firstPoint().Arrival.Effective(); }, firstReservationDateDisplay = function () { return firstReservationDate() ? tzmoment_1.tzmoment(firstReservationDate()).format(DATE_TIME_FORMAT) : '--'; }, lastReservationDate = function () { return lastPoint() && lastPoint().Arrival.Effective(); }, lastReservationDateDisplay = function () { return lastReservationDate() ? tzmoment_1.tzmoment(lastReservationDate()).format(DATE_TIME_FORMAT) : '--'; }, filterData = function () {
            return vesselName() + ' ' +
                berthName() + ' ' +
                portName() + ' ' +
                dateOrderedDisplay() + ' ' +
                firstReservationDateDisplay() + ' ' +
                lastReservationDateDisplay() + ' ' +
                batch.PortCalls().length + ' ' +
                batch.ReferenceNumber();
        };
        return {
            Model: batch,
            VesselName: vesselName,
            BerthName: berthName,
            PortName: portName,
            DateOrderedDisplay: dateOrderedDisplay,
            FirstReservationDate: firstReservationDate,
            FirstReservationDateDisplay: firstReservationDateDisplay,
            LastReservationDate: lastReservationDate,
            LastReservationDateDisplay: lastReservationDateDisplay,
            FilterData: filterData,
            OnRowClick: function () { return window.location.hash = "#!reservationsinbatch?batchId=" + batch.Id(); }
        };
    }
}
exports.BatchesDashboard = BatchesDashboard;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesDashboard = exports.Columns = exports.Column = void 0;
var s_js_1 = __webpack_require__(0);
var diacriticals_1 = __webpack_require__(42);
var debounceSignal_1 = __webpack_require__(81);
var tzmoment_1 = __webpack_require__(9);
var TopicCardStatus_1 = __webpack_require__(137);
var Column;
(function (Column) {
    Column[Column["Status"] = 0] = "Status";
    Column[Column["Time"] = 1] = "Time";
    Column[Column["Label"] = 2] = "Label";
    Column[Column["Topic"] = 3] = "Topic";
    Column[Column["Vessel"] = 4] = "Vessel";
    Column[Column["Berth"] = 5] = "Berth";
})(Column = exports.Column || (exports.Column = {}));
exports.Columns = [
    Column.Status,
    Column.Time,
    Column.Label,
    Column.Topic,
    Column.Vessel,
    Column.Berth
];
var SortFunctions = (_a = {},
    _a[Column.Status] = function (a, b) {
        return TopicCardStatus_1.TopicCardStatus[a.Status()] < TopicCardStatus_1.TopicCardStatus[b.Status()] ? -1 : 1;
    },
    _a[Column.Time] = function (a, b) {
        return a.TimeEntry.Response() == null ? 1 :
            b.TimeEntry.Response() == null ? -1 :
                +a.TimeEntry.Response() - +b.TimeEntry.Response();
    },
    _a[Column.Label] = function (a, b) {
        return !a.AmenityType() ? 1 :
            !b.AmenityType() ? -1 :
                a.AmenityType().Name() < b.AmenityType().Name() ? -1 :
                    1;
    },
    _a[Column.Topic] = function (a, b) {
        return a.Title() < b.Title() ? -1 : 1;
    },
    _a[Column.Vessel] = function (a, b) {
        return !a.PortCall() || !a.PortCall().Vessel() ? 1 :
            !b.PortCall() || !b.PortCall().Vessel() ? -1 :
                (a.PortCall().DisplayVesselIdentifier() || '') < (b.PortCall().DisplayVesselIdentifier() || '') ? -1 :
                    1;
    },
    _a[Column.Berth] = function (a, b) {
        return !a.Berth() || !a.Berth().Location() ? 1 :
            !b.Berth() || !b.Berth().Location() ? -1 :
                a.Berth().Location().Name() < b.Berth().Location().Name() ? -1 :
                    1;
    },
    _a);
var ServicesDashboard = function (params, loader, tzutils) {
    var Date = s_js_1.default.value(params.date), Today = tzutils.today(), dateData = s_js_1.default(function () { return loader({ OrganizationId: params.id, Date: Date().toJSON() }); }), Loading = function () { return dateData().loading(); }, SortReversed = s_js_1.default.value(params.reversed), Sort = s_js_1.default.value(params.sort), sortedServices = function () {
        var services = Array.from(dateData().model.Services());
        services.sort(SortFunctions[Sort()]);
        if (SortReversed())
            services.reverse();
        return services;
    }, Filter = s_js_1.default.value(params.filter), debouncedFilter = debounceSignal_1.debounceSignal(Filter), DisplayedServices = s_js_1.default(function () { return !debouncedFilter() ? sortedServices() :
        sortedServices().filter(function (s) {
            return diacriticals_1.CaseInsensitiveContains(TopicCardStatus_1.TopicCardStatus[s.Status()], debouncedFilter())
                || (s.TimeEntry.Response() && diacriticals_1.CaseInsensitiveContains(tzmoment_1.tzmoment(s.TimeEntry.Response()).format('HH:mm'), debouncedFilter()))
                || (s.AmenityType() && diacriticals_1.CaseInsensitiveContains(s.AmenityType().Name(), debouncedFilter()))
                || diacriticals_1.CaseInsensitiveContains(s.Title(), debouncedFilter())
                || (s.PortCall() && diacriticals_1.CaseInsensitiveContains(s.PortCall().DisplayVesselIdentifier() || '', debouncedFilter()))
                || (s.Berth() && s.Berth().Location() && diacriticals_1.CaseInsensitiveContains(s.Berth().Location().Name(), debouncedFilter()));
        }); });
    return { Loading: Loading, DisplayedServices: DisplayedServices, Filter: Filter, Sort: Sort, SortReversed: SortReversed, Date: Date, AddDays: AddDays, SortToggle: SortToggle, OnClickService: OnClickService, Today: Today };
    function AddDays(n) {
        Date(tzmoment_1.tzmomentMod(tzutils, Date(), function (m) { return m.add(n, 'd'); }));
    }
    function SortToggle(col) {
        if (col === Sort())
            SortReversed(!SortReversed());
        else
            s_js_1.default.freeze(function () {
                Sort(col);
                SortReversed(false);
            });
    }
    function OnClickService(s) {
        window.location.hash = "#!topiccards?id=" + s.PortCallId() + '&cardId=' + s.Id();
    }
};
exports.ServicesDashboard = ServicesDashboard;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillExportSettingsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(89);
exports.BillExportSettingsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "billexportsettings" },
        React.createElement("div", { className: "export-settings-header" }, "Export Settings"),
        React.createElement("div", { className: "export-settings-body" },
            React.createElement(BillableToggleView, { model: m }),
            React.createElement(CustomerIDView, { model: m }),
            React.createElement(ExportActionsView, { model: m })));
});
var BillableToggleView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "export-settings-line" },
        React.createElement("span", { className: "export-settings-label pc-text-billing-label" }, "Billable"),
        React.createElement(view_1.ToggleButton, { checked: m.DraftModel.Billable, onLabel: "Billable", offLabel: "Non-billable", selectedLabelClassName: "billable-toggle-selected-label", disabled: m.BillingStatus() === 1 /* Approved */ ||
                m.BillingStatus() === 0 /* Exported */ }));
});
var CustomerIDView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var customerIDDisabled = m.BillingStatus() === 2 /* NonBillable */ ||
        m.BillingStatus() === 1 /* Approved */ ||
        m.BillingStatus() === 0 /* Exported */;
    return (React.createElement("div", { className: "export-settings-line" },
        React.createElement("span", { className: "export-settings-label pc-text-billing-label" }, "Customer ID"),
        React.createElement("div", { className: "customer-input-shell" },
            React.createElement("input", { className: "customer-input", value: m.BillingStatus() === 2 /* NonBillable */ ? '' : m.DraftModel.QBTracking.Customer() || '', onChange: function (e) { return m.DraftModel.QBTracking.Customer(e.currentTarget.value); }, disabled: customerIDDisabled }),
            React.createElement("div", { className: cx('customer-input-instructions', {
                    'hide-instructions': customerIDDisabled
                }) }, "Enter matching Customer ID"))));
});
var ExportActionsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.BillingStatus() === 0 /* Exported */ ?
        React.createElement("div", { className: "export-settings-line export-actions" },
            React.createElement("span", { className: "pc-text-smalllabel" },
                "Exported:",
                ' ',
                m.LastExportDate() ? tzmoment_1.tzmoment(m.LastExportDate()).format('M/D/YY') : 'Exported with error')) :
        m.BillingStatus() === 1 /* Approved */ ?
            React.createElement("div", { className: "export-settings-line export-actions" },
                m.CanRecalculate() &&
                    React.createElement("a", { href: "", className: "recalculate-link", onClick: eventWrappers_1.noDefault(m.Recalculate) }, "Recalculate"),
                React.createElement("span", { className: "pc-text-smalllabel" },
                    "Approved:",
                    ' ',
                    m.DraftModel.ApprovalOfCharges() ? tzmoment_1.tzmoment(m.DraftModel.ApprovalOfCharges().ApprovalDate()).format('M/D/YY') : '')) :
            React.createElement("div", { className: "export-settings-line export-actions" },
                React.createElement("button", { className: "pc-button export-actions-button", onClick: m.Approve, disabled: !m.ValidForApproval() }, "Approve for Export"));
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsLoadingIcon = exports.CoordinationCardDetailsCloseLink = exports.CoordinationCardDetailsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(515);
var view_1 = __webpack_require__(197);
var actionsview_1 = __webpack_require__(512);
var logview_1 = __webpack_require__(514);
var statusview_1 = __webpack_require__(1070);
exports.CoordinationCardDetailsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationcarddetails" },
        React.createElement(view_1.PCTabStripView, { model: m.TabStrip, ctrl: new view_1.TitledTabStripViewController(), extraContents: function () {
                return React.createElement(exports.CoordinationCardDetailsCloseLink, { dismissDetails: m.DismissDetails });
            } }),
        React.createElement(view_1.PCTabContents, { model: m.TabStrip, ctrl: new TabContentsController(m) }),
        React.createElement(exports.CoordinationCardDetailsLoadingIcon, { loading: m.Loading }));
});
var TabContentsController = /** @class */ (function (_super) {
    __extends(TabContentsController, _super);
    function TabContentsController(model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        return _this;
    }
    TabContentsController.prototype.renderTabContents = function (tab) {
        var m = this.model;
        if (tab === model_1.TabStatus)
            return React.createElement(statusview_1.CoordinationCardDetailsStatusTabView, { model: m.StatusTab });
        else if (tab === model_1.TabActions)
            return React.createElement(actionsview_1.CoordinationCardDetailsActionsTabView, { model: m.ActionsTab });
        else if (tab === model_1.TabLog)
            return React.createElement(logview_1.CoordinationCardDetailsLogTabView, { model: m.LogTab });
        else
            throw new Error("Unknown tab with title '" + tab.Title + "'");
    };
    return TabContentsController;
}(view_1.TitledTabContentsController));
// UI fragments for consumption here and by the cancelled C-Card details view
exports.CoordinationCardDetailsCloseLink = supercritical_1.default(function (_a) {
    var dismissDetails = _a.dismissDetails;
    return React.createElement("span", { className: "ccard-details__close-details-link fa fa-times-circle", onClick: dismissDetails });
});
exports.CoordinationCardDetailsLoadingIcon = supercritical_1.default(function (_a) {
    var loading = _a.loading;
    return loading() ? React.createElement("div", { className: "ccard-details__loading-icon" }) : null;
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var BerthReservation_1 = __webpack_require__(38);
var CoordinationCardStatuses_1 = __webpack_require__(110);
var EventType_1 = __webpack_require__(111);
var PortCallChange_1 = __webpack_require__(610);
var PilotJobOrderChange_1 = __webpack_require__(1398);
var PilotJobOrderChangeType_1 = __webpack_require__(1399);
var PortCallChangeType_1 = __webpack_require__(209);
var VesselChangeType_1 = __webpack_require__(1372);
var view_1 = __webpack_require__(150);
var view_2 = __webpack_require__(105);
var newcommentview_1 = __webpack_require__(194);
var view_3 = __webpack_require__(78);
var view_4 = __webpack_require__(52);
exports.EventLogView = supercritical_1.default(function (_a) {
    var m = _a.model, allowTaggingUsers = _a.allowTaggingUsers;
    return React.createElement("div", { className: "eventlogcomponent" }, m.LogEntries().map(function (entry) {
        return React.createElement(LogEntryView, { entry: entry, now: m.Now, allowTaggingUsers: allowTaggingUsers, key: entry.Entry.EventId() });
    }));
});
var LogEntryView = supercritical_1.default(function (_a) {
    var vm = _a.entry, now = _a.now, allowTaggingUsers = _a.allowTaggingUsers;
    return React.createElement("div", { className: "pc-card" },
        React.createElement("div", { className: "log-entry-main-row" },
            React.createElement(LogEntryIconAndImage, { entry: vm }),
            React.createElement(LogEntryContent, { entry: vm })),
        React.createElement("div", { className: "log-entry-metadata-row clearfix" },
            React.createElement(LogEntryCommentsSummary, { entry: vm }),
            React.createElement(LogEntryTimestamp, { entry: vm, now: now })),
        React.createElement(LogEntryNewCommentView, { entry: vm, allowTaggingUsers: allowTaggingUsers }),
        React.createElement(LogEntryCommentsView, { entry: vm }));
});
var LogEntryIconAndImage = supercritical_1.default(function (_a) {
    var entry = _a.entry.Entry;
    var imageUrl = entry.Event() && LogEntryImageUrl(entry.Event());
    return (React.createElement("div", { className: "log-entry-icon-and-image" },
        React.createElement("i", { className: cx("log-entry-icon", LogEntryIconClass(entry.Event())) }),
        imageUrl && React.createElement("img", { className: "thumb-img", src: imageUrl }),
        entry.Event() && React.createElement(CCardStatusUpdateIcon, { event: entry.Event() })));
});
var LogEntryContent = supercritical_1.default(function (_a) {
    var vm = _a.entry, entry = _a.entry.Entry;
    return React.createElement("div", { className: "log-entry-content" },
        React.createElement("div", { className: "log-message" }, entry.Event() && LogMessage(entry.Event())),
        React.createElement(LogEntryExtraContent, { entry: vm }));
});
var LogEntryCommentsSummary = supercritical_1.default(function (_a) {
    var vm = _a.entry;
    var numComments = vm.Comments().length;
    return (React.createElement("div", { className: "pc-text-smalllabel comments-summary" },
        React.createElement("span", { className: "comment-count" },
            numComments,
            " Comment",
            numComments === 1 ? '' : 's'),
        React.createElement("span", { className: "pc-icon-bullet" }),
        vm.CanComment() &&
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(vm.ToggleNewComment) },
                vm.NewComment() ? 'Hide' : 'Add',
                " Comment")));
});
var LogEntryTimestamp = supercritical_1.default(function (_a) {
    var entry = _a.entry.Entry, now = _a.now;
    var event = entry.Event();
    return (React.createElement("div", { className: "log-entry-timestamp pc-text-smalllabel" }, event &&
        React.createElement(view_4.TimeAgoTooltip, { className: "pc-text-fixedwidth pc-text-fixedwidth-tooltip", date: event.Date, now: now, useAbbreviatedTimeAgo: true })));
});
var LogEntryNewCommentView = supercritical_1.default(function (_a) {
    var vm = _a.entry, allowTaggingUsers = _a.allowTaggingUsers;
    return vm.NewComment() &&
        React.createElement(newcommentview_1.NewCommentView, { model: vm.NewComment(), allowTaggingUsers: allowTaggingUsers });
});
var LogEntryCommentsView = supercritical_1.default(function (_a) {
    var vm = _a.entry;
    return vm.Comments().length ?
        React.createElement("div", { className: "log-entry-comments" }, vm.Comments().map(function (comment) {
            return React.createElement(LogEntryCommentView, { comment: comment, key: comment.Comment.Id() });
        })) :
        null;
});
var LogEntryCommentView = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var vm = _a.comment, comment = _a.comment.Comment;
    return React.createElement("div", { className: "log-entry-comment" },
        React.createElement("div", { className: "comment-icon-and-image" }, ((_b = comment.Event()) === null || _b === void 0 ? void 0 : _b.User()) ?
            React.createElement("img", { className: "thumb-img", src: comment.Event().User().Image.ThumbUrl() }) :
            ((_c = comment.Event()) === null || _c === void 0 ? void 0 : _c.Automation()) ?
                React.createElement("i", { className: "log-entry-icon icon-bollard" }) :
                null),
        React.createElement("div", { className: "comment-content" },
            React.createElement("div", null,
                React.createElement("span", { className: "comment-username pc-text-accent" }, (_d = comment.Event()) === null || _d === void 0 ? void 0 : _d.ActorName()),
                React.createElement("span", { className: "pc-text-smalllabel" }, comment.Event() && tzmoment_1.tzmoment(comment.Event().Date()).format('MM/DD/YY [at] HH:mm'))),
            React.createElement("div", { className: "comment-message" }, comment.Message()),
            React.createElement(CommentRecipientsView, { comment: vm }),
            React.createElement(CommentAttachmentView, { comment: vm })));
});
var CommentRecipientsView = supercritical_1.default(function (_a) {
    var comment = _a.comment;
    var numRecipients = comment.Recipients().length;
    // TODO: Or is it better to always show the "Recipients:" label whether or not there are any recipients?
    return numRecipients > 0 ?
        React.createElement("div", { className: "comment-recipients-shell" },
            React.createElement("span", null, "Recipients:"),
            " ",
            React.createElement("span", { className: "comment-recipients" }, comment.Recipients().map(function (r, i) {
                return React.createElement(CommentRecipientView, { recipient: r, isFinalRecipient: i === numRecipients - 1, key: r.User.Id() });
            }))) :
        null;
});
var CommentRecipientView = supercritical_1.default(function (_a) {
    var recipient = _a.recipient, isFinalRecipient = _a.isFinalRecipient;
    return React.createElement("span", null,
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(recipient.ToggleProfile) },
            recipient.User.FullName(),
            !isFinalRecipient && ", "),
        React.createElement(view_3.PersonProfilePopupView, { modelContainer: recipient.ProfilePopup }));
});
var CommentAttachmentView = supercritical_1.default(function (_a) {
    var comment = _a.comment;
    return comment.Comment.AttachmentUrl() ?
        React.createElement("div", { className: "comment-attachment-shell" },
            React.createElement(view_2.DownloadLink, { href: comment.Comment.AttachmentUrl() },
                React.createElement("i", { className: "fa fa-paperclip" }),
                " ",
                React.createElement("span", { className: "comment-attachment-name pc-text-fixedwidth" }, comment.Comment.AttachmentFileName()))) :
        null;
});
function LogEntryIconClass(event) {
    // TODO: Should review if this does what we want for all event types, especially version events.
    var pcc = event === null || event === void 0 ? void 0 : event.PortCallChange(), comment = event === null || event === void 0 ? void 0 : event.Comment();
    return ((pcc === null || pcc === void 0 ? void 0 : pcc.Type()) === PortCallChangeType_1.PortCallChangeType.Watcher ? 'icon-watch' :
        (pcc === null || pcc === void 0 ? void 0 : pcc.Type()) === PortCallChangeType_1.PortCallChangeType.InvitedEditor ? 'fa fa-group' :
            (pcc === null || pcc === void 0 ? void 0 : pcc.Type()) === PortCallChangeType_1.PortCallChangeType.AttendingAgent ? '' :
                comment ? '' :
                    // Disable the usual icon b/c we'll show a C-Card status indicator instead.
                    (event === null || event === void 0 ? void 0 : event.Type()) === EventType_1.EventType.CCardStatusUpdate ? '' :
                        'icon-bollard');
}
function LogEntryImageUrl(event) {
    var _a, _b;
    // TODO: Should review if this does what we want for all event types, especially version events.
    var pcc = event.PortCallChange(), comment = event.Comment();
    return ((pcc === null || pcc === void 0 ? void 0 : pcc.Type()) === PortCallChangeType_1.PortCallChangeType.AttendingAgent ? (_a = event.User()) === null || _a === void 0 ? void 0 : _a.Image.ThumbUrl() :
        comment ? (_b = event.User()) === null || _b === void 0 ? void 0 : _b.Image.ThumbUrl() :
            undefined);
}
var CCardStatusUpdateIcon = supercritical_1.default(function (_a) {
    var event = _a.event;
    if (event.Type() === EventType_1.EventType.CCardStatusUpdate) {
        var ccv = event.CoordinationCardVersion();
        return ccv ? React.createElement(view_1.CCardStatusIndicator, { statusId: ccv.StatusId() }) : null;
    }
    else {
        return null;
    }
});
// Extra content for select log entry types, in addition to the main log message.
var LogEntryExtraContent = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var vm = _a.entry, entry = _a.entry.Entry;
    return vm.Comment() ?
        React.createElement("div", null,
            React.createElement(CommentRecipientsView, { comment: vm.Comment() }),
            React.createElement(CommentAttachmentView, { comment: vm.Comment() })) :
        ((_b = entry.Event()) === null || _b === void 0 ? void 0 : _b.Type()) === EventType_1.EventType.ReservationStatusChanged ?
            React.createElement(ReservationStatusChangedExtraContent, { event: entry.Event() }) :
            ((_c = entry.Event()) === null || _c === void 0 ? void 0 : _c.Type()) === EventType_1.EventType.CCardStatusUpdate ?
                React.createElement(CCardStatusUpdateExtraContent, { event: entry.Event() }) :
                ((_d = entry.Event()) === null || _d === void 0 ? void 0 : _d.PilotJobOrderCancellation()) ?
                    React.createElement(PJOCancellationExtraContent, { cnx: entry.Event().PilotJobOrderCancellation() }) :
                    null;
});
var ReservationStatusChangedExtraContent = supercritical_1.default(function (_a) {
    var _b, _c;
    var event = _a.event;
    return React.createElement(AdditionalRemarks, { remarks: (_c = (_b = event.BerthReservationVersion()) === null || _b === void 0 ? void 0 : _b.CancellationRemarks()) !== null && _c !== void 0 ? _c : null });
});
var CCardStatusUpdateExtraContent = supercritical_1.default(function (_a) {
    var _b, _c;
    var event = _a.event;
    return React.createElement(AdditionalRemarks, { remarks: (_c = (_b = event.CoordinationCardVersion()) === null || _b === void 0 ? void 0 : _b.StatusReason()) !== null && _c !== void 0 ? _c : null });
});
var PJOCancellationExtraContent = supercritical_1.default(function (_a) {
    var cnx = _a.cnx;
    return React.createElement(AdditionalRemarks, { remarks: cnx.Remarks() });
});
var AdditionalRemarks = supercritical_1.default(function (_a) {
    var remarks = _a.remarks;
    return remarks ?
        React.createElement("div", { className: "additional-remarks-shell" },
            React.createElement("div", null,
                React.createElement("label", { className: "remarks-label" }, "Remarks:")),
            React.createElement("div", { className: "additional-remarks" }, remarks)) :
        null;
});
function LogMessage(event) {
    var _a, _b;
    var pcc = event.PortCallChange(), comment = event.Comment(), pjoChange = event.PilotJobOrderChange(), pjoCancellation = event.PilotJobOrderCancellation(), geoActivity = event.GeoActivity(), vesselChange = event.VesselChange(), pcv = event.PortCallVersion(), pcrv = event.PortCallReferenceVersion(), ipv = event.ItineraryPointVersion(), iprv = event.ItineraryPointReferenceVersion(), brv = event.BerthReservationVersion(), brrv = event.BerthReservationReferenceVersion(), jov = event.JobOrderVersion(), jorv = event.JobOrderReferenceVersion(), ccv = event.CoordinationCardVersion(), ccrv = event.CoordinationCardReferenceVersion(), actorName = (_a = event.ActorName()) !== null && _a !== void 0 ? _a : '';
    var message = pcc ? portCallChangeLogMessage({ pcc: pcc, actorName: actorName }) :
        comment ? actorName + ": " + ((_b = comment.Message()) !== null && _b !== void 0 ? _b : '') :
            geoActivity ? geoActivity.Message() :
                pjoChange ? pilotJobOrderChangeLogMessage({ pjoChange: pjoChange, actorName: actorName }) :
                    pjoCancellation ? pilotJobOrderCancellationLogMessage({ pjoCancellation: pjoCancellation, actorName: actorName }) :
                        vesselChange ? vesselChangeLogMessage({ vesselChange: vesselChange, actorName: actorName }) :
                            pcv ? portCallVersionChangeMessage(event, pcv, pcrv) :
                                ipv ? itineraryPointVersionChangeMessage(event, ipv, iprv) :
                                    brv ? berthReservationVersionChangeMessage(event, brv, brrv) :
                                        jov ? jobOrderVersionChangeMessage(event, jov, jorv) :
                                            ccv ? ccardEventMessage(event, ccv, ccrv) :
                                                "";
    // sometimes we land on the log without all the entities we need to display a message
    // so just report loading in that case
    return message || "Loading ...";
}
function portCallChangeLogMessage(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var pcc = _a.pcc, actorName = _a.actorName;
    var portCall = pcc.PortCall(), portCallName = (_b = portCall === null || portCall === void 0 ? void 0 : portCall.DisplayVesselIdentifier()) !== null && _b !== void 0 ? _b : '', domain = (_c = portCall === null || portCall === void 0 ? void 0 : portCall.Port()) === null || _c === void 0 ? void 0 : _c.Domain(), systemName = (_d = domain === null || domain === void 0 ? void 0 : domain.DisplayableUrl()) !== null && _d !== void 0 ? _d : '', berth = (_f = (_e = pcc.Berth()) !== null && _e !== void 0 ? _e : pcc.NewBerth()) !== null && _f !== void 0 ? _f : pcc.OldBerth(), berthName = (_h = (_g = berth === null || berth === void 0 ? void 0 : berth.Location()) === null || _g === void 0 ? void 0 : _g.Name()) !== null && _h !== void 0 ? _h : '';
    switch (pcc.Type()) {
        case PortCallChangeType_1.PortCallChangeType.Berth:
        case PortCallChangeType_1.PortCallChangeType.Berth_DEPRECATED_20170306:
            return actorName + " changed the berth for the reservation on " + tzmoment_1.tzmoment(pcc.FirstLine()).format("MM/DD/YYYY [at] HH:mm") + " to " + berthName + ".";
        case PortCallChangeType_1.PortCallChangeType.LineTime:
        case PortCallChangeType_1.PortCallChangeType.LineTime_DEPRECATED_20170308:
            if ((+pcc.OldFirstLine() !== +pcc.NewFirstLine()) && (+pcc.OldLastLine() !== +pcc.NewLastLine())) {
                return actorName + " changed First Line time at " + berthName + " to " + tzmoment_1.tzmoment(pcc.NewFirstLine()).format("MM/DD/YYYY [at] HH:mm") + " and the Last Line time to " + tzmoment_1.tzmoment(pcc.NewLastLine()).format("MM/DD/YYYY [at] HH:mm") + ".";
            }
            else if (+pcc.OldFirstLine() !== +pcc.NewFirstLine()) {
                return actorName + " changed First Line time at " + berthName + " to " + tzmoment_1.tzmoment(pcc.NewFirstLine()).format("MM/DD/YYYY [at] HH:mm") + ".";
            }
            else if (+pcc.OldLastLine() !== +pcc.NewLastLine()) {
                return actorName + " changed Last Line time at " + berthName + " to " + tzmoment_1.tzmoment(pcc.NewLastLine()).format("MM/DD/YYYY [at] HH:mm") + ".";
            }
            else {
                return actorName + " changed a line time.";
            }
        case PortCallChangeType_1.PortCallChangeType.Vessel:
            return actorName + " changed the vessel from " + (pcc.OldVessel() ? pcc.OldVessel().Name() : 'a reserved length of ' + pcc.OldLength.Num() + ' ' + pcc.OldLength.UOM()) + " to " + (pcc.NewVessel() ? pcc.NewVessel().Name() : '') + ".";
        case PortCallChangeType_1.PortCallChangeType.LineTimeActual:
            if (pcc.Field() == PortCallChange_1.LineTimeActualField.FirstLineActual)
                return actorName + " logged the " + portCallName + " as moored in " + berthName + " on " + tzmoment_1.tzmoment(pcc.ActualTime()).format("MM/DD/YYYY [at] HH:mm") + " (FirstLine).";
            else
                return actorName + " logged the " + portCallName + " as departed from " + berthName + " at " + tzmoment_1.tzmoment(pcc.ActualTime()).format("MM/DD/YYYY [at] HH:mm") + " (LastLine).";
        case PortCallChangeType_1.PortCallChangeType.AttendingAgent:
            return actorName + " made " + (pcc.NewAgent() ? pcc.NewAgent().FullName() : '---') + " the Attending Agent.";
        case PortCallChangeType_1.PortCallChangeType.Footmark:
        case PortCallChangeType_1.PortCallChangeType.Footmark_DEPRECATED_20170306:
            // TODO: This adds current Length to the historical Footmark, which seems like it'd
            // be more confusing than helpful. Given that both of these events have been replaced
            // by ReservationFootmarkChangedEvents going forward, which DO capture the historical
            // Length, seems like a better option would be to switch back to displaying just the
            // starting footmark here, since that's all these older event types tracked.
            var endmark = pcc.Reservation() && pcc.NewFootmark.add(pcc.Reservation().Length);
            return actorName + " changed the footmarks at " + berthName + " to " + pcc.NewFootmark.toString({ places: 0 }) + " and " + (endmark ? endmark.toString({ places: 0 }) : '--') + ".";
        case PortCallChangeType_1.PortCallChangeType.InvitedEditor:
            return actorName + (pcc.EditorAction() === PortCallChange_1.InvitedEditorPortCallChangeAction.Add ? " added " : " removed ") + (pcc.InvitedEditor() ? pcc.InvitedEditor().FullName() : '') + " as an editor.";
        case PortCallChangeType_1.PortCallChangeType.ShiftAdded:
        case PortCallChangeType_1.PortCallChangeType.ShiftAdded_DEPRECATED_20161117:
            return actorName + " added a shift at " + berthName + " for " + tzmoment_1.tzmoment(pcc.FirstLine()).format("MM/DD/YYYY [at] HH:mm") + " until " + tzmoment_1.tzmoment(pcc.LastLine()).format("MM/DD/YYYY [at] HH:mm" + ".");
        case PortCallChangeType_1.PortCallChangeType.ReservationStatus:
        case PortCallChangeType_1.PortCallChangeType.ReservationStatus_DEPRECATED_20161117:
            return "Status for reservation at " + berthName + " on " + tzmoment_1.tzmoment(pcc.FirstLine()).format("MM/DD/YYYY [at] HH:mm") + " changed to "
                + BerthReservation_1.BerthReservationStatusDisplayName[pcc.NewStatus()]
                // TODO: Why the check on Event.Automation here? Doesn't our actorName logic
                // already handle automations? The logic here seems to have the effect that
                // we'll override any automation name w/ the system name.
                + " by " + (((_j = pcc.Event()) === null || _j === void 0 ? void 0 : _j.Automation()) ? systemName : actorName) + ".";
        case PortCallChangeType_1.PortCallChangeType.Watcher:
            return actorName + (pcc.WatcherAction() === PortCallChange_1.WatcherPortCallChangeAction.Start ? " started " : " stopped ") + "watching this PortCall.";
        case PortCallChangeType_1.PortCallChangeType.Creation:
        case PortCallChangeType_1.PortCallChangeType.Creation_DEPRECATED_20170302:
            // TH 03/02/2017 -- Previously didn't track LastLine for CreationPortCallChanges.
            // If we get one of the deprecated types, display our original message (w/o LastLine).
            // Otherwise show FirstLine and LastLine.
            var originalMessage = ((_l = (_k = portCall === null || portCall === void 0 ? void 0 : portCall.Requestor()) === null || _k === void 0 ? void 0 : _k.FullName()) !== null && _l !== void 0 ? _l : '') + " requested " + berthName + " for " + tzmoment_1.tzmoment(pcc.FirstLine()).format("MM/DD/YYYY [at] HH:mm");
            if (pcc.Type() === PortCallChangeType_1.PortCallChangeType.Creation_DEPRECATED_20170302)
                return originalMessage + ".";
            return originalMessage + " until " + tzmoment_1.tzmoment(pcc.LastLine()).format("MM/DD/YYYY [at] HH:mm") + ".";
        case PortCallChangeType_1.PortCallChangeType.SideTo:
        case PortCallChangeType_1.PortCallChangeType.SideTo_DEPRECATED_20170306:
            return actorName + " changed the pier side to " + BerthReservation_1.VesselSideDisplayName[pcc.NewSide()] + " for the reservation at " + berthName + ".";
        case PortCallChangeType_1.PortCallChangeType.Barge:
            return actorName + " added the vessel " + (pcc.NewBarge() ? pcc.NewBarge().Name() : '') + " to the PortCall.";
        case PortCallChangeType_1.PortCallChangeType.ApprovalCard_DEPRECATED_20161125:
            return actorName + " updated the " + (pcc.ApprovalCardTitle() || '') + " approval card.";
        default:
            break;
    }
}
function pilotJobOrderCancellationLogMessage(_a) {
    var pjoCancellation = _a.pjoCancellation, actorName = _a.actorName;
    var pit = pjoCancellation.PointInTime();
    return actorName + " cancelled the pilot job order for " + (pit ? pit.DisplayVesselIdentifier() : '--') + " at " + (pit ? tzmoment_1.tzmoment(pit.Start.Estimated()).format('MM/DD/YYYY [at] HH:mm') : '--');
}
function pilotJobOrderChangeLogMessage(_a) {
    var pjoChange = _a.pjoChange, actorName = _a.actorName;
    switch (pjoChange.Type()) {
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.Creation:
            var locationText = pjoChange.FromLocation() && pjoChange.ToLocation() ?
                pjoChange.FromLocation().Berth() ?
                    "leaving " + pjoChange.FromLocation().Name() :
                    "going to " + pjoChange.ToLocation().Name() :
                "";
            return actorName + " requested a pilot for the " + pjoChange.DisplayVesselIdentifier() + " " + locationText + " at " + tzmoment_1.tzmoment(pjoChange.StartEstimated()).format("MM/DD/YYYY [at] HH:mm") + ".";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.StartEstimated:
            // TH 03/08/2017 -- We only expect StartEstimated changes to show up for IN movements. We suppress the relevance for OUTs and SHIFTs, in favor of showing the LastLine change for the
            // previous Reservation.
            return actorName + " changed the estimated " + startTimeName(pjoChange) + " time to " + tzmoment_1.tzmoment(pjoChange.NewStartEstimated()).format("MM/DD/YYYY [at] HH:mm") + ".";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.StartActual:
            if (pjoChange.NewStartActual() !== null) {
                if (pjoChange.OldStartActual() === null)
                    return actorName + " logged the pilot aboard the " + pjoChange.DisplayVesselIdentifier() + " on " + tzmoment_1.tzmoment(pjoChange.NewStartActual()).format("MM/DD/YYYY [at] HH:mm") + ".";
                return actorName + " changed the actual " + startTimeName(pjoChange) + " time to " + tzmoment_1.tzmoment(pjoChange.NewStartActual()).format("MM/DD/YYYY [at] HH:mm") + ".";
            }
            return actorName + " removed the actual " + startTimeName(pjoChange) + " time.";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.EndActual:
            if (pjoChange.NewEndActual() !== null) {
                if (pjoChange.OldEndActual() === null)
                    return actorName + " logged the pilot job complete on " + tzmoment_1.tzmoment(pjoChange.NewEndActual()).format("MM/DD/YYYY [at] HH:mm") + ".";
                return actorName + " changed the actual Pilot Complete time to " + tzmoment_1.tzmoment(pjoChange.NewEndActual()).format("MM/DD/YYYY [at] HH:mm") + ".";
            }
            return actorName + " removed the actual Pilot Complete time.";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.StartTimeConfirmed:
            return actorName + " " + (pjoChange.NewStartTimeConfirmed() ? "firmed the " + startTimeName(pjoChange) + " time." : "set the " + startTimeName(pjoChange) + " time to tentative.");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.DeepDraftConfirmed:
            return actorName + " " + (pjoChange.NewDeepDraftConfirmed() ? 'confirmed the draft.' : 'set the draft to tentative.');
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.PilotAssignment:
            return actorName + " " + (pjoChange.Action() === PilotJobOrderChange_1.PilotAssignmentChangeAction.Add ? "added " + pilotName(pjoChange) + " to this job order." : "removed " + pilotName(pjoChange) + " from this job order.");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.PilotConfirmed:
            return actorName + " " + (pjoChange.NewPilotConfirmed() ? "confirmed " + pilotName(pjoChange) + "." : "set " + pilotName(pjoChange) + " to tentative.");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.AirDraft:
            return actorName + " changed the air draft to " + pjoChange.NewAirDraft.toString({ units: true, places: 1 }) + ".";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.DeepDraft:
            return actorName + " changed the deep draft to " + pjoChange.NewDeepDraft.toString({ units: true, places: 1 }) + ".";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.Remarks:
            return actorName + " " + (!pjoChange.NewRemarks() ? "cleared the remarks." : "remarked: " + pjoChange.NewRemarks());
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.CancelledDate_DEPRECATED_20180517:
            return actorName + " " + (pjoChange.NewCancelledDate() !== null ? 'cancelled' : 'reordered')
                + " the pilot job order for " + pjoChange.DisplayVesselIdentifier() + " at "
                + tzmoment_1.tzmoment(pjoChange.StartEstimated()).format("MM/DD/YYYY [at] HH:mm") + ".";
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.TugCompany:
            if (pjoChange.NewTugCompanyId() === null) {
                return actorName + " cleared the tug for this job order.";
            }
            return actorName + (" added " + (pjoChange.NewTugCompany() ? pjoChange.NewTugCompany().Name() : '') + " to this job order.");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.LineHandlingCompany:
            if (pjoChange.NewLineHandlingCompanyId() === null) {
                return actorName + " cleared the line handler for this job order.";
            }
            return actorName + (" added " + (pjoChange.NewLineHandlingCompany() ? pjoChange.NewLineHandlingCompany().Name() : '') + " to this job order.");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.LaborStartTime:
            if (!pjoChange.NewLaborStartTime()) {
                return actorName + " cleared the Labor start time for this job order.";
            }
            return actorName + (" set the Labor start time to " + tzmoment_1.tzmoment(pjoChange.NewLaborStartTime()).format("MM/DD/YYYY [at] HH:mm") + ".");
        case PilotJobOrderChangeType_1.PilotJobOrderChangeType.BowThrusterOperational:
            return (pjoChange.NewBowThrusterOperational() ? actorName + " indicated that the bow thruster is working." :
                pjoChange.NewBowThrusterOperational() === false ? actorName + " indicated that the bow thruster is not working." :
                    actorName + " removed the bow thruster indicator." // set indicator to null
            );
        default:
            break;
    }
}
function vesselChangeLogMessage(_a) {
    var vesselChange = _a.vesselChange, actorName = _a.actorName;
    switch (vesselChange.Type()) {
        case VesselChangeType_1.VesselChangeType.BowThrusterPresent:
            if (vesselChange.NewBowThrusterPresent()) {
                return actorName + " indicates a bow thruster on the vessel.";
            }
            else if (vesselChange.NewBowThrusterPresent() === false) {
                return actorName + " indicates there is no bow thruster on the vessel.";
            }
            else {
                return actorName + " cleared the bow thruster indicator.";
            }
        case VesselChangeType_1.VesselChangeType.BowThrusterSize:
            return actorName + " changed the bow thruster to " + vesselChange.NewBowThrusterSize.toString() + ".";
        default:
            break;
    }
}
function portCallVersionChangeMessage(ev, pcv, pcrv) {
    var t = ev.Type(), data = pcv.ExtraData(), origData = pcrv === null || pcrv === void 0 ? void 0 : pcrv.ExtraData(), vesselName = pcv.VesselId() ? data === null || data === void 0 ? void 0 : data.VesselName : "a requested length of " + fmtM(pcv.LengthOnlyLength), origVesselName = pcrv === null ? '' : pcrv.VesselId() ? origData === null || origData === void 0 ? void 0 : origData.VesselName : "a requested length of " + fmtM(pcrv.LengthOnlyLength);
    return (EventType_1.EventType.PortCallAgentChanged === t ?
        ev.ActorName() + " changed the Attending Agent from " + (origData ? origData.AgentName : '(loading...)') + " to " + (data ? data.AgentName : '(loading...)') + "." :
        EventType_1.EventType.PortCallVesselChanged === t ?
            ev.ActorName() + " changed the vessel from " + (origVesselName || '(loading...)') + " to " + (vesselName || '(loading...)') :
            "");
}
function itineraryPointVersionChangeMessage(ev, ipv, iprv) {
    var _a;
    var t = ev.Type(), data = ipv.ExtraData(), origData = iprv === null || iprv === void 0 ? void 0 : iprv.ExtraData(), portCallName = (_a = data === null || data === void 0 ? void 0 : data.PortCall) === null || _a === void 0 ? void 0 : _a.VesselName, locationName = data === null || data === void 0 ? void 0 : data.LocationName, origLocationName = origData === null || origData === void 0 ? void 0 : origData.LocationName, firstLine = fmtD(ipv.Arrival.Effective()), origFirstLine = iprv && fmtD(iprv.Arrival.Effective()), lastLine = fmtD(ipv.Departure.Effective()), origLastLine = iprv && fmtD(iprv.Departure.Effective()), zeroLength = firstLine === lastLine;
    return (EventType_1.EventType.IPLocationChanged === t ?
        ev.ActorName() + " changed the berth for the reservation on " + firstLine + " from " + (origLocationName || '(loading...)') + " to " + (locationName || '(loading...)') + "." :
        EventType_1.EventType.IPArrivalEffDateChanged === t ?
            ev.ActorName() + " changed the " + (zeroLength || 'First Line') + " time at " + (locationName || '(loading...)') + " from " + (origFirstLine || '(loading...)') + " to " + firstLine + "." :
            EventType_1.EventType.IPDepartureEffDateChanged === t ?
                ev.ActorName() + " changed the " + (zeroLength || 'Last Line') + " time at " + (locationName || '(loading...)') + " from " + (origLastLine || '(loading...)') + " to " + lastLine + "." :
                EventType_1.EventType.IPBothEffDatesChanged === t && zeroLength ?
                    ev.ActorName() + " changed the time at " + (locationName || '(loading...)') + " from " + (origLastLine || '(loading...)') + " to " + lastLine + "." :
                    EventType_1.EventType.IPBothEffDatesChanged === t ?
                        ev.ActorName() + " changed the First Line time at " + (locationName || '(loading...)') + " from " + (origFirstLine || '(loading...)') + " to " + firstLine + " and the Last Line time from " + (origLastLine || '(loading...)') + " to " + lastLine + "." :
                        EventType_1.EventType.IPArrivalLogged === t ?
                            ev.ActorName() + " logged the " + (portCallName || '(loading...)') + " as moored in " + (locationName || '(loading...)') + " on " + firstLine + " (First Line)." :
                            EventType_1.EventType.IPDepartureLogged === t ?
                                ev.ActorName() + " logged the " + (portCallName || '(loading...)') + " as departed from " + (locationName || '(loading...)') + " at " + lastLine + " (Last Line)." :
                                EventType_1.EventType.IPArrivalUnlogged === t && firstLine !== origFirstLine ?
                                    ev.ActorName() + " undid the actual First Line time at " + (locationName || '(loading...)') + ".  Estimated First Line now " + firstLine + "." :
                                    EventType_1.EventType.IPArrivalUnlogged === t ?
                                        ev.ActorName() + " undid the actual First Line time at " + (locationName || '(loading...)') + "." :
                                        EventType_1.EventType.IPDepartureUnlogged === t && lastLine !== origLastLine ?
                                            ev.ActorName() + " undid the actual Last Line time at " + (locationName || '(loading...)') + ".  Estimated Last Line now " + lastLine + "." :
                                            EventType_1.EventType.IPDepartureUnlogged === t ?
                                                ev.ActorName() + " undid the actual Last Line time at " + (locationName || '(loading...)') + "." :
                                                "");
}
function berthReservationVersionChangeMessage(ev, brv, brrv) {
    var t = ev.Type(), data = brv.ExtraData(), pt = data === null || data === void 0 ? void 0 : data.ItineraryPoint, locationName = pt === null || pt === void 0 ? void 0 : pt.LocationName, firstLine = pt && fmtD(pt.Arrival.Effective), footmark = fmtM(brv.Footmark), origFootmark = brrv && fmtM(brrv.Footmark), endmark = fmtM(brv.Footmark.add(brv.Length)), origEndmark = brrv && fmtM(brrv.Footmark.add(brrv.Length));
    return (EventType_1.EventType.ReservationStatusChanged === t ?
        "Status for reservation at " + (locationName || '(loading...)') + " on " + (firstLine || '(loading...)') + " changed from " + (brrv ? BerthReservation_1.BerthReservationStatusDisplayName[brrv.Status()] : '(loading...)') + " to " + BerthReservation_1.BerthReservationStatusDisplayName[brv.Status()] + " by " + ev.ActorName() + "." :
        EventType_1.EventType.ReservationSideToChanged === t ?
            ev.ActorName() + " changed the pier side from " + (brrv ? BerthReservation_1.VesselSideDisplayName[brrv.SideTo()] : '(loading...)') + " to " + BerthReservation_1.VesselSideDisplayName[brv.SideTo()] + " for the reservation at " + (locationName || '(loading...)') + "." :
            EventType_1.EventType.ReservationFootmarkChanged === t ?
                ev.ActorName() + " changed the footmark at " + (locationName || '(loading...)') + " from " + (origFootmark || '(loading...)') + " to " + footmark + " and endmark from " + (origEndmark || '(loading...)') + " to " + (endmark || '(loading...)') + "." :
                "");
}
function ccardEventMessage(ev, ccv, ccrv) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var t = ev.Type(), actorName = ev.ActorAbbreviatedName();
    return (EventType_1.EventType.CCardCancelled === t ?
        "Card cancelled by " + actorName + "." :
        EventType_1.EventType.CCardProviderChanged === t ?
            "Provider changed from " + ((_c = (_b = (_a = ccrv === null || ccrv === void 0 ? void 0 : ccrv.Provider()) === null || _a === void 0 ? void 0 : _a.Provider()) === null || _b === void 0 ? void 0 : _b.Name()) !== null && _c !== void 0 ? _c : '(loading...)') + " to " + ((_f = (_e = (_d = ccv.Provider()) === null || _d === void 0 ? void 0 : _d.Provider()) === null || _e === void 0 ? void 0 : _e.Name()) !== null && _f !== void 0 ? _f : '(loading...)') + " by " + actorName + "." :
            EventType_1.EventType.CCardRequested === t ?
                // TODO: Checking ev.ReferenceId() would let us distinguish brand new coordination (ev.ReferenceId()
                // === null) vs cancelled-then-re-requested coordination (ev.ReferenceId() !== null). Do we want
                // slightly different text in those two cases? 
                "Coordination with " + ((_j = (_h = (_g = ccv.Provider()) === null || _g === void 0 ? void 0 : _g.Provider()) === null || _h === void 0 ? void 0 : _h.Name()) !== null && _j !== void 0 ? _j : '(loading...)') + " requested by " + actorName + "." :
                EventType_1.EventType.CCardStatusUpdate === t ?
                    ccardStatusUpdateMessage(ev, ccv) :
                    '');
}
function ccardStatusUpdateMessage(ev, ccv) {
    var _a, _b, _c;
    // NOTE: A status update event does NOT necessarily represent a CHANGE in status. Can also mean a user
    // reconfirmed the existing status (possibly with a new status reason, but not necessarily) or that multiple
    // upstream events in a row triggered a status reset. So avoiding language like "status changed from blah to
    // blah."
    var actorName = ev.ActorAbbreviatedName();
    if (ccv.StatusId() === CoordinationCardStatuses_1.CoordinationCardStatuses.Pending) {
        var cause = ev.CCardStatusUpdateCause(), causeText = cause.Type() === EventType_1.EventType.CCardProviderChanged ?
            'Provider changed' :
            'Milestone updated';
        return causeText + " by " + actorName + ". " + ccv.EffectiveStatusLabel(true) + " from " + ((_c = (_b = (_a = ccv.Provider()) === null || _a === void 0 ? void 0 : _a.Provider()) === null || _b === void 0 ? void 0 : _b.Name()) !== null && _c !== void 0 ? _c : '(loading...)') + ".";
    }
    else {
        return ccv.EffectiveStatusLabel() + " by " + actorName + ".";
    }
}
function jobOrderVersionChangeMessage(ev, jov, jorv) {
    return "jov change message";
}
// TH 03/08/2017 -- We use different language to describe the start time of IN movements
// vs SHIFT and OUT.
function startTimeName(pjoChange) {
    var _a;
    var isINMvmt = !!((_a = pjoChange.PilotJobOrder()) === null || _a === void 0 ? void 0 : _a.FromPoint())
        && pjoChange.PilotJobOrder().FromPoint().BerthReservation() === null;
    return isINMvmt ? 'Arrival' : 'Departure';
}
function pilotName(pjoChange) {
    var _a, _b, _c;
    // TH 03/01/2017 -- TODO: How do they want the Pilot name displayed?
    // Given that they don't wanna even show the PilotAssignments widget for non-Pilots/Dispatchers,
    // are they comfortable displaying the full Pilot name in the Log?
    return (_c = (_b = (_a = pjoChange.Pilot()) === null || _a === void 0 ? void 0 : _a.User()) === null || _b === void 0 ? void 0 : _b.FullName()) !== null && _c !== void 0 ? _c : '';
}
function fmtD(d) {
    return tzmoment_1.tzmoment(d).format("MM/DD/YYYY [at] HH:mm");
}
function fmtM(m) {
    return m.toString({ places: 0 });
}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIcon = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.LoadingIcon = supercritical_1.default(function (_a) {
    var loading = _a.loading;
    return React.createElement("i", { className: "loadingicon fa fa-spinner fa-spin" + (loading() ? " loading" : '') });
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = exports.HomePageTab = void 0;
var _ = __webpack_require__(67);
var s_js_1 = __webpack_require__(0);
var diacriticals_1 = __webpack_require__(42);
var tzmoment_1 = __webpack_require__(9);
var HomepageTabVisibility_1 = __webpack_require__(1397);
var model_1 = __webpack_require__(90);
var movements_1 = __webpack_require__(1098);
var inport_1 = __webpack_require__(1094);
var cruiseschedule_1 = __webpack_require__(1092);
var map_1 = __webpack_require__(1096);
var FilterStorageKey = 'portcall.homepage.filter';
var CookieComplianceKey = 'portcall.cookie.compliance';
var HomePageTab;
(function (HomePageTab) {
    HomePageTab[HomePageTab["Movements"] = 0] = "Movements";
    HomePageTab[HomePageTab["InPort"] = 1] = "InPort";
    HomePageTab[HomePageTab["Cruise"] = 2] = "Cruise";
    HomePageTab[HomePageTab["Map"] = 3] = "Map";
})(HomePageTab = exports.HomePageTab || (exports.HomePageTab = {}));
;
var HomePageTabs = [
    HomePageTab.Movements,
    HomePageTab.InPort,
    HomePageTab.Cruise,
    HomePageTab.Map
];
function HomePage(params, domain, user, initialDataLoaded, data, tzutils, entrypoints, ajax, movementsLoader, portcallScheduleModel, loginModel) {
    var tab = s_js_1.default.value(tabVisible(params.tab) ? params.tab : HomePageTabs.find(tabVisible) || HomePageTab.Movements), portFilter = s_js_1.default.value(params.port || localStorage[FilterStorageKey] || ''), date = s_js_1.default.value(params.date), now = tzutils.now(), portTypeahead = new model_1.Typeahead({
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        collection: function () { return Array.from(data.Ports.items()); },
        observable: portFilter,
        matchFn: function (port, query) { return diacriticals_1.CaseInsensitiveContains(port.Name(), query); },
        displayKey: function (port) { return port.Name(); }
    }), movements = movements_1.Movements(movementsLoader, data, date, user, portFilterer, function () { return tab() === HomePageTab.Movements; }, tzutils, portcallScheduleModel), inPortVessels = inport_1.InPortVessels(ajax, now, portFilterer, entrypoints, function () { return tab() === HomePageTab.InPort; }), cruiseSchedule = cruiseschedule_1.CruiseSchedule(ajax, portFilterer, entrypoints, function () { return tab() === HomePageTab.Cruise; }), map = map_1.Map(function () { return tab() === HomePageTab.Map; }, data.Locations.items, domain.Settings().Map), showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: true, onHidePopup: function () { return showLogin(false); } }) : null; }), numberOfPorts = function () { return data.Ports.items().size; }, showCompliancy = s_js_1.default.value(localStorage[CookieComplianceKey] || 'not compliant'), isCompliant = function () { return showCompliancy() === 'compliant' ? true : false; };
    // Store port filter
    s_js_1.default(function () { return localStorage[FilterStorageKey] = portFilter(); });
    // Store cookie compliance
    s_js_1.default(function () { return localStorage[CookieComplianceKey] = showCompliancy(); });
    var vm = {
        Domain: domain,
        User: user,
        Tab: tab,
        TabVisible: tabVisible,
        PortFilter: portFilter,
        Date: date,
        Now: now,
        DateToday: function DateToday() { date(tzutils.today()); },
        DateNext: function DateNext() { date(tzmoment_1.tzmomentMod(tzutils, date(), function (m) { return m.add(1, 'd'); })); },
        DatePrev: function DatePrev() { date(tzmoment_1.tzmomentMod(tzutils, date(), function (m) { return m.add(-1, 'd'); })); },
        GoToPortCall: goToPortCall,
        ShowLogin: showLogin,
        PortTypeahead: portTypeahead,
        Movements: movements,
        InPortVessels: inPortVessels,
        CruiseSchedule: cruiseSchedule,
        Map: map,
        Login: login,
        NumberOfPorts: numberOfPorts,
        InitialDataLoaded: initialDataLoaded,
        ShowCompliancy: showCompliancy,
        IsCompliant: isCompliant
    };
    return vm;
    function portFilterer(list, portName) {
        return s_js_1.default(function () {
            return _.filter(list(), function (i) {
                return !portFilter() || diacriticals_1.CaseInsensitiveContains(portName(i), portFilter());
            });
        });
    }
    function goToPortCall(pc) {
        if (!user() || pc.PortCallId == undefined)
            return;
        window.location.hash = "#!portcallprofile?id=" + pc.PortCallId;
    }
    function tabVisible(tab) {
        var settings = domain.Settings() ? domain.Settings().Homepage : null;
        return settings === null ? false :
            tab === HomePageTab.Movements ? tabLogInVisibility(settings.MovementsVisibility()) :
                tab === HomePageTab.InPort ? tabLogInVisibility(settings.InPortVisibility()) :
                    tab === HomePageTab.Cruise ? tabLogInVisibility(settings.CruiseVisibility()) :
                        tab === HomePageTab.Map ? tabLogInVisibility(settings.MapVisibility()) :
                            false;
    }
    function tabLogInVisibility(code) {
        return code === HomepageTabVisibility_1.HomepageTabVisibility.Public
            || (code === HomepageTabVisibility_1.HomepageTabVisibility.LoggedIn && user() !== null);
    }
}
exports.HomePage = HomePage;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageBerths = exports.PageMode = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var autoSave_1 = __webpack_require__(31);
var UOM_1 = __webpack_require__(25);
var Berth_1 = __webpack_require__(107);
var SetPierGroupFootmarksRequest_1 = __webpack_require__(587);
var PageMode;
(function (PageMode) {
    PageMode[PageMode["View"] = 0] = "View";
    PageMode[PageMode["Arrange"] = 1] = "Arrange";
    PageMode[PageMode["Link"] = 2] = "Link";
})(PageMode = exports.PageMode || (exports.PageMode = {}));
function ManageBerths(loader, domain, ajax, entrypoints, addBerthModel, pgFootmarksModel, _a) {
    var portId = _a.portId, mode = _a.mode;
    var selectedPortId = s_js_1.default.data(portId), pageMode = s_js_1.default.data(mode), ports = domain.Ports
        .sort(function (p1, p2) { return p1.Order() - p2.Order(); })
        .map(function (p) { return PortViewModel(p, ajax, entrypoints, selectedPortId, pgFootmarksModel); }), editLinkedBerths = EditLinkedBerthsViewModel(ports), addBerth = addBerthModel({ SchedulingAuthorityId: null });
    s_js_1.default.on(pageMode, function () {
        if (pageMode() === PageMode.Link)
            ports().forEach(function (p) { return p.SelectedBerths.ClearSelectedBerths(); });
    });
    loader({ Id: s_js_1.default.sample(domain.Id) }, 30);
    return {
        SelectedPortId: selectedPortId,
        PageMode: pageMode,
        Ports: ports,
        EditLinkedBerths: editLinkedBerths,
        AddBerth: addBerth
    };
}
exports.ManageBerths = ManageBerths;
function EditLinkedBerthsViewModel(ports) {
    var portsWithSelectedBerths = ports.filter(function (p) { return p.Show() && p.SelectedBerths.HasSelectedBerths(); }), invalidLinkedBerths = function () { return portsWithSelectedBerths().length > 1; }, portWithSelectedBerths = function () { return portsWithSelectedBerths().length === 0 ? null : portsWithSelectedBerths()[0]; };
    return {
        InvalidBerthSelection: invalidLinkedBerths,
        PortWithSelectedBerths: portWithSelectedBerths
    };
}
function PortViewModel(port, ajax, entrypoints, selectedPortId, pgFootmarksModel) {
    var show = function () { return selectedPortId() === null || selectedPortId() === port.Id(); }, pierGroups = port.PierGroups
        .filter(function (pg) { return pg.Berths().length > 0; })
        .map(function (pg) { return PierGroupViewModel(pg, ajax, entrypoints); })
        .sort(function (pg1, pg2) { return pg1.Model.Order() - pg2.Model.Order(); }), selectedBerths = PortSelectedBerthsViewModel(port, pierGroups, ajax, entrypoints, pgFootmarksModel);
    return {
        Model: port,
        Show: show,
        PierGroups: pierGroups,
        SelectedBerths: selectedBerths,
        OnSortPierGroups: OnSortPierGroups
    };
    function OnSortPierGroups(pierGroup, _pierGroups) {
        s_js_1.default.freeze(function () {
            _pierGroups.forEach(function (pg, idx) { return pg.Model.Order(idx); });
        });
    }
}
function PortSelectedBerthsViewModel(port, pierGroups, ajax, entrypoints, pgFootmarksModel) {
    var linkClient = ajax.Url(function () { return entrypoints.LinkBerths({ Id: port.Id() }); }, {
        include: [function (r) { return r.Berths; }],
        useCache: true
    }), selectedBerths = s_array_1.lift(pierGroups.reduce(function (list, next) { return list.concat(next.SelectedBerths()); }, function () { return []; })), req = new SetPierGroupFootmarksRequest_1.SetPierGroupFootmarksRequest(), berthModelsToBerthReqs = new Map(), NewPierGroupFootmarks = pgFootmarksModel({
        req: req,
        pierLengthUOM: port.PierLengthUOM,
        // TODO: Maybe add a UOM toggle? For now, just setting display UOM to the port's Length UOM.
        displayUOM: function () { var _a; return (_a = port.PierLengthUOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; }
    }), Linking = s_js_1.default.value(false);
    selectedBerths.forEach(function (b) { return s_js_1.default.sample(function () {
        var _a;
        // If a new berth is selected, add a matching request to the end of req.Berths. Add
        // to the end to avoid clobbering any reordering that's already been applied to
        // req.Berths.
        var prevReq = req.Berths().length ? req.Berths()[req.Berths().length - 1] : null, 
        // Set new request to start where the previous one ended, or else honor the
        // berth's current StartMark if this is the first berth selected. Users will
        // get a chance to override from here.
        newStartMark = (_a = prevReq === null || prevReq === void 0 ? void 0 : prevReq.StartMark.add(prevReq.Length)) !== null && _a !== void 0 ? _a : b.Model.StartMark, berthReq = new SetPierGroupFootmarksRequest_1.SetBerthFootmarksRequest({
            Id: b.Model.Id(),
            StartMark: {
                Num: newStartMark.Num(),
                UOM: newStartMark.UOM()
            },
            Length: {
                Num: b.Model.Length.Num(),
                UOM: b.Model.Length.UOM()
            }
        });
        berthModelsToBerthReqs.set(b, berthReq);
        req.Berths.push(berthReq);
    }); }, function (b) {
        // If a berth is deselected, remove matching request from req.Berths.
        req.Berths.remove(berthModelsToBerthReqs.get(b));
        berthModelsToBerthReqs.delete(b);
    });
    return {
        HasSelectedBerths: function () { return selectedBerths().length > 0; },
        NewPierGroupFootmarks: NewPierGroupFootmarks,
        CanLink: function () { return selectedBerths().length > 1 && NewPierGroupFootmarks.FootmarksAreValid(); },
        Link: Link,
        Linking: Linking,
        ClearSelectedBerths: ClearSelectedBerths
    };
    function Link() {
        if (Linking())
            return;
        Linking(true);
        linkClient.Post(req).finally(function () { return Linking(false); });
        // TH 12/18/2016 -- Used to need code here to uncheck berths selected
        // for linking. No longer needed as of 2/16/2016 b/c LinkBerthsController
        // now constructs a new PierGroup, which means we'll get a new
        // PierGroupViewModel client-side w/ new BerthViewModels.
    }
    function ClearSelectedBerths() {
        s_js_1.default.freeze(function () {
            selectedBerths().forEach(function (b) { return b.SelectedForLinking(false); });
        });
    }
}
function PierGroupViewModel(pierGroup, ajax, entrypoints) {
    var unlinkUrl = function () { return entrypoints.UnlinkBerths({ Id: pierGroup.Id() }); }, unlinkClient = ajax.Url(unlinkUrl, { useCache: true }), autosaveClient = ajax.Url(function () { return pierGroup.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(pierGroup, autosaveClient), berths = pierGroup.Berths
        .sort(Berth_1.Berth.StartMarkOrder)
        .map(BerthViewModel), selectedBerths = berths.filter(function (b) { return b.SelectedForLinking(); });
    return {
        Model: draft,
        Berths: berths,
        SelectedBerths: selectedBerths,
        Unlink: Unlink
    };
    function Unlink() {
        unlinkClient.Post({});
    }
}
function BerthViewModel(berth) {
    var selectedForLinking = s_js_1.default.data(false);
    return {
        Model: berth,
        SelectedForLinking: selectedForLinking,
        NavigateToProfile: function () { return window.location.hash = '#!berthprofile?id=' + berth.Id(); }
    };
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NewVessel = exports.NewVesselMode = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var OverrideServiceVessel_1 = __webpack_require__(578);
var AddVesselRequest_1 = __webpack_require__(1220);
var NewVesselMode;
(function (NewVesselMode) {
    NewVesselMode["ExternalVesselService"] = "external-vessel-service";
    NewVesselMode["EditExternalVesselOverrides"] = "edit-external-vessel-overrides";
    NewVesselMode["AddManual"] = "add-manual";
})(NewVesselMode = exports.NewVesselMode || (exports.NewVesselMode = {}));
function NewVessel(data, externalVesselSearchModel, editOverridesModel, _a) {
    var lengthUOM = _a.lengthUOM, depthUOM = _a.depthUOM, onSelect = _a.onSelect, onDismiss = _a.onDismiss;
    var ExternalVessel = s_js_1.default.value(null), Overrides = new OverrideServiceVessel_1.OverrideServiceVessel({
        Id: 0,
        Length: { UOM: s_js_1.default.sample(lengthUOM) },
        Beam: { UOM: s_js_1.default.sample(lengthUOM) },
        MaxDraft: { UOM: s_js_1.default.sample(depthUOM) },
        GrossTonnage: { UOM: UOM_1.default.GrossTonnage }
    }), Mode = s_js_1.default.data(NewVesselMode.ExternalVesselService), ReadOnlyOverrides = s_js_1.default.data({}), VesselSearch = externalVesselSearchModel({
        onSelect: function (v) {
            if (v.VesselId != null) {
                s_js_1.default.freeze(function () {
                    onSelect(data.Vessels.update1(null, v.Vessel));
                    onDismiss();
                });
                return;
            }
            ExternalVessel(v);
            // figure out which fields are read-only in the overrides list
            var readOnly = {};
            if (v.Length.Num)
                readOnly.Length = v.Length;
            if (v.Beam.Num)
                readOnly.Beam = v.Beam;
            if (v.Name)
                readOnly.Name = v.Name;
            if (v.IMO)
                readOnly.IMO = v.IMO;
            if (v.MMSID)
                readOnly.MMSID = v.MMSID;
            if (v.CallSign)
                readOnly.CallSign = v.CallSign;
            if (v.VIN)
                readOnly.VIN = v.VIN;
            if (v.VesselType)
                readOnly.VesselType = v.VesselType;
            if (v.GrossTonnage.Num)
                readOnly.GrossTonnage = v.GrossTonnage;
            if (v.FlagId !== null)
                readOnly.VesselFlagId = v.FlagId;
            if (v.MaxDraft.Num)
                readOnly.MaxDraft = v.MaxDraft;
            ReadOnlyOverrides(readOnly);
            Mode(NewVesselMode.EditExternalVesselOverrides);
        },
        onManualEntry: addManual,
        onDismiss: onDismiss
    }), EditOverrides = editOverridesModel({
        Overrides: Overrides,
        ReadOnly: ReadOnlyOverrides,
        uom: lengthUOM,
        onDismiss: onDismiss
    });
    s_js_1.default(function () {
        if (!VesselSearch.CanSearch())
            addManual();
    });
    return {
        ExternalVessel: ExternalVessel,
        Overrides: Overrides,
        CanSave: CanSave,
        Mode: Mode,
        VesselSearch: VesselSearch,
        EditOverrides: EditOverrides,
        CreateRequest: CreateRequest
    };
    function addManual() {
        Mode(NewVesselMode.AddManual);
        ReadOnlyOverrides({});
    }
    function CanSave() {
        return !!((ExternalVessel() && ExternalVessel().Length.Num || Overrides.Length.Num())
            && (ExternalVessel() && ExternalVessel().Name || Overrides.Name())
            && (ExternalVessel() && ExternalVessel().Beam.Num || Overrides.Beam.Num())
            && (ExternalVessel() && ExternalVessel().GrossTonnage.Num || Overrides.GrossTonnage.Num())
            && (ExternalVessel() && (ExternalVessel().CallSign || ExternalVessel().IMO || ExternalVessel().MMSID || ExternalVessel().VIN) ||
                Overrides.CallSign() || Overrides.IMO() || Overrides.MMSID() || Overrides.VIN()));
    }
    function CreateRequest() {
        var ext = ExternalVessel(), req = new AddVesselRequest_1.AddVesselRequest({
            PSixServiceVesselId: ext && ext.PSixServiceVesselId,
            MarineTrafficServiceVesselId: ext && ext.MarineTrafficServiceVesselId,
            LloydServiceVesselId: ext && ext.LloydServiceVesselId
        });
        req.OverrideServiceVessel(Overrides);
        return req;
    }
}
exports.NewVessel = NewVessel;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderableLookupsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(132);
var view_2 = __webpack_require__(29);
var OrderableLookupsView = /** @class */ (function (_super) {
    __extends(OrderableLookupsView, _super);
    function OrderableLookupsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderableLookupsView.prototype.srender = function (_a) {
        var m = _a.model, columns = _a.columns, addBtnText = _a.addBtnText, className = _a.className;
        return (React.createElement("div", { className: cx('orderablelookups', className) },
            React.createElement(ColumnHeaders, { columns: columns }),
            React.createElement(LookupsList, { model: m, columns: columns }),
            m.SupportsAdd && React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.Add) }, addBtnText || '+Add')));
    };
    return OrderableLookupsView;
}(supercritical_1.SuperCriticalComponent));
exports.OrderableLookupsView = OrderableLookupsView;
var ColumnHeaders = supercritical_1.default(function (_a) {
    var columns = _a.columns;
    return React.createElement("div", { className: "column-headers pc-text-label-color" },
        React.createElement("span", { className: "spacer" }),
        columns.map(function (col) {
            return React.createElement("span", { className: col.className, key: col.title }, col.title);
        }));
});
var LookupsList = /** @class */ (function (_super) {
    __extends(LookupsList, _super);
    function LookupsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LookupsList.prototype.srender = function (_a) {
        var m = _a.model, columns = _a.columns;
        return (React.createElement(view_1.PCSortable, { className: "lookup-list", onSort: m.OnSortItems, items: m.Items, rowFactory: function (item) {
                return React.createElement(ListItemView, { item: item, columns: columns, showDeleteBtn: m.ShowDeleteBtn, key: m.ItemKey(item.Model) });
            } }));
    };
    return LookupsList;
}(supercritical_1.SuperCriticalComponent));
var ListItemView = /** @class */ (function (_super) {
    __extends(ListItemView, _super);
    function ListItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemView.prototype.srender = function (_a) {
        var item = _a.item, columns = _a.columns, showDeleteBtn = _a.showDeleteBtn;
        return (React.createElement("li", null,
            React.createElement("div", null,
                React.createElement("a", { href: "", className: cx('delete-btn pc-close-icon', {
                        'hide-delete': !showDeleteBtn || !item.Editing()
                    }), onClick: eventWrappers_1.noDefault(item.Delete) }),
                columns.map(function (col) {
                    return React.createElement(ListItemColumnView, { item: item, column: col, key: col.title });
                }),
                React.createElement("a", { href: "", className: "edit-toggle", onClick: eventWrappers_1.noDefault(function () { return item.Editing(true); }), hidden: item.Editing() }, "Edit"),
                React.createElement("a", { href: "", className: "edit-toggle", onClick: eventWrappers_1.noDefault(function () { return item.Editing(false); }), hidden: !item.Editing() }, "Done")),
            React.createElement("div", null, columns.map(function (col) {
                return React.createElement(view_2.ValidationErrorView, { error: function () { return item.Validation()[col.validationKey]; }, key: col.title });
            }))));
    };
    return ListItemView;
}(supercritical_1.SuperCriticalComponent));
var ListItemColumnView = /** @class */ (function (_super) {
    __extends(ListItemColumnView, _super);
    function ListItemColumnView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemColumnView.prototype.srender = function (_a) {
        var item = _a.item, col = _a.column;
        return col.type === 'textInput' ?
            React.createElement(TextInputListItemColumnView, { item: item, column: col })
            : React.createElement(SelectListItemColumnView, { item: item, column: col });
    };
    return ListItemColumnView;
}(supercritical_1.SuperCriticalComponent));
var TextInputListItemColumnView = /** @class */ (function (_super) {
    __extends(TextInputListItemColumnView, _super);
    function TextInputListItemColumnView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextInputListItemColumnView.prototype.srender = function (_a) {
        var item = _a.item, col = _a.column;
        var prop = col.itemProp(item.Model);
        return (React.createElement("span", null,
            React.createElement(ItemColumnViewModeText, { item: item, prop: prop, className: col.className }),
            React.createElement("input", { className: cx(col.className, 'edit-mode'), value: prop() || '', onChange: function (e) { return prop(e.currentTarget.value); }, hidden: !item.Editing() })));
    };
    return TextInputListItemColumnView;
}(supercritical_1.SuperCriticalComponent));
var SelectListItemColumnView = /** @class */ (function (_super) {
    __extends(SelectListItemColumnView, _super);
    function SelectListItemColumnView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectListItemColumnView.prototype.srender = function (_a) {
        var item = _a.item, col = _a.column;
        var prop = col.itemProp(item.Model);
        return (React.createElement("span", null,
            React.createElement(ItemColumnViewModeText, { item: item, prop: prop, className: col.className }),
            React.createElement("select", { className: cx(col.className, 'edit-mode', 'pc-select'), value: prop() || '', onChange: function (e) { return prop(e.currentTarget.value); }, hidden: !item.Editing() }, col.options().map(function (o) {
                return React.createElement("option", { key: o.value(), value: o.value() }, o.name());
            })),
            React.createElement("span", { className: "pc-select-chevron", hidden: !item.Editing() })));
    };
    return SelectListItemColumnView;
}(supercritical_1.SuperCriticalComponent));
var ItemColumnViewModeText = supercritical_1.default(function (_a) {
    var item = _a.item, prop = _a.prop, className = _a.className;
    return item.Editing() ? null : React.createElement("span", { className: cx(className, 'pc-text-fixedwidth view-mode') }, prop());
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePage = exports.PersonProfilePageParams = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
var tzmoment_1 = __webpack_require__(9);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var uniqueIndex_1 = __webpack_require__(70);
var EventType_1 = __webpack_require__(111);
var PortCallChangeType_1 = __webpack_require__(209);
var LandingPage_1 = __webpack_require__(1277);
var PCUserPortCallEditor_1 = __webpack_require__(579);
var PhoneNumber_1 = __webpack_require__(287);
var model_1 = __webpack_require__(974);
var model_2 = __webpack_require__(153);
var PersonProfilePageParams = /** @class */ (function () {
    function PersonProfilePageParams(id) {
        if (id === void 0) { id = 0; }
        this.id = id;
    }
    return PersonProfilePageParams;
}());
exports.PersonProfilePageParams = PersonProfilePageParams;
function PersonProfilePage(entrypoints, ajax, cache, queryCache, selectProfileImageModel, personProfilePopupModel, phoneNumberModel, params) {
    var model = queryCache.PersonProfilePageResponses.update1(null, { UserId: params.id }), url = entrypoints.PersonProfilePage({ Id: params.id }), request = ajax.Url(url).Get(), editing = s_js_1.default.data(false), userContainer = s_js_1.default(function () { return model.PCUser() && PCUserViewModel(model.PCUser()); }), showChangePassword = s_js_1.default.data(false), changePassword = s_js_1.default(function () { return showChangePassword() ? model_1.ChangePassword({ ajax: ajax, entrypoints: entrypoints, userId: params.id, onHidePopup: function () { return showChangePassword(false); } }) : null; }), showActionsMenu = s_js_1.default.data(false);
    request.done(function (data) {
        s_js_1.default.freeze(function () {
            queryCache.PersonProfilePageResponses.update1(request.Date, data);
            if (data.LandingPages)
                model.LandingPages(data.LandingPages.map(function (lp) { return new LandingPage_1.LandingPage(lp); }));
        });
        // Post to ViewNotifications entrypoint to mark all unviewed notifications as viewed
        // NOTE: we do NOT update the UI after this call. The idea is that these notifications
        // will now appear as viewed the next time the user navigates to this page.
        if (model.CanMarkNotificationsAsViewed()) {
            var viewNotificationsUrl = entrypoints.ViewNotifications.replace('{id}', '' + params.id);
            ajax.Url(viewNotificationsUrl).Post({});
        }
    });
    return {
        Model: model,
        User: userContainer,
        Request: request,
        ChangePassword: changePassword,
        ShowChangePassword: showChangePassword,
        Editing: editing,
        Roles: model.Roles.map(RoleViewModel),
        Notifications: NotificationsViewModel(),
        UIThemes: function () { return Array.from(cache.UIThemes.items()); },
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu,
        GoBack: function () {
            history.back();
        }
    };
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function RoleViewModel(role) {
        var DEFAULT_CHARS = 20, showAll = s_js_1.default.data(false);
        return {
            Model: role,
            ShowAll: showAll,
            Description: function () {
                var descr = role.Description() || '';
                return showAll() ? descr : descr.substr(0, DEFAULT_CHARS) + '...';
            }
        };
    }
    function PCUserViewModel(user) {
        var pcUserClient = ajax.Url(function () { return user.Url() || ''; }), pcUserDraft = autoSave_1.AutoSavingDraftObject(user, pcUserClient), pcUserValidation = validationWatcher_1.ValidationWatcher(pcUserClient), _user = s_js_1.default(function () { return user.User() && UserViewModel(user.User()); }), showSelectProfileImage = s_js_1.default.data(false), imageSelector = s_js_1.default(function () { return showSelectProfileImage() ? ConstructSelectProfileImage() : null; }), showSendPasswordReset = s_js_1.default.data(false), sendPasswordResetModal = s_js_1.default(function () { return showSendPasswordReset() ? SendPasswordResetViewModel(user) : null; }), showDeleteAccount = s_js_1.default.data(false), deleteAccountModal = s_js_1.default(function () { return showDeleteAccount() ? DeleteAccountViewModel(user, function () { return showDeleteAccount(false); }) : null; }), showNotificationSettings = s_js_1.default.data(false), notificationSettingsModal = s_js_1.default(function () { return showNotificationSettings() ? NotificationSettingsViewModel(pcUserDraft, function () { return _user() && _user().Model; }) : null; }), phoneNumbersVM = UserPhoneNumbersViewModel(user), portcallEditorsVM = PortCallEditorsViewModel(user);
        return {
            Model: pcUserDraft,
            Validation: pcUserValidation,
            User: _user,
            ImageSelector: imageSelector,
            ShowSelectProfileImage: showSelectProfileImage,
            PhoneNumbers: phoneNumbersVM,
            PortCallEditors: portcallEditorsVM,
            SendPasswordResetModal: sendPasswordResetModal,
            ShowSendPasswordReset: showSendPasswordReset,
            DeleteAccountModal: deleteAccountModal,
            ShowDeleteAccount: showDeleteAccount,
            NotificationSettingsModal: notificationSettingsModal,
            ShowNotificationSettings: showNotificationSettings
        };
        function ConstructSelectProfileImage() {
            editing(false);
            return selectProfileImageModel({
                image: user.Image,
                allowedImageUploadExtensions: model.Ref.AllowedImageUploadExtensions,
                maximumImageUploadFileSize: model.Ref.MaximumImageUploadFileSize,
                defaultImages: model.Ref.DefaultImages,
                minimumImageUploadImageSize: model.Ref.MinimumImageUploadImageSize,
                saveCroppedUploadUrl: entrypoints.SavePCUserImageUpload({ Id: params.id }),
                saveImageSelection: function () {
                    ajax.Url(function () { return user.Url() || ''; }).Put(user);
                },
                onHide: function () { return showSelectProfileImage(false); }
            });
        }
    }
    function UserViewModel(u) {
        var client = ajax.Url(function () { return u.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(u, client), validation = validationWatcher_1.ValidationWatcher(client);
        return {
            Model: draft,
            Validation: validation
        };
    }
    function UserPhoneNumbersViewModel(user) {
        var client = ajax.Url(function () { return user.PhoneNumbersUrl() || ''; });
        return {
            Numbers: user.PhoneNumbers.map(function (pn) { return phoneNumberModel(pn, function (ts) { return RemoveFromCache(pn, ts); }); }),
            Add: Add
        };
        function Add() {
            var req = client.Post(new PhoneNumber_1.PhoneNumber());
            req.done(function (data) {
                cache.PhoneNumbers.update1(req.Date, data);
            });
        }
        function RemoveFromCache(pn, ts) {
            var id = s_js_1.default.sample(function () { return PhoneNumber_1.PhoneNumber.key(pn); });
            cache.PhoneNumbers.update(ts, [], [id]);
        }
    }
    function PortCallEditorsViewModel(user) {
        var editors = user.PortCallEditors
            .filter(function (editor) { return !editor.PortCallEditor() || editor.PortCallEditor().Active(); })
            .map(function (editor) { return PortCallEditorViewModel(user, editor); }), newEditorSelector = NewEditorUserSelector(user);
        return {
            Editing: s_js_1.default.data(false),
            Editors: editors,
            NewEditorSelector: newEditorSelector
        };
    }
    function PortCallEditorViewModel(user, editor) {
        var showProfile = s_js_1.default.data(false), profilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({ id: editor.PortCallEditorId(), onHidePopup: function () { return showProfile(false); } }) : null; });
        return {
            Editor: function () { return editor.PortCallEditor(); },
            ToggleProfile: function () { return showProfile(!showProfile()); },
            Remove: Remove,
            ProfilePopup: profilePopup
        };
        function Remove() {
            var req = ajax.Url(function () { return editor.Url() || ''; }).Delete();
            req.then(function () {
                var id = s_js_1.default.sample(function () { return PCUserPortCallEditor_1.PCUserPortCallEditor.key(editor); });
                cache.PCUserPortCallEditors.update(req.Date, [], [id]);
            });
        }
    }
    function NewEditorUserSelector(user) {
        var selectedUserId = s_js_1.default.value(0), editorsIdx = uniqueIndex_1.default(user.PortCallEditors, function (editor) { return editor.PortCallEditorId(); }), invitableEditors = model.InvitablePortCallEditors.filter(function (editor) { return !editorsIdx(editor.Id())(); }), userSelector = model_2.UserSelector({
            Users: invitableEditors,
            UserId: selectedUserId
        });
        var lastRequest = Promise.resolve();
        s_js_1.default(function () {
            if (selectedUserId()) {
                var url_1 = (s_js_1.default.sample(user.PortCallEditorsUrlBase) || '').replace('{rightId}', '' + selectedUserId()), client_1 = ajax.Url(url_1);
                lastRequest.finally(function () {
                    var req = client_1.Put({});
                    lastRequest = req.then(function (json) {
                        cache.PCUserPortCallEditors.update1(req.Date, json);
                    });
                });
                // Clear typeahead value
                userSelector.data('');
            }
        });
        return userSelector;
    }
    function DeleteAccountViewModel(user, closeDeleteAccountModal) {
        var client = ajax.Url(function () { return user.Url() || ''; }), action = s_js_1.default.data(null), actionSuccess = function () {
            return !!action() && !!action().Response() && action().Response().Success;
        };
        return {
            Action: action,
            ActionSuccess: actionSuccess,
            Delete: Delete,
            DoneDeleting: DoneDeleting
        };
        function Delete() {
            user.Active(false);
            action(client.Put(user));
        }
        function DoneDeleting() {
            closeDeleteAccountModal();
            // need to use a timeout otherwise modal hide animation doesn't finish
            // and semi-transparent modal backdrop is stuck on screen
            setTimeout(function () {
                window.history.back();
            }, 200);
        }
    }
    function SendPasswordResetViewModel(user) {
        var request = ajax.Url(entrypoints.SendPasswordReset).Post({
            UserId: user.Id()
        });
        return {
            Request: request
        };
    }
    function NotificationsViewModel() {
        var unviewedNotificationsCount = s_js_1.default(function () {
            return model.Notifications().filter(function (notification) { return notification.WebDate() === null; }).length;
        });
        return {
            Notifications: model.Notifications.map(NotificationViewModel),
            UnviewedNotificationsCount: unviewedNotificationsCount,
        };
    }
    function NotificationViewModel(notification) {
        var event = s_js_1.default(function () { return notification.Event() && EventViewModel(notification.Event()); });
        return {
            Model: notification,
            Event: event
        };
    }
    function EventViewModel(event) {
        var pcChange = s_js_1.default(function () {
            if (event.Type() === EventType_1.EventType.PortCallChange)
                return event.PortCallChange() && PortCallChangeViewModel(event.PortCallChange());
            return null;
        }), date = s_js_1.default(function () { return tzmoment_1.tzmoment(event.Date()).format('MM/DD/YY HH:mm'); });
        return {
            Model: event,
            Date: date,
            PortCallChange: pcChange
        };
    }
    function PortCallChangeViewModel(pcChange) {
        var firstLine = s_js_1.default(function () {
            if (pcChange.Type() === PortCallChangeType_1.PortCallChangeType.Creation)
                return tzmoment_1.tzmoment(pcChange.FirstLine());
            return null;
        }), actualDate = s_js_1.default(function () {
            if (pcChange.Type() === PortCallChangeType_1.PortCallChangeType.LineTimeActual)
                return tzmoment_1.tzmoment(pcChange.ActualTime()).format('MM/DD');
            return null;
        });
        return {
            Model: pcChange,
            FirstLineDate: function () { return firstLine() && firstLine().format('MM/DD/YY'); },
            FirstLineTime: function () { return firstLine() && firstLine().format('HH:mm'); },
            ActualDate: actualDate
        };
    }
    function NotificationSettingsViewModel(user, _u) {
        var allowBlank = s_js_1.default.data(false), notificationEmail = function (val) {
            if (arguments.length === 0) {
                var notifEmail = user.NotificationEmail();
                // Use account email as a default value, but also allow user to clear the value
                // for ease of editing
                if (allowBlank())
                    return notifEmail;
                return notifEmail || _u() && _u().Email();
            }
            // Allow blank values
            if (!val)
                allowBlank(true);
            else
                allowBlank(false);
            // Blank value or value equal to account email -> set NotificaitonEmail to null so that defaults to account email
            var newVal = !val || val === s_js_1.default.sample(function () { return _u() && _u().Email(); }) ? null : val;
            user.NotificationEmail(newVal);
            return newVal;
        };
        return {
            NotificationEmail: notificationEmail,
        };
    }
}
exports.PersonProfilePage = PersonProfilePage;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var PhoneNumberKind_1 = __webpack_require__(208);
var view_1 = __webpack_require__(52);
// character limit at which tooltips enabled
var MAX_NUMBER_CHARS = 14;
exports.PhoneNumberView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "phonenumber" },
        React.createElement("span", { className: "pc-input-viewcontrol pc-text-smalllabel phone-kind" }, PhoneNumberKind_1.PhoneNumberKindDisplayName[m.Model.Kind()]),
        React.createElement("select", { className: "pc-select pc-input-editcontrol pc-text-smalllabel phone-kind", value: m.Model.Kind(), onChange: function (e) { return m.Model.Kind(parseInt(e.target.value)); } }, PhoneNumberKind_1.PhoneNumberKinds.map(function (_a) {
            var Id = _a.Id, Name = _a.Name;
            return React.createElement("option", { key: Id, value: Id }, Name);
        })),
        React.createElement("span", { className: "pc-select-chevron pc-input-editcontrol" }),
        React.createElement(view_1.MaxLengthTooltip, { className: "pc-input-viewcontrol number-text pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: m.Model.Number, maxLength: MAX_NUMBER_CHARS }),
        React.createElement("input", { className: "pc-input-editcontrol textinput", type: "text", value: m.Model.Number(), onChange: function (e) { return m.Model.Number(e.target.value); } }),
        React.createElement("a", { href: "#", className: "pc-input-editcontrol", onClick: eventWrappers_1.noDefault(m.Delete) },
            React.createElement("i", { className: "pc-close-icon" })));
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallProfile = exports.TabLog = exports.TabPeople = exports.TabVessel = exports.TabItinerary = exports.PortCallProfileParams = void 0;
var s_js_1 = __webpack_require__(0);
// services
var objectCreate_1 = __webpack_require__(298);
var autoSave_1 = __webpack_require__(31);
var callAll_1 = __webpack_require__(165);
var draftSignals_1 = __webpack_require__(37);
var validationWatcher_1 = __webpack_require__(23);
var TZDate_1 = __webpack_require__(7);
var UOM_1 = __webpack_require__(25);
var diacriticals_1 = __webpack_require__(42);
var uniqueIndex_1 = __webpack_require__(70);
var memoize_1 = __webpack_require__(297);
__webpack_require__(296);
var tzmoment_1 = __webpack_require__(9);
var agentRestrictionsErrorParser_1 = __webpack_require__(259);
// models
var AddCoordinationCardsRequest_1 = __webpack_require__(554);
var CancelPortCallRequest_1 = __webpack_require__(1240);
var BerthReservation_1 = __webpack_require__(79);
var Issue_1 = __webpack_require__(135);
var PhoneNumberKind_1 = __webpack_require__(208);
var ShareType_1 = __webpack_require__(1401);
var ShareScope_1 = __webpack_require__(1400);
var Measurement_1 = __webpack_require__(11);
var ScheduleDate_1 = __webpack_require__(93);
var model_1 = __webpack_require__(151);
var model_2 = __webpack_require__(518);
var model_3 = __webpack_require__(272);
var model_4 = __webpack_require__(153);
var model_5 = __webpack_require__(196);
var PortCallProfileParams = /** @class */ (function () {
    function PortCallProfileParams(id, flipToTab) {
        this.id = id;
        this.flipToTab = flipToTab;
    }
    return PortCallProfileParams;
}());
exports.PortCallProfileParams = PortCallProfileParams;
// TH: Specifies display-time precision for toggleable PC and Vessel fields Length, Beam, Air Draft, and Deep Draft
var lengthConversions = [
    {
        uom: UOM_1.default.Foot,
        // 12/18/2017 DC TODO
        // TH: To display as feet and inches instead of as decimal feet, uncomment the feetAndInches property and comment out the decimalPlaces property.
        // That requires CSS tweaks to make room for the wider field, so in the interest of getting something in, I'm holding off for now.
        //feetAndInches: true
        decimalPlaces: 2
    },
    {
        uom: UOM_1.default.Meter,
        decimalPlaces: 1
    }
];
exports.TabItinerary = { Title: 'Itinerary' };
exports.TabVessel = { Title: 'Vessel' };
exports.TabPeople = { Title: 'People' };
exports.TabLog = { Title: 'Log' };
function PortCallProfile(user, params, entrypoints, ajax, data, cache, tzutils, localizationContext, localVesselSearchModel, newVesselModel, logUpdaterModel, portCallLogModel, personPopupModel, topicCardListItemModel, wartsilaEnrichmentsSummaryCardModel, portcallScheduleModel, addCCardsReqCoordSelStorage, selectCoordinationsModel, portcallReportModel) {
    var _a;
    // initialize model
    var model = cache.PortCallProfileResponses.update1(null, { Id: params.id }), portcallModel = data.PortCalls.update1(null, { Id: params.id }); // makes sure that at least a template PortCall is loaded at model.PortCall();
    // send request to update data
    var url = entrypoints.PortCallProfile({ Id: params.id }), request = ajax.Url(url).Get(), logUpdater = logUpdaterModel({ portcall: portcallModel });
    request.then(function (json) {
        cache.PortCallProfileResponses.update1(request.Date, json);
    });
    var toggleableUom = s_js_1.default.value((_a = s_js_1.default.sample(portcallModel.LengthOnlyLength.UOM)) !== null && _a !== void 0 ? _a : UOM_1.default.Foot), PortCall = PortCallViewModel(portcallModel, ajax, toggleableUom, data);
    var TabStrip = model_5.PCTabStrip(exports.TabItinerary, function () { return [exports.TabVessel, exports.TabPeople, exports.TabLog]; }, params.flipToTab ? { state: 'settled-on-back', tab: params.flipToTab } : { state: 'settled-on-front' });
    // shorthand accessors for common data
    var AllIssues = s_js_1.default(function () {
        var resIssues = PortCall.ActiveReservations().reduce(function (all, r) { return all.concat(r.Issues()); }, []), sdIssues = PortCall.Schedule().reduce(function (all, sd) { return all.concat(sd.Issues()); }, []);
        return __spreadArrays(resIssues, sdIssues);
    }), AllConflicts = s_js_1.default(function () { return AllIssues().filter(function (i) { return i.Severity() >= Issue_1.IssueSeverity.Conflict; }); });
    var serverTopicCardIdx = uniqueIndex_1.default(model.TopicCards, function (c) { return c.Id(); }), topicCardClock = tzutils.clock(1000); // clock for time ago text in topic card display
    // model -> viewmodel memoized maps.  these preserve object identity (1:1 b/w models and viewmodels) so that viewmodels can have state
    var reservationMap = memoize_1.memoize(function (res) { return ReservationViewModel(res, PortCall, ajax, data); }), itineraryPointMap = memoize_1.memoize(function (pt) { return ItineraryPointViewModel(pt, ajax); }), vesselMap = memoize_1.memoize(function (v) { return VesselViewModel(v, ajax, PortCall, toggleableUom); }), topicCardMap = memoize_1.memoize(function (c) { return TopicCardViewModel(c, params.id, ajax, topicCardListItemModel, serverTopicCardIdx, topicCardClock); });
    // viewmodels
    var reservations = s_js_1.default(function () { return PortCall.Reservations().map(reservationMap); }), vessel = s_js_1.default(function () { return PortCall.Vessel() && vesselMap(PortCall.Vessel()); }), topicCards = PortCall.TopicCards.map(topicCardMap), itineraryPts = PortCall.Itinerary.map(itineraryPointMap);
    var portcallReport = portcallReportModel({ pc: portcallModel, hideActionsMenu: function () { return showActionsMenu(false); } });
    // TH: We'll probably move the logic for sync'ing ItineraryPoint times to an app endpoint that takes the entire PortCall itinerary.
    // But for 12/31/15, this gives users a way of editing the SEA itinerary point.
    var pilotTime = function (val) {
        var _portArrival = function () { return itineraryPts().find(function (pt) { return pt.IsPortArrival(); }); }, portArrival = val === undefined ? _portArrival() : s_js_1.default.sample(_portArrival);
        if (val === undefined) {
            return portArrival ? portArrival.Departure.Effective() : new TZDate_1.default();
        }
        if (portArrival) {
            s_js_1.default.freeze(function () {
                portArrival.Arrival.Effective(val);
                portArrival.Departure.Effective(val);
            });
        }
        return val;
    };
    var hasArrived = function () { return itineraryPts().some(function (pt) { return pt.IsPortArrival() && !!pt.Departure.Actual(); }); };
    var showPilotTimeEditPopup = s_js_1.default.data(false), pilotTimeEditPopup = s_js_1.default(function () { return showPilotTimeEditPopup() ?
        model_2.DateTimeEditPopup({
            value: pilotTime,
            onDismiss: function () { return showPilotTimeEditPopup(false); }
        }) : null; });
    var berthTimelineUrl = s_js_1.default(function () {
        var url = '#schedulegrid', res = PortCall.ActiveReservations()[0], pt = res && res.Itinerary();
        if (res && pt) {
            url += '?date=' + tzmoment_1.tzmoment(pt.Arrival.Effective()).add(-1, 'days').format('YYYY-MM-DD')
                + '&resid=' + res.Id();
        }
        return url;
    });
    var Validation = s_js_1.default(function () { return validationWatcher_1.mergeErrors.apply(void 0, __spreadArrays([PortCall.Validation()], reservations().map(function (res) { return res.Validation(); }), itineraryPts().map(function (pt) { return pt.Validation(); }))); }), AgentRestrictions = s_js_1.default(function () { return agentRestrictionsErrorParser_1.agentRestrictionErrors(Validation()); }), ShowAgentRestrictions = s_js_1.default.value(false);
    s_js_1.default(function () { return ShowAgentRestrictions(Object.keys(AgentRestrictions()).length > 0); });
    // modals
    var DeletePortCallModal = DeletePortCallViewModel(ajax, PortCall), CancelPortCallModal = CancelPortCallViewModel(ajax, entrypoints, PortCall), ReserveByLengthModal = ReserveByLengthViewModel(PortCall), ShowExternalVesselSearchModal = s_js_1.default.value(false), ExternalVesselSearchModal = s_js_1.default(function () {
        return ShowExternalVesselSearchModal() ?
            ExternalVesselSearchViewModel(ajax, entrypoints, data, newVesselModel, PortCall, function () { return ShowExternalVesselSearchModal(false); }) :
            null;
    }), IssuesModal = IssuesViewModel(AllIssues), ShowManageCoordinationsModal = s_js_1.default.value(false), ManageCoordinationsModal = s_js_1.default(function () { return ShowManageCoordinationsModal() ?
        ManageCoordinationsViewModel(ajax, entrypoints, addCCardsReqCoordSelStorage, selectCoordinationsModel, PortCall, function () { return ShowManageCoordinationsModal(false); }) :
        null; });
    // sub-component view models
    var shouldPauseCCardLogUpdates = function () {
        var tabState = TabStrip.State();
        return (
        // Pause C-Card log updates if we're not on the Itinerary tab (our front tab), which is where
        // C-Cards appear.
        tabState.state === 'settled-on-back' ||
            tabState.state === 'flipping-to-back' ||
            // And, like the main PC log (see S computation below), also pause C-Card log updates if a PC
            // deletion is in progress or has succeeded, as we expect querying for log updates for a C-Card
            // belonging to a now-deleted PortCall to return an unauthorized response.
            DeletePortCallModal.ActionInProgressOrSucceeded());
    }, 
    // For now, the CoordinationCardController and CancelledCoordinationCardController interfaces are so
    // similar that we'll implement both of them together. We can of course split these later as needed.
    scheduleCCardController = function (_ccard) {
        return {
            ShouldPauseLogUpdates: shouldPauseCCardLogUpdates
        };
    }, Schedule = portcallScheduleModel({
        PortCall: PortCall,
        ccardController: scheduleCCardController,
        cancelledCCardController: scheduleCCardController
    }), People = PeopleViewModel(PortCall, model, user, data, ajax, personPopupModel), vesselSearch = localVesselSearchModel({ onSelect: function (v) { return PortCall.VesselId(v.Id()); } }), portCallLog = portCallLogModel({ portcall: PortCall });
    var showActionsMenu = s_js_1.default.data(false), ShowTabStripActionsMenu = s_js_1.default.value(false);
    // Turn log updater on/off on various triggers...
    s_js_1.default(function () {
        // Basic logic -- run log updates as long as we're on the log tab, or we can get a head start if we
        // know we're flipping to the log tab...
        var tabState = TabStrip.State(), onOrApproachingLogTab = tabState.state === 'settled-on-back' && tabState.tab === exports.TabLog ||
            tabState.state === 'flipping-to-back' && tabState.toTab === exports.TabLog, 
        // ...but also make sure we're not in the process of deleting this PortCall (and haven't already
        // completed that process). That's b/c requesting the log events for a PortCall that doesn't exist
        // will return an unauthorized resp, which would trigger an unneeded login prompt.
        shouldRunLogUpdates = onOrApproachingLogTab && !DeletePortCallModal.ActionInProgressOrSucceeded();
        if (shouldRunLogUpdates)
            logUpdater.start();
        else
            logUpdater.stop();
    });
    var extensions = {
        ResEvents: reservations,
        Schedule: Schedule,
        People: People,
        TopicCardModels: topicCards.sort(function (c1, c2) {
            return c1.Model.Title().toLowerCase() < c2.Model.Title().toLowerCase() ? -1
                : c1.Model.Title().toLowerCase() > c2.Model.Title().toLowerCase() ? 1
                    : 0;
        }),
        Now: function () { return tzutils.now(); },
        ToggleableUomIsFeet: function (val) {
            if (arguments.length === 0)
                return toggleableUom() === UOM_1.default.Foot;
            else {
                var uom = val ? UOM_1.default.Foot : UOM_1.default.Meter;
                toggleableUom(uom);
                return val;
            }
        },
        TabStrip: TabStrip,
        PortCallLog: portCallLog,
        AllIssues: AllIssues,
        AllConflicts: AllConflicts,
        DeletePortCallModal: DeletePortCallModal,
        CancelPortCallModal: CancelPortCallModal,
        ReserveByLengthModal: ReserveByLengthModal,
        ShowExternalVesselSearchModal: ShowExternalVesselSearchModal,
        ExternalVesselSearchModal: ExternalVesselSearchModal,
        IssuesModal: IssuesModal,
        ShowManageCoordinationsModal: ShowManageCoordinationsModal,
        ManageCoordinationsModal: ManageCoordinationsModal,
        LocalizationContext: localizationContext,
        VesselSearch: vesselSearch,
        PortCall: PortCall,
        PortCallReport: portcallReport,
        Vessel: vessel,
        DeclarationOfSecurity: function () { return DOSViewModel(vessel, model.Rights); },
        BerthTimelineUrl: berthTimelineUrl,
        PilotTime: pilotTime,
        HasArrived: hasArrived,
        ShowPilotTimeEditPopup: showPilotTimeEditPopup,
        PilotTimeEditPopup: pilotTimeEditPopup,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu,
        ShowTabStripActionsMenu: ShowTabStripActionsMenu,
        ToggleTabStripActionsMenu: ToggleTabStripActionsMenu,
        TabStripMenuAction: TabStripMenuAction,
        AgentRestrictions: AgentRestrictions,
        ShowAgentRestrictions: ShowAgentRestrictions,
        // Combining PJO's IsRequestingFullPageTakeOver & AllowFullPageTakeOver into ShowPortCallReport
        ShowPortCallReport: function () {
            return !!portcallReport.DisplayedPortCall();
        },
        WartsilaEnrichments: wartsilaEnrichmentsSummaryCardModel({
            portcall: portcallModel,
            // Important: Tell the Wartsila Enrichments card that we aren't ready for
            // initial refresh until we've finished our initial data request. That's b/c
            // the PCProfileController reads Issues, but refreshing performs another
            // EnhancedEstimateQuery, which can potentially add/remove Issues. So we hold
            // off on the refresh to avoid a race.
            readyForInitialRefresh: request
        }),
        GoBack: function () {
            history.back();
        }
    };
    return Object.assign(objectCreate_1.default(model), extensions);
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function ToggleTabStripActionsMenu() {
        ShowTabStripActionsMenu(!s_js_1.default.sample(ShowTabStripActionsMenu));
    }
    function TabStripMenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            ShowTabStripActionsMenu(false);
        }); };
    }
}
exports.PortCallProfile = PortCallProfile;
var commonUserTypeaheadOptions = {
    typeaheadOptions: {
        minLength: 0,
        highlight: true,
        hint: false
    },
    matchFn: function (user, query) {
        var org = user.Organization();
        return diacriticals_1.CaseInsensitiveContains(user.Name(), query)
            || (org !== null && diacriticals_1.CaseInsensitiveContains(org.Name(), query));
    },
    displayKey: function (user) { return user.Name(); }
};
function PeopleViewModel(PortCall, model, user, data, ajax, personPopupModel) {
    var SelectedInvitedEditorId = s_js_1.default.data(null), showUserProfileId = s_js_1.default.data(null);
    // user types and groupings
    var pcUserMap = memoize_1.memoize(function (u) { return PCUserViewModel(u, PortCall, showUserProfileId, ajax, personPopupModel); }), userLookup = function (userId) { var u = data.PCUsers.index(userId)(); return u && pcUserMap(u); }, Requestor = s_js_1.default(function () { return userLookup(PortCall.RequestorId()); }), Agent = s_js_1.default(function () { return userLookup(PortCall.AgentId()); }), SelectedInvitedEditor = s_js_1.default(function () { return userLookup(SelectedInvitedEditorId() || 0); }), 
    // TH: Agency editors are the Agent plus the Agent's "Who Can Edit My PortCalls?" editors.
    // Doing this computation client-side to replace the old server-side computation.
    AgencyEditors = s_js_1.default(function () {
        var ag = Agent();
        if (!ag)
            return [];
        var pce = ag.PortCallEditors().map(function (pce) { return userLookup(pce.PortCallEditorId()); }).filter(function (u) { return u !== null && u.Active(); });
        return [ag].concat(pce);
    }), SchedulingAuthorityEditors = model.SchedulingAuthorityEditors.map(function (u) { return userLookup(u); }).filter(function (u) { return u !== null; }), assignableAgents = model.AssignableAgents.map(function (u) { return userLookup(u); }).filter(function (u) { return u !== null; }), agentAndAssignableAgents = s_js_1.default(function () {
        var ag = Agent();
        if (!ag)
            return [];
        return [ag].concat(assignableAgents().filter(function (u) { return u !== null && u !== ag; }));
    }), InvitedEditors = s_js_1.default(function () { return PortCall.Sharing() && PortCall.Sharing().Shares().filter(function (s) { return s.Scope() === ShareScope_1.ShareScope.User && s.Type() === ShareType_1.ShareType.Owner; }).map(function (s) { return s.User(); }).filter(function (u) { return u !== null; }).map(pcUserMap) || []; }), 
    // Requestor, Agent, Agent's "Who Can Edit My PortCalls" editors, Berth Mgrs, and Invited Editors
    AllEditors = s_js_1.default(function () {
        var all = (Requestor() ? [Requestor()] : []).concat(AgencyEditors(), SchedulingAuthorityEditors(), InvitedEditors().map(pcUserMap));
        return Array.from(new Set(all));
    }), 
    // Short list of editors shown on the people summary (the one on the main portcall flip, as opposed to the People flip)
    // Show requestor plus agency editors, up to 4 people
    ShortEditorsList = s_js_1.default(function () {
        var _requestor = Requestor(), agencyEditorsNoRequestor = AgencyEditors().filter(function (u) { return u !== _requestor; });
        return (_requestor ? [_requestor] : []).concat(agencyEditorsNoRequestor).slice(0, 4);
    }), ShortEditorsListText = s_js_1.default(function () { return ShortEditorsList().map(function (u) { return u.Name(); }).join(', '); }), allEditorsIds = s_js_1.default(function () { return new Set(AllEditors().map(function (e) { return e.Id(); })); }), invitableEditors = s_js_1.default(function () { return Array.from(data.PCUsers.items()).filter(function (u) { return !allEditorsIds().has(u.Id()) && u.Active(); }).map(pcUserMap); });
    var sharesClient = ajax.Url(function () { return PortCall.Sharing() && PortCall.Sharing().SharesUrl() || ''; }, { useCache: true }), userShare = s_js_1.default(function () { return user() && PortCall.Sharing() && PortCall.Sharing().Shares().find(function (s) { return s.UserId() === user().Id(); }) || null; });
    // Typeaheads
    var AgentSelector = model_4.UserSelector({
        UserId: PortCall.AgentId,
        Users: agentAndAssignableAgents
    }), InvitedEditorSelector = model_4.UserSelector({
        UserId: function (id) { return id ? SelectedInvitedEditorId(id) : (SelectedInvitedEditorId() || 0); },
        Users: invitableEditors
    });
    return {
        IsWatching: function () { return userShare() !== null; },
        Agent: Agent,
        AgentSelector: AgentSelector,
        Requestor: Requestor,
        AgencyEditors: AgencyEditors,
        SchedulingAuthorityEditors: SchedulingAuthorityEditors,
        InvitedEditors: InvitedEditors,
        InvitedEditorSelector: InvitedEditorSelector,
        AllEditors: AllEditors,
        ShortEditorsList: ShortEditorsList,
        ShortEditorsListText: ShortEditorsListText,
        InviteEditor: InviteEditor,
        SelectedInvitedEditorId: SelectedInvitedEditorId,
        SelectedInvitedEditor: SelectedInvitedEditor,
        WatchPortCall: WatchPortCall,
    };
    function WatchPortCall() {
        var ushare = userShare();
        if (ushare) {
            var shareClient = ajax.Url(ushare.Url(), { useCache: true });
            shareClient.Delete();
        }
        else {
            var sharingToken = {
                Id: 0,
                Type: ShareType_1.ShareType.Viewer,
                Scope: ShareScope_1.ShareScope.User,
                UserId: user() ? user().Id() : 0,
                TokenId: PortCall.SharingId()
            };
            sharesClient.Post(sharingToken);
        }
    }
    function InviteEditor() {
        var editorId = SelectedInvitedEditorId();
        if (editorId == null)
            return true;
        var share = {
            Id: 0,
            UserId: editorId,
            Scope: ShareScope_1.ShareScope.User,
            Type: ShareType_1.ShareType.Owner,
            TokenId: PortCall.SharingId()
        };
        sharesClient.Post(share).then(function () {
            SelectedInvitedEditorId(null);
            InvitedEditorSelector.data('');
        });
    }
}
function PortCallViewModel(_portcall, ajax, toggleableUom, data) {
    var client = ajax.Url(function () { return _portcall.Url(); }, { useCache: true }), portcallEditables = [
        'AgentId',
        'VesselId',
        'LengthOnlyLength.Num',
        'LengthOnlyLength.UOM',
        'AirDraft.Num',
        'AirDraft.UOM',
        'DeepDraft.Num',
        'DeepDraft.UOM',
        'LastPortOfCall',
        'NextPortOfCall',
        // TH 03/23/2017 -- Unlisted isn't really a data field, since it's computed server-side from UnlistedOverride and Vessel.IsGovernmentVessel.
        // But we'll still include it in our draft object so we can distinguish dirty vs clean state.
        'Unlisted',
        'UnlistedOverride',
        'VoyageNumber'
    ], draft = draftSignals_1.DraftObject(_portcall, portcallEditables), portcall = draft.object, Validation = validationWatcher_1.ValidationWatcher(client);
    autoSave_1.DraftAutoSaver(draft, client);
    portcall.Vessel = s_js_1.default.value(s_js_1.default.sample(_portcall.Vessel));
    data.PortCalls.attach(portcall, [portcall.Vessel]);
    // TH 03/23/2017 -- Update our draft Unlisted status when UnlistedOverride or Vessel are edited.
    // Note that this is just for the purposes of setting the client-side value.
    // The server does its own computation of PortCall.Unlisted.
    s_js_1.default.on(callAll_1.callAll(portcall.UnlistedOverride, portcall.Vessel), function () {
        // TH 03/23/2017 -- Same idea here as for the portcall Length computation above.
        // PortCall.Unlisted and Vessel.IsGovernmentVessel can get out of sync (since our server-side
        // code intentionally limits the scope of PortCalls that can be affected by Vessel IsGovernmentVessel edits).
        // So we wanna distinguish initial data population from true UnlistedOverride or Vessel edits.
        if (portcall.UnlistedOverride() === _portcall.UnlistedOverride() && portcall.Vessel() === _portcall.Vessel())
            return;
        portcall.Unlisted(portcall.UnlistedOverride() !== null ? portcall.UnlistedOverride() :
            portcall.Vessel() !== null ? portcall.Vessel().IsGovernmentVessel() :
                false);
    }, null, true);
    // Make sure to clear any pre-existing LengthOnlyLength when selecting a vessel, whether via local search,
    // external search, etc. LengthOnlyLength and VesselId are mutually exclusive (the server has a validation
    // rule to enforce this).
    s_js_1.default.on(portcall.VesselId, function () {
        if (portcall.VesselId() !== null)
            portcall.LengthOnlyLength.Num(null);
    }, undefined, true);
    return Object.assign(portcall, {
        IsCaching: function () { return draft.methods.isCaching(); },
        ToggleableVesselLength: model_1.ToggleableMeasurement({ backingMeasurement: portcall.VesselLength, uom: toggleableUom, conversions: lengthConversions }),
        ToggleableAirDraft: model_1.ToggleableMeasurement({ backingMeasurement: portcall.AirDraft, uom: toggleableUom, conversions: lengthConversions }),
        ToggleableDeepDraft: model_1.ToggleableMeasurement({ backingMeasurement: portcall.DeepDraft, uom: toggleableUom, conversions: lengthConversions }),
        ToggleUnlistedOverride: function () { return portcall.Unlisted() ? portcall.UnlistedOverride(false) : portcall.UnlistedOverride(true); },
        Validation: Validation
    });
}
function PCUserViewModel(pcUser, PortCall, showUserProfileId, ajax, personPopupModel) {
    var phoneNumbers = pcUser.PhoneNumbers, 
    // divide phone numbers into a main number and other numbers
    // main number is:
    // 1) first mobile number, if user has any mobile numbers
    // 2) otherwise, first number of any type, if user has any numbers at all
    // 3) otherwise, null
    mobileNumbers = function () { return phoneNumbers().filter(function (pn) { return pn.Kind() === PhoneNumberKind_1.PhoneNumberKind.Mobile; }); }, mainPhoneNumber = function () {
        var _mobileNumbers = mobileNumbers(), allNumbers = phoneNumbers();
        return _mobileNumbers.length > 0 ? _mobileNumbers[0]
            : allNumbers.length > 0 ? allNumbers[0]
                : null;
    }, showProfile = function () { return showUserProfileId() === pcUser.Id(); };
    return Object.assign(objectCreate_1.default(pcUser), {
        MobileNumbers: mobileNumbers,
        MainPhoneNumber: mainPhoneNumber,
        Name: function () { return pcUser.FullName(); },
        ShowProfile: showProfile,
        ProfilePopup: s_js_1.default(function () { return showProfile() ? personPopupModel({ id: pcUser.Id(), onHidePopup: function () { return showUserProfileId(0); } }) : null; }),
        ToggleProfile: ToggleProfile,
        DeleteInvitedEditorShare: DeleteInvitedEditorShare
    });
    function ToggleProfile() {
        showUserProfileId(s_js_1.default.sample(showProfile) ? null : pcUser.Id());
    }
    function DeleteInvitedEditorShare() {
        var share = pcUser.Shares().find(function (s) { return s.TokenId() === (PortCall.Sharing() ? PortCall.Sharing().Id() : 0); });
        if (!share)
            return;
        ajax.Url(function () { return share.Url(); }, { useCache: true }).Delete();
    }
}
function DeletePortCallViewModel(ajax, portcall) {
    var Show = s_js_1.default.data(false), client = ajax.Url(function () { return portcall.Url(); }, { useCache: true }), Action = s_js_1.default.data(null), ActionSuccess = s_js_1.default(function () {
        return Action() && Action().Response() && Action().Response().Success;
    }), ActionInProgressOrSucceeded = function () { return !!Action() && (!Action().Response() || Action().Response().Success); };
    return {
        Show: Show,
        Action: Action,
        ActionSuccess: ActionSuccess,
        ActionInProgressOrSucceeded: ActionInProgressOrSucceeded,
        Delete: Delete,
        DoneDeleting: DoneDeleting
    };
    function Delete() {
        Action(client.Delete());
    }
    function DoneDeleting() {
        Show(false);
        // need to use a timeout otherwise modal hide animation doesn't finish
        // and semi-transparent modal backdrop is stuck on screen
        setTimeout(function () {
            window.location.hash = '#!schedulegrid';
        }, 200);
    }
}
function CancelPortCallViewModel(ajax, entrypoints, portcall) {
    var client = ajax.Url(entrypoints.CancelPortCall({ Id: portcall.Id() }), { useCache: true }), Req = new CancelPortCallRequest_1.CancelPortCallRequest(), Show = s_js_1.default.data(false), Working = s_js_1.default.data(false), Success = s_js_1.default.data(false);
    return {
        Req: Req,
        Show: Show,
        Working: Working,
        Success: Success,
        Cancel: Cancel
    };
    function Cancel() {
        Working(true);
        client.Post(Req).then(function () { return Success(true); }).finally(function () { return Working(false); });
    }
}
function ItineraryPointViewModel(pt, ajax) {
    // TH: We'll probably move the logic for editing ItineraryPoint times to an app endpoint that takes the entire PortCall itinerary.
    // In which case we probably won't hit the ApiItineraryPointController.
    // But for 12/31/15, this gives users a way of editing the SEA itinerary point.
    var client = ajax.Url(function () { return pt.Url(); }, { useCache: true }), editables = ['Arrival.Estimated', 'Arrival.Actual', 'Departure.Estimated', 'Departure.Actual'], draft = autoSave_1.AutoSavingDraftObject(pt, client, editables), Validation = validationWatcher_1.ValidationWatcher(client);
    draft.Arrival.Effective = ScheduleDate_1.EffectiveDate(draft.Arrival);
    draft.Departure.Effective = ScheduleDate_1.EffectiveDate(draft.Departure);
    return Object.assign(objectCreate_1.default(draft), {
        Validation: Validation
    });
}
function ReservationViewModel(res, portcall, ajax, data) {
    var client = ajax.Url(function () { return res.Url() || ''; }, { useCache: true }), 
    // TODO: Sort out what of the footmark and side to stuff is staying here and what moves into
    // the new in port ops viewmodel. At least some probably stays here b/c in port ops needs to
    // support both new entities (add portcall) and existing entities (here).
    //
    // Distinguish different "tiers" of draft objects...
    // ...starting with Length.Num in a tier all by itself, b/c it doesn't need to get
    // saved (the server applies its own logic for computing it), but we still wanna
    // distinguish the draft value from the persisted value...
    draftForLength = draftSignals_1.DraftObject(res, [
        'Length.Num'
    ]), 
    // ...and then those properties that auto-save.
    draft = draftSignals_1.DraftObject(draftForLength.object, [
        'Footmark.Num',
        'SideTo'
    ]), Validation = validationWatcher_1.ValidationWatcher(client);
    // Wire up our auto-saver.
    autoSave_1.DraftAutoSaver(draft, client);
    // Keep reservation length up-to-date when changing vessel or side to. This is purely for
    // client-side purposes (fast feedback when making changes) -- the server applies its own
    // version of the same logic.
    s_js_1.default(function (isInitialRun) {
        var _a, _b, _c, _d;
        // Propagate portcall changes to non-cancelled reservations only, but update for SideTo
        // changes whether or not the reservation is cancelled.
        if (draft.object.CancelledDate() === null || draft.object.SideTo() !== res.SideTo()) {
            var newLength = BerthReservation_1.BerthReservation.calculateLength((_b = (_a = portcall.Vessel()) === null || _a === void 0 ? void 0 : _a.Length) !== null && _b !== void 0 ? _b : null, (_d = (_c = portcall.Vessel()) === null || _c === void 0 ? void 0 : _c.Beam) !== null && _d !== void 0 ? _d : null, portcall.LengthOnlyLength, draft.object.SideTo(), res.Length.UOM());
            // Apply new length so long as we computed a usable value, but only if this is a
            // follow up run of this computation (due to data changing). Otherwise, leave
            // existing length as is whether it agrees w/ our computed length or not.
            if ((newLength === null || newLength === void 0 ? void 0 : newLength.Num()) && !isInitialRun)
                draft.object.Length.set(newLength);
        }
        return false;
    }, true);
    // Revert draft Length.Num changes when we've persisted all pending changes to this
    // reservation and to our PortCall, as at that point the server should have calculated the
    // new length itself and we should have applied that value to our data cache.
    s_js_1.default(function () {
        if (draftForLength.methods.isCaching() && !draft.methods.isCaching() && !portcall.IsCaching()) {
            draftForLength.methods.checkpoint().revert();
        }
    });
    return {
        Model: draft.object,
        Validation: Validation
    };
}
function TopicCardViewModel(card, pcId, ajax, topicCardListItemModel, serverTopicCardIdx, clock) {
    var serverTopicCard = serverTopicCardIdx(card.Id), canConfirm = function () { return serverTopicCard() ? serverTopicCard().CanConfirm() : false; }, client = ajax.Url(function () { return card.Url() || ''; }, { useCache: true }), draft = autoSave_1.AutoSavingDraftObject(card, client, [
        // TH 12/08/2016 -- Workaround. When I didn't explicitly set props,
        // the draft created a draft signal for card.Comments, which caused
        // its runtime type to change from an ArrayDataSignal to a plain function,
        // which caused TopicCardListItem to throw at runtime.
        // This is just a general typing issue w/ draft objects and child collections.
        'ConfirmedDate',
        'DeniedDate'
    ]), listItem = topicCardListItemModel({ draft: draft, canConfirm: canConfirm, clock: clock });
    return {
        Model: draft,
        ListItem: listItem,
        GoToCard: function () { return window.location.hash = "#!topiccards?id=" + pcId + "&cardId=" + card.Id(); }
    };
}
function IssuesViewModel(Issues) {
    var Show = s_js_1.default.data(false);
    return { Show: Show, Issues: Issues };
}
function ReserveByLengthViewModel(portcall) {
    var _a, _b;
    var Show = s_js_1.default.data(false), newVesselLength = new Measurement_1.Measurement({ Num: (_a = s_js_1.default.sample(portcall.LengthOnlyLength.Num)) !== null && _a !== void 0 ? _a : 0, UOM: (_b = s_js_1.default.sample(portcall.LengthOnlyLength.UOM)) !== null && _b !== void 0 ? _b : UOM_1.default.Foot }), newVesselUom = s_js_1.default.data(s_js_1.default.sample(newVesselLength.UOM)), ToggleableNewVesselLength = model_1.ToggleableMeasurement({ backingMeasurement: newVesselLength, uom: newVesselUom, conversions: lengthConversions }), ToggleableAirDraft = model_1.ToggleableMeasurement({ backingMeasurement: portcall.AirDraft, uom: newVesselUom, conversions: lengthConversions }), ToggleableDeepDraft = model_1.ToggleableMeasurement({ backingMeasurement: portcall.DeepDraft, uom: newVesselUom, conversions: lengthConversions });
    return {
        Show: Show,
        ToggleableNewVesselLength: ToggleableNewVesselLength,
        ToggleableAirDraft: ToggleableAirDraft,
        ToggleableDeepDraft: ToggleableDeepDraft,
        NewVesselIsFeet: function (val) {
            if (val === undefined)
                return newVesselUom() === UOM_1.default.Foot;
            else {
                var uom = val ? UOM_1.default.Foot : UOM_1.default.Meter;
                newVesselUom(uom);
                return val;
            }
        },
        SaveLength: SaveLength,
        //VesselImageUrl: content.VesselImageUrl,
        PortCallDrafts: portcall
    };
    function SaveLength() {
        s_js_1.default.freeze(function () {
            portcall.VesselId(null);
            portcall.LengthOnlyLength.set(newVesselLength);
            Show(false);
        });
    }
}
function ExternalVesselSearchViewModel(ajax, entrypoints, data, newVesselModel, PortCall, onDismiss) {
    var NewVessel = newVesselModel({
        lengthUOM: function () { var _a; return (_a = PortCall.LengthOnlyLength.UOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; },
        depthUOM: function () { var _a; return (_a = PortCall.DeepDraft.UOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; },
        onSelect: function (v) { return PortCall.VesselId(v.Id()); },
        onDismiss: onDismiss
    }), ShowSave = function () { return NewVessel.Mode() != model_3.NewVesselMode.ExternalVesselService; }, saving = s_js_1.default.value(false);
    return {
        NewVessel: NewVessel,
        Cancel: onDismiss,
        Save: Save,
        Saving: function () { return saving(); },
        ShowSave: ShowSave
    };
    function Save() {
        if (saving())
            return;
        saving(true);
        var request = NewVessel.CreateRequest();
        var req = ajax.Url(entrypoints.AddVessel, { include: [function (r) { return r.OverrideServiceVessel; }] }).Post(request);
        req.then(function (json) { return s_js_1.default.freeze(function () {
            data.Vessels.update1(req.Date, json);
            PortCall.VesselId(json.Id);
            onDismiss();
        }); }).finally(function () { return saving(false); });
    }
}
function VesselViewModel(vessel, ajax, PortCall, toggleableUom) {
    var client = ajax.Url(function () { return vessel.Url(); }), editables = [
        'DOS.ExpirationDate',
        'DOS.EffectiveDate',
        'DOS.IssuedBy'
    ], draft = autoSave_1.AutoSavingDraftObject(vessel, client, editables), validation = validationWatcher_1.ValidationWatcher(client);
    var toggleableLength = model_1.ToggleableMeasurement({ backingMeasurement: draft.Length, uom: toggleableUom, conversions: lengthConversions }), toggleableBeam = model_1.ToggleableMeasurement({ backingMeasurement: draft.Beam, uom: toggleableUom, conversions: lengthConversions });
    return Object.assign(objectCreate_1.default(draft), {
        ToggleableLength: toggleableLength,
        ToggleableBeam: toggleableBeam,
        Validation: validation
    });
}
function DOSViewModel(vesselDraft, rights) {
    var vessel = vesselDraft();
    if (vessel === null)
        return null;
    return Object.assign(objectCreate_1.default(vessel.DOS), {
        Rights: rights
    });
}
function ManageCoordinationsViewModel(ajax, entrypoints, addCCardsReqCoordSelStorage, selectCoordinationsModel, PortCall, onDismiss) {
    var url = function () { return entrypoints.AddCoordinationCards({ Id: PortCall.Id() }); }, client = ajax.Url(url, {
        useCache: true,
        include: [function (r) { return r.RequestedCards; }]
    }), Request = new AddCoordinationCardsRequest_1.AddCoordinationCardsRequest(), SelectCoordinations = selectCoordinationsModel({
        PortCall: PortCall,
        SelectionStorage: addCCardsReqCoordSelStorage({ Request: Request })
    }), Submitting = s_js_1.default.value(false);
    return {
        SelectCoordinations: SelectCoordinations,
        Submitting: Submitting,
        CanSubmit: CanSubmit,
        Submit: Submit,
        Cancel: onDismiss
    };
    function CanSubmit() {
        return Request.RequestedCards().length > 0 && SelectCoordinations.IsValidForSubmit();
    }
    function Submit() {
        if (Submitting())
            return;
        Submitting(true);
        client.Post(Request).then(onDismiss).finally(function () { return Submitting(false); });
    }
}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewReservationTool = exports.EditTimeblockTool = exports.BerthClosureOverlapsTool = exports.ReservationOverlapsTool = exports.BerthClosureDetailsTool = exports.UnlistedReservationDetailsTool = exports.ReservationDetailsTool = exports.AddShiftTool = exports.AttentionGrabber = exports.ChangeBerthTool = exports.AddBerthClosureModel = exports.DateRangeModel = exports.PierGroupModel = exports.PortModel = exports.DayModel = exports.ScheduleGrid = exports.ScheduleGridParams = exports.SelectMode = exports.berthBarWidth = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var nonuniqueIndex_1 = __webpack_require__(117);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var callAll_1 = __webpack_require__(165);
var draftSignals_1 = __webpack_require__(37);
var validationWatcher_1 = __webpack_require__(23);
var clientSideValidation_1 = __webpack_require__(598);
var diacriticals_1 = __webpack_require__(42);
var debounceSignal_1 = __webpack_require__(81);
var memoize_1 = __webpack_require__(297);
var UOM_1 = __webpack_require__(25);
var requestQueue_1 = __webpack_require__(300);
var Measurement_1 = __webpack_require__(11);
var ScheduleDate_1 = __webpack_require__(93);
var PierMark_1 = __webpack_require__(159);
var BerthClosure_1 = __webpack_require__(561);
var BerthReservation_1 = __webpack_require__(79);
var BollardPosition_1 = __webpack_require__(563);
var ItineraryPoint_1 = __webpack_require__(69);
var Berth_1 = __webpack_require__(107);
var BerthReservation_2 = __webpack_require__(38);
var Rights_1 = __webpack_require__(118);
var BerthReservation_3 = __webpack_require__(38);
var model_1 = __webpack_require__(508);
var scheduleConstants_1 = __webpack_require__(191);
var model_2 = __webpack_require__(90);
var IssueType_1 = __webpack_require__(112);
// TEMPORARY pixel values for sizing calculations
// TODO calculate pixel sizing in view and send info to model as needed
var MOBILE_THRESHOLD = 480; //MOBILE_THRESHOLD = @screen-size-phone-sm;
function berthBarWidth(screenWidth) {
    var STANDARD_BERTH_BAR = 200, MOBILE_BERTH_BAR = 125;
    if (screenWidth <= MOBILE_THRESHOLD) {
        return MOBILE_BERTH_BAR;
    }
    return STANDARD_BERTH_BAR;
}
exports.berthBarWidth = berthBarWidth;
var SelectMode;
(function (SelectMode) {
    SelectMode[SelectMode["Details"] = 1] = "Details";
    SelectMode[SelectMode["ChangeBerth"] = 2] = "ChangeBerth";
    SelectMode[SelectMode["EditTimeblock"] = 3] = "EditTimeblock";
    SelectMode[SelectMode["AddShift"] = 4] = "AddShift";
    SelectMode[SelectMode["ViewOverlaps"] = 5] = "ViewOverlaps";
})(SelectMode = exports.SelectMode || (exports.SelectMode = {}));
var ScheduleGridParams = /** @class */ (function () {
    function ScheduleGridParams(compact, date, resid, uresid, bclid, port, capability, mode, backOnComplete) {
        this.compact = compact;
        this.date = date;
        this.resid = resid;
        this.uresid = uresid;
        this.bclid = bclid;
        this.port = port;
        this.capability = capability;
        this.mode = mode;
        this.backOnComplete = backOnComplete;
    }
    return ScheduleGridParams;
}());
exports.ScheduleGridParams = ScheduleGridParams;
// static values
var timeIncrement = 15, // minimum time increment of a drag-and-drop operation
pierMarkIncrement = 5; // minimum footmark increment of a drag-and-drop operation;
var ScheduleGrid = function (params, user, tzutils, cache, data, entrypoints, ajax, Localization) {
    var CompactView = s_js_1.default.value(params.compact), // all days the application has seen to date
    allDays = {}, DateRange = new DateRangeModel(params, allDays, tzutils, CompactView);
    var model = cache.ScheduleGridResponses.update1(null, { From: s_js_1.default.sample(DateRange.FromDate).toJSON(), To: s_js_1.default.sample(DateRange.ToDate).toJSON() });
    // we'll update the model ASAP, but for the time being, seed it with all known timeline items in the date range
    model.BerthReservations(s_js_1.default.sample(function () { return Array.from(data.BerthReservations.items()).filter(function (r) { return DateRange.OverlapsPosition(timelinePositionForReservation(r)); }); }));
    model.UnlistedReservations(s_js_1.default.sample(function () { return Array.from(data.UnlistedBerthReservations.items()).filter(function (ur) { return DateRange.OverlapsPosition(timelinePositionForUnlistedReservation(ur)); }); }));
    model.BerthClosures(s_js_1.default.sample(function () { return Array.from(data.BerthClosures.items()).filter(function (bcl) { return DateRange.OverlapsPosition(timelinePositionForBerthClosure(bcl)); }); }));
    var CurrentTool = s_js_1.default.value(null);
    var reservationSets = s_array_1.default([model.BerthReservations]), uniqueReservationIds = function () { return uniqueIds(reservationSets, data.BerthReservations.index); }, reservationMap = memoize_1.memoize(function (id) { return ReservationModel(id, ajax, data, model.PortCallRights); }), reservations = s_array_1.lift(s_js_1.default(function () { return uniqueReservationIds().map(reservationMap); })), unlistedReservationSets = s_array_1.default([model.UnlistedReservations]), uniqueUnlistedReservationIds = function () { return uniqueIds(unlistedReservationSets, data.UnlistedBerthReservations.index); }, unlistedReservationMap = memoize_1.memoize(function (id) { return UnlistedReservationModel(id, data); }), unlistedReservations = s_array_1.lift(s_js_1.default(function () { return uniqueUnlistedReservationIds().map(unlistedReservationMap); })), berthClosureSets = s_array_1.default([model.BerthClosures]), uniqueBerthClosureIds = function () { return uniqueIds(berthClosureSets, data.BerthClosures.index); }, addClosureBerths = s_array_1.lift(function () { return Array.from(data.Berths.items()); })
        .filter(function (b) { return (model.BerthRights()[b.Id()] & Rights_1.BerthRights.AddClosure) !== 0; }), berthClosureMap = memoize_1.memoize(function (id) { return BerthClosureModel(id, ajax, data, model.BerthClosureRights, addClosureBerths); }), berthClosures = s_array_1.lift(s_js_1.default(function () { return uniqueBerthClosureIds().map(berthClosureMap); })), timelineItems = reservations
        .concat(unlistedReservations)
        .concat(berthClosures), 
    // Index timeline items by PierGroup for constructing our PierGroupModels. This also
    // handles the fact that we may have draft changes to a timeline item's Berth, and
    // therefore we can't use properties like PierGroup.Reservations() that are based on
    // the committed state of the world.
    piergroupTimelineItems = nonuniqueIndex_1.default(timelineItems, function (i) { var pos = i.TimelinePosition(); return pos.Berth() && pos.Berth().PierGroupId() || 0; }), piergroupMap = memoize_1.memoize(function (pg) { return new PierGroupModel(pg, piergroupTimelineItems(s_js_1.default.sample(pg.Id))
        .filter(function (i) { return DateRange.OverlapsPosition(i.TimelinePosition()); })
        .sort(timelineItemDisplayOrder)); }), portMap = memoize_1.memoize(function (port) { return new PortModel(port, port.PierGroups.orderBy(function (pg) { return pg.Order(); }).map(piergroupMap)); }), Ports = s_js_1.default(function () { return Array.from(data.Ports.items()).sort(function (a, b) { return a.Order() - b.Order(); }).map(portMap); });
    // make sure current DateRange contains the given timeline item
    var PanToTimelinePosition = function (pos) {
        if (pos.Start() && pos.End() && (pos.Start() > DateRange.ToDate() || pos.End() < DateRange.FromDate())) {
            DateRange.PanToViewDate(pos.Start());
        }
    }, PanToTimelineItem = function (i) { return PanToTimelinePosition(i.TimelinePosition()); };
    var 
    // Clock for determining "... ago" text in overlaps popups
    overlapsClock = s_js_1.default(function () {
        var tool = CurrentTool();
        return (tool instanceof ReservationOverlapsTool ||
            tool instanceof BerthClosureOverlapsTool ||
            null) && tzutils.clock(60 * 1000);
    }), overlapsNow = function () { return overlapsClock() ? overlapsClock().now() : tzutils.now(); };
    var ChangeTool = {
        None: function () { CurrentTool(null); },
        ReservationDetails: function (r) { var _r = reservationMap(r.Id()); PanToTimelineItem(_r); CurrentTool(new ReservationDetailsTool(_r, ChangeTool)); },
        UnlistedReservationDetails: function (ur) { var _ur = unlistedReservationMap(ur.Id()); PanToTimelineItem(_ur); CurrentTool(new UnlistedReservationDetailsTool(_ur, ChangeTool)); },
        BerthClosureDetails: function (bcl) { var _bcl = berthClosureMap(bcl.Id()); PanToTimelineItem(_bcl); CurrentTool(new BerthClosureDetailsTool(_bcl, ChangeTool)); },
        ChangeBerth: function (r) { var _r = reservationMap(r.Id()); PanToTimelineItem(_r); CurrentTool(new ChangeBerthTool(_r, piergroupMap, ChangeTool)); },
        EditTimeblock: function (r) { var _r = reservationMap(r.Id()); PanToTimelineItem(_r); CurrentTool(new EditTimeblockTool(_r, ChangeTool, tzutils)); },
        AddShift: function (r) { var _r = reservationMap(r.Id()); PanToTimelineItem(_r); CurrentTool(new AddShiftTool(r.PortCall(), ChangeTool, reservationSets, ajax, entrypoints, tzutils)); },
        ReservationOverlaps: function (r) { var _r = reservationMap(r.Id()); PanToTimelineItem(_r); CurrentTool(new ReservationOverlapsTool(_r, overlapsNow, data, ChangeTool)); },
        BerthClosureOverlaps: function (bcl) { var _bcl = berthClosureMap(bcl.Id()); PanToTimelineItem(_bcl); CurrentTool(new BerthClosureOverlapsTool(_bcl, overlapsNow, data, ChangeTool)); }
    }, Validation = function () {
        var tool = CurrentTool();
        return tool && (tool.Validation ? tool.Validation() : null) || {};
    }, ShowErrorModal = s_js_1.default.data(false);
    // TH 02/14/2017 -- Show error modal on validation errors
    s_js_1.default(function () { return ShowErrorModal(Object.keys(Validation()).length > 0); });
    var nextScrollToToolReqId = 0;
    var ScrollToToolReqId = s_js_1.default.value(null), RequestScrollToCurrentTool = function () { return ScrollToToolReqId(nextScrollToToolReqId++); };
    // If a new tool is selected, request scrolling to it.
    s_js_1.default(function () {
        if (CurrentTool())
            RequestScrollToCurrentTool();
    });
    // Handle accepting/rejecting proposed date range changes by asking the current tool (if any) whether it
    // wants to stay in view.
    s_js_1.default(function () {
        var _a, _b, _c;
        var tool = CurrentTool(), pos = (_b = (_a = tool === null || tool === void 0 ? void 0 : tool.TimelinePosition) === null || _a === void 0 ? void 0 : _a.call(tool)) !== null && _b !== void 0 ? _b : (_c = tool === null || tool === void 0 ? void 0 : tool.TimelineItem) === null || _c === void 0 ? void 0 : _c.TimelinePosition();
        // First off, do we have a date discrepancy, meaning the proposed date range fails to overlap the
        // selected item?
        if ((pos === null || pos === void 0 ? void 0 : pos.Start()) && pos.End() && !DateRange.ProposalOverlapsPosition(pos)) {
            s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
                var _a, _b;
                // Yes, we have a date discrepancy. Test whether rejecting the proposed dates would be enough to
                // keep the selected item in view....
                if (DateRange.OverlapsPosition(pos)) {
                    // Yes, rejecting the proposed dates would keep the current item in view. Ask the tool if
                    // it wants to stay selected or not....
                    var newTool = (_b = (_a = tool === null || tool === void 0 ? void 0 : tool.OnDateDiscrepancy) === null || _a === void 0 ? void 0 : _a.call(tool)) !== null && _b !== void 0 ? _b : null;
                    if (tool === newTool) {
                        // Yup, the tool wants to stay selected, so reject the proposed dates and give users some
                        // UI feedback about the rejection.
                        DateRange.RejectProposedDates();
                        RequestScrollToCurrentTool();
                    }
                    else {
                        // The current tool offered us another tool (or null) to select instead. Accept the
                        // proposed dates and select that new tool (or null).
                        DateRange.AcceptProposedDates();
                        CurrentTool(newTool);
                    }
                }
                else {
                    // No, rejecting proposed dates will NOT keep the current item in view. This means the date
                    // discrepancy must involve some change to the selected item's timeline position, not just
                    // a change to the proposed date range. Pan to keep the selected item in view, to provide
                    // clear feedback about the change in timeline position.
                    DateRange.PanToOverlapPosition(pos);
                }
            }); });
        }
        else {
            // No date discrepancy. Just accept the proposed dates.
            DateRange.AcceptProposedDates();
        }
    });
    // set port, piergroup and reservation .Tool() signals when the tool applies to them
    s_js_1.default(function () {
        var tool = CurrentTool(), berth = function () { return (tool === null || tool === void 0 ? void 0 : tool.TimelinePosition) ? tool.TimelinePosition().Berth() : (tool === null || tool === void 0 ? void 0 : tool.TimelineItem) ? tool.TimelineItem.TimelinePosition().Berth() : null; }, tpg = tool && tool.PierGroup ? tool.PierGroup() : berth() && berth().PierGroup(), ti = tool && tool.TimelineItem;
        for (var _i = 0, _a = Ports(); _i < _a.length; _i++) {
            var port = _a[_i];
            var portHasTool = false;
            for (var _b = 0, _c = port.PierGroups(); _b < _c.length; _b++) {
                var pg = _c[_b];
                var pgHasTool = pg.PierGroup === tpg;
                portHasTool = portHasTool || pgHasTool;
                pg.Tool(pgHasTool ? tool : null);
                for (var _d = 0, _e = pg.TimelineItems(); _d < _e.length; _d++) {
                    var i = _e[_d];
                    if (i.Type === "BR" /* BerthReservation */) {
                        i.Tool(i === ti ? tool : null);
                    }
                }
            }
            port.Tool(portHasTool ? tool : null);
        }
    });
    var CanAddBerthClosures = s_js_1.default(function () { return addClosureBerths().length > 0; }), ShowAddBerthClosure = s_js_1.default.value(false), AddBerthClosure = s_js_1.default(function () { return ShowAddBerthClosure() ?
        new AddBerthClosureModel(addClosureBerths, data, ajax, entrypoints, tzutils, berthClosureSets, model.BerthClosureRights, ChangeTool, function () { return ShowAddBerthClosure(false); }) :
        null; });
    // start watching to see if our desiredReservationId shows up, if set
    if (params.resid)
        watchForDesiredReservationId();
    if (params.uresid)
        watchForDesiredUnlistedReservationId();
    if (params.bclid)
        watchForDesiredBerthClosureId();
    // instantiate a DataLoader which will incrementally update our data model with necessary new pieces of information
    DataLoader(DateRange, model, reservationSets, unlistedReservationSets, berthClosureSets, ajax, cache, entrypoints);
    var PortFilter = PortFilterModel(params, Ports), CapabilityFilter = CapabilityFilterModel(params, s_array_1.lift(function () { return Array.from(data.BerthCapabilities.items()); }));
    s_js_1.default(function () { return Ports().forEach(function (port) { return port.IsDisplayed(PortFilter.QueryMatches(port.Port)); }); });
    s_js_1.default(function () { return Ports().forEach(function (port) { return port.PierGroups().forEach(function (pg) { return pg.IsDisplayed(CapabilityFilter.QueryMatches(pg.PierGroup)); }); }); });
    var showActionsMenu = s_js_1.default.data(false);
    var showTallTimeline = s_js_1.default.data(false);
    return {
        DateRange: DateRange,
        PortFilter: PortFilter,
        CapabilityFilter: CapabilityFilter,
        Ports: Ports,
        CurrentTool: CurrentTool,
        Validation: Validation,
        ShowErrorModal: ShowErrorModal,
        ScrollToToolReqId: ScrollToToolReqId,
        ShowAddBerthClosure: ShowAddBerthClosure,
        AddBerthClosure: AddBerthClosure,
        CompactView: CompactView,
        Localization: Localization,
        ShowActionsMenu: showActionsMenu,
        ShowTallTimeline: showTallTimeline,
        ToggleActionsMenu: ToggleActionsMenu,
        ToggleCompactView: ToggleCompactView,
        ToggleTallTimeline: ToggleTallTimeline,
        MenuAction: MenuAction,
        OpenSpaceClick: OpenSpaceClick,
        TimelineItemClick: TimelineItemClick,
        CanReserveBerths: CanReserveBerths,
        CanManageBerths: CanManageBerths,
        CanAddBerthClosures: CanAddBerthClosures,
        User: user,
        TZUtils: tzutils // aah: so much in the view works on dates that I'm exposing tzutils here instead of passing it through all the view props
    };
    function ToggleTallTimeline() {
        showTallTimeline(!showTallTimeline());
        CompactView() ? ToggleCompactView() : null;
    }
    function ToggleCompactView() {
        CompactView(!CompactView());
        showTallTimeline() ? ToggleTallTimeline() : null;
    }
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    // watch reservations() to see if the reservation with the desired id shows up and, if so, select it and scroll to it
    function watchForDesiredReservationId() {
        var desiredReservation = data.BerthReservations.index(params.resid);
        s_js_1.default(function (found) {
            if (!found && desiredReservation()) {
                var dres = desiredReservation();
                if (params.mode === SelectMode.ChangeBerth)
                    ChangeTool.ChangeBerth(dres);
                else if (params.mode === SelectMode.EditTimeblock)
                    ChangeTool.EditTimeblock(dres);
                else if (params.mode === SelectMode.AddShift)
                    ChangeTool.AddShift(dres);
                else if (params.mode === SelectMode.ViewOverlaps)
                    ChangeTool.ReservationOverlaps(dres);
                else
                    ChangeTool.ReservationDetails(dres);
                return true;
            }
            else {
                return false;
            }
        }, false);
    }
    // Same idea, but for unlisted reservations
    function watchForDesiredUnlistedReservationId() {
        var desiredUnlistedReservation = data.UnlistedBerthReservations.index(params.uresid);
        s_js_1.default(function (found) {
            if (!found && desiredUnlistedReservation()) {
                var ur = desiredUnlistedReservation();
                ChangeTool.UnlistedReservationDetails(ur);
                return true;
            }
            else {
                return false;
            }
        }, false);
    }
    // Same idea, but for berth closures
    function watchForDesiredBerthClosureId() {
        var desiredBerthClosure = data.BerthClosures.index(params.bclid);
        s_js_1.default(function (found) {
            if (!found && desiredBerthClosure()) {
                var bcl = desiredBerthClosure();
                if (params.mode === SelectMode.ViewOverlaps)
                    ChangeTool.BerthClosureOverlaps(bcl);
                else
                    ChangeTool.BerthClosureDetails(bcl);
                return true;
            }
            else {
                return false;
            }
        }, false);
    }
    function OpenSpaceClick(loc) {
        var _a, _b;
        var tool = CurrentTool();
        if (tool === null)
            tool = NewReservationTool.TryCreateTool(loc, model.BerthRights(), tzutils, piergroupMap);
        else
            tool = (_b = (_a = tool.OpenSpaceClick) === null || _a === void 0 ? void 0 : _a.call(tool, loc)) !== null && _b !== void 0 ? _b : null;
        CurrentTool(tool);
    }
    function TimelineItemClick(item) {
        var tool = CurrentTool();
        if (tool === null || !tool.TimelineItemClick)
            tool = item.MakeDetailsTool(ChangeTool);
        else
            tool = tool.TimelineItemClick(item);
        CurrentTool(tool);
    }
    // display order is important b/c later reservations overlap earlier ones in the dislay
    function timelineItemDisplayOrder(a, b) {
        return (CompactView() ? 0 : (timelineItemDisplayGroup(a) - timelineItemDisplayGroup(b)))
            || timelineItemChronologicalOrder(a, b);
    }
    function timelineItemDisplayGroup(item) {
        var tool = CurrentTool();
        return (tool && tool.TimelineItem === item ? 6 :
            item.Type === "BR" /* BerthReservation */ ?
                item.Reservation.Status() === BerthReservation_2.BerthReservationStatus.Booked ? 5 :
                    item.Reservation.Status() === BerthReservation_2.BerthReservationStatus.Requested ? 4 :
                        item.Reservation.Status() === BerthReservation_2.BerthReservationStatus.Conflicted ? 3 :
                            2 :
                item.Type === "BCL" /* BerthClosure */ ? 1 :
                    0);
    }
    function timelineItemChronologicalOrder(a, b) {
        var aPos = a.TimelinePosition(), bPos = b.TimelinePosition();
        return (aPos.Start() && bPos.Start() ?
            aPos.Start() < bPos.Start() ? -1
                : aPos.Start() > bPos.Start() ? 1
                    : aPos.End() < bPos.End() ? -1
                        : aPos.End() > bPos.End() ? 1
                            : 0
            : 0);
    }
    function CanReserveBerths() {
        return model.CanReserveBerths();
    }
    function CanManageBerths() {
        return model.CanManageBerths();
    }
};
exports.ScheduleGrid = ScheduleGrid;
// the DataLoader incrementally loads new data into the model as the range of displayed days changes
function DataLoader(dateRange, model, reservationSets, unlistedReservationSets, berthClosureSets, ajax, cache, entrypoints) {
    var requested = {}, loaded = {};
    s_js_1.default.sample(loadInitialData);
    s_js_1.default.on(debounceSignal_1.debounceSignal(dateRange.Days, 300), watchForDataUpdates, undefined, true);
    // make our initial request for data
    function loadInitialData() {
        var initialDays = dateRange.Days(), url = entrypoints.ScheduleGrid({ From: dateRange.FromDate().toJSON(), To: dateRange.ToDate().toJSON() });
        initialDays.forEach(function (d) { requested[d.Day.toJSON()] = true; });
        var req = ajax.Url(url).Get();
        return req.then(function (json) {
            s_js_1.default.freeze(function () {
                cache.ScheduleGridResponses.update1(req.Date, json);
                initialDays.forEach(function (d) {
                    d.IsLoaded(true);
                    loaded[d.Day.toJSON()] = true;
                });
            });
        });
    }
    // watch the days array, and check that data has been loaded for all days in it
    function watchForDataUpdates() {
        var need = {};
        dateRange.Days().forEach(function (day) {
            var key = day.Day.toJSON();
            if (loaded[key]) {
                day.IsLoaded(true);
            }
            else if (requested[key]) {
                // nothing to do, request still pending
            }
            else {
                need[key] = day;
            }
        });
        if (Object.keys(need).length) {
            // we need to tell the server what we need and what we've already requested so that it can send us the missing items
            var req_1 = ajax.Url(entrypoints.UpdateScheduleGrid).Post({
                Need: Object.keys(need),
                Have: Object.keys(requested)
            });
            req_1.then(function (json) {
                model.PortCallRights(Object.assign(model.PortCallRights(), json.PortCallRights));
                model.BerthClosureRights(Object.assign(model.BerthClosureRights(), json.BerthClosureRights));
                var update = cache.ScheduleGridUpdateResponses.update1(req_1.Date, json), reses = update.BerthReservations(), urs = update.UnlistedReservations(), bcls = update.BerthClosures();
                // note: can't push update.BerthReservations onto reservationSets, since ScheduleGridUpdateResponses don't have a key,
                // so if we push the signal onto the set, it will be reset to the next update once it comes in
                reservationSets.push(function () { return reses; });
                // And ditto for other timeline items
                unlistedReservationSets.push(function () { return urs; });
                berthClosureSets.push(function () { return bcls; });
                // mark the days as loaded
                for (var key in need) {
                    need[key].IsLoaded(true);
                    loaded[key] = true;
                }
            });
            for (var key in need) {
                requested[key] = true;
            }
        }
    }
}
var DayModel = /** @class */ (function () {
    function DayModel(Day, NextDay, Today) {
        this.Day = Day;
        this.NextDay = NextDay;
        this.Today = Today;
        this.IsLoaded = s_js_1.default.value(false);
    }
    return DayModel;
}());
exports.DayModel = DayModel;
var PortModel = /** @class */ (function () {
    function PortModel(Port, PierGroups) {
        this.Port = Port;
        this.PierGroups = PierGroups;
        this.IsDisplayed = s_js_1.default.value(true);
        this.Tool = s_js_1.default.value(null);
    }
    return PortModel;
}());
exports.PortModel = PortModel;
var PierGroupModel = /** @class */ (function () {
    function PierGroupModel(PierGroup, TimelineItems) {
        this.PierGroup = PierGroup;
        this.TimelineItems = TimelineItems;
        this.IsDisplayed = s_js_1.default.value(true);
        this.Tool = s_js_1.default.value(null);
        this.SelectedBollard = s_js_1.default.value(null);
        this.Berths = this.PierGroup.Berths.sort(Berth_1.Berth.StartMarkOrder);
        this.Bollards = s_js_1.default(function () {
            var bollards = PierGroup.Berths().reduce(function (acc, next) { return acc.concat(next.BollardPositions()); }, []);
            bollards.sort(BollardPosition_1.BollardPosition.PierMarkOrder);
            return bollards;
        });
    }
    PierGroupModel.prototype.SelectBollard = function (bol) {
        this.SelectedBollard(bol);
    };
    PierGroupModel.prototype.DeselectBollard = function (bol) {
        if (s_js_1.default.sample(this.SelectedBollard) === bol)
            this.SelectedBollard(null);
    };
    return PierGroupModel;
}());
exports.PierGroupModel = PierGroupModel;
var DateRangeModel = /** @class */ (function () {
    function DateRangeModel(params, allDays, tzutils, CompactView) {
        var _this = this;
        this.tzutils = tzutils;
        this.CompactView = CompactView;
        this._FromDate = s_js_1.default.value(params.date, TZDate_1.default.eq);
        this.FromDate = function () { return _this._FromDate(); };
        this.ProposedFromDate = s_js_1.default.value(params.date, TZDate_1.default.eq);
        var msPerDay = 24 * 60 * 60 * 1000;
        this.MaxDuration = s_js_1.default.value(window.innerWidth <= MOBILE_THRESHOLD ?
            msPerDay :
            (window.innerWidth - berthBarWidth(window.innerWidth)) / 240 * msPerDay);
        this.Duration = s_js_1.default(function () { return CompactView() ? msPerDay : _this.MaxDuration(); });
        this.ToDate = s_js_1.default(function () { return tzutils.newDate(_this.FromDate().getTime() + _this.Duration()); });
        this.ProposedToDate = s_js_1.default(function () { return tzutils.newDate(_this.ProposedFromDate().getTime() + _this.Duration()); });
        this.Now = tzutils.now();
        this.Today = tzutils.today();
        this.Days = s_js_1.default(function () {
            var day, days = [], dayModel, nextDay = function (d) { return tzmoment_1.tzmomentMod(tzutils, d, function (m) { return m.add(1, 'day'); }); };
            for (day = _this.FromDate(); day < _this.ToDate(); day = nextDay(day)) {
                // get cached day if we have it, otherwise create one and cache it
                dayModel = allDays[day.toJSON()] || (allDays[day.toJSON()] = new DayModel(day, nextDay(day), TZDate_1.default.eq(day, _this.Today)));
                days.push(dayModel);
            }
            return days;
        });
    }
    // move the displayed date range the requested number of days, positive (future) or negative (past)
    DateRangeModel.prototype.ShiftDate = function (days) {
        var from = tzmoment_1.tzmomentMod(this.tzutils, this.FromDate(), function (m) { return m.add(days, 'day'); });
        this.ProposedFromDate(from);
    };
    DateRangeModel.prototype.GoToToday = function () {
        this.ProposedFromDate(this.tzutils.today());
    };
    // pan the view to bring the given date into view
    DateRangeModel.prototype.PanToViewDate = function (d) {
        var shift = 0;
        var extraDays = this.CompactView() ? 0 : 1;
        if (d < this.FromDate())
            shift = Math.floor((+d - +this.FromDate()) / 24 / 60 / 60 / 1000) - extraDays;
        else if (d > this.ToDate())
            shift = Math.ceil((+d - +this.ToDate()) / 24 / 60 / 60 / 1000) + extraDays;
        if (shift !== 0)
            this.ShiftDate(shift);
    };
    DateRangeModel.prototype.PanToOverlapPosition = function (pos) {
        if (pos.Start() && pos.End()) {
            var shift = 0;
            var extraDays = this.CompactView() ? 0 : 1;
            if (pos.End() < this.FromDate())
                shift = Math.floor((+pos.End() - +this.FromDate()) / 24 / 60 / 60 / 1000) - extraDays;
            if (pos.Start() > this.ToDate())
                shift = Math.ceil((+pos.Start() - +this.ToDate()) / 24 / 60 / 60 / 1000) + extraDays;
            if (shift !== 0)
                this.ShiftDate(shift);
        }
    };
    DateRangeModel.prototype.OverlapsPosition = function (pos) {
        return !!pos.Start() && !!pos.End() && pos.Start() <= this.ToDate() && pos.End() >= this.FromDate();
    };
    DateRangeModel.prototype.ProposalOverlapsPosition = function (pos) {
        return !!pos.Start() && !!pos.End() && pos.Start() <= this.ProposedToDate() && pos.End() >= this.ProposedFromDate();
    };
    DateRangeModel.prototype.AcceptProposedDates = function () {
        this._FromDate(this.ProposedFromDate());
    };
    DateRangeModel.prototype.RejectProposedDates = function () {
        this.ProposedFromDate(this.FromDate());
    };
    return DateRangeModel;
}());
exports.DateRangeModel = DateRangeModel;
function timelinePositionForReservation(res) {
    return {
        Start: function () { var _a, _b; return res.Status() === BerthReservation_2.BerthReservationStatus.Cancelled ? null : (_b = (_a = res.Itinerary()) === null || _a === void 0 ? void 0 : _a.Arrival.Effective()) !== null && _b !== void 0 ? _b : null; },
        End: function () { return res.Status() === BerthReservation_2.BerthReservationStatus.Cancelled ? null : res.Itinerary() ? maxDate(res.Itinerary().Arrival.Effective(), res.Itinerary().Departure.Effective()) : null; },
        Berth: function () { return res.Berth(); },
        PierMark: res.PierMark,
        Length: function () { return res.Length; },
        UniqueKey: function () { return 'res-' + res.Id(); }
    };
}
function timelinePositionForUnlistedReservation(_a) {
    var Start = _a.Start, End = _a.End, Berth = _a.Berth, PierMark = _a.PierMark, Length = _a.Length, Id = _a.Id;
    return {
        Start: Start,
        End: function () { return maxDate(Start(), End()); },
        Berth: Berth,
        PierMark: PierMark,
        Length: function () { return Length; },
        UniqueKey: function () { return 'ures-' + Id(); }
    };
}
var VERY_LONG_TIME_IN_THE_FUTURE = new TZDate_1.default(Date.now() + 2000 * 365.25 * 24 * 60 * 60 * 1000);
function timelinePositionForBerthClosure(_a) {
    var StartDate = _a.StartDate, EndDate = _a.EndDate, Berth = _a.Berth, PierMark = _a.PierMark, Length = _a.Length, Id = _a.Id;
    return {
        Start: StartDate,
        // Null EndDate is the same as "closed indefinitely," which we'll interpret as "roughly 2000 yrs from now." :)
        End: function () { return EndDate() ? maxDate(StartDate(), EndDate()) : VERY_LONG_TIME_IN_THE_FUTURE; },
        Berth: Berth,
        PierMark: PierMark,
        Length: function () { return Length; },
        UniqueKey: function () { return 'bcl-' + Id(); }
    };
}
function maxDate(d1, d2) {
    return d1 < d2 ? d2 : d1;
}
function footmarkSelectionForReservation(res) {
    return {
        Footmark: res.Footmark,
        Position: timelinePositionForReservation(res)
    };
}
function footmarkSelectionForUnlistedReservation(ur) {
    return {
        Footmark: ur.Footmark,
        Position: timelinePositionForUnlistedReservation(ur)
    };
}
function footmarkSelectionForBerthClosure(bcl) {
    return {
        Footmark: bcl.Footmark,
        Position: timelinePositionForBerthClosure(bcl)
    };
}
function ReservationModel(id, ajax, data, portCallRights) {
    var _this = this;
    var res = data.BerthReservations.update1(null, { Id: id }), client = ajax.Url(function () { return res.Url() || ''; }, { useCache: true, include: [function (res) { return res.Itinerary; }] }), _a = draftSignals_1.DraftObject(res, ['Footmark.Num']), Reservation = _a.object, draftMethods = _a.methods, pt = data.ItineraryPoints.update1(null, { Id: id }), _b = draftSignals_1.DraftObject(pt, ['Arrival.Estimated', 'Arrival.Actual', 'Departure.Estimated', 'Departure.Actual', 'LocationId']), ItineraryPoint = _b.object, ptDraftMethods = _b.methods, Validation = validationWatcher_1.ValidationWatcher(client), Tool = s_js_1.default.value(null), rights = function () { return portCallRights()[ItineraryPoint.PortCallId()]; }, Edit = function () { return (rights() & Rights_1.PortCallRights.Edit) !== 0; }, EditActuals = function () { return (rights() & Rights_1.PortCallRights.EditActuals) !== 0; }, commitQueue = new requestQueue_1.RequestQueue(function () { return __awaiter(_this, void 0, void 0, function () {
        var resCheckpoint_1, ptCheckpoint_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(draftMethods.isCaching() || ptDraftMethods.isCaching())) return [3 /*break*/, 2];
                    resCheckpoint_1 = draftMethods.checkpoint(), ptCheckpoint_1 = ptDraftMethods.checkpoint();
                    return [4 /*yield*/, client.Put(Reservation)];
                case 1:
                    _a.sent();
                    s_js_1.default.freeze(function () {
                        // the DataCache will have committed changes to the model already, so we actually revert() here, not commit().
                        // otherwise, any tweaks to the data by the server won't be picked up.
                        resCheckpoint_1.revert();
                        ptCheckpoint_1.revert();
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); });
    // have to replace PierMark in draft res, as the base PierMark is bound to the base signals
    Reservation.PierMark = new PierMark_1.PierMark(Reservation.Footmark, function () { return Reservation.Berth(); });
    // have to recreate Effective dates, so that they read from the draft signals
    ItineraryPoint.Arrival.Effective = ScheduleDate_1.EffectiveDate(ItineraryPoint.Arrival);
    ItineraryPoint.Departure.Effective = ScheduleDate_1.EffectiveDate(ItineraryPoint.Departure);
    // have to re-attach ItineraryPoint's reference to Location so that it reads from draft LocationId
    Reservation.Itinerary = s_js_1.default.data(ItineraryPoint);
    ItineraryPoint.Location = s_js_1.default.data(s_js_1.default.sample(pt.Location));
    data.ItineraryPoints.attach(ItineraryPoint, [ItineraryPoint.Location]);
    // Apply most-utilized-berth rule. Matters for, e.g., selecting the correct length/time buffers when moving
    // reservations around in a piergroup in which different berths use different length or time buffers.
    ApplyBerthReservationMostUtilizedBerthRule(Reservation, ItineraryPoint, function () { return draftMethods.isCaching() || ptDraftMethods.isCaching(); });
    return {
        // ITimelineItem impl...
        Type: "BR" /* BerthReservation */,
        TimelinePosition: function () { return timelinePositionForReservation(Reservation); },
        FootmarkSelection: function () { return footmarkSelectionForReservation(Reservation); },
        MakeDetailsTool: function (changeTool) { return new ReservationDetailsTool(this, changeTool); },
        // Other properties...
        Reservation: Reservation,
        ItineraryPoint: ItineraryPoint,
        // Issues representing overlaps that should be displayed in the overlaps popup
        Overlaps: Reservation.Issues.filter(function (i) {
            return i.Type() === IssueType_1.IssueType.ReservationOverlapsOther ||
                i.Type() === IssueType_1.IssueType.ReservationOverlapsShift ||
                i.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure;
        }
        // NOT ReservationOverlapsVesselSchedule. That indicates a logical overlap (same
        // vessel assigned to two PortCalls simultaneously). Whereas what we care about
        // here is physical overlaps (two things occupying the same berth space at the
        // same time).
        ),
        Validation: Validation,
        Tool: Tool,
        Edit: Edit,
        EditActuals: EditActuals,
        CommitChanges: CommitChanges,
        RevertChanges: RevertChanges
    };
    function CommitChanges() {
        commitQueue.enqueueRequest();
        return commitQueue.mostRecentRequest();
    }
    function RevertChanges() {
        Validation({});
        //ItineraryValidation({});
        draftMethods.checkpoint().revert();
        ptDraftMethods.checkpoint().revert();
    }
}
function ApplyBerthReservationMostUtilizedBerthRule(res, pt, isCaching) {
    // Refine selected berth as footmarks or selected berth change. This is purely for better client-side
    // feedback. The server applies its own version of the same logic.
    s_js_1.default(function () {
        var _a, _b, _c, _d;
        // Similar to berth closures below, we wanna avoid modifying BerthId unless we've gotten some kind of
        // explicit user input.
        if (!isCaching())
            return;
        // Similar to berth closures below, also skip updating if Location and LocationId are out of sync.
        if (((_a = pt.Location()) === null || _a === void 0 ? void 0 : _a.Id()) !== pt.LocationId())
            return;
        var pg = (_d = (_c = (_b = pt.Location()) === null || _b === void 0 ? void 0 : _b.Berth()) === null || _c === void 0 ? void 0 : _c.PierGroup()) !== null && _d !== void 0 ? _d : null;
        if (pg) {
            var b = pg.MostUtilizedBerth(res.Footmark, res.Length);
            if (b)
                pt.LocationId(b.Id());
        }
    });
}
function UnlistedReservationModel(id, data) {
    var 
    // No draft object b/c unlisted reservations aren't ever editable.
    UnlistedReservation = data.UnlistedBerthReservations.update1(null, { Id: id });
    return {
        // ITimelineItem impl...
        Type: "UR" /* UnlistedReservation */,
        TimelinePosition: function () { return timelinePositionForUnlistedReservation(UnlistedReservation); },
        FootmarkSelection: function () { return footmarkSelectionForUnlistedReservation(UnlistedReservation); },
        MakeDetailsTool: function (changeTool) { return new UnlistedReservationDetailsTool(this, changeTool); },
        // Other properties...
        UnlistedReservation: UnlistedReservation
    };
}
function BerthClosureModel(id, ajax, data, berthClosureRights, addClosureBerths) {
    var _this = this;
    var closure = data.BerthClosures.update1(null, { Id: id }), client = ajax.Url(function () { return closure.Url() || ''; }, { useCache: true }), _a = draftSignals_1.DraftObject(closure, [
        'Title',
        'StartDate',
        'EndDate',
        'BerthId',
        'Footmark.Num',
        'Footmark.UOM',
        'Length.Num',
        'Length.UOM',
        'Remarks'
    ]), BerthClosure = _a.object, draftMethods = _a.methods, _b = BerthClosureValidationWatcher(BerthClosure, true), Validation = _b.Validation, ValidForSubmit = _b.ValidForSubmit, rights = function () { return berthClosureRights()[BerthClosure.Id()]; }, Edit = function () { return (rights() & Rights_1.BerthClosureRights.Edit) !== 0; }, commitQueue = new requestQueue_1.RequestQueue(function () { return __awaiter(_this, void 0, void 0, function () {
        var checkpoint;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!draftMethods.isCaching()) return [3 /*break*/, 2];
                    checkpoint = draftMethods.checkpoint();
                    return [4 /*yield*/, client.Put(BerthClosure)];
                case 1:
                    _a.sent();
                    // As w/ ReservationModel, we actually revert() here not commit(), since we'll
                    // let the data cache commit changes to our cached model, and we don't wanna
                    // clobber the data caches commit and lose any server-side tweaks.
                    checkpoint.revert();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); });
    // Have to re-attach parent navigation properties to read from draft foreign keys
    BerthClosure.Berth = s_js_1.default.data(s_js_1.default.sample(closure.Berth));
    data.BerthClosures.attach(BerthClosure, [BerthClosure.Berth]);
    var berthSelector = BerthClosureBerthSelector(BerthClosure, addClosureBerths);
    ApplyBerthClosureMostUtilizedBerthRule(BerthClosure, draftMethods.isCaching);
    // DON'T have to recreate PierMark for BerthClosures. We made that property a getter
    // to avoid needing this.
    var _c = BerthClosureStartAndEndMarks(BerthClosure), StartmarkNum = _c.StartmarkNum, EndmarkNum = _c.EndmarkNum;
    return {
        // ITimelineItem impl...
        Type: "BCL" /* BerthClosure */,
        TimelinePosition: function () { return timelinePositionForBerthClosure(BerthClosure); },
        FootmarkSelection: function () { return footmarkSelectionForBerthClosure(BerthClosure); },
        MakeDetailsTool: function (changeTool) { return new BerthClosureDetailsTool(this, changeTool); },
        // Other properties...
        BerthClosure: BerthClosure,
        StartmarkNum: StartmarkNum,
        EndmarkNum: EndmarkNum,
        // Issues representing overlaps that should be displayed in the overlaps popup.
        // Both this closure's issues and issues that any berth reservations might have
        // b/c of this closure.
        // NOTE: Keep in sync w/ portcall/berthclosuresdashboard/model (see BerthClosureViewModel)
        Overlaps: BerthClosure.Issues.filter(function (i) {
            return i.Type() === IssueType_1.IssueType.BerthClosureOverlapsOther;
        }).concat(BerthClosure.ReservationIssues.filter(function (i) {
            return i.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure;
        })),
        Edit: Edit,
        Delete: Delete,
        BerthSelector: berthSelector,
        HasUnsavedChanges: HasUnsavedChanges,
        Validation: Validation,
        ValidForSubmit: ValidForSubmit,
        CommitChanges: CommitChanges,
        RevertChanges: RevertChanges
    };
    function HasUnsavedChanges() {
        return draftMethods.isCaching();
    }
    function CommitChanges() {
        commitQueue.enqueueRequest();
        return commitQueue.mostRecentRequest();
    }
    function RevertChanges() {
        draftMethods.checkpoint().revert();
    }
    function Delete() {
        return client.Delete();
    }
}
var AddBerthClosureModel = /** @class */ (function () {
    function AddBerthClosureModel(addClosureBerths, data, ajax, entrypoints, tzutils, berthClosureSets, berthClosureRights, changeTool, dismiss) {
        var _this = this;
        this.berthClosureSets = berthClosureSets;
        this.berthClosureRights = berthClosureRights;
        this.changeTool = changeTool;
        this.dismiss = dismiss;
        this.BerthClosure = new BerthClosure_1.BerthClosure({
            Id: 0,
            StartDate: tzutils.today().toJSON(),
            EndDate: tzmoment_1.tzmomentMod(tzutils, tzutils.today(), function (m) { return m.add(1, 'days'); }).toJSON(),
            Footmark: { UOM: UOM_1.default.Foot },
            Length: { UOM: UOM_1.default.Foot }
        });
        data.BerthClosures.attach(this.BerthClosure, [this.BerthClosure.Berth]);
        var _a = BerthClosureStartAndEndMarks(this.BerthClosure), StartmarkNum = _a.StartmarkNum, EndmarkNum = _a.EndmarkNum;
        this.StartmarkNum = StartmarkNum;
        this.EndmarkNum = EndmarkNum;
        this.BerthSelector = BerthClosureBerthSelector(this.BerthClosure, addClosureBerths);
        ApplyBerthClosureMostUtilizedBerthRule(this.BerthClosure, function () { return true; });
        this.client = ajax.Url(entrypoints.AddBerthClosure, { useCache: true });
        var _b = BerthClosureValidationWatcher(this.BerthClosure, false), Validation = _b.Validation, ValidForSubmit = _b.ValidForSubmit;
        this.Validation = Validation;
        this.ValidForSubmit = ValidForSubmit;
        this._Submitting = s_js_1.default.value(false);
        this.Submitting = function () { return _this._Submitting(); };
    }
    AddBerthClosureModel.prototype.Submit = function () {
        var _this = this;
        if (this._Submitting())
            return;
        this._Submitting(true);
        this.client.Post(this.BerthClosure).then(function (resp) { return s_js_1.default.freeze(function () {
            var _a;
            var bcl = resp.BerthClosures()[0];
            _this.berthClosureSets.push(function () { return [bcl]; });
            // Assume that if you just added a closure successfully, then you can also edit
            // that closure. Otherwise we'd default to no edit rights.
            _this.berthClosureRights(Object.assign(_this.berthClosureRights(), (_a = {}, _a[bcl.Id()] = Rights_1.BerthClosureRights.Edit, _a)));
            _this.changeTool.BerthClosureDetails(bcl);
            _this.dismiss();
        }); }).finally(function () { return _this._Submitting(false); });
    };
    return AddBerthClosureModel;
}());
exports.AddBerthClosureModel = AddBerthClosureModel;
function ApplyBerthClosureMostUtilizedBerthRule(berthClosure, isCaching) {
    // Refine selected berth as footmarks or selected berth change. This is purely for faster client-side
    // feedback. The server applies its own version of the same logic.
    s_js_1.default(function () {
        var _a, _b, _c;
        // We wanna avoid modifying BerthId unless we've gotten some kind of explicit user input, in case this
        // is an existing closure whose BerthId has somehow gotten out of sync with its Footmark and Length.
        // That's b/c w/ no guard here, the UX in the event that a user happens to click on such an out-of-sync
        // closure would be really bad: For berth mgrs/admins, they'd find that the details popup immediately
        // acts as if they have unsaved changes, but Quit Changes wouldn't work (it'd appear to do nothing),
        // and they'd be forced to hit Update to get out of the bad state. For non-berth mgrs, it's even worse:
        // they don't even have access to Update (or Quit Changes), so they'd be stuck viewing that closure.
        // So, say that we only apply the most-utilized-berth rule if our draft closure is already dirty for
        // some reason. That way, we at least know that THIS computation can never be the sole reason our draft
        // closure is dirty.
        if (!isCaching())
            return;
        // Also skip updating if berthClosure.Berth and berthClosure.BerthId are out-of-sync. This can happen if
        // the user selects a new berth and that changes both berthClosure.BerthId and berthClosure.Footmark;
        // changing berthClosure.Footmark will trigger this computation to re-run in the next tick of S's clock,
        // but it'll take at least one extra clock tick for berthClosure.Berth to reflect the new
        // berthClosure.BerthId value. W/o this guard, we can wind up applying the most-utilized-berth rule to
        // the wrong piergroup.
        if (((_a = berthClosure.Berth()) === null || _a === void 0 ? void 0 : _a.Id()) !== berthClosure.BerthId())
            return;
        var pg = (_c = (_b = berthClosure.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) !== null && _c !== void 0 ? _c : null;
        // PierGroup.MostUtilizedBerth throws on negative lengths, so bail early in that case.
        if (pg && berthClosure.Length.Num() >= 0) {
            var b = pg.MostUtilizedBerth(berthClosure.Footmark, berthClosure.Length);
            if (b)
                berthClosure.BerthId(b.Id());
        }
    });
}
function BerthClosureBerthSelector(berthClosure, addClosureBerths) {
    var 
    // A pure event signal so that we can distinguish berth changes originating from
    // a typeahead selection vs those originating from any other source (e.g. the
    // user reverts draft berth changes).
    typeaheadSelection = s_js_1.default.data(null), selectedBerth = s_js_1.default.data(s_js_1.default.sample(berthClosure.Berth));
    // If a typeahead option is selected that differs from the current berth, then update
    // the current berth and update Footmark and Length so that the closure defaults to
    // spanning the entire berth. Be careful to do this only when a typeahead option is
    // selected, not anytime the berth changes, to avoid clobbering user Footmark/Length
    // edits if the user reverts draft berth changes.
    //
    // BUGFIX: The debounceSignal call is purely to work around a behavior (arguably a bug) in
    // our version of Twitter Typeahead (currently 0.10.5). When you select an item from a
    // Twitter typeahead (at least in v0.10.5), the typeahead does two things in succession:
    // 1) Trigger the "selected" event for that typeahead, and 2) close the typeahead's
    // dropdown menu. (Search lib/typeahead.jquery.js for "_select:"). The issue for us is
    // that if selecting a berth causes the berth closure to change piergroups, then (1)
    // causes us to totally destroy the existing BerthClosure details popup, including
    // destroying the triggering berth selector typeahead, and then construct a NEW
    // BerthClosure details popup under the DOM tree for the new piergroup. All this
    // happens synchronously before (2) runs, such that by the time (2) runs, the triggering
    // typeahead has already been destroyed. The logic for closing a typeahead's dropdown
    // menu doesn't expect that typeahead to have been destroyed in the meantime, so it ends
    // up throwing an error that leaves us in a dirty state. Search lib/typeahead.jquery.js
    // for "_getCursor:" for the method that ultimately throws the error. This gets called
    // in the course of the Dropdown class's close() method. Arguably Twitter Typeahead
    // should anticipate that firing the "selected" event might trigger code that destroys
    // the triggering typeahead and just skip closing the dropdown menu if so. We could see
    // if a more recent version has fixed or just patch Twitter Typeahead ourselves. But for
    // now, delaying the berth change so that it happens AFTER Twitter Typeahead has closed
    // the triggering typeahead's dropdown menu is enough to fix the problem.
    //
    // TODO: This fix doesn't stop the Twitter typeahead from throwing OTHER errors when
    // you change to a different piergroup. One seems to be connected to cleanup the
    // typeahead tries to do when the input loses focus. Those other errors don't seem to
    // interfere w/ our desired functionality, but still might wanna try upgrading the
    // library. Note that Twitter no longer maintains this library, but there's a fork
    // by the core-js team that seems well maintained:
    // https://github.com/corejavascript/typeahead.js
    s_js_1.default.on(debounceSignal_1.debounceSignal(typeaheadSelection, 0, function () { return false; }), function () {
        var b = selectedBerth(), curr = berthClosure.Berth();
        if (b && b !== curr) {
            berthClosure.BerthId(b.Id());
            berthClosure.Footmark.set(b.StartMark);
            berthClosure.Length.set(b.Length);
        }
    }, undefined, true);
    // Also flow the other direction: If model's Berth changes, update SelectedBerth. This
    // supports updating the displayed berth if the user reverts draft berth changes.
    s_js_1.default(function () { return selectedBerth(berthClosure.Berth()); });
    return model_1.BerthSelector({
        Berths: addClosureBerths,
        SelectedBerth: function (b) {
            if (b === undefined) {
                return selectedBerth();
            }
            else {
                return s_js_1.default.freeze(function () {
                    typeaheadSelection(null);
                    return selectedBerth(b);
                });
            }
        }
    });
}
function BerthClosureStartAndEndMarks(berthClosure) {
    // Support presenting in UI as start/end footmarks instead of as start footmark + length.
    // NOTE: data/models/EndMark.ts is no good for us here b/c that assumes that length is
    // fixed and edits to the EndMark update the Footmark. We want just the opposite here.
    var endmarkImmutable = berthClosure.Footmark.add(berthClosure.Length);
    return {
        StartmarkNum: StartmarkNum,
        EndmarkNum: EndmarkNum
    };
    function StartmarkNum(num) {
        if (num === undefined) {
            return Math.round(berthClosure.Footmark.Num());
        }
        else {
            return s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
                var diff = num - berthClosure.Footmark.Num();
                // Changing StartmarkNum changes Length in the opposite
                // direction, to preserve the appearance for users that
                // Startmark and Endmark are independent of each other.
                berthClosure.Length.Num(berthClosure.Length.Num() - diff);
                return berthClosure.Footmark.Num(num);
            }); });
        }
    }
    function EndmarkNum(num) {
        if (num === undefined) {
            return Math.round(endmarkImmutable.Num());
        }
        else {
            return s_js_1.default.sample(function () { return berthClosure.Length.Num(num - berthClosure.Footmark.Num()); });
        }
    }
}
// Do all validation client-side to provide feedback before submitting rather than after.
function BerthClosureValidationWatcher(closure, initApplyValidation) {
    var hasTitle = function () { return !!closure.Title(); }, hasEndAfterStart = function () { return closure.EndDate() === null || +closure.EndDate() > +closure.StartDate(); }, hasPositiveLength = function () { return closure.Length.Num() > 0; }, hasBerth = function () { return !!closure.Berth(); }, 
    // TODO: Do these piermark calculations need to be revised for the upcoming majority
    // footmark change?
    startPiermark = function () {
        var b = closure.Berth();
        return b ? closure.Footmark.Num() + b.PierMark.Num() - b.StartMark.Num() : null;
    }, endPiermark = function () {
        var pm = startPiermark();
        return pm === null ? null : pm + closure.Length.Num();
    }, hasNonnegativeStartPiermark = function () {
        var pm = startPiermark();
        return pm === null || pm >= 0;
    }, hasStartPierMarkWithinPier = function () {
        var pm = startPiermark(), pg = closure.Berth() && closure.Berth().PierGroup();
        return pm === null || pg === null || pm <= pg.Length.Num();
    }, hasEndPiermarkWithinPier = function () {
        var pm = endPiermark(), pg = closure.Berth() && closure.Berth().PierGroup();
        return pm === null || pg === null || pm <= pg.Length.Num();
    }, applyTitleValidation = s_js_1.default.value(initApplyValidation), applyEndDateValidation = s_js_1.default.value(initApplyValidation), applyLengthValidation = s_js_1.default.value(initApplyValidation), applyBerthValidation = s_js_1.default.value(initApplyValidation), applyFootmarkValidation = s_js_1.default.value(initApplyValidation), ifThen = function (condition, consequence) { return function () { return !condition() || consequence(); }; }, 
    // Can't submit until all VRs pass
    vrsForCanSubmit = new clientSideValidation_1.ValidationRules(new clientSideValidation_1.ValidationRule('Title', hasTitle, ''), new clientSideValidation_1.ValidationRule('EndDate', hasEndAfterStart, ''), new clientSideValidation_1.ValidationRule('Length', hasPositiveLength, ''), new clientSideValidation_1.ValidationRule('BerthId', hasBerth, ''), new clientSideValidation_1.ValidationRule('Footmark', hasNonnegativeStartPiermark, ''), new clientSideValidation_1.ValidationRule('Footmark', hasEndPiermarkWithinPier, ''), new clientSideValidation_1.ValidationRule('Length', hasEndPiermarkWithinPier, '')), 
    // VRs to drive validation UI. Suppress displaying errors until user edits a given field.
    vrsForDisplay = new clientSideValidation_1.ValidationRules(new clientSideValidation_1.ValidationRule('Title', ifThen(applyTitleValidation, hasTitle), 'Title is required'), new clientSideValidation_1.ValidationRule('EndDate', ifThen(applyEndDateValidation, hasEndAfterStart), 'End date must be after start date'), new clientSideValidation_1.ValidationRule('Length', ifThen(applyLengthValidation, hasPositiveLength), 'Footmark end must be after footmark start'), new clientSideValidation_1.ValidationRule('BerthId', ifThen(applyBerthValidation, hasBerth), 'Berth is required'), new clientSideValidation_1.ValidationRule('Footmark', ifThen(applyFootmarkValidation, hasNonnegativeStartPiermark), 'Exceeds start of pier'), new clientSideValidation_1.ValidationRule('Footmark', ifThen(applyFootmarkValidation, hasStartPierMarkWithinPier), 'Exceeds pier group maximum'), new clientSideValidation_1.ValidationRule('Length', ifThen(applyLengthValidation, hasEndPiermarkWithinPier), 'Exceeds pier group maximum'));
    // Apply validation to individual fields as the user edits those fields
    s_js_1.default.on(closure.Title, function () { return applyTitleValidation(true); }, undefined, true);
    s_js_1.default.on(callAll_1.callAll(closure.StartDate, closure.EndDate), function () { return applyEndDateValidation(true); }, undefined, true);
    s_js_1.default.on(callAll_1.callAll(closure.Footmark.Num, closure.Length.Num), function () { return applyLengthValidation(true); }, undefined, true);
    s_js_1.default.on(closure.Berth, function () { return applyBerthValidation(true); }, undefined, true);
    s_js_1.default.on(closure.Footmark.Num, function () { return applyFootmarkValidation(true); }, undefined, true);
    return {
        Validation: vrsForDisplay.validation,
        ValidForSubmit: function () { return Object.keys(vrsForCanSubmit.validation()).length === 0; }
    };
}
function berthAtPierMark(pg, pm) {
    var berths = pg.Berths();
    for (var i = 0; i < berths.length; i++) {
        var b = berths[i];
        if (b.PierMark.Num() + b.Length.Num() > pm) {
            return b;
        }
    }
    return null;
}
var ChangeBerthTool = /** @class */ (function () {
    function ChangeBerthTool(Reservation, piergroupMap, changeTool) {
        this.Reservation = Reservation;
        this.piergroupMap = piergroupMap;
        this.changeTool = changeTool;
        this.Seeking = s_js_1.default.value(true);
        this.AttentionGrabber = new AttentionGrabber();
    }
    Object.defineProperty(ChangeBerthTool.prototype, "TimelineItem", {
        get: function () { return this.Reservation; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChangeBerthTool.prototype, "Validation", {
        get: function () { return this.Reservation.Validation; },
        enumerable: false,
        configurable: true
    });
    // Given an existing reservation of set height, try and find an open slot in the given berth to put it, starting at beginning of berth and working down
    ChangeBerthTool.prototype.OpenSpaceClick = function (loc) {
        var res = this.Reservation.Reservation, pt = this.Reservation.ItineraryPoint, pg = this.piergroupMap(loc.PierGroup), pc = this.Reservation.Reservation.PortCall(), berth = berthAtPierMark(pg.PierGroup, loc.PierMark.Num());
        if (pc === null || berth === null || pg.PierGroup.Port() !== pc.Port())
            return this;
        pt.LocationId(berth.Id());
        this.Seeking(false);
        // find all other reservations in the piergroup that overlap with res' timeslot
        var // the length we need to find available, plus the required buffers
        l = res.Length.Num(), tbuf = berth.TimeBuffer(), lbuf = berth.LengthBuffer.Num(), 
        // the lowest we could possibly put pm: either end of berth, or furthest possible given pier length
        bottom = Math.min(berth.PierMark.Num() + berth.Length.Num(), pg.PierGroup.Length.Num() + pg.PierGroup.EndOverhang.Num() - l), overlaps = pg.TimelineItems()
            .map(function (i) { return i.TimelinePosition(); })
            .filter(function (pos) { return (pos.Start() && pos.End() && pos.Length()) !== null
            && (+pos.End() + tbuf) > +pt.Arrival.Effective()
            && (+pos.Start() - tbuf) < +pt.Departure.Effective(); }).map(function (pos) { return ({
            top: pos.PierMark.Num() - lbuf,
            bottom: pos.PierMark.Num() + pos.Length().Num() + lbuf
        }); }), 
        // find candidate piermarks for res: either at the top of the berth or right under an existing reservation in the berth
        pms = [berth.PierMark.Num()].concat(overlaps
            .filter(function (o) { return o.bottom > berth.PierMark.Num() && o.bottom <= bottom; })
            .map(function (o) { return o.bottom; }));
        pms.sort(function (a, b) { return a - b; });
        // loop through pm candidates until we find one that doesn't overlap an existing reservation
        PM: for (var i = 0; i < pms.length; i++) {
            var pm = pms[i];
            // loop through all potential overlaps to see if they do indeed overlap with res
            for (var j = 0; j < overlaps.length; j++) {
                var o = overlaps[j];
                // if o overlaps with the current pm, then pm is invalid, so go to the next candidate
                if (pm < o.bottom && (pm + l) > o.top) {
                    continue PM;
                }
            }
            // if we made it here, then the current fm doesn't overlap with any other reservation, so we're done searching
            res.PierMark.Num(pm);
            return this;
        }
        // all candidates failed - set fm to the top of the berth and let the user resolve
        res.PierMark.Num(berth.PierMark.Num());
        return this;
    };
    ChangeBerthTool.prototype.TimelineItemClick = function () { return this; };
    ChangeBerthTool.prototype.OnDateDiscrepancy = function () { this.AttentionGrabber.Activate(); return this; };
    ChangeBerthTool.prototype.Confirm = function () {
        var _this = this;
        this.Reservation.CommitChanges().then(function () {
            _this.changeTool.ReservationDetails(_this.Reservation.Reservation);
        });
    };
    ChangeBerthTool.prototype.Cancel = function () {
        this.Reservation.RevertChanges();
        this.changeTool.ReservationDetails(this.Reservation.Reservation);
    };
    return ChangeBerthTool;
}());
exports.ChangeBerthTool = ChangeBerthTool;
var AttentionGrabber = /** @class */ (function () {
    function AttentionGrabber() {
        var _this = this;
        this._Active = s_js_1.default.value(false);
        this.Active = function () { return _this._Active(); };
        this.timeoutId = undefined;
    }
    AttentionGrabber.prototype.Activate = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(function () { return _this._Active(false); }, 200);
        this._Active(true);
    };
    return AttentionGrabber;
}());
exports.AttentionGrabber = AttentionGrabber;
var AddShiftTool = /** @class */ (function () {
    function AddShiftTool(PortCall, changeTool, reservationSets, ajax, entrypoints, tzutils) {
        var _this = this;
        this.PortCall = PortCall;
        this.changeTool = changeTool;
        this.reservationSets = reservationSets;
        this.tzutils = tzutils;
        this.Dragging = s_js_1.default.value(true);
        this.AttentionGrabber = new AttentionGrabber();
        var previous = null;
        for (var _i = 0, _a = PortCall.ActiveReservations(); _i < _a.length; _i++) {
            var r = _a[_i];
            var dep = r.Itinerary() && r.Itinerary().Departure.Effective();
            if (dep && (!previous || dep > previous.Itinerary().Departure.Effective()))
                previous = r;
        }
        this.PreviousReservation = previous;
        this.NewReservation = new BerthReservation_1.BerthReservation({
            Id: 0,
            SideTo: BerthReservation_3.VesselSide.TBD
        });
        var initArrival = previous.Itinerary().Departure.Effective();
        this.minDeparture = tzutils.newDate(+initArrival + scheduleConstants_1.DEFAULT_NEW_SHIFT_DURATION_MINS * 60 * 1000);
        var itinerary = new ItineraryPoint_1.ItineraryPoint({
            Id: 0,
            PortCallId: PortCall.Id(),
            Arrival: { Estimated: initArrival.toJSON() },
            Departure: { Estimated: this.minDeparture.toJSON() }
        });
        this.NewReservation.Itinerary = function () { return itinerary; };
        this.PierGroup = s_js_1.default.value(previous.Berth().PierGroup());
        this.PierMark = new Measurement_1.Measurement({ Num: previous.PierMark.Num(), UOM: previous.PierMark.UOM() });
        this._Submitting = s_js_1.default.value(false);
        this.Submitting = function () { return _this._Submitting(); };
        this.client = ajax.Url(entrypoints.AddShift, { include: [function (r) { return r.Itinerary; }], useCache: true }),
            // NOTE: This subscribes to this.client.LastResponse, but that's not a memory leak b/c this.client will be
            // freed for GC when this AddShiftTool is.
            this.Validation = validationWatcher_1.ValidationWatcher(this.client);
        // Set NewReservation's length for accurate client-side feedback. The server will apply it's own version
        // of the same logic when we submit our AddShift request.
        // NOTE: We're fine subscribing to this.NewReservation.SideTo b/c this.NewReservation will be freed for
        // GC when this AddShiftTool is, but we avoid subscribing to any properties of PortCall to avoid creating
        // a memory leak.
        s_js_1.default.on(this.NewReservation.SideTo, function () {
            var _a, _b, _c, _d, _e;
            var length = BerthReservation_1.BerthReservation.calculateLength((_b = (_a = PortCall.Vessel()) === null || _a === void 0 ? void 0 : _a.Length) !== null && _b !== void 0 ? _b : null, (_d = (_c = PortCall.Vessel()) === null || _c === void 0 ? void 0 : _c.Beam) !== null && _d !== void 0 ? _d : null, PortCall.LengthOnlyLength, _this.NewReservation.SideTo(), (_e = PortCall.LengthOnlyLength.UOM()) !== null && _e !== void 0 ? _e : UOM_1.default.Foot);
            if (length === null || length === void 0 ? void 0 : length.Num())
                _this.NewReservation.Length.set(length);
        });
    }
    Object.defineProperty(AddShiftTool.prototype, "Departure", {
        get: function () {
            return this.NewReservation.Itinerary().Departure.Estimated;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddShiftTool.prototype, "Arrival", {
        get: function () {
            return this.NewReservation.Itinerary().Arrival.Estimated;
        },
        enumerable: false,
        configurable: true
    });
    AddShiftTool.prototype.TimelinePosition = function () {
        var _this = this;
        return {
            Start: this.Arrival,
            // Allow shifting date range to be in the future when in dragging mode, as user might be trying to
            // create a longer shift.
            End: function () { return _this.Dragging() ? VERY_LONG_TIME_IN_THE_FUTURE : maxDate(_this.Arrival(), _this.Departure()); },
            Berth: function () { return berthAtPierMark(_this.PierGroup(), _this.PierMark.Num()); },
            PierMark: this.PierMark,
            Length: function () { return _this.NewReservation.Length; },
            UniqueKey: function () { return 'add-shift-tool'; }
        };
    };
    AddShiftTool.prototype.Drag = function (loc) {
        if (this.Dragging() && loc && loc.PierGroup.Port() === this.PortCall.Port()) {
            this.PierGroup(loc.PierGroup);
            this.PierMark.Num(roundPierMark(loc.PierMark.Num() - this.NewReservation.Length.Num() / 2));
            this.Departure(roundTime(+loc.Date, this.tzutils) < this.minDeparture ? this.minDeparture : roundTime(+loc.Date, this.tzutils));
        }
    };
    AddShiftTool.prototype.OpenSpaceClick = function () {
        if (this.Dragging()) {
            var prev = this.PreviousReservation, 
            // TODO: It'd be slick to figure out if this "shift" is really the in (or out) movement from
            // (or to) an anchorage, in which case using the arrival (or departure) berth's
            // BerthTransitOffset would probably make more sense here.
            transitMins_1 = prev.Berth().PierGroup() === this.PierGroup() ? scheduleConstants_1.SAME_PIERGROUP_TRANSIT_MINS : scheduleConstants_1.DIFFERENT_PIERGROUP_TRANSIT_MINS, arrival = tzmoment_1.tzmomentMod(this.tzutils, prev.Itinerary().Departure.Effective(), function (d) { return d.add(transitMins_1, "minutes"); }), minDeparture = tzmoment_1.tzmomentMod(this.tzutils, arrival, function (d) { return d.add(scheduleConstants_1.DEFAULT_NEW_SHIFT_DURATION_MINS, "minutes"); });
            this.Arrival(arrival);
            if (this.Departure() < minDeparture)
                this.Departure(minDeparture);
            this.Dragging(false);
        }
        return this;
    };
    AddShiftTool.prototype.TimelineItemClick = function () { return this; };
    AddShiftTool.prototype.OnDateDiscrepancy = function () { this.AttentionGrabber.Activate(); return this; };
    AddShiftTool.prototype.Confirm = function () {
        var _this = this;
        if (this._Submitting())
            return;
        this._Submitting(true);
        var berth = berthAtPierMark(this.PierGroup(), this.PierMark.Num());
        this.NewReservation.Footmark.Num(FootmarkForPierMark(berth, this.PierMark.Num()));
        this.NewReservation.Footmark.UOM(berth.StartMark.UOM());
        this.NewReservation.Itinerary().LocationId(berth.Id());
        this.client.Post(this.NewReservation).then(function (entities) {
            _this.reservationSets.push(entities.BerthReservations);
            var res = entities.BerthReservations()[0];
            _this.changeTool.ReservationDetails(res);
        }).finally(function () { return _this._Submitting(false); });
    };
    AddShiftTool.prototype.Cancel = function () {
        this.changeTool.None();
    };
    return AddShiftTool;
}());
exports.AddShiftTool = AddShiftTool;
var ReservationDetailsTool = /** @class */ (function () {
    function ReservationDetailsTool(Reservation, changeTool) {
        this.Reservation = Reservation;
        this.changeTool = changeTool;
    }
    Object.defineProperty(ReservationDetailsTool.prototype, "TimelineItem", {
        get: function () { return this.Reservation; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReservationDetailsTool.prototype, "Validation", {
        get: function () { return this.Reservation.Validation; },
        enumerable: false,
        configurable: true
    });
    ReservationDetailsTool.prototype.TimelineItemClick = function (item) {
        return item === this.Reservation ? null : item.MakeDetailsTool(this.changeTool);
    };
    ReservationDetailsTool.prototype.LogActual = function (arrival) {
        var _this = this;
        var pt = this.Reservation.Reservation.Itinerary();
        if (!pt)
            return;
        var sched = arrival ? pt.Arrival : pt.Departure;
        s_js_1.default.freeze(function () {
            sched.Actual(sched.Estimated());
            _this.EditTimeblock();
        });
    };
    ReservationDetailsTool.prototype.EditTimeblock = function () {
        this.changeTool.EditTimeblock(this.Reservation.Reservation);
    };
    ReservationDetailsTool.prototype.ChangeBerth = function () {
        this.changeTool.ChangeBerth(this.Reservation.Reservation);
    };
    ReservationDetailsTool.prototype.AddShift = function () {
        this.changeTool.AddShift(this.Reservation.Reservation);
    };
    ReservationDetailsTool.prototype.ShiftReservation = function (r) {
        this.changeTool.ReservationDetails(r);
    };
    ReservationDetailsTool.prototype.ViewOverlaps = function () {
        this.changeTool.ReservationOverlaps(this.Reservation.Reservation);
    };
    return ReservationDetailsTool;
}());
exports.ReservationDetailsTool = ReservationDetailsTool;
var UnlistedReservationDetailsTool = /** @class */ (function () {
    function UnlistedReservationDetailsTool(UnlistedReservation, changeTool) {
        this.UnlistedReservation = UnlistedReservation;
        this.changeTool = changeTool;
    }
    Object.defineProperty(UnlistedReservationDetailsTool.prototype, "TimelineItem", {
        get: function () { return this.UnlistedReservation; },
        enumerable: false,
        configurable: true
    });
    UnlistedReservationDetailsTool.prototype.TimelineItemClick = function (item) {
        return item === this.UnlistedReservation ? null : item.MakeDetailsTool(this.changeTool);
    };
    return UnlistedReservationDetailsTool;
}());
exports.UnlistedReservationDetailsTool = UnlistedReservationDetailsTool;
var BerthClosureDetailsTool = /** @class */ (function () {
    function BerthClosureDetailsTool(BerthClosure, changeTool) {
        this.BerthClosure = BerthClosure;
        this.changeTool = changeTool;
        this.ShowActionsMenu = s_js_1.default.value(false);
        this.ShowConfirmDelete = s_js_1.default.value(false);
        this.AttentionGrabber = new AttentionGrabber();
    }
    Object.defineProperty(BerthClosureDetailsTool.prototype, "TimelineItem", {
        get: function () { return this.BerthClosure; },
        enumerable: false,
        configurable: true
    });
    // DON'T proxy this.BerthClosure.Validation via this.Validation.
    // ITimelineItemTool.Validation opens a modal popup on validation errors, which is a good
    // UX for server-side validation errors but works really badly for client-side validation
    // like we do for berth closures. We'll rely on inline validation messages in the berth
    // closure details popup instead.
    BerthClosureDetailsTool.prototype.OpenSpaceClick = function () { return this.BerthClosure.HasUnsavedChanges() ? this : null; };
    BerthClosureDetailsTool.prototype.TimelineItemClick = function (item) {
        return this.BerthClosure.HasUnsavedChanges() ? this : item === this.BerthClosure ? null : item.MakeDetailsTool(this.changeTool);
    };
    BerthClosureDetailsTool.prototype.OnDateDiscrepancy = function () {
        if (this.BerthClosure.HasUnsavedChanges()) {
            this.AttentionGrabber.Activate();
            return this;
        }
        else {
            return null;
        }
    };
    BerthClosureDetailsTool.prototype.ToggleActionsMenu = function () {
        this.ShowActionsMenu(!this.ShowActionsMenu());
    };
    BerthClosureDetailsTool.prototype.MenuAction = function (action) {
        var _this = this;
        return function () { return s_js_1.default.freeze(function () {
            action();
            _this.ShowActionsMenu(false);
        }); };
    };
    BerthClosureDetailsTool.prototype.DeleteClosure = function () {
        var _this = this;
        this.BerthClosure.Delete().then(function () { return _this.changeTool.None(); });
    };
    BerthClosureDetailsTool.prototype.ViewOverlaps = function () {
        this.changeTool.BerthClosureOverlaps(this.BerthClosure.BerthClosure);
    };
    return BerthClosureDetailsTool;
}());
exports.BerthClosureDetailsTool = BerthClosureDetailsTool;
var ReservationOverlapsTool = /** @class */ (function () {
    function ReservationOverlapsTool(Reservation, Now, data, changeTool) {
        this.Reservation = Reservation;
        this.Now = Now;
        this.navigation = new OverlapsNavigation(data, changeTool);
    }
    Object.defineProperty(ReservationOverlapsTool.prototype, "TimelineItem", {
        get: function () { return this.Reservation; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReservationOverlapsTool.prototype, "Validation", {
        get: function () { return this.Reservation.Validation; },
        enumerable: false,
        configurable: true
    });
    ReservationOverlapsTool.prototype.ViewConflictingReservation = function (resId) {
        this.navigation.ViewConflictingReservation(resId);
    };
    ReservationOverlapsTool.prototype.ViewConflictingBerthClosure = function (bclId) {
        this.navigation.ViewConflictingBerthClosure(bclId);
    };
    return ReservationOverlapsTool;
}());
exports.ReservationOverlapsTool = ReservationOverlapsTool;
var BerthClosureOverlapsTool = /** @class */ (function () {
    function BerthClosureOverlapsTool(BerthClosure, Now, data, changeTool) {
        this.BerthClosure = BerthClosure;
        this.Now = Now;
        this.navigation = new OverlapsNavigation(data, changeTool);
    }
    Object.defineProperty(BerthClosureOverlapsTool.prototype, "TimelineItem", {
        get: function () { return this.BerthClosure; },
        enumerable: false,
        configurable: true
    });
    // DON'T proxy this.BerthClosure.Validation via this.Validation, for the same reasons as
    // BerthClosureDetailsTool above.
    BerthClosureOverlapsTool.prototype.ViewConflictingReservation = function (resId) {
        this.navigation.ViewConflictingReservation(resId);
    };
    BerthClosureOverlapsTool.prototype.ViewConflictingBerthClosure = function (bclId) {
        this.navigation.ViewConflictingBerthClosure(bclId);
    };
    return BerthClosureOverlapsTool;
}());
exports.BerthClosureOverlapsTool = BerthClosureOverlapsTool;
var OverlapsNavigation = /** @class */ (function () {
    function OverlapsNavigation(data, changeTool) {
        this.data = data;
        this.changeTool = changeTool;
    }
    OverlapsNavigation.prototype.ViewConflictingReservation = function (resId) {
        // Our issue schema will tell us if something has an issue w/ a berth reservation,
        // but not whether that reservation shows up as listed or unlisted (since that's
        // permissions dependent). So try looking up the reservation for the given ID, and
        // if that fails, try looking up an unlisted reservation for the same ID.
        var r = this.data.BerthReservations.index(resId)();
        if (r) {
            this.changeTool.ReservationDetails(r);
        }
        else {
            var ur = this.data.UnlistedBerthReservations.index(resId)();
            if (ur) {
                this.changeTool.UnlistedReservationDetails(ur);
            }
            else {
                throw new Error("No BerthReservation or UnlistedBerthReservation found with ID " + resId);
            }
        }
    };
    OverlapsNavigation.prototype.ViewConflictingBerthClosure = function (bclId) {
        var bcl = this.data.BerthClosures.index(bclId)();
        if (bcl) {
            this.changeTool.BerthClosureDetails(bcl);
        }
        else {
            throw new Error("No BerthClosure found with ID " + bclId);
        }
    };
    return OverlapsNavigation;
}());
// must move an appreciable ammount to trigger change: moved flag keeps track of that
var dragReservationThreshhold = 5, minOverlap = 50; // minimum length of reservation that must not be overhanging
var EditTimeblockTool = /** @class */ (function () {
    function EditTimeblockTool(Reservation, changeTool, tzutils) {
        this.Reservation = Reservation;
        this.changeTool = changeTool;
        this.tzutils = tzutils;
        this.AttentionGrabber = new AttentionGrabber();
    }
    Object.defineProperty(EditTimeblockTool.prototype, "TimelineItem", {
        get: function () { return this.Reservation; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditTimeblockTool.prototype, "Validation", {
        get: function () { return this.Reservation.Validation; },
        enumerable: false,
        configurable: true
    });
    EditTimeblockTool.prototype.OpenSpaceClick = function () { return this; };
    EditTimeblockTool.prototype.TimelineItemClick = function () { return this; };
    EditTimeblockTool.prototype.OnDateDiscrepancy = function () { this.AttentionGrabber.Activate(); return this; };
    EditTimeblockTool.prototype.StartDragReservation = function (start, compact) {
        var _this = this;
        var b = this.Reservation.Reservation.Berth();
        var res = this.Reservation.Reservation, pt = this.Reservation.ItineraryPoint, pg = b && b.PierGroup();
        // we "box" how far the reservation can be dragged to only within the current piergroup
        var markbox = {
            min: Math.max(-pg.StartOverhang.Num(), minOverlap - res.Length.Num()),
            max: pg.Length.Num() + Math.min(pg.EndOverhang.Num(), res.Length.Num() - minOverlap) - res.Length.Num()
        }, startArrival = pt.Arrival.Effective(), startDeparture = pt.Departure.Effective(), duration = +startDeparture - +startArrival, startPierMark = res.PierMark.Num(), startBerth = b;
        var moved = '';
        return function (loc) {
            s_js_1.default.freeze(function () {
                var dPierMark = loc.PierMark.Num() - start.PierMark.Num(), dMilliseconds = +loc.Date - +start.Date, dX = loc.X - start.X, dY = loc.Y - start.Y;
                // set moved flag if we've moved at least 5 px in x or y direction
                moved =
                    Math.abs(dX) > dragReservationThreshhold && (compact || Math.abs(dX) > Math.abs(dY)) ? 'x' :
                        Math.abs(dY) > dragReservationThreshhold && (!compact && Math.abs(dY) > Math.abs(dX)) ? 'y' :
                            '';
                if (moved === 'x') {
                    var newArrivalTime = roundTime(+startArrival + dMilliseconds, _this.tzutils), newDepartureTime = _this.tzutils.newDate(+newArrivalTime + duration);
                    pt.Arrival.Effective(newArrivalTime);
                    pt.Departure.Effective(newDepartureTime);
                    // since we're only dragging in x direction, reset y to start
                    pt.LocationId(startBerth.Id());
                    res.PierMark.Num(startPierMark);
                }
                else if (moved === 'y') {
                    // ignore drag motions beyond piergroup
                    if (loc.PierGroup !== pg)
                        return;
                    var newPierMark = box(markbox, roundPierMark(startPierMark + dPierMark));
                    //check the new piermark to see if it falls in the same berth or a different one in the pier group
                    if (newPierMark < b.PierMark.Num() || newPierMark > b.PierMark.Num() + b.Length.Num()) {
                        var berths = pg.Berths();
                        for (var i = 0; i < berths.length; i++) {
                            var berth = berths[i];
                            if (newPierMark >= berth.PierMark.Num() && newPierMark <= berth.PierMark.Num() + berth.Length.Num()) {
                                b = berth;
                                pt.LocationId(b.Id());
                                break;
                            }
                        }
                    }
                    res.PierMark.Num(newPierMark);
                    // reset any changes to x direction
                    pt.Arrival.Effective(startArrival);
                    pt.Departure.Effective(startDeparture);
                }
            });
        };
    };
    EditTimeblockTool.prototype.DragDate = function (arrival) {
        var _this = this;
        return function (loc) {
            var pt = _this.Reservation.Reservation.Itinerary();
            if (!pt)
                return;
            var date = roundTime(+loc.Date, _this.tzutils);
            // can't drag date beyond opposite line time
            if (arrival) {
                if (+date > +pt.Departure.Effective())
                    date = pt.Departure.Effective();
                pt.Arrival.Effective(date);
            }
            else {
                if (+date < +pt.Arrival.Effective())
                    date = pt.Arrival.Effective();
                pt.Departure.Effective(date);
            }
        };
    };
    EditTimeblockTool.prototype.LogActual = function (arrival) {
        var pt = this.Reservation.Reservation.Itinerary();
        if (!pt)
            return;
        var sched = arrival ? pt.Arrival : pt.Departure;
        sched.Actual(sched.Estimated());
    };
    EditTimeblockTool.prototype.Confirm = function () {
        var _this = this;
        this.Reservation.CommitChanges().then(function () {
            _this.changeTool.ReservationDetails(_this.Reservation.Reservation);
        });
    };
    EditTimeblockTool.prototype.Cancel = function () {
        this.Reservation.RevertChanges();
        this.changeTool.ReservationDetails(this.Reservation.Reservation);
    };
    return EditTimeblockTool;
}());
exports.EditTimeblockTool = EditTimeblockTool;
function FootmarkForPierMark(b, pm) {
    return pm - b.PierMark.Num() + b.StartMark.Num();
}
var NewReservationTool = /** @class */ (function () {
    function NewReservationTool(loc, tzutils, piergroupMap) {
        this.tzutils = tzutils;
        this.piergroupMap = piergroupMap;
        var uom = s_js_1.default.sample(loc.PierGroup.Length.UOM);
        this.PierGroup = function () { return loc.PierGroup; };
        this.PierMark = new Measurement_1.Measurement({ Num: loc.PierMark, UOM: uom });
        this.Length = new Measurement_1.Measurement({ Num: loc.Length, UOM: uom });
        this.Arrival = s_js_1.default.value(loc.First, TZDate_1.default.eq);
        this.Departure = s_js_1.default.value(loc.Last, TZDate_1.default.eq);
    }
    NewReservationTool.prototype.TimelinePosition = function () {
        var _this = this;
        return {
            Start: this.Arrival,
            End: function () { return maxDate(_this.Arrival(), _this.Departure()); },
            Berth: function () { return berthAtPierMark(_this.PierGroup(), _this.PierMark.Num()); },
            PierMark: this.PierMark,
            Length: function () { return _this.Length; },
            UniqueKey: function () { return 'new-reservation-tool'; }
        };
    };
    NewReservationTool.TryCreateTool = function (loc, berthRights, tzutils, piergroupMap) {
        var region = NewReservationTool.FindReservableRegion(loc, berthRights, tzutils, piergroupMap);
        return region && new NewReservationTool(region, tzutils, piergroupMap);
    };
    // based on the location of the click event, see how much of the pier group is available for reservation, 
    // up to the entire piergroup for the entire day of the click
    // returns either a NewReservation object or null, if no space was available.
    NewReservationTool.FindReservableRegion = function (loc, berthRights, tzutils, piergroupMap) {
        var pg = piergroupMap(loc.PierGroup), cpm = loc.PierMark.Num(), day = loc.Date;
        // start out trying to reserve entire pier group, from piermark (pm) 0 to full length (len)
        var pm = 0, len = pg.PierGroup.Length.Num(), 
        // start with duration of (almost) a full day
        first = tzmoment_1.tzmomentMod(tzutils, day, function (m) { return m.startOf('day'); }), fail = false;
        var last = tzmoment_1.tzmomentMod(tzutils, first, function (m) { return m.add(1, 'day').subtract(1, 'minute'); });
        // dimensions of timeline items, padded by required buffers
        var others = pg.TimelineItems()
            .map(function (i) { return i.TimelinePosition(); })
            .filter(function (pos) { return (pos.Start() && pos.End() && pos.Berth() && pos.Length()) !== null; })
            .map(function (pos) {
            var pbuf = pos.Berth().LengthBuffer.Num(), tbuf = pos.Berth().TimeBuffer() * 60 * 1000;
            return {
                top: pos.PierMark.Num() - pbuf,
                bot: pos.PierMark.Num() + pos.Length().Num() + pbuf,
                // TH 03/29/2017 -- NOTE: Before refactoring to use an ITimelinePosition,
                // this code used Itinerary()!.Arrival.Estimated() and Itinerary()!.Departure.Estimated.
                // The switch to ITimelinePositions has the functional effect of using Effective instead of Estimated.
                // This was the only spot on the page we were using Estimates instead of Effectives in overlap calculations.
                // From talking w/ AH, we believe Effective times should work just as well here.
                first: pos.Start().getTime() - tbuf,
                last: pos.End().getTime() + tbuf
            };
        });
        // if user doesn't have rights to reserve any berths in the piergroup, block them out
        pg.Berths().forEach(function (b) {
            if (!(berthRights[s_js_1.default.sample(b.Id)] & Rights_1.BerthRights.Reserve)) {
                others.push({
                    top: b.PierMark.Num(),
                    bot: b.PierMark.Num() + b.Length.Num(),
                    first: +first,
                    last: +last
                });
            }
        });
        // now we search to see how much of the day is available
        others.forEach(function (r) {
            // see if reservation is in line with click point
            if (r.top < cpm && cpm < r.bot) {
                // see if other res is before, after, or at (!) our click
                if (r.last < +day) {
                    // before.  check if we need to pull back our start time
                    if (r.last > +first)
                        first = tzutils.newDate(r.last);
                }
                else if (+day < r.first) {
                    // after.  check if we need to bring back our end time
                    if (r.first < +last)
                        last = tzutils.newDate(r.first);
                }
                else {
                    // click is *on* reservation - can't make res
                    fail = true;
                }
            }
        });
        if (fail)
            return null;
        // now that we know our time range, see how much of the piergroup length is open
        others.forEach(function (r) {
            // see if other res overlaps our time range
            if (r.last > +first && r.first < +last) {
                // yes: check if it overlaps our pier range
                if (cpm < r.top) {
                    // clicked above other res and other res overlaps: shorten length of new res
                    if (pm + len > r.top)
                        len = r.top - pm;
                }
                else if (cpm > r.bot) {
                    // clicked below other res and other res overlaps: drop footmark and shorten equiv. ammount
                    if (r.bot > pm) {
                        len -= (r.bot - pm);
                        pm = r.bot;
                    }
                }
                else {
                    // click is *on* reservation - can't make res
                    fail = true;
                }
            }
        });
        if (fail)
            return null;
        return { PierGroup: pg.PierGroup, PierMark: pm, Length: len, First: first, Last: last };
    };
    NewReservationTool.prototype.StartDateDrag = function (arrival) {
        var _this = this;
        var date = arrival ? this.Arrival : this.Departure, opposite = arrival ? this.Departure : this.Arrival, dir = date() < opposite() ? -1 : 1, // are we dragging the left handle (dir = -1) or the right one (dir = 1)?
        pmBox = { min: 0, max: this.PierGroup().Length.Num() }, dateBox = { min: dir * +opposite() }, barriers = this.piergroupMap(this.PierGroup()).TimelineItems()
            .map(function (i) { return i.TimelinePosition(); })
            .filter(function (pos) { return (pos.Start() && pos.End() && pos.Berth() && pos.Length()) !== null; })
            .map(function (pos) {
            var b = pos.Berth(), tbuf = b.TimeBuffer() * 60 * 1000, pbuf = b.LengthBuffer.Num(), d = +pos.Start() - tbuf < +opposite() && +opposite() < +pos.End() + tbuf
                ? dateBox.min
                : dir === 1 ? +pos.Start() - tbuf
                    : dir * +pos.End() - tbuf;
            return {
                date: d,
                top: pos.PierMark.Num() - pbuf,
                bottom: pos.PierMark.Num() + pos.Length().Num() + pbuf
            };
        })
            .filter(function (r) { return r.date >= dateBox.min; });
        barriers.sort(function (a, b) { return a.date - b.date; });
        var lastValidPm = pmBox.min;
        var checkfit = function (d, pm) {
            var top = pmBox.min, bottom = pmBox.max, i;
            for (i = 0; i < barriers.length; i++) {
                var barrier = barriers[i];
                if (barrier.date > d)
                    break;
                if (pm < barrier.top) {
                    // cutting above barrier
                    if (bottom > barrier.top) {
                        bottom = barrier.top;
                    }
                }
                else if (pm > barrier.bottom) {
                    // cutting below barrier
                    if (top < barrier.bottom) {
                        top = barrier.bottom;
                    }
                }
                else {
                    // ran straight into barrier - halt
                    d = barrier.date;
                    break;
                }
            }
            if (d <= dateBox.min) {
                // impossible, ignore action;
                return;
            }
            // record the last valid piermark in case user moves mouse to impossible position
            lastValidPm = pm;
            s_js_1.default.freeze(function () {
                _this.PierMark.Num(top);
                _this.Length.Num(bottom - top);
                date(roundTime(dir * d, _this.tzutils));
            });
        };
        return function (loc) {
            var d = box(dateBox, dir * +loc.Date), pm = loc.PierGroup === _this.PierGroup() ? box(pmBox, loc.PierMark.Num()) : lastValidPm;
            checkfit(d, pm);
        };
    };
    NewReservationTool.prototype.Reserve = function () {
        var berth = berthAtPierMark(this.PierGroup(), this.PierMark.Num());
        if (!berth)
            return;
        window.location.href = '#!addportcall?berth=' + berth.Id()
            + '&footmark=' + Math.ceil(FootmarkForPierMark(berth, this.PierMark.Num())) // round to nearest whole number
            + '&firstline=' + encodeURIComponent(this.Arrival().toJSON())
            + '&lastline=' + encodeURIComponent(this.Departure().toJSON());
    };
    return NewReservationTool;
}());
exports.NewReservationTool = NewReservationTool;
var typeaheadOptions = {
    minLength: 0,
    highlight: true,
    hint: false
};
function PortFilterModel(params, ports) {
    // filter values are route parameters, and baring that, we preserve them in localStorage
    var Query = s_js_1.default.value(params.port), debouncedQuery = debounceSignal_1.debounceSignal(Query);
    var typeahead = new model_2.Typeahead({
        typeaheadOptions: typeaheadOptions,
        collection: ports,
        observable: Query,
        matchFn: function (port, query) { return diacriticals_1.CaseInsensitiveContains(port.Port.Name(), query); },
        displayKey: function (port) { return port.Port.Name(); }
    });
    return {
        Query: Query,
        QueryMatches: function (port) { return !debouncedQuery() || diacriticals_1.CaseInsensitiveContains(port.Name(), debouncedQuery()); },
        Typeahead: typeahead,
        ShowFilter: function () { return ports().length > 1; }
    };
}
function CapabilityFilterModel(params, berthCapabilities) {
    // filter values are route parameters, and baring that, we preserve them in localStorage
    var Query = s_js_1.default.value(params.capability), debouncedQuery = debounceSignal_1.debounceSignal(Query);
    var typeahead = new model_2.Typeahead({
        typeaheadOptions: typeaheadOptions,
        collection: berthCapabilities.filter(function (c) { return c.Active(); }),
        observable: Query,
        matchFn: function (cap, query) { return diacriticals_1.CaseInsensitiveContains(cap.Name(), query); },
        displayKey: function (cap) { return cap.Name(); }
    });
    return {
        Query: Query,
        QueryMatches: QueryMatches,
        Typeahead: typeahead
    };
    function QueryMatches(pg) {
        return !debouncedQuery() || pg.Berths().some(function (berth) {
            return berth.Capabilities().some(function (bca) {
                return !!bca.Capability() && diacriticals_1.CaseInsensitiveContains(bca.Capability().Name(), debouncedQuery());
            });
        });
    }
}
function roundTime(t, tzutils) {
    return tzutils.newDate(nearest(timeIncrement * 60 * 1000, t));
}
function roundPierMark(d) {
    return nearest(pierMarkIncrement, d);
}
function box(b, x) {
    return b.min !== undefined && x < b.min ? b.min : b.max !== undefined && x > b.max ? b.max : x;
}
function nearest(n, x) {
    return n * Math.round(x / n);
}
// Helper function that we call above to get unique IDs from lists of BerthReservations and
// other "timeline item" entities and filter out deleted entities.
function uniqueIds(sets, index) {
    var ids = {};
    sets().forEach(function (set) { return set().forEach(function (item) {
        var id = item.Id();
        if (index(id)() !== null) {
            ids[id] = true;
        }
    }); });
    return Object.keys(ids).map(function (id) { return +id; });
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceProfile = exports.VesselServiceProfileMode = void 0;
var s_js_1 = __webpack_require__(0);
var VesselServiceProfileMode;
(function (VesselServiceProfileMode) {
    VesselServiceProfileMode[VesselServiceProfileMode["Particulars"] = 0] = "Particulars";
    VesselServiceProfileMode[VesselServiceProfileMode["PortCalls"] = 1] = "PortCalls";
})(VesselServiceProfileMode = exports.VesselServiceProfileMode || (exports.VesselServiceProfileMode = {}));
function VesselServiceProfile(params, vesselServiceOverrideModel, vesselPortCallsModel) {
    var id = params.id, _mode = params.mode, mode = s_js_1.default.data(_mode), vesselServiceOverride = vesselServiceOverrideModel(params), vesselPortCalls = vesselPortCallsModel(params);
    return {
        Id: id,
        VesselServiceOverride: vesselServiceOverride,
        VesselPortCalls: vesselPortCalls,
        GoBack: function () { return window.history.back(); },
        GoParticulars: GoParticulars,
        GoPortCalls: GoPortCalls,
        Mode: mode
    };
    function GoParticulars() {
        mode(VesselServiceProfileMode.Particulars);
    }
    function GoPortCalls() {
        mode(VesselServiceProfileMode.PortCalls);
    }
}
exports.VesselServiceProfile = VesselServiceProfile;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchRecurrencePeriod = void 0;
var BatchRecurrenceFrequency_1 = __webpack_require__(302);
var BatchRecurrencePeriod_1 = __webpack_require__(1416);
var BatchRecurrencePeriod = /** @class */ (function (_super) {
    __extends(BatchRecurrencePeriod, _super);
    function BatchRecurrencePeriod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BatchRecurrencePeriod.prototype.toString = function () {
        return this.Frequency() === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom ?
            this.CustomDays() + ' Days' :
            BatchRecurrenceFrequency_1.BatchRecurrenceFrequencyDisplayName[this.Frequency()];
    };
    return BatchRecurrencePeriod;
}(BatchRecurrencePeriod_1.BatchRecurrencePeriod));
exports.BatchRecurrencePeriod = BatchRecurrencePeriod;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoActivityType = void 0;
var CargoActivityType_1 = __webpack_require__(613);
__exportStar(__webpack_require__(613), exports);
var CargoActivityType = /** @class */ (function (_super) {
    __extends(CargoActivityType, _super);
    function CargoActivityType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for CargoActivityTypes. */
    CargoActivityType.DisplayOrder = function (t1, t2) {
        var cmp;
        return (cmp = t1.DisplayOrder() - t2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            t1.Id() - t2.Id() :
            cmp;
    };
    return CargoActivityType;
}(CargoActivityType_1.CargoActivityType));
exports.CargoActivityType = CargoActivityType;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoCategory = void 0;
var CargoCategory_1 = __webpack_require__(614);
__exportStar(__webpack_require__(614), exports);
var CargoCategory = /** @class */ (function (_super) {
    __extends(CargoCategory, _super);
    function CargoCategory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for CargoCategories. */
    CargoCategory.DisplayOrder = function (c1, c2) {
        var cmp;
        return (cmp = c1.DisplayOrder() - c2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            c1.Id() - c2.Id() :
            cmp;
    };
    return CargoCategory;
}(CargoCategory_1.CargoCategory));
exports.CargoCategory = CargoCategory;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
var fileurls_1 = __webpack_require__(261);
var Comment_1 = __webpack_require__(1442);
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Comment.prototype.AttachmentFileName = function () {
        return this.AttachmentUrl() && fileurls_1.fileNameFromUrl(this.AttachmentUrl());
    };
    /**
     * The Event to which this Comment is rooted in any logs in which it appears. Mimics
     * server-side Comment.RootEvent property from PortCall.Models\Comments\Comment.cs.
     */
    Comment.prototype.RootEvent = function () {
        var _a, _b;
        var next = this;
        while ((_a = next.SubjectEvent()) === null || _a === void 0 ? void 0 : _a.Comment()) {
            next = next.SubjectEvent().Comment();
        }
        return (_b = next.SubjectEvent()) !== null && _b !== void 0 ? _b : next.Event();
    };
    return Comment;
}(Comment_1.Comment));
exports.Comment = Comment;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
var Country_1 = __webpack_require__(1452);
var Country = /** @class */ (function (_super) {
    __extends(Country, _super);
    function Country() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Country.SortOrder = function (c1, c2) {
        return c1.SortOrder() !== c2.SortOrder() ? c1.SortOrder() - c2.SortOrder()
            : c1.Name() < c2.Name() ? -1
                : c1.Name() > c2.Name() ? 1
                    : 0;
    };
    return Country;
}(Country_1.Country));
exports.Country = Country;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1475), exports);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1500), exports);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 10/5/2016 -- Generated by hand from PortCall.Models\Users\PCRoles.cs.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCRoles = void 0;
var PCRoles;
(function (PCRoles) {
    PCRoles[PCRoles["SiteAdmin"] = 10] = "SiteAdmin";
    PCRoles[PCRoles["ManageBerths"] = 20] = "ManageBerths";
    PCRoles[PCRoles["ManageUsers"] = 30] = "ManageUsers";
    PCRoles[PCRoles["ReserveBerths"] = 40] = "ReserveBerths";
    PCRoles[PCRoles["ManageBills"] = 50] = "ManageBills";
})(PCRoles = exports.PCRoles || (exports.PCRoles = {}));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1522), exports);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatch = void 0;
var ItineraryPoint_1 = __webpack_require__(69);
var RecurringBatch_1 = __webpack_require__(1559);
var RecurringBatch = /** @class */ (function (_super) {
    __extends(RecurringBatch, _super);
    function RecurringBatch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecurringBatch.prototype.ReservationPoints = function () {
        return this.PortCalls()
            .map(function (pc) { return pc.Itinerary().filter(function (pt) { return pt.BerthReservation() !== null; }); })
            .reduce(function (pts, nextPts) { return pts.concat(nextPts); }, [])
            .slice()
            .sort(ItineraryPoint_1.ItineraryPoint.EffectiveOrder);
    };
    RecurringBatch.prototype.Reservations = function () {
        return this.ReservationPoints()
            .filter(function (pt) { return pt.BerthReservation() !== null; })
            .map(function (pt) { return pt.BerthReservation(); });
    };
    RecurringBatch.prototype.FirstReservationPoint = function () {
        return this.ReservationPoints().length > 0 ? this.ReservationPoints()[0] : null;
    };
    RecurringBatch.prototype.LastReservationPoint = function () {
        return this.ReservationPoints().length > 0 ? this.ReservationPoints()[this.ReservationPoints().length - 1] : null;
    };
    RecurringBatch.prototype.FirstReservation = function () {
        return this.FirstReservationPoint() && this.FirstReservationPoint().BerthReservation();
    };
    RecurringBatch.prototype.LastReservation = function () {
        return this.LastReservationPoint() && this.LastReservationPoint().BerthReservation();
    };
    RecurringBatch.prototype.FirstPortCall = function () {
        return this.FirstReservationPoint() && this.FirstReservationPoint().PortCall();
    };
    RecurringBatch.prototype.LastPortCall = function () {
        return this.LastReservationPoint() && this.LastReservationPoint().PortCall();
    };
    return RecurringBatch;
}(RecurringBatch_1.RecurringBatch));
exports.RecurringBatch = RecurringBatch;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateEntity = void 0;
var s_js_1 = __webpack_require__(0);
var MilestoneTypes_1 = __webpack_require__(158);
var ScheduleDateEntity_1 = __webpack_require__(1572);
var ScheduleDateType_1 = __webpack_require__(80);
var ScheduleDate_1 = __webpack_require__(93);
var ScheduleDateEntity = /** @class */ (function (_super) {
    __extends(ScheduleDateEntity, _super);
    function ScheduleDateEntity(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data) || this;
        // get the ScheduleDate entity stored in the parent
        var getParentDate = function () {
            return (_this.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ? _this.ItineraryPoint() && _this.ItineraryPoint().Arrival :
                _this.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ? _this.ItineraryPoint() && _this.ItineraryPoint().Departure :
                    _this.Type() === ScheduleDateType_1.ScheduleDateType.PJOStart ? _this.JobOrder() && _this.JobOrder().PilotJobOrder() && _this.JobOrder().PilotJobOrder().Start :
                        _this.Type() === ScheduleDateType_1.ScheduleDateType.PJOEnd ? _this.JobOrder() && _this.JobOrder().PilotJobOrder() && _this.JobOrder().PilotJobOrder().End :
                            null)
                || new ScheduleDate_1.ScheduleDate();
        };
        _this.Estimated = function (val) { return val === undefined ? getParentDate().Estimated() : s_js_1.default.sample(getParentDate).Estimated(val); };
        _this.Actual = function (val) { return val === undefined ? getParentDate().Actual() : s_js_1.default.sample(getParentDate).Actual(val); };
        _this.Anchor = function (val) { return val === undefined ? getParentDate().Anchor() : s_js_1.default.sample(getParentDate).Anchor(val); };
        _this.Effective = ScheduleDate_1.EffectiveDate(_this);
        return _this;
    }
    ScheduleDateEntity.prototype.IsMovementStartDate = function () {
        return (this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FirstArrival ||
            this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.ShiftDeparture ||
            this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FinalDeparture);
    };
    ScheduleDateEntity.prototype.IsBerthArrivalDate = function () {
        return (this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.BerthArrival);
    };
    // NOTE: NextMilestoneDate and PreviousMilestoneDate mirrored in C# in
    // PortCall.Models\Schedule\ScheduleDateEntity.cs. Keep in sync.
    ScheduleDateEntity.prototype.NextMilestoneDate = function () {
        var pc = this.PortCall(), sched = pc === null || pc === void 0 ? void 0 : pc.MovementSchedule();
        var i = sched === null || sched === void 0 ? void 0 : sched.indexOf(this);
        if (i === undefined || i === -1)
            return null;
        for (i = i + 1; i < sched.length; i++) {
            var date = sched[i];
            // Refuse to go forwards past a null date, on the thinking that the missing/unloaded date may just
            // have been the next milestone date.
            if (date === null)
                return null;
            else if (date.MilestoneTypeId() !== null)
                return date;
        }
        return null;
    };
    ScheduleDateEntity.prototype.PreviousMilestoneDate = function () {
        var pc = this.PortCall(), sched = pc === null || pc === void 0 ? void 0 : pc.MovementSchedule();
        var i = sched === null || sched === void 0 ? void 0 : sched.indexOf(this);
        if (i === undefined || i === -1)
            return null;
        for (i = i - 1; i >= 0; i--) {
            var date = sched[i];
            // Refuse to go backwards past a null date, on the thinking that the missing/unloaded date may just
            // have been the previous milestone date.
            if (date === null)
                return null;
            else if (date.MilestoneTypeId() !== null)
                return date;
        }
        return null;
    };
    // NOTE: Coordinations... methods mirrored in C# in PortCall.Models\Schedule\ScheduleDateEntity.cs.
    // Keep in sync.
    ScheduleDateEntity.prototype.CoordinationsMainLocation = function () {
        var _a, _b;
        return (_b = (_a = this.ItineraryPoint()) === null || _a === void 0 ? void 0 : _a.Location()) !== null && _b !== void 0 ? _b : null;
    };
    ScheduleDateEntity.prototype.CoordinationsRelatedLocation = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.CoordinationsRelatedDate()) === null || _a === void 0 ? void 0 : _a.ItineraryPoint()) === null || _b === void 0 ? void 0 : _b.Location()) !== null && _c !== void 0 ? _c : null;
    };
    ScheduleDateEntity.prototype.CoordinationsRelatedDate = function () {
        var _a, _b, _c, _d;
        if (this.MilestoneTypeId() === null)
            return null;
        return (
        // For berth arrival, look to previous milestone date.
        this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.BerthArrival ? this.PreviousMilestoneDate() :
            // For final departure, look to next milestone date for future proofing, then to port departure b/c
            // we don't actually have a milestone type for port departure currently.
            this.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FinalDeparture ? (_d = (_a = this.NextMilestoneDate()) !== null && _a !== void 0 ? _a : (_c = (_b = this.PortCall()) === null || _b === void 0 ? void 0 : _b.Itinerary().find(function (pt) { return pt.IsPortDeparture(); })) === null || _c === void 0 ? void 0 : _c.ArrivalEntity()) !== null && _d !== void 0 ? _d : null :
                // All others -- Look to next milestone date.
                this.NextMilestoneDate());
    };
    return ScheduleDateEntity;
}(ScheduleDateEntity_1.ScheduleDateEntity));
exports.ScheduleDateEntity = ScheduleDateEntity;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1573), exports);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateEventType = void 0;
// ScheduleDateEventType values, hand-synched w/ PortCall.Models\Schedule\ScheduleDateEvent.cs
var ScheduleDateEventType;
(function (ScheduleDateEventType) {
    ScheduleDateEventType["EstimatedDateEntered"] = "EE";
    ScheduleDateEventType["ActualDateEntered"] = "AE";
    ScheduleDateEventType["EstimatedDateChanged"] = "EC";
    ScheduleDateEventType["ActualDateChanged"] = "AC";
})(ScheduleDateEventType = exports.ScheduleDateEventType || (exports.ScheduleDateEventType = {}));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeRoute = void 0;
var TradeRoute_1 = __webpack_require__(620);
__exportStar(__webpack_require__(620), exports);
var TradeRoute = /** @class */ (function (_super) {
    __extends(TradeRoute, _super);
    function TradeRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** A comparator function for TradeRoutes. */
    TradeRoute.DisplayOrder = function (r1, r2) {
        var cmp;
        return (cmp = r1.DisplayOrder() - r2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            r1.Id() - r2.Id() :
            cmp;
    };
    return TradeRoute;
}(TradeRoute_1.TradeRoute));
exports.TradeRoute = TradeRoute;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// From mustache.js https://github.com/janl/mustache.js/blob/master/mustache.js#L60
// Copyright (c) 2009 Chris Wanstrath (Ruby)
// Copyright (c) 2010-2014 Jan Lehnardt (JavaScript)
// Copyright (c) 2010-2015 The mustache.js community
// Mustache license: https://github.com/janl/mustache.js/blob/master/LICENSE
Object.defineProperty(exports, "__esModule", { value: true });
// Ported to typescript by Tim Hambourger (c) 2017
var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};
var TO_ESCAPE = /[&<>"'`=\/]/g;
function fromEntityMap(s) {
    return entityMap[s];
}
function escapeHtml(string) {
    return string.replace(TO_ESCAPE, fromEntityMap);
}
exports.default = escapeHtml;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusGroupParticipant = exports.FocusGroup = void 0;
// Symbols for use w/in this module only
var ON_PARTICIPANT_FOCUS = Symbol('onParticipantFocus'), ON_PARTICIPANT_BLUR = Symbol('onParticipantBlur');
/**
 * A utility to treat a set of DOM elements as a group for focus and blur purposes.
 * Lets you give the group a blur and/or focus handler such that blurring or focusing the entire group will
 * fire the handler but tabbing between elements in the group won't. Note that this is different from the
 * behavior if you simply add an onBlur or onFocus handler to some parent element of the entire group; in that
 * case all blurs or focuses from inside the group will bubble up to the parent, just like a normal event
 * propagation chain.
 */
var FocusGroup = /** @class */ (function () {
    function FocusGroup(_a) {
        var onFocus = _a.onFocus, onBlur = _a.onBlur;
        this.onFocus = onFocus;
        this.onBlur = onBlur;
    }
    /**
     * Enroll one or more new participants in this @see FocusGroup.
     */
    FocusGroup.prototype.enroll = function () {
        return new FocusGroupParticipant(this);
    };
    // Internal methods only callable from w/in this module (hence the computed symbol-valued method names).
    FocusGroup.prototype[ON_PARTICIPANT_FOCUS] = function (participant) {
        var _a;
        window.clearTimeout(this.blurTimeout);
        var wasUnfocused = this.focusedParticipant === undefined;
        this.focusedParticipant = participant;
        if (wasUnfocused)
            (_a = this.onFocus) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    FocusGroup.prototype[ON_PARTICIPANT_BLUR] = function (participant) {
        var _this = this;
        // Tolerate onParticipantFocus and onParticipantBlur firing in either order (new focus before old blur
        // or old blur before new focus). Native DOM events fire in the order blur on old focused element then
        // focus on new focused element, but if we chain focus groups together, then onParticipantBlur on the
        // downstream FocusGroup can fire after a timeout and thus AFTER onParticipantFocus on the new focused
        // element. So... if a new participant has already gotten focus, then no need for any further action.
        // Otherwise, handle blur in a timeout to see if onParticipantFocus is about to fire.
        if (this.focusedParticipant === participant) {
            window.clearTimeout(this.blurTimeout);
            this.blurTimeout = window.setTimeout(function () {
                var _a;
                _this.focusedParticipant = undefined;
                (_a = _this.onBlur) === null || _a === void 0 ? void 0 : _a.call(_this);
            });
        }
    };
    return FocusGroup;
}());
exports.FocusGroup = FocusGroup;
var FocusGroupParticipant = /** @class */ (function () {
    function FocusGroupParticipant(focusGroup) {
        var _this = this;
        this.events = {
            onFocus: function () { return focusGroup[ON_PARTICIPANT_FOCUS](_this); },
            onBlur: function () { return focusGroup[ON_PARTICIPANT_BLUR](_this); }
        };
    }
    return FocusGroupParticipant;
}());
exports.FocusGroupParticipant = FocusGroupParticipant;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
var s_array_1 = __webpack_require__(3);
var nonuniqueIndex_1 = __webpack_require__(117);
function groupBy(items, keyFn) {
    var itemsByKey = nonuniqueIndex_1.default(items, keyFn), keySet = items.map(keyFn)
        .reduce(function (found, next) { return found.add(next); }, function () { return new Set(); });
    return s_array_1.lift(function () { return Array.from(keySet()); })
        .map(function (key) { return ({ key: key, items: itemsByKey(key) }); });
}
exports.groupBy = groupBy;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(27);
// TH: bootstrap npm package expects to find jquery as window.jQuery... :-(
var oldjquery = window.jQuery;
window.jQuery = $;
// import 'lib/kendo/2014.3.1119/jquery.min';
__webpack_require__(870);
__webpack_require__(629);
__webpack_require__(630);
window.jQuery = oldjquery;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize = void 0;
var s_js_1 = __webpack_require__(0);
function memoize(fn) {
    var map = new Map(), disposers = [];
    s_js_1.default.cleanup(function () { return disposers.forEach(function (disposer) { return disposer(); }); });
    return function (v) {
        if (map.has(v))
            return map.get(v)();
        var sub = s_js_1.default.root(function (dispose) {
            disposers.push(dispose);
            return s_js_1.default(function () { return fn(v); });
        });
        map.set(v, sub);
        return sub();
    };
}
exports.memoize = memoize;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// TH 05/01/2017 -- As of TS 2.2.1, typescript changed their typing of Object.create. It now always returns type any.
// This is a thin wrapper to give us the old behavior of infering the return type from the parameter type.
// Hopefully they'll roll out a bugfix, but in the meantime, this gives us a way to upgrade typescript.
// See AH's bug report: https://github.com/Microsoft/TypeScript/issues/14247
function objectCreate(obj) {
    return Object.create(obj);
}
exports.default = objectCreate;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Pollster = exports.PollsterStartupBehavior = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
var PollsterStartupBehavior;
(function (PollsterStartupBehavior) {
    /**
     * The `Pollster` should send another request as soon as possible, even if the pollster is already polling
     * when `start` is called.
     */
    PollsterStartupBehavior[PollsterStartupBehavior["Eager"] = 0] = "Eager";
    /**
     * If the `Pollster` is already polling when `start` is called, then it should continue on its regular
     * schedule, otherwise it should fire a request immediately and continue polling after that. This is
     * equivalent to `Lazy` when the `Pollster` is already polling and `Eager` when it isn't.
     */
    PollsterStartupBehavior[PollsterStartupBehavior["Default"] = 1] = "Default";
    /**
     * If the `Pollster` is already polling when `start` is called, then it should continue on its regular
     * schedule, otherwise it should (re)start polling now but shouldn't fire its next request until after its
     * delay has passed.
     */
    PollsterStartupBehavior[PollsterStartupBehavior["Lazy"] = 2] = "Lazy";
})(PollsterStartupBehavior = exports.PollsterStartupBehavior || (exports.PollsterStartupBehavior = {}));
/**
 * Pollster class
 *
 * A utility to call a request function repeatedly on a delay, with the guarantee that it will always wait for
 * the current request to finish before sending the next request.
 */
var Pollster = /** @class */ (function () {
    /**
     * Construct a new `Pollster` instance. The `Pollster` will initially be in a stopped state (not polling) but
     * can be started with a call to `start`.
     * @param reqFn Function to issue a single request.
     * @param delay Delay between polls in millseconds.
     */
    function Pollster(reqFn, delay) {
        var _this = this;
        this.reqFn = reqFn;
        this.delay = delay;
        // Semantically, S.value would make sense here, but using S.data instead to work around
        // https://github.com/adamhaile/S/issues/25. Our issue is that 1) the only time we ever set _isRequesting
        // to false is in a Promise.finally handler, meaning no S clock is running at that point, 2) it's common
        // for this _isRequesting signal to have no listeners, b/c most Pollster use cases don't need it, and 3)
        // that combo of updating an S.value that has no listeners at a time when no S clock is running is
        // precisely the situation that triggers https://github.com/adamhaile/S/issues/25. This was leading to
        // polling stopping unexpectedly on the Dispatch Dashboard due to S throwing a "conflicting values" error
        // when we try to set _isRequesting to true at the start of the next fireRequest call.
        this._isRequesting = s_js_1.default.data(false);
        this._isPolling = false;
        this.fireEagerly = false;
        this.isRequesting = function () { return _this._isRequesting(); };
        s_js_1.default.cleanup(function () { return _this.stop(); });
    }
    Object.defineProperty(Pollster.prototype, "isPolling", {
        /**
         * Is the `Pollster` polling in general. I.e. `false` if the `Pollster` is in a stopped state and `true`
         * otherwise.
         */
        get: function () { return this._isPolling; },
        enumerable: false,
        configurable: true
    });
    /**
    * Start or restart polling. Calling this method on an already-started `Pollster` has no effect unless the
    * provided `behavior` is `PollsterStartupBehavior.Eager`.
    */
    Pollster.prototype.start = function (behavior) {
        if (behavior === void 0) { behavior = PollsterStartupBehavior.Default; }
        if (behavior === PollsterStartupBehavior.Eager || !this.isPolling) {
            this.stop();
            this._isPolling = true;
            if (s_js_1.default.sample(this.isRequesting)) {
                this.fireEagerly = behavior === PollsterStartupBehavior.Eager;
            }
            else {
                if (behavior === PollsterStartupBehavior.Lazy)
                    this.setTimeout();
                else
                    this.fireRequest();
            }
        }
        return this;
    };
    Pollster.prototype.fireRequest = function () {
        var _this = this;
        this.fireEagerly = false;
        this._isRequesting(true);
        Promise.resolve(this.reqFn()).finally(function () {
            if (_this.isPolling) {
                if (_this.fireEagerly) {
                    _this.fireRequest();
                }
                else {
                    _this.setTimeout();
                    _this._isRequesting(false);
                }
            }
            else {
                _this._isRequesting(false);
            }
        });
    };
    Pollster.prototype.setTimeout = function () {
        var _this = this;
        this.timeoutId = window.setTimeout(function () { return _this.fireRequest(); }, this.delay);
    };
    /**
     * Stop polling. Polling can later be restarted by calling `start`. Calling this method on a
     * already-stopped `Pollster` has no effect.
     */
    Pollster.prototype.stop = function () {
        this._isPolling = false;
        window.clearTimeout(this.timeoutId);
    };
    return Pollster;
}());
exports.Pollster = Pollster;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestQueue = void 0;
var Promise = __webpack_require__(41);
/**
 * Take an async request function and return a queue that serializes calls to that request
 * function. At any given time, the queue may be in one of three states: 1) Empty 2) 1 request
 * in flight, or 3) 1 request in flight and 1 request pending.
 * @param requestFn A function that performs a single request
 */
var RequestQueue = /** @class */ (function () {
    function RequestQueue(requestFn) {
        this.requestFn = requestFn;
        this.request = Promise.resolve(undefined);
        this.requestQueued = false;
    }
    /**
     * Enqueue a request, provided none is already pending.
     * If the queue is empty, enqueues a new request to run on the next tick.
     * If a request is in flight, enqueues a new request to run when that in-flight request completes (is resolved or rejected).
     * If a request is already pending after the in-flight request, this call is a no-op.
     */
    RequestQueue.prototype.enqueueRequest = function () {
        var _this = this;
        if (this.requestQueued)
            return;
        this.requestQueued = true;
        var fireNext = function () {
            _this.requestQueued = false;
            return _this.requestFn();
        };
        // .then(fireNext, fireNext) instead of .finally(fireNext) so that the resolution/rejection status
        // of the new Promise depends only on the most recent call to requestFn. Otherwise one failed request
        // would cause all later Promises constructed to count as rejected.
        // Matters for consumers that use the mostRecentRequest method and care about the resolution/rejection status.
        this.request = this.request.then(fireNext, fireNext);
    };
    /**
     * Return the most recent request in the request queue, or a Promise resolved to undefined if no request has ever been issued.
     * The most recent request means:
     * - The last request completed if no request is pending or in flight, or a Promise resolved to undefined if no request has ever been issued.
     * - The in-flight request, if a request is in flight and no request is pending after that.
     * - The pending request, if a request is in flight and a request is pending after that.
     */
    RequestQueue.prototype.mostRecentRequest = function () {
        return this.request;
    };
    return RequestQueue;
}());
exports.RequestQueue = RequestQueue;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipMap = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
/**
 * Zip one or more source arrays onto a target `SArray` and map to a results array via the provided mapping
 * function. The mapping function is called with an item of the target array followed by one "zip accessor"
 * signal for each source array. When evaluated, the zip accessor signal returns the item from that source
 * array that's parallel with the given item from the target array, or undefined if there's no such item.
 * @param target The target array to be mapped.
 * @param sources A variable number of source arrays that will be "zipped onto" the target array.
 * @param fn The mapping function to apply to items of the target array. Will also be passed "zip accessor"
 * signals that allow access to the corresponding items from the source arrays.
 */
function zipMap() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Destructure args by hand as rest destructuring in this case gives, "A rest element must be last in a
    // destructuring pattern." (Our ...sources bit is in the middle instead of at the end).
    var target = args[0], fn = args[args.length - 1], sources = args.slice(1, args.length - 1);
    var nextKey = 0;
    var itemsByKey = new Map(), zipSignalMaps = sources.map(function (_) { return new Map(); }), zipAccessorMaps = sources.map(function (_) { return new Map(); }), 
    // We'll assign items in the target array a unique key that we use to do lookups in the zip signal maps.
    // Note that if the target array has duplicate items, we assign each INSTANCE of a given item its own key.
    keys = target.map(function (item) {
        // Item is entering. Assign it a unique key and make new zip signals for it.
        var k = nextKey++;
        itemsByKey.set(k, item);
        var _loop_1 = function (j) {
            // We init all new zip signals as empty (undefined) and then set the correct value when we
            // apply zipping below.
            var signal = s_js_1.default.value(undefined, getEq(sources[j]));
            zipSignalMaps[j].set(k, signal);
            // Also stash a readonly version to expose to calling code.
            zipAccessorMaps[j].set(k, function () { return signal(); });
        };
        for (var j = 0; j < sources.length; j++) {
            _loop_1(j);
        }
        return k;
    }, function (_, k) {
        // Item is exiting. Remove from our maps (and thus free zip signals for GC).
        itemsByKey.delete(k);
        for (var j = 0; j < zipSignalMaps.length; j++) {
            zipSignalMaps[j].delete(k);
            zipAccessorMaps[j].delete(k);
        }
    });
    // Here's where we actually zip everything together. We do this in one big S computation for timing reasons:
    // We want it to be the case that if the target array and/or one or more source arrays are all updated in
    // the same tick of S's clock, then any updates to our zip signals all land together in some subsequent tick
    // of S's clock.
    // TODO: Maybe tune performance? The tradeoff w/ doing this as one big S computation is that it means we
    // re-apply all zipping anytime any of our target or source arrays changes. Runtime there is O(NM) where N
    // = number of items in target array and M = number of source arrays. The alternative is we try to track
    // exactly which array(s) are changing, maybe in combo with some array diffing, and do more focused updates.
    // But not gonna try too hard for now. SArray's map method is at least O(N) when the input array changes
    // (actually more like O(N^2) in common cases I think), so there's no point in trying to do better than O(N)
    // when the target array changes. And my guess is that most use cases for this util will see the number of
    // source arrays be small and will see roughly the same number of items in the target and source arrays, so
    // likely little benefit in diffing the source array vs just running back through the target array.
    s_js_1.default(function () {
        var _keys = keys();
        for (var j = 0; j < sources.length; j++) {
            applyZipping(_keys, sources[j], zipSignalMaps[j]);
        }
    });
    // Ugly: Timing-wise, we wanna make sure that if any new target item is discovered, we set its corresponding
    // zip signals BEFORE we call the provided mapping function for that item. That's to avoid calling the
    // mapping function twice, once w/ all zip signals empty (evaluating to undefined) and again w/ the zip
    // signals populated correctly. To make that work, we need to introduce an extra tick of S's clock btwn when
    // our keys array updates and when we run the mapping function. This way, updates end up happening in 3
    // phases:
    // 1) Update zip signals that have been passed into existing mapped items.
    // 2) Map any new target items, with zip signals already populated correctly.
    // 3) Notify consumers of our mapped output array of the change to that array.
    var keys2 = s_array_1.default([]);
    s_js_1.default(function () { return keys2(keys()); });
    // Finally, apply the provided mapping function.
    return keys2.map(function (k, m, i) {
        var zipAccessors = zipAccessorMaps.map(function (map) { return map.get(k); });
        return fn.apply(void 0, __spreadArrays([itemsByKey.get(k)], zipAccessors, [m, i]));
    });
}
exports.zipMap = zipMap;
function applyZipping(keys, source, signalMap) {
    var arr = getArr(source)(), align = getAlign(source);
    for (var i = 0; i < keys.length; i++) {
        signalMap.get(keys[i])(selectMatch(i, keys.length, arr, align));
    }
}
/**
 * Selecting matching element from the source array to zip onto a given element of the target array.
 * @param i Array index of the element in the target array.
 * @param targetLength Length of the target array.
 * @param sourceArr The source array.
 * @param align Whether to align left edges or right edges when zipping.
 */
function selectMatch(i, targetLength, sourceArr, align) {
    return (align === 'right' ? sourceArr[i + sourceArr.length - targetLength] : sourceArr[i]);
}
function getArr(source) {
    return typeof source === 'function' ? source : source.arr;
}
function getAlign(source) {
    var _a;
    // Default to aligning left edges
    return (_a = (typeof source === 'function' ? undefined : source.align)) !== null && _a !== void 0 ? _a : 'left';
}
function getEq(source) {
    return typeof source === 'function' ? undefined : source.eq;
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchRecurrenceFrequencys = exports.BatchRecurrenceFrequencyDisplayName = exports.BatchRecurrenceFrequency = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\BatchRecurrencePeriod.cs
var BatchRecurrenceFrequency;
(function (BatchRecurrenceFrequency) {
    BatchRecurrenceFrequency[BatchRecurrenceFrequency["Daily"] = 0] = "Daily";
    BatchRecurrenceFrequency[BatchRecurrenceFrequency["Weekly"] = 1] = "Weekly";
    BatchRecurrenceFrequency[BatchRecurrenceFrequency["Monthly"] = 2] = "Monthly";
    BatchRecurrenceFrequency[BatchRecurrenceFrequency["Custom"] = 3] = "Custom";
})(BatchRecurrenceFrequency = exports.BatchRecurrenceFrequency || (exports.BatchRecurrenceFrequency = {}));
exports.BatchRecurrenceFrequencyDisplayName = {
    0: 'Daily',
    1: 'Weekly',
    2: 'Monthly',
    3: 'Custom'
};
exports.BatchRecurrenceFrequencys = [
    { Id: BatchRecurrenceFrequency.Daily, Name: 'Daily' },
    { Id: BatchRecurrenceFrequency.Weekly, Name: 'Weekly' },
    { Id: BatchRecurrenceFrequency.Monthly, Name: 'Monthly' },
    { Id: BatchRecurrenceFrequency.Custom, Name: 'Custom' }
];


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UnactionableReasons = exports.UnactionableReasonDisplayName = exports.UnactionableReason = exports.EnhancedEstimateQueryStatuses = exports.EnhancedEstimateQueryStatusDisplayName = exports.EnhancedEstimateQueryStatus = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Wartsila.Models\EnhancedEstimateQuery.cs
var EnhancedEstimateQueryStatus;
(function (EnhancedEstimateQueryStatus) {
    EnhancedEstimateQueryStatus[EnhancedEstimateQueryStatus["Querying"] = 0] = "Querying";
    EnhancedEstimateQueryStatus[EnhancedEstimateQueryStatus["Succeeded"] = 10] = "Succeeded";
    EnhancedEstimateQueryStatus[EnhancedEstimateQueryStatus["Failed"] = 99] = "Failed";
    EnhancedEstimateQueryStatus[EnhancedEstimateQueryStatus["Unactionable"] = 98] = "Unactionable";
})(EnhancedEstimateQueryStatus = exports.EnhancedEstimateQueryStatus || (exports.EnhancedEstimateQueryStatus = {}));
exports.EnhancedEstimateQueryStatusDisplayName = {
    0: 'Querying',
    10: 'Succeeded',
    99: 'Failed',
    98: 'Unactionable'
};
exports.EnhancedEstimateQueryStatuses = [
    { Id: EnhancedEstimateQueryStatus.Querying, Name: 'Querying' },
    { Id: EnhancedEstimateQueryStatus.Succeeded, Name: 'Succeeded' },
    { Id: EnhancedEstimateQueryStatus.Failed, Name: 'Failed' },
    { Id: EnhancedEstimateQueryStatus.Unactionable, Name: 'Unactionable' }
];
var UnactionableReason;
(function (UnactionableReason) {
    UnactionableReason[UnactionableReason["NoValidVesselIdentifiers"] = 1] = "NoValidVesselIdentifiers";
    UnactionableReason[UnactionableReason["NoValidDestinationZone"] = 2] = "NoValidDestinationZone";
    UnactionableReason[UnactionableReason["MissingEnhancedEstimatesAutomationConfiguration"] = 4] = "MissingEnhancedEstimatesAutomationConfiguration";
    UnactionableReason[UnactionableReason["None"] = 0] = "None";
})(UnactionableReason = exports.UnactionableReason || (exports.UnactionableReason = {}));
exports.UnactionableReasonDisplayName = {
    1: 'NoValidVesselIdentifiers',
    2: 'NoValidDestinationZone',
    4: 'MissingEnhancedEstimatesAutomationConfiguration',
    0: 'None'
};
exports.UnactionableReasons = [
    { Id: UnactionableReason.NoValidVesselIdentifiers, Name: 'NoValidVesselIdentifiers' },
    { Id: UnactionableReason.NoValidDestinationZone, Name: 'NoValidDestinationZone' },
    { Id: UnactionableReason.MissingEnhancedEstimatesAutomationConfiguration, Name: 'MissingEnhancedEstimatesAutomationConfiguration' },
    { Id: UnactionableReason.None, Name: 'None' }
];


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright 2014 Telerik AD
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(e,define){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(function(){return function(e,t,n){function i(){}function r(e,t){if(t)return"'"+e.split("'").join("\\'").split('\\"').join('\\\\\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t")+"'";var n=e.charAt(0),i=e.substring(1);return"="===n?"+("+i+")+":":"===n?"+e("+i+")+":";"+e+";o+="}function o(e,t,n){return e+="",t=t||2,n=t-e.length,n?O[t].substring(0,n)+e:e}function a(e){var t=e.css(gt.support.transitions.css+"box-shadow")||e.css("box-shadow"),n=t?t.match(Tt)||[0,0,0,0,0]:[0,0,0,0,0],i=bt.max(+n[3],+(n[4]||0));return{left:-n[1]+i,right:+n[1]+i,bottom:+n[2]+i}}function s(t,n){var i,r,o,s,l,c,d,u,h=xt.browser,p="rtl"==t.css("direction");return t.parent().hasClass("k-animation-container")?(d=t.parent(".k-animation-container"),u=d[0].style,d.is(":hidden")&&d.show(),i=Ct.test(u.width)||Ct.test(u.height),i||d.css({width:t.outerWidth(),height:t.outerHeight(),boxSizing:"content-box",mozBoxSizing:"content-box",webkitBoxSizing:"content-box"})):(r=a(t),o=t[0].style.width,s=t[0].style.height,l=Ct.test(o),c=Ct.test(s),h.opera&&(r.left=r.right=r.bottom=5),i=l||c,!l&&(!n||n&&o)&&(o=t.outerWidth()),!c&&(!n||n&&s)&&(s=t.outerHeight()),t.wrap(e("<div/>").addClass("k-animation-container").css({width:o,height:s,marginLeft:r.left*(p?1:-1),paddingLeft:r.left,paddingRight:r.right,paddingBottom:r.bottom})),i&&t.css({width:"100%",height:"100%",boxSizing:"border-box",mozBoxSizing:"border-box",webkitBoxSizing:"border-box"})),h.msie&&bt.floor(h.version)<=7&&(t.css({zoom:1}),t.children(".k-menu").width(t.width())),t.parent()}function l(e){var t=1,n=arguments.length;for(t=1;n>t;t++)c(e,arguments[t]);return e}function c(e,t){var n,i,r,o,a,s=gt.data.ObservableArray,l=gt.data.LazyObservableArray,d=gt.data.DataSource,u=gt.data.HierarchicalDataSource;for(n in t)i=t[n],r=typeof i,o=r===It&&null!==i?i.constructor:null,o&&o!==Array&&o!==s&&o!==l&&o!==d&&o!==u?i instanceof Date?e[n]=new Date(i.getTime()):M(i.clone)?e[n]=i.clone():(a=e[n],e[n]=typeof a===It?a||{}:{},c(e[n],i)):r!==zt&&(e[n]=i);return e}function d(e,t,i){for(var r in t)if(t.hasOwnProperty(r)&&t[r].test(e))return r;return i!==n?i:e}function u(e){return e.replace(/([a-z][A-Z])/g,function(e){return e.charAt(0)+"-"+e.charAt(1).toLowerCase()})}function h(e){return e.replace(/\-(\w)/g,function(e,t){return t.toUpperCase()})}function p(t,n){var i,r={};return document.defaultView&&document.defaultView.getComputedStyle?(i=document.defaultView.getComputedStyle(t,""),n&&e.each(n,function(e,t){r[t]=i.getPropertyValue(t)})):(i=t.currentStyle,n&&e.each(n,function(e,t){r[t]=i[h(t)]})),gt.size(r)||(r=i),r}function f(e){var t,n=0;for(t in e)e.hasOwnProperty(t)&&"toJSON"!=t&&n++;return n}function g(e,n,i){n||(n="offset");var r=e[n]();return xt.browser.msie&&(xt.pointers||xt.msPointers)&&!i&&(r.top-=t.pageYOffset-document.documentElement.scrollTop,r.left-=t.pageXOffset-document.documentElement.scrollLeft),r}function m(e){var t={};return vt("string"==typeof e?e.split(" "):e,function(e){t[e]=this}),t}function v(e){return new gt.effects.Element(e)}function _(e,t,n,i){return typeof e===Et&&(M(t)&&(i=t,t=400,n=!1),M(n)&&(i=n,n=!1),typeof t===Ft&&(n=t,t=400),e={effects:e,duration:t,reverse:n,complete:i}),mt({effects:{},duration:400,reverse:!1,init:wt,teardown:wt,hide:!1},e,{completeCallback:e.complete,complete:wt})}function y(t,n,i,r,o){for(var a,s=0,l=t.length;l>s;s++)a=e(t[s]),a.queue(function(){U.promise(a,_(n,i,r,o))});return t}function w(e,t,n,i){return t&&(t=t.split(" "),vt(t,function(t,n){e.toggleClass(n,i)})),e}function b(e){return(""+e).replace(W,"&amp;").replace(j,"&lt;").replace($,"&gt;").replace(q,"&quot;").replace(G,"&#39;")}function k(e,t){var i;return 0===t.indexOf("data")&&(t=t.substring(4),t=t.charAt(0).toLowerCase()+t.substring(1)),t=t.replace(nt,"-$1"),i=e.getAttribute("data-"+gt.ns+t),null===i?i=n:"null"===i?i=null:"true"===i?i=!0:"false"===i?i=!1:Dt.test(i)?i=parseFloat(i):et.test(i)&&!tt.test(i)&&(i=Function("return ("+i+")")()),i}function x(t,i){var r,o,a={};for(r in i)o=k(t,r),o!==n&&(J.test(r)&&(o=gt.template(e("#"+o).html())),a[r]=o);return a}function C(t,n){return e.contains(t,n)?-1:1}function S(){var t=e(this);return e.inArray(t.attr("data-"+gt.ns+"role"),["slider","rangeslider"])>-1||t.is(":visible")}function T(e,t){var n=e.nodeName.toLowerCase();return(/input|select|textarea|button|object/.test(n)?!e.disabled:"a"===n?e.href||t:t)&&D(e)}function D(t){return!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")||e.expr.filters.hidden(this)}).length}function A(e,t){return new A.fn.init(e,t)}var E,M,I,P,F,z,R,B,H,L,N,O,V,U,W,j,q,G,$,Y,Q,K,X,Z,J,et,tt,nt,it,rt,ot,at,st,lt,ct,dt,ut,ht,pt,ft,gt=t.kendo=t.kendo||{cultures:{}},mt=e.extend,vt=e.each,_t=e.isArray,yt=e.proxy,wt=e.noop,bt=Math,kt=t.JSON||{},xt={},Ct=/%/,St=/\{(\d+)(:[^\}]+)?\}/g,Tt=/(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,Dt=/^(\+|-?)\d+(\.?)\d*$/,At="function",Et="string",Mt="number",It="object",Pt="null",Ft="boolean",zt="undefined",Rt={},Bt={},Ht=[].slice,Lt=t.Globalize;gt.version="2014.3.1119",i.extend=function(e){var t,n,i=function(){},r=this,o=e&&e.init?e.init:function(){r.apply(this,arguments)};i.prototype=r.prototype,n=o.fn=o.prototype=new i;for(t in e)n[t]=null!=e[t]&&e[t].constructor===Object?mt(!0,{},i.prototype[t],e[t]):e[t];return n.constructor=o,o.extend=r.extend,o},i.prototype._initOptions=function(e){this.options=l({},this.options,e)},M=gt.isFunction=function(e){return"function"==typeof e},I=function(){this._defaultPrevented=!0},P=function(){return this._defaultPrevented===!0},F=i.extend({init:function(){this._events={}},bind:function(e,t,i){var r,o,a,s,l,c=this,d=typeof e===Et?[e]:e,u=typeof t===At;if(t===n){for(r in e)c.bind(r,e[r]);return c}for(r=0,o=d.length;o>r;r++)e=d[r],s=u?t:t[e],s&&(i&&(a=s,s=function(){c.unbind(e,s),a.apply(c,arguments)},s.original=a),l=c._events[e]=c._events[e]||[],l.push(s));return c},one:function(e,t){return this.bind(e,t,!0)},first:function(e,t){var n,i,r,o,a=this,s=typeof e===Et?[e]:e,l=typeof t===At;for(n=0,i=s.length;i>n;n++)e=s[n],r=l?t:t[e],r&&(o=a._events[e]=a._events[e]||[],o.unshift(r));return a},trigger:function(e,t){var n,i,r=this,o=r._events[e];if(o){for(t=t||{},t.sender=r,t._defaultPrevented=!1,t.preventDefault=I,t.isDefaultPrevented=P,o=o.slice(),n=0,i=o.length;i>n;n++)o[n].call(r,t);return t._defaultPrevented===!0}return!1},unbind:function(e,t){var i,r=this,o=r._events[e];if(e===n)r._events={};else if(o)if(t)for(i=o.length-1;i>=0;i--)(o[i]===t||o[i].original===t)&&o.splice(i,1);else r._events[e]=[];return r}}),z=/^\w+/,R=/\$\{([^}]*)\}/g,B=/\\\}/g,H=/__CURLY__/g,L=/\\#/g,N=/__SHARP__/g,O=["","0","00","000","0000"],E={paramName:"data",useWithBlock:!0,render:function(e,t){var n,i,r="";for(n=0,i=t.length;i>n;n++)r+=e(t[n]);return r},compile:function(e,t){var n,i,o,a=mt({},this,t),s=a.paramName,l=s.match(z)[0],c=a.useWithBlock,d="var o,e=kendo.htmlEncode;";if(M(e))return e;for(d+=c?"with("+s+"){":"",d+="o=",i=e.replace(B,"__CURLY__").replace(R,"#=e($1)#").replace(H,"}").replace(L,"__SHARP__").split("#"),o=0;i.length>o;o++)d+=r(i[o],o%2===0);d+=c?";}":";",d+="return o;",d=d.replace(N,"#");try{return n=Function(l,d),n._slotCount=Math.floor(i.length/2),n}catch(u){throw Error(gt.format("Invalid template:'{0}' Generated code:'{1}'",e,d))}}},function(){function e(e){return a.lastIndex=0,a.test(e)?'"'+e.replace(a,function(e){var t=s[e];return typeof t===Et?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function t(o,a){var s,c,d,u,h,p,f=n,g=a[o];if(g&&typeof g===It&&typeof g.toJSON===At&&(g=g.toJSON(o)),typeof r===At&&(g=r.call(a,o,g)),p=typeof g,p===Et)return e(g);if(p===Mt)return isFinite(g)?g+"":Pt;if(p===Ft||p===Pt)return g+"";if(p===It){if(!g)return Pt;if(n+=i,h=[],"[object Array]"===l.apply(g)){for(u=g.length,s=0;u>s;s++)h[s]=t(s,g)||Pt;return d=0===h.length?"[]":n?"[\n"+n+h.join(",\n"+n)+"\n"+f+"]":"["+h.join(",")+"]",n=f,d}if(r&&typeof r===It)for(u=r.length,s=0;u>s;s++)typeof r[s]===Et&&(c=r[s],d=t(c,g),d&&h.push(e(c)+(n?": ":":")+d));else for(c in g)Object.hasOwnProperty.call(g,c)&&(d=t(c,g),d&&h.push(e(c)+(n?": ":":")+d));return d=0===h.length?"{}":n?"{\n"+n+h.join(",\n"+n)+"\n"+f+"}":"{"+h.join(",")+"}",n=f,d}}var n,i,r,a=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,s={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},l={}.toString;typeof Date.prototype.toJSON!==At&&(Date.prototype.toJSON=function(){var e=this;return isFinite(e.valueOf())?o(e.getUTCFullYear(),4)+"-"+o(e.getUTCMonth()+1)+"-"+o(e.getUTCDate())+"T"+o(e.getUTCHours())+":"+o(e.getUTCMinutes())+":"+o(e.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()}),typeof kt.stringify!==At&&(kt.stringify=function(e,o,a){var s;if(n="",i="",typeof a===Mt)for(s=0;a>s;s+=1)i+=" ";else typeof a===Et&&(i=a);if(r=o,o&&typeof o!==At&&(typeof o!==It||typeof o.length!==Mt))throw Error("JSON.stringify");return t("",{"":e})})}(),function(){function t(e){if(e){if(e.numberFormat)return e;if(typeof e===Et){var t=gt.cultures;return t[e]||t[e.split("-")[0]]||null}return null}return null}function i(e){return e&&(e=t(e)),e||gt.cultures.current}function r(e){e.groupSizes=e.groupSize,e.percent.groupSizes=e.percent.groupSize,e.currency.groupSizes=e.currency.groupSize}function a(e,t,r){r=i(r);var a=r.calendars.standard,s=a.days,l=a.months;return t=a.patterns[t]||t,t.replace(d,function(t){var i,r,c;return"d"===t?r=e.getDate():"dd"===t?r=o(e.getDate()):"ddd"===t?r=s.namesAbbr[e.getDay()]:"dddd"===t?r=s.names[e.getDay()]:"M"===t?r=e.getMonth()+1:"MM"===t?r=o(e.getMonth()+1):"MMM"===t?r=l.namesAbbr[e.getMonth()]:"MMMM"===t?r=l.names[e.getMonth()]:"yy"===t?r=o(e.getFullYear()%100):"yyyy"===t?r=o(e.getFullYear(),4):"h"===t?r=e.getHours()%12||12:"hh"===t?r=o(e.getHours()%12||12):"H"===t?r=e.getHours():"HH"===t?r=o(e.getHours()):"m"===t?r=e.getMinutes():"mm"===t?r=o(e.getMinutes()):"s"===t?r=e.getSeconds():"ss"===t?r=o(e.getSeconds()):"f"===t?r=bt.floor(e.getMilliseconds()/100):"ff"===t?(r=e.getMilliseconds(),r>99&&(r=bt.floor(r/10)),r=o(r)):"fff"===t?r=o(e.getMilliseconds(),3):"tt"===t?r=e.getHours()<12?a.AM[0]:a.PM[0]:"zzz"===t?(i=e.getTimezoneOffset(),c=0>i,r=(""+bt.abs(i/60)).split(".")[0],i=bt.abs(i)-60*r,r=(c?"+":"-")+o(r),r+=":"+o(i)):("zz"===t||"z"===t)&&(r=e.getTimezoneOffset()/60,c=0>r,r=(""+bt.abs(r)).split(".")[0],r=(c?"+":"-")+("zz"===t?o(r):r)),r!==n?r:t.slice(1,t.length-1)})}function s(e,t,r){r=i(r);var o,a,s,c,d,w,b,k,x,C,S,T,D,A,E,M,I,P,F,z,R,B,H,L=r.numberFormat,N=L.groupSize[0],O=L[m],V=L[g],U=L.decimals,W=L.pattern[0],j=[],q=0>e,G=f,$=f,Y=-1;if(e===n)return f;if(!isFinite(e))return e;if(!t)return r.name.length?e.toLocaleString():""+e;if(d=u.exec(t)){if(t=d[1].toLowerCase(),a="c"===t,s="p"===t,(a||s)&&(L=a?L.currency:L.percent,N=L.groupSize[0],O=L[m],V=L[g],U=L.decimals,o=L.symbol,W=L.pattern[q?0:1]),c=d[2],c&&(U=+c),"e"===t)return c?e.toExponential(U):e.toExponential();if(s&&(e*=100),e=l(e,U),q=0>e,e=e.split(g),w=e[0],b=e[1],q&&(w=w.substring(1)),$=w,k=w.length,k>=N)for($=f,C=0;k>C;C++)C>0&&(k-C)%N===0&&($+=O),$+=w.charAt(C);if(b&&($+=V+b),"n"===t&&!q)return $;for(e=f,C=0,S=W.length;S>C;C++)T=W.charAt(C),e+="n"===T?$:"$"===T||"%"===T?o:T;return e}if(q&&(e=-e),(t.indexOf("'")>-1||t.indexOf('"')>-1||t.indexOf("\\")>-1)&&(t=t.replace(h,function(e){var t=e.charAt(0).replace("\\",""),n=e.slice(1).replace(t,"");return j.push(n),y})),t=t.split(";"),q&&t[1])t=t[1],A=!0;else if(0===e){if(t=t[2]||t[0],-1==t.indexOf(v)&&-1==t.indexOf(_))return t}else t=t[0];if(z=t.indexOf("%"),R=t.indexOf("$"),s=-1!=z,a=-1!=R,s&&(e*=100),a&&"\\"===t[R-1]&&(t=t.split("\\").join(""),a=!1),(a||s)&&(L=a?L.currency:L.percent,N=L.groupSize[0],O=L[m],V=L[g],U=L.decimals,o=L.symbol),D=t.indexOf(m)>-1,D&&(t=t.replace(p,f)),E=t.indexOf(g),S=t.length,-1!=E?(b=(""+e).split("e"),b=b[1]?l(e,Math.abs(b[1])):b[0],b=b.split(g)[1]||f,I=t.lastIndexOf(_)-E,M=t.lastIndexOf(v)-E,P=I>-1,F=M>-1,C=b.length,P||F||(t=t.substring(0,E)+t.substring(E+1),S=t.length,E=-1,C=0),P&&I>M?C=I:M>I&&(F&&C>M?C=M:P&&I>C&&(C=I)),C>-1&&(e=l(e,C))):e=l(e),M=t.indexOf(v),B=I=t.indexOf(_),Y=-1==M&&-1!=I?I:-1!=M&&-1==I?M:M>I?I:M,M=t.lastIndexOf(v),I=t.lastIndexOf(_),H=-1==M&&-1!=I?I:-1!=M&&-1==I?M:M>I?M:I,Y==S&&(H=Y),-1!=Y){if($=(""+e).split(g),w=$[0],b=$[1]||f,k=w.length,x=b.length,q&&-1*e>=0&&(q=!1),D)if(k===N&&E-B>k)w=O+w;else if(k>N){for($=f,C=0;k>C;C++)C>0&&(k-C)%N===0&&($+=O),$+=w.charAt(C);w=$}for(e=t.substring(0,Y),q&&!A&&(e+="-"),C=Y;S>C;C++){if(T=t.charAt(C),-1==E){if(k>H-C){e+=w;break}}else if(-1!=I&&C>I&&(G=f),k>=E-C&&E-C>-1&&(e+=w,C=E),E===C){e+=(b?V:f)+b,C+=H-E+1;continue}T===_?(e+=T,G=T):T===v&&(e+=G)}if(H>=Y&&(e+=t.substring(H+1)),a||s){for($=f,C=0,S=e.length;S>C;C++)T=e.charAt(C),$+="$"===T||"%"===T?o:T;e=$}if(S=j.length)for(C=0;S>C;C++)e=e.replace(y,j[C])}return e}var l,c,d=/dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,u=/^(n|c|p|e)(\d*)$/i,h=/(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,p=/\,/g,f="",g=".",m=",",v="#",_="0",y="??",w="en-US",b={}.toString;gt.cultures["en-US"]={name:w,numberFormat:{pattern:["-n"],decimals:2,",":",",".":".",groupSize:[3],percent:{pattern:["-n %","n %"],decimals:2,",":",",".":".",groupSize:[3],symbol:"%"},currency:{pattern:["($n)","$n"],decimals:2,",":",",".":".",groupSize:[3],symbol:"$"}},calendars:{standard:{days:{names:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],namesAbbr:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],namesShort:["Su","Mo","Tu","We","Th","Fr","Sa"]},months:{names:["January","February","March","April","May","June","July","August","September","October","November","December"],namesAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},AM:["AM","am","AM"],PM:["PM","pm","PM"],patterns:{d:"M/d/yyyy",D:"dddd, MMMM dd, yyyy",F:"dddd, MMMM dd, yyyy h:mm:ss tt",g:"M/d/yyyy h:mm tt",G:"M/d/yyyy h:mm:ss tt",m:"MMMM dd",M:"MMMM dd",s:"yyyy'-'MM'-'ddTHH':'mm':'ss",t:"h:mm tt",T:"h:mm:ss tt",u:"yyyy'-'MM'-'dd HH':'mm':'ss'Z'",y:"MMMM, yyyy",Y:"MMMM, yyyy"},"/":"/",":":":",firstDay:0,twoDigitYearMax:2029}}},gt.culture=function(e){var i,o=gt.cultures;return e===n?o.current:(i=t(e)||o[w],i.calendar=i.calendars.standard,o.current=i,Lt&&!Lt.load&&r(i.numberFormat),n)},gt.findCulture=t,gt.getCulture=i,gt.culture(w),l=function(e,t){return t=t||0,e=(""+e).split("e"),e=Math.round(+(e[0]+"e"+(e[1]?+e[1]+t:t))),e=(""+e).split("e"),e=+(e[0]+"e"+(e[1]?+e[1]-t:-t)),e.toFixed(t)},c=function(e,t,i){if(t){if("[object Date]"===b.call(e))return a(e,t,i);if(typeof e===Mt)return s(e,t,i)}return e!==n?e:""},Lt&&!Lt.load&&(c=function(t,n,i){return e.isPlainObject(i)&&(i=i.name),Lt.format(t,n,i)}),gt.format=function(e){var t=arguments;return e.replace(St,function(e,n,i){var r=t[parseInt(n,10)+1];return c(r,i?i.substring(1):"")})},gt._extractFormat=function(e){return"{0:"===e.slice(0,3)&&(e=e.slice(3,e.length-1)),e},gt._activeElement=function(){try{return document.activeElement}catch(e){return document.documentElement.activeElement}},gt._round=l,gt.toString=c}(),function(){function t(e,t,n){return!(e>=t&&n>=e)}function i(e){return e.charAt(0)}function r(t){return e.map(t,i)}function o(e,t){t||23!==e.getHours()||e.setHours(e.getHours()+2)}function a(e){for(var t=0,n=e.length,i=[];n>t;t++)i[t]=(e[t]+"").toLowerCase();return i}function s(e){var t,n={};for(t in e)n[t]=a(e[t]);return n}function l(e,i,a){if(!e)return null;var l,c,d,u,f,g,m,_,y,w,b,k,x,C=function(e){for(var t=0;i[B]===e;)t++,B++;return t>0&&(B-=1),t},S=function(t){var n=v[t]||RegExp("^\\d{1,"+t+"}"),i=e.substr(H,t).match(n);return i?(i=i[0],H+=i.length,parseInt(i,10)):null},T=function(t,n){for(var i,r,o,a=0,s=t.length;s>a;a++)if(i=t[a],r=i.length,o=e.substr(H,r),n&&(o=o.toLowerCase()),o==i)return H+=r,a+1;return null},D=function(){var t=!1;return e.charAt(H)===i[B]&&(H++,t=!0),t},A=a.calendars.standard,E=null,M=null,I=null,P=null,F=null,z=null,R=null,B=0,H=0,L=!1,N=new Date,O=A.twoDigitYearMax||2029,V=N.getFullYear();for(i||(i="d"),u=A.patterns[i],u&&(i=u),i=i.split(""),d=i.length;d>B;B++)if(l=i[B],L)"'"===l?L=!1:D();else if("d"===l){if(c=C("d"),A._lowerDays||(A._lowerDays=s(A.days)),I=3>c?S(2):T(A._lowerDays[3==c?"namesAbbr":"names"],!0),null===I||t(I,1,31))return null}else if("M"===l){if(c=C("M"),A._lowerMonths||(A._lowerMonths=s(A.months)),M=3>c?S(2):T(A._lowerMonths[3==c?"namesAbbr":"names"],!0),null===M||t(M,1,12))return null;M-=1}else if("y"===l){if(c=C("y"),E=S(c),null===E)return null;2==c&&("string"==typeof O&&(O=V+parseInt(O,10)),E=V-V%100+E,E>O&&(E-=100))}else if("h"===l){if(C("h"),P=S(2),12==P&&(P=0),null===P||t(P,0,11))return null}else if("H"===l){if(C("H"),P=S(2),null===P||t(P,0,23))return null}else if("m"===l){if(C("m"),F=S(2),null===F||t(F,0,59))return null}else if("s"===l){if(C("s"),z=S(2),null===z||t(z,0,59))return null}else if("f"===l){if(c=C("f"),x=e.substr(H,c).match(v[3]),R=S(c),null!==R&&(x=x[0].length,3>x&&(R*=Math.pow(10,3-x)),c>3&&(R=parseInt((""+R).substring(0,3),10))),null===R||t(R,0,999))return null}else if("t"===l){if(c=C("t"),_=A.AM,y=A.PM,1===c&&(_=r(_),y=r(y)),f=T(y),!f&&!T(_))return null}else if("z"===l){if(g=!0,c=C("z"),"Z"===e.substr(H,1)){D();continue}if(m=e.substr(H,6).match(c>2?p:h),!m)return null;if(m=m[0].split(":"),w=m[0],b=m[1],!b&&w.length>3&&(H=w.length-2,b=w.substring(H),w=w.substring(0,H)),w=parseInt(w,10),t(w,-12,13))return null;if(c>2&&(b=parseInt(b,10),isNaN(b)||t(b,0,59)))return null}else if("'"===l)L=!0,D();else if(!D())return null;return k=null!==P||null!==F||z||null,null===E&&null===M&&null===I&&k?(E=V,M=N.getMonth(),I=N.getDate()):(null===E&&(E=V),null===I&&(I=1)),f&&12>P&&(P+=12),g?(w&&(P+=-w),b&&(F+=-b),e=new Date(Date.UTC(E,M,I,P,F,z,R))):(e=new Date(E,M,I,P,F,z,R),o(e,P)),100>E&&e.setFullYear(E),e.getDate()!==I&&g===n?null:e}function c(e){var t="-"===e.substr(0,1)?-1:1;return e=e.substring(1),e=60*parseInt(e.substr(0,2),10)+parseInt(e.substring(2),10),t*e}var d=/\u00A0/g,u=/[eE][\-+]?[0-9]+/,h=/[+|\-]\d{1,2}/,p=/[+|\-]\d{1,2}:?\d{2}/,f=/^\/Date\((.*?)\)\/$/,g=/[+-]\d*/,m=["G","g","d","F","D","y","m","T","t"],v={2:/^\d{1,2}/,3:/^\d{1,3}/,4:/^\d{4}/},_={}.toString;gt.parseDate=function(e,t,n){var i,r,o,a,s;if("[object Date]"===_.call(e))return e;if(i=0,r=null,e&&0===e.indexOf("/D")&&(r=f.exec(e)))return r=r[1],s=g.exec(r.substring(1)),r=new Date(parseInt(r,10)),s&&(s=c(s[0]),r=gt.timezone.apply(r,0),r=gt.timezone.convert(r,0,-1*s)),r;if(n=gt.getCulture(n),!t){for(t=[],a=n.calendar.patterns,o=m.length;o>i;i++)t[i]=a[m[i]];i=0,t=["yyyy/MM/dd HH:mm:ss","yyyy/MM/dd HH:mm","yyyy/MM/dd","ddd MMM dd yyyy HH:mm:ss","yyyy-MM-ddTHH:mm:ss.fffffffzzz","yyyy-MM-ddTHH:mm:ss.fffzzz","yyyy-MM-ddTHH:mm:sszzz","yyyy-MM-ddTHH:mm:ss.fffffff","yyyy-MM-ddTHH:mm:ss.fff","yyyy-MM-ddTHH:mmzzz","yyyy-MM-ddTHH:mmzz","yyyy-MM-ddTHH:mm:ss","yyyy-MM-ddTHH:mm","yyyy-MM-dd HH:mm:ss","yyyy-MM-dd HH:mm","yyyy-MM-dd","HH:mm:ss","HH:mm"].concat(t)}for(t=_t(t)?t:[t],o=t.length;o>i;i++)if(r=l(e,t[i],n))return r;return r},gt.parseInt=function(e,t){var n=gt.parseFloat(e,t);return n&&(n=0|n),n},gt.parseFloat=function(e,t,n){if(!e&&0!==e)return null;if(typeof e===Mt)return e;e=""+e,t=gt.getCulture(t);var i,r,o=t.numberFormat,a=o.percent,s=o.currency,l=s.symbol,c=a.symbol,h=e.indexOf("-");return u.test(e)?(e=parseFloat(e.replace(o["."],".")),isNaN(e)&&(e=null),e):h>0?null:(h=h>-1,e.indexOf(l)>-1||n&&n.toLowerCase().indexOf("c")>-1?(o=s,i=o.pattern[0].replace("$",l).split("n"),e.indexOf(i[0])>-1&&e.indexOf(i[1])>-1&&(e=e.replace(i[0],"").replace(i[1],""),h=!0)):e.indexOf(c)>-1&&(r=!0,o=a,l=c),e=e.replace("-","").replace(l,"").replace(d," ").split(o[","].replace(d," ")).join("").replace(o["."],"."),e=parseFloat(e),isNaN(e)?e=null:h&&(e*=-1),e&&r&&(e/=100),e)},Lt&&!Lt.load&&(gt.parseDate=function(e,t,n){return"[object Date]"===_.call(e)?e:Lt.parseDate(e,t,n)},gt.parseFloat=function(t,i){return typeof t===Mt?t:t===n||null===t?null:(e.isPlainObject(i)&&(i=i.name),t=Lt.parseFloat(t,i),isNaN(t)?null:t)})}(),function(){var i,r,o,a,s,l,c;xt._scrollbar=n,xt.scrollbar=function(e){if(isNaN(xt._scrollbar)||e){var t,n=document.createElement("div");return n.style.cssText="overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block",n.innerHTML="&nbsp;",document.body.appendChild(n),xt._scrollbar=t=n.offsetWidth-n.scrollWidth,document.body.removeChild(n),t}return xt._scrollbar},xt.isRtl=function(t){return e(t).closest(".k-rtl").length>0},i=document.createElement("table");try{i.innerHTML="<tr><td></td></tr>",xt.tbodyInnerHtml=!0}catch(u){xt.tbodyInnerHtml=!1}xt.touch="ontouchstart"in t,xt.msPointers=t.MSPointerEvent,xt.pointers=t.PointerEvent,r=xt.transitions=!1,o=xt.transforms=!1,a="HTMLElement"in t?HTMLElement.prototype:[],xt.hasHW3D="WebKitCSSMatrix"in t&&"m11"in new t.WebKitCSSMatrix||"MozPerspective"in document.documentElement.style||"msPerspective"in document.documentElement.style,vt(["Moz","webkit","O","ms"],function(){var e,t=""+this,a=typeof i.style[t+"Transition"]===Et;return a||typeof i.style[t+"Transform"]===Et?(e=t.toLowerCase(),o={css:"ms"!=e?"-"+e+"-":"",prefix:t,event:"o"===e||"webkit"===e?e:""},a&&(r=o,r.event=r.event?r.event+"TransitionEnd":"transitionend"),!1):n}),i=null,xt.transforms=o,xt.transitions=r,xt.devicePixelRatio=t.devicePixelRatio===n?1:t.devicePixelRatio;try{xt.screenWidth=t.outerWidth||t.screen?t.screen.availWidth:t.innerWidth,xt.screenHeight=t.outerHeight||t.screen?t.screen.availHeight:t.innerHeight}catch(u){xt.screenWidth=t.screen.availWidth,xt.screenHeight=t.screen.availHeight}xt.detectOS=function(e){var n,i,r=!1,o=[],a=!/mobile safari/i.test(e),s={wp:/(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,fire:/(Silk)\/(\d+)\.(\d+(\.\d+)?)/,android:/(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.(\d+(\.\d+)?)/,iphone:/(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,ipad:/(iPad).*OS\s+(\d+)[\._]([\d_]+)/,meego:/(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,webos:/(webOS)\/(\d+)\.(\d+(\.\d+)?)/,blackberry:/(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,playbook:/(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,windows:/(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,tizen:/(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,sailfish:/(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,ffos:/(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/},l={ios:/^i(phone|pad|pod)$/i,android:/^android|fire$/i,blackberry:/^blackberry|playbook/i,windows:/windows/,wp:/wp/,flat:/sailfish|ffos|tizen/i,meego:/meego/},c={tablet:/playbook|ipad|fire/i},u={omini:/Opera\sMini/i,omobile:/Opera\sMobi/i,firefox:/Firefox|Fennec/i,mobilesafari:/version\/.*safari/i,ie:/MSIE|Windows\sPhone/i,chrome:/chrome|crios/i,webkit:/webkit/i};for(i in s)if(s.hasOwnProperty(i)&&(o=e.match(s[i]))){if("windows"==i&&"plugins"in navigator)return!1;r={},r.device=i,r.tablet=d(i,c,!1),r.browser=d(e,u,"default"),r.name=d(i,l),r[r.name]=!0,r.majorVersion=o[2],r.minorVersion=o[3].replace("_","."),n=r.minorVersion.replace(".","").substr(0,2),r.flatVersion=r.majorVersion+n+Array(3-(3>n.length?n.length:2)).join("0"),r.cordova=typeof t.PhoneGap!==zt||typeof t.cordova!==zt,r.appMode=t.navigator.standalone||/file|local|wmapp/.test(t.location.protocol)||r.cordova,r.android&&(1.5>xt.devicePixelRatio&&400>r.flatVersion||a)&&(xt.screenWidth>800||xt.screenHeight>800)&&(r.tablet=i);break}return r},s=xt.mobileOS=xt.detectOS(navigator.userAgent),xt.wpDevicePixelRatio=s.wp?screen.width/320:0,xt.kineticScrollNeeded=s&&(xt.touch||xt.msPointers||xt.pointers),xt.hasNativeScrolling=!1,(s.ios||s.android&&s.majorVersion>2||s.wp)&&(xt.hasNativeScrolling=s),xt.mouseAndTouchPresent=xt.touch&&!(xt.mobileOS.ios||xt.mobileOS.android),xt.detectBrowser=function(e){var t,n=!1,i=[],r={webkit:/(chrome)[ \/]([\w.]+)/i,safari:/(webkit)[ \/]([\w.]+)/i,opera:/(opera)(?:.*version|)[ \/]([\w.]+)/i,msie:/(msie\s|trident.*? rv:)([\w.]+)/i,mozilla:/(mozilla)(?:.*? rv:([\w.]+)|)/i};for(t in r)if(r.hasOwnProperty(t)&&(i=e.match(r[t]))){n={},n[t]=!0,n[i[1].toLowerCase().split(" ")[0].split("/")[0]]=!0,n.version=parseInt(document.documentMode||i[2],10);break}return n},xt.browser=xt.detectBrowser(navigator.userAgent),xt.zoomLevel=function(){try{return xt.touch?document.documentElement.clientWidth/t.innerWidth:xt.browser.msie&&xt.browser.version>=10?(top||t).document.documentElement.offsetWidth/(top||t).innerWidth:1}catch(e){return 1}},xt.cssBorderSpacing=n!==document.documentElement.style.borderSpacing&&!(xt.browser.msie&&8>xt.browser.version),function(t){var n="",i=e(document.documentElement),r=parseInt(t.version,10);t.msie?n="ie":t.mozilla?n="ff":t.safari?n="safari":t.webkit?n="webkit":t.opera&&(n="opera"),n&&(n="k-"+n+" k-"+n+r),xt.mobileOS&&(n+=" k-mobile"),i.addClass(n)}(xt.browser),xt.eventCapture=document.documentElement.addEventListener,l=document.createElement("input"),xt.placeholder="placeholder"in l,xt.propertyChangeEvent="onpropertychange"in l,xt.input=function(){for(var e,t=["number","date","time","month","week","datetime","datetime-local"],n=t.length,i="test",r={},o=0;n>o;o++)e=t[o],l.setAttribute("type",e),l.value=i,r[e.replace("-","")]="text"!==l.type&&l.value!==i;return r}(),l.style.cssText="float:left;",xt.cssFloat=!!l.style.cssFloat,l=null,xt.stableSort=function(){var e,t=513,n=[{index:0,field:"b"}];for(e=1;t>e;e++)n.push({index:e,field:"a"});return n.sort(function(e,t){return e.field>t.field?1:t.field>e.field?-1:0}),1===n[0].index}(),xt.matchesSelector=a.webkitMatchesSelector||a.mozMatchesSelector||a.msMatchesSelector||a.oMatchesSelector||a.matchesSelector||a.matches||function(t){for(var n=document.querySelectorAll?(this.parentNode||document).querySelectorAll(t)||[]:e(t),i=n.length;i--;)if(n[i]==this)return!0;return!1},xt.pushState=t.history&&t.history.pushState,c=document.documentMode,xt.hashChange="onhashchange"in t&&!(xt.browser.msie&&(!c||8>=c))}(),V={left:{reverse:"right"},right:{reverse:"left"},down:{reverse:"up"},up:{reverse:"down"},top:{reverse:"bottom"},bottom:{reverse:"top"},"in":{reverse:"out"},out:{reverse:"in"}},U={},e.extend(U,{enabled:!0,Element:function(t){this.element=e(t)},promise:function(e,t){e.is(":visible")||e.css({display:e.data("olddisplay")||"block"}).css("display"),t.hide&&e.data("olddisplay",e.css("display")).hide(),t.init&&t.init(),t.completeCallback&&t.completeCallback(e),e.dequeue()},disable:function(){this.enabled=!1,this.promise=this.promiseShim},enable:function(){this.enabled=!0,this.promise=this.animatedPromise}}),U.promiseShim=U.promise,"kendoAnimate"in e.fn||mt(e.fn,{kendoStop:function(e,t){return this.stop(e,t)},kendoAnimate:function(e,t,n,i){return y(this,e,t,n,i)},kendoAddClass:function(e,t){return gt.toggleClass(this,e,t,!0)},kendoRemoveClass:function(e,t){return gt.toggleClass(this,e,t,!1)},kendoToggleClass:function(e,t,n){return gt.toggleClass(this,e,t,n)}}),W=/&/g,j=/</g,q=/"/g,G=/'/g,$=/>/g,Y=function(e){return e.target},xt.touch&&(Y=function(e){var t="originalEvent"in e?e.originalEvent.changedTouches:"changedTouches"in e?e.changedTouches:null;return t?document.elementFromPoint(t[0].clientX,t[0].clientY):e.target},vt(["swipe","swipeLeft","swipeRight","swipeUp","swipeDown","doubleTap","tap"],function(t,n){e.fn[n]=function(e){return this.bind(n,e)}})),xt.touch?xt.mobileOS?(xt.mousedown="touchstart",xt.mouseup="touchend",xt.mousemove="touchmove",xt.mousecancel="touchcancel",xt.click="touchend",xt.resize="orientationchange"):(xt.mousedown="mousedown touchstart",xt.mouseup="mouseup touchend",xt.mousemove="mousemove touchmove",xt.mousecancel="mouseleave touchcancel",xt.click="click",xt.resize="resize"):xt.pointers?(xt.mousemove="pointermove",xt.mousedown="pointerdown",xt.mouseup="pointerup",xt.mousecancel="pointercancel",xt.click="pointerup",xt.resize="orientationchange resize"):xt.msPointers?(xt.mousemove="MSPointerMove",xt.mousedown="MSPointerDown",xt.mouseup="MSPointerUp",xt.mousecancel="MSPointerCancel",xt.click="MSPointerUp",xt.resize="orientationchange resize"):(xt.mousemove="mousemove",xt.mousedown="mousedown",xt.mouseup="mouseup",xt.mousecancel="mouseleave",xt.click="click",xt.resize="resize"),Q=function(e,t){var n,i,r,o,a=t||"d",s=1;for(i=0,r=e.length;r>i;i++)o=e[i],""!==o&&(n=o.indexOf("["),0!==n&&(-1==n?o="."+o:(s++,o="."+o.substring(0,n)+" || {})"+o.substring(n))),s++,a+=o+(r-1>i?" || {})":")"));return Array(s).join("(")+a},K=/^([a-z]+:)?\/\//i,mt(gt,{ui:gt.ui||{},fx:gt.fx||v,effects:gt.effects||U,mobile:gt.mobile||{},data:gt.data||{},dataviz:gt.dataviz||{},keys:{INSERT:45,DELETE:46,BACKSPACE:8,TAB:9,ENTER:13,ESC:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,END:35,HOME:36,SPACEBAR:32,PAGEUP:33,PAGEDOWN:34,F2:113,F10:121,F12:123,NUMPAD_PLUS:107,NUMPAD_MINUS:109,NUMPAD_DOT:110},support:gt.support||xt,animate:gt.animate||y,ns:"",attr:function(e){return"data-"+gt.ns+e},getShadows:a,wrap:s,deepExtend:l,getComputedStyles:p,size:f,toCamelCase:h,toHyphens:u,getOffset:gt.getOffset||g,parseEffects:gt.parseEffects||m,toggleClass:gt.toggleClass||w,directions:gt.directions||V,Observable:F,Class:i,Template:E,template:yt(E.compile,E),render:yt(E.render,E),stringify:yt(kt.stringify,kt),eventTarget:Y,htmlEncode:b,isLocalUrl:function(e){return e&&!K.test(e)},expr:function(e,t,n){return e=e||"",typeof t==Et&&(n=t,t=!1),n=n||"d",e&&"["!==e.charAt(0)&&(e="."+e),e=t?Q(e.split("."),n):n+e},getter:function(e,t){var n=e+t;return Rt[n]=Rt[n]||Function("d","return "+gt.expr(e,t))},setter:function(e){return Bt[e]=Bt[e]||Function("d,value",gt.expr(e)+"=value")},accessor:function(e){return{get:gt.getter(e),set:gt.setter(e)}},guid:function(){var e,t,n="";for(e=0;32>e;e++)t=16*bt.random()|0,(8==e||12==e||16==e||20==e)&&(n+="-"),n+=(12==e?4:16==e?3&t|8:t).toString(16);return n},roleSelector:function(e){return e.replace(/(\S+)/g,"["+gt.attr("role")+"=$1],").slice(0,-1)},directiveSelector:function(e){var t,n=e.split(" ");if(n)for(t=0;n.length>t;t++)"view"!=n[t]&&(n[t]=n[t].replace(/(\w*)(view|bar|strip|over)$/,"$1-$2"));return n.join(" ").replace(/(\S+)/g,"kendo-mobile-$1,").slice(0,-1)},triggeredByInput:function(e){return/^(label|input|textarea|select)$/i.test(e.target.tagName)},logToConsole:function(e){var i=t.console;!gt.suppressLog&&n!==i&&i.log&&i.log(e)}}),X=F.extend({init:function(e,t){var n,i=this;i.element=gt.jQuery(e).handler(i),i.angular("init",t),F.fn.init.call(i),n=t?t.dataSource:null,n&&(t=mt({},t,{dataSource:{}})),t=i.options=mt(!0,{},i.options,t),n&&(t.dataSource=n),i.element.attr(gt.attr("role"))||i.element.attr(gt.attr("role"),(t.name||"").toLowerCase()),i.element.data("kendo"+t.prefix+t.name,i),i.bind(i.events,t)},events:[],options:{prefix:""},_hasBindingTarget:function(){return!!this.element[0].kendoBindingTarget},_tabindex:function(e){e=e||this.wrapper;var t=this.element,n="tabindex",i=e.attr(n)||t.attr(n);t.removeAttr(n),e.attr(n,isNaN(i)?0:i)},setOptions:function(t){this._setEvents(t),e.extend(this.options,t)},_setEvents:function(e){for(var t,n=this,i=0,r=n.events.length;r>i;i++)t=n.events[i],n.options[t]&&e[t]&&n.unbind(t,n.options[t]);n.bind(n.events,e)},resize:function(e){var t=this.getSize(),n=this._size;(e||!n||t.width!==n.width||t.height!==n.height)&&(this._size=t,this._resize(t),this.trigger("resize",t))},getSize:function(){return gt.dimensions(this.element)},size:function(e){return e?(this.setSize(e),n):this.getSize()},setSize:e.noop,_resize:e.noop,destroy:function(){var e=this;e.element.removeData("kendo"+e.options.prefix+e.options.name),e.element.removeData("handler"),e.unbind()},angular:function(){}}),Z=X.extend({dataItems:function(){return this.dataSource.flatView()},_angularItems:function(t){var n=this;n.angular(t,function(){return{elements:n.items(),data:e.map(n.dataItems(),function(e){return{dataItem:e}})}})}}),gt.dimensions=function(e,t){var n=e[0];return t&&e.css(t),{width:n.offsetWidth,height:n.offsetHeight}},gt.notify=wt,J=/template$/i,et=/^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/,tt=/^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]*\]$/,nt=/([A-Z])/g,gt.initWidget=function(i,r,o){var a,s,l,c,d,u,h,p,f,g,m,v,_;if(o?o.roles&&(o=o.roles):o=gt.ui.roles,i=i.nodeType?i:i[0],u=i.getAttribute("data-"+gt.ns+"role")){f=-1===u.indexOf("."),l=f?o[u]:gt.getter(u)(t),m=e(i).data(),v=l?"kendo"+l.fn.options.prefix+l.fn.options.name:"",g=f?RegExp("^kendo.*"+u+"$","i"):RegExp("^"+v+"$","i");
for(_ in m)if(_.match(g)){if(_!==v)return m[_];a=m[_]}if(l){for(p=k(i,"dataSource"),r=e.extend({},x(i,l.fn.options),r),p&&(r.dataSource=typeof p===Et?gt.getter(p)(t):p),c=0,d=l.fn.events.length;d>c;c++)s=l.fn.events[c],h=k(i,s),h!==n&&(r[s]=gt.getter(h)(t));return a?e.isEmptyObject(r)||a.setOptions(r):a=new l(i,r),a}}},gt.rolesFromNamespaces=function(e){var t,n,i=[];for(e[0]||(e=[gt.ui,gt.dataviz.ui]),t=0,n=e.length;n>t;t++)i[t]=e[t].roles;return mt.apply(null,[{}].concat(i.reverse()))},gt.init=function(t){var n=gt.rolesFromNamespaces(Ht.call(arguments,1));e(t).find("[data-"+gt.ns+"role]").addBack().each(function(){gt.initWidget(this,{},n)})},gt.destroy=function(t){e(t).find("[data-"+gt.ns+"role]").addBack().each(function(){var t,n=e(this).data();for(t in n)0===t.indexOf("kendo")&&typeof n[t].destroy===At&&n[t].destroy()})},gt.resize=function(t,n){var i,r=e(t).find("[data-"+gt.ns+"role]").addBack().filter(S);r.length&&(i=e.makeArray(r),i.sort(C),e.each(i,function(){var t=gt.widgetInstance(e(this));t&&t.resize(n)}))},gt.parseOptions=x,mt(gt.ui,{Widget:X,DataBoundWidget:Z,roles:{},progress:function(t,n){var i,r,o,a,s=t.find(".k-loading-mask"),l=gt.support,c=l.browser;n?s.length||(i=l.isRtl(t),r=i?"right":"left",a=t.scrollLeft(),o=c.webkit&&i?t[0].scrollWidth-t.width()-2*a:0,s=e("<div class='k-loading-mask'><span class='k-loading-text'>Loading...</span><div class='k-loading-image'/><div class='k-loading-color'/></div>").width("100%").height("100%").css("top",t.scrollTop()).css(r,Math.abs(a)+o).prependTo(t)):s&&s.remove()},plugin:function(t,i,r){var o,a=t.fn.options.name;i=i||gt.ui,r=r||"",i[a]=t,i.roles[a.toLowerCase()]=t,o="getKendo"+r+a,a="kendo"+r+a,e.fn[a]=function(i){var r,o=this;return typeof i===Et?(r=Ht.call(arguments,1),this.each(function(){var t,s,l=e.data(this,a);if(!l)throw Error(gt.format("Cannot call method '{0}' of {1} before it is initialized",i,a));if(t=l[i],typeof t!==At)throw Error(gt.format("Cannot find method '{0}' of {1}",i,a));return s=t.apply(l,r),s!==n?(o=s,!1):n})):this.each(function(){new t(this,i)}),o},e.fn[a].widget=t,e.fn[o]=function(){return this.data(a)}}}),it={bind:function(){return this},nullObject:!0,options:{}},rt=X.extend({init:function(e,t){X.fn.init.call(this,e,t),this.element.autoApplyNS(),this.wrapper=this.element,this.element.addClass("km-widget")},destroy:function(){X.fn.destroy.call(this),this.element.kendoDestroy()},options:{prefix:"Mobile"},events:[],view:function(){var e=this.element.closest(gt.roleSelector("view splitview modalview drawer"));return gt.widgetInstance(e,gt.mobile.ui)||it},viewHasNativeScrolling:function(){var e=this.view();return e&&e.options.useNativeScrolling},container:function(){var e=this.element.closest(gt.roleSelector("view layout modalview drawer splitview"));return gt.widgetInstance(e.eq(0),gt.mobile.ui)||it}}),mt(gt.mobile,{init:function(e){gt.init(e,gt.mobile.ui,gt.ui,gt.dataviz.ui)},appLevelNativeScrolling:function(){return gt.mobile.application&&gt.mobile.application.options&&gt.mobile.application.options.useNativeScrolling},roles:{},ui:{Widget:rt,DataBoundWidget:Z.extend(rt.prototype),roles:{},plugin:function(e){gt.ui.plugin(e,gt.mobile.ui,"Mobile")}}}),l(gt.dataviz,{init:function(e){gt.init(e,gt.dataviz.ui)},ui:{roles:{},themes:{},views:[],plugin:function(e){gt.ui.plugin(e,gt.dataviz.ui)}},roles:{}}),gt.touchScroller=function(t,n){return e(t).map(function(t,i){return i=e(i),xt.kineticScrollNeeded&&gt.mobile.ui.Scroller&&!i.data("kendoMobileScroller")?(i.kendoMobileScroller(n),i.data("kendoMobileScroller")):!1})[0]},gt.preventDefault=function(e){e.preventDefault()},gt.widgetInstance=function(e,n){var i,r,o,a,s=e.data(gt.ns+"role"),l=[];if(s){if("content"===s&&(s="scroller"),n)if(n[0])for(i=0,r=n.length;r>i;i++)l.push(n[i].roles[s]);else l.push(n.roles[s]);else l=[gt.ui.roles[s],gt.dataviz.ui.roles[s],gt.mobile.ui.roles[s]];for(s.indexOf(".")>=0&&(l=[gt.getter(s)(t)]),i=0,r=l.length;r>i;i++)if(o=l[i],o&&(a=e.data("kendo"+o.fn.options.prefix+o.fn.options.name)))return a}},gt.onResize=function(n){var i=n;return xt.mobileOS.android&&(i=function(){setTimeout(n,600)}),e(t).on(xt.resize,i),i},gt.unbindResize=function(n){e(t).off(xt.resize,n)},gt.attrValue=function(e,t){return e.data(gt.ns+t)},gt.days={Sunday:0,Monday:1,Tuesday:2,Wednesday:3,Thursday:4,Friday:5,Saturday:6},e.extend(e.expr[":"],{kendoFocusable:function(t){var n=e.attr(t,"tabindex");return T(t,!isNaN(n)&&n>-1)}}),ot=["mousedown","mousemove","mouseenter","mouseleave","mouseover","mouseout","mouseup","click"],at="label, input, [data-rel=external]",st={setupMouseMute:function(){var t,n=0,i=ot.length,r=document.documentElement;if(!st.mouseTrap&&xt.eventCapture)for(st.mouseTrap=!0,st.bustClick=!1,st.captureMouse=!1,t=function(t){st.captureMouse&&("click"===t.type?st.bustClick&&!e(t.target).is(at)&&(t.preventDefault(),t.stopPropagation()):t.stopPropagation())};i>n;n++)r.addEventListener(ot[n],t,!0)},muteMouse:function(e){st.captureMouse=!0,e.data.bustClick&&(st.bustClick=!0),clearTimeout(st.mouseTrapTimeoutID)},unMuteMouse:function(){clearTimeout(st.mouseTrapTimeoutID),st.mouseTrapTimeoutID=setTimeout(function(){st.captureMouse=!1,st.bustClick=!1},400)}},lt={down:"touchstart mousedown",move:"mousemove touchmove",up:"mouseup touchend touchcancel",cancel:"mouseleave touchcancel"},xt.touch&&(xt.mobileOS.ios||xt.mobileOS.android)?lt={down:"touchstart",move:"touchmove",up:"touchend touchcancel",cancel:"touchcancel"}:xt.pointers?lt={down:"pointerdown",move:"pointermove",up:"pointerup",cancel:"pointercancel pointerleave"}:xt.msPointers&&(lt={down:"MSPointerDown",move:"MSPointerMove",up:"MSPointerUp",cancel:"MSPointerCancel MSPointerLeave"}),!xt.msPointers||"onmspointerenter"in t||e.each({MSPointerEnter:"MSPointerOver",MSPointerLeave:"MSPointerOut"},function(t,n){e.event.special[t]={delegateType:n,bindType:n,handle:function(t){var i,r=this,o=t.relatedTarget,a=t.handleObj;return(!o||o!==r&&!e.contains(r,o))&&(t.type=a.origType,i=a.handler.apply(this,arguments),t.type=n),i}}}),ct=function(e){return lt[e]||e},dt=/([^ ]+)/g,gt.applyEventMap=function(e,t){return e=e.replace(dt,ct),t&&(e=e.replace(dt,"$1."+t)),e},ut=e.fn.on,mt(!0,A,e),A.fn=A.prototype=new e,A.fn.constructor=A,A.fn.init=function(t,n){return n&&n instanceof e&&!(n instanceof A)&&(n=A(n)),e.fn.init.call(this,t,n,ht)},A.fn.init.prototype=A.fn,ht=A(document),mt(A.fn,{handler:function(e){return this.data("handler",e),this},autoApplyNS:function(e){return this.data("kendoNS",e||gt.guid()),this},on:function(){var e,t,n,i,r,o,a=this,s=a.data("kendoNS");return 1===arguments.length?ut.call(a,arguments[0]):(e=a,t=Ht.call(arguments),typeof t[t.length-1]===zt&&t.pop(),n=t[t.length-1],i=gt.applyEventMap(t[0],s),xt.mouseAndTouchPresent&&i.search(/mouse|click/)>-1&&this[0]!==document.documentElement&&(st.setupMouseMute(),r=2===t.length?null:t[1],o=i.indexOf("click")>-1&&i.indexOf("touchend")>-1,ut.call(this,{touchstart:st.muteMouse,touchend:st.unMuteMouse},r,{bustClick:o})),typeof n===Et&&(e=a.data("handler"),n=e[n],t[t.length-1]=function(t){n.call(e,t)}),t[0]=i,ut.apply(a,t),a)},kendoDestroy:function(e){return e=e||this.data("kendoNS"),e&&this.off("."+e),this}}),gt.jQuery=A,gt.eventMap=lt,gt.timezone=function(){function e(e,t){var n,i,r,o=t[3],a=t[4],s=t[5],l=t[8];return l||(t[8]=l={}),l[e]?l[e]:(isNaN(a)?0===a.indexOf("last")?(n=new Date(Date.UTC(e,d[o]+1,1,s[0]-24,s[1],s[2],0)),i=u[a.substr(4,3)],r=n.getUTCDay(),n.setUTCDate(n.getUTCDate()+i-r-(i>r?7:0))):a.indexOf(">=")>=0&&(n=new Date(Date.UTC(e,d[o],a.substr(5),s[0],s[1],s[2],0)),i=u[a.substr(0,3)],r=n.getUTCDay(),n.setUTCDate(n.getUTCDate()+i-r+(r>i?7:0))):n=new Date(Date.UTC(e,d[o],a,s[0],s[1],s[2],0)),l[e]=n)}function t(t,n,i){var r,o,a,s;return(n=n[i])?(a=new Date(t).getUTCFullYear(),n=jQuery.grep(n,function(e){var t=e[0],n=e[1];return a>=t&&(n>=a||t==a&&"only"==n||"max"==n)}),n.push(t),n.sort(function(t,n){return"number"!=typeof t&&(t=+e(a,t)),"number"!=typeof n&&(n=+e(a,n)),t-n}),s=n[jQuery.inArray(t,n)-1]||n[n.length-1],isNaN(s)?s:null):(r=i.split(":"),o=0,r.length>1&&(o=60*r[0]+ +r[1]),[-1e6,"max","-","Jan",1,[0,0,0],o,"-"])}function n(e,t,n){var i,r,o,a=t[n];if("string"==typeof a&&(a=t[a]),!a)throw Error('Timezone "'+n+'" is either incorrect, or kendo.timezones.min.js is not included.');for(i=a.length-1;i>=0&&(r=a[i][3],!(r&&e>r));i--);if(o=a[i+1],!o)throw Error('Timezone "'+n+'" not found on '+e+".");return o}function i(e,i,r,o){typeof e!=Mt&&(e=Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()));var a=n(e,i,o);return{zone:a,rule:t(e,r,a[1])}}function r(e,t){var n,r,o;return"Etc/UTC"==t||"Etc/GMT"==t?0:(n=i(e,this.zones,this.rules,t),r=n.zone,o=n.rule,gt.parseFloat(o?r[0]-o[6]:r[0]))}function o(e,t){var n=i(e,this.zones,this.rules,t),r=n.zone,o=n.rule,a=r[2];return a.indexOf("/")>=0?a.split("/")[o&&+o[6]?1:0]:a.indexOf("%s")>=0?a.replace("%s",o&&"-"!=o[7]?o[7]:""):a}function a(e,t,n){var i,r;return typeof t==Et&&(t=this.offset(e,t)),typeof n==Et&&(n=this.offset(e,n)),i=e.getTimezoneOffset(),e=new Date(e.getTime()+6e4*(t-n)),r=e.getTimezoneOffset(),new Date(e.getTime()+6e4*(r-i))}function s(e,t){return this.convert(e,e.getTimezoneOffset(),t)}function l(e,t){return this.convert(e,t,e.getTimezoneOffset())}function c(e){return this.apply(new Date(e),"Etc/UTC")}var d={Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11},u={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6};return{zones:{},rules:{},offset:r,convert:a,apply:s,remove:l,abbr:o,toLocalDate:c}}(),gt.date=function(){function e(e,t){return 0===t&&23===e.getHours()?(e.setHours(e.getHours()+2),!0):!1}function t(t,n,i){var r=t.getHours();i=i||1,n=(n-t.getDay()+7*i)%7,t.setDate(t.getDate()+n),e(t,r)}function n(e,n,i){return e=new Date(e),t(e,n,i),e}function i(e){return new Date(e.getFullYear(),e.getMonth(),1)}function r(e){var t=new Date(e.getFullYear(),e.getMonth()+1,0),n=i(e),r=Math.abs(t.getTimezoneOffset()-n.getTimezoneOffset());return r&&t.setHours(n.getHours()+r/60),t}function o(t){return t=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0),e(t,0),t}function a(e){return Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds())}function s(e){return e.getTime()-o(e)}function l(e,t,n){var i,r=s(t),o=s(n);return e&&r!=o?(t>=n&&(n+=m),i=s(e),r>i&&(i+=m),r>o&&(o+=m),i>=r&&o>=i):!0}function c(e,t,n){var i,r=t.getTime(),o=n.getTime();return r>=o&&(o+=m),i=e.getTime(),i>=r&&o>=i}function d(t,n){var i=t.getHours();return t=new Date(t),u(t,n*m),e(t,i),t}function u(e,t,n){var i,r=e.getTimezoneOffset();e.setTime(e.getTime()+t),n||(i=e.getTimezoneOffset()-r,e.setTime(e.getTime()+i*g))}function h(){return o(new Date)}function p(e){return o(e).getTime()==h().getTime()}function f(e){var t=new Date(1980,1,1,0,0,0);return e&&t.setHours(e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()),t}var g=6e4,m=864e5;return{adjustDST:e,dayOfWeek:n,setDayOfWeek:t,getDate:o,isInDateRange:c,isInTimeRange:l,isToday:p,nextDay:function(e){return d(e,1)},previousDay:function(e){return d(e,-1)},toUtcTime:a,MS_PER_DAY:m,MS_PER_HOUR:60*g,MS_PER_MINUTE:g,setTime:u,addDays:d,today:h,toInvariantTime:f,firstDayOfMonth:i,lastDayOfMonth:r,getMilliseconds:s}}(),gt.stripWhitespace=function(e){var t,n,i;if(document.createNodeIterator)for(t=document.createNodeIterator(e,NodeFilter.SHOW_TEXT,function(t){return t.parentNode==e?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT},!1);t.nextNode();)t.referenceNode&&!t.referenceNode.textContent.trim()&&t.referenceNode.parentNode.removeChild(t.referenceNode);else for(n=0;e.childNodes.length>n;n++)i=e.childNodes[n],3!=i.nodeType||/\S/.test(i.nodeValue)||(e.removeChild(i),n--),1==i.nodeType&&gt.stripWhitespace(i)},pt=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,1e3/60)},gt.animationFrame=function(e){pt.call(t,e)},ft=[],gt.queueAnimation=function(e){ft[ft.length]=e,1===ft.length&&gt.runNextAnimation()},gt.runNextAnimation=function(){gt.animationFrame(function(){ft[0]&&(ft.shift()(),ft[0]&&gt.runNextAnimation())})},gt.parseQueryStringParams=function(e){for(var t=e.split("?")[1]||"",n={},i=t.split(/&|=/),r=i.length,o=0;r>o;o+=2)""!==i[o]&&(n[decodeURIComponent(i[o])]=decodeURIComponent(i[o+1]));return n},gt.elementUnderCursor=function(e){return document.elementFromPoint(e.x.client,e.y.client)},gt.wheelDeltaY=function(e){var t,i=e.originalEvent,r=i.wheelDeltaY;return i.wheelDelta?(r===n||r)&&(t=i.wheelDelta):i.detail&&i.axis===i.VERTICAL_AXIS&&(t=10*-i.detail),t},gt.throttle=function(e,t){var i,r=0;return!t||0>=t?e:function(){function o(){e.apply(a,l),r=+new Date}var a=this,s=+new Date-r,l=arguments;return r?(i&&clearTimeout(i),s>t?o():i=setTimeout(o,t-s),n):o()}},gt.caret=function(t,i,r){var o,a,s,l,c=i!==n;if(r===n&&(r=i),t[0]&&(t=t[0]),!c||!t.disabled){try{t.selectionStart!==n?c?(t.focus(),t.setSelectionRange(i,r)):i=[t.selectionStart,t.selectionEnd]:document.selection&&(e(t).is(":visible")&&t.focus(),o=t.createTextRange(),c?(o.collapse(!0),o.moveStart("character",i),o.moveEnd("character",r-i),o.select()):(a=o.duplicate(),o.moveToBookmark(document.selection.createRange().getBookmark()),a.setEndPoint("EndToStart",o),s=a.text.length,l=s+o.text.length,i=[s,l]))}catch(d){i=[]}return i}},gt.compileMobileDirective=function(e,n){var i=t.angular;return e.attr("data-"+gt.ns+"role",e[0].tagName.toLowerCase().replace("kendo-mobile-","").replace("-","")),i.element(e).injector().invoke(["$compile",function(t){var r=i.element(e).scope();n&&n(r),t(e)(r),r.$digest()}]),gt.widgetInstance(e,gt.mobile.ui)},function(){function n(t,n,i){var r=e("<form>").attr({action:i,method:"POST"}),o=t.split(";base64,");e("<input>").attr({value:o[0].replace("data:",""),name:"contentType",type:"hidden"}).appendTo(r),e("<input>").attr({value:o[1],name:"base64",type:"hidden"}).appendTo(r),e("<input>").attr({value:n,name:"fileName",type:"hidden"}).appendTo(r),r.appendTo("body").submit().remove()}function i(e,t){var n,i,r,o,a,s=e;if("string"==typeof e){for(n=e.split(";base64,"),i=n[0],r=atob(n[1]),o=new Uint8Array(r.length),a=0;r.length>a;a++)o[a]=r.charCodeAt(a);s=new Blob([o.buffer],{type:i})}navigator.msSaveBlob(s,t)}function r(e,n){t.Blob&&e instanceof Blob&&(e=URL.createObjectURL(e)),o.download=n,o.href=e;var i=document.createEvent("MouseEvents");i.initMouseEvent("click",!0,!1,t,0,0,0,0,0,!1,!1,!1,!1,0,null),o.dispatchEvent(i)}var o=document.createElement("a"),a="download"in o;gt.saveAs=function(e){var t=n;e.forceProxy||(a?t=r:navigator.msSaveBlob&&(t=i)),t(e.dataURI,e.fileName,e.proxyURL)}}()}(jQuery,window),window.kendo},__webpack_require__(166));

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright 2014 Telerik AD
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(e,define){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(function(){return function(e){function t(t,n){return t===n||e.contains(t,n)}var n=window.kendo,i=n.ui,r=i.Widget,o=n.support,a=n.getOffset,s=n._activeElement,l="open",c="close",d="deactivate",u="activate",h="center",f="left",p="right",g="top",m="bottom",v="absolute",_="hidden",w="body",y="location",b="position",x="visible",k="effects",C="k-state-active",S="k-state-border",T=/k-state-border-(\w+)/,D=".k-picker-wrap, .k-dropdown-wrap, .k-link",A="down",E=e(document.documentElement),P=e(window),M="scroll",I="resize scroll",B=o.transitions.css,L=B+"transform",F=e.extend,z=".kendoPopup",R=["font-size","font-family","font-stretch","font-style","font-weight","line-height"],O=r.extend({init:function(t,i){var o,a=this;i=i||{},i.isRtl&&(i.origin=i.origin||m+" "+p,i.position=i.position||g+" "+p),r.fn.init.call(a,t,i),t=a.element,i=a.options,a.collisions=i.collision?i.collision.split(" "):[],a.downEvent=n.applyEventMap(A,n.guid()),1===a.collisions.length&&a.collisions.push(a.collisions[0]),o=e(a.options.anchor).closest(".k-popup,.k-group").filter(":not([class^=km-])"),i.appendTo=e(e(i.appendTo)[0]||o[0]||w),a.element.hide().addClass("k-popup k-group k-reset").toggleClass("k-rtl",!!i.isRtl).css({position:v}).appendTo(i.appendTo).on("mouseenter"+z,function(){a._hovered=!0}).on("mouseleave"+z,function(){a._hovered=!1}),a.wrapper=e(),i.animation===!1&&(i.animation={open:{effects:{}},close:{hide:!0,effects:{}}}),F(i.animation.open,{complete:function(){a.wrapper.css({overflow:x}),a._trigger(u)}}),F(i.animation.close,{complete:function(){a._animationClose()}}),a._mousedownProxy=function(e){a._mousedown(e)},a._resizeProxy=function(e){a._resize(e)},i.toggleTarget&&e(i.toggleTarget).on(i.toggleEvent+z,e.proxy(a.toggle,a))},events:[l,u,c,d],options:{name:"Popup",toggleEvent:"click",origin:m+" "+f,position:g+" "+f,anchor:w,appendTo:null,collision:"flip fit",viewport:window,copyAnchorStyles:!0,autosize:!1,modal:!1,animation:{open:{effects:"slideIn:down",transition:!0,duration:200},close:{duration:100,hide:!0}}},_animationClose:function(){var t,i,r,o,a=this,s=a.options;a.wrapper.hide(),t=a.wrapper.data(y),i=e(s.anchor),t&&a.wrapper.css(t),s.anchor!=w&&(r=((i.attr("class")||"").match(T)||["","down"])[1],o=S+"-"+r,i.removeClass(o).children(D).removeClass(C).removeClass(o),a.element.removeClass(S+"-"+n.directions[r].reverse)),a._closing=!1,a._trigger(d)},destroy:function(){var t,i=this,o=i.options,a=i.element.off(z);r.fn.destroy.call(i),o.toggleTarget&&e(o.toggleTarget).off(z),o.modal||(E.unbind(i.downEvent,i._mousedownProxy),i._scrollableParents().unbind(M,i._resizeProxy),P.unbind(I,i._resizeProxy)),n.destroy(i.element.children()),a.removeData(),o.appendTo[0]===document.body&&(t=a.parent(".k-animation-container"),t[0]?t.remove():a.remove())},open:function(t,i){var r,a,s,c=this,d={isFixed:!isNaN(parseInt(i,10)),x:t,y:i},u=c.element,h=c.options,f="down",p=e(h.anchor),m=u[0]&&u.hasClass("km-widget");if(!c.visible()){if(h.copyAnchorStyles&&(m&&"font-size"==R[0]&&R.shift(),u.css(n.getComputedStyles(p[0],R))),u.data("animating")||c._trigger(l))return;h.modal||(E.unbind(c.downEvent,c._mousedownProxy).bind(c.downEvent,c._mousedownProxy),o.mobileOS.ios||o.mobileOS.android||(c._scrollableParents().unbind(M,c._resizeProxy).bind(M,c._resizeProxy),P.unbind(I,c._resizeProxy).bind(I,c._resizeProxy))),c.wrapper=a=n.wrap(u,h.autosize).css({overflow:_,display:"block",position:v}),o.mobileOS.android&&a.css(L,"translatez(0)"),a.css(b),e(h.appendTo)[0]==document.body&&a.css(g,"-10000px"),r=F(!0,{},h.animation.open),c.flipped=c._position(d),r.effects=n.parseEffects(r.effects,c.flipped),f=r.effects.slideIn?r.effects.slideIn.direction:f,h.anchor!=w&&(s=S+"-"+f,u.addClass(S+"-"+n.directions[f].reverse),p.addClass(s).children(D).addClass(C).addClass(s)),u.data(k,r.effects).kendoStop(!0).kendoAnimate(r)}},toggle:function(){var e=this;e[e.visible()?c:l]()},visible:function(){return this.element.is(":"+x)},close:function(t){var i,r,o,a,s=this,l=s.options;if(s.visible()){if(i=s.wrapper[0]?s.wrapper:n.wrap(s.element).hide(),s._closing||s._trigger(c))return;s.element.find(".k-popup").each(function(){var n=e(this),i=n.data("kendoPopup");i&&i.close(t)}),E.unbind(s.downEvent,s._mousedownProxy),s._scrollableParents().unbind(M,s._resizeProxy),P.unbind(I,s._resizeProxy),t?r={hide:!0,effects:{}}:(r=F(!0,{},l.animation.close),o=s.element.data(k),a=r.effects,!a&&!n.size(a)&&o&&n.size(o)&&(r.effects=o,r.reverse=!0),s._closing=!0),s.element.kendoStop(!0),i.css({overflow:_}),s.element.kendoAnimate(r)}},_trigger:function(e){return this.trigger(e,{type:e})},_resize:function(e){var n=this;"resize"===e.type?(clearTimeout(n._resizeTimeout),n._resizeTimeout=setTimeout(function(){n._position(),n._resizeTimeout=null},50)):n._hovered||t(n.element[0],s())||n.close()},_mousedown:function(i){var r=this,o=r.element[0],a=r.options,s=e(a.anchor)[0],l=a.toggleTarget,c=n.eventTarget(i),d=e(c).closest(".k-popup"),u=d.parent().parent(".km-shim").length;d=d[0],(u||!d||d===r.element[0])&&"popover"!==e(i.target).closest("a").data("rel")&&(t(o,c)||t(s,c)||l&&t(e(l)[0],c)||r.close())},_fit:function(e,t,n){var i=0;return e+t>n&&(i=n-(e+t)),0>e&&(i=-e),i},_flip:function(e,t,n,i,r,o,a){var s=0;return a=a||t,o!==r&&o!==h&&r!==h&&(e+a>i&&(s+=-(n+t)),0>e+s&&(s+=n+t)),s},_scrollableParents:function(){return e(this.options.anchor).parentsUntil("body").filter(function(e,t){var i=n.getComputedStyles(t,["overflow"]);return"visible"!=i.overflow})},_position:function(t){var n,i,r,s,l,c,d,u,h,f=this,p=f.element.css(b,""),g=f.wrapper,m=f.options,_=e(m.viewport),w=_.offset(),x=e(m.anchor),k=m.origin.toLowerCase().split(" "),C=m.position.toLowerCase().split(" "),S=f.collisions,T=o.zoomLevel(),D=10002,A=!!(_[0]==window&&window.innerWidth&&1.02>=T),E=0,P=A?window.innerWidth:_.width(),M=A?window.innerHeight:_.height(),I=x.parents().filter(g.siblings());if(I[0])if(i=Math.max(+I.css("zIndex"),0))D=i+10;else for(n=x.parentsUntil(I),r=n.length;r>E;E++)i=+e(n[E]).css("zIndex"),i&&i>D&&(D=i+10);return g.css("zIndex",D),g.css(t&&t.isFixed?{left:t.x,top:t.y}:f._align(k,C)),s=a(g,b,x[0]===g.offsetParent()[0]),l=a(g),c=x.offsetParent().parent(".k-animation-container,.k-popup,.k-group"),c.length&&(s=a(g,b,!0),l=a(g)),_[0]===window?(l.top-=window.pageYOffset||document.documentElement.scrollTop||0,l.left-=window.pageXOffset||document.documentElement.scrollLeft||0):(l.top-=w.top,l.left-=w.left),f.wrapper.data(y)||g.data(y,F({},s)),d=F({},l),u=F({},s),"fit"===S[0]&&(u.top+=f._fit(d.top,g.outerHeight(),M/T)),"fit"===S[1]&&(u.left+=f._fit(d.left,g.outerWidth(),P/T)),h=F({},u),"flip"===S[0]&&(u.top+=f._flip(d.top,p.outerHeight(),x.outerHeight(),M/T,k[0],C[0],g.outerHeight())),"flip"===S[1]&&(u.left+=f._flip(d.left,p.outerWidth(),x.outerWidth(),P/T,k[1],C[1],g.outerWidth())),p.css(b,v),g.css(u),u.left!=h.left||u.top!=h.top},_align:function(t,n){var i,r=this,o=r.wrapper,s=e(r.options.anchor),l=t[0],c=t[1],d=n[0],u=n[1],f=a(s),g=e(r.options.appendTo),v=o.outerWidth(),_=o.outerHeight(),w=s.outerWidth(),y=s.outerHeight(),b=f.top,x=f.left,k=Math.round;return g[0]!=document.body&&(i=a(g),b-=i.top,x-=i.left),l===m&&(b+=y),l===h&&(b+=k(y/2)),d===m&&(b-=_),d===h&&(b-=k(_/2)),c===p&&(x+=w),c===h&&(x+=k(w/2)),u===p&&(x-=v),u===h&&(x-=k(v/2)),{top:b,left:x}}});i.plugin(O)}(window.kendo.jQuery),window.kendo},__webpack_require__(166));

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(56);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(102);
var toLength = __webpack_require__(32);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(83);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(39);
var toObject = __webpack_require__(36);
var IObject = __webpack_require__(139);
var toLength = __webpack_require__(32);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(39);
var isObject = __webpack_require__(18);
var invoke = __webpack_require__(219);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(26).f;
var create = __webpack_require__(72);
var redefineAll = __webpack_require__(100);
var ctx = __webpack_require__(53);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(83);
var $iterDefine = __webpack_require__(174);
var step = __webpack_require__(221);
var setSpecies = __webpack_require__(101);
var DESCRIPTORS = __webpack_require__(30);
var fastKey = __webpack_require__(84).fastKey;
var validate = __webpack_require__(121);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(96);
var from = __webpack_require__(308);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(100);
var getWeak = __webpack_require__(84).getWeak;
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(18);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(83);
var createArrayMethod = __webpack_require__(61);
var $has = __webpack_require__(45);
var validate = __webpack_require__(121);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(171);
var isObject = __webpack_require__(18);
var toLength = __webpack_require__(32);
var ctx = __webpack_require__(53);
var IS_CONCAT_SPREADABLE = __webpack_require__(24)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(30) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(214)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(18);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(14);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(223);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 319 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var gOPD = __webpack_require__(48);
var ownKeys = __webpack_require__(227);
var toIObject = __webpack_require__(43);

module.exports = function define(target, mixin) {
  var keys = ownKeys(toIObject(mixin));
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) dP.f(target, key = keys[i++], gOPD.f(mixin, key));
  return target;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var anObject = __webpack_require__(14);
var getKeys = __webpack_require__(73);

module.exports = __webpack_require__(30) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(43);
var gOPN = __webpack_require__(99).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(45);
var toIObject = __webpack_require__(43);
var arrayIndexOf = __webpack_require__(167)(false);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(73);
var toIObject = __webpack_require__(43);
var isEnum = __webpack_require__(140).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(16).parseFloat;
var $trim = __webpack_require__(120).trim;

module.exports = 1 / $parseFloat(__webpack_require__(234) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(16).parseInt;
var $trim = __webpack_require__(120).trim;
var ws = __webpack_require__(234);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(329);
var invoke = __webpack_require__(219);
var aFunction = __webpack_require__(39);
module.exports = function (/* ...pargs */) {
  var fn = aFunction(this);
  var length = arguments.length;
  var pargs = new Array(length);
  var i = 0;
  var _ = path._;
  var holder = false;
  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
  return function (/* ...args */) {
    var that = this;
    var aLen = arguments.length;
    var j = 0;
    var k = 0;
    var args;
    if (!holder && !aLen) return invoke(fn, pargs, that);
    args = pargs.slice();
    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
    while (aLen > k) args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var isObject = __webpack_require__(18);
var newPromiseCapability = __webpack_require__(225);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(32);
var repeat = __webpack_require__(233);
var defined = __webpack_require__(62);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(32);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(24);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(96);
var ITERATOR = __webpack_require__(24)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(44).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(311);
var validate = __webpack_require__(121);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(168)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(30) && /./g.flags != 'g') __webpack_require__(26).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(170)
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(311);
var validate = __webpack_require__(121);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(168)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(61)(0);
var redefine = __webpack_require__(50);
var meta = __webpack_require__(84);
var assign = __webpack_require__(226);
var weak = __webpack_require__(313);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(19);
var validate = __webpack_require__(121);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(168)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(58);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(27), __webpack_require__(122) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

// This file is deprecated
return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
} ) );


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(27), __webpack_require__(122) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

return $.widget;

} ) );


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Operator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Constraint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expression__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strength__ = __webpack_require__(240);
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/


/**
 * An enum defining the linear constraint operators.
 *
 * |Value|Operator|Description|
 * |----|-----|-----|
 * |`Le`|<=|Less than equal|
 * |`Ge`|>=|Greater than equal|
 * |`Eq`|==|Equal|
 *
 * @enum {Number}
 */
var Operator;
(function (Operator) {
    Operator[Operator["Le"] = 0] = "Le";
    Operator[Operator["Ge"] = 1] = "Ge";
    Operator[Operator["Eq"] = 2] = "Eq";
})(Operator || (Operator = {}));
/**
 * A linear constraint equation.
 *
 * A constraint equation is composed of an expression, an operator,
 * and a strength. The RHS of the equation is implicitly zero.
 *
 * @class
 * @param {Expression} expression The constraint expression (LHS).
 * @param {Operator} operator The equation operator.
 * @param {Expression} [rhs] Right hand side of the expression.
 * @param {Number} [strength=Strength.required] The strength of the constraint.
 */
var Constraint = /** @class */ (function () {
    function Constraint(expression, operator, rhs, strength) {
        if (strength === void 0) { strength = __WEBPACK_IMPORTED_MODULE_1__strength__["a" /* Strength */].required; }
        this._id = CnId++;
        this._operator = operator;
        this._strength = __WEBPACK_IMPORTED_MODULE_1__strength__["a" /* Strength */].clip(strength);
        if ((rhs === undefined) && (expression instanceof __WEBPACK_IMPORTED_MODULE_0__expression__["a" /* Expression */])) {
            this._expression = expression;
        }
        else {
            this._expression = expression.minus(rhs);
        }
    }
    /**
     * A static constraint comparison function.
     * @private
     */
    Constraint.Compare = function (a, b) {
        return a.id() - b.id();
    };
    /**
     * Returns the unique id number of the constraint.
     * @private
     */
    Constraint.prototype.id = function () {
        return this._id;
    };
    /**
     * Returns the expression of the constraint.
     *
     * @return {Expression} expression
     */
    Constraint.prototype.expression = function () {
        return this._expression;
    };
    /**
     * Returns the relational operator of the constraint.
     *
     * @return {Operator} linear constraint operator
     */
    Constraint.prototype.op = function () {
        return this._operator;
    };
    /**
     * Returns the strength of the constraint.
     *
     * @return {Number} strength
     */
    Constraint.prototype.strength = function () {
        return this._strength;
    };
    Constraint.prototype.toString = function () {
        return this._expression.toString() + " " + ["<=", ">=", "="][this._operator] + " 0 (" + this._strength.toString() + ")";
    };
    return Constraint;
}());

/**
 * The internal constraint id counter.
 * @private
 */
var CnId = 0;


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMap;
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/
function createMap(compare) {
    return new IndexedMap();
}
var IndexedMap = /** @class */ (function () {
    function IndexedMap() {
        this.index = {};
        this.array = [];
    }
    /**
     * Returns the number of items in the array.
     */
    IndexedMap.prototype.size = function () {
        return this.array.length;
    };
    /**
     * Returns true if the array is empty.
     */
    IndexedMap.prototype.empty = function () {
        return this.array.length === 0;
    };
    /**
     * Returns the item at the given array index.
     *
     * @param index The integer index of the desired item.
     */
    IndexedMap.prototype.itemAt = function (index) {
        return this.array[index];
    };
    /**
     * Returns true if the key is in the array, false otherwise.
     *
     * @param key The key to locate in the array.
     */
    IndexedMap.prototype.contains = function (key) {
        return this.index[key.id()] !== undefined;
    };
    /**
     * Returns the pair associated with the given key, or undefined.
     *
     * @param key The key to locate in the array.
     */
    IndexedMap.prototype.find = function (key) {
        var i = this.index[key.id()];
        return i === undefined ? undefined : this.array[i];
    };
    /**
     * Returns the pair associated with the key if it exists.
     *
     * If the key does not exist, a new pair will be created and
     * inserted using the value created by the given factory.
     *
     * @param key The key to locate in the array.
     * @param factory The function which creates the default value.
     */
    IndexedMap.prototype.setDefault = function (key, factory) {
        var i = this.index[key.id()];
        if (i === undefined) {
            var pair = new Pair(key, factory());
            this.index[key.id()] = this.array.length;
            this.array.push(pair);
            return pair;
        }
        else {
            return this.array[i];
        }
    };
    /**
     * Insert the pair into the array and return the pair.
     *
     * This will overwrite any existing entry in the array.
     *
     * @param key The key portion of the pair.
     * @param value The value portion of the pair.
     */
    IndexedMap.prototype.insert = function (key, value) {
        var pair = new Pair(key, value);
        var i = this.index[key.id()];
        if (i === undefined) {
            this.index[key.id()] = this.array.length;
            this.array.push(pair);
        }
        else {
            this.array[i] = pair;
        }
        return pair;
    };
    /**
     * Removes and returns the pair for the given key, or undefined.
     *
     * @param key The key to remove from the map.
     */
    IndexedMap.prototype.erase = function (key) {
        var i = this.index[key.id()];
        if (i === undefined) {
            return undefined;
        }
        this.index[key.id()] = undefined;
        var pair = this.array[i];
        var last = this.array.pop();
        if (pair !== last) {
            this.array[i] = last;
            this.index[last.first.id()] = i;
        }
        return pair;
    };
    /**
     * Create a copy of this associative array.
     */
    IndexedMap.prototype.copy = function () {
        var copy = new IndexedMap();
        for (var i = 0; i < this.array.length; i++) {
            var pair = this.array[i].copy();
            copy.array[i] = pair;
            copy.index[pair.first.id()] = i;
        }
        return copy;
    };
    return IndexedMap;
}());
/**
 * A class which defines a generic pair object.
 * @private
 */
// tslint:disable: max-classes-per-file
var Pair = /** @class */ (function () {
    /**
     * Construct a new Pair object.
     *
     * @param first The first item of the pair.
     * @param second The second item of the pair.
     */
    function Pair(first, second) {
        this.first = first;
        this.second = second;
    }
    /**
     * Create a copy of the pair.
     */
    Pair.prototype.copy = function () { return new Pair(this.first, this.second); };
    return Pair;
}());


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/*
 Leaflet.draw 0.4.13, a plugin that adds drawing and editing tools to Leaflet powered maps.
 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet

 https://github.com/Leaflet/Leaflet.draw
 http://leafletjs.com
 */
!function(t,e,i){function o(t,e){for(;(t=t.parentElement)&&!t.classList.contains(e););return t}L.drawVersion="0.4.13",L.Draw={},L.drawLocal={draw:{toolbar:{actions:{title:"Cancel drawing",text:"Cancel"},finish:{title:"Finish drawing",text:"Finish"},undo:{title:"Delete last point drawn",text:"Delete last point"},buttons:{polyline:"Draw a polyline",polygon:"Draw a polygon",rectangle:"Draw a rectangle",circle:"Draw a circle",marker:"Draw a marker",circlemarker:"Draw a circlemarker"}},handlers:{circle:{tooltip:{start:"Click and drag to draw circle."},radius:"Radius"},circlemarker:{tooltip:{start:"Click map to place circle marker."}},marker:{tooltip:{start:"Click map to place marker."}},polygon:{tooltip:{start:"Click to start drawing shape.",cont:"Click to continue drawing shape.",end:"Click first point to close this shape."}},polyline:{error:"<strong>Error:</strong> shape edges cannot cross!",tooltip:{start:"Click to start drawing line.",cont:"Click to continue drawing line.",end:"Click last point to finish line."}},rectangle:{tooltip:{start:"Click and drag to draw rectangle."}},simpleshape:{tooltip:{end:"Release mouse to finish drawing."}}}},edit:{toolbar:{actions:{save:{title:"Save changes",text:"Save"},cancel:{title:"Cancel editing, discards all changes",text:"Cancel"},clearAll:{title:"Clear all layers",text:"Clear All"}},buttons:{edit:"Edit layers",editDisabled:"No layers to edit",remove:"Delete layers",removeDisabled:"No layers to delete"}},handlers:{edit:{tooltip:{text:"Drag handles or markers to edit features.",subtext:"Click cancel to undo changes."}},remove:{tooltip:{text:"Click on a feature to remove."}}}}},L.Draw.Event={},L.Draw.Event.CREATED="draw:created",L.Draw.Event.EDITED="draw:edited",L.Draw.Event.DELETED="draw:deleted",L.Draw.Event.DRAWSTART="draw:drawstart",L.Draw.Event.DRAWSTOP="draw:drawstop",L.Draw.Event.DRAWVERTEX="draw:drawvertex",L.Draw.Event.EDITSTART="draw:editstart",L.Draw.Event.EDITMOVE="draw:editmove",L.Draw.Event.EDITRESIZE="draw:editresize",L.Draw.Event.EDITVERTEX="draw:editvertex",L.Draw.Event.EDITSTOP="draw:editstop",L.Draw.Event.DELETESTART="draw:deletestart",L.Draw.Event.DELETESTOP="draw:deletestop",L.Draw.Event.TOOLBAROPENED="draw:toolbaropened",L.Draw.Event.TOOLBARCLOSED="draw:toolbarclosed",L.Draw=L.Draw||{},L.Draw.Feature=L.Handler.extend({initialize:function(t,e){this._map=t,this._container=t._container,this._overlayPane=t._panes.overlayPane,this._popupPane=t._panes.popupPane,e&&e.shapeOptions&&(e.shapeOptions=L.Util.extend({},this.options.shapeOptions,e.shapeOptions)),L.setOptions(this,e);var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.Draw.Feature.include(L.Evented.prototype):L.Draw.Feature.include(L.Mixin.Events)},enable:function(){this._enabled||(L.Handler.prototype.enable.call(this),this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DRAWSTART,{layerType:this.type}))},disable:function(){this._enabled&&(L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DRAWSTOP,{layerType:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(L.DomUtil.disableTextSelection(),t.getContainer().focus(),this._tooltip=new L.Draw.Tooltip(this._map),L.DomEvent.on(this._container,"keyup",this._cancelDrawing,this))},removeHooks:function(){this._map&&(L.DomUtil.enableTextSelection(),this._tooltip.dispose(),this._tooltip=null,L.DomEvent.off(this._container,"keyup",this._cancelDrawing,this))},setOptions:function(t){L.setOptions(this,t)},_fireCreatedEvent:function(t){this._map.fire(L.Draw.Event.CREATED,{layer:t,layerType:this.type})},_cancelDrawing:function(t){27===t.keyCode&&(this._map.fire("draw:canceled",{layerType:this.type}),this.disable())}}),L.Draw.Polyline=L.Draw.Feature.extend({statics:{TYPE:"polyline"},Poly:L.Polyline,options:{allowIntersection:!0,repeatMode:!1,drawError:{color:"#b00b00",timeout:2500},icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),guidelineDistance:20,maxGuideLineLength:4e3,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!1,clickable:!0},metric:!0,feet:!0,nautic:!1,showLength:!0,zIndexOffset:2e3,factor:1,maxPoints:0},initialize:function(t,e){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this.options.drawError.message=L.drawLocal.draw.handlers.polyline.error,e&&e.drawError&&(e.drawError=L.Util.extend({},this.options.drawError,e.drawError)),this.type=L.Draw.Polyline.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._markers=[],this._markerGroup=new L.LayerGroup,this._map.addLayer(this._markerGroup),this._poly=new L.Polyline([],this.options.shapeOptions),this._tooltip.updateContent(this._getTooltipText()),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("mouseout",this._onMouseOut,this).on("mousemove",this._onMouseMove,this).on("mousedown",this._onMouseDown,this).on("mouseup",this._onMouseUp,this).addTo(this._map),this._map.on("mouseup",this._onMouseUp,this).on("mousemove",this._onMouseMove,this).on("zoomlevelschange",this._onZoomEnd,this).on("touchstart",this._onTouch,this).on("zoomend",this._onZoomEnd,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._clearHideErrorTimeout(),this._cleanUpShape(),this._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers,this._map.removeLayer(this._poly),delete this._poly,this._mouseMarker.off("mousedown",this._onMouseDown,this).off("mouseout",this._onMouseOut,this).off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._clearGuides(),this._map.off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this).off("zoomlevelschange",this._onZoomEnd,this).off("zoomend",this._onZoomEnd,this).off("touchstart",this._onTouch,this).off("click",this._onTouch,this)},deleteLastVertex:function(){if(!(this._markers.length<=1)){var t=this._markers.pop(),e=this._poly,i=e.getLatLngs(),o=i.splice(-1,1)[0];this._poly.setLatLngs(i),this._markerGroup.removeLayer(t),e.getLatLngs().length<2&&this._map.removeLayer(e),this._vertexChanged(o,!1)}},addVertex:function(t){if(this._markers.length>=2&&!this.options.allowIntersection&&this._poly.newLatLngIntersects(t))return void this._showErrorTooltip();this._errorShown&&this._hideErrorTooltip(),this._markers.push(this._createMarker(t)),this._poly.addLatLng(t),2===this._poly.getLatLngs().length&&this._map.addLayer(this._poly),this._vertexChanged(t,!0)},completeShape:function(){this._markers.length<=1||(this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable())},_finishShape:function(){var t=this._poly._defaultShape?this._poly._defaultShape():this._poly.getLatLngs(),e=this._poly.newLatLngIntersects(t[t.length-1]);if(!this.options.allowIntersection&&e||!this._shapeIsValid())return void this._showErrorTooltip();this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_shapeIsValid:function(){return!0},_onZoomEnd:function(){null!==this._markers&&this._updateGuide()},_onMouseMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent),i=this._map.layerPointToLatLng(e);this._currentLatLng=i,this._updateTooltip(i),this._updateGuide(e),this._mouseMarker.setLatLng(i),L.DomEvent.preventDefault(t.originalEvent)},_vertexChanged:function(t,e){this._map.fire(L.Draw.Event.DRAWVERTEX,{layers:this._markerGroup}),this._updateFinishHandler(),this._updateRunningMeasure(t,e),this._clearGuides(),this._updateTooltip()},_onMouseDown:function(t){if(!this._clickHandled&&!this._touchHandled&&!this._disableMarkers){this._onMouseMove(t),this._clickHandled=!0,this._disableNewMarkers();var e=t.originalEvent,i=e.clientX,o=e.clientY;this._startPoint.call(this,i,o)}},_startPoint:function(t,e){this._mouseDownOrigin=L.point(t,e)},_onMouseUp:function(t){var e=t.originalEvent,i=e.clientX,o=e.clientY;this._endPoint.call(this,i,o,t),this._clickHandled=null},_endPoint:function(e,i,o){if(this._mouseDownOrigin){var n=L.point(e,i).distanceTo(this._mouseDownOrigin),a=this._calculateFinishDistance(o.latlng);this.options.maxPoints>1&&this.options.maxPoints==this._markers.length+1?(this.addVertex(o.latlng),this._finishShape()):a<10&&L.Browser.touch?this._finishShape():Math.abs(n)<9*(t.devicePixelRatio||1)&&this.addVertex(o.latlng),this._enableNewMarkers()}this._mouseDownOrigin=null},_onTouch:function(t){var e,i,o=t.originalEvent;!o.touches||!o.touches[0]||this._clickHandled||this._touchHandled||this._disableMarkers||(e=o.touches[0].clientX,i=o.touches[0].clientY,this._disableNewMarkers(),this._touchHandled=!0,this._startPoint.call(this,e,i),this._endPoint.call(this,e,i,t),this._touchHandled=null),this._clickHandled=null},_onMouseOut:function(){this._tooltip&&this._tooltip._onMouseOut.call(this._tooltip)},_calculateFinishDistance:function(t){var e;if(this._markers.length>0){var i;if(this.type===L.Draw.Polyline.TYPE)i=this._markers[this._markers.length-1];else{if(this.type!==L.Draw.Polygon.TYPE)return 1/0;i=this._markers[0]}var o=this._map.latLngToContainerPoint(i.getLatLng()),n=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset}),a=this._map.latLngToContainerPoint(n.getLatLng());e=o.distanceTo(a)}else e=1/0;return e},_updateFinishHandler:function(){var t=this._markers.length;t>1&&this._markers[t-1].on("click",this._finishShape,this),t>2&&this._markers[t-2].off("click",this._finishShape,this)},_createMarker:function(t){var e=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset});return this._markerGroup.addLayer(e),e},_updateGuide:function(t){var e=this._markers?this._markers.length:0;e>0&&(t=t||this._map.latLngToLayerPoint(this._currentLatLng),this._clearGuides(),this._drawGuide(this._map.latLngToLayerPoint(this._markers[e-1].getLatLng()),t))},_updateTooltip:function(t){var e=this._getTooltipText();t&&this._tooltip.updatePosition(t),this._errorShown||this._tooltip.updateContent(e)},_drawGuide:function(t,e){var i,o,n,a=Math.floor(Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))),s=this.options.guidelineDistance,r=this.options.maxGuideLineLength,l=a>r?a-r:s;for(this._guidesContainer||(this._guidesContainer=L.DomUtil.create("div","leaflet-draw-guides",this._overlayPane));l<a;l+=this.options.guidelineDistance)i=l/a,o={x:Math.floor(t.x*(1-i)+i*e.x),y:Math.floor(t.y*(1-i)+i*e.y)},n=L.DomUtil.create("div","leaflet-draw-guide-dash",this._guidesContainer),n.style.backgroundColor=this._errorShown?this.options.drawError.color:this.options.shapeOptions.color,L.DomUtil.setPosition(n,o)},_updateGuideColor:function(t){if(this._guidesContainer)for(var e=0,i=this._guidesContainer.childNodes.length;e<i;e++)this._guidesContainer.childNodes[e].style.backgroundColor=t},_clearGuides:function(){if(this._guidesContainer)for(;this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild)},_getTooltipText:function(){var t,e,i=this.options.showLength;return L.Browser.touch&&(i=!1),0===this._markers.length?t={text:L.drawLocal.draw.handlers.polyline.tooltip.start}:(e=i?this._getMeasurementString():"",t=1===this._markers.length?{text:L.drawLocal.draw.handlers.polyline.tooltip.cont,subtext:e}:{text:L.drawLocal.draw.handlers.polyline.tooltip.end,subtext:e}),t},_updateRunningMeasure:function(t,e){var i,o,n=this._markers.length;1===this._markers.length?this._measurementRunningTotal=0:(i=n-(e?2:1),o=L.GeometryUtil.isVersion07x()?t.distanceTo(this._markers[i].getLatLng())*(this.options.factor||1):this._map.distance(t,this._markers[i].getLatLng())*(this.options.factor||1),this._measurementRunningTotal+=o*(e?1:-1))},_getMeasurementString:function(){var t,e=this._currentLatLng,i=this._markers[this._markers.length-1].getLatLng();return t=L.GeometryUtil.isVersion07x()?i&&e&&e.distanceTo?this._measurementRunningTotal+e.distanceTo(i)*(this.options.factor||1):this._measurementRunningTotal||0:i&&e?this._measurementRunningTotal+this._map.distance(e,i)*(this.options.factor||1):this._measurementRunningTotal||0,L.GeometryUtil.readableDistance(t,this.options.metric,this.options.feet,this.options.nautic,this.options.precision)},_showErrorTooltip:function(){this._errorShown=!0,this._tooltip.showAsError().updateContent({text:this.options.drawError.message}),this._updateGuideColor(this.options.drawError.color),this._poly.setStyle({color:this.options.drawError.color}),this._clearHideErrorTimeout(),this._hideErrorTimeout=setTimeout(L.Util.bind(this._hideErrorTooltip,this),this.options.drawError.timeout)},_hideErrorTooltip:function(){this._errorShown=!1,this._clearHideErrorTimeout(),this._tooltip.removeError().updateContent(this._getTooltipText()),this._updateGuideColor(this.options.shapeOptions.color),this._poly.setStyle({color:this.options.shapeOptions.color})},_clearHideErrorTimeout:function(){this._hideErrorTimeout&&(clearTimeout(this._hideErrorTimeout),this._hideErrorTimeout=null)},_disableNewMarkers:function(){this._disableMarkers=!0},_enableNewMarkers:function(){setTimeout(function(){this._disableMarkers=!1}.bind(this),50)},_cleanUpShape:function(){this._markers.length>1&&this._markers[this._markers.length-1].off("click",this._finishShape,this)},_fireCreatedEvent:function(){var t=new this.Poly(this._poly.getLatLngs(),this.options.shapeOptions);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.Polygon=L.Draw.Polyline.extend({statics:{TYPE:"polygon"},Poly:L.Polygon,options:{showArea:!1,showLength:!1,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},metric:!0,feet:!0,nautic:!1,precision:{}},initialize:function(t,e){L.Draw.Polyline.prototype.initialize.call(this,t,e),this.type=L.Draw.Polygon.TYPE},_updateFinishHandler:function(){var t=this._markers.length;1===t&&this._markers[0].on("click",this._finishShape,this),t>2&&(this._markers[t-1].on("dblclick",this._finishShape,this),t>3&&this._markers[t-2].off("dblclick",this._finishShape,this))},_getTooltipText:function(){var t,e;return 0===this._markers.length?t=L.drawLocal.draw.handlers.polygon.tooltip.start:this._markers.length<3?(t=L.drawLocal.draw.handlers.polygon.tooltip.cont,e=this._getMeasurementString()):(t=L.drawLocal.draw.handlers.polygon.tooltip.end,e=this._getMeasurementString()),{text:t,subtext:e}},_getMeasurementString:function(){var t=this._area,e="";return t||this.options.showLength?(this.options.showLength&&(e=L.Draw.Polyline.prototype._getMeasurementString.call(this)),t&&(e+="<br>"+L.GeometryUtil.readableArea(t,this.options.metric,this.options.precision)),e):null},_shapeIsValid:function(){return this._markers.length>=3},_vertexChanged:function(t,e){var i;!this.options.allowIntersection&&this.options.showArea&&(i=this._poly.getLatLngs(),this._area=L.GeometryUtil.geodesicArea(i)),L.Draw.Polyline.prototype._vertexChanged.call(this,t,e)},_cleanUpShape:function(){var t=this._markers.length;t>0&&(this._markers[0].off("click",this._finishShape,this),t>2&&this._markers[t-1].off("dblclick",this._finishShape,this))}}),L.SimpleShape={},L.Draw.SimpleShape=L.Draw.Feature.extend({options:{repeatMode:!1},initialize:function(t,e){this._endLabelText=L.drawLocal.draw.handlers.simpleshape.tooltip.end,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._mapDraggable=this._map.dragging.enabled(),this._mapDraggable&&this._map.dragging.disable(),this._container.style.cursor="crosshair",this._tooltip.updateContent({text:this._initialLabelText}),this._map.on("mousedown",this._onMouseDown,this).on("mousemove",this._onMouseMove,this).on("touchstart",this._onMouseDown,this).on("touchmove",this._onMouseMove,this),e.addEventListener("touchstart",L.DomEvent.preventDefault,{passive:!1}))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._mapDraggable&&this._map.dragging.enable(),this._container.style.cursor="",this._map.off("mousedown",this._onMouseDown,this).off("mousemove",this._onMouseMove,this).off("touchstart",this._onMouseDown,this).off("touchmove",this._onMouseMove,this),L.DomEvent.off(e,"mouseup",this._onMouseUp,this),L.DomEvent.off(e,"touchend",this._onMouseUp,this),e.removeEventListener("touchstart",L.DomEvent.preventDefault),this._shape&&(this._map.removeLayer(this._shape),delete this._shape)),this._isDrawing=!1},_getTooltipText:function(){return{text:this._endLabelText}},_onMouseDown:function(t){this._isDrawing=!0,this._startLatLng=t.latlng,L.DomEvent.on(e,"mouseup",this._onMouseUp,this).on(e,"touchend",this._onMouseUp,this).preventDefault(t.originalEvent)},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._isDrawing&&(this._tooltip.updateContent(this._getTooltipText()),this._drawShape(e))},_onMouseUp:function(){this._shape&&this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()}}),L.Draw.Rectangle=L.Draw.SimpleShape.extend({statics:{TYPE:"rectangle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,showArea:!0,clickable:!0},metric:!0},initialize:function(t,e){this.type=L.Draw.Rectangle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.rectangle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},disable:function(){this._enabled&&(this._isCurrentlyTwoClickDrawing=!1,L.Draw.SimpleShape.prototype.disable.call(this))},_onMouseUp:function(t){if(!this._shape&&!this._isCurrentlyTwoClickDrawing)return void(this._isCurrentlyTwoClickDrawing=!0);this._isCurrentlyTwoClickDrawing&&!o(t.target,"leaflet-pane")||L.Draw.SimpleShape.prototype._onMouseUp.call(this)},_drawShape:function(t){this._shape?this._shape.setBounds(new L.LatLngBounds(this._startLatLng,t)):(this._shape=new L.Rectangle(new L.LatLngBounds(this._startLatLng,t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Rectangle(this._shape.getBounds(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_getTooltipText:function(){var t,e,i,o=L.Draw.SimpleShape.prototype._getTooltipText.call(this),n=this._shape,a=this.options.showArea;return n&&(t=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),e=L.GeometryUtil.geodesicArea(t),i=a?L.GeometryUtil.readableArea(e,this.options.metric):""),{text:o.text,subtext:i}}}),L.Draw.Marker=L.Draw.Feature.extend({statics:{TYPE:"marker"},options:{icon:new L.Icon.Default,repeatMode:!1,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.Marker.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.marker.tooltip.start,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._tooltip.updateContent({text:this._initialLabelText}),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("click",this._onClick,this).addTo(this._map),this._map.on("mousemove",this._onMouseMove,this),this._map.on("click",this._onTouch,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._marker&&(this._marker.off("click",this._onClick,this),this._map.off("click",this._onClick,this).off("click",this._onTouch,this).removeLayer(this._marker),delete this._marker),this._mouseMarker.off("click",this._onClick,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._map.off("mousemove",this._onMouseMove,this))},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._mouseMarker.setLatLng(e),this._marker?(e=this._mouseMarker.getLatLng(),this._marker.setLatLng(e)):(this._marker=this._createMarker(e),this._marker.on("click",this._onClick,this),this._map.on("click",this._onClick,this).addLayer(this._marker))},_createMarker:function(t){return new L.Marker(t,{icon:this.options.icon,zIndexOffset:this.options.zIndexOffset})},_onClick:function(){this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_onTouch:function(t){this._onMouseMove(t),this._onClick()},_fireCreatedEvent:function(){var t=new L.Marker.Touch(this._marker.getLatLng(),{icon:this.options.icon});L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.CircleMarker=L.Draw.Marker.extend({statics:{TYPE:"circlemarker"},options:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.CircleMarker.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circlemarker.tooltip.start,L.Draw.Feature.prototype.initialize.call(this,t,e)},_fireCreatedEvent:function(){var t=new L.CircleMarker(this._marker.getLatLng(),this.options);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)},_createMarker:function(t){return new L.CircleMarker(t,this.options)}}),L.Draw.Circle=L.Draw.SimpleShape.extend({statics:{TYPE:"circle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},showRadius:!0,metric:!0,feet:!0,nautic:!1},initialize:function(t,e){this.type=L.Draw.Circle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){if(L.GeometryUtil.isVersion07x())var e=this._startLatLng.distanceTo(t);else var e=this._map.distance(this._startLatLng,t);this._shape?this._shape.setRadius(e):(this._shape=new L.Circle(this._startLatLng,e,this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Circle(this._startLatLng,this._shape.getRadius(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_onMouseMove:function(t){var e,i=t.latlng,o=this.options.showRadius,n=this.options.metric;if(this._tooltip.updatePosition(i),this._isDrawing){this._drawShape(i),e=this._shape.getRadius().toFixed(1);var a="";o&&(a=L.drawLocal.draw.handlers.circle.radius+": "+L.GeometryUtil.readableDistance(e,n,this.options.feet,this.options.nautic)),this._tooltip.updateContent({text:this._endLabelText,subtext:a})}}}),L.Edit=L.Edit||{},L.Edit.Marker=L.Handler.extend({initialize:function(t,e){this._marker=t,L.setOptions(this,e)},addHooks:function(){var t=this._marker;t.dragging.enable(),t.on("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},removeHooks:function(){var t=this._marker;t.dragging.disable(),t.off("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},_onDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_toggleMarkerHighlight:function(){var t=this._marker._icon;t&&(t.style.display="none",L.DomUtil.hasClass(t,"leaflet-edit-marker-selected")?(L.DomUtil.removeClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,-4)):(L.DomUtil.addClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,4)),t.style.display="")},_offsetMarker:function(t,e){var i=parseInt(t.style.marginTop,10)-e,o=parseInt(t.style.marginLeft,10)-e;t.style.marginTop=i+"px",t.style.marginLeft=o+"px"}}),L.Marker.addInitHook(function(){L.Edit.Marker&&(this.editing=new L.Edit.Marker(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Poly=L.Handler.extend({initialize:function(t){this.latlngs=[t._latlngs],t._holes&&(this.latlngs=this.latlngs.concat(t._holes)),this._poly=t,this._poly.on("revert-edited",this._updateLatLngs,this)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._poly._latlngs)?this._poly._latlngs:this._poly._latlngs[0]:this._poly._latlngs},_eachVertexHandler:function(t){for(var e=0;e<this._verticesHandlers.length;e++)t(this._verticesHandlers[e])},addHooks:function(){this._initHandlers(),this._eachVertexHandler(function(t){t.addHooks()})},removeHooks:function(){this._eachVertexHandler(function(t){t.removeHooks()})},updateMarkers:function(){this._eachVertexHandler(function(t){t.updateMarkers()})},_initHandlers:function(){this._verticesHandlers=[];for(var t=0;t<this.latlngs.length;t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly,this.latlngs[t],this._poly.options.poly))},_updateLatLngs:function(t){this.latlngs=[t.layer._latlngs],t.layer._holes&&(this.latlngs=this.latlngs.concat(t.layer._holes))}}),L.Edit.PolyVerticesEdit=L.Handler.extend({options:{icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),drawError:{color:"#b00b00",timeout:1e3}},initialize:function(t,e,i){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this._poly=t,i&&i.drawError&&(i.drawError=L.Util.extend({},this.options.drawError,i.drawError)),this._latlngs=e,L.setOptions(this,i)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._latlngs)?this._latlngs:this._latlngs[0]:this._latlngs},addHooks:function(){var t=this._poly,e=t._path;t instanceof L.Polygon||(t.options.fill=!1,t.options.editing&&(t.options.editing.fill=!1)),e&&t.options.editing.className&&(t.options.original.className&&t.options.original.className.split(" ").forEach(function(t){L.DomUtil.removeClass(e,t)}),t.options.editing.className.split(" ").forEach(function(t){L.DomUtil.addClass(e,t)})),t.setStyle(t.options.editing),this._poly._map&&(this._map=this._poly._map,this._markerGroup||this._initMarkers(),this._poly._map.addLayer(this._markerGroup))},removeHooks:function(){var t=this._poly,e=t._path;e&&t.options.editing.className&&(t.options.editing.className.split(" ").forEach(function(t){L.DomUtil.removeClass(e,t)}),t.options.original.className&&t.options.original.className.split(" ").forEach(function(t){L.DomUtil.addClass(e,t)})),t.setStyle(t.options.original),t._map&&(t._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers)},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._markers=[];var t,e,i,o,n=this._defaultShape();for(t=0,i=n.length;t<i;t++)o=this._createMarker(n[t],t),o.on("click",this._onMarkerClick,this),this._markers.push(o);var a,s;for(t=0,e=i-1;t<i;e=t++)(0!==t||L.Polygon&&this._poly instanceof L.Polygon)&&(a=this._markers[e],s=this._markers[t],this._createMiddleMarker(a,s),this._updatePrevNext(a,s))},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:this.options.icon});return i._origLatLng=t,i._index=e,i.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._fireEdit,this).on("touchmove",this._onTouchMove,this).on("touchend",this._fireEdit,this).on("MSPointerMove",this._onTouchMove,this).on("MSPointerUp",this._fireEdit,this),this._markerGroup.addLayer(i),i},_onMarkerDragStart:function(){this._poly.fire("editstart")},_spliceLatLngs:function(){var t=this._defaultShape(),e=[].splice.apply(t,arguments);return this._poly._convertLatLngs(t,!0),this._poly.redraw(),e},_removeMarker:function(t){var e=t._index;this._markerGroup.removeLayer(t),this._markers.splice(e,1),this._spliceLatLngs(e,1),this._updateIndexes(e,-1),t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._fireEdit,this).off("touchmove",this._onMarkerDrag,this).off("touchend",this._fireEdit,this).off("click",this._onMarkerClick,this).off("MSPointerMove",this._onTouchMove,this).off("MSPointerUp",this._fireEdit,this)},_fireEdit:function(){this._poly.edited=!0,this._poly.fire("edit"),this._poly._map.fire(L.Draw.Event.EDITVERTEX,{layers:this._markerGroup,poly:this._poly})},_onMarkerDrag:function(t){var e=t.target,i=this._poly;if(L.extend(e._origLatLng,e._latlng),e._middleLeft&&e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev,e)),e._middleRight&&e._middleRight.setLatLng(this._getMiddleLatLng(e,e._next)),i.options.poly){var o=i._map._editTooltip;if(!i.options.poly.allowIntersection&&i.intersects()){var n=i.options.color;i.setStyle({color:this.options.drawError.color}),0!==L.version.indexOf("0.7")&&e.dragging._draggable._onUp(t),this._onMarkerClick(t),o&&o.updateContent({text:L.drawLocal.draw.handlers.polyline.error}),setTimeout(function(){i.setStyle({color:n}),o&&o.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext})},1e3)}}this._poly.redraw(),this._poly.fire("editdrag")},_onMarkerClick:function(t){var e=L.Polygon&&this._poly instanceof L.Polygon?4:3,i=t.target;this._defaultShape().length<e||(this._removeMarker(i),this._updatePrevNext(i._prev,i._next),i._middleLeft&&this._markerGroup.removeLayer(i._middleLeft),i._middleRight&&this._markerGroup.removeLayer(i._middleRight),i._prev&&i._next?this._createMiddleMarker(i._prev,i._next):i._prev?i._next||(i._prev._middleRight=null):i._next._middleLeft=null,this._fireEdit())},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;L.extend(o._origLatLng,i),o._middleLeft&&o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev,o)),o._middleRight&&o._middleRight.setLatLng(this._getMiddleLatLng(o,o._next)),this._poly.redraw(),this.updateMarkers()},_updateIndexes:function(t,e){this._markerGroup.eachLayer(function(i){i._index>t&&(i._index+=e)})},_createMiddleMarker:function(t,e){var i,o,n,a=this._getMiddleLatLng(t,e),s=this._createMarker(a);s.setOpacity(.6),t._middleRight=e._middleLeft=s,o=function(){s.off("touchmove",o,this);var n=e._index;s._index=n,s.off("click",i,this).on("click",this._onMarkerClick,this),a.lat=s.getLatLng().lat,a.lng=s.getLatLng().lng,this._spliceLatLngs(n,0,a),this._markers.splice(n,0,s),s.setOpacity(1),this._updateIndexes(n,1),e._index++,this._updatePrevNext(t,s),this._updatePrevNext(s,e),this._poly.fire("editstart")},n=function(){s.off("dragstart",o,this),s.off("dragend",n,this),s.off("touchmove",o,this),this._createMiddleMarker(t,s),this._createMiddleMarker(s,e)},i=function(){o.call(this),n.call(this),this._fireEdit()},s.on("click",i,this).on("dragstart",o,this).on("dragend",n,this).on("touchmove",o,this),this._markerGroup.addLayer(s)},_updatePrevNext:function(t,e){t&&(t._next=e),e&&(e._prev=t)},_getMiddleLatLng:function(t,e){var i=this._poly._map,o=i.project(t.getLatLng()),n=i.project(e.getLatLng());return i.unproject(o._add(n)._divideBy(2))}}),L.Polyline.addInitHook(function(){this.editing||(L.Edit.Poly&&(this.editing=new L.Edit.Poly(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()}))}),L.Edit=L.Edit||{},L.Edit.SimpleShape=L.Handler.extend({options:{moveIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move"}),resizeIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"}),touchMoveIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"}),touchResizeIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"})},initialize:function(t,e){L.Browser.touch&&(this.options.moveIcon=this.options.touchMoveIcon,this.options.resizeIcon=this.options.touchResizeIcon),this._shape=t,
L.Util.setOptions(this,e)},addHooks:function(){var t=this._shape;this._shape._map&&(this._map=this._shape._map,t.setStyle(t.options.editing),t._map&&(this._map=t._map,this._markerGroup||this._initMarkers(),this._map.addLayer(this._markerGroup)))},removeHooks:function(){var t=this._shape;if(t.setStyle(t.options.original),t._map){this._unbindMarker(this._moveMarker);for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._unbindMarker(this._resizeMarkers[e]);this._resizeMarkers=null,this._map.removeLayer(this._markerGroup),delete this._markerGroup}this._map=null},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._createMoveMarker(),this._createResizeMarker()},_createMoveMarker:function(){},_createResizeMarker:function(){},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:e,zIndexOffset:10});return this._bindMarker(i),this._markerGroup.addLayer(i),i},_bindMarker:function(t){t.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._onMarkerDragEnd,this).on("touchstart",this._onTouchStart,this).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onTouchEnd,this).on("MSPointerUp",this._onTouchEnd,this)},_unbindMarker:function(t){t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._onMarkerDragEnd,this).off("touchstart",this._onTouchStart,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onTouchEnd,this).off("MSPointerUp",this._onTouchEnd,this)},_onMarkerDragStart:function(t){t.target.setOpacity(0),this._shape.fire("editstart")},_fireEdit:function(){this._shape.edited=!0,this._shape.fire("edit")},_onMarkerDrag:function(t){var e=t.target,i=e.getLatLng();e===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),this._shape.fire("editdrag")},_onMarkerDragEnd:function(t){t.target.setOpacity(1),this._fireEdit()},_onTouchStart:function(t){if(L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t),"function"==typeof this._getCorners){var e=this._getCorners(),i=t.target,o=i._cornerIndex;i.setOpacity(0),this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)}this._shape.fire("editstart")},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e);return t.target===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),!1},_onTouchEnd:function(t){t.target.setOpacity(1),this.updateMarkers(),this._fireEdit()},_move:function(){},_resize:function(){}}),L.Edit=L.Edit||{},L.Edit.Rectangle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getBounds(),e=t.getCenter();this._moveMarker=this._createMarker(e,this.options.moveIcon)},_createResizeMarker:function(){var t=this._getCorners();this._resizeMarkers=[];for(var e=0,i=t.length;e<i;e++)this._resizeMarkers.push(this._createMarker(t[e],this.options.resizeIcon)),this._resizeMarkers[e]._cornerIndex=e},_onMarkerDragStart:function(t){L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t);var e=this._getCorners(),i=t.target,o=i._cornerIndex;this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)},_onMarkerDragEnd:function(t){var e,i,o=t.target;o===this._moveMarker&&(e=this._shape.getBounds(),i=e.getCenter(),o.setLatLng(i)),this._toggleCornerMarkers(1),this._repositionCornerMarkers(),L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this,t)},_move:function(t){for(var e,i=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),o=this._shape.getBounds(),n=o.getCenter(),a=[],s=0,r=i.length;s<r;s++)e=[i[s].lat-n.lat,i[s].lng-n.lng],a.push([t.lat+e[0],t.lng+e[1]]);this._shape.setLatLngs(a),this._repositionCornerMarkers(),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})},_resize:function(t){var e;this._shape.setBounds(L.latLngBounds(t,this._oppositeCorner)),e=this._shape.getBounds(),this._moveMarker.setLatLng(e.getCenter()),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})},_getCorners:function(){var t=this._shape.getBounds();return[t.getNorthWest(),t.getNorthEast(),t.getSouthEast(),t.getSouthWest()]},_toggleCornerMarkers:function(t){for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setOpacity(t)},_repositionCornerMarkers:function(){for(var t=this._getCorners(),e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setLatLng(t[e])}}),L.Rectangle.addInitHook(function(){L.Edit.Rectangle&&(this.editing=new L.Edit.Rectangle(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.CircleMarker=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getLatLng();this._moveMarker=this._createMarker(t,this.options.moveIcon)},_createResizeMarker:function(){this._resizeMarkers=[]},_move:function(t){if(this._resizeMarkers.length){var e=this._getResizeMarkerPoint(t);this._resizeMarkers[0].setLatLng(e)}this._shape.setLatLng(t),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})}}),L.CircleMarker.addInitHook(function(){L.Edit.CircleMarker&&(this.editing=new L.Edit.CircleMarker(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()})}),L.Edit=L.Edit||{},L.Edit.Circle=L.Edit.CircleMarker.extend({_createResizeMarker:function(){var t=this._shape.getLatLng(),e=this._getResizeMarkerPoint(t);this._resizeMarkers=[],this._resizeMarkers.push(this._createMarker(e,this.options.resizeIcon))},_getResizeMarkerPoint:function(t){var e=this._shape._radius*Math.cos(Math.PI/4),i=this._map.project(t);return this._map.unproject([i.x+e,i.y-e])},_resize:function(t){var e=this._moveMarker.getLatLng();L.GeometryUtil.isVersion07x()?radius=e.distanceTo(t):radius=this._map.distance(e,t),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})}}),L.Circle.addInitHook(function(){L.Edit.Circle&&(this.editing=new L.Edit.Circle(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()})}),L.Map.mergeOptions({touchExtend:!0}),L.Map.TouchExtend=L.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){L.DomEvent.on(this._container,"touchstart",this._onTouchStart,this),L.DomEvent.on(this._container,"touchend",this._onTouchEnd,this),L.DomEvent.on(this._container,"touchmove",this._onTouchMove,this),this._detectIE()?(L.DomEvent.on(this._container,"MSPointerDown",this._onTouchStart,this),L.DomEvent.on(this._container,"MSPointerUp",this._onTouchEnd,this),L.DomEvent.on(this._container,"MSPointerMove",this._onTouchMove,this),L.DomEvent.on(this._container,"MSPointerCancel",this._onTouchCancel,this)):(L.DomEvent.on(this._container,"touchcancel",this._onTouchCancel,this),L.DomEvent.on(this._container,"touchleave",this._onTouchLeave,this))},removeHooks:function(){L.DomEvent.off(this._container,"touchstart",this._onTouchStart),L.DomEvent.off(this._container,"touchend",this._onTouchEnd),L.DomEvent.off(this._container,"touchmove",this._onTouchMove),this._detectIE()?(L.DomEvent.off(this._container,"MSPointerDowm",this._onTouchStart),L.DomEvent.off(this._container,"MSPointerUp",this._onTouchEnd),L.DomEvent.off(this._container,"MSPointerMove",this._onTouchMove),L.DomEvent.off(this._container,"MSPointerCancel",this._onTouchCancel)):(L.DomEvent.off(this._container,"touchcancel",this._onTouchCancel),L.DomEvent.off(this._container,"touchleave",this._onTouchLeave))},_touchEvent:function(t,e){var i={};if(void 0!==t.touches){if(!t.touches.length)return;i=t.touches[0]}else{if("touch"!==t.pointerType)return;if(i=t,!this._filterClick(t))return}var o=this._map.mouseEventToContainerPoint(i),n=this._map.mouseEventToLayerPoint(i),a=this._map.layerPointToLatLng(n);this._map.fire(e,{latlng:a,layerPoint:n,containerPoint:o,pageX:i.pageX,pageY:i.pageY,originalEvent:t})},_filterClick:function(t){var e=t.timeStamp||t.originalEvent.timeStamp,i=L.DomEvent._lastClick&&e-L.DomEvent._lastClick;return i&&i>100&&i<500||t.target._simulatedClick&&!t._simulated?(L.DomEvent.stop(t),!1):(L.DomEvent._lastClick=e,!0)},_onTouchStart:function(t){if(this._map._loaded){this._touchEvent(t,"touchstart")}},_onTouchEnd:function(t){if(this._map._loaded){this._touchEvent(t,"touchend")}},_onTouchCancel:function(t){if(this._map._loaded){var e="touchcancel";this._detectIE()&&(e="pointercancel"),this._touchEvent(t,e)}},_onTouchLeave:function(t){if(this._map._loaded){this._touchEvent(t,"touchleave")}},_onTouchMove:function(t){if(this._map._loaded){this._touchEvent(t,"touchmove")}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);if(e.indexOf("Trident/")>0){var o=e.indexOf("rv:");return parseInt(e.substring(o+3,e.indexOf(".",o)),10)}var n=e.indexOf("Edge/");return n>0&&parseInt(e.substring(n+5,e.indexOf(".",n)),10)}}),L.Map.addInitHook("addHandler","touchExtend",L.Map.TouchExtend),L.Marker.Touch=L.Marker.extend({_initInteraction:function(){return this.addInteractiveTarget?L.Marker.prototype._initInteraction.apply(this):this._initInteractionLegacy()},_initInteractionLegacy:function(){if(this.options.clickable){var t=this._icon,e=["dblclick","mousedown","mouseover","mouseout","contextmenu","touchstart","touchend","touchmove"];this._detectIE?e.concat(["MSPointerDown","MSPointerUp","MSPointerMove","MSPointerCancel"]):e.concat(["touchcancel"]),L.DomUtil.addClass(t,"leaflet-clickable"),L.DomEvent.on(t,"click",this._onMouseClick,this),L.DomEvent.on(t,"keypress",this._onKeyPress,this);for(var i=0;i<e.length;i++)L.DomEvent.on(t,e[i],this._fireMouseEvent,this);L.Handler.MarkerDrag&&(this.dragging=new L.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);if(e.indexOf("Trident/")>0){var o=e.indexOf("rv:");return parseInt(e.substring(o+3,e.indexOf(".",o)),10)}var n=e.indexOf("Edge/");return n>0&&parseInt(e.substring(n+5,e.indexOf(".",n)),10)}}),L.LatLngUtil={cloneLatLngs:function(t){for(var e=[],i=0,o=t.length;i<o;i++)Array.isArray(t[i])?e.push(L.LatLngUtil.cloneLatLngs(t[i])):e.push(this.cloneLatLng(t[i]));return e},cloneLatLng:function(t){return L.latLng(t.lat,t.lng)}},function(){var t={km:2,ha:2,m:0,mi:2,ac:2,yd:0,ft:0,nm:2};L.GeometryUtil=L.extend(L.GeometryUtil||{},{geodesicArea:function(t){var e,i,o=t.length,n=0,a=Math.PI/180;if(o>2){for(var s=0;s<o;s++)e=t[s],i=t[(s+1)%o],n+=(i.lng-e.lng)*a*(2+Math.sin(e.lat*a)+Math.sin(i.lat*a));n=6378137*n*6378137/2}return Math.abs(n)},formattedNumber:function(t,e){var i=parseFloat(t).toFixed(e),o=L.drawLocal.format&&L.drawLocal.format.numeric,n=o&&o.delimiters,a=n&&n.thousands,s=n&&n.decimal;if(a||s){var r=i.split(".");i=a?r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+a):r[0],s=s||".",r.length>1&&(i=i+s+r[1])}return i},readableArea:function(e,i,o){var n,a,o=L.Util.extend({},t,o);return i?(a=["ha","m"],type=typeof i,"string"===type?a=[i]:"boolean"!==type&&(a=i),n=e>=1e6&&-1!==a.indexOf("km")?L.GeometryUtil.formattedNumber(1e-6*e,o.km)+" km²":e>=1e4&&-1!==a.indexOf("ha")?L.GeometryUtil.formattedNumber(1e-4*e,o.ha)+" ha":L.GeometryUtil.formattedNumber(e,o.m)+" m²"):(e/=.836127,n=e>=3097600?L.GeometryUtil.formattedNumber(e/3097600,o.mi)+" mi²":e>=4840?L.GeometryUtil.formattedNumber(e/4840,o.ac)+" acres":L.GeometryUtil.formattedNumber(e,o.yd)+" yd²"),n},readableDistance:function(e,i,o,n,a){var s,a=L.Util.extend({},t,a);switch(i?"string"==typeof i?i:"metric":o?"feet":n?"nauticalMile":"yards"){case"metric":s=e>1e3?L.GeometryUtil.formattedNumber(e/1e3,a.km)+" km":L.GeometryUtil.formattedNumber(e,a.m)+" m";break;case"feet":e*=3.28083,s=L.GeometryUtil.formattedNumber(e,a.ft)+" ft";break;case"nauticalMile":e*=.53996,s=L.GeometryUtil.formattedNumber(e/1e3,a.nm)+" nm";break;case"yards":default:e*=1.09361,s=e>1760?L.GeometryUtil.formattedNumber(e/1760,a.mi)+" miles":L.GeometryUtil.formattedNumber(e,a.yd)+" yd"}return s},isVersion07x:function(){var t=L.version.split(".");return 0===parseInt(t[0],10)&&7===parseInt(t[1],10)}})}(),L.Util.extend(L.LineUtil,{segmentsIntersect:function(t,e,i,o){return this._checkCounterclockwise(t,i,o)!==this._checkCounterclockwise(e,i,o)&&this._checkCounterclockwise(t,e,i)!==this._checkCounterclockwise(t,e,o)},_checkCounterclockwise:function(t,e,i){return(i.y-t.y)*(e.x-t.x)>(e.y-t.y)*(i.x-t.x)}}),L.Polyline.include({intersects:function(){var t,e,i,o=this._getProjectedPoints(),n=o?o.length:0;if(this._tooFewPointsForIntersection())return!1;for(t=n-1;t>=3;t--)if(e=o[t-1],i=o[t],this._lineSegmentsIntersectsRange(e,i,t-2))return!0;return!1},newLatLngIntersects:function(t,e){return!!this._map&&this.newPointIntersects(this._map.latLngToLayerPoint(t),e)},newPointIntersects:function(t,e){var i=this._getProjectedPoints(),o=i?i.length:0,n=i?i[o-1]:null,a=o-2;return!this._tooFewPointsForIntersection(1)&&this._lineSegmentsIntersectsRange(n,t,a,e?1:0)},_tooFewPointsForIntersection:function(t){var e=this._getProjectedPoints(),i=e?e.length:0;return i+=t||0,!e||i<=3},_lineSegmentsIntersectsRange:function(t,e,i,o){var n,a,s=this._getProjectedPoints();o=o||0;for(var r=i;r>o;r--)if(n=s[r-1],a=s[r],L.LineUtil.segmentsIntersect(t,e,n,a))return!0;return!1},_getProjectedPoints:function(){if(!this._defaultShape)return this._originalPoints;for(var t=[],e=this._defaultShape(),i=0;i<e.length;i++)t.push(this._map.latLngToLayerPoint(e[i]));return t}}),L.Polygon.include({intersects:function(){var t,e,i,o,n=this._getProjectedPoints();return!this._tooFewPointsForIntersection()&&(!!L.Polyline.prototype.intersects.call(this)||(t=n.length,e=n[0],i=n[t-1],o=t-2,this._lineSegmentsIntersectsRange(i,e,o,1)))}}),L.Control.Draw=L.Control.extend({options:{position:"topleft",draw:{},edit:!1},initialize:function(t){if(L.version<"0.7")throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");L.Control.prototype.initialize.call(this,t);var e;this._toolbars={},L.DrawToolbar&&this.options.draw&&(e=new L.DrawToolbar(this.options.draw),this._toolbars[L.DrawToolbar.TYPE]=e,this._toolbars[L.DrawToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.EditToolbar&&this.options.edit&&(e=new L.EditToolbar(this.options.edit),this._toolbars[L.EditToolbar.TYPE]=e,this._toolbars[L.EditToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.toolbar=this},onAdd:function(t){var e,i=L.DomUtil.create("div","leaflet-draw"),o=!1;for(var n in this._toolbars)this._toolbars.hasOwnProperty(n)&&(e=this._toolbars[n].addToolbar(t))&&(o||(L.DomUtil.hasClass(e,"leaflet-draw-toolbar-top")||L.DomUtil.addClass(e.childNodes[0],"leaflet-draw-toolbar-top"),o=!0),i.appendChild(e));return i},onRemove:function(){for(var t in this._toolbars)this._toolbars.hasOwnProperty(t)&&this._toolbars[t].removeToolbar()},setDrawingOptions:function(t){for(var e in this._toolbars)this._toolbars[e]instanceof L.DrawToolbar&&this._toolbars[e].setOptions(t)},_toolbarEnabled:function(t){var e=t.target;for(var i in this._toolbars)this._toolbars[i]!==e&&this._toolbars[i].disable()}}),L.Map.mergeOptions({drawControlTooltips:!0,drawControl:!1}),L.Map.addInitHook(function(){this.options.drawControl&&(this.drawControl=new L.Control.Draw,this.addControl(this.drawControl))}),L.Toolbar=L.Class.extend({initialize:function(t){L.setOptions(this,t),this._modes={},this._actionButtons=[],this._activeMode=null;var e=L.version.split(".");1===parseInt(e[0],10)&&parseInt(e[1],10)>=2?L.Toolbar.include(L.Evented.prototype):L.Toolbar.include(L.Mixin.Events)},enabled:function(){return null!==this._activeMode},disable:function(){this.enabled()&&this._activeMode.handler.disable()},addToolbar:function(t){var e,i=L.DomUtil.create("div","leaflet-draw-section"),o=0,n=this._toolbarClass||"",a=this.getModeHandlers(t);for(this._toolbarContainer=L.DomUtil.create("div","leaflet-draw-toolbar leaflet-bar"),this._map=t,e=0;e<a.length;e++)a[e].enabled&&this._initModeHandler(a[e].handler,this._toolbarContainer,o++,n,a[e].title);if(o)return this._lastButtonIndex=--o,this._actionsContainer=L.DomUtil.create("ul","leaflet-draw-actions"),i.appendChild(this._toolbarContainer),i.appendChild(this._actionsContainer),i},removeToolbar:function(){for(var t in this._modes)this._modes.hasOwnProperty(t)&&(this._disposeButton(this._modes[t].button,this._modes[t].handler.enable,this._modes[t].handler),this._modes[t].handler.disable(),this._modes[t].handler.off("enabled",this._handlerActivated,this).off("disabled",this._handlerDeactivated,this));this._modes={};for(var e=0,i=this._actionButtons.length;e<i;e++)this._disposeButton(this._actionButtons[e].button,this._actionButtons[e].callback,this);this._actionButtons=[],this._actionsContainer=null},_initModeHandler:function(t,e,i,o,n){var a=t.type;this._modes[a]={},this._modes[a].handler=t,this._modes[a].button=this._createButton({type:a,title:n,className:o+"-"+a,container:e,callback:this._modes[a].handler.enable,context:this._modes[a].handler}),this._modes[a].buttonIndex=i,this._modes[a].handler.on("enabled",this._handlerActivated,this).on("disabled",this._handlerDeactivated,this)},_detectIOS:function(){return/iPad|iPhone|iPod/.test(navigator.userAgent)&&!t.MSStream},_createButton:function(t){var e=L.DomUtil.create("a",t.className||"",t.container),i=L.DomUtil.create("span","sr-only",t.container);e.href="#",e.appendChild(i),t.title&&(e.title=t.title,i.innerHTML=t.title),t.text&&(e.innerHTML=t.text,i.innerHTML=t.text);var o=this._detectIOS()?"touchstart":"click";return L.DomEvent.on(e,"click",L.DomEvent.stopPropagation).on(e,"mousedown",L.DomEvent.stopPropagation).on(e,"dblclick",L.DomEvent.stopPropagation).on(e,"touchstart",L.DomEvent.stopPropagation).on(e,"click",L.DomEvent.preventDefault).on(e,o,t.callback,t.context),e},_disposeButton:function(t,e){var i=this._detectIOS()?"touchstart":"click";L.DomEvent.off(t,"click",L.DomEvent.stopPropagation).off(t,"mousedown",L.DomEvent.stopPropagation).off(t,"dblclick",L.DomEvent.stopPropagation).off(t,"touchstart",L.DomEvent.stopPropagation).off(t,"click",L.DomEvent.preventDefault).off(t,i,e)},_handlerActivated:function(t){this.disable(),this._activeMode=this._modes[t.handler],L.DomUtil.addClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._showActionsToolbar(),this.fire("enable")},_handlerDeactivated:function(){this._hideActionsToolbar(),L.DomUtil.removeClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._activeMode=null,this.fire("disable")},_createActions:function(t){var e,i,o,n,a=this._actionsContainer,s=this.getActions(t),r=s.length;for(i=0,o=this._actionButtons.length;i<o;i++)this._disposeButton(this._actionButtons[i].button,this._actionButtons[i].callback);for(this._actionButtons=[];a.firstChild;)a.removeChild(a.firstChild);for(var l=0;l<r;l++)"enabled"in s[l]&&!s[l].enabled||(e=L.DomUtil.create("li","",a),n=this._createButton({title:s[l].title,text:s[l].text,container:e,callback:s[l].callback,context:s[l].context}),this._actionButtons.push({button:n,callback:s[l].callback}))},_showActionsToolbar:function(){var t=this._activeMode.buttonIndex,e=this._lastButtonIndex,i=this._activeMode.button.offsetTop-1;this._createActions(this._activeMode.handler),this._actionsContainer.style.top=i+"px",0===t&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-top")),t===e&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-bottom")),this._actionsContainer.style.display="block",this._map.fire(L.Draw.Event.TOOLBAROPENED)},_hideActionsToolbar:function(){this._actionsContainer.style.display="none",L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-top"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-bottom"),this._map.fire(L.Draw.Event.TOOLBARCLOSED)}}),L.Draw=L.Draw||{},L.Draw.Tooltip=L.Class.extend({initialize:function(t){this._map=t,this._popupPane=t._panes.popupPane,this._visible=!1,this._container=t.options.drawControlTooltips?L.DomUtil.create("div","leaflet-draw-tooltip",this._popupPane):null,this._singleLineLabel=!1,this._map.on("mouseout",this._onMouseOut,this)},dispose:function(){this._map.off("mouseout",this._onMouseOut,this),this._container&&(this._popupPane.removeChild(this._container),this._container=null)},updateContent:function(t){return this._container?(t.subtext=t.subtext||"",0!==t.subtext.length||this._singleLineLabel?t.subtext.length>0&&this._singleLineLabel&&(L.DomUtil.removeClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!1):(L.DomUtil.addClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!0),this._container.innerHTML=(t.subtext.length>0?'<span class="leaflet-draw-tooltip-subtext">'+t.subtext+"</span><br />":"")+"<span>"+t.text+"</span>",t.text||t.subtext?(this._visible=!0,this._container.style.visibility="inherit"):(this._visible=!1,this._container.style.visibility="hidden"),this):this},updatePosition:function(t){var e=this._map.latLngToLayerPoint(t),i=this._container;return this._container&&(this._visible&&(i.style.visibility="inherit"),L.DomUtil.setPosition(i,e)),this},showAsError:function(){return this._container&&L.DomUtil.addClass(this._container,"leaflet-error-draw-tooltip"),this},removeError:function(){return this._container&&L.DomUtil.removeClass(this._container,"leaflet-error-draw-tooltip"),this},_onMouseOut:function(){this._container&&(this._container.style.visibility="hidden")}}),L.DrawToolbar=L.Toolbar.extend({statics:{TYPE:"draw"},options:{polyline:{},polygon:{},rectangle:{},circle:{},marker:{},circlemarker:{}},initialize:function(t){for(var e in this.options)this.options.hasOwnProperty(e)&&t[e]&&(t[e]=L.extend({},this.options[e],t[e]));this._toolbarClass="leaflet-draw-draw",L.Toolbar.prototype.initialize.call(this,t)},getModeHandlers:function(t){return[{enabled:this.options.polyline,handler:new L.Draw.Polyline(t,this.options.polyline),title:L.drawLocal.draw.toolbar.buttons.polyline},{enabled:this.options.polygon,handler:new L.Draw.Polygon(t,this.options.polygon),title:L.drawLocal.draw.toolbar.buttons.polygon},{enabled:this.options.rectangle,handler:new L.Draw.Rectangle(t,this.options.rectangle),title:L.drawLocal.draw.toolbar.buttons.rectangle},{enabled:this.options.circle,handler:new L.Draw.Circle(t,this.options.circle),title:L.drawLocal.draw.toolbar.buttons.circle},{enabled:this.options.marker,handler:new L.Draw.Marker(t,this.options.marker),title:L.drawLocal.draw.toolbar.buttons.marker},{enabled:this.options.circlemarker,handler:new L.Draw.CircleMarker(t,this.options.circlemarker),title:L.drawLocal.draw.toolbar.buttons.circlemarker}]},getActions:function(t){return[{enabled:t.completeShape,title:L.drawLocal.draw.toolbar.finish.title,text:L.drawLocal.draw.toolbar.finish.text,callback:t.completeShape,context:t},{enabled:t.deleteLastVertex,title:L.drawLocal.draw.toolbar.undo.title,text:L.drawLocal.draw.toolbar.undo.text,callback:t.deleteLastVertex,context:t},{title:L.drawLocal.draw.toolbar.actions.title,text:L.drawLocal.draw.toolbar.actions.text,callback:this.disable,context:this}]},setOptions:function(t){L.setOptions(this,t);for(var e in this._modes)this._modes.hasOwnProperty(e)&&t.hasOwnProperty(e)&&this._modes[e].handler.setOptions(t[e])}}),L.EditToolbar=L.Toolbar.extend({statics:{TYPE:"edit"},options:{edit:{selectedPathOptions:{dashArray:"10, 10",fill:!0,fillColor:"#fe57a1",fillOpacity:.1,maintainColor:!1}},remove:{},poly:null,featureGroup:null},initialize:function(t){t.edit&&(void 0===t.edit.selectedPathOptions&&(t.edit.selectedPathOptions=this.options.edit.selectedPathOptions),t.edit.selectedPathOptions=L.extend({},this.options.edit.selectedPathOptions,t.edit.selectedPathOptions)),t.remove&&(t.remove=L.extend({},this.options.remove,t.remove)),t.poly&&(t.poly=L.extend({},this.options.poly,t.poly)),this._toolbarClass="leaflet-draw-edit",L.Toolbar.prototype.initialize.call(this,t),this._selectedFeatureCount=0},getModeHandlers:function(t){var e=this.options.featureGroup;return[{enabled:this.options.edit,handler:new L.EditToolbar.Edit(t,{featureGroup:e,selectedPathOptions:this.options.edit.selectedPathOptions,poly:this.options.poly}),title:L.drawLocal.edit.toolbar.buttons.edit},{enabled:this.options.remove,handler:new L.EditToolbar.Delete(t,{featureGroup:e}),title:L.drawLocal.edit.toolbar.buttons.remove}]},getActions:function(t){var e=[{title:L.drawLocal.edit.toolbar.actions.save.title,text:L.drawLocal.edit.toolbar.actions.save.text,callback:this._save,context:this},{title:L.drawLocal.edit.toolbar.actions.cancel.title,text:L.drawLocal.edit.toolbar.actions.cancel.text,callback:this.disable,context:this}];return t.removeAllLayers&&e.push({title:L.drawLocal.edit.toolbar.actions.clearAll.title,text:L.drawLocal.edit.toolbar.actions.clearAll.text,callback:this._clearAllLayers,context:this}),e},addToolbar:function(t){var e=L.Toolbar.prototype.addToolbar.call(this,t);return this._checkDisabled(),this.options.featureGroup.on("layeradd layerremove",this._checkDisabled,this),e},removeToolbar:function(){this.options.featureGroup.off("layeradd layerremove",this._checkDisabled,this),L.Toolbar.prototype.removeToolbar.call(this)},disable:function(){this.enabled()&&(this._activeMode.handler.revertLayers(),L.Toolbar.prototype.disable.call(this))},_save:function(){this._activeMode.handler.save(),this._activeMode&&this._activeMode.handler.disable()},_clearAllLayers:function(){this._activeMode.handler.removeAllLayers(),this._activeMode&&this._activeMode.handler.disable()},_checkDisabled:function(){var t,e=this.options.featureGroup,i=0!==e.getLayers().length;this.options.edit&&(t=this._modes[L.EditToolbar.Edit.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.edit:L.drawLocal.edit.toolbar.buttons.editDisabled)),this.options.remove&&(t=this._modes[L.EditToolbar.Delete.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.remove:L.drawLocal.edit.toolbar.buttons.removeDisabled))}}),L.EditToolbar.Edit=L.Handler.extend({statics:{TYPE:"edit"},initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.setOptions(this,e),this._featureGroup=e.featureGroup,!(this._featureGroup instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this._uneditedLayerProps={},this.type=L.EditToolbar.Edit.TYPE;var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.EditToolbar.Edit.include(L.Evented.prototype):L.EditToolbar.Edit.include(L.Mixin.Events)},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.EDITSTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._featureGroup.on("layeradd",this._enableLayerEdit,this).on("layerremove",this._disableLayerEdit,this))},disable:function(){this._enabled&&(this._featureGroup.off("layeradd",this._enableLayerEdit,this).off("layerremove",this._disableLayerEdit,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.EDITSTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._featureGroup.eachLayer(this._enableLayerEdit,this),this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}),t._editTooltip=this._tooltip,this._updateTooltip(),this._map.on("mousemove",this._onMouseMove,this).on("touchmove",this._onMouseMove,this).on("MSPointerMove",this._onMouseMove,this).on(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},removeHooks:function(){this._map&&(this._featureGroup.eachLayer(this._disableLayerEdit,this),this._uneditedLayerProps={},this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this).off("touchmove",this._onMouseMove,this).off("MSPointerMove",this._onMouseMove,this).off(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},revertLayers:function(){this._featureGroup.eachLayer(function(t){this._revertLayer(t)},this)},save:function(){var t=new L.LayerGroup;this._featureGroup.eachLayer(function(e){e.edited&&(t.addLayer(e),e.edited=!1)}),this._map.fire(L.Draw.Event.EDITED,{layers:t})},_backupLayer:function(t){var e=L.Util.stamp(t);this._uneditedLayerProps[e]||(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?this._uneditedLayerProps[e]={latlngs:L.LatLngUtil.cloneLatLngs(t.getLatLngs())}:t instanceof L.Circle?this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng()),radius:t.getRadius()}:(t instanceof L.Marker||t instanceof L.CircleMarker)&&(this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng())}))},_getTooltipText:function(){return{text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}},_updateTooltip:function(){this._tooltip.updateContent(this._getTooltipText())},_revertLayer:function(t){var e=L.Util.stamp(t);t.edited=!1,this._uneditedLayerProps.hasOwnProperty(e)&&(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?t.setLatLngs(this._uneditedLayerProps[e].latlngs):t instanceof L.Circle?(t.setLatLng(this._uneditedLayerProps[e].latlng),t.setRadius(this._uneditedLayerProps[e].radius)):(t instanceof L.Marker||t instanceof L.CircleMarker)&&t.setLatLng(this._uneditedLayerProps[e].latlng),t.fire("revert-edited",{layer:t}))},_enableLayerEdit:function(t){var e,i,o=t.layer||t.target||t;this._backupLayer(o),this.options.poly&&(i=L.Util.extend({},this.options.poly),o.options.poly=i),this.options.selectedPathOptions&&(e=L.Util.extend({},this.options.selectedPathOptions),e.maintainColor&&(e.color=o.options.color,e.fillColor=o.options.fillColor),o.options.original=L.extend({},o.options),o.options.editing=e),o instanceof L.Marker?(o.editing&&o.editing.enable(),o.dragging.enable(),o.on("dragend",this._onMarkerDragEnd).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onMarkerDragEnd,this).on("MSPointerUp",this._onMarkerDragEnd,this)):o.editing.enable()},_disableLayerEdit:function(t){var e=t.layer||t.target||t;e.edited=!1,e.editing&&e.editing.disable(),delete e.options.editing,delete e.options.original,this._selectedPathOptions&&(e instanceof L.Marker?this._toggleMarkerHighlight(e):(e.setStyle(e.options.previousOptions),delete e.options.previousOptions)),e instanceof L.Marker?(e.dragging.disable(),e.off("dragend",this._onMarkerDragEnd,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onMarkerDragEnd,this).off("MSPointerUp",this._onMarkerDragEnd,this)):e.editing.disable()},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_onMarkerDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_onTouchMove:function(t){var e=t.originalEvent.changedTouches[0],i=this._map.mouseEventToLayerPoint(e),o=this._map.layerPointToLatLng(i);t.target.setLatLng(o)},_hasAvailableLayers:function(){return 0!==this._featureGroup.getLayers().length}}),
L.EditToolbar.Delete=L.Handler.extend({statics:{TYPE:"remove"},initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.Util.setOptions(this,e),this._deletableLayers=this.options.featureGroup,!(this._deletableLayers instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this.type=L.EditToolbar.Delete.TYPE;var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.EditToolbar.Delete.include(L.Evented.prototype):L.EditToolbar.Delete.include(L.Mixin.Events)},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DELETESTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._deletableLayers.on("layeradd",this._enableLayerDelete,this).on("layerremove",this._disableLayerDelete,this))},disable:function(){this._enabled&&(this._deletableLayers.off("layeradd",this._enableLayerDelete,this).off("layerremove",this._disableLayerDelete,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DELETESTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._deletableLayers.eachLayer(this._enableLayerDelete,this),this._deletedLayers=new L.LayerGroup,this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.remove.tooltip.text}),this._map.on("mousemove",this._onMouseMove,this))},removeHooks:function(){this._map&&(this._deletableLayers.eachLayer(this._disableLayerDelete,this),this._deletedLayers=null,this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this))},revertLayers:function(){this._deletedLayers.eachLayer(function(t){this._deletableLayers.addLayer(t),t.fire("revert-deleted",{layer:t})},this)},save:function(){this._map.fire(L.Draw.Event.DELETED,{layers:this._deletedLayers})},removeAllLayers:function(){this._deletableLayers.eachLayer(function(t){this._removeLayer({layer:t})},this),this.save()},_enableLayerDelete:function(t){(t.layer||t.target||t).on("click",this._removeLayer,this)},_disableLayerDelete:function(t){var e=t.layer||t.target||t;e.off("click",this._removeLayer,this),this._deletedLayers.removeLayer(e)},_removeLayer:function(t){var e=t.layer||t.target||t;this._deletableLayers.removeLayer(e),this._deletedLayers.addLayer(e),e.fire("deleted")},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_hasAvailableLayers:function(){return 0!==this._deletableLayers.getLayers().length}})}(window,document);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY H:mm',
        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(6)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(887);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(104);

var invariant = __webpack_require__(13);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(124);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(59);

var quoteAttributeValueForBrowser = __webpack_require__(950);
var warning = __webpack_require__(20);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var LinkedValueUtils = __webpack_require__(248);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(66);

var warning = __webpack_require__(20);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(910);

var containsNode = __webpack_require__(858);
var focusNode = __webpack_require__(341);
var getActiveElement = __webpack_require__(342);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var DOMLazyTree = __webpack_require__(123);
var DOMProperty = __webpack_require__(124);
var React = __webpack_require__(126);
var ReactBrowserEventEmitter = __webpack_require__(185);
var ReactCurrentOwner = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMContainerInfo = __webpack_require__(904);
var ReactDOMFeatureFlags = __webpack_require__(906);
var ReactFeatureFlags = __webpack_require__(473);
var ReactInstanceMap = __webpack_require__(146);
var ReactInstrumentation = __webpack_require__(59);
var ReactMarkupChecksum = __webpack_require__(920);
var ReactReconciler = __webpack_require__(125);
var ReactUpdateQueue = __webpack_require__(251);
var ReactUpdates = __webpack_require__(66);

var emptyObject = __webpack_require__(183);
var instantiateReactComponent = __webpack_require__(484);
var invariant = __webpack_require__(13);
var setInnerHTML = __webpack_require__(189);
var shouldUpdateReactComponent = __webpack_require__(257);
var warning = __webpack_require__(20);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var React = __webpack_require__(126);

var invariant = __webpack_require__(13);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(477);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(33);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var ReactCompositeComponent = __webpack_require__(901);
var ReactEmptyComponent = __webpack_require__(472);
var ReactHostComponent = __webpack_require__(474);

var getNextDebugID = __webpack_require__(960);
var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);
var escapeTextContentForBrowser = __webpack_require__(188);
var setInnerHTML = __webpack_require__(189);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(76);
var REACT_ELEMENT_TYPE = __webpack_require__(916);

var getIteratorFn = __webpack_require__(947);
var invariant = __webpack_require__(13);
var KeyEscapeUtils = __webpack_require__(247);
var warning = __webpack_require__(20);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(148),
    _assign = __webpack_require__(28);

var ReactNoopUpdateQueue = __webpack_require__(491);

var canDefineProperty = __webpack_require__(492);
var emptyObject = __webpack_require__(183);
var invariant = __webpack_require__(13);
var lowPriorityWarning = __webpack_require__(961);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(148);

var ReactCurrentOwner = __webpack_require__(76);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(20);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(964);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonScheduleRules = void 0;
var ScheduleDateType_1 = __webpack_require__(80);
var scheduleChangeEngine_1 = __webpack_require__(190);
var scheduleConstants_1 = __webpack_require__(191);
var commonScheduleRules = function (pc) { return __spreadArrays(ipArrivalBeforeDeparture(pc), preserveMovementSequence(pc), pjoStartMatchesIPDeparture(pc), pjoEndMatchesIPArrival(pc), portArrivalPointHasNoDuration(pc), portDeparturePointHasNoDuration(pc)); };
exports.commonScheduleRules = commonScheduleRules;
var getPJO = function (date) { var _a, _b; return (_b = (_a = date.JobOrder()) === null || _a === void 0 ? void 0 : _a.PilotJobOrder()) !== null && _b !== void 0 ? _b : null; }, isPortArrival = function (date) { var _a, _b; return date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival && ((_b = (_a = date.ItineraryPoint()) === null || _a === void 0 ? void 0 : _a.IsPortArrival()) !== null && _b !== void 0 ? _b : false); }, isPortDeparture = function (date) { var _a, _b; return date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture && ((_b = (_a = date.ItineraryPoint()) === null || _a === void 0 ? void 0 : _a.IsPortDeparture()) !== null && _b !== void 0 ? _b : false); }, ipArrivalBeforeDeparture = function (pc) {
    return pc.Itinerary().map(function (ip) {
        return ip.ArrivalEntity() &&
            ip.DepartureEntity() &&
            new scheduleChangeEngine_1.ScheduleRule(ip.ArrivalEntity(), scheduleChangeEngine_1.ScheduleRel.LEq, ip.DepartureEntity(), ip.BerthReservation() ? scheduleConstants_1.MINIMUM_RES_DURATION_MINS * 60 * 1000 : 0);
    });
}, preserveMovementSequence = function (pc) {
    return pc.MovementSeries().map(function (ip, i, ips) {
        var _a, _b, _c, _d;
        return (i > 0 || null) && // skips first ip
            ip.ArrivalEntity() &&
            ips[i - 1].DepartureEntity() &&
            new scheduleChangeEngine_1.ScheduleRule(ips[i - 1].DepartureEntity(), scheduleChangeEngine_1.ScheduleRel.LEq, ip.ArrivalEntity(), ((_a = ip.Location()) === null || _a === void 0 ? void 0 : _a.Berth()) && ((_b = ips[i - 1].Location()) === null || _b === void 0 ? void 0 : _b.Berth()) ?
                // Both IPs at a berth, i.e. this is a shift. Do piergroups match?
                ip.Location().Berth().PierGroupId() === ((_d = (_c = ips[i - 1].Location()) === null || _c === void 0 ? void 0 : _c.Berth()) === null || _d === void 0 ? void 0 : _d.PierGroupId()) ?
                    // Yes, piergroups match. Use same piergroup transit duration.
                    scheduleConstants_1.SAME_PIERGROUP_TRANSIT_MINS * 60 * 1000 :
                    // No, piergroups don't match. Use different piergroup transit duration.
                    // TODO: Is this too strict? We're saying shifts btwn piergroups must take at least this
                    // duration, and this rule isn't some default, it's a rule that our linear constraint
                    // solver will try to preserve at all times. Do we want zero here for max flexibility to
                    // the user? Also, remember that a "shift" can also mean the in (or out) movement from
                    // (or to) an anchorage and that some berth mgrs like to have their BerthTransitOffsets
                    // set to zero, which presumbably means they'd prefer to model the time from (or to) the
                    // anchorage as zero too.
                    scheduleConstants_1.DIFFERENT_PIERGROUP_TRANSIT_MINS * 60 * 1000 :
                // At least one IP isn't at a berth, e.g. this is the initial movement in from the pilot station.
                // Allow a min of zero, as we have some installations where many berth managers set all their
                // BerthTransitOffsets to zero (they don't care about representing that initial transit time).
                0);
    });
}, pjoStartMatchesIPDeparture = function (pc) {
    return pc.Schedule().filter(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.PJOStart; }).map(function (pjoStart) {
        var _a, _b;
        var ipDeparture = (_b = (_a = getPJO(pjoStart)) === null || _a === void 0 ? void 0 : _a.FromPoint()) === null || _b === void 0 ? void 0 : _b.DepartureEntity();
        return ipDeparture && new scheduleChangeEngine_1.ScheduleRule(ipDeparture, scheduleChangeEngine_1.ScheduleRel.Eq, pjoStart);
    });
}, pjoEndMatchesIPArrival = function (pc) {
    return pc.Schedule().filter(function (d) { return d.Type() === ScheduleDateType_1.ScheduleDateType.PJOEnd; }).map(function (pjoEnd) {
        var _a, _b;
        var ipArrival = (_b = (_a = getPJO(pjoEnd)) === null || _a === void 0 ? void 0 : _a.ToPoint()) === null || _b === void 0 ? void 0 : _b.ArrivalEntity();
        return ipArrival && new scheduleChangeEngine_1.ScheduleRule(ipArrival, scheduleChangeEngine_1.ScheduleRel.Eq, pjoEnd);
    });
}, portArrivalPointHasNoDuration = function (pc) {
    return pc.Schedule().filter(isPortArrival).map(function (arr) {
        var dep = arr.ItineraryPoint().DepartureEntity();
        return dep && new scheduleChangeEngine_1.ScheduleRule(arr, scheduleChangeEngine_1.ScheduleRel.Eq, dep);
    });
}, portDeparturePointHasNoDuration = function (pc) {
    return pc.Schedule().filter(isPortDeparture).map(function (dep) {
        var arr = dep.ItineraryPoint().ArrivalEntity();
        return arr && new scheduleChangeEngine_1.ScheduleRule(arr, scheduleChangeEngine_1.ScheduleRel.Eq, dep);
    });
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleMapper = void 0;
var s_js_1 = __webpack_require__(0);
var PCRoles_1 = __webpack_require__(286);
// roles that are soft implied by virtue of having another role
var implies = {};
// TH: No implied roles currently.
// roles that are hard materialized by virtue of having another role
var materializes = {};
materializes[PCRoles_1.PCRoles.ManageBerths] = [PCRoles_1.PCRoles.ReserveBerths];
/*
    * RoleMapper class.
    *
    * A utility for mapping materialized/implied roles. Represents the roles possessed by an
    * individual user (so you construct one of these per user). Understands two kinds of
    * inference btwn roles:
    *
    *   implies -- role A implies role B if possessing A enables all of the functional effects
    *              of possessing B, whether or not a row for B exists for this user in the Db.
    *              I.e., implication is checked in the UserRights layer, not materialized in the
    *              Db.
    *
    *   materializes -- role A materializes role B if every time we add role B to a given user
    *                   we should also add role B. This means a row for each role should be
    *                   created for this user in the Db.
    *                   I.e. materialization is materialized in the Db and NOT checked in the
    *                   UserRights layer.
    *
    *
    * Constructor
    *
    *   RoleMapper(assignedRoles, roleIdsByName)
    *
    *     assignedRoles -- an observable array of role ids assigned to a particular user.
    *                      Corresponds to the roles actually materialized in Db for that user.
    *                      Can contain an initial set of roles possessed by the user.
    *                      Values in the array should be JS ints (not role objects or
    *                      observable ints).
    *                      Can be a KO observable array, or any array-valued observable (like
    *                      the result of calling observableArray.map())
    *
    *     roleIdsByName -- a dictionary mapping camel-case role names (e.g. 'SiteAdmin', 'ManageUsers')
    *                      to the Db Ids for those roles. Property values can be plain JS ints
    *                      or observable ints.
    *
    * Methods
    *
    *   HasOrImplies(id) -- do the current assigned roles contain or imply the given role id?
    *
    *     id -- the role id. A plain JS int or an observable int.
    *
    *     returns -- a computed observable with a boolean value
    *
    *
    *   ImpliesOrMaterializes(id) -- do the current assigned roles imply or materialize the given
    *                                role
    *
    *     id -- the role id. A plain JS int or an observable int.
    *
    *     returns -- a compute observable with a boolean value
    *
    *     NOTE: Tests STRICTLY whether any of the assigned roles implies or materializes the given
    *     role. Observable will evaluate to false if the assigned roles only contain the given role.
    *
    *
    *   ToggleRole(addRole, removeRole, id) -- produce a function that toggles the state of given role
    *
    *     addRole -- a callback to add a role. Takes the int id of the role to be added.
    *
    *     removeRole -- a callback to remove a role. Takes the int id of the role to be removed.
    *
    *     id -- the role id. A plain JS int or an observable int.
    *
    *     returns -- a function to be used with KO's click binding.
    *
    *     NOTE: ToggleRole takes care of figuring out materializes and implies relationships so
    *     that addRole and removeRole are called for exactly the roles that need to be turned
    *     on and off.
    *     So your addRole and removeRole implementations just need the logic for
    *     turning on or off an individual role. E.g. should the change be written to the Db
    *     immediately, or should it be stored in an array to be written to the Db as a group
    *     later?
    */
function RoleMapper(assignedRoles) {
    return {
        HasOrImpliesRole: function (id) {
            return assignedRoles().some(function (roleId) { return roleId === id || (implies[roleId] || []).indexOf(id) >= 0; });
        },
        ImpliesOrMaterializesRole: function (id) {
            return assignedRoles().some(function (roleId) { return (implies[roleId] || []).indexOf(id) >= 0 || (materializes[roleId] || []).indexOf(id) >= 0; });
        },
        ToggleRole: function (addRole, removeRole, id) {
            var _assigned = s_js_1.default.sample(assignedRoles), hasRole = _assigned.indexOf(id) >= 0, materializedOrSame = [id].concat(materializes[id] || []), impliedRoles = implies[id] || [];
            // removing a role removes all of its materialized roles
            // adding a role adds all of its materialized roles (provided they aren't already added)
            for (var i = 0; i < materializedOrSame.length; i++) {
                var role = materializedOrSame[i];
                if (hasRole)
                    removeRole(role);
                else if (role === id || _assigned.indexOf(role) === -1)
                    addRole(role);
            }
            // adding a role REMOVES all of its implied roles
            // removing a role has no effect on implied roles
            for (var i = 0; i < impliedRoles.length; i++) {
                var role = impliedRoles[i];
                if (!hasRole && _assigned.indexOf(role) >= 0)
                    removeRole(role);
            }
        }
    };
}
exports.RoleMapper = RoleMapper;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchEventDetailsView = exports.DispatchEventDetailsBody = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(266);
var view_2 = __webpack_require__(60);
var view_3 = __webpack_require__(35);
var view_4 = __webpack_require__(29);
exports.DispatchEventDetailsBody = supercritical_1.default(function (_a) {
    var event = _a.event, canEdit = _a.canEdit, validation = _a.validation, localization = _a.localization;
    return React.createElement("div", { className: "dispatch-evt-details-body" },
        React.createElement("div", { className: "dispatch-evt-start" },
            React.createElement("span", { className: "dispatch-evt-field-label pc-text-label-color" }, "Start"),
            React.createElement(view_2.DateTimePicker, { value: event.Start, disabled: !canEdit(), localization: localization })),
        React.createElement("div", { className: "dispatch-evt-descr" },
            React.createElement("span", { className: "dispatch-evt-field-label pc-text-label-color" }, "Description"),
            React.createElement("div", { className: "dispatch-evt-descr-content" },
                canEdit() ?
                    React.createElement("textarea", { className: "descr-edit-mode", value: event.Description(), onChange: function (e) { return event.Description(e.currentTarget.value); } }) :
                    React.createElement("div", { className: "descr-view-mode" }, event.Description()),
                React.createElement(view_4.ValidationErrorView, { error: function () { return validation()['Description']; } }))));
});
exports.DispatchEventDetailsView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    if (!m)
        return null;
    return (React.createElement("div", { className: "dispatcheventdetails pc-card" },
        React.createElement("div", { className: "details-content" },
            React.createElement("div", { className: "details-header pc-card-header" },
                React.createElement("div", { className: "dispatch-evt-actions-container" },
                    m.CanEdit() &&
                        React.createElement("button", { className: "dispatch-evt-actions-menu-btn fa fa-bars", onClick: m.ToggleActionsMenu }),
                    m.ShowActionsMenu() &&
                        React.createElement(view_3.PCDismissible, { className: "dispatch-evt-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
                            React.createElement("div", { className: "dispatch-evt-actions-menu-item" },
                                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.ShowDeleteConfirmation) }, "Delete Event")))),
                m.DeleteConfirmationVisible() &&
                    React.createElement("div", { className: "dispatch-evt-delete-conf" },
                        React.createElement("span", null, "Are you sure?"),
                        ' ',
                        React.createElement("a", { href: "", className: "dispatch-evt-delete-conf-yes", onClick: eventWrappers_1.noDefault(m.Model.Delete) }, "Yes"),
                        ' ',
                        React.createElement("a", { href: "", className: "dispatch-evt-delete-conf-no", onClick: eventWrappers_1.noDefault(function () { return m.DeleteConfirmationVisible(false); }) }, "No")),
                React.createElement("div", { className: "details-title pc-card-title" }, "Event")),
            React.createElement(exports.DispatchEventDetailsBody, { event: m.Model.Model, canEdit: m.CanEdit, validation: m.Model.Validation, localization: m.Localization }),
            m.CanManageBills() &&
                React.createElement("div", null,
                    React.createElement(view_1.BillExportSettingsView, { model: m.BillExportSettings }),
                    React.createElement(BillAttributesView, { model: m })))));
});
var BillAttributesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Bill() ?
        React.createElement("div", { className: "dispatch-event-bill-attributes" },
            React.createElement("span", { className: "attribute-label pc-text-billing-label" }, "Invoice Date:"),
            React.createElement("span", { className: "attribute-value" }, tzmoment_1.tzmoment(m.Bill().InvoiceDate()).format('M/D/YY')),
            React.createElement("span", { className: "attribute-label pc-text-billing-label" }, "Invoice Number:"),
            React.createElement("span", { className: "attribute-value" }, m.Bill().InvoiceNumber())) : null;
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateHeaderView = exports.DispatchDashboardView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var tzmoment_1 = __webpack_require__(9);
var DispatchDashboardTab_1 = __webpack_require__(207);
var model_1 = __webpack_require__(262);
var adddispatcheventview_1 = __webpack_require__(979);
var addpilotjoborderview_1 = __webpack_require__(981);
var dispatcheventdetailsview_1 = __webpack_require__(497);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(128);
var view_3 = __webpack_require__(105);
var view_4 = __webpack_require__(40);
var view_5 = __webpack_require__(35);
var view_6 = __webpack_require__(22);
var view_7 = __webpack_require__(52);
var view_8 = __webpack_require__(500);
var view_9 = __webpack_require__(998);
var view_10 = __webpack_require__(68);
function getStickyHeaderFudgeFactor(_a, tab) {
    var screenWidth = _a.screenWidth, availWidth = _a.availWidth;
    var STICKY_DAY_HEADER_FUDGE_FACTOR_MAIN_1 = 123, STICKY_DAY_HEADER_FUDGE_FACTOR_MAIN_2 = 158, STICKY_DAY_HEADER_FUDGE_FACTOR_MOBILE_1 = 90, STICKY_DAY_HEADER_FUDGE_FACTOR_MOBILE_2 = 158, MOBILE_THRESHOLD = 768;
    //MOBILE_THRESHOLD = @screen-size-tab-md;
    if (screenWidth <= MOBILE_THRESHOLD || availWidth <= MOBILE_THRESHOLD) {
        if (tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist)
            return STICKY_DAY_HEADER_FUDGE_FACTOR_MOBILE_2;
        return STICKY_DAY_HEADER_FUDGE_FACTOR_MOBILE_1;
    }
    else if (tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist)
        return STICKY_DAY_HEADER_FUDGE_FACTOR_MAIN_2;
    return STICKY_DAY_HEADER_FUDGE_FACTOR_MAIN_1;
}
;
exports.DispatchDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('dispatchdashboard', {
            'allow-full-page-take-over': m.AllowFullPageTakeOver()
        }) },
        m.Model().Navbar() &&
            React.createElement(view_8.PilotsHeaderView, { selectedTab: m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.New ? 0 /* New */ :
                    (m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist) ? 2 /* Search */ :
                        1 /* Movements */, title: "Dispatch Dashboard", model: m.Model().Navbar() }),
        React.createElement(SecondaryPageTitle, { model: m }),
        React.createElement(PageControlBar, { model: m }),
        React.createElement(InvalidSearchMsg, { model: m }),
        React.createElement(view_4.PageLoadingIndicator, { loading: m.ModelLoading }),
        React.createElement(PageBody, { model: m }),
        React.createElement(ActionsMenu, { model: m }),
        (m.SelectedItemKey() && m.SelectedItemKey().pjoId || m.SelectedDispatchEvent()) &&
            React.createElement("div", { className: "details-backdrop", onClick: function () { return m.SelectedItemKey(null); } }),
        React.createElement("div", { className: "pjo-container" },
            React.createElement(view_9.PilotJobOrderDetailsView, { modelContainer: m.PilotJobOrderDetails })),
        React.createElement("div", { className: "dispatch-evt-container" },
            React.createElement(dispatcheventdetailsview_1.DispatchEventDetailsView, { modelContainer: m.SelectedDispatchEvent })),
        React.createElement(adddispatcheventview_1.AddDispatchEventView, { modelContainer: m.AddDispatchEvent }),
        React.createElement(addpilotjoborderview_1.AddPilotJobOrderView, { modelContainer: m.AddPilotJobOrder }),
        React.createElement(view_9.PilotJobOrderDetailsPopupViews, { modelContainer: m.PilotJobOrderDetails }));
});
var SecondaryPageTitle = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "secondary-page-title" },
        React.createElement("div", { className: "title-main" }, m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ? 'Billing Worklist' : ''),
        React.createElement("div", { className: "title-sub" }, m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist &&
            React.createElement("a", { href: m.BackToFullSearchLink() }, "View All")));
});
var PageControlBar = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('pc-actions-links-header control-bar', {
            'secondary-page-title-positioning': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist,
            'pc-search-mobile': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist
        }) },
        m.Filter &&
            React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter By \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); }, onKeyUp: function (e) { return e.key === 'Enter' ? m.UpdateModelKey() : function () { }; } }),
        m.DateRangeSelector && React.createElement(view_2.DateRangeSelectorView, { model: m.DateRangeSelector }),
        (m.Filter || m.DateRangeSelector) && React.createElement(SearchButton, { model: m }),
        React.createElement(view_1.ActionsMenuButton, { onClick: m.ToggleActionsMenu }));
});
var SearchButton = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("button", { className: "pc-button search-button", disabled: m.ModelLoading(), onClick: m.UpdateModelKey }, m.ModelLoading() ? 'Searching...' : m.ModelKeyDirty() ? 'Search' : 'Refresh');
});
var InvalidSearchMsg = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_6.PCModal, { className: "invalid-search-msg", shown: m.ShowInvalidSearchMsg, onBackDropClick: function () { return m === null || m === void 0 ? void 0 : m.ShowInvalidSearchMsg(false); } },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", null, "The search parameters you've entered may overload your browser. Please enter a longer text filter or reduce the date range to 1 year or less."),
            React.createElement("div", { className: "controls" },
                React.createElement("button", { className: "pc-button", onClick: function () { return m.ShowInvalidSearchMsg(false); } }, "OK"))));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_5.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return m.ShowActionsMenu(false); } },
                m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements && m.Model().CanReserveBerths() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "#!addportcall" }, "Add PortCall")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Create a new PortCall.")),
                m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements && m.Model().CanAddPilotJobOrders() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(m.ShowAddPilotJobOrderModal)) }, "Add Pilot Order")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Add Pilot Orders to movements from existing PortCalls. View movements without pilot orders.")),
                m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements && m.Model().CanManageDispatchEvents() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.ShowAddDispatchEventModal(true); })) }, "Add Event")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Add an Event to the Dispatch Dashboard.")),
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(m.PrintPage)) }, "Print Schedule")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Use the browser menu to print all movements in this view.")),
                (m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist) &&
                    m.Model().CanExportSchedule() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement(CSVExportLink, { model: m, onClick: m.MenuAction(function () { }) }, "Export to CSV")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Save to a CSV file for Excel.")),
                m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(m.PrintRollingWindow)) },
                                "Print Next ",
                                model_1.ROLLING_EXPORT_HOURS,
                                " Hours")),
                        React.createElement("div", { className: "pc-action-item-descr" },
                            "Use the browser menu to print the schedule for the next ",
                            model_1.ROLLING_EXPORT_HOURS,
                            " hours.")),
                m.Model().CanManageBills() &&
                    React.createElement("div", null,
                        React.createElement("div", { className: "pc-admin-separator pc-card-admin-title" },
                            "Pilot Billing ",
                            React.createElement("div", { className: "pc-admin-line" })),
                        m.Tab !== DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist &&
                            React.createElement("div", { className: "action-item" },
                                React.createElement("div", null,
                                    React.createElement("a", { href: m.ViewBillingWorklistLink() }, "View Billing Worklist")),
                                React.createElement("div", { className: "pc-action-item-descr" }, "View and approve movements and events that are ready to export.")),
                        m.BillingSystem() &&
                            React.createElement("div", { className: "action-item" },
                                React.createElement("div", null,
                                    React.createElement("a", { href: '#!pendingexports?id=' + m.BillingSystem().Id() }, "View Pending Exports")),
                                React.createElement("div", { className: "pc-action-item-descr" }, "Export approved bills to an external file."))))) : null;
});
var CSVExportLink = supercritical_1.default(function (_a) {
    var m = _a.model, onClick = _a.onClick, children = _a.children;
    return React.createElement(view_3.DownloadDataLink, { className: "csv-export-link", data: m.CSVData, filename: "movements.csv", onClick: onClick }, children);
});
var PageBody = /** @class */ (function (_super) {
    __extends(PageBody, _super);
    function PageBody(props) {
        var _this = _super.call(this, props) || this;
        _this.recalcStickyHeaders = s_js_1.default.data(null);
        var recalcStickyHeadersQueued = false;
        var recalcStickyHeadersAsync = function () {
            if (recalcStickyHeadersQueued)
                return;
            recalcStickyHeadersQueued = true;
            // TH 03/31/2017 -- setTimeout instead of requestAnimationFrame for smoother scroll performance
            setTimeout(function () {
                recalcStickyHeadersQueued = false;
                _this.recalcStickyHeaders(null);
            }, 300);
        };
        _this.deviceSize = s_js_1.default.data(_this.getDeviceSize());
        _this.ref = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            // TH 01/24/2017 -- We need to recalc sticky headers whenever we do anything
            // that affects the overall page height or the height of any DashboardDayView elements.
            // We do this by subscribing to our viewmodel signals and triggering a recalc async.
            // That way the DOM gets a chance to update before we recalc.
            // Currently, each recalc involves visiting every DashboardDayView and checking its positioning.
            // In theory, we could optimize this to visit as few DashboardDayViews as possible.
            // But that'd involve more bookkeeping, and so far I haven't found much performance improvement.
            var m = _a.model;
            s_js_1.default(function () {
                // Recalc headers when the collection of days changes...
                m.Days();
                recalcStickyHeadersAsync();
            });
            m.Days.map(function (day) {
                s_js_1.default(function () {
                    // Recalc whenever the collection of dashboard items changes...
                    day.DashboardItems();
                    recalcStickyHeadersAsync();
                });
                day.DashboardItems.map(function (item) {
                    if (item.ItemType === 'PJO') {
                        // Recalc whenever we hide/show a PilotJobOrderRemarksRow element.
                        item.RemarksVisible();
                        recalcStickyHeadersAsync();
                    }
                });
            });
            var refreshDeviceSize = function () { return _this.deviceSize(_this.getDeviceSize()); };
            // TH 01/24/2017 -- Also recalc anytime window scrolls or resizes...
            window.addEventListener('scroll', recalcStickyHeadersAsync);
            window.addEventListener('resize', recalcStickyHeadersAsync);
            window.addEventListener('resize', refreshDeviceSize);
            s_js_1.default.cleanup(function () {
                window.removeEventListener('scroll', recalcStickyHeadersAsync);
                window.removeEventListener('resize', recalcStickyHeadersAsync);
                window.removeEventListener('resize', refreshDeviceSize);
            });
        });
        return _this;
    }
    PageBody.prototype.srender = function (_a) {
        var _this = this;
        var m = _a.model;
        return (React.createElement("div", { className: cx('page-body', {
                'pc-search-mobile': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Search || m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist,
                'tab-new': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.New,
                'tab-movements': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Movements,
                'tab-search': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.Search,
                'tab-billing': m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist
            }), ref: this.ref },
            m.Days().map(function (day) {
                return React.createElement(DashboardDayView, { model: m, day: day, recalcStickyHeaders: _this.recalcStickyHeaders, deviceSize: _this.deviceSize, key: day.Date });
            }),
            React.createElement(LargeResultSetMessage, { model: m })));
    };
    PageBody.prototype.getDeviceSize = function () {
        return {
            screenWidth: window.innerWidth,
            availWidth: window.screen.availWidth
        };
    };
    return PageBody;
}(supercritical_1.SuperCriticalComponent));
var DashboardDayView = /** @class */ (function (_super) {
    __extends(DashboardDayView, _super);
    function DashboardDayView(props) {
        var _this = _super.call(this, props) || this;
        _this.stickyHeader = s_js_1.default.data(false);
        _this.monitorRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var m = _a.model, recalcStickyHeaders = _a.recalcStickyHeaders, day = _a.day, deviceSize = _a.deviceSize;
            recalcStickyHeaders(); // subscribe to the recalc trigger
            if (el.offsetTop < window.scrollY + getStickyHeaderFudgeFactor(deviceSize(), m.Tab)) {
                _this.stickyHeader(true);
            }
            else {
                _this.stickyHeader(false);
            }
        });
        return _this;
    }
    DashboardDayView.prototype.srender = function (_a) {
        var m = _a.model, day = _a.day, deviceSize = _a.deviceSize;
        return (React.createElement("div", { className: cx('dashboard-day', {
                'sticky-day-header': this.stickyHeader()
            }) },
            React.createElement("div", { className: "header-scroll-monitor", ref: this.monitorRef }),
            React.createElement(DashboardDayHeader, { day: day, stickyHeader: this.stickyHeader(), deviceSize: deviceSize, tab: m.Tab }),
            React.createElement("div", { className: "day-spacing" }),
            React.createElement(DashboardDayTable, { model: m, day: day })));
    };
    return DashboardDayView;
}(supercritical_1.SuperCriticalComponent));
exports.DateHeaderView = supercritical_1.default(function (_a) {
    var m = _a.moment, style = _a.style;
    return React.createElement("div", { className: "day-header", style: style },
        React.createElement("span", { className: "month" }, m.format('MMMM')),
        ' ',
        React.createElement("span", { className: "date" }, m.format('DD')),
        ' ',
        React.createElement("span", { className: "year" }, m.format('YYYY')),
        ' ',
        React.createElement("span", { className: "pipe" }, "\u00A0|\u00A0"),
        ' ',
        React.createElement("span", { className: "day-of-week" }, m.format('dddd')));
});
var DashboardDayHeader = supercritical_1.default(function (_a) {
    var day = _a.day, stickyHeader = _a.stickyHeader, deviceSize = _a.deviceSize, tab = _a.tab;
    return React.createElement(exports.DateHeaderView, { moment: day.DateMoment, style: { top: stickyHeader ? getStickyHeaderFudgeFactor(deviceSize(), tab) + 'px' : '' } });
});
var DashboardDayTable = supercritical_1.default(function (_a) {
    var day = _a.day, m = _a.model;
    return React.createElement("table", { className: "pilot-job-orders" },
        React.createElement(DashboardDayTableHeader, { model: m }),
        React.createElement("tbody", { className: "pc-card" }, day.DashboardItems().map(function (item) {
            return item.ItemType === 'PJO' ? [
                React.createElement(PilotJobOrderMainRow, { pjo: item, model: m, key: 'pjo-main-' + item.Model.Id() }),
                React.createElement(PilotJobOrderRemarksRow, { pjo: item, model: m, key: 'pjo-remarks-' + item.Model.Id() })
            ] : [
                React.createElement(DispatchEventRow, { event: item, model: m, key: 'dispatch-evt-' + item.Model.Id() })
            ];
        })));
});
var DashboardDayTableHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    var colNames = m.ColumnNames();
    return (React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { className: "pilot-flag" }),
            React.createElement("th", { className: "pc-text-smalllabel movement-type" }, colNames.MovementType),
            React.createElement("th", { className: "pc-text-smalllabel est-time" }, colNames.EstimatedTime),
            React.createElement("th", { className: "pc-text-smalllabel actual-time" }, colNames.ActualTime),
            React.createElement("th", { className: "pc-text-smalllabel vessel" }, colNames.VesselName),
            React.createElement("th", { className: "pc-text-smalllabel location" }, colNames.Location),
            React.createElement("th", { className: "mvmt-remarks-badge-container" }),
            React.createElement("th", { className: "pc-text-smalllabel agent" }, colNames.AgencyCode),
            React.createElement("th", { className: "pc-text-smalllabel right-aligned-column tonnage" }, colNames.GrossTonnage),
            React.createElement("th", { className: "pc-text-smalllabel right-aligned-column length" }, colNames.Length),
            React.createElement("th", { className: "pc-text-smalllabel right-aligned-column beam" }, colNames.Beam),
            React.createElement("th", { className: "pc-text-smalllabel right-aligned-column draft" }, colNames.DeepDraft),
            React.createElement("th", { className: "pc-text-smalllabel tug-co" }, colNames.TugCompany),
            React.createElement("th", { className: "pc-text-smalllabel side-to" }, colNames.SideTo),
            React.createElement("th", { className: "pc-text-smalllabel last-column pilots" }, colNames.Pilot))));
});
var PilotJobOrderMainRow = supercritical_1.default(function (_a) {
    var pjo = _a.pjo, m = _a.model;
    return React.createElement("tr", { className: cx('dashboard-item-row pilot-job-order-row', {
            underway: !!pjo.Model.Start.Actual(),
            complete: !!pjo.Model.End.Actual(),
            cancelled: !!pjo.Model.Cancellation(),
            selected: pjo.Selected(),
            showRemarks: pjo.RemarksVisible()
        }), onClick: function () { return m.SelectedItemKey({ pjoId: pjo.Model.Id() }); } },
        React.createElement(PilotFlagCell, { pjo: pjo }),
        React.createElement(MovementTypeCell, { pjo: pjo }),
        React.createElement(EstimatedTimeCell, { pjo: pjo }),
        React.createElement(ActualTimeCell, { pjo: pjo }),
        React.createElement(VesselNameCell, { pjo: pjo }),
        React.createElement(MovementLocationCell, { pjo: pjo }),
        React.createElement(RemarksBadgeCell, { pjo: pjo }),
        React.createElement(AgencyCodeCell, { pjo: pjo }),
        React.createElement(GrossTonnageCell, { pjo: pjo }),
        React.createElement(LengthCell, { pjo: pjo }),
        React.createElement(BeamCell, { pjo: pjo }),
        React.createElement(DeepDraftCell, { pjo: pjo }),
        React.createElement(TugCoCell, { pjo: pjo }),
        React.createElement(SideToCell, { pjo: pjo }),
        React.createElement(PilotsCell, { pjo: pjo }));
});
var PilotFlagCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: cx('pilot-flag', {
            'show-flag': !!pjo.Model.Start.Actual() && !pjo.Model.End.Actual()
        }) },
        React.createElement(view_7.PCTooltip, { title: function () { return 'Pilot Aboard'; }, className: "pilot-tooltip" }),
        !pjo.Model.Start.Actual() && !pjo.Model.End.Actual() &&
            React.createElement(view_10.SmallConflictCountBadgeWithTooltip, { conflicts: function () { return pjo.AllConflicts(); } }));
});
var MovementTypeCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "movement-type" }, pjo.MovementTypeText());
});
var EstimatedTimeCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: cx('est-time confirmation-container', {
            confirmed: pjo.Model.StartTimeConfirmed(),
            textForActual: pjo.Model.Start.Actual() !== null
        }) },
        React.createElement("span", { className: "confirmation-text" }, tzmoment_1.tzmoment(pjo.Model.Start.Estimated()).format('HH:mm')),
        React.createElement("span", { className: "fa fa-question unfirmed-icon" }),
        React.createElement("span", { className: cx("fa fa-check confirmed-icon", {
                iconForActual: pjo.Model.Start.Actual() !== null
            }) }));
});
var ActualTimeCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "actual-time" }, pjo.Model.Start.Actual() ? tzmoment_1.tzmoment(pjo.Model.Start.Actual()).format('HH:mm') : '');
});
var VesselNameCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "vessel" }, pjo.VesselNameText());
});
var MovementLocationCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "location" },
        React.createElement(LocationNameView, { point: pjo.FromPoint }),
        ' ',
        React.createElement("span", { className: "is-not-berth" }, "to"),
        ' ',
        React.createElement(LocationNameView, { point: pjo.ToPoint }));
});
var LocationNameView = supercritical_1.default(function (_a) {
    var pt = _a.point;
    return React.createElement("span", { className: cx({
            'is-not-berth': !pt() && !pt().Model.Location() && !!pt().Model.Location().Berth()
        }) }, pt() && pt().Model.Location() && pt().Model.Location().Name());
});
var RemarksBadgeCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "mvmt-remarks-badge-container" },
        pjo.Model.EffectiveAirDraft.Num() !== null &&
            React.createElement(view_7.PCTooltip, { title: pjo.AirDraftText },
                React.createElement("span", { className: "air-draft-icon fa fa-exclamation-triangle" })),
        !!pjo.Model.Remarks() &&
            React.createElement("span", { className: "mvmt-remarks-badge fa fa-file-text", onClick: eventWrappers_1.noPropagation(pjo.ToggleRemarksVisible) }));
});
var AgencyCodeCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "agent" }, pjo.AgencyCodeText());
});
var GrossTonnageCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "tonnage right-aligned-column" }, pjo.GrossTonnageText());
});
var LengthCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "length right-aligned-column" }, pjo.LengthText());
});
var BeamCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "beam right-aligned-column" }, pjo.BeamText());
});
var DeepDraftCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: cx('draft right-aligned-column confirmation-container', {
            confirmed: pjo.Model.DeepDraftConfirmed(),
            blank: pjo.Model.EffectiveDeepDraft.Num() === null || pjo.Model.EffectiveDeepDraft.UOM() === null,
            // TH 04/11/2017 -- confirmed styling trumps conflict styling
            conflicted: !pjo.Model.DeepDraftConfirmed() && pjo.HasDraftConflict()
        }) },
        React.createElement("span", { className: "confirmation-text" }, pjo.DeepDraftText()),
        React.createElement("span", { className: "fa fa-question unfirmed-icon" }),
        React.createElement("span", { className: "fa fa-check confirmed-icon" }));
});
var TugCoCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "tug-co" }, pjo.TugCompanyText());
});
var SideToCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "side-to" }, pjo.SideToText());
});
var PilotsCell = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("td", { className: "pilots" }, !pjo.Pilots().length ?
        React.createElement("span", null, "--") :
        pjo.Pilots().map(function (p, i) { return [
            React.createElement(PilotCodeView, { pilotAssignment: p, key: 'pilot-' + p.PilotId() }),
            i < pjo.Pilots().length - 1 ?
                React.createElement("span", { className: "pilot-separator", key: 'sep-' + i }, ",") : null
        ]; }));
});
var PilotCodeView = supercritical_1.default(function (_a) {
    var p = _a.pilotAssignment;
    return React.createElement("span", { className: cx('confirmation-container', {
            confirmed: p.PilotConfirmed()
        }) },
        React.createElement("span", { className: "confirmation-text" }, p.Pilot() && p.Pilot().EffectiveCode()),
        React.createElement("span", { className: "fa fa-question unfirmed-icon" }),
        React.createElement("span", { className: "fa fa-check confirmed-icon" }));
});
var PilotJobOrderRemarksRow = supercritical_1.default(function (_a) {
    var pjo = _a.pjo, m = _a.model;
    return React.createElement("tr", { className: cx('dashboard-item-row mvmt-remarks-row', {
            'remarks-visible': pjo.RemarksVisible(),
            complete: !!pjo.Model.End.Actual(),
            selected: pjo.Selected()
        }), onClick: function () { return m.SelectedItemKey({ pjoId: pjo.Model.Id() }); } },
        React.createElement("td", { className: "pilot-flag" }),
        React.createElement("td", { className: "movement-type" }),
        React.createElement("td", { className: "est-time" }),
        React.createElement("td", { className: "actual-time" }),
        React.createElement("td", { className: "remarks-text", colSpan: 11 }, pjo.RemarksVisible() && pjo.Model.Remarks()));
});
var DispatchEventRow = supercritical_1.default(function (_a) {
    var event = _a.event, m = _a.model;
    return React.createElement("tr", { className: cx('dashboard-item-row dispatch-event-row', {
            selected: event.Selected()
        }), onClick: function () { return m.SelectedItemKey({ dispatchEventId: event.Model.Id() }); } },
        React.createElement("td", { className: "pilot-flag" }),
        React.createElement("td", { className: "movement-type" }),
        React.createElement("td", { className: "est-time" }, tzmoment_1.tzmoment(event.Model.Start()).format('HH:mm')),
        React.createElement("td", { className: "actual-time" }),
        React.createElement("td", { className: "dispatch-descr", colSpan: 11 }, event.Model.Description()));
});
var LargeResultSetMessage = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ResultSetIsTruncated() ?
        React.createElement("div", { className: "large-result-set-msg pc-card" },
            "Your search returned a large number of results. The first",
            ' ',
            model_1.MAX_SEARCH_RESULTS_SHOWN,
            ' ',
            "are shown. View entire results as a ",
            React.createElement(CSVExportLink, { model: m }, "CSV file"),
            "?") :
        null;
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotageCharges = exports.PRICE_PRECISION = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var Currency_1 = __webpack_require__(164);
var TZDate_1 = __webpack_require__(7);
var Charge_1 = __webpack_require__(108);
// TH 05/03/2017 -- For now, rounding all prices to nearest cent.
// This aligns w/ what QuickBooks requires.
// In the future, I could see needing to make this configurable.
exports.PRICE_PRECISION = 2;
function PilotageCharges(ajax, entrypoints, pjoCache, billExportSettingsModel, _a) {
    var PJO = _a.PJO, PersistedPJO = _a.PersistedPJO, PilotageChargesFlipActive = _a.PilotageChargesFlipActive;
    var billingModel = pjoCache.PilotJobOrderDetailsBillings.update1(null, { Id: PJO.Model.Id() }), billingSystems = function () { return PJO.Model.PilotAgency() && PJO.Model.PilotAgency().Organization() ?
        PJO.Model.PilotAgency().Organization().BillingSystems() : []; }, 
    // TH 05/03/2017 -- For now, the front end will only support having exactly one BillingSystem.
    // Our Db schema and server endpoints all support having multiple BillingSystems.
    // So longer term, we'd just need to change the client to have a BillingSystem dropdown or some such.
    billingSystem = s_js_1.default(function () { return billingSystems().length > 0 ? billingSystems()[0] : null; }), billExportSettings = billExportSettingsModel({
        DraftModel: PJO.Model,
        LastExportDate: billingModel.LastExportDate,
        ApproveAndRecalculate: {
            PersistedModel: PersistedPJO,
            BillingSystem: billingSystem,
            DraftChargeCollections: pjoCache.DraftChargeCollections,
            JobComplete: function () {
                // The BillExportSettings component uses JobComplete to determine whether to enable the
                // Approve for Export button.
                // The ApprovePilotJobOrderCharges endpoint requires that the PJO be complete or cancelled.
                // So in the non-cancelled case it's important we make sure the PJO actual times have been
                // persisted before we enable the Approve for Export button.
                return !!PJO.Model.Cancellation() || (!!PersistedPJO.Start.Actual() &&
                    !!PersistedPJO.End.Actual() &&
                    !!PJO.Model.Start.Actual() &&
                    !!PJO.Model.End.Actual() &&
                    TZDate_1.default.eq(PersistedPJO.Start.Actual(), PJO.Model.Start.Actual()) &&
                    TZDate_1.default.eq(PersistedPJO.End.Actual(), PJO.Model.End.Actual()));
            },
            ApproveEndPoint: entrypoints.ApprovePilotJobOrderCharges,
            RecalculateEndPoint: entrypoints.RecalculatePilotJobOrderCharges
        }
    }), bill = s_js_1.default(function () { return PJO.Model.Bills().length > 0 ? PJO.Model.Bills()[0].Bill() : null; }), chargesList = s_array_1.lift(function () {
        // TH 05/15/2017 -- Update: removed the branch for showing bill().Items().
        // bill().Items() includes charges for all PJOs that were grouped into the same
        // invoice. That's not what we want here.
        return PJO.Model.ApprovalOfCharges() ? PJO.Model.ApprovalOfCharges().Charges() :
            billingModel.DraftCharges() ? billingModel.DraftCharges().Charges() :
                [];
    }), defaultCurrency = function () { return billingSystem() && billingSystem().Currency() || Currency_1.default.USD; }, invoiceTotal = Charge_1.TotalPriceForCharges(chargesList, defaultCurrency, exports.PRICE_PRECISION), refreshClient = ajax.Url(function () {
        return entrypoints.PilotJobOrderDetailsBilling({ BillingSystemId: billingSystem().Id(), Id: PJO.Model.Id() });
    }), loading = s_js_1.default.data(false);
    var lastRefreshRequest = Promise.resolve(), refreshAlreadyQueued = false;
    s_js_1.default(function () {
        // TH 05/04/2017 -- UPDATE: Tolerate a missing billingSystem instead of throwing.
        // Don't fetch billing data until we find a BillingSystem.
        // This is to prevent a race condition fetching the BillingSystems list in the event
        // the user loads the site on the PJO details billing flip.
        if (PilotageChargesFlipActive() && billingSystem()) {
            // TH 05/16/2017 -- Subscribe to other values that we expect might influence the
            // draft charges. This is so that if the user flips to the Pilotage Charges while
            // an auto-save is in flight, we can refresh the draft charges after the auto-save
            // completes.
            // NOTE: Subscribing to both draft and persisted values. It's somewhat redundant,
            // but gives us the best chance of being notified once an auto-save is finished.
            PersistedPJO.DeepDraft.Num(); // DeepDraft affects draft charges
            PJO.Model.DeepDraft.Num();
            PersistedPJO.DeepDraft.UOM();
            PJO.Model.DeepDraft.UOM();
            PersistedPJO.EffectiveVessel(); // EffectiveVessel affects Tonnage charges
            PJO.Model.EffectiveVessel();
            PersistedPJO.Pilots(); // Pilots appear in description of various charges
            PersistedPJO.FromPoint() && PersistedPJO.FromPoint().Location(); // From and To Location appear in description of various charges
            PJO.FromPoint() && PJO.FromPoint().Model.Location();
            PersistedPJO.ToPoint() && PersistedPJO.ToPoint().Location();
            PJO.ToPoint() && PJO.ToPoint().Model.Location();
            if (!refreshAlreadyQueued) {
                refreshAlreadyQueued = true;
                lastRefreshRequest.finally(function () {
                    refreshAlreadyQueued = false;
                    lastRefreshRequest = sendRefreshRequest();
                });
            }
        }
    });
    return {
        Model: billingModel,
        // TH 05/10/2017 -- If we're waiting on a BillingSystem, also count that as loading
        Loading: function () { return !billingSystem() || loading(); },
        JobOrder: PJO.Model,
        Bill: bill,
        BillExportSettings: billExportSettings,
        BillingStatus: billExportSettings.BillingStatus,
        ChargesList: chargesList,
        InvoiceTotal: invoiceTotal
    };
    function sendRefreshRequest() {
        var req = refreshClient.Get();
        loading(true);
        return req.then(function (billingData) {
            pjoCache.PilotJobOrderDetailsBillings.update1(req.Date, billingData);
        }).finally(function () { return loading(false); });
    }
}
exports.PilotageCharges = PilotageCharges;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsHeaderView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var DispatchDashboardTab_1 = __webpack_require__(207);
exports.PilotsHeaderView = supercritical_1.default(function (_a) {
    var selectedTab = _a.selectedTab, title = _a.title, m = _a.model;
    return React.createElement("div", { className: "pilots-header-shell" },
        React.createElement("div", { className: "pilots-header" },
            React.createElement("ul", { className: "pilots-nav-tabs" },
                React.createElement(NavItemLink, { tab: 0 /* New */, selectedTab: selectedTab, href: "#!dispatchdashboard?id=" + m.Id() + "&tab=" + DispatchDashboardTab_1.DispatchDashboardTab.New, 
                    // TH 10/20/2017 -- DC originally had this note in dispatchdashboard/model.ts:
                    // DC 08/16/2017 -- Minor Note: the Count takes in Unlisted Movements
                    // Users that view DDash can see the count and could appear "wrong" to them
                    text: (m.AcknowledgeCount() > 0) ? "New (" + m.AcknowledgeCount() + ")" : "New", styles: (m.AcknowledgeCount() > 0) ? "pending" : "" }),
                React.createElement(NavItemLink, { tab: 1 /* Movements */, selectedTab: selectedTab, href: '#!dispatchdashboard?id=' + m.Id(), text: "Movements", styles: "" }),
                React.createElement(NavItemLink, { tab: 2 /* Search */, selectedTab: selectedTab, href: "#!dispatchdashboard?id=" + m.Id() + "&tab=" + DispatchDashboardTab_1.DispatchDashboardTab.Search, text: "Search", styles: "" }),
                (m.CanViewRotation() || selectedTab === 3 /* Rotation */) &&
                    React.createElement(NavItemLink, { tab: 3 /* Rotation */, selectedTab: selectedTab, href: '#!rotationdashboard?id=' + m.Id(), text: "Rotation", styles: "" })),
            React.createElement("h1", { className: "pilots-page-title" }, title)));
});
var NavItemLink = supercritical_1.default(function (_a) {
    var tab = _a.tab, selectedTab = _a.selectedTab, href = _a.href, text = _a.text, styles = _a.styles;
    return React.createElement("li", { className: cx('pilots-nav-item', {
            'pilots-nav-item-selected': selectedTab === tab,
            'pending-orders': styles === 'pending'
        }) },
        React.createElement("a", { href: href, onClick: selectedTab === tab ? eventWrappers_1.noDefault(function () { }) : undefined }, text));
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonInvitationErrorsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var invitationerrors_1 = __webpack_require__(192);
var invitationlinks_1 = __webpack_require__(263);
exports.CommonInvitationErrorsView = supercritical_1.default(function (_a) {
    var m = _a.model, getError = _a.getError, tokenErrorText = _a.tokenErrorText;
    return React.createElement("div", null,
        React.createElement(TokenErrorView, { model: m, getError: getError, tokenErrorText: tokenErrorText }),
        React.createElement(DeactivatedOrgErrorView, { getError: getError }),
        React.createElement(DeactivatedUserErrorView, { getError: getError }),
        React.createElement(AlreadyActiveErrorView, { model: m, getError: getError }));
});
var TokenErrorView = supercritical_1.default(function (_a) {
    var m = _a.model, getError = _a.getError, tokenErrorText = _a.tokenErrorText;
    var tokenError = getError(invitationerrors_1.VALIDATION_TOKEN);
    if (!tokenError)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "result-description" },
            React.createElement("div", null, tokenError.ErrorText),
            React.createElement("div", null, tokenErrorText)),
        React.createElement("div", { className: "link-shell" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.ShowLogin(true); }) }, "Login")),
        React.createElement(invitationlinks_1.HomepageLink, null)));
});
var DeactivatedOrgErrorView = supercritical_1.default(function (_a) {
    var getError = _a.getError;
    var deactivatedOrgError = getError(invitationerrors_1.VALIDATION_DEACTIVATED_ORG);
    if (!deactivatedOrgError)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "result-description" }, deactivatedOrgError.ErrorText),
        React.createElement(invitationlinks_1.HomepageLink, null)));
});
var DeactivatedUserErrorView = supercritical_1.default(function (_a) {
    var getError = _a.getError;
    var deactivatedUserError = getError(invitationerrors_1.VALIDATION_DEACTIVATED_USER);
    if (!deactivatedUserError)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "result-description" }, deactivatedUserError.ErrorText),
        React.createElement(invitationlinks_1.HomepageLink, null)));
});
var AlreadyActiveErrorView = supercritical_1.default(function (_a) {
    var m = _a.model, getError = _a.getError;
    var alreadyActiveError = getError(invitationerrors_1.VALIDATION_ALREADY_ACTIVE);
    if (!alreadyActiveError)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "result-description" }, alreadyActiveError.ErrorText),
        React.createElement(invitationlinks_1.ProfileAndLandingPageLinks, { model: m })));
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallItineraryTab = exports.BATCH_VALIDATION_KEY_STOP_DATE = exports.BATCH_VALIDATION_KEY_CUSTOM_DAYS = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var filterSignalWrites_1 = __webpack_require__(599);
var notNullish_1 = __webpack_require__(94);
var sumSignal_1 = __webpack_require__(602);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var clientSideValidation_1 = __webpack_require__(598);
var zipMap_1 = __webpack_require__(301);
var BerthReservation_1 = __webpack_require__(79);
var ItineraryPoint_1 = __webpack_require__(69);
var MilestoneTypes_1 = __webpack_require__(158);
var RecurringBatch_1 = __webpack_require__(288);
var RecurringBatchRequest_1 = __webpack_require__(1338);
var ScheduleDateEntity_1 = __webpack_require__(289);
var ScheduleDateType_1 = __webpack_require__(80);
var BerthReservation_2 = __webpack_require__(38);
var commonScheduleRules_1 = __webpack_require__(495);
var scheduleChangeEngine_1 = __webpack_require__(190);
var scheduleConstants_1 = __webpack_require__(191);
var model_1 = __webpack_require__(508);
var progInit_1 = __webpack_require__(1078);
var BatchRecurrenceFrequency_1 = __webpack_require__(302);
var DEFAULT_BATCH_LENGTH_WEEKS = 3;
exports.BATCH_VALIDATION_KEY_CUSTOM_DAYS = 'Batch.RecurrencePeriod.CustomDays';
exports.BATCH_VALIDATION_KEY_STOP_DATE = 'StopDate';
function AddPortCallItineraryTab(data, tzutils, LocalizationContext, _a) {
    var PortCall = _a.PortCall, Request = _a.Request, ScheduleHeader = _a.ScheduleHeader, initReservationParams = _a.initReservationParams;
    var nextBuilderKey = 0;
    var _b = makeScheduleViolationsCounters(), scheduleViolationsGetter = _b[0], scheduleViolationsSetter = _b[1], PortArrivalDate = progInit_1.ProgInitDateTime(null, tzutils), PortEntry = s_js_1.default(function () { var _a, _b; return (_b = (_a = PortCall.Port()) === null || _a === void 0 ? void 0 : _a.Locations().find(function (l) { return l.DefaultPortEntry(); })) !== null && _b !== void 0 ? _b : null; }), arrivalPointInit = s_js_1.default(function (_a) {
        var _b;
        var pt = _a[0], cleanup = _a[1];
        if (pt === null && PortArrivalDate() && PortEntry()) {
            var arrivalTimeJSON = PortArrivalDate().toJSON();
            _b = AddItineraryPoint(data, PortCall, {
                Id: 0,
                IsPortArrival: true,
                // We have computations below to set LocationId, Arrival, and Departure from upstream
                // data. But set them all here anyway so that the values are correct as soon as we add
                // the new point to the portcall itinerary.
                LocationId: PortEntry().Id(),
                Arrival: { Estimated: arrivalTimeJSON },
                Departure: { Estimated: arrivalTimeJSON }
            }, { Id: 0, MilestoneTypeId: MilestoneTypes_1.MilestoneTypes.FirstArrival }, { Id: 0 }), pt = _b[0], cleanup = _b[1];
        }
        s_js_1.default.cleanup(function (isFinal) { return isFinal && (cleanup === null || cleanup === void 0 ? void 0 : cleanup()); });
        return [pt, cleanup];
    }, [null, null]), PortArrivalPoint = function () { return arrivalPointInit()[0]; }, IsPortArrivalDateValid = function () {
        var _a, _b;
        return (!((_a = PortArrivalPoint()) === null || _a === void 0 ? void 0 : _a.ArrivalEntity()) ||
            scheduleViolationsGetter(PortArrivalPoint().ArrivalEntity())() === 0) && (!((_b = PortArrivalPoint()) === null || _b === void 0 ? void 0 : _b.DepartureEntity()) ||
            scheduleViolationsGetter(PortArrivalPoint().DepartureEntity())() === 0);
    }, departurePointInit = s_js_1.default(function (_a) {
        var _b;
        var pt = _a[0], cleanup = _a[1];
        if (pt === null && PortEntry()) {
            _b = AddItineraryPoint(data, PortCall, 
            // NOTE: Unlike other itinerary points we construct in this file, don't worry about init'ing
            // Arrival/Departure times correctly here. We have a computation below to handle it, the
            // logic is a little bit complicated, and not much of anything depends on port departure
            // times anyway.
            { Id: 0, IsPortDeparture: true, LocationId: PortEntry().Id() }, { Id: 0 }, { Id: 0 }), pt = _b[0], cleanup = _b[1];
        }
        s_js_1.default.cleanup(function (isFinal) { return isFinal && (cleanup === null || cleanup === void 0 ? void 0 : cleanup()); });
        return [pt, cleanup];
    }, [null, null]), PortDeparturePoint = function () { return departurePointInit()[0]; }, Berths = s_js_1.default(function () { return Array.from(data.Berths.items()); }), 
    // We'll assign our reservation builders an opaque key.
    builderKeys = s_array_1.default([]), buildersByKey = new Map(), ReservationBuilders = zipMap_1.zipMap(builderKeys, 
    // Remove last key and align w/ right edge of original builderKeys array to pair each key with its
    // prior key.
    { arr: function () { return builderKeys().slice(0, builderKeys().length - 1); }, align: 'right' }, function (key, prevKey) {
        var builder = ReservationBuilder(key, data, Berths, tzutils, PortCall, scheduleViolationsGetter, 
        // pass init params to first builder only
        s_js_1.default.sample(prevKey) === undefined ? initReservationParams : null, function () {
            var _a, _b, _c;
            return prevKey() === undefined ?
                PortArrivalPoint() : (_c = (_b = (_a = buildersByKey.get(prevKey())) === null || _a === void 0 ? void 0 : _a.Reservation()) === null || _b === void 0 ? void 0 : _b.Itinerary()) !== null && _c !== void 0 ? _c : null;
        }, function () {
            buildersByKey.delete(key);
            builderKeys.remove(key);
        });
        buildersByKey.set(key, builder);
        return builder;
    }), FirstBuilder = function () { return ReservationBuilders().length > 0 ? ReservationBuilders()[0] : null; };
    // Set PortCall's port from first reservation builder's location
    s_js_1.default(function () {
        var _a, _b;
        return ((_b = (_a = FirstBuilder()) === null || _a === void 0 ? void 0 : _a.Berth()) === null || _b === void 0 ? void 0 : _b.Location()) &&
            PortCall.PortId(FirstBuilder().Berth().Location().PortId());
    });
    // Update port arrival and port departure locations as port changes
    s_js_1.default(function () {
        var _a, _b;
        return PortEntry() && ((_a = PortArrivalPoint()) === null || _a === void 0 ? void 0 : _a.LocationId(PortEntry().Id()), (_b = PortDeparturePoint()) === null || _b === void 0 ? void 0 : _b.LocationId(PortEntry().Id()));
    });
    // Set times for port arrival point
    s_js_1.default(function () {
        var _a, _b;
        return PortArrivalDate() && ((_a = PortArrivalPoint()) === null || _a === void 0 ? void 0 : _a.Arrival.Estimated(PortArrivalDate()), (_b = PortArrivalPoint()) === null || _b === void 0 ? void 0 : _b.Departure.Estimated(PortArrivalDate()));
    });
    // Set times for port departure point
    s_js_1.default(function () {
        if (PortDeparturePoint()) {
            var builders = ReservationBuilders();
            // Find last builder that has both Berth and LastLine populated.
            var builder = null;
            for (var i = builders.length - 1; i >= 0; i--) {
                if (builders[i].Berth() && builders[i].LastLine()) {
                    builder = builders[i];
                    break;
                }
            }
            if (builder) {
                var transitMins = builder.Berth().BerthTransitOffset(), portDepartureTime = tzutils.newDate(+builder.LastLine() + transitMins * 60 * 1000);
                PortDeparturePoint().Arrival.Estimated(portDepartureTime);
                PortDeparturePoint().Departure.Estimated(portDepartureTime);
            }
            else if (PortArrivalDate()) {
                // Silly, but we'll have a port departure point even before we have our first reservation
                // builder, and if we don't set the departure point's dates somehow, then they'll remain at
                // the default value of UNIX timestamp 0, which will likely be less than the port arrival date,
                // thus triggering a bogus schedule rule violation (the rules say reasonably enough that the port
                // departure can't happen before the port arrival). So until we get our first reservation builder,
                // just default the port departure point's dates to the port arrival date.
                PortDeparturePoint().Arrival.Estimated(PortArrivalDate());
                PortDeparturePoint().Departure.Estimated(PortArrivalDate());
            }
        }
    });
    // Start building the first reservation when port arrival date is entered.
    s_js_1.default(function () { return PortArrivalDate() && ReservationBuilders().length === 0 && AddReservationBuilder(); });
    // If incoming params include enough detail to compute our initial berth transit offset, then go ahead and
    // start building our first reservation and use its initial values to initialize our port arrival date.
    if (initReservationParams.berth && initReservationParams.firstLine) {
        AddReservationBuilder();
        s_js_1.default(function () {
            var _a, _b;
            if (PortArrivalDate() === null && ((_a = FirstBuilder()) === null || _a === void 0 ? void 0 : _a.Berth()) && ((_b = FirstBuilder()) === null || _b === void 0 ? void 0 : _b.FirstLine())) {
                var transitMins = FirstBuilder().Berth().BerthTransitOffset();
                PortArrivalDate(tzutils.newDate(+FirstBuilder().FirstLine() - transitMins * 60 * 1000));
            }
        });
    }
    // Handle switching btwn FinalDeparture vs ShiftDeparture milestone type as shifts are added/removed.
    s_js_1.default(function () {
        var _a, _b;
        var reservations = ReservationBuilders()
            .map(function (builder) { return builder.Reservation(); })
            .filter(notNullish_1.notNullish);
        for (var i = 0; i < reservations.length; i++) {
            (_b = (_a = reservations[i].Itinerary()) === null || _a === void 0 ? void 0 : _a.DepartureEntity()) === null || _b === void 0 ? void 0 : _b.MilestoneTypeId(i === reservations.length - 1 ? MilestoneTypes_1.MilestoneTypes.FinalDeparture : MilestoneTypes_1.MilestoneTypes.ShiftDeparture);
        }
    });
    // Date validation via delegating to the same commonScheduleRules that drive the date updating behavior on
    // the metro map. Note that I originally tried to do this validation via a ScheduleChangeEngine instance
    // instead of querying our schedule rules directly, but that had two main drawbacks:
    //   1. It was overkill, since all we're after here is a boolean answer of valid vs not valid, not a
    //      proposal for how to revise the dates.
    //   2. The ScheduleChangeEngine currently bakes in the assumption that it's working w/ persisted date
    //      entities since it uses a keying strategy that relies on the dates' Ids being populated. So to use
    //      it here we'd either need to change that keying strategy or give our date entities here dummy Ids.
    //      Both ideas seem yucky.
    var nextRuleId = 0;
    s_js_1.default(function () {
        var rules = commonScheduleRules_1.commonScheduleRules(PortCall).filter(scheduleChangeEngine_1.ScheduleRule.isRule);
        var _loop_1 = function (rule) {
            var id = nextRuleId++, recordViolation = function (ruleIds) { return ruleIds.add(id); }, forgetViolation = function (ruleIds) { return (ruleIds.delete(id), ruleIds); }, dates = [rule.a];
            if (rule.b instanceof ScheduleDateEntity_1.ScheduleDateEntity)
                dates.push(rule.b);
            // Watch rule to record it as satisfied vs unsatisfied.
            s_js_1.default(function (wasSatisfied) {
                var isSatisfied = rule.isSatisfied();
                if (isSatisfied && !wasSatisfied) {
                    for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
                        var date = dates_1[_i];
                        scheduleViolationsSetter(date)(forgetViolation);
                    }
                }
                else if (wasSatisfied && !isSatisfied) {
                    for (var _a = 0, dates_2 = dates; _a < dates_2.length; _a++) {
                        var date = dates_2[_a];
                        scheduleViolationsSetter(date)(recordViolation);
                    }
                    s_js_1.default.cleanup(function (isFinal) {
                        if (isFinal) {
                            // This rule is disappearing. It may or may not be getting replaced by an equivalent
                            // rule, but either way remove it from these dates' sets of violated rule IDs.
                            for (var _i = 0, dates_3 = dates; _i < dates_3.length; _i++) {
                                var date = dates_3[_i];
                                scheduleViolationsSetter(date)(forgetViolation);
                            }
                        }
                    });
                }
                return isSatisfied;
            }, true);
        };
        for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
            var rule = rules_1[_i];
            _loop_1(rule);
        }
    });
    var CanRepeatPortCall = function () {
        // We use PortArrivalDate to initialize the batch request's StopDate below, so it makes sense to
        // require PortArrivalDate before letting the user request a repeated portcall.
        return !!PortArrivalDate() &&
            // We'll also require that the user not be in the middle of building a new reservation. There's no
            // technical reason why we couldn't support requesting a repeated portcall in this case; I think
            // this is more about helping the user focus on one thing at a time.
            ReservationBuilders().length > 0 &&
            !!ReservationBuilders()[ReservationBuilders().length - 1].Reservation();
    }, RepeatPortCall = s_js_1.default.value(false), BatchRequest = s_js_1.default(function () {
        if (RepeatPortCall()) {
            var batch = new RecurringBatch_1.RecurringBatch({
                Id: 0,
                RecurrencePeriod: { Frequency: BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Weekly },
                // Need to set ReferenceNumber to some non-empty value b/c unfortunately our
                // AddPortCall endpoint returns a 400 response if we don't. This is b/c our base
                // ReferenceNumber declaration in PortCall.Models\PortCall\RecurringBatch.cs has a
                // [Required] attribute. See comment re ReferenceNumber in
                // PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatch.cs for more on the
                // tradeoffs involved.
                ReferenceNumber: '--'
            }), arrivalDate = s_js_1.default.sample(PortArrivalDate), req = new RecurringBatchRequest_1.RecurringBatchRequest({
                StopDate: arrivalDate ?
                    tzmoment_1.tzmomentMod(tzutils, arrivalDate, function (m) { return m.add(DEFAULT_BATCH_LENGTH_WEEKS, 'weeks'); }).toJSON() :
                    undefined
            });
            req.Batch(batch);
            Request.BatchRequest(req);
            s_js_1.default.cleanup(function () { return Request.BatchRequest(null); });
            return req;
        }
        else {
            return null;
        }
    }), BatchValidation = new clientSideValidation_1.ValidationRules(new clientSideValidation_1.ValidationRule(exports.BATCH_VALIDATION_KEY_STOP_DATE, function () {
        return !BatchRequest()
            || !PortArrivalDate()
            || +BatchRequest().StopDate() >= +PortArrivalDate();
    }, 'Stop date must come after start date.'), new clientSideValidation_1.ValidationRule(exports.BATCH_VALIDATION_KEY_CUSTOM_DAYS, function () {
        var _a;
        return !((_a = BatchRequest()) === null || _a === void 0 ? void 0 : _a.Batch())
            || BatchRequest().Batch().RecurrencePeriod.Frequency() !== BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom
            || BatchRequest().Batch().RecurrencePeriod.CustomDays() !== 0;
    }, 'Days is required'), new clientSideValidation_1.ValidationRule(exports.BATCH_VALIDATION_KEY_CUSTOM_DAYS, function () {
        var _a;
        return !((_a = BatchRequest()) === null || _a === void 0 ? void 0 : _a.Batch())
            || BatchRequest().Batch().RecurrencePeriod.Frequency() !== BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom
            || BatchRequest().Batch().RecurrencePeriod.CustomDays() >= 0;
    }, 'Days must be positive')).validation;
    s_js_1.default(function () {
        var _a;
        return ((_a = BatchRequest()) === null || _a === void 0 ? void 0 : _a.Batch()) &&
            BatchRequest().Batch().RecurrencePeriod.CustomDays(
            // When selecting custom batch frequency, default custom days to 1. If selecting any other batch
            // frequency type, set custom days to 0.
            BatchRequest().Batch().RecurrencePeriod.Frequency() === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom ? 1 : 0);
    });
    var CanProceed = s_js_1.default(function () {
        return IsPortArrivalDateValid() &&
            ReservationBuilders().length > 0 &&
            ReservationBuilders().every(function (d) { return d.CanProceedToNextTab(); }) &&
            Object.keys(BatchValidation()).length === 0;
    });
    return {
        LocalizationContext: LocalizationContext,
        ScheduleHeader: ScheduleHeader,
        PortArrivalDate: PortArrivalDate,
        PortArrivalPoint: PortArrivalPoint,
        IsPortArrivalDateValid: IsPortArrivalDateValid,
        ReservationBuilders: ReservationBuilders,
        FirstBuilder: FirstBuilder,
        CanRepeatPortCall: CanRepeatPortCall,
        RepeatPortCall: RepeatPortCall,
        BatchRequest: BatchRequest,
        BatchValidation: BatchValidation,
        CanProceed: CanProceed,
        AddReservationBuilder: AddReservationBuilder
    };
    function AddReservationBuilder() {
        builderKeys.push(nextBuilderKey++);
    }
}
exports.AddPortCallItineraryTab = AddPortCallItineraryTab;
var ViolationsData = /** @class */ (function () {
    function ViolationsData() {
        var ruleIds = this.violatedRuleIds = sumSignal_1.sumSignal(new Set()), 
        // An S.value so that even if the ruleIds change, downstream code only gets notified if the total
        // COUNT changes.
        counts = this.violationCounts = s_js_1.default.value(0);
        // We don't need to worry about disposing this computation ever since nothing will reference either
        // ruleIds or counts once this ViolationsData instance gets GC'd.
        s_js_1.default.root(function () { return s_js_1.default.on(ruleIds, function () { return counts(ruleIds().size); }, undefined, true); });
    }
    return ViolationsData;
}());
function makeScheduleViolationsCounters() {
    var map = new WeakMap(), slot = function (d) {
        var data = map.get(d);
        if (data === undefined) {
            data = new ViolationsData();
            map.set(d, data);
        }
        return data;
    }, setter = function (d) { return slot(d).violatedRuleIds; }, getter = function (d) { return slot(d).violationCounts; };
    return [getter, setter];
}
function ReservationBuilder(Key, data, Berths, tzutils, portcall, scheduleViolationsGetter, initParams, prevPoint, onDelete) {
    var _a, _b;
    var 
    // The last berth the user explicitly selected. For now, only relevant up until we have enough info
    // to construct our Reservation.
    UserBerth = filterSignalWrites_1.filterWrites(s_js_1.default.value(null), function (b) { return b !== null; }), FirstLine = progInit_1.ProgInitDateTime((_a = initParams === null || initParams === void 0 ? void 0 : initParams.firstLine) !== null && _a !== void 0 ? _a : null, tzutils), LastLine = progInit_1.ProgInitDateTime((_b = initParams === null || initParams === void 0 ? void 0 : initParams.lastLine) !== null && _b !== void 0 ? _b : null, tzutils), reservationInit = s_js_1.default(function (_a) {
        var _b;
        var _c;
        var br = _a[0], cleanup = _a[1];
        if (br === null && UserBerth() && FirstLine() && LastLine()) {
            br = new BerthReservation_1.BerthReservation({
                Id: 0,
                Footmark: {
                    Num: UserBerth().Id() === (initParams === null || initParams === void 0 ? void 0 : initParams.berth) ? (_c = initParams === null || initParams === void 0 ? void 0 : initParams.footmark) !== null && _c !== void 0 ? _c : 0 :
                        Math.ceil(UserBerth().StartMark.Num()),
                    UOM: UserBerth().StartMark.UOM()
                },
                SideTo: BerthReservation_2.VesselSide.TBD
            });
            var pt = void 0;
            _b = AddItineraryPoint(data, portcall, {
                Id: 0,
                // We have computations below to set LocationId, Arrival, and Departure from upstream
                // data. But set them all here anyway so that the values are correct as soon as we add
                // the new point to the portcall itinerary.
                LocationId: UserBerth().Id(),
                Arrival: { Estimated: FirstLine().toJSON() },
                Departure: { Estimated: LastLine().toJSON() }
            }, { Id: 0, MilestoneTypeId: MilestoneTypes_1.MilestoneTypes.BerthArrival }, 
            // Construct departure point as a final departure. But if we add a next reservation, we'll
            // make sure to change this to ShiftDeparture instead.
            { Id: 0, MilestoneTypeId: MilestoneTypes_1.MilestoneTypes.FinalDeparture }), pt = _b[0], cleanup = _b[1];
            pt.BerthReservation(br);
            br.Itinerary(pt);
        }
        s_js_1.default.cleanup(function (isFinal) { return isFinal && (cleanup === null || cleanup === void 0 ? void 0 : cleanup()); });
        return [br, cleanup];
    }, [null, null]), Reservation = function () { return reservationInit()[0]; }, 
    // Once we have a Reservation, give its Berth priority over UserBerth, since we have logic elsewhere
    // to update the Reservation's assigned berth on changes to vessel info and footmarks, in accordance
    // w/ our most-utilized-berth rule.
    Berth = function () { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.Location()) === null || _c === void 0 ? void 0 : _c.Berth()) !== null && _d !== void 0 ? _d : UserBerth()) !== null && _e !== void 0 ? _e : null; }, berthSelector = model_1.BerthSelector({
        Berths: Berths,
        SelectedBerth: function (b) {
            if (b === undefined) {
                // Display the ASSIGNED berth, no matter what the user last selected.
                return Berth();
            }
            else {
                return s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
                    var _a, _b, _c, _d, _e;
                    if (b && b !== Berth()) {
                        (_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.LocationId(b.Id());
                        // Set res.Footmark based on selected berth, but only if selecting a different
                        // berth than the current one.
                        (_c = Reservation()) === null || _c === void 0 ? void 0 : _c.Footmark.Num(b.Id() === (initParams === null || initParams === void 0 ? void 0 : initParams.berth) ? (_d = initParams.footmark) !== null && _d !== void 0 ? _d : 0 :
                            Math.ceil(b.StartMark.Num()));
                        (_e = Reservation()) === null || _e === void 0 ? void 0 : _e.Footmark.UOM(b.StartMark.UOM());
                    }
                    return UserBerth(b);
                }); });
            }
        }
    }), IsPortValid = function () { var _a; return Berth() === null || ((_a = Berth().Location()) === null || _a === void 0 ? void 0 : _a.PortId()) === portcall.PortId(); }, IsFirstLineValid = function () {
        var _a, _b;
        return !((_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.ArrivalEntity()) ||
            scheduleViolationsGetter(Reservation().Itinerary().ArrivalEntity())() === 0;
    }, IsLastLineValid = function () {
        var _a, _b;
        return !((_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.DepartureEntity()) ||
            scheduleViolationsGetter(Reservation().Itinerary().DepartureEntity())() === 0;
    }, CanProceedToNextTab = function () {
        return Reservation() !== null &&
            IsPortValid() &&
            IsFirstLineValid() &&
            IsLastLineValid();
    };
    // If we were passed an initial berth Id, then watch for a berth matching that Id.
    if (initParams === null || initParams === void 0 ? void 0 : initParams.berth) {
        s_js_1.default(function () { return UserBerth() === null && UserBerth(data.Berths.index(initParams.berth)()); });
    }
    // Copy line times to underlying data model.
    s_js_1.default(function () { var _a, _b; return FirstLine() && ((_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.Arrival.Estimated(FirstLine())); });
    s_js_1.default(function () { var _a, _b; return LastLine() && ((_b = (_a = Reservation()) === null || _a === void 0 ? void 0 : _a.Itinerary()) === null || _b === void 0 ? void 0 : _b.Departure.Estimated(LastLine())); });
    // Update first line based on changes to assigned berth and previous point's location and departure time.
    var _prevIsPortArrival = function () { var _a, _b; return (_b = (_a = prevPoint()) === null || _a === void 0 ? void 0 : _a.IsPortArrival()) !== null && _b !== void 0 ? _b : null; }, _prevBerth = function () { var _a, _b, _c; return (_c = (_b = (_a = prevPoint()) === null || _a === void 0 ? void 0 : _a.Location()) === null || _b === void 0 ? void 0 : _b.Berth()) !== null && _c !== void 0 ? _c : null; }, _prevDeparture = function () { var _a, _b; return (_b = (_a = prevPoint()) === null || _a === void 0 ? void 0 : _a.Departure.Estimated()) !== null && _b !== void 0 ? _b : null; };
    s_js_1.default(function (_a) {
        var oldBerth = _a.berth, oldFirstLine = _a.firstLine, oldPrevIsPortArrival = _a.prevIsPortArrival, oldPrevBerth = _a.prevBerth, oldPrevDeparture = _a.prevDeparture;
        var berth = Berth(), firstLine = FirstLine(), prevIsPortArrival = _prevIsPortArrival(), prevBerth = _prevBerth(), prevDeparture = _prevDeparture();
        if (prevDeparture && (berth !== oldBerth
            || prevIsPortArrival !== oldPrevIsPortArrival
            || prevBerth !== oldPrevBerth
            || !TZDate_1.default.nullableEq(prevDeparture, oldPrevDeparture))) {
            if (berth === oldBerth
                && prevIsPortArrival === oldPrevIsPortArrival
                && prevBerth === oldPrevBerth
                && oldPrevDeparture
                && oldFirstLine) {
                // Only relevant change is to previous point's departure time --> stick w/ the existing transit
                // time.
                FirstLine(tzutils.newDate(+prevDeparture + +oldFirstLine - +oldPrevDeparture));
            }
            else if (berth) {
                // Otherwise recalculate transit time.
                // TODO: It'd be slick to figure out if this "shift" is really the in (or out) movement from
                // (or to) an anchorage, in which case using the arrival (or departure) berth's
                // BerthTransitOffset would probably make more sense here.
                var transitMins = prevIsPortArrival ? berth.BerthTransitOffset() :
                    (prevBerth === null || prevBerth === void 0 ? void 0 : prevBerth.PierGroup()) === berth.PierGroup() ? scheduleConstants_1.SAME_PIERGROUP_TRANSIT_MINS :
                        scheduleConstants_1.DIFFERENT_PIERGROUP_TRANSIT_MINS;
                FirstLine(tzutils.newDate(+prevDeparture + transitMins * 60 * 1000));
            }
        }
        return {
            berth: berth,
            firstLine: firstLine,
            prevIsPortArrival: prevIsPortArrival,
            prevBerth: prevBerth,
            prevDeparture: prevDeparture
        };
    }, {
        berth: s_js_1.default.sample(Berth),
        firstLine: s_js_1.default.sample(FirstLine),
        prevIsPortArrival: s_js_1.default.sample(_prevIsPortArrival),
        prevBerth: s_js_1.default.sample(_prevBerth),
        prevDeparture: s_js_1.default.sample(_prevDeparture)
    });
    return {
        Key: Key,
        FirstLine: FirstLine,
        LastLine: LastLine,
        Reservation: Reservation,
        Berth: Berth,
        IsPortValid: IsPortValid,
        BerthSelector: berthSelector,
        IsFirstLineValid: IsFirstLineValid,
        IsLastLineValid: IsLastLineValid,
        CanProceedToNextTab: CanProceedToNextTab,
        Delete: onDelete
    };
}
function AddItineraryPoint(data, PortCall, opts, arrivalOpts, departureOpts) {
    // Do these here b/c there are no other rational choices.
    arrivalOpts.Type = ScheduleDateType_1.ScheduleDateType.IPArrival;
    departureOpts.Type = ScheduleDateType_1.ScheduleDateType.IPDeparture;
    var pt = new ItineraryPoint_1.ItineraryPoint(opts), arrival = new ScheduleDateEntity_1.ScheduleDateEntity(arrivalOpts), departure = new ScheduleDateEntity_1.ScheduleDateEntity(departureOpts);
    // Wire up nav props to non-persisted entities.
    pt.PortCall(PortCall);
    pt.Schedule([arrival, departure]);
    arrival.PortCall(PortCall);
    arrival.ItineraryPoint(pt);
    departure.PortCall(PortCall);
    departure.ItineraryPoint(pt);
    // Wire up nav props to persisted entities.
    // Pass false for the autoDetach param on all of these attach calls. We'll call detach manually below.
    data.ItineraryPoints.attach(pt, [pt.Location], false);
    data.ScheduleDates.attach(arrival, [arrival.MilestoneType], false);
    data.ScheduleDates.attach(departure, [departure.MilestoneType], false);
    // Add to our PortCall.
    PortCall.Itinerary.push(pt);
    PortCall.Schedule.push(arrival);
    PortCall.Schedule.push(departure);
    return [pt, cleanup];
    // Cleanup function for calling code to call to remove this point.
    function cleanup() {
        data.ItineraryPoints.detach(pt, [pt.Location]);
        data.ScheduleDates.detach(arrival, [arrival.MilestoneType]);
        data.ScheduleDates.detach(departure, [departure.MilestoneType]);
        PortCall.Itinerary.remove(pt);
        PortCall.Schedule.remove(arrival);
        PortCall.Schedule.remove(departure);
    }
}


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.frequencyDescriptionText = exports.AddPortCallItineraryTabView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var BatchRecurrenceFrequency_1 = __webpack_require__(302);
var itinerary_1 = __webpack_require__(502);
var view_1 = __webpack_require__(509);
var view_2 = __webpack_require__(60);
var view_3 = __webpack_require__(55);
var view_4 = __webpack_require__(88);
var view_5 = __webpack_require__(29);
// It's just fine if this overshoots the actual number. Good to leave extra room.
var TAB_STOPS_PER_BUILDER_ROW = 5;
exports.AddPortCallItineraryTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallitinerarytab" },
        React.createElement(view_4.PortCallScheduleHeaderView, { className: "schedule-header", model: m.ScheduleHeader, includeItinerary: false }),
        React.createElement(ItineraryBuilder, { model: m }),
        React.createElement(RepeatPortCall, { model: m }));
});
var ItineraryBuilder = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "itinerary-builder" },
        React.createElement("label", { className: "itinerary-builder-label" }, "Itinerary"),
        React.createElement("div", { className: "itinerary-builder-content" },
            React.createElement(ItineraryBuilderInstructions, { model: m }),
            React.createElement(ItineraryBuilderBody, { model: m })));
});
var ItineraryBuilderInstructions = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var m = _a.model;
    var firstBuilder;
    return (React.createElement("div", { className: "itinerary-builder-instructions" }, m.PortArrivalDate() === null ?
        'Start with Arrival ETA' :
        ((_c = (_b = (firstBuilder = m.FirstBuilder())) === null || _b === void 0 ? void 0 : _b.Berth()) !== null && _c !== void 0 ? _c : null) === null ?
            'Enter the Arrival location' :
            ((_d = firstBuilder === null || firstBuilder === void 0 ? void 0 : firstBuilder.LastLine()) !== null && _d !== void 0 ? _d : null) === null ?
                'Indicate the ETD' :
                'Add a shift, repeat the portcall or move on'));
});
var ItineraryBuilderBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    var builders = m.ReservationBuilders(), rows = [
        React.createElement(FirstArrivalRow, { key: "first-arrival", model: m, tabIndexStart: 1 })
    ];
    for (var i = 0; i < builders.length; i++) {
        var builder = builders[i], nextBuilder = i === builders.length - 1 ? null : builders[i + 1];
        if (builder.Berth()) {
            rows.push(React.createElement(FirstLineRow, { key: "first-line-" + builder.Key, model: m, builder: builder, tabIndexStart: (2 * i + 1) * TAB_STOPS_PER_BUILDER_ROW + 1 }), React.createElement(LastLineRow, { key: "last-line-" + builder.Key, model: m, builder: builder, nextBuilder: nextBuilder, tabIndexStart: 2 * (i + 1) * TAB_STOPS_PER_BUILDER_ROW + 1 }));
        }
    }
    return (React.createElement("div", { className: "itinerary-builder-body" }, rows));
});
var FirstArrivalRow = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "itinerary-builder-row first-arrival-row" },
        React.createElement("div", { className: cx('date-picker-shell', { 'invalid-date': !m.IsPortArrivalDateValid() }) },
            React.createElement("div", null,
                React.createElement(view_2.ProgInitDateTimePicker, { value: m.PortArrivalDate, localization: m.LocalizationContext, tabindex: { date: tabIndexStart, time: tabIndexStart + 1 }, autofocus: { date: true } })),
            React.createElement("div", { className: "label-below" }, "First Arrival")),
        React.createElement("div", { className: "row-text" },
            React.createElement("b", null, (_c = LocationNameText((_b = m.PortArrivalPoint()) === null || _b === void 0 ? void 0 : _b.Location())) !== null && _c !== void 0 ? _c : 'Pilot Area'),
            ' ',
            "\u2014 inbound to"),
        m.FirstBuilder() &&
            React.createElement("div", { className: "berth-selector-shell" },
                React.createElement(view_1.BerthSelectorView, { className: "search-filter", model: m.FirstBuilder().BerthSelector, tabIndex: tabIndexStart + 2 })));
});
var FirstLineRow = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model, builder = _a.builder, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "itinerary-builder-row first-line-row" },
        React.createElement("div", { className: cx('date-picker-shell', { 'invalid-date': !builder.IsFirstLineValid() }) },
            React.createElement("div", null,
                React.createElement(view_2.ProgInitDateTimePicker, { value: builder.FirstLine, localization: m.LocalizationContext, tabindex: { date: tabIndexStart, time: tabIndexStart + 1 } })),
            React.createElement("div", { className: "label-below" }, "First Line")),
        React.createElement("div", { className: "row-text" },
            "Arriving",
            ' ',
            React.createElement("b", null, LocationNameText((_b = builder.Berth()) === null || _b === void 0 ? void 0 : _b.Location()))));
});
var LastLineRow = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model, builder = _a.builder, nextBuilder = _a.nextBuilder, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "itinerary-builder-row last-line-row" },
        React.createElement("div", { className: cx('date-picker-shell', { 'invalid-date': !builder.IsLastLineValid() }) },
            React.createElement("div", null,
                React.createElement(view_2.ProgInitDateTimePicker, { value: builder.LastLine, localization: m.LocalizationContext, tabindex: { date: tabIndexStart, time: tabIndexStart + 1 } })),
            React.createElement("div", { className: "label-below" }, "Last Line")),
        React.createElement("div", { className: "row-text" },
            "Departing",
            ' ',
            React.createElement("b", null, LocationNameText((_b = builder.Berth()) === null || _b === void 0 ? void 0 : _b.Location())),
            ' ',
            "\u2014",
            nextBuilder ? ' shifting to' : ' outbound'),
        nextBuilder ?
            React.createElement("div", { className: "berth-selector-shell" },
                React.createElement("div", null,
                    React.createElement(view_1.BerthSelectorView, { className: "search-filter", model: nextBuilder.BerthSelector, tabIndex: tabIndexStart + 2 })),
                !nextBuilder.IsPortValid() &&
                    React.createElement("div", { className: "invalid-port-msg" }, "Location must match the first location's port/region."),
                React.createElement("div", { className: "cancel-shift-shell" },
                    React.createElement("a", { href: "", className: "cancel-shift-link", onClick: eventWrappers_1.noDefault(nextBuilder.Delete) }, "Cancel Shift"))) :
            builder.Reservation() ?
                React.createElement("div", { className: "add-shift-shell" },
                    React.createElement("a", { href: "", className: "add-shift-link", onClick: eventWrappers_1.noDefault(m.AddReservationBuilder) }, "+ Add Shift")) :
                null);
});
function LocationNameText(loc) {
    var _a, _b;
    return loc && loc.Name() + " (" + ((_b = (_a = loc.Port()) === null || _a === void 0 ? void 0 : _a.Name()) !== null && _b !== void 0 ? _b : 'loading...') + ")";
}
var RepeatPortCall = supercritical_1.default(function (_a) {
    var m = _a.model;
    // 2 rows per reservation builder plus a row for the port arrival date.
    var nextTabIndex = (2 * m.ReservationBuilders().length + 1) * TAB_STOPS_PER_BUILDER_ROW + 1;
    return (m.BatchRequest() ?
        React.createElement("div", { className: "repeat-pc-section" },
            React.createElement(RepeatPortCallHeader, { model: m }),
            React.createElement(RepeatPortCallBody, { model: m, tabIndexStart: nextTabIndex })) :
        m.CanRepeatPortCall() ?
            React.createElement("div", { className: "repeat-pc-link-shell" },
                React.createElement("a", { href: "", className: "repeat-pc-link", onClick: eventWrappers_1.noDefault(function () { return m.RepeatPortCall(true); }) }, "Repeat PortCall")) :
            null);
});
var RepeatPortCallHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "repeat-pc-header" },
        React.createElement("label", { className: "repeat-pc-title" }, "Range"),
        React.createElement("a", { href: "", className: "cancel-repeat-link", onClick: eventWrappers_1.noDefault(function () { return m.RepeatPortCall(false); }) }, "Cancel repeating PortCalls"));
});
var RepeatPortCallBody = supercritical_1.default(function (_a) {
    var m = _a.model, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "repeat-pc-body" },
        React.createElement(RepeatPortCallDates, { model: m, tabIndexStart: tabIndexStart }),
        React.createElement(RepeatPortCallFrequency, { model: m, tabIndexStart: tabIndexStart + 5 }));
});
var RepeatPortCallDates = supercritical_1.default(function (_a) {
    var m = _a.model, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "repeat-pc-dates" },
        React.createElement("div", null,
            React.createElement("div", { className: "start-date-shell" },
                React.createElement("div", null,
                    React.createElement(view_2.NullableDatePicker, { value: m.PortArrivalDate, disabled: true, localization: m.LocalizationContext })),
                React.createElement("div", { className: "label-below" }, "Start")),
            m.BatchRequest() &&
                React.createElement("div", { className: "stop-date-shell" },
                    React.createElement("div", null,
                        React.createElement(view_2.DatePicker, { value: m.BatchRequest().StopDate, localization: m.LocalizationContext, tabindex: tabIndexStart })),
                    React.createElement("div", { className: "label-below" }, "Stop"))),
        React.createElement(view_5.ValidationErrorView, { error: function () { return m.BatchValidation()[itinerary_1.BATCH_VALIDATION_KEY_STOP_DATE]; } }));
});
var RepeatPortCallFrequency = supercritical_1.default(function (_a) {
    var m = _a.model, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "repeat-pc-frequency" },
        React.createElement(FrequencyDropdown, { model: m, tabIndex: tabIndexStart }),
        React.createElement(FrequencyDescription, { model: m, tabIndex: tabIndexStart + 1 }),
        React.createElement(view_5.ValidationErrorView, { error: function () { return m.BatchValidation()[itinerary_1.BATCH_VALIDATION_KEY_CUSTOM_DAYS]; } }));
});
var FrequencyDropdown = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model, tabIndex = _a.tabIndex;
    return ((_b = m.BatchRequest()) === null || _b === void 0 ? void 0 : _b.Batch()) ?
        React.createElement("div", { className: "frequency-shell" },
            React.createElement("select", { className: "pc-select frequency-select", value: m.BatchRequest().Batch().RecurrencePeriod.Frequency(), onChange: function (e) { return m.BatchRequest().Batch().RecurrencePeriod.Frequency(+e.currentTarget.value); }, tabIndex: tabIndex }, BatchRecurrenceFrequency_1.BatchRecurrenceFrequencys.map(function (_a) {
                var Id = _a.Id, Name = _a.Name;
                return React.createElement("option", { value: Id, key: Id }, Name);
            })),
            React.createElement("span", { className: "pc-select-chevron" })) :
        null;
});
var FrequencyDescription = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model, tabIndex = _a.tabIndex;
    return React.createElement("div", { className: "frequency-description label-below" },
        "Frequency |",
        ' ',
        ((_b = m.BatchRequest()) === null || _b === void 0 ? void 0 : _b.Batch()) && (((_c = m.BatchRequest()) === null || _c === void 0 ? void 0 : _c.Batch().RecurrencePeriod.Frequency()) === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom ?
            React.createElement("span", null,
                "Repeats every",
                ' ',
                React.createElement(view_3.NumericInput, { className: "custom-days", value: m.BatchRequest().Batch().RecurrencePeriod.CustomDays, tabindex: tabIndex }),
                ' ',
                "days.") :
            React.createElement("span", null, frequencyDescriptionText(m.PortArrivalDate(), m.BatchRequest().Batch().RecurrencePeriod))));
});
function frequencyDescriptionText(startDate, recurrencePeriod) {
    var frequency = recurrencePeriod.Frequency();
    if (frequency === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Daily) {
        return 'Repeats every day.';
    }
    else if (frequency === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Weekly) {
        var format = 'dddd'; // Full day of week name
        return "Repeats every week" + (startDate ? " on " + tzmoment_1.tzmoment(startDate).format(format) : '') + ".";
    }
    else if (frequency === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Monthly) {
        var format = 'Do'; // Ordinal day of month
        return "Repeats every month" + (startDate ? " on the " + tzmoment_1.tzmoment(startDate).format(format) : '') + ".";
    }
    else if (frequency === BatchRecurrenceFrequency_1.BatchRecurrenceFrequency.Custom) {
        return "Repeats every " + (recurrencePeriod.CustomDays() === 1 ? 'day' : recurrencePeriod.CustomDays() + " days") + ".";
    }
    else {
        throw new Error("Unknown BatchRecurrenceFrequency value " + frequency);
    }
}
exports.frequencyDescriptionText = frequencyDescriptionText;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCall = exports.TabId = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var notNullish_1 = __webpack_require__(94);
var UOM_1 = __webpack_require__(25);
var validationWatcher_1 = __webpack_require__(23);
var AddPortCallRequest_1 = __webpack_require__(1219);
var BerthReservation_1 = __webpack_require__(79);
var Measurement_1 = __webpack_require__(11);
var PortCall_1 = __webpack_require__(161);
var TabId;
(function (TabId) {
    TabId["Berths"] = "berths";
    TabId["Coordinations"] = "coordinations";
    TabId["Itinerary"] = "itinerary";
    TabId["Pilots"] = "pilots";
    TabId["Review"] = "review";
    TabId["Summary"] = "summary";
    TabId["Vessel"] = "vessel";
})(TabId = exports.TabId || (exports.TabId = {}));
function AddPortCall(ajax, entrypoints, data, scheduleHeaderModel, berthsTabModel, coordinationsTabModel, itineraryTabModel, pilotsTabModel, reviewTabModel, summaryTabModel, vesselTabModel, params) {
    var portcall = new PortCall_1.PortCall({
        Id: 0,
        LengthOnlyLength: { UOM: UOM_1.default.Foot },
        AirDraft: { UOM: UOM_1.default.Foot },
        DeepDraft: { UOM: UOM_1.default.Foot }
    });
    data.PortCalls.attach(portcall, [
        portcall.Agent,
        portcall.Port,
        portcall.Vessel
    ]);
    var Request = new AddPortCallRequest_1.AddPortCallRequest();
    Request.PortCall(portcall);
    var client = ajax.Url(entrypoints.AddPortCall, {
        useCache: true,
        include: [
            function (r) { return r.PortCall; },
            function (_) { return portcall.Itinerary; },
            function (_) { return portcall.Itinerary().map(function (pt) { return pt.BerthReservation; }); },
            function (_) { return portcall.Itinerary().map(function (pt) { var _a; return (_a = pt.BerthReservation()) === null || _a === void 0 ? void 0 : _a.CargoActivities; }); },
            function (_) { return portcall.Itinerary().map(function (pt) { var _a; return (_a = pt.BerthReservation()) === null || _a === void 0 ? void 0 : _a.CruiseActivities; }); },
            // The server needs us to go via PortCall -> Itinerary -> Schedule -> CoordinationCards and NOT
            // via PortCall -> Schedule -> CoordinationCards, otherwise it can't figure out which itinerary
            // point each date entity is supposed to go with (there are no Ids populated yet).
            function (_) { return portcall.Itinerary().map(function (pt) { return pt.Schedule; }); },
            function (_) { return portcall.Itinerary().map(function (pt) { return pt.Schedule().map(function (sd) { return sd.CoordinationCards; }); }); },
            // The server expects us to go via PortCall -> Itinerary -> DeparturePilotJobOrders so
            // it can tell which movement each PJO corresponds to (there are no Ids populated yet).
            function (_) { return portcall.Itinerary().map(function (pt) { return pt.DeparturePilotJobOrders; }); },
            // But DON'T include PortCall -> Itinerary -> ArrivalPilotJobOrders. The server doesn't like that
            // since it thinks we might be trying to specify PJOs twice.
            function (r) { return r.BatchRequest; },
            function (r) { var _a; return (_a = r.BatchRequest()) === null || _a === void 0 ? void 0 : _a.Batch; },
            function (r) { return r.AddVessel; },
            function (r) { var _a; return (_a = r.AddVessel()) === null || _a === void 0 ? void 0 : _a.OverrideServiceVessel; }
        ]
    });
    var Validation = validationWatcher_1.ValidationWatcher(client), ShowValidationErrors = s_js_1.default.value(false), FinishedOrder = s_js_1.default.value(null), SubmissionSucceeded = function () { return !!FinishedOrder(); }, Submitting = s_js_1.default.value(false);
    s_js_1.default(function () { return ShowValidationErrors(Object.keys(Validation()).length > 0); });
    var currentTabId = s_js_1.default.value(TabId.Vessel), ScheduleHeader = scheduleHeaderModel({ PortCall: portcall }), berthsTab = berthsTabModel({ PortCall: portcall, ScheduleHeader: ScheduleHeader }), coordinationsTab = coordinationsTabModel({ PortCall: portcall, ScheduleHeader: ScheduleHeader }), itineraryTab = itineraryTabModel({
        PortCall: portcall,
        Request: Request,
        ScheduleHeader: ScheduleHeader,
        initReservationParams: params
    }), pilotsTab = pilotsTabModel({ PortCall: portcall, ScheduleHeader: ScheduleHeader }), reviewTab = reviewTabModel({
        PortCall: portcall,
        Request: Request,
        ScheduleHeader: ScheduleHeader,
        OnReviewTab: function () { return currentTabId() === TabId.Review; }
    }), summaryTab = summaryTabModel({ FinishedOrder: FinishedOrder }), vesselTab = vesselTabModel({ PortCall: portcall, Request: Request }), CurrentTab = s_js_1.default(function () {
        var id = currentTabId();
        return (id === TabId.Berths ? { id: id, model: berthsTab } :
            id === TabId.Coordinations ? { id: id, model: coordinationsTab } :
                id === TabId.Itinerary ? { id: id, model: itineraryTab } :
                    id === TabId.Pilots ? { id: id, model: pilotsTab } :
                        id === TabId.Review ? { id: id, model: reviewTab } :
                            id === TabId.Summary ? { id: id, model: summaryTab } :
                                id === TabId.Vessel ? { id: id, model: vesselTab } :
                                    null);
    }), AvailableTabs = s_js_1.default(function () {
        return SubmissionSucceeded() ?
            [TabId.Summary] :
            [
                // NOTE: Order matters. List tabs in the order we want users to proceed through them.
                TabId.Vessel,
                TabId.Itinerary,
                TabId.Berths,
                coordinationsTab.HasActionableContent() ? TabId.Coordinations : null,
                pilotsTab.IsTabAvailable() ? TabId.Pilots : null,
                TabId.Review
            ].filter(notNullish_1.notNullish);
    }), HasPreviousTab = function () { return AvailableTabs().indexOf(currentTabId()) > 0; }, HasNextTab = function () {
        var idx = AvailableTabs().indexOf(currentTabId());
        return idx >= 0 && idx < AvailableTabs().length - 1;
    }, CanProceed = function () { return CurrentTab().model.CanProceed(); }, Loading = function () {
        return Submitting()
            || reviewTab.UpdatingPreview();
    };
    s_js_1.default(function () {
        // If current tab is no longer in our available list, jump to the first available tab. In practice
        // this is how we enforce that we should jump to the Summary tab after the user's submission goes
        // through successfully.
        if (AvailableTabs().indexOf(currentTabId()) < 0 && AvailableTabs().length > 0) {
            currentTabId(AvailableTabs()[0]);
        }
    });
    // Computations to keep core data model internally consistent. Rule of thumb: The computations here should
    // be about either 1) sync'ing one part of our Request object graph with another part of that object graph
    // or 2) synthesizing data contributed by multiple Add PC tabs (e.g. the reservation length calculation
    // depends on vessel info from the Vessel tab, berth info from the Itinerary tab, and footmark info from the
    // Berths tab). If your computation is mostly about updating our Request object graph in response to a UI
    // trigger specific to a single tab, it'd probably be clearer to declare it in that tab's viewmodel instead
    // of here.
    SyncPortCallUOMs(portcall);
    // Per-reservation computations
    var externalVessel = function () { var _a, _b; return (_b = (_a = vesselTab.NewVessel()) === null || _a === void 0 ? void 0 : _a.ExternalVessel()) !== null && _b !== void 0 ? _b : null; };
    s_array_1.lift(function () { return portcall.Reservations(); }).map(function (br) {
        SetReservationLength(br, portcall, Request, externalVessel);
        ApplyMostUtilizedBerthRule(br);
    });
    return {
        Validation: Validation,
        ShowValidationErrors: ShowValidationErrors,
        SubmissionSucceeded: SubmissionSucceeded,
        CurrentTab: CurrentTab,
        AvailableTabs: AvailableTabs,
        HasPreviousTab: HasPreviousTab,
        HasNextTab: HasNextTab,
        CanProceed: CanProceed,
        Loading: Loading,
        GoToPreviousTab: GoToPreviousTab,
        GoToNextTab: GoToNextTab,
        JumpBackToTab: JumpBackToTab,
        Submit: Submit,
        Submitting: Submitting
    };
    function GoToPreviousTab() {
        s_js_1.default.sample(function () {
            var idx = AvailableTabs().indexOf(currentTabId());
            if (idx > 0)
                currentTabId(AvailableTabs()[idx - 1]);
        });
    }
    function GoToNextTab() {
        s_js_1.default.sample(function () {
            if (CurrentTab().model.CanProceed()) {
                var idx = AvailableTabs().indexOf(currentTabId());
                if (idx >= 0 && idx < AvailableTabs().length - 1) {
                    currentTabId(AvailableTabs()[idx + 1]);
                }
            }
        });
    }
    function JumpBackToTab(tab) {
        s_js_1.default.sample(function () {
            var proposedIdx = AvailableTabs().indexOf(tab);
            // For now, only allowing jumping backwards, not forwards, as an easy way of enforcing validation:
            // To go forwards, you have to use GoToNextTab above, and that method ensures that we check the
            // current tab's CanProceed method before navigating. Of course, we COULD allow jumping forwards so
            // long as we also check all intervening tabs' CanProceed methods, but for now the design thinking
            // is that "jump backwards, step forwards" is flexible enough and more teachable.
            if (proposedIdx >= 0 && proposedIdx <= AvailableTabs().indexOf(currentTabId())) {
                currentTabId(tab);
            }
        });
    }
    function Submit() {
        return __awaiter(this, void 0, void 0, function () {
            var dataCacheUpdate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Submitting())
                            return [2 /*return*/];
                        Submitting(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, client.Post(Request)];
                    case 2:
                        dataCacheUpdate = _a.sent();
                        if (dataCacheUpdate.PortCalls().length === 0) {
                            throw new Error('The server response unexpectedly included no new PortCalls even though its status was successful.');
                        }
                        FinishedOrder({
                            PortCalls: dataCacheUpdate.PortCalls(),
                            Batch: dataCacheUpdate.RecurringBatches().length > 0 ? dataCacheUpdate.RecurringBatches()[0] : null
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        Submitting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
exports.AddPortCall = AddPortCall;
function SyncPortCallUOMs(PortCall) {
    s_js_1.default(function () {
        var _a;
        return ((_a = PortCall.Port()) === null || _a === void 0 ? void 0 : _a.PierLengthUOM()) && PortCall.LengthOnlyLength.set(PortCall
            .LengthOnlyLength
            .convert(PortCall.Port().PierLengthUOM())
            .roundToNearest(1));
    });
    s_js_1.default(function () {
        var _a;
        return ((_a = PortCall.Port()) === null || _a === void 0 ? void 0 : _a.PierDepthUOM()) && (PortCall.DeepDraft.set(PortCall
            .DeepDraft
            .convert(PortCall.Port().PierDepthUOM())
            .roundToNearest(0.01)),
            PortCall.AirDraft.set(PortCall
                .AirDraft
                .convert(PortCall.Port().PierDepthUOM())
                .roundToNearest(0.01)));
    });
}
function SetReservationLength(Reservation, PortCall, Request, ExternalVessel) {
    // Set reservation length. This is purely for client-side purposes (keeping the footmarks widget in sync
    // while filling out the Add PC form). The server applies its own version of the same logic.
    s_js_1.default(function () {
        var _a;
        var vlength, vbeam;
        if (PortCall.Vessel()) {
            vlength = PortCall.Vessel().Length;
            vbeam = PortCall.Vessel().Beam;
        }
        else if (Request.AddVessel()) {
            var ov = Request.AddVessel().OverrideServiceVessel(), ev = ExternalVessel();
            vlength = (ov === null || ov === void 0 ? void 0 : ov.Length.Num()) ? ov.Length : ev ? new Measurement_1.NullableMeasurement(ev.Length) : null;
            vbeam = (ov === null || ov === void 0 ? void 0 : ov.Beam.Num()) ? ov.Beam : ev ? new Measurement_1.NullableMeasurement(ev.Beam) : null;
        }
        else {
            vlength = vbeam = null;
        }
        var brLength = BerthReservation_1.BerthReservation.calculateLength(vlength, vbeam, PortCall.LengthOnlyLength, Reservation.SideTo(), (_a = PortCall.LengthOnlyLength.UOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot);
        if (brLength === null || brLength === void 0 ? void 0 : brLength.Num()) {
            // DC: Getting an "Uncaught Error: conflicting values: [metric value] (e.g. 199.9488000007998) is not the same as [imp value] (e.g. 656)".
            // This happens on sites that are set to metric and a user has pre-selected an area on the Berths timeline. It causes the vessel data below
            // the vessel search to not appear, and the footmarks cannot be adjusted correctly on the Berths tab. Upon submission, the PortCall is normal.
            // The issues stems from an order of operations when parameters are passed in, i.e. berth and itinerary info are known at vessel selection. 
            // Add PC (here) running BR.calcLength() (above), and InPort Ops running Br.calcLength() causes an error when Reservation.Length.set() (below) runs.
            // S-JS has an issue because it's being told to set the Num value in InPort Ops to A white it's set to B here.
            // DC 02/08/2022 -- Similar to the PJO Abort issue, S-JS order of operations are preventing the flow of data. Adding a timeout avoids the issue.
            // Will revisit and provide a more appropriate S resolution when applicable.
            setTimeout(function () { return Reservation.Length.set(brLength); }, 300);
        }
        else {
            // If we fail to find a usable reservation length (most likely b/c we've chosen an existing vessel
            // for which Beam.Num is null), fallback to a length of 0. That's also what we expect the server to
            // do if we submit in this state.
            Reservation.Length.Num(0);
        }
    });
}
function ApplyMostUtilizedBerthRule(Reservation) {
    // Refine selected berth as footmarks or selected berth change. This is purely for faster client-side
    // feedback. The server applies its own version of the same logic.
    s_js_1.default(function () {
        var _a, _b;
        var pt = Reservation.Itinerary();
        if (pt === null)
            return;
        var berth = (_b = (_a = Reservation.Itinerary()) === null || _a === void 0 ? void 0 : _a.Location()) === null || _b === void 0 ? void 0 : _b.Berth();
        // Ugly. Skip updating if Berth and LocationId are out-of-sync. This can happen if the user selects a
        // new berth and that changes both LocationId and Footmark; changing Footmark will trigger this
        // computation to re-run in the next tick of S's clock, but it'll take at least one extra clock tick for
        // Berth to reflect the new LocationId value. W/o this guard, we can wind up applying the
        // most-utilized-berth rule to the wrong piergroup.
        if ((berth === null || berth === void 0 ? void 0 : berth.Id()) !== pt.LocationId())
            return;
        var pg = berth === null || berth === void 0 ? void 0 : berth.PierGroup();
        if (pg) {
            var b = pg.MostUtilizedBerth(Reservation.Footmark, Reservation.Length);
            if (b)
                pt.LocationId(b.Id());
        }
    });
}


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallVesselTab = exports.VesselType = void 0;
var s_js_1 = __webpack_require__(0);
var notNullish_1 = __webpack_require__(94);
var UOM_1 = __webpack_require__(25);
var PCRoles_1 = __webpack_require__(286);
var model_1 = __webpack_require__(151);
var model_2 = __webpack_require__(153);
var VesselType;
(function (VesselType) {
    VesselType["Existing"] = "existing";
    VesselType["Import"] = "import";
    VesselType["LengthOnly"] = "length-only";
})(VesselType = exports.VesselType || (exports.VesselType = {}));
var lengthConversions = [{
        uom: UOM_1.default.Foot,
        // TH: To display as feet and inches instead of as decimal feet, uncomment the feetAndInches property and comment out the decimalPlaces property.
        // That requires CSS tweaks to make room for the wider field, so in the interest of getting something in, I'm holding off for now.
        //feetAndInches: true
        decimalPlaces: 2
    }, {
        uom: UOM_1.default.Meter,
        decimalPlaces: 1
    }];
function AddPortCallVesselTab(user, data, localVesselSearchModel, newVesselModel, _a) {
    var PortCall = _a.PortCall, Request = _a.Request;
    var vesselType = s_js_1.default.value(VesselType.Existing), LocalSearch = localVesselSearchModel({ onSelect: function (v) { return PortCall.VesselId(v.Id()); } }), NewVessel = s_js_1.default(function () {
        return vesselType() === VesselType.Import ?
            newVesselModel({
                lengthUOM: function () { var _a; return (_a = PortCall.LengthOnlyLength.UOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; },
                depthUOM: function () { var _a; return (_a = PortCall.DeepDraft.UOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; },
                onSelect: function (v) { return PortCall.VesselId(v.Id()); },
                onDismiss: function () { return vesselType(VesselType.Existing); }
            }) :
            null;
    }), LengthOnlyLengthUOM = s_js_1.default.value(UOM_1.default.Foot), LengthOnlyLengthInFeet = function (val) {
        if (val === undefined) {
            return LengthOnlyLengthUOM() === UOM_1.default.Foot;
        }
        else {
            LengthOnlyLengthUOM(val ? UOM_1.default.Foot : UOM_1.default.Meter);
            return val;
        }
    }, ToggleableLengthOnlyLength = model_1.ToggleableMeasurement({
        backingMeasurement: PortCall.LengthOnlyLength,
        uom: LengthOnlyLengthUOM,
        conversions: lengthConversions
    }), availableAgents = s_js_1.default(function () {
        var _a;
        var r = data.Roles.index(PCRoles_1.PCRoles.ReserveBerths)();
        return (_a = r === null || r === void 0 ? void 0 : r.Users().map(function (ur) { var _a; return (_a = ur.User()) === null || _a === void 0 ? void 0 : _a.PCUser(); }).filter(notNullish_1.notNullish).filter(function (u) { return u.Active(); })) !== null && _a !== void 0 ? _a : [];
    }), AgentSelector = model_2.UserSelector({ UserId: PortCall.AgentId, Users: availableAgents }), vesselReqSatisfied = function () {
        var _a, _b;
        return ((_b = (_a = NewVessel()) === null || _a === void 0 ? void 0 : _a.CanSave()) !== null && _b !== void 0 ? _b : false)
            || vesselType() === VesselType.Existing && !!PortCall.Vessel()
            || vesselType() === VesselType.LengthOnly && !!PortCall.LengthOnlyLength.Num();
    }, CanProceed = function () { return vesselReqSatisfied() && !!PortCall.Agent(); };
    s_js_1.default(function () {
        if (vesselType() !== VesselType.Existing)
            PortCall.VesselId(null);
    });
    s_js_1.default(function () {
        if (vesselType() !== VesselType.LengthOnly)
            PortCall.LengthOnlyLength.Num(null);
    });
    s_js_1.default(function () {
        if (NewVessel())
            Request.AddVessel(NewVessel().CreateRequest());
        else
            Request.AddVessel(null);
    });
    s_js_1.default(function () { var _a, _b; return AgentSelector.data((_b = (_a = PortCall.Agent()) === null || _a === void 0 ? void 0 : _a.FullName()) !== null && _b !== void 0 ? _b : ''); });
    return {
        User: user,
        PortCall: PortCall,
        VesselType: vesselType,
        LocalSearch: LocalSearch,
        NewVessel: NewVessel,
        LengthOnlyLengthInFeet: LengthOnlyLengthInFeet,
        ToggleableLengthOnlyLength: ToggleableLengthOnlyLength,
        AgentSelector: AgentSelector,
        CanProceed: CanProceed
    };
}
exports.AddPortCallVesselTab = AddPortCallVesselTab;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetails = exports.TabInPortOps = exports.TabActions = void 0;
var mutex_1 = __webpack_require__(204);
var model_1 = __webpack_require__(196);
exports.TabActions = { Title: 'Actions' };
exports.TabInPortOps = { Title: 'In Port Ops' };
function BerthAssignmentDetails(loader, actionsTabModel, inPortOpsTabModel, _a) {
    var BerthReservation = _a.BerthReservation, DismissDetails = _a.DismissDetails, _b = _a.SaveMutex, SaveMutex = _b === void 0 ? new mutex_1.Mutex() : _b;
    var _c = loader({ Id: BerthReservation.Id() }, 10), detailsResp = _c.model, detailsRespLoading = _c.loading, ActionsTab = actionsTabModel({
        BerthReservation: BerthReservation,
        DismissDetails: DismissDetails,
        PCRights: detailsResp.PCRights,
        SaveMutex: SaveMutex
    }), InPortOpsTab = inPortOpsTabModel({
        BerthReservation: BerthReservation,
        PCRights: detailsResp.PCRights,
        SaveMutex: SaveMutex
    }), 
    // The actions tab has no other content if no actions are available, so suppress the tab completely
    // in that case.
    TabStrip = model_1.PCTabStrip(exports.TabInPortOps, function () { return ActionsTab.HasAnyAvailableActions() ? [exports.TabActions] : []; }), Loading = function () {
        return detailsRespLoading()
            || ActionsTab.Loading()
            || InPortOpsTab.Loading();
    };
    return {
        DismissDetails: DismissDetails,
        ActionsTab: ActionsTab,
        InPortOpsTab: InPortOpsTab,
        TabStrip: TabStrip,
        Loading: Loading
    };
}
exports.BerthAssignmentDetails = BerthAssignmentDetails;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosuresDashboard = exports.Columns = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var debounceSignal_1 = __webpack_require__(81);
var tzmoment_1 = __webpack_require__(9);
var ConvertedMeasurement_1 = __webpack_require__(116);
var UOM_1 = __webpack_require__(25);
var diacriticals_1 = __webpack_require__(42);
var IssueType_1 = __webpack_require__(112);
var csvExport_1 = __webpack_require__(149);
var model_1 = __webpack_require__(129);
// TODO: Localization!!
var DATE_TIME_FORMAT = 'MM/DD/YYYY [at] HH:mm';
var VERY_LONG_TIME_IN_THE_FUTURE = new TZDate_1.default(Date.now() + 2000 * 365.25 * 24 * 60 * 60 * 1000);
var StartDate = {
    Title: 'Start',
    DisplayValue: function (closure) { return closure.StartDateDisplay(); },
    SortValue: function (closure) { return closure.Model.StartDate(); },
    ClassName: 'start-date'
}, EndDate = {
    Title: 'End',
    DisplayValue: function (closure) { return closure.EndDateDisplay(); },
    SortValue: function (closure) { return closure.Model.EndDate() || VERY_LONG_TIME_IN_THE_FUTURE; },
    ClassName: 'end-date'
}, Title = {
    Title: 'Event',
    DisplayValue: function (closure) { return closure.TitleDisplay(); },
    SortValue: function (closure) { return closure.TitleDisplay(); },
    ClassName: 'title'
}, Footmark = {
    Title: 'Ftmk S',
    DisplayValue: function (closure) { return closure.FootmarkDisplay(); },
    SortValue: function (closure) { return closure.Model.Footmark.convert(UOM_1.default.Foot).Num(); },
    ClassName: 'footmark'
}, Endmark = {
    Title: 'Ftmk E',
    DisplayValue: function (closure) { return closure.EndmarkDisplay(); },
    SortValue: function (closure) { return closure.Endmark.convert(UOM_1.default.Foot).Num(); },
    ClassName: 'endmark'
}, Berth = {
    Title: 'Berth',
    DisplayValue: function (closure) { return closure.BerthName(); },
    SortValue: function (closure) { return closure.BerthName(); },
    ClassName: 'berth'
}, Port = {
    Title: 'Port/Region',
    DisplayValue: function (closure) { return closure.PortName(); },
    SortValue: function (closure) { return closure.PortName(); },
    ClassName: 'port'
}, OverlapsCount = {
    Title: 'Overlaps',
    DisplayValue: function (closure) { return '' + closure.OverlapsCount(); },
    SortValue: function (closure) { return closure.OverlapsCount(); },
    ClassName: 'overlaps-count'
};
var DefaultSortColumn = StartDate;
exports.Columns = [
    StartDate,
    EndDate,
    Title,
    Footmark,
    Endmark,
    Berth,
    Port,
    OverlapsCount
];
var CSVColumns = [{
        name: StartDate.Title + " (Date)",
        formatter: function (closure) { return csvExport_1.ExcelDateFormat(closure.Model.StartDate()); }
    }, {
        name: StartDate.Title + " (Time)",
        formatter: function (closure) { return csvExport_1.ExcelTimeFormat(closure.Model.StartDate()); }
    }, {
        name: EndDate.Title + " (Date)",
        formatter: function (closure) { return closure.Model.EndDate() ? csvExport_1.ExcelDateFormat(closure.Model.EndDate()) : ''; }
    }, {
        name: EndDate.Title + " (Time)",
        formatter: function (closure) { return closure.Model.EndDate() ? csvExport_1.ExcelTimeFormat(closure.Model.EndDate()) : ''; }
    }, {
        name: Title.Title,
        formatter: Title.DisplayValue
    }, {
        name: Footmark.Title + " (feet)",
        formatter: function (closure) { return convert(closure.Model.Footmark, UOM_1.default.Foot, 0); }
    }, {
        name: Footmark.Title + " (meters)",
        formatter: function (closure) { return convert(closure.Model.Footmark, UOM_1.default.Meter, 1); }
    }, {
        name: Endmark.Title + " (feet)",
        formatter: function (closure) { return convert(closure.Endmark, UOM_1.default.Foot, 0); }
    }, {
        name: Endmark.Title + " (meters)",
        formatter: function (closure) { return convert(closure.Endmark, UOM_1.default.Meter, 1); }
    }, {
        name: Berth.Title,
        formatter: Berth.DisplayValue,
    }, {
        name: Port.Title,
        formatter: Port.DisplayValue
    }, {
        name: OverlapsCount.Title,
        formatter: OverlapsCount.DisplayValue
    }];
var filterStorageKey = 'portcall.berthclosuresdashboard.filter';
function BerthClosuresDashboard(ajax, entrypoints, cache, user, dateRangeSelectorModel, params) {
    var orgId = params.orgId === undefined ?
        user() ?
            user().OrganizationId() :
            0 :
        params.orgId, dateRangeSelector = dateRangeSelectorModel(params), loading = s_js_1.default.value(true), key = function () { return ({
        OrganizationId: orgId,
        FromDate: dateRangeSelector.FromDate().toJSON(),
        ToDate: dateRangeSelector.ToDate().toJSON()
    }); }, model = s_js_1.default(function () { return cache.BerthClosuresDashboards.update1(null, key()); }), rowSorter = model_1.RowSorter(DefaultSortColumn), filter = s_js_1.default.data(params.filter || localStorage[filterStorageKey] || ''), debouncedFilter = debounceSignal_1.debounceSignal(filter), closures = s_array_1.default([]), sortedClosures = closures.map(BerthClosureViewModel)
        .filter(function (closure) { return diacriticals_1.CaseInsensitiveContains(closure.FilterData(), debouncedFilter()); })
        .sort(rowSorter.RowOrder), ShowActionsMenu = s_js_1.default.value(false), CSVExportLink = s_js_1.default(function () { return csvExport_1.toCSVDataUri(sortedClosures(), CSVColumns); });
    // Store filter
    s_js_1.default(function () {
        localStorage[filterStorageKey] = filter();
    });
    // Fetch data
    s_js_1.default(function () {
        loading(true);
        var req = ajax.Url(entrypoints.BerthClosuresDashboard(key())).Get();
        req.then(function (json) { return cache.BerthClosuresDashboards.update1(req.Date, json); })
            .finally(function () { return loading(false); });
    });
    s_js_1.default(function () { return closures(model().Closures()); });
    return {
        OrgId: orgId,
        Organization: function () { return model().Organization(); },
        Closures: sortedClosures,
        DateRangeSelector: dateRangeSelector,
        Filter: filter,
        Loading: loading,
        RowSorter: rowSorter,
        ShowActionsMenu: ShowActionsMenu,
        CSVExportLink: CSVExportLink
    };
}
exports.BerthClosuresDashboard = BerthClosuresDashboard;
function BerthClosureViewModel(closure) {
    var StartDateDisplay = function () { return tzmoment_1.tzmoment(closure.StartDate()).format(DATE_TIME_FORMAT); }, EndDateDisplay = function () { return closure.EndDate() ? tzmoment_1.tzmoment(closure.EndDate()).format(DATE_TIME_FORMAT) : '--'; }, TitleDisplay = function () { return closure.Title(); }, FootmarkDisplay = function () { return closure.Footmark.toString({ places: 0 }); }, Endmark = closure.Footmark.add(closure.Length), EndmarkDisplay = function () { return Endmark.toString({ places: 0 }); }, BerthName = function () { return closure.Berth() && closure.Berth().Location() && closure.Berth().Location().Name() || '--'; }, PortName = function () { return closure.Berth() && closure.Berth().Location() && closure.Berth().Location().Port() && closure.Berth().Location().Port().Name() || '--'; }, 
    // NOTE: Keep in sync w/ portcall/schedulegrid/model (see BerthClosureModel).
    overlaps = closure.Issues.filter(function (i) {
        return i.Type() === IssueType_1.IssueType.BerthClosureOverlapsOther;
    }).concat(closure.ReservationIssues.filter(function (i) {
        return i.Type() === IssueType_1.IssueType.ReservationOverlapsBerthClosure;
    })), OverlapsCount = function () { return overlaps().length; }, FilterData = function () {
        return StartDateDisplay() + ' ' +
            EndDateDisplay() + ' ' +
            TitleDisplay() + ' ' +
            FootmarkDisplay() + ' ' +
            EndmarkDisplay() + ' ' +
            BerthName() + ' ' +
            PortName() + ' ' +
            OverlapsCount();
    }, ShowActionsMenu = s_js_1.default.value(false);
    return {
        Model: closure,
        StartDateDisplay: StartDateDisplay,
        EndDateDisplay: EndDateDisplay,
        TitleDisplay: TitleDisplay,
        FootmarkDisplay: FootmarkDisplay,
        Endmark: Endmark,
        EndmarkDisplay: EndmarkDisplay,
        BerthName: BerthName,
        PortName: PortName,
        OverlapsCount: OverlapsCount,
        FilterData: FilterData,
        ShowActionsMenu: ShowActionsMenu
    };
}
function convert(v, uom, precision) {
    return v.Num() === null ? '' : new ConvertedMeasurement_1.ConvertedMeasurement(v, uom, precision).toString({ units: false });
}


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayKey = exports.BerthSelector = void 0;
var s_js_1 = __webpack_require__(0);
var diacriticals_1 = __webpack_require__(42);
var model_1 = __webpack_require__(90);
function BerthSelector(_a) {
    var Berths = _a.Berths, SelectedBerth = _a.SelectedBerth;
    var berth = SelectedBerth || s_js_1.default.data(null), query = s_js_1.default.data(s_js_1.default.sample(function () { return berth() ? DisplayKey(berth()) : ''; }));
    // If the berth changes, update the displayed query. Do this even/especially if the
    // berth changes due to some source other than the user selecting an option from the
    // typeahaed.
    s_js_1.default.on(berth, function () { return query(berth() ? DisplayKey(berth()) : ''); }, undefined, true);
    return new model_1.Typeahead({
        collection: Berths,
        matchFn: function (berth, query) {
            return diacriticals_1.CaseInsensitiveStartsWith(DisplayKey(berth), query);
        },
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        observable: query,
        displayKey: DisplayKey,
        onSelect: function (b) { return berth(b); }
    });
}
exports.BerthSelector = BerthSelector;
function DisplayKey(berth) {
    var l = berth.Location(), p = l && l.Port();
    return l ? l.Name() + (p ? " (" + p.Name() + ")" : '') : '';
}
exports.DisplayKey = DisplayKey;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthSelectorView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(91);
exports.BerthSelectorView = supercritical_1.default(function (props) {
    return React.createElement("div", { className: "berth-selector" },
        React.createElement(view_1.TypeaheadInput, __assign({}, props)));
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingRateView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.BookingRateView = supercritical_1.default(function (_a) {
    var bookingRate = _a.bookingRate;
    return React.createElement("div", { className: "bookingrate" },
        React.createElement("div", { className: "bookingrate-label pc-text-accent bookingtip" },
            "Booking Rate",
            React.createElement("span", { className: "glyphicon glyphicon-info-sign" }),
            React.createElement("span", { className: "bookingtiptext" },
                "The Booking Rate is the percentage of ",
                React.createElement("span", { className: "bold" }, "Total Reservations "),
                "during the last year that have an ",
                React.createElement("span", { className: "bold" }, "Actual Arrival"),
                ". Actual Arrivals are reservations where the First Line is logged as",
                React.createElement("span", { className: "italic" }, " actual"),
                ". A 100% Booking Rate means every reservation had an actual arrival. Cancellations lower the Booking Rate. If every reservation was cancelled, the Booking Rate would be 0%. Reservations without a First Line Actual (no-shows or missing actuals) are not counted as Actual Arrivals. They also lower the Booking Rate.")),
        React.createElement("div", { className: "percentage" }, bookingRate() === null ? '--' : bookingRate() + '%'));
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertedMeasurementView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(55);
exports.ConvertedMeasurementView = supercritical_1.default(function (_a) {
    var model = _a.model, _b = _a.disabled, disabled = _b === void 0 ? false : _b, tabindex = _a.tabindex, onFocus = _a.onFocus, _onBlur = _a.onBlur, placeholder = _a.placeholder;
    return React.createElement(view_1.NullableNumericInput, { className: "convertedmeasurement-input", value: model.Num, disabled: disabled, onFocus: onFocus, onBlur: function () { return onBlur({ model: model, _onBlur: _onBlur }); }, tabindex: tabindex, placeholder: placeholder });
});
function onBlur(_a) {
    var model = _a.model, _onBlur = _a._onBlur;
    s_js_1.default.freeze(function () {
        model.RelinquishWriter();
        _onBlur && _onBlur();
    });
}


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationDescriptionView = exports.CoordinationCardDetailsActionsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
exports.CoordinationCardDetailsActionsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationcarddetailsactionstab" },
        React.createElement(CoordinationActions, { model: m }),
        React.createElement(exports.CoordinationDescriptionView, { coordination: m.CoordinationCard.Coordination }));
});
var CoordinationActions = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "ccard-details-actions-tab__section ccard-details-actions-tab__coordination-actions-shell" },
        React.createElement("div", { className: "ccard-details-actions-tab__section-title" }, "Coordination Actions"),
        m.HasAnyAvailableActions() ?
            React.createElement("div", null,
                React.createElement(CancelCoordinationActionView, { action: m.CancelCoordination }),
                React.createElement(ChangeProviderActionView, { action: m.ChangeProvider })) :
            React.createElement("div", { className: "no-actions-available" }, "There are no actions available."));
});
var CancelCoordinationActionView = supercritical_1.default(function (_a) {
    var action = _a.action;
    return action.IsAvailable() ?
        React.createElement("div", { className: "ccard-details-actions-tab__coordination-action cancel-coordination-action" },
            React.createElement("div", { className: "coordination-action-link-shell" },
                React.createElement("a", { href: "", className: "coordination-action-link", onClick: eventWrappers_1.noDefault(function () { return action.IsSelected(true); }) }, "Cancel this Coordination")),
            action.IsSelected() ?
                React.createElement("div", { className: "pc-confirm" },
                    React.createElement("span", { className: "pc-confirm-question" },
                        React.createElement("b", null, "Are you sure?"),
                        " The provider will be notified."),
                    React.createElement("button", { className: "pc-confirm-button pc-confirm-button-primary", onClick: action.Perform, disabled: action.IsPerforming() }, "Yup"),
                    React.createElement("button", { className: "pc-confirm-button", onClick: function () { return action.IsSelected(false); }, disabled: action.IsPerforming() }, "Nope")) :
                React.createElement("div", { className: "coordination-action-description" }, "Turn off coordination for this milestone. The current provider will be notified and the coordination will be reset to \"Inactive.\"")) :
        null;
});
var ChangeProviderActionView = supercritical_1.default(function (_a) {
    var action = _a.action;
    return action.AvailableProviders().length > 0 ?
        React.createElement("div", { className: "ccard-details-actions-tab__coordination-action change-provider-action" },
            React.createElement("div", { className: "coordination-action-link-shell" },
                React.createElement("a", { href: "", className: "coordination-action-link", onClick: eventWrappers_1.noDefault(function () { return action.IsSelected(true); }) }, "Change Provider"),
                action.IsSelected() &&
                    React.createElement("select", { className: "provider-dropdown", value: action.Draft.ProviderId(), onChange: function (e) { return action.Draft.ProviderId(+e.currentTarget.value); } }, action.AvailableProviders().map(function (p) { var _a; return React.createElement("option", { value: p.ProviderId(), key: p.ProviderId() }, (_a = p.Provider()) === null || _a === void 0 ? void 0 : _a.Name()); }))),
            action.IsSelected() ?
                React.createElement("div", { className: "pc-confirm" },
                    React.createElement("span", { className: "pc-confirm-question" },
                        React.createElement("b", null, "Are you sure?"),
                        " Both providers will be notified."),
                    React.createElement("button", { className: "pc-confirm-button pc-confirm-button-primary", onClick: action.Perform, disabled: action.IsPerforming() }, "Yup"),
                    React.createElement("button", { className: "pc-confirm-button", onClick: function () { return action.IsSelected(false); }, disabled: action.IsPerforming() }, "Nope")) :
                React.createElement("div", { className: "coordination-action-description" }, "Change the organization responsible for this coordination. This will set the status to pending (yellow) and notify both organizations of the change.")) :
        null;
});
// UI fragments for consumption here and by the cancelled C-Card details view.
exports.CoordinationDescriptionView = supercritical_1.default(function (_a) {
    var _b;
    var coordination = _a.coordination;
    return React.createElement("div", { className: "ccard-details-actions-tab__section ccard-details-actions-tab__coordination-description-shell" },
        React.createElement("div", { className: "ccard-details-actions-tab__section-title" }, "Coordination Description"),
        React.createElement("div", { className: "coordination-description" }, (_b = coordination()) === null || _b === void 0 ? void 0 : _b.Description()));
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledCoordinationCardDetails = exports.TabSettings = exports.TabLog = void 0;
var s_js_1 = __webpack_require__(0);
var model_1 = __webpack_require__(196);
exports.TabLog = { Title: 'Log' };
exports.TabSettings = { Title: 'Settings' };
function CancelledCoordinationCardDetails(loader, data, logTabModel, settingsTabModel, _a) {
    var CoordinationCard = _a.CoordinationCard, DismissDetails = _a.DismissDetails, ShouldPauseLogUpdates = _a.ShouldPauseLogUpdates;
    loader({ Id: CoordinationCard.Id(), ChangeId: CoordinationCard.ChangeId() });
    var 
    // Upsert Self ourselves so that it doesn't matter if the server has ever sent us the Self object or
    // not.
    Self = data.CoordinationCardSelves.update1(null, { Id: CoordinationCard.Id() }), LogTab = logTabModel({ CoordinationCardSelf: Self }), SettingsTab = settingsTabModel({ CoordinationCard: CoordinationCard }), TabStrip = model_1.PCTabStrip(exports.TabLog, function () { return [exports.TabSettings]; }), Loading = function () {
        return LogTab.Loading();
    };
    // Turn log updater on/off on various triggers...
    s_js_1.default(function () {
        // Basic logic -- run log updates as long as we're on the log tab, or we can get a head start if we
        // know we're flipping to the log tab...
        var tabState = TabStrip.State(), 
        // CAUTION: The log tab is our FRONT tab here, unlike some other spots where we do similar logic
        // for log updates.
        onOrApproachingLogTab = tabState.state === 'settled-on-front' ||
            tabState.state === 'flipping-to-front', 
        // ...but also give calling code a say in whether we should be running log updates.
        shouldRunLogUpdates = onOrApproachingLogTab && !(ShouldPauseLogUpdates === null || ShouldPauseLogUpdates === void 0 ? void 0 : ShouldPauseLogUpdates());
        if (shouldRunLogUpdates)
            LogTab.LogUpdater.start();
        else
            LogTab.LogUpdater.stop();
    });
    return {
        DismissDetails: DismissDetails,
        LogTab: LogTab,
        SettingsTab: SettingsTab,
        TabStrip: TabStrip,
        Loading: Loading
    };
}
exports.CancelledCoordinationCardDetails = CancelledCoordinationCardDetails;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsLogTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var newcommentview_1 = __webpack_require__(194);
var view_1 = __webpack_require__(268);
exports.CoordinationCardDetailsLogTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationcarddetailslog" },
        React.createElement("div", { className: "pc-card" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Log"),
            React.createElement(newcommentview_1.NewCommentView, { model: m.NewComment, topLevel: true, allowTaggingUsers: false })),
        React.createElement(view_1.EventLogView, { model: m.EventLog, allowTaggingUsers: false }));
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetails = exports.TabStatus = exports.TabActions = exports.TabLog = void 0;
var s_js_1 = __webpack_require__(0);
var Rights_1 = __webpack_require__(118);
var model_1 = __webpack_require__(196);
exports.TabLog = { Title: 'Log' };
exports.TabActions = { Title: 'Actions' };
exports.TabStatus = { Title: 'Status' };
function CoordinationCardDetails(loader, data, statusTabModel, actionsTabModel, logTabModel, _a) {
    var CoordinationCard = _a.CoordinationCard, DismissDetails = _a.DismissDetails, ShouldPauseLogUpdates = _a.ShouldPauseLogUpdates;
    var _b = loader({ Id: CoordinationCard.Id() }, 10), detailsResp = _b.model, detailsRespLoading = _b.loading, 
    // Upsert Self ourselves so it doesn't matter whether server has ever sent the Self object
    // to us or not.
    Self = data.CoordinationCardSelves.update1(null, { Id: CoordinationCard.Id() }), StatusTab = statusTabModel({
        CoordinationCard: CoordinationCard,
        DismissDetails: DismissDetails,
        HasEditStatus: function () { return (detailsResp.Rights() & Rights_1.CoordinationCardRights.EditStatus) !== 0; }
    }), ActionsTab = actionsTabModel({
        CoordinationCard: CoordinationCard,
        DismissDetails: DismissDetails,
        Rights: detailsResp.Rights
    }), LogTab = logTabModel({ CoordinationCardSelf: Self }), 
    // NOTE: We'll keep the Actions tab available always, even if there are no individual actions available,
    // b/c it's also the main/only place where non-admins can view the coordination description.
    TabStrip = model_1.PCTabStrip(exports.TabStatus, function () { return [exports.TabActions, exports.TabLog]; }), Loading = function () {
        return detailsRespLoading()
            || StatusTab.Loading()
            || ActionsTab.Loading()
            || LogTab.Loading();
    };
    // Turn log updater on/off on various triggers...
    s_js_1.default(function () {
        // Basic logic -- run log updates as long as we're on the log tab, or we can get a head start if we
        // know we're flipping to the log tab...
        var tabState = TabStrip.State(), onOrApproachingLogTab = tabState.state === 'settled-on-back' && tabState.tab === exports.TabLog ||
            tabState.state === 'flipping-to-back' && tabState.toTab === exports.TabLog, 
        // ...but also give calling code a say in whether we should be running log updates.
        shouldRunLogUpdates = onOrApproachingLogTab && !(ShouldPauseLogUpdates === null || ShouldPauseLogUpdates === void 0 ? void 0 : ShouldPauseLogUpdates());
        if (shouldRunLogUpdates)
            LogTab.LogUpdater.start();
        else
            LogTab.LogUpdater.stop();
    });
    return {
        DismissDetails: DismissDetails,
        StatusTab: StatusTab,
        ActionsTab: ActionsTab,
        LogTab: LogTab,
        TabStrip: TabStrip,
        Loading: Loading
    };
}
exports.CoordinationCardDetails = CoordinationCardDetails;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationDisplayKey = exports.CoordinationConfigurator = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var diacriticals_1 = __webpack_require__(42);
var draftSignals_1 = __webpack_require__(37);
var Monitorable_1 = __webpack_require__(596);
var validationWatcher_1 = __webpack_require__(23);
var Berth_1 = __webpack_require__(107);
var Coordination_1 = __webpack_require__(200);
var CoordinationAltStatusLabel_1 = __webpack_require__(568);
var CoordinationCurrency_1 = __webpack_require__(205);
var CoordinationEditingPolicy_1 = __webpack_require__(605);
var CoordinationLocation_1 = __webpack_require__(569);
var CoordinationLocationType_1 = __webpack_require__(606);
var CoordinationMilestoneType_1 = __webpack_require__(570);
var CoordinationProvider_1 = __webpack_require__(201);
var CoordinationProviderCurrency_1 = __webpack_require__(206);
var model_1 = __webpack_require__(90);
function CoordinationConfigurator(loader, domain, ajax, data, params) {
    // TODO: Better UI warnings about effects of actions like:
    // - Remove a milestone type
    // - Remove a main/related location
    // - Set to mandatory
    var _a, _b;
    var initialDataLoad = params.id === undefined ? null : loader({ Id: params.id }), 
    // Our persisted Coordination, if any. A signal so we can update it after a successful save.
    persisted = s_js_1.default.value((_a = initialDataLoad === null || initialDataLoad === void 0 ? void 0 : initialDataLoad.model) !== null && _a !== void 0 ? _a : null), upstream = (_b = s_js_1.default.sample(persisted)) !== null && _b !== void 0 ? _b : new Coordination_1.Coordination({
        Id: 0,
        Currency: CoordinationCurrency_1.CoordinationCurrency.Current,
        DisplayOrder: s_js_1.default.sample(function () {
            var max = -1;
            for (var _i = 0, _a = domain.Coordinations(); _i < _a.length; _i++) {
                var coord = _a[_i];
                if (coord.DisplayOrder() > max)
                    max = coord.DisplayOrder();
            }
            return max + 1;
        })
    }), _c = makeDraftObject(upstream), draft = _c.object, draftMethods = _c.methods, url = function () { var _a, _b; return (_b = (persisted() ? (_a = persisted()) === null || _a === void 0 ? void 0 : _a.Url() : domain.CoordinationsUrl())) !== null && _b !== void 0 ? _b : ''; }, 
    // NOTE: DON'T use our data cache. The server isn't currently setup to return DataCacheUpdate responses
    // for either of these endpoints anyway, but even if it were, modifying coordinations can sometimes
    // add/remove a lot of C-Cards, and we don't wanna burden the server or the client w/ serializing and
    // deserializing every single one of them.
    client = ajax.Url(url, {
        include: [
            function (c) { return c.AltStatusLabels; },
            function (c) { return c.MilestoneTypes; },
            function (c) { return c.Locations; },
            function (c) { return c.Providers; },
        ]
    }), ServerValidation = validationWatcher_1.ValidationWatcher(client), CoordinationCardStatuses = s_array_1.lift(function () { return Array.from(data.CoordinationCardStatuses.items()); })
        .map(function (status) { return CCardStatusViewModel(draft, status, ServerValidation); })
        .orderBy(function (status) { return status.Model.DisplayOrder(); }), MilestoneTypes = s_array_1.lift(function () { return Array.from(data.MilestoneTypes.items()); })
        .map(function (type) { return MilestoneTypeViewModel(draft, type); })
        .orderBy(function (type) { return type.Model.DisplayOrder(); }), NumMilestoneTypesSelected = s_js_1.default(function () { return MilestoneTypes().filter(function (type) { return type.IsSelected(); }).length; }), allLocations = draft.Locations
        .map(function (cl) { return LocationViewModel(draft, cl); }), MainLocations = allLocations
        .filter(function (l) { return l.Model.Type() === CoordinationLocationType_1.CoordinationLocationType.Main; })
        .sort(LocationVMComparator), AddMainLocation = AddLocationViewModel(draft, CoordinationLocationType_1.CoordinationLocationType.Main, data), RelatedLocations = allLocations
        .filter(function (l) { return l.Model.Type() === CoordinationLocationType_1.CoordinationLocationType.Related; })
        .sort(LocationVMComparator), AddRelatedLocation = AddLocationViewModel(draft, CoordinationLocationType_1.CoordinationLocationType.Related, data), addingNewProviders = s_js_1.default.value(false), Providers = draft.Providers
        .map(function (cp) { return ProviderViewModel(draft, cp, !s_js_1.default.sample(addingNewProviders)); })
        .sort(function (cp1, cp2) { return CoordinationProvider_1.CoordinationProvider.DisplayOrder(cp1.Model, cp2.Model); }), AddProvider = AddProviderViewModel(draft, data, addingNewProviders), 
    // We'll handle most validation server-side (see ServerValidation declared above). But validating that
    // there's at least one current provider is handled more easily client-side, so we do that here.
    HasCurrentProvider = function () { return draft.Providers().some(function (p) { return p.Currency() === CoordinationProviderCurrency_1.CoordinationProviderCurrency.Current; }); }, ClientValidationErrorsCount = function () {
        var count = 0;
        if (!HasCurrentProvider())
            count++;
        return count;
    }, SavingChanges = s_js_1.default.value(false);
    s_js_1.default(function (initialRun) {
        if (draft.IsMandatory() && !initialRun)
            draft.AgentPrompt(null);
        return false;
    }, true);
    // Clear main locations if not scoped by main location.
    s_js_1.default(function (initialRun) {
        if (!draft.IsScopedByMainLocation() && !initialRun) {
            // Go through each location VM's Delete method to honor the limitations of our draftArray util below.
            s_js_1.default.sample(MainLocations).forEach(function (l) { return l.Delete(); });
        }
        return false;
    }, true);
    // Clear related locations if not scoped by related location.
    s_js_1.default(function (initialRun) {
        if (!draft.IsScopedByRelatedLocation() && !initialRun) {
            // Go through each location VM's Delete method to honor the limitations of our draftArray util below.
            s_js_1.default.sample(RelatedLocations).forEach(function (l) { return l.Delete(); });
        }
        return false;
    }, true);
    // Whenever addingNewProviders is set to true, set it back to false on the next tick of S's clock.
    s_js_1.default.on(addingNewProviders, function () { return addingNewProviders(false); });
    return {
        Loading: function () { var _a; return (_a = initialDataLoad === null || initialDataLoad === void 0 ? void 0 : initialDataLoad.loading()) !== null && _a !== void 0 ? _a : false; },
        Model: draft,
        ServerValidation: ServerValidation,
        CoordinationCardStatuses: CoordinationCardStatuses,
        MilestoneTypes: MilestoneTypes,
        NumMilestoneTypesSelected: NumMilestoneTypesSelected,
        MainLocations: MainLocations,
        AddMainLocation: AddMainLocation,
        RelatedLocations: RelatedLocations,
        AddRelatedLocation: AddRelatedLocation,
        Providers: Providers,
        AddProvider: AddProvider,
        OnSortProviders: OnSortProviders,
        HasCurrentProvider: HasCurrentProvider,
        ClientValidationErrorsCount: ClientValidationErrorsCount,
        IsPersisted: function () { return !!persisted(); },
        HasUnsavedChanges: function () { return !persisted() || draftMethods.isCaching(); },
        SaveChanges: SaveChanges,
        SavingChanges: SavingChanges,
        QuitChanges: QuitChanges
    };
    function makeDraftObject(upstream) {
        return s_js_1.default.sample(function () {
            var _a = draftSignals_1.DraftObject(upstream), draft = _a.object, methods = _a.methods, allMethods = [methods];
            draft.AltStatusLabels = draftArray(upstream.AltStatusLabels, function (l) { return l.StatusId(); });
            draft.MilestoneTypes = draftArray(upstream.MilestoneTypes, function (t) { return t.MilestoneTypeId(); });
            draft.Locations = draftArray(upstream.Locations, function (l) { return l.LocationId() + ":" + l.Type(); });
            draft.Providers = draftArray(upstream.Providers, function (p) { return p.ProviderId(); });
            return {
                object: draft,
                methods: draftSignals_1.mergeDraftMethods.apply(void 0, allMethods)
            };
            // TODO: Since writing this draftArray utility, I've added an attempt at an even more generic way
            // of doing the same thing. See PortCall.FrontEnd\lib\draftArray.ts. It might be worth trying to
            // switch to that version here. BUT BEWARE: The new DraftArray utility is NOT a drop-in replacement
            // for this one. The biggest difference is that this utility tries to be responsible for making
            // draft objects for each item in the original array, whereas the new DraftArray utility puts that
            // responsibility on calling code. PortCall.FrontEnd\apps\portcall\inportops\model.ts has examples
            // of how to use the new utility. But b/c those DraftArrays are for collections of one-to-many child
            // entities (cargo and cruise activities), and the ones here are for collections of many-to-many
            // child entities, there will have to be a few differences:
            // - This spot should use the MergeByKey function exported by PortCall.FrontEnd\lib\draftArray.ts
            //   instead of the MergeByObjectIdentity function.
            // - We need to handle cases like the following:
            //   - User defines a new AltStatusLabel (for example) at a point in time at which we believe the
            //     original AltStatusLabels array signal has no matching entry for that particular StatusId.
            //   - Later, the original AltStatusLabels array signal is updated so that it DOES now have a
            //     matching entry for that particular StatusId, but the matching entry is a DIFFERENT
            //     CoordinationAltStatusLabel object. B/c we'll use MergeByKey, we'll correctly swap in the new
            //     "official" CoordinationAltStatusLabel object in place of the one we added when we thought
            //     there was no such official object. Cool.
            //   - But we'll still have a draft CoordinationAltStatusLabel object that references our TEMPORARY
            //     CoordinationAltStatusLabel object as its upstream data source. To avoid throwing away those
            //     pending user edits, when making a new draft object for the new OFFICIAL
            //     CoordinationAltStatusLabel object, we should make sure to detect that we'd already made a
            //     draft object for the same StatusId and copy that old draft object's payload fields over to
            //     the new draft object before we forget about the old draft object.
            //   - The same concern comes up for all the draft arrays here, not just AltStatusLabels.
            // Anyhow, skipping the above for now.
            //
            // Original comment:
            // Construct an array that mirrors an upstream/original array signal except that it holds draft
            // objects instead of committed model objects and can have objects added to/removed from it w/o
            // affecting the upstream array signal. While this is fairly generic, it's NOT intended as a
            // general solution for making "draft" signals that implement the SArray.ArrayDataSignal interface.
            // In particular, this implementation makes the following assumptions:
            //  - It assumes the order of elements in the resulting draft array signal is irrelevant.
            //  - It assumes that objects will only be added to or removed from the resulting draft array signal
            //    via its push and remove methods.
            //  - Each array signal's elements can be uniquely indexed via the provided key func.
            // All three assumptions are safe in our case.
            function draftArray(original, keyFunc) {
                var version = 0;
                var onReinit = s_js_1.default.data(null), isCaching = s_js_1.default.value(false), drafts = Monitorable_1.Monitorable(s_array_1.default([])), methodsCache = new Map(), pushed = new Set(), removed = new Set(), logWrite = function () { return (version++, isCaching(true)); }, monitor = {
                    push: function (item) {
                        var key = keyFunc(item);
                        pushed.add(key);
                        removed.delete(key);
                        logWrite();
                    },
                    remove: function (item) {
                        methodsCache.delete(item);
                        var key = keyFunc(item);
                        pushed.delete(key);
                        removed.add(key);
                        logWrite();
                    }
                };
                Monitorable_1.Monitor(drafts, monitor);
                // Add matching draft objects as new objects are added to the upstream array, but only so long
                // as we haven't already made a draft object for the upstream object and haven't explicitly
                // removed a matching draft object from the downstream array.
                s_js_1.default(function () {
                    onReinit();
                    var draftsByKey = new Map();
                    for (var _i = 0, _a = s_js_1.default.sample(drafts); _i < _a.length; _i++) {
                        var draft_1 = _a[_i];
                        draftsByKey.set(keyFunc(draft_1), draft_1);
                    }
                    var newDrafts = [];
                    for (var _b = 0, _c = original(); _b < _c.length; _b++) {
                        var obj = _c[_b];
                        var key = keyFunc(obj);
                        // Skip if explicitly removed, and also skip if explicitly pushed b/c we'll do those
                        // below.
                        if (!removed.has(key) && !pushed.has(key)) {
                            var draft_2 = draftsByKey.get(key);
                            if (!draft_2) {
                                var _d = draftSignals_1.DraftObject(obj), object = _d.object, methods_1 = _d.methods;
                                methodsCache.set(object, methods_1);
                                draft_2 = object;
                            }
                            newDrafts.push(draft_2);
                        }
                    }
                    pushed.forEach(function (key) { return newDrafts.push(draftsByKey.get(key)); });
                    drafts(newDrafts);
                });
                allMethods.push({
                    isCaching: function () { return isCaching() || drafts().some(function (d) { var _a, _b; return (_b = (_a = methodsCache.get(d)) === null || _a === void 0 ? void 0 : _a.isCaching()) !== null && _b !== void 0 ? _b : false; }); },
                    // onWrite would be kinda annoying to support b/c really we should be catching writes to
                    // new objects pushed by downstream code in addition to draft objects constructed above.
                    // But we don't ever need this onWrite anyway.
                    onWrite: function () { throw new Error("Not implementing onWrite for draftArray."); },
                    checkpoint: function () {
                        var checkpointVersion = version;
                        return {
                            commit: function () {
                                // Committing would be kinda annoying to support b/c really we should
                                // preserve object identity for objects that already exist in the upstream
                                // array. But we don't ever need to commit anyway.
                                throw new Error("Not implementing commit for draftArray.");
                            },
                            revert: function () {
                                if (checkpointVersion === version) {
                                    // Reverting just means re-initing from the upstream array.
                                    // FIXME: There's a hole here: OK, so we'll re-init from the usptream
                                    // array. But what if some child item has been written to since when
                                    // this checkpoint was taken? As is, we'll throw away those edits
                                    // unless we've ALSO added or removed child items since this
                                    // checkpoint was taken. Basically, our version counter doesn't count
                                    // writes to child items, only push or remove calls to this draft
                                    // array. Since the current UX is that we return to the coordinations
                                    // overview list after a successful save, this doesn't matter in
                                    // practice for now, as we're gonna lose any user edits made while the
                                    // save is in progress anyway. But if we switch to letting users stay
                                    // on this configurator page after a successful save, then we might
                                    // wanna tackle this one; the current behavior would be that we might
                                    // throw away edits to child items that the user made while the save
                                    // was in progress. We should probably do that in combo w/ switching to
                                    // the newer DraftArray utility from PortCall.FrontEnd\lib\draftArray.ts.
                                    // See TODO comment above.
                                    s_js_1.default.freeze(function () {
                                        onReinit(null);
                                        isCaching(false);
                                        drafts([]);
                                        methodsCache.clear();
                                        pushed.clear();
                                        removed.clear();
                                    });
                                }
                            }
                        };
                    }
                });
                return drafts;
            }
        });
    }
    function OnSortProviders(_movedProvider, newOrder) {
        s_js_1.default.freeze(function () { return newOrder.forEach(function (p, i) { return p.Model.DisplayOrder(i); }); });
    }
    function SaveChanges() {
        // TODO: A nice-to-have here would be diffing to see if the save is likely to require adding/removing C-Cards
        // (i.e. the save will trigger
        // PortCall.Services\CoordinationCards\CoordinationConfigurationChanged_SyncCCards.cs), and if so spawn a
        // confirmation popup to make sure admins realize what they're doing.
        if (SavingChanges())
            return;
        SavingChanges(true);
        var req = persisted() ? client.Put(draft) : client.Post(draft), checkpoint = draftMethods.checkpoint();
        req.then(function (coordData) {
            s_js_1.default.freeze(function () {
                // Use our upstream Coordination as a template such that if this is a new Coordination that we
                // just saved, we'll attach it to our PCCache and reverting below will pick up the values
                // persisted from the server.
                data.Coordinations.update1(req.Date, coordData, upstream);
                // Record that we have a persisted Coordination now.
                persisted(upstream);
                // Revert draft changes to pick up the updated values from our PCCache. This is future proofing
                // in case we ever decide we want users to stay on this page after saving to be able to make
                // further edits. For now, redundant b/c we're gonna navigate to the coordinations overview
                // page next and thus throw away this page's in memory state anyway.
                checkpoint.revert();
            });
            QuitChanges();
        }).finally(function () { return SavingChanges(false); });
    }
    function QuitChanges() {
        window.location.href = '#!coordinationsoverview';
    }
}
exports.CoordinationConfigurator = CoordinationConfigurator;
function CCardStatusViewModel(coordination, status, serverValidation) {
    var altLabelIndex = s_js_1.default(function () { return coordination.AltStatusLabels().findIndex(function (l) { return l.Status() === status; }); }), altLabel = function () { return altLabelIndex() >= 0 ? coordination.AltStatusLabels()[altLabelIndex()] : null; }, AltLabelText = function (val) {
        var _a, _b;
        if (val === undefined) {
            return (_b = (_a = altLabel()) === null || _a === void 0 ? void 0 : _a.Label()) !== null && _b !== void 0 ? _b : '';
        }
        else {
            s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
                var l = altLabel();
                if (val) {
                    if (!l) {
                        l = new CoordinationAltStatusLabel_1.CoordinationAltStatusLabel({
                            CoordinationId: coordination.Id(),
                            StatusId: status.Id()
                        });
                        l.Status(status);
                        coordination.AltStatusLabels.push(l);
                    }
                    l.Label(val);
                }
                else if (l) {
                    coordination.AltStatusLabels.remove(l);
                    // We're removing an object from our AltStatusLabels array, so if we did nothing to our
                    // serverValidation collection, that'd cause our matching of validation errors to
                    // CCardStatusViewModels to get off for all CCardStatusViewModels that happened to have
                    // a higher altLabelIndex than this one. For an easy fix, we'll just throw away any
                    // validation error related to our AltStatusLabels array.
                    serverValidation(validationWatcher_1.filterErrors(serverValidation(), function (key) { return key.indexOf('AltStatusLabels') !== 0; }));
                }
            }); });
            return val;
        }
    }, validationPrefix = function () { return "AltStatusLabels[" + altLabelIndex() + "]."; }, filteredValidation = function () { return validationWatcher_1.mapErrorKeys(validationWatcher_1.filterErrors(serverValidation(), function (key) { return key.indexOf(validationPrefix()) === 0; }), function (key) { return key.substring(validationPrefix().length); }); }, IsEditingLabel = s_js_1.default.value(false);
    return {
        Model: status,
        AltLabelText: AltLabelText,
        ServerValidation: filteredValidation,
        IsEditingLabel: IsEditingLabel
    };
}
function MilestoneTypeViewModel(coordination, type) {
    var coordType = s_js_1.default(function () { var _a; return (_a = coordination.MilestoneTypes().find(function (t) { return t.MilestoneType() === type; })) !== null && _a !== void 0 ? _a : null; }), IsSelected = function (val) {
        if (val === undefined) {
            return !!coordType();
        }
        else {
            s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
                var t = coordType();
                if (val && !t) {
                    t = new CoordinationMilestoneType_1.CoordinationMilestoneType({
                        CoordinationId: coordination.Id(),
                        MilestoneTypeId: type.Id()
                    });
                    t.MilestoneType(type);
                    coordination.MilestoneTypes.push(t);
                }
                else if (t && !val) {
                    coordination.MilestoneTypes.remove(t);
                }
            }); });
            return val;
        }
    };
    return { Model: type, IsSelected: IsSelected };
}
function LocationViewModel(coordination, cl) {
    return { Model: cl, Delete: Delete };
    function Delete() {
        coordination.Locations.remove(cl);
    }
}
function LocationVMComparator(cl1, cl2) {
    // Order locations as we do on the berth timeline, i.e. by Port, then by PierGroup, then by Berth.
    var l1 = cl1.Model.Location(), p1 = l1 === null || l1 === void 0 ? void 0 : l1.Port(), b1 = l1 === null || l1 === void 0 ? void 0 : l1.Berth(), pg1 = b1 === null || b1 === void 0 ? void 0 : b1.PierGroup(), l2 = cl2.Model.Location(), p2 = l2 === null || l2 === void 0 ? void 0 : l2.Port(), b2 = l2 === null || l2 === void 0 ? void 0 : l2.Berth(), pg2 = b2 === null || b2 === void 0 ? void 0 : b2.PierGroup();
    return (p1 ?
        p2 ?
            p2 === p1 ?
                b1 ?
                    b2 ?
                        pg1 ?
                            pg2 ?
                                pg2 === pg1 ?
                                    Berth_1.Berth.StartMarkOrder(b1, b2) :
                                    PierGroupComparator(pg1, pg2) :
                                -1 /* sort berths w/ missing piergroup last among berths for that port */ :
                            pg2 ?
                                1 /* sort berths w/ missing piergroup last among berths for that port */ :
                                0 :
                        1 /* sort locations w/ no berth (like port arrival/departure points) ahead of berths */ :
                    b2 ?
                        -1 /* sort locations w/ no berth (like port arrival/departure points) ahead of berths */ :
                        // We've already confirmed p1 and p2 are both truthy, which means l1 and l2 HAVE to
                        // be truthy too. Typescript's nullability analysis just doesn't seem to get that.
                        BerthlessLocationComparator(l1, l2) :
                PortComparator(p1, p2) :
            -1 /* sort locations w/ missing Port last */ :
        p2 ?
            1 /* sort locations w/ missing Port last */ :
            0);
}
// Compare Locations that are in the same Port and don't have berths.
function BerthlessLocationComparator(l1, l2) {
    // Neither has a berth. Sort by name case-insensitively, I guess?
    var name1 = l1.Name().toLowerCase(), name2 = l2.Name().toLowerCase();
    return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
}
// Compare PierGroups that are in the same Port.
function PierGroupComparator(pg1, pg2) {
    var diff = pg1.Order() - pg2.Order();
    // Sort by Id as a fallback if orders are the same
    return diff === 0 ? pg1.Id() - pg2.Id() : diff;
}
// Compare Ports that are in the same Domain.
function PortComparator(p1, p2) {
    var diff = p1.Order() - p2.Order();
    // Sort by Id as a fallback if orders are the same
    return diff === 0 ? p1.Id() - p2.Id() : diff;
}
function AddLocationViewModel(coordination, type, data) {
    var selectedLocations = s_js_1.default(function () {
        var sel = new Set();
        for (var _i = 0, _a = coordination.Locations(); _i < _a.length; _i++) {
            var cl = _a[_i];
            if (cl.Type() === type && cl.Location())
                sel.add(cl.Location());
        }
        return sel;
    }), availableLocations = s_js_1.default(function () {
        var sel = selectedLocations();
        return Array.from(data.Locations.items()).filter(function (l) { return !sel.has(l); });
    }), locationToAdd = s_js_1.default.value(null), locationQuery = s_js_1.default.value(''), LocationSelector = new model_1.Typeahead({
        collection: availableLocations,
        matchFn: function (l, query) { return diacriticals_1.CaseInsensitiveContains(LocationDisplayKey(l), query); },
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        observable: locationQuery,
        displayKey: LocationDisplayKey,
        onSelect: function (l) { return locationToAdd(l); }
    });
    s_js_1.default.on(locationToAdd, function () { return locationQuery(locationToAdd() ? LocationDisplayKey(locationToAdd()) : ''); });
    s_js_1.default.on(locationToAdd, function () {
        var l = locationToAdd();
        if (l) {
            s_js_1.default.freeze(function () {
                var cl = new CoordinationLocation_1.CoordinationLocation({
                    CoordinationId: coordination.Id(),
                    LocationId: l.Id(),
                    Type: type
                });
                cl.Location(l);
                coordination.Locations.push(cl);
                // Clear our typeahead for faster entry of the next location, if any.
                locationToAdd(null);
            });
        }
    });
    return { LocationSelector: LocationSelector };
}
function LocationDisplayKey(l) {
    var _a, _b;
    return l.Name() + " (" + ((_b = (_a = l.Port()) === null || _a === void 0 ? void 0 : _a.Name()) !== null && _b !== void 0 ? _b : 'loading...') + ")";
}
exports.LocationDisplayKey = LocationDisplayKey;
function ProviderViewModel(coordination, provider, IsPersisted) {
    return {
        Model: provider,
        IsPersisted: IsPersisted,
        GetEditingPolicyBits: GetEditingPolicyBits,
        SetEditingPolicyBits: SetEditingPolicyBits,
        Delete: Delete
    };
    /**
     * Get the provider's EditingPolicy for the bits indicated by the provided mask.
     */
    function GetEditingPolicyBits(mask) {
        return provider.EditingPolicy() & mask;
    }
    /**
     * Set the provider's EditingPolicy for the bits indicated by the provided mask using the bit values from
     * the provided value.
     */
    function SetEditingPolicyBits(mask, value) {
        // NOTE: Use of JS bitwise NOT (~) operator assumes CoordinationEditingPolicy enum stays w/in the range
        // of a 32-bit integer, which it currently does.
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_NOT
        provider.EditingPolicy(s_js_1.default.sample(provider.EditingPolicy) & ~mask | value & mask);
    }
    function Delete() {
        // The server would technically let us delete a persisted provider so long as it doesn't have any
        // existing C-Cards. But trying to delete a provider w/ existing C-Cards would throw a 500 error.
        // So for now, we'll be conservative and say you can't delete persisted providers at all. Deprecating
        // achieves more or less the same thing except that the provider is still visible on this configurator
        // page.
        if (IsPersisted)
            throw new Error("Can't delete persisted coordination providers. Deprecate instead.");
        coordination.Providers.remove(provider);
    }
}
function AddProviderViewModel(coordination, data, addingNewProviders) {
    var selectedProviders = s_js_1.default(function () {
        var sel = new Set();
        for (var _i = 0, _a = coordination.Providers(); _i < _a.length; _i++) {
            var cp = _a[_i];
            if (cp.Provider())
                sel.add(cp.Provider());
        }
        return sel;
    }), availableProviders = s_js_1.default(function () {
        var sel = selectedProviders();
        return Array.from(data.Organizations.items()).filter(function (b) { return !sel.has(b); });
    }), providerToAdd = s_js_1.default.value(null), providerQuery = s_js_1.default.value(''), ProviderSelector = new model_1.Typeahead({
        collection: availableProviders,
        matchFn: function (org, query) { return diacriticals_1.CaseInsensitiveContains(ProviderDisplayKey(org), query); },
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        observable: providerQuery,
        displayKey: ProviderDisplayKey,
        onSelect: function (org) { return providerToAdd(org); }
    });
    s_js_1.default.on(providerToAdd, function () { return providerQuery(providerToAdd() ? ProviderDisplayKey(providerToAdd()) : ''); });
    s_js_1.default.on(providerToAdd, function () {
        var p = providerToAdd();
        if (p) {
            s_js_1.default.freeze(function () {
                var maxDisplayOrder = -1;
                for (var _i = 0, _a = coordination.Providers(); _i < _a.length; _i++) {
                    var otherCP = _a[_i];
                    if (otherCP.DisplayOrder() > maxDisplayOrder)
                        maxDisplayOrder = otherCP.DisplayOrder();
                }
                var cp = new CoordinationProvider_1.CoordinationProvider({
                    CoordinationId: coordination.Id(),
                    ProviderId: p.Id(),
                    DisplayOrder: maxDisplayOrder + 1,
                    // Default to the more permissive option and admins can opt into the more restrictive behavior.
                    EditingPolicy: CoordinationEditingPolicy_1.CoordinationEditingPolicy.AllowAgentStatusEdits
                });
                cp.Provider(p);
                addingNewProviders(true);
                coordination.Providers.push(cp);
                // Clear our typeahead for faster entry of the next provider, if any.
                providerToAdd(null);
            });
        }
    });
    return { ProviderSelector: ProviderSelector };
}
function ProviderDisplayKey(provider) {
    return provider.Name();
}


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CropImage = exports.CropSelection = void 0;
var SaveImageRequest_1 = __webpack_require__(1346);
var CropSelection = /** @class */ (function () {
    function CropSelection(x1, y1, x2, y2) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    CropSelection.prototype.toArray = function () {
        return [this.x1, this.y1, this.x2, this.y2];
    };
    return CropSelection;
}());
exports.CropSelection = CropSelection;
function CropImage(ajax, _a) {
    var imageUrl = _a.imageUrl, imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, initialSelection = _a.initialSelection, minSize = _a.minSize, saveUrl = _a.saveUrl, onComplete = _a.onComplete, onCloseModal = _a.onCloseModal;
    var saveImageRequest = new SaveImageRequest_1.SaveImageRequest({ RawUrl: imageUrl }), _initialSelection;
    if (initialSelection) {
        _initialSelection = initialSelection;
    }
    else {
        // if initial selection is not provided, set initial selection to be maximum possible square in middle of image
        var minDimension = Math.min(imageHeight, imageWidth), xOffset = (imageWidth - minDimension) / 2, yOffset = (imageHeight - minDimension) / 2;
        _initialSelection = new CropSelection(xOffset, yOffset, imageWidth - xOffset, imageHeight - yOffset);
    }
    return {
        ImageUrl: imageUrl,
        InitialSelection: _initialSelection,
        MinSize: minSize,
        OnJCropSelect: OnJCropSelect,
        SaveSelection: SaveSelection,
        Cancel: Cancel
    };
    function OnJCropSelect(coords) {
        SaveImageRequest_1.SaveImageRequest.update(saveImageRequest, {
            CropX1: coords.x,
            CropY1: coords.y,
            CropX2: coords.x2,
            CropY2: coords.y2
        });
    }
    function SaveSelection() {
        ajax.Url(saveUrl).Post(saveImageRequest)
            .then(function (data) {
            onComplete(data);
            onCloseModal();
        });
    }
    function Cancel() {
        onCloseModal();
    }
}
exports.CropImage = CropImage;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableDateTimeEditPopup = exports.DateTimeEditPopup = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
var TZDate_1 = __webpack_require__(7);
var autoSave_1 = __webpack_require__(31);
var draftSignals_1 = __webpack_require__(37);
function DateTimeEditPopupGeneric(_a) {
    var value = _a.value, onDismiss = _a.onDismiss, validation = _a.validation;
    var draft = draftSignals_1.DraftSignal(value, TZDate_1.default.nullableEq), validator = DateTimeValidator({ draft: draft, validation: validation });
    var saveQueued = false;
    return {
        Draft: function (val) { return val === undefined ? draft() : draft(val); },
        Save: Save,
        Cancel: function () { return onDismiss(0 /* Canceled */); },
        ValidationErrors: validator.Errors
    };
    function Save() {
        if (saveQueued)
            return;
        validator.QueuePostValidationTask(function () {
            saveQueued = false;
            // Don't save if there are errors
            if (validator.Errors().length)
                return;
            s_js_1.default.freeze(function () {
                var wasEdited = s_js_1.default.sample(draft.isCaching);
                draft.checkpoint().commit();
                onDismiss(wasEdited ? 2 /* OKWasEdited */ : 1 /* OKNotEdited */);
            });
        });
    }
}
function DateTimeValidator(_a) {
    var draft = _a.draft, _b = _a.validation, validation = _b === void 0 ? {} : _b;
    var validate = validation.validate || (function () { return Promise.resolve(); }), writtenVersion = s_js_1.default.on(draft.onWrite, function (prev) { return prev + 1; }, 0, true);
    // If runOnStart, we initialize the validatedVersion to be less than the written version,
    // otherwise we assume initial state has been validated.
    var validatedVersion = s_js_1.default.sample(writtenVersion) + (validation.runOnStart ? -1 : 0), validationTask = null, postValidationTasks = [];
    autoSave_1.AutoSaver(draft.onWrite, function () {
        var version = writtenVersion();
        validationTask = validate(draft()).finally(function () {
            validatedVersion = version;
            validationTask = null;
        });
        postValidationTasks.forEach(function (task) { return validationTask.finally(task); });
        postValidationTasks = [];
        return validationTask;
    }, 0, !validation.runOnStart);
    return {
        QueuePostValidationTask: QueuePostValidationTask,
        Errors: function () { return (validation.errors ? validation.errors() : []); }
    };
    /**
     * Queue a task to run after the next pending validation, if any.
     * If no pending validation, queue the task to run on the next tick.
     */
    function QueuePostValidationTask(task) {
        if (s_js_1.default.sample(writtenVersion) === validatedVersion)
            Promise.resolve().then(task);
        else if (validationTask)
            validationTask.finally(task);
        else
            postValidationTasks.push(task);
    }
}
function DateTimeEditPopup(params) {
    return DateTimeEditPopupGeneric(params);
}
exports.DateTimeEditPopup = DateTimeEditPopup;
function NullableDateTimeEditPopup(params) {
    return DateTimeEditPopupGeneric(params);
}
exports.NullableDateTimeEditPopup = NullableDateTimeEditPopup;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableDateTimeEditPopupTrigger = exports.DateTimeEditPopupTrigger = exports.NullableDateTimeEditPopupView = exports.DateTimeEditPopupView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var $ = __webpack_require__(27);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(60);
var view_2 = __webpack_require__(22);
// TH 07/10/2017 -- A popup for editing a TZDate's date and time portions simultaneously.
// See note in ./model for rationale.
// Splitting the popup component from the trigger component so that the popup can
// potentially live inside a different parent element than the trigger. This avoids
// position: fixed issues on the PJO details popup in particular.
var DateTimeEditPopupView = function (props) {
    return React.createElement(PopupView, __assign({}, props, { nullable: false }));
};
exports.DateTimeEditPopupView = DateTimeEditPopupView;
var NullableDateTimeEditPopupView = function (props) {
    return React.createElement(PopupView, __assign({}, props, { nullable: true }));
};
exports.NullableDateTimeEditPopupView = NullableDateTimeEditPopupView;
var PopupView = /** @class */ (function (_super) {
    __extends(PopupView, _super);
    function PopupView(props) {
        var _this = _super.call(this, props) || this;
        _this.dateInputRef = supercritical_1.SuperCriticalReference(_this, function (props, el) {
            // TH 07/14/2017 -- Same technique as login popup to autofocus date input.
            // See portcall/login/view.tsx.
            var $modal = $(el).closest('.modal'), focus = function () {
                el.focus();
                el.select();
            };
            $modal.on('shown.bs.modal', focus);
            s_js_1.default.cleanup(function () { return $modal.off('shown.bs.modal', focus); });
        });
        _this.validationUpdatesPaused = s_js_1.default.value(false);
        s_js_1.default.root(function () { return s_js_1.default(function () {
            if (_this.smounted() && _this.validationUpdatesPaused()) {
                var unpause_1 = function () { return _this.validationUpdatesPaused(false); };
                document.addEventListener('mouseup', unpause_1);
                document.addEventListener('touchend', unpause_1);
                s_js_1.default.cleanup(function () {
                    document.removeEventListener('mouseup', unpause_1);
                    document.removeEventListener('touchend', unpause_1);
                });
            }
        }); });
        return _this;
    }
    PopupView.prototype.srender = function (_a) {
        var _this = this;
        var modelContainer = _a.modelContainer, nullable = _a.nullable, title = _a.title, rest = __rest(_a, ["modelContainer", "nullable", "title"]);
        var m = modelContainer();
        return (React.createElement(view_2.PCModal, { className: "datetimeedit-popup", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
            React.createElement("div", { className: "modal-content pc-card" },
                React.createElement("div", { className: "pc-card-header pc-card-title" }, title || 'Change Date and Time'),
                React.createElement("form", { onSubmit: m ? eventWrappers_1.noDefault(m.Save) : undefined },
                    React.createElement("div", null, m && (nullable ?
                        React.createElement(view_1.NullableDateTimePicker, __assign({ value: m.Draft, inputRef: { date: this.dateInputRef } }, rest)) :
                        React.createElement(view_1.DateTimePicker, __assign({ value: m.Draft, inputRef: { date: this.dateInputRef } }, rest)))),
                    m &&
                        React.createElement(ValidationErrors, { errors: m.ValidationErrors, paused: this.validationUpdatesPaused }),
                    React.createElement("div", { className: "controls" },
                        React.createElement("a", { href: "", className: "cancel-btn", onClick: m ? eventWrappers_1.noDefault(m.Cancel) : undefined }, "Cancel"),
                        React.createElement("button", { className: "pc-button", 
                            // Pausing validation error updates while the submit button is clicked.
                            // This fixes a silly bug that occurs when:
                            //   1) The user types into the Kendo widget, then
                            //   2) Without blurring the Kendo input first, they hit OK, and
                            //   3) The new value causes the height of the rendered validation errors to decrease.
                            // The observed outcome is that the user's OK click seems to get ignored, such that
                            // they have to click OK a 2nd time. The problem is that when the validation errors'
                            // height decreases, the OK button moves up while the user's click is still in progress.
                            // So when the user releases their click, they're no longer over the OK button.
                            // Pausing the validation update fixes the issue.
                            onMouseDown: function () { return _this.validationUpdatesPaused(true); }, onTouchStart: function () { return _this.validationUpdatesPaused(true); } }, "OK"))))));
    };
    return PopupView;
}(supercritical_1.SuperCriticalComponent));
var ValidationErrors = /** @class */ (function (_super) {
    __extends(ValidationErrors, _super);
    function ValidationErrors(initProps) {
        var _this = _super.call(this, initProps) || this;
        _this.renderedErrors = s_js_1.default.value([]);
        s_js_1.default.root(function () { return s_js_1.default(function () {
            if (_this.smounted()) {
                var props = _this.sprops();
                if (!props.paused()) {
                    _this.renderedErrors(props.errors().map(function (err) {
                        return React.createElement(ValidationErrorView, { key: err.Field, error: err });
                    }));
                }
            }
        }); });
        return _this;
    }
    ValidationErrors.prototype.srender = function () {
        return (React.createElement("div", { className: "validation-errors" }, this.renderedErrors()));
    };
    return ValidationErrors;
}(supercritical_1.SuperCriticalComponent));
var ValidationErrorView = supercritical_1.default(function (_a) {
    var error = _a.error;
    return React.createElement("div", { className: "validation-err" }, error.ErrorText);
});
// TH 07/10/2017 -- A trigger for opening one of the popups above.
// Presented as a readonly DateTimePicker w/ slightly different styling.
var DateTimeEditPopupTrigger = function (props) {
    return React.createElement(PopupTrigger, __assign({}, props, { nullable: false }));
};
exports.DateTimeEditPopupTrigger = DateTimeEditPopupTrigger;
var NullableDateTimeEditPopupTrigger = function (props) {
    return React.createElement(PopupTrigger, __assign({}, props, { nullable: true }));
};
exports.NullableDateTimeEditPopupTrigger = NullableDateTimeEditPopupTrigger;
var PopupTrigger = supercritical_1.default(function (_a) {
    var value = _a.value, nullable = _a.nullable, onTriggerPopup = _a.onTriggerPopup, disabled = _a.disabled, rest = __rest(_a, ["value", "nullable", "onTriggerPopup", "disabled"]);
    var onClick = disabled ? undefined : onTriggerPopup;
    return (React.createElement("span", { className: cx('datetimeedit-trigger', { disabled: disabled }), onClick: onClick, onFocus: onClick }, nullable ?
        React.createElement(view_1.NullableDateTimePicker, __assign({ value: value, disabled: true }, rest)) :
        React.createElement(view_1.DateTimePicker, __assign({ value: value, disabled: true }, rest))));
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeetAndInches = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var focusGroup_1 = __webpack_require__(294);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(55);
var FeetAndInches = /** @class */ (function (_super) {
    __extends(FeetAndInches, _super);
    function FeetAndInches(props) {
        var _this = _super.call(this, props) || this;
        var focusGroup = new focusGroup_1.FocusGroup({
            onFocus: function () { var _a, _b; return (_b = (_a = _this.sprops()).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a); },
            onBlur: function () { return s_js_1.default.freeze(function () {
                var _a, _b;
                _this.sprops().model.RelinquishWriter();
                (_b = (_a = _this.sprops()).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a);
            }); }
        });
        _this.feetFocus = focusGroup.enroll().events;
        _this.inchesFocus = focusGroup.enroll().events;
        return _this;
    }
    FeetAndInches.prototype.srender = function (_a) {
        var model = _a.model, disabled = _a.disabled, placeholder = _a.placeholder, tabindex = _a.tabindex, autoFocus = _a.autoFocus;
        return (React.createElement("span", { className: "feetandinches" },
            React.createElement(view_1.NullableNumericInput, __assign({ className: "feetandinches-input feetandinches-feet", value: model.Feet, disabled: disabled, placeholder: placeholder, tabindex: tabindex && tabindex.feet, autoFocus: autoFocus }, this.feetFocus)),
            React.createElement("span", { className: "feetandinches-uom" }, "ft."),
            React.createElement(view_1.NullableNumericInput, __assign({ className: "feetandinches-input feetandinches-inches", value: model.Inches, disabled: disabled, placeholder: placeholder, tabindex: tabindex && tabindex.inches }, this.inchesFocus)),
            React.createElement("span", { className: "feetandinches-uom" }, "in.")));
    };
    return FeetAndInches;
}(supercritical_1.SuperCriticalComponent));
exports.FeetAndInches = FeetAndInches;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableFeetInchesMetersEdit = exports.FeetInchesMetersEdit = void 0;
var ConvertedMeasurement_1 = __webpack_require__(116);
var ConvertibleMeasurement_1 = __webpack_require__(163);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var UOM_1 = __webpack_require__(25);
function FeetInchesMetersEdit(_a) {
    var backingMeasurement = _a.backingMeasurement, decimalPlaces = _a.decimalPlaces;
    var convertible;
    if (backingMeasurement instanceof ConvertibleMeasurement_1.ConvertibleMeasurement)
        convertible = backingMeasurement;
    else
        convertible = new ConvertibleMeasurement_1.ConvertibleMeasurement(backingMeasurement);
    return makeMeasurements(convertible, decimalPlaces);
}
exports.FeetInchesMetersEdit = FeetInchesMetersEdit;
function NullableFeetInchesMetersEdit(_a) {
    var backingMeasurement = _a.backingMeasurement, decimalPlaces = _a.decimalPlaces;
    var convertible;
    if (backingMeasurement instanceof ConvertibleMeasurement_1.NullableConvertibleMeasurement)
        convertible = backingMeasurement;
    else
        convertible = new ConvertibleMeasurement_1.NullableConvertibleMeasurement(backingMeasurement);
    return makeMeasurements(convertible, decimalPlaces);
}
exports.NullableFeetInchesMetersEdit = NullableFeetInchesMetersEdit;
function makeMeasurements(convertible, decimalPlaces) {
    return {
        FeetAndInches: new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(convertible, (decimalPlaces || {}).inches || 0),
        Meters: new ConvertedMeasurement_1.ConvertedMeasurement(convertible, UOM_1.default.Meter, (decimalPlaces || {}).meters || 0)
    };
}


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeetInchesMetersEditView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var focusGroup_1 = __webpack_require__(294);
var view_1 = __webpack_require__(520);
var view_2 = __webpack_require__(511);
var FeetInchesMetersEditView = /** @class */ (function (_super) {
    __extends(FeetInchesMetersEditView, _super);
    function FeetInchesMetersEditView(props) {
        var _this = _super.call(this, props) || this;
        var focusGroup = new focusGroup_1.FocusGroup({
            onFocus: function () { var _a, _b; return (_b = (_a = _this.sprops()).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a); },
            onBlur: function () { var _a, _b; return (_b = (_a = _this.sprops()).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a); }
        });
        _this.feetFocus = focusGroup.enroll().events;
        _this.metersFocus = focusGroup.enroll().events;
        return _this;
    }
    FeetInchesMetersEditView.prototype.srender = function (_a) {
        var model = _a.model, disabled = _a.disabled, tabindex = _a.tabindex, autoFocus = _a.autoFocus;
        return (React.createElement("div", { className: "feetinchesmetersedit" },
            React.createElement(view_1.FeetAndInches, __assign({ model: model.FeetAndInches, disabled: disabled, tabindex: {
                    feet: (tabindex || {}).feet,
                    inches: (tabindex || {}).inches
                }, autoFocus: autoFocus }, this.feetFocus)),
            React.createElement("span", { className: "feetinchesmeters-separator" }),
            React.createElement(view_2.ConvertedMeasurementView, __assign({ model: model.Meters, disabled: disabled, tabindex: (tabindex || {}).meters }, this.metersFocus)),
            React.createElement("span", { className: "feetinchesmeters-uom" }, "m")));
    };
    return FeetInchesMetersEditView;
}(supercritical_1.SuperCriticalComponent));
exports.FeetInchesMetersEditView = FeetInchesMetersEditView;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FootmarkAssignments = exports.FootmarksUpdateTrigger = void 0;
var s_js_1 = __webpack_require__(0);
var draftSignals_1 = __webpack_require__(37);
var FootmarksUpdateTrigger;
(function (FootmarksUpdateTrigger) {
    /**
     * Write footmarks edits to the provided `Reservation` on each change event (i.e. w/ every keystroke).
     */
    FootmarksUpdateTrigger["OnChange"] = "on-change";
    /**
     * Write footmarks edits to the provided `Reservation` only when the user changes focus away from the
     * startmark and endmark inputs.
     */
    FootmarksUpdateTrigger["OnBlur"] = "on-blur";
})(FootmarksUpdateTrigger = exports.FootmarksUpdateTrigger || (exports.FootmarksUpdateTrigger = {}));
function FootmarkAssignments(_a) {
    var Reservation = _a.Reservation, CanEdit = _a.CanEdit, _b = _a.FootmarksUpdateTrigger, FootmarksTrigger = _b === void 0 ? FootmarksUpdateTrigger.OnChange : _b;
    var 
    // Footmarks drive important business logic server-side (overlap detection, most-utilized-berth rule).
    // So, to avoid unnecessary work server-side (recomputing issues, recomputing assigned berth, sending
    // notifications about changes from the above), we provide an option to only push footmark edits to the
    // provided Reservation model on specific triggers.
    draftStartmark = draftSignals_1.DraftSignal(function (num) {
        if (num === undefined) {
            return Reservation.Footmark.Num();
        }
        else {
            if (num !== null) {
                return Reservation.Footmark.Num(num);
            }
            else {
                // Don't write a null value to the underlying Footmark.Num signal. This supports a UX
                // whereby clearing either input element and then changing focus counts as cancelling the
                // footmark edit.
                return num;
            }
        }
    }), resLength = s_js_1.default(function () { return Reservation.Length.convert(Reservation.Footmark.UOM()); }), draftEndmark = function (num) {
        if (num === undefined) {
            return draftStartmark() === null ? null : draftStartmark() + resLength().Num();
        }
        else {
            draftStartmark(s_js_1.default.sample(function () { return num === null ? null : num - resLength().Num(); }));
            return num;
        }
    };
    if (FootmarksTrigger === FootmarksUpdateTrigger.OnChange) {
        s_js_1.default(function () { return draftStartmark.isCaching() && draftStartmark.checkpoint().commit(); });
    }
    return {
        Reservation: Reservation,
        CanEdit: CanEdit,
        StartmarkNum: StartmarkNum,
        EndmarkNum: EndmarkNum,
        CommitFootmarks: CommitFootmarks
    };
    function StartmarkNum(num) {
        if (num === undefined) {
            return draftStartmark() === null ? null : Math.round(draftStartmark());
        }
        else {
            return draftStartmark(num);
        }
    }
    function EndmarkNum(num) {
        if (num === undefined) {
            return draftEndmark() === null ? null : Math.round(draftEndmark());
        }
        else {
            return draftEndmark(num);
        }
    }
    function CommitFootmarks() {
        draftStartmark.checkpoint().commit();
    }
}
exports.FootmarkAssignments = FootmarkAssignments;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FootmarkAssignmentsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var _ = __webpack_require__(67);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var focusGroup_1 = __webpack_require__(294);
var CompassPointExtensions_1 = __webpack_require__(566);
var BerthReservation_1 = __webpack_require__(38);
var view_1 = __webpack_require__(55);
var SortedVesselSides = _.sortBy(BerthReservation_1.VesselSides, function (side) {
    return side.Id === BerthReservation_1.VesselSide.TBD ? -1 : side.Id;
});
var FootmarkAssignmentsView = /** @class */ (function (_super) {
    __extends(FootmarkAssignmentsView, _super);
    function FootmarkAssignmentsView(props) {
        var _this = _super.call(this, props) || this;
        var focusGroup = new focusGroup_1.FocusGroup({
            onBlur: function () { return _this.sprops().model.CommitFootmarks(); }
        });
        _this.startmarkFocus = focusGroup.enroll().events;
        _this.endmarkFocus = focusGroup.enroll().events;
        return _this;
    }
    FootmarkAssignmentsView.prototype.srender = function (_a) {
        var _b;
        var model = _a.model, _c = _a.labelStyle, labelStyle = _c === void 0 ? 'none' : _c, tabIndex = _a.tabIndex, autoFocus = _a.autoFocus;
        var res = model.Reservation, pt = res.Itinerary(), berth = (_b = pt === null || pt === void 0 ? void 0 : pt.Location()) === null || _b === void 0 ? void 0 : _b.Berth();
        return (React.createElement("div", { className: cx("footmark-assignments", { 'port-side-vessel-has-bow-to-low-footmark': berth === null || berth === void 0 ? void 0 : berth.PortSideVesselHasBowToLowFootmark() }) },
            labelStyle !== 'none' &&
                React.createElement("div", { className: "pc-text-smalllabel assignment-label assignment-label-" + labelStyle }, labelStyle === 'full' ? 'Footmark Assignments' :
                    labelStyle === 'short' ? 'Footmarks' :
                        null),
            React.createElement("div", { className: "assignment-widget" },
                React.createElement("div", { className: "timeline-graphic" },
                    React.createElement("div", { className: "numbers-side" },
                        React.createElement("div", { className: "startmark" },
                            React.createElement(view_1.NullableNumericInput, __assign({ className: "footmark-num", value: model.StartmarkNum, disabled: !model.CanEdit(), tabindex: tabIndex === null || tabIndex === void 0 ? void 0 : tabIndex.startmark, autoFocus: autoFocus }, this.startmarkFocus)),
                            React.createElement("span", { className: "footmark-uom" },
                                " ",
                                res.Footmark.UOM())),
                        React.createElement("div", { className: "duration pc-text-smalllabel" }, pt && 'Staying ' + tzmoment_1.tzmoment(pt.Departure.Effective()).from(tzmoment_1.tzmoment(pt.Arrival.Effective()), true)),
                        React.createElement("div", { className: "endmark" },
                            React.createElement(view_1.NullableNumericInput, __assign({ className: "footmark-num", value: model.EndmarkNum, disabled: !model.CanEdit(), tabindex: tabIndex === null || tabIndex === void 0 ? void 0 : tabIndex.endmark }, this.endmarkFocus)),
                            React.createElement("span", { className: "footmark-uom" },
                                " ",
                                res.Footmark.UOM()))),
                    React.createElement("div", { className: "line tick start-tick" }),
                    React.createElement("div", { className: "line tick startmark-tick" }),
                    React.createElement("div", { className: "line tick endmark-tick" }),
                    React.createElement("div", { className: "line tick end-tick" }),
                    React.createElement("div", { className: "line main-line" }),
                    React.createElement("div", { className: "vessel-side" },
                        React.createElement("div", null,
                            React.createElement("div", { className: cx("vessel-side-graphic", {
                                    'is-port': res.SideTo() === BerthReservation_1.VesselSide.Port,
                                    'is-starboard': res.SideTo() === BerthReservation_1.VesselSide.Starboard,
                                    'no-vessel': res.SideTo() !== BerthReservation_1.VesselSide.Port && res.SideTo() !== BerthReservation_1.VesselSide.Starboard
                                }) }, model.CanEdit()
                                ? React.createElement("select", { className: "side-to-descr side-to-descr-edit", value: res.SideTo(), onChange: function (e) { return res.SideTo(+e.currentTarget.value); }, tabIndex: tabIndex && tabIndex.sideto }, SortedVesselSides.map(function (v) { return React.createElement("option", { value: v.Id, key: v.Id }, v.Name); }))
                                : React.createElement("span", { className: "side-to-descr" }, BerthReservation_1.VesselSideDisplayName[res.SideTo()])),
                            React.createElement("span", { className: cx("glyphicon glyphicon-chevron-down", {
                                    'hidden': !model.CanEdit()
                                }) }))),
                    React.createElement("div", { className: "compass-point compass-point-low" }, berth && CompassPointExtensions_1.Abbreviation(berth.LowFootmarkCompassPoint())),
                    React.createElement("div", { className: "compass-point compass-point-high" }, berth && CompassPointExtensions_1.Abbreviation(CompassPointExtensions_1.Antipode(berth.LowFootmarkCompassPoint())))))));
    };
    return FootmarkAssignmentsView;
}(supercritical_1.SuperCriticalComponent));
exports.FootmarkAssignmentsView = FootmarkAssignmentsView;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUISE_ERROR_CREW_NEGATIVE = exports.CRUISE_ERROR_IN_TRANSIT_NEGATIVE = exports.CRUISE_ERROR_EMBARK_NEGATIVE = exports.CRUISE_ERROR_DISEMBARK_NEGATIVE = exports.CRUISE_ERROR_MISSING_PASSENGER_COUNT = exports.CARGO_ERROR_QUANTITY_NONPOSITIVE = exports.CARGO_ERROR_MISSING_QUANTITY = exports.CARGO_ERROR_MISSING_TRADE_ROUTE = exports.CARGO_ERROR_MISSING_CARGO_CATEGORY = exports.CARGO_ERROR_MISSING_ACTIVITY_TYPE = exports.InPortOps = exports.ExistingReservationInPortOps = exports.NewReservationInPortOps = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var draftArray_1 = __webpack_require__(1385);
var draftSignals_1 = __webpack_require__(37);
var objectCreate_1 = __webpack_require__(298);
var validationWatcher_1 = __webpack_require__(23);
var BerthReservation_1 = __webpack_require__(79);
var CargoActivity_1 = __webpack_require__(564);
var CargoActivityType_1 = __webpack_require__(280);
var CargoCategory_1 = __webpack_require__(281);
var CruiseActivity_1 = __webpack_require__(571);
var TradeRoute_1 = __webpack_require__(292);
function NewReservationInPortOps(data, inPortOpsModel, _a) {
    var Reservation = _a.Reservation;
    // Wire up navigation props to reference data for cargo activities.
    Reservation.CargoActivities.map(function (act) { return data.CargoActivities.attach(act, [
        act.ActivityType,
        act.CargoCategory,
        act.TradeRoute,
    ]); });
    return inPortOpsModel({
        Reservation: Reservation,
        CanEdit: function () { return true; },
        AddNewCargoActivity: AddNewCargoActivity,
        AddNewCruiseActivity: AddNewCruiseActivity,
        RemoveCargoActivity: RemoveCargoActivity,
        RemoveCruiseActivity: RemoveCruiseActivity,
        // Any cargo or cruise activity must have unsaved changes b/c ALL of this data is unsaved.
        CargoActivityHasUnsavedChanges: function () { return true; },
        CruiseActivityHasUnsavedChanges: function () { return true; },
        // Can't have any port ops persisted b/c this is a brand new reservation.
        HasAnyPortOpsPersisted: function () { return false; },
    });
    function AddNewCargoActivity() {
        Reservation.CargoActivities.push(new CargoActivity_1.CargoActivity());
    }
    function AddNewCruiseActivity() {
        Reservation.CruiseActivities.push(new CruiseActivity_1.CruiseActivity());
    }
    function RemoveCargoActivity(act) {
        Reservation.CargoActivities.remove(act);
    }
    function RemoveCruiseActivity(act) {
        Reservation.CruiseActivities.remove(act);
    }
}
exports.NewReservationInPortOps = NewReservationInPortOps;
function ExistingReservationInPortOps(ajax, entrypoints, data, inPortOpsModel, _a) {
    var Reservation = _a.Reservation, CanEdit = _a.CanEdit, SaveMutex = _a.SaveMutex;
    var hasLayOpsOnlyDraft = draftSignals_1.DraftObject(Reservation, ['HasLayOpsOnly']), cargoOriginals = draftArray_1.DraftArray(Reservation.CargoActivities, draftArray_1.MergeByObjectIdentity), cargoDraftToMetadata = new WeakMap(), 
    // Make a draft object for each activity in our cargoOriginals DraftArray.
    cargoDrafts = cargoOriginals.signal.map(function (act) {
        var draft = draftSignals_1.DraftObject(act, [
            'ActivityTypeId',
            'CargoCategoryId',
            'TradeRouteId',
            'Quantity.Num',
            'Quantity.UOM'
        ]);
        draft.object.ActivityType = s_js_1.default.value(s_js_1.default.sample(act.ActivityType));
        draft.object.CargoCategory = s_js_1.default.value(s_js_1.default.sample(act.CargoCategory));
        draft.object.TradeRoute = s_js_1.default.value(s_js_1.default.sample(act.TradeRoute));
        data.CargoActivities.attach(draft.object, [
            draft.object.ActivityType,
            draft.object.CargoCategory,
            draft.object.TradeRoute,
        ]);
        cargoDraftToMetadata.set(draft.object, { original: act, draftObject: draft });
        return draft;
    }), cruiseOriginals = draftArray_1.DraftArray(Reservation.CruiseActivities, draftArray_1.MergeByObjectIdentity), cruiseDraftToMetadata = new WeakMap(), 
    // Make a draft object for each activity in our cruiseOriginals DraftArray.
    cruiseDrafts = cruiseOriginals.signal.map(function (act) {
        var draft = draftSignals_1.DraftObject(act);
        cruiseDraftToMetadata.set(draft.object, { original: act, draftObject: draft });
        return draft;
    }), pierPositionDraft = draftSignals_1.DraftObject(Reservation, [
        'Footmark.Num',
        'Footmark.UOM',
        'Length.Num',
        'Length.UOM',
        'SideTo'
    ]), merged = objectCreate_1.default(Reservation);
    merged.HasLayOpsOnly = hasLayOpsOnlyDraft.object.HasLayOpsOnly;
    merged.CargoActivities = cargoDrafts.map(function (draft) { return draft.object; });
    merged.CruiseActivities = cruiseDrafts.map(function (draft) { return draft.object; });
    merged.Footmark = pierPositionDraft.object.Footmark;
    merged.Length = pierPositionDraft.object.Length;
    merged.SideTo = pierPositionDraft.object.SideTo;
    // We don't ordinarily do much if any diff'ing when tracking whether a draft object has unsaved changes or
    // not. But we'll make an exception and do som very minimal diff'ing in this case b/c it makes the labeling
    // around Lay Only reservations a little clearer.
    s_js_1.default(function () {
        return hasLayOpsOnlyDraft.methods.isCaching()
            && Reservation.HasLayOpsOnly() === hasLayOpsOnlyDraft.object.HasLayOpsOnly()
            && hasLayOpsOnlyDraft.methods.checkpoint().revert();
    });
    s_js_1.default(function () {
        return cargoOriginals.methods.isCaching()
            && Reservation.CargoActivities().length === 0
            && cargoOriginals.signal().length === 0
            && cargoOriginals.methods.checkpoint().revert();
    });
    s_js_1.default(function () {
        return cruiseOriginals.methods.isCaching()
            && Reservation.CruiseActivities().length === 0
            && cruiseOriginals.signal().length === 0
            && cruiseOriginals.methods.checkpoint().revert();
    });
    var HasAnyPortOpsPersisted = function () {
        return Reservation.HasLayOpsOnly()
            || Reservation.CargoActivities().length > 0
            || Reservation.CruiseActivities().length > 0;
    };
    // Save handlers
    var isSavingActivities = s_js_1.default.value(false), activitiesClient = ajax.Url(entrypoints.UpdateInPortActivities({ Id: Reservation.Id() }), 
    // DON'T use our data cache, as we want finer control of the DataCacheCollection.update calls so
    // we can specify template objects. See SaveActivities implementation below.
    { useCache: false }), activitiesValidation = validationWatcher_1.ValidationWatcher(activitiesClient), 
    // TODO: Some designs have shown separate save buttons for cargo vs cruise. But that adds implementation
    // complexity b/c the Lay Only flag depends on the combined state of cargo AND cruise activities. For
    // now just using a single save button to persist both activity types.
    ActivitiesSaveHandler = {
        HasUnsavedChanges: s_js_1.default(function () {
            return hasLayOpsOnlyDraft.methods.isCaching()
                || cargoOriginals.methods.isCaching()
                || cruiseOriginals.methods.isCaching()
                || cargoDrafts().some(function (d) { return d.methods.isCaching(); })
                || cruiseDrafts().some(function (d) { return d.methods.isCaching(); });
        }),
        IsSaving: function () { return isSavingActivities(); },
        PerformSave: SaveActivities,
        QuitChanges: function () {
            s_js_1.default.freeze(function () {
                hasLayOpsOnlyDraft.methods.checkpoint().revert();
                cargoOriginals.methods.checkpoint().revert();
                cruiseOriginals.methods.checkpoint().revert();
                for (var _i = 0, _a = cargoDrafts(); _i < _a.length; _i++) {
                    var draft = _a[_i];
                    draft.methods.checkpoint().revert();
                }
                for (var _b = 0, _c = cruiseDrafts(); _b < _c.length; _b++) {
                    var draft = _c[_b];
                    draft.methods.checkpoint().revert();
                }
            });
        },
        Validation: activitiesValidation
    }, isSavingPierPosition = s_js_1.default.value(false), pierPositionClient = ajax.Url(function () { var _a; return (_a = Reservation.Url()) !== null && _a !== void 0 ? _a : ''; }, { useCache: true }), pierPositionValidation = validationWatcher_1.ValidationWatcher(pierPositionClient), PierPositionSaveHandler = {
        HasUnsavedChanges: function () { return pierPositionDraft.methods.isCaching(); },
        IsSaving: function () { return isSavingPierPosition(); },
        PerformSave: SavePierPosition,
        QuitChanges: function () {
            pierPositionDraft.methods.checkpoint().revert();
        },
        Validation: pierPositionValidation
    };
    // Clear validation errors when quitting changes.
    s_js_1.default(function () { return !ActivitiesSaveHandler.HasUnsavedChanges() && activitiesValidation({}); });
    s_js_1.default(function () { return !PierPositionSaveHandler.HasUnsavedChanges() && pierPositionValidation({}); });
    return inPortOpsModel({
        Reservation: merged,
        CanEdit: CanEdit,
        AddNewCargoActivity: AddActivity(cargoOriginals, function () { return new CargoActivity_1.CargoActivity(); }),
        AddNewCruiseActivity: AddActivity(cruiseOriginals, function () { return new CruiseActivity_1.CruiseActivity(); }),
        RemoveCargoActivity: RemoveActivity(cargoOriginals, cargoDraftToMetadata),
        RemoveCruiseActivity: RemoveActivity(cruiseOriginals, cruiseDraftToMetadata),
        CargoActivityHasUnsavedChanges: ActivityHasUnsavedChanges(cargoDraftToMetadata),
        CruiseActivityHasUnsavedChanges: ActivityHasUnsavedChanges(cruiseDraftToMetadata),
        HasAnyPortOpsPersisted: HasAnyPortOpsPersisted,
        ActivitiesSaveHandler: ActivitiesSaveHandler,
        PierPositionSaveHandler: PierPositionSaveHandler
    });
    function AddActivity(originals, factory) {
        // Add a new original for the new activity. Our matching .map(...) call above will handle making a
        // matching draft object for it.
        return function () { return originals.signal.push(factory()); };
    }
    function RemoveActivity(originals, draftToMetadata) {
        return function (act) {
            var _a;
            // CAREFUL: The activity removed will be one of the ones from the merged reservation's matching
            // ...Activities array. I.e. one of our DRAFT activities.
            var orig = (_a = draftToMetadata.get(act)) === null || _a === void 0 ? void 0 : _a.original;
            if (orig)
                originals.signal.remove(orig);
        };
    }
    function ActivityHasUnsavedChanges(draftToMetadata) {
        // CAREFUL: The activity queried about will be one of the ones from the merged reservation's matching
        // ...Activities array. I.e. one of our DRAFT activities.
        return function (act) {
            var _a, _b;
            return act.Id() === 0
                || ((_b = (_a = draftToMetadata.get(act)) === null || _a === void 0 ? void 0 : _a.draftObject.methods.isCaching()) !== null && _b !== void 0 ? _b : false);
        };
    }
    function SaveActivities() {
        return __awaiter(this, void 0, void 0, function () {
            var 
            // Snapshot request data as of when the user hit save, rather than waiting till after we
            // acquire the SaveMutex below. That's b/c by the time we acquire the SaveMutex, the user might
            // have gone on to make other activities edits that they may or may not be ready to save at
            // that point.
            reqData, alreadyPersistedCargoIds_1, alreadyPersistedCruiseIds_1, unpersistedCargoOriginals_1, unpersistedCruiseOriginals_1, checkpoints_1, guard, req_1, resp_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isSavingActivities())
                            return [2 /*return*/];
                        isSavingActivities(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        reqData = {
                            Id: Reservation.Id(),
                            HasLayOpsOnly: hasLayOpsOnlyDraft.object.HasLayOpsOnly(),
                            CargoActivities: JSON.parse(JSON.stringify(cargoDrafts().map(function (d) { return d.object; }))),
                            CruiseActivities: JSON.parse(JSON.stringify(cruiseDrafts().map(function (d) { return d.object; }))),
                        }, alreadyPersistedCargoIds_1 = new Set(Reservation.CargoActivities().map(function (act) { return act.Id(); }).filter(function (id) { return id !== 0; })), alreadyPersistedCruiseIds_1 = new Set(Reservation.CruiseActivities().map(function (act) { return act.Id(); }).filter(function (id) { return id !== 0; })), unpersistedCargoOriginals_1 = cargoOriginals.signal().filter(function (act) { return act.Id() === 0; }), unpersistedCruiseOriginals_1 = cruiseOriginals.signal().filter(function (act) { return act.Id() === 0; }), checkpoints_1 = __spreadArrays([
                            hasLayOpsOnlyDraft.methods.checkpoint(),
                            cargoOriginals.methods.checkpoint(),
                            cruiseOriginals.methods.checkpoint()
                        ], cargoDrafts().map(function (d) { return d.methods.checkpoint(); }), cruiseDrafts().map(function (d) { return d.methods.checkpoint(); }));
                        return [4 /*yield*/, SaveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        req_1 = activitiesClient.Put(reqData);
                        return [4 /*yield*/, req_1];
                    case 4:
                        resp_1 = _a.sent();
                        s_js_1.default.freeze(function () {
                            if (resp_1.CargoActivities) {
                                // When updating our data cache w/ new cargo activity data, use unpersisted "original"
                                // cargo activities as templates. The idea is that we already have draft CargoActivity
                                // objects referencing those unpersisted originals, and we wanna try our best to hold
                                // onto those existing draft objects. If we didn't, we'd end up constructing NEW draft
                                // CargoActivity objects for all newly-persisted CargoActivities, thus throwing away any
                                // edits that the user might have made to those activities while our
                                // UpdateInPortActivities request was in flight.
                                //
                                // To do this matching of incoming response data to unpersisted originals, we'll...
                                // 1. Use a `null` template for any incoming CargoActivity data that matches on Id to
                                //    a persisted CargoActivity that we already knew of before we sent our
                                //    UpdateInPortActivities request. The data.CargoActivities.update(...) call will
                                //    select that existing activity to receive the updated data, so there's nothing
                                //    more we need to do in that case.
                                // 2. The remaining CargoActivity data objects are the ones that need to get matched up
                                //    to our unpersisted originals. We'll assume that the server will assign Ids to the
                                //    new activities in the SAME ORDER that we listed them in our request. Thus, we'll
                                //    walk through the incoming response data in ascending Id order.
                                resp_1.CargoActivities.sort(function (a1, a2) { return a1.Id - a2.Id; });
                                var i_1 = 0;
                                var templates = resp_1.CargoActivities.map(function (act) { var _a; return alreadyPersistedCargoIds_1.has(act.Id) ? null : (_a = unpersistedCargoOriginals_1[i_1++]) !== null && _a !== void 0 ? _a : null; });
                                // Remove returned activities from alreadyPersistedCargoIds so we can be sure to delete
                                // any that weren't returned.
                                for (var _i = 0, _a = resp_1.CargoActivities; _i < _a.length; _i++) {
                                    var act = _a[_i];
                                    alreadyPersistedCargoIds_1.delete(act.Id);
                                }
                                data.CargoActivities.update(req_1.Date, resp_1.CargoActivities, Array.from(alreadyPersistedCargoIds_1), templates);
                            }
                            if (resp_1.CruiseActivities) {
                                // Same matching logic for cruise activities as for cargo above.
                                resp_1.CruiseActivities.sort(function (a1, a2) { return a1.Id - a2.Id; });
                                var i_2 = 0;
                                var templates = resp_1.CruiseActivities.map(function (act) { var _a; return alreadyPersistedCruiseIds_1.has(act.Id) ? null : (_a = unpersistedCruiseOriginals_1[i_2++]) !== null && _a !== void 0 ? _a : null; });
                                for (var _b = 0, _c = resp_1.CruiseActivities; _b < _c.length; _b++) {
                                    var act = _c[_b];
                                    alreadyPersistedCruiseIds_1.delete(act.Id);
                                }
                                data.CruiseActivities.update(req_1.Date, resp_1.CruiseActivities, Array.from(alreadyPersistedCruiseIds_1), templates);
                            }
                            BerthReservation_1.BerthReservation.update(Reservation, resp_1);
                        });
                        // A little bit hacky: The whole point of using our existing unpersisted "originals" as
                        // templates for the data.FooActivites.update(...) calls above is so that we can hold onto
                        // our existing draft activity objects that already reference those template activities.
                        // However, there's an S timing issue w/ that: When we call data.FooActivities.update(...), it
                        // takes multiple ticks of S's clock before the matching Reservation.FooActivities array
                        // reflects the new data. But calling fooOriginals.methods.checkpoint().revert() causes the
                        // DraftArray to revert to the Reservation.FooActivities value on the next tick. As a result,
                        // our DraftArrays will temporarily expose the OLD Reservation.FooActivities value before
                        // updating to the new value. To our .map(...) calls that construct our draft activity objects,
                        // it'll thus look like any new activities temporarily disappeared from our DraftArrays before
                        // reappearing. And as a result we'll STILL end up constructing new draft activity objects and
                        // throwing away any pending user edits.
                        //
                        // An easy fix is just to revert our checkpoints in their own later S.freeze(...) call. That
                        // way, we don't revert our DraftArrays until AFTER Reservation.FooActivities reflects the
                        // newly save data.
                        //
                        // Note that we COULD try to solve all this by teaching our .map(...) calls above to remember
                        // and reuse previous draft objects instead of using S timing tricks here. Except that falls
                        // over in the following scenario: 1) User makes pending edits to an existing activity. 2)
                        // Without saving their changes, user changes their mind and decides to instead delete that
                        // activity. 3) Again w/o saving their changes, user changes their mind again and decides to
                        // cancel all changes. In that case we WANT our .map(...) call to construct a fresh draft
                        // object for the relevant activity so that it reappears w/o any pending changes.
                        s_js_1.default.freeze(function () {
                            for (var _i = 0, checkpoints_2 = checkpoints_1; _i < checkpoints_2.length; _i++) {
                                var checkpoint = checkpoints_2[_i];
                                checkpoint.revert();
                            }
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        isSavingActivities(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function SavePierPosition() {
        return __awaiter(this, void 0, void 0, function () {
            var 
            // Snapshot request data as of when the user hit save, for the same reasons as SaveActivities
            // above.
            reqData, checkpoint, guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isSavingPierPosition())
                            return [2 /*return*/];
                        isSavingPierPosition(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        reqData = JSON.parse(JSON.stringify(pierPositionDraft.object)), checkpoint = pierPositionDraft.methods.checkpoint();
                        return [4 /*yield*/, SaveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, pierPositionClient.Put(reqData)];
                    case 4:
                        _a.sent();
                        checkpoint.revert();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        isSavingPierPosition(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
}
exports.ExistingReservationInPortOps = ExistingReservationInPortOps;
function InPortOps(footmarkAssignmentsModel, _a) {
    var Reservation = _a.Reservation, CanEdit = _a.CanEdit, AddNewCargoActivity = _a.AddNewCargoActivity, AddNewCruiseActivity = _a.AddNewCruiseActivity, RemoveCargoActivity = _a.RemoveCargoActivity, RemoveCruiseActivity = _a.RemoveCruiseActivity, CargoActivityHasUnsavedChanges = _a.CargoActivityHasUnsavedChanges, CruiseActivityHasUnsavedChanges = _a.CruiseActivityHasUnsavedChanges, HasAnyPortOpsPersisted = _a.HasAnyPortOpsPersisted, ActivitiesSaveHandler = _a.ActivitiesSaveHandler, PierPositionSaveHandler = _a.PierPositionSaveHandler;
    var schedAuth = function () { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = Reservation.Itinerary()) === null || _a === void 0 ? void 0 : _a.Location()) === null || _b === void 0 ? void 0 : _b.Berth()) === null || _c === void 0 ? void 0 : _c.SchedulingAuthority()) !== null && _d !== void 0 ? _d : null; }, knownActivityTypes = s_array_1.lift(function () { var _a, _b; return (_b = (_a = schedAuth()) === null || _a === void 0 ? void 0 : _a.CargoActivityTypes()) !== null && _b !== void 0 ? _b : []; })
        .filter(function (t) { return t.Active(); })
        .sort(CargoActivityType_1.CargoActivityType.DisplayOrder), knownCargoCategories = s_array_1.lift(function () { var _a, _b; return (_b = (_a = schedAuth()) === null || _a === void 0 ? void 0 : _a.CargoCategories()) !== null && _b !== void 0 ? _b : []; })
        .filter(function (c) { return c.Active(); })
        .sort(CargoCategory_1.CargoCategory.DisplayOrder), knownTradeRoutes = s_array_1.lift(function () { var _a, _b; return (_b = (_a = schedAuth()) === null || _a === void 0 ? void 0 : _a.TradeRoutes()) !== null && _b !== void 0 ? _b : []; })
        .filter(function (r) { return r.Active(); })
        .sort(TradeRoute_1.TradeRoute.DisplayOrder), 
    // Scheduling authorities can choose whether or not to use the Trade Route field. If the scheduling
    // authority has defined no trade routes in their lookup list and this reservation has no existing
    // cargo activities that reference a trade route, then we'll hide the column completely.
    ShouldShowTradeRoute = s_js_1.default(function () { return knownTradeRoutes().length > 0 ||
        Reservation.CargoActivities().some(function (act) { return act.TradeRouteId() !== null; }); }), 
    // Unlike trade route, activity type and cargo category are required to add a cargo activity. If we're
    // missing lookup list values for either AND this reservation has no existing 
    HasRequiredCargoActivityLookups = function () {
        return knownActivityTypes().length > 0
            && knownCargoCategories().length > 0;
    }, CargoActivities = Reservation.CargoActivities.map(function (act) { return CargoActivityViewModel(act, function () { return CargoActivityHasUnsavedChanges(act); }, knownActivityTypes, knownCargoCategories, knownTradeRoutes, function () { return RemoveCargoActivity(act); }); }).orderBy(function (act) { return act.Model.Id() === 0 ? Number.MAX_SAFE_INTEGER : act.Model.Id(); }), CruiseActivities = Reservation.CruiseActivities.map(function (act) { return CruiseActivityViewModel(act, function () { return CruiseActivityHasUnsavedChanges(act); }, function () { return RemoveCruiseActivity(act); }); }).orderBy(function (act) { return act.Model.Id() === 0 ? Number.MAX_SAFE_INTEGER : act.Model.Id(); }), 
    // As long as we have enough reference data to add a cargo activity, then we'll say to be valid we
    // need at least one cargo or cruise activity OR a Lay Only designation. But skip if reference data is
    // missing, which includes the case where this reservation has no scheduling authority. Also, note that
    // we AUTOMATICALLY set HasLayOpsOnly to true in some cases (see below).
    AreActivitiesRequired = function () { return HasRequiredCargoActivityLookups(); }, AreActivitiesValidForSave = s_js_1.default(function () {
        return (!AreActivitiesRequired()
            || Reservation.HasLayOpsOnly()
            || Reservation.CargoActivities().length > 0
            || Reservation.CruiseActivities().length > 0)
            && CargoActivities().every(function (act) { return act.IsValidForSave(); })
            && CruiseActivities().every(function (act) { return act.IsValidForSave(); });
    });
    // Update HasLayOpsOnly as cargo/cruise activities are updated.
    s_js_1.default(function (prev) {
        var cargo = Reservation.CargoActivities(), cruise = Reservation.CruiseActivities();
        // Only update if this isn't our initial run
        if (prev) {
            if (cargo.length > 0 || cruise.length > 0) {
                // If we have any cargo or cruise activities, then can't be Lay Only.
                Reservation.HasLayOpsOnly(false);
            }
            else if (HasAnyPortOpsPersisted() && (prev.cargo.length > 0 || prev.cruise.length > 0)) {
                // Otherwise, so long as we've persisted some port ops info for this reservation, then we'll say
                // that removing all cargo and cruise activities AUTOMATICALLY means that the reservation is Lay
                // Only. I.e. this UI won't let you get BACK into the state HasLayOpsOnly = false AND no cargo
                // or cruise activities are present once any other state has been persisted.
                Reservation.HasLayOpsOnly(true);
            }
        }
        return { cargo: cargo, cruise: cruise };
    }, null);
    var FootmarkAssignments = footmarkAssignmentsModel({ Reservation: Reservation, CanEdit: CanEdit });
    // Keep reservation length up-to-date when changing side to. This is purely for client-side purposes (fast
    // feedback when making changes) -- the server applies its own version of the same logic.
    s_js_1.default(function (prevSideTo) {
        var _a, _b, _c, _d, _e;
        var sideTo = Reservation.SideTo();
        // Propagate portcall changes to non-cancelled reservations only, but update for SideTo changes whether
        // or not the reservation is cancelled.
        if (prevSideTo !== null && sideTo !== prevSideTo || Reservation.CancelledDate() === null) {
            var portcall = (_a = Reservation.Itinerary()) === null || _a === void 0 ? void 0 : _a.PortCall();
            if (portcall) {
                var newLength = BerthReservation_1.BerthReservation.calculateLength((_c = (_b = portcall.Vessel()) === null || _b === void 0 ? void 0 : _b.Length) !== null && _c !== void 0 ? _c : null, (_e = (_d = portcall.Vessel()) === null || _d === void 0 ? void 0 : _d.Beam) !== null && _e !== void 0 ? _e : null, portcall.LengthOnlyLength, Reservation.SideTo(), Reservation.Length.UOM());
                // Apply new length so long as we computed a usable value, but only if this is a follow up run
                // of this computation (due to data changing). Otherwise, leave existing length as is whether
                // it agrees w/ our computed length or not.
                if ((newLength === null || newLength === void 0 ? void 0 : newLength.Num()) && prevSideTo !== null)
                    Reservation.Length.set(newLength);
            }
        }
        return sideTo;
    }, null);
    // TODO: Client-side validation of footmarks. We already have server-side validation, but client-side here
    // would be polite.
    var IsValidForSave = function () { return AreActivitiesValidForSave(); }, IsSaving = function () { var _a; return (_a = ((ActivitiesSaveHandler === null || ActivitiesSaveHandler === void 0 ? void 0 : ActivitiesSaveHandler.IsSaving()) || (PierPositionSaveHandler === null || PierPositionSaveHandler === void 0 ? void 0 : PierPositionSaveHandler.IsSaving()))) !== null && _a !== void 0 ? _a : false; };
    return {
        Reservation: Reservation,
        CanEdit: CanEdit,
        AddNewCargoActivity: AddNewCargoActivity,
        AddNewCruiseActivity: AddNewCruiseActivity,
        HasAnyPortOpsPersisted: HasAnyPortOpsPersisted,
        ActivitiesSaveHandler: ActivitiesSaveHandler,
        PierPositionSaveHandler: PierPositionSaveHandler,
        ShouldShowTradeRoute: ShouldShowTradeRoute,
        HasRequiredCargoActivityLookups: HasRequiredCargoActivityLookups,
        CargoActivities: CargoActivities,
        CruiseActivities: CruiseActivities,
        AreActivitiesRequired: AreActivitiesRequired,
        AreActivitiesValidForSave: AreActivitiesValidForSave,
        FootmarkAssignments: FootmarkAssignments,
        IsValidForSave: IsValidForSave,
        IsSaving: IsSaving,
    };
}
exports.InPortOps = InPortOps;
exports.CARGO_ERROR_MISSING_ACTIVITY_TYPE = 0x01;
exports.CARGO_ERROR_MISSING_CARGO_CATEGORY = 0x02;
exports.CARGO_ERROR_MISSING_TRADE_ROUTE = 0x04;
exports.CARGO_ERROR_MISSING_QUANTITY = 0x08;
exports.CARGO_ERROR_QUANTITY_NONPOSITIVE = 0x10;
function CargoActivityViewModel(activity, hasUnsavedChanges, knownActivityTypes, knownCargoCategories, knownTradeRoutes, onDelete) {
    var Errors = s_js_1.default(function () {
        var _a;
        var errors = 0;
        // ActivityTypeId and CargoCategoryId are required always, even if there are no known options
        // available. As in, before you can add a cargo activity, there NEEDS to be a scheduling authority
        // and they NEED to have defined some activity types and cargo categories. We have logic elsewhere
        // to do graceful things if that isn't the case.
        if (activity.ActivityTypeId() === null)
            errors |= exports.CARGO_ERROR_MISSING_ACTIVITY_TYPE;
        if (activity.CargoCategoryId() === null)
            errors |= exports.CARGO_ERROR_MISSING_CARGO_CATEGORY;
        // Trade route is only required if there are some options available. Scheduling authorities can
        // choose not to use trade routes at all.
        if (activity.TradeRouteId() === null && knownTradeRoutes().length > 0)
            errors |= exports.CARGO_ERROR_MISSING_TRADE_ROUTE;
        if (activity.Quantity.Num() === null)
            errors |= exports.CARGO_ERROR_MISSING_QUANTITY;
        if (((_a = activity.Quantity.Num()) !== null && _a !== void 0 ? _a : 1) <= 0)
            errors |= exports.CARGO_ERROR_QUANTITY_NONPOSITIVE;
        return errors;
    }), errorTracker = ErrorTracker(Errors, hasUnsavedChanges), AvailableActivityTypes = s_js_1.default(function () { return includeExisting(activity.ActivityType(), knownActivityTypes()); }), AvailableCargoCategories = s_js_1.default(function () { return includeExisting(activity.CargoCategory(), knownCargoCategories()); }), AvailableTradeRoutes = s_js_1.default(function () { return includeExisting(activity.TradeRoute(), knownTradeRoutes()); });
    s_js_1.default.on(activity.CargoCategory, function () {
        var category = activity.CargoCategory();
        // Check hasUnsavedChanges so we can distinguish the user selecting a new cargo category from the user
        // cancelling pending changes. In the latter case we wanna avoid clobbering the persisted UOM, which
        // may or may not agree w/ the selected category's current UOM.
        if (category && hasUnsavedChanges())
            activity.Quantity.UOM(category.UOM());
    }, undefined, true);
    return __assign(__assign({ Model: activity, Delete: onDelete, Errors: Errors }, errorTracker), { AvailableActivityTypes: AvailableActivityTypes,
        AvailableCargoCategories: AvailableCargoCategories,
        AvailableTradeRoutes: AvailableTradeRoutes });
}
function includeExisting(existing, known) {
    return existing === null || known.includes(existing) ? known : __spreadArrays([existing], known);
}
exports.CRUISE_ERROR_MISSING_PASSENGER_COUNT = 0x01;
exports.CRUISE_ERROR_DISEMBARK_NEGATIVE = 0x02;
exports.CRUISE_ERROR_EMBARK_NEGATIVE = 0x04;
exports.CRUISE_ERROR_IN_TRANSIT_NEGATIVE = 0x08;
exports.CRUISE_ERROR_CREW_NEGATIVE = 0x10;
function CruiseActivityViewModel(activity, hasUnsavedChanges, onDelete) {
    var Errors = s_js_1.default(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var errors = 0;
        if (((_a = activity.Disembark()) !== null && _a !== void 0 ? _a : 0) === 0
            && ((_b = activity.Embark()) !== null && _b !== void 0 ? _b : 0) === 0
            && ((_c = activity.InTransit()) !== null && _c !== void 0 ? _c : 0) === 0) {
            errors |= exports.CRUISE_ERROR_MISSING_PASSENGER_COUNT;
        }
        if (((_d = activity.Disembark()) !== null && _d !== void 0 ? _d : 0) < 0)
            errors |= exports.CRUISE_ERROR_DISEMBARK_NEGATIVE;
        if (((_e = activity.Embark()) !== null && _e !== void 0 ? _e : 0) < 0)
            errors |= exports.CRUISE_ERROR_EMBARK_NEGATIVE;
        if (((_f = activity.InTransit()) !== null && _f !== void 0 ? _f : 0) < 0)
            errors |= exports.CRUISE_ERROR_IN_TRANSIT_NEGATIVE;
        if (((_g = activity.Crew()) !== null && _g !== void 0 ? _g : 0) < 0)
            errors |= exports.CRUISE_ERROR_CREW_NEGATIVE;
        return errors;
    }), errorTracker = ErrorTracker(Errors, hasUnsavedChanges);
    return __assign({ Model: activity, Delete: onDelete, Errors: Errors }, errorTracker);
}
// A common validation pattern for both cargo and cruise activities abstracted as a small standalone function.
function ErrorTracker(errors, hasUnsavedChanges) {
    var 
    // If there ARE errors, should we take ownership of them, meaning we treat them as something the user
    // needs to resolve via the In Port Ops UI before we'll allow saving this activity? Or should we deny
    // ownership, meaning we think the error comes from some external source, e.g. it's legacy data from
    // our old Tariff Activities UI, in which case we'll let the validation errors slide?
    shouldOwnErrors = s_js_1.default.value(s_js_1.default.sample(hasUnsavedChanges)), 
    // We lock editing of an invalid activity unless/until we take ownership of its errors.
    IsEditingLocked = function () { return errors() !== 0 && !shouldOwnErrors(); }, IsValidForSave = function () { return errors() === 0 || !shouldOwnErrors(); };
    s_js_1.default(function (hadUnsaved) {
        var hasUnsaved = hasUnsavedChanges();
        // If there are any unsaved changes to this activity, then we'll automatically take ownership of all
        // errors. The user has to fix ALL errors before we'll allow saving the activity.
        if (hasUnsaved)
            shouldOwnErrors(true);
        // Conversely, if the user quits pending changes for this activity, then we'll go back to tolerating
        // errors. But make sure we only do this when the hasUnsavedChanges signal flips from true to false,
        // so that we still support explicitly unlocking this activity even if there are no unsaved changes.
        else if (hadUnsaved)
            shouldOwnErrors(false);
        return hasUnsaved;
    }, s_js_1.default.sample(hasUnsavedChanges));
    return {
        IsEditingLocked: IsEditingLocked,
        IsValidForSave: IsValidForSave,
        UnlockEditing: UnlockEditing
    };
    function UnlockEditing() {
        shouldOwnErrors(true);
    }
}


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InPortOpsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(525);
var view_1 = __webpack_require__(524);
var view_2 = __webpack_require__(29);
var view_3 = __webpack_require__(55);
exports.InPortOpsView = supercritical_1.default(function (_a) {
    var m = _a.model, includeChrome = _a.includeChrome, includeInstructions = _a.includeInstructions, tabIndex = _a.tabIndex, autoFocus = _a.autoFocus;
    return React.createElement("div", { className: cx('inportops', { 'include-instructions': includeInstructions }) },
        includeChrome && React.createElement(OpsHeader, { model: m }),
        React.createElement("div", { className: cx("inportops-main", { 'include-chrome': includeChrome }) },
            React.createElement(CargoActivities, { model: m, includeInstructions: includeInstructions }),
            React.createElement(CruiseActivities, { model: m }),
            React.createElement(PierPosition, { model: m, includeInstructions: includeInstructions, tabIndex: tabIndex, autoFocus: autoFocus })));
});
var EM_DASH = '\u2014';
var OpsHeader = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var l = (_b = m.Reservation.Itinerary()) === null || _b === void 0 ? void 0 : _b.Location();
    return (React.createElement("div", { className: "inportops-header" },
        "In Port Ops",
        l && " " + EM_DASH + " " + l.Name()));
});
var CargoActivities = supercritical_1.default(function (_a) {
    var m = _a.model, includeInstructions = _a.includeInstructions;
    return React.createElement("div", { className: "ops-section in-port-activities-section cargo-activities-section" },
        React.createElement("div", { className: "ops-section-main" },
            React.createElement("div", { className: "ops-section-header" },
                React.createElement("div", { className: "ops-section-title" }, "Cargo Activities"),
                m.Reservation.HasLayOpsOnly() &&
                    React.createElement("div", { className: "lay-only-label" }, "Lay Only")),
            React.createElement("div", { className: "ops-section-body in-port-activities-body cargo-activities-body" },
                m.CargoActivities().length > 0 &&
                    React.createElement("div", { className: cx('column-headers cargo-columns-shell', {
                            'has-trade-route': m.ShouldShowTradeRoute()
                        }) },
                        React.createElement("span", { className: "col-header col-trade-route" }, "Trade Route"),
                        React.createElement("span", { className: "col-header col-activity-type" }, "Activity"),
                        React.createElement("span", { className: "col-header col-cargo-category" }, "Cargo"),
                        React.createElement("span", { className: "col-header col-quantity" }, "Qty"),
                        React.createElement("span", { className: "col-header col-delete" })),
                m.CargoActivities().map(function (a) {
                    return React.createElement(CargoActivityRow, { activity: a, model: m, key: CargoRowKey(a) });
                }),
                m.CanEdit() &&
                    React.createElement("div", { className: "add-activity-shell" },
                        React.createElement("span", { className: "add-cargo-activity-shell" }, m.HasRequiredCargoActivityLookups() &&
                            React.createElement("a", { href: "", className: "add-activity", onClick: eventWrappers_1.noDefault(m.AddNewCargoActivity) }, "+ Add Cargo Activity")),
                        React.createElement(LayOnlySelector, { model: m })))),
        includeInstructions && React.createElement(ActivitiesInstructions, { model: m }));
});
var nextCargoRowKey = 0;
var CARGO_ROW_KEYS = new WeakMap();
function CargoRowKey(a) {
    var id = CARGO_ROW_KEYS.get(a);
    if (id === undefined) {
        id = nextCargoRowKey++;
        CARGO_ROW_KEYS.set(a, id);
    }
    return id;
}
var CargoActivityRow = supercritical_1.default(function (_a) {
    var a = _a.activity, m = _a.model;
    var disabled = !m.CanEdit() || a.IsEditingLocked();
    return (React.createElement("div", { className: "in-port-activity cargo-activity" },
        React.createElement("div", { className: cx('activity-data cargo-columns-shell', {
                'has-trade-route': m.ShouldShowTradeRoute()
            }) },
            React.createElement(TradeRouteColumn, { activity: a, disabled: disabled }),
            React.createElement(ActivityTypeColumn, { activity: a, disabled: disabled }),
            React.createElement(CargoCategoryColumn, { activity: a, disabled: disabled }),
            React.createElement("span", { className: "col-quantity" },
                React.createElement(view_3.NullableNumericInput, { className: "quantity-num activity-data-entry", value: a.Model.Quantity.Num, disabled: disabled }),
                ' ',
                React.createElement("span", { className: "quantity-uom" }, a.Model.Quantity.UOM())),
            React.createElement("span", { className: "col-delete" }, m.CanEdit() &&
                React.createElement("a", { href: "", className: "fa fa-times-circle delete-btn", onClick: eventWrappers_1.noDefault(a.Delete) }))),
        m.CanEdit() && a.IsEditingLocked() ?
            React.createElement("div", { className: "unlock-activity" },
                "There are errors with this activity.",
                ' ',
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(a.UnlockEditing) }, "Unlock to fix.")) :
            !a.IsEditingLocked() ?
                React.createElement(CargoValidationMessage, { activity: a }) :
                null));
});
var TradeRouteColumn = supercritical_1.default(function (_a) {
    var _b;
    var a = _a.activity, disabled = _a.disabled;
    return React.createElement("span", { className: "col-trade-route" },
        React.createElement("select", { className: "pc-select activity-data-entry", value: (_b = a.Model.TradeRouteId()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return e.currentTarget.value && a.Model.TradeRouteId(+e.currentTarget.value); }, disabled: disabled },
            a.Model.TradeRouteId() === null && React.createElement("option", { value: "" }, "--"),
            a.AvailableTradeRoutes().map(function (tr) {
                return React.createElement("option", { value: tr.Id(), key: tr.Id() }, tr.Name());
            })),
        React.createElement("span", { className: "pc-select-chevron" }));
});
var ActivityTypeColumn = supercritical_1.default(function (_a) {
    var _b;
    var a = _a.activity, disabled = _a.disabled;
    return React.createElement("span", { className: "col-activity-type" },
        React.createElement("select", { className: "pc-select activity-data-entry", value: (_b = a.Model.ActivityTypeId()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return e.currentTarget.value && a.Model.ActivityTypeId(+e.currentTarget.value); }, disabled: disabled },
            a.Model.ActivityTypeId() === null && React.createElement("option", { value: "" }, "--"),
            a.AvailableActivityTypes().map(function (t) {
                return React.createElement("option", { value: t.Id(), key: t.Id() }, t.Name());
            })),
        React.createElement("span", { className: "pc-select-chevron" }));
});
var CargoCategoryColumn = supercritical_1.default(function (_a) {
    var _b;
    var a = _a.activity, disabled = _a.disabled;
    return React.createElement("span", { className: "col-cargo-category" },
        React.createElement("select", { className: "pc-select activity-data-entry", value: (_b = a.Model.CargoCategoryId()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return e.currentTarget.value && a.Model.CargoCategoryId(+e.currentTarget.value); }, disabled: disabled },
            a.Model.CargoCategoryId() === null && React.createElement("option", { value: "" }, "--"),
            a.AvailableCargoCategories().map(function (c) {
                return React.createElement("option", { value: c.Id(), key: c.Id() }, c.Name());
            })),
        React.createElement("span", { className: "pc-select-chevron" }));
});
var CargoValidationMessage = supercritical_1.default(function (_a) {
    var a = _a.activity;
    var errors = a.Errors();
    return errors === 0 ?
        null :
        React.createElement("div", { className: "activity-validation" },
            // Missing required fields: We figure these are inevitable for just-added activities, so
            // we'll only list one at a time and we'll style them more as instructions than as errors.
            (errors & model_1.CARGO_ERROR_MISSING_TRADE_ROUTE) !== 0 ?
                React.createElement("div", { className: "required-field" }, "Enter Trade Route") :
                (errors & model_1.CARGO_ERROR_MISSING_ACTIVITY_TYPE) !== 0 ?
                    React.createElement("div", { className: "required-field" }, "Enter Activity") :
                    (errors & model_1.CARGO_ERROR_MISSING_CARGO_CATEGORY) !== 0 ?
                        React.createElement("div", { className: "required-field" }, "Enter Cargo") :
                        (errors & model_1.CARGO_ERROR_MISSING_QUANTITY) !== 0 ?
                            React.createElement("div", { className: "required-field" }, "Enter Quantity") :
                            null,
            (errors & model_1.CARGO_ERROR_QUANTITY_NONPOSITIVE) !== 0 &&
                React.createElement("div", { className: "alert alert-danger" }, "Quantity must be positive."));
});
var LayOnlySelector = supercritical_1.default(function (_a) {
    var m = _a.model;
    // Only render a Lay Only selector if we have no cargo or cruise activities AND we haven't already
    // persisted some port ops data.
    var shouldRender = m.CargoActivities().length === 0
        && m.CruiseActivities().length === 0
        && !m.HasAnyPortOpsPersisted();
    return shouldRender ?
        React.createElement("label", { className: "lay-only-selector-shell" },
            React.createElement("input", { type: "checkbox", className: "pc-breaker-input", checked: m.Reservation.HasLayOpsOnly(), onChange: function (e) { return m.Reservation.HasLayOpsOnly(e.currentTarget.checked); }, tabIndex: 400 }),
            React.createElement("span", { className: "pc-breaker-light lay-only-selector" }),
            ' ',
            "Lay Only") :
        null;
});
var ActivitiesInstructions = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "ops-section-instructions" },
        m.AreActivitiesRequired() ?
            'At least one row of Cargo or Cruise Activities required.' :
            m.HasRequiredCargoActivityLookups() ?
                'Enter Cargo or Cruise Activities.' :
                'Enter Cruise Activities.',
        ' ',
        "If none, select Lay Only.");
});
var CruiseActivities = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e;
    var m = _a.model;
    return React.createElement("div", { className: "ops-section in-port-activities-section cruise-activities-section" },
        React.createElement("div", { className: "ops-section-main" },
            React.createElement("div", { className: "ops-section-header ops-section-title" }, "Cruise Activities"),
            React.createElement("div", { className: "ops-section-body in-port-activities-body cruise-activities-body" },
                m.CruiseActivities().length > 0 &&
                    React.createElement("div", { className: "default-guest-count-shell" },
                        "Default Guest Count \u2014",
                        ' ', (_e = (_d = (_c = (_b = m.Reservation.Itinerary()) === null || _b === void 0 ? void 0 : _b.PortCall()) === null || _c === void 0 ? void 0 : _c.Vessel()) === null || _d === void 0 ? void 0 : _d.ExpectedPassengerCount()) !== null && _e !== void 0 ? _e : 'N/A'),
                m.CruiseActivities().length > 0 &&
                    React.createElement("div", { className: "column-headers cruise-columns-shell" },
                        React.createElement("span", { className: "col-header col-disembark" }, "Disembark"),
                        React.createElement("span", { className: "col-header col-embark" }, "Embark"),
                        React.createElement("span", { className: "col-header col-in-transit" }, "In Transit"),
                        React.createElement("span", { className: "cruise-field-separator" }),
                        React.createElement("span", { className: "col-header col-crew" }, "Crew"),
                        React.createElement("span", { className: "col-header col-voyage" }, "Voyage"),
                        React.createElement("span", { className: "col-header col-delete" })),
                m.CruiseActivities().map(function (a) {
                    return React.createElement(CruiseActivityRow, { activity: a, model: m, key: CruiseRowKey(a) });
                }),
                m.CanEdit() &&
                    React.createElement("div", { className: "add-activity-shell" },
                        React.createElement("a", { href: "", className: "add-activity", onClick: eventWrappers_1.noDefault(m.AddNewCruiseActivity) }, "+ Add Passengers"))),
            m.ActivitiesSaveHandler && view_2.ListErrors(m.ActivitiesSaveHandler.Validation()),
            React.createElement(ActivitiesSaveControls, { model: m })));
});
var nextCruiseRowKey = 0;
var CRUISE_ROW_KEYS = new WeakMap();
function CruiseRowKey(a) {
    var id = CRUISE_ROW_KEYS.get(a);
    if (id === undefined) {
        id = nextCruiseRowKey++;
        CRUISE_ROW_KEYS.set(a, id);
    }
    return id;
}
var CruiseActivityRow = supercritical_1.default(function (_a) {
    var _b;
    var a = _a.activity, m = _a.model;
    var disabled = !m.CanEdit() || a.IsEditingLocked();
    return (React.createElement("div", { className: "in-port-activity cruise-activity" },
        React.createElement("div", { className: "activity-data cruise-columns-shell" },
            React.createElement("span", { className: "col-disembark" },
                React.createElement(view_3.NullableNumericInput, { className: "activity-data-entry", value: a.Model.Disembark, disabled: disabled })),
            React.createElement("span", { className: "col-embark" },
                React.createElement(view_3.NullableNumericInput, { className: "activity-data-entry", value: a.Model.Embark, disabled: disabled })),
            React.createElement("span", { className: "col-in-transit" },
                React.createElement(view_3.NullableNumericInput, { className: "activity-data-entry", value: a.Model.InTransit, disabled: disabled })),
            React.createElement("span", { className: "cruise-field-separator" }),
            React.createElement("span", { className: "col-crew" },
                React.createElement(view_3.NullableNumericInput, { className: "activity-data-entry", value: a.Model.Crew, disabled: disabled, placeholder: "optional" })),
            React.createElement("span", { className: "col-voyage" },
                React.createElement("input", { className: "activity-data-entry", value: (_b = a.Model.VoyageNumber()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return a.Model.VoyageNumber(e.currentTarget.value || null); }, disabled: disabled, placeholder: "optional" })),
            React.createElement("span", { className: "col-delete" }, m.CanEdit() &&
                React.createElement("a", { href: "", className: "fa fa-times-circle delete-btn", onClick: eventWrappers_1.noDefault(a.Delete) }))),
        m.CanEdit() && a.IsEditingLocked() ?
            React.createElement("div", { className: "unlock-activity" },
                "There are errors with this activity.",
                ' ',
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(a.UnlockEditing) }, "Unlock to fix.")) :
            !a.IsEditingLocked() ?
                React.createElement(CruiseValidationMessage, { activity: a }) :
                null));
});
var CruiseValidationMessage = supercritical_1.default(function (_a) {
    var a = _a.activity;
    var errors = a.Errors();
    return errors === 0 ?
        null :
        React.createElement("div", { className: "activity-validation" },
            // Missing required fields: We figure these are inevitable for just-added activities, so
            // we'll only list one at a time and we'll style them more as instructions than as errors.
            (errors & model_1.CRUISE_ERROR_MISSING_PASSENGER_COUNT) !== 0 ?
                React.createElement("div", { className: "required-field" }, "Enter Disembark, Embark, or In Transit.") :
                null,
            (errors & model_1.CRUISE_ERROR_DISEMBARK_NEGATIVE) !== 0 &&
                React.createElement("div", { className: "alert alert-danger" }, "Disembark can't be negative."),
            (errors & model_1.CRUISE_ERROR_EMBARK_NEGATIVE) !== 0 &&
                React.createElement("div", { className: "alert alert-danger" }, "Embark can't be negative."),
            (errors & model_1.CRUISE_ERROR_IN_TRANSIT_NEGATIVE) !== 0 &&
                React.createElement("div", { className: "alert alert-danger" }, "In Transit can't be negative."),
            (errors & model_1.CRUISE_ERROR_CREW_NEGATIVE) !== 0 &&
                React.createElement("div", { className: "alert alert-danger" }, "Crew can't be negative."));
});
var ActivitiesSaveControls = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return ((_b = m.ActivitiesSaveHandler) === null || _b === void 0 ? void 0 : _b.HasUnsavedChanges()) ?
        React.createElement("div", { className: "ops-section-save-controls" },
            !m.ActivitiesSaveHandler.IsSaving() &&
                React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(m.ActivitiesSaveHandler.QuitChanges) }, "Cancel"),
            React.createElement("button", { className: "pc-button", onClick: m.ActivitiesSaveHandler.PerformSave, disabled: !m.AreActivitiesValidForSave() || m.ActivitiesSaveHandler.IsSaving() },
                "Save ",
                m.Reservation.HasLayOpsOnly() ? 'Lay Only' : 'Activities')) :
        null;
});
var PierPosition = supercritical_1.default(function (_a) {
    var m = _a.model, includeInstructions = _a.includeInstructions, tabIndex = _a.tabIndex, autoFocus = _a.autoFocus;
    return React.createElement("div", { className: "ops-section pier-position-section" },
        React.createElement("div", { className: "ops-section-main" },
            React.createElement("div", { className: "ops-section-header ops-section-title" }, "Footmarks and Side-To"),
            React.createElement("div", { className: "ops-section-body" },
                React.createElement(view_1.FootmarkAssignmentsView, { model: m.FootmarkAssignments, autoFocus: autoFocus, tabIndex: {
                        startmark: tabIndex ? tabIndex + 1 : 1,
                        endmark: tabIndex ? tabIndex + 2 : 2,
                        sideto: tabIndex ? tabIndex + 3 : 3,
                    } })),
            m.PierPositionSaveHandler && view_2.ListErrors(m.PierPositionSaveHandler.Validation()),
            React.createElement(PierPositionSaveControls, { model: m })),
        includeInstructions &&
            React.createElement("div", { className: "ops-section-instructions" }, "Indicate the ship's Footmarks and select a Side-To"));
});
var PierPositionSaveControls = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return ((_b = m.PierPositionSaveHandler) === null || _b === void 0 ? void 0 : _b.HasUnsavedChanges()) ?
        React.createElement("div", { className: "ops-section-save-controls" },
            !m.PierPositionSaveHandler.IsSaving() &&
                React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(m.PierPositionSaveHandler.QuitChanges) }, "Cancel"),
            React.createElement("button", { className: "pc-button", onClick: m.PierPositionSaveHandler.PerformSave, disabled: m.PierPositionSaveHandler.IsSaving() }, "Save Footmarks & Side-To")) :
        null;
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUsersView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
var view_2 = __webpack_require__(29);
exports.InviteUsersView = supercritical_1.default(function (_a) {
    var _b;
    var modelContainer = _a.modelContainer;
    return React.createElement(view_1.PCModal, { className: "inviteusers", shown: function () { return !!modelContainer(); }, onBackDropClick: (_b = modelContainer()) === null || _b === void 0 ? void 0 : _b.HidePopup },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header pc-modal-header" },
                (function (m) { return m && React.createElement("button", { className: "close pc-modal-close", onClick: m.HidePopup }, "Close"); })(modelContainer()),
                React.createElement("h2", { className: "modal-title pc-modal-title" }, "Invited")),
            (function (m) { return m &&
                React.createElement("div", { className: "modal-body inviteModal" }, m.SendInvitationRequest() && m.SendInvitationRequest().Response() && m.SendInvitationRequest().Response().Success ?
                    React.createElement(InviteUsersSuccess, { onCloseModal: m.HidePopup })
                    :
                        React.createElement(InviteUsersInProgress, { model: m })); })(modelContainer())));
});
var InviteUsersSuccess = supercritical_1.default(function (_a) {
    var onCloseModal = _a.onCloseModal;
    return React.createElement("div", { className: "action-success clearfix" },
        React.createElement("div", null, "Your invitations have been sent successfully."),
        React.createElement("div", null,
            React.createElement("button", { className: "pc-button", onClick: onCloseModal }, "OK")));
});
var InviteUsersInProgress = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(SelectOrgView, { model: m }),
        React.createElement(AddEmailsView, { model: m }),
        React.createElement(SendInvitationsView, { model: m }));
});
var SelectOrgView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "select-org" },
        React.createElement(SelectOrgLeftSide, { model: m }),
        React.createElement(SelectOrgRightSide, { model: m }));
});
var SelectOrgLeftSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "content-left" },
        React.createElement("h2", { className: "step-title" }, "Step 1: Select the New Person's Organization"),
        React.createElement("div", { className: "step-description" }, "Select the new person's organization or add a new organization if it isn't already in the list."),
        m.Model.CanManageOrgs() &&
            React.createElement("div", null,
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.Invitation.IsNewOrganization(true); }) }, "+ Add a new organization")));
});
var SelectOrgRightSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "content-right" },
        React.createElement("div", { className: "selector-shell" }, !m.Invitation.IsNewOrganization() ?
            React.createElement("div", { className: "org-select-container" },
                React.createElement("select", { className: "pc-select-secondary org-select", value: m.Invitation.OrganizationId() || '', onChange: function (e) { return m.Invitation.OrganizationId(e.currentTarget.value ? +e.currentTarget.value : null); }, disabled: !m.Model.CanManageOrgs() },
                    React.createElement("option", { value: "" }, "--"),
                    m.Model.AvailableOrganizations().map(function (org) {
                        return React.createElement("option", { key: org.Id(), value: org.Id() }, org.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" }),
                React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['OrganizationId']; } }))
            :
                React.createElement("div", { className: "new-org-name clearfix" },
                    React.createElement("input", { type: "text", className: "new-org-input form-control", placeholder: "Enter Organization Name", value: m.Invitation.OrganizationName() || '', onChange: function (e) { return m.Invitation.OrganizationName(e.currentTarget.value); } }),
                    React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['OrganizationName']; } }),
                    (function (err) { return err &&
                        React.createElement("div", { className: "validationerror alert alert-danger" },
                            err.ErrorText,
                            ' ',
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.SelectDuplicateOrg(+err.RawErrors[1]); }) }, "Select this organization instead?")); })(m.Validation()['DuplicateOrganization']),
                    React.createElement("a", { href: "", className: "hide-org-btn", onClick: eventWrappers_1.noDefault(function () { return m.Invitation.IsNewOrganization(false); }) }, "Cancel"))));
});
var AddEmailsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "add-emails" },
        React.createElement("div", { className: "content-left" },
            React.createElement("h2", { className: "step-title" }, "Step 2: Add Emails and Set Permissions"),
            React.createElement("div", { className: "step-description" }, "Enter one or more email addresses for the new member(s) and indicate what they can do in PortCall.com.")),
        React.createElement(AddEmailsRoleLabels, { model: m }),
        React.createElement(AddEmailsInvitedUsers, { model: m }),
        React.createElement(AddEmailsFooter, { model: m }));
});
var AddEmailsRoleLabels = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "content-right role-labels" }, m.Model.AssignableRoles().map(function (r) {
        return React.createElement("span", { className: "role-name", key: r.Id() }, r.Name());
    }));
});
var AddEmailsInvitedUsers = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null, m.InvitedUsers().map(function (user) {
        return React.createElement(AddEmailsInvitedUserView, { key: user.Key, user: user, assignableRoles: m.Model.AssignableRoles });
    }));
});
var AddEmailsInvitedUserView = supercritical_1.default(function (_a) {
    var user = _a.user, assignableRoles = _a.assignableRoles;
    return React.createElement("div", { className: "invited-user clearfix" },
        React.createElement("div", { className: "invited-user-row" },
            React.createElement("a", { href: "", className: "delete-row", onClick: eventWrappers_1.noDefault(user.Delete) },
                React.createElement("i", { className: "glyphicon glyphicon-remove-circle" })),
            React.createElement("div", { className: "email" },
                React.createElement("input", { type: "text", className: "pc-input-editcontrol", placeholder: "Email", value: user.Model.Email(), onChange: function (e) { return user.Model.Email(e.target.value); } }),
                React.createElement(view_2.ValidationErrorView, { error: user.EmailValidation }))),
        React.createElement(InvitedUserRoles, { user: user, assignableRoles: assignableRoles }));
});
var InvitedUserRoles = supercritical_1.default(function (_a) {
    var user = _a.user, assignableRoles = _a.assignableRoles;
    return React.createElement("div", { className: "content-right" }, assignableRoles().map(function (r) {
        return React.createElement("input", { key: r.Id(), className: "checkbox", type: "checkbox", checked: user.HasOrImpliesRole(r.Id()), disabled: user.ImpliesOrMaterializesRole(r.Id()), onChange: function (e) { return user.ToggleRole(r.Id()); } });
    }));
});
var AddEmailsFooter = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "content-left" },
        React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['InvitedUsers']; } }),
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.AddInvitedUser) }, "+ Invite another person from this organization"));
});
var SendInvitationsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "send-invitations" },
        React.createElement("div", { className: "content-left" },
            React.createElement("h2", { className: "step-title" }, "Step 3: Send Invitations"),
            React.createElement("div", { className: "step-description" }, "Click Send Invitation and each person will receive an email with a link to set their password.")),
        React.createElement("div", { className: "content-right" },
            React.createElement("div", { className: "send-btn-shell" },
                React.createElement("button", { className: "pc-button send-btn", onClick: m.Submit }, "Send Invitation"))));
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalVesselSearchView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(91);
exports.LocalVesselSearchView = supercritical_1.default(function (_a) {
    var model = _a.model, tabIndex = _a.tabIndex, placeholder = _a.placeholder, specificInput = _a.specificInput;
    return React.createElement("div", { className: "vessel-search" },
        React.createElement(view_1.TypeaheadInput, { className: "search-filter", placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Search a vessel by name, IMO, Call Sign, or MMSID", model: model.Typeahead, tabIndex: tabIndex, specificInput: specificInput }));
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.drawLocation = exports.drawCircleLocation = exports.drawPolygonLocation = exports.MAP_FILL_COLOR = void 0;
var s_js_1 = __webpack_require__(0);
var ZoneCoordinates_1 = __webpack_require__(115);
exports.MAP_FILL_COLOR = '#E8E343';
function drawPolygonLocation(coords) {
    return coords.toLeaflet({ color: exports.MAP_FILL_COLOR, weight: 2, fillColor: exports.MAP_FILL_COLOR, fillOpacity: .1 });
}
exports.drawPolygonLocation = drawPolygonLocation;
function drawCircleLocation(coords) {
    return coords.toLeaflet({ color: exports.MAP_FILL_COLOR, weight: 2, fillColor: exports.MAP_FILL_COLOR, fillOpacity: .1 });
}
exports.drawCircleLocation = drawCircleLocation;
function drawLocation(container, coords) {
    var center = null;
    if (!coords) {
        // ignore locations without coordinates
    }
    else if (coords instanceof ZoneCoordinates_1.PolygonCoords) {
        var polygon_1 = drawPolygonLocation(coords);
        container.addLayer(polygon_1);
        s_js_1.default.cleanup(function () { return container.removeLayer(polygon_1); });
        center = polygon_1.getBounds().getCenter();
    }
    else {
        var circle_1 = drawCircleLocation(coords);
        container.addLayer(circle_1);
        s_js_1.default.cleanup(function () { return container.removeLayer(circle_1); });
        center = circle_1.getLatLng();
    }
    return center;
}
exports.drawLocation = drawLocation;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NewVesselView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(272);
var view_1 = __webpack_require__(1082);
var view_2 = __webpack_require__(1087);
exports.NewVesselView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return model.Mode() === model_1.NewVesselMode.ExternalVesselService
        ? React.createElement(view_2.ExternalVesselSearchView, { model: model.VesselSearch })
        : React.createElement(view_1.EditNewVesselOverridesView, { model: model.EditOverrides });
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProfile = exports.OrgProfileParams = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var nonuniqueIndex_1 = __webpack_require__(117);
var Berth_1 = __webpack_require__(107);
var PhoneNumber_1 = __webpack_require__(287);
var PostalAddress_1 = __webpack_require__(586);
var OrgProfileParams = /** @class */ (function () {
    function OrgProfileParams(id) {
        if (id === void 0) { id = 0; }
        this.id = id;
    }
    return OrgProfileParams;
}());
exports.OrgProfileParams = OrgProfileParams;
function OrgProfile(entrypoints, ajax, cache, queryCache, personProfilePopupModel, inviteUsersModel, userPermissionsModel, selectProfileImageModel, phoneNumberModel, postalAddressModel, addBerthModel, params) {
    var model = queryCache.OrgProfileResponses.update1(null, { OrganizationId: params.id }), url = entrypoints.OrgProfile({ Id: params.id }), request = ajax.Url(url).Get(), orgContainer = s_js_1.default(function () { return model.Organization() && OrganizationViewModel(model.Organization()); }), editing = s_js_1.default.data(false), berths = s_array_1.default([]), berthsByPierGroup = nonuniqueIndex_1.default(berths, function (b) { return b.PierGroupId(); }), piergroups = model.PierGroups.map(PierGroupViewModel), pierGroupsByPort = nonuniqueIndex_1.default(piergroups, function (pg) { return pg.Model.PortId(); }), ports = model.Ports.sort(function (p1, p2) { return p1.Order() - p2.Order(); }).map(PortViewModel), showInviteUsers = s_js_1.default.data(false), inviteUsers = s_js_1.default(function () { return showInviteUsers() ? inviteUsersModel({ selectedOrganizationId: params.id, onHidePopup: function () { return showInviteUsers(false); } }) : null; }), showUserPermissions = s_js_1.default.data(false), userPermissions = s_js_1.default(function () { return showUserPermissions() ? userPermissionsModel({ organizationId: params.id, onHidePopup: function () { return showUserPermissions(false); } }) : null; }), addBerth = addBerthModel({ SchedulingAuthorityId: params.id });
    s_js_1.default(function () {
        if (model.Organization()) {
            berths(model.Organization().ManagedBerths());
        }
        else {
            berths([]);
        }
    });
    request.done(function (data) {
        queryCache.OrgProfileResponses.update1(request.Date, data);
    });
    return {
        Id: params.id,
        Request: request,
        Editing: editing,
        Model: model,
        Organization: orgContainer,
        Berths: berths,
        Ports: ports,
        InviteUsers: inviteUsers,
        ShowInviteUsers: showInviteUsers,
        UserPermissions: userPermissions,
        ShowUserPermissions: showUserPermissions,
        AddBerth: addBerth,
        GoBack: function () { return window.history.back(); }
    };
    function OrganizationViewModel(organization) {
        var client = ajax.Url(function () { return organization.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(organization, client), validation = validationWatcher_1.ValidationWatcher(client), showSelectProfileImage = s_js_1.default.data(false), imageSelector = s_js_1.default(function () { return showSelectProfileImage() ? ConstructSelectProfileImage() : null; }), phoneNumbersVM = PhoneNumbersViewModel(organization), postalAddressesVM = PostalAddressesViewModel(organization), users = organization.Users.filter(function (u) { return u.Active(); }).map(PCUserViewModel);
        return {
            Model: draft,
            Validation: validation,
            ImageSelector: imageSelector,
            ShowSelectProfileImage: showSelectProfileImage,
            Users: users,
            PhoneNumbers: phoneNumbersVM,
            PostalAddresses: postalAddressesVM
        };
        function ConstructSelectProfileImage() {
            editing(false);
            return selectProfileImageModel({
                image: organization.Image,
                allowedImageUploadExtensions: model.Ref.AllowedImageUploadExtensions,
                maximumImageUploadFileSize: model.Ref.MaximumImageUploadFileSize,
                defaultImages: model.Ref.DefaultImages,
                minimumImageUploadImageSize: model.Ref.MinimumImageUploadImageSize,
                saveCroppedUploadUrl: entrypoints.SaveOrganizationImageUpload({ Id: params.id }),
                saveImageSelection: function () {
                    client.Put(organization);
                },
                onHide: function () { return showSelectProfileImage(false); }
            });
        }
    }
    function PCUserViewModel(user) {
        var showProfile = s_js_1.default.data(false), profilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({ id: user.Id(), onHidePopup: function () { return showProfile(false); } }) : null; });
        return {
            Model: user,
            ToggleProfile: function () { return showProfile(!showProfile()); },
            ProfilePopup: profilePopup
        };
    }
    function PortViewModel(port) {
        var piergroups = s_array_1.lift(pierGroupsByPort(port.Id)).orderBy(function (p) { return p.Model.Order(); });
        return {
            Model: port,
            PierGroups: piergroups
        };
    }
    function PierGroupViewModel(pg) {
        var berths = s_array_1.lift(berthsByPierGroup(pg.Id)).sort(Berth_1.Berth.StartMarkOrder);
        return {
            Model: pg,
            Berths: berths
        };
    }
    function PostalAddressesViewModel(organization) {
        var client = ajax.Url(function () { return organization.PostalAddressesUrl() || ''; });
        return {
            Addresses: organization.PostalAddresses.map(function (addr) { return postalAddressModel(addr, function (ts) { return RemoveFromCache(addr, ts); }); }),
            Add: Add
        };
        function Add() {
            var req = client.Post(new PostalAddress_1.PostalAddress());
            req.done(function (data) {
                cache.PostalAddresses.update1(req.Date, data);
            });
        }
        function RemoveFromCache(addr, ts) {
            var id = s_js_1.default.sample(function () { return PostalAddress_1.PostalAddress.key(addr); });
            cache.PostalAddresses.update(ts, [], [id]);
        }
    }
    function PhoneNumbersViewModel(organization) {
        var client = ajax.Url(function () { return organization.PhoneNumbersUrl() || ''; });
        return {
            PhoneNumbers: organization.PhoneNumbers.map(function (pn) { return phoneNumberModel(pn, function (ts) { return RemoveFromCache(pn, ts); }); }),
            Add: Add
        };
        function Add() {
            var req = client.Post(new PhoneNumber_1.PhoneNumber());
            req.done(function (data) {
                cache.PhoneNumbers.update1(req.Date, data);
            });
        }
        function RemoveFromCache(pn, ts) {
            var id = s_js_1.default.sample(function () { return PhoneNumber_1.PhoneNumber.key(pn); });
            cache.PhoneNumbers.update(ts, [], [id]);
        }
    }
}
exports.OrgProfile = OrgProfile;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordEntry = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var cx = __webpack_require__(10);
// TH 12/15/2016 -- NOTE: This view is specifically for when users are creating a brand new password.
// Don't use this when all you need is for users to enter their current password.
exports.PasswordEntry = supercritical_1.default(function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return React.createElement("span", { className: cx('password-entry', className) },
        React.createElement(PasswordInput, __assign({}, rest)),
        React.createElement(PasswordValidation, __assign({}, rest)));
});
var PasswordInput = supercritical_1.default(function (_a) {
    var value = _a.value, showValidation = _a.showValidation, placeholder = _a.placeholder, autoFocus = _a.autoFocus;
    return React.createElement("input", { type: "password", placeholder: placeholder, autoFocus: autoFocus, value: value(), onChange: function (e) { return value(e.currentTarget.value); }, onFocus: function () { return showValidation(true); }, onBlur: function () { return showValidation(false); } });
});
var passHasUpper = function (pass) { return /[A-Z]/.test(pass); }, passHasLower = function (pass) { return /[a-z]/.test(pass); }, passHasNumber = function (pass) { return /[0-9]/.test(pass); }, passHasSymbol = function (pass) { return /[^A-Za-z0-9]/.test(pass); }, passHasMinLength = function (pass) { return pass.length >= 6; };
var PasswordValidation = supercritical_1.default(function (_a) {
    var value = _a.value, showValidation = _a.showValidation;
    if (!showValidation())
        return null;
    return (React.createElement("div", { className: "password-validation" },
        React.createElement("div", { className: "arrow-up" }),
        React.createElement("div", { className: "description" }, "Make sure you have:"),
        React.createElement("div", { className: cx('validation-item', { 'passes-validation': passHasUpper(value()) }) }, "One uppercase letter"),
        React.createElement("div", { className: cx('validation-item', { 'passes-validation': passHasLower(value()) }) }, "One lowercase letter"),
        React.createElement("div", { className: cx('validation-item', { 'passes-validation': passHasNumber(value()) }) }, "One number"),
        React.createElement("div", { className: cx('validation-item', { 'passes-validation': passHasSymbol(value()) }) }, "One symbol (ex: $, # or !)"),
        React.createElement("div", { className: cx('validation-item', { 'passes-validation': passHasMinLength(value()) }) }, "At least 6 characters")));
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCAutoScroll = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
// Utility view to scroll a container element vertically to a selected child element.
// Put this around the child element.
var PCAutoScroll = /** @class */ (function (_super) {
    __extends(PCAutoScroll, _super);
    function PCAutoScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var keepInView = _a.keepInView, scrollParent = _a.scrollParent, retriggerScroll = _a.retriggerScroll;
            if (keepInView()) {
                if (retriggerScroll)
                    retriggerScroll();
                // TH 12/07/2016 -- requestAnimationFrame so we give the DOM a chance to update after a retriggerScroll.
                window.requestAnimationFrame(function () {
                    // TH 12/07/2016 -- Scroll element into view.
                    // Tried el.scrollIntoView, but it cause the whole page to move, so seemed way
                    // to jumpy for the current applications.
                    // Down the road, could maybe pass a flag for different scroll behaviors.
                    var parentElement = scrollParent ? scrollParent(el) : el.parentElement;
                    if (!parentElement)
                        return;
                    // maximum for el not to fall off the top
                    var maxScrollTop = el.offsetTop - parentElement.offsetTop, scrollTop = parentElement.scrollTop;
                    if (scrollTop > maxScrollTop) {
                        parentElement.scrollTop = maxScrollTop;
                    }
                    else {
                        // minimum for el not to fall off bottom
                        var minScrollTop = maxScrollTop + el.offsetHeight - parentElement.clientHeight;
                        if (scrollTop < minScrollTop)
                            parentElement.scrollTop = minScrollTop;
                    }
                });
            }
        });
        return _this;
    }
    PCAutoScroll.prototype.srender = function (_a) {
        var className = _a.className, onClick = _a.onClick, children = _a.children;
        return (React.createElement("div", { className: cx('pc-auto-scroll', {
                clickable: !!onClick
            }, className), onClick: onClick, ref: this.ref }, children));
    };
    return PCAutoScroll;
}(supercritical_1.SuperCriticalComponent));
exports.PCAutoScroll = PCAutoScroll;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PCBadge = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.PCBadge = supercritical_1.default(function (_a) {
    var visible = _a.visible, className = _a.className, onClick = _a.onClick, children = _a.children;
    return React.createElement("div", { className: "pc-badge "
            + (visible ? 'pc-badge-visible ' : '')
            + (onClick ? 'pc-badge-has-click ' : '')
            + (className || ''), onClick: onClick }, children);
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallEditorsView = exports.UIThemeView = exports.LandingPageView = exports.UserPhoneNumbersView = exports.UserJobDescriptionView = exports.UserOrganizationView = exports.UserEmailView = exports.UserNameView = exports.PersonProfilePageView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var EventType_1 = __webpack_require__(111);
var PortCallChangeType_1 = __webpack_require__(209);
var PortCallChange_1 = __webpack_require__(610);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(275);
var view_3 = __webpack_require__(547);
var view_4 = __webpack_require__(975);
var view_5 = __webpack_require__(154);
var view_6 = __webpack_require__(29);
var view_7 = __webpack_require__(510);
var view_8 = __webpack_require__(78);
var view_9 = __webpack_require__(35);
var view_10 = __webpack_require__(22);
exports.PersonProfilePageView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "personprofilepage pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back"),
            React.createElement(view_1.ActionsMenuButton, { onClick: m.ToggleActionsMenu }),
            React.createElement(ActionsMenu, { model: m })),
        React.createElement(Header, { model: m }),
        (function (user) { return user && React.createElement(view_3.SelectProfileImageView, { modelContainer: user.ImageSelector }); })(m.User()),
        React.createElement(PageBody, { model: m }),
        React.createElement(PageModals, { model: m }));
});
var Header = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e;
    var m = _a.model;
    return React.createElement("div", { className: "profile-header" },
        React.createElement("img", { src: (_b = m.User()) === null || _b === void 0 ? void 0 : _b.Model.Image.ProfileUrl() }),
        React.createElement("div", { className: "profile-header-details" },
            React.createElement("div", { className: "name pc-text-fixedwidth" }, (_c = m.User()) === null || _c === void 0 ? void 0 : _c.Model.FullName()),
            React.createElement("div", { className: "org-info" },
                (function (o) { return o &&
                    React.createElement("a", { className: "pc-text-fixedwidth", href: '#!orgprofile?id=' + o.Id() }, o.Name()); })((_d = m.User()) === null || _d === void 0 ? void 0 : _d.Model.Organization()),
                React.createElement("span", { className: "pc-icon-bullet" }),
                React.createElement("span", { className: "pc-text-fixedwidth" }, (_e = m.User()) === null || _e === void 0 ? void 0 : _e.Model.JobDescription()))));
});
var PageBody = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { hidden: !!((_b = m.User()) === null || _b === void 0 ? void 0 : _b.ImageSelector()) },
        React.createElement(PageLeftSide, { model: m }),
        React.createElement(PageRightSide, { model: m }));
});
var PageLeftSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "left-side" },
        React.createElement("div", { className: "pc-card profile-body clearfix" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("span", { className: "pc-card-title" }, "Profile")),
            React.createElement("div", { className: "left-column" },
                React.createElement(UserDetails, { model: m }),
                React.createElement(exports.LandingPageView, { model: m }),
                React.createElement(exports.UIThemeView, { model: m }),
                React.createElement(exports.PortCallEditorsView, { model: m })),
            React.createElement("div", { className: "right-column" },
                React.createElement(view_7.BookingRateView, { bookingRate: m.Model.BookingRate }),
                React.createElement(RolesView, { model: m }))));
});
var RolesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "roles" },
        React.createElement("h3", { className: "profile-section-title" }, "What can I do?"),
        m.Roles().map(function (r) {
            return React.createElement("div", { className: "role", key: r.Model.Id() },
                React.createElement("div", { className: "role-name" },
                    React.createElement("span", { className: "glyphicon glyphicon-ok pc-text-accent" }),
                    ' ',
                    React.createElement("span", null, r.Model.Name())),
                React.createElement("div", { className: "role-description pc-text-smalllabel" },
                    React.createElement("span", null, r.Description()),
                    ' ',
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return r.ShowAll(true); }), hidden: r.ShowAll() }, "More"),
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return r.ShowAll(false); }), hidden: !r.ShowAll() }, "Less")));
        }));
});
var UserDetails = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('user-details', {
            'pc-show-editcontrols': m.Editing(),
            'pc-show-viewcontrols': !m.Editing()
        }) },
        React.createElement("h3", { className: "profile-section-title" }, "Details"),
        React.createElement("a", { href: "", className: "pc-input-viewcontrol", onClick: eventWrappers_1.noDefault(function () { return m.Editing(true); }) }, "Edit"),
        React.createElement("a", { href: "", className: "pc-input-editcontrol", onClick: eventWrappers_1.noDefault(function () { return m.Editing(false); }) }, "Done Editing"),
        (function (user) { return user &&
            React.createElement("div", { className: "editprofileimagelink pc-input-editcontrol" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(user.ShowSelectProfileImage) }, "Edit Profile Image")); })(m.User()),
        React.createElement(exports.UserNameView, { model: m }),
        React.createElement(exports.UserEmailView, { model: m }),
        React.createElement(exports.UserOrganizationView, { model: m }),
        React.createElement(exports.UserJobDescriptionView, { model: m }),
        React.createElement(exports.UserPhoneNumbersView, { model: m }));
});
exports.UserNameView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "details-row" },
        React.createElement("label", { className: "left-col" }, "Name"),
        React.createElement("div", { className: "right-col" },
            React.createElement("span", { className: "pc-input-viewcontrol pc-text-fixedwidth" }, (_b = m.User()) === null || _b === void 0 ? void 0 : _b.Model.FullName()),
            (function (user) { return user &&
                React.createElement("span", null,
                    React.createElement("input", { className: "pc-input-editcontrol firstname", type: "text", placeholder: "First name", value: user.Model.FirstName(), onChange: function (e) { return user.Model.FirstName(e.target.value); } }),
                    React.createElement("input", { className: "pc-input-editcontrol lastname", type: "text", placeholder: "Last name", value: user.Model.LastName(), onChange: function (e) { return user.Model.LastName(e.target.value); } }),
                    React.createElement(view_6.ValidationErrorView, { error: function () { return user.Validation()['FirstName']; } }),
                    React.createElement(view_6.ValidationErrorView, { error: function () { return user.Validation()['LastName']; } })); })(m.User())));
});
exports.UserEmailView = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e, _f;
    var m = _a.model;
    return React.createElement("div", { className: "email details-row" },
        React.createElement("label", { className: "left-col" }, "Email"),
        React.createElement("div", { className: "right-col" },
            React.createElement("a", { className: "pc-input-viewcontrol pc-text-fixedwidth", href: 'mailto:' + ((_d = (_c = (_b = m.User()) === null || _b === void 0 ? void 0 : _b.User()) === null || _c === void 0 ? void 0 : _c.Model.Email()) !== null && _d !== void 0 ? _d : '') }, (_f = (_e = m.User()) === null || _e === void 0 ? void 0 : _e.User()) === null || _f === void 0 ? void 0 : _f.Model.Email()),
            (function (user) {
                if (!user)
                    return;
                var _u = user.User();
                return (React.createElement("span", null,
                    _u &&
                        React.createElement("input", { className: "pc-input-editcontrol", type: "text", placeholder: "Email", value: _u.Model.Email() || '', onChange: function (e) { return _u.Model.Email(e.target.value); } }),
                    React.createElement("a", { href: "", className: "notification-settings-link pc-input-editcontrol", onClick: eventWrappers_1.noDefault(user.ShowNotificationSettings) }, "Set notification email"),
                    _u && React.createElement(view_6.ValidationErrorView, { error: function () { return _u.Validation()['Email']; } })));
            })(m.User())));
});
exports.UserOrganizationView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "organization details-row" },
        React.createElement("label", { className: "left-col" }, "Organization"),
        React.createElement("div", { className: "right-col" }, (function (o) { return o &&
            React.createElement("a", { className: "pc-text-fixedwidth", href: '#!orgprofile?id=' + o.Id() }, o.Name()); })((_b = m.User()) === null || _b === void 0 ? void 0 : _b.Model.Organization())));
});
exports.UserJobDescriptionView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "job-description details-row" },
        React.createElement("label", { className: "left-col" }, "Job Description"),
        React.createElement("div", { className: "right-col" },
            React.createElement("span", { className: "pc-input-viewcontrol pc-text-fixedwidth" }, (_b = m.User()) === null || _b === void 0 ? void 0 : _b.Model.JobDescription()),
            (function (user) { return user &&
                React.createElement("span", null,
                    React.createElement("input", { className: "pc-input-editcontrol pc-text-fixedwidth", type: "text", placeholder: "Job description", value: user.Model.JobDescription() || '', onChange: function (e) { return user.Model.JobDescription(e.target.value); } }),
                    React.createElement(view_6.ValidationErrorView, { error: function () { return user.Validation()['JobDescription']; } })); })(m.User())));
});
exports.UserPhoneNumbersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "contacts details-row" },
        React.createElement("label", { className: "left-col" }, "Contacts"),
        (function (user) { return user &&
            React.createElement("div", { className: "right-col" },
                React.createElement("div", { className: "link-shell" },
                    React.createElement("a", { href: "", className: "pc-input-editcontrol profile-add-link", onClick: eventWrappers_1.noDefault(user.PhoneNumbers.Add) }, "+Add")),
                React.createElement("div", { className: "phonenumbers" }, user.PhoneNumbers.Numbers().map(function (phoneNumber) {
                    return React.createElement(view_2.PhoneNumberView, { key: phoneNumber.Model.Id(), model: phoneNumber });
                }))); })(m.User()));
});
exports.LandingPageView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "landing-page" },
        React.createElement("h3", { className: "profile-section-title my-landing-page" }, "My Landing Page"),
        (function (u) {
            var _a;
            return u &&
                React.createElement("select", { className: "pc-select", value: (_a = u.Model.LandingPage()) !== null && _a !== void 0 ? _a : '', onChange: function (e) { return u.Model.LandingPage(e.currentTarget.value); } }, m.Model.LandingPages().map(function (lp) { var _a, _b; return React.createElement("option", { key: (_a = lp.Hash()) !== null && _a !== void 0 ? _a : '', value: (_b = lp.Hash()) !== null && _b !== void 0 ? _b : '' }, lp.Name()); }));
        })(m.User()),
        React.createElement("span", { className: "pc-select-chevron" }));
});
exports.UIThemeView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "ui-theme" },
        React.createElement("h3", { className: "profile-section-title ui-theme" }, "My Visual Theme"),
        (function (u) { return u &&
            React.createElement("select", { className: "pc-select", value: u.Model.UIThemeId() + '', onChange: function (e) { return u.Model.UIThemeId(+e.currentTarget.value || null); } }, m.UIThemes().map(function (t) {
                var def = t === u.Model.DefaultUITheme();
                return (React.createElement("option", { key: t.Id(), value: def ? 'null' : t.Id() }, "" + (def ? '(default) ' : '') + t.Name() + " - " + t.Description()));
            })); })(m.User()),
        React.createElement("span", { className: "pc-select-chevron" }));
});
exports.PortCallEditorsView = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", { className: cx('portcall-editors', {
            'pc-show-editcontrols': !!((_b = m.User()) === null || _b === void 0 ? void 0 : _b.PortCallEditors.Editing()),
            'pc-show-viewcontrols': !((_c = m.User()) === null || _c === void 0 ? void 0 : _c.PortCallEditors.Editing())
        }) },
        React.createElement("h3", { className: "profile-section-title" },
            "Who can edit my PortCalls?",
            ' ',
            m.User() ? '(' + m.User().PortCallEditors.Editors().length + ')' : ''),
        (function (user) { return user &&
            React.createElement("div", { className: "edit-link" },
                React.createElement("a", { href: "", className: "pc-input-viewcontrol", onClick: eventWrappers_1.noDefault(function () { return user.PortCallEditors.Editing(true); }) }, "Edit"),
                React.createElement("a", { href: "", className: "pc-input-editcontrol", onClick: eventWrappers_1.noDefault(function () { return user.PortCallEditors.Editing(false); }) }, "Done Editing")); })(m.User()),
        (function (user) { return user &&
            React.createElement("div", null,
                React.createElement("div", { className: "pc-input-editcontrol" },
                    React.createElement(view_5.UserSelectorView, { model: user.PortCallEditors.NewEditorSelector, placeholder: "Invite Editor..." })),
                user.PortCallEditors.Editors().map(function (editor) {
                    return editor.Editor() &&
                        React.createElement("div", { className: "portcall-editor", key: editor.Editor().Id() },
                            React.createElement("a", { href: "", className: "pc-input-editcontrol delete-btn", onClick: eventWrappers_1.noDefault(editor.Remove) },
                                React.createElement("span", { className: "pc-close-icon" })),
                            ' ',
                            React.createElement("img", { src: editor.Editor().Image.ThumbUrl() }),
                            React.createElement("a", { href: "", className: "name-text pc-text-fixedwidth pc-text-smalltext", onClick: eventWrappers_1.noDefault(editor.ToggleProfile) }, editor.Editor().FullName()),
                            React.createElement(view_8.PersonProfilePopupView, { modelContainer: editor.ProfilePopup }));
                })); })(m.User()));
});
var PageRightSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "right-side" },
        React.createElement(NotificationsView, { model: m }));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_9.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return m.ShowActionsMenu(false); } },
                m.User() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: '#!reservationsdashboard?orgId=' + m.User().Model.OrganizationId() }, "View Reservations")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "View all reservations for your organization.")),
                m.User() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: '#!batchesdashboard?orgId=' + m.User().Model.OrganizationId() }, "View Batch Reservations")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "View all batches of repeating reservations for your organization.")),
                m.Model.CanChangePassword() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.ShowChangePassword(true); }) }, "Change Password")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Enter a new password for your PortCall account.")),
                m.Model.CanAdmin() &&
                    React.createElement("div", null,
                        React.createElement("div", { className: "pc-admin-separator pc-card-admin-title" },
                            "Admin ",
                            React.createElement("div", { className: "pc-admin-line" })),
                        (function (user) { return user &&
                            React.createElement("div", null,
                                React.createElement("div", { className: "action-item" },
                                    React.createElement("div", null,
                                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return user.ShowSendPasswordReset(true); }) }, "Send Password Reset")),
                                    React.createElement("div", { className: "pc-action-item-descr" }, "Send this person a password reset link.")),
                                React.createElement("div", { className: "action-item" },
                                    React.createElement("div", null,
                                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(user.ShowDeleteAccount) }, "Delete Account")),
                                    React.createElement("div", { className: "pc-action-item-descr" }, "Remove account and block access. All history will be saved."))); })(m.User())))) : null;
});
var NotificationsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card notifications" },
        React.createElement("div", { className: "pc-card-header" },
            React.createElement("span", { className: "pc-card-title" },
                "Notifications",
                ' ',
                '(' + m.Notifications.UnviewedNotificationsCount() + ')')),
        m.Notifications.Notifications().map(function (notif) {
            return React.createElement(NotificationView, { notif: notif, key: notif.Model.EventId() });
        }));
});
var NotificationView = supercritical_1.default(function (_a) {
    var notif = _a.notif;
    var event = notif.Event();
    if (!event)
        return null;
    return (React.createElement("div", { className: cx('user-notification', {
            unviewed: notif.Model.WebDate() === null
        }) },
        event.Model.Type() === EventType_1.EventType.Comment ? React.createElement(CommentEventView, { event: event }) :
            event.Model.Type() === EventType_1.EventType.PortCallChange ? React.createElement(PortCallChangeEventView, { event: event }) :
                // TODO: This misses many event types, most notably version events.
                null,
        React.createElement("span", { className: "pc-text-smalllabel" }, event.Date())));
});
var CommentEventView = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var event = _a.event;
    var comment = event.Model.Comment();
    if (!comment)
        return null;
    var logEvent = (_b = comment.RootEvent()) === null || _b === void 0 ? void 0 : _b.PortCalls()[0];
    return (React.createElement("div", null,
        React.createElement("span", null, (_e = (_d = (_c = comment.Event()) === null || _c === void 0 ? void 0 : _c.User()) === null || _d === void 0 ? void 0 : _d.FullName()) !== null && _e !== void 0 ? _e : (_g = (_f = comment.Event()) === null || _f === void 0 ? void 0 : _f.Automation()) === null || _g === void 0 ? void 0 : _g.Name()),
        ' ',
        "commented on your",
        ' ',
        logEvent ?
            React.createElement("a", { href: '#!portcallprofile?id=' + logEvent.PortCallId() }, "portcall.") :
            // logEvent being falsey probably means the PortCall on which this comment was made has since
            // been deleted, since we delete all of the PortCall's LogEvents at that point. (Well, or it
            // could mean the server has underpopulated the navigation properties to get to RootEvent.)
            // So no live PortCall to navigate to in that case.
            // TODO: But this makes for pretty useless notification text. Could see either showing the
            // comment message, even though the PortCall has since been deleted, or else suppressing
            // this whole notification row.
            React.createElement("span", null, "portcall.")));
});
var PortCallChangeEventView = supercritical_1.default(function (_a) {
    var event = _a.event;
    var pcChange = event.PortCallChange();
    if (!pcChange)
        return null;
    return (React.createElement("div", null, pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.Vessel ||
        pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.LineTime ||
        pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.Berth ? React.createElement(VesselTimeOrBerthChangeView, { pcChange: pcChange }) :
        pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.Creation ? React.createElement(CreationChangeView, { pcChange: pcChange }) :
            pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.LineTimeActual ? React.createElement(LineTimeActualChangeView, { pcChange: pcChange }) : null));
});
var VesselTimeOrBerthChangeView = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e, _f;
    var pcChange = _a.pcChange;
    return React.createElement("div", null,
        React.createElement("span", null, (_d = (_c = (_b = pcChange.Model.Event()) === null || _b === void 0 ? void 0 : _b.User()) === null || _c === void 0 ? void 0 : _c.FullName()) !== null && _d !== void 0 ? _d : (_f = (_e = pcChange.Model.Event()) === null || _e === void 0 ? void 0 : _e.Automation()) === null || _f === void 0 ? void 0 : _f.Name()),
        ' ',
        "changed the",
        pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.Vessel ? ' vessel ' :
            pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.LineTime ? ' time ' :
                pcChange.Model.Type() === PortCallChangeType_1.PortCallChangeType.Berth ? ' location ' : ' ',
        "of your",
        ' ',
        React.createElement("a", { href: '#!portcallprofile?id=' + pcChange.Model.PortCallId() }, "portcall."));
});
var CreationChangeView = supercritical_1.default(function (_a) {
    var pcChange = _a.pcChange;
    return React.createElement("div", null,
        "URGENT: New",
        ' ',
        React.createElement("a", { href: '#!portcallprofile?id=' + pcChange.Model.PortCallId() }, "PortCall"),
        ' ',
        "at ",
        pcChange.FirstLineTime(),
        " for ",
        ".");
});
var LineTimeActualChangeView = supercritical_1.default(function (_a) {
    var pcChange = _a.pcChange;
    return React.createElement("div", null,
        "Your ",
        pcChange.ActualDate(),
        ' ',
        React.createElement("a", { href: '#!portcallprofile?id=' + pcChange.Model.PortCallId() }, "PortCall"),
        ' ',
        "has",
        pcChange.Model.Field() === PortCallChange_1.LineTimeActualField.FirstLineActual ? ' arrived.' :
            pcChange.Model.Field() === PortCallChange_1.LineTimeActualField.LastLineActual ? ' departed.' : '');
});
var PageModals = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(view_4.ChangePasswordView, { modelContainer: m.ChangePassword }),
        React.createElement(SendPasswordResetModal, { model: m }),
        React.createElement(DeleteAccountModal, { model: m }),
        React.createElement(NotificationSettingsModal, { model: m }));
});
var SendPasswordResetModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_10.PCModal, { className: "sendpasswordreset", shown: function () { return !!(m.User() && m.User().SendPasswordResetModal()); }, onBackDropClick: function () { var _a; (_a = m === null || m === void 0 ? void 0 : m.User()) === null || _a === void 0 ? void 0 : _a.ShowSendPasswordReset(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" },
                React.createElement("h2", { className: "modal-title" }, "Send Password Reset"),
                (function (user) {
                    var _a, _b;
                    return ((_b = (_a = user === null || user === void 0 ? void 0 : user.SendPasswordResetModal()) === null || _a === void 0 ? void 0 : _a.Request.Response()) === null || _b === void 0 ? void 0 : _b.Success) &&
                        React.createElement("div", null,
                            React.createElement("div", null,
                                "A password reset link has been sent to",
                                ' ',
                                (function (_u) { return _u &&
                                    React.createElement("div", { className: "user-email" }, _u.Email()); })(user.Model.User())),
                            React.createElement("div", null,
                                React.createElement("button", { className: "pc-button", onClick: function () { return user.ShowSendPasswordReset(false); } }, "OK")));
                })(m.User()))));
});
var DeleteAccountModal = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement(view_10.PCModal, { className: "deleteaccount", shown: function () { return !!(m.User() && m.User().DeleteAccountModal()); }, onBackDropClick: function () { var _a; (_a = m === null || m === void 0 ? void 0 : m.User()) === null || _a === void 0 ? void 0 : _a.ShowDeleteAccount(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" },
                React.createElement("h2", { className: "modal-title" }, "Delete Account"),
                (function (deleteAccount) { return deleteAccount && (!deleteAccount.ActionSuccess() ?
                    React.createElement("div", null,
                        React.createElement("div", null, "Are you sure you want to delete this account?"),
                        React.createElement("div", { className: "action-btns" },
                            React.createElement("button", { className: "close pc-modal-close delete-close", onClick: function () { return m.User().ShowDeleteAccount(false); } }, "Cancel"),
                            React.createElement("button", { className: "pc-button", onClick: deleteAccount.Delete }, "Delete")))
                    :
                        React.createElement("div", null,
                            React.createElement("div", { className: "confirmation-message" }, "This account was deleted successfully."),
                            React.createElement("div", null,
                                React.createElement("button", { className: "pc-button", onClick: deleteAccount.DoneDeleting }, "OK")))); })((_b = m.User()) === null || _b === void 0 ? void 0 : _b.DeleteAccountModal()))));
});
var NotificationSettingsModal = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement(view_10.PCModal, { className: "notificationsettings", shown: function () { return !!(m.User() && m.User().NotificationSettingsModal()); }, onBackDropClick: function () { var _a; (_a = m === null || m === void 0 ? void 0 : m.User()) === null || _a === void 0 ? void 0 : _a.ShowNotificationSettings(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header pc-modal-header" },
                (function (user) { return user &&
                    React.createElement("button", { type: "button", className: "close pc-modal-close", onClick: function () { return user.ShowNotificationSettings(false); } },
                        React.createElement("span", null, "Close")); })(m.User()),
                React.createElement("h2", { className: "modal-title pc-modal-title" }, "Notification Settings")),
            React.createElement("div", { className: "modal-body" },
                React.createElement("div", { className: "notification-email" },
                    React.createElement("label", { className: "notification-email-label" }, "Notification Email"),
                    (function (notifSettings) { return notifSettings &&
                        React.createElement("input", { className: "notification-email-input", value: notifSettings.NotificationEmail() || '', onChange: function (e) { return notifSettings.NotificationEmail(e.target.value); } }); })((_b = m.User()) === null || _b === void 0 ? void 0 : _b.NotificationSettingsModal()),
                    React.createElement("div", { className: "notification-email-descr pc-text-smalllabel" }, "Enter an email address to receive notifications. Default is your log in email.")),
                (function (user) { return user &&
                    React.createElement(view_6.ValidationErrorView, { error: function () { return user.Validation()['NotificationEmail']; } }); })(m.User()))));
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PierGroupFootmarksView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(132);
var view_2 = __webpack_require__(152);
exports.PierGroupFootmarksView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "piergroupfootmarks" },
        React.createElement(ColumnHeaders, null),
        React.createElement(BerthsTable, { model: m }),
        React.createElement(TotalGroupLength, { model: m }));
});
var ColumnHeaders = supercritical_1.default(function () {
    return React.createElement("div", { className: "pgfm-headers" },
        React.createElement("span", { className: "pgfm-col pgfm-berth-name" }, "Berth"),
        React.createElement("span", { className: "pgfm-col pgfm-startmark" }, "Starting footmark"),
        React.createElement("span", { className: "pgfm-col pgfm-length" }, "Length"));
});
var BerthsTable = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.PCSortable, { className: "pgfm-berths-in-group", onSort: m.OnSortBerths, items: m.Berths, rowFactory: function (b) {
            return React.createElement(BerthRow, { berth: b, key: b.Berth.Id() });
        } });
});
var BerthRow = supercritical_1.default(function (_a) {
    var _b;
    var b = _a.berth;
    return React.createElement("li", null,
        React.createElement("div", null,
            React.createElement("span", { className: "pgfm-col pgfm-berth-name" }, (_b = b.Berth.Location()) === null || _b === void 0 ? void 0 : _b.Name()),
            React.createElement("span", { className: "pgfm-col pgfm-startmark" },
                React.createElement(view_2.ToggleableMeasurementView, { model: b.StartMark }),
                ' ',
                b.StartMark.uom()),
            React.createElement("span", { className: "pgfm-col pgfm-length" }, b.LengthIsValid() && React.createElement(view_2.ToggleableMeasurementView, { model: b.Length, textonly: true }))),
        !b.PrevLengthIsValid() &&
            React.createElement("div", { className: "pgfm-invalid-entry" }, "Cannot be less than the prior berth's starting footmark."));
});
var TotalGroupLength = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pgfm-total-group-length" },
        React.createElement("div", null,
            React.createElement("span", { className: "pgfm-col pgfm-berth-name" }, "Total group length"),
            React.createElement("span", { className: "pgfm-col pgfm-startmark" }),
            React.createElement("span", { className: "pgfm-col pgfm-length" },
                React.createElement(view_2.ToggleableMeasurementView, { model: m.PierGroupLength }),
                ' ',
                m.PierGroupLength.uom())),
        !m.LastBerthLengthIsValid() &&
            React.createElement("div", { className: "pgfm-invalid-entry" }, "Cannot be less than the sum of the lengths above."));
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallHeaderView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var view_1 = __webpack_require__(68);
var view_2 = __webpack_require__(534);
var view_3 = __webpack_require__(52);
exports.PortCallHeaderView = supercritical_1.default(function (_a) {
    var pc = _a.portcall, canEdit = _a.canEdit, issues = _a.issues, onIssueBadgeClick = _a.onIssueBadgeClick;
    var brs = pc.ActiveReservations(), durationMonths = "", durationDays = "", pjos = pc.JobOrders(), rafting = brs.some(function (br) { return br.Rafting(); }), hasPilotOrders = pjos.length > 0;
    if (brs.length > 0) {
        var firstLine = tzmoment_1.tzmoment(brs[0].Itinerary().Arrival.Effective()), lastLine = tzmoment_1.tzmoment(brs[brs.length - 1].Itinerary().Departure.Effective());
        durationMonths = firstLine.format("MMM");
        if (lastLine.format("MMM") != durationMonths)
            durationMonths += " - " + lastLine.format("MMM");
        durationDays = firstLine.format("DD");
        if (lastLine.format("MMM") != durationMonths || lastLine.format("DD") != durationDays)
            durationDays += " - " + lastLine.format("DD");
    }
    return (React.createElement("div", { className: "portcall-header" },
        React.createElement("div", { className: "pc-card pc-card-pcprofile header-timestamp" },
            React.createElement("div", { className: "month" }, durationMonths),
            React.createElement("div", { className: "days" }, durationDays)),
        React.createElement("div", { className: "header-text" },
            React.createElement("div", { className: "pc-page-title portcall-title" }, pc.DisplayVesselIdentifier() + ' PortCall'),
            React.createElement("div", { className: "portcall-subtitle" },
                React.createElement("span", { className: "pc-text-smalllabel" }, "Requested by "),
                React.createElement("span", { className: "pc-text-smalltext" }, pc.Requestor() ? pc.Requestor().FullName() : ''),
                React.createElement("span", { className: "pc-icon-bullet" }),
                React.createElement("span", { className: "pc-text-smalllabel" }, "Voyage # "),
                React.createElement("span", { className: "pc-text-smalltext", hidden: canEdit() }, pc.VoyageNumber()),
                React.createElement("input", { type: "text", className: "pc-text-smalltext", hidden: !canEdit(), value: pc.VoyageNumber() || '', onChange: function (e) { return pc.VoyageNumber(e.currentTarget.value); } }))),
        React.createElement("div", { className: "header-icons" },
            React.createElement(view_3.PCTooltip, { title: function () { return 'This PortCall has pilotage ordered. Please review the Dispatch Dashboard for additional information.'; }, className: 'badge-tooltip' },
                React.createElement(view_2.PCBadge, { className: "pilotage-badge", visible: hasPilotOrders }, "P")),
            React.createElement(view_3.PCTooltip, { title: function () { return 'This PortCall is Unlisted. It can only be viewed by people associated with the PortCall. Only authorized users can list it.'; }, className: 'badge-tooltip' },
                React.createElement(view_2.PCBadge, { className: "unlisted-badge", visible: pc.Unlisted() }, "U")),
            React.createElement(view_3.PCTooltip, { title: function () { return 'This PortCall has a rafted reservation. Go to the Berths Timeline to view the vessel this is rafted to.'; }, className: 'badge-tooltip' },
                React.createElement(view_2.PCBadge, { className: "rafting-badge", visible: rafting }, "R")),
            React.createElement(view_3.PCTooltip, { title: function () { return 'Click this badge to view more details behind the conflicts in this PortCall.'; }, className: 'badge-tooltip' }, issues && React.createElement(view_1.IssueCountBadge, { issues: issues, onClick: onIssueBadgeClick })))));
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CCardCurrency = exports.EditPhase = exports.EditType = exports.PortCallSchedule = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var mutex_1 = __webpack_require__(204);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var uniqueIndex_1 = __webpack_require__(70);
var validationWatcher_1 = __webpack_require__(23);
var CoordinationCard_1 = __webpack_require__(109);
var Issue_1 = __webpack_require__(157);
var MilestoneTypes_1 = __webpack_require__(158);
var Rights_1 = __webpack_require__(118);
var ScheduleDateEvent_1 = __webpack_require__(290);
var ScheduleDateEventType_1 = __webpack_require__(291);
var scheduleChangeEngine_1 = __webpack_require__(190);
var commonScheduleRules_1 = __webpack_require__(495);
function PortCallSchedule(loader, data, ajax, entrypoints, tzutils, Localization, scheduleChangeEngineModel, metroMapFrameworkModel, metroMapMilestoneModel, berthAssgnDetailsModel, ccardDetailsModel, cancelledCCardDetailsModel, headerModel, _a) {
    var PortCall = _a.PortCall, ccardController = _a.ccardController, cancelledCCardController = _a.cancelledCCardController;
    var _b = loader({ Id: PortCall.Id() }), model = _b.model, initialDataLoading = _b.loading, SetEditState = s_js_1.default.value(null), CurrentEditState = s_js_1.default(function () { return SetEditState() && EditState(SetEditState(), function () { return SetEditState(null); }); }), CurrentEditPhase = function () { var _a, _b; return (_b = (_a = CurrentEditState()) === null || _a === void 0 ? void 0 : _a.Phase()) !== null && _b !== void 0 ? _b : null; }, scheduleEngine = s_js_1.default.on(CurrentEditState, function () {
        var edit = CurrentEditState(), Policy = edit === null || edit === void 0 ? void 0 : edit.SchedulePolicy;
        if (!edit || !Policy)
            return null;
        var date = edit.Date, logActual = edit.Type === EditType.LogActual, clearActual = edit.Type === EditType.ClearActual, editActual = edit.Type === EditType.EditActual, isActual = logActual || clearActual || editActual, engine = scheduleChangeEngineModel({ PortCall: PortCall, Policy: Policy }), enter = new ScheduleDateEvent_1.ScheduleDateEvent({ Id: 0,
            Type: isActual ? ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered : ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered,
            ScheduleDateId: date.Id(), 
            // For logging actual, default to current date/time, but rounded down to the nearest minute
            // since otherwise you can wind up with small rounding artifacts in our UI since our UI
            // only displays dates to the nearest minute and our schedule engine only compares dates
            // to the nearest minute.
            Date: logActual ? tzmoment_1.tzmomentMod(tzutils, tzutils.now(), function (m) { return m.startOf('minute'); }).toJSON() :
                clearActual ? null :
                    date.Effective().toJSON()
        });
        enter.ScheduleDate(date);
        enter.ScheduleChange(engine.ScheduleChange);
        engine.ScheduleChange.ScheduleEvents.push(enter);
        return engine;
    }), scheduleChange = function () { return scheduleEngine() && scheduleEngine().ScheduleChange; }, scheduleEvents = s_array_1.lift(function () { return scheduleChange() && scheduleChange().ScheduleEvents() || []; }), eventIndex = uniqueIndex_1.default(scheduleEvents, scheduleChangeEngine_1.eventKey);
    var pcChangesClient = ajax.Url(function () { var _a; return (_a = PortCall.ChangesUrl()) !== null && _a !== void 0 ? _a : ''; }, { useCache: true, include: [function (c) { return c.ScheduleEvents; }] }), pcChangesCommitHandler = {
        Commit: function () {
            return __awaiter(this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = scheduleChange();
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, pcChangesClient.Post(scheduleChange())];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        _a;
                        return [2 /*return*/];
                }
            }); });
        },
        NewValidationWatcher: function () { return validationWatcher_1.ValidationWatcher(pcChangesClient); }
    };
    var Framework = metroMapFrameworkModel({
        PortCall: PortCall,
        MilestoneConstructor: Milestone
    }), milestones = Framework.Milestones, CanEditPortCall = function () { return (model.Rights() & Rights_1.PortCallRights.Edit) !== 0; }, CanEditActuals = function () { return (model.Rights() & Rights_1.PortCallRights.EditActuals) !== 0; }, CanMovePortCall = function () { return CanEditPortCall() && CurrentEditState() === null && milestones().length > 0 && PortCall.Schedule().every(function (d) { return d.Actual() === null; }); }, MovePortCall = function () { return SetEditState(MovePortCallState(milestones()[0].Date, pcChangesCommitHandler)); }, focusedMilestone = function () { return CurrentEditState() !== null && milestones().find(function (m) { return m.Date === CurrentEditState().Date; }) || null; }, changeInProgress = function () { var _a; return !!((_a = focusedMilestone()) === null || _a === void 0 ? void 0 : _a.ChangedDate()); };
    var Loading = s_js_1.default(function () {
        return initialDataLoading()
            || CurrentEditPhase() === EditPhase.Committing
            || milestones().some(function (m) { var _a; return (_a = m.BerthAssignment()) === null || _a === void 0 ? void 0 : _a.Loading(); });
    });
    return {
        PortCall: PortCall,
        Framework: Framework,
        CurrentEditState: CurrentEditState,
        CanMovePortCall: CanMovePortCall,
        MovePortCall: MovePortCall,
        Loading: Loading,
        Header: headerModel({ PortCall: PortCall })
    };
    function Milestone(params) {
        // related entities
        var Date = params.Date, MilestoneDates = params.MilestoneDates, metroMapMilestone = metroMapMilestoneModel(params);
        // movement properties
        var HasOccurred = function () { return Date.Actual() !== null; };
        // Testing out a looser UX on logging actuals; commenting out incase we revert based off user feedback
        // index = () => MilestoneDates().indexOf(Date),
        // isFirstWithoutActual = () => { const i = index(); return Date.Actual() === null && !MilestoneDates().some((m, j) => j < i && m.Actual() === null); },
        // isLastWithActual = () => { const i = index(); return Date.Actual() !== null && !MilestoneDates().some((m, j) => j > i && m.Actual() !== null); };
        // pending schedule events for this milestone
        var enteredEstimate = eventIndex(scheduleChangeEngine_1.buildEventKey(Date.Id(), ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateEntered)), enteredActual = eventIndex(scheduleChangeEngine_1.buildEventKey(Date.Id(), ScheduleDateEventType_1.ScheduleDateEventType.ActualDateEntered)), enteredEffective = function () { return enteredActual() || enteredEstimate(); }, changedEstimate = eventIndex(scheduleChangeEngine_1.buildEventKey(Date.Id(), ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged)), ChangedActual = eventIndex(scheduleChangeEngine_1.buildEventKey(Date.Id(), ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged));
        // pending schedule events for the end of this milestone segment
        var segmentEnd = function () { return metroMapMilestone.NextDate(); }, segmentEndChangedEstimate = eventIndex(function () { var _a, _b; return scheduleChangeEngine_1.buildEventKey((_b = (_a = segmentEnd()) === null || _a === void 0 ? void 0 : _a.Id()) !== null && _b !== void 0 ? _b : 0, ScheduleDateEventType_1.ScheduleDateEventType.EstimatedDateChanged); }), segmentEndChangedActual = eventIndex(function () { var _a, _b; return scheduleChangeEngine_1.buildEventKey((_b = (_a = segmentEnd()) === null || _a === void 0 ? void 0 : _a.Id()) !== null && _b !== void 0 ? _b : 0, ScheduleDateEventType_1.ScheduleDateEventType.ActualDateChanged); }), segmentEndChangedDate = function () {
            var _a, _b, _c, _e, _f, _g, _h;
            return segmentEndChangedActual() ?
                // Similar handling of clearing actual as for ChangedDate declared below. See comment there.
                ((_f = (_c = (_a = segmentEndChangedActual().Date()) !== null && _a !== void 0 ? _a : (_b = segmentEndChangedEstimate()) === null || _b === void 0 ? void 0 : _b.Date()) !== null && _c !== void 0 ? _c : (_e = segmentEnd()) === null || _e === void 0 ? void 0 : _e.Estimated()) !== null && _f !== void 0 ? _f : null) : (_h = (_g = segmentEndChangedEstimate()) === null || _g === void 0 ? void 0 : _g.Date()) !== null && _h !== void 0 ? _h : null;
        };
        // display and edit values that respect the above pending events
        var DateEntry = function () { return enteredEffective() && enteredEffective().Date; }, ChangedDate = function () {
            var _a, _b, _c, _e, _f;
            return ChangedActual() ?
                // Careful: If clearing actual, make sure to fallback to the saved estimated date (after a
                // defensive check to make sure we don't have a changed estimate too, which would be unexpected).
                // Basically, this says that the date is changing from the actual value to the estimated value.
                ((_c = (_a = ChangedActual().Date()) !== null && _a !== void 0 ? _a : (_b = changedEstimate()) === null || _b === void 0 ? void 0 : _b.Date()) !== null && _c !== void 0 ? _c : Date.Estimated()) : (_f = (_e = changedEstimate()) === null || _e === void 0 ? void 0 : _e.Date()) !== null && _f !== void 0 ? _f : null;
        }, DisplayDate = function () { var _a; return (_a = ChangedDate()) !== null && _a !== void 0 ? _a : Date.Effective(); }, 
        // The DisplayDate is an estimate (might be the committed estimate or might be a new estimate in
        // progress).
        DisplayDateIsEstimated = function () { return ChangedActual() ? ChangedActual().Date() === null : Date.Actual() === null; }, SegmentEndDate = function () { var _a, _b, _c; return (_c = (_a = segmentEndChangedDate()) !== null && _a !== void 0 ? _a : (_b = segmentEnd()) === null || _b === void 0 ? void 0 : _b.Effective()) !== null && _c !== void 0 ? _c : null; };
        // status of current edit state and pending changes
        var DateHasEditFocus = function () { var _a; return ((_a = CurrentEditState()) === null || _a === void 0 ? void 0 : _a.Date) === Date ? CurrentEditState() : null; }, DateIsInEditScope = function () { var _a; return ((_a = CurrentEditState()) === null || _a === void 0 ? void 0 : _a.EditScope.includes(Date)) || ChangedDate() !== null; }, NextDateIsInEditScope = function () { var _a; return !!segmentEnd() && ((_a = CurrentEditState()) === null || _a === void 0 ? void 0 : _a.EditScope.includes(segmentEnd())) || segmentEndChangedDate() !== null; }, DurationIsInEditScope = function () {
            return DateIsInEditScope() && !NextDateIsInEditScope() ||
                !DateIsInEditScope() && NextDateIsInEditScope() ||
                !!segmentEnd() && (+SegmentEndDate() - +DisplayDate()) !== (+segmentEnd().Effective() - +Date.Effective());
        }, enteredEstimateWasAccepted = function () {
            return !!enteredEstimate() && !!changedEstimate() && TZDate_1.default.nullableEq(enteredEstimate().Date(), changedEstimate().Date());
        }, enteredActualWasAccepted = function () {
            return !!enteredActual() && !!ChangedActual() && TZDate_1.default.nullableEq(enteredActual().Date(), ChangedActual().Date());
        }, entryWasAccepted = function () { return enteredEstimateWasAccepted() || enteredActualWasAccepted(); }, 
        // The user entered a date that differs from the current value, yet our schedule change engine either
        // didn't accept the users entry at all or only accepted it partially.
        DateEntryWasRejected = function () { return !!enteredEffective() && !TZDate_1.default.nullableEq(enteredEffective().Date(), Date.Effective()) && !entryWasAccepted(); };
        // actions
        var 
        // don't allow user to switch focus if they've got pending changes on another milestone
        CanEdit = function () { return CanEditPortCall() && !changeInProgress(); }, EditDate = function () { return CanEdit() && SetEditState(Date.Actual() !== null ? EditActualState(Date, pcChangesCommitHandler) :
            Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FirstArrival ? EditFirstArrivalState(Date, pcChangesCommitHandler) :
                Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.FinalDeparture ? EditFinalDepartureState(Date, pcChangesCommitHandler) :
                    Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.BerthArrival ? EditBerthArrivalState(Date, pcChangesCommitHandler) :
                        Date.MilestoneTypeId() === MilestoneTypes_1.MilestoneTypes.ShiftDeparture ? EditShiftDepartureState(Date, pcChangesCommitHandler) :
                            null); }, ReviewChanges = function () {
            var _a;
            // We'll allow moving to the review stage so long as the user's entered valued was accepted as is
            // by our schedule change engine. Figure that's clearer to the user than moving to the review stage
            // w/ a date that differs from what the user entered in.
            if (entryWasAccepted()) {
                (_a = CurrentEditState()) === null || _a === void 0 ? void 0 : _a.Phase(EditPhase.Reviewing);
            }
            else if (enteredEffective() && TZDate_1.default.nullableEq(enteredEffective().Date(), Date.Effective())) {
                // The user didn't make any changes, which is why our schedule change engine didn't record a
                // change event for their entry. Just treat that as equivalent to cancelling the edit.
                SetEditState(null);
            }
            else {
                // Apparently the user DID enter a new value, but our schedule change engine rejected the user's
                // entry either partly or in full. Stay in editing mode so the user can fix the problem.
            }
        }, 
        // Testing out a looser UX on logging actuals; commenting out incase we revert based off user feedback
        // CanLogActual = () => CanEditActuals() && isFirstWithoutActual() && !changeInProgress(),
        // CanClearActual = () => CanEditActuals() && isLastWithActual() && !changeInProgress(),
        CanLogActual = function () { return CanEditActuals() && !HasOccurred() && !changeInProgress(); }, CanClearActual = function () { return CanEditActuals() && HasOccurred() && !changeInProgress(); }, LogActual = function () { return CanLogActual() && SetEditState(LogActualState(Date, pcChangesCommitHandler)); }, ClearActual = function () { return CanClearActual() && SetEditState(ClearActualState(Date, pcChangesCommitHandler)); };
        // Berth assignment and C-Cards
        var BerthAssignment = s_js_1.default(function () {
            var _a;
            return Date.IsBerthArrivalDate() && ((_a = Date.ItineraryPoint()) === null || _a === void 0 ? void 0 : _a.BerthReservation()) ?
                BerthAssignmentViewModel(Date.ItineraryPoint().BerthReservation(), model.Rights, ajax, entrypoints, berthAssgnDetailsModel) :
                null;
        }), CurrentCoordinationCards = Date.CoordinationCards
            .map(function (ccard) { return CurrentCCardViewModel(ccard, ccardController, ccardDetailsModel); }), ShowObsoleteCoordinations = s_js_1.default.value(false), CancelledCoordinationCards = s_array_1.lift(function () {
            var _a, _b;
            // A representative version for each deleted C-Card we know of. This may or may not be the
            // most recent version of that C-Card.
            var representativeVersions = new Map();
            for (var _i = 0, _c = (_b = (_a = Date.Self()) === null || _a === void 0 ? void 0 : _a.DeletedCoordinationCardVersions()) !== null && _b !== void 0 ? _b : []; _i < _c.length; _i++) {
                var v = _c[_i];
                representativeVersions.set(v.Id(), v);
            }
            return Array.from(representativeVersions.values());
        })
            // Grab the C-Card self for each of these versions. Upserting it ourselves covers the case where
            // the server might not have sent us the Self object yet.
            .map(function (v) { return data.CoordinationCardSelves.update1(null, { Id: v.Id() }); })
            // Make sure that C-Card self has no Live version that we know of. Also ignore C-Card selves
            // that have no known versions, which can happen b/c of a delay (in terms of S's clock)
            // populating the Versions property.
            .filter(function (self) { return self.Live() === null && self.Versions().length > 0; })
            // Grab the most recent version we know of for each C-Card self
            .map(function (self) { return self.Versions().reduce(function (mostRecent, next) { return next.ChangeId() > mostRecent.ChangeId() ? next : mostRecent; }); })
            // Make sure this version says it's Deleted. This is defensive, as we already checked above that
            // we don't have a Live version of this C-Card. Also make sure this version says it belongs to
            // this milestone date, to guard against the possibility that this C-Card may have been
            // reassigned to a different milestone date since the deletion we started from above.
            .filter(function (v) { return v.Deleted() && v.ScheduleDateId() === Date.Id(); })
            .map(function (v) { return CancelledCCardViewModel(v, Date, ShowObsoleteCoordinations, cancelledCCardController, cancelledCCardDetailsModel); }), 
        // All current cards plus cancelled cards that match our ShowObsoleteCoordinations flag.
        VisibleCoordinationCards = CurrentCoordinationCards
            .concat(CancelledCoordinationCards.filter(function (ccard) { return ccard.IsVisible(); }))
            .sort(function (ccard1, ccard2) { return CoordinationCard_1.CoordinationCard.DisplayOrder(ccard1.Model, ccard2.Model); }), 
        // Cancelled coordinations that no longer apply to this milestone date (i.e. they were auto-cancelled
        // BECAUSE they no longer applied, say due to a location change).
        ObsoleteCoordinationCards = CancelledCoordinationCards.filter(function (ccard) { return !ccard.AppliesToMilestoneDate(); });
        return __assign(__assign({}, metroMapMilestone), { HasOccurred: HasOccurred,
            ChangedActual: ChangedActual,
            DateEntry: DateEntry,
            ChangedDate: ChangedDate,
            DisplayDate: DisplayDate,
            DisplayDateIsEstimated: DisplayDateIsEstimated,
            DateHasEditFocus: DateHasEditFocus,
            DateIsInEditScope: DateIsInEditScope,
            DurationIsInEditScope: DurationIsInEditScope,
            DateEntryWasRejected: DateEntryWasRejected, GlobalEditPhase: CurrentEditPhase, CanEdit: CanEdit,
            EditDate: EditDate,
            ReviewChanges: ReviewChanges,
            CanLogActual: CanLogActual,
            LogActual: LogActual,
            CanClearActual: CanClearActual,
            ClearActual: ClearActual,
            SegmentEndDate: SegmentEndDate,
            BerthAssignment: BerthAssignment,
            ShowObsoleteCoordinations: ShowObsoleteCoordinations,
            VisibleCoordinationCards: VisibleCoordinationCards,
            ObsoleteCoordinationCards: ObsoleteCoordinationCards,
            Localization: Localization });
    }
}
exports.PortCallSchedule = PortCallSchedule;
var EditType;
(function (EditType) {
    EditType["LogActual"] = "logactual";
    EditType["EditActual"] = "editactual";
    EditType["ClearActual"] = "clearactual";
    EditType["EditFirstArrival"] = "firstarrival";
    EditType["EditFinalDeparture"] = "finaldeparture";
    EditType["EditBerthArrival"] = "bertharrival";
    EditType["EditShiftDeparture"] = "shiftdepature";
    EditType["Move"] = "move";
})(EditType = exports.EditType || (exports.EditType = {}));
var EditPhase;
(function (EditPhase) {
    EditPhase["Editing"] = "editing";
    EditPhase["Reviewing"] = "reviewing";
    EditPhase["Committing"] = "committing";
    EditPhase["CommitErrors"] = "commit-errors";
})(EditPhase = exports.EditPhase || (exports.EditPhase = {}));
function EditState(_a, onCancelEdit) {
    var Type = _a.Type, Date = _a.Date, InitialPhase = _a.InitialPhase, SchedulePolicy = _a.SchedulePolicy, EditScope = _a.EditScope, CommitHandler = _a.CommitHandler;
    var Phase = s_js_1.default.value(InitialPhase), CommitErrors = CommitHandler.NewValidationWatcher();
    return {
        Type: Type,
        Date: Date,
        SchedulePolicy: SchedulePolicy(Date),
        EditScope: EditScope(Date),
        Cancel: onCancelEdit,
        Phase: Phase,
        CommitErrors: CommitErrors,
        Commit: Commit
    };
    function Commit() {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (s_js_1.default.sample(Phase) === EditPhase.Committing)
                            return [2 /*return*/];
                        Phase(EditPhase.Committing);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, CommitHandler.Commit()];
                    case 2:
                        _a.sent();
                        onCancelEdit();
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _a.sent();
                        // Validation errors put us in a distinct CommitErrors phase, from which the only option is to
                        // cancel the edit. All other errors (like 500 errors) put us back in the Reviewing phase, in case
                        // users decide they wanna retry the commit.
                        Phase(Object.keys(CommitErrors()).length > 0 ? EditPhase.CommitErrors : EditPhase.Reviewing);
                        throw ex_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
var EditMovementStartPolicy = function (d) { return function (pc) {
    if (!d.IsMovementStartDate())
        throw new Error("Cannot use movement start policy for milestone that isn't one");
    var ip = d.ItineraryPoint(), ipDeparture = ip && ip.DepartureEntity(), prev = ip && ip.PreviousMovementPoint(), prevArrival = prev && prev.ArrivalEntity(), next = ip && ip.NextMovementPoint(), nextArrival = next && next.ArrivalEntity(), nextDeparture = next && next.DepartureEntity();
    return commonScheduleRules_1.commonScheduleRules(pc).concat([
        // arrival at previous IP is anchored
        anchorDate(prevArrival),
        // transit duration is fixed, unless next arrival is an actual
        fixOffset(ipDeparture, nextArrival),
        // departure from next IP is anchored unless it's the port departure
        next && next.IsPortDeparture() ? null : anchorDate(nextDeparture)
    ]);
}; }, EditBerthArrivalPolicy = function (d) { return function (pc) {
    if (!d.IsBerthArrivalDate())
        throw new Error("Cannot use berth arrival policy for milestone that isn't one");
    var ip = d.ItineraryPoint(), prev = ip && ip.PreviousMovementPoint();
    return commonScheduleRules_1.commonScheduleRules(pc).concat([
        // departure from this IP is anchored
        anchorDate(ip && ip.DepartureEntity()),
        // departure from previous IP is anchored
        anchorDate(prev && prev.DepartureEntity()),
    ]);
}; }, LogOrEditActualPolicy = function (_d) { return function (pc) {
    // Actuals get committed straight to the schedule with the smallest possible impact on adjacent estimates.
    // See notes on actuals handling in scheduleChangeEngine.ts for more.
    return commonScheduleRules_1.commonScheduleRules(pc);
}; }, MovePortCallPolicy = function (d) { return function (pc) {
    // all dates move with the one being edited
    return pc.Schedule().filter(function (o) { return o !== d; }).map(function (o) {
        return fixOffset(d, o);
    });
}; }, anchorDate = function (d) {
    return d && new scheduleChangeEngine_1.ScheduleRule(d, scheduleChangeEngine_1.ScheduleRel.Eq, d.Estimated());
}, fixOffset = function (from, to) {
    return from && to && new scheduleChangeEngine_1.ScheduleRule(from, scheduleChangeEngine_1.ScheduleRel.Eq, to, +to.Estimated() - +from.Estimated());
}, movementScope = function (d) {
    var next = d.ItineraryPoint() && d.ItineraryPoint().NextMovementPoint() && d.ItineraryPoint().NextMovementPoint().ArrivalEntity();
    return next && next.Actual() === null ? [d, next] : [d];
}, allScope = function (d) { return d.PortCall() ? d.PortCall().Schedule() : [d]; }, singleScope = function (d) { return [d]; }, createScheduleEditState = function (Type, policy, scope, initialPhase) {
    return function (Date, CommitHandler) { return ({
        Type: Type,
        Date: Date,
        InitialPhase: initialPhase,
        SchedulePolicy: policy,
        EditScope: scope,
        CommitHandler: CommitHandler
    }); };
}, EditFirstArrivalState = createScheduleEditState(EditType.EditFirstArrival, EditMovementStartPolicy, movementScope, EditPhase.Editing), EditBerthArrivalState = createScheduleEditState(EditType.EditBerthArrival, EditBerthArrivalPolicy, singleScope, EditPhase.Editing), EditShiftDepartureState = createScheduleEditState(EditType.EditShiftDeparture, EditMovementStartPolicy, movementScope, EditPhase.Editing), EditFinalDepartureState = createScheduleEditState(EditType.EditFinalDeparture, EditMovementStartPolicy, movementScope, EditPhase.Editing), LogActualState = createScheduleEditState(EditType.LogActual, LogOrEditActualPolicy, singleScope, EditPhase.Editing), EditActualState = createScheduleEditState(EditType.EditActual, LogOrEditActualPolicy, singleScope, EditPhase.Editing), MovePortCallState = createScheduleEditState(EditType.Move, MovePortCallPolicy, allScope, EditPhase.Editing), ClearActualState = createScheduleEditState(EditType.ClearActual, LogOrEditActualPolicy, singleScope, EditPhase.Reviewing);
function BerthAssignmentViewModel(BerthReservation, rights, ajax, entrypoints, detailsModel) {
    var Issues = BerthReservation.Issues.sort(Issue_1.Issue.ReversePrecedenceOrder), SaveMutex = new mutex_1.Mutex(), ShowDetails = s_js_1.default.value(false), Details = s_js_1.default(function () { return ShowDetails() ?
        detailsModel({
            BerthReservation: BerthReservation,
            DismissDetails: function () { return ShowDetails(false); },
            SaveMutex: SaveMutex
        }) :
        null; }), bookUnbookReq = { ReservationIds: [BerthReservation.Id()] }, bookClient = ajax.Url(entrypoints.BookReservations, { useCache: true }), unbookClient = ajax.Url(entrypoints.UnbookReservations, { useCache: true }), booking = s_js_1.default.value(false), unbooking = s_js_1.default.value(false), hasBookPC = function () { return (rights() & Rights_1.PortCallRights.Book) !== 0; }, CanBook = function () { return hasBookPC() && BerthReservation.Bookable(); }, CanUnbook = function () { return hasBookPC() && BerthReservation.Unbookable(); }, Loading = function () { return booking() || unbooking(); };
    return {
        BerthReservation: BerthReservation,
        Issues: Issues,
        Details: Details,
        CanBook: CanBook,
        CanUnbook: CanUnbook,
        Loading: Loading,
        ToggleDetails: ToggleDetails,
        Book: Book,
        Unbook: Unbook
    };
    function ToggleDetails() {
        ShowDetails(!s_js_1.default.sample(ShowDetails));
    }
    function Book() {
        return __awaiter(this, void 0, void 0, function () {
            var guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (booking())
                            return [2 /*return*/];
                        booking(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, SaveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, bookClient.Post(bookUnbookReq)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        booking(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function Unbook() {
        return __awaiter(this, void 0, void 0, function () {
            var guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (unbooking())
                            return [2 /*return*/];
                        unbooking(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, SaveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, unbookClient.Post(bookUnbookReq)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        unbooking(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
}
var CCardCurrency;
(function (CCardCurrency) {
    CCardCurrency["Current"] = "current";
    CCardCurrency["Cancelled"] = "cancelled";
})(CCardCurrency = exports.CCardCurrency || (exports.CCardCurrency = {}));
var DEFAULT_CCARD_CONTROLLER = {};
function CurrentCCardViewModel(ccard, controllerFactory, detailsModel) {
    var _a;
    var controller = (_a = controllerFactory === null || controllerFactory === void 0 ? void 0 : controllerFactory(ccard)) !== null && _a !== void 0 ? _a : DEFAULT_CCARD_CONTROLLER, ShowDetails = s_js_1.default.value(false), Details = s_js_1.default(function () { return ShowDetails() ?
        detailsModel({
            CoordinationCard: ccard,
            DismissDetails: function () { return ShowDetails(false); },
            ShouldPauseLogUpdates: controller.ShouldPauseLogUpdates
        }) :
        null; });
    return {
        Currency: CCardCurrency.Current,
        Model: ccard,
        Details: Details,
        ToggleDetails: ToggleDetails
    };
    function ToggleDetails() {
        ShowDetails(!s_js_1.default.sample(ShowDetails));
    }
}
var DEFAULT_CANCELLED_CCARD_CONTROLLER = {};
function CancelledCCardViewModel(ccv, Date, ShowObsoleteCoordinations, controllerFactory, detailsModel) {
    var _a;
    var AppliesToMilestoneDate = s_js_1.default(function () { var _a, _b; return (_b = (_a = ccv.Coordination()) === null || _a === void 0 ? void 0 : _a.AppliesToScheduleDate(Date)) !== null && _b !== void 0 ? _b : false; }), IsVisible = function () { return AppliesToMilestoneDate() || ShowObsoleteCoordinations(); }, controller = (_a = controllerFactory === null || controllerFactory === void 0 ? void 0 : controllerFactory(ccv)) !== null && _a !== void 0 ? _a : DEFAULT_CANCELLED_CCARD_CONTROLLER, ShowDetails = s_js_1.default.value(false), Details = s_js_1.default(function () { return ShowDetails() ?
        detailsModel({
            CoordinationCard: ccv,
            DismissDetails: function () { return ShowDetails(false); },
            ShouldPauseLogUpdates: controller.ShouldPauseLogUpdates
        }) :
        null; });
    // Hide details if the C-Card itself is hidden
    s_js_1.default(function () { return IsVisible() || ShowDetails(false); });
    return {
        Currency: CCardCurrency.Cancelled,
        Model: ccv,
        AppliesToMilestoneDate: AppliesToMilestoneDate,
        IsVisible: IsVisible,
        Details: Details,
        ToggleDetails: ToggleDetails
    };
    function ToggleDetails() {
        ShowDetails(!s_js_1.default.sample(ShowDetails));
    }
}


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalAddressView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
exports.PostalAddressView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "postaladdress" },
        React.createElement("div", { className: "address-details" },
            React.createElement("span", { className: "pc-input-viewcontrol address pc-text-fixedwidth" }, m.Model.Address()),
            React.createElement("input", { className: "pc-input-editcontrol address", type: "text", placeholder: "Street Address", value: m.Model.Address(), onChange: function (e) { return m.Model.Address(e.target.value); } }),
            ' ',
            React.createElement("span", { className: "pc-input-viewcontrol apt pc-text-fixedwidth" }, m.Model.AptSte()),
            React.createElement("input", { className: "pc-input-editcontrol apt", type: "text", placeholder: "Apt./Ste.", value: m.Model.AptSte() || '', onChange: function (e) { return m.Model.AptSte(e.target.value); } }),
            React.createElement("br", null),
            React.createElement("span", { className: "pc-input-viewcontrol city pc-text-fixedwidth" }, m.Model.City() ? m.Model.City() + ',' : ''),
            React.createElement("input", { className: "pc-input-editcontrol city", type: "text", placeholder: "City", value: m.Model.City(), onChange: function (e) { return m.Model.City(e.target.value); } }),
            ' ',
            React.createElement("span", { className: "pc-input-viewcontrol state pc-text-fixedwidth" }, m.Model.StateProv()),
            React.createElement("input", { className: "pc-input-editcontrol state", type: "text", placeholder: "State/Province", value: m.Model.StateProv(), onChange: function (e) { return m.Model.StateProv(e.target.value); } }),
            ' ',
            React.createElement("span", { className: "pc-input-viewcontrol zip pc-text-fixedwidth" }, m.Model.PostalCode()),
            React.createElement("input", { className: "pc-input-editcontrol zip", type: "text", placeholder: "Postal Code", value: m.Model.PostalCode(), onChange: function (e) { return m.Model.PostalCode(e.target.value); } })),
        m.CanDelete &&
            React.createElement("a", { href: "", className: "delete pc-input-editcontrol", onClick: eventWrappers_1.noDefault(m.Delete) },
                React.createElement("i", { className: "pc-close-icon" })));
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportGroupListView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var exportgrouplist_1 = __webpack_require__(133);
var view_1 = __webpack_require__(106);
exports.ExportGroupListView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "exportgrouplist" },
        React.createElement(ExportGroupListHeader, { model: m }),
        m.ExportGroups().map(function (g) {
            return React.createElement(ExportGroupView, { model: m, group: g, key: g.UniqueKey() });
        }));
});
var ExportGroupListHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('export-group-list-header-row') },
        view_1.GridDivHeaderCells(exportgrouplist_1.Columns, m.RowSorter, 'export-group-list-cell'),
        React.createElement("div", { className: "export-group-list-cell group-selector" }, "\u00A0"));
});
var ExportGroupView = supercritical_1.default(function (_a) {
    var m = _a.model, g = _a.group;
    return React.createElement("div", { className: cx('export-group', { expanded: g.Expanded() }) },
        React.createElement(ExportGroupSummaryView, { model: m, group: g }),
        React.createElement(ExportGroupChargesView, { group: g }));
});
var ExportGroupSummaryView = supercritical_1.default(function (_a) {
    var m = _a.model, g = _a.group;
    return React.createElement("div", { className: "export-group-summary", onClick: function () { return g.Expanded(!g.Expanded()); } },
        view_1.GridDivRowCells(exportgrouplist_1.Columns, g, 'export-group-list-cell'),
        React.createElement("div", { className: "export-group-list-cell group-selector" }, m.ShowGroupSelectors() &&
            React.createElement("input", { type: "checkbox", checked: g.SelectedForExport(), onClick: eventWrappers_1.noPropagation(function () { }), onChange: function (e) { return g.SelectedForExport(e.currentTarget.checked); } })));
});
var ExportGroupChargesView = supercritical_1.default(function (_a) {
    var g = _a.group;
    return React.createElement("table", { className: "export-group-charges" },
        React.createElement("thead", { className: "pc-text-billing-label" },
            React.createElement("tr", null,
                React.createElement("th", { className: "item-code" }, "Item Code"),
                React.createElement("th", { className: "description" }, "Description"),
                React.createElement("th", { className: "quantity" }, "Qty."),
                React.createElement("th", { className: "rate" }, "Rate"),
                React.createElement("th", { className: "total" }, "Total"))),
        React.createElement("tbody", null, g.Charges().map(function (c) {
            return React.createElement(GroupChargeItemView, { charge: c, key: c.Id() });
        })));
});
var GroupChargeItemView = supercritical_1.default(function (_a) {
    var c = _a.charge;
    return React.createElement("tr", null,
        React.createElement("td", { className: "item-code" }, c.StandardItem() && c.StandardItem().QBTracking.Name()),
        React.createElement("td", { className: "description" }, c.Description()),
        React.createElement("td", { className: "quantity" }, c.NumberOfUnits()),
        React.createElement("td", { className: "rate" }, c.UnitPrice.toString({ places: exportgrouplist_1.PRICE_PRECISION })),
        React.createElement("td", { className: "total" }, c.Total.toString({ places: exportgrouplist_1.PRICE_PRECISION })));
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportSelectionControls = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(106);
exports.ExportSelectionControls = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.PageAction() === 1 /* SelectForExport */ ?
        React.createElement("div", { className: "export-selection-controls" },
            React.createElement(YesNoConfirmation, { model: m }),
            React.createElement(view_1.RowSelectorView, { model: m.RowSelector })) : null;
});
var YesNoConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("span", { className: "yes-no-confirmation" },
        React.createElement("span", { className: "yes-no-question-text" }, "Export selected?"),
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.PageAction(0 /* View */); }) }, "No"),
        React.createElement("span", { className: "pc-icon-bullet" }),
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.ShowConfirmExport(true); }) }, "Yes, Export"));
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportToQuickBooksLink = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
exports.ExportToQuickBooksLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.PageAction(1 /* SelectForExport */); })) }, "Export to QuickBooks");
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboard = exports.DefaultRole = void 0;
var s_js_1 = __webpack_require__(0);
var PortCallUserRole_1 = __webpack_require__(136);
exports.DefaultRole = PortCallUserRole_1.PortCallUserRole.Any;
var reservationsFilterStorageKey = "portcall.reservationsdashboard.filter";
function ReservationsDashboard(entrypoints, cache, user, baseModel, _a) {
    var _orgId = _a.orgId, range = _a.range, _role = _a.role, from = _a.from, to = _a.to, filter = _a.filter;
    var orgId = _orgId !== undefined ? _orgId : user() ? user().OrganizationId() : 0, role = s_js_1.default.data(_role !== undefined ? _role : exports.DefaultRole), base = baseModel({
        cacheCollection: cache.ReservationsDashboardResponses,
        modelKey: function (_a) {
            var FromDate = _a.FromDate, ToDate = _a.ToDate;
            return ({
                FromDate: FromDate,
                ToDate: ToDate,
                OrganizationId: orgId,
                Role: role()
            });
        },
        organizationRef: function (model) { return function () { return model().Organization(); }; },
        url: entrypoints.ReservationsDashboard,
        filterStorageKey: reservationsFilterStorageKey,
        range: range, from: from, to: to, filter: filter
    });
    return Object.assign({}, base, {
        OrgId: orgId,
        Role: role
    });
}
exports.ReservationsDashboard = ReservationsDashboard;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsListBase = exports.Columns = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var tzmoment_1 = __webpack_require__(9);
var callAll_1 = __webpack_require__(165);
var TZDate_1 = __webpack_require__(7);
var diacriticals_1 = __webpack_require__(42);
var BerthReservation_1 = __webpack_require__(38);
var csvExport_1 = __webpack_require__(149);
var model_1 = __webpack_require__(129);
var debounceSignal_1 = __webpack_require__(81);
// TH: TODO: Localization!!
var DATE_FORMAT = 'MM/DD/YY [at] HH:mm';
var VesselName = {
    Title: 'Vessel',
    DisplayValue: function (row) { return row.VesselName(); },
    SortValue: function (row) { return row.VesselName(); },
    ClassName: 'vessel'
}, BerthName = {
    Title: 'Berth',
    DisplayValue: function (row) { return row.BerthName(); },
    SortValue: function (row) { return row.BerthName(); },
    ClassName: 'berth'
}, PilotTime = {
    Title: 'Pilot Time',
    DisplayValue: function (row) { return row.PilotTimeDisplay(); },
    SortValue: function (row) { return row.PilotTime() || new TZDate_1.default(0); },
    ClassName: 'pilot-time'
}, FirstLine = {
    Title: 'First Line',
    DisplayValue: function (row) { return row.FirstLineDisplay(); },
    SortValue: function (row) { return row.FirstLine() || new TZDate_1.default(0); },
    ClassName: 'first-line'
}, LastLine = {
    Title: 'Last Line',
    DisplayValue: function (row) { return row.LastLineDisplay(); },
    SortValue: function (row) { return row.LastLine() || new TZDate_1.default(0); },
    ClassName: 'last-line'
}, Status = {
    Title: 'Status',
    DisplayValue: function (row) { return row.StatusText(); },
    SortValue: function (row) { return row.StatusText(); },
    ClassName: 'status'
}, RequestingAgency = {
    Title: 'Agency',
    DisplayValue: function (row) { return row.AgencyName(); },
    SortValue: function (row) { return row.AgencyName(); },
    ClassName: 'agency'
}, VoyageNumber = {
    Title: 'Voyage Number',
    DisplayValue: function (row) { return row.VoyageNumber(); },
    SortValue: function (row) { return row.VoyageNumber(); },
    ClassName: 'voyage-number'
}, PortName = {
    Title: 'Port/Region',
    DisplayValue: function (row) { return row.PortName(); },
    SortValue: function (row) { return row.PortName(); },
    ClassName: 'port'
}, PortCallId = {
    Title: 'PortCall Id',
    DisplayValue: function (row) { return row.PortCallIdDisplay(); },
    SortValue: function (row) { return row.PortCallId() || 0; },
    ClassName: 'pc-id'
};
var DefaultSortColumn = FirstLine;
exports.Columns = [
    VesselName,
    BerthName,
    PilotTime,
    FirstLine,
    LastLine,
    Status,
    RequestingAgency,
    VoyageNumber,
    PortName
];
var CSVColumns = [{
        name: VesselName.Title,
        formatter: VesselName.DisplayValue
    }, {
        name: BerthName.Title,
        formatter: BerthName.DisplayValue
    }, {
        name: PilotTime.Title,
        formatter: function (row) { return row.PilotTime() ? csvExport_1.ExcelTimeFormat(row.PilotTime()) : ''; }
    }, {
        name: 'First Line (Date)',
        formatter: function (row) { return row.FirstLine() ? csvExport_1.ExcelDateFormat(row.FirstLine()) : ''; }
    }, {
        name: 'First Line (Time)',
        formatter: function (row) { return row.FirstLine() ? csvExport_1.ExcelTimeFormat(row.FirstLine()) : ''; }
    }, {
        name: 'Last Line (Date)',
        formatter: function (row) { return row.LastLine() ? csvExport_1.ExcelDateFormat(row.LastLine()) : ''; }
    }, {
        name: 'Last Line (Time)',
        formatter: function (row) { return row.LastLine() ? csvExport_1.ExcelTimeFormat(row.LastLine()) : ''; }
    }, {
        name: Status.Title,
        formatter: Status.DisplayValue
    }, {
        name: RequestingAgency.Title,
        formatter: RequestingAgency.DisplayValue
    }, {
        name: VoyageNumber.Title,
        formatter: VoyageNumber.DisplayValue
    }, {
        name: PortName.Title,
        formatter: PortName.DisplayValue
    }, {
        name: PortCallId.Title,
        formatter: PortCallId.DisplayValue
    }];
function ReservationsListBase(ajax, entrypoints, dateRangeSelectorModel, _a) {
    var cacheCollection = _a.cacheCollection, url = _a.url, filterStorageKey = _a.filterStorageKey, modelKey = _a.modelKey, organizationRef = _a.organizationRef, range = _a.range, allowedRanges = _a.allowedRanges, from = _a.from, to = _a.to, _filter = _a.filter;
    var dateRangeSelector = dateRangeSelectorModel({ range: range, allowedRanges: allowedRanges, from: from, to: to }), filter = s_js_1.default.data(_filter || localStorage[filterStorageKey] || ''), loading = s_js_1.default.data(true), bookingOrCancelling = s_js_1.default.data(false), key = function () { return modelKey({
        FromDate: dateRangeSelector.FromDate().toJSON(),
        ToDate: dateRangeSelector.ToDate().toJSON(),
    }); }, model = s_js_1.default(function () { return cacheCollection.update1(null, key()); }), rowSorter = model_1.RowSorter(DefaultSortColumn), debouncedFilter = debounceSignal_1.debounceSignal(filter), pageAction = s_js_1.default.data(0 /* View */), rows = s_array_1.default([]), rowModels = rows.map(RowModel), anyBookableRows = rowModels.some(function (row) { return row.Bookable() && row.Model.CanBook(); }), anyCancellableRows = rowModels.some(function (row) { return row.Cancellable() && row.Model.CanCancel(); }), filteredRows = rowModels
        .filter(function (row) { return pageAction() === 0 /* View */
        || pageAction() === 1 /* Book */ && row.Bookable() && row.Model.CanBook()
        || pageAction() === 2 /* Cancel */ && row.Cancellable() && row.Model.CanCancel(); })
        .filter(function (row) { return diacriticals_1.CaseInsensitiveContains(row.FilterData(), debouncedFilter() || ''); }), sortedRows = filteredRows.sort(rowSorter.RowOrder), rowSelector = model_1.RowSelector(sortedRows, function (row) { return row.SelectedForPageAction; }), showActionsMenu = s_js_1.default.data(false), csvExportLink = s_js_1.default(function () { return csvExport_1.toCSVDataUri(sortedRows(), CSVColumns); }), showCancellationRemarksPrompt = s_js_1.default.value(false), cancellationRemarksPrompt = s_js_1.default(function () { return showCancellationRemarksPrompt() ?
        CancellationRemarksPrompt(CancelSelectedReservations, pageAction, function () { return showCancellationRemarksPrompt(false); }) :
        null; });
    // Store filter
    s_js_1.default(function () {
        localStorage[filterStorageKey] = filter();
    });
    // Fetch data
    s_js_1.default(function () {
        loading(true);
        var req = ajax.Url(url(key())).Get();
        req.then(function (json) {
            cacheCollection.update1(req.Date, json);
        }).finally(function () { return loading(false); });
    });
    // Populate data
    s_js_1.default(function () { return rows(model().Rows()); });
    // Clear all row selections when either the filter or the page action changes
    s_js_1.default.on(callAll_1.callAll(filteredRows, pageAction), function () { return rowModels().forEach(function (row) { return row.SelectedForPageAction(false); }); }, null, true);
    return {
        Model: model,
        Organization: organizationRef(model),
        Rows: sortedRows,
        RowSelector: rowSelector,
        DateRangeSelector: dateRangeSelector,
        Filter: filter,
        Loading: loading,
        BookingOrCancelling: bookingOrCancelling,
        RowSorter: rowSorter,
        AnyBookableRows: anyBookableRows,
        AnyCancellableRows: anyCancellableRows,
        ShowActionsMenu: showActionsMenu,
        PageAction: pageAction,
        SelectRowsToBook: SelectRowsToBook,
        BookSelectedReservations: BookSelectedReservations,
        SelectRowsToCancel: SelectRowsToCancel,
        PromptForCancellationRemarks: PromptForCancellationRemarks,
        CancellationRemarksPrompt: cancellationRemarksPrompt,
        CSVExportLink: csvExportLink,
        GoBack: function () { return window.history.back(); }
    };
    function SelectRowsToBook() {
        s_js_1.default.freeze(function () {
            showActionsMenu(false);
            pageAction(1 /* Book */);
        });
    }
    function SelectRowsToCancel() {
        s_js_1.default.freeze(function () {
            showActionsMenu(false);
            pageAction(2 /* Cancel */);
        });
    }
    function BookSelectedReservations() {
        var reservationIds = SelectedReservationIds();
        // Prevent double submits and submitting empty requests
        if (bookingOrCancelling() || !reservationIds.length)
            return;
        bookingOrCancelling(true);
        return ajax.Url(entrypoints.BookReservations, { useCache: true })
            .Post({ ReservationIds: reservationIds })
            .then(function () { pageAction(0 /* View */); })
            .finally(function () { return bookingOrCancelling(false); });
    }
    function CancelSelectedReservations(remarks) {
        var reservationIds = SelectedReservationIds();
        // Prevent double submits and submitting empty requests
        if (bookingOrCancelling() || !reservationIds.length)
            return;
        bookingOrCancelling(true);
        return ajax.Url(entrypoints.CancelReservations, { useCache: true })
            .Post({ ReservationIds: reservationIds, Remarks: remarks || null })
            .then(function () { pageAction(0 /* View */); })
            .finally(function () { return bookingOrCancelling(false); });
    }
    function SelectedReservationIds() {
        return filteredRows().filter(function (row) { return row.SelectedForPageAction(); }).map(function (row) { return row.Model.Id(); });
    }
    function PromptForCancellationRemarks() {
        if (!bookingOrCancelling() && SelectedReservationIds().length) {
            showCancellationRemarksPrompt(true);
        }
    }
    function RowModel(row) {
        var showActionsMenu = s_js_1.default.data(false), selectedForPageAction = s_js_1.default.data(false), pc = function () { return row.Reservation() && row.Reservation().Itinerary() && row.Reservation().Itinerary().PortCall(); }, loc = function () { return row.Reservation() && row.Reservation().Itinerary() && row.Reservation().Itinerary().Location(); }, portCallId = function () { return row.Reservation() && row.Reservation().Itinerary()
            ? row.Reservation().Itinerary().PortCallId() : null; }, portCallIdDisplay = s_js_1.default(function () { var _a, _b; return (_b = (_a = portCallId()) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '--'; }), vesselName = function () { return pc() ? pc().DisplayVesselIdentifier() || '--' : '--'; }, berthName = function () { return loc() ? loc().Name() : '--'; }, pilotTime = function () {
            var _pc = pc();
            if (_pc) {
                var portArrival = _pc.Itinerary().find(function (pt) { return pt.IsPortArrival(); });
                if (!portArrival)
                    return null;
                return portArrival.Departure.Effective();
            }
            return null;
        }, pilotTimeDisplay = s_js_1.default(function () { return pilotTime() ? tzmoment_1.tzmoment(pilotTime()).format(DATE_FORMAT) : '--'; }), firstLine = function () { return row.Reservation() && row.Reservation().Itinerary()
            ? row.Reservation().Itinerary().Arrival.Effective() : null; }, firstLineDisplay = s_js_1.default(function () { return firstLine() ? tzmoment_1.tzmoment(firstLine()).format(DATE_FORMAT) : '--'; }), lastLine = function () { return row.Reservation() && row.Reservation().Itinerary()
            ? row.Reservation().Itinerary().Departure.Effective() : null; }, lastLineDisplay = s_js_1.default(function () { return lastLine() ? tzmoment_1.tzmoment(lastLine()).format(DATE_FORMAT) : '--'; }), status = function () { return row.Reservation() ? row.Reservation().Status() : null; }, statusText = function () { return row.Reservation() ?
            row.Reservation().Status() === BerthReservation_1.BerthReservationStatus.Cancelled ? 'Cancelled' :
                row.Reservation().Itinerary()
                    && row.Reservation().Itinerary().Arrival.Actual()
                    && row.Reservation().Itinerary().Departure.Actual() ? 'Closed' :
                    row.Reservation().Status() === BerthReservation_1.BerthReservationStatus.Conflicted ? 'Conflicted' :
                        row.Reservation().Status() === BerthReservation_1.BerthReservationStatus.Booked ? 'Booked' :
                            'Requested'
            : '--'; }, agencyName = function () { return pc() && pc().Agent() && pc().Agent().Organization()
            ? pc().Agent().Organization().Name() : '--'; }, voyageNumber = function () { return pc() ? pc().VoyageNumber() || '--' : '--'; }, portName = function () { return loc() && loc().Berth() && loc().Berth().PierGroup() && loc().Berth().PierGroup().Port()
            ? loc().Berth().PierGroup().Port().Name() : '--'; }, bookable = function () { return row.Reservation() ? row.Reservation().Bookable() : false; }, cancellable = function () { return row.Reservation() ? row.Reservation().Cancellable() : false; }, filterData = function () {
            return vesselName() + " " +
                berthName() + " " +
                pilotTimeDisplay() + " " +
                firstLineDisplay() + " " +
                lastLineDisplay() + " " +
                statusText() + " " +
                agencyName() + " " +
                voyageNumber() + " " +
                portName();
        };
        return {
            Model: row,
            ShowActionsMenu: showActionsMenu,
            SelectedForPageAction: selectedForPageAction,
            PortCallId: portCallId,
            PortCallIdDisplay: portCallIdDisplay,
            VesselName: vesselName,
            BerthName: berthName,
            PilotTime: pilotTime,
            PilotTimeDisplay: pilotTimeDisplay,
            FirstLine: firstLine,
            FirstLineDisplay: firstLineDisplay,
            LastLine: lastLine,
            LastLineDisplay: lastLineDisplay,
            Status: status,
            StatusText: statusText,
            AgencyName: agencyName,
            VoyageNumber: voyageNumber,
            PortName: portName,
            Bookable: bookable,
            Cancellable: cancellable,
            FilterData: filterData
        };
    }
}
exports.ReservationsListBase = ReservationsListBase;
function CancellationRemarksPrompt(doCancel, pageAction, dismissPrompt) {
    var Remarks = s_js_1.default.value(null);
    return {
        Remarks: Remarks,
        CancelReservations: CancelReservations,
        QuitChanges: QuitChanges
    };
    function CancelReservations() {
        dismissPrompt();
        doCancel(Remarks());
    }
    function QuitChanges() {
        s_js_1.default.freeze(function () {
            dismissPrompt();
            pageAction(0 /* View */);
        });
    }
}


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsListBaseView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var tzmoment_1 = __webpack_require__(9);
var model_1 = __webpack_require__(544);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(128);
var view_3 = __webpack_require__(105);
var view_4 = __webpack_require__(106);
var orgheaderview_1 = __webpack_require__(131);
var view_5 = __webpack_require__(40);
var view_6 = __webpack_require__(35);
var view_7 = __webpack_require__(22);
var ReservationsListBaseView = /** @class */ (function (_super) {
    __extends(ReservationsListBaseView, _super);
    function ReservationsListBaseView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReservationsListBaseView.prototype.srender = function (props) {
        // This is one way to reference generic React components. An alternative is to nongeneric subclasses. See https://github.com/Microsoft/TypeScript/issues/3960.
        var m = props.model, className = props.className, title = props.title;
        return (React.createElement("div", { className: cx('reservations-list-base', className) },
            React.createElement("div", { className: "pc-actions-links-header" },
                React.createElement("a", { className: "pc-back-link", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back"),
                React.createElement(view_1.ActionsMenuButton, { onClick: function () { return m.ShowActionsMenu(!m.ShowActionsMenu()); } }),
                React.createElement(ActionsContainer, __assign({}, props))),
            m.Organization() && React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Organization() }),
            React.createElement(PageActionConfirmSelect, { model: m }),
            React.createElement(ControlsView, { model: m, title: title }),
            React.createElement(view_5.PageLoadingIndicator, { loading: function () { return m.Loading() || m.BookingOrCancelling(); } }),
            React.createElement(ReservationsTable, { model: m }),
            React.createElement(CancellationRemarksModal, { model: m })));
    };
    return ReservationsListBaseView;
}(supercritical_1.SuperCriticalComponent));
exports.ReservationsListBaseView = ReservationsListBaseView;
var ActionsContainer = /** @class */ (function (_super) {
    __extends(ActionsContainer, _super);
    function ActionsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionsContainer.prototype.srender = function (_a) {
        var m = _a.model, actionsMenuFactory = _a.actionsMenuFactory, csvExportFileName = _a.csvExportFileName;
        var factory = actionsMenuFactory || defaultActionsMenuFactory;
        return (React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
            React.createElement(view_6.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } }, factory({
                printMenuItem: React.createElement(PrintMenuItem, { model: m }),
                csvExportMenuItem: React.createElement(CSVExportMenuItem, { model: m, csvExportFileName: csvExportFileName }),
                cancelReservationsMenuItem: React.createElement(CancelReservationsMenuItem, { model: m }),
                bookReservationsMenuItem: React.createElement(BookReservationsMenuItem, { model: m }),
                adminSeparator: React.createElement(AdminSeparator, null)
            }))));
        function defaultActionsMenuFactory(_a) {
            var printMenuItem = _a.printMenuItem, csvExportMenuItem = _a.csvExportMenuItem, cancelReservationsMenuItem = _a.cancelReservationsMenuItem, bookReservationsMenuItem = _a.bookReservationsMenuItem, adminSeparator = _a.adminSeparator;
            return (React.createElement("div", null,
                printMenuItem,
                csvExportMenuItem,
                cancelReservationsMenuItem,
                m.AnyBookableRows() && adminSeparator,
                bookReservationsMenuItem));
        }
    };
    return ActionsContainer;
}(supercritical_1.SuperCriticalComponent));
var PrintMenuItem = /** @class */ (function (_super) {
    __extends(PrintMenuItem, _super);
    function PrintMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrintMenuItem.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("div", { className: "action-item" },
            React.createElement("div", null,
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () {
                        m.ShowActionsMenu(false);
                        window.print();
                    }) }, "Print Report")),
            React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Print the current view's results.")));
    };
    return PrintMenuItem;
}(supercritical_1.SuperCriticalComponent));
var CSVExportMenuItem = /** @class */ (function (_super) {
    __extends(CSVExportMenuItem, _super);
    function CSVExportMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CSVExportMenuItem.prototype.srender = function (_a) {
        var m = _a.model, csvExportFileName = _a.csvExportFileName;
        return (React.createElement("div", { className: "action-item" },
            React.createElement("div", null,
                React.createElement(view_3.DownloadLink, { href: m.CSVExportLink(), download: csvExportFileName ? csvExportFileName() : 'reservations.csv', onClick: function () { return m.ShowActionsMenu(false); } }, "Export to CSV")),
            React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Save the current view's results as a CSV, which can be used in Excel.")));
    };
    return CSVExportMenuItem;
}(supercritical_1.SuperCriticalComponent));
var CancelReservationsMenuItem = /** @class */ (function (_super) {
    __extends(CancelReservationsMenuItem, _super);
    function CancelReservationsMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CancelReservationsMenuItem.prototype.srender = function (_a) {
        var m = _a.model;
        return m.AnyCancellableRows() ?
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.SelectRowsToCancel) }, "Cancel Reservations")),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Select the reservations to be cancelled."))
            : null;
    };
    return CancelReservationsMenuItem;
}(supercritical_1.SuperCriticalComponent));
var AdminSeparator = supercritical_1.default(function () {
    return React.createElement("div", { className: "pc-admin-separator pc-card-admin-title" },
        "Admin ",
        React.createElement("div", { className: "pc-admin-line" }));
});
var BookReservationsMenuItem = /** @class */ (function (_super) {
    __extends(BookReservationsMenuItem, _super);
    function BookReservationsMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BookReservationsMenuItem.prototype.srender = function (_a) {
        var m = _a.model;
        return m.AnyBookableRows() ?
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.SelectRowsToBook) }, "Book Reservations")),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Select the reservations to be booked. Overlapping reservations in conflict will be changed to Booked."))
            : null;
    };
    return BookReservationsMenuItem;
}(supercritical_1.SuperCriticalComponent));
var PageActionConfirmSelect = /** @class */ (function (_super) {
    __extends(PageActionConfirmSelect, _super);
    function PageActionConfirmSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageActionConfirmSelect.prototype.srender = function (_a) {
        var m = _a.model;
        return (m.PageAction() === 1 /* Book */ || m.PageAction() === 2 /* Cancel */) ?
            React.createElement("div", { className: "page-action-confirm-select" },
                React.createElement(PageActionConfirm, { model: m }),
                React.createElement(view_4.RowSelectorView, { model: m.RowSelector }))
            : null;
    };
    return PageActionConfirmSelect;
}(supercritical_1.SuperCriticalComponent));
var PageActionConfirm = /** @class */ (function (_super) {
    __extends(PageActionConfirm, _super);
    function PageActionConfirm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageActionConfirm.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("span", { className: "page-action-confirm" },
            React.createElement("span", { className: "are-you-sure" }, "Are you sure?"),
            React.createElement("a", { href: "", className: "no", onClick: eventWrappers_1.noDefault(function () { return !m.BookingOrCancelling() && m.PageAction(0 /* View */); }) }, "No"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("a", { href: "", className: "yes", onClick: eventWrappers_1.noDefault(m.PageAction() === 1 /* Book */ ? m.BookSelectedReservations : m.PromptForCancellationRemarks) }, "Yes")));
    };
    return PageActionConfirm;
}(supercritical_1.SuperCriticalComponent));
var ControlsView = /** @class */ (function (_super) {
    __extends(ControlsView, _super);
    function ControlsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlsView.prototype.srender = function (_a) {
        var m = _a.model, title = _a.title;
        return (React.createElement("div", { className: "controls pc-search-mobile" },
            React.createElement("div", { className: "title" }, title ? title() : 'Reservations'),
            React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter By \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }),
            React.createElement(view_2.DateRangeSelectorView, { model: m.DateRangeSelector })));
    };
    return ControlsView;
}(supercritical_1.SuperCriticalComponent));
var ReservationsTable = /** @class */ (function (_super) {
    __extends(ReservationsTable, _super);
    function ReservationsTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReservationsTable.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("table", { className: "table" },
            React.createElement(TableHead, { model: m }),
            React.createElement(TableBody, { model: m })));
    };
    return ReservationsTable;
}(supercritical_1.SuperCriticalComponent));
var TableHead = /** @class */ (function (_super) {
    __extends(TableHead, _super);
    function TableHead() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableHead.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("thead", null,
            React.createElement("tr", null,
                view_4.GridTableHeaderCells(model_1.Columns, m.RowSorter),
                React.createElement("th", null))));
    };
    return TableHead;
}(supercritical_1.SuperCriticalComponent));
var TableBody = /** @class */ (function (_super) {
    __extends(TableBody, _super);
    function TableBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBody.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("tbody", null, m.Rows().map(function (row) {
            return React.createElement(TableRow, { row: row, model: m, key: row.Model.Id() });
        })));
    };
    return TableBody;
}(supercritical_1.SuperCriticalComponent));
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRow.prototype.srender = function (_a) {
        var row = _a.row, m = _a.model;
        return (React.createElement("tr", null,
            view_4.GridTableRowCells(model_1.Columns, row),
            React.createElement("td", { className: "actions" },
                m.PageAction() === 0 /* View */ ?
                    React.createElement("a", { href: "", className: "fa fa-bars actions-link", onClick: eventWrappers_1.noDefault(function () { return row.ShowActionsMenu(true); }) })
                    :
                        React.createElement("input", { type: "checkbox", checked: row.SelectedForPageAction(), onChange: function (e) { return row.SelectedForPageAction(e.currentTarget.checked); } }),
                React.createElement(RowActionsMenu, { row: row }))));
    };
    return TableRow;
}(supercritical_1.SuperCriticalComponent));
var RowActionsMenu = supercritical_1.default(function (_a) {
    var row = _a.row;
    return row.ShowActionsMenu() ?
        React.createElement(view_6.PCDismissible, { className: "pc-card actions-menu", onDismiss: function () { return row.ShowActionsMenu(false); } },
            React.createElement("div", { className: "action-item" }, row.FirstLine() && React.createElement("a", { href: '#!schedulegrid?resid=' + row.Model.Id() + '&date=' + tzmoment_1.tzmoment(row.FirstLine()).add(-1, 'days').format('YYYY-MM-DD') }, "Go to Berths")),
            React.createElement("div", { className: "action-item" }, row.PortCallId() !== null && React.createElement("a", { href: '#!portcallprofile?id=' + row.PortCallId() }, "Go to PortCall")))
        : null;
});
var CancellationRemarksModal = /** @class */ (function (_super) {
    __extends(CancellationRemarksModal, _super);
    function CancellationRemarksModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CancellationRemarksModal.prototype.srender = function (_a) {
        var _b;
        var m = _a.model;
        var prompt = m.CancellationRemarksPrompt();
        return (React.createElement(view_7.PCModal, { className: "cancellation-remarks-modal", shown: function () { return !!prompt; }, onBackDropClick: prompt === null || prompt === void 0 ? void 0 : prompt.QuitChanges },
            React.createElement("div", { className: "modal-content pc-card" },
                React.createElement("div", { className: "modal-body" },
                    React.createElement("h2", { className: "modal-title" }, "Cancel Reservations"),
                    React.createElement("div", null, "Are you sure you want to cancel the following reservation(s)?"),
                    prompt &&
                        React.createElement("div", null,
                            React.createElement("div", { className: "remarks-shell" },
                                React.createElement("textarea", { className: "remarks", value: (_b = prompt.Remarks()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return prompt.Remarks(e.currentTarget.value || null); }, placeholder: "These remarks will be sent to editors on each PortCall.", rows: 3 })),
                            React.createElement("div", { className: "actions" },
                                React.createElement("button", { className: "close pc-modal-close close-btn", onClick: prompt.QuitChanges }, "Close"),
                                React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(prompt.CancelReservations) }, "Cancel")))))));
    };
    return CancellationRemarksModal;
}(supercritical_1.SuperCriticalComponent));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCoordinationsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(195);
exports.SelectCoordinationsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "selectcoordinations" },
        React.createElement(view_1.MetroMapFrameworkView, { model: m.Framework, ctrl: { milestoneContent: function (m) { return React.createElement(MilestoneContent, { milestone: m }); } } }));
});
var MilestoneContent = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", null,
        React.createElement(view_1.MilestoneHeaderRow, { milestone: m }),
        React.createElement(view_1.MilestoneScheduleDetailsRow, { milestone: m }),
        React.createElement(MilestoneCoordinationsRow, { milestone: m }));
});
var MilestoneCoordinationsRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row portcall-milestone__coordinations-row" },
        React.createElement(MilestoneCoordinationsRowLabel, { milestone: m }),
        React.createElement(MilestoneCoordinationsRowBody, { milestone: m }));
});
var MilestoneCoordinationsRowLabel = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-label" }, m.Date.IsBerthArrivalDate() && view_1.BerthStayDurationText(m));
});
var MilestoneCoordinationsRowBody = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row-body" }, m.AvailableCoordinations().map(function (c) {
        return React.createElement(AvailableCoordinationView, { coordination: c, key: c.Coordination.Coordination.Id() });
    }));
});
var AvailableCoordinationView = supercritical_1.default(function (_a) {
    var c = _a.coordination;
    return React.createElement("div", { className: "available-coordination" },
        React.createElement(AvailableCoordinationSelector, { coordination: c }),
        React.createElement("div", { className: "available-coordination-info" },
            React.createElement(AvailableCoordinationTitleRow, { coordination: c }),
            React.createElement("div", { className: "available-coordination-descr-row pc-text-smalllabel" }, c.Coordination.Coordination.Description())));
});
var AvailableCoordinationSelector = supercritical_1.default(function (_a) {
    var c = _a.coordination;
    return React.createElement("div", { className: "available-coordination-selector" },
        React.createElement("label", { className: "pc-option" },
            React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: c.State().selected, onChange: function (e) { return e.currentTarget.checked ? c.Request() : c.CancelRequest(); } }),
            React.createElement("span", { className: "pc-breaker-light" }),
            React.createElement("span", { className: "pc-option-label" }, c.Coordination.Coordination.IsMandatory() ? 'Required' : 'Yes')),
        !c.Coordination.Coordination.IsMandatory() &&
            React.createElement("label", { className: "pc-option" },
                React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: !c.State().selected, onChange: function (e) { return e.currentTarget.checked ? c.CancelRequest() : c.Request(); } }),
                React.createElement("span", { className: "pc-breaker-light" }),
                React.createElement("span", { className: "pc-option-label" }, "No")));
});
var AvailableCoordinationTitleRow = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var c = _a.coordination;
    var s = c.State();
    return (React.createElement("div", { className: "available-coordination-title-row" },
        React.createElement("span", { className: "available-coordination-title" }, c.Coordination.Coordination.Title()),
        React.createElement("span", { className: "available-coordination-title-separator" }, "|"),
        s.selected ?
            c.Coordination.AvailableProviders().length === 1 ?
                React.createElement("span", { className: "available-coordination-provider-readonly" }, (_b = c.Coordination.AvailableProviders()[0].Provider.Provider()) === null || _b === void 0 ? void 0 : _b.Name()) :
                React.createElement("select", { className: "available-coordination-provider-dropdown", value: (_d = (_c = s.data) === null || _c === void 0 ? void 0 : _c.ProviderId) !== null && _d !== void 0 ? _d : 'no-provider', onChange: function (e) { return e.currentTarget.value !== 'no-provider' && c.Request(+e.currentTarget.value); } },
                    !s.data &&
                        React.createElement("option", { value: "no-provider", disabled: true }, "Select Provider"),
                    c.Coordination.AvailableProviders().map(function (p) {
                        var _a;
                        return React.createElement("option", { value: p.Provider.ProviderId(), key: p.Provider.ProviderId() }, (_a = p.Provider.Provider()) === null || _a === void 0 ? void 0 : _a.Name());
                    })) :
            React.createElement("span", { className: "available-coordination-agent-prompt" }, c.Coordination.Coordination.AgentPrompt())));
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectProfileImageView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(198);
var view_2 = __webpack_require__(1076);
var cx = __webpack_require__(10);
exports.SelectProfileImageView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    if (!m)
        return null;
    return (React.createElement("div", { className: "selectprofileimage pc-card" },
        React.createElement("div", { className: "pc-card-header" },
            React.createElement("span", { className: "pc-card-title" }, "Select Profile Image"),
            (function (m) { return m &&
                React.createElement("a", { href: "", className: "done-btn", onClick: eventWrappers_1.noDefault(m.Hide) }, "Done"); })(modelContainer())),
        React.createElement("div", null,
            React.createElement("label", { className: "img-block upload-new-image", htmlFor: m.FileUploader.FileInputId() },
                React.createElement("a", { className: "file-picker-link" }, "Upload New Image"),
                React.createElement(view_1.UploadFileView, { model: m.FileUploader })),
            m.Image.UploadProfileUrl() &&
                React.createElement("div", { className: cx('img-block uploaded-image', {
                        selected: m.Image.ProfileUrl() === m.Image.UploadProfileUrl()
                    }) },
                    React.createElement("img", { src: m.Image.UploadProfileUrl(), onClick: m.SelectUploadedImage }),
                    React.createElement("div", { className: "uploaded-image-controls" },
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.CropUploadedImage) },
                            React.createElement("span", { className: "glyphicon glyphicon-pencil edit-cropping pc-text-label-color" })))),
            m.DefaultImages().map(function (img) {
                return React.createElement("div", { className: cx('img-block', {
                        selected: m.Image.ProfileUrl() === img.Model.ProfileUrl()
                    }), key: img.Model.Id() },
                    React.createElement("img", { src: img.Model.ProfileUrl() || '', onClick: img.Select }));
            }),
            React.createElement(view_2.CropImageView, { modelContainer: m.ImageCropper }))));
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardListItemView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var TopicCardStatus_1 = __webpack_require__(137);
var view_1 = __webpack_require__(52);
exports.TopicCardListItemView = supercritical_1.default(function (_a) {
    var m = _a.model, className = _a.className, hideLastUpdate = _a.hideLastUpdate, onClick = _a.onClick;
    return React.createElement("div", { className: cx('topic-card-list-item pc-topic-card-list-item', {
            clickable: !!onClick
        }, className), onClick: onClick },
        React.createElement("div", { className: "card-title" }, m.Model.Title()),
        React.createElement("div", { className: "card-remarks" }, m.Model.Remarks()),
        React.createElement("div", { className: "card-comments-and-date pc-text-smalllabel" },
            !(hideLastUpdate && hideLastUpdate()) &&
                React.createElement(view_1.PCTooltip, { className: "card-last-updated", title: function () { return tzmoment_1.tzmoment(m.LastUpdated()).format('MM/DD/YY [at] HH:mm'); } },
                    "last update ",
                    tzmoment_1.tzmoment(m.LastUpdated()).from(m.Now())),
            React.createElement("span", null,
                m.Model.Comments().length,
                " Comments")),
        React.createElement(CardStatusView, { model: m, stopStatusClickPropagation: !!onClick }));
});
var CardStatusView = supercritical_1.default(function (_a) {
    var m = _a.model, stopStatusClickPropagation = _a.stopStatusClickPropagation;
    var possiblyStopPropagation = function (clickHandler) { return function (e) {
        stopStatusClickPropagation && e.stopPropagation();
        clickHandler && clickHandler();
    }; };
    return (React.createElement("div", { className: "card-status" }, m.Model.Status() === TopicCardStatus_1.TopicCardStatus.Confirmed ?
        React.createElement("span", null,
            React.createElement("span", { className: "confirm readonly" }, "Confirmed"),
            React.createElement("span", { className: cx('withdraw', {
                    disabled: !m.CanConfirm()
                }), onClick: possiblyStopPropagation(m.CanConfirm() ? m.WithdrawConfirmation : undefined) }, "Withdraw"))
        : m.Model.Status() === TopicCardStatus_1.TopicCardStatus.Denied ?
            React.createElement("span", null,
                React.createElement("span", { className: "deny readonly" }, "Denied"),
                React.createElement("span", { className: cx('withdraw', {
                        disabled: !m.CanConfirm()
                    }), onClick: possiblyStopPropagation(m.CanConfirm() ? m.WithdrawDenial : undefined) }, "Withdraw"))
            : m.Model.Status() === TopicCardStatus_1.TopicCardStatus.PendingReview ?
                React.createElement("span", null,
                    React.createElement("span", { className: cx('confirm', {
                            disabled: !m.CanConfirm()
                        }), onClick: possiblyStopPropagation(m.CanConfirm() ? m.Confirm : undefined) }, "Confirm"),
                    React.createElement("span", { className: cx('deny', {
                            disabled: !m.CanConfirm()
                        }), onClick: possiblyStopPropagation(m.CanConfirm() ? m.Deny : undefined) }, "Deny"))
                : null));
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFile = exports.FILE_TOO_BIG = exports.INVALID_EXTENSION = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var formatFileSize_1 = __webpack_require__(1386);
var FILE_INPUT_ID_PREFIX = '__pc_upload_file_input_';
var _fileInputId = 0;
function nextFileInputId() {
    return _fileInputId++;
}
exports.INVALID_EXTENSION = 'InvalidExtension', exports.FILE_TOO_BIG = 'FileTooBig';
function UploadFile(client, settings, invalidExtensionMessage, _a) {
    var onComplete = _a.onComplete;
    var validation = validationWatcher_1.ValidationWatcher(client), invalidExtension = s_js_1.default.data(false), fileTooBig = s_js_1.default.data(false), fileInputId = s_js_1.default.value(nextFileInputId());
    var uploading = false;
    var extendedValidation = s_js_1.default(function () {
        var errors = validation(), fileTooBigMsg = "Please pick a file that's " + formatFileSize_1.formatFileSize(settings.MaximumFileSize() * 1024, 0) + " or less.";
        if (invalidExtension())
            errors[exports.INVALID_EXTENSION] = {
                Field: exports.INVALID_EXTENSION,
                RawErrors: [invalidExtensionMessage],
                ErrorTexts: [invalidExtensionMessage],
                ErrorText: invalidExtensionMessage
            };
        if (fileTooBig())
            errors[exports.FILE_TOO_BIG] = {
                Field: exports.FILE_TOO_BIG,
                RawErrors: [fileTooBigMsg],
                ErrorTexts: [fileTooBigMsg],
                ErrorText: fileTooBigMsg
            };
        return errors;
    });
    return {
        UploadFile: UploadFile,
        AllowedExtensions: function () { return '.' + settings.AllowedExtensions().join(',.'); },
        Validation: extendedValidation,
        ResetValidation: ResetValidation,
        FileInputId: function () { return FILE_INPUT_ID_PREFIX + fileInputId(); }
    };
    function UploadFile(file) {
        if (uploading)
            return;
        uploading = true;
        // validate extension
        var ext = GetFileExtension(file.name).toLowerCase();
        var extMatch = s_js_1.default.sample(settings.AllowedExtensions).some(function (_ext) {
            return _ext.toLowerCase() === ext;
        });
        if (!extMatch) {
            s_js_1.default.freeze(function () {
                invalidExtension(true);
                clearFilePicker();
            });
            return;
        }
        // validate file size
        if (file.size / 1024 > s_js_1.default.sample(settings.MaximumFileSize)) {
            s_js_1.default.freeze(function () {
                fileTooBig(true);
                clearFilePicker();
            });
            return;
        }
        var formData = new FormData();
        formData.append('file', file);
        client.Post(formData)
            .then(onComplete)
            .finally(function () {
            clearFilePicker();
        });
        // TODO: progress bar?
        // TODO: make upload abortable?
    }
    function clearFilePicker() {
        uploading = false;
        // We use the fileInputId to drive a React key.
        // So incrementing the id will force React to render a new file input, thus clearing state from the old input.
        fileInputId(nextFileInputId());
    }
    function GetFileExtension(filename) {
        var match = filename.match(/\.([^.]*)$/);
        return match ? match[1] : '';
    }
    function ResetValidation() {
        s_js_1.default.freeze(function () {
            validation({});
            invalidExtension(false);
            fileTooBig(false);
        });
    }
}
exports.UploadFile = UploadFile;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
var view_2 = __webpack_require__(52);
var cx = __webpack_require__(10);
// character limits at which tooltips will be enabled
var MAX_NAME_CHARS = 20, MAX_ORG_CHARS = 22;
exports.UserPermissionsView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement(view_1.PCModal, { className: "userpermissions", shown: function () { return !!modelContainer(); }, onBackDropClick: m === null || m === void 0 ? void 0 : m.HidePopup },
        React.createElement("div", { className: "modal-content " + (m && m.HasPilots() ? "pilot-module" : "") },
            React.createElement("div", { className: "modal-header pc-modal-header" },
                m && React.createElement("button", { type: "button", className: "close pc-modal-close", onClick: m.HidePopup }, "Close"),
                React.createElement("h2", { className: "modal-title pc-modal-title" }, "Manage User Permissions")),
            m &&
                React.createElement("div", null,
                    React.createElement("div", { className: "modal-body" },
                        React.createElement(PermissionsContainer, { model: m }),
                        React.createElement(RoleDescriptionsList, { model: m })),
                    React.createElement(DeleteUserModal, { model: m })))));
});
var PermissionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "permissions-container" },
        React.createElement(PermissionsHeader, { model: m }),
        React.createElement(PermissionsUserList, { model: m }));
});
var PermissionsHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "permissions-header" },
        m.CanAssignSiteAdmin() &&
            React.createElement("div", { className: "site-admin-shading pc-shading-siteadmin" }),
        React.createElement("div", { className: "user-image row-item" }, "\u00A0"),
        React.createElement("div", { className: "user-details row-item" }, "\u00A0"),
        m.Model.AssignableRoles().map(function (r) {
            return React.createElement("div", { className: "perm row-item", key: r.Id() }, r.Name());
        }));
});
var PermissionsUserList = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "user-list" }, m.Users().map(function (user) {
        return React.createElement(PermissionsUserListUser, { model: user, assignableRoles: m.Model.AssignableRoles, key: user.Model.Id() });
    }));
});
var PermissionsUserListUser = supercritical_1.default(function (_a) {
    var m = _a.model, assignableRoles = _a.assignableRoles;
    return React.createElement("div", null,
        React.createElement("div", { className: "user-image row-item" },
            React.createElement("img", { className: "user-thumbnail", src: m.Model.Image.ThumbUrl() })),
        React.createElement("div", { className: "user-details row-item" },
            React.createElement(view_2.MaxLengthTooltip, { className: "user-name pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: function () { return m.Model.FullName(); }, maxLength: MAX_NAME_CHARS }),
            React.createElement(view_2.MaxLengthTooltip, { className: "organization-name pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: function () { return m.Model.Organization() ? m.Model.Organization().Name() : ''; }, maxLength: MAX_ORG_CHARS })),
        m.User() && React.createElement(UserRolesList, { model: m.User(), assignableRoles: assignableRoles }),
        React.createElement("div", { className: "perm row-item delete-user" },
            React.createElement("a", { href: "", className: "delete-link", onClick: eventWrappers_1.noDefault(m.ConfirmDeleteUser) }, "Delete")));
});
var UserRolesList = supercritical_1.default(function (_a) {
    var m = _a.model, assignableRoles = _a.assignableRoles;
    return React.createElement("div", { className: "row-item" }, assignableRoles().map(function (r) {
        return React.createElement("div", { className: "perm row-item", key: r.Id() },
            React.createElement("input", { className: "checkbox", type: "checkbox", checked: m.HasOrImpliesRole(r.Id()), disabled: m.ImpliesOrMaterializesRole(r.Id()), onChange: function (e) { return m.ToggleRole(r.Id()); } }));
    }));
});
var RoleDescriptionsList = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "info-container" }, m.Model.AssignableRoles().map(function (r) {
        return React.createElement("div", { key: r.Id() },
            React.createElement("div", { className: "permissions-name" }, r.Name()),
            React.createElement("div", { className: "permissions-desc" }, r.Description()));
    }));
});
var DeleteUserModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    // (TH 10/6/2016 -- This is a comment from the original HTML template)
    //
    // This isn't a true bootstrap modal, since user permissions is already a modal,
    // and modals inside of modals do funky things.
    return React.createElement("div", { className: cx('delete-user-popup', {
            open: !!m.DeleteUserModal()
        }) },
        React.createElement("div", { className: "modal-content" },
            React.createElement("h2", { className: "modal-title" }, "Delete User"),
            (function (d) { return d &&
                React.createElement("div", null, !d.ActionSuccess() ?
                    React.createElement("div", null,
                        React.createElement("div", null,
                            "Are you sure you want to delete",
                            React.createElement("br", null),
                            React.createElement("span", null, d.User.FullName() + '?')),
                        React.createElement("div", { className: "action-btns" },
                            React.createElement("button", { className: "close pc-modal-close delete-close", onClick: d.HideModal }, "Cancel"),
                            React.createElement("button", { className: "pc-button pc-button-primary", onClick: d.Delete }, "Delete")))
                    :
                        React.createElement("div", null,
                            React.createElement("div", { className: "confirmation-message" },
                                d.User.FullName(),
                                " was deleted successfully."),
                            React.createElement("div", { className: "action-btns" },
                                React.createElement("button", { className: "pc-button pc-button-primary done-btn", onClick: d.HideModal }, "OK")))); })(m.DeleteUserModal())));
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryViewModel = exports.PortCallViewModel = exports.PortCallsViewModel = exports.VesselPortCalls = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var tzmoment_1 = __webpack_require__(9);
var BerthReservation_1 = __webpack_require__(38);
function VesselPortCalls(ajax, entrypoints, data, cache, dateRangeSelectorModel, _a) {
    var id = _a.id, range = _a.range, from = _a.from, to = _a.to;
    var dateRangeSelector = dateRangeSelectorModel({ range: range, from: from, to: to });
    var key = function () { return ({
        VesselId: id,
        FromDate: dateRangeSelector.FromDate().toJSON(),
        ToDate: dateRangeSelector.ToDate().toJSON()
    }); };
    var model = s_js_1.default(function () { return cache.VesselPortCallResponses.update1(null, key()); });
    s_js_1.default(function () {
        var req = ajax.Url(entrypoints.VesselPortCalls(key())).Get();
        req.then(function (json) { return cache.VesselPortCallResponses.update1(req.Date, json); });
    });
    return {
        Model: model,
        DateRangeSelector: dateRangeSelector
    };
}
exports.VesselPortCalls = VesselPortCalls;
function PortCallsViewModel(portcalls) {
    return {
        PortCalls: portcalls.map(function (portcall) { return PortCallViewModel(portcall); }).sort(function (p1, p2) {
            if (p1.MinimumDate() != p2.MinimumDate())
                return +p1.MinimumDate() - +p2.MinimumDate();
            if (p1.PortCall.Port() && p2.PortCall.Port())
                return p1.PortCall.Port().Name().toLowerCase() < p2.PortCall.Port().Name().toLowerCase() ? -1 : p1.PortCall.Port().Name().toLowerCase() > p2.PortCall.Port().Name().toLowerCase() ? 1 : 0;
            return 0;
        })
    };
}
exports.PortCallsViewModel = PortCallsViewModel;
function PortCallViewModel(portcall) {
    var LastReservation = s_js_1.default(function () { return portcall.ActiveReservations().length > 0 ? portcall.ActiveReservations()[portcall.ActiveReservations().length - 1] : null; }), Itineraries = portcall.Itinerary.filter(function (f) { return !!f.BerthReservation(); }).map(function (i) { return ItineraryViewModel(i); }), MinDate = s_js_1.default(function () { return portcall.ActiveReservations()[0] && tzmoment_1.tzmoment(portcall.ActiveReservations()[0].Itinerary().Arrival.Effective()).format('MM-DD-YYYY'); }), MinimumDate = s_js_1.default(function () { return portcall.ActiveReservations()[0] && portcall.ActiveReservations()[0].Itinerary().Arrival.Effective(); }), PortName = s_js_1.default(function () { return portcall.Port() && portcall.Port().Name(); }), VoyageNumber = s_js_1.default(function () { return portcall.VoyageNumber() && portcall.VoyageNumber() != null ? portcall.VoyageNumber() : ''; });
    return {
        PortCall: portcall,
        Itineraries: Itineraries,
        MinDate: MinDate,
        LastReservation: LastReservation,
        MinimumDate: MinimumDate,
        PortName: PortName,
        VoyageNumber: VoyageNumber,
        NavigateToPortCall: function () { return window.location.hash = '#!portcallprofile?id=' + portcall.Id(); }
    };
}
exports.PortCallViewModel = PortCallViewModel;
function ItineraryViewModel(itinerary) {
    var berthReservation = itinerary.BerthReservation, arrival = tzmoment_1.tzmoment(itinerary.Arrival.Effective() && itinerary.Arrival.Effective()).format('MM-DD-YYYY [at] HH:mm'), departure = tzmoment_1.tzmoment(itinerary.Departure.Effective() && itinerary.Departure.Effective()).format('MM-DD-YYYY [at] HH:mm'), reservationStatus = berthReservation() && berthReservation().Status() && berthReservation().Status(), LocationName = s_js_1.default(function () { return itinerary.Location() && itinerary.Location().Berth() && itinerary.Location().Name(); }), ReservationStatus = BerthReservation_1.BerthReservationStatusDisplayName[reservationStatus], Issues1 = berthReservation() && berthReservation().Issues(), Issues = s_array_1.default([]), HasIssues = s_js_1.default(function () { return Issues().length > 1; });
    s_js_1.default(function () {
        if (berthReservation() && berthReservation().Issues())
            Issues(berthReservation().Issues());
    });
    return {
        Itinerary: itinerary,
        BerthReservation: berthReservation,
        Arrival: arrival,
        Departure: departure,
        LocationName: LocationName,
        ReservationStatus: ReservationStatus,
        HasIssues: HasIssues,
        Issues: Issues
    };
}
exports.ItineraryViewModel = ItineraryViewModel;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateDetailsCondensedView = exports.EstimateDetailsCardView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var EnhancedEstimateQuery_1 = __webpack_require__(303);
var view_1 = __webpack_require__(52);
/**
 * Estimate details as a stand-alone card.
 */
exports.EstimateDetailsCardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "wartsila-enrichments estimate-details estimate-details-card pc-card" },
        React.createElement("div", { className: "estimate-details-header pc-card-header" },
            React.createElement("span", { className: "title pc-card-title" }, "Estimated Arrival"),
            m.EstimateRefresher() && !m.InitialRefreshPendingOrInProgress() && React.createElement(RefreshLink, { refresher: m.EstimateRefresher() })),
        m.EstimateRefresher() && React.createElement(FailedRefreshView, { refresher: m.EstimateRefresher() }),
        React.createElement(EstimateDetailsBody, { model: m }));
});
/**
 * Estimate details in a condensed view for embedding in other cards.
 */
exports.EstimateDetailsCondensedView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "wartsila-enrichments estimate-details estimate-details-condensed" },
        React.createElement("div", { className: "condensed-header" },
            React.createElement("span", { className: "title" }, "Last Estimated Arrival"),
            m.EstimateRefresher() && !m.InitialRefreshPendingOrInProgress() && React.createElement(RefreshLink, { refresher: m.EstimateRefresher() })),
        m.EstimateRefresher() && React.createElement(FailedRefreshView, { refresher: m.EstimateRefresher() }),
        React.createElement(EstimateDetailsBody, { model: m }));
});
var RefreshLink = supercritical_1.default(function (_a) {
    var r = _a.refresher;
    return React.createElement("a", { className: "refresh-link", href: "", onClick: eventWrappers_1.noDefault(r.RefreshEstimate) }, "Refresh");
});
var FailedRefreshView = supercritical_1.default(function (_a) {
    var r = _a.refresher;
    if (r.FailedRefreshAttempt()) {
        var _b = r.FailedRefreshAttempt(), query = _b.query, dismiss = _b.dismiss;
        return (React.createElement("div", { className: "refresh-errors alert alert-danger" },
            React.createElement(UnsuccessfulQueryView, { query: query }),
            React.createElement("div", { className: "dismiss-container" },
                React.createElement("a", { className: "dismiss", href: "", onClick: eventWrappers_1.noDefault(dismiss) }, "Dismiss"))));
    }
    else {
        return null;
    }
});
var EstimateDetailsBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "estimate-details-body" }, m.RelevantQuery() ?
        React.createElement(EnhancedEstimateQueryView, { query: m.RelevantQuery() }) :
        React.createElement(MissingQueryView, null));
});
var EnhancedEstimateQueryView = supercritical_1.default(function (_a) {
    var query = _a.query;
    return query.Result() ? React.createElement(EnhancedEstimateView, { estimate: query.Result(), query: query }) :
        query.Model.Status() !== EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Succeeded ? React.createElement(UnsuccessfulQueryView, { query: query }) :
            null;
});
var EnhancedEstimateView = supercritical_1.default(function (_a) {
    var est = _a.estimate, query = _a.query;
    return React.createElement("div", { className: "enhanced-estimate" },
        React.createElement(EnhancedEstimateMain, { estimate: est, query: query }),
        React.createElement(EnhancedEstimateMeta, { estimate: est, query: query }));
});
var EnhancedEstimateMain = supercritical_1.default(function (_a) {
    var est = _a.estimate, query = _a.query;
    return React.createElement("div", { className: "enhanced-estimate-main" },
        "Based on its last reported position,",
        ' ',
        React.createElement("span", { className: "enhanced-estimate-vessel" }, query.Model.Vessel() && query.Model.Vessel().Name()),
        ' ',
        "could arrive by",
        ' ',
        est.Model.EstimatedArrival() && tzmoment_1.tzmoment(est.Model.EstimatedArrival()).format('MM/DD/YYYY [at] HH:mm'),
        ".");
});
var EnhancedEstimateMeta = supercritical_1.default(function (_a) {
    var est = _a.estimate, query = _a.query;
    return React.createElement("div", { className: "enhanced-estimate-meta" },
        React.createElement("span", { className: "automation-name pc-text-smalllabel" },
            "by ",
            query.Model.Automation() && query.Model.Automation().Name()),
        est.Timestamp() &&
            React.createElement(view_1.TimeAgoTooltip, { className: "estimate-time pc-text-smalllabel", date: function () { return est.Timestamp(); }, now: est.Clock.now }));
});
var UnsuccessfulQueryView = supercritical_1.default(function (_a) {
    var query = _a.query;
    return query.Model.Status() === EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Unactionable ?
        React.createElement(UnactionableQueryView, { query: query }) :
        query.Model.Status() === EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Failed ?
            React.createElement(FailedQueryView, { query: query }) :
            query.Model.Status() === EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Querying ?
                React.createElement(InProgressQueryView, null) :
                null;
});
var UnactionableQueryView = supercritical_1.default(function (_a) {
    var query = _a.query;
    var errors = [];
    // Missing IMO -- Expected and user-correctable.
    if ((query.Model.UnactionableReason() & EnhancedEstimateQuery_1.UnactionableReason.NoValidVesselIdentifiers) !== 0) {
        errors.push("Missing required field IMO. Make sure your vessel has a valid IMO.");
    }
    // Missing destination zone or automation system config -- Unexpected so long as we've
    // configured the database correctly. Correctable via direct db access only.
    if ((query.Model.UnactionableReason() & EnhancedEstimateQuery_1.UnactionableReason.NoValidDestinationZone) !== 0) {
        errors.push("Missing destination zone coordinates. Ask PortCall support to configure zone coordinates for the port arrival location.");
    }
    if ((query.Model.UnactionableReason() & EnhancedEstimateQuery_1.UnactionableReason.MissingEnhancedEstimatesAutomationConfiguration) !== 0) {
        errors.push("Missing enhanced estimates automation configuration. Ask PortCall support to configure the enhanced estimates automation.");
    }
    return (React.createElement("div", { className: "enhanced-estimate-query-unactionable" },
        React.createElement("div", null,
            "No enhanced estimate is available because of the following error",
            errors.length > 1 ? "s" : "",
            ":"),
        React.createElement("ul", null, errors.map(function (err, idx) {
            return React.createElement("li", { key: idx }, err);
        }))));
});
var FailedQueryView = supercritical_1.default(function (_a) {
    var query = _a.query;
    return React.createElement("div", { className: "enhanced-estimate-query-failed" },
        React.createElement("div", null, "Requesting an enhanced estimate failed with the following error:"),
        React.createElement("textarea", { className: "error-details", disabled: true, value: query.Model.FailureDetails() || '' }));
});
var InProgressQueryView = function () {
    return React.createElement("div", { className: "enhanced-estimate-query-inprogress" }, "A request for an enhanced estimate is in progress. Please check back in a few minutes.");
};
var MissingQueryView = function () {
    return React.createElement("div", { className: "enhanced-estimate-query-missing" }, "No enhanced estimate is available at this time.");
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var L = __webpack_require__(142);
__webpack_require__(347);
__webpack_require__(242);
var supercritical_1 = __webpack_require__(4);
var ZoneCoordinates_1 = __webpack_require__(115);
var MapView = /** @class */ (function (_super) {
    __extends(MapView, _super);
    function MapView(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, loadMap);
        return _this;
    }
    MapView.prototype.srender = function () {
        return (React.createElement("div", { className: "wartsila-enrichments estimated-route-map", ref: this.ref }));
    };
    return MapView;
}(supercritical_1.SuperCriticalComponent));
exports.MapView = MapView;
function loadMap(_a, el) {
    var m = _a.model;
    var map = L.map(el, { attributionControl: true });
    s_js_1.default.cleanup(function () { return map.remove(); });
    L.tileLayer(L.TileLayer.Provider.providers.Esri.url, L.TileLayer.Provider.providers.Esri.variants.WorldImagery.options).addTo(map);
    var route = function () {
        return m.RelevantQuery() &&
            m.RelevantQuery().Result() &&
            m.RelevantQuery().Result().Model.EstimatedRoute();
    }, routePolyline = s_js_1.default(function () {
        var r = route();
        return r && r.length ? L.polyline(r.map(ZoneCoordinates_1.LatLong.toLeaflet), { color: '#FFFFFF', opacity: 0.9 }) : null;
    }), sourceLatLng = function () {
        var r = route();
        return r && r.length ? r[0] : null;
    }, destinationCoords = s_js_1.default(function () {
        var query = m.RelevantQuery();
        if (!query)
            return null;
        // For now, just going with the zoone coords and zone type from the query entity itself.
        // The alternative is that we could add fallbacks to check the query's Destination nav
        // prop or even go straight to the portcall Itinerary, which might be pre-loaded. But
        // neither of those adds much since we're only initializing the map view if we have a valid
        // estimated route anyway. See the note below.
        return ZoneCoordinates_1.parseZoneCoordinates(query.Model.DestinationZoneCoordinates(), query.Model.DestinationZoneType());
    });
    // Zoom and position map
    s_js_1.default(function () {
        // For now, going with the theory that to position the map, we need an estimated route.
        // Otherwise we could, oh, try to center the view on the destination location, but I
        // found that made things kinda jumpy in the case where we do have an estimated route,
        // and also didn't add much useful info in the case that we don't.
        var polyline = routePolyline();
        if (!polyline)
            return;
        map.fitBounds(polyline.getBounds().pad(0.3));
    });
    // Draw source marker
    var srcIcon = L.divIcon({
        className: 'map-icon map-icon-src fa fa-map-marker',
        // NOTE: These sizes need to be tuned in coordination with the font-size rule on
        // .map-icon in mapview.less.
        iconSize: L.point(28, 28),
        // Tell Leaflet where the tip of our icon is relative to its top left corner.
        iconAnchor: L.point(14, 25)
    });
    s_js_1.default(function () {
        var src = sourceLatLng();
        if (!src)
            return;
        var srcMarker = L.marker(ZoneCoordinates_1.LatLong.toLeaflet(src), { icon: srcIcon });
        map.addLayer(srcMarker);
        s_js_1.default.cleanup(function () { return map.removeLayer(srcMarker); });
    });
    // Draw destination marker
    var destIcon = L.divIcon({
        className: 'map-icon map-icon-dest fa fa-times',
        // NOTE: These sizes need to be tuned in coordination with the font-size rule on
        // .map-icon in mapview.less.
        iconSize: L.point(28, 28)
    });
    s_js_1.default(function () {
        var dest = destinationCoords();
        if (!dest)
            return;
        // We won't draw the destination zone in full detail b/c we expect this
        // map to be too zoomed out for that to be useful. Instead, just
        // place a marker at the center of the destination.
        var center = dest instanceof ZoneCoordinates_1.PolygonCoords ?
            dest.toLeaflet().getBounds().getCenter() :
            dest.toLeaflet().getLatLng();
        var destMarker = L.marker(center, { icon: destIcon });
        map.addLayer(destMarker);
        s_js_1.default.cleanup(function () { return map.removeLayer(destMarker); });
    });
    // Draw route
    s_js_1.default(function () {
        var polyline = routePolyline();
        if (!polyline)
            return;
        map.addLayer(polyline);
        s_js_1.default.cleanup(function () { return map.removeLayer(polyline); });
    });
}


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1406), exports);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1409), exports);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationSystemType = void 0;
// AutomationSystemType values, hand-synched w/ PortCall.Models\DomainSettings\AutomationSystem.cs
var AutomationSystemType;
(function (AutomationSystemType) {
    AutomationSystemType["PortCallSystem"] = "SYS";
    AutomationSystemType["SystemUpgrade"] = "UPG";
    AutomationSystemType["TransasNaviHarbour"] = "TNH";
    AutomationSystemType["WartsilaEnhancedEstimates"] = "WES";
})(AutomationSystemType = exports.AutomationSystemType || (exports.AutomationSystemType = {}));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1419), exports);


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1420), exports);


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1422), exports);


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1423), exports);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosure = void 0;
var BerthClosure_1 = __webpack_require__(1424);
var PierMark_1 = __webpack_require__(159);
var BerthClosure = /** @class */ (function (_super) {
    __extends(BerthClosure, _super);
    function BerthClosure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BerthClosure.prototype, "PierMark", {
        // Following aah's note re BerthReservation.EndMark, making PierMark a getter property
        // to avoid needing to recreate it when constructing draft objects.
        get: function () { return new PierMark_1.PierMark(this.Footmark, this.Berth); },
        enumerable: false,
        configurable: true
    });
    return BerthClosure;
}(BerthClosure_1.BerthClosure));
exports.BerthClosure = BerthClosure;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1426), exports);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BollardPosition = void 0;
var BollardPosition_1 = __webpack_require__(612);
var PierMark_1 = __webpack_require__(159);
__exportStar(__webpack_require__(612), exports);
var BollardPosition = /** @class */ (function (_super) {
    __extends(BollardPosition, _super);
    function BollardPosition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BollardPosition.PierMarkOrder = function (bol1, bol2) {
        var bol1PierMark = bol1.PierMark, bol2PierMark = bol2.PierMark.convert(bol1PierMark.UOM()), cmp = bol1PierMark.Num() - bol2PierMark.Num();
        return cmp === 0 ? bol1.Id() - bol2.Id() : cmp;
    };
    Object.defineProperty(BollardPosition.prototype, "PierMark", {
        get: function () {
            return new PierMark_1.PierMark(this.Footmark, this.Berth);
        },
        enumerable: false,
        configurable: true
    });
    return BollardPosition;
}(BollardPosition_1.BollardPosition));
exports.BollardPosition = BollardPosition;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1439), exports);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1441), exports);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Antipode = exports.Abbreviation = exports.PointType = exports.PointsOfType = exports.COMPASS_SIZE = void 0;
var CompassPoint_1 = __webpack_require__(604);
// TH: A typescript port of CompassPointExtensions from PortCall.Models\Utils\CompassPoint.cs
exports.COMPASS_SIZE = 32;
function PointsOfType(type) {
    return CompassPoint_1.CompassPoints.map(function (item) { return item.Id; }).filter(function (compass) { return (type & PointType(compass)) !== 0; });
}
exports.PointsOfType = PointsOfType;
function PointType(compass) {
    return compass % CompassPoint_1.CompassPointType.Cardinal === 0 ? CompassPoint_1.CompassPointType.Cardinal
        : compass % CompassPoint_1.CompassPointType.Ordinal === 0 ? CompassPoint_1.CompassPointType.Ordinal
            : compass % CompassPoint_1.CompassPointType.SecondaryInterCardinal === 0 ? CompassPoint_1.CompassPointType.SecondaryInterCardinal
                : CompassPoint_1.CompassPointType.QuarterWind;
}
exports.PointType = PointType;
function Abbreviation(compass) {
    return compass === CompassPoint_1.CompassPoint.North ? "N"
        : compass === CompassPoint_1.CompassPoint.NorthByEast ? "NbE"
            : compass === CompassPoint_1.CompassPoint.NorthNorthEast ? "NNE"
                : compass === CompassPoint_1.CompassPoint.NorthEastByNorth ? "NEbN"
                    : compass === CompassPoint_1.CompassPoint.NorthEast ? "NE"
                        : compass === CompassPoint_1.CompassPoint.NorthEastByEast ? "NEbE"
                            : compass === CompassPoint_1.CompassPoint.EastNorthEast ? "ENE"
                                : compass === CompassPoint_1.CompassPoint.EastByNorth ? "EbN"
                                    : compass === CompassPoint_1.CompassPoint.East ? "E"
                                        : compass === CompassPoint_1.CompassPoint.EastBySouth ? "EbS"
                                            : compass === CompassPoint_1.CompassPoint.EastSouthEast ? "ESE"
                                                : compass === CompassPoint_1.CompassPoint.SouthEastByEast ? "SEbE"
                                                    : compass === CompassPoint_1.CompassPoint.SouthEast ? "SE"
                                                        : compass === CompassPoint_1.CompassPoint.SouthEastBySouth ? "SEbS"
                                                            : compass === CompassPoint_1.CompassPoint.SouthSouthEast ? "SSE"
                                                                : compass === CompassPoint_1.CompassPoint.SouthByEast ? "SbE"
                                                                    : compass === CompassPoint_1.CompassPoint.South ? "S"
                                                                        : compass === CompassPoint_1.CompassPoint.SouthByWest ? "SbW"
                                                                            : compass === CompassPoint_1.CompassPoint.SouthSouthWest ? "SSW"
                                                                                : compass === CompassPoint_1.CompassPoint.SouthWestBySouth ? "SWbS"
                                                                                    : compass === CompassPoint_1.CompassPoint.SouthWest ? "SW"
                                                                                        : compass === CompassPoint_1.CompassPoint.SouthWestByWest ? "SWbW"
                                                                                            : compass === CompassPoint_1.CompassPoint.WestSouthWest ? "WSW"
                                                                                                : compass === CompassPoint_1.CompassPoint.WestBySouth ? "WbS"
                                                                                                    : compass === CompassPoint_1.CompassPoint.West ? "W"
                                                                                                        : compass === CompassPoint_1.CompassPoint.WestByNorth ? "WbN"
                                                                                                            : compass === CompassPoint_1.CompassPoint.WestNorthWest ? "WNW"
                                                                                                                : compass === CompassPoint_1.CompassPoint.NorthWestByWest ? "NWbW"
                                                                                                                    : compass === CompassPoint_1.CompassPoint.NorthWest ? "NW"
                                                                                                                        : compass === CompassPoint_1.CompassPoint.NorthWestByNorth ? "NWbN"
                                                                                                                            : compass === CompassPoint_1.CompassPoint.NorthNorthWest ? "NNW"
                                                                                                                                : "NbW";
}
exports.Abbreviation = Abbreviation;
// Opposite side of the compass
function Antipode(compass) {
    return (compass + exports.COMPASS_SIZE / 2) % exports.COMPASS_SIZE;
}
exports.Antipode = Antipode;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1443), exports);


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1444), exports);


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1450), exports);


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1451), exports);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1453), exports);


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1454), exports);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchEvent = void 0;
var DispatchEvent_1 = __webpack_require__(1459);
var DispatchEvent = /** @class */ (function (_super) {
    __extends(DispatchEvent, _super);
    function DispatchEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DispatchEvent.prototype.ApprovalOfCharges = function () {
        return this._approvalsOfCharges().length === 0 ? null : this._approvalsOfCharges()[0];
    };
    return DispatchEvent;
}(DispatchEvent_1.DispatchEvent));
exports.DispatchEvent = DispatchEvent;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1463), exports);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1474), exports);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrder = void 0;
var JobOrder_1 = __webpack_require__(1482);
var JobOrder = /** @class */ (function (_super) {
    __extends(JobOrder, _super);
    function JobOrder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JobOrder.prototype.ApprovalOfCharges = function () {
        return this._approvalsOfCharges().length === 0 ? null : this._approvalsOfCharges()[0];
    };
    return JobOrder;
}(JobOrder_1.JobOrder));
exports.JobOrder = JobOrder;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1505), exports);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1509), exports);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1511), exports);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1513), exports);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1520), exports);


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1527), exports);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1534), exports);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1537), exports);


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1544), exports);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1551), exports);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1579), exports);


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1584), exports);


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCard = void 0;
var TopicCard_1 = __webpack_require__(1585);
var TopicCardStatus_1 = __webpack_require__(137);
var TopicCard = /** @class */ (function (_super) {
    __extends(TopicCard, _super);
    function TopicCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicCard.prototype.Status = function () {
        return this.DeniedDate() !== null ? TopicCardStatus_1.TopicCardStatus.Denied :
            this.ConfirmedDate() !== null ? TopicCardStatus_1.TopicCardStatus.Confirmed :
                TopicCardStatus_1.TopicCardStatus.PendingReview;
    };
    return TopicCard;
}(TopicCard_1.TopicCard));
exports.TopicCard = TopicCard;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1589), exports);


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1592), exports);


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1594), exports);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1597), exports);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1603), exports);


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1609), exports);


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Unmonitor = exports.Monitor = exports.Monitorable = void 0;
function Monitorable(obj, monitors) {
    if (monitors === void 0) { monitors = []; }
    var monitored = (obj instanceof Function ?
        function () {
            for (var _i = 0, monitors_2 = monitors; _i < monitors_2.length; _i++) {
                var monitor = monitors_2[_i];
                if (monitor instanceof Function)
                    monitor.apply(this, arguments);
            }
            return obj.apply(this, arguments);
        }
        : {});
    Object.setPrototypeOf(monitored, obj);
    Object.defineProperty(monitored, '%%Monitorable%%', { value: { monitors: [], base: obj } });
    for (var _i = 0, monitors_1 = monitors; _i < monitors_1.length; _i++) {
        var m = monitors_1[_i];
        Monitor(monitored, m);
    }
    return monitored;
}
exports.Monitorable = Monitorable;
function Monitor(monitored, monitor) {
    var data = monitored['%%Monitorable%%'];
    var _loop_1 = function (prop) {
        if (monitor.hasOwnProperty(prop) && prop in monitored && !monitored.hasOwnProperty(prop)) {
            var base_1 = monitored[prop];
            if (!(base_1 instanceof Function))
                throw new Error("Monitorable: cannot monitor a non-method: " + prop);
            monitored[prop] = function () {
                for (var _i = 0, _a = data.monitors; _i < _a.length; _i++) {
                    var monitor_1 = _a[_i];
                    if (monitor_1.hasOwnProperty(prop)) {
                        monitor_1[prop].apply(this, arguments);
                    }
                }
                base_1.apply(data.base, arguments);
            };
        }
    };
    for (var prop in monitor) {
        _loop_1(prop);
    }
    data.monitors.push(monitor);
}
exports.Monitor = Monitor;
function Unmonitor(monitored, monitor) {
    var data = monitored['%%Monitorable%%'];
    var i = data.monitors.indexOf(monitor);
    if (i !== -1)
        data.monitors.splice(i, 1);
}
exports.Unmonitor = Unmonitor;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronousSet = void 0;
var s_js_1 = __webpack_require__(0);
var SynchronousSet = function (init) {
    var items = new Set(init), // ts types don't appear to have the iterable signature on Set yet
    adds = new Set(), deletes = new Set(), clear = false, reset = null, changed = s_js_1.default.data(true), update = s_js_1.default.root(function () { return s_js_1.default.on(changed, function () {
        var item;
        if (reset)
            items = reset;
        else if (clear)
            items.clear();
        else
            for (var _i = 0, _a = Array.from(deletes); _i < _a.length; _i++) {
                item = _a[_i];
                items.delete(item);
            }
        for (var _b = 0, _c = Array.from(adds); _b < _c.length; _b++) {
            item = _c[_b];
            items.add(item);
        }
        clear = false;
        reset = null;
        deletes.clear();
        adds.clear();
    }); }), set = (function (_reset) { return _reset ? (changed(true), reset = _reset) : (update(), items); });
    set.add = function (item) { return (adds.add(item), changed(true), set); };
    set.delete = function (item) { return (deletes.add(item), changed(true), items.has(item)); };
    set.clear = function () { return (clear = true, changed(true), set); };
    return set;
};
exports.SynchronousSet = SynchronousSet;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationRule = exports.ValidationRules = void 0;
var s_js_1 = __webpack_require__(0);
/**
 * A utility class for doing client-side validation. This exposes errors in the same format as
 * our ValidationWatcher utility for displaying server-side validation errors. The intention is
 * that viewmodel code can switch btwn server-side and client-side validation (or a combo of the
 * two) w/o changing the API it exposes to view code.
 */
var ValidationRules = /** @class */ (function () {
    function ValidationRules() {
        var rules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rules[_i] = arguments[_i];
        }
        this.validation = s_js_1.default(function () {
            var errorSink = {};
            for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
                var rule = rules_1[_i];
                rule.run(errorSink);
            }
            var errors = {};
            for (var key in errorSink) {
                var theseErrors = errorSink[key];
                if (theseErrors && theseErrors.length > 0) {
                    errors[key] = {
                        Field: key,
                        RawErrors: theseErrors,
                        ErrorTexts: theseErrors,
                        ErrorText: theseErrors[0]
                    };
                }
            }
            return errors;
        });
    }
    return ValidationRules;
}());
exports.ValidationRules = ValidationRules;
var ValidationRule = /** @class */ (function () {
    function ValidationRule(field, isValid, errorText) {
        this.field = field;
        this.isValid = isValid;
        this.errorText = errorText;
    }
    ValidationRule.prototype.run = function (errorSink) {
        var errors = errorSink[this.field] = errorSink[this.field] || [];
        if (!this.isValid())
            errors.push(this.getErrorText());
    };
    ValidationRule.prototype.getErrorText = function () {
        return typeof this.errorText === 'string' ? this.errorText : this.errorText();
    };
    return ValidationRule;
}());
exports.ValidationRule = ValidationRule;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.filterWrites = void 0;
var s_js_1 = __webpack_require__(0);
function filterWrites(signal, filter) {
    return function (incoming) {
        var current;
        return (arguments.length === 0 ? signal() :
            filter(incoming, current = s_js_1.default.sample(signal)) ? signal(incoming) :
                current);
    };
}
exports.filterWrites = filterWrites;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonizeSignals = void 0;
var jsonizeSignals = function (obj, signals) {
    var resolvedSignals = new Set();
    // extract the raw signal instances
    for (var _i = 0, signals_1 = signals; _i < signals_1.length; _i++) {
        var accessor = signals_1[_i];
        resolveSignals(accessor(obj), resolvedSignals);
    }
    // if we encounter one of them while jsonizing, unwrap (call) it
    var replacer = function (_key, value) {
        if (resolvedSignals.has(value))
            value = value(); // it's a listed signal, unwrap
        if (value === null || value === void 0 ? void 0 : value.toJSON)
            value = value.toJSON(); // if underlying type has a .toJSON, respect it
        return value; // return result for base jsonizer
    };
    return JSON.stringify(obj, replacer);
};
exports.jsonizeSignals = jsonizeSignals;
function resolveSignals(signals, resolved) {
    if (signals instanceof Function) {
        resolved.add(signals);
    }
    else if (Array.isArray(signals)) {
        for (var _i = 0, signals_2 = signals; _i < signals_2.length; _i++) {
            var childSignals = signals_2[_i];
            resolveSignals(childSignals, resolved);
        }
    }
}


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeLoader = void 0;
// small utility to handle loading data that may or may not be required
// when required() turns true, sends AJAX request to url, loading the result (via jsonMapping) into the target
// provides loading, loaded and error observables to report state of loader
// returns the computed that watches required -- be sure to dispose as needed.
var s_js_1 = __webpack_require__(0);
var loader_1 = __webpack_require__(1392);
function maybeLoader(ajax, url, target, required) {
    var loader = loader_1.Loader(ajax, url, target), watcher = s_js_1.default(function () {
        if (required())
            loader.Load();
    });
    return loader;
}
exports.maybeLoader = maybeLoader;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sumSignal = void 0;
var s_js_1 = __webpack_require__(0);
/**
 * Returns a "reducing" signal which takes its updates in the form of a transform function and allows for the
 * possibility that multiple transforms might be applied in a single tick of S's clock.
 * @param value The intial value
 */
function sumSignal(value) {
    var 
    // A pure event signal
    ev = s_js_1.default.data(null), 
    // Distinguish the pending value that's being operated on by any provided update functions from the
    // comitted value that will be exposed to code reading from the signal. If the signal is updated while
    // S's clock is already frozen, we don't wanna expose the pending value to signal readers till after
    // S's clock ticks.
    committedValue = s_js_1.default.root(function () { return s_js_1.default.on(ev, function () { return value; }); });
    return function (update) {
        if (update === undefined) {
            return committedValue();
        }
        else {
            // Update pending value...
            value = update(value);
            // ...then notify S that the value is changing. It's important to notify second in case this update
            // happens while S's clock is unfrozen.
            ev(null);
            return value;
        }
    };
}
exports.sumSignal = sumSignal;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(27);
// TH: bootstrap npm package expects to find jquery as window.jQuery... :-(
var oldjquery = window.jQuery;
window.jQuery = $;
__webpack_require__(632);
window.jQuery = oldjquery;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CompassPointTypes = exports.CompassPointTypeDisplayName = exports.CompassPointType = exports.CompassPoints = exports.CompassPointDisplayName = exports.CompassPoint = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Utils\CompassPoint.cs
var CompassPoint;
(function (CompassPoint) {
    CompassPoint[CompassPoint["North"] = 0] = "North";
    CompassPoint[CompassPoint["NorthByEast"] = 1] = "NorthByEast";
    CompassPoint[CompassPoint["NorthNorthEast"] = 2] = "NorthNorthEast";
    CompassPoint[CompassPoint["NorthEastByNorth"] = 3] = "NorthEastByNorth";
    CompassPoint[CompassPoint["NorthEast"] = 4] = "NorthEast";
    CompassPoint[CompassPoint["NorthEastByEast"] = 5] = "NorthEastByEast";
    CompassPoint[CompassPoint["EastNorthEast"] = 6] = "EastNorthEast";
    CompassPoint[CompassPoint["EastByNorth"] = 7] = "EastByNorth";
    CompassPoint[CompassPoint["East"] = 8] = "East";
    CompassPoint[CompassPoint["EastBySouth"] = 9] = "EastBySouth";
    CompassPoint[CompassPoint["EastSouthEast"] = 10] = "EastSouthEast";
    CompassPoint[CompassPoint["SouthEastByEast"] = 11] = "SouthEastByEast";
    CompassPoint[CompassPoint["SouthEast"] = 12] = "SouthEast";
    CompassPoint[CompassPoint["SouthEastBySouth"] = 13] = "SouthEastBySouth";
    CompassPoint[CompassPoint["SouthSouthEast"] = 14] = "SouthSouthEast";
    CompassPoint[CompassPoint["SouthByEast"] = 15] = "SouthByEast";
    CompassPoint[CompassPoint["South"] = 16] = "South";
    CompassPoint[CompassPoint["SouthByWest"] = 17] = "SouthByWest";
    CompassPoint[CompassPoint["SouthSouthWest"] = 18] = "SouthSouthWest";
    CompassPoint[CompassPoint["SouthWestBySouth"] = 19] = "SouthWestBySouth";
    CompassPoint[CompassPoint["SouthWest"] = 20] = "SouthWest";
    CompassPoint[CompassPoint["SouthWestByWest"] = 21] = "SouthWestByWest";
    CompassPoint[CompassPoint["WestSouthWest"] = 22] = "WestSouthWest";
    CompassPoint[CompassPoint["WestBySouth"] = 23] = "WestBySouth";
    CompassPoint[CompassPoint["West"] = 24] = "West";
    CompassPoint[CompassPoint["WestByNorth"] = 25] = "WestByNorth";
    CompassPoint[CompassPoint["WestNorthWest"] = 26] = "WestNorthWest";
    CompassPoint[CompassPoint["NorthWestByWest"] = 27] = "NorthWestByWest";
    CompassPoint[CompassPoint["NorthWest"] = 28] = "NorthWest";
    CompassPoint[CompassPoint["NorthWestByNorth"] = 29] = "NorthWestByNorth";
    CompassPoint[CompassPoint["NorthNorthWest"] = 30] = "NorthNorthWest";
    CompassPoint[CompassPoint["NorthByWest"] = 31] = "NorthByWest";
})(CompassPoint = exports.CompassPoint || (exports.CompassPoint = {}));
exports.CompassPointDisplayName = {
    0: 'North',
    1: 'NorthByEast',
    2: 'NorthNorthEast',
    3: 'NorthEastByNorth',
    4: 'NorthEast',
    5: 'NorthEastByEast',
    6: 'EastNorthEast',
    7: 'EastByNorth',
    8: 'East',
    9: 'EastBySouth',
    10: 'EastSouthEast',
    11: 'SouthEastByEast',
    12: 'SouthEast',
    13: 'SouthEastBySouth',
    14: 'SouthSouthEast',
    15: 'SouthByEast',
    16: 'South',
    17: 'SouthByWest',
    18: 'SouthSouthWest',
    19: 'SouthWestBySouth',
    20: 'SouthWest',
    21: 'SouthWestByWest',
    22: 'WestSouthWest',
    23: 'WestBySouth',
    24: 'West',
    25: 'WestByNorth',
    26: 'WestNorthWest',
    27: 'NorthWestByWest',
    28: 'NorthWest',
    29: 'NorthWestByNorth',
    30: 'NorthNorthWest',
    31: 'NorthByWest'
};
exports.CompassPoints = [
    { Id: CompassPoint.North, Name: 'North' },
    { Id: CompassPoint.NorthByEast, Name: 'NorthByEast' },
    { Id: CompassPoint.NorthNorthEast, Name: 'NorthNorthEast' },
    { Id: CompassPoint.NorthEastByNorth, Name: 'NorthEastByNorth' },
    { Id: CompassPoint.NorthEast, Name: 'NorthEast' },
    { Id: CompassPoint.NorthEastByEast, Name: 'NorthEastByEast' },
    { Id: CompassPoint.EastNorthEast, Name: 'EastNorthEast' },
    { Id: CompassPoint.EastByNorth, Name: 'EastByNorth' },
    { Id: CompassPoint.East, Name: 'East' },
    { Id: CompassPoint.EastBySouth, Name: 'EastBySouth' },
    { Id: CompassPoint.EastSouthEast, Name: 'EastSouthEast' },
    { Id: CompassPoint.SouthEastByEast, Name: 'SouthEastByEast' },
    { Id: CompassPoint.SouthEast, Name: 'SouthEast' },
    { Id: CompassPoint.SouthEastBySouth, Name: 'SouthEastBySouth' },
    { Id: CompassPoint.SouthSouthEast, Name: 'SouthSouthEast' },
    { Id: CompassPoint.SouthByEast, Name: 'SouthByEast' },
    { Id: CompassPoint.South, Name: 'South' },
    { Id: CompassPoint.SouthByWest, Name: 'SouthByWest' },
    { Id: CompassPoint.SouthSouthWest, Name: 'SouthSouthWest' },
    { Id: CompassPoint.SouthWestBySouth, Name: 'SouthWestBySouth' },
    { Id: CompassPoint.SouthWest, Name: 'SouthWest' },
    { Id: CompassPoint.SouthWestByWest, Name: 'SouthWestByWest' },
    { Id: CompassPoint.WestSouthWest, Name: 'WestSouthWest' },
    { Id: CompassPoint.WestBySouth, Name: 'WestBySouth' },
    { Id: CompassPoint.West, Name: 'West' },
    { Id: CompassPoint.WestByNorth, Name: 'WestByNorth' },
    { Id: CompassPoint.WestNorthWest, Name: 'WestNorthWest' },
    { Id: CompassPoint.NorthWestByWest, Name: 'NorthWestByWest' },
    { Id: CompassPoint.NorthWest, Name: 'NorthWest' },
    { Id: CompassPoint.NorthWestByNorth, Name: 'NorthWestByNorth' },
    { Id: CompassPoint.NorthNorthWest, Name: 'NorthNorthWest' },
    { Id: CompassPoint.NorthByWest, Name: 'NorthByWest' }
];
var CompassPointType;
(function (CompassPointType) {
    CompassPointType[CompassPointType["Cardinal"] = 8] = "Cardinal";
    CompassPointType[CompassPointType["Ordinal"] = 4] = "Ordinal";
    CompassPointType[CompassPointType["SecondaryInterCardinal"] = 2] = "SecondaryInterCardinal";
    CompassPointType[CompassPointType["QuarterWind"] = 1] = "QuarterWind";
})(CompassPointType = exports.CompassPointType || (exports.CompassPointType = {}));
exports.CompassPointTypeDisplayName = {
    8: 'Cardinal',
    4: 'Ordinal',
    2: 'SecondaryInterCardinal',
    1: 'QuarterWind'
};
exports.CompassPointTypes = [
    { Id: CompassPointType.Cardinal, Name: 'Cardinal' },
    { Id: CompassPointType.Ordinal, Name: 'Ordinal' },
    { Id: CompassPointType.SecondaryInterCardinal, Name: 'SecondaryInterCardinal' },
    { Id: CompassPointType.QuarterWind, Name: 'QuarterWind' }
];


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationEditingPolicys = exports.CoordinationEditingPolicyDisplayName = exports.CoordinationEditingPolicy = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationEditingPolicy.cs
var CoordinationEditingPolicy;
(function (CoordinationEditingPolicy) {
    CoordinationEditingPolicy[CoordinationEditingPolicy["AllowAgentStatusEdits"] = 1] = "AllowAgentStatusEdits";
    CoordinationEditingPolicy[CoordinationEditingPolicy["None"] = 0] = "None";
})(CoordinationEditingPolicy = exports.CoordinationEditingPolicy || (exports.CoordinationEditingPolicy = {}));
exports.CoordinationEditingPolicyDisplayName = {
    1: 'AllowAgentStatusEdits',
    0: 'None'
};
exports.CoordinationEditingPolicys = [
    { Id: CoordinationEditingPolicy.AllowAgentStatusEdits, Name: 'AllowAgentStatusEdits' },
    { Id: CoordinationEditingPolicy.None, Name: 'None' }
];


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationLocationTypes = exports.CoordinationLocationTypeDisplayName = exports.CoordinationLocationType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationLocation.cs
var CoordinationLocationType;
(function (CoordinationLocationType) {
    CoordinationLocationType[CoordinationLocationType["Main"] = 0] = "Main";
    CoordinationLocationType[CoordinationLocationType["Related"] = 10] = "Related";
})(CoordinationLocationType = exports.CoordinationLocationType || (exports.CoordinationLocationType = {}));
exports.CoordinationLocationTypeDisplayName = {
    0: 'Main',
    10: 'Related'
};
exports.CoordinationLocationTypes = [
    { Id: CoordinationLocationType.Main, Name: 'Main' },
    { Id: CoordinationLocationType.Related, Name: 'Related' }
];


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportPayloadStatuses = exports.ExportPayloadStatusDisplayName = exports.ExportPayloadStatus = exports.ExportTargetTypes = exports.ExportTargetTypeDisplayName = exports.ExportTargetType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Billing\ExportPayload.cs
var ExportTargetType;
(function (ExportTargetType) {
    ExportTargetType[ExportTargetType["QuickBooks"] = 0] = "QuickBooks";
})(ExportTargetType = exports.ExportTargetType || (exports.ExportTargetType = {}));
exports.ExportTargetTypeDisplayName = {
    0: 'QuickBooks'
};
exports.ExportTargetTypes = [
    { Id: ExportTargetType.QuickBooks, Name: 'QuickBooks' }
];
var ExportPayloadStatus;
(function (ExportPayloadStatus) {
    ExportPayloadStatus[ExportPayloadStatus["New"] = 0] = "New";
    ExportPayloadStatus[ExportPayloadStatus["Formatting"] = 10] = "Formatting";
    ExportPayloadStatus[ExportPayloadStatus["FormattingFailed"] = 20] = "FormattingFailed";
    ExportPayloadStatus[ExportPayloadStatus["Formatted"] = 99] = "Formatted";
})(ExportPayloadStatus = exports.ExportPayloadStatus || (exports.ExportPayloadStatus = {}));
exports.ExportPayloadStatusDisplayName = {
    0: 'New',
    10: 'Formatting',
    20: 'FormattingFailed',
    99: 'Formatted'
};
exports.ExportPayloadStatuses = [
    { Id: ExportPayloadStatus.New, Name: 'New' },
    { Id: ExportPayloadStatus.Formatting, Name: 'Formatting' },
    { Id: ExportPayloadStatus.FormattingFailed, Name: 'FormattingFailed' },
    { Id: ExportPayloadStatus.Formatted, Name: 'Formatted' }
];


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalVesselSearchTypes = exports.ExternalVesselSearchTypeDisplayName = exports.ExternalVesselSearchType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\VesselResult\ExternalVesselSearchType.cs
var ExternalVesselSearchType;
(function (ExternalVesselSearchType) {
    ExternalVesselSearchType[ExternalVesselSearchType["CallSign"] = 20] = "CallSign";
    ExternalVesselSearchType[ExternalVesselSearchType["IMO"] = 0] = "IMO";
    ExternalVesselSearchType[ExternalVesselSearchType["MMSI"] = 10] = "MMSI";
})(ExternalVesselSearchType = exports.ExternalVesselSearchType || (exports.ExternalVesselSearchType = {}));
exports.ExternalVesselSearchTypeDisplayName = {
    20: 'CallSign',
    0: 'IMO',
    10: 'MMSI'
};
exports.ExternalVesselSearchTypes = [
    { Id: ExternalVesselSearchType.CallSign, Name: 'CallSign' },
    { Id: ExternalVesselSearchType.IMO, Name: 'IMO' },
    { Id: ExternalVesselSearchType.MMSI, Name: 'MMSI' }
];


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingPilotJobOrderTypes = exports.MissingPilotJobOrderTypeDisplayName = exports.MissingPilotJobOrderType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\MissingPilotJobOrdersViewModel.cs
var MissingPilotJobOrderType;
(function (MissingPilotJobOrderType) {
    MissingPilotJobOrderType[MissingPilotJobOrderType["In"] = 0] = "In";
    MissingPilotJobOrderType[MissingPilotJobOrderType["Shift"] = 1] = "Shift";
    MissingPilotJobOrderType[MissingPilotJobOrderType["Out"] = 2] = "Out";
})(MissingPilotJobOrderType = exports.MissingPilotJobOrderType || (exports.MissingPilotJobOrderType = {}));
exports.MissingPilotJobOrderTypeDisplayName = {
    0: 'In',
    1: 'Shift',
    2: 'Out'
};
exports.MissingPilotJobOrderTypes = [
    { Id: MissingPilotJobOrderType.In, Name: 'In' },
    { Id: MissingPilotJobOrderType.Shift, Name: 'Shift' },
    { Id: MissingPilotJobOrderType.Out, Name: 'Out' }
];


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CreationRecipients = exports.CreationRecipientDisplayName = exports.CreationRecipient = exports.WatcherPortCallChangeActions = exports.WatcherPortCallChangeActionDisplayName = exports.WatcherPortCallChangeAction = exports.InvitedEditorPortCallChangeActions = exports.InvitedEditorPortCallChangeActionDisplayName = exports.InvitedEditorPortCallChangeAction = exports.LineTimeActualFields = exports.LineTimeActualFieldDisplayName = exports.LineTimeActualField = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\PortCallChange.cs
var LineTimeActualField;
(function (LineTimeActualField) {
    LineTimeActualField[LineTimeActualField["FirstLineActual"] = 0] = "FirstLineActual";
    LineTimeActualField[LineTimeActualField["LastLineActual"] = 1] = "LastLineActual";
})(LineTimeActualField = exports.LineTimeActualField || (exports.LineTimeActualField = {}));
exports.LineTimeActualFieldDisplayName = {
    0: 'FirstLineActual',
    1: 'LastLineActual'
};
exports.LineTimeActualFields = [
    { Id: LineTimeActualField.FirstLineActual, Name: 'FirstLineActual' },
    { Id: LineTimeActualField.LastLineActual, Name: 'LastLineActual' }
];
var InvitedEditorPortCallChangeAction;
(function (InvitedEditorPortCallChangeAction) {
    InvitedEditorPortCallChangeAction[InvitedEditorPortCallChangeAction["Add"] = 0] = "Add";
    InvitedEditorPortCallChangeAction[InvitedEditorPortCallChangeAction["Remove"] = 1] = "Remove";
})(InvitedEditorPortCallChangeAction = exports.InvitedEditorPortCallChangeAction || (exports.InvitedEditorPortCallChangeAction = {}));
exports.InvitedEditorPortCallChangeActionDisplayName = {
    0: 'Add',
    1: 'Remove'
};
exports.InvitedEditorPortCallChangeActions = [
    { Id: InvitedEditorPortCallChangeAction.Add, Name: 'Add' },
    { Id: InvitedEditorPortCallChangeAction.Remove, Name: 'Remove' }
];
var WatcherPortCallChangeAction;
(function (WatcherPortCallChangeAction) {
    WatcherPortCallChangeAction[WatcherPortCallChangeAction["Start"] = 0] = "Start";
    WatcherPortCallChangeAction[WatcherPortCallChangeAction["Stop"] = 1] = "Stop";
})(WatcherPortCallChangeAction = exports.WatcherPortCallChangeAction || (exports.WatcherPortCallChangeAction = {}));
exports.WatcherPortCallChangeActionDisplayName = {
    0: 'Start',
    1: 'Stop'
};
exports.WatcherPortCallChangeActions = [
    { Id: WatcherPortCallChangeAction.Start, Name: 'Start' },
    { Id: WatcherPortCallChangeAction.Stop, Name: 'Stop' }
];
var CreationRecipient;
(function (CreationRecipient) {
    CreationRecipient[CreationRecipient["RequestorAndAgent"] = 0] = "RequestorAndAgent";
    CreationRecipient[CreationRecipient["BerthManager"] = 1] = "BerthManager";
})(CreationRecipient = exports.CreationRecipient || (exports.CreationRecipient = {}));
exports.CreationRecipientDisplayName = {
    0: 'RequestorAndAgent',
    1: 'BerthManager'
};
exports.CreationRecipients = [
    { Id: CreationRecipient.RequestorAndAgent, Name: 'RequestorAndAgent' },
    { Id: CreationRecipient.BerthManager, Name: 'BerthManager' }
];


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceActives = exports.VesselServiceActiveDisplayName = exports.VesselServiceActive = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\VesselServiceSettings.cs
var VesselServiceActive;
(function (VesselServiceActive) {
    VesselServiceActive[VesselServiceActive["InActive"] = 0] = "InActive";
    VesselServiceActive[VesselServiceActive["Active"] = 10] = "Active";
})(VesselServiceActive = exports.VesselServiceActive || (exports.VesselServiceActive = {}));
exports.VesselServiceActiveDisplayName = {
    0: 'InActive',
    10: 'Active'
};
exports.VesselServiceActives = [
    { Id: VesselServiceActive.InActive, Name: 'InActive' },
    { Id: VesselServiceActive.Active, Name: 'Active' }
];


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BollardPosition = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BollardPosition\ApiBollardPosition.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var BollardPosition = /** @class */ (function () {
    function BollardPosition(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.CssClass = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CssClass !== undefined ? data.CssClass : null));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement_1.Measurement(data.Footmark) : new Measurement_1.Measurement();
    }
    BollardPosition.key = function (obj) {
        return obj.Id();
    };
    BollardPosition.dataKey = function (obj) {
        return obj.Id;
    };
    BollardPosition.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.CssClass !== undefined)
                obj.CssClass(data.CssClass);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Footmark !== undefined)
                Measurement_1.Measurement.update(obj.Footmark, data.Footmark);
        });
    };
    return BollardPosition;
}());
exports.BollardPosition = BollardPosition;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoActivityType = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoActivityType\ApiCargoActivityType.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CargoActivityType = /** @class */ (function () {
    function CargoActivityType(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    CargoActivityType.key = function (obj) {
        return obj.Id();
    };
    CargoActivityType.dataKey = function (obj) {
        return obj.Id;
    };
    CargoActivityType.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return CargoActivityType;
}());
exports.CargoActivityType = CargoActivityType;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoCategory = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoCategory\ApiCargoCategory.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CargoCategory = /** @class */ (function () {
    function CargoCategory(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.UOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UOM !== undefined ? data.UOM : ''));
    }
    CargoCategory.key = function (obj) {
        return obj.Id();
    };
    CargoCategory.dataKey = function (obj) {
        return obj.Id;
    };
    CargoCategory.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.UOM !== undefined)
                obj.UOM(data.UOM);
        });
    };
    return CargoCategory;
}());
exports.CargoCategory = CargoCategory;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Coordination = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Coordination\ApiCoordination.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Coordination = /** @class */ (function () {
    function Coordination(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AltStatusLabels = s_array_1.default([]);
        this.Cards = s_array_1.default([]);
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Locations = s_array_1.default([]);
        this.MilestoneTypes = s_array_1.default([]);
        this.Providers = s_array_1.default([]);
        this.AdminNotes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AdminNotes !== undefined ? data.AdminNotes : null));
        this.AgentPrompt = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgentPrompt !== undefined ? data.AgentPrompt : null));
        this.AllowsMultiple = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AllowsMultiple !== undefined ? data.AllowsMultiple : false));
        this.AppearsOnTraffic = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AppearsOnTraffic !== undefined ? data.AppearsOnTraffic : false));
        this.Currency = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Currency !== undefined ? data.Currency : 0));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : ''));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.IsMandatory = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsMandatory !== undefined ? data.IsMandatory : false));
        this.IsScopedByMainLocation = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsScopedByMainLocation !== undefined ? data.IsScopedByMainLocation : false));
        this.IsScopedByRelatedLocation = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsScopedByRelatedLocation !== undefined ? data.IsScopedByRelatedLocation : false));
        this.Title = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Title !== undefined ? data.Title : ''));
    }
    Coordination.key = function (obj) {
        return obj.Id();
    };
    Coordination.dataKey = function (obj) {
        return obj.Id;
    };
    Coordination.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.AdminNotes !== undefined)
                obj.AdminNotes(data.AdminNotes);
            if (data.AgentPrompt !== undefined)
                obj.AgentPrompt(data.AgentPrompt);
            if (data.AllowsMultiple !== undefined)
                obj.AllowsMultiple(data.AllowsMultiple);
            if (data.AppearsOnTraffic !== undefined)
                obj.AppearsOnTraffic(data.AppearsOnTraffic);
            if (data.Currency !== undefined)
                obj.Currency(data.Currency);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.IsMandatory !== undefined)
                obj.IsMandatory(data.IsMandatory);
            if (data.IsScopedByMainLocation !== undefined)
                obj.IsScopedByMainLocation(data.IsScopedByMainLocation);
            if (data.IsScopedByRelatedLocation !== undefined)
                obj.IsScopedByRelatedLocation(data.IsScopedByRelatedLocation);
            if (data.Title !== undefined)
                obj.Title(data.Title);
        });
    };
    return Coordination;
}());
exports.Coordination = Coordination;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCard.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCard = /** @class */ (function () {
    function CoordinationCard(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Coordination = s_js_1.default.value(null);
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.Provider = s_js_1.default.value(null);
        this.ProviderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDate = s_js_1.default.value(null);
        this.ScheduleDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.Self = s_js_1.default.value(null);
        this.Status = s_js_1.default.value(null);
        this.StatusId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusId !== undefined ? data.StatusId : 0));
        this.Version = s_js_1.default.value(null);
        this.StatusReason = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }
    CoordinationCard.key = function (obj) {
        return obj.Id();
    };
    CoordinationCard.dataKey = function (obj) {
        return obj.Id;
    };
    CoordinationCard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined)
                obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined)
                obj.ScheduleDateId(data.ScheduleDateId);
            if (data.StatusId !== undefined)
                obj.StatusId(data.StatusId);
            if (data.StatusReason !== undefined)
                obj.StatusReason(data.StatusReason);
        });
    };
    return CoordinationCard;
}());
exports.CoordinationCard = CoordinationCard;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCardVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardVersion = /** @class */ (function () {
    function CoordinationCardVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.Coordination = s_js_1.default.value(null);
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.NextVersion = s_array_1.default([]);
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Provider = s_js_1.default.value(null);
        this.ProviderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDate = s_js_1.default.value(null);
        this.ScheduleDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.Self = s_js_1.default.value(null);
        this.Status = s_js_1.default.value(null);
        this.StatusId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusId !== undefined ? data.StatusId : 0));
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.StatusReason = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }
    CoordinationCardVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    CoordinationCardVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    CoordinationCardVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.ProviderId !== undefined)
                obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined)
                obj.ScheduleDateId(data.ScheduleDateId);
            if (data.StatusId !== undefined)
                obj.StatusId(data.StatusId);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.StatusReason !== undefined)
                obj.StatusReason(data.StatusReason);
        });
    };
    return CoordinationCardVersion;
}());
exports.CoordinationCardVersion = CoordinationCardVersion;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationProvider = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationProvider\ApiCoordinationProvider.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationProvider = /** @class */ (function () {
    function CoordinationProvider(data) {
        if (data === void 0) { data = null; }
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.ProviderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.CardsAsProvider = s_array_1.default([]);
        this.Coordination = s_js_1.default.value(null);
        this.Provider = s_js_1.default.value(null);
        this.Currency = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Currency !== undefined ? data.Currency : 0));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.EditingPolicy = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EditingPolicy !== undefined ? data.EditingPolicy : 0));
    }
    CoordinationProvider.key = function (obj) {
        return obj.CoordinationId() + '\u2618' + obj.ProviderId();
    };
    CoordinationProvider.dataKey = function (obj) {
        return obj.CoordinationId + '\u2618' + obj.ProviderId;
    };
    CoordinationProvider.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined)
                obj.ProviderId(data.ProviderId);
            if (data.Currency !== undefined)
                obj.Currency(data.Currency);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.EditingPolicy !== undefined)
                obj.EditingPolicy(data.EditingPolicy);
        });
    };
    return CoordinationProvider;
}());
exports.CoordinationProvider = CoordinationProvider;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboardCorePermissions = exports.DispatchDashboard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchDashboardViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var DispatchDashboard = /** @class */ (function () {
    function DispatchDashboard(data) {
        if (data === void 0) { data = null; }
        this.From = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.From !== undefined ? data.From === null ? null : new TZDate_1.default(data.From) : null, TZDate_1.default.nullableEq));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.SearchQuery = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SearchQuery !== undefined ? data.SearchQuery : null));
        this.Tab = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Tab !== undefined ? data.Tab : 0));
        this.To = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.To !== undefined ? data.To === null ? null : new TZDate_1.default(data.To) : null, TZDate_1.default.nullableEq));
        this.CorePermissions = s_js_1.default.value(null);
        this.DispatchEvents = s_array_1.default([]);
        this.JobOrders = s_array_1.default([]);
        this.Navbar = s_js_1.default.value(null);
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotJobOrderUserPreferences = s_array_1.default([]);
        this.CanAcknowledgeIds = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.CanAcknowledgeIds !== undefined ? data.CanAcknowledgeIds : []));
    }
    DispatchDashboard.key = function (obj) {
        return (obj.From() === null ? '' : obj.From().toJSON()) + '\u2618' + obj.Id() + '\u2618' + (obj.SearchQuery() === null ? '\u2603' : obj.SearchQuery()) + '\u2618' + obj.Tab() + '\u2618' + (obj.To() === null ? '' : obj.To().toJSON());
    };
    DispatchDashboard.dataKey = function (obj) {
        return (obj.From === null ? '' : new TZDate_1.default(obj.From).toJSON()) + '\u2618' + obj.Id + '\u2618' + (obj.SearchQuery === null ? '\u2603' : obj.SearchQuery) + '\u2618' + obj.Tab + '\u2618' + (obj.To === null ? '' : new TZDate_1.default(obj.To).toJSON());
    };
    DispatchDashboard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.From !== undefined)
                obj.From(data.From === null ? null : new TZDate_1.default(data.From));
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.SearchQuery !== undefined)
                obj.SearchQuery(data.SearchQuery);
            if (data.Tab !== undefined)
                obj.Tab(data.Tab);
            if (data.To !== undefined)
                obj.To(data.To === null ? null : new TZDate_1.default(data.To));
            if (data.CanAcknowledgeIds !== undefined)
                obj.CanAcknowledgeIds(data.CanAcknowledgeIds);
        });
    };
    return DispatchDashboard;
}());
exports.DispatchDashboard = DispatchDashboard;
var DispatchDashboardCorePermissions = /** @class */ (function () {
    function DispatchDashboardCorePermissions(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.CanAddPilotJobOrders = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAddPilotJobOrders !== undefined ? data.CanAddPilotJobOrders : false));
        this.CanExportSchedule = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanExportSchedule !== undefined ? data.CanExportSchedule : false));
        this.CanManageBills = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageBills !== undefined ? data.CanManageBills : false));
        this.CanManageDispatchEvents = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageDispatchEvents !== undefined ? data.CanManageDispatchEvents : false));
        this.CanReserveBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanReserveBerths !== undefined ? data.CanReserveBerths : false));
    }
    DispatchDashboardCorePermissions.key = function (obj) {
        return obj.Id();
    };
    DispatchDashboardCorePermissions.dataKey = function (obj) {
        return obj.Id;
    };
    DispatchDashboardCorePermissions.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CanAddPilotJobOrders !== undefined)
                obj.CanAddPilotJobOrders(data.CanAddPilotJobOrders);
            if (data.CanExportSchedule !== undefined)
                obj.CanExportSchedule(data.CanExportSchedule);
            if (data.CanManageBills !== undefined)
                obj.CanManageBills(data.CanManageBills);
            if (data.CanManageDispatchEvents !== undefined)
                obj.CanManageDispatchEvents(data.CanManageDispatchEvents);
            if (data.CanReserveBerths !== undefined)
                obj.CanReserveBerths(data.CanReserveBerths);
        });
    };
    return DispatchDashboardCorePermissions;
}());
exports.DispatchDashboardCorePermissions = DispatchDashboardCorePermissions;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeRoute = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TradeRoute\ApiTradeRoute.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TradeRoute = /** @class */ (function () {
    function TradeRoute(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    TradeRoute.key = function (obj) {
        return obj.Id();
    };
    TradeRoute.dataKey = function (obj) {
        return obj.Id;
    };
    TradeRoute.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return TradeRoute;
}());
exports.TradeRoute = TradeRoute;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(854);
__webpack_require__(652);
__webpack_require__(141);
__webpack_require__(654);
__webpack_require__(335);
__webpack_require__(651);
__webpack_require__(653);
__webpack_require__(658);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(659);
__webpack_require__(655);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
module.exports = __webpack_require__(44);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(902);


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.deps = void 0;
var s_js_1 = __webpack_require__(0);
var PCCache_1 = __webpack_require__(17);
var Ajax_1 = __webpack_require__(1379);
var bootstrapCache_1 = __webpack_require__(971);
var tzutils_1 = __webpack_require__(1395);
var entrypoints_1 = __webpack_require__(972);
var CachedModelLoader_1 = __webpack_require__(1380);
var hashSignal_1 = __webpack_require__(1389);
var requestSignal_1 = __webpack_require__(1394);
var hashComponentLocationParser_1 = __webpack_require__(1388);
var componentLocation_1 = __webpack_require__(34);
var componentRouter_1 = __webpack_require__(1383);
var LocalizationContext_1 = __webpack_require__(966);
var model_1 = __webpack_require__(1028);
var model_2 = __webpack_require__(1116);
var model_3 = __webpack_require__(968);
var model_4 = __webpack_require__(1190);
var model_5 = __webpack_require__(270);
var route_1 = __webpack_require__(1100);
var cache_1 = __webpack_require__(1091);
var model_6 = __webpack_require__(277);
var route_2 = __webpack_require__(1172);
var cache_2 = __webpack_require__(1171);
var model_7 = __webpack_require__(1108);
var route_3 = __webpack_require__(1109);
var model_8 = __webpack_require__(274);
var route_4 = __webpack_require__(1133);
var cache_3 = __webpack_require__(1132);
var model_9 = __webpack_require__(1135);
var cache_4 = __webpack_require__(1134);
var model_10 = __webpack_require__(276);
var route_5 = __webpack_require__(1144);
var cache_5 = __webpack_require__(1141);
var AddBerth_1 = __webpack_require__(965);
var model_11 = __webpack_require__(531);
var route_6 = __webpack_require__(1124);
var cache_6 = __webpack_require__(1123);
var model_12 = __webpack_require__(1103);
var cache_7 = __webpack_require__(1102);
var model_13 = __webpack_require__(1193);
var cache_8 = __webpack_require__(1192);
var model_14 = __webpack_require__(517);
var model_15 = __webpack_require__(549);
var model_16 = __webpack_require__(1175);
var model_17 = __webpack_require__(1105);
var model_18 = __webpack_require__(1136);
var model_19 = __webpack_require__(1148);
var model_20 = __webpack_require__(1054);
var route_7 = __webpack_require__(1055);
var cache_9 = __webpack_require__(1052);
var model_21 = __webpack_require__(1120);
var route_8 = __webpack_require__(1121);
var cache_10 = __webpack_require__(1119);
var model_22 = __webpack_require__(544);
var cache_11 = __webpack_require__(1164);
var model_23 = __webpack_require__(543);
var route_9 = __webpack_require__(1158);
var cache_12 = __webpack_require__(1157);
var berths_1 = __webpack_require__(1012);
var coordinations_1 = __webpack_require__(1014);
var itinerary_1 = __webpack_require__(502);
var model_24 = __webpack_require__(504);
var pilots_1 = __webpack_require__(1016);
var review_1 = __webpack_require__(1018);
var route_10 = __webpack_require__(1020);
var summary_1 = __webpack_require__(1021);
var vessel_1 = __webpack_require__(505);
var model_25 = __webpack_require__(1161);
var route_11 = __webpack_require__(1162);
var cache_13 = __webpack_require__(1160);
var model_26 = __webpack_require__(1077);
var model_27 = __webpack_require__(264);
var route_12 = __webpack_require__(1030);
var cache_14 = __webpack_require__(1029);
var model_28 = __webpack_require__(507);
var route_13 = __webpack_require__(1039);
var cache_15 = __webpack_require__(1038);
var model_29 = __webpack_require__(1113);
var route_14 = __webpack_require__(1114);
var cache_16 = __webpack_require__(1112);
var route_15 = __webpack_require__(1176);
var model_30 = __webpack_require__(1081);
var model_31 = __webpack_require__(1086);
var model_32 = __webpack_require__(1104);
var model_33 = __webpack_require__(272);
var model_34 = __webpack_require__(1201);
var route_16 = __webpack_require__(1202);
var cache_17 = __webpack_require__(1200);
var model_35 = __webpack_require__(1197);
var route_17 = __webpack_require__(1198);
var cache_18 = __webpack_require__(1196);
var model_36 = __webpack_require__(1205);
var cache_19 = __webpack_require__(1204);
var model_37 = __webpack_require__(278);
var route_18 = __webpack_require__(1207);
var model_38 = __webpack_require__(551);
var cache_20 = __webpack_require__(1194);
var model_39 = __webpack_require__(1129);
var route_19 = __webpack_require__(1130);
var cache_21 = __webpack_require__(1128);
var model_40 = __webpack_require__(193);
var route_20 = __webpack_require__(1049);
var cache_22 = __webpack_require__(1046);
var operationsforecast_1 = __webpack_require__(1047);
var activityfeed_1 = __webpack_require__(1044);
var servicesdashboard_1 = __webpack_require__(265);
var model_41 = __webpack_require__(1186);
var route_21 = __webpack_require__(1187);
var model_42 = __webpack_require__(1183);
var cache_23 = __webpack_require__(1182);
var route_22 = __webpack_require__(1184);
var model_43 = __webpack_require__(1181);
var model_44 = __webpack_require__(1118);
var model_45 = __webpack_require__(1025);
var route_23 = __webpack_require__(1026);
var model_46 = __webpack_require__(1178);
var route_24 = __webpack_require__(1179);
var model_47 = __webpack_require__(1041);
var route_25 = __webpack_require__(1042);
var model_48 = __webpack_require__(1059);
var cache_24 = __webpack_require__(1058);
var route_26 = __webpack_require__(1060);
var model_49 = __webpack_require__(1009);
var route_27 = __webpack_require__(1010);
var model_50 = __webpack_require__(1088);
var route_28 = __webpack_require__(1089);
var model_51 = __webpack_require__(1165);
var route_29 = __webpack_require__(1166);
var model_52 = __webpack_require__(1168);
var route_30 = __webpack_require__(1169);
var model_53 = __webpack_require__(271);
var route_31 = __webpack_require__(1106);
var model_54 = __webpack_require__(1137);
var model_55 = __webpack_require__(988);
var cache_25 = __webpack_require__(987);
var route_32 = __webpack_require__(989);
var route_33 = __webpack_require__(1002);
var cache_26 = __webpack_require__(1004);
var model_56 = __webpack_require__(1006);
var cache_27 = __webpack_require__(1005);
var route_34 = __webpack_require__(1007);
var model_57 = __webpack_require__(262);
var cache_28 = __webpack_require__(982);
var route_35 = __webpack_require__(986);
var adddispatchevent_1 = __webpack_require__(978);
var addpilotjoborder_1 = __webpack_require__(980);
var dispatcheventdetails_1 = __webpack_require__(984);
var pilotjoborderpreferences_1 = __webpack_require__(985);
var model_58 = __webpack_require__(992);
var cache_29 = __webpack_require__(991);
var pilotassignments_1 = __webpack_require__(996);
var pilotagecharges_1 = __webpack_require__(499);
var originalpilotorder_1 = __webpack_require__(993);
var logupdater_1 = __webpack_require__(1138);
var model_59 = __webpack_require__(1139);
var logupdater_2 = __webpack_require__(999);
var model_60 = __webpack_require__(1000);
var model_61 = __webpack_require__(1084);
var logupdater_3 = __webpack_require__(1083);
var newcomment_1 = __webpack_require__(1085);
var model_62 = __webpack_require__(1079);
var model_63 = __webpack_require__(976);
var model_64 = __webpack_require__(1057);
var exportgrouplist_1 = __webpack_require__(133);
var pendingexports_1 = __webpack_require__(1153);
var pendingexportscache_1 = __webpack_require__(1154);
var pendingexportsroute_1 = __webpack_require__(1155);
var pastexports_1 = __webpack_require__(1149);
var pastexportscache_1 = __webpack_require__(1150);
var pastexportsroute_1 = __webpack_require__(1151);
var model_65 = __webpack_require__(1073);
var route_36 = __webpack_require__(1074);
var model_66 = __webpack_require__(516);
var route_37 = __webpack_require__(1071);
var model_67 = __webpack_require__(1212);
var estimateDetails_1 = __webpack_require__(1210);
var map_1 = __webpack_require__(1211);
var summaryCard_1 = __webpack_require__(1214);
var cache_30 = __webpack_require__(1209);
var route_38 = __webpack_require__(1213);
var model_68 = __webpack_require__(1111);
var scheduleChangeEngine_1 = __webpack_require__(190);
var model_69 = __webpack_require__(538);
var cache_31 = __webpack_require__(1146);
var header_1 = __webpack_require__(1147);
var model_70 = __webpack_require__(1174);
var actions_1 = __webpack_require__(1032);
var model_71 = __webpack_require__(506);
var cache_32 = __webpack_require__(1034);
var inportops_1 = __webpack_require__(1035);
var actions_2 = __webpack_require__(1062);
var cache_33 = __webpack_require__(1063);
var cancelled_1 = __webpack_require__(513);
var cancelledsettings_1 = __webpack_require__(1064);
var log_1 = __webpack_require__(1067);
var logupdater_4 = __webpack_require__(1068);
var model_72 = __webpack_require__(515);
var status_1 = __webpack_require__(1069);
var model_73 = __webpack_require__(523);
var model_74 = __webpack_require__(525);
var portcallreport_1 = __webpack_require__(1142);
// import { PortCallReportView } from 'portcall/portcallprofile/portcallreportview';
exports.deps = s_js_1.default.root(function () {
    // config loaded in from environment.config.js
    var PORTCALLCONFIG = window.PORTCALLCONFIG;
    var 
    // data caches
    data = new PCCache_1.PCCache(), reservationsListBaseCache = new cache_11.ReservationsListBaseCache(data), pilotsNavbarCache = new cache_26.PilotsNavbarCache(), queryCaches = {
        bootstrap: new bootstrapCache_1.BootstrapCache(data),
        schedulegrid: new cache_2.ScheduleGridCache(data),
        portcallprofile: new cache_5.PortCallProfileCache(data),
        personProfilePage: new cache_3.PersonProfilePageCache(data),
        personProfilePopup: new cache_4.PersonProfilePopupCache(data),
        orgProfile: new cache_6.OrgProfileCache(data),
        inviteUsers: new cache_7.InviteUsersCache(data),
        userPermissions: new cache_8.UserPermissionsCache(data),
        organizations: new cache_10.OrganizationsCache(data),
        homepage: new cache_1.HomePageCache(data),
        berthProfile: new cache_9.BerthProfileCache(data),
        reservationsDashboard: new cache_12.ReservationsDashboardCache(data, reservationsListBaseCache),
        reservationsInBatch: new cache_13.ReservationsInBatchCache(data, reservationsListBaseCache),
        batchesDashboard: new cache_14.BatchesDashboardCache(data),
        berthClosuresDashboard: new cache_15.BerthClosuresDashboardCache(data),
        morePage: new cache_16.MorePageCache(),
        vesselServiceListing: new cache_17.VesselServiceListingCache(data),
        pendingVesselServiceListing: new cache_21.PendingVesselServiceListingCache(data),
        vesselServiceConfigure: new cache_18.VesselServiceConfigureCache(data),
        vesselServiceOverride: new cache_19.VesselServiceOverrideCache(data),
        vesselPortCalls: new cache_20.VesselPortCallsCache(data),
        berthmgrDashboard: new cache_22.BerthManagerDashboardCache(data),
        topicCards: new cache_23.TopicCardsCache(data),
        configureReminders: new cache_24.ConfigureRemindersCache(data),
        managePilotLookups: new cache_25.ManagePilotLookupsCache(data),
        rotationDashboard: new cache_27.RotationDashboardCache(data, pilotsNavbarCache),
        dispatchDashboard: new cache_28.DispatchDashboardCache(data, pilotsNavbarCache),
        pilotJobOrderDetails: new cache_29.PilotJobOrderDetailsCache(data),
        pendingExports: new pendingexportscache_1.PendingExportsCache(data),
        pastExports: new pastexportscache_1.PastExportsCache(data),
        portcallSchedule: new cache_31.PortCallScheduleCache(data),
        berthAssignmentDetails: new cache_32.BerthAssignmentDetailsCache(data),
        ccardDetails: new cache_33.CoordinationCardDetailsCache(data),
        wartsilaEnrichments: new cache_30.WartsilaEnrichmentsCache(data),
    }, 
    // ajax
    ajax = Ajax_1.default(data), entrypoints = entrypoints_1.Entrypoints(PORTCALLCONFIG.Server, PORTCALLCONFIG.Id), loaders = {
        movements: CachedModelLoader_1.CachedModelLoader(queryCaches.homepage.HomePageDateMovements, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.HomeMovements)),
        operationsForecast: CachedModelLoader_1.CachedModelLoader(queryCaches.berthmgrDashboard.OperationsForecastResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.OperationsForecast)),
        activityFeed: CachedModelLoader_1.CachedModelLoader(queryCaches.berthmgrDashboard.ActivityFeedResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.ActivityFeed)),
        servicesDashboard: CachedModelLoader_1.CachedModelLoader(queryCaches.berthmgrDashboard.ServicesDashboardResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.ServicesDashboard)),
        topicCardTemplates: CachedModelLoader_1.CachedModelLoader(data.Organizations, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.TopicCardTemplates)),
        topicCards: CachedModelLoader_1.CachedModelLoader(queryCaches.topicCards.TopicCardsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.TopicCards)),
        amenityListMgmt: CachedModelLoader_1.CachedModelLoader(data.Organizations, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.BerthAmenityTypeLookups)),
        tariffLookups: CachedModelLoader_1.CachedModelLoader(data.Organizations, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.TariffLookups)),
        configureReminders: CachedModelLoader_1.CachedModelLoader(queryCaches.configureReminders.ConfigureReminders, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.ConfigureReminders)),
        berthLookups: CachedModelLoader_1.CachedModelLoader(data.Domains, CachedModelLoader_1.ModelDataClient(ajax, function () { return entrypoints.BerthLookups; })),
        manageBerths: CachedModelLoader_1.CachedModelLoader(data.Domains, CachedModelLoader_1.ModelDataClient(ajax, function () { return entrypoints.ManageBerths; })),
        morePage: CachedModelLoader_1.CachedModelLoader(queryCaches.morePage.MorePages, CachedModelLoader_1.ModelDataClient(ajax, function () { return entrypoints.MorePage; })),
        managePilotLookups: CachedModelLoader_1.CachedModelLoader(queryCaches.managePilotLookups.ManagePilotLookupses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.ManagePilotLookups)),
        rotationDashboard: CachedModelLoader_1.CachedModelLoader(queryCaches.rotationDashboard.RotationDashboards, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.RotationDashboard)),
        dispatchDashboard: CachedModelLoader_1.CachedModelLoader(queryCaches.dispatchDashboard.DispatchDashboards, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.DispatchDashboard)),
        missingPilotJobOrders: CachedModelLoader_1.CachedModelLoader(queryCaches.dispatchDashboard.MissingPilotJobOrdersResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.MissingPilotJobOrders)),
        pilotJobOrderDetails: CachedModelLoader_1.CachedModelLoader(queryCaches.pilotJobOrderDetails.PilotJobOrderDetailses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.PilotJobOrderDetails)),
        dispatchEventDetailsBilling: CachedModelLoader_1.CachedModelLoader(queryCaches.dispatchDashboard.DispatchEventDetailsBillings, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.DispatchEventDetailsBilling)),
        pendingExports: CachedModelLoader_1.CachedModelLoader(queryCaches.pendingExports.PendingExportsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.PendingExports)),
        pastExports: CachedModelLoader_1.CachedModelLoader(queryCaches.pastExports.PastExportsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.PastExports)),
        coordinationsOverview: CachedModelLoader_1.CachedModelLoader(data.Domains, CachedModelLoader_1.ModelDataClient(ajax, function () { return entrypoints.CoordinationsOverview; })),
        coordinationConfigurator: CachedModelLoader_1.CachedModelLoader(data.Coordinations, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.CoordinationConfigurator)),
        portcallSchedule: CachedModelLoader_1.CachedModelLoader(queryCaches.portcallSchedule.PortCallScheduleResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.PortCallSchedule)),
        berthAssignmentDetails: CachedModelLoader_1.CachedModelLoader(queryCaches.berthAssignmentDetails.BerthAssignmentDetailsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.BerthAssignmentDetails)),
        ccardDetails: CachedModelLoader_1.CachedModelLoader(queryCaches.ccardDetails.CoordinationCardDetailsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.CoordinationCardDetails)),
        cancelledCCardDetails: CachedModelLoader_1.CachedModelLoader(data.CoordinationCardVersions, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.CancelledCoordinationCardDetails)),
        wartsilaEnrichments: CachedModelLoader_1.CachedModelLoader(queryCaches.wartsilaEnrichments.WartsilaEnrichmentsResponses, CachedModelLoader_1.ModelDataClient(ajax, entrypoints.WartsilaEnrichments)),
    }, 
    // global data
    initialDataLoaded = s_js_1.default.data(false), domainSummary = queryCaches.bootstrap.DomainSummaries.update1(null, PORTCALLCONFIG), user = s_js_1.default.data(null), userEntity = s_js_1.default(function () { return user() && data.PCUsers.update1(null, { Id: user().Id() }); }), domain = data.Domains.update1(null, { Id: PORTCALLCONFIG.Id }), domainSettings = data.DomainSettings.update1(null, { Id: PORTCALLCONFIG.Id }), 
    // services
    tzutils = function () { return new tzutils_1.TZUtils(domainSummary.TimeZone()); }, localizationContext = function () { return LocalizationContext_1.LocalizationContext(tzutils(), domainSettings.DateTimeDisplay); }, 
    // request
    hash = hashSignal_1.HashSignal(), hashParser = new hashComponentLocationParser_1.HashComponentLocationParser(), request = requestSignal_1.RequestSignal(hash, hashParser.parse, hashParser.serialize), 
    // viewmodels
    addBerthModel = function (params) { return AddBerth_1.AddBerth(ajax, entrypoints, data, domainSettings.Pier, params); }, navbarModel = function () { return model_2.Navbar(domainSummary, user, ajax, entrypoints); }, loginModel = function (params) { return model_17.Login(ajax, entrypoints, queryCaches.bootstrap, user, params); }, ajaxErrorsModel = model_3.AjaxErrors(domainSummary, ajax, loginModel), phoneNumberModel = function (pn, deleteFn) { return model_18.PhoneNumber(ajax, pn, deleteFn); }, postalAddressModel = function (addr, deleteFn) { return model_19.PostalAddress(ajax, addr, deleteFn); }, personProfilePopupModel = function (params) { return model_9.PersonProfilePopup(entrypoints, ajax, queryCaches.personProfilePopup, phoneNumberModel, params); }, inviteUsersModel = function (params) { return model_12.InviteUsers(ajax, entrypoints, queryCaches.inviteUsers, params); }, userPermissionsModel = function (params) { return model_13.UserPermissions(ajax, entrypoints, data, queryCaches.userPermissions, domainSummary, params); }, cropImageModel = function (params) { return model_14.CropImage(ajax, params); }, uploadFileModel = function (params) { return model_15.UploadFile(ajax.Url(entrypoints.UploadFile), domainSettings.Uploads.File, 'This is not a valid file type. Please pick another file.', params); }, uploadImageModel = function (params) { return model_15.UploadFile(ajax.Url(entrypoints.UploadImage), domainSettings.Uploads.Image, 'This is not an image file. Please pick another file.', params); }, selectProfileImageModel = function (params) { return model_16.SelectProfileImage(ajax, entrypoints, cropImageModel, uploadImageModel, params); }, footmarkAssignmentsModel = function (params) { return model_73.FootmarkAssignments(params); }, inPortOpsModel = function (params) { return model_74.InPortOps(footmarkAssignmentsModel, params); }, newReservationInPortOpsModel = function (params) { return model_74.NewReservationInPortOps(data, inPortOpsModel, params); }, existingReservationInPortOpsModel = function (params) { return model_74.ExistingReservationInPortOps(ajax, entrypoints, data, inPortOpsModel, params); }, logUpdaterModel = function (params) { return logupdater_3.LogUpdater(ajax, tzutils(), params); }, newCommentModel = function (params) { return newcomment_1.NewComment(ajax, data, personProfilePopupModel, uploadFileModel, params); }, eventLogModel = function (params) { return model_61.EventLog(tzutils(), data, personProfilePopupModel, newCommentModel, params); }, localVesselSearchModel = function (params) { return model_32.LocalVesselSearch(domainSettings.Pier, ajax, entrypoints, data, params); }, externalVesselSearchModel = function (params) { return model_31.ExternalVesselSearch(domainSettings.VesselServiceSettings, ajax, entrypoints, params); }, editNewVesselOverridesModel = function (params) { return model_30.EditNewVesselOverrides(data, params); }, newVesselModel = function (params) { return model_33.NewVessel(data, externalVesselSearchModel, editNewVesselOverridesModel, params); }, ccardDetailsActionsTabModel = function (params) { return actions_2.CoordinationCardDetailsActionsTab(ajax, entrypoints, params); }, ccardLogUpdaterModel = function (params) { return logupdater_4.CoordinationCardLogUpdater(entrypoints, data, logUpdaterModel, params); }, ccardDetailsLogTabModel = function (params) { return log_1.CoordinationCardDetailsLogTab(newCommentModel, eventLogModel, ccardLogUpdaterModel, params); }, ccardDetailsStatusTabModel = function (params) { return status_1.CoordinationCardDetailsStatusTab(tzutils(), data, ajax, entrypoints, params); }, ccardDetailsModel = function (params) { return model_72.CoordinationCardDetails(loaders.ccardDetails, data, ccardDetailsStatusTabModel, ccardDetailsActionsTabModel, ccardDetailsLogTabModel, params); }, cancelledCCardDetailsSettingsTabModel = function (params) { return cancelledsettings_1.CancelledCoordinationCardDetailsSettingsTab(params); }, cancelledCCardDetailsModel = function (params) { return cancelled_1.CancelledCoordinationCardDetails(loaders.cancelledCCardDetails, data, ccardDetailsLogTabModel, cancelledCCardDetailsSettingsTabModel, params); }, berthAssgnDetailsActionsTabModel = function (params) { return actions_1.BerthAssignmentDetailsActionsTab(ajax, entrypoints, params); }, berthAssignDetailsInPortOpsTabModel = function (params) { return inportops_1.BerthAssignmentDetailsInPortOpsTab(existingReservationInPortOpsModel, params); }, berthAssgnDetailsModel = function (params) { return model_71.BerthAssignmentDetails(loaders.berthAssignmentDetails, berthAssgnDetailsActionsTabModel, berthAssignDetailsInPortOpsTabModel, params); }, metroMapFrameworkModel = function (params) { return model_68.MetroMapFramework(params); }, metroMapMilestoneModel = function (params) { return model_68.MetroMapMilestone(params); }, scheduleChangeEngineModel = function (params) { return scheduleChangeEngine_1.ScheduleChangeEngine(tzutils(), params); }, portcallScheduleHeaderModel = function (params) { return header_1.PortCallScheduleHeader(tzutils(), params); }, portcallScheduleModel = function (params) { return model_69.PortCallSchedule(loaders.portcallSchedule, data, ajax, entrypoints, tzutils(), localizationContext(), scheduleChangeEngineModel, metroMapFrameworkModel, metroMapMilestoneModel, berthAssgnDetailsModel, ccardDetailsModel, cancelledCCardDetailsModel, portcallScheduleHeaderModel, params); }, selectCoordinationsModel = function (params) { return model_70.SelectCoordinations(metroMapFrameworkModel, metroMapMilestoneModel, params); }, addCCardsReqCoordSelStorage = function (params) { return model_70.AddCCardsRequestCoordinationSelectionStorage(params); }, schedDateCoordSelStorage = function (params) { return model_70.ScheduleDateCoordinationSelectionStorage(params); }, editMovementEndPopupModel = function (params) { return model_62.EditMovementEndPopup(localizationContext(), domainSummary, tzutils(), params); }, homepageModel = function (params) { return model_5.HomePage(params, domainSummary, user, initialDataLoaded, data, tzutils(), entrypoints, ajax, loaders.movements, portcallScheduleModel, loginModel); }, uithemesetterModel = model_4.UIThemeSetter(initialDataLoaded, userEntity, domainSettings), appWrapperModel = function () { return model_1.AppWrapper(navbarModel(), ajaxErrorsModel, domainSummary, uithemesetterModel); }, schedulegridModel = function (params) { return model_6.ScheduleGrid(params, user, tzutils(), queryCaches.schedulegrid, data, entrypoints, ajax, localizationContext()); }, topicCardListItemModel = function (params) { return model_43.TopicCardListItem(tzutils(), params); }, portCallLogUpdaterModel = function (params) { return logupdater_1.PortCallLogUpdater(entrypoints, data, logUpdaterModel, params); }, portCallLogModel = function (params) { return model_59.PortCallLog(newCommentModel, eventLogModel, params); }, wartsilaEnrichmentsEstimateDetailsModel = function (params) { return estimateDetails_1.WartsilaEnrichmentsEstimateDetails(data, ajax, entrypoints, tzutils(), params); }, wartsilaEnrichmentsMapModel = function (params) { return map_1.WartsilaEnrichmentsMap(params); }, wartsilaEnrichmentsSummaryCardModel = function (params) { return summaryCard_1.WartsilaEnrichmentsSummaryCard(loaders.wartsilaEnrichments, data, wartsilaEnrichmentsEstimateDetailsModel, wartsilaEnrichmentsMapModel, params); }, wartsilaEnrichmentsModel = function (params) { return model_67.WartsilaEnrichments(loaders.wartsilaEnrichments, data, wartsilaEnrichmentsEstimateDetailsModel, wartsilaEnrichmentsMapModel, params); }, portcallprofileModel = function (params) { return model_10.PortCallProfile(user, params, entrypoints, ajax, data, queryCaches.portcallprofile, tzutils(), localizationContext(), localVesselSearchModel, newVesselModel, portCallLogUpdaterModel, portCallLogModel, personProfilePopupModel, topicCardListItemModel, wartsilaEnrichmentsSummaryCardModel, portcallScheduleModel, addCCardsReqCoordSelStorage, selectCoordinationsModel, portcallReportModel); }, personProfilePageModel = function (params) { return model_8.PersonProfilePage(entrypoints, ajax, data, queryCaches.personProfilePage, selectProfileImageModel, personProfilePopupModel, phoneNumberModel, params); }, mepageModel = function () { return model_7.MePage(user, loginModel, personProfilePageModel); }, orgprofileModel = function (params) { return model_11.OrgProfile(entrypoints, ajax, data, queryCaches.orgProfile, personProfilePopupModel, inviteUsersModel, userPermissionsModel, selectProfileImageModel, phoneNumberModel, postalAddressModel, addBerthModel, params); }, organizationsModel = function () { return model_21.Organizations(ajax, entrypoints, user, domainSummary, data, queryCaches.organizations, personProfilePopupModel, inviteUsersModel, userPermissionsModel); }, pierGroupFootmarksModel = function (params) { return model_54.PierGroupFootmarks(data, params); }, berthProfileModel = function (params) { return model_20.BerthProfile(ajax, entrypoints, domainSettings, data, queryCaches.berthProfile, postalAddressModel, pierGroupFootmarksModel, params); }, addPortCallBerthsTabModel = function (params) { return berths_1.AddPortCallBerthsTab(newReservationInPortOpsModel, params); }, addPortCallCoordinationsTabModel = function (params) { return coordinations_1.AddPortCallCoordinationsTab(data, schedDateCoordSelStorage, selectCoordinationsModel, params); }, addPortCallItineraryTabModel = function (params) { return itinerary_1.AddPortCallItineraryTab(data, tzutils(), localizationContext(), params); }, addPortCallPilotsTabModel = function (params) { return pilots_1.AddPortCallPilotsTab(data, domain, localizationContext(), metroMapMilestoneModel, params); }, addPortCallReviewTabModel = function (params) { return review_1.AddPortCallReviewTab(ajax, entrypoints, domain, metroMapFrameworkModel, metroMapMilestoneModel, params); }, addPortCallSummaryTabModel = function (params) { return summary_1.AddPortCallSummaryTab(portcallScheduleModel, params); }, addPortCallVesselTabModel = function (params) { return vessel_1.AddPortCallVesselTab(user, data, localVesselSearchModel, newVesselModel, params); }, addportcallModel = function (params) { return model_24.AddPortCall(ajax, entrypoints, data, portcallScheduleHeaderModel, addPortCallBerthsTabModel, addPortCallCoordinationsTabModel, addPortCallItineraryTabModel, addPortCallPilotsTabModel, addPortCallReviewTabModel, addPortCallSummaryTabModel, addPortCallVesselTabModel, params); }, dateRangeSelectorModel = function (params) { return model_26.DateRangeSelector(tzutils(), localizationContext(), params); }, reservationsListBaseModel = function (params) { return model_22.ReservationsListBase(ajax, entrypoints, dateRangeSelectorModel, params); }, reservationsDashboardModel = function (params) { return model_23.ReservationsDashboard(entrypoints, queryCaches.reservationsDashboard, user, reservationsListBaseModel, params); }, reservationsInBatchModel = function (params) { return model_25.ReservationsInBatch(ajax, entrypoints, queryCaches.reservationsInBatch, user, reservationsListBaseModel, params); }, batchesDashboardModel = function (params) { return model_27.BatchesDashboard(ajax, entrypoints, queryCaches.batchesDashboard, user, dateRangeSelectorModel, params); }, berthClosuresDashboardModel = function (params) { return model_28.BerthClosuresDashboard(ajax, entrypoints, queryCaches.berthClosuresDashboard, user, dateRangeSelectorModel, params); }, morePageModel = function () { return model_29.MorePage(loaders.morePage, domainSummary, user, queryCaches.morePage); }, vesselServiceListingModel = function (params) { return model_34.VesselServiceListing(ajax, entrypoints, queryCaches.vesselServiceListing, params); }, pendingVesselServiceListingModel = function (params) { return model_39.PendingVesselServiceListing(ajax, entrypoints, queryCaches.vesselServiceListing, params); }, vesselServiceConfigureModel = function (params) { return model_35.VesselServiceConfigure(ajax, entrypoints, queryCaches.vesselServiceConfigure, domainSettings.VesselServiceSettings, params); }, vesselServiceOverrideModel = function (params) { return model_36.VesselServiceOverride(ajax, entrypoints, data, queryCaches.vesselServiceOverride, params); }, vesselPortCallsModel = function (params) { return model_38.VesselPortCalls(ajax, entrypoints, data, queryCaches.vesselPortCalls, dateRangeSelectorModel, params); }, vesselServiceProfileModel = function (params) { return model_37.VesselServiceProfile(params, vesselServiceOverrideModel, vesselPortCallsModel); }, operationsForecastModel = function (params) { return function (tab) { return operationsforecast_1.OperationsForecast(params, tab, tzutils(), loaders.operationsForecast); }; }, activityFeedModel = function (params) { return activityfeed_1.ActivityFeed(loaders.activityFeed, domainSummary, tzutils(), personProfilePopupModel, params); }, servicesDashboardModel = function (params) { return servicesdashboard_1.ServicesDashboard(params, loaders.servicesDashboard, tzutils()); }, berthManagerDashboardModel = function (params) { return model_40.BerthManagerDashboard(params, activityFeedModel(params), operationsForecastModel(params), servicesDashboardModel(params)); }, topicCardTemplatesModel = function (params) { return model_41.TopicCardTemplates(loaders.topicCardTemplates, ajax, data, uploadFileModel, params); }, topicCardsModel = function (params) { return model_42.TopicCards(loaders.topicCards, entrypoints, ajax, data, queryCaches.topicCards, domainSummary, tzutils(), localizationContext(), uploadFileModel, personProfilePopupModel, topicCardListItemModel, params); }, orderableLookupsModel = function (params) { return model_44.OrderableLookups(ajax, params); }, amenityListMgmtModel = function (params) { return model_45.AmenityListMgmt(loaders.amenityListMgmt, ajax, data, orderableLookupsModel, params); }, tariffLookupsModel = function (params) { return model_46.TariffLookups(loaders.tariffLookups, ajax, data, orderableLookupsModel, params); }, configureRemindersModel = function (params) { return model_48.ConfigureReminders(loaders.configureReminders, ajax, data, params); }, berthLookupsModel = function () { return model_47.BerthLookups(loaders.berthLookups, domain, ajax, data, orderableLookupsModel); }, acceptInvitationModel = function (params) { return model_49.AcceptInvitation(ajax, entrypoints, user, loginModel, params); }, forgotPasswordModel = function () { return model_50.ForgotPassword(ajax, entrypoints); }, resetPasswordModel = function (params) { return model_51.ResetPassword(ajax, entrypoints, loginModel, params); }, restoreAccountModel = function (params) { return model_52.RestoreAccount(ajax, entrypoints, user, loginModel, params); }, manageBerthsModel = function (params) { return model_53.ManageBerths(loaders.manageBerths, domain, ajax, entrypoints, addBerthModel, pierGroupFootmarksModel, params); }, managePilotLookupsModel = function (params) { return model_55.ManagePilotLookups(ajax, loaders.managePilotLookups, data, params); }, rotationDashboardModel = function (params) { return model_56.RotationDashboard(ajax, loaders.rotationDashboard, entrypoints, data, personProfilePopupModel, params); }, billExportSettingsModel = function (params) { return model_64.BillExportSettings(ajax, data, params); }, addDispatchEventModel = function (params) { return adddispatchevent_1.AddDispatchEvent(ajax, data, tzutils(), localizationContext(), billExportSettingsModel, params); }, dispatchEventDetailsModel = function (params) { return dispatcheventdetails_1.DispatchEventDetails(queryCaches.dispatchDashboard, loaders.dispatchEventDetailsBilling, entrypoints, tzutils(), localizationContext(), billExportSettingsModel, params); }, addPilotJobOrderModel = function (params) { return addpilotjoborder_1.AddPilotJobOrder(loaders.missingPilotJobOrders, ajax, entrypoints, data, queryCaches.dispatchDashboard, params); }, pilotJobOrderPreferencesModel = function (params) { return pilotjoborderpreferences_1.PilotJobOrderPreferences(ajax, data, user, params); }, addShiftPopupModel = function (params) { return model_63.AddShiftPopup(ajax, entrypoints, data, tzutils(), params); }, pilotJobOrderLogUpdaterModel = function (params) { return logupdater_2.PilotJobOrderLogUpdater(entrypoints, data, logUpdaterModel, params); }, pilotJobOrderLogModel = function (params) { return model_60.PilotJobOrderLog(newCommentModel, eventLogModel, params); }, pilotAssignmentsModel = function (params) { return pilotassignments_1.PilotAssignments(ajax, data, params); }, pilotageChargesModel = function (params) { return pilotagecharges_1.PilotageCharges(ajax, entrypoints, queryCaches.pilotJobOrderDetails, billExportSettingsModel, params); }, originalPilotOrderModel = function (params) { return originalpilotorder_1.OriginalPilotOrder(ajax, entrypoints, queryCaches.pilotJobOrderDetails, params); }, pilotJobOrderDetailsModel = function (params) { return model_58.PilotJobOrderDetails(ajax, entrypoints, data, tzutils(), localizationContext(), domainSettings.Pier, userEntity, pilotJobOrderPreferencesModel, pilotAssignmentsModel, pilotJobOrderLogUpdaterModel, pilotJobOrderLogModel, addShiftPopupModel, editMovementEndPopupModel, pilotageChargesModel, originalPilotOrderModel, footmarkAssignmentsModel, params); }, dispatchDashboardModel = function (params) { return model_57.DispatchDashboard(loaders.dispatchDashboard, loaders.pilotJobOrderDetails, queryCaches.pilotJobOrderDetails, ajax, entrypoints, data, tzutils(), domainSettings.Pier, dateRangeSelectorModel, addDispatchEventModel, dispatchEventDetailsModel, addPilotJobOrderModel, pilotJobOrderDetailsModel, pilotJobOrderPreferencesModel, params); }, exportGroupListModel = function (params) { return exportgrouplist_1.ExportGroupList(params); }, pendingExportsModel = function (params) { return pendingexports_1.PendingExports(loaders.pendingExports, ajax, entrypoints, data, domainSummary, tzutils(), localizationContext(), exportGroupListModel, params); }, pastExportsModel = function (params) { return pastexports_1.PastExports(loaders.pastExports, ajax, entrypoints, data, domainSummary, dateRangeSelectorModel, exportGroupListModel, params); }, coordinationsOverviewModel = function (params) { return model_65.CoordinationsOverview(loaders.coordinationsOverview, domain, ajax, entrypoints, data, params); }, coordinationConfiguratorModel = function (params) { return model_66.CoordinationConfigurator(loaders.coordinationConfigurator, domain, ajax, data, params); }, portcallReportModel = function (params) { return portcallreport_1.PortCallReport(ajax, entrypoints, queryCaches.portcallprofile, params); }, 
    // routes
    defaultLocation = new componentLocation_1.Location("", {}), routes = {
        '': function (request) { return route_1.HomePageRoute(request, homepageModel, tzutils(), appWrapperModel()); },
        'schedulegrid': function (request) { return route_2.ScheduleGridRoute(schedulegridModel, tzutils(), appWrapperModel(), request); },
        'portcallprofile': function (request) { return route_5.PortCallProfileRoute(portcallprofileModel, appWrapperModel(), request); },
        'mepage': function () { return route_3.MePageRoute(mepageModel(), appWrapperModel()); },
        'personprofilepage': function (request) { return route_4.PersonProfilePageRoute(personProfilePageModel, appWrapperModel(), request); },
        'orgprofile': function (request) { return route_6.OrgProfileRoute(orgprofileModel, appWrapperModel(), request); },
        'organizations': function (request) { return route_8.OrganizationsRoute(organizationsModel(), appWrapperModel()); },
        'berthprofile': function (request) { return route_7.BerthProfileRoute(berthProfileModel, appWrapperModel(), request); },
        'reservationsdashboard': function (request) { return route_9.ReservationsDashboardRoute(reservationsDashboardModel, appWrapperModel(), tzutils(), request); },
        'addportcall': function (request) { return route_10.AddPortCallRoute(addportcallModel, appWrapperModel(), request); },
        'reservationsinbatch': function (request) { return route_11.ReservationsInBatchRoute(reservationsInBatchModel, appWrapperModel(), tzutils(), request); },
        'batchesdashboard': function (request) { return route_12.BatchesDashboardRoute(batchesDashboardModel, appWrapperModel(), tzutils(), request); },
        'berthclosuresdashboard': function (request) { return route_13.BerthClosuresDashboardRoute(berthClosuresDashboardModel, appWrapperModel(), tzutils(), request); },
        'morepage': function (request) { return route_14.MorePageRoute(morePageModel(), appWrapperModel()); },
        'siteadminsettings': function (request) { return route_15.SiteAdminSettingsRoute(appWrapperModel()); },
        'vesselservicelisting': function (request) { return route_16.VesselServiceListingRoute(vesselServiceListingModel, appWrapperModel(), request); },
        'pendingvesselservicelisting': function (request) { return route_19.PendingVesselServiceListingRoute(pendingVesselServiceListingModel, appWrapperModel(), request); },
        'vesselserviceconfigure': function (request) { return route_17.VesselServiceConfigureRoute(vesselServiceConfigureModel, appWrapperModel(), request); },
        'vesselserviceprofile': function (request) { return route_18.VesselServiceProfileRoute(vesselServiceProfileModel, appWrapperModel(), tzutils(), request); },
        'berthmgrdashboard': function (request) { return route_20.BerthManagerDashboardRoute(berthManagerDashboardModel, appWrapperModel(), tzutils(), request); },
        'topiccardtemplates': function (request) { return route_21.TopicCardTemplatesRoute(topicCardTemplatesModel, appWrapperModel(), request); },
        'topiccards': function (request) { return route_22.TopicCardsRoute(topicCardsModel, appWrapperModel(), request); },
        'amenitylistmgmt': function (request) { return route_23.AmenityListMgmtRoute(amenityListMgmtModel, appWrapperModel(), request); },
        'tarifflookups': function (request) { return route_24.TariffLookupsRoute(tariffLookupsModel, appWrapperModel(), request); },
        'configurereminders': function (request) { return route_26.ConfigureRemindersRoute(configureRemindersModel, appWrapperModel(), request); },
        'berthlookups': function (request) { return route_25.BerthLookupsRoute(berthLookupsModel(), appWrapperModel()); },
        'acceptinvitation': function (request) { return route_27.AcceptInvitationRoute(acceptInvitationModel, appWrapperModel(), request); },
        'forgotpassword': function (request) { return route_28.ForgotPasswordRoute(forgotPasswordModel(), appWrapperModel()); },
        'resetpassword': function (request) { return route_29.ResetPasswordRoute(resetPasswordModel, appWrapperModel(), request); },
        'restoreaccount': function (request) { return route_30.RestoreAccountRoute(restoreAccountModel, appWrapperModel(), request); },
        'manageberths': function (request) { return route_31.ManageBerthsRoute(manageBerthsModel, appWrapperModel(), request); },
        'managepilotlookups': function (request) { return route_32.ManagePilotLookupsRoute(managePilotLookupsModel, appWrapperModel(), request); },
        'pilotsettings': function (request) { return route_33.PilotSettingsRoute(appWrapperModel(), request); },
        'rotationdashboard': function (request) { return route_34.RotationDashboardRoute(rotationDashboardModel, appWrapperModel(), request); },
        'dispatchdashboard': function (request) { return route_35.DispatchDashboardRoute(dispatchDashboardModel, appWrapperModel(), tzutils(), request); },
        'pendingexports': function (request) { return pendingexportsroute_1.PendingExportsRoute(pendingExportsModel, appWrapperModel(), request); },
        'pastexports': function (request) { return pastexportsroute_1.PastExportsRoute(pastExportsModel, appWrapperModel(), tzutils(), request); },
        'coordinationsoverview': function (request) { return route_36.CoordinationsOverviewRoute(coordinationsOverviewModel, appWrapperModel(), request); },
        'coordinationconfigurator': function (request) { return route_37.CoordinationConfiguratorRoute(coordinationConfiguratorModel, appWrapperModel(), request); },
        'wartsilaenrichments': function (request) { return route_38.WartsilaEnrichmentsRoute(wartsilaEnrichmentsModel, appWrapperModel(), request); },
    }, 
    // router
    router = new componentRouter_1.Router(routes, request, defaultLocation);
    return { router: router, queryCaches: queryCaches, user: user, initialDataLoaded: initialDataLoaded };
});


/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"version":"2020a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 348,
	"./af.js": 348,
	"./ar": 355,
	"./ar-dz": 349,
	"./ar-dz.js": 349,
	"./ar-kw": 350,
	"./ar-kw.js": 350,
	"./ar-ly": 351,
	"./ar-ly.js": 351,
	"./ar-ma": 352,
	"./ar-ma.js": 352,
	"./ar-sa": 353,
	"./ar-sa.js": 353,
	"./ar-tn": 354,
	"./ar-tn.js": 354,
	"./ar.js": 355,
	"./az": 356,
	"./az.js": 356,
	"./be": 357,
	"./be.js": 357,
	"./bg": 358,
	"./bg.js": 358,
	"./bm": 359,
	"./bm.js": 359,
	"./bn": 360,
	"./bn.js": 360,
	"./bo": 361,
	"./bo.js": 361,
	"./br": 362,
	"./br.js": 362,
	"./bs": 363,
	"./bs.js": 363,
	"./ca": 364,
	"./ca.js": 364,
	"./cs": 365,
	"./cs.js": 365,
	"./cv": 366,
	"./cv.js": 366,
	"./cy": 367,
	"./cy.js": 367,
	"./da": 368,
	"./da.js": 368,
	"./de": 371,
	"./de-at": 369,
	"./de-at.js": 369,
	"./de-ch": 370,
	"./de-ch.js": 370,
	"./de.js": 371,
	"./dv": 372,
	"./dv.js": 372,
	"./el": 373,
	"./el.js": 373,
	"./en-au": 374,
	"./en-au.js": 374,
	"./en-ca": 375,
	"./en-ca.js": 375,
	"./en-gb": 376,
	"./en-gb.js": 376,
	"./en-ie": 377,
	"./en-ie.js": 377,
	"./en-nz": 378,
	"./en-nz.js": 378,
	"./eo": 379,
	"./eo.js": 379,
	"./es": 382,
	"./es-do": 380,
	"./es-do.js": 380,
	"./es-us": 381,
	"./es-us.js": 381,
	"./es.js": 382,
	"./et": 383,
	"./et.js": 383,
	"./eu": 384,
	"./eu.js": 384,
	"./fa": 385,
	"./fa.js": 385,
	"./fi": 386,
	"./fi.js": 386,
	"./fo": 387,
	"./fo.js": 387,
	"./fr": 390,
	"./fr-ca": 388,
	"./fr-ca.js": 388,
	"./fr-ch": 389,
	"./fr-ch.js": 389,
	"./fr.js": 390,
	"./fy": 391,
	"./fy.js": 391,
	"./gd": 392,
	"./gd.js": 392,
	"./gl": 393,
	"./gl.js": 393,
	"./gom-latn": 394,
	"./gom-latn.js": 394,
	"./gu": 395,
	"./gu.js": 395,
	"./he": 396,
	"./he.js": 396,
	"./hi": 397,
	"./hi.js": 397,
	"./hr": 398,
	"./hr.js": 398,
	"./hu": 399,
	"./hu.js": 399,
	"./hy-am": 400,
	"./hy-am.js": 400,
	"./id": 401,
	"./id.js": 401,
	"./is": 402,
	"./is.js": 402,
	"./it": 403,
	"./it.js": 403,
	"./ja": 404,
	"./ja.js": 404,
	"./jv": 405,
	"./jv.js": 405,
	"./ka": 406,
	"./ka.js": 406,
	"./kk": 407,
	"./kk.js": 407,
	"./km": 408,
	"./km.js": 408,
	"./kn": 409,
	"./kn.js": 409,
	"./ko": 410,
	"./ko.js": 410,
	"./ky": 411,
	"./ky.js": 411,
	"./lb": 412,
	"./lb.js": 412,
	"./lo": 413,
	"./lo.js": 413,
	"./lt": 414,
	"./lt.js": 414,
	"./lv": 415,
	"./lv.js": 415,
	"./me": 416,
	"./me.js": 416,
	"./mi": 417,
	"./mi.js": 417,
	"./mk": 418,
	"./mk.js": 418,
	"./ml": 419,
	"./ml.js": 419,
	"./mr": 420,
	"./mr.js": 420,
	"./ms": 422,
	"./ms-my": 421,
	"./ms-my.js": 421,
	"./ms.js": 422,
	"./my": 423,
	"./my.js": 423,
	"./nb": 424,
	"./nb.js": 424,
	"./ne": 425,
	"./ne.js": 425,
	"./nl": 427,
	"./nl-be": 426,
	"./nl-be.js": 426,
	"./nl.js": 427,
	"./nn": 428,
	"./nn.js": 428,
	"./pa-in": 429,
	"./pa-in.js": 429,
	"./pl": 430,
	"./pl.js": 430,
	"./pt": 432,
	"./pt-br": 431,
	"./pt-br.js": 431,
	"./pt.js": 432,
	"./ro": 433,
	"./ro.js": 433,
	"./ru": 434,
	"./ru.js": 434,
	"./sd": 435,
	"./sd.js": 435,
	"./se": 436,
	"./se.js": 436,
	"./si": 437,
	"./si.js": 437,
	"./sk": 438,
	"./sk.js": 438,
	"./sl": 439,
	"./sl.js": 439,
	"./sq": 440,
	"./sq.js": 440,
	"./sr": 442,
	"./sr-cyrl": 441,
	"./sr-cyrl.js": 441,
	"./sr.js": 442,
	"./ss": 443,
	"./ss.js": 443,
	"./sv": 444,
	"./sv.js": 444,
	"./sw": 445,
	"./sw.js": 445,
	"./ta": 446,
	"./ta.js": 446,
	"./te": 447,
	"./te.js": 447,
	"./tet": 448,
	"./tet.js": 448,
	"./th": 449,
	"./th.js": 449,
	"./tl-ph": 450,
	"./tl-ph.js": 450,
	"./tlh": 451,
	"./tlh.js": 451,
	"./tr": 452,
	"./tr.js": 452,
	"./tzl": 453,
	"./tzl.js": 453,
	"./tzm": 455,
	"./tzm-latn": 454,
	"./tzm-latn.js": 454,
	"./tzm.js": 455,
	"./uk": 456,
	"./uk.js": 456,
	"./ur": 457,
	"./ur.js": 457,
	"./uz": 459,
	"./uz-latn": 458,
	"./uz-latn.js": 458,
	"./uz.js": 459,
	"./vi": 460,
	"./vi.js": 460,
	"./x-pseudo": 461,
	"./x-pseudo.js": 461,
	"./yo": 462,
	"./yo.js": 462,
	"./zh-cn": 463,
	"./zh-cn.js": 463,
	"./zh-hk": 464,
	"./zh-hk.js": 464,
	"./zh-tw": 465,
	"./zh-tw.js": 465
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// This is just a shim file to connect our custom typings to the jquery-ui npm package
__webpack_require__(874);

/***/ }),
/* 627 */
/***/ (function(module, exports) {

/**
 * jquery.Jcrop.js v0.9.12
 * jQuery Image Cropping Plugin - released under MIT License 
 * Author: Kelly Hallman <khallman@gmail.com>
 * http://github.com/tapmodo/Jcrop
 * Copyright (c) 2008-2013 Tapmodo Interactive LLC {{{
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * }}}
 */

(function ($) {

  $.Jcrop = function (obj, opt) {
    var options = $.extend({}, $.Jcrop.defaults),
        docOffset,
        _ua = navigator.userAgent.toLowerCase(),
        is_msie = /msie/.test(_ua),
        ie6mode = /msie [1-6]\./.test(_ua);

    // Internal Methods {{{
    function px(n) {
      return Math.round(n) + 'px';
    }
    function cssClass(cl) {
      return options.baseClass + '-' + cl;
    }
    function supportsColorFade() {
      return $.fx.step.hasOwnProperty('backgroundColor');
    }
    function getPos(obj) //{{{
    {
      var pos = $(obj).offset();
      return [pos.left, pos.top];
    }
    //}}}
    function mouseAbs(e) //{{{
    {
      return [(e.pageX - docOffset[0]), (e.pageY - docOffset[1])];
    }
    //}}}
    function setOptions(opt) //{{{
    {
      if (typeof(opt) !== 'object') opt = {};
      options = $.extend(options, opt);

      $.each(['onChange','onSelect','onRelease','onDblClick'],function(i,e) {
        if (typeof(options[e]) !== 'function') options[e] = function () {};
      });
    }
    //}}}
    function startDragMode(mode, pos, touch) //{{{
    {
      docOffset = getPos($img);
      Tracker.setCursor(mode === 'move' ? mode : mode + '-resize');

      if (mode === 'move') {
        return Tracker.activateHandlers(createMover(pos), doneSelect, touch);
      }

      var fc = Coords.getFixed();
      var opp = oppLockCorner(mode);
      var opc = Coords.getCorner(oppLockCorner(opp));

      Coords.setPressed(Coords.getCorner(opp));
      Coords.setCurrent(opc);

      Tracker.activateHandlers(dragmodeHandler(mode, fc), doneSelect, touch);
    }
    //}}}
    function dragmodeHandler(mode, f) //{{{
    {
      return function (pos) {
        if (!options.aspectRatio) {
          switch (mode) {
          case 'e':
            pos[1] = f.y2;
            break;
          case 'w':
            pos[1] = f.y2;
            break;
          case 'n':
            pos[0] = f.x2;
            break;
          case 's':
            pos[0] = f.x2;
            break;
          }
        } else {
          switch (mode) {
          case 'e':
            pos[1] = f.y + 1;
            break;
          case 'w':
            pos[1] = f.y + 1;
            break;
          case 'n':
            pos[0] = f.x + 1;
            break;
          case 's':
            pos[0] = f.x + 1;
            break;
          }
        }
        Coords.setCurrent(pos);
        Selection.update();
      };
    }
    //}}}
    function createMover(pos) //{{{
    {
      var lloc = pos;
      KeyManager.watchKeys();

      return function (pos) {
        Coords.moveOffset([pos[0] - lloc[0], pos[1] - lloc[1]]);
        lloc = pos;

        Selection.update();
      };
    }
    //}}}
    function oppLockCorner(ord) //{{{
    {
      switch (ord) {
      case 'n':
        return 'sw';
      case 's':
        return 'nw';
      case 'e':
        return 'nw';
      case 'w':
        return 'ne';
      case 'ne':
        return 'sw';
      case 'nw':
        return 'se';
      case 'se':
        return 'nw';
      case 'sw':
        return 'ne';
      }
    }
    //}}}
    function createDragger(ord) //{{{
    {
      return function (e) {
        if (options.disabled) {
          return false;
        }
        if ((ord === 'move') && !options.allowMove) {
          return false;
        }
        
        // Fix position of crop area when dragged the very first time.
        // Necessary when crop image is in a hidden element when page is loaded.
        docOffset = getPos($img);

        btndown = true;
        startDragMode(ord, mouseAbs(e));
        e.stopPropagation();
        e.preventDefault();
        return false;
      };
    }
    //}}}
    function presize($obj, w, h) //{{{
    {
      var nw = $obj.width(),
          nh = $obj.height();
      if ((nw > w) && w > 0) {
        nw = w;
        nh = (w / $obj.width()) * $obj.height();
      }
      if ((nh > h) && h > 0) {
        nh = h;
        nw = (h / $obj.height()) * $obj.width();
      }
      xscale = $obj.width() / nw;
      yscale = $obj.height() / nh;
      $obj.width(nw).height(nh);
    }
    //}}}
    function unscale(c) //{{{
    {
      return {
        x: c.x * xscale,
        y: c.y * yscale,
        x2: c.x2 * xscale,
        y2: c.y2 * yscale,
        w: c.w * xscale,
        h: c.h * yscale
      };
    }
    //}}}
    function doneSelect(pos) //{{{
    {
      var c = Coords.getFixed();
      if ((c.w > options.minSelect[0]) && (c.h > options.minSelect[1])) {
        Selection.enableHandles();
        Selection.done();
      } else {
        Selection.release();
      }
      Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
    }
    //}}}
    function newSelection(e) //{{{
    {
      if (options.disabled) {
        return false;
      }
      if (!options.allowSelect) {
        return false;
      }
      btndown = true;
      docOffset = getPos($img);
      Selection.disableHandles();
      Tracker.setCursor('crosshair');
      var pos = mouseAbs(e);
      Coords.setPressed(pos);
      Selection.update();
      Tracker.activateHandlers(selectDrag, doneSelect, e.type.substring(0,5)==='touch');
      KeyManager.watchKeys();

      e.stopPropagation();
      e.preventDefault();
      return false;
    }
    //}}}
    function selectDrag(pos) //{{{
    {
      Coords.setCurrent(pos);
      Selection.update();
    }
    //}}}
    function newTracker() //{{{
    {
      var trk = $('<div></div>').addClass(cssClass('tracker'));
      if (is_msie) {
        trk.css({
          opacity: 0,
          backgroundColor: 'white'
        });
      }
      return trk;
    }
    //}}}

    // }}}
    // Initialization {{{
    // Sanitize some options {{{
    if (typeof(obj) !== 'object') {
      obj = $(obj)[0];
    }
    if (typeof(opt) !== 'object') {
      opt = {};
    }
    // }}}
    setOptions(opt);
    // Initialize some jQuery objects {{{
    // The values are SET on the image(s) for the interface
    // If the original image has any of these set, they will be reset
    // However, if you destroy() the Jcrop instance the original image's
    // character in the DOM will be as you left it.
    var img_css = {
      border: 'none',
      visibility: 'visible',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0,
      left: 0
    };

    var $origimg = $(obj),
      img_mode = true;

    if (obj.tagName == 'IMG') {
      // Fix size of crop image.
      // Necessary when crop image is within a hidden element when page is loaded.
      if ($origimg[0].width != 0 && $origimg[0].height != 0) {
        // Obtain dimensions from contained img element.
        $origimg.width($origimg[0].width);
        $origimg.height($origimg[0].height);
      } else {
        // Obtain dimensions from temporary image in case the original is not loaded yet (e.g. IE 7.0). 
        var tempImage = new Image();
        tempImage.src = $origimg[0].src;
        $origimg.width(tempImage.width);
        $origimg.height(tempImage.height);
      } 

      var $img = $origimg.clone().removeAttr('id').css(img_css).show();

      $img.width($origimg.width());
      $img.height($origimg.height());
      $origimg.after($img).hide();

    } else {
      $img = $origimg.css(img_css).show();
      img_mode = false;
      if (options.shade === null) { options.shade = true; }
    }

    presize($img, options.boxWidth, options.boxHeight);

    var boundx = $img.width(),
        boundy = $img.height(),
        
        
        $div = $('<div />').width(boundx).height(boundy).addClass(cssClass('holder')).css({
        position: 'relative',
        backgroundColor: options.bgColor
      }).insertAfter($origimg).append($img);

    if (options.addClass) {
      $div.addClass(options.addClass);
    }

    var $img2 = $('<div />'),

        $img_holder = $('<div />') 
        .width('100%').height('100%').css({
          zIndex: 310,
          position: 'absolute',
          overflow: 'hidden'
        }),

        $hdl_holder = $('<div />') 
        .width('100%').height('100%').css('zIndex', 320), 

        $sel = $('<div />') 
        .css({
          position: 'absolute',
          zIndex: 600
        }).dblclick(function(){
          var c = Coords.getFixed();
          options.onDblClick.call(api,c);
        }).insertBefore($img).append($img_holder, $hdl_holder); 

    if (img_mode) {

      $img2 = $('<img />')
          .attr('src', $img.attr('src')).css(img_css).width(boundx).height(boundy),

      $img_holder.append($img2);

    }

    if (ie6mode) {
      $sel.css({
        overflowY: 'hidden'
      });
    }

    var bound = options.boundary;
    var $trk = newTracker().width(boundx + (bound * 2)).height(boundy + (bound * 2)).css({
      position: 'absolute',
      top: px(-bound),
      left: px(-bound),
      zIndex: 290
    }).mousedown(newSelection);

    /* }}} */
    // Set more variables {{{
    var bgcolor = options.bgColor,
        bgopacity = options.bgOpacity,
        xlimit, ylimit, xmin, ymin, xscale, yscale, enabled = true,
        btndown, animating, shift_down;

    docOffset = getPos($img);
    // }}}
    // }}}
    // Internal Modules {{{
    // Touch Module {{{ 
    var Touch = (function () {
      // Touch support detection function adapted (under MIT License)
      // from code by Jeffrey Sambells - http://github.com/iamamused/
      function hasTouchSupport() {
        var support = {}, events = ['touchstart', 'touchmove', 'touchend'],
            el = document.createElement('div'), i;

        try {
          for(i=0; i<events.length; i++) {
            var eventName = events[i];
            eventName = 'on' + eventName;
            var isSupported = (eventName in el);
            if (!isSupported) {
              el.setAttribute(eventName, 'return;');
              isSupported = typeof el[eventName] == 'function';
            }
            support[events[i]] = isSupported;
          }
          return support.touchstart && support.touchend && support.touchmove;
        }
        catch(err) {
          return false;
        }
      }

      function detectSupport() {
        if ((options.touchSupport === true) || (options.touchSupport === false)) return options.touchSupport;
          else return hasTouchSupport();
      }
      return {
        createDragger: function (ord) {
          return function (e) {
            if (options.disabled) {
              return false;
            }
            if ((ord === 'move') && !options.allowMove) {
              return false;
            }
            docOffset = getPos($img);
            btndown = true;
            startDragMode(ord, mouseAbs(Touch.cfilter(e)), true);
            e.stopPropagation();
            e.preventDefault();
            return false;
          };
        },
        newSelection: function (e) {
          return newSelection(Touch.cfilter(e));
        },
        cfilter: function (e){
          e.pageX = e.originalEvent.changedTouches[0].pageX;
          e.pageY = e.originalEvent.changedTouches[0].pageY;
          return e;
        },
        isSupported: hasTouchSupport,
        support: detectSupport()
      };
    }());
    // }}}
    // Coords Module {{{
    var Coords = (function () {
      var x1 = 0,
          y1 = 0,
          x2 = 0,
          y2 = 0,
          ox, oy;

      function setPressed(pos) //{{{
      {
        pos = rebound(pos);
        x2 = x1 = pos[0];
        y2 = y1 = pos[1];
      }
      //}}}
      function setCurrent(pos) //{{{
      {
        pos = rebound(pos);
        ox = pos[0] - x2;
        oy = pos[1] - y2;
        x2 = pos[0];
        y2 = pos[1];
      }
      //}}}
      function getOffset() //{{{
      {
        return [ox, oy];
      }
      //}}}
      function moveOffset(offset) //{{{
      {
        var ox = offset[0],
            oy = offset[1];

        if (0 > x1 + ox) {
          ox -= ox + x1;
        }
        if (0 > y1 + oy) {
          oy -= oy + y1;
        }

        if (boundy < y2 + oy) {
          oy += boundy - (y2 + oy);
        }
        if (boundx < x2 + ox) {
          ox += boundx - (x2 + ox);
        }

        x1 += ox;
        x2 += ox;
        y1 += oy;
        y2 += oy;
      }
      //}}}
      function getCorner(ord) //{{{
      {
        var c = getFixed();
        switch (ord) {
        case 'ne':
          return [c.x2, c.y];
        case 'nw':
          return [c.x, c.y];
        case 'se':
          return [c.x2, c.y2];
        case 'sw':
          return [c.x, c.y2];
        }
      }
      //}}}
      function getFixed() //{{{
      {
        if (!options.aspectRatio) {
          return getRect();
        }
        // This function could use some optimization I think...
        var aspect = options.aspectRatio,
            min_x = options.minSize[0] / xscale,
            
            
            //min_y = options.minSize[1]/yscale,
            max_x = options.maxSize[0] / xscale,
            max_y = options.maxSize[1] / yscale,
            rw = x2 - x1,
            rh = y2 - y1,
            rwa = Math.abs(rw),
            rha = Math.abs(rh),
            real_ratio = rwa / rha,
            xx, yy, w, h;

        if (max_x === 0) {
          max_x = boundx * 10;
        }
        if (max_y === 0) {
          max_y = boundy * 10;
        }
        if (real_ratio < aspect) {
          yy = y2;
          w = rha * aspect;
          xx = rw < 0 ? x1 - w : w + x1;

          if (xx < 0) {
            xx = 0;
            h = Math.abs((xx - x1) / aspect);
            yy = rh < 0 ? y1 - h : h + y1;
          } else if (xx > boundx) {
            xx = boundx;
            h = Math.abs((xx - x1) / aspect);
            yy = rh < 0 ? y1 - h : h + y1;
          }
        } else {
          xx = x2;
          h = rwa / aspect;
          yy = rh < 0 ? y1 - h : y1 + h;
          if (yy < 0) {
            yy = 0;
            w = Math.abs((yy - y1) * aspect);
            xx = rw < 0 ? x1 - w : w + x1;
          } else if (yy > boundy) {
            yy = boundy;
            w = Math.abs(yy - y1) * aspect;
            xx = rw < 0 ? x1 - w : w + x1;
          }
        }

        // Magic %-)
        if (xx > x1) { // right side
          if (xx - x1 < min_x) {
            xx = x1 + min_x;
          } else if (xx - x1 > max_x) {
            xx = x1 + max_x;
          }
          if (yy > y1) {
            yy = y1 + (xx - x1) / aspect;
          } else {
            yy = y1 - (xx - x1) / aspect;
          }
        } else if (xx < x1) { // left side
          if (x1 - xx < min_x) {
            xx = x1 - min_x;
          } else if (x1 - xx > max_x) {
            xx = x1 - max_x;
          }
          if (yy > y1) {
            yy = y1 + (x1 - xx) / aspect;
          } else {
            yy = y1 - (x1 - xx) / aspect;
          }
        }

        if (xx < 0) {
          x1 -= xx;
          xx = 0;
        } else if (xx > boundx) {
          x1 -= xx - boundx;
          xx = boundx;
        }

        if (yy < 0) {
          y1 -= yy;
          yy = 0;
        } else if (yy > boundy) {
          y1 -= yy - boundy;
          yy = boundy;
        }

        return makeObj(flipCoords(x1, y1, xx, yy));
      }
      //}}}
      function rebound(p) //{{{
      {
        if (p[0] < 0) p[0] = 0;
        if (p[1] < 0) p[1] = 0;

        if (p[0] > boundx) p[0] = boundx;
        if (p[1] > boundy) p[1] = boundy;

        return [Math.round(p[0]), Math.round(p[1])];
      }
      //}}}
      function flipCoords(x1, y1, x2, y2) //{{{
      {
        var xa = x1,
            xb = x2,
            ya = y1,
            yb = y2;
        if (x2 < x1) {
          xa = x2;
          xb = x1;
        }
        if (y2 < y1) {
          ya = y2;
          yb = y1;
        }
        return [xa, ya, xb, yb];
      }
      //}}}
      function getRect() //{{{
      {
        var xsize = x2 - x1,
            ysize = y2 - y1,
            delta;

        if (xlimit && (Math.abs(xsize) > xlimit)) {
          x2 = (xsize > 0) ? (x1 + xlimit) : (x1 - xlimit);
        }
        if (ylimit && (Math.abs(ysize) > ylimit)) {
          y2 = (ysize > 0) ? (y1 + ylimit) : (y1 - ylimit);
        }

        if (ymin / yscale && (Math.abs(ysize) < ymin / yscale)) {
          y2 = (ysize > 0) ? (y1 + ymin / yscale) : (y1 - ymin / yscale);
        }
        if (xmin / xscale && (Math.abs(xsize) < xmin / xscale)) {
          x2 = (xsize > 0) ? (x1 + xmin / xscale) : (x1 - xmin / xscale);
        }

        if (x1 < 0) {
          x2 -= x1;
          x1 -= x1;
        }
        if (y1 < 0) {
          y2 -= y1;
          y1 -= y1;
        }
        if (x2 < 0) {
          x1 -= x2;
          x2 -= x2;
        }
        if (y2 < 0) {
          y1 -= y2;
          y2 -= y2;
        }
        if (x2 > boundx) {
          delta = x2 - boundx;
          x1 -= delta;
          x2 -= delta;
        }
        if (y2 > boundy) {
          delta = y2 - boundy;
          y1 -= delta;
          y2 -= delta;
        }
        if (x1 > boundx) {
          delta = x1 - boundy;
          y2 -= delta;
          y1 -= delta;
        }
        if (y1 > boundy) {
          delta = y1 - boundy;
          y2 -= delta;
          y1 -= delta;
        }

        return makeObj(flipCoords(x1, y1, x2, y2));
      }
      //}}}
      function makeObj(a) //{{{
      {
        return {
          x: a[0],
          y: a[1],
          x2: a[2],
          y2: a[3],
          w: a[2] - a[0],
          h: a[3] - a[1]
        };
      }
      //}}}

      return {
        flipCoords: flipCoords,
        setPressed: setPressed,
        setCurrent: setCurrent,
        getOffset: getOffset,
        moveOffset: moveOffset,
        getCorner: getCorner,
        getFixed: getFixed
      };
    }());

    //}}}
    // Shade Module {{{
    var Shade = (function() {
      var enabled = false,
          holder = $('<div />').css({
            position: 'absolute',
            zIndex: 240,
            opacity: 0
          }),
          shades = {
            top: createShade(),
            left: createShade().height(boundy),
            right: createShade().height(boundy),
            bottom: createShade()
          };

      function resizeShades(w,h) {
        shades.left.css({ height: px(h) });
        shades.right.css({ height: px(h) });
      }
      function updateAuto()
      {
        return updateShade(Coords.getFixed());
      }
      function updateShade(c)
      {
        shades.top.css({
          left: px(c.x),
          width: px(c.w),
          height: px(c.y)
        });
        shades.bottom.css({
          top: px(c.y2),
          left: px(c.x),
          width: px(c.w),
          height: px(boundy-c.y2)
        });
        shades.right.css({
          left: px(c.x2),
          width: px(boundx-c.x2)
        });
        shades.left.css({
          width: px(c.x)
        });
      }
      function createShade() {
        return $('<div />').css({
          position: 'absolute',
          backgroundColor: options.shadeColor||options.bgColor
        }).appendTo(holder);
      }
      function enableShade() {
        if (!enabled) {
          enabled = true;
          holder.insertBefore($img);
          updateAuto();
          Selection.setBgOpacity(1,0,1);
          $img2.hide();

          setBgColor(options.shadeColor||options.bgColor,1);
          if (Selection.isAwake())
          {
            setOpacity(options.bgOpacity,1);
          }
            else setOpacity(1,1);
        }
      }
      function setBgColor(color,now) {
        colorChangeMacro(getShades(),color,now);
      }
      function disableShade() {
        if (enabled) {
          holder.remove();
          $img2.show();
          enabled = false;
          if (Selection.isAwake()) {
            Selection.setBgOpacity(options.bgOpacity,1,1);
          } else {
            Selection.setBgOpacity(1,1,1);
            Selection.disableHandles();
          }
          colorChangeMacro($div,0,1);
        }
      }
      function setOpacity(opacity,now) {
        if (enabled) {
          if (options.bgFade && !now) {
            holder.animate({
              opacity: 1-opacity
            },{
              queue: false,
              duration: options.fadeTime
            });
          }
          else holder.css({opacity:1-opacity});
        }
      }
      function refreshAll() {
        options.shade ? enableShade() : disableShade();
        if (Selection.isAwake()) setOpacity(options.bgOpacity);
      }
      function getShades() {
        return holder.children();
      }

      return {
        update: updateAuto,
        updateRaw: updateShade,
        getShades: getShades,
        setBgColor: setBgColor,
        enable: enableShade,
        disable: disableShade,
        resize: resizeShades,
        refresh: refreshAll,
        opacity: setOpacity
      };
    }());
    // }}}
    // Selection Module {{{
    var Selection = (function () {
      var awake,
          hdep = 370,
          borders = {},
          handle = {},
          dragbar = {},
          seehandles = false;

      // Private Methods
      function insertBorder(type) //{{{
      {
        var jq = $('<div />').css({
          position: 'absolute',
          opacity: options.borderOpacity
        }).addClass(cssClass(type));
        $img_holder.append(jq);
        return jq;
      }
      //}}}
      function dragDiv(ord, zi) //{{{
      {
        var jq = $('<div />').mousedown(createDragger(ord)).css({
          cursor: ord + '-resize',
          position: 'absolute',
          zIndex: zi
        }).addClass('ord-'+ord);

        if (Touch.support) {
          jq.bind('touchstart.jcrop', Touch.createDragger(ord));
        }

        $hdl_holder.append(jq);
        return jq;
      }
      //}}}
      function insertHandle(ord) //{{{
      {
        var hs = options.handleSize,

          div = dragDiv(ord, hdep++).css({
            opacity: options.handleOpacity
          }).addClass(cssClass('handle'));

        if (hs) { div.width(hs).height(hs); }

        return div;
      }
      //}}}
      function insertDragbar(ord) //{{{
      {
        return dragDiv(ord, hdep++).addClass('jcrop-dragbar');
      }
      //}}}
      function createDragbars(li) //{{{
      {
        var i;
        for (i = 0; i < li.length; i++) {
          dragbar[li[i]] = insertDragbar(li[i]);
        }
      }
      //}}}
      function createBorders(li) //{{{
      {
        var cl,i;
        for (i = 0; i < li.length; i++) {
          switch(li[i]){
            case'n': cl='hline'; break;
            case's': cl='hline bottom'; break;
            case'e': cl='vline right'; break;
            case'w': cl='vline'; break;
          }
          borders[li[i]] = insertBorder(cl);
        }
      }
      //}}}
      function createHandles(li) //{{{
      {
        var i;
        for (i = 0; i < li.length; i++) {
          handle[li[i]] = insertHandle(li[i]);
        }
      }
      //}}}
      function moveto(x, y) //{{{
      {
        if (!options.shade) {
          $img2.css({
            top: px(-y),
            left: px(-x)
          });
        }
        $sel.css({
          top: px(y),
          left: px(x)
        });
      }
      //}}}
      function resize(w, h) //{{{
      {
        $sel.width(Math.round(w)).height(Math.round(h));
      }
      //}}}
      function refresh() //{{{
      {
        var c = Coords.getFixed();

        Coords.setPressed([c.x, c.y]);
        Coords.setCurrent([c.x2, c.y2]);

        updateVisible();
      }
      //}}}

      // Internal Methods
      function updateVisible(select) //{{{
      {
        if (awake) {
          return update(select);
        }
      }
      //}}}
      function update(select) //{{{
      {
        var c = Coords.getFixed();

        resize(c.w, c.h);
        moveto(c.x, c.y);
        if (options.shade) Shade.updateRaw(c);

        awake || show();

        if (select) {
          options.onSelect.call(api, unscale(c));
        } else {
          options.onChange.call(api, unscale(c));
        }
      }
      //}}}
      function setBgOpacity(opacity,force,now) //{{{
      {
        if (!awake && !force) return;
        if (options.bgFade && !now) {
          $img.animate({
            opacity: opacity
          },{
            queue: false,
            duration: options.fadeTime
          });
        } else {
          $img.css('opacity', opacity);
        }
      }
      //}}}
      function show() //{{{
      {
        $sel.show();

        if (options.shade) Shade.opacity(bgopacity);
          else setBgOpacity(bgopacity,true);

        awake = true;
      }
      //}}}
      function release() //{{{
      {
        disableHandles();
        $sel.hide();

        if (options.shade) Shade.opacity(1);
          else setBgOpacity(1);

        awake = false;
        options.onRelease.call(api);
      }
      //}}}
      function showHandles() //{{{
      {
        if (seehandles) {
          $hdl_holder.show();
        }
      }
      //}}}
      function enableHandles() //{{{
      {
        seehandles = true;
        if (options.allowResize) {
          $hdl_holder.show();
          return true;
        }
      }
      //}}}
      function disableHandles() //{{{
      {
        seehandles = false;
        $hdl_holder.hide();
      } 
      //}}}
      function animMode(v) //{{{
      {
        if (v) {
          animating = true;
          disableHandles();
        } else {
          animating = false;
          enableHandles();
        }
      } 
      //}}}
      function done() //{{{
      {
        animMode(false);
        refresh();
      } 
      //}}}
      // Insert draggable elements {{{
      // Insert border divs for outline

      if (options.dragEdges && $.isArray(options.createDragbars))
        createDragbars(options.createDragbars);

      if ($.isArray(options.createHandles))
        createHandles(options.createHandles);

      if (options.drawBorders && $.isArray(options.createBorders))
        createBorders(options.createBorders);

      //}}}

      // This is a hack for iOS5 to support drag/move touch functionality
      $(document).bind('touchstart.jcrop-ios',function(e) {
        if ($(e.currentTarget).hasClass('jcrop-tracker')) e.stopPropagation();
      });

      var $track = newTracker().mousedown(createDragger('move')).css({
        cursor: 'move',
        position: 'absolute',
        zIndex: 360
      });

      if (Touch.support) {
        $track.bind('touchstart.jcrop', Touch.createDragger('move'));
      }

      $img_holder.append($track);
      disableHandles();

      return {
        updateVisible: updateVisible,
        update: update,
        release: release,
        refresh: refresh,
        isAwake: function () {
          return awake;
        },
        setCursor: function (cursor) {
          $track.css('cursor', cursor);
        },
        enableHandles: enableHandles,
        enableOnly: function () {
          seehandles = true;
        },
        showHandles: showHandles,
        disableHandles: disableHandles,
        animMode: animMode,
        setBgOpacity: setBgOpacity,
        done: done
      };
    }());
    
    //}}}
    // Tracker Module {{{
    var Tracker = (function () {
      var onMove = function () {},
          onDone = function () {},
          trackDoc = options.trackDocument;

      function toFront(touch) //{{{
      {
        $trk.css({
          zIndex: 450
        });

        if (touch)
          $(document)
            .bind('touchmove.jcrop', trackTouchMove)
            .bind('touchend.jcrop', trackTouchEnd);

        else if (trackDoc)
          $(document)
            .bind('mousemove.jcrop',trackMove)
            .bind('mouseup.jcrop',trackUp);
      } 
      //}}}
      function toBack() //{{{
      {
        $trk.css({
          zIndex: 290
        });
        $(document).unbind('.jcrop');
      } 
      //}}}
      function trackMove(e) //{{{
      {
        onMove(mouseAbs(e));
        return false;
      } 
      //}}}
      function trackUp(e) //{{{
      {
        e.preventDefault();
        e.stopPropagation();

        if (btndown) {
          btndown = false;

          onDone(mouseAbs(e));

          if (Selection.isAwake()) {
            options.onSelect.call(api, unscale(Coords.getFixed()));
          }

          toBack();
          onMove = function () {};
          onDone = function () {};
        }

        return false;
      }
      //}}}
      function activateHandlers(move, done, touch) //{{{
      {
        btndown = true;
        onMove = move;
        onDone = done;
        toFront(touch);
        return false;
      }
      //}}}
      function trackTouchMove(e) //{{{
      {
        onMove(mouseAbs(Touch.cfilter(e)));
        return false;
      }
      //}}}
      function trackTouchEnd(e) //{{{
      {
        return trackUp(Touch.cfilter(e));
      }
      //}}}
      function setCursor(t) //{{{
      {
        $trk.css('cursor', t);
      }
      //}}}

      if (!trackDoc) {
        $trk.mousemove(trackMove).mouseup(trackUp).mouseout(trackUp);
      }

      $img.before($trk);
      return {
        activateHandlers: activateHandlers,
        setCursor: setCursor
      };
    }());
    //}}}
    // KeyManager Module {{{
    var KeyManager = (function () {
      var $keymgr = $('<input type="radio" />').css({
        position: 'fixed',
        left: '-120px',
        width: '12px'
      }).addClass('jcrop-keymgr'),

        $keywrap = $('<div />').css({
          position: 'absolute',
          overflow: 'hidden'
        }).append($keymgr);

      function watchKeys() //{{{
      {
        if (options.keySupport) {
          $keymgr.show();
          $keymgr.focus();
        }
      }
      //}}}
      function onBlur(e) //{{{
      {
        $keymgr.hide();
      }
      //}}}
      function doNudge(e, x, y) //{{{
      {
        if (options.allowMove) {
          Coords.moveOffset([x, y]);
          Selection.updateVisible(true);
        }
        e.preventDefault();
        e.stopPropagation();
      }
      //}}}
      function parseKey(e) //{{{
      {
        if (e.ctrlKey || e.metaKey) {
          return true;
        }
        shift_down = e.shiftKey ? true : false;
        var nudge = shift_down ? 10 : 1;

        switch (e.keyCode) {
        case 37:
          doNudge(e, -nudge, 0);
          break;
        case 39:
          doNudge(e, nudge, 0);
          break;
        case 38:
          doNudge(e, 0, -nudge);
          break;
        case 40:
          doNudge(e, 0, nudge);
          break;
        case 27:
          if (options.allowSelect) Selection.release();
          break;
        case 9:
          return true;
        }

        return false;
      }
      //}}}

      if (options.keySupport) {
        $keymgr.keydown(parseKey).blur(onBlur);
        if (ie6mode || !options.fixedSupport) {
          $keymgr.css({
            position: 'absolute',
            left: '-20px'
          });
          $keywrap.append($keymgr).insertBefore($img);
        } else {
          $keymgr.insertBefore($img);
        }
      }


      return {
        watchKeys: watchKeys
      };
    }());
    //}}}
    // }}}
    // API methods {{{
    function setClass(cname) //{{{
    {
      $div.removeClass().addClass(cssClass('holder')).addClass(cname);
    }
    //}}}
    function animateTo(a, callback) //{{{
    {
      var x1 = a[0] / xscale,
          y1 = a[1] / yscale,
          x2 = a[2] / xscale,
          y2 = a[3] / yscale;

      if (animating) {
        return;
      }

      var animto = Coords.flipCoords(x1, y1, x2, y2),
          c = Coords.getFixed(),
          initcr = [c.x, c.y, c.x2, c.y2],
          animat = initcr,
          interv = options.animationDelay,
          ix1 = animto[0] - initcr[0],
          iy1 = animto[1] - initcr[1],
          ix2 = animto[2] - initcr[2],
          iy2 = animto[3] - initcr[3],
          pcent = 0,
          velocity = options.swingSpeed;

      x1 = animat[0];
      y1 = animat[1];
      x2 = animat[2];
      y2 = animat[3];

      Selection.animMode(true);
      var anim_timer;

      function queueAnimator() {
        window.setTimeout(animator, interv);
      }
      var animator = (function () {
        return function () {
          pcent += (100 - pcent) / velocity;

          animat[0] = Math.round(x1 + ((pcent / 100) * ix1));
          animat[1] = Math.round(y1 + ((pcent / 100) * iy1));
          animat[2] = Math.round(x2 + ((pcent / 100) * ix2));
          animat[3] = Math.round(y2 + ((pcent / 100) * iy2));

          if (pcent >= 99.8) {
            pcent = 100;
          }
          if (pcent < 100) {
            setSelectRaw(animat);
            queueAnimator();
          } else {
            Selection.done();
            Selection.animMode(false);
            if (typeof(callback) === 'function') {
              callback.call(api);
            }
          }
        };
      }());
      queueAnimator();
    }
    //}}}
    function setSelect(rect) //{{{
    {
      setSelectRaw([rect[0] / xscale, rect[1] / yscale, rect[2] / xscale, rect[3] / yscale]);
      options.onSelect.call(api, unscale(Coords.getFixed()));
      Selection.enableHandles();
    }
    //}}}
    function setSelectRaw(l) //{{{
    {
      Coords.setPressed([l[0], l[1]]);
      Coords.setCurrent([l[2], l[3]]);
      Selection.update();
    }
    //}}}
    function tellSelect() //{{{
    {
      return unscale(Coords.getFixed());
    }
    //}}}
    function tellScaled() //{{{
    {
      return Coords.getFixed();
    }
    //}}}
    function setOptionsNew(opt) //{{{
    {
      setOptions(opt);
      interfaceUpdate();
    }
    //}}}
    function disableCrop() //{{{
    {
      options.disabled = true;
      Selection.disableHandles();
      Selection.setCursor('default');
      Tracker.setCursor('default');
    }
    //}}}
    function enableCrop() //{{{
    {
      options.disabled = false;
      interfaceUpdate();
    }
    //}}}
    function cancelCrop() //{{{
    {
      Selection.done();
      Tracker.activateHandlers(null, null);
    }
    //}}}
    function destroy() //{{{
    {
      $div.remove();
      $origimg.show();
      $origimg.css('visibility','visible');
      $(obj).removeData('Jcrop');
    }
    //}}}
    function setImage(src, callback) //{{{
    {
      Selection.release();
      disableCrop();
      var img = new Image();
      img.onload = function () {
        var iw = img.width;
        var ih = img.height;
        var bw = options.boxWidth;
        var bh = options.boxHeight;
        $img.width(iw).height(ih);
        $img.attr('src', src);
        $img2.attr('src', src);
        presize($img, bw, bh);
        boundx = $img.width();
        boundy = $img.height();
        $img2.width(boundx).height(boundy);
        $trk.width(boundx + (bound * 2)).height(boundy + (bound * 2));
        $div.width(boundx).height(boundy);
        Shade.resize(boundx,boundy);
        enableCrop();

        if (typeof(callback) === 'function') {
          callback.call(api);
        }
      };
      img.src = src;
    }
    //}}}
    function colorChangeMacro($obj,color,now) {
      var mycolor = color || options.bgColor;
      if (options.bgFade && supportsColorFade() && options.fadeTime && !now) {
        $obj.animate({
          backgroundColor: mycolor
        }, {
          queue: false,
          duration: options.fadeTime
        });
      } else {
        $obj.css('backgroundColor', mycolor);
      }
    }
    function interfaceUpdate(alt) //{{{
    // This method tweaks the interface based on options object.
    // Called when options are changed and at end of initialization.
    {
      if (options.allowResize) {
        if (alt) {
          Selection.enableOnly();
        } else {
          Selection.enableHandles();
        }
      } else {
        Selection.disableHandles();
      }

      Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
      Selection.setCursor(options.allowMove ? 'move' : 'default');

      if (options.hasOwnProperty('trueSize')) {
        xscale = options.trueSize[0] / boundx;
        yscale = options.trueSize[1] / boundy;
      }

      if (options.hasOwnProperty('setSelect')) {
        setSelect(options.setSelect);
        Selection.done();
        delete(options.setSelect);
      }

      Shade.refresh();

      if (options.bgColor != bgcolor) {
        colorChangeMacro(
          options.shade? Shade.getShades(): $div,
          options.shade?
            (options.shadeColor || options.bgColor):
            options.bgColor
        );
        bgcolor = options.bgColor;
      }

      if (bgopacity != options.bgOpacity) {
        bgopacity = options.bgOpacity;
        if (options.shade) Shade.refresh();
          else Selection.setBgOpacity(bgopacity);
      }

      xlimit = options.maxSize[0] || 0;
      ylimit = options.maxSize[1] || 0;
      xmin = options.minSize[0] || 0;
      ymin = options.minSize[1] || 0;

      if (options.hasOwnProperty('outerImage')) {
        $img.attr('src', options.outerImage);
        delete(options.outerImage);
      }

      Selection.refresh();
    }
    //}}}
    //}}}

    if (Touch.support) $trk.bind('touchstart.jcrop', Touch.newSelection);

    $hdl_holder.hide();
    interfaceUpdate(true);

    var api = {
      setImage: setImage,
      animateTo: animateTo,
      setSelect: setSelect,
      setOptions: setOptionsNew,
      tellSelect: tellSelect,
      tellScaled: tellScaled,
      setClass: setClass,

      disable: disableCrop,
      enable: enableCrop,
      cancel: cancelCrop,
      release: Selection.release,
      destroy: destroy,

      focus: KeyManager.watchKeys,

      getBounds: function () {
        return [boundx * xscale, boundy * yscale];
      },
      getWidgetSize: function () {
        return [boundx, boundy];
      },
      getScaleFactor: function () {
        return [xscale, yscale];
      },
      getOptions: function() {
        // careful: internal values are returned
        return options;
      },

      ui: {
        holder: $div,
        selection: $sel
      }
    };

    if (is_msie) $div.bind('selectstart', function () { return false; });

    $origimg.data('Jcrop', api);
    return api;
  };
  $.fn.Jcrop = function (options, callback) //{{{
  {
    var api;
    // Iterate over each object, attach Jcrop
    this.each(function () {
      // If we've already attached to this object
      if ($(this).data('Jcrop')) {
        // The API can be requested this way (undocumented)
        if (options === 'api') return $(this).data('Jcrop');
        // Otherwise, we just reset the options...
        else $(this).data('Jcrop').setOptions(options);
      }
      // If we haven't been attached, preload and attach
      else {
        if (this.tagName == 'IMG')
          $.Jcrop.Loader(this,function(){
            $(this).css({display:'block',visibility:'hidden'});
            api = $.Jcrop(this, options);
            if ($.isFunction(callback)) callback.call(api);
          });
        else {
          $(this).css({display:'block',visibility:'hidden'});
          api = $.Jcrop(this, options);
          if ($.isFunction(callback)) callback.call(api);
        }
      }
    });

    // Return "this" so the object is chainable (jQuery-style)
    return this;
  };
  //}}}
  // $.Jcrop.Loader - basic image loader {{{

  $.Jcrop.Loader = function(imgobj,success,error){
    var $img = $(imgobj), img = $img[0];

    function completeCheck(){
      if (img.complete) {
        $img.unbind('.jcloader');
        if ($.isFunction(success)) success.call(img);
      }
      else window.setTimeout(completeCheck,50);
    }

    $img
      .bind('load.jcloader',completeCheck)
      .bind('error.jcloader',function(e){
        $img.unbind('.jcloader');
        if ($.isFunction(error)) error.call(img);
      });

    if (img.complete && $.isFunction(success)){
      $img.unbind('.jcloader');
      success.call(img);
    }
  };

  //}}}
  // Global Defaults {{{
  $.Jcrop.defaults = {

    // Basic Settings
    allowSelect: true,
    allowMove: true,
    allowResize: true,

    trackDocument: true,

    // Styling Options
    baseClass: 'jcrop',
    addClass: null,
    bgColor: 'black',
    bgOpacity: 0.6,
    bgFade: false,
    borderOpacity: 0.4,
    handleOpacity: 0.5,
    handleSize: null,

    aspectRatio: 0,
    keySupport: true,
    createHandles: ['n','s','e','w','nw','ne','se','sw'],
    createDragbars: ['n','s','e','w'],
    createBorders: ['n','s','e','w'],
    drawBorders: true,
    dragEdges: true,
    fixedSupport: true,
    touchSupport: null,

    shade: null,

    boxWidth: 0,
    boxHeight: 0,
    boundary: 2,
    fadeTime: 400,
    animationDelay: 20,
    swingSpeed: 3,

    minSelect: [0, 0],
    maxSize: [0, 0],
    minSize: [0, 0],

    // Callbacks / Event Handlers
    onChange: function () {},
    onSelect: function () {},
    onDblClick: function () {},
    onRelease: function () {}
  };

  // }}}
}(jQuery));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright 2014 Telerik AD
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(e,define){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(function(){return function(e,t){function n(e,t,n,i){var r,o=e.getFullYear(),a=t.getFullYear(),s=n.getFullYear();return o-=o%i,r=o+(i-1),a>o&&(o=a),r>s&&(r=s),o+"-"+r}function i(e){for(var t,n=0,i=e.min,r=e.max,o=e.start,a=e.setter,l=e.build,c=e.cells||12,d=e.perRow||4,u=e.content||I,h=e.empty||P,p=e.html||'<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><tbody><tr role="row">';c>n;n++)n>0&&n%d===0&&(p+='</tr><tr role="row">'),t=l(o,n),p+=s(o,i,r)?u(t):h(t),a(o,1);return p+"</tr></tbody></table>"}function r(e,t,n){var i=e.getFullYear(),r=t.getFullYear(),o=r,a=0;return n&&(r-=r%n,o=r-r%n+n-1),i>o?a=1:r>i&&(a=-1),a}function o(){var e=new ft;return new ft(e.getFullYear(),e.getMonth(),e.getDate())}function a(e,t,n){var i=o();return e&&(i=new ft(+e)),t>i?i=new ft(+t):i>n&&(i=new ft(+n)),i}function s(e,t,n){return+e>=+t&&+n>=+e}function l(e,t){return e.slice(t).concat(e.slice(0,t))}function c(e,t,n){t=t instanceof ft?t.getFullYear():e.getFullYear()+n*t,e.setFullYear(t)}function d(t){e(this).toggleClass($,it.indexOf(t.type)>-1||t.type==tt)}function u(e){e.preventDefault()}function h(e){return A(e).calendars.standard}function p(e){var n=gt[e.start],i=gt[e.depth],r=A(e.culture);e.format=T(e.format||r.calendars.standard.patterns.d),isNaN(n)&&(n=0,e.start=U),(i===t||i>n)&&(e.depth=U),e.dates||(e.dates=[])}function f(e){z&&e.find("*").attr("unselectable","on")}function g(e,t){for(var n=0,i=t.length;i>n;n++)if(e===+t[n])return!0;return!1}function m(e,t){return e?e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth()&&e.getDate()===t.getDate():!1}function v(e,t){return e?e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth():!1}var _,w=window.kendo,y=w.support,b=w.ui,k=b.Widget,x=w.keys,C=w.parseDate,S=w.date.adjustDST,T=w._extractFormat,D=w.template,A=w.getCulture,E=w.support.transitions,M=E?E.css+"transform-origin":"",I=D('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link" href="\\#" data-#=data.ns#value="#=data.dateString#">#=data.value#</a></td>',{useWithBlock:!1}),P=D('<td role="gridcell">&nbsp;</td>',{useWithBlock:!1}),F=w.support.browser,z=F.msie&&9>F.version,R=".kendoCalendar",B="click"+R,H="keydown"+R,L="id",N="min",O="left",V="slideIn",U="month",W="century",j="change",q="navigate",G="value",$="k-state-hover",Y="k-state-disabled",Q="k-state-focused",K="k-other-month",X=' class="'+K+'"',Z="k-nav-today",J="td:has(.k-link)",et="blur"+R,tt="focus",nt=tt+R,it=y.touch?"touchstart":"mouseenter",rt=y.touch?"touchstart"+R:"mouseenter"+R,ot=y.touch?"touchend"+R+" touchmove"+R:"mouseleave"+R,at=6e4,st=864e5,lt="_prevArrow",ct="_nextArrow",dt="aria-disabled",ut="aria-selected",ht=e.proxy,pt=e.extend,ft=Date,gt={month:0,year:1,decade:2,century:3},mt=k.extend({init:function(t,n){var i,r,o=this;k.fn.init.call(o,t,n),t=o.wrapper=o.element,n=o.options,n.url=window.unescape(n.url),o._templates(),o._header(),o._footer(o.footer),r=t.addClass("k-widget k-calendar").on(rt+" "+ot,J,d).on(H,"table.k-content",ht(o._move,o)).on(B,J,function(t){var n=t.currentTarget.firstChild;-1!=n.href.indexOf("#")&&t.preventDefault(),o._click(e(n))}).on("mouseup"+R,"table.k-content, .k-footer",function(){o._focusView(o.options.focusOnNav!==!1)}).attr(L),r&&(o._cellID=r+"_cell_selected"),p(n),i=C(n.value,n.format,n.culture),o._index=gt[n.start],o._current=new ft(+a(i,n.min,n.max)),o._addClassProxy=function(){o._active=!0,o._cell.addClass(Q)},o._removeClassProxy=function(){o._active=!1,o._cell.removeClass(Q)},o.value(i),w.notify(o)},options:{name:"Calendar",value:null,min:new ft(1900,0,1),max:new ft(2099,11,31),dates:[],url:"",culture:"",footer:"",format:"",month:{},start:U,depth:U,animation:{horizontal:{effects:V,reverse:!0,duration:500,divisor:2},vertical:{effects:"zoomIn",duration:400}}},events:[j,q],setOptions:function(e){var t=this;p(e),e.dates[0]||(e.dates=t.options.dates),k.fn.setOptions.call(t,e),t._templates(),t._footer(t.footer),t._index=gt[t.options.start],t.navigate()},destroy:function(){var e=this,t=e._today;e.element.off(R),e._title.off(R),e[lt].off(R),e[ct].off(R),w.destroy(e._table),t&&w.destroy(t.off(R)),k.fn.destroy.call(e)},current:function(){return this._current},view:function(){return this._view},focus:function(e){e=e||this._table,this._bindTable(e),e.focus()},min:function(e){return this._option(N,e)},max:function(e){return this._option("max",e)},navigateToPast:function(){this._navigate(lt,-1)},navigateToFuture:function(){this._navigate(ct,1)},navigateUp:function(){var e=this,t=e._index;e._title.hasClass(Y)||e.navigate(e._current,++t)},navigateDown:function(e){var n=this,i=n._index,r=n.options.depth;if(e)return i===gt[r]?(+n._value!=+e&&(n.value(e),n.trigger(j)),t):(n.navigate(e,--i),t)},navigate:function(n,i){i=isNaN(i)?gt[i]:i;var r,o,s,l,c=this,d=c.options,u=d.culture,h=d.min,p=d.max,g=c._title,m=c._table,v=c._oldTable,w=c._value,y=c._current,b=n&&+n>+y,k=i!==t&&i!==c._index;n||(n=y),c._current=n=new ft(+a(n,h,p)),i===t?i=c._index:c._index=i,c._view=o=_.views[i],s=o.compare,l=i===gt[W],g.toggleClass(Y,l).attr(dt,l),l=s(n,h)<1,c[lt].toggleClass(Y,l).attr(dt,l),l=s(n,p)>-1,c[ct].toggleClass(Y,l).attr(dt,l),m&&v&&v.data("animating")&&(v.kendoStop(!0,!0),m.kendoStop(!0,!0)),c._oldTable=m,(!m||c._changeView)&&(g.html(o.title(n,h,p,u)),c._table=r=e(o.content(pt({min:h,max:p,date:n,url:d.url,dates:d.dates,format:d.format,culture:u},c[o.name]))),f(r),c._animate({from:m,to:r,vertical:k,future:b}),c._focus(n),c.trigger(q)),i===gt[d.depth]&&w&&c._class("k-state-selected",o.toDateString(w)),c._class(Q,o.toDateString(n)),!m&&c._cell&&c._cell.removeClass(Q),c._changeView=!0},value:function(e){var n=this,i=n._view,r=n.options,o=n._view,a=r.min,l=r.max;return e===t?n._value:(e=C(e,r.format,r.culture),null!==e&&(e=new ft(+e),s(e,a,l)||(e=null)),n._value=e,o&&null===e&&n._cell?n._cell.removeClass("k-state-selected"):(n._changeView=!e||i&&0!==i.compare(e,n._current),n.navigate(e)),t)},_move:function(t){var n,i,r,o,s=this,l=s.options,c=t.keyCode,d=s._view,u=s._index,h=new ft(+s._current),p=w.support.isRtl(s.wrapper);return t.target===s._table[0]&&(s._active=!0),t.ctrlKey?c==x.RIGHT&&!p||c==x.LEFT&&p?(s.navigateToFuture(),i=!0):c==x.LEFT&&!p||c==x.RIGHT&&p?(s.navigateToPast(),i=!0):c==x.UP?(s.navigateUp(),i=!0):c==x.DOWN&&(s._click(e(s._cell[0].firstChild)),i=!0):(c==x.RIGHT&&!p||c==x.LEFT&&p?(n=1,i=!0):c==x.LEFT&&!p||c==x.RIGHT&&p?(n=-1,i=!0):c==x.UP?(n=0===u?-7:-4,i=!0):c==x.DOWN?(n=0===u?7:4,i=!0):c==x.ENTER?(s._click(e(s._cell[0].firstChild)),i=!0):c==x.HOME||c==x.END?(r=c==x.HOME?"first":"last",o=d[r](h),h=new ft(o.getFullYear(),o.getMonth(),o.getDate(),h.getHours(),h.getMinutes(),h.getSeconds(),h.getMilliseconds()),i=!0):c==x.PAGEUP?(i=!0,s.navigateToPast()):c==x.PAGEDOWN&&(i=!0,s.navigateToFuture()),(n||r)&&(r||d.setDate(h,n),s._focus(a(h,l.min,l.max)))),i&&t.preventDefault(),s._current},_animate:function(e){var t=this,n=e.from,i=e.to,r=t._active;n?n.parent().data("animating")?(n.off(R),n.parent().kendoStop(!0,!0).remove(),n.remove(),i.insertAfter(t.element[0].firstChild),t._focusView(r)):n.is(":visible")&&t.options.animation!==!1?t[e.vertical?"_vertical":"_horizontal"](n,i,e.future):(i.insertAfter(n),n.off(R).remove(),t._focusView(r)):(i.insertAfter(t.element[0].firstChild),t._bindTable(i))},_horizontal:function(e,t,n){var i=this,r=i._active,o=i.options.animation.horizontal,a=o.effects,s=e.outerWidth();a&&-1!=a.indexOf(V)&&(e.add(t).css({width:s}),e.wrap("<div/>"),i._focusView(r,e),e.parent().css({position:"relative",width:2*s,"float":O,"margin-left":n?0:-s}),t[n?"insertAfter":"insertBefore"](e),pt(o,{effects:V+":"+(n?"right":O),complete:function(){e.off(R).remove(),i._oldTable=null,t.unwrap(),i._focusView(r)}}),e.parent().kendoStop(!0,!0).kendoAnimate(o))},_vertical:function(e,t){var n,i,r=this,o=r.options.animation.vertical,a=o.effects,s=r._active;a&&-1!=a.indexOf("zoom")&&(t.css({position:"absolute",top:e.prev().outerHeight(),left:0}).insertBefore(e),M&&(n=r._cellByDate(r._view.toDateString(r._current)),i=n.position(),i=i.left+parseInt(n.width()/2,10)+"px "+(i.top+parseInt(n.height()/2,10)+"px"),t.css(M,i)),e.kendoStop(!0,!0).kendoAnimate({effects:"fadeOut",duration:600,complete:function(){e.off(R).remove(),r._oldTable=null,t.css({position:"static",top:0,left:0}),r._focusView(s)}}),t.kendoStop(!0,!0).kendoAnimate(o))},_cellByDate:function(t){return this._table.find("td:not(."+K+")").filter(function(){return e(this.firstChild).attr(w.attr(G))===t})},_class:function(t,n){var i=this,r=i._cellID,o=i._cell;o&&o.removeAttr(ut).removeAttr("aria-label").removeAttr(L),o=i._table.find("td:not(."+K+")").removeClass(t).filter(function(){return e(this.firstChild).attr(w.attr(G))===n}).attr(ut,!0),t!==Q||i._active||i.options.focusOnNav===!1||(t=""),o.addClass(t),o[0]&&(i._cell=o),r&&(o.attr(L,r),i._table.removeAttr("aria-activedescendant").attr("aria-activedescendant",r))},_bindTable:function(e){e.on(nt,this._addClassProxy).on(et,this._removeClassProxy)},_click:function(e){var t=this,n=t.options,i=new Date(+t._current),r=e.attr(w.attr(G)).split("/");r=new ft(r[0],r[1],r[2]),S(r,0),t._view.setDate(i,r),t.navigateDown(a(i,n.min,n.max))},_focus:function(e){var t=this,n=t._view;0!==n.compare(e,t._current)?t.navigate(e):(t._current=e,t._class(Q,n.toDateString(e)))},_focusView:function(e,t){e&&this.focus(t)},_footer:function(n){var i=this,r=o(),a=i.element,s=a.find(".k-footer");return n?(s[0]||(s=e('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(a)),i._today=s.show().find(".k-link").html(n(r)).attr("title",w.toString(r,"D",i.options.culture)),i._toggle(),t):(i._toggle(!1),s.hide(),t)},_header:function(){var e,t=this,n=t.element;n.find(".k-header")[0]||n.html('<div class="k-header"><a href="#" role="button" class="k-link k-nav-prev"><span class="k-icon k-i-arrow-w"></span></a><a href="#" role="button" aria-live="assertive" aria-atomic="true" class="k-link k-nav-fast"></a><a href="#" role="button" class="k-link k-nav-next"><span class="k-icon k-i-arrow-e"></span></a></div>'),e=n.find(".k-link").on(rt+" "+ot+" "+nt+" "+et,d).click(!1),t._title=e.eq(1).on(B,function(){t._active=t.options.focusOnNav!==!1,t.navigateUp()}),t[lt]=e.eq(0).on(B,function(){t._active=t.options.focusOnNav!==!1,t.navigateToPast()}),t[ct]=e.eq(2).on(B,function(){t._active=t.options.focusOnNav!==!1,t.navigateToFuture()})},_navigate:function(e,t){var n=this,i=n._index+1,r=new ft(+n._current);e=n[e],e.hasClass(Y)||(i>3?r.setFullYear(r.getFullYear()+100*t):_.views[i].setDate(r,t),n.navigate(r))},_option:function(e,n){var i,r=this,o=r.options,a=r._value||r._current;return n===t?o[e]:(n=C(n,o.format,o.culture),n&&(o[e]=new ft(+n),i=e===N?n>a:a>n,(i||v(a,n))&&(i&&(r._value=null),r._changeView=!0),r._changeView||(r._changeView=!(!o.month.content&&!o.month.empty)),r.navigate(r._value),r._toggle()),t)},_toggle:function(e){var n=this,i=n.options,r=n._today;e===t&&(e=s(o(),i.min,i.max)),r&&(r.off(B),e?r.addClass(Z).removeClass(Y).on(B,ht(n._todayClick,n)):r.removeClass(Z).addClass(Y).on(B,u))},_todayClick:function(e){var t=this,n=gt[t.options.depth],i=o();e.preventDefault(),0===t._view.compare(t._current,i)&&t._index==n&&(t._changeView=!1),t._value=i,t.navigate(i,n),t.trigger(j)},_templates:function(){var e=this,t=e.options,n=t.footer,i=t.month,r=i.content,o=i.empty;e.month={content:D('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" '+w.attr("value")+'="#=data.dateString#" title="#=data.title#">'+(r||"#=data.value#")+"</a></td>",{useWithBlock:!!r}),empty:D('<td role="gridcell">'+(o||"&nbsp;")+"</td>",{useWithBlock:!!o})},e.footer=n!==!1?D(n||'#= kendo.toString(data,"D","'+t.culture+'") #',{useWithBlock:!1}):null}});b.plugin(mt),_={firstDayOfMonth:function(e){return new ft(e.getFullYear(),e.getMonth(),1)},firstVisibleDay:function(e,t){t=t||w.culture().calendar;for(var n=t.firstDay,i=new ft(e.getFullYear(),e.getMonth(),0,e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds());i.getDay()!=n;)_.setTime(i,-1*st);return i},setTime:function(e,t){var n=e.getTimezoneOffset(),i=new ft(e.getTime()+t),r=i.getTimezoneOffset()-n;e.setTime(i.getTime()+r*at)},views:[{name:U,title:function(e,t,n,i){return h(i).months.names[e.getMonth()]+" "+e.getFullYear()},content:function(e){for(var t=this,n=0,r=e.min,o=e.max,a=e.date,s=e.dates,c=e.format,d=e.culture,u=e.url,p=u&&s[0],f=h(d),m=f.firstDay,v=f.days,y=l(v.names,m),b=l(v.namesShort,m),k=_.firstVisibleDay(a,f),x=t.first(a),C=t.last(a),T=t.toDateString,D=new ft,A='<table tabindex="0" role="grid" class="k-content" cellspacing="0"><thead><tr role="row">';7>n;n++)A+='<th scope="col" title="'+y[n]+'">'+b[n]+"</th>";return D=new ft(D.getFullYear(),D.getMonth(),D.getDate()),S(D,0),D=+D,i({cells:42,perRow:7,html:A+='</tr></thead><tbody><tr role="row">',start:new ft(k.getFullYear(),k.getMonth(),k.getDate()),min:new ft(r.getFullYear(),r.getMonth(),r.getDate()),max:new ft(o.getFullYear(),o.getMonth(),o.getDate()),content:e.content,empty:e.empty,setter:t.setDate,build:function(e){var t=[],n=e.getDay(),i="",r="#";return(x>e||e>C)&&t.push(K),+e===D&&t.push("k-today"),(0===n||6===n)&&t.push("k-weekend"),p&&g(+e,s)&&(r=u.replace("{0}",w.toString(e,c,d)),i=" k-action-link"),{date:e,dates:s,ns:w.ns,title:w.toString(e,"D",d),value:e.getDate(),dateString:T(e),cssClass:t[0]?' class="'+t.join(" ")+'"':"",linkClass:i,url:r}}})},first:function(e){return _.firstDayOfMonth(e)},last:function(e){var t=new ft(e.getFullYear(),e.getMonth()+1,0),n=_.firstDayOfMonth(e),i=Math.abs(t.getTimezoneOffset()-n.getTimezoneOffset());return i&&t.setHours(n.getHours()+i/60),t},compare:function(e,t){var n,i=e.getMonth(),r=e.getFullYear(),o=t.getMonth(),a=t.getFullYear();return n=r>a?1:a>r?-1:i==o?0:i>o?1:-1},setDate:function(e,t){var n=e.getHours();t instanceof ft?e.setFullYear(t.getFullYear(),t.getMonth(),t.getDate()):_.setTime(e,t*st),S(e,n)},toDateString:function(e){return e.getFullYear()+"/"+e.getMonth()+"/"+e.getDate()}},{name:"year",title:function(e){return e.getFullYear()},content:function(e){var t=h(e.culture).months.namesAbbr,n=this.toDateString,r=e.min,o=e.max;return i({min:new ft(r.getFullYear(),r.getMonth(),1),max:new ft(o.getFullYear(),o.getMonth(),1),start:new ft(e.date.getFullYear(),0,1),setter:this.setDate,build:function(e){return{value:t[e.getMonth()],ns:w.ns,dateString:n(e),cssClass:""}}})},first:function(e){return new ft(e.getFullYear(),0,e.getDate())},last:function(e){return new ft(e.getFullYear(),11,e.getDate())},compare:function(e,t){return r(e,t)},setDate:function(e,t){var n,i=e.getHours();t instanceof ft?(n=t.getMonth(),e.setFullYear(t.getFullYear(),n,e.getDate()),n!==e.getMonth()&&e.setDate(0)):(n=e.getMonth()+t,e.setMonth(n),n>11&&(n-=12),n>0&&e.getMonth()!=n&&e.setDate(0)),S(e,i)},toDateString:function(e){return e.getFullYear()+"/"+e.getMonth()+"/1"}},{name:"decade",title:function(e,t,i){return n(e,t,i,10)},content:function(e){var t=e.date.getFullYear(),n=this.toDateString;return i({start:new ft(t-t%10-1,0,1),min:new ft(e.min.getFullYear(),0,1),max:new ft(e.max.getFullYear(),0,1),setter:this.setDate,build:function(e,t){return{value:e.getFullYear(),ns:w.ns,dateString:n(e),cssClass:0===t||11==t?X:""}}})},first:function(e){var t=e.getFullYear();return new ft(t-t%10,e.getMonth(),e.getDate())},last:function(e){var t=e.getFullYear();return new ft(t-t%10+9,e.getMonth(),e.getDate())},compare:function(e,t){return r(e,t,10)},setDate:function(e,t){c(e,t,1)},toDateString:function(e){return e.getFullYear()+"/0/1"}},{name:W,title:function(e,t,i){return n(e,t,i,100)},content:function(e){var t=e.date.getFullYear(),n=e.min.getFullYear(),r=e.max.getFullYear(),o=this.toDateString,a=n,s=r;return a-=a%10,s-=s%10,10>s-a&&(s=a+9),i({start:new ft(t-t%100-10,0,1),min:new ft(a,0,1),max:new ft(s,0,1),setter:this.setDate,build:function(e,t){var i=e.getFullYear(),a=i+9;return n>i&&(i=n),a>r&&(a=r),{ns:w.ns,value:i+" - "+a,dateString:o(e),cssClass:0===t||11==t?X:""}}})},first:function(e){var t=e.getFullYear();return new ft(t-t%100,e.getMonth(),e.getDate())},last:function(e){var t=e.getFullYear();return new ft(t-t%100+99,e.getMonth(),e.getDate())},compare:function(e,t){return r(e,t,100)},setDate:function(e,t){c(e,t,10)},toDateString:function(e){var t=e.getFullYear();return t-t%10+"/0/1"}}]},_.isEqualDatePart=m,_.makeUnselectable=f,_.restrictValue=a,_.isInRange=s,_.normalize=p,_.viewsEnum=gt,w.calendar=_}(window.kendo.jQuery),window.kendo},__webpack_require__(166));

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright 2014 Telerik AD
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(e,define){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(628),__webpack_require__(305)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(function(){return function(e,t){function n(t){var n=t.parseFormats,i=t.format;F.normalize(t),n=e.isArray(n)?n:[n],-1===e.inArray(i,n)&&n.splice(0,0,t.format),t.parseFormats=n}function i(e){e.preventDefault()}var o,r=window.kendo,a=r.ui,s=a.Widget,l=r.parseDate,c=r.keys,h=r.template,d=r._activeElement,u="<div />",f="<span />",p=".kendoDatePicker",g="click"+p,m="open",v="close",_="change",w="disabled",y="readonly",b="k-state-default",x="k-state-focused",k="k-state-selected",C="k-state-disabled",S="k-state-hover",T="mouseenter"+p+" mouseleave"+p,D="mousedown"+p,A="id",P="min",M="max",E="month",I="aria-disabled",B="aria-expanded",L="aria-hidden",z="aria-readonly",F=r.calendar,R=F.isInRange,O=F.restrictValue,N=F.isEqualDatePart,H=e.extend,V=e.proxy,U=Date,j=function(t){var n,i=this,o=document.body,s=e(u).attr(L,"true").addClass("k-calendar-container").appendTo(o);i.options=t=t||{},n=t.id,n&&(n+="_dateview",s.attr(A,n),i._dateViewID=n),i.popup=new a.Popup(s,H(t.popup,t,{name:"Popup",isRtl:r.support.isRtl(t.anchor)})),i.div=s,i.value(t.value)};j.prototype={_calendar:function(){var t,n=this,o=n.calendar,s=n.options;o||(t=e(u).attr(A,r.guid()).appendTo(n.popup.element).on(D,i).on(g,"td:has(.k-link)",V(n._click,n)),n.calendar=o=new a.Calendar(t),n._setOptions(s),r.calendar.makeUnselectable(o.element),o.navigate(n._value||n._current,s.start),n.value(n._value))},_setOptions:function(e){this.calendar.setOptions({focusOnNav:!1,change:e.change,culture:e.culture,dates:e.dates,depth:e.depth,footer:e.footer,format:e.format,max:e.max,min:e.min,month:e.month,start:e.start})},setOptions:function(e){var t=this.options;this.options=H(t,e,{change:t.change,close:t.close,open:t.open}),this.calendar&&this._setOptions(this.options)},destroy:function(){this.popup.destroy()},open:function(){var e=this;e._calendar(),e.popup.open()},close:function(){this.popup.close()},min:function(e){this._option(P,e)},max:function(e){this._option(M,e)},toggle:function(){var e=this;e[e.popup.visible()?v:m]()},move:function(e){var n=this,i=e.keyCode,o=n.calendar,r=e.ctrlKey&&i==c.DOWN||i==c.ENTER;if(i==c.ESC)return n.close(),t;if(e.altKey)return i==c.DOWN?(n.open(),e.preventDefault()):i==c.UP&&(n.close(),e.preventDefault()),t;if(n.popup.visible())return r&&o._cell.hasClass(k)?(n.close(),e.preventDefault(),t):(n._current=o._move(e),t)},current:function(e){this._current=e,this.calendar._focus(e)},value:function(e){var t=this,n=t.calendar,i=t.options;t._value=e,t._current=new U(+O(e,i.min,i.max)),n&&n.value(e)},_click:function(e){-1!==e.currentTarget.className.indexOf(k)&&this.close()},_option:function(e,t){var n=this,i=n.calendar;n.options[e]=t,i&&i[e](t)}},j.normalize=n,r.DateView=j,o=s.extend({init:function(e,t){var i,o,a=this;s.fn.init.call(a,e,t),e=a.element,t=a.options,t.min=l(e.attr("min"))||l(t.min),t.max=l(e.attr("max"))||l(t.max),n(t),a._wrapper(),a.dateView=new j(H({},t,{id:e.attr(A),anchor:a.wrapper,change:function(){a._change(this.value()),a.close()},close:function(t){a.trigger(v)?t.preventDefault():(e.attr(B,!1),o.attr(L,!0))},open:function(t){var n,i=a.options;a.trigger(m)?t.preventDefault():(a.element.val()!==a._oldText&&(n=l(e.val(),i.parseFormats,i.culture),a.dateView[n?"current":"value"](n)),e.attr(B,!0),o.attr(L,!1),a._updateARIA(n))}})),o=a.dateView.div,a._icon();try{e[0].setAttribute("type","text")}catch(c){e[0].type="text"}e.addClass("k-input").attr({role:"combobox","aria-expanded":!1,"aria-owns":a.dateView._dateViewID}),a._reset(),a._template(),i=e.is("[disabled]"),i?a.enable(!1):a.readonly(e.is("[readonly]")),a._old=a._update(t.value||a.element.val()),a._oldText=e.val(),r.notify(a)},events:[m,v,_],options:{name:"DatePicker",value:null,footer:"",format:"",culture:"",parseFormats:[],min:new Date(1900,0,1),max:new Date(2099,11,31),start:E,depth:E,animation:{},month:{},dates:[],ARIATemplate:'Current focused date is #=kendo.toString(data.current, "D")#'},setOptions:function(e){var t=this,i=t._value;s.fn.setOptions.call(t,e),e=t.options,e.min=l(e.min),e.max=l(e.max),n(e),t.dateView.setOptions(e),i&&(t.element.val(r.toString(i,e.format,e.culture)),t._updateARIA(i))},_editable:function(e){var t=this,n=t._dateIcon.off(p),o=t.element.off(p),r=t._inputWrapper.off(p),a=e.readonly,s=e.disable;a||s?(r.addClass(s?C:b).removeClass(s?b:C),o.attr(w,s).attr(y,a).attr(I,s).attr(z,a)):(r.addClass(b).removeClass(C).on(T,t._toggleHover),o.removeAttr(w).removeAttr(y).attr(I,!1).attr(z,!1).on("keydown"+p,V(t._keydown,t)).on("focusout"+p,V(t._blur,t)).on("focus"+p,function(){t._inputWrapper.addClass(x)}),n.on(g,V(t._click,t)).on(D,i))},readonly:function(e){this._editable({readonly:e===t?!0:e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t?!0:e)})},destroy:function(){var e=this;s.fn.destroy.call(e),e.dateView.destroy(),e.element.off(p),e._dateIcon.off(p),e._inputWrapper.off(p),e._form&&e._form.off("reset",e._resetHandler)},open:function(){this.dateView.open()},close:function(){this.dateView.close()},min:function(e){return this._option(P,e)},max:function(e){return this._option(M,e)},value:function(e){var n=this;return e===t?n._value:(n._old=n._update(e),null===n._old&&n.element.val(""),n._oldText=n.element.val(),t)},_toggleHover:function(t){e(t.currentTarget).toggleClass(S,"mouseenter"===t.type)},_blur:function(){var e=this,t=e.element.val();e.close(),t!==e._oldText&&e._change(t),e._inputWrapper.removeClass(x)},_click:function(){var e=this,t=e.element;e.dateView.toggle(),r.support.touch||t[0]===d()||t.focus()},_change:function(e){var t=this;e=t._update(e),+t._old!=+e&&(t._old=e,t._oldText=t.element.val(),t.element.trigger(_),t.trigger(_))},_keydown:function(e){var t=this,n=t.dateView,i=t.element.val();n.popup.visible()||e.keyCode!=c.ENTER||i===t._oldText?(n.move(e),t._updateARIA(n._current)):t._change(i)},_icon:function(){var t,n=this,i=n.element;t=i.next("span.k-select"),t[0]||(t=e('<span unselectable="on" class="k-select"><span unselectable="on" class="k-icon k-i-calendar">select</span></span>').insertAfter(i)),n._dateIcon=t.attr({role:"button","aria-controls":n.dateView._dateViewID})},_option:function(e,n){var i=this,o=i.options;return n===t?o[e]:(n=l(n,o.parseFormats,o.culture),n&&(o[e]=new U(+n),i.dateView[e](n)),t)},_update:function(e){var t,n=this,i=n.options,o=i.min,a=i.max,s=n._value,c=l(e,i.parseFormats,i.culture),h=null===c&&null===s||c instanceof Date&&s instanceof Date;return+c===+s&&h?(t=r.toString(c,i.format,i.culture),t!==e&&n.element.val(null===c?e:t),c):(null!==c&&N(c,o)?c=O(c,o,a):R(c,o,a)||(c=null),n._value=c,n.dateView.value(c),n.element.val(c?r.toString(c,i.format,i.culture):e),n._updateARIA(c),c)},_wrapper:function(){var t,n=this,i=n.element;t=i.parents(".k-datepicker"),t[0]||(t=i.wrap(f).parent().addClass("k-picker-wrap k-state-default"),t=t.wrap(f).parent()),t[0].style.cssText=i[0].style.cssText,i.css({width:"100%",height:i[0].style.height}),n.wrapper=t.addClass("k-widget k-datepicker k-header").addClass(i[0].className),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),o=i?e("#"+i):n.closest("form");o[0]&&(t._resetHandler=function(){t.value(n[0].defaultValue)},t._form=o.on("reset",t._resetHandler))},_template:function(){this._ariaTemplate=h(this.options.ARIATemplate)},_updateARIA:function(e){var t,n=this,i=n.dateView.calendar;n.element.removeAttr("aria-activedescendant"),i&&(t=i._cell,t.attr("aria-label",n._ariaTemplate({current:e||i.current()})),n.element.attr("aria-activedescendant",t.attr("id")))}}),a.plugin(o)}(window.kendo.jQuery),window.kendo},__webpack_require__(166));

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright 2014 Telerik AD
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!function(e,define){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(305)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(function(){return function(e,t){function n(e,t,n){var i,r=e.getTimezoneOffset();e.setTime(e.getTime()+t),n||(i=e.getTimezoneOffset()-r,e.setTime(e.getTime()+i*z))}function i(){var e=new $,t=new $(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0),n=new $(e.getFullYear(),e.getMonth(),e.getDate(),12,0,0);return-1*(t.getTimezoneOffset()-n.getTimezoneOffset())}function r(e){return 60*e.getHours()*z+e.getMinutes()*z+1e3*e.getSeconds()+e.getMilliseconds()}function o(e,t,n){var i,o=r(t),a=r(n);return e&&o!=a?(i=r(e),o>i&&(i+=B),o>a&&(a+=B),i>=o&&a>=i):!0}function a(e){var t=e.parseFormats;e.format=p(e.format||d.getCulture(e.culture).calendars.standard.patterns.t),t=j(t)?t:[t],t.splice(0,0,e.format),e.parseFormats=t}function s(e){e.preventDefault()}var l,c,d=window.kendo,u=d.keys,h=d.parseDate,f=d._activeElement,p=d._extractFormat,g=d.support,m=g.browser,v=d.ui,_=v.Widget,w="open",y="close",b="change",x=".kendoTimePicker",k="click"+x,C="k-state-default",S="disabled",T="readonly",D="li",A="<span/>",E="k-state-focused",P="k-state-hover",M="mouseenter"+x+" mouseleave"+x,I="mousedown"+x,z=6e4,B=864e5,F="k-state-selected",L="k-state-disabled",R="aria-selected",O="aria-expanded",N="aria-hidden",H="aria-disabled",V="aria-readonly",U="aria-activedescendant",W="id",j=e.isArray,G=e.extend,q=e.proxy,$=Date,Y=new $;Y=new $(Y.getFullYear(),Y.getMonth(),Y.getDate(),0,0,0),l=function(t){var n=this,i=t.id;n.options=t,n.ul=e('<ul tabindex="-1" role="listbox" aria-hidden="true" unselectable="on" class="k-list k-reset"/>').css({overflow:g.kineticScrollNeeded?"":"auto"}).on(k,D,q(n._click,n)).on("mouseenter"+x,D,function(){e(this).addClass(P)}).on("mouseleave"+x,D,function(){e(this).removeClass(P)}),n.list=e("<div class='k-list-container'/>").append(n.ul).on(I,s),i&&(n._timeViewID=i+"_timeview",n._optionID=i+"_option_selected",n.ul.attr(W,n._timeViewID)),n._popup(),n._heightHandler=q(n._height,n),n.template=d.template('<li tabindex="-1" role="option" class="k-item" unselectable="on">#=data#</li>',{useWithBlock:!1})},l.prototype={current:function(n){var i=this,r=i.options.active;return n===t?i._current:(i._current&&i._current.removeClass(F).removeAttr(R).removeAttr(W),n&&(n=e(n).addClass(F).attr(W,i._optionID).attr(R,!0),i.scroll(n[0])),i._current=n,r&&r(n),t)},close:function(){this.popup.close()},destroy:function(){var e=this;e.ul.off(x),e.list.off(x),e._touchScroller&&e._touchScroller.destroy(),e.popup.destroy()},open:function(){var e=this;e.ul[0].firstChild||e.bind(),e.popup.open(),e._current&&e.scroll(e._current[0])},dataBind:function(e){for(var t,n=this,i=n.options,r=i.format,a=d.toString,s=n.template,l=e.length,c=0,u="";l>c;c++)t=e[c],o(t,i.min,i.max)&&(u+=s(a(t,r,i.culture)));n._html(u)},refresh:function(){var e,t,o,a=this,s=a.options,l=s.format,c=i(),u=0>c,h=s.min,f=s.max,p=r(h),g=r(f),m=s.interval*z,v=d.toString,_=a.template,w=new $(+h),y=w.getDate(),b=0,x="";for(o=u?(B+c*z)/m:B/m,p!=g&&(p>g&&(g+=B),o=(g-p)/m+1),t=parseInt(o,10);o>b;b++)b&&n(w,m,u),g&&t==b&&(e=r(w),y<w.getDate()&&(e+=B),e>g&&(w=new $(+f))),x+=_(v(w,l,s.culture));a._html(x)},bind:function(){var e=this,t=e.options.dates;t&&t[0]?e.dataBind(t):e.refresh()},_html:function(e){var t=this;t.ul[0].innerHTML=e,t.popup.unbind(w,t._heightHandler),t.popup.one(w,t._heightHandler),t.current(null),t.select(t._value)},scroll:function(e){if(e){var t,n=this.ul[0],i=e.offsetTop,r=e.offsetHeight,o=n.scrollTop,a=n.clientHeight,s=i+r,l=this._touchScroller;l?(t=this.list.height(),i>t&&(i=i-t+r),l.scrollTo(0,-i)):n.scrollTop=o>i?i:s>o+a?s-a:o}},select:function(t){var n=this,i=n.options,r=n._current;t instanceof Date&&(t=d.toString(t,i.format,i.culture)),"string"==typeof t&&(r&&r.text()===t?t=r:(t=e.grep(n.ul[0].childNodes,function(e){return(e.textContent||e.innerText)==t}),t=t[0]?t:null)),n.current(t)},setOptions:function(e){var t=this.options;e.min=h(e.min),e.max=h(e.max),this.options=G(t,e,{active:t.active,change:t.change,close:t.close,open:t.open}),this.bind()},toggle:function(){var e=this;e.popup.visible()?e.close():e.open()},value:function(e){var t=this;t._value=e,t.ul[0].firstChild&&t.select(e)},_click:function(t){var n=this,i=e(t.currentTarget);t.isDefaultPrevented()||(n.select(i),n.options.change(i.text(),!0),n.close())},_height:function(){var e=this,t=e.list,n=t.parent(".k-animation-container"),i=e.options.height;e.ul[0].children.length&&t.add(n).show().height(e.ul[0].scrollHeight>i?i:"auto").hide()},_parse:function(e){var t=this,n=t.options,i=t._value||Y;return e instanceof $?e:(e=h(e,n.parseFormats,n.culture),e&&(e=new $(i.getFullYear(),i.getMonth(),i.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds())),e)},_adjustListWidth:function(){var e,t,n=this.list,i=n[0].style.width,r=this.options.anchor;(n.data("width")||!i)&&(e=window.getComputedStyle?window.getComputedStyle(r[0],null):0,t=e?parseFloat(e.width):r.outerWidth(),e&&(m.mozilla||m.msie)&&(t+=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight)+parseFloat(e.borderLeftWidth)+parseFloat(e.borderRightWidth)),i=t-(n.outerWidth()-n.width()),n.css({fontFamily:r.css("font-family"),width:i}).data("width",i))},_popup:function(){var e=this,t=e.list,n=e.options,i=n.anchor;e.popup=new v.Popup(t,G(n.popup,{anchor:i,open:n.open,close:n.close,animation:n.animation,isRtl:g.isRtl(n.anchor)})),e._touchScroller=d.touchScroller(e.popup.element)},move:function(e){var n=this,i=e.keyCode,r=n.ul[0],o=n._current,a=i===u.DOWN;if(i===u.UP||a){if(e.altKey)return n.toggle(a),t;o=a?o?o[0].nextSibling:r.firstChild:o?o[0].previousSibling:r.lastChild,o&&n.select(o),n.options.change(n._current.text()),e.preventDefault()}else(i===u.ENTER||i===u.TAB||i===u.ESC)&&(e.preventDefault(),o&&n.options.change(o.text(),!0),n.close())}},l.getMilliseconds=r,d.TimeView=l,c=_.extend({init:function(e,t){var n,i,r,o=this;_.fn.init.call(o,e,t),e=o.element,t=o.options,t.min=h(e.attr("min"))||h(t.min),t.max=h(e.attr("max"))||h(t.max),a(t),o._wrapper(),o.timeView=i=new l(G({},t,{id:e.attr(W),anchor:o.wrapper,format:t.format,change:function(t,n){n?o._change(t):e.val(t)},open:function(t){o.timeView._adjustListWidth(),o.trigger(w)?t.preventDefault():(e.attr(O,!0),n.attr(N,!1))},close:function(t){o.trigger(y)?t.preventDefault():(e.attr(O,!1),n.attr(N,!0))},active:function(t){e.removeAttr(U),t&&e.attr(U,i._optionID)}})),n=i.ul,o._icon(),o._reset();try{e[0].setAttribute("type","text")}catch(s){e[0].type="text"}e.addClass("k-input").attr({role:"combobox","aria-expanded":!1,"aria-owns":i._timeViewID}),r=e.is("[disabled]"),r?o.enable(!1):o.readonly(e.is("[readonly]")),o._old=o._update(t.value||o.element.val()),o._oldText=e.val(),d.notify(o)},options:{name:"TimePicker",min:Y,max:Y,format:"",dates:[],parseFormats:[],value:null,interval:30,height:200,animation:{}},events:[w,y,b],setOptions:function(e){var t=this,n=t._value;_.fn.setOptions.call(t,e),e=t.options,a(e),t.timeView.setOptions(e),n&&t.element.val(d.toString(n,e.format,e.culture))},dataBind:function(e){j(e)&&this.timeView.dataBind(e)},_editable:function(e){var t=this,n=e.disable,i=e.readonly,r=t._arrow.off(x),o=t.element.off(x),a=t._inputWrapper.off(x);i||n?(a.addClass(n?L:C).removeClass(n?C:L),o.attr(S,n).attr(T,i).attr(H,n).attr(V,i)):(a.addClass(C).removeClass(L).on(M,t._toggleHover),o.removeAttr(S).removeAttr(T).attr(H,!1).attr(V,!1).on("keydown"+x,q(t._keydown,t)).on("focusout"+x,q(t._blur,t)).on("focus"+x,function(){t._inputWrapper.addClass(E)}),r.on(k,q(t._click,t)).on(I,s))},readonly:function(e){this._editable({readonly:e===t?!0:e,disable:!1})},enable:function(e){this._editable({readonly:!1,disable:!(e=e===t?!0:e)})},destroy:function(){var e=this;_.fn.destroy.call(e),e.timeView.destroy(),e.element.off(x),e._arrow.off(x),e._inputWrapper.off(x),e._form&&e._form.off("reset",e._resetHandler)},close:function(){this.timeView.close()},open:function(){this.timeView.open()},min:function(e){return this._option("min",e)},max:function(e){return this._option("max",e)},value:function(e){var n=this;return e===t?n._value:(n._old=n._update(e),null===n._old&&n.element.val(""),n._oldText=n.element.val(),t)},_blur:function(){var e=this,t=e.element.val();e.close(),t!==e._oldText&&e._change(t),e._inputWrapper.removeClass(E)},_click:function(){var e=this,t=e.element;e.timeView.toggle(),g.touch||t[0]===f()||t.focus()},_change:function(e){var t=this;e=t._update(e),+t._old!=+e&&(t._old=e,t._oldText=t.element.val(),t.element.trigger(b),t.trigger(b))},_icon:function(){var t,n=this,i=n.element;t=i.next("span.k-select"),t[0]||(t=e('<span unselectable="on" class="k-select"><span unselectable="on" class="k-icon k-i-clock">select</span></span>').insertAfter(i)),n._arrow=t.attr({role:"button","aria-controls":n.timeView._timeViewID})},_keydown:function(e){var t=this,n=e.keyCode,i=t.timeView,r=t.element.val();i.popup.visible()||e.altKey?i.move(e):n===u.ENTER&&r!==t._oldText&&t._change(r)},_option:function(e,n){var i=this,r=i.options;return n===t?r[e]:(n=i.timeView._parse(n),n&&(n=new $(+n),r[e]=n,i.timeView.options[e]=n,i.timeView.bind()),t)},_toggleHover:function(t){e(t.currentTarget).toggleClass(P,"mouseenter"===t.type)},_update:function(e){var t=this,n=t.options,i=t.timeView,r=i._parse(e);return o(r,n.min,n.max)||(r=null),t._value=r,t.element.val(r?d.toString(r,n.format,n.culture):e),i.value(r),r},_wrapper:function(){var t,n=this,i=n.element;t=i.parents(".k-timepicker"),t[0]||(t=i.wrap(A).parent().addClass("k-picker-wrap k-state-default"),t=t.wrap(A).parent()),t[0].style.cssText=i[0].style.cssText,n.wrapper=t.addClass("k-widget k-timepicker k-header").addClass(i[0].className),i.css({width:"100%",height:i[0].style.height}),n._inputWrapper=e(t[0].firstChild)},_reset:function(){var t=this,n=t.element,i=n.attr("form"),r=i?e("#"+i):n.closest("form");r[0]&&(t._resetHandler=function(){t.value(n[0].defaultValue)},t._form=r.on("reset",t._resetHandler))}}),v.plugin(c)}(window.kendo.jQuery),window.kendo},__webpack_require__(166));

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
 * typeahead.js 0.10.5
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

var $ = __webpack_require__(27);

(function($) {
    var _ = function() {
        "use strict";
        return {
            isMsie: function() {
                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
            },
            isBlankString: function(str) {
                return !str || /^\s*$/.test(str);
            },
            escapeRegExChars: function(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            isString: function(obj) {
                return typeof obj === "string";
            },
            isNumber: function(obj) {
                return typeof obj === "number";
            },
            isArray: $.isArray,
            isFunction: $.isFunction,
            isObject: $.isPlainObject,
            isUndefined: function(obj) {
                return typeof obj === "undefined";
            },
            toStr: function toStr(s) {
                return _.isUndefined(s) || s === null ? "" : s + "";
            },
            bind: $.proxy,
            each: function(collection, cb) {
                $.each(collection, reverseArgs);
                function reverseArgs(index, value) {
                    return cb(value, index);
                }
            },
            map: $.map,
            filter: $.grep,
            every: function(obj, test) {
                var result = true;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (!(result = test.call(null, val, key, obj))) {
                        return false;
                    }
                });
                return !!result;
            },
            some: function(obj, test) {
                var result = false;
                if (!obj) {
                    return result;
                }
                $.each(obj, function(key, val) {
                    if (result = test.call(null, val, key, obj)) {
                        return false;
                    }
                });
                return !!result;
            },
            mixin: $.extend,
            getUniqueId: function() {
                var counter = 0;
                return function() {
                    return counter++;
                };
            }(),
            templatify: function templatify(obj) {
                return $.isFunction(obj) ? obj : template;
                function template() {
                    return String(obj);
                }
            },
            defer: function(fn) {
                setTimeout(fn, 0);
            },
            debounce: function(func, wait, immediate) {
                var timeout, result;
                return function() {
                    var context = this, args = arguments, later, callNow;
                    later = function() {
                        timeout = null;
                        if (!immediate) {
                            result = func.apply(context, args);
                        }
                    };
                    callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        result = func.apply(context, args);
                    }
                    return result;
                };
            },
            throttle: function(func, wait) {
                var context, args, timeout, result, previous, later;
                previous = 0;
                later = function() {
                    previous = new Date();
                    timeout = null;
                    result = func.apply(context, args);
                };
                return function() {
                    var now = new Date(), remaining = wait - (now - previous);
                    context = this;
                    args = arguments;
                    if (remaining <= 0) {
                        clearTimeout(timeout);
                        timeout = null;
                        previous = now;
                        result = func.apply(context, args);
                    } else if (!timeout) {
                        timeout = setTimeout(later, remaining);
                    }
                    return result;
                };
            },
            noop: function() {}
        };
    }();
    var html = function() {
        return {
            wrapper: '<span class="twitter-typeahead"></span>',
            dropdown: '<span class="tt-dropdown-menu"></span>',
            dataset: '<div class="tt-dataset-%CLASS%"></div>',
            suggestions: '<span class="tt-suggestions"></span>',
            suggestion: '<div class="tt-suggestion"></div>'
        };
    }();
    var css = function() {
        "use strict";
        var css = {
            wrapper: {
                position: "relative",
                display: "inline-block"
            },
            hint: {
                position: "absolute",
                top: "0",
                left: "0",
                borderColor: "transparent",
                boxShadow: "none",
                opacity: "1"
            },
            input: {
                position: "relative",
                verticalAlign: "top",
                backgroundColor: "transparent"
            },
            inputWithNoHint: {
                position: "relative",
                verticalAlign: "top"
            },
            dropdown: {
                position: "absolute",
                top: "100%",
                left: "0",
                zIndex: "100",
                display: "none"
            },
            suggestions: {
                display: "block"
            },
            suggestion: {
                whiteSpace: "nowrap",
                cursor: "pointer"
            },
            suggestionChild: {
                whiteSpace: "normal"
            },
            ltr: {
                left: "0",
                right: "auto"
            },
            rtl: {
                left: "auto",
                right: " 0"
            }
        };
        if (_.isMsie()) {
            _.mixin(css.input, {
                backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
            });
        }
        if (_.isMsie() && _.isMsie() <= 7) {
            _.mixin(css.input, {
                marginTop: "-1px"
            });
        }
        return css;
    }();
    var EventBus = function() {
        "use strict";
        var namespace = "typeahead:";
        function EventBus(o) {
            if (!o || !o.el) {
                $.error("EventBus initialized without el");
            }
            this.$el = $(o.el);
        }
        _.mixin(EventBus.prototype, {
            trigger: function(type) {
                var args = [].slice.call(arguments, 1);
                this.$el.trigger(namespace + type, args);
            }
        });
        return EventBus;
    }();
    var EventEmitter = function() {
        "use strict";
        var splitter = /\s+/, nextTick = getNextTick();
        return {
            onSync: onSync,
            onAsync: onAsync,
            off: off,
            trigger: trigger
        };
        function on(method, types, cb, context) {
            var type;
            if (!cb) {
                return this;
            }
            types = types.split(splitter);
            cb = context ? bindContext(cb, context) : cb;
            this._callbacks = this._callbacks || {};
            while (type = types.shift()) {
                this._callbacks[type] = this._callbacks[type] || {
                    sync: [],
                    async: []
                };
                this._callbacks[type][method].push(cb);
            }
            return this;
        }
        function onAsync(types, cb, context) {
            return on.call(this, "async", types, cb, context);
        }
        function onSync(types, cb, context) {
            return on.call(this, "sync", types, cb, context);
        }
        function off(types) {
            var type;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            while (type = types.shift()) {
                delete this._callbacks[type];
            }
            return this;
        }
        function trigger(types) {
            var type, callbacks, args, syncFlush, asyncFlush;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            args = [].slice.call(arguments, 1);
            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
                syncFlush() && nextTick(asyncFlush);
            }
            return this;
        }
        function getFlush(callbacks, context, args) {
            return flush;
            function flush() {
                var cancelled;
                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
                    cancelled = callbacks[i].apply(context, args) === false;
                }
                return !cancelled;
            }
        }
        function getNextTick() {
            var nextTickFn;
            if (window.setImmediate) {
                nextTickFn = function nextTickSetImmediate(fn) {
                    setImmediate(function() {
                        fn();
                    });
                };
            } else {
                nextTickFn = function nextTickSetTimeout(fn) {
                    setTimeout(function() {
                        fn();
                    }, 0);
                };
            }
            return nextTickFn;
        }
        function bindContext(fn, context) {
            return fn.bind ? fn.bind(context) : function() {
                fn.apply(context, [].slice.call(arguments, 0));
            };
        }
    }();
    var highlight = function(doc) {
        "use strict";
        var defaults = {
            node: null,
            pattern: null,
            tagName: "strong",
            className: null,
            wordsOnly: false,
            caseSensitive: false
        };
        return function hightlight(o) {
            var regex;
            o = _.mixin({}, defaults, o);
            if (!o.node || !o.pattern) {
                return;
            }
            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
            traverse(o.node, hightlightTextNode);
            function hightlightTextNode(textNode) {
                var match, patternNode, wrapperNode;
                if (match = regex.exec(textNode.data)) {
                    wrapperNode = doc.createElement(o.tagName);
                    o.className && (wrapperNode.className = o.className);
                    patternNode = textNode.splitText(match.index);
                    patternNode.splitText(match[0].length);
                    wrapperNode.appendChild(patternNode.cloneNode(true));
                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
                }
                return !!match;
            }
            function traverse(el, hightlightTextNode) {
                var childNode, TEXT_NODE_TYPE = 3;
                for (var i = 0; i < el.childNodes.length; i++) {
                    childNode = el.childNodes[i];
                    if (childNode.nodeType === TEXT_NODE_TYPE) {
                        i += hightlightTextNode(childNode) ? 1 : 0;
                    } else {
                        traverse(childNode, hightlightTextNode);
                    }
                }
            }
        };
        function getRegex(patterns, caseSensitive, wordsOnly) {
            var escapedPatterns = [], regexStr;
            for (var i = 0, len = patterns.length; i < len; i++) {
                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
            }
            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
        }
    }(window.document);
    var Input = function() {
        "use strict";
        var specialKeyCodeMap;
        specialKeyCodeMap = {
            9: "tab",
            27: "esc",
            37: "left",
            39: "right",
            13: "enter",
            38: "up",
            40: "down"
        };
        function Input(o) {
            var that = this, onBlur, onFocus, onKeydown, onInput;
            o = o || {};
            if (!o.input) {
                $.error("input is missing");
            }
            onBlur = _.bind(this._onBlur, this);
            onFocus = _.bind(this._onFocus, this);
            onKeydown = _.bind(this._onKeydown, this);
            onInput = _.bind(this._onInput, this);
            this.$hint = $(o.hint);
            this.$input = $(o.input).on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
            if (this.$hint.length === 0) {
                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
            }
            if (!_.isMsie()) {
                this.$input.on("input.tt", onInput);
            } else {
                this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
                    if (specialKeyCodeMap[$e.which || $e.keyCode]) {
                        return;
                    }
                    _.defer(_.bind(that._onInput, that, $e));
                });
            }
            this.query = this.$input.val();
            this.$overflowHelper = buildOverflowHelper(this.$input);
        }
        Input.normalizeQuery = function(str) {
            return (str || "").replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
        };
        _.mixin(Input.prototype, EventEmitter, {
            _onBlur: function onBlur() {
                this.resetInputValue();
                this.trigger("blurred");
            },
            _onFocus: function onFocus() {
                this.trigger("focused");
            },
            _onKeydown: function onKeydown($e) {
                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
                this._managePreventDefault(keyName, $e);
                if (keyName && this._shouldTrigger(keyName, $e)) {
                    this.trigger(keyName + "Keyed", $e);
                }
            },
            _onInput: function onInput() {
                this._checkInputValue();
            },
            _managePreventDefault: function managePreventDefault(keyName, $e) {
                var preventDefault, hintValue, inputValue;
                switch (keyName) {
                  case "tab":
                    hintValue = this.getHint();
                    inputValue = this.getInputValue();
                    preventDefault = hintValue && hintValue !== inputValue && !withModifier($e);
                    break;

                  case "up":
                  case "down":
                    preventDefault = !withModifier($e);
                    break;

                  default:
                    preventDefault = false;
                }
                preventDefault && $e.preventDefault();
            },
            _shouldTrigger: function shouldTrigger(keyName, $e) {
                var trigger;
                switch (keyName) {
                  case "tab":
                    trigger = !withModifier($e);
                    break;

                  default:
                    trigger = true;
                }
                return trigger;
            },
            _checkInputValue: function checkInputValue() {
                var inputValue, areEquivalent, hasDifferentWhitespace;
                inputValue = this.getInputValue();
                areEquivalent = areQueriesEquivalent(inputValue, this.query);
                hasDifferentWhitespace = areEquivalent ? this.query.length !== inputValue.length : false;
                this.query = inputValue;
                if (!areEquivalent) {
                    this.trigger("queryChanged", this.query);
                } else if (hasDifferentWhitespace) {
                    this.trigger("whitespaceChanged", this.query);
                }
            },
            focus: function focus() {
                this.$input.focus();
            },
            blur: function blur() {
                this.$input.blur();
            },
            getQuery: function getQuery() {
                return this.query;
            },
            setQuery: function setQuery(query) {
                this.query = query;
            },
            getInputValue: function getInputValue() {
                return this.$input.val();
            },
            setInputValue: function setInputValue(value, silent) {
                this.$input.val(value);
                silent ? this.clearHint() : this._checkInputValue();
            },
            resetInputValue: function resetInputValue() {
                this.setInputValue(this.query, true);
            },
            getHint: function getHint() {
                return this.$hint.val();
            },
            setHint: function setHint(value) {
                this.$hint.val(value);
            },
            clearHint: function clearHint() {
                this.setHint("");
            },
            clearHintIfInvalid: function clearHintIfInvalid() {
                var val, hint, valIsPrefixOfHint, isValid;
                val = this.getInputValue();
                hint = this.getHint();
                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
                !isValid && this.clearHint();
            },
            getLanguageDirection: function getLanguageDirection() {
                return (this.$input.css("direction") || "ltr").toLowerCase();
            },
            hasOverflow: function hasOverflow() {
                var constraint = this.$input.width() - 2;
                this.$overflowHelper.text(this.getInputValue());
                return this.$overflowHelper.width() >= constraint;
            },
            isCursorAtEnd: function() {
                var valueLength, selectionStart, range;
                valueLength = this.$input.val().length;
                selectionStart = this.$input[0].selectionStart;
                if (_.isNumber(selectionStart)) {
                    return selectionStart === valueLength;
                } else if (document.selection) {
                    range = document.selection.createRange();
                    range.moveStart("character", -valueLength);
                    return valueLength === range.text.length;
                }
                return true;
            },
            destroy: function destroy() {
                this.$hint.off(".tt");
                this.$input.off(".tt");
                this.$hint = this.$input = this.$overflowHelper = null;
            }
        });
        return Input;
        function buildOverflowHelper($input) {
            return $('<pre aria-hidden="true"></pre>').css({
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "pre",
                fontFamily: $input.css("font-family"),
                fontSize: $input.css("font-size"),
                fontStyle: $input.css("font-style"),
                fontVariant: $input.css("font-variant"),
                fontWeight: $input.css("font-weight"),
                wordSpacing: $input.css("word-spacing"),
                letterSpacing: $input.css("letter-spacing"),
                textIndent: $input.css("text-indent"),
                textRendering: $input.css("text-rendering"),
                textTransform: $input.css("text-transform")
            }).insertAfter($input);
        }
        function areQueriesEquivalent(a, b) {
            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
        }
        function withModifier($e) {
            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
        }
    }();
    var Dataset = function() {
        "use strict";
        var datasetKey = "ttDataset", valueKey = "ttValue", datumKey = "ttDatum";
        function Dataset(o) {
            o = o || {};
            o.templates = o.templates || {};
            if (!o.source) {
                $.error("missing source");
            }
            if (o.name && !isValidName(o.name)) {
                $.error("invalid dataset name: " + o.name);
            }
            this.query = null;
            this.highlight = !!o.highlight;
            this.name = o.name || _.getUniqueId();
            this.source = o.source;
            this.displayFn = getDisplayFn(o.display || o.displayKey);
            this.templates = getTemplates(o.templates, this.displayFn);
            this.$el = $(html.dataset.replace("%CLASS%", this.name));
        }
        Dataset.extractDatasetName = function extractDatasetName(el) {
            return $(el).data(datasetKey);
        };
        Dataset.extractValue = function extractDatum(el) {
            return $(el).data(valueKey);
        };
        Dataset.extractDatum = function extractDatum(el) {
            return $(el).data(datumKey);
        };
        _.mixin(Dataset.prototype, EventEmitter, {
            _render: function render(query, suggestions) {
                if (!this.$el) {
                    return;
                }
                var that = this, hasSuggestions;
                this.$el.empty();
                hasSuggestions = suggestions && suggestions.length;
                if (!hasSuggestions && this.templates.empty) {
                    this.$el.html(getEmptyHtml()).prepend(that.templates.header ? getHeaderHtml() : null).append(that.templates.footer ? getFooterHtml() : null);
                } else if (hasSuggestions) {
                    this.$el.html(getSuggestionsHtml()).prepend(that.templates.header ? getHeaderHtml() : null).append(that.templates.footer ? getFooterHtml() : null);
                }
                this.trigger("rendered");
                function getEmptyHtml() {
                    return that.templates.empty({
                        query: query,
                        isEmpty: true
                    });
                }
                function getSuggestionsHtml() {
                    var $suggestions, nodes;
                    $suggestions = $(html.suggestions).css(css.suggestions);
                    nodes = _.map(suggestions, getSuggestionNode);
                    $suggestions.append.apply($suggestions, nodes);
                    that.highlight && highlight({
                        className: "tt-highlight",
                        node: $suggestions[0],
                        pattern: query
                    });
                    return $suggestions;
                    function getSuggestionNode(suggestion) {
                        var $el;
                        $el = $(html.suggestion).append(that.templates.suggestion(suggestion)).data(datasetKey, that.name).data(valueKey, that.displayFn(suggestion)).data(datumKey, suggestion);
                        $el.children().each(function() {
                            $(this).css(css.suggestionChild);
                        });
                        return $el;
                    }
                }
                function getHeaderHtml() {
                    return that.templates.header({
                        query: query,
                        isEmpty: !hasSuggestions
                    });
                }
                function getFooterHtml() {
                    return that.templates.footer({
                        query: query,
                        isEmpty: !hasSuggestions
                    });
                }
            },
            getRoot: function getRoot() {
                return this.$el;
            },
            update: function update(query) {
                var that = this;
                this.query = query;
                this.canceled = false;
                this.source(query, render);
                function render(suggestions) {
                    if (!that.canceled && query === that.query) {
                        that._render(query, suggestions);
                    }
                }
            },
            cancel: function cancel() {
                this.canceled = true;
            },
            clear: function clear() {
                this.cancel();
                this.$el.empty();
                this.trigger("rendered");
            },
            isEmpty: function isEmpty() {
                return this.$el.is(":empty");
            },
            destroy: function destroy() {
                this.$el = null;
            }
        });
        return Dataset;
        function getDisplayFn(display) {
            display = display || "value";
            return _.isFunction(display) ? display : displayFn;
            function displayFn(obj) {
                return obj[display];
            }
        }
        function getTemplates(templates, displayFn) {
            return {
                empty: templates.empty && _.templatify(templates.empty),
                header: templates.header && _.templatify(templates.header),
                footer: templates.footer && _.templatify(templates.footer),
                suggestion: templates.suggestion || suggestionTemplate
            };
            function suggestionTemplate(context) {
                return "<p>" + displayFn(context) + "</p>";
            }
        }
        function isValidName(str) {
            return /^[_a-zA-Z0-9-]+$/.test(str);
        }
    }();
    var Dropdown = function() {
        "use strict";
        function Dropdown(o) {
            var that = this, onSuggestionClick, onSuggestionMouseEnter, onSuggestionMouseLeave;
            o = o || {};
            if (!o.menu) {
                $.error("menu is required");
            }
            this.isOpen = false;
            this.isEmpty = true;
            this.datasets = _.map(o.datasets, initializeDataset);
            onSuggestionClick = _.bind(this._onSuggestionClick, this);
            onSuggestionMouseEnter = _.bind(this._onSuggestionMouseEnter, this);
            onSuggestionMouseLeave = _.bind(this._onSuggestionMouseLeave, this);
            this.$menu = $(o.menu).on("click.tt", ".tt-suggestion", onSuggestionClick).on("mouseenter.tt", ".tt-suggestion", onSuggestionMouseEnter).on("mouseleave.tt", ".tt-suggestion", onSuggestionMouseLeave);
            _.each(this.datasets, function(dataset) {
                that.$menu.append(dataset.getRoot());
                dataset.onSync("rendered", that._onRendered, that);
            });
        }
        _.mixin(Dropdown.prototype, EventEmitter, {
            _onSuggestionClick: function onSuggestionClick($e) {
                this.trigger("suggestionClicked", $($e.currentTarget));
            },
            _onSuggestionMouseEnter: function onSuggestionMouseEnter($e) {
                this._removeCursor();
                this._setCursor($($e.currentTarget), true);
            },
            _onSuggestionMouseLeave: function onSuggestionMouseLeave() {
                this._removeCursor();
            },
            _onRendered: function onRendered() {
                this.isEmpty = _.every(this.datasets, isDatasetEmpty);
                this.isEmpty ? this._hide() : this.isOpen && this._show();
                this.trigger("datasetRendered");
                function isDatasetEmpty(dataset) {
                    return dataset.isEmpty();
                }
            },
            _hide: function() {
                this.$menu.hide();
            },
            _show: function() {
                this.$menu.css("display", "block");
            },
            _getSuggestions: function getSuggestions() {
                return this.$menu.find(".tt-suggestion");
            },
            _getCursor: function getCursor() {
                return this.$menu.find(".tt-cursor").first();
            },
            _setCursor: function setCursor($el, silent) {
                $el.first().addClass("tt-cursor");
                !silent && this.trigger("cursorMoved");
            },
            _removeCursor: function removeCursor() {
                this._getCursor().removeClass("tt-cursor");
            },
            _moveCursor: function moveCursor(increment) {
                var $suggestions, $oldCursor, newCursorIndex, $newCursor;
                if (!this.isOpen) {
                    return;
                }
                $oldCursor = this._getCursor();
                $suggestions = this._getSuggestions();
                this._removeCursor();
                newCursorIndex = $suggestions.index($oldCursor) + increment;
                newCursorIndex = (newCursorIndex + 1) % ($suggestions.length + 1) - 1;
                if (newCursorIndex === -1) {
                    this.trigger("cursorRemoved");
                    return;
                } else if (newCursorIndex < -1) {
                    newCursorIndex = $suggestions.length - 1;
                }
                this._setCursor($newCursor = $suggestions.eq(newCursorIndex));
                this._ensureVisible($newCursor);
            },
            _ensureVisible: function ensureVisible($el) {
                var elTop, elBottom, menuScrollTop, menuHeight;
                elTop = $el.position().top;
                elBottom = elTop + $el.outerHeight(true);
                menuScrollTop = this.$menu.scrollTop();
                menuHeight = this.$menu.height() + parseInt(this.$menu.css("paddingTop"), 10) + parseInt(this.$menu.css("paddingBottom"), 10);
                if (elTop < 0) {
                    this.$menu.scrollTop(menuScrollTop + elTop);
                } else if (menuHeight < elBottom) {
                    this.$menu.scrollTop(menuScrollTop + (elBottom - menuHeight));
                }
            },
            close: function close() {
                if (this.isOpen) {
                    this.isOpen = false;
                    this._removeCursor();
                    this._hide();
                    this.trigger("closed");
                }
            },
            open: function open() {
                if (!this.isOpen) {
                    this.isOpen = true;
                    !this.isEmpty && this._show();
                    this.trigger("opened");
                }
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$menu.css(dir === "ltr" ? css.ltr : css.rtl);
            },
            moveCursorUp: function moveCursorUp() {
                this._moveCursor(-1);
            },
            moveCursorDown: function moveCursorDown() {
                this._moveCursor(+1);
            },
            getDatumForSuggestion: function getDatumForSuggestion($el) {
                var datum = null;
                if ($el.length) {
                    datum = {
                        raw: Dataset.extractDatum($el),
                        value: Dataset.extractValue($el),
                        datasetName: Dataset.extractDatasetName($el)
                    };
                }
                return datum;
            },
            getDatumForCursor: function getDatumForCursor() {
                return this.getDatumForSuggestion(this._getCursor().first());
            },
            getDatumForTopSuggestion: function getDatumForTopSuggestion() {
                return this.getDatumForSuggestion(this._getSuggestions().first());
            },
            update: function update(query) {
                _.each(this.datasets, updateDataset);
                function updateDataset(dataset) {
                    dataset.update(query);
                }
            },
            empty: function empty() {
                _.each(this.datasets, clearDataset);
                this.isEmpty = true;
                function clearDataset(dataset) {
                    dataset.clear();
                }
            },
            isVisible: function isVisible() {
                return this.isOpen && !this.isEmpty;
            },
            destroy: function destroy() {
                this.$menu.off(".tt");
                this.$menu = null;
                _.each(this.datasets, destroyDataset);
                function destroyDataset(dataset) {
                    dataset.destroy();
                }
            }
        });
        return Dropdown;
        function initializeDataset(oDataset) {
            return new Dataset(oDataset);
        }
    }();
    var Typeahead = function() {
        "use strict";
        var attrsKey = "ttAttrs";
        function Typeahead(o) {
            var $menu, $input, $hint;
            o = o || {};
            if (!o.input) {
                $.error("missing input");
            }
            this.isActivated = false;
            this.autoselect = !!o.autoselect;
            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
            this.$node = buildDom(o.input, o.withHint);
            $menu = this.$node.find(".tt-dropdown-menu");
            $input = this.$node.find(".tt-input");
            $hint = this.$node.find(".tt-hint");
            $input.on("blur.tt", function($e) {
                var active, isActive, hasActive;
                active = document.activeElement;
                isActive = $menu.is(active);
                hasActive = $menu.has(active).length > 0;
                if (_.isMsie() && (isActive || hasActive)) {
                    $e.preventDefault();
                    $e.stopImmediatePropagation();
                    _.defer(function() {
                        $input.focus();
                    });
                }
            });
            $menu.on("mousedown.tt", function($e) {
                $e.preventDefault();
            });
            this.eventBus = o.eventBus || new EventBus({
                el: $input
            });
            this.dropdown = new Dropdown({
                menu: $menu,
                datasets: o.datasets
            }).onSync("suggestionClicked", this._onSuggestionClicked, this).onSync("cursorMoved", this._onCursorMoved, this).onSync("cursorRemoved", this._onCursorRemoved, this).onSync("opened", this._onOpened, this).onSync("closed", this._onClosed, this).onAsync("datasetRendered", this._onDatasetRendered, this);
            this.input = new Input({
                input: $input,
                hint: $hint
            }).onSync("focused", this._onFocused, this).onSync("blurred", this._onBlurred, this).onSync("enterKeyed", this._onEnterKeyed, this).onSync("tabKeyed", this._onTabKeyed, this).onSync("escKeyed", this._onEscKeyed, this).onSync("upKeyed", this._onUpKeyed, this).onSync("downKeyed", this._onDownKeyed, this).onSync("leftKeyed", this._onLeftKeyed, this).onSync("rightKeyed", this._onRightKeyed, this).onSync("queryChanged", this._onQueryChanged, this).onSync("whitespaceChanged", this._onWhitespaceChanged, this);
            this._setLanguageDirection();
        }
        _.mixin(Typeahead.prototype, {
            _onSuggestionClicked: function onSuggestionClicked(type, $el) {
                var datum;
                if (datum = this.dropdown.getDatumForSuggestion($el)) {
                    this._select(datum);
                }
            },
            _onCursorMoved: function onCursorMoved() {
                var datum = this.dropdown.getDatumForCursor();
                this.input.setInputValue(datum.value, true);
                this.eventBus.trigger("cursorchanged", datum.raw, datum.datasetName);
            },
            _onCursorRemoved: function onCursorRemoved() {
                this.input.resetInputValue();
                this._updateHint();
            },
            _onDatasetRendered: function onDatasetRendered() {
                this._updateHint();
            },
            _onOpened: function onOpened() {
                this._updateHint();
                this.eventBus.trigger("opened");
            },
            _onClosed: function onClosed() {
                this.input.clearHint();
                this.eventBus.trigger("closed");
            },
            _onFocused: function onFocused() {
                this.isActivated = true;
                this.dropdown.open();
            },
            _onBlurred: function onBlurred() {
                this.isActivated = false;
                this.dropdown.empty();
                this.dropdown.close();
            },
            _onEnterKeyed: function onEnterKeyed(type, $e) {
                var cursorDatum, topSuggestionDatum;
                cursorDatum = this.dropdown.getDatumForCursor();
                topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
                if (cursorDatum) {
                    this._select(cursorDatum);
                    $e.preventDefault();
                } else if (this.autoselect && topSuggestionDatum) {
                    this._select(topSuggestionDatum);
                    $e.preventDefault();
                }
            },
            _onTabKeyed: function onTabKeyed(type, $e) {
                var datum;
                if (datum = this.dropdown.getDatumForCursor()) {
                    this._select(datum);
                    $e.preventDefault();
                } else {
                    this._autocomplete(true);
                }
            },
            _onEscKeyed: function onEscKeyed() {
                this.dropdown.close();
                this.input.resetInputValue();
            },
            _onUpKeyed: function onUpKeyed() {
                var query = this.input.getQuery();
                this.dropdown.isEmpty && query.length >= this.minLength ? this.dropdown.update(query) : this.dropdown.moveCursorUp();
                this.dropdown.open();
            },
            _onDownKeyed: function onDownKeyed() {
                var query = this.input.getQuery();
                this.dropdown.isEmpty && query.length >= this.minLength ? this.dropdown.update(query) : this.dropdown.moveCursorDown();
                this.dropdown.open();
            },
            _onLeftKeyed: function onLeftKeyed() {
                this.dir === "rtl" && this._autocomplete();
            },
            _onRightKeyed: function onRightKeyed() {
                this.dir === "ltr" && this._autocomplete();
            },
            _onQueryChanged: function onQueryChanged(e, query) {
                this.input.clearHintIfInvalid();
                query.length >= this.minLength ? this.dropdown.update(query) : this.dropdown.empty();
                this.dropdown.open();
                this._setLanguageDirection();
            },
            _onWhitespaceChanged: function onWhitespaceChanged() {
                this._updateHint();
                this.dropdown.open();
            },
            _setLanguageDirection: function setLanguageDirection() {
                var dir;
                if (this.dir !== (dir = this.input.getLanguageDirection())) {
                    this.dir = dir;
                    this.$node.css("direction", dir);
                    this.dropdown.setLanguageDirection(dir);
                }
            },
            _updateHint: function updateHint() {
                var datum, val, query, escapedQuery, frontMatchRegEx, match;
                datum = this.dropdown.getDatumForTopSuggestion();
                if (datum && this.dropdown.isVisible() && !this.input.hasOverflow()) {
                    val = this.input.getInputValue();
                    query = Input.normalizeQuery(val);
                    escapedQuery = _.escapeRegExChars(query);
                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
                    match = frontMatchRegEx.exec(datum.value);
                    match ? this.input.setHint(val + match[1]) : this.input.clearHint();
                } else {
                    this.input.clearHint();
                }
            },
            _autocomplete: function autocomplete(laxCursor) {
                var hint, query, isCursorAtEnd, datum;
                hint = this.input.getHint();
                query = this.input.getQuery();
                isCursorAtEnd = laxCursor || this.input.isCursorAtEnd();
                if (hint && query !== hint && isCursorAtEnd) {
                    datum = this.dropdown.getDatumForTopSuggestion();
                    datum && this.input.setInputValue(datum.value);
                    this.eventBus.trigger("autocompleted", datum.raw, datum.datasetName);
                }
            },
            _select: function select(datum) {
                this.input.setQuery(datum.value);
                this.input.setInputValue(datum.value, true);
                this._setLanguageDirection();
                this.eventBus.trigger("selected", datum.raw, datum.datasetName);
                this.dropdown.close();
                _.defer(_.bind(this.dropdown.empty, this.dropdown));
            },
            open: function open() {
                this.dropdown.open();
            },
            close: function close() {
                this.dropdown.close();
            },
            setVal: function setVal(val) {
                val = _.toStr(val);
                if (this.isActivated) {
                    this.input.setInputValue(val);
                } else {
                    this.input.setQuery(val);
                    this.input.setInputValue(val, true);
                }
                this._setLanguageDirection();
            },
            getVal: function getVal() {
                return this.input.getQuery();
            },
            destroy: function destroy() {
                this.input.destroy();
                this.dropdown.destroy();
                destroyDomStructure(this.$node);
                this.$node = null;
            }
        });
        return Typeahead;
        function buildDom(input, withHint) {
            var $input, $wrapper, $dropdown, $hint;
            $input = $(input);
            $wrapper = $(html.wrapper).css(css.wrapper);
            $dropdown = $(html.dropdown).css(css.dropdown);
            $hint = $input.clone().css(css.hint).css(getBackgroundStyles($input));
            $hint.val("").removeData().addClass("tt-hint").removeAttr("id name placeholder required").prop("readonly", true).attr({
                autocomplete: "off",
                spellcheck: "false",
                tabindex: -1
            });
            $input.data(attrsKey, {
                dir: $input.attr("dir"),
                autocomplete: $input.attr("autocomplete"),
                spellcheck: $input.attr("spellcheck"),
                style: $input.attr("style")
            });
            $input.addClass("tt-input").attr({
                autocomplete: "off",
                spellcheck: false
            }).css(withHint ? css.input : css.inputWithNoHint);
            try {
                !$input.attr("dir") && $input.attr("dir", "auto");
            } catch (e) {}
            return $input.wrap($wrapper).parent().prepend(withHint ? $hint : null).append($dropdown);
        }
        function getBackgroundStyles($el) {
            return {
                backgroundAttachment: $el.css("background-attachment"),
                backgroundClip: $el.css("background-clip"),
                backgroundColor: $el.css("background-color"),
                backgroundImage: $el.css("background-image"),
                backgroundOrigin: $el.css("background-origin"),
                backgroundPosition: $el.css("background-position"),
                backgroundRepeat: $el.css("background-repeat"),
                backgroundSize: $el.css("background-size")
            };
        }
        function destroyDomStructure($node) {
            var $input = $node.find(".tt-input");
            _.each($input.data(attrsKey), function(val, key) {
                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
            });
            $input.detach().removeData(attrsKey).removeClass("tt-input").insertAfter($node);
            $node.remove();
        }
    }();
    (function() {
        "use strict";
        var old, typeaheadKey, methods;
        old = $.fn.typeahead;
        typeaheadKey = "ttTypeahead";
        methods = {
            initialize: function initialize(o, datasets) {
                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
                o = o || {};
                return this.each(attach);
                function attach() {
                    var $input = $(this), eventBus, typeahead;
                    _.each(datasets, function(d) {
                        d.highlight = !!o.highlight;
                    });
                    typeahead = new Typeahead({
                        input: $input,
                        eventBus: eventBus = new EventBus({
                            el: $input
                        }),
                        withHint: _.isUndefined(o.hint) ? true : !!o.hint,
                        minLength: o.minLength,
                        autoselect: o.autoselect,
                        datasets: datasets
                    });
                    $input.data(typeaheadKey, typeahead);
                }
            },
            open: function open() {
                return this.each(openTypeahead);
                function openTypeahead() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.open();
                    }
                }
            },
            close: function close() {
                return this.each(closeTypeahead);
                function closeTypeahead() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.close();
                    }
                }
            },
            val: function val(newVal) {
                return !arguments.length ? getVal(this.first()) : this.each(setVal);
                function setVal() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.setVal(newVal);
                    }
                }
                function getVal($input) {
                    var typeahead, query;
                    if (typeahead = $input.data(typeaheadKey)) {
                        query = typeahead.getVal();
                    }
                    return query;
                }
            },
            destroy: function destroy() {
                return this.each(unattach);
                function unattach() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.destroy();
                        $input.removeData(typeaheadKey);
                    }
                }
            }
        };
        $.fn.typeahead = function(method) {
            var tts;
            if (methods[method] && method !== "initialize") {
                tts = this.filter(function() {
                    return !!$(this).data(typeaheadKey);
                });
                return methods[method].apply(tts, [].slice.call(arguments, 1));
            } else {
                return methods.initialize.apply(this, arguments);
            }
        };
        $.fn.typeahead.noConflict = function noConflict() {
            $.fn.typeahead = old;
            return this;
        };
    })();
})($);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(493).setImmediate))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(644)
__webpack_require__(634)
__webpack_require__(635)
__webpack_require__(636)
__webpack_require__(637)
__webpack_require__(638)
__webpack_require__(639)
__webpack_require__(643)
__webpack_require__(640)
__webpack_require__(641)
__webpack_require__(642)
__webpack_require__(633)

/***/ }),
/* 633 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),
/* 634 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);


/***/ }),
/* 635 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);


/***/ }),
/* 636 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var isArray = __webpack_require__(171);
var SPECIES = __webpack_require__(24)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(19);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(65);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(73);
var gOPS = __webpack_require__(177);
var pIE = __webpack_require__(140);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(73);
var toIObject = __webpack_require__(43);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),
/* 650 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(44);
var $export = __webpack_require__(5);
var partial = __webpack_require__(328);
// https://esdiscuss.org/topic/promise-returning-delay-function
$export($export.G + $export.F, {
  delay: function delay(time) {
    return new (core.Promise || global.Promise)(function (resolve) {
      setTimeout(partial.call(resolve, true), time);
    });
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(53);
var $export = __webpack_require__(5);
var createDesc = __webpack_require__(85);
var assign = __webpack_require__(226);
var create = __webpack_require__(72);
var getPrototypeOf = __webpack_require__(49);
var getKeys = __webpack_require__(73);
var dP = __webpack_require__(26);
var keyOf = __webpack_require__(649);
var aFunction = __webpack_require__(39);
var forOf = __webpack_require__(83);
var isIterable = __webpack_require__(335);
var $iterCreate = __webpack_require__(173);
var step = __webpack_require__(221);
var isObject = __webpack_require__(18);
var toIObject = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(30);
var has = __webpack_require__(45);

// 0 -> Dict.forEach
// 1 -> Dict.map
// 2 -> Dict.filter
// 3 -> Dict.some
// 4 -> Dict.every
// 5 -> Dict.find
// 6 -> Dict.findKey
// 7 -> Dict.mapPairs
var createDictMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_EVERY = TYPE == 4;
  return function (object, callbackfn, that /* = undefined */) {
    var f = ctx(callbackfn, that, 3);
    var O = toIObject(object);
    var result = IS_MAP || TYPE == 7 || TYPE == 2
          ? new (typeof this == 'function' ? this : Dict)() : undefined;
    var key, val, res;
    for (key in O) if (has(O, key)) {
      val = O[key];
      res = f(val, key, object);
      if (TYPE) {
        if (IS_MAP) result[key] = res;          // map
        else if (res) switch (TYPE) {
          case 2: result[key] = val; break;     // filter
          case 3: return true;                  // some
          case 5: return val;                   // find
          case 6: return key;                   // findKey
          case 7: result[res[0]] = res[1];      // mapPairs
        } else if (IS_EVERY) return false;      // every
      }
    }
    return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
  };
};
var findKey = createDictMethod(6);

var createDictIter = function (kind) {
  return function (it) {
    return new DictIterator(it, kind);
  };
};
var DictIterator = function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._a = getKeys(iterated);   // keys
  this._i = 0;                   // next index
  this._k = kind;                // kind
};
$iterCreate(DictIterator, 'Dict', function () {
  var that = this;
  var O = that._t;
  var keys = that._a;
  var kind = that._k;
  var key;
  do {
    if (that._i >= keys.length) {
      that._t = undefined;
      return step(1);
    }
  } while (!has(O, key = keys[that._i++]));
  if (kind == 'keys') return step(0, key);
  if (kind == 'values') return step(0, O[key]);
  return step(0, [key, O[key]]);
});

function Dict(iterable) {
  var dict = create(null);
  if (iterable != undefined) {
    if (isIterable(iterable)) {
      forOf(iterable, true, function (key, value) {
        dict[key] = value;
      });
    } else assign(dict, iterable);
  }
  return dict;
}
Dict.prototype = null;

function reduce(object, mapfn, init) {
  aFunction(mapfn);
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var i = 0;
  var memo, key;
  if (arguments.length < 3) {
    if (!length) throw TypeError('Reduce of empty object with no initial value');
    memo = O[keys[i++]];
  } else memo = Object(init);
  while (length > i) if (has(O, key = keys[i++])) {
    memo = mapfn(memo, O[key], key, object);
  }
  return memo;
}

function includes(object, el) {
  // eslint-disable-next-line no-self-compare
  return (el == el ? keyOf(object, el) : findKey(object, function (it) {
    // eslint-disable-next-line no-self-compare
    return it != it;
  })) !== undefined;
}

function get(object, key) {
  if (has(object, key)) return object[key];
}
function set(object, key, value) {
  if (DESCRIPTORS && key in Object) dP.f(object, key, createDesc(0, value));
  else object[key] = value;
  return object;
}

function isDict(it) {
  return isObject(it) && getPrototypeOf(it) === Dict.prototype;
}

$export($export.G + $export.F, { Dict: Dict });

$export($export.S, 'Dict', {
  keys: createDictIter('keys'),
  values: createDictIter('values'),
  entries: createDictIter('entries'),
  forEach: createDictMethod(0),
  map: createDictMethod(1),
  filter: createDictMethod(2),
  some: createDictMethod(3),
  every: createDictMethod(4),
  find: createDictMethod(5),
  findKey: findKey,
  mapPairs: createDictMethod(7),
  reduce: reduce,
  keyOf: keyOf,
  includes: includes,
  has: has,
  get: get,
  set: set,
  isDict: isDict
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(329);
var $export = __webpack_require__(5);

// Placeholder
__webpack_require__(44)._ = path._ = path._ || {};

$export($export.P + $export.F, 'Function', { part: __webpack_require__(328) });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var get = __webpack_require__(141);
module.exports = __webpack_require__(44).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(174)(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', { classof: __webpack_require__(96) });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var define = __webpack_require__(321);

$export($export.S + $export.F, 'Object', { define: define });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', { isObject: __webpack_require__(18) });


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var define = __webpack_require__(321);
var create = __webpack_require__(72);

$export($export.S + $export.F, 'Object', {
  make: function (proto, mixin) {
    return define(create(proto), mixin);
  }
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(5);
var $re = __webpack_require__(228)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $re = __webpack_require__(228)(/[&<>"']/g, {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});

$export($export.P + $export.F, 'String', { escapeHTML: function escapeHTML() { return $re(this); } });


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $re = __webpack_require__(228)(/&(?:amp|lt|gt|quot|apos);/g, {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&apos;': "'"
});

$export($export.P + $export.F, 'String', { unescapeHTML: function unescapeHTML() { return $re(this); } });


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { copyWithin: __webpack_require__(307) });

__webpack_require__(82)('copyWithin');


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $every = __webpack_require__(61)(4);

$export($export.P + $export.F * !__webpack_require__(57)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { fill: __webpack_require__(211) });

__webpack_require__(82)('fill');


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $filter = __webpack_require__(61)(2);

$export($export.P + $export.F * !__webpack_require__(57)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(61)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(82)(KEY);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(61)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(82)(KEY);


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $forEach = __webpack_require__(61)(0);
var STRICT = __webpack_require__(57)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(53);
var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var call = __webpack_require__(317);
var isArrayIter = __webpack_require__(220);
var toLength = __webpack_require__(32);
var createProperty = __webpack_require__(213);
var getIterFn = __webpack_require__(141);

$export($export.S + $export.F * !__webpack_require__(175)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $indexOf = __webpack_require__(167)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(5);

$export($export.S, 'Array', { isArray: __webpack_require__(171) });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(5);
var toIObject = __webpack_require__(43);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(139) != Object || !__webpack_require__(57)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(43);
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(32);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $map = __webpack_require__(61)(1);

$export($export.P + $export.F * !__webpack_require__(57)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var createProperty = __webpack_require__(213);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(19)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(309);

$export($export.P + $export.F * !__webpack_require__(57)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(309);

$export($export.P + $export.F * !__webpack_require__(57)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var html = __webpack_require__(217);
var cof = __webpack_require__(56);
var toAbsoluteIndex = __webpack_require__(102);
var toLength = __webpack_require__(32);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(19)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $some = __webpack_require__(61)(3);

$export($export.P + $export.F * !__webpack_require__(57)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var aFunction = __webpack_require__(39);
var toObject = __webpack_require__(36);
var fails = __webpack_require__(19);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(57)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101)('Array');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(5);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(5);
var toISOString = __webpack_require__(646);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(65);

$export($export.P + $export.F * __webpack_require__(19)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(24)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(47)(proto, TO_PRIMITIVE, __webpack_require__(647));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(50)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(5);

$export($export.P, 'Function', { bind: __webpack_require__(310) });


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(49);
var HAS_INSTANCE = __webpack_require__(24)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(26).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(30) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(5);
var log1p = __webpack_require__(319);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(5);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(5);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(5);
var sign = __webpack_require__(223);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(5);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(5);
var $expm1 = __webpack_require__(222);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { fround: __webpack_require__(318) });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(5);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(5);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { log1p: __webpack_require__(319) });


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { sign: __webpack_require__(223) });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(222);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(222);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var has = __webpack_require__(45);
var cof = __webpack_require__(56);
var inheritIfRequired = __webpack_require__(218);
var toPrimitive = __webpack_require__(65);
var fails = __webpack_require__(19);
var gOPN = __webpack_require__(99).f;
var gOPD = __webpack_require__(48).f;
var dP = __webpack_require__(26).f;
var $trim = __webpack_require__(120).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(72)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(30) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(50)(global, NUMBER, $Number);
}


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(5);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(5);
var _isFinite = __webpack_require__(16).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', { isInteger: __webpack_require__(316) });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(5);
var isInteger = __webpack_require__(316);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(326);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(327);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toInteger = __webpack_require__(64);
var aNumberValue = __webpack_require__(306);
var repeat = __webpack_require__(233);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(19)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $fails = __webpack_require__(19);
var aNumberValue = __webpack_require__(306);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(226) });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(72) });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperties: __webpack_require__(322) });


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperty: __webpack_require__(26).f });


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(84).onFreeze;

__webpack_require__(63)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(43);
var $getOwnPropertyDescriptor = __webpack_require__(48).f;

__webpack_require__(63)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(63)('getOwnPropertyNames', function () {
  return __webpack_require__(323).f;
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(36);
var $getPrototypeOf = __webpack_require__(49);

__webpack_require__(63)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(18);

__webpack_require__(63)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(18);

__webpack_require__(63)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(18);

__webpack_require__(63)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { is: __webpack_require__(650) });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(36);
var $keys = __webpack_require__(73);

__webpack_require__(63)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(84).onFreeze;

__webpack_require__(63)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(84).onFreeze;

__webpack_require__(63)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(229).set });


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(96);
var test = {};
test[__webpack_require__(24)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(50)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(326);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(327);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(98);
var global = __webpack_require__(16);
var ctx = __webpack_require__(53);
var classof = __webpack_require__(96);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(18);
var aFunction = __webpack_require__(39);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(83);
var speciesConstructor = __webpack_require__(181);
var task = __webpack_require__(235).set;
var microtask = __webpack_require__(224)();
var newPromiseCapabilityModule = __webpack_require__(225);
var perform = __webpack_require__(330);
var promiseResolve = __webpack_require__(331);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(24)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(100)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(119)($Promise, PROMISE);
__webpack_require__(101)(PROMISE);
Wrapper = __webpack_require__(44)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(175)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(5);
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(14);
var rApply = (__webpack_require__(16).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(19)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(5);
var create = __webpack_require__(72);
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(19);
var bind = __webpack_require__(310);
var rConstruct = (__webpack_require__(16).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(26);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(65);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(19)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(5);
var gOPD = __webpack_require__(48).f;
var anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(14);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(173)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(48);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(5);
var getProto = __webpack_require__(49);
var anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(49);
var has = __webpack_require__(45);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(14);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(14);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(227) });


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(14);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(5);
var setProto = __webpack_require__(229);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(26);
var gOPD = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(49);
var has = __webpack_require__(45);
var $export = __webpack_require__(5);
var createDesc = __webpack_require__(85);
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(18);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var inheritIfRequired = __webpack_require__(218);
var dP = __webpack_require__(26).f;
var gOPN = __webpack_require__(99).f;
var isRegExp = __webpack_require__(172);
var $flags = __webpack_require__(170);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(30) && (!CORRECT_NEW || __webpack_require__(19)(function () {
  re2[__webpack_require__(24)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(50)(global, 'RegExp', $RegExp);
}

__webpack_require__(101)('RegExp');


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(169)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(169)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(169)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(169)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(172);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(337);
var anObject = __webpack_require__(14);
var $flags = __webpack_require__(170);
var DESCRIPTORS = __webpack_require__(30);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(50)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(19)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(51)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(51)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(51)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(51)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $at = __webpack_require__(231)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(32);
var context = __webpack_require__(232);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(216)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(51)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(51)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(51)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(102);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(5);
var context = __webpack_require__(232);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(216)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(51)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(231)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(174)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(51)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(32);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(233)
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(51)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(32);
var context = __webpack_require__(232);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(216)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(51)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(51)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(51)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(120)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(16);
var has = __webpack_require__(45);
var DESCRIPTORS = __webpack_require__(30);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(50);
var META = __webpack_require__(84).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(180);
var setToStringTag = __webpack_require__(119);
var uid = __webpack_require__(103);
var wks = __webpack_require__(24);
var wksExt = __webpack_require__(334);
var wksDefine = __webpack_require__(237);
var enumKeys = __webpack_require__(648);
var isArray = __webpack_require__(171);
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(18);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(65);
var createDesc = __webpack_require__(85);
var _create = __webpack_require__(72);
var gOPNExt = __webpack_require__(323);
var $GOPD = __webpack_require__(48);
var $DP = __webpack_require__(26);
var $keys = __webpack_require__(73);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(99).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(140).f = $propertyIsEnumerable;
  __webpack_require__(177).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(98)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(47)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $typed = __webpack_require__(182);
var buffer = __webpack_require__(236);
var anObject = __webpack_require__(14);
var toAbsoluteIndex = __webpack_require__(102);
var toLength = __webpack_require__(32);
var isObject = __webpack_require__(18);
var ArrayBuffer = __webpack_require__(16).ArrayBuffer;
var speciesConstructor = __webpack_require__(181);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(19)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(101)(ARRAY_BUFFER);


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
$export($export.G + $export.W + $export.F * !__webpack_require__(182).ABV, {
  DataView: __webpack_require__(236).DataView
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(313);
var validate = __webpack_require__(121);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(168)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(314);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var aFunction = __webpack_require__(39);
var arraySpeciesCreate = __webpack_require__(212);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(82)('flatMap');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(314);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var toInteger = __webpack_require__(64);
var arraySpeciesCreate = __webpack_require__(212);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(82)('flatten');


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(5);
var $includes = __webpack_require__(167)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(82)('includes');


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(5);
var microtask = __webpack_require__(224)();
var process = __webpack_require__(16).process;
var isNode = __webpack_require__(56)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(5);
var cof = __webpack_require__(56);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(5);

$export($export.G, { global: __webpack_require__(16) });


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(178)('Map');


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(179)('Map');


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(5);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(312)('Map') });


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var scale = __webpack_require__(320);
var fround = __webpack_require__(318);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { scale: __webpack_require__(320) });


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(5);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var aFunction = __webpack_require__(39);
var $defineProperty = __webpack_require__(26);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(30) && $export($export.P + __webpack_require__(176), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var aFunction = __webpack_require__(39);
var $defineProperty = __webpack_require__(26);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(30) && $export($export.P + __webpack_require__(176), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(325)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(5);
var ownKeys = __webpack_require__(227);
var toIObject = __webpack_require__(43);
var gOPD = __webpack_require__(48);
var createProperty = __webpack_require__(213);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(49);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(30) && $export($export.P + __webpack_require__(176), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(49);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(30) && $export($export.P + __webpack_require__(176), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $values = __webpack_require__(325)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(5);
var global = __webpack_require__(16);
var core = __webpack_require__(44);
var microtask = __webpack_require__(224)();
var OBSERVABLE = __webpack_require__(24)('observable');
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(14);
var anInstance = __webpack_require__(95);
var redefineAll = __webpack_require__(100);
var hide = __webpack_require__(47);
var forOf = __webpack_require__(83);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(101)('Observable');


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(5);
var core = __webpack_require__(44);
var global = __webpack_require__(16);
var speciesConstructor = __webpack_require__(181);
var promiseResolve = __webpack_require__(331);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(225);
var perform = __webpack_require__(330);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(338);
var from = __webpack_require__(308);
var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(49);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(49);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(49);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(71);
var anObject = __webpack_require__(14);
var aFunction = __webpack_require__(39);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(178)('Set');


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(179)('Set');


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(5);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(312)('Set') });


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(5);
var $at = __webpack_require__(231)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(5);
var defined = __webpack_require__(62);
var toLength = __webpack_require__(32);
var isRegExp = __webpack_require__(172);
var getFlags = __webpack_require__(170);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(173)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(332);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(332);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(120)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(120)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237)('asyncIterator');


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237)('observable');


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(5);

$export($export.S, 'System', { global: __webpack_require__(16) });


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(178)('WeakMap');


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(179)('WeakMap');


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(178)('WeakSet');


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(179)('WeakSet');


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(238);
var getKeys = __webpack_require__(73);
var redefine = __webpack_require__(50);
var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(97);
var wks = __webpack_require__(24);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $task = __webpack_require__(235);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(16);
var $export = __webpack_require__(5);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(782);
__webpack_require__(721);
__webpack_require__(723);
__webpack_require__(722);
__webpack_require__(725);
__webpack_require__(727);
__webpack_require__(732);
__webpack_require__(726);
__webpack_require__(724);
__webpack_require__(734);
__webpack_require__(733);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(728);
__webpack_require__(720);
__webpack_require__(731);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(688);
__webpack_require__(690);
__webpack_require__(689);
__webpack_require__(738);
__webpack_require__(737);
__webpack_require__(708);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(769);
__webpack_require__(774);
__webpack_require__(781);
__webpack_require__(772);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(770);
__webpack_require__(775);
__webpack_require__(777);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(771);
__webpack_require__(773);
__webpack_require__(776);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(683);
__webpack_require__(685);
__webpack_require__(684);
__webpack_require__(687);
__webpack_require__(686);
__webpack_require__(672);
__webpack_require__(670);
__webpack_require__(676);
__webpack_require__(673);
__webpack_require__(679);
__webpack_require__(681);
__webpack_require__(669);
__webpack_require__(675);
__webpack_require__(666);
__webpack_require__(680);
__webpack_require__(664);
__webpack_require__(678);
__webpack_require__(677);
__webpack_require__(671);
__webpack_require__(674);
__webpack_require__(663);
__webpack_require__(665);
__webpack_require__(668);
__webpack_require__(667);
__webpack_require__(682);
__webpack_require__(238);
__webpack_require__(754);
__webpack_require__(759);
__webpack_require__(337);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(739);
__webpack_require__(336);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(794);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(789);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(787);
__webpack_require__(790);
__webpack_require__(788);
__webpack_require__(791);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(747);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(753);
__webpack_require__(752);
__webpack_require__(797);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(838);
__webpack_require__(841);
__webpack_require__(840);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(839);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(819);
__webpack_require__(822);
__webpack_require__(818);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(803);
__webpack_require__(837);
__webpack_require__(802);
__webpack_require__(836);
__webpack_require__(848);
__webpack_require__(850);
__webpack_require__(801);
__webpack_require__(835);
__webpack_require__(847);
__webpack_require__(849);
__webpack_require__(800);
__webpack_require__(846);
__webpack_require__(799);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(810);
__webpack_require__(809);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(815);
__webpack_require__(814);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(829);
__webpack_require__(828);
__webpack_require__(831);
__webpack_require__(830);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(798);
__webpack_require__(823);
__webpack_require__(853);
__webpack_require__(852);
__webpack_require__(851);
module.exports = __webpack_require__(44);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var emptyObject = __webpack_require__(183);
var _invariant = __webpack_require__(13);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(856);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(866);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(13);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(46);

var createArrayFromMixed = __webpack_require__(859);
var getMarkupWrap = __webpack_require__(861);
var invariant = __webpack_require__(13);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(46);

var invariant = __webpack_require__(13);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(863);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(865);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(869)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 869 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 870 */
/***/ (function(module, exports) {

/*!
 * jQuery Migrate - v3.0.0 - 2016-06-09
 * Copyright jQuery Foundation and other contributors
 */
(function( jQuery, window ) {
"use strict";


jQuery.migrateVersion = "3.0.0";


( function() {

	// Support: IE9 only
	// IE9 only creates console object when dev tools are first opened
	// Also, avoid Function#bind here to simplify PhantomJS usage
	var log = window.console && window.console.log &&
			function() { window.console.log.apply( window.console, arguments ); },
		rbadVersions = /^[12]\./;

	if ( !log ) {
		return;
	}

	// Need jQuery 3.0.0+ and no older Migrate loaded
	if ( !jQuery || rbadVersions.test( jQuery.fn.jquery ) ) {
		log( "JQMIGRATE: jQuery 3.0.0+ REQUIRED" );
	}
	if ( jQuery.migrateWarnings ) {
		log( "JQMIGRATE: Migrate plugin loaded multiple times" );
	}

	// Show a message on the console so devs know we're active
	log( "JQMIGRATE: Migrate is installed" +
		( jQuery.migrateMute ? "" : " with logging active" ) +
		", version " + jQuery.migrateVersion );

} )();

var warnedAbout = {};

// List of warnings already given; public read only
jQuery.migrateWarnings = [];

// Set to false to disable traces that appear with warnings
if ( jQuery.migrateTrace === undefined ) {
	jQuery.migrateTrace = true;
}

// Forget any warnings we've already given; public
jQuery.migrateReset = function() {
	warnedAbout = {};
	jQuery.migrateWarnings.length = 0;
};

function migrateWarn( msg ) {
	var console = window.console;
	if ( !warnedAbout[ msg ] ) {
		warnedAbout[ msg ] = true;
		jQuery.migrateWarnings.push( msg );
		if ( console && console.warn && !jQuery.migrateMute ) {
			console.warn( "JQMIGRATE: " + msg );
			if ( jQuery.migrateTrace && console.trace ) {
				console.trace();
			}
		}
	}
}

function migrateWarnProp( obj, prop, value, msg ) {
	Object.defineProperty( obj, prop, {
		configurable: true,
		enumerable: true,
		get: function() {
			migrateWarn( msg );
			return value;
		}
	} );
}

if ( document.compatMode === "BackCompat" ) {

	// JQuery has never supported or tested Quirks Mode
	migrateWarn( "jQuery is not compatible with Quirks Mode" );
}


var oldInit = jQuery.fn.init,
	oldIsNumeric = jQuery.isNumeric,
	oldFind = jQuery.find,
	rattrHashTest = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
	rattrHashGlob = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g;

jQuery.fn.init = function( arg1 ) {
	var args = Array.prototype.slice.call( arguments );

	if ( typeof arg1 === "string" && arg1 === "#" ) {

		// JQuery( "#" ) is a bogus ID selector, but it returned an empty set before jQuery 3.0
		migrateWarn( "jQuery( '#' ) is not a valid selector" );
		args[ 0 ] = [];
	}

	return oldInit.apply( this, args );
};
jQuery.fn.init.prototype = jQuery.fn;

jQuery.find = function( selector ) {
	var args = Array.prototype.slice.call( arguments );

	// Support: PhantomJS 1.x
	// String#match fails to match when used with a //g RegExp, only on some strings
	if ( typeof selector === "string" && rattrHashTest.test( selector ) ) {

		// The nonstandard and undocumented unquoted-hash was removed in jQuery 1.12.0
		// First see if qS thinks it's a valid selector, if so avoid a false positive
		try {
			document.querySelector( selector );
		} catch ( err1 ) {

			// Didn't *look* valid to qSA, warn and try quoting what we think is the value
			selector = selector.replace( rattrHashGlob, function( _, attr, op, value ) {
				return "[" + attr + op + "\"" + value + "\"]";
			} );

			// If the regexp *may* have created an invalid selector, don't update it
			// Note that there may be false alarms if selector uses jQuery extensions
			try {
				document.querySelector( selector );
				migrateWarn( "Attribute selector with '#' must be quoted: " + args[ 0 ] );
				args[ 0 ] = selector;
			} catch ( err2 ) {
				migrateWarn( "Attribute selector with '#' was not fixed: " + args[ 0 ] );
			}
		}
	}

	return oldFind.apply( this, args );
};

// Copy properties attached to original jQuery.find method (e.g. .attr, .isXML)
var findProp;
for ( findProp in oldFind ) {
	if ( Object.prototype.hasOwnProperty.call( oldFind, findProp ) ) {
		jQuery.find[ findProp ] = oldFind[ findProp ];
	}
}

// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	migrateWarn( "jQuery.fn.size() is deprecated; use the .length property" );
	return this.length;
};

jQuery.parseJSON = function() {
	migrateWarn( "jQuery.parseJSON is deprecated; use JSON.parse" );
	return JSON.parse.apply( null, arguments );
};

jQuery.isNumeric = function( val ) {

	// The jQuery 2.2.3 implementation of isNumeric
	function isNumeric2( obj ) {
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	}

	var newValue = oldIsNumeric( val ),
		oldValue = isNumeric2( val );

	if ( newValue !== oldValue ) {
		migrateWarn( "jQuery.isNumeric() should not be called on constructed objects" );
	}

	return oldValue;
};

migrateWarnProp( jQuery, "unique", jQuery.uniqueSort,
	"jQuery.unique is deprecated, use jQuery.uniqueSort" );

// Now jQuery.expr.pseudos is the standard incantation
migrateWarnProp( jQuery.expr, "filters", jQuery.expr.pseudos,
	"jQuery.expr.filters is now jQuery.expr.pseudos" );
migrateWarnProp( jQuery.expr, ":", jQuery.expr.pseudos,
	"jQuery.expr[\":\"] is now jQuery.expr.pseudos" );


var oldAjax = jQuery.ajax;

jQuery.ajax = function( ) {
	var jQXHR = oldAjax.apply( this, arguments );

	// Be sure we got a jQXHR (e.g., not sync)
	if ( jQXHR.promise ) {
		migrateWarnProp( jQXHR, "success", jQXHR.done,
			"jQXHR.success is deprecated and removed" );
		migrateWarnProp( jQXHR, "error", jQXHR.fail,
			"jQXHR.error is deprecated and removed" );
		migrateWarnProp( jQXHR, "complete", jQXHR.always,
			"jQXHR.complete is deprecated and removed" );
	}

	return jQXHR;
};


var oldRemoveAttr = jQuery.fn.removeAttr,
	oldToggleClass = jQuery.fn.toggleClass,
	rmatchNonSpace = /\S+/g;

jQuery.fn.removeAttr = function( name ) {
	var self = this;

	jQuery.each( name.match( rmatchNonSpace ), function( i, attr ) {
		if ( jQuery.expr.match.bool.test( attr ) ) {
			migrateWarn( "jQuery.fn.removeAttr no longer sets boolean properties: " + attr );
			self.prop( attr, false );
		}
	} );

	return oldRemoveAttr.apply( this, arguments );
};

jQuery.fn.toggleClass = function( state ) {

	// Only deprecating no-args or single boolean arg
	if ( state !== undefined && typeof state !== "boolean" ) {
		return oldToggleClass.apply( this, arguments );
	}

	migrateWarn( "jQuery.fn.toggleClass( boolean ) is deprecated" );

	// Toggle entire class name of each element
	return this.each( function() {
		var className = this.getAttribute && this.getAttribute( "class" ) || "";

		if ( className ) {
			jQuery.data( this, "__className__", className );
		}

		// If the element has a class name or if we're passed `false`,
		// then remove the whole classname (if there was one, the above saved it).
		// Otherwise bring back whatever was previously saved (if anything),
		// falling back to the empty string if nothing was stored.
		if ( this.setAttribute ) {
			this.setAttribute( "class",
				className || state === false ?
				"" :
				jQuery.data( this, "__className__" ) || ""
			);
		}
	} );
};


var internalSwapCall = false;

// If this version of jQuery has .swap(), don't false-alarm on internal uses
if ( jQuery.swap ) {
	jQuery.each( [ "height", "width", "reliableMarginRight" ], function( _, name ) {
		var oldHook = jQuery.cssHooks[ name ] && jQuery.cssHooks[ name ].get;

		if ( oldHook ) {
			jQuery.cssHooks[ name ].get = function() {
				var ret;

				internalSwapCall = true;
				ret = oldHook.apply( this, arguments );
				internalSwapCall = false;
				return ret;
			};
		}
	} );
}

jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	if ( !internalSwapCall ) {
		migrateWarn( "jQuery.swap() is undocumented and deprecated" );
	}

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};

var oldData = jQuery.data;

jQuery.data = function( elem, name, value ) {
	var curData;

	// If the name is transformed, look for the un-transformed name in the data object
	if ( name && name !== jQuery.camelCase( name ) ) {
		curData = jQuery.hasData( elem ) && oldData.call( this, elem );
		if ( curData && name in curData ) {
			migrateWarn( "jQuery.data() always sets/gets camelCased names: " + name );
			if ( arguments.length > 2 ) {
				curData[ name ] = value;
			}
			return curData[ name ];
		}
	}

	return oldData.apply( this, arguments );
};

var oldTweenRun = jQuery.Tween.prototype.run;

jQuery.Tween.prototype.run = function( percent ) {
	if ( jQuery.easing[ this.easing ].length > 1 ) {
		migrateWarn(
			"easing function " +
			"\"jQuery.easing." + this.easing.toString() +
			"\" should use only first argument"
		);

		jQuery.easing[ this.easing ] = jQuery.easing[ this.easing ].bind(
			jQuery.easing,
			percent, this.options.duration * percent, 0, 1, this.options.duration
		);
	}

	oldTweenRun.apply( this, arguments );
};

var oldLoad = jQuery.fn.load,
	originalFix = jQuery.event.fix;

jQuery.event.props = [];
jQuery.event.fixHooks = {};

jQuery.event.fix = function( originalEvent ) {
	var event,
		type = originalEvent.type,
		fixHook = this.fixHooks[ type ],
		props = jQuery.event.props;

	if ( props.length ) {
		migrateWarn( "jQuery.event.props are deprecated and removed: " + props.join() );
		while ( props.length ) {
			jQuery.event.addProp( props.pop() );
		}
	}

	if ( fixHook && !fixHook._migrated_ ) {
		fixHook._migrated_ = true;
		migrateWarn( "jQuery.event.fixHooks are deprecated and removed: " + type );
		if ( ( props = fixHook.props ) && props.length ) {
			while ( props.length ) {
			   jQuery.event.addProp( props.pop() );
			}
		}
	}

	event = originalFix.call( this, originalEvent );

	return fixHook && fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
};

jQuery.each( [ "load", "unload", "error" ], function( _, name ) {

	jQuery.fn[ name ] = function() {
		var args = Array.prototype.slice.call( arguments, 0 );

		// If this is an ajax load() the first arg should be the string URL;
		// technically this could also be the "Anything" arg of the event .load()
		// which just goes to show why this dumb signature has been deprecated!
		// jQuery custom builds that exclude the Ajax module justifiably die here.
		if ( name === "load" && typeof args[ 0 ] === "string" ) {
			return oldLoad.apply( this, args );
		}

		migrateWarn( "jQuery.fn." + name + "() is deprecated" );

		args.splice( 0, 0, name );
		if ( arguments.length ) {
			return this.on.apply( this, args );
		}

		// Use .triggerHandler here because:
		// - load and unload events don't need to bubble, only applied to window or image
		// - error event should not bubble to window, although it does pre-1.7
		// See http://bugs.jquery.com/ticket/11820
		this.triggerHandler.apply( this, args );
		return this;
	};

} );

// Trigger "ready" event only once, on document ready
jQuery( function() {
	jQuery( document ).triggerHandler( "ready" );
} );

jQuery.event.special.ready = {
	setup: function() {
		if ( this === document ) {
			migrateWarn( "'ready' event is deprecated" );
		}
	}
};

jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		migrateWarn( "jQuery.fn.bind() is deprecated" );
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		migrateWarn( "jQuery.fn.unbind() is deprecated" );
		return this.off( types, null, fn );
	},
	delegate: function( selector, types, data, fn ) {
		migrateWarn( "jQuery.fn.delegate() is deprecated" );
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		migrateWarn( "jQuery.fn.undelegate() is deprecated" );
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );


var oldOffset = jQuery.fn.offset;

jQuery.fn.offset = function() {
	var docElem,
		elem = this[ 0 ],
		origin = { top: 0, left: 0 };

	if ( !elem || !elem.nodeType ) {
		migrateWarn( "jQuery.fn.offset() requires a valid DOM element" );
		return origin;
	}

	docElem = ( elem.ownerDocument || document ).documentElement;
	if ( !jQuery.contains( docElem, elem ) ) {
		migrateWarn( "jQuery.fn.offset() requires an element connected to a document" );
		return origin;
	}

	return oldOffset.apply( this, arguments );
};


var oldParam = jQuery.param;

jQuery.param = function( data, traditional ) {
	var ajaxTraditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;

	if ( traditional === undefined && ajaxTraditional ) {

		migrateWarn( "jQuery.param() no longer uses jQuery.ajaxSettings.traditional" );
		traditional = ajaxTraditional;
	}

	return oldParam.call( this, data, traditional );
};

var oldSelf = jQuery.fn.andSelf || jQuery.fn.addBack;

jQuery.fn.andSelf = function() {
	migrateWarn( "jQuery.fn.andSelf() replaced by jQuery.fn.addBack()" );
	return oldSelf.apply( this, arguments );
};


var oldDeferred = jQuery.Deferred,
	tuples = [

		// Action, add listener, callbacks, .then handlers, final state
		[ "resolve", "done", jQuery.Callbacks( "once memory" ),
			jQuery.Callbacks( "once memory" ), "resolved" ],
		[ "reject", "fail", jQuery.Callbacks( "once memory" ),
			jQuery.Callbacks( "once memory" ), "rejected" ],
		[ "notify", "progress", jQuery.Callbacks( "memory" ),
			jQuery.Callbacks( "memory" ) ]
	];

jQuery.Deferred = function( func ) {
	var deferred = oldDeferred(),
		promise = deferred.promise();

	deferred.pipe = promise.pipe = function( /* fnDone, fnFail, fnProgress */ ) {
		var fns = arguments;

		migrateWarn( "deferred.pipe() is deprecated" );

		return jQuery.Deferred( function( newDefer ) {
			jQuery.each( tuples, function( i, tuple ) {
				var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

				// Deferred.done(function() { bind to newDefer or newDefer.resolve })
				// deferred.fail(function() { bind to newDefer or newDefer.reject })
				// deferred.progress(function() { bind to newDefer or newDefer.notify })
				deferred[ tuple[ 1 ] ]( function() {
					var returned = fn && fn.apply( this, arguments );
					if ( returned && jQuery.isFunction( returned.promise ) ) {
						returned.promise()
							.done( newDefer.resolve )
							.fail( newDefer.reject )
							.progress( newDefer.notify );
					} else {
						newDefer[ tuple[ 0 ] + "With" ](
							this === promise ? newDefer.promise() : this,
							fn ? [ returned ] : arguments
						);
					}
				} );
			} );
			fns = null;
		} ).promise();

	};

	if ( func ) {
		func.call( deferred, deferred );
	}

	return deferred;
};



})( jQuery, window );


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(27), __webpack_require__(122) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {
return $.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo( function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		} ) :

		// Support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		}
} );
} ) );


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(27), __webpack_require__(122) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

return $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};

} ) );


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: http://api.jqueryui.com/mouse/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(27),
			__webpack_require__(343),
			__webpack_require__(122),
			__webpack_require__(344)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

return $.widget( "ui.mouse", {
	version: "1.12.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		( this._mouseStarted && this._mouseUp( event ) );

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) { return true; }
} );

} ) );


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: http://api.jqueryui.com/sortable/
//>>demos: http://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(27),
			__webpack_require__(873),
			__webpack_require__(871),
			__webpack_require__(343),
			__webpack_require__(872),
			__webpack_require__(122),
			__webpack_require__(344)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

return $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Generate the original position
		this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// Support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		// Execute the drag once - this causes the helper not to be visiblebefore getting its
		// correct position
		this._mouseDrag( event );
		return true;

	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		if ( !this.lastPositionAbs ) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if ( this.options.scroll ) {
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

				if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
				} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
				}

				if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
				}

			} else {

				if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
				} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
				}

				if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() - o.scrollSpeed
					);
				} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() + o.scrollSpeed
					);
				}

			}

			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this._getDragVerticalDirection();
		horizontalDirection = this._getDragHorizontalDirection();

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
			: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ $.isFunction( this.options.items ) ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ $.isFunction( this.options.items ) ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[ 0 ] );

						that._addClass( element, "ui-sortable-placeholder",
								className || that.currentItem[ 0 ].className )
							._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming
					// from a stylesheet), it receives the inline height from the dragged item
					if ( !p.height() ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ?
				this._rearrange( event, itemWithLeastDistance, null, true ) :
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = $.isFunction( o.helper ) ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			$( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this
		// information with an ugly IE fix
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );

} ) );


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Module dependencies.
 */
var os = __webpack_require__(885);
var lodashGet = __webpack_require__(880);
var lodashFlatten = __webpack_require__(879);
var lodashUniq = __webpack_require__(882);
var lodashSet = __webpack_require__(881);
var lodashCloneDeep = __webpack_require__(878);
var flatten = __webpack_require__(868);

/**
 * @name Json2CsvParams
 * @typedef {Object}
 * @property {Array} data - array of JSON objects
 * @property {Array} [fields] - see documentation for details
 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
 * @property {String} [del=","] - delimiter of columns
 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
 * @property {String} [quotes='"'] - quotes around cell values and column names
 * @property {String} [doubleQuotes='""'] - the value to replace double quotes in strings
 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
 * @property {String} [eol=''] - it gets added to each row of data
 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
 * @property {String[]} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
 * @property {Boolean} [withBOM=false] - includes BOM character at the beginning of the csv
 */

/**
 * Main function that converts json to csv.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter (default is ','), hasCSVColumnTitle (default is true)
 * and default value (default is '')
 * @param {Function} [callback] Callback function
 *   if error, returning error in call back.
 *   if csv is created successfully, returning csv output to callback.
 */
module.exports = function (params, callback) {
  var hasCallback = typeof callback === 'function';
  var err;

  try {
    checkParams(params);
  } catch (err) {
    if (hasCallback) {
      return process.nextTick(function () {
        callback(err);
      });
    } else {
      throw err;
    }
  }

  var titles = createColumnTitles(params);
  var csv = createColumnContent(params, titles);

  if (hasCallback) {
    return process.nextTick(function () {
      callback(null, csv);
    });
  } else {
    return csv;
  }
};


/**
 * Check passing params.
 *
 * Note that this modifies params.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter, default value, mark quotes and hasCSVColumnTitle
 */
function checkParams(params) {
  params.data = params.data || [];

  // if data is an Object, not in array [{}], then just create 1 item array.
  // So from now all data in array of object format.
  if (!Array.isArray(params.data)) {
    params.data = [params.data];
  }

  if (params.flatten) {
    params.data = params.data.map(flatten);
  }

  // Set params.fields default to first data element's keys
  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
  }

  if (!params.fields) {
    var dataFields = params.data.map(function (item) {
      return Object.keys(item);
    });

    dataFields = lodashFlatten(dataFields);
    params.fields = lodashUniq(dataFields);
  }


  //#check fieldNames
  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
  }

  // Get fieldNames from fields
  params.fieldNames = params.fields.map(function (field, i) {
    if (params.fieldNames && typeof field === 'string') {
      return params.fieldNames[i];
    }
    return (typeof field === 'string') ? field : (field.label || field.value);
  });

  //#check delimiter
  params.del = params.del || ',';

  //#check end of line character
  params.eol = params.eol || '';

  //#check quotation mark
  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';

  //#check double quotes
  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);

  //#check default value
  params.defaultValue = params.defaultValue;

  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;

  //#check include empty rows, defaults to false
  params.includeEmptyRows = params.includeEmptyRows || false;

  //#check with BOM, defaults to false
  params.withBOM = params.withBOM || false;

  //#check unwindPath, defaults to empty array
  params.unwindPath = params.unwindPath || [];

  // if unwindPath is not in array [{}], then just create 1 item array.
  if (!Array.isArray(params.unwindPath)) {
    params.unwindPath = [params.unwindPath];
  }
}

/**
 * Create the title row with all the provided fields as column headings
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
 * @returns {String} titles as a string
 */
function createColumnTitles(params) {
  var str = '';

  //if CSV has column title, then create it
  if (params.hasCSVColumnTitle) {
    params.fieldNames.forEach(function (element) {
      if (str !== '') {
        str += params.del;
      }
      str += JSON.stringify(element).replace(/\"/g, params.quotes);
    });
  }

  return str;
}

/**
 * Replace the quotation marks of the field element if needed (can be a not string-like item)
 *
 * @param {string} stringifiedElement The field element after JSON.stringify()
 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
 */
function replaceQuotationMarks(stringifiedElement, quotes) {
  var lastCharIndex = stringifiedElement.length - 1;

  //check if it's an string-like element
  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
    //split the stringified field element because Strings are immutable
    var splitElement = stringifiedElement.split('');

    //replace the quotation marks
    splitElement[0] = quotes;
    splitElement[lastCharIndex] = quotes;

    //join again
    stringifiedElement = splitElement.join('');
  }

  return stringifiedElement;
}

/**
 * Create the content column by column and row by row below the title
 *
 * @param {Object} params Function parameters containing data, fields and delimiter
 * @param {String} str Title row as a string
 * @returns {String} csv string
 */
function createColumnContent(params, str) {
  createDataRows(params.data, params.unwindPath).forEach(function (dataElement) {
    //if null do nothing, if empty object without includeEmptyRows do nothing
    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
      var line = '';
      var eol = params.newLine || os.EOL || '\n';

      params.fields.forEach(function (fieldElement) {
        var val;
        var defaultValue = params.defaultValue;
        var stringify = true;
        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
          defaultValue = fieldElement.default;
        }

        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
          val = lodashGet(dataElement, path, defaultValue);
        } else if (fieldElement && typeof fieldElement.value === 'function') {
          var field = {
            label: fieldElement.label,
            default: fieldElement.default
          };
          val = fieldElement.value(dataElement, field, params.data);
          if (fieldElement.stringify !== undefined) {
            stringify = fieldElement.stringify;
          }
        }

        if (val === null || val === undefined){
          val = defaultValue;
        }

        if (val !== undefined) {
          if (params.preserveNewLinesInValues && typeof val === 'string') {
            val = val
              .replace(/\n/g, '\u2028')
              .replace(/\r/g, '\u2029');
          }

          var stringifiedElement = val;
          if (stringify) {
            stringifiedElement = JSON.stringify(val);
          }

          if (params.preserveNewLinesInValues && typeof val === 'string') {
            stringifiedElement = stringifiedElement
              .replace(/\u2028/g, '\n')
              .replace(/\u2029/g, '\r');
          }

          if (typeof val === 'object') {
            // In some cases (e.g. val is a Date), stringifiedElement is already a quoted string.
            // Strip the leading and trailing quotes if so, so we don't end up double-quoting it
            stringifiedElement = replaceQuotationMarks(stringifiedElement, '');

            // If val is a normal object, we want to escape its JSON so any commas etc
            // don't get interpreted as field separators
            stringifiedElement = JSON.stringify(stringifiedElement);
          }

          if (params.quotes !== '"') {
            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
          }

          //JSON.stringify('\\') results in a string with two backslash
          //characters in it. I.e. '\\\\'.
          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');

          if (params.excelStrings && typeof val === 'string') {
            stringifiedElement = '"="' + stringifiedElement + '""';
          }

          //Replace single quotes with double quotes.  Single quotes are preceeded by
          //a backslash,  and it's not at the end of the stringifiedElement.
          stringifiedElement = stringifiedElement.replace(/(\\")(?=.)/g, params.doubleQuotes);

          line += stringifiedElement;
        }

        line += params.del;
      });

      //remove last delimeter by its length
      line = line.substring(0, line.length - params.del.length);

      //Remove the final excess backslashes from the stringified value.
      line = line.replace(/\\\\/g,'\\');

      //If header exists, add it, otherwise, print only content
      if (str !== '') {
        str += eol + line + params.eol;
      } else {
        str = line + params.eol;
      }
    }
  });
  // Add BOM character if required
  if (params.withBOM) {
    str = '\ufeff' + str;
  }

  return str;
}

/**
 * Performs the unwind recursively in specified sequence
 *
 * @param {Array} originalData The params.data value. Original array of JSON objects
 * @param {String[]} unwindPaths The params.unwindPath value. Unwind strings to be used to deconstruct array
 * @returns {Array} Array of objects containing all rows after unwind of chosen paths
 */
function createDataRows(originalData, unwindPaths) {
  var dataRows = [];
  if (unwindPaths.length) {
    originalData.forEach(function(dataElement) {
      var dataRow = [dataElement];

      unwindPaths.forEach(function(unwindPath) {
        dataRow = unwindRows(dataRow, unwindPath);
      });

      Array.prototype.push.apply(dataRows, dataRow);
    });
  } else {
    dataRows = originalData;
  }

  return dataRows;
}

/**
 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
 *
 * @param {Array} inputRows Array contaning single or multiple rows to unwind
 * @param {String} unwindPath Single path to do unwind
 * @returns {Array} Array of rows processed
 */
function unwindRows(inputRows, unwindPath) {
  var outputRows = [];
  inputRows.forEach(function(dataEl) {
    var unwindArray = lodashGet(dataEl, unwindPath);
    var isArr = Array.isArray(unwindArray);

    if (isArr && unwindArray.length) {
      unwindArray.forEach(function(unwindEl) {
        var dataCopy = lodashCloneDeep(dataEl);
        lodashSet(dataCopy, unwindPath, unwindEl);
        outputRows.push(dataCopy);
      });
    } else if (isArr && !unwindArray.length) {
      var dataCopy = lodashCloneDeep(dataEl);
      lodashSet(dataCopy, unwindPath, undefined);
      outputRows.push(dataCopy);
    } else {
      outputRows.push(dataEl);
    }
  });
  return outputRows;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(143)))

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constraint__ = __webpack_require__(345);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Operator", function() { return __WEBPACK_IMPORTED_MODULE_0__constraint__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Constraint", function() { return __WEBPACK_IMPORTED_MODULE_0__constraint__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expression__ = __webpack_require__(184);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Expression", function() { return __WEBPACK_IMPORTED_MODULE_1__expression__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__solver__ = __webpack_require__(877);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Solver", function() { return __WEBPACK_IMPORTED_MODULE_2__solver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strength__ = __webpack_require__(240);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Strength", function() { return __WEBPACK_IMPORTED_MODULE_3__strength__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variable__ = __webpack_require__(241);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Variable", function() { return __WEBPACK_IMPORTED_MODULE_4__variable__["a"]; });
/*-----------------------------------------------------------------------------
| Copyright (c) 2014-2018, Nucleic Development Team & H. Rutjes.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/







/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Solver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constraint__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expression__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__maptype__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strength__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variable__ = __webpack_require__(241);
/*-----------------------------------------------------------------------------
| Copyright (c) 2014, Nucleic Development Team.
|
| Distributed under the terms of the Modified BSD License.
|
| The full license is in the file COPYING.txt, distributed with this software.
|----------------------------------------------------------------------------*/





/**
 * The constraint solver class.
 *
 * @class
 */
var Solver = /** @class */ (function () {
    /**
     * Construct a new Solver.
     */
    function Solver() {
        this._cnMap = createCnMap();
        this._rowMap = createRowMap();
        this._varMap = createVarMap();
        this._editMap = createEditMap();
        this._infeasibleRows = [];
        this._objective = new Row();
        this._artificial = null;
        this._idTick = 0;
    }
    /**
     * Creates and add a constraint to the solver.
     *
     * @param {Expression|Variable} lhs Left hand side of the expression
     * @param {Operator} operator Operator
     * @param {Expression|Variable|Number} rhs Right hand side of the expression
     * @param {Number} [strength=Strength.required] Strength
     */
    Solver.prototype.createConstraint = function (lhs, operator, rhs, strength) {
        if (strength === void 0) { strength = __WEBPACK_IMPORTED_MODULE_3__strength__["a" /* Strength */].required; }
        var cn = new __WEBPACK_IMPORTED_MODULE_0__constraint__["b" /* Constraint */](lhs, operator, rhs, strength);
        this.addConstraint(cn);
        return cn;
    };
    /**
     * Add a constraint to the solver.
     *
     * @param {Constraint} constraint Constraint to add to the solver
     */
    Solver.prototype.addConstraint = function (constraint) {
        var cnPair = this._cnMap.find(constraint);
        if (cnPair !== undefined) {
            throw new Error("duplicate constraint");
        }
        // Creating a row causes symbols to be reserved for the variables
        // in the constraint. If this method exits with an exception,
        // then its possible those variables will linger in the var map.
        // Since its likely that those variables will be used in other
        // constraints and since exceptional conditions are uncommon,
        // i'm not too worried about aggressive cleanup of the var map.
        var data = this._createRow(constraint);
        var row = data.row;
        var tag = data.tag;
        var subject = this._chooseSubject(row, tag);
        // If chooseSubject couldnt find a valid entering symbol, one
        // last option is available if the entire row is composed of
        // dummy variables. If the constant of the row is zero, then
        // this represents redundant constraints and the new dummy
        // marker can enter the basis. If the constant is non-zero,
        // then it represents an unsatisfiable constraint.
        if (subject.type() === SymbolType.Invalid && row.allDummies()) {
            if (!nearZero(row.constant())) {
                throw new Error("unsatisfiable constraint");
            }
            else {
                subject = tag.marker;
            }
        }
        // If an entering symbol still isn't found, then the row must
        // be added using an artificial variable. If that fails, then
        // the row represents an unsatisfiable constraint.
        if (subject.type() === SymbolType.Invalid) {
            if (!this._addWithArtificialVariable(row)) {
                throw new Error("unsatisfiable constraint");
            }
        }
        else {
            row.solveFor(subject);
            this._substitute(subject, row);
            this._rowMap.insert(subject, row);
        }
        this._cnMap.insert(constraint, tag);
        // Optimizing after each constraint is added performs less
        // aggregate work due to a smaller average system size. It
        // also ensures the solver remains in a consistent state.
        this._optimize(this._objective);
    };
    /**
     * Remove a constraint from the solver.
     *
     * @param {Constraint} constraint Constraint to remove from the solver
     */
    Solver.prototype.removeConstraint = function (constraint) {
        var cnPair = this._cnMap.erase(constraint);
        if (cnPair === undefined) {
            throw new Error("unknown constraint");
        }
        // Remove the error effects from the objective function
        // *before* pivoting, or substitutions into the objective
        // will lead to incorrect solver results.
        this._removeConstraintEffects(constraint, cnPair.second);
        // If the marker is basic, simply drop the row. Otherwise,
        // pivot the marker into the basis and then drop the row.
        var marker = cnPair.second.marker;
        var rowPair = this._rowMap.erase(marker);
        if (rowPair === undefined) {
            var leaving = this._getMarkerLeavingSymbol(marker);
            if (leaving.type() === SymbolType.Invalid) {
                throw new Error("failed to find leaving row");
            }
            rowPair = this._rowMap.erase(leaving);
            rowPair.second.solveForEx(leaving, marker);
            this._substitute(marker, rowPair.second);
        }
        // Optimizing after each constraint is removed ensures that the
        // solver remains consistent. It makes the solver api easier to
        // use at a small tradeoff for speed.
        this._optimize(this._objective);
    };
    /**
     * Test whether the solver contains the constraint.
     *
     * @param {Constraint} constraint Constraint to test for
     * @return {Bool} true or false
     */
    Solver.prototype.hasConstraint = function (constraint) {
        return this._cnMap.contains(constraint);
    };
    /**
     * Add an edit variable to the solver.
     *
     * @param {Variable} variable Edit variable to add to the solver
     * @param {Number} strength Strength, should be less than `Strength.required`
     */
    Solver.prototype.addEditVariable = function (variable, strength) {
        var editPair = this._editMap.find(variable);
        if (editPair !== undefined) {
            throw new Error("duplicate edit variable");
        }
        strength = __WEBPACK_IMPORTED_MODULE_3__strength__["a" /* Strength */].clip(strength);
        if (strength === __WEBPACK_IMPORTED_MODULE_3__strength__["a" /* Strength */].required) {
            throw new Error("bad required strength");
        }
        var expr = new __WEBPACK_IMPORTED_MODULE_1__expression__["a" /* Expression */](variable);
        var cn = new __WEBPACK_IMPORTED_MODULE_0__constraint__["b" /* Constraint */](expr, __WEBPACK_IMPORTED_MODULE_0__constraint__["a" /* Operator */].Eq, undefined, strength);
        this.addConstraint(cn);
        var tag = this._cnMap.find(cn).second;
        var info = { tag: tag, constraint: cn, constant: 0.0 };
        this._editMap.insert(variable, info);
    };
    /**
     * Remove an edit variable from the solver.
     *
     * @param {Variable} variable Edit variable to remove from the solver
     */
    Solver.prototype.removeEditVariable = function (variable) {
        var editPair = this._editMap.erase(variable);
        if (editPair === undefined) {
            throw new Error("unknown edit variable");
        }
        this.removeConstraint(editPair.second.constraint);
    };
    /**
     * Test whether the solver contains the edit variable.
     *
     * @param {Variable} variable Edit variable to test for
     * @return {Bool} true or false
     */
    Solver.prototype.hasEditVariable = function (variable) {
        return this._editMap.contains(variable);
    };
    /**
     * Suggest the value of an edit variable.
     *
     * @param {Variable} variable Edit variable to suggest a value for
     * @param {Number} value Suggested value
     */
    Solver.prototype.suggestValue = function (variable, value) {
        var editPair = this._editMap.find(variable);
        if (editPair === undefined) {
            throw new Error("unknown edit variable");
        }
        var rows = this._rowMap;
        var info = editPair.second;
        var delta = value - info.constant;
        info.constant = value;
        // Check first if the positive error variable is basic.
        var marker = info.tag.marker;
        var rowPair = rows.find(marker);
        if (rowPair !== undefined) {
            if (rowPair.second.add(-delta) < 0.0) {
                this._infeasibleRows.push(marker);
            }
            this._dualOptimize();
            return;
        }
        // Check next if the negative error variable is basic.
        var other = info.tag.other;
        rowPair = rows.find(other);
        if (rowPair !== undefined) {
            if (rowPair.second.add(delta) < 0.0) {
                this._infeasibleRows.push(other);
            }
            this._dualOptimize();
            return;
        }
        // Otherwise update each row where the error variables exist.
        for (var i = 0, n = rows.size(); i < n; ++i) {
            var rowPair_1 = rows.itemAt(i);
            var row = rowPair_1.second;
            var coeff = row.coefficientFor(marker);
            if (coeff !== 0.0 && row.add(delta * coeff) < 0.0 &&
                rowPair_1.first.type() !== SymbolType.External) {
                this._infeasibleRows.push(rowPair_1.first);
            }
        }
        this._dualOptimize();
    };
    /**
     * Update the values of the variables.
     */
    Solver.prototype.updateVariables = function () {
        var vars = this._varMap;
        var rows = this._rowMap;
        for (var i = 0, n = vars.size(); i < n; ++i) {
            var pair = vars.itemAt(i);
            var rowPair = rows.find(pair.second);
            if (rowPair !== undefined) {
                pair.first.setValue(rowPair.second.constant());
            }
            else {
                pair.first.setValue(0.0);
            }
        }
    };
    /**
     * Get the symbol for the given variable.
     *
     * If a symbol does not exist for the variable, one will be created.
     * @private
     */
    Solver.prototype._getVarSymbol = function (variable) {
        var _this = this;
        var factory = function () { return _this._makeSymbol(SymbolType.External); };
        return this._varMap.setDefault(variable, factory).second;
    };
    /**
     * Create a new Row object for the given constraint.
     *
     * The terms in the constraint will be converted to cells in the row.
     * Any term in the constraint with a coefficient of zero is ignored.
     * This method uses the `_getVarSymbol` method to get the symbol for
     * the variables added to the row. If the symbol for a given cell
     * variable is basic, the cell variable will be substituted with the
     * basic row.
     *
     * The necessary slack and error variables will be added to the row.
     * If the constant for the row is negative, the sign for the row
     * will be inverted so the constant becomes positive.
     *
     * Returns the created Row and the tag for tracking the constraint.
     * @private
     */
    Solver.prototype._createRow = function (constraint) {
        var expr = constraint.expression();
        var row = new Row(expr.constant());
        // Substitute the current basic variables into the row.
        var terms = expr.terms();
        for (var i = 0, n = terms.size(); i < n; ++i) {
            var termPair = terms.itemAt(i);
            if (!nearZero(termPair.second)) {
                var symbol = this._getVarSymbol(termPair.first);
                var basicPair = this._rowMap.find(symbol);
                if (basicPair !== undefined) {
                    row.insertRow(basicPair.second, termPair.second);
                }
                else {
                    row.insertSymbol(symbol, termPair.second);
                }
            }
        }
        // Add the necessary slack, error, and dummy variables.
        var objective = this._objective;
        var strength = constraint.strength();
        var tag = { marker: INVALID_SYMBOL, other: INVALID_SYMBOL };
        switch (constraint.op()) {
            case __WEBPACK_IMPORTED_MODULE_0__constraint__["a" /* Operator */].Le:
            case __WEBPACK_IMPORTED_MODULE_0__constraint__["a" /* Operator */].Ge:
                {
                    var coeff = constraint.op() === __WEBPACK_IMPORTED_MODULE_0__constraint__["a" /* Operator */].Le ? 1.0 : -1.0;
                    var slack = this._makeSymbol(SymbolType.Slack);
                    tag.marker = slack;
                    row.insertSymbol(slack, coeff);
                    if (strength < __WEBPACK_IMPORTED_MODULE_3__strength__["a" /* Strength */].required) {
                        var error = this._makeSymbol(SymbolType.Error);
                        tag.other = error;
                        row.insertSymbol(error, -coeff);
                        objective.insertSymbol(error, strength);
                    }
                    break;
                }
            case __WEBPACK_IMPORTED_MODULE_0__constraint__["a" /* Operator */].Eq:
                {
                    if (strength < __WEBPACK_IMPORTED_MODULE_3__strength__["a" /* Strength */].required) {
                        var errplus = this._makeSymbol(SymbolType.Error);
                        var errminus = this._makeSymbol(SymbolType.Error);
                        tag.marker = errplus;
                        tag.other = errminus;
                        row.insertSymbol(errplus, -1.0); // v = eplus - eminus
                        row.insertSymbol(errminus, 1.0); // v - eplus + eminus = 0
                        objective.insertSymbol(errplus, strength);
                        objective.insertSymbol(errminus, strength);
                    }
                    else {
                        var dummy = this._makeSymbol(SymbolType.Dummy);
                        tag.marker = dummy;
                        row.insertSymbol(dummy);
                    }
                    break;
                }
        }
        // Ensure the row has a positive constant.
        if (row.constant() < 0.0) {
            row.reverseSign();
        }
        return { row: row, tag: tag };
    };
    /**
     * Choose the subject for solving for the row.
     *
     * This method will choose the best subject for using as the solve
     * target for the row. An invalid symbol will be returned if there
     * is no valid target.
     *
     * The symbols are chosen according to the following precedence:
     *
     * 1) The first symbol representing an external variable.
     * 2) A negative slack or error tag variable.
     *
     * If a subject cannot be found, an invalid symbol will be returned.
     *
     * @private
     */
    Solver.prototype._chooseSubject = function (row, tag) {
        var cells = row.cells();
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            if (pair.first.type() === SymbolType.External) {
                return pair.first;
            }
        }
        var type = tag.marker.type();
        if (type === SymbolType.Slack || type === SymbolType.Error) {
            if (row.coefficientFor(tag.marker) < 0.0) {
                return tag.marker;
            }
        }
        type = tag.other.type();
        if (type === SymbolType.Slack || type === SymbolType.Error) {
            if (row.coefficientFor(tag.other) < 0.0) {
                return tag.other;
            }
        }
        return INVALID_SYMBOL;
    };
    /**
     * Add the row to the tableau using an artificial variable.
     *
     * This will return false if the constraint cannot be satisfied.
     *
     * @private
     */
    Solver.prototype._addWithArtificialVariable = function (row) {
        // Create and add the artificial variable to the tableau.
        var art = this._makeSymbol(SymbolType.Slack);
        this._rowMap.insert(art, row.copy());
        this._artificial = row.copy();
        // Optimize the artificial objective. This is successful
        // only if the artificial objective is optimized to zero.
        this._optimize(this._artificial);
        var success = nearZero(this._artificial.constant());
        this._artificial = null;
        // If the artificial variable is basic, pivot the row so that
        // it becomes non-basic. If the row is constant, exit early.
        var pair = this._rowMap.erase(art);
        if (pair !== undefined) {
            var basicRow = pair.second;
            if (basicRow.isConstant()) {
                return success;
            }
            var entering = this._anyPivotableSymbol(basicRow);
            if (entering.type() === SymbolType.Invalid) {
                return false; // unsatisfiable (will this ever happen?)
            }
            basicRow.solveForEx(art, entering);
            this._substitute(entering, basicRow);
            this._rowMap.insert(entering, basicRow);
        }
        // Remove the artificial variable from the tableau.
        var rows = this._rowMap;
        for (var i = 0, n = rows.size(); i < n; ++i) {
            rows.itemAt(i).second.removeSymbol(art);
        }
        this._objective.removeSymbol(art);
        return success;
    };
    /**
     * Substitute the parametric symbol with the given row.
     *
     * This method will substitute all instances of the parametric symbol
     * in the tableau and the objective function with the given row.
     *
     * @private
     */
    Solver.prototype._substitute = function (symbol, row) {
        var rows = this._rowMap;
        for (var i = 0, n = rows.size(); i < n; ++i) {
            var pair = rows.itemAt(i);
            pair.second.substitute(symbol, row);
            if (pair.second.constant() < 0.0 &&
                pair.first.type() !== SymbolType.External) {
                this._infeasibleRows.push(pair.first);
            }
        }
        this._objective.substitute(symbol, row);
        if (this._artificial) {
            this._artificial.substitute(symbol, row);
        }
    };
    /**
     * Optimize the system for the given objective function.
     *
     * This method performs iterations of Phase 2 of the simplex method
     * until the objective function reaches a minimum.
     *
     * @private
     */
    Solver.prototype._optimize = function (objective) {
        while (true) {
            var entering = this._getEnteringSymbol(objective);
            if (entering.type() === SymbolType.Invalid) {
                return;
            }
            var leaving = this._getLeavingSymbol(entering);
            if (leaving.type() === SymbolType.Invalid) {
                throw new Error("the objective is unbounded");
            }
            // pivot the entering symbol into the basis
            var row = this._rowMap.erase(leaving).second;
            row.solveForEx(leaving, entering);
            this._substitute(entering, row);
            this._rowMap.insert(entering, row);
        }
    };
    /**
     * Optimize the system using the dual of the simplex method.
     *
     * The current state of the system should be such that the objective
     * function is optimal, but not feasible. This method will perform
     * an iteration of the dual simplex method to make the solution both
     * optimal and feasible.
     *
     * @private
     */
    Solver.prototype._dualOptimize = function () {
        var rows = this._rowMap;
        var infeasible = this._infeasibleRows;
        while (infeasible.length !== 0) {
            var leaving = infeasible.pop();
            var pair = rows.find(leaving);
            if (pair !== undefined && pair.second.constant() < 0.0) {
                var entering = this._getDualEnteringSymbol(pair.second);
                if (entering.type() === SymbolType.Invalid) {
                    throw new Error("dual optimize failed");
                }
                // pivot the entering symbol into the basis
                var row = pair.second;
                rows.erase(leaving);
                row.solveForEx(leaving, entering);
                this._substitute(entering, row);
                rows.insert(entering, row);
            }
        }
    };
    /**
     * Compute the entering variable for a pivot operation.
     *
     * This method will return first symbol in the objective function which
     * is non-dummy and has a coefficient less than zero. If no symbol meets
     * the criteria, it means the objective function is at a minimum, and an
     * invalid symbol is returned.
     *
     * @private
     */
    Solver.prototype._getEnteringSymbol = function (objective) {
        var cells = objective.cells();
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            var symbol = pair.first;
            if (pair.second < 0.0 && symbol.type() !== SymbolType.Dummy) {
                return symbol;
            }
        }
        return INVALID_SYMBOL;
    };
    /**
     * Compute the entering symbol for the dual optimize operation.
     *
     * This method will return the symbol in the row which has a positive
     * coefficient and yields the minimum ratio for its respective symbol
     * in the objective function. The provided row *must* be infeasible.
     * If no symbol is found which meats the criteria, an invalid symbol
     * is returned.
     *
     * @private
     */
    Solver.prototype._getDualEnteringSymbol = function (row) {
        var ratio = Number.MAX_VALUE;
        var entering = INVALID_SYMBOL;
        var cells = row.cells();
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            var symbol = pair.first;
            var c = pair.second;
            if (c > 0.0 && symbol.type() !== SymbolType.Dummy) {
                var coeff = this._objective.coefficientFor(symbol);
                var r = coeff / c;
                if (r < ratio) {
                    ratio = r;
                    entering = symbol;
                }
            }
        }
        return entering;
    };
    /**
     * Compute the symbol for pivot exit row.
     *
     * This method will return the symbol for the exit row in the row
     * map. If no appropriate exit symbol is found, an invalid symbol
     * will be returned. This indicates that the objective function is
     * unbounded.
     *
     * @private
     */
    Solver.prototype._getLeavingSymbol = function (entering) {
        var ratio = Number.MAX_VALUE;
        var found = INVALID_SYMBOL;
        var rows = this._rowMap;
        for (var i = 0, n = rows.size(); i < n; ++i) {
            var pair = rows.itemAt(i);
            var symbol = pair.first;
            if (symbol.type() !== SymbolType.External) {
                var row = pair.second;
                var temp = row.coefficientFor(entering);
                if (temp < 0.0) {
                    var temp_ratio = -row.constant() / temp;
                    if (temp_ratio < ratio) {
                        ratio = temp_ratio;
                        found = symbol;
                    }
                }
            }
        }
        return found;
    };
    /**
     * Compute the leaving symbol for a marker variable.
     *
     * This method will return a symbol corresponding to a basic row
     * which holds the given marker variable. The row will be chosen
     * according to the following precedence:
     *
     * 1) The row with a restricted basic varible and a negative coefficient
     *    for the marker with the smallest ratio of -constant / coefficient.
     *
     * 2) The row with a restricted basic variable and the smallest ratio
     *    of constant / coefficient.
     *
     * 3) The last unrestricted row which contains the marker.
     *
     * If the marker does not exist in any row, an invalid symbol will be
     * returned. This indicates an internal solver error since the marker
     * *should* exist somewhere in the tableau.
     *
     * @private
     */
    Solver.prototype._getMarkerLeavingSymbol = function (marker) {
        var dmax = Number.MAX_VALUE;
        var r1 = dmax;
        var r2 = dmax;
        var invalid = INVALID_SYMBOL;
        var first = invalid;
        var second = invalid;
        var third = invalid;
        var rows = this._rowMap;
        for (var i = 0, n = rows.size(); i < n; ++i) {
            var pair = rows.itemAt(i);
            var row = pair.second;
            var c = row.coefficientFor(marker);
            if (c === 0.0) {
                continue;
            }
            var symbol = pair.first;
            if (symbol.type() === SymbolType.External) {
                third = symbol;
            }
            else if (c < 0.0) {
                var r = -row.constant() / c;
                if (r < r1) {
                    r1 = r;
                    first = symbol;
                }
            }
            else {
                var r = row.constant() / c;
                if (r < r2) {
                    r2 = r;
                    second = symbol;
                }
            }
        }
        if (first !== invalid) {
            return first;
        }
        if (second !== invalid) {
            return second;
        }
        return third;
    };
    /**
     * Remove the effects of a constraint on the objective function.
     *
     * @private
     */
    Solver.prototype._removeConstraintEffects = function (cn, tag) {
        if (tag.marker.type() === SymbolType.Error) {
            this._removeMarkerEffects(tag.marker, cn.strength());
        }
        if (tag.other.type() === SymbolType.Error) {
            this._removeMarkerEffects(tag.other, cn.strength());
        }
    };
    /**
     * Remove the effects of an error marker on the objective function.
     *
     * @private
     */
    Solver.prototype._removeMarkerEffects = function (marker, strength) {
        var pair = this._rowMap.find(marker);
        if (pair !== undefined) {
            this._objective.insertRow(pair.second, -strength);
        }
        else {
            this._objective.insertSymbol(marker, -strength);
        }
    };
    /**
     * Get the first Slack or Error symbol in the row.
     *
     * If no such symbol is present, an invalid symbol will be returned.
     *
     * @private
     */
    Solver.prototype._anyPivotableSymbol = function (row) {
        var cells = row.cells();
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            var type = pair.first.type();
            if (type === SymbolType.Slack || type === SymbolType.Error) {
                return pair.first;
            }
        }
        return INVALID_SYMBOL;
    };
    /**
     * Returns a new Symbol of the given type.
     *
     * @private
     */
    Solver.prototype._makeSymbol = function (type) {
        return new Symbol(type, this._idTick++);
    };
    return Solver;
}());

/**
 * Test whether a value is approximately zero.
 * @private
 */
function nearZero(value) {
    var eps = 1.0e-8;
    return value < 0.0 ? -value < eps : value < eps;
}
/**
 * An internal function for creating a constraint map.
 * @private
 */
function createCnMap() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__maptype__["a" /* createMap */])(__WEBPACK_IMPORTED_MODULE_0__constraint__["b" /* Constraint */].Compare);
}
/**
 * An internal function for creating a row map.
 * @private
 */
function createRowMap() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__maptype__["a" /* createMap */])(Symbol.Compare);
}
/**
 * An internal function for creating a variable map.
 * @private
 */
function createVarMap() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__maptype__["a" /* createMap */])(__WEBPACK_IMPORTED_MODULE_4__variable__["a" /* Variable */].Compare);
}
/**
 * An internal function for creating an edit map.
 * @private
 */
function createEditMap() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__maptype__["a" /* createMap */])(__WEBPACK_IMPORTED_MODULE_4__variable__["a" /* Variable */].Compare);
}
/**
 * An enum defining the available symbol types.
 * @private
 */
var SymbolType;
(function (SymbolType) {
    SymbolType[SymbolType["Invalid"] = 0] = "Invalid";
    SymbolType[SymbolType["External"] = 1] = "External";
    SymbolType[SymbolType["Slack"] = 2] = "Slack";
    SymbolType[SymbolType["Error"] = 3] = "Error";
    SymbolType[SymbolType["Dummy"] = 4] = "Dummy";
})(SymbolType || (SymbolType = {}));
/**
 * An internal class representing a symbol in the solver.
 * @private
 */
var Symbol = /** @class */ (function () {
    /**
     * Construct a new Symbol
     *
     * @param [type] The type of the symbol.
     * @param [id] The unique id number of the symbol.
     */
    function Symbol(type, id) {
        this._id = id;
        this._type = type;
    }
    /**
     * The static Symbol comparison function.
     */
    Symbol.Compare = function (a, b) {
        return a.id() - b.id();
    };
    /**
     * Returns the unique id number of the symbol.
     */
    Symbol.prototype.id = function () {
        return this._id;
    };
    /**
     * Returns the type of the symbol.
     */
    Symbol.prototype.type = function () {
        return this._type;
    };
    return Symbol;
}());
/**
 * A static invalid symbol
 * @private
 */
var INVALID_SYMBOL = new Symbol(SymbolType.Invalid, -1);
/**
 * An internal row class used by the solver.
 * @private
 */
var Row = /** @class */ (function () {
    /**
     * Construct a new Row.
     */
    function Row(constant) {
        if (constant === void 0) { constant = 0.0; }
        this._cellMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__maptype__["a" /* createMap */])(Symbol.Compare);
        this._constant = constant;
    }
    /**
     * Returns the mapping of symbols to coefficients.
     */
    Row.prototype.cells = function () {
        return this._cellMap;
    };
    /**
     * Returns the constant for the row.
     */
    Row.prototype.constant = function () {
        return this._constant;
    };
    /**
     * Returns true if the row is a constant value.
     */
    Row.prototype.isConstant = function () {
        return this._cellMap.empty();
    };
    /**
     * Returns true if the Row has all dummy symbols.
     */
    Row.prototype.allDummies = function () {
        var cells = this._cellMap;
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            if (pair.first.type() !== SymbolType.Dummy) {
                return false;
            }
        }
        return true;
    };
    /**
     * Create a copy of the row.
     */
    Row.prototype.copy = function () {
        var theCopy = new Row(this._constant);
        theCopy._cellMap = this._cellMap.copy();
        return theCopy;
    };
    /**
     * Add a constant value to the row constant.
     *
     * Returns the new value of the constant.
     */
    Row.prototype.add = function (value) {
        return this._constant += value;
    };
    /**
     * Insert the symbol into the row with the given coefficient.
     *
     * If the symbol already exists in the row, the coefficient
     * will be added to the existing coefficient. If the resulting
     * coefficient is zero, the symbol will be removed from the row.
     */
    Row.prototype.insertSymbol = function (symbol, coefficient) {
        if (coefficient === void 0) { coefficient = 1.0; }
        var pair = this._cellMap.setDefault(symbol, function () { return 0.0; });
        if (nearZero(pair.second += coefficient)) {
            this._cellMap.erase(symbol);
        }
    };
    /**
     * Insert a row into this row with a given coefficient.
     *
     * The constant and the cells of the other row will be
     * multiplied by the coefficient and added to this row. Any
     * cell with a resulting coefficient of zero will be removed
     * from the row.
     */
    Row.prototype.insertRow = function (other, coefficient) {
        if (coefficient === void 0) { coefficient = 1.0; }
        this._constant += other._constant * coefficient;
        var cells = other._cellMap;
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            this.insertSymbol(pair.first, pair.second * coefficient);
        }
    };
    /**
     * Remove a symbol from the row.
     */
    Row.prototype.removeSymbol = function (symbol) {
        this._cellMap.erase(symbol);
    };
    /**
     * Reverse the sign of the constant and cells in the row.
     */
    Row.prototype.reverseSign = function () {
        this._constant = -this._constant;
        var cells = this._cellMap;
        for (var i = 0, n = cells.size(); i < n; ++i) {
            var pair = cells.itemAt(i);
            pair.second = -pair.second;
        }
    };
    /**
     * Solve the row for the given symbol.
     *
     * This method assumes the row is of the form
     * a * x + b * y + c = 0 and (assuming solve for x) will modify
     * the row to represent the right hand side of
     * x = -b/a * y - c / a. The target symbol will be removed from
     * the row, and the constant and other cells will be multiplied
     * by the negative inverse of the target coefficient.
     *
     * The given symbol *must* exist in the row.
     */
    Row.prototype.solveFor = function (symbol) {
        var cells = this._cellMap;
        var pair = cells.erase(symbol);
        var coeff = -1.0 / pair.second;
        this._constant *= coeff;
        for (var i = 0, n = cells.size(); i < n; ++i) {
            cells.itemAt(i).second *= coeff;
        }
    };
    /**
     * Solve the row for the given symbols.
     *
     * This method assumes the row is of the form
     * x = b * y + c and will solve the row such that
     * y = x / b - c / b. The rhs symbol will be removed from the
     * row, the lhs added, and the result divided by the negative
     * inverse of the rhs coefficient.
     *
     * The lhs symbol *must not* exist in the row, and the rhs
     * symbol must* exist in the row.
     */
    Row.prototype.solveForEx = function (lhs, rhs) {
        this.insertSymbol(lhs, -1.0);
        this.solveFor(rhs);
    };
    /**
     * Returns the coefficient for the given symbol.
     */
    Row.prototype.coefficientFor = function (symbol) {
        var pair = this._cellMap.find(symbol);
        return pair !== undefined ? pair.second : 0.0;
    };
    /**
     * Substitute a symbol with the data from another row.
     *
     * Given a row of the form a * x + b and a substitution of the
     * form x = 3 * y + c the row will be updated to reflect the
     * expression 3 * a * y + a * c + b.
     *
     * If the symbol does not exist in the row, this is a no-op.
     */
    Row.prototype.substitute = function (symbol, row) {
        var pair = this._cellMap.erase(symbol);
        if (pair !== undefined) {
            this.insertRow(row, pair.second);
        }
    };
    return Row;
}());


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86), __webpack_require__(494)(module)))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(884);
moment.tz.load(__webpack_require__(624));


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.31
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(6)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.31",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 885 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(58);
var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);
var assign = __webpack_require__(28);

var ReactPropTypesSecret = __webpack_require__(888);
var checkPropTypes = __webpack_require__(886);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(33);

var focusNode = __webpack_require__(341);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(145);
var ExecutionEnvironment = __webpack_require__(46);
var FallbackCompositionState = __webpack_require__(897);
var SyntheticCompositionEvent = __webpack_require__(934);
var SyntheticInputEvent = __webpack_require__(937);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(467);
var ExecutionEnvironment = __webpack_require__(46);
var ReactInstrumentation = __webpack_require__(59);

var camelizeStyleName = __webpack_require__(857);
var dangerousStyleValue = __webpack_require__(943);
var hyphenateStyleName = __webpack_require__(864);
var memoizeStringOnly = __webpack_require__(867);
var warning = __webpack_require__(20);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(144);
var EventPropagators = __webpack_require__(145);
var ExecutionEnvironment = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(66);
var SyntheticEvent = __webpack_require__(75);

var inputValueTracking = __webpack_require__(483);
var getEventTarget = __webpack_require__(255);
var isEventSupported = __webpack_require__(256);
var isTextInputElement = __webpack_require__(485);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var DOMLazyTree = __webpack_require__(123);
var ExecutionEnvironment = __webpack_require__(46);

var createNodesFromMarkup = __webpack_require__(860);
var emptyFunction = __webpack_require__(58);
var invariant = __webpack_require__(13);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(145);
var ReactDOMComponentTree = __webpack_require__(33);
var SyntheticMouseEvent = __webpack_require__(186);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var PooledClass = __webpack_require__(104);

var getTextContentAccessor = __webpack_require__(482);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(124);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(125);

var instantiateReactComponent = __webpack_require__(484);
var KeyEscapeUtils = __webpack_require__(247);
var shouldUpdateReactComponent = __webpack_require__(257);
var traverseAllChildren = __webpack_require__(487);
var warning = __webpack_require__(20);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(489);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(143)))

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(243);
var ReactDOMIDOperations = __webpack_require__(907);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var React = __webpack_require__(126);
var ReactComponentEnvironment = __webpack_require__(249);
var ReactCurrentOwner = __webpack_require__(76);
var ReactErrorUtils = __webpack_require__(250);
var ReactInstanceMap = __webpack_require__(146);
var ReactInstrumentation = __webpack_require__(59);
var ReactNodeTypes = __webpack_require__(477);
var ReactReconciler = __webpack_require__(125);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(183);
var invariant = __webpack_require__(13);
var shallowEqual = __webpack_require__(239);
var shouldUpdateReactComponent = __webpack_require__(257);
var warning = __webpack_require__(20);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(33);
var ReactDefaultInjection = __webpack_require__(915);
var ReactMount = __webpack_require__(476);
var ReactReconciler = __webpack_require__(125);
var ReactUpdates = __webpack_require__(66);
var ReactVersion = __webpack_require__(928);

var findDOMNode = __webpack_require__(944);
var getHostComponentFromComposite = __webpack_require__(481);
var renderSubtreeIntoContainer = __webpack_require__(951);
var warning = __webpack_require__(20);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var AutoFocusUtils = __webpack_require__(890);
var CSSPropertyOperations = __webpack_require__(892);
var DOMLazyTree = __webpack_require__(123);
var DOMNamespaces = __webpack_require__(244);
var DOMProperty = __webpack_require__(124);
var DOMPropertyOperations = __webpack_require__(469);
var EventPluginHub = __webpack_require__(144);
var EventPluginRegistry = __webpack_require__(245);
var ReactBrowserEventEmitter = __webpack_require__(185);
var ReactDOMComponentFlags = __webpack_require__(470);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMInput = __webpack_require__(908);
var ReactDOMOption = __webpack_require__(909);
var ReactDOMSelect = __webpack_require__(471);
var ReactDOMTextarea = __webpack_require__(912);
var ReactInstrumentation = __webpack_require__(59);
var ReactMultiChild = __webpack_require__(921);
var ReactServerRenderingTransaction = __webpack_require__(926);

var emptyFunction = __webpack_require__(58);
var escapeTextContentForBrowser = __webpack_require__(188);
var invariant = __webpack_require__(13);
var isEventSupported = __webpack_require__(256);
var shallowEqual = __webpack_require__(239);
var inputValueTracking = __webpack_require__(483);
var validateDOMNesting = __webpack_require__(258);
var warning = __webpack_require__(20);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(258);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var DOMLazyTree = __webpack_require__(123);
var ReactDOMComponentTree = __webpack_require__(33);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(243);
var ReactDOMComponentTree = __webpack_require__(33);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var DOMPropertyOperations = __webpack_require__(469);
var LinkedValueUtils = __webpack_require__(248);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(66);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var React = __webpack_require__(126);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMSelect = __webpack_require__(471);

var warning = __webpack_require__(20);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);

var getNodeForCharacterOffset = __webpack_require__(948);
var getTextContentAccessor = __webpack_require__(482);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var DOMChildrenOperations = __webpack_require__(243);
var DOMLazyTree = __webpack_require__(123);
var ReactDOMComponentTree = __webpack_require__(33);

var escapeTextContentForBrowser = __webpack_require__(188);
var invariant = __webpack_require__(13);
var validateDOMNesting = __webpack_require__(258);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21),
    _assign = __webpack_require__(28);

var LinkedValueUtils = __webpack_require__(248);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(66);

var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var ReactUpdates = __webpack_require__(66);
var Transaction = __webpack_require__(187);

var emptyFunction = __webpack_require__(58);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(889);
var BeforeInputEventPlugin = __webpack_require__(891);
var ChangeEventPlugin = __webpack_require__(893);
var DefaultEventPluginOrder = __webpack_require__(895);
var EnterLeaveEventPlugin = __webpack_require__(896);
var HTMLDOMPropertyConfig = __webpack_require__(898);
var ReactComponentBrowserEnvironment = __webpack_require__(900);
var ReactDOMComponent = __webpack_require__(903);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMEmptyComponent = __webpack_require__(905);
var ReactDOMTreeTraversal = __webpack_require__(913);
var ReactDOMTextComponent = __webpack_require__(911);
var ReactDefaultBatchingStrategy = __webpack_require__(914);
var ReactEventListener = __webpack_require__(918);
var ReactInjection = __webpack_require__(919);
var ReactReconcileTransaction = __webpack_require__(924);
var SVGDOMPropertyConfig = __webpack_require__(929);
var SelectEventPlugin = __webpack_require__(930);
var SimpleEventPlugin = __webpack_require__(931);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(144);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var EventListener = __webpack_require__(340);
var ExecutionEnvironment = __webpack_require__(46);
var PooledClass = __webpack_require__(104);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(66);

var getEventTarget = __webpack_require__(255);
var getUnboundedScrollPosition = __webpack_require__(862);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(124);
var EventPluginHub = __webpack_require__(144);
var EventPluginUtils = __webpack_require__(246);
var ReactComponentEnvironment = __webpack_require__(249);
var ReactEmptyComponent = __webpack_require__(472);
var ReactBrowserEventEmitter = __webpack_require__(185);
var ReactHostComponent = __webpack_require__(474);
var ReactUpdates = __webpack_require__(66);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(942);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactComponentEnvironment = __webpack_require__(249);
var ReactInstanceMap = __webpack_require__(146);
var ReactInstrumentation = __webpack_require__(59);

var ReactCurrentOwner = __webpack_require__(76);
var ReactReconciler = __webpack_require__(125);
var ReactChildReconciler = __webpack_require__(899);

var emptyFunction = __webpack_require__(58);
var flattenChildren = __webpack_require__(945);
var invariant = __webpack_require__(13);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var invariant = __webpack_require__(13);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var CallbackQueue = __webpack_require__(468);
var PooledClass = __webpack_require__(104);
var ReactBrowserEventEmitter = __webpack_require__(185);
var ReactInputSelection = __webpack_require__(475);
var ReactInstrumentation = __webpack_require__(59);
var Transaction = __webpack_require__(187);
var ReactUpdateQueue = __webpack_require__(251);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(922);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(28);

var PooledClass = __webpack_require__(104);
var Transaction = __webpack_require__(187);
var ReactInstrumentation = __webpack_require__(59);
var ReactServerUpdateQueue = __webpack_require__(927);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(251);

var warning = __webpack_require__(20);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(145);
var ExecutionEnvironment = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInputSelection = __webpack_require__(475);
var SyntheticEvent = __webpack_require__(75);

var getActiveElement = __webpack_require__(342);
var isTextInputElement = __webpack_require__(485);
var shallowEqual = __webpack_require__(239);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(21);

var EventListener = __webpack_require__(340);
var EventPropagators = __webpack_require__(145);
var ReactDOMComponentTree = __webpack_require__(33);
var SyntheticAnimationEvent = __webpack_require__(932);
var SyntheticClipboardEvent = __webpack_require__(933);
var SyntheticEvent = __webpack_require__(75);
var SyntheticFocusEvent = __webpack_require__(936);
var SyntheticKeyboardEvent = __webpack_require__(938);
var SyntheticMouseEvent = __webpack_require__(186);
var SyntheticDragEvent = __webpack_require__(935);
var SyntheticTouchEvent = __webpack_require__(939);
var SyntheticTransitionEvent = __webpack_require__(940);
var SyntheticUIEvent = __webpack_require__(147);
var SyntheticWheelEvent = __webpack_require__(941);

var emptyFunction = __webpack_require__(58);
var getEventCharCode = __webpack_require__(253);
var invariant = __webpack_require__(13);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(186);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(147);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(147);

var getEventCharCode = __webpack_require__(253);
var getEventKey = __webpack_require__(946);
var getEventModifierState = __webpack_require__(254);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(147);

var getEventModifierState = __webpack_require__(254);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(75);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(186);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(467);
var warning = __webpack_require__(20);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstanceMap = __webpack_require__(146);

var getHostComponentFromComposite = __webpack_require__(481);
var invariant = __webpack_require__(13);
var warning = __webpack_require__(20);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(247);
var traverseAllChildren = __webpack_require__(487);
var warning = __webpack_require__(20);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(489);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(143)))

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(253);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(46);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(188);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(476);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(148);

var invariant = __webpack_require__(13);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(953);
var ReactElement = __webpack_require__(127);

var emptyFunction = __webpack_require__(58);
var traverseAllChildren = __webpack_require__(963);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(127);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(127),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(466);

module.exports = factory(isValidElement);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(488),
    Component = _require.Component;

var _require2 = __webpack_require__(127),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(491);
var factory = __webpack_require__(855);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(148);

var ReactElement = __webpack_require__(127);

var invariant = __webpack_require__(13);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(148);

var ReactCurrentOwner = __webpack_require__(76);
var REACT_ELEMENT_TYPE = __webpack_require__(490);

var getIteratorFn = __webpack_require__(959);
var invariant = __webpack_require__(13);
var KeyEscapeUtils = __webpack_require__(952);
var warning = __webpack_require__(20);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86), __webpack_require__(143)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBerth = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
function AddBerth(ajax, entrypoints, data, pierSettings, _a) {
    var SchedulingAuthorityId = _a.SchedulingAuthorityId;
    var client = ajax.Url(entrypoints.AddBerth), request = s_js_1.default.data(null);
    return {
        Add: Add
    };
    function Add() {
        if (request() && !request().Response())
            return;
        var lengthUOM = pierSettings.DefaultLengthUOM() || UOM_1.default.Foot, req = client.Post({
            Id: 0,
            SchedulingAuthorityId: SchedulingAuthorityId,
            Location: {
                Id: 0,
                Name: 'New berth'
            },
            Length: {
                Num: lengthUOM === UOM_1.default.Meter ? 30 : 100,
                UOM: lengthUOM
            }
        });
        request(req);
        req.then(function (json) {
            data.Berths.update1(req.Date, json);
            window.location.hash = "#!berthprofile?id=" + json.Id + "&editName=true";
        });
    }
}
exports.AddBerth = AddBerth;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationContext = void 0;
var _ = __webpack_require__(67);
var DateDisplayOrder_1 = __webpack_require__(1396);
function LocalizationContext(tzutils, dateTimeSettings) {
    return {
        tzutils: tzutils,
        DateFormatDefaults: DateFormatDefaults(dateTimeSettings)
    };
}
exports.LocalizationContext = LocalizationContext;
// Default date/time formatting.
// Takes into account culture info on DomainSettings.
// Individual DateOrTimePickerBase instances can still override these defaults.
//
// TH: This is all based on a roll-our-own approach to localization, w/ custom settings in DomainSettings.
// Medium term, we might wanna switch to a more out-of-the-box solution based on the localization tools already provided by .NET, momentjs, and Kendo UI.
// Also, as of 4/20/2016, only the datepickers have been localized.
// For consistency, we need to localize all date displays in the UI and in other messaging like workflow emails and operational notifications.
function DateFormatDefaults(dateTimeSettings) {
    // 1. Date formatting...
    // Kendo-specific date formatting tokens
    var kMonth = 'MM', kDay = 'dd', kFullYear = 'yyyy', kShortYear = 'yy';
    var dateComponents = function () {
        var dateOrder = dateTimeSettings.DateOrder();
        if (dateOrder === DateDisplayOrder_1.DateDisplayOrder.MonthDayYear)
            return [kMonth, kDay, kFullYear];
        if (dateOrder === DateDisplayOrder_1.DateDisplayOrder.DayMonthYear)
            return [kDay, kMonth, kFullYear];
        if (dateOrder === DateDisplayOrder_1.DateDisplayOrder.YearMonthDay)
            return [kFullYear, kMonth, kDay];
        throw new Error('Unknown DateDisplayOrder value: ' + dateOrder);
    };
    var dateFormat = function () { return dateComponents().join(dateTimeSettings.DateSeparator()); };
    var knownDateSeparators = function () { return _.uniq(['/', '-', '.', ''].concat(dateTimeSettings.DateSeparator())); };
    var dateParseFormats = function () { return knownDateSeparators().reduce(function (formats, sep) {
        var withFullYear = dateComponents().join(sep), withShortYear = withFullYear.replace(kFullYear, kShortYear);
        return formats.concat(withFullYear, withShortYear);
    }, []); };
    // 2. Time formatting...
    // TH: 24-hour time only. Kendo format for 24-hour is 'HH:mm'.
    var timeComponents = ['HH', 'mm'];
    var timeFormat = function () { return timeComponents.join(dateTimeSettings.TimeSeparator()); };
    var knownTimeSeparators = function () { return _.uniq([':', '.', ''].concat(dateTimeSettings.TimeSeparator())); };
    var timeParseFormats = function () { return knownTimeSeparators().map(function (sep) {
        return timeComponents.join(sep);
    }).concat('HH'); }; // Also allow entering hours w/ no minutes
    return {
        dateFormat: dateFormat,
        dateParseFormats: dateParseFormats,
        timeFormat: timeFormat,
        timeParseFormats: timeParseFormats
    };
}


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.uomIsFeet = void 0;
var UOM_1 = __webpack_require__(25);
var uomIsFeet = function (uom) { return (function (val) {
    if (val === undefined)
        return uom() === UOM_1.default.Foot;
    uom(val ? UOM_1.default.Foot : UOM_1.default.Meter);
    return val;
}); };
exports.uomIsFeet = uomIsFeet;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxErrors = void 0;
var s_js_1 = __webpack_require__(0);
function AjaxErrors(domain, ajax, loginModel) {
    var error = s_js_1.default.data(null), showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: false, onHidePopup: function () { return showLogin(false); } }) : null; });
    s_js_1.default(function () {
        var resp = ajax.LastResponse();
        if (resp)
            checkResponse(resp);
    });
    return {
        Error: error,
        Login: login,
        SupportHref: supportHref
    };
    function checkResponse(resp) {
        if (resp.Status === 401) { // unauthorized, redirect to login page
            showLogin(true);
        }
        else if (resp.Status === 500) {
            var showDetails_1 = s_js_1.default.data(false);
            error({
                StatusCode: resp.Status,
                ToggleDetails: function () { showDetails_1(!showDetails_1()); },
                ShowDetails: showDetails_1,
                ServerMessage: resp.Data.Message,
                ServerStackTrace: resp.Data.StackTrace,
                Remove: function () { error(null); }
            });
        }
    }
    function supportHref() {
        return 'mailto:' + domain.SupportEmail();
    }
}
exports.AjaxErrors = AjaxErrors;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxErrorsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(130);
var eventWrappers_1 = __webpack_require__(8);
exports.AjaxErrorsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var err = m.Error();
    return (React.createElement("div", null,
        err && React.createElement("div", { className: "ajaxerrors" },
            React.createElement("div", { className: "ajaxerrors-content alert alert-danger" },
                React.createElement("div", null,
                    React.createElement("span", { className: "controls" },
                        React.createElement("a", { href: "#", onClick: eventWrappers_1.noDefault(err.ToggleDetails) }, "Details"),
                        React.createElement("span", { className: "pc-icon-bullet" }),
                        React.createElement("a", { href: "#", onClick: eventWrappers_1.noDefault(err.Remove) },
                            React.createElement("i", { className: "glyphicon glyphicon-remove" }))),
                    React.createElement("span", { className: "message" },
                        "The server encountered an internal error performing your request (Status Code ",
                        err.StatusCode,
                        "). Please re-load this page and retry your request. If this problem persists, please contact",
                        ' ',
                        React.createElement("a", { href: m.SupportHref() }, "Support"),
                        ".")),
                React.createElement("ul", { className: "error-properties", hidden: !err.ShowDetails() },
                    React.createElement("li", null,
                        React.createElement("label", null, "Server Message"),
                        React.createElement("span", null, err.ServerMessage)),
                    React.createElement("li", null,
                        React.createElement("label", null, "Server Stack Trace"),
                        React.createElement("span", null, err.ServerStackTrace))))),
        React.createElement(view_1.LoginView, { modelContainer: m.Login })));
});


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var s_js_1 = __webpack_require__(0);
var React = __webpack_require__(2);
var ReactDOM = __webpack_require__(622);
__webpack_require__(621);
var supercritical_1 = __webpack_require__(4);
var deps_1 = __webpack_require__(623);
var loadInitialData = function () {
    var json = window.PORTCALLINITIALDATA;
    if (json) {
        var data = deps_1.deps.queryCaches.bootstrap.InitialData.update1(null, json);
        deps_1.deps.user(data.UserSummary());
        deps_1.deps.initialDataLoaded(true);
        window.PORTCALLINITIALDATA = null; // free GC
        window.PORTCALLINITIALDATACALLBACK = null;
    }
    else {
        window.PORTCALLINITIALDATACALLBACK = loadInitialData;
    }
};
loadInitialData();
deps_1.deps.router.running(true);
// TH 12/21/2016 -- Global scroll to top on route changes
s_js_1.default.root(function () { return s_js_1.default.on(deps_1.deps.router.route, function () { return window.scrollTo(0, 0); }); });
var Container = supercritical_1.default(function () { var _a, _b; return (_b = (_a = deps_1.deps.router.route()) === null || _a === void 0 ? void 0 : _a.view) !== null && _b !== void 0 ? _b : null; });
ReactDOM.render(React.createElement(Container, null), document.getElementById("app"));


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootstrapCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var InitialData_1 = __webpack_require__(1269);
var PilotsInitialData_1 = __webpack_require__(1320);
var AuthorizedData_1 = __webpack_require__(1224);
var DomainSummary_1 = __webpack_require__(1257);
var UserSummary_1 = __webpack_require__(203);
var BootstrapCache = /** @class */ (function (_super) {
    __extends(BootstrapCache, _super);
    function BootstrapCache(data) {
        var _this = _super.call(this) || this;
        _this.InitialData = PCCache_1.PCCollection(InitialData_1.InitialData);
        _this.PilotsInitialData = PCCache_1.PCCollection(PilotsInitialData_1.PilotsInitialData);
        _this.AuthorizedData = PCCache_1.PCCollection(AuthorizedData_1.AuthorizedData);
        _this.DomainSummaries = PCCache_1.PCCollection(DomainSummary_1.DomainSummary);
        _this.UserSummaries = PCCache_1.PCCollection(UserSummary_1.UserSummary);
        new DataCache_1.QueryResultRelationship(_this.InitialData, _this.UserSummaries, function (d) { return d.UserSummary; });
        new DataCache_1.SharedKeyRelationship(_this.InitialData, _this.DomainSummaries, function (a) { return a.DomainSummary; }, null);
        new DataCache_1.SharedKeyRelationship(_this.InitialData, data.Domains, function (a) { return a.Domain; }, null);
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.Countries, function (a) { return a.Countries; });
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.Roles, function (a) { return a.Roles; });
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.UIThemes, function (a) { return a.UIThemes; });
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.AutomationSystems, function (d) { return d.AutomationSystems; });
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.MilestoneTypes, function (d) { return d.MilestoneTypes; });
        new DataCache_1.QueryResultsRelationship(_this.InitialData, data.CoordinationCardStatuses, function (d) { return d.CoordinationCardStatuses; });
        new DataCache_1.SharedKeyRelationship(_this.AuthorizedData, data.Domains, function (d) { return d.Domain; }, null);
        new DataCache_1.QueryResultRelationship(_this.AuthorizedData, _this.UserSummaries, function (d) { return d.UserSummary; });
        new DataCache_1.SharedKeyRelationship(_this.DomainSummaries, data.DomainSettings, function (d) { return d.Settings; }, null);
        new DataCache_1.SharedKeyRelationship(_this.PilotsInitialData, _this.InitialData, function (pd) { return pd.InitialData; }, function (d) { return d.Pilots; });
        new DataCache_1.QueryResultsRelationship(_this.PilotsInitialData, data.PilotAgencies, function (pd) { return pd.PilotAgencies; });
        new DataCache_1.QueryResultsRelationship(_this.PilotsInitialData, data.Pilots, function (pd) { return pd.Pilots; });
        return _this;
    }
    return BootstrapCache;
}(DataCache_1.DataCache));
exports.BootstrapCache = BootstrapCache;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Entrypoints = void 0;
// entrypoint keys extracted from server response 2016-09-23
// JSON.stringify(e, null, 4).replace(/"http:\/\/localhost:60018/g, '`${server}').replace(/\/1/g, "/${domainId}").replace(/",/g, '`,')
var Entrypoints = function (server, domainId) { return ({
    "Login": server + "/app/Account/Login",
    "Logout": server + "/app/Account/Logout",
    "ChangePassword": function (_a) {
        var Id = _a.Id;
        return server + "/app/Account/ChangePassword/" + Id;
    },
    "LloydsSearch": function (_a) {
        var IMO = _a.IMO, MMSID = _a.MMSID, CallSign = _a.CallSign;
        return server + "/portcall/app/VesselService/LloydsSearch?imo=" + IMO + "&mmsid=" + MMSID + "&callsign=" + (CallSign || '');
    },
    "VesselServiceListing": function (_a) {
        var Status = _a.Status, SearchString = _a.SearchString;
        return server + "/portcall/app/vesselservicelisting?status=" + Status + "&searchString=" + (SearchString || '');
    },
    "PSixSearch": function (_a) {
        var VesselName = _a.VesselName, CallSign = _a.CallSign, HIN = _a.HIN, VIN = _a.VIN;
        return server + "/portcall/app/VesselService/PSixSearch?vesselName=" + (VesselName || '') + "&callSign=" + (CallSign || '') + "&hin=" + (HIN || '') + "&vin=" + (VIN || '');
    },
    "MarineTrafficSearch": function (_a) {
        var IMO = _a.IMO, MMSID = _a.MMSID;
        return server + "/portcall/app/VesselService/MarineTrafficSearch?imo=" + IMO + "&mmsid=" + MMSID;
    },
    "LocalVesselSearch": server + "/portcall/app/localvesselsearch",
    "UserSummary": server + "/portcall/app/UserSummary/" + domainId,
    "UserPermissions": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/UserPermissions/" + Id;
    },
    "Traffic": server + "/portcall/app/traffic/" + domainId,
    "TariffLookups": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/TariffLookups/" + Id;
    },
    "PortDemo": server + "/portcall/app/port/{id}",
    "PersonProfilePopup": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/PersonProfilePopup/" + Id;
    },
    "OrgProfile": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/OrgProfile/" + Id;
    },
    "Organizations": server + "/portcall/app/Organizations",
    "InviteUsers": server + "/portcall/app/InviteUsers",
    "ScheduleGrid": function (_a) {
        var From = _a.From, To = _a.To;
        return server + "/portcall/app/schedulegrid?from=" + enc(From) + "&to=" + enc(To);
    },
    "UpdateScheduleGrid": server + "/portcall/app/updateschedulegrid",
    "SaveOrganizationImageUpload": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/saveimage/organization/" + Id;
    },
    "SavePCUserImageUpload": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/saveimage/pcuser/" + Id;
    },
    "ReservationsDashboard": function (_a) {
        var OrganizationId = _a.OrganizationId, FromDate = _a.FromDate, ToDate = _a.ToDate, Role = _a.Role;
        return server + "/portcall/app/reservationsdashboard?orgId=" + OrganizationId + "&from=" + enc(FromDate) + "&to=" + enc(ToDate) + "&role=" + Role;
    },
    "ReservationsInBatch": function (_a) {
        var BatchId = _a.BatchId, FromDate = _a.FromDate, ToDate = _a.ToDate;
        return server + "/portcall/app/reservationsinbatch?batchId=" + BatchId + "&from=" + enc(FromDate) + "&to=" + enc(ToDate);
    },
    "PortCallProfile": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/portcallprofile/" + Id;
    },
    "PortCallSchedule": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/portcallschedule/" + Id;
    },
    "ViewLogEvents": function (_a) {
        var Id = _a.Id, NeedSince = _a.NeedSince;
        return server + "/portcall/app/PortCallProfilePage/ViewLogEvents/" + Id + "?needSince=" + (NeedSince ? enc(NeedSince) : '');
    },
    "PilotJobOrderLog": function (_a) {
        var Id = _a.Id, NeedSince = _a.NeedSince;
        return server + "/pilots/app/PilotJobOrderLog/" + Id + "?needSince=" + (NeedSince ? enc(NeedSince) : '');
    },
    "TopicCards": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/topiccards/" + Id;
    },
    "NewTopicCard": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/newtopiccard/" + Id;
    },
    "ViewNotifications": server + "/portcall/app/PersonProfilePage/ViewNotifications/{id}",
    "PersonProfilePage": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/PersonProfilePage/" + Id;
    },
    "MorePage": server + "/portcall/app/MorePage",
    "CancelPortCall": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/cancelportcall/" + Id;
    },
    "LinkBerths": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/LinkBerths/" + Id;
    },
    "ManageBerths": server + "/portcall/app/ManageBerths",
    "UnlinkBerths": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/UnlinkBerths/" + Id;
    },
    "HomeInPort": server + "/portcall/app/home/inport/" + domainId,
    "HomeCruise": server + "/portcall/app/home/cruise/" + domainId,
    "HomeMovements": function (_a) {
        var Date = _a.Date;
        return server + "/portcall/app/home/movements/" + domainId + "?date=" + enc(Date);
    },
    "UploadFile": server + "/portcall/app/uploadfile",
    "UploadImage": server + "/portcall/app/uploadimage",
    "DomainSummary": server + "/portcall/app/DomainSummary/" + domainId,
    "ConfigureReminders": function (_a) {
        var OrganizationId = _a.OrganizationId;
        return server + "/portcall/app/ConfigureReminders/" + OrganizationId;
    },
    "BerthProfile": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/berthprofile/" + Id;
    },
    "PierGroupFootmarks": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/PierGroupFootmarks/" + Id;
    },
    "BerthLookups": server + "/portcall/app/BerthLookups",
    "TopicCardTemplates": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/topiccardtemplates/" + Id;
    },
    "BerthAmenityTypeLookups": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/BerthAmenityTypeLookups/" + Id;
    },
    "AddVessel": server + "/portcall/app/AddVessel",
    "AddPortCall": server + "/portcall/app/addportcall",
    "PreviewBatchDates": server + "/portcall/app/previewbatchdates",
    "AddShift": server + "/portcall/app/addshift",
    "AddBerth": server + "/portcall/app/AddBerth",
    "AddBerthClosure": server + "/portcall/app/AddBerthClosure",
    "AddBarge": server + "/portcall/app/AddBarge",
    "ForgotPassword": server + "/portcall/Account/ForgotPassword/" + domainId,
    "ResetPassword": server + "/portcall/Account/ResetPassword",
    "SendPasswordReset": server + "/portcall/Account/SendPasswordReset",
    "SendInvitation": server + "/portcall/Account/Invite",
    "AcceptInvitation": server + "/portcall/Account/AcceptInvitation",
    "CheckInvitation": server + "/portcall/Account/CheckInvitation",
    "RestoreAccount": server + "/portcall/Account/RestoreAccount",
    "VesselServiceOverride": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/vesselserviceoverride/" + Id;
    },
    "PortCallVesselServiceSearch": function (_a) {
        var Type = _a.Type, Query = _a.Query;
        return server + "/portcall/app/vesselservicesearch/" + Type + "/" + Query;
    },
    "VesselServiceConfigure": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/vesselserviceconfigure/" + Id;
    },
    "DomainOrganizations": server + "/portcall/api/domain/{id}/organizations",
    "DomainPorts": server + "/portcall/api/domain/{id}/ports",
    "DeletePilotSection": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/deletepilotsection/" + Id;
    },
    "RotationDashboard": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/rotationdashboard/" + Id;
    },
    "PilotJobOrderDetails": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/pilotjoborderdetails/" + Id;
    },
    "ValidatePilotJobOrderTimes": server + "/pilots/app/validatepilotjobordertimes",
    "PilotJobOrderDetailsBilling": function (_a) {
        var BillingSystemId = _a.BillingSystemId, Id = _a.Id;
        return server + "/pilots/app/pilotjoborderdetailsbilling/" + BillingSystemId + "/" + Id;
    },
    "DispatchEventDetailsBilling": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/dispatcheventdetailsbilling/" + Id;
    },
    "ManagePilotLookups": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/managepilotlookups/" + Id;
    },
    "DispatchDashboard": function (_a) {
        var Id = _a.Id, Tab = _a.Tab, From = _a.From, To = _a.To, SearchQuery = _a.SearchQuery;
        return server + "/pilots/app/dispatchdashboard/" + Id + "?tab=" + Tab + "&from=" + (From ? enc(From) : '') + "&to=" + (To ? enc(To) : '') + "&searchQuery=" + (SearchQuery ? enc(SearchQuery) : '');
    },
    "AcknowledgePilotJobOrders": server + "/pilots/app/acknowledgepilotjoborders",
    "MissingPilotJobOrders": function (_a) {
        var From = _a.From, To = _a.To, PortCallId = _a.PortCallId;
        return server + "/pilots/app/missingpilotjoborders?from=" + enc(From) + "&to=" + enc(To) + "&portcallId=" + (PortCallId !== null ? PortCallId : '');
    },
    "AddPilotJobOrder": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/dispatchdashboard/addpilotjoborder/" + Id;
    },
    "CancelPilotJobOrder": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/cancelpilotjoborder/" + Id;
    },
    "InitialData": server + "/portcall/app/data/initial/" + domainId,
    "AuthorizedData": server + "/portcall/app/data/authorized/" + domainId,
    "BookReservations": server + "/portcall/app/bookreservations",
    "UnbookReservations": server + "/portcall/app/unbookreservations",
    "CancelReservations": server + "/portcall/app/cancelreservations",
    "BatchesDashboard": function (_a) {
        var OrganizationId = _a.OrganizationId, FromDate = _a.FromDate, ToDate = _a.ToDate, Role = _a.Role;
        return server + "/portcall/app/batchesdashboard?orgId=" + OrganizationId + "&from=" + enc(FromDate) + "&to=" + enc(ToDate) + "&role=" + Role;
    },
    "BerthClosuresDashboard": function (_a) {
        var OrganizationId = _a.OrganizationId, FromDate = _a.FromDate, ToDate = _a.ToDate;
        return server + "/portcall/app/berthclosuresdashboard?orgId=" + OrganizationId + "&from=" + enc(FromDate) + "&to=" + enc(ToDate);
    },
    "OperationsForecast": function (_a) {
        var OrganizationId = _a.OrganizationId, Date = _a.Date;
        return server + "/portcall/operationsforecast/" + OrganizationId + "?date=" + enc(Date);
    },
    "ActivityFeed": function (_a) {
        var OrganizationId = _a.OrganizationId;
        return server + "/portcall/app/activityfeed/" + OrganizationId;
    },
    "ServicesDashboard": function (_a) {
        var OrganizationId = _a.OrganizationId, Date = _a.Date;
        return server + "/portcall/app/servicesdashboard/" + OrganizationId + "?date=" + enc(Date);
    },
    "ModifyMovementSchedule": server + "/portcall/app/modifymovementschedule",
    "VesselPortCalls": function (_a) {
        var VesselId = _a.VesselId, FromDate = _a.FromDate, ToDate = _a.ToDate;
        return server + "/portcall/app/vesselportcall/?vesselId=" + VesselId + "&fromDate=" + enc(FromDate) + "&toDate=" + enc(ToDate);
    },
    "ApprovePilotJobOrderCharges": function (_a) {
        var BillingSystemId = _a.BillingSystemId, Id = _a.Id;
        return server + "/portcall/app/billing/approvepilotjobordercharges/" + BillingSystemId + "/" + Id;
    },
    "RecalculatePilotJobOrderCharges": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/billing/recalculatepilotjobordercharges/" + Id;
    },
    "ApproveDispatchEventCharges": function (_a) {
        var BillingSystemId = _a.BillingSystemId, Id = _a.Id;
        return server + "/portcall/app/billing/approvedispatcheventcharges/" + BillingSystemId + "/" + Id;
    },
    "RecalculateDispatchEventCharges": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/billing/recalculatedispatcheventcharges/" + Id;
    },
    "QuickBooksExport": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/billing/quickbooksexport/" + Id;
    },
    "QuickBooksReexport": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/billing/quickbooksreexport/" + Id;
    },
    "PendingExports": function (_a) {
        var Id = _a.Id;
        return server + "/pilots/app/billing/pendingexports/" + Id;
    },
    "PastExports": function (_a) {
        var Id = _a.Id, From = _a.From, To = _a.To;
        return server + "/pilots/app/billing/pastexports/" + Id + "?from=" + enc(From) + "&to=" + enc(To);
    },
    "WartsilaEnrichments": function (_a) {
        var Id = _a.Id;
        return server + "/wartsila/app/wartsilaenrichments/" + Id;
    },
    "WartsilaRefreshEstimate": function (_a) {
        var PCId = _a.PCId, AutomationId = _a.AutomationId;
        return server + "/wartsila/app/refreshestimate/" + PCId + "/" + AutomationId;
    },
    "ViewOriginalPilotOrder": function (_a) {
        var PortCallId = _a.PortCallId;
        return server + "/pilots/app/vieworiginalpilotorder/" + PortCallId;
    },
    "CoordinationsOverview": server + "/portcall/app/coordinations/" + domainId + "/overview",
    "ReorderCoordinations": server + "/portcall/app/coordinations/" + domainId + "/reorder",
    "CoordinationConfigurator": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/coordinationconfigurator/" + Id;
    },
    "AddCoordinationCards": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/portcall/" + Id + "/addcoordinationcards";
    },
    "CoordinationCardDetails": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/coordinationcard/" + Id + "/details";
    },
    "CancelledCoordinationCardDetails": function (_a) {
        var Id = _a.Id, ChangeId = _a.ChangeId;
        return server + "/portcall/app/cancelledcoordinationcard/" + Id + "/" + ChangeId + "/details";
    },
    "BerthAssignmentDetails": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/berthassignment/" + Id + "/details";
    },
    "CoordinationCardLog": function (_a) {
        var Id = _a.Id, NeedSince = _a.NeedSince;
        return server + "/portcall/app/coordinationcard/" + Id + "/log?needSince=" + (NeedSince ? enc(NeedSince) : '');
    },
    "CoordinationCardStatusUpdates": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/coordinationcard/" + Id + "/statusupdates";
    },
    "UpdateInPortActivities": function (_a) {
        var Id = _a.Id;
        return server + "/portcall/app/berthreservation/" + Id + "/updateinportactivities";
    },
    "ViewPortCallReport": function (_a) {
        var PortCallId = _a.PortCallId;
        return server + "/portcall/app/viewportcallreport/" + PortCallId;
    },
}); };
exports.Entrypoints = Entrypoints;
var enc = function (v) { return encodeURIComponent(v.toString()); };


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PORTCALLBUILDID = void 0;
exports.PORTCALLBUILDID = window.PORTCALLBUILDID;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePassword = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var ChangePasswordRequest_1 = __webpack_require__(565);
function ChangePassword(_a) {
    var ajax = _a.ajax, entrypoints = _a.entrypoints, userId = _a.userId, onHidePopup = _a.onHidePopup;
    var url = entrypoints.ChangePassword({ Id: userId }), client = ajax.Url(url), validation = validationWatcher_1.ValidationWatcher(client), changePasswordRequest = new ChangePasswordRequest_1.ChangePasswordRequest(), httpRequest = s_js_1.default.data(null), success = function () {
        return httpRequest() && httpRequest().Response() && httpRequest().Response().Success;
    };
    return {
        ChangePasswordRequest: changePasswordRequest,
        Success: success,
        Validation: validation,
        Submit: Submit,
        HidePopup: onHidePopup
    };
    function Submit() {
        httpRequest(client.Post(changePasswordRequest));
    }
}
exports.ChangePassword = ChangePassword;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
var view_2 = __webpack_require__(29);
exports.ChangePasswordView = supercritical_1.default(function (_a) {
    var _b;
    var modelContainer = _a.modelContainer;
    return React.createElement(view_1.PCModal, { className: "changepassword", shown: function () { return !!modelContainer(); }, onBackDropClick: (_b = modelContainer()) === null || _b === void 0 ? void 0 : _b.HidePopup },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header" },
                (function (m) { return m &&
                    React.createElement("button", { className: "close", onClick: m.HidePopup },
                        React.createElement("span", { "aria-hidden": "true" }, "\u00D7"),
                        React.createElement("span", { className: "sr-only" }, "Close")); })(modelContainer()),
                React.createElement("h2", { className: "modal-title" }, "Change password")),
            (function (m) { return m &&
                React.createElement("div", { className: "modal-body" },
                    !m.Success() ?
                        React.createElement("form", { onSubmit: eventWrappers_1.noDefault(m.Submit) },
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { type: "password", className: "form-control pc-input-box", placeholder: "Old password", value: m.ChangePasswordRequest.OldPassword(), onChange: function (e) { return m.ChangePasswordRequest.OldPassword(e.target.value); } }),
                                React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['OldPassword']; } })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { type: "password", className: "form-control pc-input-box", placeholder: "New password", value: m.ChangePasswordRequest.NewPassword(), onChange: function (e) { return m.ChangePasswordRequest.NewPassword(e.target.value); } }),
                                React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['NewPassword']; } })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { type: "password", className: "form-control pc-input-box", placeholder: "Confirm password", value: m.ChangePasswordRequest.ConfirmPassword() || '', onChange: function (e) { return m.ChangePasswordRequest.ConfirmPassword(e.target.value); } }),
                                React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['ConfirmPassword']; } })),
                            React.createElement("div", { className: "form-group pc-button-shell" },
                                React.createElement("button", { type: "submit", className: "pc-button pc-button-primary" }, "Change")))
                        :
                            React.createElement("div", null,
                                React.createElement("div", null, "Your password has been changed successfully."),
                                React.createElement("div", null,
                                    React.createElement("button", { className: "pc-button pc-button-primary", onClick: m.HidePopup }, "OK"))),
                    React.createElement("div", { className: "clearfix" })); })(modelContainer())));
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddShiftPopup = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var diacriticals_1 = __webpack_require__(42);
var tzmoment_1 = __webpack_require__(9);
var validationWatcher_1 = __webpack_require__(23);
var BerthReservation_1 = __webpack_require__(79);
var ItineraryPoint_1 = __webpack_require__(69);
var BerthReservation_2 = __webpack_require__(38);
var agentRestrictionsErrorParser_1 = __webpack_require__(259);
var model_1 = __webpack_require__(90);
var scheduleConstants_1 = __webpack_require__(191);
function AddShiftPopup(ajax, entrypoints, data, tzutils, _a) {
    var previousPoint = _a.previousPoint, onCancel = _a.onCancel, onSuccess = _a.onSuccess;
    var newPoint = new ItineraryPoint_1.ItineraryPoint(), newReservation = new BerthReservation_1.BerthReservation({
        Id: 0,
        SideTo: BerthReservation_2.VesselSide.TBD
    }), client = ajax.Url(entrypoints.AddShift, {
        useCache: true,
        include: [function (br) { return br.Itinerary; }]
    }), berths = s_array_1.lift(function () { return Array.from(data.Berths.items()); })
        .filter(function (b) {
        return !!b.Location() &&
            !!previousPoint() &&
            !!previousPoint().Location() &&
            b.Location().Port() === previousPoint().Location().Port();
    }), berthQuery = s_js_1.default.data(''), berthTypeahead = new model_1.Typeahead({
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        collection: berths,
        observable: berthQuery,
        matchFn: function (berth, query) { return !!berth.Location() &&
            diacriticals_1.CaseInsensitiveContains(berth.Location().Name(), query); },
        displayKey: function (berth) { return berth.Location() && berth.Location().Name() || ''; },
        onSelect: function (berth) { return newPoint.LocationId(berth.Id()); }
    }), submitting = s_js_1.default.data(false), Validation = validationWatcher_1.ValidationWatcher(client), AgentRestrictions = s_js_1.default(function () { return agentRestrictionsErrorParser_1.agentRestrictionErrors(Validation()); }), ShowAgentRestrictions = s_js_1.default.value(false);
    s_js_1.default(function () { return ShowAgentRestrictions(Object.keys(AgentRestrictions()).length > 0); });
    data.ItineraryPoints.attach(newPoint, [newPoint.Location]);
    newReservation.Itinerary(newPoint);
    s_js_1.default(function () { return previousPoint() && newPoint.PortCallId(previousPoint().PortCallId()); });
    s_js_1.default(function () {
        var berth = newPoint.Location() && newPoint.Location().Berth();
        if (!berth)
            return;
        newReservation.Footmark.UOM(berth.StartMark.UOM());
        var prev = previousPoint(), prevBerth = prev && prev.Location() && prev.Location().Berth();
        if (prev && prevBerth) {
            var 
            // TODO: It'd be slick to figure out if this "shift" is really the in (or out) movement from
            // (or to) an anchorage, in which case using the arrival (or departure) berth's
            // BerthTransitOffset would probably make more sense here.
            transitMins_1 = prevBerth.PierGroup() === berth.PierGroup() ? scheduleConstants_1.SAME_PIERGROUP_TRANSIT_MINS : scheduleConstants_1.DIFFERENT_PIERGROUP_TRANSIT_MINS, arrival = tzmoment_1.tzmomentMod(tzutils, prev.Departure.Effective(), function (m) { return m.add(transitMins_1, 'minutes'); }), departure = tzmoment_1.tzmomentMod(tzutils, arrival, function (m) { return m.add(scheduleConstants_1.DEFAULT_NEW_SHIFT_DURATION_MINS, 'minutes'); });
            newPoint.Arrival.Estimated(arrival);
            newPoint.Departure.Estimated(departure);
        }
    });
    return {
        BerthTypeahead: berthTypeahead,
        CanSubmit: function () {
            // TH 02/13/2017 -- Make sure we've populated all the fields we care about.
            // Location is the main one, but the others could start out unpopulated if somehow
            // the previous point wasn't fully populated.
            return !!newPoint.Location() &&
                !!newReservation.Footmark.UOM() &&
                !!newPoint.PortCallId() &&
                +newPoint.Arrival.Estimated() > 0 &&
                +newPoint.Departure.Estimated() > 0;
        },
        Cancel: onCancel,
        Submit: Submit,
        Submitting: submitting,
        AgentRestrictions: AgentRestrictions,
        ShowAgentRestrictions: ShowAgentRestrictions
    };
    function Submit() {
        if (submitting())
            return;
        submitting(true);
        client.Post(newReservation).then(onSuccess).finally(function () { return submitting(false); });
    }
}
exports.AddShiftPopup = AddShiftPopup;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddShiftPopupView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(29);
var view_3 = __webpack_require__(22);
var view_4 = __webpack_require__(91);
exports.AddShiftPopupView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement("div", null,
        React.createElement(view_3.PCModal, { className: "addshiftpopupcomponent", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
            React.createElement("div", { className: "modal-content pc-card" },
                React.createElement("div", { className: "pc-card-header pc-card-title" }, "Add a Shift"),
                React.createElement("div", { className: "pc-text-smalllabel" }, "Select the location the vessel will shift to. This will change the current OUT movement to a SHIFT and add a new OUT movement."),
                m && React.createElement(AddShiftPopupMain, { model: m }))),
        m && React.createElement(view_2.ErrorModal, { errors: m.AgentRestrictions, shown: m.ShowAgentRestrictions, title: "There is an issue with this shift" })));
});
var AddShiftPopupMain = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "berth-container" },
            React.createElement(view_4.TypeaheadInput, { className: "search-filter", model: m.BerthTypeahead, placeholder: "Berth ..." })),
        React.createElement("div", { className: "controls" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.Cancel) }, "Cancel"),
            React.createElement("button", { className: "pc-button add-shift-btn", disabled: !m.CanSubmit(), onClick: m.Submit }, "Add Shift")),
        React.createElement(view_1.ActionLoadingIndicator, { loading: m.Submitting }));
});


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDispatchEvent = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var DispatchEvent_1 = __webpack_require__(573);
function AddDispatchEvent(ajax, data, tzutils, localization, billExportSettingsModel, _a) {
    var url = _a.url, canManageBills = _a.canManageBills, onAddDispatchEvent = _a.onAddDispatchEvent, onCancel = _a.onCancel;
    var dispatchEvent = new DispatchEvent_1.DispatchEvent({
        Id: 0,
        Start: tzutils.now().toJSON()
    }), billExportSettings = billExportSettingsModel({
        DraftModel: dispatchEvent,
        LastExportDate: function () { return null; },
        ApproveAndRecalculate: null
    }), client = ajax.Url(url), validation = validationWatcher_1.ValidationWatcher(client);
    return {
        Model: dispatchEvent,
        BillExportSettings: billExportSettings,
        CanManageBills: canManageBills,
        Validation: validation,
        AddDispatchEvent: AddDispatchEvent,
        Cancel: onCancel,
        Localization: localization
    };
    function AddDispatchEvent() {
        var req = client.Post(dispatchEvent);
        req.then(function (json) { return s_js_1.default.freeze(function () {
            var event = data.DispatchEvents.update1(req.Date, json);
            onAddDispatchEvent(event);
        }); });
    }
}
exports.AddDispatchEvent = AddDispatchEvent;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDispatchEventView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var dispatcheventdetailsview_1 = __webpack_require__(497);
var view_1 = __webpack_require__(266);
var view_2 = __webpack_require__(22);
exports.AddDispatchEventView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement(view_2.PCModal, { className: "adddispatchevent", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Add Event"),
            m &&
                React.createElement("form", { className: "modal-body" },
                    React.createElement(dispatcheventdetailsview_1.DispatchEventDetailsBody, { event: m.Model, canEdit: function () { return true; }, validation: m.Validation, localization: m.Localization }),
                    m.CanManageBills() &&
                        React.createElement(view_1.BillExportSettingsView, { model: m.BillExportSettings }),
                    React.createElement("div", { className: "buttons" },
                        React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(m.Cancel) }, "Cancel"),
                        React.createElement("button", { className: "submit-btn pc-button pc-button-primary", onClick: eventWrappers_1.noDefault(m.AddDispatchEvent) }, "Submit"))))));
});


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPilotJobOrder = void 0;
var s_js_1 = __webpack_require__(0);
var moment = __webpack_require__(6);
var groupBy_1 = __webpack_require__(295);
var MissingPilotJobOrders_1 = __webpack_require__(285);
var MissingPilotJobOrderType_1 = __webpack_require__(609);
var PilotJobOrder_1 = __webpack_require__(160);
var model_1 = __webpack_require__(262);
function AddPilotJobOrder(loader, ajax, entrypoints, data, cache, _a) {
    var pilotAgencyId = _a.pilotAgencyId, from = _a.from, to = _a.to, portCallId = _a.portCallId, _template = _a.template, onAddPilotJobOrder = _a.onAddPilotJobOrder, onCancel = _a.onCancel;
    var model = loader({ From: from.toJSON(), To: to.toJSON(), PortCallId: portCallId }).model, client = ajax.Url(entrypoints.AddPilotJobOrder({ Id: pilotAgencyId })), days = groupBy_1.groupBy(model.MissingPilotJobOrders, function (pjo) { return model_1.internalDateFormat(pjo.Date()); })
        // Th 01/26/2017 -- Our date format of 'YYYY-MM-DD' is string sortable
        .orderBy(function (_a) {
        var date = _a.key;
        return date;
    })
        .map(function (_a) {
        var date = _a.key, items = _a.items;
        return MissingPJOsDayViewModel(date, items);
    }), adding = s_js_1.default.data(false), template = _template || new PilotJobOrder_1.PilotJobOrder({
        Id: 0,
        Billable: true
    });
    return {
        Days: days,
        AddPilotJobOrder: AddPilotJobOrder,
        Cancel: onCancel
    };
    function AddPilotJobOrder(missingPJO) {
        if (adding())
            return;
        var opts = JSON.parse(JSON.stringify(template));
        opts.FromPointId = missingPJO.FromPointId();
        opts.ToPointId = missingPJO.ToPointId();
        var key = MissingPilotJobOrders_1.MissingPilotJobOrder.key(missingPJO), req = client.Post(opts);
        req.then(function (json) { return s_js_1.default.freeze(function () {
            var ts = req.Date, pjo = data.PilotJobOrders.update1(ts, json);
            cache.MissingPilotJobOrders.update(ts, [], [key]);
            model.MissingPilotJobOrders.remove(missingPJO);
            onAddPilotJobOrder(pjo);
        }); }).finally(function () { return adding(false); });
    }
}
exports.AddPilotJobOrder = AddPilotJobOrder;
var MissingPilotJobOrderTypeSortOrder = (_a = {},
    _a[MissingPilotJobOrderType_1.MissingPilotJobOrderType.In] = 0,
    _a[MissingPilotJobOrderType_1.MissingPilotJobOrderType.Out] = 1,
    _a[MissingPilotJobOrderType_1.MissingPilotJobOrderType.Shift] = 2,
    _a);
function MissingPJOsDayViewModel(date, missingPJOs) {
    return {
        Date: date,
        DateMoment: moment(date),
        // TH 04/14/2017 -- Hmm... I somehow missed adding a sort to the AddPilotJobOrder popup.
        // Do essentially the same sort as for the main dashboard.
        MissingPJOs: missingPJOs.sort(function (a, b) {
            return (a.Date().getTime() - b.Date().getTime())
                || (MissingPilotJobOrderTypeSortOrder[a.Type()] - MissingPilotJobOrderTypeSortOrder[b.Type()])
                || (a.FromPointId() - b.FromPointId())
                || (a.ToPointId() - b.ToPointId());
        })
    };
}


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPilotJobOrderView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var MissingPilotJobOrders_1 = __webpack_require__(285);
var MissingPilotJobOrderType_1 = __webpack_require__(609);
var view_1 = __webpack_require__(498);
var view_2 = __webpack_require__(22);
exports.AddPilotJobOrderView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement("div", null,
        React.createElement(view_2.PCModal, { className: "addpilotjoborder", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
            React.createElement("div", { className: "modal-content pc-card" },
                React.createElement("div", { className: "pc-card-header pc-card-title" }, "Movements Without Pilot Orders"),
                m &&
                    React.createElement("div", { className: "modal-body" },
                        m.Days().length ?
                            React.createElement("div", { className: "days" }, m.Days().map(function (day) {
                                return React.createElement(MissingPJOsDayView, { day: day, model: m, key: day.Date });
                            })) :
                            React.createElement("div", { className: "placeholder-text" },
                                React.createElement("div", null, "All current movements have Pilot Orders."),
                                React.createElement("div", null,
                                    "Need new orders? ",
                                    React.createElement("a", { href: "#!addportcall" }, "Add PortCall"),
                                    ".")),
                        React.createElement("div", { className: "buttons" },
                            React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(m.Cancel) }, "Cancel")))))));
});
var MissingPJOsDayView = supercritical_1.default(function (_a) {
    var day = _a.day, m = _a.model;
    return React.createElement("div", { className: "day" },
        React.createElement(view_1.DateHeaderView, { moment: day.DateMoment }),
        React.createElement("table", { className: "missing-pjos" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { className: "pilot-flag" }),
                    React.createElement("th", { className: "pc-text-smalllabel movement-type" }, "Type"),
                    React.createElement("th", { className: "pc-text-smalllabel est-time" }, "Est."),
                    React.createElement("th", { className: "pc-text-smalllabel vessel" }, "Vessel"),
                    React.createElement("th", { className: "pc-text-smalllabel location" }, "Location"),
                    React.createElement("th", { className: "pc-text-smalllabel last-column" }))),
            React.createElement(DayTableBody, { day: day, model: m })));
});
var DayTableBody = supercritical_1.default(function (_a) {
    var day = _a.day, m = _a.model;
    return React.createElement("tbody", { className: "pc-card" }, day.MissingPJOs().map(function (pjo) {
        return React.createElement(MissingPJOView, { pjo: pjo, model: m, key: MissingPilotJobOrders_1.MissingPilotJobOrder.key(pjo) });
    }));
});
var MissingPJOView = supercritical_1.default(function (_a) {
    var pjo = _a.pjo, m = _a.model;
    return React.createElement("tr", { className: "missing-pjo", onClick: function () { return m.AddPilotJobOrder(pjo); } },
        React.createElement("td", { className: "pilot-flag" }),
        React.createElement("td", { className: "movement-type" }, pjo.Type() === MissingPilotJobOrderType_1.MissingPilotJobOrderType.In ? 'IN' :
            pjo.Type() === MissingPilotJobOrderType_1.MissingPilotJobOrderType.Shift ? 'SHIFT' :
                'OUT'),
        React.createElement("td", { className: "est-time" }, tzmoment_1.tzmoment(pjo.Date()).format('HH:mm')),
        React.createElement("td", { className: "vessel" }, pjo.VesselName()),
        React.createElement("td", { className: "location" },
            React.createElement("span", { className: cx({
                    'is-not-berth': pjo.Type() === MissingPilotJobOrderType_1.MissingPilotJobOrderType.In
                }) }, pjo.FromName()),
            ' ',
            React.createElement("span", { className: "is-not-berth" }, "to"),
            ' ',
            React.createElement("span", { className: cx({
                    'is-not-berth': pjo.Type() === MissingPilotJobOrderType_1.MissingPilotJobOrderType.Out
                }) }, pjo.ToName())),
        React.createElement("td", null));
});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var DispatchDashboard_1 = __webpack_require__(1253);
var MissingPilotJobOrders_1 = __webpack_require__(285);
var DispatchEventDetailsBilling_1 = __webpack_require__(1254);
var DispatchDashboardCache = /** @class */ (function (_super) {
    __extends(DispatchDashboardCache, _super);
    function DispatchDashboardCache(data, navbarCache) {
        var _this = _super.call(this) || this;
        _this.DispatchDashboards = PCCache_1.PCCollection(DispatchDashboard_1.DispatchDashboard);
        _this.CorePermissions = PCCache_1.PCCollection(DispatchDashboard_1.DispatchDashboardCorePermissions);
        _this.MissingPilotJobOrdersResponses = PCCache_1.PCCollection(MissingPilotJobOrders_1.MissingPilotJobOrdersResponse);
        _this.MissingPilotJobOrders = PCCache_1.PCCollection(MissingPilotJobOrders_1.MissingPilotJobOrder);
        _this.DispatchEventDetailsBillings = PCCache_1.PCCollection(DispatchEventDetailsBilling_1.DispatchEventDetailsBilling);
        new DataCache_1.ForeignKeyRelationship(data.PilotAgencies, _this.DispatchDashboards, null, function (d) { return d.PilotAgency; }, function (d) { return d.Id(); });
        new DataCache_1.QueryResultsRelationship(_this.DispatchDashboards, data.DispatchEvents, function (d) { return d.DispatchEvents; });
        new DataCache_1.QueryResultsRelationship(_this.DispatchDashboards, data.PilotJobOrders, function (d) { return d.JobOrders; });
        new DataCache_1.QueryResultsRelationship(_this.DispatchDashboards, data.PilotJobOrderUserPreferenceses, function (d) { return d.PilotJobOrderUserPreferences; });
        new DataCache_1.SharedKeyRelationship(_this.DispatchEventDetailsBillings, data.DispatchEvents, function (b) { return b.DispatchEvent; }, null);
        new DataCache_1.ForeignKeyRelationship(_this.CorePermissions, _this.DispatchDashboards, null, function (d) { return d.CorePermissions; }, function (d) { return d.Id(); });
        new DataCache_1.ForeignKeyRelationship(navbarCache.PilotsNavbars, _this.DispatchDashboards, null, function (d) { return d.Navbar; }, function (d) { return d.Id(); });
        new DataCache_1.QueryResultsRelationship(_this.MissingPilotJobOrdersResponses, _this.MissingPilotJobOrders, function (r) { return r.MissingPilotJobOrders; });
        return _this;
    }
    return DispatchDashboardCache;
}(DataCache_1.DataCache));
exports.DispatchDashboardCache = DispatchDashboardCache;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVColumns = exports.CsvColumnNames = void 0;
var ConvertedMeasurement_1 = __webpack_require__(116);
var UOM_1 = __webpack_require__(25);
var notNullish_1 = __webpack_require__(94);
var csvExport_1 = __webpack_require__(149);
var BerthReservation_1 = __webpack_require__(38);
function CsvColumnNames(settings) {
    return {
        MovementType: 'Movement Type',
        MovementStartEst: 'Movement Start Date/Time (Est)',
        MovementStartActual: 'Movement Start Date/Time (Actual)',
        MovementEndEst: 'Movement End Date/Time (Est)',
        MovementEndActual: 'Movement End Date/Time (Act)',
        VesselName: 'Vessel Name',
        From: 'From',
        To: 'To',
        AgentCode: 'Agent Code',
        AgencyName: 'Agency Name',
        AttendingAgent: 'Attending Agent ',
        AttendingAgentEmail: 'Attending Agent Email',
        GrossTonnage: 'Gross Tonnage',
        MovementLengthFeet: 'Movement Length (feet)',
        MovementLengthMeters: 'Movement Length (meters)',
        MovementBeamFeet: 'Movement Beam  (feet)',
        MovementBeamMeters: 'Movement Beam  (meters)',
        MovementDeepDraftFeet: 'Movement Deep Draft (feet)',
        MovementDeepDraftMeters: 'Movement Deep Draft (meters)',
        MovementAirDraftFeet: 'Movement Air Draft (feet)',
        MovementAirDraftMeters: 'Movement Air Draft (meters)',
        TugCode: 'Tug Code',
        SideTo: 'Side To',
        PilotsAssigned: 'Pilots Assigned',
        BowThrusterPresent: 'Bow Thruster Present?',
        BowThrusterSize: 'Bow Thruster Size',
        BowThrusterUoM: 'Bow Thruster UoM',
        BowThrusterWorking: 'Was bow thruster working?',
        VesselIMO: 'IMO',
        VesselOfficialNumber: 'Official Number',
        VesselCallSign: 'CallSign',
        VesselVIN: 'VIN',
        VesselOperatorLloyds: 'Operator (Lloyds)',
        VesselDeadweightLloyds: 'Deadweight (Lloyds)',
        ShiptypeLevel2: 'ShiptypeLevel2',
        ShiptypeLevel3: 'ShiptypeLevel3',
        ShiptypeLevel4: 'ShiptypeLevel4',
        ShiptypeLevel5: 'ShiptypeLevel5',
        ShiptypeLevel5HullType: 'ShiptypeLevel5HullType',
        VesselTEULloyds: 'TEU',
        VesselYearOfBuildLloyds: 'YearOfBuild',
        LastPort: 'LastPort',
        NextPort: 'NextPort'
    };
}
exports.CsvColumnNames = CsvColumnNames;
function CSVColumns(settings) {
    var colNames = CsvColumnNames(settings);
    return [{
            name: colNames.MovementType,
            formatter: function (item) { return item.MovementTypeText(); }
        }, {
            name: colNames.MovementStartEst,
            formatter: function (item) { return csvExport_1.ExcelDateTimeFormat(item.Model.Start.Estimated()); }
        }, {
            name: colNames.MovementStartActual,
            formatter: function (item) { return item.Model.Start.Actual() ? csvExport_1.ExcelDateTimeFormat(item.Model.Start.Actual()) : ''; }
        }, {
            name: colNames.MovementEndEst,
            formatter: function (item) { return csvExport_1.ExcelDateTimeFormat(item.Model.End.Estimated()); }
        }, {
            name: colNames.MovementEndActual,
            formatter: function (item) { return item.Model.End.Actual() ? csvExport_1.ExcelDateTimeFormat(item.Model.End.Actual()) : ''; }
        }, {
            name: colNames.VesselName,
            formatter: function (item) { return item.VesselNameText(); }
        }, {
            name: colNames.From,
            formatter: function (item) {
                var pt = item.Model.EffectiveFromPoint(), l = pt && pt.Location();
                return l && l.Name() || '';
            }
        }, {
            name: colNames.To,
            formatter: function (item) {
                var pt = item.Model.EffectiveToPoint(), l = pt && pt.Location();
                return l && l.Name() || '';
            }
        }, {
            name: colNames.AgentCode,
            formatter: function (item) { return item.AgencyCodeText(); }
        }, {
            name: colNames.AgencyName,
            formatter: function (item) { return item.Model.EffectivePortCall() && item.Model.EffectivePortCall().Agent() && item.Model.EffectivePortCall().Agent().Organization() && item.Model.EffectivePortCall().Agent().Organization().Name() || ''; }
        }, {
            name: colNames.AttendingAgent,
            formatter: function (item) { return item.Model.EffectivePortCall() && item.Model.EffectivePortCall().Agent() && item.Model.EffectivePortCall().Agent().FullName() || ''; }
        }, {
            name: colNames.AttendingAgentEmail,
            formatter: function (item) { return item.Model.EffectivePortCall() && item.Model.EffectivePortCall().Agent() && item.Model.EffectivePortCall().Agent().User() && item.Model.EffectivePortCall().Agent().User().Email() || ''; }
        }, {
            name: colNames.GrossTonnage,
            formatter: function (item) { return item.GrossTonnageText(); }
        }, {
            name: colNames.MovementLengthFeet,
            formatter: function (item) { return convert(item.Model.EffectiveLength, UOM_1.default.Foot, 2); }
        }, {
            name: colNames.MovementLengthMeters,
            formatter: function (item) { return convert(item.Model.EffectiveLength, UOM_1.default.Meter, 2); }
        }, {
            name: colNames.MovementBeamFeet,
            formatter: function (item) { return item.Model.EffectiveVessel() ? convert(item.Model.EffectiveVessel().Beam, UOM_1.default.Foot, 2) : ''; }
        }, {
            name: colNames.MovementBeamMeters,
            formatter: function (item) { return item.Model.EffectiveVessel() ? convert(item.Model.EffectiveVessel().Beam, UOM_1.default.Meter, 2) : ''; }
        }, {
            name: colNames.MovementDeepDraftFeet,
            formatter: function (item) { return convert(item.Model.EffectiveDeepDraft, UOM_1.default.Foot, 2); }
        }, {
            name: colNames.MovementDeepDraftMeters,
            formatter: function (item) { return convert(item.Model.EffectiveDeepDraft, UOM_1.default.Meter, 2); }
        }, {
            name: colNames.MovementAirDraftFeet,
            formatter: function (item) { return convert(item.Model.EffectiveAirDraft, UOM_1.default.Foot, 2); }
        }, {
            name: colNames.MovementAirDraftMeters,
            formatter: function (item) { return convert(item.Model.EffectiveAirDraft, UOM_1.default.Meter, 2); }
        }, {
            name: colNames.TugCode,
            formatter: function (item) { return item.Model.TugCompany() && item.Model.TugCompany().Code() || ''; }
        }, {
            name: colNames.SideTo,
            formatter: function (item) {
                var to = item.Model.EffectiveToPoint(), toRes = to && to.BerthReservation(), from = item.Model.EffectiveFromPoint(), fromRes = from && from.BerthReservation();
                return toRes ? BerthReservation_1.VesselSideDisplayName[toRes.SideTo()] :
                    fromRes ? BerthReservation_1.VesselSideDisplayName[fromRes.SideTo()] :
                        '';
            }
        }, {
            name: colNames.PilotsAssigned,
            formatter: function (item) {
                // create list of pilot first initial last name, like 'E. Sanders, B. Cisco'
                return item.Model.Pilots()
                    .map(function (p) { var _a, _b; return (_b = (_a = p.Pilot()) === null || _a === void 0 ? void 0 : _a.User()) !== null && _b !== void 0 ? _b : null; })
                    .filter(notNullish_1.notNullish)
                    .map(function (u) { return u.AbbreviatedName(); })
                    .join(', ');
            }
        }, {
            name: colNames.BowThrusterPresent,
            formatter: vesselField(function (v) { return yesNoNull(v.BowThruster.Present()); })
        }, {
            name: colNames.BowThrusterSize,
            formatter: vesselField(function (v) { return v.BowThruster.Size.Num() === null ? null : v.BowThruster.Size.Num().toString(); })
        }, {
            name: colNames.BowThrusterUoM,
            formatter: vesselField(function (v) { return v.BowThruster.Size.UOM(); })
        }, {
            name: colNames.BowThrusterWorking,
            formatter: function (item) { return yesNoNull(item.Model.BowThrusterOperational()); }
        }, {
            name: colNames.VesselIMO,
            formatter: vesselField(function (v) { return v.IMO(); })
        }, {
            name: colNames.VesselOfficialNumber,
            formatter: lloydsResultField(function (l) { return l.OfficialNumber(); })
        }, {
            name: colNames.VesselCallSign,
            formatter: vesselField(function (v) { return v.CallSign(); })
        }, {
            name: colNames.VesselVIN,
            formatter: vesselField(function (v) { return v.VIN(); })
        }, {
            name: colNames.VesselOperatorLloyds,
            formatter: lloydsResultField(function (r) { return r.Operator(); })
        }, {
            name: colNames.VesselDeadweightLloyds,
            formatter: lloydsResultField(function (r) { return r.Deadweight(); })
        }, {
            name: colNames.ShiptypeLevel2,
            formatter: lloydsResultField(function (l) { return l.ShiptypeLevel2(); })
        }, {
            name: colNames.ShiptypeLevel3,
            formatter: lloydsResultField(function (l) { return l.ShiptypeLevel3(); })
        }, {
            name: colNames.ShiptypeLevel4,
            formatter: lloydsResultField(function (l) { return l.ShiptypeLevel4(); })
        }, {
            name: colNames.ShiptypeLevel5,
            formatter: lloydsResultField(function (l) { return l.ShiptypeLevel5(); })
        }, {
            name: colNames.ShiptypeLevel5HullType,
            formatter: lloydsResultField(function (l) { return l.ShiptypeLevel5HullType(); })
        }, {
            name: colNames.VesselTEULloyds,
            formatter: lloydsResultField(function (l) { return l.TEU(); })
        }, {
            name: colNames.VesselYearOfBuildLloyds,
            formatter: lloydsResultField(function (l) { return l.YearOfBuild(); })
        }, {
            name: colNames.LastPort,
            formatter: function (item) { return item.Model.EffectivePortCall() &&
                item.Model.EffectivePortCall().LastPortOfCall() || ''; }
        }, {
            name: colNames.NextPort,
            formatter: function (item) { return item.Model.EffectivePortCall() &&
                item.Model.EffectivePortCall().NextPortOfCall() || ''; }
        }
    ];
}
exports.CSVColumns = CSVColumns;
function vesselField(prop) {
    return function (item) {
        var v = item.Model.EffectiveVessel();
        return v && prop(v) || '';
    };
}
function lloydsResultField(prop) {
    return function (item) {
        var v = item.Model.EffectiveVessel(), l = v && v.LloydServiceVessel(), r = l && l.VesselResult();
        return r && prop(r) || '';
    };
}
function yesNoNull(v) {
    return v === true ? 'Yes' : v === false ? 'No' : '';
}
function convert(v, uom, precision) {
    return v.Num() === null ? '' : new ConvertedMeasurement_1.ConvertedMeasurement(v, uom, precision).toString({ units: false });
}


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchEventDetails = void 0;
var s_js_1 = __webpack_require__(0);
function DispatchEventDetails(dashboardCache, billingLoader, entrypoints, tzutils, localization, billExportSettingsModel, _a) {
    var event = _a.event, canEdit = _a.canEdit, canManageBills = _a.canManageBills;
    var showActionsMenu = s_js_1.default.data(false), deleteConfirmationVisible = s_js_1.default.data(false), billingModel = dashboardCache.DispatchEventDetailsBillings.update1(null, { Id: event.Model.Id() }), billingSystems = function () { return event.Model.PilotAgency() && event.Model.PilotAgency().Organization() ?
        event.Model.PilotAgency().Organization().BillingSystems() : []; }, 
    // TH 05/15/2017 -- For now, the front end will only support having exactly one BillingSystem.
    // Our Db schema and server endpoints all support having multiple BillingSystems.
    // So longer term, we'd just need to change the client to have a BillingSystem dropdown or some such.
    billingSystem = s_js_1.default(function () { return billingSystems().length > 0 ? billingSystems()[0] : null; }), jobCompleteClock = tzutils.clock(1000), jobComplete = function () {
        // TH 05/15/2017 -- Don't enable Approve for Export until Event is in the past.
        // No need to subscribe to the jobCompleteClock once this is the case.
        var now = s_js_1.default.sample(jobCompleteClock.now), complete = event.Model.Start() < now;
        if (!complete)
            jobCompleteClock.now(); // subscribe to next update
        return complete;
    }, billExportSettings = billExportSettingsModel({
        DraftModel: event.Model,
        LastExportDate: billingModel.LastExportDate,
        ApproveAndRecalculate: {
            PersistedModel: event.Persisted,
            BillingSystem: billingSystem,
            DraftChargeCollections: null,
            JobComplete: jobComplete,
            ApproveEndPoint: entrypoints.ApproveDispatchEventCharges,
            RecalculateEndPoint: entrypoints.RecalculateDispatchEventCharges
        }
    }), bill = s_js_1.default(function () { return event.Model.Bills().length > 0 ? event.Model.Bills()[0].Bill() : null; });
    s_js_1.default.on(canManageBills, function () { return canManageBills() && billingLoader({ Id: event.Model.Id() }); });
    return {
        Model: event,
        CanEdit: canEdit,
        CanManageBills: canManageBills,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu,
        DeleteConfirmationVisible: deleteConfirmationVisible,
        Bill: bill,
        BillExportSettings: billExportSettings,
        ShowDeleteConfirmation: ShowDeleteConfirmation,
        Localization: localization
    };
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function ShowDeleteConfirmation() {
        s_js_1.default.freeze(function () {
            deleteConfirmationVisible(true);
            showActionsMenu(false);
        });
    }
}
exports.DispatchEventDetails = DispatchEventDetails;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderPreferences = void 0;
var s_js_1 = __webpack_require__(0);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var PilotJobOrderUserPreferences_1 = __webpack_require__(583);
function PilotJobOrderPreferences(ajax, data, user, _a) {
    var pjo = _a.pjo;
    var userId = function () { return user() ? user().Id() : 0; }, preferencesClient = ajax.Url(function () { return (pjo.UserPreferencesUrlBase() || '')
        .replace('{userId}', '' + userId()); }), persistedPreferences = data.PilotJobOrderUserPreferenceses.index(function () { return PilotJobOrderUserPreferences_1.PilotJobOrderUserPreferences.dataKey({
        PilotJobOrderId: pjo.Id(),
        UserId: userId()
    }); }), effectivePreferences = new PilotJobOrderUserPreferences_1.PilotJobOrderUserPreferences(), _b = draftSignals_1.DraftObject(effectivePreferences), draftPreferences = _b.object, draftPreferencesMethods = _b.methods;
    // TH 02/02/2017 -- Update effectivePreferences from persistedPreferences.
    s_js_1.default(function () { return persistedPreferences() &&
        PilotJobOrderUserPreferences_1.PilotJobOrderUserPreferences.update(effectivePreferences, asOptions(persistedPreferences())); });
    autoSave_1.AutoSaver(draftPreferencesMethods.onWrite, function () {
        var req = preferencesClient.Put(draftPreferences), checkpoint = draftPreferencesMethods.checkpoint();
        return req.then(function (json) { return s_js_1.default.freeze(function () {
            data.PilotJobOrderUserPreferenceses.update1(req.Date, json);
            checkpoint.revert();
        }); });
    });
    return {
        draftPreferences: draftPreferences
    };
}
exports.PilotJobOrderPreferences = PilotJobOrderPreferences;
// TH 02/08/2017 -- Ditto pilotsjoborderdetails\pilotassignments.ts about a generic utility
// and/or extension of auto-generated models?
function asOptions(prefs) {
    return JSON.parse(JSON.stringify(prefs));
}


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboardRoute = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var componentLocation_1 = __webpack_require__(34);
var DispatchDashboardTab_1 = __webpack_require__(207);
var routeParams_1 = __webpack_require__(77);
var routeParams_2 = __webpack_require__(87);
var view_1 = __webpack_require__(498);
var view_2 = __webpack_require__(12);
function DispatchDashboardRoute(model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper, navbarTab: 2 /* Pilots */ },
            React.createElement(view_1.DispatchDashboardView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.DispatchDashboardRoute = DispatchDashboardRoute;
function inboundParams(request, tzutils) {
    var id = +(request.params['id'] || 0), pjoId = +(request.params['pjo'] || 0), pjoFlip = request.params['pjoFlip'], dispatchEventId = +(request.params['dispatchevt'] || 0), 
    // TH 04/12/2017 -- We used to expect a boolean 'historical' param.
    // I'm changing that to a numeric 'tab' param.
    // This will break any users who saved the History tab URL in their browser.
    // Oh well.
    tab = request.params['tab'], range = request.params['range'], from = request.params['from'], to = request.params['to'], filter = request.params['filter'];
    return {
        id: id,
        pjoId: pjoId,
        pjoFlip: pjoFlip === undefined || !pjoId ? null : +pjoFlip,
        dispatchEventId: dispatchEventId,
        tab: tab === undefined ? DispatchDashboardTab_1.DispatchDashboardTab.Movements : +tab,
        searchParams: {
            range: range !== undefined ? routeParams_2.parseDateRange(range) :
                +(tab || 0) === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ? 0 /* AllDates */ :
                    1 /* ThisWeek */,
            from: from !== undefined ? routeParams_1.parseDate(from, tzutils) : undefined,
            to: to !== undefined ? routeParams_1.parseDate(to, tzutils) : undefined,
            filter: filter
        }
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = '' + m.Id;
    if (m.Tab !== DispatchDashboardTab_1.DispatchDashboardTab.Movements)
        params['tab'] = '' + m.Tab;
    // Sample internal state of DateRangeSelector and Filter, then subscribe to our ModelKey.
    // That way the URL params for date and text searches only update when the user executes
    // their new search.
    s_js_1.default.sample(function () {
        if (m.DateRangeSelector) {
            var defaultRange = m.Tab === DispatchDashboardTab_1.DispatchDashboardTab.BillingWorklist ? 0 /* AllDates */ : 1 /* ThisWeek */;
            m.DateRangeSelector && routeParams_2.outboundDateRangeParams(m.DateRangeSelector, params, defaultRange, { range: 'range', from: 'from', to: 'to' });
        }
        if (m.Filter && m.Filter())
            params['filter'] = m.Filter();
    });
    m.ModelKey();
    var selectedItem = m.SelectedItemKey();
    if (selectedItem) {
        if (selectedItem.pjoId)
            params['pjo'] = '' + selectedItem.pjoId;
        if (selectedItem.dispatchEventId)
            params['dispatchevt'] = '' + selectedItem.dispatchEventId;
    }
    if (m.PilotJobOrderDetails() &&
        m.PilotJobOrderDetails().Flipped() &&
        m.PilotJobOrderDetails().BackPage() !== null) {
        params['pjoFlip'] = '' + m.PilotJobOrderDetails().BackPage();
    }
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagePilotLookupsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ManagePilotLookups_1 = __webpack_require__(1284);
var ManagePilotLookupsCache = /** @class */ (function (_super) {
    __extends(ManagePilotLookupsCache, _super);
    function ManagePilotLookupsCache(data) {
        var _this = _super.call(this) || this;
        // TH 01/18/2017 -- Feeling Gollum-ish...
        _this.ManagePilotLookupses = PCCache_1.PCCollection(ManagePilotLookups_1.ManagePilotLookups);
        new DataCache_1.SharedKeyRelationship(_this.ManagePilotLookupses, data.PilotAgencies, function (l) { return l.PilotAgency; }, null);
        new DataCache_1.QueryResultsRelationship(_this.ManagePilotLookupses, data.Organizations, function (l) { return l.Organizations; });
        new DataCache_1.QueryResultsRelationship(_this.ManagePilotLookupses, data.Pilots, function (l) { return l.Pilots; });
        return _this;
    }
    return ManagePilotLookupsCache;
}(DataCache_1.DataCache));
exports.ManagePilotLookupsCache = ManagePilotLookupsCache;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagePilotLookups = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var AgencyCode_1 = __webpack_require__(555);
function ManagePilotLookups(ajax, loader, data, _a) {
    var id = _a.id;
    var model = loader({ Id: id }, 30).model, autoEditAgency = { autoEdit: false }, autoEditTug = { autoEdit: false }, autoEditLineHandler = { autoEdit: false }, agencyCodes = s_array_1.lift(function () { return model.PilotAgency() ? model.PilotAgency().AgencyCodes() : []; })
        .map(function (ac) { return AgencyCodeViewModel(ac, ajax, model.Organizations, data, AgencyCodesUrl, autoEditAgency); }), pilots = model.Pilots.map(function (p) { return PilotViewModel(p, ajax); }), lineHandlingCompanies = s_array_1.lift(function () { return model.PilotAgency() ? model.PilotAgency().LineHandlingCompanies() : []; })
        .filter(function (l) { return l.Active(); })
        .map(function (l) { return LineHandlingCompanyViewModel(l, ajax, autoEditLineHandler); }), tugCompanies = s_array_1.lift(function () { return model.PilotAgency() ? model.PilotAgency().TugCompanies() : []; })
        .filter(function (t) { return t.Active(); })
        .map(function (t) { return TugCompanyViewModel(t, ajax, autoEditTug); }), assignedOrgsArray = agencyCodes
        .filter(function (c) { return !!c.Model.CodedOrganization(); })
        .map(function (c) { return c.Model.CodedOrganization(); }), assignedOrganizations = s_js_1.default(function () { return new Set(assignedOrgsArray()); }), 
    // All the orgs that are available for any (new or existing) agency code
    allOrgs = s_array_1.lift(function () { return Array.from(data.Organizations.items()); })
        .filter(function (o) { return o.Active(); }), globallyAvailableOrgs = allOrgs
        .filter(function (o) { return !assignedOrganizations().has(o); }), addTugClient = ajax.Url(function () { return model.PilotAgency() && model.PilotAgency().TugCompaniesUrl() || ''; }), addLineHandlerClient = ajax.Url(function () { return model.PilotAgency() && model.PilotAgency().LineHandlingCompaniesUrl() || ''; });
    return {
        Model: model,
        AgencyCodes: agencyCodes,
        Pilots: pilots,
        TugCompanies: tugCompanies,
        LineHandlingCompanies: lineHandlingCompanies,
        GloballyAvailableOrganizations: globallyAvailableOrgs,
        EnableAddAgencyCode: function () { return !!model.PilotAgency() && globallyAvailableOrgs().length > 0; },
        AddAgencyCode: AddAgencyCode,
        OrganizationsAvailableForAgencyCode: OrganizationsAvailableForAgencyCode,
        EnableAddTug: function () { return !!model.PilotAgency(); },
        AddTugCompany: AddTugCompany,
        EnableAddLineHandler: function () { return !!model.PilotAgency(); },
        AddLineHandlingCompany: AddLineHandlingCompany
    };
    function AddAgencyCode() {
        var orgs = globallyAvailableOrgs();
        if (!orgs.length)
            return;
        var codedOrgId = orgs[0].Id(), req = ajax.Url(AgencyCodesUrl(codedOrgId)).Put({
            PilotAgencyId: 0,
            CodedOrganizationId: 0,
            Code: '--'
        });
        req.then(function (json) {
            autoEditAgency.autoEdit = true;
            data.AgencyCodes.update1(req.Date, json);
        });
    }
    function OrganizationsAvailableForAgencyCode(code) {
        return allOrgs().filter(function (o) { return !assignedOrganizations().has(o) || o === code.Model.CodedOrganization(); });
    }
    function AgencyCodesUrl(codedOrgId) {
        return model.PilotAgency()
            && model.PilotAgency().AgencyCodesUrlBase()
            && model.PilotAgency().AgencyCodesUrlBase().replace('{codedOrganizationId}', '' + codedOrgId)
            || '';
    }
    function AddTugCompany() {
        var req = addTugClient.Post({
            Id: 0,
            Active: true,
            Code: '--',
            Name: '--',
        });
        req.then(function (json) {
            autoEditTug.autoEdit = true;
            data.TugCompanies.update1(req.Date, json);
        });
    }
    function AddLineHandlingCompany() {
        var req = addLineHandlerClient.Post({
            Id: 0,
            Active: true,
            Code: '--',
            Name: '--'
        });
        req.then(function (json) {
            autoEditLineHandler.autoEdit = true;
            data.LineHandlingCompanies.update1(req.Date, json);
        });
    }
}
exports.ManagePilotLookups = ManagePilotLookups;
function AgencyCodeViewModel(agencyCode, ajax, orgs, data, agencyCodesUrl, autoEditContainer) {
    var deleteClient = ajax.Url(function () { return agencyCode.Url() || ''; }), _a = draftSignals_1.DraftObject(agencyCode, [
        // TH 01/18/2017 -- Explicitly enumerating properties so we don't
        // draft the CodedOrganization navigation property.
        // Otherwise we can run into scenarios where persisting a change to CodedOrganizationId
        // can trigger a change to CodedOrganization (via the data.AgencyCodes.attach call below),
        // which marks CodedOrganization as dirty and triggers an extra unnecessary save.
        'CodedOrganizationId',
        'Code'
    ]), draft = _a.object, draftMethods = _a.methods, client = ajax.Url(function () { return agencyCodesUrl(draft.CodedOrganizationId()); }), editing = s_js_1.default.data(autoEditContainer.autoEdit);
    autoSave_1.AutoSaver(draftMethods.onWrite, function () {
        var initialRequest = Promise.resolve();
        if (draft.CodedOrganizationId() !== agencyCode.CodedOrganizationId())
            initialRequest = deleteClient.Delete();
        // TH 01/17/2017 -- If CodedOrganizationId is changing, delete the old AgencyCode then PUT then new one.
        return initialRequest.then(function () {
            var req = client.Put(draft), checkpoint = draftMethods.checkpoint();
            return req.then(function (json) { return s_js_1.default.freeze(function () {
                // TH 01/17/2017 -- Need to actually update from json instead of just calling
                // draftMethods.commit b/c this request can change the AgencyCode's
                // CodedOrganizationId, thus changing its key and, in particular, its URL.
                data.AgencyCodes.update1(req.Date, json, agencyCode);
                // TH 01/18/2017 -- NOTE: Have to do draftMethods.revert instead of draftMethods.commit.
                // draftMethods.commit creates the possibility that we might be committing draft changes
                // in advance of when they're actually persisted.
                // Since we're also updating the original agencyCode from the persisted json in the line
                // above, committing here could cause S.js conflicting value errors.
                checkpoint.revert();
            }); });
        });
    });
    draft.CodedOrganization = s_js_1.default.value(s_js_1.default.sample(agencyCode.CodedOrganization));
    data.AgencyCodes.attach(draft, [draft.CodedOrganization]);
    autoEditContainer.autoEdit = false;
    return {
        Model: draft,
        Editing: editing,
        Delete: Delete,
        Validation: validationWatcher_1.ValidationWatcher(client)
    };
    function Delete() {
        var id = AgencyCode_1.AgencyCode.key(agencyCode), req = deleteClient.Delete();
        req.then(function () { return data.AgencyCodes.update(req.Date, [], [id]); });
    }
}
function PilotViewModel(pilot, ajax) {
    var client = ajax.Url(function () { return pilot.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(pilot, client), editing = s_js_1.default.data(false), code = function (val) {
        if (val === undefined)
            return draft.Code();
        // TH 01/17/2017: Coerce empty string to null.
        // Unlike AgencyCode.Code, LineHandlingCompany.Code, and TugCompany.Code, Pilot.Code
        // is not marked Required server-side.
        // But like the other Code fields, it does have minimum-length validation.
        // The empty string fails length validation, but null passes.
        // So this gives a way of resetting the value of the field to null.
        return draft.Code(val || null);
    };
    return {
        Model: draft,
        Code: code,
        Editing: editing,
        Validation: validationWatcher_1.ValidationWatcher(client)
    };
}
function TugCompanyViewModel(tug, ajax, autoEditContainer) {
    var client = ajax.Url(function () { return tug.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(tug, client), editing = s_js_1.default.data(autoEditContainer.autoEdit);
    autoEditContainer.autoEdit = false;
    return {
        Model: draft,
        Editing: editing,
        Delete: function () { return draft.Active(false); },
        Validation: validationWatcher_1.ValidationWatcher(client)
    };
}
function LineHandlingCompanyViewModel(handler, ajax, autoEditContainer) {
    var client = ajax.Url(function () { return handler.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(handler, client), editing = s_js_1.default.data(autoEditContainer.autoEdit);
    autoEditContainer.autoEdit = false;
    return {
        Model: draft,
        Editing: editing,
        Delete: function () { return draft.Active(false); },
        Validation: validationWatcher_1.ValidationWatcher(client)
    };
}


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagePilotLookupsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(990);
var view_2 = __webpack_require__(12);
function ManagePilotLookupsRoute(model, appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ManagePilotLookupsView, { model: model(inboundParams(request)) }))
    };
}
exports.ManagePilotLookupsRoute = ManagePilotLookupsRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0)
    };
}


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagePilotLookupsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(29);
exports.ManagePilotLookupsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "managepilotlookups pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: '#!pilotsettings?id=' + m.Model.Id() }, "<< Back to Pilot Settings")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet pc-text-label-color" }),
            React.createElement("span", { className: "pc-text-label-color" }, "Pilot Settings"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Manage Lookups")),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body pc-card" },
        React.createElement(AgencyCodesView, { model: m }),
        React.createElement(PilotsView, { model: m }),
        React.createElement(TugCompaniesView, { model: m }),
        React.createElement(LineHandlersView, { model: m }));
});
var AgencyCodesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "lookup-section agencycodes" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Agencies"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "This is a list of agent organizations and their agency codes. You can only add agencies that are registered on PortCall.com. Provide a code which will be seen on the Dispatch Dashboard."),
        React.createElement("div", { className: "lookup-section-content" },
            React.createElement("div", { className: "lookup-section-headers" },
                React.createElement("span", { className: "lookup-col-title name-col" }, "Name"),
                React.createElement("span", { className: "lookup-col-title code-col" }, "Code")),
            React.createElement("ul", { className: "lookup-section-list" }, m.AgencyCodes().map(function (c) {
                return React.createElement(AgencyCodeView, { agencyCode: c, model: m, key: c.Model.CodedOrganizationId() });
            })),
            React.createElement("div", { className: "add-btn-row" }, m.EnableAddAgencyCode() &&
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.AddAgencyCode) }, "+Add Agency"))));
});
var AgencyCodeView = supercritical_1.default(function (_a) {
    var c = _a.agencyCode, m = _a.model;
    return React.createElement("li", null,
        React.createElement("div", null,
            React.createElement(DeleteBtn, { item: c }),
            React.createElement("span", { className: "name-col pc-text-fixedwidth" }, c.Editing() ?
                React.createElement("span", null,
                    React.createElement("select", { className: "cell-edit pc-select", value: c.Model.CodedOrganizationId(), onChange: function (e) { return c.Model.CodedOrganizationId(+e.currentTarget.value); } }, m.OrganizationsAvailableForAgencyCode(c).map(function (o) {
                        return React.createElement("option", { value: o.Id(), key: o.Id() }, o.Name());
                    })),
                    React.createElement("span", { className: "pc-select-chevron" })) :
                React.createElement("span", { className: "cell-view" }, c.Model.CodedOrganization() && c.Model.CodedOrganization().Name())),
            React.createElement("span", { className: "code-col" },
                React.createElement(TextEditControl, { value: c.Model.Code, editing: c.Editing })),
            React.createElement(EditToggle, { item: c })),
        React.createElement("div", null,
            React.createElement(view_1.ValidationErrorView, { error: function () { return c.Validation()['Code']; } })));
});
var PilotsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "lookup-section pilots" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Pilots"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "This is a list of all the users with the Pilot permission. Provide each pilot with a code, and it will be reflected on the Dispatch Dashboard."),
        React.createElement("div", { className: "lookup-section-content" },
            React.createElement("div", { className: "lookup-section-headers" },
                React.createElement("span", { className: "lookup-col-title name-col" }, "Name"),
                React.createElement("span", { className: "lookup-col-title code-col" }, "Code")),
            React.createElement("ul", { className: "lookup-section-list" }, m.Pilots().map(function (p) {
                return React.createElement(PilotView, { pilot: p, key: p.Model.Id() });
            }))));
});
var PilotView = supercritical_1.default(function (_a) {
    var p = _a.pilot;
    return React.createElement("li", null,
        React.createElement("div", null,
            React.createElement("span", { className: "name-col pc-text-fixedwidth" },
                React.createElement("span", { className: "cell-view" }, p.Model.User() && p.Model.User().FullName())),
            React.createElement("span", { className: "code-col" },
                React.createElement(TextEditControl, { value: p.Code, editing: p.Editing })),
            React.createElement(EditToggle, { item: p })),
        React.createElement("div", null,
            React.createElement(view_1.ValidationErrorView, { error: function () { return p.Validation()['Code']; } })));
});
var TugCompaniesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "lookup-section" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Tug Companies"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "This is a list of tug companies that work within the port. These names will be listed on the Pilot Order form. Provide each tug company with a code, and it will be reflected on the Dispatch Dashboard."),
        React.createElement("div", { className: "lookup-section-content" },
            React.createElement("div", { className: "lookup-section-headers" },
                React.createElement("span", { className: "lookup-col-title name-col" }, "Name"),
                React.createElement("span", { className: "lookup-col-title code-col" }, "Code")),
            React.createElement("ul", { className: "lookup-section-list" }, m.TugCompanies().map(function (tug) {
                return React.createElement(TugCompanyView, { tug: tug, key: tug.Model.Id() });
            })),
            React.createElement("div", { className: "add-btn-row" }, m.EnableAddTug() &&
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.AddTugCompany) }, "+Add Tug Co."))));
});
var TugCompanyView = supercritical_1.default(function (_a) {
    var tug = _a.tug;
    return React.createElement("li", null,
        React.createElement("div", null,
            React.createElement(DeleteBtn, { item: tug }),
            React.createElement("span", { className: "name-col pc-text-fixedwidth" },
                React.createElement(TextEditControl, { value: tug.Model.Name, editing: tug.Editing })),
            React.createElement("span", { className: "code-col" },
                React.createElement(TextEditControl, { value: tug.Model.Code, editing: tug.Editing })),
            React.createElement(EditToggle, { item: tug })),
        React.createElement("div", null,
            React.createElement(view_1.ValidationErrorView, { error: function () { return tug.Validation()['Name']; } }),
            React.createElement(view_1.ValidationErrorView, { error: function () { return tug.Validation()['Code']; } })));
});
var LineHandlersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "lookup-section" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Line Handlers"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "This is a list of line handlers that work within the port. These names will be listed on the Pilot Order form and the Movement Details popup on the Dispatch Dashboard."),
        React.createElement("div", { className: "lookup-section-content" },
            React.createElement("div", { className: "lookup-section-headers" },
                React.createElement("span", { className: "lookup-col-title name-col" }, "Name"),
                React.createElement("span", { className: "lookup-col-title code-col" }, "Code")),
            React.createElement("ul", { className: "lookup-section-list" }, m.LineHandlingCompanies().map(function (l) {
                return React.createElement(LineHandlerView, { lineHandler: l, key: l.Model.Id() });
            })),
            React.createElement("div", { className: "add-btn-row" }, m.EnableAddLineHandler() &&
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.AddLineHandlingCompany) }, "+Add Line Handler"))));
});
var LineHandlerView = supercritical_1.default(function (_a) {
    var l = _a.lineHandler;
    return React.createElement("li", null,
        React.createElement("div", null,
            React.createElement(DeleteBtn, { item: l }),
            React.createElement("span", { className: "name-col pc-text-fixedwidth" },
                React.createElement(TextEditControl, { value: l.Model.Name, editing: l.Editing })),
            React.createElement("span", { className: "code-col" },
                React.createElement(TextEditControl, { value: l.Model.Code, editing: l.Editing })),
            React.createElement(EditToggle, { item: l })),
        React.createElement("div", null,
            React.createElement(view_1.ValidationErrorView, { error: function () { return l.Validation()['Name']; } }),
            React.createElement(view_1.ValidationErrorView, { error: function () { return l.Validation()['Code']; } })));
});
var DeleteBtn = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("a", { href: "", className: cx('delete-btn pc-close-icon', {
            'delete-btn-hide': !item.Editing()
        }), onClick: eventWrappers_1.noDefault(item.Delete) });
});
var EditToggle = supercritical_1.default(function (_a) {
    var item = _a.item;
    return item.Editing() ?
        React.createElement("a", { href: "", className: "edit-toggle edit-done", onClick: eventWrappers_1.noDefault(function () { return item.Editing(false); }) }, "Done") :
        React.createElement("a", { href: "", className: "edit-toggle", onClick: eventWrappers_1.noDefault(function () { return item.Editing(true); }) }, "Edit");
});
var TextEditControl = supercritical_1.default(function (_a) {
    var value = _a.value, editing = _a.editing;
    return editing() ?
        React.createElement("input", { className: "cell-edit", value: value() || '', onChange: function (e) { return value(e.currentTarget.value); } }) :
        React.createElement("span", { className: "cell-view" }, value());
});


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderDetailsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var DraftCharge_1 = __webpack_require__(1258);
var DraftChargeCollection_1 = __webpack_require__(1259);
var OriginalPilotOrder_1 = __webpack_require__(1297);
var PilotJobOrderDetails_1 = __webpack_require__(1313);
var PilotJobOrderDetailsBilling_1 = __webpack_require__(1314);
var PilotJobOrderDetailsCache = /** @class */ (function (_super) {
    __extends(PilotJobOrderDetailsCache, _super);
    function PilotJobOrderDetailsCache(data) {
        var _this = _super.call(this) || this;
        _this.PilotJobOrderDetailses = PCCache_1.PCCollection(PilotJobOrderDetails_1.PilotJobOrderDetails);
        _this.PilotJobOrderDetailsBillings = PCCache_1.PCCollection(PilotJobOrderDetailsBilling_1.PilotJobOrderDetailsBilling);
        _this.DraftChargeCollections = PCCache_1.PCCollection(DraftChargeCollection_1.DraftChargeCollection);
        _this.DraftCharges = PCCache_1.PCCollection(DraftCharge_1.DraftCharge);
        _this.OriginalPilotOrders = PCCache_1.PCCollection(OriginalPilotOrder_1.OriginalPilotOrder);
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrderDetailses, data.PilotJobOrders, function (d) { return d.PilotJobOrder; }, null);
        new DataCache_1.SharedKeyRelationship(_this.PilotJobOrderDetailsBillings, data.PilotJobOrders, function (b) { return b.PilotJobOrder; }, null);
        new DataCache_1.SharedKeyRelationship(_this.DraftChargeCollections, _this.PilotJobOrderDetailsBillings, null, function (b) { return b.DraftCharges; });
        new DataCache_1.ForeignKeyRelationship(_this.DraftChargeCollections, _this.DraftCharges, function (col) { return col.Charges; }, function (c) { return c.ChargeCollection; }, function (c) { return c.ChargeCollectionId(); });
        new DataCache_1.ForeignKeyRelationship(data.StandardItems, _this.DraftCharges, null, function (c) { return c.StandardItem; }, function (c) { return c.StandardItemId(); });
        new DataCache_1.ForeignKeyRelationship(data.Rates, _this.DraftCharges, null, function (c) { return c.StandardRate; }, function (c) { return c.StandardRateId(); });
        new DataCache_1.QueryResultRelationship(_this.OriginalPilotOrders, data.PortCallPITs, function (r) { return r.OriginalOrder; });
        return _this;
    }
    return PilotJobOrderDetailsCache;
}(DataCache_1.DataCache));
exports.PilotJobOrderDetailsCache = PilotJobOrderDetailsCache;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderDetails = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var underscore_1 = __webpack_require__(67);
var autoSave_1 = __webpack_require__(31);
var draftSignals_1 = __webpack_require__(37);
var tzmoment_1 = __webpack_require__(9);
var ConvertibleMeasurement_1 = __webpack_require__(163);
var ConvertedMeasurement_1 = __webpack_require__(116);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var UOM_1 = __webpack_require__(25);
var diacriticals_1 = __webpack_require__(42);
var jsonableObservable_1 = __webpack_require__(1);
var validationWatcher_1 = __webpack_require__(23);
var BerthReservation_1 = __webpack_require__(79);
var ScheduleDate_1 = __webpack_require__(93);
var Issue_1 = __webpack_require__(135);
var IssueType_1 = __webpack_require__(112);
var Measurement_1 = __webpack_require__(11);
var PhoneNumberKind_1 = __webpack_require__(208);
var PilotJobOrder_1 = __webpack_require__(160);
var PilotShiphandlingNote_1 = __webpack_require__(584);
var agentRestrictionsErrorParser_1 = __webpack_require__(259);
var model_1 = __webpack_require__(518);
var model_2 = __webpack_require__(521);
var model_3 = __webpack_require__(523);
var model_4 = __webpack_require__(90);
function PilotJobOrderDetails(ajax, entrypoints, data, tzutils, localization, pierSettings, user, pjoPrefsModel, pilotAssignmentsModel, logUpdaterModel, pilotJobOrderLogModel, addShiftPopupModel, editMovementEndPopupModel, pilotageChargesModel, originalPilotOrderModel, footmarkAssignmentsModel, _a) {
    var pjo = _a.pjo, model = _a.model, flip = _a.flip, onDelete = _a.onDelete, onReorder = _a.onReorder, onAddShift = _a.onAddShift, onAcknowledge = _a.onAcknowledge, canAcknowledge = _a.canAcknowledge, corePermissions = _a.corePermissions;
    var showActionsMenu = s_js_1.default.data(false), actionToConfirm = s_js_1.default.data(null), flipped = s_js_1.default.data(flip !== null), backPage = s_js_1.default.data(flip), clock = tzutils.clock(1000), bowThrusterModel = function (b) { return BowThrusterViewModel(b, model); }, vesselModel = function (v) { return VesselViewModel(v, ajax, pierSettings, bowThrusterModel); }, portCallModel = function (pc) { return PortCallViewModel(pc, ajax, AgentViewModel); }, reservationModel = function (br) { return ReservationViewModel(br, function () { return model.CanEditPortCall() && !!model.PilotJobOrder() && !model.PilotJobOrder().Cancellation(); }, footmarkAssignmentsModel); }, 
    // Th 02/03/2017 -- Berths for berth typeaheds
    berths = s_array_1.lift(function () { return Array.from(data.Berths.items()); })
        .filter(function (b) {
        return !!b.Location() &&
            !!pjo.EffectivePortCall() &&
            b.Location().PortId() === pjo.EffectivePortCall().PortId();
    }), itineraryPointModel = function (pt) { return ItineraryPointViewModel(pt, ajax, data, berths, reservationModel); }, jobOrder = PilotJobOrderViewModel({
        pjo: pjo,
        ajax: ajax,
        entrypoints: entrypoints,
        data: data,
        pierSettings: pierSettings,
        tzutils: tzutils,
        actionToConfirm: actionToConfirm,
        portCallModel: portCallModel,
        itineraryPointModel: itineraryPointModel,
        vesselModel: vesselModel,
        pjoPrefsModel: pjoPrefsModel,
        addShiftPopupModel: addShiftPopupModel,
        editMovementEndPopupModel: editMovementEndPopupModel,
        onDelete: onDelete,
        onReorder: onReorder,
        onAddShift: onAddShift,
        onAcknowledge: onAcknowledge
    }), berthReservationDetails = BerthReservationDetailsSection(jobOrder), pilotAssignments = pilotAssignmentsModel({ model: model }), logUpdater = logUpdaterModel({ pjo: pjo }), log = pilotJobOrderLogModel({ pjo: pjo }), originalPilotOrder = originalPilotOrderModel({ pjo: pjo, hideActionsMenu: function () { return showActionsMenu(false); } }), Validation = s_js_1.default(function () { var _a, _b, _c, _d; return validationWatcher_1.mergeErrors((_b = (_a = jobOrder.FromPoint()) === null || _a === void 0 ? void 0 : _a.Validation()) !== null && _b !== void 0 ? _b : {}, (_d = (_c = jobOrder.ToPoint()) === null || _c === void 0 ? void 0 : _c.Validation()) !== null && _d !== void 0 ? _d : {}); }), AgentRestrictions = s_js_1.default(function () { return agentRestrictionsErrorParser_1.agentRestrictionErrors(Validation()); }), ShowAgentRestrictions = s_js_1.default.value(false);
    s_js_1.default(function () { return ShowAgentRestrictions(Object.keys(AgentRestrictions()).length > 0); });
    s_js_1.default(function () {
        // No need to poll PortCall Log when the Log isn't visible.
        if (flipped() && backPage() === 0 /* Log */)
            logUpdater.start();
        else
            logUpdater.stop();
    });
    // Standard dropdown options used for BowThruster Present and Does it work? fields
    var yesNoUnknown = [{
            name: '--',
            value: null
        }, {
            name: 'Yes',
            value: true
        }, {
            name: 'No',
            value: false
        }];
    var pilotageCharges = pilotageChargesModel({
        PJO: jobOrder,
        PersistedPJO: pjo,
        PilotageChargesFlipActive: function () { return flipped() && backPage() === 3 /* PilotageCharges */; }
    });
    return {
        Model: model,
        JobOrder: jobOrder,
        // TH 04/13/2017 -- For Acknowledgement workflow:
        // Preload the Acknowledge permission from the DDash.
        // Show the Acknowledge link if either the DDash or the PJO Details response indicate that they have permissions.
        // That way we can make the Acknowledge link available even before the rest of the PJO details loads.
        // This speeds up the workflow for users acknowledging several PJOs in a row.
        CanAcknowledge: function () { return canAcknowledge() || model.CanAcknowledge(); },
        CanReorder: function () { var _a, _b; return (_b = (_a = corePermissions()) === null || _a === void 0 ? void 0 : _a.CanAddPilotJobOrders()) !== null && _b !== void 0 ? _b : null; },
        ShowConflicts: ShowConflicts,
        ShowActionsMenu: showActionsMenu,
        ActionToConfirm: actionToConfirm,
        ToggleActionsMenu: function () { return showActionsMenu(!showActionsMenu()); },
        PilotAssignments: pilotAssignments,
        PilotageCharges: pilotageCharges,
        OriginalPilotOrder: originalPilotOrder,
        BerthReservationDetails: berthReservationDetails,
        Log: log,
        Flipped: flipped,
        MenuAction: MenuAction,
        FlipToBack: FlipToBack,
        BackPage: backPage,
        YesNoUnknown: yesNoUnknown,
        Localization: localization,
        TugCompanies: s_array_1.lift(function () { var _a, _b; return (_b = (_a = pjo.PilotAgency()) === null || _a === void 0 ? void 0 : _a.TugCompanies()) !== null && _b !== void 0 ? _b : []; })
            .filter(function (tug) { return tug.Active(); }),
        LineHandlingCompanies: s_array_1.lift(function () { var _a, _b; return (_b = (_a = pjo.PilotAgency()) === null || _a === void 0 ? void 0 : _a.LineHandlingCompanies()) !== null && _b !== void 0 ? _b : []; })
            .filter(function (lh) { return lh.Active(); }),
        Clock: clock,
        User: user,
        // Signal to the DDash that we'd like to take over the entire page w/ temporary UI of our
        // choosing. In theory, there could be multiple reasons we want to do this. In practice,
        // we'll use this to support printing the original pilot order. We want that UI to briefly
        // be the only thing visible on screen.
        IsRequestingFullPageTakeOver: function () {
            return !!originalPilotOrder.DisplayedOrder();
        },
        AgentRestrictions: AgentRestrictions,
        ShowAgentRestrictions: ShowAgentRestrictions
    };
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function FlipToBack(page) {
        s_js_1.default.freeze(function () {
            backPage(page);
            flipped(true);
        });
    }
    function ShowConflicts() {
        // Ignore conflicts for CNX PJOs
        return !pjo.Cancellation();
    }
}
exports.PilotJobOrderDetails = PilotJobOrderDetails;
function PilotJobOrderViewModel(_a) {
    var pjo = _a.pjo, ajax = _a.ajax, entrypoints = _a.entrypoints, data = _a.data, pierSettings = _a.pierSettings, tzutils = _a.tzutils, actionToConfirm = _a.actionToConfirm, portCallModel = _a.portCallModel, itineraryPointModel = _a.itineraryPointModel, vesselModel = _a.vesselModel, pjoPrefsModel = _a.pjoPrefsModel, addShiftPopupModel = _a.addShiftPopupModel, editMovementEndPopupModel = _a.editMovementEndPopupModel, onDelete = _a.onDelete, onReorder = _a.onReorder, onAddShift = _a.onAddShift, onAcknowledge = _a.onAcknowledge;
    var client = ajax.Url(function () { return pjo.Url() || ''; }, { useCache: true }), cnxClient = ajax.Url(function () { return entrypoints.CancelPilotJobOrder({ Id: pjo.Id() }); }), draft = autoSave_1.AutoSavingDraftObject(pjo, client, [
        'AirDraft.Num',
        'AirDraft.UOM',
        'Billable',
        'BillToAddress',
        'BowThrusterOperational',
        'DeepDraftConfirmed',
        'DeepDraft.Num',
        'DeepDraft.UOM',
        'End.Actual',
        'End.Estimated',
        'LaborStartTime',
        'Length.Num',
        'Length.UOM',
        'LineHandlingCompanyId',
        'NumberOfTugs',
        'QBTracking.Customer',
        'Remarks',
        'Start.Actual',
        'Start.Estimated',
        'StartTimeConfirmed',
        'TugCompanyId',
        'VesselId'
    ]), transitTime = function () { return tzmoment_1.tzmoment(draft.End.Estimated()).diff(tzmoment_1.tzmoment(draft.Start.Estimated()), 'minutes'); }, showUndoStartActual = s_js_1.default.data(false), showUndoEndActual = s_js_1.default.data(false), syncedStartAndEndEstimate = function (val) {
        if (val === undefined)
            return draft.Start.Estimated();
        return s_js_1.default.freeze(function () {
            draft.End.Estimated(tzmoment_1.tzmomentMod(tzutils, val, function (m) { return m.add(transitTime(), 'minutes'); }));
            return draft.Start.Estimated(val);
        });
    }, showEditMovementEndPopup = s_js_1.default.data(false), editMovementEndPopup = s_js_1.default(function () {
        var _a, _b;
        if (!showEditMovementEndPopup())
            return null;
        var toRes = (_a = pjo.EffectiveToPoint()) === null || _a === void 0 ? void 0 : _a.BerthReservation(), fromRes = (_b = pjo.EffectiveFromPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation(), validateClient = ajax.Url(entrypoints.ValidatePilotJobOrderTimes);
        return editMovementEndPopupModel({
            EndTime: draft.End.Estimated,
            StartTime: draft.Start.Estimated,
            MovementType: fromRes ? toRes ? 'shift' : 'out' : 'in',
            OnClosePopup: function () { return showEditMovementEndPopup(false); },
            Validate: function (startDate, endDate) {
                var pjo = JSON.parse(JSON.stringify(draft));
                pjo.Start.Estimated = startDate.toJSON();
                pjo.End.Estimated = endDate.toJSON();
                return validateClient.Put(pjo).then(function () { return []; }, function (errs) { return underscore_1.values(validationWatcher_1.parseModelStateErrors(errs)); });
            }
        });
    }), showDateTimeEditPopup = s_js_1.default.data(null), dateTimeEditPopup = s_js_1.default(function () {
        if (showDateTimeEditPopup() === null)
            return null;
        var popupKind = showDateTimeEditPopup(), value = popupKind === 'start-est' ? syncedStartAndEndEstimate :
            popupKind === 'start-effective' ? draft.Start.Effective :
                popupKind === 'end-effective' ? draft.End.Effective :
                    // Until typescript lands throw expressions...
                    // See https://github.com/Microsoft/TypeScript/issues/18535
                    (function () { throw new Error("Unknown dateTimeEditPopup kind: " + popupKind); })(), validateClient = ajax.Url(entrypoints.ValidatePilotJobOrderTimes), validation = validationWatcher_1.ValidationWatcher(validateClient);
        return model_1.DateTimeEditPopup({
            value: value,
            onDismiss: function () { return showDateTimeEditPopup(null); },
            validation: {
                validate: function (val) {
                    var toValidate = JSON.parse(JSON.stringify(draft));
                    if (popupKind === 'start-est') {
                        toValidate.Start.Estimated = val.toJSON();
                        toValidate.End.Estimated = tzmoment_1.tzmomentMod(tzutils, val, function (m) { return m.add(transitTime(), 'minutes'); }).toJSON();
                    }
                    else if (popupKind === 'start-effective') {
                        if (toValidate.Start.Actual)
                            toValidate.Start.Actual = val.toJSON();
                        else
                            toValidate.Start.Estimated = val.toJSON();
                    }
                    else if (popupKind === 'end-effective') {
                        if (toValidate.End.Actual)
                            toValidate.End.Actual = val.toJSON();
                        else
                            toValidate.End.Estimated = val.toJSON();
                    }
                    return validateClient.Put(toValidate);
                },
                errors: function () { return underscore_1.values(validation()); }
            }
        });
    }), showNullableDateTimeEditPopup = s_js_1.default.data(null), nullableDateTimeEditPopup = s_js_1.default(function () {
        if (showNullableDateTimeEditPopup() === null)
            return null;
        var value = showNullableDateTimeEditPopup() === 'labor-start' ? draft.LaborStartTime :
            // Until typescript lands throw expressions...
            (function () { throw new Error("Unknown nullableDateTimeEditPopup kind: " + showNullableDateTimeEditPopup()); })();
        return model_1.NullableDateTimeEditPopup({
            value: value,
            onDismiss: function () { return showNullableDateTimeEditPopup(null); }
        });
    }), showLogActualTimePopup = s_js_1.default.data(null), logActualTimePopup = s_js_1.default(function () {
        if (showLogActualTimePopup() === null)
            return null;
        var now = tzutils.now(), popupKind = showLogActualTimePopup(), actual = popupKind === 'start-actual' ? draft.Start.Actual :
            popupKind === 'end-actual' ? draft.End.Actual :
                // Until typescript lands throw expressions...
                (function () { throw new Error("Unknown logActualTimePopup kind: " + popupKind); })(), validateClient = ajax.Url(entrypoints.ValidatePilotJobOrderTimes), validation = validationWatcher_1.ValidationWatcher(validateClient);
        return model_1.DateTimeEditPopup({
            value: function (val) {
                if (val === undefined)
                    return actual() || now;
                return actual(val);
            },
            onDismiss: function (status) { return s_js_1.default.freeze(function () {
                showLogActualTimePopup(null);
                // If the user hit OK without editing the value in the DateTimeEditPopup,
                // we wanna set the actual to the init value at the time the popup is dismissed.
                if (status === 1 /* OKNotEdited */)
                    actual(now);
            }); },
            validation: {
                validate: function (val) {
                    var toValidate = JSON.parse(JSON.stringify(draft));
                    if (popupKind === 'start-actual') {
                        toValidate.Start.Actual = val.toJSON();
                    }
                    else if (popupKind === 'end-actual') {
                        toValidate.End.Actual = val.toJSON();
                    }
                    return validateClient.Put(toValidate);
                },
                // We initialize the popup value to now, which might be invalid if
                // PJO start is somehow in the future. Hence we validate immediately.
                runOnStart: true,
                errors: function () { return underscore_1.values(validation()); }
            }
        });
    }), showAddShift = s_js_1.default.data(false), addShiftPopup = s_js_1.default(function () { return showAddShift() ? addShiftPopupModel({
        // TH 02/13/2017 -- We'll only ever show the AddShiftPopup for OUTs, in which
        // case we want to use the FromPoint as the previousPoint.
        previousPoint: pjo.FromPoint,
        onCancel: function () { return showAddShift(false); },
        onSuccess: AddShiftSuccess
    }) : null; }), showCancellationRemarksPromp = s_js_1.default.value(false), cancellationRemarksPrompt = s_js_1.default(function () { return showCancellationRemarksPromp() ?
        CancellationRemarksPrompt(Cancel, function () { return s_js_1.default.freeze(function () {
            showCancellationRemarksPromp(false);
            actionToConfirm(null);
        }); }) :
        null; }), showAbortRemarksPromp = s_js_1.default.value(false), abortRemarksPrompt = s_js_1.default(function () { return showAbortRemarksPromp() ?
        AbortRemarksPrompt(Cancel, UndoStartActual, function () { return s_js_1.default.freeze(function () {
            showAbortRemarksPromp(false);
            actionToConfirm(null);
        }); }) :
        null; }), cancelWholePortCallParams = s_js_1.default.value(null), cancelWholePortCallPrompt = s_js_1.default(function () { return cancelWholePortCallParams() ? CancelWholePortCallPrompt({
        pjo: pjo,
        remarks: cancelWholePortCallParams().remarks,
        ajax: ajax,
        entrypoints: entrypoints,
        hidePrompt: function () { return cancelWholePortCallParams(null); }
    }) : null; }), draftPreferences = pjoPrefsModel({ pjo: pjo }).draftPreferences, Working = s_js_1.default.value(false);
    // TODO -- Possibly move lock/unlock logic server-side. I spotted about 5 cases in CHP db where
    // PJOs had logged pilot aboard but didn't have a locked vessel. My guess is those are coming
    // via the homepage movements widget.
    // TH 02/03/2017 -- Wire up draft computed and navigation properties.
    var startActualDraftSignal = draft.Start.Actual;
    draft.Start.Actual = jsonableObservable_1.jsonableObservable(function (val) {
        if (val === undefined)
            return startActualDraftSignal();
        return s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
            // TH 03/09/2017 -- Memorialize the current PortCall Vessel and Length when the user
            // logs pilot aboard...
            if (val) {
                // ... but do nothing if the user is just changing the pilot aboard time...
                if (draft.EffectivePortCall() && !startActualDraftSignal()) {
                    draft.VesselId(draft.EffectivePortCall().VesselId());
                    draft.Length.set(draft.EffectivePortCall().VesselLength);
                }
            }
            else {
                // ... and if undoing pilot aboard, default back to current PortCall Vessel and Length.
                draft.VesselId(null);
                draft.Length.set(new Measurement_1.NullableMeasurement());
            }
            return startActualDraftSignal(val);
        }); });
    });
    draft.Start.Effective = ScheduleDate_1.EffectiveDate(draft.Start);
    draft.End.Effective = ScheduleDate_1.EffectiveDate(draft.End);
    draft.EffectiveLength = PilotJobOrder_1.EffectiveLength(draft);
    draft.EffectiveAirDraft = PilotJobOrder_1.EffectiveAirDraft(draft);
    draft.EffectiveDeepDraft = PilotJobOrder_1.EffectiveDeepDraft(draft);
    draft.TugCompany = s_js_1.default.value(s_js_1.default.sample(pjo.TugCompany));
    draft.LineHandlingCompany = s_js_1.default.value(s_js_1.default.sample(pjo.LineHandlingCompany));
    draft.Vessel = s_js_1.default.value(s_js_1.default.sample(pjo.Vessel));
    data.PilotJobOrders.attach(draft, [draft.TugCompany, draft.LineHandlingCompany, draft.Vessel]);
    // TH 02/03/2017 -- Have to construct these AFTER setting draft.EffectiveAirDraft and draft.EffectiveDeepDraft above.
    var effectiveDeepDraft = EffectiveDraftViewModel(draft.DeepDraft, draft.EffectiveDeepDraft), effectiveAirDraft = EffectiveDraftViewModel(draft.AirDraft, draft.EffectiveAirDraft), deepDraftConfirmed = (function (val) {
        if (val === undefined)
            return draft.DeepDraftConfirmed();
        return s_js_1.default.freeze(function () {
            if (val) {
                // TH: 02/02/2017 -- "Lock" PJO Air and DeepDraft upon confirming DeepDraft.
                // That way future changes to the PortCall drafts don't alter the confirmed draft value.
                effectiveDeepDraft.Lock();
                effectiveAirDraft.Lock();
            }
            return draft.DeepDraftConfirmed(val);
        });
    }), hasDraftConflict = pjo.Issues.some(function (i) { return i.Type() === IssueType_1.IssueType.PilotJobOrderExceedsBerthDepth && i.Severity() >= Issue_1.IssueSeverity.Conflict; });
    return {
        Model: draft,
        PortCall: s_js_1.default(function () { return pjo.EffectivePortCall() && portCallModel(pjo.EffectivePortCall()); }),
        FromPoint: s_js_1.default(function () { return pjo.EffectiveFromPoint() && itineraryPointModel(pjo.EffectiveFromPoint()); }),
        ToPoint: s_js_1.default(function () { return pjo.EffectiveToPoint() && itineraryPointModel(pjo.EffectiveToPoint()); }),
        EffectiveVessel: s_js_1.default(function () { return pjo.EffectiveVessel() && vesselModel(pjo.EffectiveVessel()); }),
        EffectiveLength: function () {
            var effective = new Measurement_1.Measurement({
                Num: draft.EffectiveLength.Num(),
                UOM: draft.EffectiveLength.UOM()
            });
            return lengthText(effective, pierSettings.DefaultLengthUOM)();
        },
        TransitTime: transitTime,
        ToggleStartConfirmed: ToggleStartConfirmed,
        DeepDraftConfirmed: deepDraftConfirmed,
        ToggleDeepDraftConfirmed: ToggleDeepDraftConfirmed,
        HasDraftConflict: hasDraftConflict,
        EffectiveDeepDraft: effectiveDeepDraft,
        EffectiveAirDraft: effectiveAirDraft,
        SyncedStartAndEndEstimate: syncedStartAndEndEstimate,
        ShowUndoStartActual: showUndoStartActual,
        UndoStartActual: UndoStartActual,
        ShowUndoEndActual: showUndoEndActual,
        UndoEndActual: UndoEndActual,
        ShowEditMovementEndPopup: showEditMovementEndPopup,
        EditMovementEndPopup: editMovementEndPopup,
        ShowDateTimeEditPopup: showDateTimeEditPopup,
        DateTimeEditPopup: dateTimeEditPopup,
        ShowLogActualTimePopup: showLogActualTimePopup,
        LogActualTimePopup: logActualTimePopup,
        ShowNullableDateTimeEditPopup: showNullableDateTimeEditPopup,
        NullableDateTimeEditPopup: nullableDateTimeEditPopup,
        EffectiveUserPreferences: draftPreferences,
        ToggleRemarksVisible: function () { return draftPreferences.RemarksVisible(!draftPreferences.RemarksVisible()); },
        Acknowledge: Acknowledge,
        PromptForCancellationRemarks: PromptForCancellationRemarks,
        CancellationRemarksPrompt: cancellationRemarksPrompt,
        PromptForAbortRemarks: PromptForAbortRemarks,
        AbortRemarksPrompt: abortRemarksPrompt,
        CancelWholePortCallPrompt: cancelWholePortCallPrompt,
        Reorder: onReorder,
        Delete: Delete,
        Working: Working,
        ShowAddShift: showAddShift,
        AddShiftPopup: addShiftPopup
    };
    function ToggleStartConfirmed() {
        draft.StartTimeConfirmed(!draft.StartTimeConfirmed());
    }
    function ToggleDeepDraftConfirmed() {
        deepDraftConfirmed(!deepDraftConfirmed());
    }
    function UndoStartActual() {
        s_js_1.default.freeze(function () {
            draft.Start.Actual(null);
            showUndoStartActual(false);
        });
    }
    function UndoEndActual() {
        s_js_1.default.freeze(function () {
            draft.End.Actual(null);
            showUndoEndActual(false);
        });
    }
    function Acknowledge() {
        // TH 04/14/2017 -- UPDATE:
        // Now batching PJO Acknowledgement request to prevent multiple overlapping requests from
        // crashing the server.
        // So no longer using the AutoSavingDraftObject to persist AcknowledgedDate changes.
        onAcknowledge();
        // TH 04/12/2017 -- Hmm...
        // Subtle bug. Setting the AcknowledgedDate and calling onAcknowledge in the same tick
        // ends up preventing the autosave from happening.
        // That's b/c the PilotJobOrderDetailsViewModel is constructed inside an S computation
        // in the DispatchDashboardViewModel that depends on the selectedItemKey, and onAcknowledge
        // changes the selectedItemKey.
        // Will probably look at splitting up our draft construction so that our draft objects
        // remain stable across changing the selected PJO.
        // But for now removing the freeze is enough to get this saving correctly.
        // S.freeze(() => {
        // draft.AcknowledgedDate(tzutils.now());
        // onAcknowledge();
        // });
    }
    function PromptForAbortRemarks() {
        if (!Working())
            showAbortRemarksPromp(true);
    }
    function PromptForCancellationRemarks() {
        if (!Working())
            showCancellationRemarksPromp(true);
    }
    function Cancel(remarks) {
        if (Working())
            return;
        Working(true);
        var req = cnxClient.Post({ Id: 0, Remarks: remarks || null });
        return req.then(function (result) { return s_js_1.default.freeze(function () {
            data.PilotJobOrderCancellations.update1(req.Date, result.Cancellation);
            if (result.AllPilotJobOrdersCancelled)
                cancelWholePortCallParams({ remarks: remarks });
        }); }).finally(function () { return Working(false); });
    }
    function Delete() {
        if (Working())
            return;
        s_js_1.default.freeze(function () {
            actionToConfirm(null);
            Working(true);
        });
        var req = client.Delete();
        req.then(function () { return s_js_1.default.freeze(function () {
            data.PilotJobOrders.update(req.Date, [], [pjo.Id()]);
            onDelete();
        }); }).finally(function () { return Working(false); });
    }
    function AddShiftSuccess(entities) {
        var _a;
        // TH 02/13/2017 -- We expect 2 PJOs to be added/updated from the Add Shift:
        //   1) The current PJO, which will change from an OUT to a SHIFT
        //   2) The new OUT PJO
        // We wanna pass the new OUT to the DispatchDashboard, so we filter out the current PJO.
        var _pjo = (_a = entities.PilotEntities()) === null || _a === void 0 ? void 0 : _a.PilotJobOrders().filter(function (p) { return p !== pjo; })[0];
        if (_pjo)
            onAddShift(_pjo);
        else
            throw new Error('AddShiftSuccess -- Expected to find a new PilotJobOrder.');
    }
}
function EffectiveDraftViewModel(pjoRawDraft, pjoEffectiveDraft) {
    // TH 02/03/2017 -- Unlike the effective drafts from data/models/PilotJobOrder.ts,
    // this version also checks a hasWritten flag. The purpose is to allow users to
    // temporarily clear the display value of the field.
    var hasWritten = s_js_1.default.data(false), effective = function () { return hasWritten() ? pjoRawDraft : pjoEffectiveDraft; }, backingMeasurement = {
        Num: function (val) {
            if (val === undefined) {
                return effective().Num();
            }
            return s_js_1.default.freeze(function () {
                hasWritten(true);
                return pjoEffectiveDraft.Num(val);
            });
        },
        UOM: function () { return effective().UOM(); }
    }, decimalPlaces = { inches: 0, meters: 2 }, feetInchesMeters = model_2.NullableFeetInchesMetersEdit({ backingMeasurement: backingMeasurement, decimalPlaces: decimalPlaces });
    return {
        FeetInchesMeters: feetInchesMeters,
        Lock: pjoEffectiveDraft.Lock,
        OnBlur: function () { return hasWritten(false); },
        HasLockedValue: function () { return pjoRawDraft.Num() !== null; }
    };
}
function ItineraryPointViewModel(point, ajax, data, berths, reservationModel) {
    var client = ajax.Url(function () { return point.Url() || ''; }, { useCache: true, include: [function (pt) { return pt.BerthReservation; }] }), _a = draftSignals_1.DraftObject(point, [
        // aah: itinerary time updates is now handled server-side
        //'Arrival.Estimated',
        //'Arrival.Actual',
        //'Departure.Estimated',
        //'Departure.Actual',
        'LocationId'
    ]), draft = _a.object, draftMethods = _a.methods, berthQuery = s_js_1.default.data(s_js_1.default.sample(function () { var _a, _b; return (_b = (_a = point.Location()) === null || _a === void 0 ? void 0 : _a.Name()) !== null && _b !== void 0 ? _b : ''; })), berthTypeahead = new model_4.Typeahead({
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        collection: berths,
        observable: berthQuery,
        matchFn: function (berth, query) { return !!berth.Location() &&
            diacriticals_1.CaseInsensitiveStartsWith(berth.Location().Name(), query); },
        displayKey: function (berth) { return berth.Location() && berth.Location().Name() || ''; },
        onSelect: function (berth) { return draft.LocationId(berth.Id()); }
    }), berthReservation = s_js_1.default(function () { return point.BerthReservation() && reservationModel(point.BerthReservation()); }), mergedDraftMethods = draftSignals_1.mergeDraftMethods(draftMethods, function () { var _a, _b; return (_b = (_a = berthReservation()) === null || _a === void 0 ? void 0 : _a.DraftMethods) !== null && _b !== void 0 ? _b : null; }), Validation = validationWatcher_1.ValidationWatcher(client);
    autoSave_1.DraftAutoSaver({ object: draft, methods: mergedDraftMethods }, client);
    draft.Location = s_js_1.default.value(s_js_1.default.sample(point.Location));
    data.ItineraryPoints.attach(draft, [draft.Location]);
    draft.BerthReservation = function () { var _a, _b; return (_b = (_a = berthReservation()) === null || _a === void 0 ? void 0 : _a.Model) !== null && _b !== void 0 ? _b : null; };
    s_js_1.default(function () { return draft.Location() && berthQuery(draft.Location().Name()); });
    // when location changes, check that res footmarks are still in allowed range for given berth and move res to start of berth if not
    s_js_1.default.on(draft.Location, function () {
        var _a;
        var b = (_a = draft.Location()) === null || _a === void 0 ? void 0 : _a.Berth(), res = berthReservation();
        if (!b || !res)
            return;
        res.Model.Footmark.Num(Math.ceil(b.StartMark.Num()));
    }, null, true);
    return {
        Model: draft,
        BerthReservation: berthReservation,
        BerthTypeahead: berthTypeahead,
        Validation: Validation
    };
}
function PortCallViewModel(portcall, ajax, agentModel) {
    var client = ajax.Url(function () { return portcall.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(portcall, client, ['NextPortOfCall', 'LastPortOfCall']);
    return {
        Model: draft,
        Agent: s_js_1.default(function () { return portcall.Agent() && agentModel(portcall.Agent()); }),
        Unlisted: s_js_1.default(function () { return portcall.Unlisted(); })
    };
}
function VesselViewModel(vessel, ajax, pierSettings, bowThrusterModel) {
    var client = ajax.Url(function () { return vessel.Url() || ''; }, { useCache: true }), 
    // TH 02/05/2017 -- TODO: For incorporating BowThruster into Lloyd's --
    // That'll mean users no longer edit vessel.BowThruster directly but
    // instead make they're edits to the OverrideServiceVessel.
    // So we need to rewire our AutoSavingDraftObjects.
    draft = autoSave_1.AutoSavingDraftObject(vessel, client, [
        'BowThruster.Present',
        'BowThruster.Size.Num',
        'BowThruster.Size.UOM'
    ]), pilotShiphandlingNotes = vessel.PilotShiphandlingNotes
        // Reverse chronological
        .orderBy(function (n) { return n.Event() ? -n.Event().Date() : 0; }), shiphandlingNotesClient = ajax.Url(function () { return vessel.PilotShiphandlingNotesUrl() || ''; }, {
        useCache: true
    }), draftNote = s_js_1.default.data(new PilotShiphandlingNote_1.PilotShiphandlingNote()), bowThruster = bowThrusterModel(draft.BowThruster), addingNote = s_js_1.default.data(false);
    return {
        Model: draft,
        // Length and Beam in feet and inches or in tenths of a meter.
        Beam: lengthText(draft.Beam, pierSettings.DefaultLengthUOM),
        PilotShiphandlingNotes: pilotShiphandlingNotes,
        DraftNote: draftNote,
        AddShiphandlingNote: AddShiphandlingNote,
        BowThruster: bowThruster,
    };
    function AddShiphandlingNote() {
        // Prevent accidental empty notes.
        if (!draftNote().Message() || !draftNote().Message().trim() || addingNote())
            return;
        addingNote(true);
        shiphandlingNotesClient.Post(draftNote())
            .then(function () { return draftNote(new PilotShiphandlingNote_1.PilotShiphandlingNote()); })
            .finally(function () { return addingNote(false); });
    }
}
function BowThrusterViewModel(bowThruster, model) {
    var sizeConvertible = new ConvertibleMeasurement_1.NullableConvertibleMeasurement(bowThruster.Size), sizeInHorsepower = new ConvertedMeasurement_1.ConvertedMeasurement(sizeConvertible, UOM_1.default.Horsepower, 0), sizeInKilowatts = new ConvertedMeasurement_1.ConvertedMeasurement(sizeConvertible, UOM_1.default.Kilowatt, 0);
    // TH 02/05/2017 -- Coerce BowThruster UOM to Horsepower or Kilowatt.
    // This triggers an auto-save request, hence why we need to check permissions.
    //
    // Before typescript conversion, we used to do this via a KO options binding in which
    // the only available options were Horsepower and Kilowatt.
    // But KO and React have different behaviors around <select> elements when the current value
    // is not in the list of available <option>'s --
    // KO would set the current value to the first available <option>, if any.
    // Whereas React silently leaves the current value as is, even though the UI looks as if
    // the first available option is selected.
    // Personally, this feels like a bug on React's part, since React is normally quite
    // strict about avoiding cases where visible view state and js model state differ.
    s_js_1.default(function () {
        return bowThruster.Present() &&
            bowThruster.Size.UOM() !== UOM_1.default.Horsepower &&
            bowThruster.Size.UOM() !== UOM_1.default.Kilowatt &&
            model.CanEditVessel() &&
            bowThruster.Size.UOM(UOM_1.default.Horsepower);
    });
    return {
        Raw: bowThruster,
        SizeInHorsepower: sizeInHorsepower,
        SizeInKilowatts: sizeInKilowatts,
        OnSizeBlur: function () { return sizeConvertible.LastWriter(null); }
    };
}
function AgentViewModel(user) {
    var mobileNumbers = user.PhoneNumbers.filter(function (pn) { return pn.Kind() === PhoneNumberKind_1.PhoneNumberKind.Mobile; }), 
    // Logic for "main" phone number taken from personprofilepopup
    mainNumber = s_js_1.default(function () {
        return mobileNumbers().length > 0 ? mobileNumbers()[0] : user.PhoneNumbers().length > 0 ? user.PhoneNumbers()[0] : null;
    });
    return {
        Model: user,
        MainNumber: mainNumber
    };
}
function ReservationViewModel(berthReservation, canEdit, footmarkAssignmentsModel) {
    var 
    // Distinguish different "tiers" of draft objects...
    // ...starting with Length.Num in a tier all by itself, b/c it doesn't need to get
    // saved (the server applies its own logic for computing it), but we still wanna
    // distinguish the draft value from the persisted value...
    draftForLength = draftSignals_1.DraftObject(berthReservation, [
        'Length.Num'
    ]), 
    // ...and then those properties that we'll auto-save with our ItineraryPoint.
    draft = draftSignals_1.DraftObject(draftForLength.object, [
        'Footmark.Num',
        'Footmark.UOM',
        'SideTo'
    ]);
    // Keep reservation length up-to-date when changing side to. This is purely for client-side
    // purposes (fast feedback when making changes) -- the server applies its own version of
    // the same logic.
    s_js_1.default(function (isInitialRun) {
        var _a, _b, _c, _d, _e;
        var portcall = (_a = berthReservation.Itinerary()) === null || _a === void 0 ? void 0 : _a.PortCall();
        // Propagate portcall changes to non-cancelled reservations only, but update for SideTo
        // changes whether or not the reservation is cancelled.
        if (portcall && (berthReservation.CancelledDate() === null || draft.object.SideTo() !== berthReservation.SideTo())) {
            var newLength = BerthReservation_1.BerthReservation.calculateLength((_c = (_b = portcall.Vessel()) === null || _b === void 0 ? void 0 : _b.Length) !== null && _c !== void 0 ? _c : null, (_e = (_d = portcall.Vessel()) === null || _d === void 0 ? void 0 : _d.Beam) !== null && _e !== void 0 ? _e : null, portcall.LengthOnlyLength, draft.object.SideTo(), berthReservation.Length.UOM());
            // Apply new length so long as we computed a usable value, but only if this is a
            // follow up run of this computation (due to data changing). Otherwise, leave
            // existing length as is whether it agrees w/ our computed length or not.
            if ((newLength === null || newLength === void 0 ? void 0 : newLength.Num()) && !isInitialRun)
                draft.object.Length.set(newLength);
        }
        return false;
    }, true);
    // Revert draft Length.Num changes when we've persisted all pending changes to this
    // reservation, as at that point the server should have calculated the new length itself
    // and we should have applied that value to our data cache.
    s_js_1.default(function () {
        if (draftForLength.methods.isCaching() && !draft.methods.isCaching()) {
            draftForLength.methods.checkpoint().revert();
        }
    });
    return {
        Model: draft.object,
        DraftMethods: draft.methods,
        FootmarkAssignments: footmarkAssignmentsModel({
            Reservation: draft.object,
            CanEdit: canEdit,
            // B/c we auto-save footmarks edits, don't write them to our draft Reservation until the user blurs
            // either the startmark or endmark input.
            FootmarksUpdateTrigger: model_3.FootmarksUpdateTrigger.OnBlur
        })
    };
}
function BerthReservationDetailsSection(jobOrder) {
    var userSelectedItineraryPoint = s_js_1.default.data(null);
    return {
        SelectedItineraryPoint: (function (pt) {
            var _a, _b;
            if (pt === undefined) {
                var fromRes = (_a = jobOrder.FromPoint()) === null || _a === void 0 ? void 0 : _a.BerthReservation(), toRes = (_b = jobOrder.ToPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation(), userSelection = userSelectedItineraryPoint();
                return fromRes && toRes && userSelection ? userSelection
                    : fromRes ? jobOrder.FromPoint()
                        : toRes ? jobOrder.ToPoint()
                            : null;
            }
            return userSelectedItineraryPoint(pt);
        })
    };
}
function CancellationRemarksPrompt(doCancel, onDismiss) {
    var Remarks = s_js_1.default.value(null);
    return {
        Remarks: Remarks,
        CancelPJO: CancelPJO,
        QuitChanges: onDismiss
    };
    function CancelPJO() {
        onDismiss();
        doCancel(Remarks());
    }
}
function AbortRemarksPrompt(doAbort, undoActual, onDismiss) {
    var Remarks = s_js_1.default.value(null);
    return {
        Remarks: Remarks,
        AbortPJO: AbortPJO,
        QuitChanges: onDismiss
    };
    function AbortPJO() {
        undoActual();
        // DC 02/08/2022 -- Required timeout to allow undoing the actual to propogate thru and save via DB and/or cache
        // Will consider revisiting for a more elegant S solution in the future
        setTimeout(function () {
            onDismiss();
            doAbort(Remarks());
        }, 500);
    }
}
function CancelWholePortCallPrompt(_a) {
    var pjo = _a.pjo, remarks = _a.remarks, ajax = _a.ajax, entrypoints = _a.entrypoints, hidePrompt = _a.hidePrompt;
    var url = function () { return entrypoints.CancelPortCall({ Id: pjo.PortCallId() }); }, client = ajax.Url(url, { useCache: true }), status = s_js_1.default.value(0 /* Prompting */), exception = s_js_1.default.value(null);
    return {
        Status: status,
        ExceptionDetails: s_js_1.default(function () {
            var ex = exception();
            if (ex) {
                var stringified = ex.toString();
                if (stringified === "[object Object]") {
                    try {
                        return JSON.stringify(ex, undefined, 2);
                    }
                    catch (ex2) {
                        return null;
                    }
                }
                else {
                    return stringified;
                }
            }
            else {
                return null;
            }
        }),
        CancelWholePortCall: CancelWholePortCall,
        HidePrompt: hidePrompt,
        PortCallProfileHref: function () { return "#!portcallprofile?id=" + pjo.PortCallId(); }
    };
    function CancelWholePortCall() {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (status() !== 0 /* Prompting */)
                            return [2 /*return*/];
                        status(1 /* Cancelling */);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.Post({ Remarks: remarks || null })];
                    case 2:
                        _a.sent();
                        status(2 /* CancellationSucceeded */);
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _a.sent();
                        status(3 /* CancellationFailed */);
                        exception(ex_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
function lengthText(length, uom) {
    var effectiveUom = function () { return uom() || UOM_1.default.Foot; };
    return function () { return effectiveUom() === UOM_1.default.Foot ?
        new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(length, 0).toString() :
        new ConvertedMeasurement_1.ConvertedMeasurement(length, effectiveUom(), 1).toString(); };
}


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginalPilotOrder = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var nonuniqueIndex_1 = __webpack_require__(117);
var BerthReservation_1 = __webpack_require__(38);
var ItineraryPoint_1 = __webpack_require__(69);
function OriginalPilotOrder(ajax, entrypoints, cache, _a) {
    var _this = this;
    var pjo = _a.pjo, hideActionsMenu = _a.hideActionsMenu;
    var url = function () { return entrypoints.ViewOriginalPilotOrder({ PortCallId: pjo.PortCallId() }); }, client = ajax.Url(url), displayedOrder = s_js_1.default.value(null), showOrderUnavailableMsg = s_js_1.default.value(false), loading = s_js_1.default.value(false);
    // For doing dev on UI/styling. I found this useful since otherwise this component's UI is
    // only rendered while the print dialog is open. To use:
    //
    // 1) Set a breakpoint on the statement after this one.
    // 2) Open the PJO details popup for a PJO.
    // 3) Your breakpoint will be hit. When that happens, run the following in your browser's dev
    //    console:
    //
    //    attachDevTools()
    //
    // 4) Continue from your breakpoint. Now, as long as that PJO is still open, you can run the
    //    following commands in your browser's dev console:
    //
    //    OriginalPilotOrderDevTools.ShowPrintView()
    //    OriginalPilotOrderDevTools.HidePrintView()
    //
    // 5) You may also find it helpful to emulate @media print. Instructions for how to do this
    //    in Chrome at https://stackoverflow.com/a/29962072. Summary:
    //       - Open dev tools
    //       - Open hamburger menu in top right corner (tooltip reads "Customize and control DevTools")
    //       - Go to More tools > Rendering
    //       - Find "Emulate CSS media" option (near bottom) and select "print"
    var attachDevTools = function () {
        window.OriginalPilotOrderDevTools = {
            ShowPrintView: function () { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = displayedOrder;
                        return [4 /*yield*/, LoadOriginalOrder()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            }); }); },
            HidePrintView: function () { return displayedOrder(null); }
        };
    };
    return {
        PilotAgency: function () { return pjo.PilotAgency(); },
        DisplayedOrder: s_js_1.default(function () {
            return displayedOrder() &&
                displayedOrder().OriginalOrder() &&
                OriginalPortCallViewModel(displayedOrder().OriginalOrder());
        }),
        ShowOrderUnavailableMsg: showOrderUnavailableMsg,
        Loading: loading,
        LinkAvailable: LinkAvailable,
        PrintOrder: PrintOrder
    };
    function LinkAvailable() {
        // No sense offering a print pilot order link unless/until we have a valid PortCallId.
        return pjo.PortCallId() > 0;
    }
    function PrintOrder() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (loading())
                            return [2 /*return*/];
                        loading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = displayedOrder;
                        return [4 /*yield*/, LoadOriginalOrder()];
                    case 2:
                        _a.apply(void 0, [_b.sent()]);
                        try {
                            window.print();
                        }
                        finally {
                            displayedOrder(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        s_js_1.default.freeze(function () {
                            loading(false);
                            hideActionsMenu();
                        });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    // NOTE: I originally tried using a CachedModelLoader here instead of this function.
    // Using this function instead so we can implement custom error handling logic based on
    // the response status. CachedModelLoader doesn't currently expose the error response
    // (well, unless you check ajax.LastResponse, but that makes it hard to know you've got the
    // right response).
    function LoadOriginalOrder() {
        return __awaiter(this, void 0, void 0, function () {
            var req, orderData, ex_1, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = client.Get();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        orderData = _a.sent();
                        return [2 /*return*/, cache.OriginalPilotOrders.update1(req.Date, orderData)];
                    case 3:
                        ex_1 = _a.sent();
                        resp = req.Response();
                        // 404 signals that we couldn't find the original order data for this PortCall.
                        // That most likely means the PortCall predates our version tables. Show an
                        // appropriate error message.
                        if (resp && resp.Status === 404) {
                            showOrderUnavailableMsg(true);
                        }
                        throw ex_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
exports.OriginalPilotOrder = OriginalPilotOrder;
function OriginalPortCallViewModel(pc) {
    var lengthUOM = function () { return pc.Port() && pc.Port().PierLengthUOM() || UOM_1.default.Foot; }, depthUOM = function () { return pc.Port() && pc.Port().PierDepthUOM() || UOM_1.default.Foot; }, pjos = pc.JobOrders
        .map(function (jo) { return jo.PilotJobOrder(); })
        .filter(function (pjo) { return pjo !== null; }), pjosByMovement = nonuniqueIndex_1.default(pjos, function (pjo) { return movementKey(pjo.FromPointId(), pjo.ToPointId()); }), itinerary = pc.Itinerary.sort(ItineraryPoint_1.ItineraryPoint.EffectiveOrder), movements = s_js_1.default(function () {
        var _itinerary = itinerary();
        return _itinerary.slice(0, -1).map(function (fromPt, idx) {
            var toPt = _itinerary[idx + 1];
            return MovementViewModel(fromPt, toPt, pjosByMovement, depthUOM);
        });
    }), 
    // For certain PJO fields (e.g. Bill To, Tugs, Remarks, others), the AddPortCall form
    // uses a single input field to set the initial value for multiple PJOs at once. For
    // most such fields, all PJOs for that PortCall get matching initial values. The one
    // exception is labor start time: That one's presented as a single input field like the
    // others, but our business rules say to apply the supplied value to the IN PJO only. So,
    // since we're trying to recreate the AddPortCall form as the user originally entered it,
    // we'll take the 1st PJO in movement order as definitive for all of these fields.
    typicalPJO = s_js_1.default(function () {
        var pjos = movements().map(function (mvmt) { return mvmt.PilotJobOrder(); }).filter(function (pjo) { return pjo !== null; });
        return pjos.length ? pjos[0] : null;
    });
    return {
        Model: pc,
        LengthDisplay: lengthDisplay(pc.VesselLength, lengthUOM),
        Vessel: s_js_1.default(function () { return pc.Vessel() && OriginalVesselViewModel(pc.Vessel(), lengthUOM); }),
        Movements: movements,
        TypicalPilotJobOrder: typicalPJO
    };
}
function OriginalVesselViewModel(vessel, lengthUOM) {
    return {
        Model: vessel,
        BeamDisplay: lengthDisplay(vessel.Beam, lengthUOM),
        GrossTonnageDisplay: function () { return vessel.GrossTonnage.toString({ units: false }); }
    };
}
function MovementViewModel(fromPt, toPt, pjosByMovement, depthUOM) {
    var key = function () { return movementKey(fromPt.Id(), toPt.Id()); }, 
    // To reservation on INs and SHIFTs, from reservation on OUTs
    referenceReservation = function () { return toPt.BerthReservation() || fromPt.BerthReservation(); }, pjo = s_js_1.default(function () {
        var all = pjosByMovement(key())();
        return all.length ? all[0] : null;
    });
    return {
        Key: key,
        FromPoint: fromPt,
        ToPoint: toPt,
        // Ditto DispatchDashboard on how this determination of movement type won't hold up
        // if we start modeling things like taking multiple stops from SEA to the reserved berth.
        Type: function () { return fromPt.BerthReservation() ?
            toPt.BerthReservation() ?
                'shift' :
                'out' :
            'in'; },
        MovementTime: fromPt.Departure.Effective,
        Reservation: s_js_1.default(function () { return referenceReservation() && ReservationViewModel(referenceReservation()); }),
        PilotJobOrder: s_js_1.default(function () { return pjo() && OriginalPilotJobOrderViewModel(pjo(), depthUOM); })
    };
}
function ReservationViewModel(reservation) {
    return {
        // Rounding behavior intended to match the FootmarkAssignments widget
        FootmarkNum: function () { return Math.round(reservation.Footmark.Num()); },
        EndmarkNum: function () { return Math.round(reservation.EndMark.Num()); },
        SideToText: function () {
            return reservation.SideTo() === BerthReservation_1.VesselSide.Starboard ? 'Starboard' :
                reservation.SideTo() === BerthReservation_1.VesselSide.Port ? 'Port' :
                    BerthReservation_1.VesselSideDisplayName[reservation.SideTo()];
        }
    };
}
function OriginalPilotJobOrderViewModel(pjo, depthUOM) {
    return {
        Model: pjo,
        AirDraftDisplay: draftDisplay(pjo.AirDraft, depthUOM),
        DeepDraftDisplay: draftDisplay(pjo.DeepDraft, depthUOM)
    };
}
function lengthDisplay(m, uom) {
    return function () { return uom() === UOM_1.default.Foot ?
        new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(m, 0)
            .toString({ unitsStyle: 'abbrev', padInchesLeft: false }) :
        m.convert(UOM_1.default.Meter).roundToNPlaces(0).toString(); };
}
function draftDisplay(m, uom) {
    return function () { return uom() === UOM_1.default.Foot ?
        new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(m, 0)
            .toString({ unitsStyle: 'pretty-ticks', padInchesLeft: false }) :
        m.convert(UOM_1.default.Meter).roundToNPlaces(2).toString(); };
}
function movementKey(fromPointId, toPointId) {
    return fromPointId + ":" + toPointId;
}


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginalPilotOrderView = exports.PrintOriginalOrderLink = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
exports.PrintOriginalOrderLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.LinkAvailable() ?
        React.createElement("div", { className: "pjo-actions-menu-item" }, m.Loading() ?
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { }) }, "Printing...") :
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.PrintOrder) }, "Print Original Order")) :
        null;
});
exports.OriginalPilotOrderView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(OrderUnavailablePopup, { model: m }),
        React.createElement(OriginalPilotOrderPrintView, { model: m }));
});
var OrderUnavailablePopup = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.PCModal, { shown: m.ShowOrderUnavailableMsg, className: "original-pilot-order-unavailable", onBackDropClick: function () { return m === null || m === void 0 ? void 0 : m.ShowOrderUnavailableMsg(false); } },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", null, "Sorry, the receipt you requested is not available for this pilot order."),
            React.createElement("div", { className: "controls" },
                React.createElement("button", { className: "pc-button", onClick: function () { return m.ShowOrderUnavailableMsg(false); } }, "OK"))));
});
var OriginalPilotOrderPrintView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var originalOrder = m.DisplayedOrder();
    if (!originalOrder)
        return null;
    return (React.createElement("div", { className: "original-pilot-order" },
        React.createElement(PrintViewTitle, { model: m }),
        React.createElement(OriginalOrderSubmission, { order: originalOrder }),
        React.createElement(OriginalOrderVessel, { order: originalOrder }),
        React.createElement(OriginalOrderMovements, { order: originalOrder }),
        React.createElement(OriginalOrderAgentAndBilling, { order: originalOrder })));
});
var PrintViewTitle = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("h1", { className: "original-order-title" },
        "Original Pilot Orders \u2014",
        ' ',
        m.PilotAgency() &&
            m.PilotAgency().Organization() &&
            m.PilotAgency().Organization().Name());
});
var OriginalOrderSubmission = supercritical_1.default(function (_a) {
    var o = _a.order;
    var requestor = o.Model.Requestor(), requestingOrg = requestor && requestor.Organization(), reservations = o.Model.Reservations(), requestDate = reservations.length ? reservations[0].RequestDate() : null;
    return (React.createElement("div", { className: "original-order-submission" },
        React.createElement("div", null,
            "Submitted by:",
            ' ',
            requestor && requestor.FullName(),
            ', ',
            requestingOrg && requestingOrg.Name()),
        React.createElement("div", null,
            "Date submitted:",
            ' ',
            React.createElement("span", { className: "submitted-date" }, requestDate && tzmoment_1.tzmoment(requestDate).format('DD MMM YYYY')))));
});
var OriginalOrderVessel = supercritical_1.default(function (_a) {
    var o = _a.order;
    var v = o.Vessel();
    return (React.createElement("div", { className: "original-order-section original-order-vessel" },
        React.createElement("h2", { className: "original-order-section-header" }, o.Model.DisplayVesselIdentifier()),
        React.createElement("div", { className: "original-order-section-body" },
            React.createElement("div", { className: "vessel-details" },
                React.createElement(LengthOverall, { order: o }),
                React.createElement(Flag, { vessel: v }),
                React.createElement(GrossTonnage, { vessel: v }),
                React.createElement(IMO, { vessel: v }),
                React.createElement(VesselType, { vessel: v }),
                React.createElement(CallSign, { vessel: v }),
                React.createElement(Beam, { vessel: v })),
            React.createElement(PortsOfCall, { order: o }))));
});
var LengthOverall = supercritical_1.default(function (_a) {
    var o = _a.order;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Length Overall:"),
        React.createElement("span", { className: "vessel-section-item-value" }, o.LengthDisplay()));
});
var Flag = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Flag:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.Flag() && v.Model.Flag().Name()));
});
var GrossTonnage = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Gross Tonnage:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.GrossTonnageDisplay()));
});
var IMO = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "IMO:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.IMO()));
});
var VesselType = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Vessel Type:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.VesselType()));
});
var CallSign = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Call Sign:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.CallSign()));
});
var Beam = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Beam:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.BeamDisplay()));
});
var PortsOfCall = supercritical_1.default(function (_a) {
    var o = _a.order;
    return React.createElement("div", { className: "ports-of-call" },
        React.createElement("div", { className: "vessel-section-item" },
            React.createElement("span", { className: "vessel-section-item-label" }, "Last Port:"),
            React.createElement("span", { className: "vessel-section-item-value" }, o.Model.LastPortOfCall())),
        React.createElement("div", { className: "vessel-section-item" },
            React.createElement("span", { className: "vessel-section-item-label" }, "Next Port:"),
            React.createElement("span", { className: "vessel-section-item-value" }, o.Model.NextPortOfCall())));
});
var OriginalOrderMovements = supercritical_1.default(function (_a) {
    var o = _a.order;
    return React.createElement("div", { className: "original-order-section original-order-movements" },
        React.createElement("h2", { className: "original-order-section-header" }, "Movements"),
        React.createElement("div", { className: "original-order-section-body" }, o.Movements().map(function (mvmt) {
            return React.createElement(MovementView, { movement: mvmt, key: mvmt.Key() });
        })));
});
var MovementView = supercritical_1.default(function (_a) {
    var mvmt = _a.movement;
    return React.createElement("div", { className: "original-order-mvmt" },
        React.createElement(MovementTimeAndStatus, { movement: mvmt }),
        React.createElement(MovementDetails, { movement: mvmt }));
});
var MovementTimeAndStatus = supercritical_1.default(function (_a) {
    var mvmt = _a.movement;
    return React.createElement("div", { className: "mvmt-time-status" },
        React.createElement("div", { className: "mvmt-date" }, tzmoment_1.tzmoment(mvmt.MovementTime()).format('MMM D, YYYY')),
        React.createElement("div", { className: "mvmt-type-time" },
            mvmt.Type() === 'in' ? 'Inbound:' : mvmt.Type() === 'out' ? 'Outbound:' : 'Shifting:',
            ' ',
            tzmoment_1.tzmoment(mvmt.MovementTime()).format('HH:mm')),
        React.createElement("div", { className: "mvmt-unordered-indicator" }, !mvmt.PilotJobOrder() && '(unordered)'));
});
var MovementDetails = supercritical_1.default(function (_a) {
    var mvmt = _a.movement;
    return React.createElement("div", { className: "mvmt-details" },
        React.createElement(MovementLocation, { movement: mvmt }),
        React.createElement(MovementDrillDown, { movement: mvmt }));
});
var MovementLocation = supercritical_1.default(function (_a) {
    var mvmt = _a.movement;
    return React.createElement("div", { className: "mvmt-location" },
        React.createElement("div", { className: "mvmt-location-item" },
            React.createElement("span", { className: "mvmt-location-item-label" }, "From"),
            React.createElement("span", { className: "mvmt-location-item-value" }, mvmt.FromPoint.Location() && mvmt.FromPoint.Location().Name())),
        React.createElement("div", { className: "mvmt-location-item" },
            React.createElement("span", { className: "mvmt-location-item-label" }, "To"),
            React.createElement("span", { className: "mvmt-location-item-value" }, mvmt.ToPoint.Location() && mvmt.ToPoint.Location().Name())));
});
var MovementDrillDown = supercritical_1.default(function (_a) {
    var mvmt = _a.movement;
    var pjo = mvmt.PilotJobOrder(), res = mvmt.Reservation();
    return (React.createElement("div", { className: "mvmt-drill-down" },
        React.createElement("div", { className: "mvmt-drill-down-item" },
            React.createElement("span", { className: "mvmt-drill-down-item-label" }, "Deep Draft:"),
            React.createElement("span", { className: "mvmt-drill-down-item-value" }, pjo && pjo.DeepDraftDisplay())),
        React.createElement("div", { className: "mvmt-drill-down-item" },
            React.createElement("span", { className: "mvmt-drill-down-item-label" }, "Air Draft:"),
            React.createElement("span", { className: "mvmt-drill-down-item-value" }, pjo && pjo.AirDraftDisplay())),
        React.createElement("div", { className: "mvmt-drill-down-item" },
            React.createElement("span", { className: "mvmt-drill-down-item-label" }, "Side to:"),
            React.createElement("span", { className: "mvmt-drill-down-item-value" }, res && res.SideToText())),
        React.createElement("div", { className: "mvmt-drill-down-item" },
            React.createElement("span", { className: "mvmt-drill-down-item-label" }, "Footmarks:"),
            React.createElement("span", { className: "mvmt-drill-down-item-value" }, res && res.FootmarkNum() + "-" + res.EndmarkNum()))));
});
var OriginalOrderAgentAndBilling = supercritical_1.default(function (_a) {
    var o = _a.order;
    return React.createElement("div", { className: "original-order-section original-order-agent-billing" },
        React.createElement("h2", { className: "original-order-section-header" },
            React.createElement("span", { className: "agent-header" }, "Agent"),
            React.createElement("span", { className: "billing-header" }, "Billing Party/Address")),
        React.createElement("div", { className: "original-order-section-body" },
            React.createElement(AgentView, { order: o }),
            React.createElement(BillingEtcView, { order: o }),
            React.createElement(RemarksView, { order: o })));
});
var AgentView = supercritical_1.default(function (_a) {
    var o = _a.order;
    var agent = o.Model.Agent();
    return (React.createElement("div", { className: "agent" }, agent &&
        React.createElement("div", null,
            React.createElement("div", { className: "agent-name" }, agent.FullName()),
            React.createElement("div", { className: "agent-contact-info" },
                React.createElement("div", null, agent.Organization() && agent.Organization().Name()),
                React.createElement("div", { className: "agent-email" }, agent.User() && agent.User().Email()),
                React.createElement("div", null, agent.MainPhoneNumber() && agent.MainPhoneNumber().Number())))));
});
var BillingEtcView = supercritical_1.default(function (_a) {
    var o = _a.order;
    var pjo = o.TypicalPilotJobOrder();
    return (React.createElement("div", { className: "billing-etc" }, pjo &&
        React.createElement("div", null,
            React.createElement(BillToAddress, { pjo: pjo }),
            React.createElement(ServicesView, { pjo: pjo }))));
});
var BillToAddress = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    var billToAddr = pjo.Model.BillToAddress();
    return billToAddr ?
        React.createElement("div", { className: "bill-to-address" }, pjo.Model.BillToAddress() || '') :
        null;
});
var ServicesView = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    return React.createElement("div", { className: "services" },
        React.createElement("div", { className: "services-item" },
            React.createElement("span", { className: "services-item-label" }, "Tug:"),
            React.createElement("span", { className: "services-item-value" }, pjo.Model.TugCompany() && pjo.Model.TugCompany().Name())),
        React.createElement("div", { className: "services-item" },
            React.createElement("span", { className: "services-item-label" }, "Tug #:"),
            React.createElement("span", { className: "services-item-value" }, pjo.Model.NumberOfTugs())),
        React.createElement("div", { className: "services-item" },
            React.createElement("span", { className: "services-item-label" }, "Lines:"),
            React.createElement("span", { className: "services-item-value" }, pjo.Model.LineHandlingCompany() && pjo.Model.LineHandlingCompany().Name())),
        React.createElement("div", { className: "services-item" },
            React.createElement("span", { className: "services-item-label" }, "Labor:"),
            React.createElement("span", { className: "services-item-value" }, pjo.Model.LaborStartTime() && tzmoment_1.tzmoment(pjo.Model.LaborStartTime()).format("MMM D, YYYY [at] HH:mm"))));
});
var RemarksView = supercritical_1.default(function (_a) {
    var o = _a.order;
    return React.createElement("div", { className: "remarks" },
        React.createElement("span", { className: "remarks-label" }, "Remarks:"),
        React.createElement("span", { className: "remarks-value" }, o.TypicalPilotJobOrder() && o.TypicalPilotJobOrder().Model.Remarks()));
});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotageChargesView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var pilotagecharges_1 = __webpack_require__(499);
var view_1 = __webpack_require__(266);
var view_2 = __webpack_require__(40);
exports.PilotageChargesView = supercritical_1.default(function (_a) {
    var m = _a.model, backPage = _a.backPage, flipToFront = _a.flipToFront;
    return backPage() === 3 /* PilotageCharges */ ?
        React.createElement("div", { className: "pilotage-charges-full" },
            React.createElement("div", { className: "details-section-header" },
                React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-main", onClick: eventWrappers_1.noDefault(flipToFront) }),
                React.createElement("span", { className: "details-section-title" }, "Pilotage Charges")),
            React.createElement(view_2.PageLoadingIndicator, { loading: function () { return m.Loading() || m.BillExportSettings.SendingRequest(); } }),
            React.createElement(PilotageChargesBody, { model: m })) : null;
});
var PilotageChargesBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pilotage-charges-body" },
        React.createElement(BillToView, { model: m }),
        React.createElement(BillAttributesView, { model: m }),
        React.createElement(view_1.BillExportSettingsView, { model: m.BillExportSettings }),
        React.createElement(PilotageChargesWatermark, { model: m }),
        React.createElement(ChargesListView, { model: m }));
});
var BillToView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pilotage-charges-bill-to" },
        React.createElement("span", { className: "pc-text-billing-label bill-to-label" }, "Bill To:"),
        React.createElement("textarea", { className: "bill-to-value", value: m.JobOrder.BillToAddress() || '', onChange: function (e) { return m.JobOrder.BillToAddress(e.currentTarget.value); }, 
            // TH 05/04/2017 -- I figure 5 rows can comfortably fit most addresses.
            // If the address has more lines, it'll just scroll.
            rows: 5, disabled: 
            // Matching BillExportSettings' behavior for the QB Customer ID for a
            // consistent UI feel.
            m.BillingStatus() === 2 /* NonBillable */ ||
                m.BillingStatus() === 1 /* Approved */ ||
                m.BillingStatus() === 0 /* Exported */ }));
});
var BillAttributesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Bill() ?
        React.createElement("div", { className: "pilotage-charges-bill-attributes" },
            React.createElement("div", { className: "attribute-line" },
                React.createElement("span", { className: "attribute-label pc-text-billing-label" }, "Invoice Date:"),
                React.createElement("span", { className: "attribute-value" }, tzmoment_1.tzmoment(m.Bill().InvoiceDate()).format('M/D/YY'))),
            React.createElement("div", { className: "attribute-line" },
                React.createElement("span", { className: "attribute-label pc-text-billing-label" }, "Invoice Number:"),
                React.createElement("span", { className: "attribute-value" }, m.Bill().InvoiceNumber()))) : null;
});
var PilotageChargesWatermark = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pilotage-charges-watermark" }, m.BillingStatus() === 0 /* Exported */ ? 'Exported' :
        m.BillingStatus() === 1 /* Approved */ ? 'Approved' :
            'Draft Charges');
});
var ChargesListView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "charges-list-shell" },
        React.createElement(ChargesListTable, { model: m }),
        React.createElement(InvoiceTotalView, { model: m }));
});
var ChargesListTable = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("table", { className: "charges-list" },
        React.createElement("thead", { className: "pc-text-billing-label" },
            React.createElement("tr", null,
                React.createElement("th", { className: "item-code" }, "Item Code"),
                React.createElement("th", { className: "description" }, "Description"),
                React.createElement("th", { className: "quantity" }, "Qty."),
                React.createElement("th", { className: "rate" }, "Rate"),
                React.createElement("th", { className: "total" }, "Total"))),
        React.createElement("tbody", null, m.ChargesList().map(function (c) {
            return React.createElement(ChargeListItemView, { charge: c, key: c.Id() });
        })));
});
var ChargeListItemView = supercritical_1.default(function (_a) {
    var c = _a.charge;
    return React.createElement("tr", null,
        React.createElement("td", { className: "item-code" }, c.StandardItem() && c.StandardItem().Name()),
        React.createElement("td", { className: "description" }, c.Description()),
        React.createElement("td", { className: "quantity" }, c.NumberOfUnits()),
        React.createElement("td", { className: "rate" }, c.UnitPrice.toString({ places: pilotagecharges_1.PRICE_PRECISION })),
        React.createElement("td", { className: "total" }, c.Total.toString({ places: pilotagecharges_1.PRICE_PRECISION })));
});
var InvoiceTotalView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "invoice-total" },
        React.createElement("span", { className: "pc-text-billing-label invoice-total-label" }, "Invoice Total"),
        React.createElement("span", null, m.InvoiceTotal.toString({ places: pilotagecharges_1.PRICE_PRECISION })));
});


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotAssignments = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var uniqueIndex_1 = __webpack_require__(70);
var nonuniqueIndex_1 = __webpack_require__(117);
var PilotAssignment_1 = __webpack_require__(582);
function PilotAssignments(ajax, data, _a) {
    var model = _a.model;
    var pilotAgency = function () { return model.PilotJobOrder() && model.PilotJobOrder().PilotAgency(); }, persistedAssignments = s_array_1.lift(function () { return model.PilotJobOrder() && model.PilotJobOrder().Pilots() || []; }), 
    // TH 02/09/2017 -- We have a Db unique index on the combo of PilotAssignment.PilotJobOrderId and PilotAssignment.AssignmentOrder.
    // Hence why it's safe to assume AssignmentOrder is unique here.
    persistedAssignmentByAssignmentOrder = uniqueIndex_1.default(persistedAssignments, function (pa) { return pa.AssignmentOrder(); }), pilots = s_array_1.lift(function () { return Array.from(data.Pilots.items()); })
        .filter(function (p) {
        return !!p.User() &&
            !!pilotAgency() &&
            p.User().Organization() === pilotAgency().Organization();
    })
        .map(function (p) { return PilotViewModel(p); }), pilotsIdx = uniqueIndex_1.default(pilots, function (p) { return p.Model.Id(); }), pilotsBySection = nonuniqueIndex_1.default(pilots, function (p) { return SectionIndexKey(p.Model.SectionId()); }), pilotGroupingModel = function (sectionId) { return PilotGroupingViewModel(sectionId, pilotsBySection); }, pilotSections = s_array_1.lift(function () { return pilotAgency() && pilotAgency().Sections() || []; })
        .orderBy(function (s) { return s.Order(); })
        .map(function (s) { return PilotSectionViewModel(s, pilotGroupingModel); }), unassignedPilotSection = pilotGroupingModel(function () { return null; }), slotParams = s_array_1.default([]), 
    // TH 02/08/2017 -- tempCollectionsDiry: Inspired by the tempcache trick from lib/DataCache.ts, but we need two extra ticks
    // to get the timing btwn the AssignmentSlotViewModel AutoSaver and the persistedAssignments.forEach call right.
    tempCollectionsDirtyTick1 = s_js_1.default.data(true), tempCollectionsDirtyTick2 = s_js_1.default.data(true), tempAddedPilotAssignments = s_js_1.default.on(tempCollectionsDirtyTick2, function () { return new Set(); }), tempDeletedPilotIds = s_js_1.default.on(tempCollectionsDirtyTick2, function () { return new Set(); }), savingChanges = s_js_1.default.data(false), assignmentSlots = slotParams.map(function (params) { return AssignmentSlotViewModel(params, ajax, model, pilotsIdx, nextAvailableOrder, savingChanges, markAsAdded, markAsDeleted, removeSlot); })
        .orderBy(function (slot) { return slot.Order(); }), assignedPilotsArray = assignmentSlots.filter(function (s) { return !!s.Pilot(); }).map(function (s) { return s.Pilot(); }), assignedPilots = s_js_1.default(function () { return new Set(assignedPilotsArray()); }), assignablePilotIds = s_js_1.default(function () { return new Set(model.AssignablePilotIds()); });
    // TH 02/08/2017 -- Sequence our ticks.
    // The goal is to get the new temp collections to get constructed AFTER we've checked
    // the old collections for added/deleted assignments.
    s_js_1.default(function () {
        tempCollectionsDirtyTick1();
        tempCollectionsDirtyTick2(true);
    });
    // TH 03/02/2017 -- We had to change the timing of this forEach call in order to use the
    // useCache option w/ our ajax calls. Hence why we now check a savingChanges flag.
    // See the putAssignment and deleteAssignment functions inside AssignmentSlotViewModel.
    persistedAssignments.forEach(function (assignment) {
        var doAddSlot = function () { return slotParams.push({
            assignment: assignment,
            proposedOrder: assignment.AssignmentOrder()
        }); };
        // TH 03/02/2017 -- Found a new PilotAssignment.
        // Are we currently saving?...
        if (savingChanges()) {
            // ... if so, need to subscribe to savingChanges...
            s_js_1.default(function () {
                var saving = s_js_1.default.sample(savingChanges);
                if (saving) {
                    // ... if still saving, call savingChanges to subscribe to future updates...
                    savingChanges();
                }
                else {
                    // ... once done saving, don't wanna subscribe to future updates.
                    // Sample the tempAddedPilotAssignments.
                    // If this assignment is in there, it means we just added this assignment
                    // from an existing slot. No need to create another slot.
                    // If it's not in the temp collection, then add a new slot.
                    s_js_1.default.sample(function () {
                        if (!tempAddedPilotAssignments().has(assignment))
                            doAddSlot();
                    });
                }
            });
        }
        else {
            // ... if we're not saving, then we can just add the new slot immediately.
            doAddSlot();
        }
    }, function (assignment) { return s_js_1.default.sample(function () {
        var doRemoveSlot = function () {
            var slot = assignmentSlots().find(function (s) { return s.Model.PilotId() === assignment.PilotId(); });
            if (slot)
                removeSlot(slot.Params);
        };
        // TH 03/02/2017 -- Discovered that a PilotAssignment was deleted.
        // Are we currently saving?...
        if (savingChanges()) {
            // ... if so, need to subscribe to savingChanges...
            s_js_1.default(function () {
                var saving = s_js_1.default.sample(savingChanges);
                if (saving) {
                    // ... if still saving, call savingChanges to subscribe to future updates...
                    savingChanges();
                }
                else {
                    // ... once done saving, don't wanna subscribe to future updates.
                    // Sample tempDeletedPilotIds.
                    // If this assignment is in there, it means we just deleted this assignment
                    // from an existing slot. No need to delete the slot here.
                    // (If the user clicked to delete the whole slot, we'll handle removing the slot in the AssignmentSlotViewModel.Delete method.)
                    // If it's not in the temp collection, then remove the slot.
                    s_js_1.default.sample(function () {
                        if (!tempDeletedPilotIds().has(assignment.PilotId()))
                            doRemoveSlot();
                    });
                }
            });
        }
        else {
            // ... if we're not saving, then we can just remove the slot immediately.
            doRemoveSlot();
        }
    }); });
    return {
        Model: model,
        AssignmentSlots: assignmentSlots,
        PilotSections: pilotSections,
        UnassignedPilotSection: unassignedPilotSection,
        CanEditPilotAssignments: function () { return model.AssignablePilotIds().length > 0 && !!model.PilotJobOrder() && !model.PilotJobOrder().Cancellation(); },
        AddAssignmentSlot: AddAssignmentSlot,
        AnyAssignablePilots: AnyAssignablePilots,
        PilotAssignableForSlot: PilotAssignableForSlot
    };
    function nextAvailableOrder(proposedOrder) {
        // TH 02/08/2017 -- Next available order # on or after the proposedOrder that doesn't
        // already have any assigned slots.
        // TH 02/09/2017 -- The intention here is to try do reasonable things if a user
        // creates some empty slots but then gets more persisted PilotAssignments from a poll request.
        // That assumes we're polling while the details popup is open (which is the current behavior)
        // and also that two users are editing the same PJO at once.
        // But concurrent edits open up lots of other issues, and in general we aren't doing much to
        // try to handle concurrent edits gracefully. So I'm not too concerned about getting this one perfect.
        while (persistedAssignmentByAssignmentOrder(proposedOrder)())
            proposedOrder++;
        return proposedOrder;
    }
    function markAsAdded(assignment) {
        s_js_1.default.freeze(function () {
            tempAddedPilotAssignments().add(assignment);
            tempCollectionsDirtyTick1(true);
        });
    }
    function markAsDeleted(pilotId) {
        s_js_1.default.freeze(function () {
            tempDeletedPilotIds().add(pilotId);
            tempCollectionsDirtyTick1(true);
        });
    }
    function removeSlot(params) {
        slotParams.remove(params);
    }
    function AddAssignmentSlot() {
        slotParams.push({
            assignment: null,
            proposedOrder: assignmentSlots().length ? Math.max.apply(Math, assignmentSlots().map(function (s) { return s.Order(); })) + 1 : 0
        });
    }
    function AnyAssignablePilots(group, slot) {
        return group.Pilots().some(function (p) { return PilotAssignableForSlot(p, slot); });
    }
    function PilotAssignableForSlot(pilot, slot) {
        return assignablePilotIds().has(pilot.Model.Id()) && !assignedPilots().has(pilot)
            || slot.Pilot() === pilot;
    }
}
exports.PilotAssignments = PilotAssignments;
var AssignmentSlotReactId = 0;
// A slot that can hold 0 or 1 variable pilot assignments.
function AssignmentSlotViewModel(params, ajax, model, pilotsIdx, nextAvailableOrder, savingChanges, markAsAdded, markAsDeleted, removeSlot) {
    var initialAssignment = params.assignment, proposedOrder = params.proposedOrder, assignmentsUrlBase = function () { return model.PilotJobOrder() && model.PilotJobOrder().PilotsUrlBase() || ''; }, assignmentUrl = function (pilotId) { return assignmentsUrlBase().replace('{pilotId}', '' + pilotId); }, persistedAssignment = s_js_1.default.value(initialAssignment), order = function () { return persistedAssignment() ? persistedAssignment().AssignmentOrder() : nextAvailableOrder(proposedOrder); }, effectiveAssignment = new PilotAssignment_1.PilotAssignment(initialAssignment ?
        s_js_1.default.sample(function () { return asOptions(initialAssignment); }) :
        { PilotId: 0, PilotJobOrderId: 0 }), 
    // TH 02/08/2017 -- NOTE: We'll store the currently selected PilotId as draft.PilotId,
    // w/ 0 representing no pilot selected.
    _a = draftSignals_1.DraftObject(effectiveAssignment, [
        'PilotId',
        'PilotConfirmed'
    ]), draft = _a.object, draftMethods = _a.methods;
    // TH 02/08/2017 -- Update effective assignment from persisted assignment.
    s_js_1.default(function () { return persistedAssignment() && PilotAssignment_1.PilotAssignment.update(effectiveAssignment, asOptions(persistedAssignment())); });
    // TH 02/08/2017 -- Update effective order from order computation -- also flows through to draft for being persisted by the AutoSaver.
    s_js_1.default(function () { return effectiveAssignment.AssignmentOrder(order()); });
    // TH 02/09/2017 -- Also had code that attempted to reset PilotConfirmed to false when PilotId changes.
    // But it led to complicated interactions w/ the AutoSaver, and I decided it wasn't worth pushing it at this time.
    // We also don't do that for any of the other Tentative/Confirmed toggles.
    autoSave_1.AutoSaver(draftMethods.onWrite, function () {
        var _persisted = persistedAssignment(), persistedId = _persisted && _persisted.PilotId(), currentDraft = asOptions(draft), selectedId = currentDraft.PilotId, draftCheckpoint = draftMethods.checkpoint();
        // TH 02/08/2017 -- firstReq and secondReq resolve w/ what the persistedAssignment
        // value should be after the request is finished.
        var firstReq = Promise.resolve(_persisted);
        if (persistedId && persistedId !== selectedId) {
            firstReq = deleteAssignment(persistedId).then(function () { return null; });
        }
        var secondReq = firstReq;
        if (selectedId) {
            secondReq = firstReq.then(function () { return putAssignment(currentDraft); });
        }
        return secondReq.then(function (assignment) { return s_js_1.default.freeze(function () {
            draftCheckpoint.revert();
            persistedAssignment(assignment);
        }); });
    });
    return {
        Params: params,
        Model: draft,
        Pilot: pilotsIdx(draft.PilotId),
        Order: order,
        Delete: Delete,
        ReactKey: AssignmentSlotReactId++
    };
    function Delete() {
        if (savingChanges())
            return;
        var persistedId = persistedAssignment() && persistedAssignment().PilotId();
        var req = Promise.resolve();
        if (persistedId) {
            req = deleteAssignment(persistedId);
        }
        // TH 02/08/2017 -- Remove the slot by removing its params object.
        req.then(function () { return removeSlot(params); });
    }
    function putAssignment(assignment) {
        var client = ajax.Url(assignmentUrl(assignment.PilotId), {
            useCache: true
        });
        savingChanges(true);
        return client.Put(assignment).then(function (updates) { return s_js_1.default.freeze(function () {
            // TH 03/02/2017 -- Fish the new/updated PilotAssignment out of the DataCacheUpdate.
            // We expect exactly one PilotAssignment to be updated from this request.
            var serverAssignment = updates.PilotEntities() &&
                updates.PilotEntities().PilotAssignments()[0] || null;
            if (!serverAssignment)
                throw new Error('PutAssignmentSuccess -- Expected to find a new/update PilotAssignment');
            // TH 03/02/2017 -- UPDATE. We're now using the useCache option on our ajax client.
            // That's so we can pick up possible log events generated by this action.
            // As a result, this function now gets called AFTER the PCCache has been updated, after an async delay.
            // B/c of that, we had to change the timing of the persistedAssignments.forEach call above.
            //
            // TH 02/08/2017 -- markAsAdded to avoid adding a duplicate assignment slot.
            markAsAdded(serverAssignment);
            savingChanges(false);
            return serverAssignment;
        }); }).finally(function () { return savingChanges(false); });
    }
    function deleteAssignment(pilotId) {
        var client = ajax.Url(assignmentUrl(pilotId), { useCache: true });
        savingChanges(true);
        return client.Delete().then(function () { return s_js_1.default.freeze(function () {
            // 03/02/2017 -- UPDATE. We're now using the useCache option on our ajax client.
            // That causes the same timing changes as for the putAssignment call. See above.
            //
            // TH 02/08/2017 -- markAsDeleted to avoid deleting this slot.
            // If this is a swap of pilots w/in a single slot, we definitely don't wanna delete the slot.
            // And if this is an actual deletion of the slot, we'll take care of removing the slot in the
            // Delete function above.
            markAsDeleted(pilotId);
            savingChanges(false);
        }); }).finally(function () { return savingChanges(false); });
    }
}
// TH 02/08/2017 -- Hmmm... A possible generic utility?
// Alternatively, do we maybe wanna bake functionality into auto-generated models for
// converting to a Data or Options type and/or adding an updateFromModel method?
function asOptions(assignment) {
    return JSON.parse(JSON.stringify(assignment));
}
// ViewModel properties that apply to a PilotSection entity or to the set of unassigned pilots
function PilotGroupingViewModel(sectionId, pilotsBySection) {
    var indexKey = function () { return SectionIndexKey(sectionId()); };
    return {
        Pilots: s_array_1.lift(pilotsBySection(indexKey)).orderBy(function (p) { return p.Model.Order(); })
    };
}
function SectionIndexKey(sectionId) {
    return sectionId === null ? NaN : sectionId;
}
// ViewModel for an actual PilotSection entity
function PilotSectionViewModel(pilotSection, pilotGroupingModel) {
    var grouping = pilotGroupingModel(pilotSection.Id);
    return Object.assign(grouping, {
        Model: pilotSection
    });
}
function PilotViewModel(pilot) {
    var userAbbrev = function () { var _a, _b; return (_b = (_a = pilot.User()) === null || _a === void 0 ? void 0 : _a.AbbreviatedName()) !== null && _b !== void 0 ? _b : ''; }, displayName = function () { return userAbbrev() + ' (' + pilot.EffectiveCode() + ')'; };
    return {
        Model: pilot,
        DisplayName: displayName
    };
}


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotAssignmentsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
exports.PilotAssignmentsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Model.CanViewFullPilotAssignments() ?
        React.createElement("div", { className: "details-section pilot-assignments" },
            React.createElement("div", { className: "details-section-header" },
                React.createElement("span", { className: "details-section-title" }, "Pilot Assignments")),
            React.createElement("div", { className: "details-section-body" },
                m.AssignmentSlots().map(function (s) {
                    return React.createElement(AssignmentSlotView, { slot: s, model: m, key: s.ReactKey });
                }),
                React.createElement("div", { className: "add-pilot-container" }, m.CanEditPilotAssignments() &&
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.AddAssignmentSlot) }, "+ Assign Pilot")))) : null;
});
var AssignmentSlotView = supercritical_1.default(function (_a) {
    var s = _a.slot, m = _a.model;
    return React.createElement("div", { className: "pilot-assignment" },
        React.createElement("label", { className: "pilot-assignment-label pc-text-smalllabel" }, "Pilot"),
        ' ',
        m.CanEditPilotAssignments() ?
            React.createElement(AssignmentSlotEditView, { slot: s, model: m }) :
            React.createElement(AssignmentSlotReadonlyView, { slot: s }));
});
var AssignmentSlotEditView = supercritical_1.default(function (_a) {
    var s = _a.slot, m = _a.model;
    return React.createElement("span", null,
        React.createElement(PilotSelector, { slot: s, model: m }),
        ' ',
        React.createElement(AssignmentConfirmationView, { slot: s }),
        ' ',
        React.createElement("i", { className: "delete-pilot-assignment undo-btn icon-undo-circle", onClick: s.Delete }));
});
var PilotSelector = supercritical_1.default(function (_a) {
    var s = _a.slot, m = _a.model;
    return React.createElement("span", null,
        React.createElement("select", { className: "pc-select pilot-name pilot-select pjo-select", value: s.Model.PilotId(), onChange: function (e) { return s.Model.PilotId(+e.currentTarget.value); } },
            React.createElement("option", { value: 0 }, "--"),
            m.PilotSections().filter(function (ps) { return m.AnyAssignablePilots(ps, s); }).map(function (ps) {
                return React.createElement(PilotsOptGroup, { group: ps, label: ps.Model.Name, slot: s, model: m, key: ps.Model.Id() });
            }),
            m.AnyAssignablePilots(m.UnassignedPilotSection, s) &&
                React.createElement(PilotsOptGroup, { group: m.UnassignedPilotSection, label: function () { return 'Unassigned'; }, slot: s, model: m })),
        React.createElement("span", { className: "pc-select-chevron" }));
});
var PilotsOptGroup = supercritical_1.default(function (_a) {
    var g = _a.group, label = _a.label, s = _a.slot, m = _a.model;
    return React.createElement("optgroup", { label: label() }, g.Pilots().filter(function (p) { return m.PilotAssignableForSlot(p, s); }).map(function (p) {
        return React.createElement(PilotOption, { pilot: p, key: p.Model.Id() });
    }));
});
var PilotOption = supercritical_1.default(function (_a) {
    var p = _a.pilot;
    return React.createElement("option", { value: p.Model.Id() }, p.DisplayName());
});
var AssignmentSlotReadonlyView = supercritical_1.default(function (_a) {
    var s = _a.slot;
    return React.createElement("span", null,
        React.createElement("span", { className: "pilot-name pilot-name-view-only" }, s.Pilot() && s.Pilot().DisplayName()),
        ' ',
        React.createElement(AssignmentConfirmationView, { slot: s, readonly: true }));
});
var AssignmentConfirmationView = supercritical_1.default(function (_a) {
    var s = _a.slot, readonly = _a.readonly;
    if (!s.Model.PilotId())
        return null;
    var className = cx('pjo-details-confirmation', {
        'pjo-details-confirmed': s.Model.PilotConfirmed()
    }), confirmationText = s.Model.PilotConfirmed() ? 'Confirmed' : 'Tentative';
    return readonly ?
        React.createElement("span", { className: className }, confirmationText) :
        React.createElement("a", { href: "", className: className, onClick: eventWrappers_1.noDefault(function () { return s.Model.PilotConfirmed(!s.Model.PilotConfirmed()); }) }, confirmationText);
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderDetailsPopupViews = exports.PilotJobOrderDetailsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var UOM_1 = __webpack_require__(25);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(977);
var view_3 = __webpack_require__(1080);
var view_4 = __webpack_require__(519);
var view_5 = __webpack_require__(29);
var view_6 = __webpack_require__(522);
var view_7 = __webpack_require__(524);
var view_8 = __webpack_require__(68);
var view_9 = __webpack_require__(55);
var view_10 = __webpack_require__(35);
var view_11 = __webpack_require__(22);
var view_12 = __webpack_require__(1001);
var view_13 = __webpack_require__(68);
var view_14 = __webpack_require__(52);
var view_15 = __webpack_require__(91);
var pilotassignmentsview_1 = __webpack_require__(997);
var pilotagechargesview_1 = __webpack_require__(995);
var originalpilotorderview_1 = __webpack_require__(994);
exports.PilotJobOrderDetailsView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    if (!m)
        return null;
    return (React.createElement("div", { className: "pilotjoborderdetails pc-card" },
        React.createElement("div", { className: 'details-content' },
            React.createElement(DetailsHeader, { model: m }),
            React.createElement(DetailsBody, { model: m }),
            React.createElement(view_1.ActionLoadingIndicator, { loading: m.JobOrder.Working }))));
});
var DetailsHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-header pc-card-header" },
        React.createElement(ActionsContainer, { model: m }),
        React.createElement(ActionConfirmation, { model: m }),
        React.createElement(DetailsTitle, { model: m }));
});
var ActionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pjo-actions-container" },
        m.JobOrder.Model.AcknowledgedDate() === null && m.CanAcknowledge() &&
            React.createElement("a", { href: "", className: "pjo-acknowledge-link", onClick: eventWrappers_1.noDefault(m.JobOrder.Acknowledge) }, "Acknowledge"),
        React.createElement("button", { className: "pjo-actions-menu-btn fa fa-bars", onClick: m.ToggleActionsMenu }),
        m.ShowActionsMenu() &&
            React.createElement(view_10.PCDismissible, { className: "pjo-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
                React.createElement(BerthTimelineLink, { model: m }),
                React.createElement(PortCallProfileLink, { model: m }),
                React.createElement(FlipToLogLink, { model: m }),
                React.createElement(originalpilotorderview_1.PrintOriginalOrderLink, { model: m.OriginalPilotOrder }),
                React.createElement(CancelPJOLink, { model: m }),
                React.createElement(ReorderPJOLink, { model: m }),
                React.createElement(AbortPJOLink, { model: m }),
                React.createElement(DeletePJOLink, { model: m })));
});
var BerthTimelineLink = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var point = ((_b = m.JobOrder.FromPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation()) ? m.JobOrder.FromPoint() :
        ((_c = m.JobOrder.ToPoint()) === null || _c === void 0 ? void 0 : _c.BerthReservation()) ? m.JobOrder.ToPoint() :
            null;
    if (!point)
        return null;
    return (React.createElement("div", { className: "pjo-actions-menu-item" },
        React.createElement("a", { href: '#!schedulegrid'
                + '?date=' + tzmoment_1.tzmoment(point.Model.Arrival.Effective()).add(-1, 'days').format('YYYY-MM-DD')
                + '&resid=' + point.BerthReservation().Model.Id() }, "Go to Berths Timeline")));
});
var PortCallProfileLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pjo-actions-menu-item" },
        React.createElement("a", { href: '#!portcallprofile?id=' + m.JobOrder.Model.PortCallId() }, "Go to the PortCall Profile"));
});
var FlipToLogLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pjo-actions-menu-item" },
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.FlipToBack(0 /* Log */); })) }, "Flip to Log"));
});
var CancelPJOLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return !m.JobOrder.Model.Start.Actual() && m.Model.CanCancel() && !m.JobOrder.Model.Cancellation() ?
        React.createElement("div", { className: "pjo-actions-menu-item" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.ActionToConfirm(m.JobOrder.PromptForCancellationRemarks); })) }, "Cancel Movement")) : null;
});
var ReorderPJOLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.CanReorder() && m.JobOrder.Model.Cancellation() ?
        React.createElement("div", { className: "pjo-actions-menu-item" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(m.JobOrder.Reorder)) }, "Reorder Movement")) : null;
});
var AbortPJOLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.JobOrder.Model.Start.Actual() && m.Model.CanCancel() && !m.JobOrder.Model.Cancellation() ?
        React.createElement("div", { className: "pjo-actions-menu-item" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.ActionToConfirm(m.JobOrder.PromptForAbortRemarks); })) }, "Abort Movement")) : null;
});
var DeletePJOLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Model.CanDelete() ?
        React.createElement("div", { className: "pjo-actions-menu-item" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.MenuAction(function () { return m.ActionToConfirm(m.JobOrder.Delete); })) }, "Delete Movement")) : null;
});
var ActionConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ActionToConfirm() &&
        React.createElement("div", { className: "pjo-details-action-conf" },
            React.createElement("span", null, "Are you sure?"),
            ' ',
            React.createElement("a", { className: "pjo-details-action-conf-yes", href: "", onClick: eventWrappers_1.noDefault(m.ActionToConfirm()) }, "Yes"),
            ' ',
            React.createElement("a", { className: "pjo-details-action-conf-no", href: "", onClick: eventWrappers_1.noDefault(function () { return m.ActionToConfirm(null); }) }, "No"));
});
var DetailsTitle = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "pc-card-title" },
        React.createElement("span", { className: "vessel" }, m.JobOrder.Model.DisplayVesselIdentifier()),
        ' ',
        React.createElement("span", { className: "em-dash" }, "\u2014"),
        ' ',
        React.createElement(LocationNameView, { point: m.JobOrder.FromPoint }),
        ' ',
        React.createElement("span", { className: "location is-not-berth" }, "to"),
        ' ',
        React.createElement(LocationNameView, { point: m.JobOrder.ToPoint }),
        ' ',
        React.createElement("span", { className: "em-dash" }, "\u2014"),
        ' ',
        React.createElement("span", { className: "date" }, tzmoment_1.tzmoment(m.JobOrder.Model.Start.Effective()).format('MMMM DD, YYYY')),
        ' ',
        m.JobOrder.Model.Cancellation() &&
            React.createElement("span", null,
                React.createElement("span", { className: "em-dash" }, "\u2014"),
                ' ',
                React.createElement("span", { className: "cancelled-msg" }, "Cancelled")),
        ((_b = m.JobOrder.PortCall()) === null || _b === void 0 ? void 0 : _b.Unlisted()) ? React.createElement("span", null, " \u2014 UNLISTED") : '',
        React.createElement("span", { className: "print-reminder" }, "*remember to set your page range"));
});
var LocationNameView = supercritical_1.default(function (_a) {
    var pt = _a.point;
    return React.createElement("span", { className: cx('location', {
            'is-not-berth': !pt() ||
                !pt().Model.Location() ||
                !pt().Model.Location().Berth()
        }) }, pt() && pt().Model.Location() && pt().Model.Location().Name());
});
var DetailsBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-body flip-card" },
        React.createElement(DetailsFrontContent, { model: m }),
        React.createElement(DetailsBackContent, { model: m }));
});
var DetailsFrontContent = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('face front', { flipped: m.Flipped() }) },
        React.createElement(DetailsBodyLeft, { model: m }),
        React.createElement(DetailsBodyRight, { model: m }));
});
var DetailsBodyLeft = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-body-left details-body-column" },
        React.createElement(MovementTimes, { model: m }),
        React.createElement("div", { className: "space-allocation pilots" },
            React.createElement(pilotassignmentsview_1.PilotAssignmentsView, { model: m.PilotAssignments })),
        React.createElement(BerthReservationDetails, { model: m }),
        React.createElement(ServicesView, { model: m }));
});
var MovementTimes = supercritical_1.default(function (_a) {
    var m = _a.model;
    var fromRes = m.JobOrder.FromPoint() && m.JobOrder.FromPoint().BerthReservation(), toRes = m.JobOrder.ToPoint() && m.JobOrder.ToPoint().BerthReservation();
    return (
    // TH 02/06/2017 -- Changing movement-times to pjo-movement-times to prevent
    // styles from the new MovementTimes widget (portcall/movementtimes/*) from bleeding
    // through.
    React.createElement("div", { className: "details-section pjo-movement-times" },
        React.createElement("div", { className: "details-section-header" },
            React.createElement("span", { className: "details-section-title" }, "Movement Times")),
        React.createElement("div", { className: cx('details-section-body mvmt-times-body', {
                'show-mvmt-in': !fromRes && !!toRes,
                'show-mvmt-out': !!fromRes && !toRes,
                'show-mvmt-shift': !!fromRes && !!toRes
            }) },
            React.createElement(StartTimes, { model: m }),
            React.createElement(EndTimes, { model: m }),
            React.createElement(LogStartActualLink, { model: m }),
            React.createElement(LogEndActualLink, { model: m }),
            React.createElement(UndoStartActualConfirmation, { model: m }),
            React.createElement(UndoEndActualConfirmation, { model: m }),
            React.createElement(PrimaryBerthLabel, { model: m }),
            React.createElement(SecondaryLocationLabel, { model: m }),
            React.createElement(TransitLine, { model: m }),
            React.createElement("div", { className: "alignment-tick alignment-tick-start" }),
            React.createElement("div", { className: "alignment-tick alignment-tick-end" }))));
});
// Start Est. and Actual, Start Time Confirmed Toggle, Undo Start Actual Link/Icon
var StartTimes = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "start-times" },
        React.createElement(StartEstimate, { model: m }),
        React.createElement(StartActual, { model: m }));
});
var StartEstimate = supercritical_1.default(function (_a) {
    var m = _a.model;
    return !m.JobOrder.Model.Start.Actual() ?
        React.createElement("div", { className: "start-estimate" },
            React.createElement("div", { className: "mvmt-time-label" },
                React.createElement("span", { className: "mvmt-in" }, "Arriving"),
                React.createElement("span", { className: "mvmt-out" }, "Departing"),
                React.createElement("span", { className: "mvmt-shift" }, "Shifting")),
            React.createElement("div", null,
                React.createElement(view_4.DateTimeEditPopupTrigger, { value: m.JobOrder.SyncedStartAndEndEstimate, disabled: !m.Model.CanEditTimes() || !!m.JobOrder.Model.Cancellation(), onTriggerPopup: function () { return m.JobOrder.ShowDateTimeEditPopup('start-est'); }, localization: m.Localization }),
                React.createElement(StartTimeConfirmation, { model: m }))) : null;
});
var StartTimeConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    var className = cx('start-time-confirmation pjo-details-confirmation', {
        'pjo-details-confirmed': m.JobOrder.Model.StartTimeConfirmed()
    }), classSpan = 'start-time-confirmation-span', text = m.JobOrder.Model.StartTimeConfirmed() ? 'Firm' : 'Tentative';
    return m.Model.CanEditStartTimeConfirmed() && !m.JobOrder.Model.Cancellation() ?
        React.createElement("a", { href: "", className: className, onClick: eventWrappers_1.noDefault(m.JobOrder.ToggleStartConfirmed) }, text) :
        React.createElement("span", { className: classSpan }, text);
});
var StartActual = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.JobOrder.Model.Start.Actual() && !m.JobOrder.ShowUndoStartActual() ?
        React.createElement("div", { className: "start-actual" },
            React.createElement("div", { className: "mvmt-time-label" },
                React.createElement("span", { className: "mvmt-in" }, "Arrived"),
                React.createElement("span", { className: "mvmt-out" }, "Departed"),
                React.createElement("span", { className: "mvmt-shift" }, "Shifted")),
            React.createElement("div", null,
                React.createElement(view_4.DateTimeEditPopupTrigger, { value: m.JobOrder.Model.Start.Effective, disabled: !m.Model.CanEditTimes() || !!m.JobOrder.Model.Cancellation(), onTriggerPopup: function () { return m.JobOrder.ShowDateTimeEditPopup('start-effective'); }, localization: m.Localization }),
                m.Model.CanEditTimes() && m.Model.CanChangeVessel() && !m.JobOrder.Model.Cancellation() && !m.JobOrder.Model.End.Actual() &&
                    React.createElement("i", { className: "undo-btn icon-undo-circle", onClick: m.JobOrder.ShowUndoStartActual }))) : null;
});
// End Est. and Actual, Undo End Actual Link/Icon
// TH: Still very apocalyptic :(
var EndTimes = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "end-times" },
        React.createElement(EndEstimate, { model: m }),
        React.createElement(EndActual, { model: m }));
});
var EndEstimate = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    if (m.JobOrder.Model.End.Actual())
        return null;
    var endEstimateText = tzmoment_1.tzmoment(m.JobOrder.Model.End.Estimated()).format('HH:mm');
    return (React.createElement("div", { className: "end-estimate" },
        React.createElement("span", { className: "end-estimate-descr pc-text-fixedwidth" },
            React.createElement("span", { className: "mvmt-in" }, "Est. First Line at"),
            React.createElement("span", { className: "mvmt-out" }, "Est. Pilot End (Disembark) at"),
            React.createElement("span", { className: "mvmt-shift" },
                "Est. First Line",
                ' ', (_c = (_b = m.JobOrder.ToPoint()) === null || _b === void 0 ? void 0 : _b.Model.Location()) === null || _c === void 0 ? void 0 :
                _c.Name(),
                ' ',
                "at")),
        ' ',
        m.Model.CanEditTimes() && !m.JobOrder.Model.Cancellation() && !m.JobOrder.Model.Start.Actual() ?
            React.createElement("a", { href: "", className: "end-estimate-link", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowEditMovementEndPopup(true); }) }, endEstimateText) :
            React.createElement("span", null, endEstimateText)));
});
var EndActual = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.JobOrder.Model.End.Actual() && !m.JobOrder.ShowUndoEndActual() ?
        React.createElement("div", { className: "end-actual" },
            React.createElement("span", { className: "mvmt-time-label" }, "Pilot Complete"),
            React.createElement(view_4.DateTimeEditPopupTrigger, { value: m.JobOrder.Model.End.Effective, disabled: !m.Model.CanEditTimes() || !!m.JobOrder.Model.Cancellation(), onTriggerPopup: function () { return m.JobOrder.ShowDateTimeEditPopup('end-effective'); }, localization: m.Localization }),
            m.Model.CanEditTimes() && !m.JobOrder.Model.Cancellation() &&
                React.createElement("i", { className: "undo-btn icon-undo-circle", onClick: function () { return m.JobOrder.ShowUndoEndActual(true); } })) : null;
});
var LogStartActualLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    // TH 03/09/2017 -- we'll also set PJO.Vessel and PJO.Length when logging pilot aboard.
    // So check CanChangeVessel in addition to CanEditTimes.
    // This is really just defensive since the two permissions currently check the same roles.
    return m.Model.CanEditTimes() && m.Model.CanChangeVessel() && !m.JobOrder.Model.Cancellation() && !m.JobOrder.Model.Start.Actual() ?
        React.createElement("div", { className: "log-start-actual" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowLogActualTimePopup('start-actual'); }) },
                React.createElement("span", { className: "mvmt-in" }, "Log Pilot Aboard"),
                React.createElement("span", { className: "mvmt-out" }, "Log Last Line"),
                React.createElement("span", { className: "mvmt-shift" }, "Log Last Line"))) : null;
});
var LogEndActualLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Model.CanEditTimes() && !m.JobOrder.Model.Cancellation() && m.JobOrder.Model.Start.Actual() && !m.JobOrder.Model.End.Actual() ?
        React.createElement("div", { className: "log-end-actual" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowLogActualTimePopup('end-actual'); }) }, "Log Pilot Complete")) : null;
});
var UndoStartActualConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.JobOrder.Model.Start.Actual() && m.JobOrder.ShowUndoStartActual() ?
        React.createElement("div", { className: "undo-conf-container undo-start-actual" },
            React.createElement("div", { className: "undo-conf-main-line" },
                React.createElement("span", { className: "undo-conf-prompt" },
                    React.createElement("span", { className: "mvmt-in" }, "Undo Log Pilot Aboard?"),
                    React.createElement("span", { className: "mvmt-out" }, "Undo Log Last Line?"),
                    React.createElement("span", { className: "mvmt-shift" }, "Undo Log Last Line?")),
                React.createElement("span", { className: "undo-conf-links" },
                    React.createElement("a", { href: "", className: "undo-conf-confirm-link", onClick: eventWrappers_1.noDefault(m.JobOrder.UndoStartActual) }, "Yes"),
                    React.createElement("a", { href: "", className: "undo-conf-cancel-link", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowUndoStartActual(false); }) }, "No"))),
            React.createElement("div", { className: "undo-conf-descr-line pc-text-smalllabel" },
                React.createElement("span", { className: "mvmt-in" }, "This will revert Actual back to Estimated."),
                React.createElement("span", { className: "mvmt-out" }, "This will revert departure back to Estimated."),
                React.createElement("span", { className: "mvmt-shift" }, "This will revert departure back to Estimated."))) : null;
});
var UndoEndActualConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.JobOrder.Model.End.Actual() && m.JobOrder.ShowUndoEndActual() ?
        React.createElement("div", { className: "undo-conf-container undo-end-actual" },
            React.createElement("div", { className: "undo-conf-main-line" },
                React.createElement("span", { className: "undo-conf-prompt" }, "Undo Log Pilot Complete?"),
                React.createElement("span", { className: "undo-conf-links" },
                    React.createElement("a", { href: "", className: "undo-conf-confirm-link", onClick: eventWrappers_1.noDefault(m.JobOrder.UndoEndActual) }, "Yes"),
                    React.createElement("a", { href: "", className: "undo-conf-cancel-link", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowUndoEndActual(false); }) }, "No"))),
            React.createElement("div", { className: "undo-conf-descr-line pc-text-smalllabel" },
                React.createElement("span", { className: "mvmt-in" }, "This will revert back to Est. First Line."),
                React.createElement("span", { className: "mvmt-out" }, "This will revert back to Est. Pilot End."),
                React.createElement("span", { className: "mvmt-shift" }, "This will revert back to Est. Pilot End."))) : null;
});
var PrimaryBerthLabel = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "primary-location-label" },
        React.createElement("span", { className: "mvmt-in" },
            React.createElement(BerthTypeahead, { point: m.JobOrder.ToPoint, model: m })),
        React.createElement("span", { className: "mvmt-out" },
            React.createElement(BerthTypeahead, { point: m.JobOrder.FromPoint, model: m })),
        React.createElement("span", { className: "mvmt-shift" },
            React.createElement(BerthTypeahead, { point: m.JobOrder.ToPoint, model: m })));
});
var BerthTypeahead = supercritical_1.default(function (_a) {
    var pt = _a.point, m = _a.model;
    return pt() &&
        React.createElement(view_15.TypeaheadInput, { className: "search-filter", model: pt().BerthTypeahead, disabled: !m.Model.CanEditPortCall() || !!m.JobOrder.Model.Cancellation() });
});
// "Secondary" Location Label, e.g. "from Sea", "to Sea", "to Reed Rd An..."
var SecondaryLocationLabel = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var m = _a.model;
    return React.createElement("div", { className: "secondary-location-label pc-text-fixedwidth" },
        React.createElement("span", { className: "mvmt-in" },
            "from ", (_c = (_b = m.JobOrder.FromPoint()) === null || _b === void 0 ? void 0 : _b.Model.Location()) === null || _c === void 0 ? void 0 :
            _c.Name()),
        React.createElement("span", { className: "mvmt-shift" },
            "from ", (_e = (_d = m.JobOrder.FromPoint()) === null || _d === void 0 ? void 0 : _d.Model.Location()) === null || _e === void 0 ? void 0 :
            _e.Name()),
        React.createElement(MovementOutSecondaryLocationLabel, { model: m, locationName: (_h = (_g = (_f = m.JobOrder.ToPoint()) === null || _f === void 0 ? void 0 : _f.Model.Location()) === null || _g === void 0 ? void 0 : _g.Name()) !== null && _h !== void 0 ? _h : null }));
});
var MovementOutSecondaryLocationLabel = supercritical_1.default(function (_a) {
    var m = _a.model, locationName = _a.locationName;
    return m.Model.CanAddShift() && !m.JobOrder.Model.Cancellation() ?
        React.createElement("a", { className: "mvmt-out", href: "", onClick: eventWrappers_1.noDefault(function () { return m.JobOrder.ShowAddShift(true); }) },
            "to ",
            locationName) :
        React.createElement("span", { className: "mvmt-out" },
            "to ",
            locationName);
});
// "Transit" line - Line itself,transit time text, and different arrow head/tail styling for IN vs OUT vs SHIFT
var TransitLine = supercritical_1.default(function (_a) {
    var m = _a.model;
    var transitText = formatHrMin(m.JobOrder.TransitTime()) + ' transit';
    return (React.createElement("div", { className: "transit-duration-container" },
        React.createElement("div", { className: "transit-duration-arrow" }),
        React.createElement("div", { className: "transit-duration-line" }),
        React.createElement("div", { className: "transit-duration-text" },
            React.createElement("span", { className: "mvmt-in" }, transitText),
            React.createElement("span", { className: "mvmt-out" }, transitText),
            React.createElement("span", { className: "mvmt-shift" }, "Shift"))));
});
function formatHrMin(mins) {
    var hrs = Math.floor(Math.abs(mins) / 60), minsRemainder = Math.abs(mins) % 60, signText = mins < 0 ? 'neg.' : '', hrsText = hrs ? ' ' + hrs + ' hr' : '', minsText = minsRemainder ? ' ' + minsRemainder + ' min' : '';
    return (signText + hrsText + minsText).trim();
}
var BerthReservationDetails = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section berth-reservation-details" },
        React.createElement(BerthReservationDetailsHeader, { model: m }),
        React.createElement(BerthReservationDetailsBody, { model: m }));
});
var BerthReservationDetailsHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section-header" },
        React.createElement("div", { className: "details-section-header-side-item" },
            React.createElement(BerthReservationDetailsReservationSelector, { model: m }),
            React.createElement(BerthReservationDetailsNonShiftConflictBadge, { model: m })),
        React.createElement("span", { className: "details-section-title" }, "Berth Details"));
});
var BerthReservationDetailsReservationSelector = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return ((_b = m.JobOrder.FromPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation()) && ((_c = m.JobOrder.ToPoint()) === null || _c === void 0 ? void 0 : _c.BerthReservation()) ?
        React.createElement("div", { className: "berth-reservation-selection-container" },
            React.createElement(ReservationSelectorTab, { point: m.JobOrder.FromPoint, className: "berth-reservation-selector-tab-from", text: "From", model: m }),
            React.createElement("span", { className: "berth-reservation-selection-pipe" }, "|"),
            React.createElement(ReservationSelectorTab, { point: m.JobOrder.ToPoint, className: "berth-reservation-selector-tab-to", text: "To", model: m })) :
        null;
});
var ReservationSelectorTab = supercritical_1.default(function (_a) {
    var pt = _a.point, className = _a.className, text = _a.text, m = _a.model;
    return React.createElement("span", { className: cx('berth-reservation-selection-tab', className), onClick: function () { return m.BerthReservationDetails.SelectedItineraryPoint(pt()); } },
        React.createElement("span", { className: cx('berth-reservation-selection-tab-text', {
                'berth-reservation-selection-tab-selected': m.BerthReservationDetails.SelectedItineraryPoint() === pt()
            }) }, text),
        React.createElement("span", { className: "shift-conflict-container" }, m.ShowConflicts() && React.createElement(view_13.SmallConflictCountBadge, { conflictCount: function () { var _a, _b, _c; return (_c = (_b = (_a = pt()) === null || _a === void 0 ? void 0 : _a.BerthReservation()) === null || _b === void 0 ? void 0 : _b.Model.ConflictCount()) !== null && _c !== void 0 ? _c : 0; } })));
});
var BerthReservationDetailsNonShiftConflictBadge = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowConflicts() &&
        m.JobOrder.FromPoint() &&
        m.JobOrder.ToPoint() &&
        (!m.JobOrder.FromPoint().BerthReservation() || !m.JobOrder.ToPoint().BerthReservation()) ?
        React.createElement("div", { className: "non-shift-conflict-container" },
            React.createElement(view_13.SmallConflictCountBadge, { conflictCount: function () { var _a, _b, _c; return (_c = (_b = (_a = m.BerthReservationDetails.SelectedItineraryPoint()) === null || _a === void 0 ? void 0 : _a.BerthReservation()) === null || _b === void 0 ? void 0 : _b.Model.ConflictCount()) !== null && _c !== void 0 ? _c : 0; } })) : null;
});
var BerthReservationDetailsBody = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var pt = m.BerthReservationDetails.SelectedItineraryPoint(), res = pt === null || pt === void 0 ? void 0 : pt.BerthReservation();
    return res && pt ?
        React.createElement("div", { className: "details-section-body berth-reservation-details-body" },
            React.createElement("div", { className: "selected-reservation-location details-section-title" }, (_b = pt.Model.Location()) === null || _b === void 0 ? void 0 : _b.Name()),
            React.createElement("div", { className: "selected-reservation-conflict-text pjo-conflict-msg" }, m.ShowConflicts() && React.createElement(view_8.IssuesShortSummary, { issues: res.Model.Issues })),
            React.createElement(view_7.FootmarkAssignmentsView, { model: res.FootmarkAssignments })) :
        null;
});
var ServicesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section pjo-services" },
        React.createElement("div", { className: "details-section-header" },
            React.createElement("span", { className: "details-section-title" }, "Services")),
        React.createElement("div", { className: "details-section-body" },
            React.createElement(TugsView, { model: m }),
            React.createElement(LineHandlersView, { model: m }),
            React.createElement(LaborView, { model: m })));
});
var TugsView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "service-row" },
        React.createElement("label", { className: "service-row-label pc-text-smalllabel" }, "Tugs"),
        m.Model.CanEditServices() && !m.JobOrder.Model.Cancellation() ?
            React.createElement("span", null,
                React.createElement("select", { className: "pc-select service-main-select pjo-select", value: m.JobOrder.Model.TugCompanyId() === null ? '' : '' + m.JobOrder.Model.TugCompanyId(), onChange: function (e) { return m.JobOrder.Model.TugCompanyId(e.currentTarget.value === '' ? null : +e.currentTarget.value); } },
                    React.createElement("option", { value: "", key: "" }, "--"),
                    m.TugCompanies().map(function (tug) {
                        return React.createElement("option", { value: tug.Id(), key: tug.Id() }, tug.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" })) :
            React.createElement("span", { className: "service-main-select pc-text-fixedwidth" }, (_b = m.JobOrder.Model.TugCompany()) === null || _b === void 0 ? void 0 : _b.Name()),
        m.JobOrder.Model.TugCompanyId() !== null &&
            React.createElement("div", { className: "service-last-item" },
                React.createElement("label", { className: "service-second-label pc-text-smalllabel" }, "Assigned"),
                m.Model.CanEditServices() && !m.JobOrder.Model.Cancellation() ?
                    React.createElement(view_9.NumericInput, { className: "tugs-assigned numeric-input", value: m.JobOrder.Model.NumberOfTugs }) :
                    React.createElement("span", { className: "tugs-assigned" }, m.JobOrder.Model.NumberOfTugs())));
});
var LineHandlersView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "service-row" },
        React.createElement("label", { className: "service-row-label pc-text-smalllabel" }, "Line H."),
        m.Model.CanEditServices() && !m.JobOrder.Model.Cancellation() ?
            React.createElement("span", null,
                React.createElement("select", { className: "pc-select service-main-select pjo-select", value: m.JobOrder.Model.LineHandlingCompanyId() === null ? '' : '' + m.JobOrder.Model.LineHandlingCompanyId(), onChange: function (e) { return m.JobOrder.Model.LineHandlingCompanyId(e.currentTarget.value === '' ? null : +e.currentTarget.value); } },
                    React.createElement("option", { value: "", key: "" }, "--"),
                    m.LineHandlingCompanies().map(function (lh) {
                        return React.createElement("option", { value: lh.Id(), key: lh.Id() }, lh.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" })) :
            React.createElement("span", { className: "service-main-select pc-text-fixedwidth" }, (_b = m.JobOrder.Model.LineHandlingCompany()) === null || _b === void 0 ? void 0 : _b.Name()));
});
var LaborView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "service-row" },
        React.createElement("label", { className: "service-row-label pc-text-smalllabel" }, "Labor"),
        React.createElement(view_4.NullableDateTimeEditPopupTrigger, { value: m.JobOrder.Model.LaborStartTime, disabled: !m.Model.CanEditServices() || !!m.JobOrder.Model.Cancellation(), onTriggerPopup: function () { return m.JobOrder.ShowNullableDateTimeEditPopup('labor-start'); }, localization: m.Localization }));
});
var DetailsBodyRight = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-body-right details-body-column" },
        React.createElement(VesselDetails, { model: m }),
        React.createElement(MovementDrafts, { model: m }),
        React.createElement(BowThrusterFrontView, { model: m }),
        React.createElement(AttendingAgentView, { model: m }),
        React.createElement(PilotageChargesFrontView, { model: m }),
        React.createElement("div", { className: "space-allocation shiphandlingnotes" },
            React.createElement(ShiphandlingNotesFrontView, { model: m })),
        React.createElement(MovementRemarks, { model: m }));
});
var VesselDetails = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var v = m.JobOrder.EffectiveVessel();
    return (React.createElement("div", { className: "details-section vessel" },
        React.createElement("div", { className: "details-section-header" },
            React.createElement("span", { className: "details-section-header-side-item pc-text-smalllabel" }, (_b = v === null || v === void 0 ? void 0 : v.Model.Flag()) === null || _b === void 0 ? void 0 : _b.Name()),
            React.createElement("span", { className: "details-section-title" },
                m.JobOrder.Model.DisplayVesselIdentifier(),
                ((_c = m.JobOrder.PortCall()) === null || _c === void 0 ? void 0 : _c.Unlisted()) ? React.createElement("span", null, " \u2014 UNLISTED") : '')),
        React.createElement("div", { className: "details-section-body" },
            React.createElement("div", { className: "vessel-basics-col vessel-basics-col-1" },
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "Length Overall"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, m.JobOrder.EffectiveLength())),
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "Beam"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, v === null || v === void 0 ? void 0 : v.Beam())),
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "Gross Tonnage"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, v === null || v === void 0 ? void 0 : v.Model.GrossTonnage.toString({ units: false })))),
            React.createElement("div", { className: "vessel-basics-col" },
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "IMO"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, v === null || v === void 0 ? void 0 : v.Model.IMO())),
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "Callsign"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, v === null || v === void 0 ? void 0 : v.Model.CallSign())),
                React.createElement("div", { className: "vessel-item-row" },
                    React.createElement("label", { className: "vessel-item-label pc-text-smalllabel" }, "Vessel Type"),
                    React.createElement("span", { className: "vessel-item-value pc-text-smalltext pc-text-fixedwidth" }, v === null || v === void 0 ? void 0 : v.Model.VesselType()))),
            React.createElement(NextLastPortOfCall, { model: m }))));
});
var MovementDrafts = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section details-section-narrow vessel-drafts" },
        React.createElement(MovementDraftsHeader, { model: m }),
        React.createElement("div", null,
            React.createElement(DraftEditRow, { model: m, label: "Air Draft", draft: m.JobOrder.EffectiveAirDraft }),
            React.createElement(DraftEditRow, { model: m, label: "Deep Draft", draft: m.JobOrder.EffectiveDeepDraft }),
            React.createElement(DeepDraftConfirmation, { model: m })));
});
var MovementDraftsHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vessel-draft-header details-section-header details-subsection-header" },
        m.ShowConflicts() && m.JobOrder.HasDraftConflict() &&
            React.createElement("span", { className: "details-section-header-side-item pjo-conflict-msg" }, "Exceeds movement draft"),
        React.createElement("div", { className: "details-section-title details-subsection-title" }, "Actual Drafts"));
});
var DraftEditRow = supercritical_1.default(function (_a) {
    var m = _a.model, draft = _a.draft, label = _a.label;
    return React.createElement("div", { className: cx('vessel-draft-row', { 'has-default-value': !draft.HasLockedValue() }) },
        React.createElement("span", { className: "vessel-draft-label pc-text-smalllabel" }, label),
        React.createElement(view_6.FeetInchesMetersEditView, { model: draft.FeetInchesMeters, disabled: !m.Model.CanEditDrafts() || !!m.JobOrder.Model.Cancellation(), onBlur: draft.OnBlur }));
});
var DeepDraftConfirmation = supercritical_1.default(function (_a) {
    var m = _a.model;
    var className = cx('pjo-details-confirmation', {
        'pjo-details-confirmed': m.JobOrder.DeepDraftConfirmed()
    }), classSpan = '', confirmationText = m.JobOrder.DeepDraftConfirmed() ? 'Confirmed' : 'Tentative';
    return (React.createElement("div", { className: "vessel-draft-row deep-draft-row" },
        React.createElement("span", { className: "deep-draft-confirmation" }, m.Model.CanEditDeepDraftConfirmed() && !m.JobOrder.Model.Cancellation() ?
            React.createElement("a", { href: "", className: className, onClick: eventWrappers_1.noDefault(m.JobOrder.ToggleDeepDraftConfirmed) }, confirmationText) :
            React.createElement("span", { className: classSpan }, confirmationText)),
        React.createElement("span", { className: "vessel-draft-separator" })));
});
var BowThrusterFrontView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section details-section-narrow bow-thruster-front" },
        React.createElement(BowThrusterFrontHeader, { model: m }),
        React.createElement(BowThrusterFrontBody, { model: m }));
});
var BowThrusterFrontHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section-header details-subsection-header" },
        m.JobOrder.EffectiveVessel() &&
            // TH 02/05/2017 -- Permissions:
            //   CanEditVessel - matches server requirement for editing BowThruster fields.
            //   CanEditPortCall -- matches server requirement for editing Next/Last Port of Call
            // Figure you should be able to see the flip as long as you can edit at least one of
            // the items on it.
            (m.Model.CanEditVessel() || m.Model.CanEditPortCall()) &&
            React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-more", onClick: eventWrappers_1.noDefault(function () { return m.FlipToBack(2 /* Vessel */); }) }),
        React.createElement("div", { className: "details-section-title details-subsection-title" }, "Bow Thruster"));
});
var BowThrusterFrontBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    var v = m.JobOrder.EffectiveVessel();
    return v &&
        React.createElement("div", { className: "details-section-body" }, v.BowThruster.Raw.Present() ?
            React.createElement("div", null,
                React.createElement(BowThrusterVesselSummary, { vessel: v }),
                React.createElement(BowThrusterOperational, { model: m })) :
            React.createElement("div", { className: "no-bow-thruster" }, v.BowThruster.Raw.Present() === null ? 'Unknown' : 'None'));
});
var BowThrusterVesselSummary = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "bow-thruster-row" },
        React.createElement("span", { className: "pc-text-label-color" }, "Size"),
        React.createElement("span", { className: "bow-thruster-value bow-thruster-size" }, v.BowThruster.Raw.Size.UOM() === UOM_1.default.Horsepower ?
            React.createElement("span", null, v.BowThruster.SizeInHorsepower.toString()) :
            React.createElement("span", null, v.BowThruster.SizeInKilowatts.toString())));
});
var BowThrusterOperational = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "bow-thruster-row" },
        React.createElement("span", { className: "bow-text pc-text-label-color" }, "Does it work?"),
        React.createElement("span", { className: "bow-thruster-value" }, m.Model.CanEditBowThrusterOperational() && !m.JobOrder.Model.Cancellation() ?
            React.createElement(YesNoUnknownSelector, { value: m.JobOrder.Model.BowThrusterOperational, model: m }) :
            React.createElement("span", null, m.JobOrder.Model.BowThrusterOperational() ? 'Yes' :
                m.JobOrder.Model.BowThrusterOperational() === null ? '--' :
                    'No')));
});
var ShiphandlingNotesFrontView = supercritical_1.default(function (_a) {
    var m = _a.model;
    // TH 10/20/2017 -- Changing to make visible to all users who land here.
    // Still need CanAddShiphandlingNote to see the widget for adding notes.
    return React.createElement("div", { className: "details-section details-section-narrow shiphandling-notes-front" },
        React.createElement(ShiphandlingNotesFrontHeader, { model: m }),
        React.createElement(ShiphandlingNotesFrontBody, { model: m }));
});
var ShiphandlingNotesFrontHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section-header" },
        m.JobOrder.EffectiveVessel() &&
            React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-more", onClick: eventWrappers_1.noDefault(function () { return m.FlipToBack(1 /* ShiphandlingNotes */); }) }),
        React.createElement("span", { className: "details-section-title" }, "Pilot Shiphandling Notes"));
});
// TH 02/03/2017 -- Max number of shiphandling notes displayed in the front view.
// The full list of notes is displayed on the back flip.
var MAX_NOTES = 2;
var ShiphandlingNotesFrontBody = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var notes = (_c = (_b = m.JobOrder.EffectiveVessel()) === null || _b === void 0 ? void 0 : _b.PilotShiphandlingNotes()) !== null && _c !== void 0 ? _c : [];
    return (React.createElement("div", { className: "details-section-body" },
        React.createElement("div", null, notes.slice(0, MAX_NOTES).map(function (n) {
            return React.createElement(ShiphandlingNoteFrontItem, { note: n, model: m, key: n.Id() });
        })),
        notes.length > MAX_NOTES &&
            React.createElement("div", { className: "shiphandling-notes-more-link-container" },
                React.createElement("span", { className: "shiphandling-notes-more-link pc-text-smalllabel", onClick: function () { return m.FlipToBack(1 /* ShiphandlingNotes */); } }, "...more..."))));
});
var ShiphandlingNoteFrontItem = supercritical_1.default(function (_a) {
    var _b;
    var n = _a.note, m = _a.model;
    return React.createElement("div", { className: "shiphandling-note" },
        React.createElement("div", { className: "shiphandling-note-main-line" },
            React.createElement("div", { className: "shiphandling-note-left" },
                React.createElement("span", { className: "shiphandling-note-user-name" }, (_b = n.Noter()) === null || _b === void 0 ? void 0 : _b.FullName())),
            React.createElement("div", { className: "shiphandling-note-message" }, n.Message())),
        React.createElement("div", { className: "shiphandling-note-timestamp-line" },
            React.createElement(ShiphandlingNoteTimestamp, { note: n, model: m })));
});
var AttendingAgentView = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var m = _a.model;
    var agent = (_b = m.JobOrder.PortCall()) === null || _b === void 0 ? void 0 : _b.Agent();
    return agent ?
        React.createElement("div", { className: "details-section attending-agent" },
            React.createElement("div", { className: "agent-header details-section-header details-section-title" }, "Attending Agent"),
            React.createElement("div", { className: "agent-body details-section-body" },
                React.createElement("img", { className: "agent-profile-image", src: agent.Model.Image.ThumbUrl() }),
                ' ',
                React.createElement("span", { className: "agent-name pc-text-fixedwidth" }, agent.Model.FullName()),
                React.createElement("br", null),
                React.createElement("span", { className: "agent-organization-name pc-text-smalllabel pc-text-fixedwidth" }, (_c = agent.Model.Organization()) === null || _c === void 0 ? void 0 : _c.Name()),
                React.createElement("br", null),
                React.createElement("span", { className: "agent-phone-number pc-text-fixedwidth" }, (_d = agent.MainNumber()) === null || _d === void 0 ? void 0 : _d.Number()))) :
        null;
});
var PilotageChargesFrontView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return !m.Model.CanManageBills() ? null :
        React.createElement("div", { className: "details-section pilotage-charges-front" },
            React.createElement("div", { className: "details-section-header" },
                React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-more", onClick: eventWrappers_1.noDefault(function () { return m.FlipToBack(3 /* PilotageCharges */); }) }),
                React.createElement("span", { className: "details-section-title" }, "Pilotage Charges")),
            React.createElement("div", { className: "details-section-body pilotage-charges-watermark" }, m.JobOrder.Model.Bills().length > 0 ? 'Exported' :
                m.JobOrder.Model.ApprovalOfCharges() !== null ? 'Approved' :
                    'Draft'));
});
var MovementRemarks = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "details-section details-section-narrow pjo-mvmt-remarks" },
        React.createElement("div", { className: "details-section-header" },
            m.JobOrder.Model.Remarks() &&
                React.createElement("a", { href: "", className: "details-section-header-side-item", onClick: eventWrappers_1.noDefault(m.JobOrder.ToggleRemarksVisible) }, m.JobOrder.EffectiveUserPreferences.RemarksVisible() ? 'Hide' : 'Show'),
            React.createElement("span", { className: "details-section-title" }, "Movement Remarks")),
        React.createElement("div", { className: "details-section-body pjo-mvmt-remarks-body" },
            React.createElement("textarea", { className: "pjo-mvmt-remarks-content", placeholder: "Enter remarks ...", value: m.JobOrder.Model.Remarks() || '', onChange: function (e) { return m.JobOrder.Model.Remarks(e.currentTarget.value); }, 
                // Can edit remarks even for CNX PJOs
                disabled: !m.Model.CanEdit() })));
});
var DetailsBackContent = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('face back', { flipped: m.Flipped() }) },
        React.createElement(MovementLog, { model: m }),
        React.createElement(ShiphandlingNotesFlipView, { model: m }),
        React.createElement(VesselFlipView, { model: m }),
        React.createElement(pilotagechargesview_1.PilotageChargesView, { model: m.PilotageCharges, backPage: m.BackPage, flipToFront: function () { return m.Flipped(false); } }));
});
var MovementLog = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.BackPage() === 0 /* Log */ ?
        React.createElement("div", { className: "mvmt-log" },
            React.createElement("div", { className: "flip-back-link-container" },
                React.createElement("a", { href: "", className: "flip-icon icon-flip-to-main", onClick: eventWrappers_1.noDefault(function () { return m.Flipped(false); }) })),
            React.createElement(view_12.PilotJobOrderLogView, { model: m.Log })) : null;
});
var ShiphandlingNotesFlipView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.BackPage() === 1 /* ShiphandlingNotes */ ?
        React.createElement("div", { className: "shiphandling-notes-full" },
            React.createElement("div", { className: "details-section-header" },
                React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-main", onClick: eventWrappers_1.noDefault(function () { return m.Flipped(false); }) }),
                React.createElement("span", { className: "details-section-title" }, "Pilot Shiphandling Notes")),
            React.createElement(ShiphandlingNotesFlipBody, { model: m })) : null;
});
var ShiphandlingNotesFlipBody = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "shiphandling-notes-full-body" },
        React.createElement(AddNoteView, { model: m }),
        React.createElement("div", null, (_b = m.JobOrder.EffectiveVessel()) === null || _b === void 0 ? void 0 : _b.PilotShiphandlingNotes().map(function (n) {
            return React.createElement(ShiphandlingNotesFlipItem, { note: n, model: m, key: n.Id() });
        })));
});
var AddNoteView = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    // Can add shiphandling notes, even for CNX PJOs. Note that remarks are added to whichever
    // vessel was selected at time of cancellation.
    if (!m.Model.CanAddShiphandlingNote())
        return null;
    var v = m.JobOrder.EffectiveVessel();
    return v &&
        React.createElement("form", { className: "shiphandling-note draft-note" },
            React.createElement("img", { className: "shiphandling-note-profile-img", src: (_b = m.User()) === null || _b === void 0 ? void 0 : _b.Image.ThumbUrl() }),
            React.createElement("input", { className: "draft-note-input", placeholder: "Add Pilot Note", value: (_c = v.DraftNote().Message()) !== null && _c !== void 0 ? _c : '', onChange: function (e) { return v.DraftNote().Message(e.currentTarget.value); } }),
            React.createElement("button", { className: "pc-button draft-note-button", onClick: eventWrappers_1.noDefault(v.AddShiphandlingNote) }, "Add"));
});
var ShiphandlingNotesFlipItem = supercritical_1.default(function (_a) {
    var _b, _c;
    var n = _a.note, m = _a.model;
    return React.createElement("div", { className: "shiphandling-note" },
        React.createElement("div", { className: "shiphandling-note-left" },
            React.createElement("img", { className: "shiphandling-note-profile-img", src: (_b = n.Noter()) === null || _b === void 0 ? void 0 : _b.Image.ThumbUrl() }),
            React.createElement("span", { className: "shiphandling-note-user-name" }, (_c = n.Noter()) === null || _c === void 0 ? void 0 : _c.AbbreviatedName())),
        React.createElement("div", { className: "shiphandling-note-message" },
            React.createElement("span", null, n.Message()),
            React.createElement(ShiphandlingNoteTimestamp, { note: n, model: m })));
});
var ShiphandlingNoteTimestamp = supercritical_1.default(function (_a) {
    var n = _a.note, m = _a.model;
    /* TH: NOTE: In theory, Shiphandling Notes might come from other Domains.
        Currently, not displaying any timezone info in timestamp tooltip or converting to user's Domain's timezone.
        May wanna do one or the other if we ever have an installation w/ multiple Domains. */
    return n.Event() &&
        React.createElement(view_14.TimeAgoTooltip, { className: "shiphandling-note-timestamp pc-text-smalllabel pc-text-fixedwidth-tooltip", date: n.Event().Date, now: m.Clock.now });
});
var VesselFlipView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.BackPage() === 2 /* Vessel */ ?
        React.createElement("div", { className: "vessel-flip" },
            React.createElement("div", { className: "vessel-flip-content" },
                React.createElement(BowThrusterFullView, { model: m }))) : null;
});
var BowThrusterFullView = supercritical_1.default(function (_a) {
    var m = _a.model;
    // Only show if user has permissions to edit BowThruster fields, but show even for CNX PJOs
    return m.Model.CanEditVessel() ?
        React.createElement("div", { className: "bow-thruster-full" },
            React.createElement("div", { className: "details-section-header" },
                React.createElement("a", { href: "", className: "details-section-header-side-item flip-icon icon-flip-to-main", onClick: eventWrappers_1.noDefault(function () { return m.Flipped(false); }) }),
                React.createElement("span", { className: "details-section-title" }, "Bow Thruster")),
            React.createElement(BowThrusterFullBody, { model: m })) : null;
});
var BowThrusterFullBody = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var b = (_b = m.JobOrder.EffectiveVessel()) === null || _b === void 0 ? void 0 : _b.BowThruster;
    return b ?
        React.createElement("div", { className: "details-section-body" },
            React.createElement("div", { className: "bow-thruster-row" },
                React.createElement("span", { className: "bow-thruster-label pc-text-label-color" }, "Present"),
                React.createElement(YesNoUnknownSelector, { value: b.Raw.Present, model: m })),
            b.Raw.Present() &&
                React.createElement("div", null,
                    React.createElement("div", { className: "bow-thruster-row" },
                        React.createElement("span", { className: "bow-thruster-label pc-text-label-color" }, "Size"),
                        React.createElement("span", null,
                            React.createElement(view_9.NullableNumericInput, { className: "numeric-input bow-thruster-size", value: b.Raw.Size.UOM() === UOM_1.default.Horsepower ? b.SizeInHorsepower.Num : b.SizeInKilowatts.Num, onBlur: b.OnSizeBlur }))),
                    React.createElement("div", { className: "bow-thruster-row" },
                        React.createElement("span", { className: "bow-thruster-label pc-text-label-color" }, "UoM"),
                        React.createElement("span", null,
                            React.createElement("select", { className: "pc-select pjo-select", value: b.Raw.Size.UOM() || '', onChange: function (e) { return b.Raw.Size.UOM(e.currentTarget.value); } },
                                React.createElement("option", { value: UOM_1.default.Horsepower }, UOM_1.default.Horsepower),
                                React.createElement("option", { value: UOM_1.default.Kilowatt }, UOM_1.default.Kilowatt)),
                            React.createElement("span", { className: "pc-select-chevron" }))))) :
        null;
});
var NextLastPortOfCall = supercritical_1.default(function (_a) {
    var m = _a.model;
    var pc = m.JobOrder.PortCall();
    return (React.createElement("div", { className: "ports-of-call" },
        React.createElement("div", { className: "details-section-body" },
            React.createElement("div", { className: "last-port-of-call" },
                React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Next"),
                pc &&
                    React.createElement("input", { type: "text", placeholder: "Port of Call", value: pc.Model.NextPortOfCall() || '', onChange: function (e) { return pc.Model.NextPortOfCall(e.currentTarget.value); }, disabled: !m.Model.CanEditPortCall() || !!m.JobOrder.Model.Cancellation() })),
            React.createElement("div", { className: "next-port-of-call" },
                React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Last"),
                pc &&
                    React.createElement("input", { type: "text", placeholder: "Port of Call", value: pc.Model.LastPortOfCall() || '', onChange: function (e) { return pc.Model.LastPortOfCall(e.currentTarget.value); }, disabled: !m.Model.CanEditPortCall() || !!m.JobOrder.Model.Cancellation() })))));
});
var YesNoUnknownSelector = supercritical_1.default(function (_a) {
    var value = _a.value, m = _a.model, className = _a.className;
    return React.createElement("span", null,
        React.createElement("select", { className: cx('pc-select pjo-select', className), value: boolToNum(value()), onChange: function (e) { return value(numToBool(+e.currentTarget.value)); } }, m.YesNoUnknown.map(function (_a) {
            var name = _a.name, value = _a.value;
            return React.createElement("option", { value: boolToNum(value), key: boolToNum(value) }, name);
        })),
        React.createElement("span", { className: "pc-select-chevron" }));
});
function boolToNum(val) {
    return val === null ? 0 : val ? 1 : -1;
}
function numToBool(num) {
    return num === 0 ? null : num > 0;
}
var CancellationRemarksPromptView = supercritical_1.default(function (_a) {
    var _b;
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement(view_11.PCModal, { shown: function () { return !!m; }, className: "pilotjoborderdetails-cancellation-remarks-prompt", onBackDropClick: m === null || m === void 0 ? void 0 : m.QuitChanges },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "modal-body" },
                React.createElement("h2", { className: "modal-title" }, "Cancel Pilot Order"),
                React.createElement("div", null, "Are you sure you want to cancel this pilot order?"),
                m &&
                    React.createElement("div", null,
                        React.createElement("div", { className: "remarks-shell" },
                            React.createElement("textarea", { className: "remarks", value: (_b = m.Remarks()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.Remarks(e.currentTarget.value || null); }, placeholder: "These remarks will be added to the log.", rows: 3 })),
                        React.createElement("div", { className: "actions" },
                            React.createElement("button", { className: "close pc-modal-close close-btn", onClick: m.QuitChanges }, "Close"),
                            React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(m.CancelPJO) }, "Cancel")))))));
});
var AbortRemarksPromptView = supercritical_1.default(function (_a) {
    var _b;
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement(view_11.PCModal, { shown: function () { return !!m; }, className: "pilotjoborderdetails-cancellation-remarks-prompt", onBackDropClick: m === null || m === void 0 ? void 0 : m.QuitChanges },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "modal-body" },
                React.createElement("h2", { className: "modal-title" }, "Abort Pilot Order"),
                React.createElement("div", null, "Are you sure you want to abort this pilot order?"),
                m &&
                    React.createElement("div", null,
                        React.createElement("div", { className: "remarks-shell" },
                            React.createElement("textarea", { className: "remarks", value: (_b = m.Remarks()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.Remarks(e.currentTarget.value || null); }, placeholder: "These remarks will be added to the log.", rows: 3 })),
                        React.createElement("div", { className: "actions" },
                            React.createElement("button", { className: "close pc-modal-close close-btn", onClick: m.QuitChanges }, "Close"),
                            React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(m.AbortPJO) }, "Abort")))))));
});
var CancelWholePortCallPromptView = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return (React.createElement(view_11.PCModal, { shown: function () { return !!m; }, className: "pilotjoborderdetails-cancel-whole-portcall-prompt" },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("h2", { className: "prompt-title" }, "One Last Thing"),
            (m === null || m === void 0 ? void 0 : m.Status()) === 0 /* Prompting */ ||
                (m === null || m === void 0 ? void 0 : m.Status()) === 1 /* Cancelling */ ?
                React.createElement(CancelWholePortCallPromptingView, { model: m }) :
                (m === null || m === void 0 ? void 0 : m.Status()) === 2 /* CancellationSucceeded */ ?
                    React.createElement(CancelWholePortCallSucceededView, { model: m }) :
                    (m === null || m === void 0 ? void 0 : m.Status()) === 3 /* CancellationFailed */ ?
                        React.createElement(CancelWholePortCallFailedView, { model: m }) :
                        null,
            React.createElement(view_1.ActionLoadingIndicator, { loading: function () { return (m === null || m === void 0 ? void 0 : m.Status()) === 1 /* Cancelling */; } }))));
});
var CancelWholePortCallPromptingView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "prompting" },
        React.createElement("div", null,
            "You just cancelled the last pilot order for this PortCall.",
            React.createElement("br", null),
            "Would you like to..."),
        React.createElement("div", { className: "controls" },
            React.createElement("div", { className: "cancellation-option" },
                React.createElement("div", null,
                    React.createElement("button", { className: "pc-button", onClick: m.HidePrompt }, "Cancel Pilot Only")),
                React.createElement("div", { className: "option-explanation" }, "The ship is still coming here but does not require a pilot.")),
            React.createElement("div", { className: "cancellation-option" },
                React.createElement("div", null,
                    React.createElement("button", { className: "pc-button", onClick: m.CancelWholePortCall }, "Cancel PortCall")),
                React.createElement("div", { className: "option-explanation" }, "The ship is not coming."))));
});
var CancelWholePortCallSucceededView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "succeeded" },
        React.createElement("div", null, "The PortCall was cancelled successfully."),
        React.createElement("div", { className: "controls" },
            React.createElement("button", { className: "pc-button", onClick: m.HidePrompt }, "OK")));
});
var CancelWholePortCallFailedView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "failed" },
        React.createElement("div", null,
            "An unexpected error occurred while cancelling the PortCall. Please try cancelling the PortCall from the",
            ' ',
            React.createElement("a", { href: m.PortCallProfileHref() }, "PortCall profile"),
            ". Details:"),
        React.createElement("div", { className: "exception-details" }, m.ExceptionDetails()),
        React.createElement("div", { className: "controls" },
            React.createElement("button", { className: "pc-button", onClick: m.HidePrompt }, "OK")));
});
// TH 07/10/2017 -- These are popups that are part of the PJO Details popup but can't live
// inside of the PJO Details DOM b/c of "position: fixed" issues.
// So we'll instead instantiate this view from higher up in the DispatchDashboard DOM.
exports.PilotJobOrderDetailsPopupViews = supercritical_1.default(function (_a) {
    var modelContainer = _a.modelContainer;
    var m = modelContainer();
    return m &&
        React.createElement("div", null,
            React.createElement(view_3.EditMovementEndPopupView, { model: m.JobOrder.EditMovementEndPopup }),
            React.createElement(view_2.AddShiftPopupView, { modelContainer: m.JobOrder.AddShiftPopup }),
            React.createElement(view_4.DateTimeEditPopupView, { modelContainer: m.JobOrder.DateTimeEditPopup, localization: m.Localization }),
            React.createElement(view_4.DateTimeEditPopupView, { title: "Log Actual Time", modelContainer: m.JobOrder.LogActualTimePopup, localization: m.Localization }),
            React.createElement(view_4.NullableDateTimeEditPopupView, { modelContainer: m.JobOrder.NullableDateTimeEditPopup, localization: m.Localization }),
            React.createElement(originalpilotorderview_1.OriginalPilotOrderView, { model: m.OriginalPilotOrder }),
            React.createElement(CancellationRemarksPromptView, { modelContainer: m.JobOrder.CancellationRemarksPrompt }),
            React.createElement(AbortRemarksPromptView, { modelContainer: m.JobOrder.AbortRemarksPrompt }),
            React.createElement(CancelWholePortCallPromptView, { modelContainer: m.JobOrder.CancelWholePortCallPrompt }),
            React.createElement(view_5.ErrorModal, { errors: m.AgentRestrictions, shown: m.ShowAgentRestrictions, title: "There are issues with your Pilot Order" }));
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderLogUpdater = void 0;
var LOG_REFRESH_SECONDS = 20, LOG_REFRESH_BACKWARDS_MINS = 10;
function PilotJobOrderLogUpdater(entrypoints, data, logUpdaterModel, _a) {
    var pjo = _a.pjo;
    return logUpdaterModel({
        collection: data.PilotJobOrderRelevances,
        url: function (_a) {
            var NeedSince = _a.NeedSince;
            return entrypoints.PilotJobOrderLog({ Id: pjo.Id(), NeedSince: NeedSince });
        },
        refreshSeconds: LOG_REFRESH_SECONDS,
        refreshBackwardsMins: LOG_REFRESH_BACKWARDS_MINS
    });
}
exports.PilotJobOrderLogUpdater = PilotJobOrderLogUpdater;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderLog = void 0;
function PilotJobOrderLog(newCommentModel, eventLogModel, _a) {
    var pjo = _a.pjo;
    var EventLog = eventLogModel({
        log: pjo.Log,
        // TH: TODO: Permissions? On PCProfile it was safe to assume that anyone who can
        // view the page can comment on the log. Is that still true for PJO details?
        canComment: function () { return true; }
    }), NewComment = newCommentModel({
        url: function () { var _a, _b; return (_b = (_a = pjo.Self()) === null || _a === void 0 ? void 0 : _a.CommentsUrl()) !== null && _b !== void 0 ? _b : ''; }
    });
    return { EventLog: EventLog, NewComment: NewComment };
}
exports.PilotJobOrderLog = PilotJobOrderLog;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderLogView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var newcommentview_1 = __webpack_require__(194);
var view_1 = __webpack_require__(268);
exports.PilotJobOrderLogView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "pc-card" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Log"),
            React.createElement(newcommentview_1.NewCommentView, { model: m.NewComment, topLevel: true, allowTaggingUsers: false })),
        React.createElement(view_1.EventLogView, { model: m.EventLog, allowTaggingUsers: false }));
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotSettingsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1003);
var view_2 = __webpack_require__(12);
function PilotSettingsRoute(appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.PilotSettingsView, { id: +(request.params['id'] || 0) }))
    };
}
exports.PilotSettingsRoute = PilotSettingsRoute;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotSettingsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.PilotSettingsView = supercritical_1.default(function (_a) {
    var id = _a.id;
    return React.createElement("div", { className: "pilotsettings pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "#!morepage" }, "<< Back to More")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Pilot Settings")),
        React.createElement("div", { className: "page-body pc-card" },
            React.createElement("div", { className: "managelookups-setting" },
                React.createElement("div", { className: "setting-link" },
                    React.createElement("a", { href: '#!managepilotlookups?id=' + id }, "Manage Lookups")),
                React.createElement("div", { className: "setting-description pc-text-smalllabel" }, "Manage lookup lists for pilots, agencies, tugs, and pier-side. Set codes or nicknames for pilots and agencies."))));
});


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsNavbarCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PilotsNavbar_1 = __webpack_require__(1322);
var PilotsNavbarCache = /** @class */ (function (_super) {
    __extends(PilotsNavbarCache, _super);
    function PilotsNavbarCache() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PilotsNavbars = PCCache_1.PCCollection(PilotsNavbar_1.PilotsNavbar);
        return _this;
    }
    return PilotsNavbarCache;
}(DataCache_1.DataCache));
exports.PilotsNavbarCache = PilotsNavbarCache;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RotationDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var RotationDashboard_1 = __webpack_require__(1345);
var RotationDashboardCache = /** @class */ (function (_super) {
    __extends(RotationDashboardCache, _super);
    function RotationDashboardCache(data, navbarCache) {
        var _this = _super.call(this) || this;
        _this.RotationDashboards = PCCache_1.PCCollection(RotationDashboard_1.RotationDashboard);
        new DataCache_1.SharedKeyRelationship(_this.RotationDashboards, data.PilotAgencies, function (d) { return d.PilotAgency; }, null);
        new DataCache_1.QueryResultsRelationship(_this.RotationDashboards, data.Pilots, function (d) { return d.Pilots; });
        new DataCache_1.ForeignKeyRelationship(navbarCache.PilotsNavbars, _this.RotationDashboards, null, function (d) { return d.Navbar; }, function (d) { return d.Id(); });
        return _this;
    }
    return RotationDashboardCache;
}(DataCache_1.DataCache));
exports.RotationDashboardCache = RotationDashboardCache;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RotationDashboard = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var nonuniqueIndex_1 = __webpack_require__(117);
function RotationDashboard(ajax, loader, entrypoints, data, personProfilePopupModel, _a) {
    var id = _a.id, mode = _a.mode;
    var model = loader({
        Id: id,
        // TH 10/20/2017 -- Seed navbar too, so it can load w/ deault values as soon as possible
        Navbar: { Id: id }
    }, 30).model, pageMode = s_js_1.default.data(mode), editingSection = s_js_1.default.data(null), editSectionModal = s_js_1.default(function () { return editingSection() ? EditSectionViewModel(editingSection(), ajax, data, function () { return editingSection(null); }) : null; }), 
    // Either holds a delete fn that returns a promise or else null
    deletingSection = s_js_1.default.data(null), deleteSectionModal = s_js_1.default(function () { return deletingSection() ? DeleteSectionViewModel(deletingSection(), function () { return deletingSection(null); }) : null; }), pilots = model.Pilots.map(function (p) { return PilotViewModel(p, ajax, personProfilePopupModel); }), pilotsBySection = nonuniqueIndex_1.default(pilots, function (p) { return p.Model.SectionId() || 0; }), sections = s_array_1.lift(function () { return model.PilotAgency() ? model.PilotAgency().Sections() : []; })
        .map(function (s) { return PilotSectionViewModel(s, ajax, entrypoints, data, function (sectionId) { return PilotGroupingViewModel(sectionId, pilotsBySection); }, editingSection, deletingSection); })
        .sort(function (p1, p2) { return p1.Model.Order() - p2.Model.Order(); }), addSectionClient = ajax.Url(function () { return model.PilotAgency() && model.PilotAgency().SectionsUrl() || ''; });
    return {
        Model: model,
        PageMode: pageMode,
        Sections: sections,
        OnSortSections: OnSortSections,
        UnassignedPilots: PilotGroupingViewModel(null, pilotsBySection),
        ShowAddSection: function () { return !!model.PilotAgency() && pageMode() === 2 /* ManageSections */; },
        AddSection: AddSection,
        EditSectionModal: editSectionModal,
        DeleteSectionModal: deleteSectionModal
    };
    function AddSection() {
        var pilotAgency = model.PilotAgency();
        if (!pilotAgency)
            return;
        var nextSectionOrder = pilotAgency.Sections().length ?
            Math.max.apply(Math, pilotAgency.Sections().map(function (s) { return s.Order(); })) + 1 : 0, req = addSectionClient.Post({
            Id: 0,
            Name: 'New Section',
            Order: nextSectionOrder
        });
        req.then(function (json) { return data.PilotSections.update1(req.Date, json); });
    }
}
exports.RotationDashboard = RotationDashboard;
function OnSortSections(section, sections) {
    s_js_1.default.freeze(function () { return sections.forEach(SetItemOrder); });
}
function SetPilotSortOrder(sectionId, pilot, targetPilots, sourcePilots) {
    s_js_1.default.freeze(function () {
        pilot.Model.SectionId(sectionId);
        targetPilots.forEach(SetItemOrder);
        sourcePilots && sourcePilots.forEach(SetItemOrder);
    });
}
function SetItemOrder(item, order) {
    item.Model.Order(order);
}
// ViewModel properties that apply to PilotSection entity or the unassigned pilots area
function PilotGroupingViewModel(sectionId, pilotsBySection) {
    var pilots = pilotsBySection(sectionId || 0)
        .sort(function (p1, p2) { return p1.Model.Order() - p2.Model.Order(); });
    return {
        Pilots: pilots,
        OnSortPilots: function (pilot, targetPilots, sourcePilots) { return SetPilotSortOrder(sectionId, pilot, targetPilots, sourcePilots); }
    };
}
// ViewModel for an actual PilotSection entity
function PilotSectionViewModel(pilotSection, ajax, entrypoints, data, groupingModel, editingSection, deletingSection) {
    var client = ajax.Url(function () { return pilotSection.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(pilotSection, client), deleteClient = ajax.Url(function () { return entrypoints.DeletePilotSection({ Id: pilotSection.Id() }); }), groupingVM = groupingModel(s_js_1.default.sample(pilotSection.Id));
    return Object.assign(groupingVM, {
        Model: draft,
        ShowEditName: ShowEditName,
        ShowDeleteSection: ShowDeleteSection
    });
    function ShowEditName() {
        editingSection(pilotSection);
    }
    function ShowDeleteSection() {
        deletingSection(Delete);
    }
    function Delete() {
        var req = deleteClient.Post({}), id = pilotSection.Id();
        return req.then(function (json) { return s_js_1.default.freeze(function () {
            var ts = req.Date;
            data.PilotSections.update(ts, [], [id]);
            data.Pilots.update(ts, json, []);
        }); });
    }
}
function PilotViewModel(pilot, ajax, personProfilePopupModel) {
    var client = ajax.Url(function () { return pilot.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(pilot, client), displayName = function () { var _a, _b; return (_b = (_a = pilot.User()) === null || _a === void 0 ? void 0 : _a.AbbreviatedName()) !== null && _b !== void 0 ? _b : ''; }, showProfile = s_js_1.default.data(false), personProfilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({ id: pilot.Id(), onHidePopup: function () { return showProfile(false); } }) : null; });
    return {
        Model: draft,
        DisplayName: displayName,
        PersonProfilePopup: personProfilePopup,
        ToggleProfile: function () { return showProfile(!showProfile()); }
    };
}
function EditSectionViewModel(pilotSection, ajax, data, onHidePopup) {
    var draft = draftSignals_1.DraftObject(pilotSection).object, client = ajax.Url(function () { return pilotSection.Url() || ''; }), validation = validationWatcher_1.ValidationWatcher(client), loading = s_js_1.default.data(false);
    return {
        Model: draft,
        SaveChanges: SaveChanges,
        Cancel: onHidePopup,
        Validation: validation,
        Loading: loading
    };
    function SaveChanges() {
        if (loading() || draft.Name() === pilotSection.Name())
            return;
        loading(true);
        var req = client.Put(draft);
        req.then(function (json) { return s_js_1.default.freeze(function () {
            data.PilotSections.update1(req.Date, json);
            onHidePopup();
        }); }).finally(function () { return loading(false); });
    }
}
function DeleteSectionViewModel(deleteSection, onHidePopup) {
    var loading = s_js_1.default.data(false);
    return {
        Loading: loading,
        Delete: Delete,
        Cancel: onHidePopup
    };
    function Delete() {
        if (loading())
            return;
        loading(true);
        deleteSection().then(onHidePopup).finally(function () { return loading(false); });
    }
}


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RotationDashboardRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var view_1 = __webpack_require__(1008);
var view_2 = __webpack_require__(12);
function RotationDashboardRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper, navbarTab: 2 /* Pilots */ },
            React.createElement(view_1.RotationDashboardView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.RotationDashboardRoute = RotationDashboardRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0),
        mode: request.params['mode'] ? +request.params['mode'] : 0 /* View */
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = '' + m.Model.Id();
    if (m.PageMode() !== 0 /* View */)
        params['mode'] = '' + m.PageMode();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RotationDashboardView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(22);
var view_3 = __webpack_require__(132);
var view_4 = __webpack_require__(78);
var view_5 = __webpack_require__(500);
var view_6 = __webpack_require__(29);
exports.RotationDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "rotationdashboard pc-page-fixedwidth" },
        m.Model.Navbar() &&
            React.createElement(view_5.PilotsHeaderView, { selectedTab: 3 /* Rotation */, title: "Rotation Dashboard", model: m.Model.Navbar() }),
        React.createElement(PageBody, { model: m }),
        React.createElement(EditSectionModal, { model: m }),
        React.createElement(DeleteSectionModal, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card page-body" },
        React.createElement(PageLeftSide, { model: m }),
        React.createElement(PageRightSide, { model: m }));
});
var PageLeftSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "left-side" },
        React.createElement(view_3.PCSortable, { className: "sections-in-agency", onSort: m.OnSortSections, items: m.Sections, rowFactory: function (s) {
                return React.createElement(PilotSectionView, { section: s, model: m, key: s.Model.Id() });
            }, disabled: function () { return m.PageMode() !== 2 /* ManageSections */; } }),
        React.createElement("div", { className: "add-section" }, m.ShowAddSection() &&
            React.createElement("a", { href: "", className: "add-section-link", onClick: eventWrappers_1.noDefault(m.AddSection) }, "+ Add Section")));
});
var PilotSectionView = supercritical_1.default(function (_a) {
    var s = _a.section, m = _a.model;
    return React.createElement("li", { className: cx({
            'cursor-auto': m.PageMode() !== 2 /* ManageSections */
        }) },
        React.createElement("div", { className: cx('section-header', {
                'space-headers': m.PageMode() === 2 /* ManageSections */
            }) }, m.PageMode() === 2 /* ManageSections */ ?
            React.createElement("span", null,
                React.createElement("a", { href: "", className: "delete-link", onClick: eventWrappers_1.noDefault(s.ShowDeleteSection) }, "Delete"),
                React.createElement("a", { href: "", className: "edit-name-link", onClick: eventWrappers_1.noDefault(s.ShowEditName) }, s.Model.Name())) :
            React.createElement("span", null, s.Model.Name())),
        m.PageMode() !== 2 /* ManageSections */ &&
            React.createElement(PilotsList, { group: s, model: m, className: "pilots-in-section" }));
});
var PageRightSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "right-side" },
        React.createElement("div", { className: "page-description pc-text-smalllabel" }, "This is a list of all the pilots in the system. Pilots will appear in this order throughout the system, such as on the Assignments page. Select a row to jump to that pilot's profile."),
        React.createElement(ActionsView, { model: m }),
        React.createElement("div", { className: "unassigned-pilots-area" },
            React.createElement("div", { className: "unassigned-pilots-header" }, "Unassigned Pilots"),
            React.createElement(PilotsList, { group: m.UnassignedPilots, model: m, className: "unassigned-pilots-list" })));
});
var ActionsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Model.CanEdit() ?
        React.createElement("div", { className: "pc-card actions-box" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Actions"),
            React.createElement(PageModeSelector, { model: m, pageMode: 1 /* SetRotationOrder */, linkText: "Set Rotation Order", 
                // NOTE: {'...'} gets compiled to a JS string as is, so escapes like \u201C are preserved and respected in the compiled output.
                // "..." gets treated as HTML in compilation, so escapes like \u201C get escaped AGAIN and shown to the user as literal strings.
                // So options are {'...'} with embedded JS escapes, or "..." with embedded HTML escapes. I prefer the JS escapes.
                // See https://reactjs.org/docs/jsx-in-depth.html#string-literals
                description: 'Drag pilots into sections. Order the pilots in the desired rotation (the \u201Cbatting order\u201D).' }),
            React.createElement(PageModeSelector, { model: m, pageMode: 2 /* ManageSections */, linkText: "Manage Sections", description: "Add, remove, edit, and reorder the sections on the left. Drag section headers to reorder." })) : null;
});
var PageModeSelector = supercritical_1.default(function (_a) {
    var m = _a.model, pageMode = _a.pageMode, linkText = _a.linkText, description = _a.description;
    var selected = m.PageMode() === pageMode;
    return (React.createElement("div", { className: cx('action', { 'selected': selected }) },
        selected &&
            React.createElement("a", { href: "", className: "done-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(0 /* View */); }) }, "Done"),
        React.createElement("a", { href: "", className: "main-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(pageMode); }) }, linkText),
        React.createElement("div", { className: "description pc-text-smalllabel" }, description)));
});
var PilotsList = supercritical_1.default(function (_a) {
    var g = _a.group, m = _a.model, className = _a.className;
    return React.createElement(view_3.PCSortable, { className: cx('connected-pilot-lists', className), onSort: g.OnSortPilots, items: g.Pilots, rowFactory: function (p) {
            return React.createElement(PilotView, { pilot: p, model: m, key: p.Model.Id() });
        }, disabled: function () { return m.PageMode() !== 1 /* SetRotationOrder */; }, connectWith: function () { return '.connected-pilot-lists'; } });
});
var PilotView = supercritical_1.default(function (_a) {
    var p = _a.pilot, m = _a.model;
    return React.createElement("li", { className: cx({
            'cursor-click': m.PageMode() !== 1 /* SetRotationOrder */
        }) },
        React.createElement("div", { className: "row-contents", onClick: m.PageMode() === 1 /* SetRotationOrder */ ? undefined : p.ToggleProfile }, p.DisplayName()),
        React.createElement(view_4.PersonProfilePopupView, { modelContainer: p.PersonProfilePopup }));
});
var EditSectionModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    var editSection = m.EditSectionModal();
    return (React.createElement(view_2.PCModal, { className: "editsection", shown: function () { return !!editSection; }, onBackDropClick: editSection === null || editSection === void 0 ? void 0 : editSection.Cancel },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "pc-card-header editsection-title" }, "Rename Section"),
            React.createElement(view_1.ActionLoadingIndicator, { loading: function () { return !!editSection && editSection.Loading(); } }),
            editSection &&
                React.createElement("form", { onSubmit: eventWrappers_1.noDefault(editSection.SaveChanges) },
                    React.createElement("div", { className: "editsection-body" },
                        React.createElement("div", { className: "edit-name" },
                            React.createElement("label", null, "Enter a new section name:"),
                            React.createElement("input", { className: "edit-name-input", value: editSection.Model.Name(), onChange: function (e) { return editSection.Model.Name(e.currentTarget.value); } })),
                        React.createElement(view_6.ValidationErrorView, { error: function () { return editSection.Validation()['Name']; } })),
                    React.createElement("div", { className: "editsection-footer" },
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(editSection.Cancel) }, "Cancel"),
                        React.createElement("span", { className: "pc-icon-bullet" }),
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(editSection.SaveChanges) }, "Change Name"))))));
});
var DeleteSectionModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    var deleteSection = m.DeleteSectionModal();
    return (React.createElement(view_2.PCModal, { className: "deletesection", shown: function () { return !!deleteSection; }, onBackDropClick: deleteSection === null || deleteSection === void 0 ? void 0 : deleteSection.Cancel },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" },
                React.createElement("h2", { className: "modal-title" }, "Delete Section"),
                React.createElement(view_1.ActionLoadingIndicator, { loading: function () { return !!deleteSection && deleteSection.Loading(); } }),
                React.createElement("div", null, "Are you sure you want to delete this section? Any pilots will be moved into the unassigned section."),
                deleteSection &&
                    React.createElement("div", { className: "action-btns" },
                        React.createElement("a", { className: "pc-cancel-link", onClick: eventWrappers_1.noDefault(deleteSection.Cancel) }, "Cancel"),
                        ' ',
                        React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(deleteSection.Delete) }, "Delete"))))));
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitation = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var Accounts_1 = __webpack_require__(199);
var UserSummary_1 = __webpack_require__(203);
var invitationerrors_1 = __webpack_require__(192);
function AcceptInvitation(ajax, entrypoints, user, loginModel, _a) {
    // This component sends two different requests:
    //   1) When component loads, posts to CheckInvitation endpoint. That way, if user
    //      is returning to a previously accepted invitation link, they get a nice
    //      message about already being registered, etc.
    //   2) If user passes CheckInvitation endpoint, then page displays registration
    //      form. When user submits that form, posts to AcceptInvitation endpoint.
    var invitationId = _a.invitationId, token = _a.token;
    var checkInvitationClient = ajax.Url(entrypoints.CheckInvitation), checkInvitationValidation = validationWatcher_1.ValidationWatcher(checkInvitationClient), checkInvitationRequest = checkInvitationClient.Post({
        InvitationId: invitationId,
        Token: token
    }), acceptInvitationClient = ajax.Url(entrypoints.AcceptInvitation), acceptInvitationValidation = validationWatcher_1.ValidationWatcher(acceptInvitationClient), acceptInvitation = new Accounts_1.AcceptInvitationRequest({
        InvitationId: invitationId,
        Token: token
    }), acceptInvitationRequest = s_js_1.default.data(null), showPasswordValidation = s_js_1.default.data(false), showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: true, onHidePopup: function () { return showLogin(false); } }) : null; });
    // if either request gets AlreadyActive error, update user object
    s_js_1.default(function () { return invitationerrors_1.HandleAlreadyActive(checkInvitationValidation(), user); });
    s_js_1.default(function () { return invitationerrors_1.HandleAlreadyActive(acceptInvitationValidation(), user); });
    return {
        CheckInvitationResponse: checkInvitationRequest.Response,
        CheckInvitationValidation: checkInvitationValidation,
        AcceptInvitation: acceptInvitation,
        AcceptInvitationResponse: function () { return acceptInvitationRequest() && acceptInvitationRequest().Response(); },
        AcceptInvitationValidation: acceptInvitationValidation,
        Submit: Submit,
        ShowLogin: showLogin,
        Login: login,
        User: user,
        ShowPasswordValidation: showPasswordValidation
    };
    function Submit() {
        var req = acceptInvitationClient.Post(acceptInvitation);
        acceptInvitationRequest(req);
        // update user object on successful registration
        req.then(function (userSummary) { return user(new UserSummary_1.UserSummary(userSummary)); });
    }
}
exports.AcceptInvitation = AcceptInvitation;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitationRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1011);
var view_2 = __webpack_require__(12);
function AcceptInvitationRoute(model, appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.AcceptInvitationView, { model: model(inboundParams(request)) }))
    };
}
exports.AcceptInvitationRoute = AcceptInvitationRoute;
function inboundParams(request) {
    return {
        invitationId: +(request.params['invitationId'] || 0),
        token: request.params['token'] || ''
    };
}


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitationView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var invitationerrors_1 = __webpack_require__(192);
var invitationerrorsview_1 = __webpack_require__(501);
var invitationlinks_1 = __webpack_require__(263);
var view_1 = __webpack_require__(130);
var view_2 = __webpack_require__(532);
var view_3 = __webpack_require__(29);
exports.AcceptInvitationView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "acceptinvitation pc-page-fixedwidth" },
        m.CheckInvitationResponse() ?
            m.CheckInvitationResponse().Success ?
                React.createElement(CheckInvitationSuccessView, { model: m }) :
                React.createElement(InvitationErrorsView, { model: m }) :
            null // TH: TODO -- <loadingindicator params="request: CheckInvitation" />
    ,
        React.createElement(view_1.LoginView, { modelContainer: m.Login }));
});
var CheckInvitationSuccessView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.AcceptInvitationResponse() && m.AcceptInvitationResponse().Success ?
        React.createElement(RegistrationSuccessView, { model: m }) :
        m.AcceptInvitationValidation()[invitationerrors_1.VALIDATION_TOKEN] ||
            m.AcceptInvitationValidation()[invitationerrors_1.VALIDATION_DEACTIVATED_ORG] ||
            m.AcceptInvitationValidation()[invitationerrors_1.VALIDATION_DEACTIVATED_USER] ||
            m.AcceptInvitationValidation()[invitationerrors_1.VALIDATION_ALREADY_ACTIVE] ?
            React.createElement(InvitationErrorsView, { model: m }) :
            React.createElement(AcceptInvitationForm, { model: m });
});
var AcceptInvitationForm = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("form", { className: "pc-card small-width" },
        React.createElement("h2", { className: "pc-card-header pc-card-title" }, "Complete registration"),
        React.createElement("div", { className: "registration-field" }, "Please enter the information below to complete your registration."),
        React.createElement(FirstNameView, { model: m }),
        React.createElement(LastNameView, { model: m }),
        React.createElement(PasswordInputView, { model: m }),
        React.createElement(ConfirmPasswordView, { model: m }),
        React.createElement("div", { className: "registration-button" },
            React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(m.Submit) }, "Complete")));
});
var FirstNameView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "registration-field" },
        React.createElement("input", { className: "form-control pc-input-box", placeholder: "First name", value: m.AcceptInvitation.FirstName(), onChange: function (e) { return m.AcceptInvitation.FirstName(e.currentTarget.value); }, autoFocus: true }),
        React.createElement(view_3.ValidationErrorView, { error: function () { return m.AcceptInvitationValidation()['FirstName']; } }));
});
var LastNameView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "registration-field" },
        React.createElement("input", { className: "form-control pc-input-box", placeholder: "Last name", value: m.AcceptInvitation.LastName(), onChange: function (e) { return m.AcceptInvitation.LastName(e.currentTarget.value); } }),
        React.createElement(view_3.ValidationErrorView, { error: function () { return m.AcceptInvitationValidation()['LastName']; } }));
});
var PasswordInputView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "registration-field" },
        React.createElement(view_2.PasswordEntry, { value: m.AcceptInvitation.Password, showValidation: m.ShowPasswordValidation, placeholder: "Password" }),
        React.createElement(view_3.ValidationErrorView, { error: function () { return m.AcceptInvitationValidation()['Password']; } }));
});
var ConfirmPasswordView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "registration-field" },
        React.createElement("input", { type: "password", className: "form-control pc-input-box", placeholder: "Confirm password", value: m.AcceptInvitation.ConfirmPassword() || '', onChange: function (e) { return m.AcceptInvitation.ConfirmPassword(e.currentTarget.value); } }),
        React.createElement(view_3.ValidationErrorView, { error: function () { return m.AcceptInvitationValidation()['ConfirmPassword']; } }));
});
var RegistrationSuccessView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card small-width" },
        React.createElement("div", { className: "result-description" }, "Congratulations! Your registration is complete."),
        React.createElement(invitationlinks_1.ProfileAndLandingPageLinks, { model: m }),
        React.createElement(TrainingLink, null));
});
var InvitationErrorsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card large-width" },
        React.createElement(invitationerrorsview_1.CommonInvitationErrorsView, { model: m, getError: function (key) { return m.AcceptInvitationValidation()[key] || m.CheckInvitationValidation()[key]; }, tokenErrorText: "If you've already created your account, try logging in." }),
        React.createElement(TrainingLink, null));
});
var TrainingLink = supercritical_1.default(function () {
    return React.createElement("div", { className: "link-shell" },
        React.createElement("a", { href: "http://portcall.com/training/", target: "_blank" }, "View the online training"));
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallBerthsTab = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
function AddPortCallBerthsTab(newReservationInPortOpsModel, _a) {
    var PortCall = _a.PortCall, ScheduleHeader = _a.ScheduleHeader;
    var Reservations = s_array_1.lift(function () { return PortCall.Reservations(); }), PortOps = Reservations
        .map(function (br) {
        var ops = newReservationInPortOpsModel({ Reservation: br });
        // If we don't have enough data to enter NEW cargo activities, then also clear any EXISTING
        // cargo activities. E.g. the user might've entered cargo activities and then gone back and
        // changed to a berth w/ no scheduling authority.
        s_js_1.default(function () { return !ops.HasRequiredCargoActivityLookups() && br.CargoActivities([]); });
        return ops;
    }), CanProceed = PortOps.every(function (ops) { return ops.IsValidForSave(); });
    // A wrinkle: Changing location can change the scheduling authority, which can invalidate existing
    // CargoActivities' reference list values. Rather than trying to morph values from one scheduling
    // authority's reference list into those from another, we'll say that we'll clear any column that
    // currently references an item that isn't from the current scheduling authority's lists.
    Reservations.map(function (br) {
        // Optimization: Use an S.value() for schedAuthId so that we only need to run through every
        // CargoActivity when the schedAuthId is actually changing, as opposed to on every location change.
        var schedAuthId = s_js_1.default.value(undefined);
        // DON'T coalesce undefined to null when setting schedAuthId. We wanna distinguish null (known berth
        // whose SchedulingAuthorityId is null) from undefined (unknown berth).
        s_js_1.default(function () { var _a, _b, _c; return schedAuthId((_c = (_b = (_a = br.Itinerary()) === null || _a === void 0 ? void 0 : _a.Location()) === null || _b === void 0 ? void 0 : _b.Berth()) === null || _c === void 0 ? void 0 : _c.SchedulingAuthorityId()); });
        br.CargoActivities.map(function (cargo) {
            watch(cargo.ActivityType, cargo.ActivityTypeId);
            watch(cargo.CargoCategory, cargo.CargoCategoryId);
            watch(cargo.TradeRoute, cargo.TradeRouteId);
            function watch(navProp, fkProp) {
                s_js_1.default(function () {
                    var refListItem = navProp();
                    if (refListItem
                        // We have a known berth...
                        && schedAuthId() !== undefined
                        // ...whose scheduling authority doesn't match this item's org.
                        && schedAuthId() !== refListItem.OrganizationId()) {
                        // Clear the corresponding FK property
                        fkProp(null);
                    }
                });
            }
        });
    });
    return {
        ScheduleHeader: ScheduleHeader,
        PortOps: PortOps,
        CanProceed: CanProceed
    };
}
exports.AddPortCallBerthsTab = AddPortCallBerthsTab;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallBerthsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(526);
var view_2 = __webpack_require__(88);
exports.AddPortCallBerthsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallberthstab" },
        React.createElement(view_2.PortCallScheduleHeaderView, { className: "schedule-header", model: m.ScheduleHeader }),
        m.PortOps().map(function (ops, i) {
            return React.createElement(view_1.InPortOpsView, { model: ops, includeChrome: true, includeInstructions: true, key: OpsKey(ops), tabIndex: i * 3, autoFocus: i == 0 ? true : false });
        }));
});
var nextOpsKey = 0;
var OPS_KEYS = new WeakMap();
function OpsKey(ops) {
    var id = OPS_KEYS.get(ops);
    if (id === undefined) {
        id = nextOpsKey++;
        OPS_KEYS.set(ops, id);
    }
    return id;
}


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallCoordinationsTab = void 0;
var s_js_1 = __webpack_require__(0);
function AddPortCallCoordinationsTab(data, schedDateCoordSelStorage, selectCoordinationsModel, _a) {
    var PortCall = _a.PortCall, ScheduleHeader = _a.ScheduleHeader;
    var SelectCoordinations = selectCoordinationsModel({
        PortCall: PortCall,
        SelectionStorage: schedDateCoordSelStorage({})
    }), CanProceed = function () { return SelectCoordinations.IsValidForSubmit(); }, HasActionableContent = function () { return SelectCoordinations.HasActionableContent(); };
    // Wire up some extra behaviors that go beyond what the SelectCoordinations component provides.
    PortCall.Schedule.map(function (sd) { return sd.CoordinationCards.map(function (ccard) {
        // Populate navigation properties for added C-Cards.
        ccard.ScheduleDate(sd);
        data.CoordinationCards.attach(ccard, [
            ccard.Coordination,
            ccard.Provider
        ]);
        // Remove the C-Card if it becomes obsolete (e.g. b/c of a change to the itinerary).
        s_js_1.default(function () {
            if (ccard.Coordination() && !ccard.Coordination().AppliesToScheduleDate(sd)) {
                sd.CoordinationCards.remove(ccard);
            }
        });
    }); });
    return {
        ScheduleHeader: ScheduleHeader,
        SelectCoordinations: SelectCoordinations,
        CanProceed: CanProceed,
        HasActionableContent: HasActionableContent
    };
}
exports.AddPortCallCoordinationsTab = AddPortCallCoordinationsTab;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallCoordinationsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(88);
var view_2 = __webpack_require__(546);
exports.AddPortCallCoordinationsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallcoordinationstab" },
        React.createElement(view_1.PortCallScheduleHeaderView, { className: "schedule-header", model: m.ScheduleHeader }),
        React.createElement(view_2.SelectCoordinationsView, { model: m.SelectCoordinations }));
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallPilotsTab = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var notNullish_1 = __webpack_require__(94);
var UOM_1 = __webpack_require__(25);
var zipMap_1 = __webpack_require__(301);
var PilotJobOrder_1 = __webpack_require__(160);
var model_1 = __webpack_require__(521);
function AddPortCallPilotsTab(data, domain, Localization, metroMapMilestoneModel, _a) {
    var PortCall = _a.PortCall, ScheduleHeader = _a.ScheduleHeader;
    var PilotAgencies = s_js_1.default(function () { return domain.Organizations().map(function (org) { return org.PilotAgency(); }).filter(notNullish_1.notNullish); }), IsTabAvailable = function () { var _a, _b; return ((_b = (_a = domain.Settings()) === null || _a === void 0 ? void 0 : _a.HasPilots()) !== null && _b !== void 0 ? _b : false) && PilotAgencies().length > 0; }, PilotWasRejected = s_js_1.default.value(false), IsPilotRequired = function (val) {
        if (val === undefined) {
            return IsTabAvailable() && !PilotWasRejected();
        }
        else {
            PilotWasRejected(!val);
            return val;
        }
    }, Template = s_js_1.default(function () {
        if (IsPilotRequired()) {
            var tmpl = new PilotJobOrder_1.PilotJobOrder({
                Id: 0,
                BillToAgent: true
            });
            data.PilotJobOrders.attach(tmpl, [tmpl.PilotAgency]);
            return tmpl;
        }
        else {
            return null;
        }
    }), MovementSeries = s_array_1.lift(function () { return PortCall.MovementSeries(); }), PilotJobOrders = s_array_1.lift(MovementSeries.reduce(function (pjos, pt) { return pjos.concat(pt.DeparturePilotJobOrders()); }, function () { return []; }))
        .map(function (pjo) { return PilotJobOrderViewModel(pjo, metroMapMilestoneModel); }), TugCompanies = s_array_1.lift(function () { var _a, _b, _c; return (_c = (_b = (_a = Template()) === null || _a === void 0 ? void 0 : _a.PilotAgency()) === null || _b === void 0 ? void 0 : _b.TugCompanies()) !== null && _c !== void 0 ? _c : []; })
        .filter(function (tug) { return tug.Active(); }), LineHandlers = s_array_1.lift(function () { var _a, _b, _c; return (_c = (_b = (_a = Template()) === null || _a === void 0 ? void 0 : _a.PilotAgency()) === null || _b === void 0 ? void 0 : _b.LineHandlingCompanies()) !== null && _c !== void 0 ? _c : []; })
        .filter(function (line) { return line.Active(); });
    // Construct PJOs
    s_js_1.default(function () {
        var tmpl = Template();
        if (!tmpl)
            return;
        zipMap_1.zipMap(MovementSeries, function () { return MovementSeries().slice(1); }, function (fromPt, toPt) { return s_js_1.default(function () {
            // No PJOs leaving the port-departure point
            if (fromPt.IsPortDeparture())
                return;
            var depthUOM = function () { var _a, _b, _c; return (_c = (_b = (_a = fromPt.PortCall()) === null || _a === void 0 ? void 0 : _a.Port()) === null || _b === void 0 ? void 0 : _b.PierDepthUOM()) !== null && _c !== void 0 ? _c : UOM_1.default.Foot; };
            // Make the PJO
            var pjo = new PilotJobOrder_1.PilotJobOrder({
                Id: 0,
                DeepDraft: { UOM: s_js_1.default.sample(depthUOM) },
                AirDraft: { UOM: s_js_1.default.sample(depthUOM) }
            });
            pjo.FromPoint(fromPt);
            fromPt.DeparturePilotJobOrders.push(pjo);
            s_js_1.default.cleanup(function () { return fromPt.DeparturePilotJobOrders.remove(pjo); });
            // Set ToPoint navigation prop
            s_js_1.default(function () { var _a; return pjo.ToPoint((_a = toPt()) !== null && _a !== void 0 ? _a : null); });
            // Set PJO Start/End times from from and to points
            s_js_1.default(function () { return pjo.Start.Estimated(fromPt.Departure.Estimated()); });
            s_js_1.default(function () { return toPt() && pjo.End.Estimated(toPt().Arrival.Estimated()); });
            // Set draft UOMs
            s_js_1.default.on(depthUOM, function () {
                if (depthUOM() !== pjo.AirDraft.UOM()) {
                    pjo.AirDraft.set(pjo.AirDraft.convert(depthUOM()));
                }
            });
            s_js_1.default.on(depthUOM, function () {
                if (depthUOM() !== pjo.DeepDraft.UOM()) {
                    pjo.DeepDraft.set(pjo.DeepDraft.convert(depthUOM()));
                }
            });
            // Set various other PJO attributes from the template
            s_js_1.default(function () { return pjo.PilotAgencyId(tmpl.PilotAgencyId()); });
            s_js_1.default(function () { return pjo.TugCompanyId(tmpl.TugCompanyId()); });
            s_js_1.default(function () { return pjo.NumberOfTugs(tmpl.NumberOfTugs()); });
            s_js_1.default(function () { return pjo.LineHandlingCompanyId(tmpl.LineHandlingCompanyId()); });
            // LaborStartTime applies to the first PJO only.
            s_js_1.default(function () { return pjo.LaborStartTime(fromPt.IsPortArrival() ? tmpl.LaborStartTime() : null); });
            s_js_1.default(function () { return pjo.BillToAgent(tmpl.BillToAgent()); });
            // NOTE: BillToAddress and Remarks are free text fields, so we MIGHT wanna introduce
            // some kind of debounce for both of those as a client-side performance optimization.
            // For now, assuming that the total number of PJOs for any given PortCall is likely
            // to remain small and that the performance impact of copying the full text to every
            // PJO on each keystroke will be insignificant.
            s_js_1.default(function () { return pjo.BillToAddress(tmpl.BillToAddress()); });
            s_js_1.default(function () { return pjo.Remarks(tmpl.Remarks()); });
        }); });
    });
    // Autofill a default value for the template PJO's BillToAddress.
    s_js_1.default(function () {
        var _a;
        var tmpl = Template();
        if (tmpl) {
            var org = (_a = PortCall.Agent()) === null || _a === void 0 ? void 0 : _a.Organization();
            if (org)
                tmpl.BillToAddress(defaultBillToAddress(org));
        }
    });
    // Default the template PJO's PilotAgencyId to the first pilot agency in the domain.
    // NOTE: For now, we're assuming that the Domain has at most one pilot agency, so this is the ONLY way by
    // which we'll be setting the template PJO's PilotAgencyId. If we wanna support multiple pilot agencies
    // someday, we'll need extra logic and/or UI to select the pilot agency, in which case we may or may not
    // want to default to the first pilot agency like this.
    s_js_1.default(function () {
        var tmpl = Template();
        if (tmpl && PilotAgencies().length > 0)
            tmpl.PilotAgencyId(PilotAgencies()[0].Id());
    });
    return {
        ScheduleHeader: ScheduleHeader,
        Localization: Localization,
        IsTabAvailable: IsTabAvailable,
        IsPilotRequired: IsPilotRequired,
        Template: Template,
        PilotJobOrders: PilotJobOrders,
        CanProceed: function () { return true; },
        TugCompanies: TugCompanies,
        LineHandlers: LineHandlers
    };
}
exports.AddPortCallPilotsTab = AddPortCallPilotsTab;
var DECIMAL_PLACES = { inches: 0, meters: 2 };
function PilotJobOrderViewModel(pjo, metroMapMilestoneModel) {
    var Milestone = s_js_1.default(function () {
        var _a, _b, _c;
        // ToPoint -> ArrivalEntity -> PreviousMilestoneDate to support cases where the FromPoint's
        // DepartureEntity isn't a milestone.
        var Date = (_c = (_b = (_a = pjo.ToPoint()) === null || _a === void 0 ? void 0 : _a.ArrivalEntity()) === null || _b === void 0 ? void 0 : _b.PreviousMilestoneDate()) !== null && _c !== void 0 ? _c : null;
        return Date && metroMapMilestoneModel({ Date: Date });
    }), DeepDraft = model_1.NullableFeetInchesMetersEdit({ backingMeasurement: pjo.DeepDraft, decimalPlaces: DECIMAL_PLACES }), AirDraft = model_1.NullableFeetInchesMetersEdit({ backingMeasurement: pjo.AirDraft, decimalPlaces: DECIMAL_PLACES });
    return {
        Model: pjo,
        Milestone: Milestone,
        DeepDraft: DeepDraft,
        AirDraft: AirDraft,
    };
}
function defaultBillToAddress(org) {
    var addr = org.PostalAddresses().length > 0 ? org.PostalAddresses()[0] : null;
    return [
        org.Name(),
        addr && "" + addr.Address() + (addr.AptSte() ? " " + addr.AptSte() : ''),
        addr && addr.City() + ", " + addr.StateProv() + " " + addr.PostalCode()
    ].filter(notNullish_1.notNullish).join('\n');
}


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallPilotsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(522);
var view_2 = __webpack_require__(195);
var view_3 = __webpack_require__(55);
var view_4 = __webpack_require__(88);
var view_5 = __webpack_require__(89);
var view_6 = __webpack_require__(60);
exports.AddPortCallPilotsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallpilotstab" },
        React.createElement(view_4.PortCallScheduleHeaderView, { className: "schedule-header", model: m.ScheduleHeader }),
        React.createElement(RequiresPilotSelector, { model: m }),
        React.createElement(PilotAgencySummary, { model: m }),
        React.createElement(PilotJobOrdersView, { model: m }),
        React.createElement(PilotageBilling, { model: m }),
        React.createElement(Remarks, { model: m }),
        React.createElement(Services, { model: m }));
});
var RequiresPilotSelector = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "requires-pilot" },
        React.createElement("span", { className: "requires-pilot-label" }, "Does this ship require a pilot?"),
        React.createElement(view_5.ToggleButton, { checked: m.IsPilotRequired, onLabel: "Yes", offLabel: "No" }));
});
var PilotAgencySummary = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var agency = (_b = m.Template()) === null || _b === void 0 ? void 0 : _b.PilotAgency();
    return agency ?
        React.createElement("div", { className: "pilot-agency-summary" }, (_c = agency.Organization()) === null || _c === void 0 ? void 0 :
            _c.Name(),
            ' ',
            "\u2014",
            ' ',
            "Pilot Orders: Additional Information") :
        null;
});
// Higher than currently needed to leave room for adding more.
var TAB_STOPS_PER_PJO = 12;
var PilotJobOrdersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pilot-job-orders" }, m.PilotJobOrders().map(function (pjo, i) {
        return React.createElement(PilotJobOrderView, { pjo: pjo, 
            // Add an extra PJO row's worth of tab stops in case we wanna have some before the first PJO.
            tabIndexStart: (i + 1) * TAB_STOPS_PER_PJO, key: PJOKey(pjo), autoFocus: i == 0 ? true : false });
    }));
});
var nextPJOKey = 0;
var PJO_KEYS = new WeakMap();
function PJOKey(pjo) {
    var id = PJO_KEYS.get(pjo);
    if (id === undefined) {
        id = nextPJOKey++;
        PJO_KEYS.set(pjo, id);
    }
    return id;
}
var PilotJobOrderView = supercritical_1.default(function (_a) {
    var pjo = _a.pjo, tabIndexStart = _a.tabIndexStart, autoFocus = _a.autoFocus;
    return React.createElement("div", { className: "pilot-job-order" },
        React.createElement(PilotJobOrderMilestone, { pjo: pjo }),
        React.createElement(PilotJobOrderDrafts, { pjo: pjo, tabIndexStart: tabIndexStart, autoFocus: autoFocus }));
});
var PilotJobOrderMilestone = supercritical_1.default(function (_a) {
    var pjo = _a.pjo;
    var m = pjo.Milestone();
    return m ?
        React.createElement(view_2.MilestoneView, { milestone: m, ctrl: { milestoneContent: function (m) { return React.createElement(PJOMilestoneContent, { milestone: m }); } } }) : null;
});
var PJOMilestoneContent = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", null,
        React.createElement(view_2.MilestoneHeaderRow, { milestone: m }),
        React.createElement(view_2.MilestoneScheduleDetailsRow, { milestone: m }));
});
var PilotJobOrderDrafts = supercritical_1.default(function (_a) {
    var pjo = _a.pjo, tabIndexStart = _a.tabIndexStart, autoFocus = _a.autoFocus;
    return React.createElement("div", { className: "pilots-tab-section drafts" },
        React.createElement("div", { className: "pilots-tab-section-header" },
            "Drafts - ",
            pjo.Milestone() && view_2.MovementTypeParticiple(pjo.Milestone())),
        React.createElement("div", { className: "pilots-tab-section-body" },
            React.createElement("div", { className: "drafts-row" },
                React.createElement("span", { className: "drafts-label pc-text-smalllabel" }, "Deep Draft"),
                ' ',
                React.createElement(view_1.FeetInchesMetersEditView, { model: pjo.DeepDraft, tabindex: { feet: tabIndexStart, inches: tabIndexStart + 1, meters: tabIndexStart + 2 }, autoFocus: autoFocus })),
            React.createElement("div", { className: "drafts-row" },
                React.createElement("span", { className: "drafts-label pc-text-smalllabel" }, "Air Draft"),
                ' ',
                React.createElement(view_1.FeetInchesMetersEditView, { model: pjo.AirDraft, tabindex: { feet: tabIndexStart + 3, inches: tabIndexStart + 4, meters: tabIndexStart + 5 } }))));
});
function FirstTabStopAfterPJOs(m) {
    // Add an extra PJO row's worth of tab stops in case we wanna have some before the first PJO.
    return (m.PilotJobOrders().length + 1) * TAB_STOPS_PER_PJO;
}
// Higher than currently needed to leave room for adding more.
var BILL_TO_AGENT_TAB_STOPS = 4, BILLING_TAB_STOPS = BILL_TO_AGENT_TAB_STOPS + 4;
var PilotageBilling = supercritical_1.default(function (_a) {
    var m = _a.model;
    var tmpl = m.Template();
    if (!tmpl)
        return null;
    var tabIndexStart = FirstTabStopAfterPJOs(m);
    return (React.createElement("div", { className: "pilots-tab-section billing-section" },
        React.createElement("div", { className: "pilots-tab-section-header" }, "Pilotage Billing"),
        React.createElement("div", { className: "pilots-tab-section-body" },
            React.createElement(BillToAgentSelector, { tmpl: tmpl, tabIndexStart: tabIndexStart }),
            React.createElement(BillingAddress, { tmpl: tmpl, tabIndex: tabIndexStart + BILL_TO_AGENT_TAB_STOPS }))));
});
var ENTER_KEY = 'Enter';
var BillToAgentSelector = supercritical_1.default(function (_a) {
    var tmpl = _a.tmpl, tabIndexStart = _a.tabIndexStart;
    return React.createElement("div", { className: "bill-to-agent" },
        React.createElement("div", { className: "pc-text-smalllabel" }, "Send invoice to:"),
        React.createElement("div", { className: "bill-to-option-shell" },
            React.createElement("label", { className: "pc-option", tabIndex: tabIndexStart, 
                // It seems there's no default keybinding for "click this focused label," at least not on Chrome.
                onKeyDown: function (e) { return e.key === ENTER_KEY && e.currentTarget.click(); } },
                React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: tmpl.BillToAgent(), onChange: function (e) { return tmpl.BillToAgent(e.currentTarget.checked); } }),
                React.createElement("span", { className: "pc-breaker-light" }),
                React.createElement("span", { className: "pc-option-label" }, "Agent"))),
        React.createElement("div", { className: "bill-to-option-shell" },
            React.createElement("label", { className: "pc-option", tabIndex: tabIndexStart + 1, onKeyDown: function (e) { return e.key === ENTER_KEY && e.currentTarget.click(); } },
                React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: !tmpl.BillToAgent(), onChange: function (e) { return tmpl.BillToAgent(!e.currentTarget.checked); } }),
                React.createElement("span", { className: "pc-breaker-light" }),
                React.createElement("span", { className: "pc-option-label" }, "Other"))));
});
var BillingAddress = supercritical_1.default(function (_a) {
    var _b;
    var tmpl = _a.tmpl, tabIndex = _a.tabIndex;
    return React.createElement("div", { className: "bill-to-address-shell" },
        React.createElement("div", { className: "bill-to-address-label pc-text-smalllabel" }, "Billing Address"),
        React.createElement("div", null,
            React.createElement("textarea", { className: "pilots-textarea", rows: 4, value: (_b = tmpl.BillToAddress()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return tmpl.BillToAddress(e.currentTarget.value || null); }, 
                // Auto-select on focus to make it easy to override the default billing address if desired
                onFocus: function (e) { return e.currentTarget.select(); }, tabIndex: tabIndex })));
});
// Higher than currently needed to leave room for adding more.
var REMARKS_TAB_STOPS = 4;
var Remarks = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var tmpl = m.Template();
    return tmpl ?
        React.createElement("div", { className: "pilots-tab-section remarks-section" },
            React.createElement("div", { className: "pilots-tab-section-header" }, "Remarks"),
            React.createElement("div", { className: "pilots-tab-section-body" },
                React.createElement("textarea", { className: "pilots-textarea", rows: 3, placeholder: "Enter remarks...", value: (_b = tmpl.Remarks()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return tmpl.Remarks(e.currentTarget.value || null); }, tabIndex: FirstTabStopAfterPJOs(m) + BILLING_TAB_STOPS }))) :
        null;
});
var Services = supercritical_1.default(function (_a) {
    var m = _a.model;
    var tmpl = m.Template();
    if (!tmpl)
        return null;
    var tabIndexStart = FirstTabStopAfterPJOs(m) + BILLING_TAB_STOPS + REMARKS_TAB_STOPS;
    return (React.createElement("div", { className: "pilots-tab-section services-section" },
        React.createElement("div", { className: "pilots-tab-section-header" }, "Services"),
        React.createElement("div", { className: "pilots-tab-section-body" },
            React.createElement("div", { className: "services-row" },
                React.createElement("span", { className: "services-label pc-text-smalllabel" }, "Tug"),
                React.createElement("span", null,
                    React.createElement("select", { className: "pc-select service-main-select pjo-select", value: tmpl.TugCompanyId() === null ? '' : '' + tmpl.TugCompanyId(), onChange: function (e) { return tmpl.TugCompanyId(e.currentTarget.value === '' ? null : +e.currentTarget.value); }, tabIndex: tabIndexStart },
                        React.createElement("option", { value: "", key: "" }, "--"),
                        m.TugCompanies().map(function (tug) {
                            return React.createElement("option", { value: tug.Id(), key: tug.Id() }, tug.Name());
                        })),
                    React.createElement("span", { className: "pc-select-chevron" }))),
            React.createElement("div", { className: "services-row" },
                React.createElement("span", { className: "services-label pc-text-smalllabel" }, "Tug #"),
                React.createElement(view_3.NumericInput, { className: "pilots-input tugs-input", value: tmpl.NumberOfTugs, tabindex: tabIndexStart + 1 })),
            React.createElement("div", { className: "services-row" },
                React.createElement("span", { className: "services-label pc-text-smalllabel" }, "Line"),
                React.createElement("span", null,
                    React.createElement("select", { className: "pc-select service-main-select pjo-select", value: tmpl.LineHandlingCompanyId() === null ? '' : '' + tmpl.LineHandlingCompanyId(), onChange: function (e) { return tmpl.LineHandlingCompanyId(e.currentTarget.value === '' ? null : +e.currentTarget.value); }, tabIndex: tabIndexStart + 2 },
                        React.createElement("option", { value: "", key: "" }, "--"),
                        m.LineHandlers().map(function (line) {
                            return React.createElement("option", { value: line.Id(), key: line.Id() }, line.Name());
                        })),
                    React.createElement("span", { className: "pc-select-chevron" }))),
            React.createElement("div", { className: "services-row" },
                React.createElement("span", { className: "services-label pc-text-smalllabel" }, "Labor"),
                React.createElement(view_6.NullableDateTimePicker, { value: tmpl.LaborStartTime, localization: m.Localization, tabindex: { date: tabIndexStart + 3, time: tabIndexStart + 4 } })))));
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallReviewTab = void 0;
var s_js_1 = __webpack_require__(0);
var jsonizeSignals_1 = __webpack_require__(600);
var requestQueue_1 = __webpack_require__(300);
var TZDate_1 = __webpack_require__(7);
var CoordinationCard_1 = __webpack_require__(109);
function AddPortCallReviewTab(ajax, entrypoints, domain, metroMapFrameworkModel, metroMapMilestoneModel, _a) {
    var PortCall = _a.PortCall, Request = _a.Request, ScheduleHeader = _a.ScheduleHeader, OnReviewTab = _a.OnReviewTab;
    var ccardModel = CoordinationCardViewModel, milestoneModel = function (params) { return ReviewTabMilestone(metroMapMilestoneModel, ccardModel, params); }, Framework = metroMapFrameworkModel({
        PortCall: PortCall,
        MilestoneConstructor: milestoneModel
    });
    var BatchRequest = s_js_1.default(function () { return Request.BatchRequest() && BatchRequestViewModel(ajax, entrypoints, domain, Request.BatchRequest(), PortCall, OnReviewTab); });
    var UpdatingPreview = function () { var _a; return !!((_a = BatchRequest()) === null || _a === void 0 ? void 0 : _a.UpdatingPreview()); };
    return {
        ScheduleHeader: ScheduleHeader,
        Framework: Framework,
        BatchRequest: BatchRequest,
        UpdatingPreview: UpdatingPreview,
        CanProceed: function () { return true; }
    };
}
exports.AddPortCallReviewTab = AddPortCallReviewTab;
function ReviewTabMilestone(metroMapMilestoneModel, ccardModel, params) {
    var Date = params.Date, metroMapMilestone = metroMapMilestoneModel(params), CoordinationCards = Date.CoordinationCards
        .map(ccardModel)
        .sort(function (ccard1, ccard2) { return CoordinationCard_1.CoordinationCard.DisplayOrder(ccard1.Model, ccard2.Model); });
    return __assign(__assign({}, metroMapMilestone), { CoordinationCards: CoordinationCards });
}
function CoordinationCardViewModel(ccard) {
    return { Model: ccard };
}
function BatchRequestViewModel(ajax, entrypoints, domain, batchReq, portcall, onReviewTab) {
    var _this = this;
    var StartDate = s_js_1.default(function () { var _a, _b; return (_b = (_a = portcall.Itinerary().find(function (pt) { return pt.IsPortArrival(); })) === null || _a === void 0 ? void 0 : _a.Arrival.Estimated()) !== null && _b !== void 0 ? _b : null; }), 
    // We'll delegate to the server to figure out the overall date range for the requested batch. Of
    // course, we COULD do this date logic client-side, but the server already has responsibility for
    // determining portcall start dates on final submission, and this way we keep all that date logic
    // server-side and minimize the risk that we determine one set of start dates during preview and a
    // DIFFERENT set of start dates on final submission.
    req = s_js_1.default(function () { return onReviewTab() && StartDate() ? {
        DomainId: domain.Id(),
        StartDate: StartDate().toJSON(),
        BatchRequest: JSON.parse(jsonizeSignals_1.jsonizeSignals(batchReq, [function (_) { return batchReq.Batch; }]))
    } : null; }), resp = s_js_1.default.value(null), client = ajax.Url(entrypoints.PreviewBatchDates), UpdatingPreview = s_js_1.default.value(false), reqQueue = new requestQueue_1.RequestQueue(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!req()) return [3 /*break*/, 4];
                    UpdatingPreview(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    _a = resp;
                    return [4 /*yield*/, client.Post(req())];
                case 2:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 4];
                case 3:
                    UpdatingPreview(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }), Preview = s_js_1.default(function () {
        if (!resp())
            return null;
        var dates = resp().PortCallStartDates.map(function (d) { return new TZDate_1.default(d); });
        var minDate = null;
        for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
            var date = dates_1[_i];
            if (minDate === null || +minDate > +date)
                minDate = date;
        }
        var maxDate = null;
        for (var _a = 0, dates_2 = dates; _a < dates_2.length; _a++) {
            var date = dates_2[_a];
            if (maxDate === null || +maxDate < +date)
                maxDate = date;
        }
        return {
            BatchSize: dates.length,
            FirstPortCallArrival: minDate,
            LastPortCallArrival: maxDate
        };
    });
    s_js_1.default(function () { return req() && reqQueue.enqueueRequest(); });
    return {
        Model: batchReq,
        StartDate: StartDate,
        UpdatingPreview: UpdatingPreview,
        Preview: Preview
    };
}


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallReviewTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var view_1 = __webpack_require__(195);
var view_2 = __webpack_require__(88);
var itineraryview_1 = __webpack_require__(503);
exports.AddPortCallReviewTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallreviewtab" },
        React.createElement(view_2.PortCallScheduleHeaderView, { className: "schedule-header", model: m.ScheduleHeader }),
        React.createElement(ScheduleView, { model: m }),
        React.createElement(RepetitionInfo, { model: m }));
});
var ScheduleView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "schedule" },
        React.createElement(view_1.MetroMapFrameworkView, { model: m.Framework, ctrl: { milestoneContent: function (m) { return React.createElement(MilestoneContent, { milestone: m }); } } }));
});
var MilestoneContent = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", null,
        React.createElement(view_1.MilestoneHeaderRow, { milestone: m }),
        React.createElement(view_1.MilestoneScheduleDetailsRow, { milestone: m }),
        React.createElement(MilestoneCoordinationsRow, { milestone: m }));
});
var MilestoneCoordinationsRow = supercritical_1.default(function (_a) {
    var m = _a.milestone;
    return React.createElement("div", { className: "portcall-milestone-row coordinations-row" },
        React.createElement("div", { className: "portcall-milestone-row-label" }, m.Date.IsBerthArrivalDate() && view_1.BerthStayDurationText(m)),
        React.createElement("div", { className: "portcall-milestone-row-body" },
            m.Date.IsBerthArrivalDate() && React.createElement(BerthAssignmentView, { milestone: m }),
            m.CoordinationCards().map(function (ccard) {
                return React.createElement(CCardView, { ccard: ccard, key: CCardKey(ccard) });
            })));
});
var BerthAssignmentView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.milestone;
    return React.createElement("div", { className: "coordination-card" },
        React.createElement("div", { className: "header" },
            React.createElement("span", { className: "coordination-title" }, "Berth Assignment")),
        React.createElement("div", { className: "pc-text-smalllabel description" }, ((_b = m.Date.ItineraryPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation()) &&
            view_2.InPortOpsSummaryText(m.Date.ItineraryPoint().BerthReservation())));
});
var nextCCardKey = 0;
var CCARD_KEYS = new WeakMap();
function CCardKey(ccard) {
    var id = CCARD_KEYS.get(ccard.Model);
    if (id === undefined) {
        id = nextCCardKey++;
        CCARD_KEYS.set(ccard.Model, id);
    }
    return id;
}
var CCardView = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e;
    var ccard = _a.ccard;
    return React.createElement("div", { className: "coordination-card" },
        React.createElement("div", { className: "header" },
            React.createElement("span", { className: "coordination-title" }, (_b = ccard.Model.Coordination()) === null || _b === void 0 ? void 0 : _b.Title()),
            React.createElement("span", { className: "coordination-title-separator" }, "|"),
            React.createElement("span", { className: "coordination-provider" }, (_d = (_c = ccard.Model.Provider()) === null || _c === void 0 ? void 0 : _c.Provider()) === null || _d === void 0 ? void 0 : _d.Name())),
        React.createElement("div", { className: "pc-text-smalllabel description" }, (_e = ccard.Model.Coordination()) === null || _e === void 0 ? void 0 : _e.Description()));
});
var RepetitionInfo = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.BatchRequest() ?
        React.createElement(RepeatedPortCall, { batchReq: m.BatchRequest() }) :
        React.createElement("div", { className: "repetition-info is-not-repeated" }, "This PortCall is not repeated.");
});
var BATCH_DATES_FORMAT = 'HH:mm on DD MMM YYYY';
var RepeatedPortCall = supercritical_1.default(function (_a) {
    var b = _a.batchReq;
    var batch = b.Model.Batch(), preview = b.Preview();
    return (React.createElement("div", { className: "repetition-info is-repeated" },
        React.createElement("div", { className: "header" }, "Range"),
        React.createElement("div", { className: "batch-info-row" },
            React.createElement("label", { className: "batch-info-label" }, "Frequency"),
            React.createElement("span", { className: "batch-info-body" }, batch && itineraryview_1.frequencyDescriptionText(b.StartDate(), batch.RecurrencePeriod))),
        React.createElement("div", { className: "batch-info-row" },
            React.createElement("label", { className: "batch-info-label" }, "Batch Size"),
            React.createElement("span", { className: "batch-info-body" }, preview && preview.BatchSize + " " + (preview.BatchSize === 1 ? 'PortCall' : 'PortCalls'))),
        React.createElement("div", { className: "batch-info-row" },
            React.createElement("label", { className: "batch-info-label" }, "First PortCall Arrival"),
            React.createElement("span", { className: "batch-info-body" }, (preview === null || preview === void 0 ? void 0 : preview.FirstPortCallArrival) && tzmoment_1.tzmoment(preview.FirstPortCallArrival).format(BATCH_DATES_FORMAT))),
        React.createElement("div", { className: "batch-info-row" },
            React.createElement("label", { className: "batch-info-label" }, "Last PortCall Arrival"),
            React.createElement("span", { className: "batch-info-body" }, (preview === null || preview === void 0 ? void 0 : preview.LastPortCallArrival) && tzmoment_1.tzmoment(preview.LastPortCallArrival).format(BATCH_DATES_FORMAT)))));
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(12);
var view_2 = __webpack_require__(1024);
var TZDate_1 = __webpack_require__(7);
var AddPortCallRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
        React.createElement(view_2.AddPortCallView, { model: model(convertParams(request)) }))
}); };
exports.AddPortCallRoute = AddPortCallRoute;
function convertParams(request) {
    var p = request.params;
    return {
        firstLine: p['firstline'] ? new TZDate_1.default(p['firstline']) :
            p['arrival'] ? new TZDate_1.default(p['arrival']) :
                undefined,
        lastLine: p['lastline'] ? new TZDate_1.default(p['lastline']) :
            p['departure'] ? new TZDate_1.default(p['departure']) :
                undefined,
        footmark: p['footmark'] ? +p['footmark'] : undefined,
        berth: p['berth'] ? +p['berth'] : undefined
    };
}


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallSummaryTab = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var uniqueIndex_1 = __webpack_require__(70);
var Issue_1 = __webpack_require__(157);
function AddPortCallSummaryTab(portcallScheduleModel, _a) {
    var FinishedOrder = _a.FinishedOrder;
    var SelectedPortCallId = s_js_1.default.value(null), PortCalls = s_array_1.lift(function () { var _a, _b; return (_b = (_a = FinishedOrder()) === null || _a === void 0 ? void 0 : _a.PortCalls) !== null && _b !== void 0 ? _b : []; })
        .map(function (pc) { return SubmittedPortCall(pc, SelectedPortCallId); })
        .orderBy(function (pc) { var _a; return (_a = pc.ArrivalDate()) !== null && _a !== void 0 ? _a : new TZDate_1.default(0); }), portcallsById = uniqueIndex_1.default(PortCalls, function (pc) { return pc.Model.Id(); }), SelectedPortCall = s_js_1.default(function () {
        return SelectedPortCallId() === null ? null : portcallsById(SelectedPortCallId())();
    }), SelectedSchedule = s_js_1.default(function () { return SelectedPortCall() && portcallScheduleModel({
        PortCall: SelectedPortCall().Model
    }); }), Batch = s_js_1.default(function () { var _a, _b; return ((_b = (_a = FinishedOrder()) === null || _a === void 0 ? void 0 : _a.Batch) !== null && _b !== void 0 ? _b : null) && SubmittedBatch(FinishedOrder().Batch); });
    // Auto-select the first PortCall
    s_js_1.default(function () { return PortCalls().length > 0 && SelectedPortCallId() === null && SelectedPortCallId(PortCalls()[0].Model.Id()); });
    return {
        PortCalls: PortCalls,
        SelectedSchedule: SelectedSchedule,
        Batch: Batch,
        CanProceed: function () { return true; }
    };
}
exports.AddPortCallSummaryTab = AddPortCallSummaryTab;
function SubmittedPortCall(PortCall, SelectedPortCallId) {
    var ArrivalDate = s_js_1.default(function () { var _a, _b; return (_b = (_a = PortCall.Itinerary().find(function (pt) { return pt.IsPortArrival(); })) === null || _a === void 0 ? void 0 : _a.Arrival.Estimated()) !== null && _b !== void 0 ? _b : null; }), Issues = s_js_1.default(function () {
        return PortCall
            .Reservations()
            .reduce(function (acc, br) { return acc.concat(br.Issues()); }, [])
            // TODO: Include PJO issues here? It seems like it only makes sense to include them here if
            // we're gonna have a place to display them on the PortCallScheduleView (or WHATEVER summary UI
            // we choose to use for individual PortCalls).
            .sort(Issue_1.Issue.ReversePrecedenceOrder);
    }), 
    // A separate S.value to avoid notifying downstream code about selectedPortCallId changes unless THIS
    // PortCall's selection state is actually changing.
    IsSelected = s_js_1.default.value(s_js_1.default.sample(function () { return SelectedPortCallId() === PortCall.Id(); }));
    s_js_1.default(function () { return IsSelected(SelectedPortCallId() === PortCall.Id()); });
    return {
        Model: PortCall,
        ArrivalDate: ArrivalDate,
        Issues: Issues,
        IsSelected: IsSelected,
        Select: Select
    };
    function Select() {
        SelectedPortCallId(PortCall.Id());
    }
}
function SubmittedBatch(batch) {
    return { Model: batch };
}


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallSummaryTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(68);
var view_2 = __webpack_require__(88);
exports.AddPortCallSummaryTabView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "addportcallsummarytab" },
        React.createElement("div", { className: "main" },
            React.createElement("div", { className: "order-header" },
                React.createElement("div", { className: "order-submitted" }, "Your order has been submitted."),
                React.createElement("div", { className: "order-link" },
                    React.createElement("a", { href: '#!portcallprofile?id=' + ((_b = m.SelectedSchedule()) === null || _b === void 0 ? void 0 : _b.PortCall.Id()) }, "View PortCall"))),
            React.createElement(BatchDetails, { model: m }),
            React.createElement(SelectedSchedule, { model: m })),
        React.createElement(PortCallSelector, { model: m }));
});
var BatchDetails = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Batch() &&
        React.createElement("div", { className: "batch-details" },
            "Your batch reference number is ",
            m.Batch().Model.ReferenceNumber(),
            ".");
});
var SelectedSchedule = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "schedule" }, m.SelectedSchedule() && React.createElement(view_2.PortCallScheduleView, { model: m.SelectedSchedule() }));
});
var PortCallSelector = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.PortCalls().length > 1 ?
        React.createElement("div", { className: "portcall-selector" }, m.PortCalls().map(function (pc, i) {
            return React.createElement(PortCallSelectorOption, { portcall: pc, index: i, key: pc.Model.Id() });
        })) :
        null;
});
var PortCallSelectorOption = supercritical_1.default(function (_a) {
    var pc = _a.portcall, i = _a.index;
    return React.createElement("div", { className: "portcall-selector-option" },
        React.createElement("span", { className: "selection-indicator-shell" }, pc.IsSelected() && React.createElement("span", { className: "selection-indicator fa fa-caret-right" })),
        React.createElement("span", { className: "selection-button", onClick: pc.Select },
            "PC #",
            (i + 1).toLocaleString()),
        React.createElement(view_1.IssueCountPillBadge, { className: "issue-badge", issues: pc.Issues }));
});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallVesselTabView = void 0;
var React = __webpack_require__(2);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var vessel_1 = __webpack_require__(505);
var view_1 = __webpack_require__(528);
var view_2 = __webpack_require__(530);
var view_3 = __webpack_require__(89);
var view_4 = __webpack_require__(152);
var view_5 = __webpack_require__(154);
exports.AddPortCallVesselTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcallvesseltab" },
        React.createElement(Vessel, { model: m }),
        React.createElement(PortsOfCall, { model: m }),
        React.createElement(Agent, { model: m }));
});
var Vessel = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vessel-section" },
        React.createElement("label", { className: "vessel-section-label" }, "Vessel"),
        React.createElement("div", { className: "vessel-section-content" },
            React.createElement(ExistingVessel, { model: m }),
            React.createElement(ImportVessel, { model: m }),
            React.createElement(LengthOnlyVessel, { model: m })));
});
var ExistingVessel = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.VesselType() === vessel_1.VesselType.Existing ?
        React.createElement("div", { className: "existing-vessel" },
            React.createElement("div", { className: "vessel-search-shell" },
                React.createElement(view_1.LocalVesselSearchView, { model: m.LocalSearch, placeholder: "Required", tabIndex: 1, specificInput: "addPortCall" }),
                !m.PortCall.Vessel() &&
                    React.createElement("div", { className: "pc-text-smalllabel vessel-search-instructions" }, "Search a vessel by name, IMO, call sign, or MMSID"),
                React.createElement(ExistingVesselProperties, { model: m })),
            React.createElement("div", { className: "type-selector" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.VesselType(vessel_1.VesselType.Import); }) }, "Can't find the right vessel?"),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", { className: "pc-text-smalllabel" }, "Don't know which vessel yet?"),
                React.createElement("br", null),
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.VesselType(vessel_1.VesselType.LengthOnly); }) }, "Reserve by length."))) :
        null;
});
var ExistingVesselProperties = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var v = m.PortCall.Vessel();
    return v ?
        React.createElement("div", { className: "vessel-properties" },
            React.createElement("div", { className: "vessel-prop-col" },
                React.createElement("div", { className: "vessel-prop" },
                    React.createElement("label", { className: "vessel-prop-label" }, "IMO"),
                    React.createElement("span", null, v.IMO() || '--')),
                (v.CallSign() || v.MMSID() || v.VIN()) &&
                    React.createElement("div", { className: "vessel-prop" },
                        React.createElement("label", { className: "vessel-prop-label" }, v.CallSign() ? 'Call Sign' :
                            v.MMSID() ? 'MMSID' :
                                v.VIN() ? 'VIN' :
                                    null),
                        React.createElement("span", null, v.CallSign() || v.MMSID() || v.VIN()))),
            React.createElement("div", { className: "vessel-prop-col" },
                React.createElement("div", { className: "vessel-prop" },
                    React.createElement("label", { className: "vessel-prop-label" }, "LOA"),
                    React.createElement("span", null, v.Length.toString({ places: 0 })))),
            React.createElement("div", { className: "vessel-prop-col" },
                React.createElement("div", { className: "vessel-prop" },
                    React.createElement("label", { className: "vessel-prop-label" }, "Type"),
                    React.createElement("span", null, v.VesselType() || '--')),
                React.createElement("div", { className: "vessel-prop" },
                    React.createElement("label", { className: "vessel-prop-label" }, "Flag"),
                    React.createElement("span", null, (_c = (_b = v.Flag()) === null || _b === void 0 ? void 0 : _b.Name()) !== null && _c !== void 0 ? _c : '--')))) :
        null;
});
var ImportVessel = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.NewVessel() &&
        React.createElement("div", { className: "import-vessel" },
            React.createElement(view_2.NewVesselView, { model: m.NewVessel() }));
});
var LengthOnlyVessel = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.VesselType() === vessel_1.VesselType.LengthOnly ?
        React.createElement("div", { className: "length-only-vessel" },
            React.createElement("div", { className: "pc-text-smalllabel manual-description" },
                "Enter the approximate length.",
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.VesselType(vessel_1.VesselType.Existing); }) }, "Back to search")),
            React.createElement("div", { className: "vessel-info reserve-by-length" },
                React.createElement("div", { className: "length" },
                    React.createElement("span", { className: "pc-text-smalllabel loa-label" }, "Length Overall"),
                    React.createElement(view_4.ToggleableMeasurementView, { model: m.ToggleableLengthOnlyLength, placeholder: "Required" })),
                React.createElement("div", { className: "uomselector uom" },
                    React.createElement(view_3.ToggleButton, { checked: m.LengthOnlyLengthInFeet, onLabel: "Feet", offLabel: "Meters" })))) :
        null;
});
var PortsOfCall = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", { className: "ports-of-call-section" },
        React.createElement("div", { className: "port-of-call-shell" },
            React.createElement("label", { className: "pc-text-smalllabel vessel-tab-aligned-label" }, "Last"),
            React.createElement("input", { className: "port-of-call", type: "text", placeholder: "Port of Call", value: (_b = m.PortCall.LastPortOfCall()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.PortCall.LastPortOfCall(e.currentTarget.value); }, tabIndex: 100 })),
        React.createElement("div", { className: "port-of-call-shell" },
            React.createElement("label", { className: "pc-text-smalllabel vessel-tab-aligned-label" }, "Next"),
            React.createElement("input", { className: "port-of-call", type: "text", placeholder: "Port of Call", value: (_c = m.PortCall.NextPortOfCall()) !== null && _c !== void 0 ? _c : '', onChange: function (e) { return m.PortCall.NextPortOfCall(e.currentTarget.value); }, tabIndex: 101 })));
});
var Agent = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", { className: "agent-section" },
        React.createElement("label", { className: "pc-text-smalllabel vessel-tab-aligned-label" }, "Agent"),
        React.createElement("div", { className: "agent-selector-shell" },
            React.createElement(view_5.UserSelectorView, { model: m.AgentSelector, className: "search-filter", placeholder: "Required", tabIndex: 200 }),
            m.PortCall.Agent() &&
                React.createElement("div", { className: "agent-details" },
                    React.createElement("div", { className: "agent-company" }, (_b = m.PortCall.Agent().Organization()) === null || _b === void 0 ? void 0 : _b.Name()),
                    React.createElement("div", { className: "agent-phone" }, m.PortCall.Agent().PhoneNumbers().length > 0 ?
                        m.PortCall.Agent().PhoneNumbers()[0].Number() :
                        ''),
                    ((_c = m.PortCall.Agent()) === null || _c === void 0 ? void 0 : _c.User()) &&
                        React.createElement("div", { className: "agent-email-shell" },
                            React.createElement("a", { className: "agent-email", href: "mailto:" + m.PortCall.Agent().User().Email() }, m.PortCall.Agent().User().Email())))),
        m.User() && !m.PortCall.Agent() &&
            React.createElement("div", { className: "use-my-profile-shell" },
                React.createElement("a", { className: "use-my-profile", href: "", onClick: eventWrappers_1.noDefault(function () { return m.PortCall.AgentId(m.User().Id()); }), tabIndex: 300 }, "Use my profile as agent")));
});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(504);
var view_1 = __webpack_require__(29);
var berthsview_1 = __webpack_require__(1013);
var coordinationsview_1 = __webpack_require__(1015);
var itineraryview_1 = __webpack_require__(503);
var pilotsview_1 = __webpack_require__(1017);
var reviewview_1 = __webpack_require__(1019);
var summaryview_1 = __webpack_require__(1022);
var vesselview_1 = __webpack_require__(1023);
exports.AddPortCallView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "addportcall" },
        React.createElement("header", { className: "add-pc-page-header" },
            React.createElement("div", { className: "pc-page-title page-title" }, "Add PortCall"),
            React.createElement(TabIndicators, { model: m })),
        React.createElement(CurrentTabContents, { model: m }),
        React.createElement(NavigationControls, { model: m }),
        React.createElement(LoadingIcon, { model: m }),
        React.createElement(view_1.ErrorModal, { errors: m.Validation, shown: m.ShowValidationErrors, title: "There are issues with your PortCall" }));
});
var TabIndicators = supercritical_1.default(function (_a) {
    var m = _a.model;
    var availableTabs = m.AvailableTabs(), currentIdx = availableTabs.indexOf(m.CurrentTab().id);
    return (React.createElement("div", { className: "tab-indicators" }, availableTabs.map(function (tabId, i) { return [
        i > 0 ?
            React.createElement("span", { className: cx('tab-indicator-separator fa fa-chevron-right', { fulfilled: i <= currentIdx }), key: "separator-" + tabId }) :
            null,
        React.createElement("span", { className: cx('tab-indicator', { fulfilled: i <= currentIdx }), onClick: i <= currentIdx ? function () { return m.JumpBackToTab(tabId); } : undefined, key: "indicator-" + tabId }, TabName(tabId))
    ]; })));
});
function TabName(id) {
    if (id === model_1.TabId.Berths)
        return 'Berths';
    else if (id === model_1.TabId.Coordinations)
        return 'Coordinations';
    else if (id === model_1.TabId.Itinerary)
        return 'Itinerary';
    else if (id === model_1.TabId.Pilots)
        return 'Pilots';
    else if (id === model_1.TabId.Review)
        return 'Review';
    else if (id === model_1.TabId.Summary)
        return 'Summary';
    else if (id === model_1.TabId.Vessel)
        return 'Vessel';
    else
        return null;
}
var LoadingIcon = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Loading() ? React.createElement("div", { className: "loading-icon" }) : null;
});
var CurrentTabContents = supercritical_1.default(function (_a) {
    var m = _a.model;
    window.scrollTo(0, 0);
    var tab = m.CurrentTab();
    if (tab.id === model_1.TabId.Berths)
        return React.createElement(berthsview_1.AddPortCallBerthsTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Coordinations)
        return React.createElement(coordinationsview_1.AddPortCallCoordinationsTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Itinerary)
        return React.createElement(itineraryview_1.AddPortCallItineraryTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Pilots)
        return React.createElement(pilotsview_1.AddPortCallPilotsTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Review)
        return React.createElement(reviewview_1.AddPortCallReviewTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Summary)
        return React.createElement(summaryview_1.AddPortCallSummaryTabView, { model: tab.model });
    else if (tab.id === model_1.TabId.Vessel)
        return React.createElement(vesselview_1.AddPortCallVesselTabView, { model: tab.model });
    else
        return null;
});
var NavigationControls = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "navigation-controls" },
        React.createElement("div", { className: "back-button-shell" }, m.HasPreviousTab() &&
            React.createElement("button", { className: "pc-button back-button", disabled: m.Submitting(), onClick: m.GoToPreviousTab }, "Back")),
        React.createElement("div", { className: "next-button-shell" },
            !m.SubmissionSucceeded() &&
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return window.history.back(); }) }, "Cancel"),
            React.createElement("button", { className: "pc-button next-button", disabled: !m.CanProceed() || m.Submitting(), onClick: m.HasNextTab() ? m.GoToNextTab :
                    m.SubmissionSucceeded() ? function () { return window.history.back(); } :
                        m.Submit, tabIndex: 1000 }, m.HasNextTab() ? 'Next' : m.SubmissionSucceeded() ? 'OK' : 'Submit')));
});


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AmenityListMgmt = void 0;
var BerthAmenityType_1 = __webpack_require__(558);
function AmenityListMgmt(loader, ajax, data, orderableLookupsModel, _a) {
    var id = _a.id;
    var model = loader({ Id: id }, 30).model, orderableLookups = orderableLookupsModel({
        supportsAdd: true,
        addClient: ajax.Url(function () { return model.BerthAmenityTypesUrl() || ''; }),
        items: model.BerthAmenityTypes.filter(function (a) { return a.Active(); }),
        cacheCollection: data.BerthAmenityTypes,
        orderProp: function (a) { return a.Order; },
        itemFactory: function (order) { return new BerthAmenityType_1.BerthAmenityType({
            Id: 0,
            Active: true,
            Name: '--',
            Order: order
        }); },
        itemKey: function (a) { return a.Id(); },
        deleteFn: function (client, draft) { return draft.Active(false); }
    });
    return {
        Model: model,
        OrderableLookups: orderableLookups
    };
}
exports.AmenityListMgmt = AmenityListMgmt;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AmenityListMgmtRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1027);
var view_2 = __webpack_require__(12);
var AmenityListMgmtRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.AmenityListMgmtView, { model: model(inboundParams(request)) }))
}); };
exports.AmenityListMgmtRoute = AmenityListMgmtRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0)
    };
}


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AmenityListMgmtView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var orgheaderview_1 = __webpack_require__(131);
var view_1 = __webpack_require__(273);
exports.AmenityListMgmtView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "amenitylistmgmt pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: '#!orgprofile?id=' + m.Model.Id() }, "<< Back to Organization")),
        React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Model }),
        React.createElement("div", { className: "page-body pc-card" },
            React.createElement("div", { className: "amenitytypes" },
                React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Amenity List Management"),
                React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "List all of the amenities offered at your berths. You will select amenities from this list on a berth\u2019s profile. Click +Add Amenities to create a new line item. Click Edit to change the Type or Details of an amenity."),
                React.createElement(view_1.OrderableLookupsView, { model: m.OrderableLookups, columns: [{
                            type: 'textInput',
                            title: 'Name',
                            className: 'name',
                            validationKey: 'Name',
                            itemProp: function (a) { return a.Name; }
                        }, {
                            type: 'textInput',
                            title: 'Description',
                            className: 'description',
                            validationKey: 'Description',
                            itemProp: function (a) { return a.Description; }
                        }], addBtnText: "+Add Amenity" })))));
});


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AppWrapper = void 0;
function AppWrapper(navbar, ajaxErrors, domainSummary, UITheme) {
    return {
        Navbar: navbar,
        AjaxErrors: ajaxErrors,
        DomainSummary: domainSummary,
        UITheme: UITheme
    };
}
exports.AppWrapper = AppWrapper;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchesDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var BatchesDashboard_1 = __webpack_require__(1227);
var BatchesDashboardCache = /** @class */ (function (_super) {
    __extends(BatchesDashboardCache, _super);
    function BatchesDashboardCache(data) {
        var _this = _super.call(this) || this;
        _this.BatchesDashboards = PCCache_1.PCCollection(BatchesDashboard_1.BatchesDashboard);
        new DataCache_1.ForeignKeyRelationship(data.Organizations, _this.BatchesDashboards, null, function (r) { return r.Organization; }, function (r) { return r.OrganizationId(); });
        new DataCache_1.QueryResultsRelationship(_this.BatchesDashboards, data.RecurringBatches, function (r) { return r.Batches; });
        return _this;
    }
    return BatchesDashboardCache;
}(DataCache_1.DataCache));
exports.BatchesDashboardCache = BatchesDashboardCache;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchesDashboardRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(87);
var PortCallUserRole_1 = __webpack_require__(136);
var routeParams_2 = __webpack_require__(77);
var model_1 = __webpack_require__(264);
var view_1 = __webpack_require__(1031);
var view_2 = __webpack_require__(12);
var BatchesDashboardRoute = function (model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.BatchesDashboardView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
};
exports.BatchesDashboardRoute = BatchesDashboardRoute;
function inboundParams(request, tzutils) {
    var orgId = request.params['orgId'], range = request.params['range'], role = request.params['role'], from = request.params['from'], to = request.params['to'], filter = request.params['filter'];
    return {
        orgId: orgId !== undefined ? +orgId : undefined,
        range: range !== undefined ? routeParams_1.parseDateRange(range) : 3 /* ThisMonth */,
        role: role !== undefined ? routeParams_2.parsePortCallUserRole(role) : undefined,
        from: from !== undefined ? routeParams_2.parseDate(from, tzutils) : undefined,
        to: to !== undefined ? routeParams_2.parseDate(to, tzutils) : undefined,
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['orgId'] = m.OrgId + '';
    routeParams_1.outboundDateRangeParams(m.DateRangeSelector, params, 3 /* ThisMonth */, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter())
        params['filter'] = m.Filter();
    if (m.Role() !== model_1.DefaultRole)
        params['role'] = PortCallUserRole_1.PortCallUserRoleDisplayName[m.Role()];
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchesDashboardView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(264);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(128);
var view_3 = __webpack_require__(105);
var view_4 = __webpack_require__(106);
var view_5 = __webpack_require__(40);
var view_6 = __webpack_require__(35);
exports.BatchesDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "batches-dashboard" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back"),
            React.createElement(view_1.ActionsMenuButton, { onClick: function () { return m.ShowActionsMenu(!m.ShowActionsMenu()); } }),
            React.createElement(ActionsContainer, { model: m })),
        React.createElement(ProfileHeader, { model: m }),
        React.createElement(ControlsView, { model: m }),
        React.createElement(view_5.PageLoadingIndicator, { loading: m.Loading }),
        React.createElement(BatchesTable, { model: m }));
});
var ActionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
        React.createElement(view_6.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
            React.createElement(PrintMenuItem, { model: m }),
            React.createElement(CSVExportMenuItem, { model: m })));
});
var PrintMenuItem = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action-item" },
        React.createElement("div", null,
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () {
                    m.ShowActionsMenu(false);
                    window.print();
                }) }, "Print Report")),
        React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Print the current view's results."));
});
var CSVExportMenuItem = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action-item" },
        React.createElement("div", null,
            React.createElement(view_3.DownloadLink, { href: m.CSVExportLink(), download: "batches.csv", onClick: function () { return m.ShowActionsMenu(false); } }, "Export to CSV")),
        React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Save the current view's results as a CSV, which can be used in Excel."));
});
var ProfileHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "profile-header" },
        m.Organization() && React.createElement("img", { src: m.Organization().Image.ProfileUrl() || '' }),
        React.createElement("div", { className: "profile-header-details" },
            React.createElement("div", { className: "name pc-text-fixedwidth" }, m.Organization() && m.Organization().Name())));
});
var ControlsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "controls pc-search-mobile" },
        React.createElement("div", { className: "title" }, "Batches"),
        React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter By \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }),
        React.createElement(view_2.DateRangeSelectorView, { model: m.DateRangeSelector }));
});
var BatchesTable = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("table", { className: "table" },
        React.createElement(TableHead, { model: m }),
        React.createElement(TableBody, { model: m }));
});
var TableHead = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("thead", null,
        React.createElement("tr", null, view_4.GridTableHeaderCells(model_1.Columns, m.RowSorter)));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.Batches().map(function (batch) {
        return React.createElement(BatchRow, { batch: batch, key: batch.Model.Id() });
    }));
});
var BatchRow = supercritical_1.default(function (_a) {
    var batch = _a.batch;
    return React.createElement("tr", { onClick: batch.OnRowClick }, view_4.GridTableRowCells(model_1.Columns, batch));
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsActionsTab = void 0;
var s_js_1 = __webpack_require__(0);
var autoSave_1 = __webpack_require__(31);
var draftSignals_1 = __webpack_require__(37);
var validationWatcher_1 = __webpack_require__(23);
var CancelReservationsRequest_1 = __webpack_require__(1241);
var IssueType_1 = __webpack_require__(112);
var Rights_1 = __webpack_require__(118);
var BerthAssignmentAction;
(function (BerthAssignmentAction) {
    BerthAssignmentAction["CancelReservation"] = "cancel-reservation";
})(BerthAssignmentAction || (BerthAssignmentAction = {}));
function BerthAssignmentDetailsActionsTab(ajax, entrypoints, _a) {
    var BerthReservation = _a.BerthReservation, DismissDetails = _a.DismissDetails, PCRights = _a.PCRights, SaveMutex = _a.SaveMutex;
    var selectedAction = s_js_1.default.value(null), actionIsSelected = function (action) { return function (val) {
        if (val === undefined) {
            return selectedAction() === action;
        }
        else {
            var isSelected = s_js_1.default.sample(selectedAction) === action;
            if (val !== isSelected)
                selectedAction(val ? action : null);
            return val;
        }
    }; }, CancelReservation = CancelReservationAction(BerthReservation, ajax, entrypoints, DismissDetails, PCRights, SaveMutex, actionIsSelected(BerthAssignmentAction.CancelReservation)), RaftReservation = RaftReservationAction(BerthReservation, ajax, PCRights, SaveMutex), HasAnyAvailableActions = function () {
        return CancelReservation.IsAvailable()
            || RaftReservation.IsAvailable();
    }, Loading = function () {
        return CancelReservation.IsPerforming()
            || RaftReservation.IsSaving();
    };
    return {
        CancelReservation: CancelReservation,
        RaftReservation: RaftReservation,
        HasAnyAvailableActions: HasAnyAvailableActions,
        Loading: Loading
    };
}
exports.BerthAssignmentDetailsActionsTab = BerthAssignmentDetailsActionsTab;
function CancelReservationAction(BerthReservation, ajax, entrypoints, DismissDetails, PCRights, saveMutex, IsSelected) {
    var client = ajax.Url(entrypoints.CancelReservations, { useCache: true }), Req = s_js_1.default(function () { return IsSelected() ? new CancelReservationsRequest_1.CancelReservationsRequest({
        ReservationIds: [BerthReservation.Id()]
    }) : null; }), IsAvailable = function () { return (PCRights() & Rights_1.PortCallRights.Cancel) !== 0; }, IsPerforming = s_js_1.default.value(false);
    return {
        BerthReservation: BerthReservation,
        IsSelected: IsSelected,
        Req: Req,
        IsAvailable: IsAvailable,
        IsPerforming: function () { return IsPerforming(); },
        Perform: Perform
    };
    function Perform() {
        return __awaiter(this, void 0, void 0, function () {
            var req, guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = Req();
                        if (!req || IsPerforming())
                            return [2 /*return*/];
                        IsPerforming(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, saveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, client.Post(req)];
                    case 4:
                        _a.sent();
                        DismissDetails();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        IsPerforming(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
}
function RaftReservationAction(BerthReservation, ajax, PCRights, saveMutex) {
    var _this = this;
    var draft = draftSignals_1.DraftObject(BerthReservation, ['Rafting']), client = ajax.Url(function () { var _a; return (_a = BerthReservation.Url()) !== null && _a !== void 0 ? _a : ''; }, { useCache: true }), Validation = validationWatcher_1.ValidationWatcher(client), HasRaftableOverlaps = BerthReservation.Issues.some(function (i) { return i.Type() === IssueType_1.IssueType.ReservationOverlapsOther; }), IsAvailable = function () {
        return (PCRights() & Rights_1.PortCallRights.EditRafting) !== 0 &&
            (BerthReservation.Rafting() || HasRaftableOverlaps());
    }, IsSaving = s_js_1.default.value(false);
    autoSave_1.AutoSaver(draft.methods.onWrite, function () { return __awaiter(_this, void 0, void 0, function () {
        var guard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    IsSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 7, 8]);
                    return [4 /*yield*/, saveMutex.acquire()];
                case 2:
                    guard = _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, , 5, 6]);
                    return [4 /*yield*/, autoSave_1.SaveDraftObject(draft, client)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    guard.release();
                    return [7 /*endfinally*/];
                case 6: return [3 /*break*/, 8];
                case 7:
                    IsSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, 0);
    return {
        Persisted: BerthReservation,
        Draft: draft.object,
        Validation: Validation,
        IsAvailable: IsAvailable,
        IsSaving: function () { return IsSaving(); },
        ToggleRafting: ToggleRafting
    };
    function ToggleRafting() {
        // Toggle means set to the opposite of the current PERSISTED state, so that calling Toggle again before
        // changes have been persisted has no effect.
        s_js_1.default.sample(function () { return draft.object.Rafting(!BerthReservation.Rafting()); });
    }
}


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsActionsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(29);
exports.BerthAssignmentDetailsActionsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berthassignmentdetailsactionstab" },
        React.createElement("div", { className: "ccard-details-actions-tab__section ccard-details-actions-tab__coordination-actions-shell" },
            React.createElement("div", { className: "ccard-details-actions-tab__section-title" }, "Reservation Actions"),
            React.createElement(CancelReservationActionView, { action: m.CancelReservation }),
            React.createElement(RaftReservationActionView, { action: m.RaftReservation })));
});
var CancelReservationActionView = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var action = _a.action;
    return action.IsAvailable() ?
        React.createElement("div", { className: "ccard-details-actions-tab__coordination-action cancel-reservation-action" },
            React.createElement("div", { className: "coordination-action-link-shell" },
                React.createElement("a", { href: "", className: "coordination-action-link", onClick: eventWrappers_1.noDefault(function () { return action.IsSelected(true); }) }, "Cancel this Reservation")),
            action.IsSelected() ?
                // TODO: Some designs show this spawning a modal popup like the old cancel reservation popup
                // instead. Do we go that route? If so, we should think about whether we wanna instantiate that
                // modal here directly or put that responsibility calling code instead, for more flexibility
                // over things like z-index.
                React.createElement("div", { className: "cancellation-action-shell" },
                    React.createElement("div", { className: "remarks-shell" },
                        React.createElement("textarea", { className: "remarks", value: (_c = (_b = action.Req()) === null || _b === void 0 ? void 0 : _b.Remarks()) !== null && _c !== void 0 ? _c : '', onChange: function (e) { var _a; return (_a = action.Req()) === null || _a === void 0 ? void 0 : _a.Remarks(e.currentTarget.value || null); }, placeholder: "These remarks will be sent to editors on this PortCall." })),
                    React.createElement("div", { className: "pc-confirm" },
                        React.createElement("span", { className: "pc-confirm-question" },
                            React.createElement("b", null,
                                "Are you sure you want to cancel this",
                                ((_d = action.BerthReservation.Itinerary()) === null || _d === void 0 ? void 0 : _d.Location()) ?
                                    " reservation for " + action.BerthReservation.Itinerary().Location().Name() + "?" :
                                    ' reservation?')),
                        React.createElement("button", { className: "pc-confirm-button pc-confirm-button-primary", onClick: action.Perform, disabled: action.IsPerforming() }, "Yup"),
                        React.createElement("button", { className: "pc-confirm-button", onClick: function () { return action.IsSelected(false); }, disabled: action.IsPerforming() }, "Nope"))) :
                React.createElement("div", { className: "coordination-action-description" }, "Cancel this reservation and all coordinations to and from this location.")) :
        null;
});
var RaftReservationActionView = supercritical_1.default(function (_a) {
    var action = _a.action;
    return action.IsAvailable() ?
        React.createElement("div", { className: "ccard-details-actions-tab__coordination-action raft-reservation-action" },
            React.createElement("div", { className: "coordination-action-link-shell" },
                React.createElement("a", { href: "", className: "coordination-action-link", 
                    // TODO: Do we want a confirm workflow for rafting/unrafting like we have for other actions?
                    // For now, thinking of rafting/unrafting as fairly "light" edits, so no need to confirm.
                    // Then again, rafting/unrafting can add/remove conflicts, thus triggering emails....
                    onClick: eventWrappers_1.noDefault(action.ToggleRafting) }, action.Persisted.Rafting() ? 'Stop Rafting this Reservation' : 'Raft this Reservation')),
            React.createElement("div", { className: "coordination-action-description" }, "Raft this reservation to indicate its position at the berth as not directly resting on the berth."),
            view_1.ListErrors(action.Validation())) :
        null;
});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var BerthAssignmentDetailsResponse_1 = __webpack_require__(1228);
var PCCache_1 = __webpack_require__(17);
var BerthAssignmentDetailsCache = /** @class */ (function (_super) {
    __extends(BerthAssignmentDetailsCache, _super);
    function BerthAssignmentDetailsCache(data) {
        var _this = _super.call(this) || this;
        _this.BerthAssignmentDetailsResponses = PCCache_1.PCCollection(BerthAssignmentDetailsResponse_1.BerthAssignmentDetailsResponse);
        new DataCache_1.SharedKeyRelationship(_this.BerthAssignmentDetailsResponses, data.BerthReservations, function (r) { return r.BerthReservation; }, null);
        return _this;
    }
    return BerthAssignmentDetailsCache;
}(DataCache_1.DataCache));
exports.BerthAssignmentDetailsCache = BerthAssignmentDetailsCache;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsInPortOpsTab = void 0;
var Rights_1 = __webpack_require__(118);
function BerthAssignmentDetailsInPortOpsTab(existingInPortOpsModel, _a) {
    var BerthReservation = _a.BerthReservation, PCRights = _a.PCRights, SaveMutex = _a.SaveMutex;
    var InPortOps = existingInPortOpsModel({
        Reservation: BerthReservation,
        CanEdit: function () { return (PCRights() & Rights_1.PortCallRights.Edit) !== 0; },
        SaveMutex: SaveMutex
    }), Loading = function () { return InPortOps.IsSaving(); };
    return { InPortOps: InPortOps, Loading: Loading };
}
exports.BerthAssignmentDetailsInPortOpsTab = BerthAssignmentDetailsInPortOpsTab;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsInPortOpsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(526);
exports.BerthAssignmentDetailsInPortOpsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berthassignmentdetailsinportopstab" },
        React.createElement(view_1.InPortOpsView, { model: m.InPortOps }));
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(506);
var view_1 = __webpack_require__(267);
var view_2 = __webpack_require__(197);
var actionsview_1 = __webpack_require__(1033);
var inportopsview_1 = __webpack_require__(1036);
exports.BerthAssignmentDetailsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berthassignmentdetails" },
        React.createElement(view_2.PCTabStripView, { model: m.TabStrip, ctrl: new view_2.TitledTabStripViewController(), extraContents: function () {
                return React.createElement(view_1.CoordinationCardDetailsCloseLink, { dismissDetails: m.DismissDetails });
            } }),
        React.createElement(view_2.PCTabContents, { model: m.TabStrip, ctrl: new TabContentsController(m) }),
        React.createElement(view_1.CoordinationCardDetailsLoadingIcon, { loading: m.Loading }));
});
var TabContentsController = /** @class */ (function (_super) {
    __extends(TabContentsController, _super);
    function TabContentsController(model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        return _this;
    }
    TabContentsController.prototype.renderTabContents = function (tab) {
        var m = this.model;
        if (tab === model_1.TabActions)
            return React.createElement(actionsview_1.BerthAssignmentDetailsActionsTabView, { model: m.ActionsTab });
        else if (tab === model_1.TabInPortOps)
            return React.createElement(inportopsview_1.BerthAssignmentDetailsInPortOpsTabView, { model: m.InPortOpsTab });
        else
            throw new Error("Unknown tab with title '" + tab.Title + "'");
    };
    return TabContentsController;
}(view_2.TitledTabContentsController));


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosuresDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var BerthClosuresDashboard_1 = __webpack_require__(1229);
var BerthClosuresDashboardCache = /** @class */ (function (_super) {
    __extends(BerthClosuresDashboardCache, _super);
    function BerthClosuresDashboardCache(data) {
        var _this = _super.call(this) || this;
        _this.BerthClosuresDashboards = PCCache_1.PCCollection(BerthClosuresDashboard_1.BerthClosuresDashboard);
        new DataCache_1.ForeignKeyRelationship(data.Organizations, _this.BerthClosuresDashboards, null, function (d) { return d.Organization; }, function (d) { return d.OrganizationId(); });
        new DataCache_1.QueryResultsRelationship(_this.BerthClosuresDashboards, data.BerthClosures, function (d) { return d.Closures; });
        return _this;
    }
    return BerthClosuresDashboardCache;
}(DataCache_1.DataCache));
exports.BerthClosuresDashboardCache = BerthClosuresDashboardCache;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosuresDashboardRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(87);
var view_1 = __webpack_require__(1040);
var view_2 = __webpack_require__(12);
var routeParams_2 = __webpack_require__(77);
function BerthClosuresDashboardRoute(model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.BerthClosuresDashboardView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.BerthClosuresDashboardRoute = BerthClosuresDashboardRoute;
function inboundParams(request, tzutils) {
    var orgId = request.params['orgId'], range = request.params['range'], from = request.params['from'], to = request.params['to'], filter = request.params['filter'];
    return {
        orgId: orgId === undefined ? undefined : +orgId,
        range: range === undefined ? 3 /* ThisMonth */ : routeParams_1.parseDateRange(range),
        from: from === undefined ? undefined : routeParams_2.parseDate(from, tzutils),
        to: to === undefined ? undefined : routeParams_2.parseDate(to, tzutils),
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['orgId'] = m.OrgId + '';
    routeParams_1.outboundDateRangeParams(m.DateRangeSelector, params, 3 /* ThisMonth */, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter())
        params['filter'] = m.Filter();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosuresDashboardView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var tzmoment_1 = __webpack_require__(9);
var model_1 = __webpack_require__(507);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(128);
var view_3 = __webpack_require__(105);
var view_4 = __webpack_require__(106);
var view_5 = __webpack_require__(40);
var view_6 = __webpack_require__(35);
exports.BerthClosuresDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berth-closures-dashboard" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", onClick: eventWrappers_1.noDefault(function () { return window.history.back(); }) }, "<< Back"),
            React.createElement(view_1.ActionsMenuButton, { onClick: function () { return m.ShowActionsMenu(!m.ShowActionsMenu()); } }),
            React.createElement(ActionsContainer, { model: m })),
        React.createElement(ProfileHeader, { model: m }),
        React.createElement(ControlsView, { model: m }),
        React.createElement(view_5.PageLoadingIndicator, { loading: m.Loading }),
        React.createElement(ClosuresTable, { model: m }));
});
var ActionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
        React.createElement(view_6.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
            React.createElement(PrintMenuItem, { model: m }),
            React.createElement(CSVExportMenuItem, { model: m })));
});
var PrintMenuItem = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action-item" },
        React.createElement("div", null,
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () {
                    m.ShowActionsMenu(false);
                    window.print();
                }) }, "Print Report")),
        React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Print the current view's results."));
});
var CSVExportMenuItem = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action-item" },
        React.createElement("div", null,
            React.createElement(view_3.DownloadLink, { href: m.CSVExportLink(), download: "closures.csv", onClick: function () { return m.ShowActionsMenu(false); } }, "Export to CSV")),
        React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Save the current view's results as a CSV, which can be used in Excel."));
});
var ProfileHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "profile-header" },
        m.Organization() && React.createElement("img", { src: m.Organization().Image.ProfileUrl() || '' }),
        React.createElement("div", { className: "profile-header-details" },
            React.createElement("div", { className: "name pc-text-fixedwidth" }, m.Organization() && m.Organization().Name())));
});
var ControlsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "controls pc-search-mobile" },
        React.createElement("div", { className: "title" }, "Berth Closures"),
        React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter By \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }),
        React.createElement(view_2.DateRangeSelectorView, { model: m.DateRangeSelector }));
});
var ClosuresTable = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("table", { className: "table" },
        React.createElement(TableHead, { model: m }),
        React.createElement(TableBody, { model: m }));
});
var TableHead = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("thead", null,
        React.createElement("tr", null,
            view_4.GridTableHeaderCells(model_1.Columns, m.RowSorter),
            React.createElement("th", { className: "actions" })));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.Closures().map(function (closure) {
        return React.createElement(TableRow, { closure: closure, key: closure.Model.Id() });
    }));
});
var TableRow = supercritical_1.default(function (_a) {
    var closure = _a.closure;
    return React.createElement("tr", null,
        view_4.GridTableRowCells(model_1.Columns, closure),
        React.createElement("td", { className: "actions" },
            React.createElement("a", { href: "", className: "fa fa-bars actions-link", onClick: eventWrappers_1.noDefault(function () { return closure.ShowActionsMenu(!closure.ShowActionsMenu()); }) }),
            React.createElement(RowActionsMenu, { closure: closure })));
});
var RowActionsMenu = supercritical_1.default(function (_a) {
    var closure = _a.closure;
    return closure.ShowActionsMenu() ?
        React.createElement(view_6.PCDismissible, { className: "pc-card actions-menu", onDismiss: function () { return closure.ShowActionsMenu(false); } },
            React.createElement("div", { className: "action-item" },
                React.createElement("a", { href: "#!schedulegrid?bclid=" + closure.Model.Id() + "&date=" + tzmoment_1.tzmoment(closure.Model.StartDate()).add(-1, 'days').format('YYYY-MM-DD') }, "View on berths"))) :
        null;
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthLookups = void 0;
var s_js_1 = __webpack_require__(0);
var BerthCapability_1 = __webpack_require__(559);
function BerthLookups(loader, domain, ajax, data, orderableLookupsModel) {
    var portLookups = orderableLookupsModel({
        supportsAdd: false,
        items: domain.Ports,
        orderProp: function (p) { return p.Order; },
        itemKey: function (p) { return p.Id(); }
    }), capabilityLookups = orderableLookupsModel({
        supportsAdd: true,
        addClient: ajax.Url(function () { return domain.BerthCapabilitiesUrl() || ''; }),
        items: domain.BerthCapabilities.filter(function (c) { return c.Active(); }),
        cacheCollection: data.BerthCapabilities,
        orderProp: function (c) { return c.Order; },
        itemFactory: function (order) { return new BerthCapability_1.BerthCapability({
            Id: 0,
            Active: true,
            Name: '--',
            Order: order
        }); },
        itemKey: function (c) { return c.Id(); },
        deleteFn: function (client, draft) { return draft.Active(false); }
    });
    loader({ Id: s_js_1.default.sample(domain.Id) }, 30);
    return {
        Model: domain,
        PortLookups: portLookups,
        CapabilityLookups: capabilityLookups
    };
}
exports.BerthLookups = BerthLookups;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthLookupsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1043);
var view_2 = __webpack_require__(12);
function BerthLookupsRoute(model, appWrapper) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.BerthLookupsView, { model: model }))
    };
}
exports.BerthLookupsRoute = BerthLookupsRoute;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthLookupsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(273);
exports.BerthLookupsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berthlookups pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "#!siteadminsettings" }, "<< Back to Site Admin Settings")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet pc-text-label-color" }),
            React.createElement("span", { className: "pc-text-label-color" }, "Site Admin Settings"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Berth Lookups")),
        React.createElement("div", { className: "page-body pc-card" },
            React.createElement(PortsView, { model: m }),
            React.createElement(CapabilitiesView, { model: m })));
});
var PortsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "ports" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Ports"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" },
            "List and arrange the ports on ",
            m.Model.DisplayableUrl(),
            ". This order will carry throughout the site, such as on the Berths Timeline, and several pages will filter content off of these names. You will add berths to each port on the Manage Berths section. Click and drag a row to reposition it on this list and throughout the site."),
        React.createElement(view_1.OrderableLookupsView, { model: m.PortLookups, columns: [{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: function (p) { return p.Name; }
                }] })));
});
var CapabilitiesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "berthcapabilities" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Capabilities"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "List the capabilities of all your berths. You will select capabilities from this list on a berth\u2019s profile. The Berths Timeline will filter berths based off these capabilities. Click and drag a row to reposition it on this list and throughout the site."),
        React.createElement(view_1.OrderableLookupsView, { model: m.CapabilityLookups, columns: [{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: function (c) { return c.Name; }
                }], addBtnText: "+Add Capability" })));
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFeed = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var pollster_1 = __webpack_require__(299);
var POLLING_INTERVAL = 300000;
function ActivityFeed(loader, domain, tzutils, personProfilePopupModel, _a) {
    var id = _a.id, _tab = _a.activityFeedTab;
    var model = loader({ OrganizationId: id }).model, tab = s_js_1.default.data(_tab), eventClock = tzutils.clock(1000), // clock for refreshing event time ago text
    missingActualsClock = tzutils.clock(30000), // clock for recalculating which actuals are missing on the Open tab
    userModel = function (user) { return UserModel(user, personProfilePopupModel); }, newReservations = model.NewReservations.map(function (res) { return NewReservationModel(res, userModel); }), newBatches = model.NewBatches.map(function (b) { return NewBatchModel(b, userModel); }), changedReservations = model.ChangedReservations.map(function (c) { return ChangedReservationModel(c, userModel); }), changedBatches = model.ChangedBatches.map(function (c) { return ChangedBatchModel(c, userModel); }), changedTopicCards = model.ChangedTopicCards.map(function (c) { return ChangedTopicCardModel(c, userModel); }), conflictedReservations = model.ConflictedReservations.map(ConflictedReservationModel), conflictedBatches = model.ConflictedBatches.map(ConflictedBatchModel), open = model.OpenReservations.map(function (res) { return OpenReservationModel(res, missingActualsClock); }), missingActuals = open.reduce(function (list, next) {
        if (next.MissingFirstLineActual())
            list = list.concat(next.MissingFirstLineActual());
        if (next.MissingLastLineActual())
            list = list.concat(next.MissingLastLineActual());
        return list;
    }, function () { return []; });
    new pollster_1.Pollster(function () { return loader({ OrganizationId: id }).task; }, POLLING_INTERVAL).start(pollster_1.PollsterStartupBehavior.Lazy);
    return {
        Model: model,
        New: newReservations
            .concat(newBatches)
            .sort(itemSort),
        Changes: changedReservations
            .concat(changedBatches)
            .concat(changedTopicCards)
            .sort(itemSort),
        Conflicts: conflictedReservations
            .concat(conflictedBatches)
            .sort(itemSort),
        Open: s_array_1.lift(missingActuals).sort(itemSort),
        Domain: domain,
        EventNow: function () { return eventClock.now(); },
        Tab: tab
    };
}
exports.ActivityFeed = ActivityFeed;
function itemSort(item1, item2) {
    return item1.SortOrder() - item2.SortOrder();
}
function NewReservationModel(item, userModel) {
    return {
        Key: function () { return 'reservation-' + item.Id(); },
        Type: 'reservation',
        Model: item,
        Requestor: s_js_1.default(function () { return item.Requestor() && userModel(item.Requestor()); }),
        ShowActions: s_js_1.default.data(false),
        // Chronologically by effective first line
        SortOrder: function () { return item.Reservation() && item.Reservation().Itinerary() ? +item.Reservation().Itinerary().Arrival.Effective() : 0; }
    };
}
function NewBatchModel(item, userModel) {
    var firstPortCall = s_js_1.default(function () { return item.FirstPortCall(); }), firstPoint = s_js_1.default(function () { return item.FirstReservationPoint(); });
    return {
        Key: function () { return 'batch-' + item.Id(); },
        Type: 'batch',
        Model: item,
        Requestor: s_js_1.default(function () { return firstPortCall() && firstPortCall().Requestor() && userModel(firstPortCall().Requestor()); }),
        FirstPortCall: firstPortCall,
        FirstReservationPoint: firstPoint,
        ShowActions: s_js_1.default.data(false),
        // Chronologically by effective first line of first reservation
        SortOrder: function () { return firstPoint() ? +firstPoint().Arrival.Effective() : 0; }
    };
}
function ChangedReservationModel(item, userModel) {
    return {
        Key: function () { return 'reservation-' + item.Id(); },
        Type: 'reservation',
        Model: item,
        Changer: s_js_1.default(function () { return item.Event() && item.Event().User() && userModel(item.Event().User()); }),
        ShowActions: s_js_1.default.data(false),
        // Reverse chronologically by event date
        SortOrder: function () { return item.Event() ? -item.Event().Date() : -Infinity; }
    };
}
function ChangedBatchModel(item, userModel) {
    var firstReservationChange = s_js_1.default(function () { return item.ReservationChanges().length > 0 ? item.ReservationChanges()[0] : null; }), firstPoint = s_js_1.default(function () { return item.Batch() && item.Batch().FirstReservationPoint(); });
    return {
        Key: function () { return 'batch-' + item.Id(); },
        Type: 'batch',
        Model: item,
        ChangerId: function () { return firstReservationChange() && firstReservationChange().Event() && firstReservationChange().Event().UserId(); },
        Changer: s_js_1.default(function () { return firstReservationChange() && firstReservationChange().Event() && firstReservationChange().Event().User() && userModel(firstReservationChange().Event().User()); }),
        NewStatus: function () { return firstReservationChange() && firstReservationChange().NewStatus(); },
        FirstReservationPoint: firstPoint,
        ShowActions: s_js_1.default.data(false),
        // Reverse chronologically by event date
        SortOrder: function () { return item.Event() ? -item.Event().Date() : -Infinity; }
    };
}
function ChangedTopicCardModel(item, userModel) {
    return {
        Key: function () { return 'topiccard-' + item.Id(); },
        Type: 'topiccard',
        Model: item,
        // TH 01/27/2017 -- Currently only expect changes w/ a Changer of null to show up here
        // b/c we only list status resets, not other kinds of topic card changes.
        // But future-proofing in case we ever list other kinds of changes.
        Changer: s_js_1.default(function () { return item.Event() && item.Event().User() && userModel(item.Event().User()); }),
        ShowActions: s_js_1.default.data(false),
        // Reverse chronologically by event date
        SortOrder: function () { return item.Event() ? -item.Event().Date() : -Infinity; }
    };
}
function ConflictedReservationModel(item) {
    return {
        Key: function () { return 'reservation-' + item.Id(); },
        Type: 'reservation',
        Model: item,
        ShowActions: s_js_1.default.data(false),
        // Chronologically by effective first line
        SortOrder: function () { return item.Itinerary() ? +item.Itinerary().Arrival.Effective() : 0; }
    };
}
function ConflictedBatchModel(item) {
    var firstPoint = s_js_1.default(function () { return item.FirstReservationPoint(); });
    return {
        Key: function () { return 'batch-' + item.Id(); },
        Type: 'batch',
        Model: item,
        FirstReservationPoint: firstPoint,
        ShowActions: s_js_1.default.data(false),
        // Chronologically by effect first line of first reservation
        SortOrder: function () { return firstPoint() ? +firstPoint().Arrival.Effective() : 0; }
    };
}
function OpenReservationModel(item, missingActualsClock) {
    var missingFirstLineActual = s_js_1.default(function () { return missing(function (pt) { return pt.Arrival; }) ? MissingActualModel(item, 0 /* FirstLine */, function (pt) { return pt.Arrival; }) : null; }), missingLastLineActual = s_js_1.default(function () { return missing(function (pt) { return pt.Departure; }) ? MissingActualModel(item, 1 /* LastLine */, function (pt) { return pt.Departure; }) : null; });
    return {
        MissingFirstLineActual: missingFirstLineActual,
        MissingLastLineActual: missingLastLineActual
    };
    function missing(lineTime) {
        return !!item.Itinerary() && isMissingActual(lineTime(item.Itinerary()), missingActualsClock);
    }
}
function MissingActualModel(item, lineType, lineTime) {
    return {
        Key: function () { return item.Id() + ',' + lineType; },
        Model: item,
        LineType: lineType,
        ShowActions: s_js_1.default.data(false),
        // Chronologically by whichever line time is missing
        SortOrder: function () { return item.Itinerary() ? +lineTime(item.Itinerary()).Estimated() : 0; }
    };
}
function isMissingActual(lineTime, missingActualsClock) {
    if (lineTime.Actual() !== null)
        return false; // actual time has been specified
    var now = s_js_1.default.sample(missingActualsClock.now);
    if (lineTime.Estimated() >= now) {
        // estimated hasn't occurred yet
        // TH 11/21/2016: Since missingActualsClock.now() can only move in one direction,
        // we only need to subscribe to the clock's now value if the estimated time is in the future.
        // Once the estimated time is in the past, it will stay in the past.
        missingActualsClock.now();
        return false;
    }
    // there's no actual and the estimate has already occurred
    return true;
}
function UserModel(user, personProfilePopupModel) {
    var showProfile = s_js_1.default.data(false), profilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({ id: user.Id(), onHidePopup: function () { return showProfile(false); } }) : null; });
    return {
        Model: user,
        ToggleProfile: function () { return showProfile(!showProfile()); },
        ProfilePopup: profilePopup
    };
}


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFeedView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var BerthReservation_1 = __webpack_require__(38);
var view_1 = __webpack_require__(35);
var view_2 = __webpack_require__(52);
var view_3 = __webpack_require__(78);
var view_4 = __webpack_require__(68);
var LINE_TIME_FORMAT = 'MM/DD/YYYY [at] HH:mm';
exports.ActivityFeedView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("section", { className: "activity-feed" },
        React.createElement("header", null, "Activity Feed"),
        React.createElement(TabBar, { model: m }),
        React.createElement(NewTabContent, { model: m }),
        React.createElement(ChangesTabContent, { model: m }),
        React.createElement(ConflictsTabContent, { model: m }),
        React.createElement(OpenTabContent, { model: m }));
});
var TabBar = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "activity-feed-tabs" },
        React.createElement(TabSelector, { model: m, name: "New", className: "new", tab: 0 /* New */, items: m.New }),
        React.createElement(TabSelector, { model: m, name: "Changes", className: "changes", tab: 1 /* Changes */, items: m.Changes }),
        React.createElement(TabSelector, { model: m, name: "Conflicts", className: "conflicts", tab: 2 /* Conflicts */, items: m.Conflicts }),
        React.createElement(TabSelector, { model: m, name: "Open", className: "open", tab: 3 /* Open */, items: m.Open }));
});
var TabSelector = supercritical_1.default(function (_a) {
    var m = _a.model, tab = _a.tab, items = _a.items, name = _a.name, className = _a.className;
    return React.createElement("div", { className: cx('activity-feed-tab-selector pc-card', className, {
            selected: tab === m.Tab()
        }), onClick: function () { return m.Tab(tab); } },
        React.createElement("div", { className: "tab-name" }, name),
        React.createElement("div", { className: "tab-count" }, items().length));
});
var ActivityFeedTabContent = /** @class */ (function (_super) {
    __extends(ActivityFeedTabContent, _super);
    function ActivityFeedTabContent(props, tab) {
        var _this = _super.call(this, props) || this;
        _this.tab = tab;
        return _this;
    }
    ActivityFeedTabContent.prototype.srender = function (_a) {
        var _this = this;
        var m = _a.model;
        if (m.Tab() !== this.tab)
            return null;
        return (React.createElement("div", null, this.items(m).map(function (item) { return _this.renderItem(item, m); })));
    };
    return ActivityFeedTabContent;
}(supercritical_1.SuperCriticalComponent));
var NewTabContent = /** @class */ (function (_super) {
    __extends(NewTabContent, _super);
    function NewTabContent(props) {
        return _super.call(this, props, 0 /* New */) || this;
    }
    NewTabContent.prototype.items = function (m) {
        return m.New();
    };
    NewTabContent.prototype.renderItem = function (item, m) {
        return (React.createElement(NewTabItem, { item: item, model: m, key: item.Key() }));
    };
    return NewTabContent;
}(ActivityFeedTabContent));
var ChangesTabContent = /** @class */ (function (_super) {
    __extends(ChangesTabContent, _super);
    function ChangesTabContent(props) {
        return _super.call(this, props, 1 /* Changes */) || this;
    }
    ChangesTabContent.prototype.items = function (m) {
        return m.Changes();
    };
    ChangesTabContent.prototype.renderItem = function (item, m) {
        return (React.createElement(ChangesTabItem, { item: item, model: m, key: item.Key() }));
    };
    return ChangesTabContent;
}(ActivityFeedTabContent));
var ConflictsTabContent = /** @class */ (function (_super) {
    __extends(ConflictsTabContent, _super);
    function ConflictsTabContent(props) {
        return _super.call(this, props, 2 /* Conflicts */) || this;
    }
    ConflictsTabContent.prototype.items = function (m) {
        return m.Conflicts();
    };
    ConflictsTabContent.prototype.renderItem = function (item, m) {
        return (React.createElement(ConflictsTabItem, { item: item, model: m, key: item.Key() }));
    };
    return ConflictsTabContent;
}(ActivityFeedTabContent));
var OpenTabContent = /** @class */ (function (_super) {
    __extends(OpenTabContent, _super);
    function OpenTabContent(props) {
        return _super.call(this, props, 3 /* Open */) || this;
    }
    OpenTabContent.prototype.items = function (m) {
        return m.Open();
    };
    OpenTabContent.prototype.renderItem = function (item, m) {
        return (React.createElement(OpenTabItem, { item: item, model: m, key: item.Key() }));
    };
    return OpenTabContent;
}(ActivityFeedTabContent));
var NewTabItem = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return item.Type === 'reservation' ?
        React.createElement(NewReservationView, { item: item, model: m }) :
        React.createElement(NewBatchView, { item: item, model: m });
});
var NewReservationView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return React.createElement("div", { className: "pc-card tab-item-card" },
        item.Model.Reservation() && React.createElement(ReservationActionsView, { reservation: item.Model.Reservation(), showActions: item.ShowActions }),
        React.createElement(CardAttributionWithUserAndDate, { user: item.Requestor, date: function () { return item.Model.Reservation() && item.Model.Reservation().RequestDate(); }, now: m.EventNow }),
        React.createElement(NewReservationText, { item: item }),
        item.Model.Reservation() && React.createElement(ReservationSummaryView, { reservation: item.Model.Reservation() }));
});
var NewReservationText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null,
        "Submitted a new reservation for ",
        item.Model.Reservation() && item.Model.Reservation().Itinerary() && tzmoment_1.tzmoment(item.Model.Reservation().Itinerary().Arrival.Effective()).format('dddd ' + LINE_TIME_FORMAT),
        ".");
});
var NewBatchView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return React.createElement("div", { className: "pc-card tab-item-card" },
        React.createElement(BatchActionsView, { batch: item.Model, showActions: item.ShowActions }),
        React.createElement(CardAttributionWithUserAndDate, { user: item.Requestor, date: item.Model.RequestDate, now: m.EventNow }),
        React.createElement(NewBatchText, { item: item }),
        React.createElement(BatchSummaryView, { batch: item.Model, firstReservationPoint: item.FirstReservationPoint }));
});
var NewBatchText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null,
        "Submitted a new batch for ",
        item.FirstPortCall() && item.FirstPortCall().DisplayVesselIdentifier(),
        ".");
});
var ChangesTabItem = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return item.Type === 'reservation' ? React.createElement(ChangedReservationView, { item: item, model: m }) :
        item.Type === 'batch' ? React.createElement(ChangedBatchView, { item: item, model: m }) :
            React.createElement(ChangedTopicCardView, { item: item, model: m });
});
var ChangedReservationView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    var date = function () { return item.Model.Event() && item.Model.Event().Date(); };
    return (React.createElement("div", { className: "pc-card tab-item-card" },
        item.Model.Reservation() && React.createElement(ReservationActionsView, { reservation: item.Model.Reservation(), showActions: item.ShowActions }),
        item.Model.Event() && item.Model.Event().UserId() ?
            React.createElement(CardAttributionWithUserAndDate, { user: item.Changer, date: date, now: m.EventNow }) :
            React.createElement(CardAttributionWithDomainAndDate, { domain: m.Domain, date: date, now: m.EventNow }),
        React.createElement(ChangedReservationText, { item: item }),
        item.Model.Reservation() && React.createElement(ReservationSummaryView, { reservation: item.Model.Reservation() })));
});
var ChangedReservationText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null,
        "Changed status to",
        ' ',
        BerthReservation_1.BerthReservationStatusDisplayName[item.Model.NewStatus()],
        ".");
});
var ChangedBatchView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    var date = function () { return item.Model.Event() && item.Model.Event().Date(); };
    return (React.createElement("div", { className: "pc-card tab-item-card" },
        item.Model.Batch() && React.createElement(BatchActionsView, { batch: item.Model.Batch(), showActions: item.ShowActions }),
        item.ChangerId() ?
            React.createElement(CardAttributionWithUserAndDate, { user: item.Changer, date: date, now: m.EventNow }) :
            React.createElement(CardAttributionWithDomainAndDate, { domain: m.Domain, date: date, now: m.EventNow }),
        React.createElement(ChangedBatchText, { item: item }),
        item.Model.Batch() && React.createElement(BatchSummaryView, { batch: item.Model.Batch(), firstReservationPoint: item.FirstReservationPoint })));
});
var ChangedBatchText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null,
        "Changed",
        ' ',
        item.Model.ReservationChanges().length,
        ' ',
        "out of",
        ' ',
        item.Model.Batch() && item.Model.Batch().Reservations().length,
        ' ',
        "batch reservations status to",
        ' ',
        item.NewStatus() === null ? null : BerthReservation_1.BerthReservationStatusDisplayName[item.NewStatus()],
        ".");
});
var ChangedTopicCardView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    var date = function () { return item.Model.Event() && item.Model.Event().Date(); };
    return (React.createElement("div", { className: "pc-card tab-item-card" },
        item.Model.Card() && React.createElement(TopicCardActionsView, { card: item.Model.Card(), showActions: item.ShowActions }),
        item.Model.Event() && item.Model.Event().UserId() ?
            React.createElement(CardAttributionWithUserAndDate, { user: item.Changer, date: date, now: m.EventNow }) :
            React.createElement(CardAttributionWithDomainAndDate, { domain: m.Domain, date: date, now: m.EventNow }),
        React.createElement(ChangedTopicCardText, { item: item }),
        item.Model.Card() && React.createElement(TopicCardSummaryView, { card: item.Model.Card() })));
});
var ChangedTopicCardText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null, "Changed status for topic card.");
});
var ConflictsTabItem = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return item.Type === 'reservation' ?
        React.createElement(ConflictedReservationView, { item: item, model: m }) :
        React.createElement(ConflictedBatchView, { item: item, model: m });
});
var ConflictedReservationView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return React.createElement("div", { className: "pc-card tab-item-card" },
        React.createElement(ReservationActionsView, { reservation: item.Model, showActions: item.ShowActions }),
        React.createElement(CardAttributionWithDomain, { domain: m.Domain }),
        React.createElement(ConflictedReservationText, { item: item }),
        React.createElement(ReservationSummaryView, { reservation: item.Model }));
});
var ConflictedReservationText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", { className: "conflict-item-text" },
        React.createElement(VesselNameView, { point: item.Model.Itinerary }),
        ' ',
        "is in conflict because it",
        ' ',
        view_4.ConflictReasonText(item.Model.Issues),
        ".");
});
var ConflictedBatchView = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return React.createElement("div", { className: "pc-card tab-item-card" },
        React.createElement(BatchActionsView, { batch: item.Model, showActions: item.ShowActions }),
        React.createElement(CardAttributionWithDomain, { domain: m.Domain }),
        React.createElement(ConflictedBatchText, { item: item }),
        React.createElement(BatchSummaryView, { batch: item.Model, firstReservationPoint: item.FirstReservationPoint, showConflicted: true }));
});
var ConflictedBatchText = supercritical_1.default(function (_a) {
    var item = _a.item;
    return React.createElement("div", null,
        item.Model.Reservations().filter(function (r) { return r.Status() === BerthReservation_1.BerthReservationStatus.Conflicted; }).length,
        ' ',
        "out of",
        ' ',
        item.Model.Reservations().length,
        ' ',
        "reservations are in conflict.");
});
var OpenTabItem = supercritical_1.default(function (_a) {
    var item = _a.item, m = _a.model;
    return React.createElement("div", { className: "pc-card tab-item-card" },
        React.createElement(ReservationActionsView, { reservation: item.Model, showActions: item.ShowActions }),
        React.createElement(CardAttributionWithDomain, { domain: m.Domain }),
        React.createElement(OpenItemText, { item: item, lineType: item.LineType }),
        React.createElement(ReservationSummaryView, { reservation: item.Model, showOnly: item.LineType }));
});
var OpenItemText = supercritical_1.default(function (_a) {
    var item = _a.item, lineType = _a.lineType;
    return React.createElement("div", { className: "open-item-text" },
        React.createElement(VesselNameView, { point: item.Model.Itinerary }),
        ' ',
        "is still missing",
        ' ',
        lineType === 0 /* FirstLine */ ? 'First Line Actual' : 'Last Line Actual',
        ".");
});
var ReservationActionsView = supercritical_1.default(function (_a) {
    var res = _a.reservation, showActions = _a.showActions;
    return React.createElement(ActivityActionsContainer, { showActions: showActions },
        React.createElement("div", { className: "action-item" }, res.Itinerary() && React.createElement("a", { href: '#!portcallprofile?id=' + res.Itinerary().PortCallId() }, "View PortCall")),
        res.Status() !== BerthReservation_1.BerthReservationStatus.Cancelled &&
            React.createElement("div", { className: "action-item" }, res.Itinerary() && React.createElement("a", { href: '#!schedulegrid?date=' + tzmoment_1.tzmoment(res.Itinerary().Arrival.Effective()).add(-1, 'days').format('YYYY-MM-DD') + '&resid=' + res.Id() }, "View on Berths")));
});
var BatchActionsView = supercritical_1.default(function (_a) {
    var batch = _a.batch, showActions = _a.showActions;
    return React.createElement(ActivityActionsContainer, { showActions: showActions },
        React.createElement("div", { className: "action-item" },
            React.createElement("a", { href: '#!reservationsinbatch?batchId=' + batch.Id() }, "View Batch")));
});
var TopicCardActionsView = supercritical_1.default(function (_a) {
    var card = _a.card, showActions = _a.showActions;
    return React.createElement(ActivityActionsContainer, { showActions: showActions },
        React.createElement("div", { className: "action-item" },
            React.createElement("a", { href: "#!topiccards?id=" + card.PortCallId() + "&cardId=" + card.Id() }, "View Card")));
});
var ActivityActionsContainer = supercritical_1.default(function (_a) {
    var showActions = _a.showActions, children = _a.children;
    return React.createElement("div", { className: "activity-actions-container" },
        React.createElement("a", { href: "", className: "fa fa-bars actions-toggle", onClick: eventWrappers_1.noDefault(function () { return showActions(!showActions()); }) }),
        showActions() &&
            React.createElement(view_1.PCDismissible, { className: "activity-actions-menu pc-card", onDismiss: function () { return showActions(false); } }, children));
});
var CardAttributionBase = /** @class */ (function (_super) {
    __extends(CardAttributionBase, _super);
    function CardAttributionBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardAttributionBase.prototype.srender = function (props) {
        return (React.createElement("div", { className: "card-attribution" },
            React.createElement("div", { className: "attribution-thumb" }, this.thumb(props)),
            React.createElement("div", { className: "attribution-text" },
                React.createElement("div", { className: "attribution-text-primary" }, this.textPrimary(props)),
                this.textSecondary && React.createElement("div", { className: "attribution-text-secondary pc-text-smalllabel" }, this.textSecondary(props)))));
    };
    return CardAttributionBase;
}(supercritical_1.SuperCriticalComponent));
var bollardThumb = function () { return React.createElement("span", { className: "attribution-icon icon-bollard" }); };
var domainText = function (_a) {
    var domain = _a.domain;
    return React.createElement("span", { className: "domain-url" }, domain.DisplayableUrl());
};
var CardAttributionWithDomain = /** @class */ (function (_super) {
    __extends(CardAttributionWithDomain, _super);
    function CardAttributionWithDomain() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thumb = bollardThumb;
        _this.textPrimary = domainText;
        _this.textSecondary = null;
        return _this;
    }
    return CardAttributionWithDomain;
}(CardAttributionBase));
var CardAttributionWithDomainAndDate = /** @class */ (function (_super) {
    __extends(CardAttributionWithDomainAndDate, _super);
    function CardAttributionWithDomainAndDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thumb = bollardThumb;
        _this.textPrimary = domainText;
        _this.textSecondary = function (_a) {
            var date = _a.date, now = _a.now;
            return React.createElement(DateTooltip, { date: date, now: now });
        };
        return _this;
    }
    return CardAttributionWithDomainAndDate;
}(CardAttributionBase));
var CardAttributionWithUserAndDate = /** @class */ (function (_super) {
    __extends(CardAttributionWithUserAndDate, _super);
    function CardAttributionWithUserAndDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thumb = function (_a) {
            var user = _a.user;
            return user() && React.createElement("img", { className: "attribution-img", src: user().Model.Image.ThumbUrl() });
        };
        _this.textPrimary = function (_a) {
            var user = _a.user;
            return user() &&
                React.createElement("div", null,
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(user().ToggleProfile) }, user().Model.FullName()),
                    React.createElement(view_3.PersonProfilePopupView, { modelContainer: user().ProfilePopup }));
        };
        _this.textSecondary = function (_a) {
            var user = _a.user, date = _a.date, now = _a.now;
            return React.createElement("div", null,
                React.createElement("span", null, user() && user().Model.Organization() && user().Model.Organization().Name()),
                ' ',
                React.createElement("span", null, "|"),
                ' ',
                React.createElement(DateTooltip, { className: "date-tooltip-inline", date: date, now: now }));
        };
        return _this;
    }
    return CardAttributionWithUserAndDate;
}(CardAttributionBase));
var DateTooltip = supercritical_1.default(function (_a) {
    var date = _a.date, now = _a.now, className = _a.className;
    if (!date())
        return null;
    return (React.createElement(view_2.TimeAgoTooltip, { date: function () { return date(); }, now: now, className: className }));
});
var ReservationSummaryView = supercritical_1.default(function (_a) {
    var res = _a.reservation, showOnly = _a.showOnly;
    return React.createElement("div", { className: cx('reservation-summary', {
            conflicted: res.Status() === BerthReservation_1.BerthReservationStatus.Conflicted,
            booked: res.Status() === BerthReservation_1.BerthReservationStatus.Booked,
            inport: !!res.Itinerary() && !!res.Itinerary().Arrival.Actual() && !res.Itinerary().Departure.Actual()
        }) },
        React.createElement(VesselNameView, { point: res.Itinerary }),
        React.createElement(BerthNameView, { point: res.Itinerary }),
        showOnly !== 1 /* LastLine */ &&
            React.createElement(LineTimeView, { reservation: res, name: "First Line", lineTime: function (pt) { return pt.Arrival; } }),
        showOnly !== 0 /* FirstLine */ &&
            React.createElement(LineTimeView, { reservation: res, name: "Last Line", lineTime: function (pt) { return pt.Departure; } }));
});
var LineTimeView = supercritical_1.default(function (_a) {
    var res = _a.reservation, name = _a.name, lineTime = _a.lineTime;
    return React.createElement("div", { className: "line-time" },
        React.createElement("label", { className: "pc-text-smalllabel line-time-label" }, name),
        React.createElement("span", null, res.Itinerary() && tzmoment_1.tzmoment(lineTime(res.Itinerary()).Effective()).format(LINE_TIME_FORMAT)));
});
var BatchSummaryView = supercritical_1.default(function (_a) {
    var batch = _a.batch, pt = _a.firstReservationPoint, showConflicted = _a.showConflicted;
    return React.createElement("div", { className: cx('batch-summary', {
            conflicted: !!showConflicted
        }) },
        React.createElement(VesselNameView, { point: pt }),
        React.createElement(BerthNameView, { point: pt }),
        React.createElement("div", { className: "batch-detail-line" },
            batch.ReservationPoints().length,
            " Reservations"),
        React.createElement("div", { className: "batch-detail-line" }, batch.RecurrencePeriod.toString()));
});
var TopicCardSummaryView = supercritical_1.default(function (_a) {
    var card = _a.card;
    return React.createElement("div", { className: "topic-card-summary" },
        React.createElement("div", { className: "vessel" }, card.PortCall() && card.PortCall().DisplayVesselIdentifier()),
        React.createElement("div", { className: "card-title" }, card.Title()));
});
var VesselNameView = supercritical_1.default(function (_a) {
    var pt = _a.point;
    return React.createElement("div", { className: "vessel" }, pt() && pt().PortCall() && pt().PortCall().DisplayVesselIdentifier());
});
var BerthNameView = supercritical_1.default(function (_a) {
    var pt = _a.point;
    var loc = pt() && pt().Location();
    return loc &&
        React.createElement("div", { className: "berth" },
            loc.Port() && loc.Port().Name(),
            ' ',
            loc.Name());
});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthManagerDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ActivityFeedResponse_1 = __webpack_require__(1218);
var OperationsForecast_1 = __webpack_require__(1294);
var ServicesDashboardResponse_1 = __webpack_require__(1352);
var BerthManagerDashboardCache = /** @class */ (function () {
    function BerthManagerDashboardCache(data) {
        this.ActivityFeedResponses = PCCache_1.PCCollection(ActivityFeedResponse_1.ActivityFeedResponse);
        this.ActivityFeedNewReservations = PCCache_1.PCCollection(ActivityFeedResponse_1.ActivityFeedNewReservation);
        this.OperationsForecastResponses = PCCache_1.PCCollection(OperationsForecast_1.OperationsForecastResponse);
        this.PortOperations = PCCache_1.PCCollection(OperationsForecast_1.OperationsForecastPort);
        this.PortDayOperations = PCCache_1.PCCollection(OperationsForecast_1.OperationsForecastPortDay);
        this.ServicesDashboardResponses = PCCache_1.PCCollection(ServicesDashboardResponse_1.ServicesDashboardResponse);
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, this.ActivityFeedNewReservations, function (r) { return r.NewReservations; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatches, function (r) { return r.NewBatches; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.PortCallChanges, function (r) { return r.ChangedReservations; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatchChanges, function (r) { return r.ChangedBatches; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.TopicCardChanges, function (r) { return r.ChangedTopicCards; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.BerthReservations, function (r) { return r.ConflictedReservations; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatches, function (r) { return r.ConflictedBatches; });
        new DataCache_1.QueryResultsRelationship(this.ActivityFeedResponses, data.BerthReservations, function (r) { return r.OpenReservations; });
        new DataCache_1.SharedKeyRelationship(this.ActivityFeedNewReservations, data.BerthReservations, function (e) { return e.Reservation; }, null);
        new DataCache_1.ForeignKeyRelationship(data.PCUsers, this.ActivityFeedNewReservations, null, function (e) { return e.Requestor; }, function (e) { return e.RequestorId(); });
        new DataCache_1.QueryResultsRelationship(this.OperationsForecastResponses, this.PortOperations, function (f) { return f.Ports; });
        new DataCache_1.QueryResultsRelationship(this.PortOperations, this.PortDayOperations, function (p) { return p.Days; });
        new DataCache_1.ForeignKeyRelationship(data.Ports, this.PortOperations, null, function (m) { return m.Port; }, function (m) { return m.PortId(); });
        new DataCache_1.QueryResultsRelationship(this.ServicesDashboardResponses, data.TopicCards, function (r) { return r.Services; });
    }
    return BerthManagerDashboardCache;
}());
exports.BerthManagerDashboardCache = BerthManagerDashboardCache;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsForecast = void 0;
var OperationsForecast = function (params, currentTab, tzutils, loader) {
    var Model = loader({ OrganizationId: params.id, Date: tzutils.today().toJSON() }).model;
    return { Model: Model, CurrentTab: currentTab };
};
exports.OperationsForecast = OperationsForecast;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsForecastView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(193);
exports.OperationsForecastView = supercritical_1.default(function (_a) {
    var _b = _a.model, Ports = _b.Model.Ports, CurrentTab = _b.CurrentTab;
    return React.createElement("section", { className: "operations-forecast" },
        React.createElement("header", null,
            "Operations Forecast",
            React.createElement("a", { href: "#!schedulegrid?compact=1" }, "View Compact")),
        Ports().map(function (port) {
            return React.createElement("div", { className: "port-operations" },
                React.createElement("h4", null, port.Port() && port.Port().Name()),
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null),
                            port.Days().map(function (day, i) {
                                return React.createElement("th", null, i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                        "Day 3");
                            }))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "right-align" }, "Arrivals"),
                            port.Days().map(function (day) {
                                return React.createElement("td", null, day.Arrivals());
                            })),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "right-align" }, "Departures"),
                            port.Days().map(function (day) {
                                return React.createElement("td", null, day.Departures());
                            })),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "right-align" }, "Shifts"),
                            port.Days().map(function (day) {
                                return React.createElement("td", null, day.Shifts());
                            })))));
        }),
        React.createElement("header", null,
            "Pier-Side Services",
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function (e) { return CurrentTab(model_1.Tab.Services); }) }, "View Services")),
        Ports().map(function (port) {
            return React.createElement("div", { className: "port-operations" },
                React.createElement("h4", null, port.Port() && port.Port().Name()),
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null),
                            port.Days().map(function (day, i) {
                                return React.createElement("th", null, i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                        "Day 3");
                            }))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null),
                            port.Days().map(function (day) {
                                return React.createElement("td", null, day.Services());
                            })))));
        }),
        React.createElement("header", null,
            "Scheduled Vessels In Port",
            React.createElement("a", { href: "#!?tab=1" }, "View In-Port")),
        Ports().map(function (port) {
            return React.createElement("div", { className: "port-operations" },
                React.createElement("h4", null, port.Port() && port.Port().Name()),
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null),
                            port.Days().map(function (day, i) {
                                return React.createElement("th", null, i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                        "Day 3");
                            }))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null),
                            port.Days().map(function (day) {
                                return React.createElement("td", null, day.ScheduledVessels());
                            })))));
        }));
});


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthManagerDashboardRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var view_1 = __webpack_require__(12);
var model_1 = __webpack_require__(193);
var view_2 = __webpack_require__(1051);
var servicesdashboard_1 = __webpack_require__(265);
var BerthManagerDashboardRoute = function (model, appWrapper, tzutils, loc) {
    var m = model(inboundParams(loc.params, tzutils));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper, navbarTab: 3 /* More */ },
            React.createElement(view_2.BerthManagerDashboardView, { model: m, tzutils: tzutils })),
        reflectState: function () { return outboundParams(loc, m, tzutils); }
    };
};
exports.BerthManagerDashboardRoute = BerthManagerDashboardRoute;
var inboundParams = function (p, tzutils) { return ({
    id: +(p["id"] || 0),
    tab: 'tab' in p ? +(p["tab"] || 0) : model_1.Tab.Activity,
    activityFeedTab: 'activityFeedTab' in p ? +(p["activityFeedTab"] || 0) : 0 /* New */,
    date: p["date"] ? tzutils.setTimezoneOffset(new TZDate_1.default(p["date"] + "T00:00:00Z"), true) : tzutils.today(),
    filter: p["filter"] || '',
    sort: 'sort' in p ? +(p['sort'] || 0) : servicesdashboard_1.Column.Time,
    reversed: !!p['reversed']
}); }, outboundParams = function (loc, m, tzutils) {
    var p = {};
    p["id"] = m.Id + '';
    if (m.CurrentTab() !== model_1.Tab.Activity)
        p["tab"] = m.CurrentTab() + '';
    if (m.ActivityFeed.Tab() !== 0 /* New */)
        p["activityFeedTab"] = m.ActivityFeed.Tab() + '';
    if (!TZDate_1.default.eq(m.ServicesDashboard.Date(), tzutils.today()))
        p["date"] = tzmoment_1.tzmoment(m.ServicesDashboard.Date()).format("YYYY-MM-DD");
    if (m.ServicesDashboard.Filter())
        p['filter'] = m.ServicesDashboard.Filter();
    if (m.ServicesDashboard.Sort() !== servicesdashboard_1.Column.Time)
        p['sort'] = m.ServicesDashboard.Sort() + '';
    if (m.ServicesDashboard.SortReversed())
        p['reversed'] = '1';
    return new componentLocation_1.Location(loc.name, p);
};


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = exports.TableBody = exports.TableHead = exports.ServicesTable = exports.ControlsView = exports.ServicesDashboardView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var tzmoment_1 = __webpack_require__(9);
var servicesdashboard_1 = __webpack_require__(265);
var view_1 = __webpack_require__(40);
var TopicCardStatus_1 = __webpack_require__(137);
var StatusNames = (_a = {},
    _a[TopicCardStatus_1.TopicCardStatus.Confirmed] = 'Confirmed',
    _a[TopicCardStatus_1.TopicCardStatus.Denied] = 'Denied',
    _a[TopicCardStatus_1.TopicCardStatus.PendingReview] = 'Pending',
    _a);
exports.ServicesDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model, tzutils = _a.tzutils;
    return React.createElement("div", { className: "services-dashboard" },
        React.createElement(exports.ControlsView, { model: m, tzutils: tzutils }),
        React.createElement(view_1.PageLoadingIndicator, { loading: m.Loading }),
        React.createElement(exports.ServicesTable, { model: m }));
}), exports.ControlsView = /** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.calendarRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var model = _a.model, tzutils = _a.tzutils;
            _this.calendar = window.kendo.jQuery(el).kendoDatePicker({
                change: function () {
                    var selectedDate = tzutils.tzify(this.value());
                    var diff = selectedDate.getTime() - s_js_1.default.sample(model.Date).getTime();
                    var diffInDays = Math.round(diff / (24 * 60 * 60 * 1000));
                    model.AddDays(diffInDays);
                },
                open: function () {
                    this.value(tzutils.localify(s_js_1.default.sample(model.Date)));
                }
            }).data('kendoDatePicker');
        });
        return _this;
    }
    class_1.prototype.srender = function (_a) {
        var _this = this;
        var m = _a.model;
        return (React.createElement("div", { className: "controls" },
            React.createElement("input", { className: "pc-reports-filter", type: "text", placeholder: "Filter By \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }),
            React.createElement("div", { className: "date-navigator" },
                React.createElement("div", { className: "pc-button date-arrow", onClick: eventWrappers_1.noDefault(function () { return m.AddDays(-1); }) },
                    React.createElement("span", { className: "glyphicon glyphicon-chevron-left" })),
                React.createElement("div", { className: "pc-button today", onClick: eventWrappers_1.noDefault(function () { return m.Date(m.Today); }) }, "Today"),
                React.createElement("div", { className: "pc-button date-arrow", onClick: eventWrappers_1.noDefault(function () { return m.AddDays(1); }) },
                    React.createElement("span", { className: "glyphicon glyphicon-chevron-left mirror-glyphicon IE-mirror-glyphicon" })),
                React.createElement("div", { ref: this.calendarRef, className: "datepicker-widget" })),
            React.createElement("div", { className: "pc-button date-calendar", onClick: eventWrappers_1.noDefault(function () { return _this.calendar.open(); }) },
                React.createElement("span", { className: "glyphicon glyphicon-calendar" })),
            React.createElement("div", { className: "date-text" }, tzmoment_1.tzmoment(m.Date()).format('ddd MMM D, YYYY'))));
    };
    return class_1;
}(supercritical_1.SuperCriticalComponent)), exports.ServicesTable = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("table", { className: cx('table', {
            'sort-reversed': m.SortReversed()
        }) },
        React.createElement(exports.TableHead, { model: m }),
        React.createElement(exports.TableBody, { model: m }));
}), exports.TableHead = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("thead", null,
        React.createElement("tr", null,
            servicesdashboard_1.Columns.map(function (col) {
                return React.createElement("th", { className: 'col-' + servicesdashboard_1.Column[col].toLowerCase() + (m.Sort() === col ? ' sort-col' : ''), onClick: eventWrappers_1.noDefault(function () { return m.SortToggle(col); }), key: col },
                    React.createElement("a", { href: "" }, servicesdashboard_1.Column[col]),
                    React.createElement("i", null));
            }),
            React.createElement("th", { className: "col-link" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return void 0; }) }, "Link"))));
}), exports.TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.DisplayedServices().map(function (row) {
        return React.createElement(exports.TableRow, { row: row, key: row.Id(), onClick: m.OnClickService });
    }));
}), exports.TableRow = supercritical_1.default(function (_a) {
    var row = _a.row, onClick = _a.onClick;
    return React.createElement("tr", { onClick: function () { return onClick(row); } },
        React.createElement("td", { className: "col-status" }, StatusNames[row.Status()]),
        React.createElement("td", { className: "col-time" }, row.TimeEntry.Response() && tzmoment_1.tzmoment(row.TimeEntry.Response()).format('HH:mm')),
        React.createElement("td", { className: "col-label" }, row.AmenityType() && row.AmenityType().Name()),
        React.createElement("td", { className: "col-topic" }, row.Title()),
        React.createElement("td", { className: "col-vessel" }, row.PortCall() && row.PortCall().DisplayVesselIdentifier()),
        React.createElement("td", { className: "col-berth" }, row.Berth() && row.Berth().Location() && row.Berth().Location().Name()),
        React.createElement("td", { className: "col-link" },
            React.createElement("a", null, "View Card")));
});


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesView = exports.ActivityView = exports.BerthManagerDashboardView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var model_1 = __webpack_require__(193);
var operationsforecastview_1 = __webpack_require__(1048);
var activityfeedview_1 = __webpack_require__(1045);
var servicesdashboardview_1 = __webpack_require__(1050);
exports.BerthManagerDashboardView = supercritical_1.default(function (_a) {
    var model = _a.model, CurrentTab = _a.model.CurrentTab, tzutils = _a.tzutils;
    return React.createElement("div", { className: "berthmanager-dashboard" },
        React.createElement("header", null,
            React.createElement("div", { className: "pc-page-title" }, "Berth Managers Dashboard"),
            React.createElement("ul", { className: "tabs" },
                React.createElement("li", { className: CurrentTab() === model_1.Tab.Activity ? 'selected' : '', onClick: function () { return CurrentTab(model_1.Tab.Activity); } }, "Activity"),
                React.createElement("li", { className: CurrentTab() === model_1.Tab.Services ? 'selected' : '', onClick: function () { return CurrentTab(model_1.Tab.Services); } }, "Services"))),
        CurrentTab() === model_1.Tab.Activity ? React.createElement(exports.ActivityView, { model: model }) :
            CurrentTab() === model_1.Tab.Services ? React.createElement(exports.ServicesView, { model: model, tzutils: tzutils }) :
                null);
}), exports.ActivityView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("section", { className: "activity" },
        React.createElement(activityfeedview_1.ActivityFeedView, { model: model.ActivityFeed }),
        React.createElement(operationsforecastview_1.OperationsForecastView, { model: model.OperationsForecast }));
}), exports.ServicesView = supercritical_1.default(function (_a) {
    var model = _a.model, tzutils = _a.tzutils;
    return React.createElement("section", { className: "services" },
        React.createElement(servicesdashboardview_1.ServicesDashboardView, { model: model.ServicesDashboard, tzutils: tzutils }));
});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthProfileCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var BerthProfileResponse_1 = __webpack_require__(562);
var BerthProfileCache = /** @class */ (function (_super) {
    __extends(BerthProfileCache, _super);
    function BerthProfileCache(data) {
        var _this = _super.call(this) || this;
        _this.BerthProfileResponses = PCCache_1.PCCollection(BerthProfileResponse_1.BerthProfileResponse);
        new DataCache_1.SharedKeyRelationship(_this.BerthProfileResponses, data.Berths, function (r) { return r.Berth; }, null);
        new DataCache_1.QueryResultsRelationship(_this.BerthProfileResponses, data.BerthAmenityTypes, function (r) { return r.Ref && r.Ref.AmenityTypes; });
        new DataCache_1.QueryResultsRelationship(_this.BerthProfileResponses, data.BerthCapabilities, function (r) { return r.Ref && r.Ref.Capabilities; });
        new DataCache_1.QueryResultsRelationship(_this.BerthProfileResponses, data.Organizations, function (r) { return r.Ref && r.Ref.Organizations; });
        new DataCache_1.QueryResultsRelationship(_this.BerthProfileResponses, data.Ports, function (r) { return r.Ref && r.Ref.Ports; });
        return _this;
    }
    return BerthProfileCache;
}(DataCache_1.DataCache));
exports.BerthProfileCache = BerthProfileCache;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var L = __webpack_require__(142);
var supercritical_1 = __webpack_require__(4);
var ZoneCoordinates_1 = __webpack_require__(115);
var maptools_1 = __webpack_require__(529);
__webpack_require__(347);
__webpack_require__(242);
var MapView = /** @class */ (function (_super) {
    __extends(MapView, _super);
    function MapView(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, loadMap);
        return _this;
    }
    MapView.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("div", { className: "berth-map", ref: this.ref }));
    };
    return MapView;
}(supercritical_1.SuperCriticalComponent));
exports.MapView = MapView;
function loadMap(_a, el) {
    var m = _a.model;
    var settings = m.DomainSettings.Map, map = L.map(el, { attributionControl: true });
    s_js_1.default.cleanup(function () { return map.remove(); });
    L.tileLayer(L.TileLayer.Provider.providers.Esri.url, L.TileLayer.Provider.providers.Esri.variants.WorldImagery.options).addTo(map);
    var featureGroup = new L.FeatureGroup();
    featureGroup.addTo(map);
    var mapZoomInitialized = false;
    s_js_1.default(function () {
        var location = m.Berth() && m.Berth().Location();
        if (!location)
            return;
        s_js_1.default(function () {
            // draw berth zone
            var coords = location.Coords(), zoomCenter = maptools_1.drawLocation(featureGroup, coords);
            // TH 12/19/2016 -- B/c map coords are editable, avoid updating zoom after user edits map coords.
            if (!mapZoomInitialized) {
                if (zoomCenter) {
                    map.setView(zoomCenter, 16); // TH: Always zoom of 16?
                    mapZoomInitialized = true;
                }
                else {
                    // TH 12/19/2016 -- To avoid some UX jumpiness, don't call setView until we think we have map coords populated.
                    if (settings.Latitude() || settings.Longitude() || settings.Zoom()) {
                        map.setView([settings.Latitude(), settings.Longitude()], settings.Zoom());
                        mapZoomInitialized = true;
                    }
                }
            }
        });
        s_js_1.default(function () {
            var drawControl = new L.Control.Draw({
                draw: {
                    //restrict drawing to polygon and circle
                    polyline: false,
                    marker: false,
                    rectangle: false,
                    polygon: {
                        shapeOptions: {
                            color: maptools_1.MAP_FILL_COLOR,
                            fillColor: maptools_1.MAP_FILL_COLOR,
                            weight: 2
                        }
                    },
                    circle: {
                        shapeOptions: {
                            color: maptools_1.MAP_FILL_COLOR,
                            fillColor: maptools_1.MAP_FILL_COLOR,
                            weight: 2
                        }
                    }
                },
                edit: {
                    featureGroup: featureGroup
                }
            });
            if (m.Model.Ref.CanEdit()) {
                // TH: Hack leaflet draw private state to customize toolbar button text. There should be a better way...
                var leafletDrawButtons = L.drawLocal.draw.toolbar.buttons, oldPolygonText = leafletDrawButtons.polygon, oldCircleText = leafletDrawButtons.circle;
                leafletDrawButtons.polygon = 'Outline the berth';
                leafletDrawButtons.circle = 'Add an anchorage';
                map.addControl(drawControl);
                s_js_1.default.cleanup(function () {
                    map.removeControl(drawControl);
                    // If set, ZoneOperationsParams references the drawControl.
                    // So clear ZoneOperationsParams if drawControl is getting destroyed.
                    location.ZoneOperationsParams(null);
                });
                // TH: Now that we've added the drawControl, we can reset our button text hack...
                leafletDrawButtons.polygon = oldPolygonText;
                leafletDrawButtons.circle = oldCircleText;
                // aah: the event handlers below all have the correct, more specific DrawEvent signature,
                // but the base typedefs for leaflet expect just plain LeafletEventHandlerFn's
                // so have to downcast to satisfy TS callback contravariance constraint
                map.on('draw:drawstart', ZoneStarted);
                map.on('draw:created', ZoneCreated);
                map.on('draw:edited', ZoneEdited);
                map.on('draw:deleted', ZoneDeleted);
                s_js_1.default.cleanup(function () {
                    map.off('draw:drawstart', ZoneStarted);
                    map.off('draw:created', ZoneCreated);
                    map.off('draw:edited', ZoneEdited);
                    map.off('draw:deleted', ZoneDeleted);
                });
            }
            function ZoneStarted(e) {
                if (e.layerType !== 'polygon' && e.layerType !== 'circle')
                    throw new Error('Unknown layer type: ' + e.layerType);
                var layerType = e.layerType;
                if (s_js_1.default.sample(location.Model.ZoneCoordinates) || layerType === 'circle') {
                    location.ZoneOperationsParams({
                        selectedZoneType: layerType,
                        // TH: Hmmm... Hack private leaflet state to cancel edit action.
                        cancelLeafletEdit: function () { return drawControl._toolbars[L.DrawToolbar.TYPE].disable(); }
                    });
                }
            }
            function ZoneCreated(e) {
                updateZone(e.layer);
            }
            function ZoneEdited(e) {
                var layer = e.layers.getLayers()[0];
                if (!layer)
                    return;
                updateZone(layer);
            }
            function updateZone(layer) {
                s_js_1.default.freeze(function () {
                    if (layer instanceof L.Circle) {
                        location.Model.ZoneType(ZoneCoordinates_1.ZONE_TYPE_CIRCLE);
                        location.Model.ZoneCoordinates(ZoneCoordinates_1.CircleCoords.fromLeaflet(layer).toString());
                    }
                    else if (layer instanceof L.Polygon) {
                        location.Model.ZoneType(ZoneCoordinates_1.ZONE_TYPE_POLYGON);
                        location.Model.ZoneCoordinates(ZoneCoordinates_1.PolygonCoords.fromLeaflet(layer).toString());
                    }
                });
            }
            function ZoneDeleted(e) {
                if (!e.layers.getLayers().length)
                    return;
                s_js_1.default.freeze(function () {
                    location.Model.ZoneCoordinates(null);
                    location.Model.ZoneType(null);
                });
            }
        });
    });
}


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthProfile = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var _ = __webpack_require__(67);
var autoSave_1 = __webpack_require__(31);
var UOM_1 = __webpack_require__(25);
var diacriticals_1 = __webpack_require__(42);
var validationWatcher_1 = __webpack_require__(23);
var nonuniqueIndex_1 = __webpack_require__(117);
var Berth_1 = __webpack_require__(107);
var BerthAmenity_1 = __webpack_require__(557);
var BerthCapabilityAssignment_1 = __webpack_require__(560);
var CompassPoint_1 = __webpack_require__(604);
var CompassPointExtensions_1 = __webpack_require__(566);
var Measurement_1 = __webpack_require__(11);
var SetPierGroupFootmarksRequest_1 = __webpack_require__(587);
var ZoneCoordinates_1 = __webpack_require__(115);
var uomIsFeet_1 = __webpack_require__(967);
var model_1 = __webpack_require__(151);
function BerthProfile(ajax, entrypoints, domainSettings, data, cache, postalAddressModel, pgFootmarksModel, _a) {
    var id = _a.id, editName = _a.editName;
    var model = cache.BerthProfileResponses.update1(null, { BerthId: id }), url = entrypoints.BerthProfile({ Id: id }), request = ajax.Url(url).Get(), autoEditName = s_js_1.default.data(editName), // should the editName query string param be shown -- will set to false once the user blurs the name once
    autoEditNextAmenity = s_js_1.default.data(false), autoEditNextCapability = s_js_1.default.data(false);
    // Mini dependency injection kernel
    var amenityModel = function (amenity) { return AmenityViewModel(amenity, autoEditNextAmenity, model.Ref.CanEdit, ajax, data); }, capabilityAssignmentModel = function (cap) { return CapabilityAssignmentViewModel(cap, autoEditNextCapability, model.Ref.CanEdit, ajax, data); }, amenitiesModel = function (berth) { return AmenitiesViewModel(berth, model.Ref.AmenityTypes, ajax, data, amenityModel); }, capabilitiesModel = function (berth) { return CapabilitiesViewModel(berth, model.Ref.Capabilities, ajax, data, capabilityAssignmentModel); }, zoneOperationsModel = function (loc, coords, onCloseModal, params) { return ZoneOperationsViewModel(loc, coords, onCloseModal, params, domainSettings); }, locationModel = function (loc) { return LocationViewModel(loc, autoEditName, model.Ref.CanEdit, ajax, zoneOperationsModel); }, pgModel = function (pg, mc) { return PierGroupViewModel(pg, ajax, function (pg) { return PierGroupMeasurementsViewModel(pg, mc); }, function (pg, onCloseModal) { return PierGroupFootmarksPopup(pg, mc, onCloseModal, ajax, entrypoints, pgFootmarksModel); }, ConfigureChangeWindowPopup); }, berthModel = function (berth) { return BerthViewModel(berth, ajax, data, MeasurementsCore, BerthMeasurementsViewModel, pgModel, locationModel, postalAddressModel, CompassPointsViewModel, amenitiesModel, capabilitiesModel); };
    var berth = s_js_1.default(function () { return model.Berth() && berthModel(model.Berth()); });
    s_js_1.default(function () {
        var _a;
        // Hide editName query string param once Name is flipped to non-editable
        if (autoEditName() && ((_a = berth()) === null || _a === void 0 ? void 0 : _a.Location()) && !berth().Location().EditingName()) {
            autoEditName(false);
        }
    });
    request.done(function (data) {
        cache.BerthProfileResponses.update1(request.Date, data);
    });
    return {
        Id: id,
        Model: model,
        Berth: berth,
        Organizations: s_array_1.lift(function () { return Array.from(data.Organizations.items()); })
            .filter(function (o) { return o.Active(); })
            .orderBy(function (o) { return diacriticals_1.LatinLower(o.Name()); }),
        AutoEditName: autoEditName,
        DomainSettings: domainSettings,
        GoBack: function () {
            window.history.back();
        }
    };
}
exports.BerthProfile = BerthProfile;
function BerthViewModel(berth, ajax, data, measurementsCoreModel, berthMeasurementsModel, pierGroupModel, locationModel, postalAddressModel, compassPointsModel, amenitiesModel, capabilitiesModel) {
    var client = ajax.Url(function () { return berth.Url() || ''; }, { useCache: true }), editables = [
        'AutoCalculateBills',
        'BerthTransitOffset',
        'DaylightMooringOnly',
        'LengthBuffer.Num',
        'LengthBuffer.UOM',
        'MaxDraftAllowed.Num',
        'MaxDraftAllowed.UOM',
        'MultiVesselBerthing',
        'PortSideVesselHasBowToLowFootmark',
        'LowFootmarkCompassPoint',
        'Notes',
        'SchedulingAuthorityId',
        'TimeBuffer'
    ], draft = autoSave_1.AutoSavingDraftObject(berth, client, editables), measurementsCore = measurementsCoreModel(draft), measurements = berthMeasurementsModel(draft, measurementsCore), pierGroup = s_js_1.default(function () { return berth.PierGroup() && pierGroupModel(berth.PierGroup(), measurementsCore); }), location = s_js_1.default(function () { return berth.Location() && locationModel(berth.Location()); }), postalAddress = s_js_1.default(function () { return berth.PostalAddress() && postalAddressModel(berth.PostalAddress()); }), compassPoints = compassPointsModel(draft), amenities = amenitiesModel(berth), capabilities = capabilitiesModel(berth), editing = {
        Address: s_js_1.default.data(false),
        SchedulingAuthority: s_js_1.default.data(false)
    };
    draft.SchedulingAuthority = s_js_1.default.value(s_js_1.default.sample(berth.SchedulingAuthority));
    data.Berths.attach(draft, [draft.SchedulingAuthority]);
    return {
        Model: draft,
        PierGroup: pierGroup,
        Location: location,
        PostalAddress: postalAddress,
        CompassPoints: compassPoints,
        Amenities: amenities,
        Capabilities: capabilities,
        Editing: {
            Address: editing.Address,
            ToggleAddress: function () { return editing.Address(!editing.Address()); },
            SchedulingAuthority: editing.SchedulingAuthority,
            ToggleSchedulingAuthority: function () { return editing.SchedulingAuthority(!editing.SchedulingAuthority()); }
        },
        Measurements: measurements
    };
}
function PierGroupViewModel(pierGroup, ajax, pgMeasurementsModel, footmarksPopupModel, configureChangeWindowModel) {
    var client = ajax.Url(function () { return pierGroup.Url() || ''; }), editables = [
        'PortId',
        'StartOverhang.Num',
        'StartOverhang.UOM',
        'EndOverhang.Num',
        'EndOverhang.UOM',
        'PreventAgentOverlaps',
        'RequireKnownVessels',
        'AgentChangeWindowHours'
    ], draft = autoSave_1.AutoSavingDraftObject(pierGroup, client, editables), validation = validationWatcher_1.ValidationWatcher(client), editing = {
        Port: s_js_1.default.data(false)
    }, measurements = pgMeasurementsModel(draft), ShowEditFootmarks = s_js_1.default.value(false), EditFootmarks = s_js_1.default(function () { return ShowEditFootmarks() ?
        footmarksPopupModel(pierGroup, function () { return ShowEditFootmarks(false); }) :
        null; }), showConfigureChangeWindow = s_js_1.default.value(false), configureChangeWindowPopup = s_js_1.default(function () { return showConfigureChangeWindow() ?
        configureChangeWindowModel(draft, function () { return showConfigureChangeWindow(false); }) :
        null; });
    return {
        Model: draft,
        Validation: validation,
        Measurements: measurements,
        ShowEditFootmarks: ShowEditFootmarks,
        EditFootmarks: EditFootmarks,
        ChangeWindowToggleChecked: ChangeWindowToggleChecked,
        NonNullChangeWindow: NonNullChangeWindow,
        ConfigureChangeWindowPopup: configureChangeWindowPopup,
        Editing: {
            Port: editing.Port,
            TogglePort: function () { return editing.Port(!editing.Port()); }
        }
    };
    function ChangeWindowToggleChecked(checked) {
        if (checked === undefined) {
            return draft.AgentChangeWindowHours() !== null || showConfigureChangeWindow();
        }
        else if (checked) {
            showConfigureChangeWindow(true);
            return true;
        }
        else {
            draft.AgentChangeWindowHours(null);
            return false;
        }
    }
    function NonNullChangeWindow(val) {
        if (val === undefined) {
            return draft.AgentChangeWindowHours() || 0;
        }
        else {
            draft.AgentChangeWindowHours(val);
            return val;
        }
    }
}
function LocationViewModel(location, autoEditName, canEdit, ajax, zoneOperationsModel) {
    var client = ajax.Url(function () { return location.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(location, client), validation = validationWatcher_1.ValidationWatcher(client), editingName = s_js_1.default.data(s_js_1.default.sample(function () { return autoEditName() && canEdit(); })), coords = s_js_1.default(function () { return ZoneCoordinates_1.parseZoneCoordinates(draft.ZoneCoordinates(), draft.ZoneType()); }), zoneOperationsParams = s_js_1.default.data(null), zoneOperationsModal = s_js_1.default(function () { return zoneOperationsParams() && zoneOperationsModel(draft, coords, function () { return zoneOperationsParams(null); }, zoneOperationsParams()); });
    return {
        Model: draft,
        Validation: validation,
        Coords: coords,
        EditingName: editingName,
        ToggleEditingName: function () { return editingName(!editingName()); },
        ZoneOperationsParams: zoneOperationsParams,
        ZoneOperationsModal: zoneOperationsModal
    };
}
function ZoneOperationsViewModel(location, coords, onCloseModal, _a, domainSettings) {
    var selectedZoneType = _a.selectedZoneType, cancelLeafletEdit = _a.cancelLeafletEdit;
    var mode = s_js_1.default.data(s_js_1.default.sample(location.ZoneCoordinates) ? 0 /* PromptOverwrite */ : 1 /* PromptManualEntry */), errorMessage = s_js_1.default.data(''), 
    // prepopulate from curr zone coordinates
    currCoords = s_js_1.default.sample(coords), latLong = currCoords ?
        currCoords instanceof ZoneCoordinates_1.CircleCoords ?
            currCoords.latLong :
            currCoords.coords.length > 0 ?
                currCoords.coords[0] :
                null :
        null, anchorageLatitude = s_js_1.default.data(latLong ? latLong.lat : 0), anchorageLongitude = s_js_1.default.data(latLong ? latLong.long : 0), anchorageRadius = new Measurement_1.Measurement({
        Num: currCoords instanceof ZoneCoordinates_1.CircleCoords ? currCoords.radius : 0,
        UOM: UOM_1.default.Meter
    }), displayUom = s_js_1.default.data(s_js_1.default.sample(function () { return domainSettings.Pier.DefaultLengthUOM() || UOM_1.default.Foot; })), anchorageIsFeet = uomIsFeet_1.uomIsFeet(displayUom), toggleableRadius = model_1.ToggleableMeasurement({
        backingMeasurement: anchorageRadius,
        uom: displayUom,
        conversions: [{
                uom: UOM_1.default.Foot,
                decimalPlaces: 0
            }, {
                uom: UOM_1.default.Meter,
                decimalPlaces: 1
            }]
    });
    return {
        Mode: mode,
        ConfirmOverwrite: ConfirmOverwrite,
        CancelLeafletEdit: CancelLeafletEdit,
        ContinueLeafletEdit: ContinueLeafletEdit,
        SaveManualEntry: SaveManualEntry,
        ErrorMessage: errorMessage,
        AnchorageLatitude: anchorageLatitude,
        AnchorageLongitude: anchorageLongitude,
        ToggleableRadius: toggleableRadius,
        AnchorageIsFeet: anchorageIsFeet
    };
    function ConfirmOverwrite() {
        // TH: For circle zones we allow "manual" entry via input boxes or entry via Leaflet Draw on map.
        // For polygon zones we only allow entry via Leaflet Draw on map.
        // Not sure why that distinction, but I'm preserving it for now...
        if (selectedZoneType === 'polygon') {
            onCloseModal(); // close modal to allow leaflet edit to continue...
        }
        else {
            mode(1 /* PromptManualEntry */); // move on to next step in modal...
        }
    }
    function CancelLeafletEdit() {
        cancelLeafletEdit();
        onCloseModal();
    }
    function ContinueLeafletEdit() {
        onCloseModal();
    }
    function SaveManualEntry() {
        if (anchorageLatitude() < -90 || anchorageLatitude() > 90) {
            errorMessage('Latitude entry is invalid');
        }
        else if (anchorageLongitude() < -180 || anchorageLongitude() > 180) {
            errorMessage('Longitude entry is invalid');
        }
        else {
            s_js_1.default.freeze(function () {
                location.ZoneType(ZoneCoordinates_1.ZONE_TYPE_CIRCLE);
                location.ZoneCoordinates(new ZoneCoordinates_1.CircleCoords(new ZoneCoordinates_1.LatLong(anchorageLatitude(), anchorageLongitude()), anchorageRadius.Num()).toString());
                CancelLeafletEdit();
            });
        }
    }
}
function CompassPointsViewModel(berth) {
    var 
    // Type of points to show in dropdown UI: N, NE, E, SE, etc.
    availablePoints = CompassPointExtensions_1.PointsOfType(CompassPoint_1.CompassPointType.Cardinal | CompassPoint_1.CompassPointType.Ordinal).map(function (compass) { return ({
        Id: compass,
        Abbreviation: CompassPointExtensions_1.Abbreviation(compass)
    }); }), lowFootmarkCompassAbbreviation = function () { return CompassPointExtensions_1.Abbreviation(berth.LowFootmarkCompassPoint()); }, highFootmarkCompassAbbreviation = function () { return CompassPointExtensions_1.Abbreviation(CompassPointExtensions_1.Antipode(berth.LowFootmarkCompassPoint())); }, showCompassPointsMenu = s_js_1.default.data(false);
    return {
        AvailablePoints: availablePoints,
        LowFootmarkCompassAbbreviation: lowFootmarkCompassAbbreviation,
        HighFootmarkCompassAbbreviation: highFootmarkCompassAbbreviation,
        ShowCompassPointsMenu: showCompassPointsMenu,
        ToggleCompassPointsMenu: ToggleCompassPointsMenu,
        SelectCompassPoint: SelectCompassPoint
    };
    function ToggleCompassPointsMenu() {
        showCompassPointsMenu(!showCompassPointsMenu());
    }
    function SelectCompassPoint(compass) {
        s_js_1.default.freeze(function () {
            berth.LowFootmarkCompassPoint(compass);
            showCompassPointsMenu(false);
        });
    }
}
function AmenitiesViewModel(berth, amenityTypes, ajax, data, amenityModel) {
    var client = ajax.Url(function () { return berth.AmenitiesUrl() || ''; }), assignedAmenitiesIdx = nonuniqueIndex_1.default(berth.Amenities, function (ba) { return ba.AmenityId(); }), availableAmenityTypes = amenityTypes.filter(function (bat) {
        return bat.OrganizationId() === berth.SchedulingAuthorityId()
            && bat.Active() && !assignedAmenitiesIdx(bat.Id())().length;
    }), amenities = berth.Amenities.map(amenityModel);
    return {
        AvailableAmenityTypes: availableAmenityTypes,
        AvailableForSlot: AvailableForSlot,
        Amenities: amenities,
        Add: addAmenity
    };
    function addAmenity() {
        if (!availableAmenityTypes().length)
            return;
        var req = client.Post(new BerthAmenity_1.BerthAmenity({
            Id: 0,
            AmenityId: availableAmenityTypes()[0].Id()
        }));
        req.then(function (_data) {
            data.BerthAmenities.update1(req.Date, _data);
        });
    }
    function AvailableForSlot(amenity) {
        var amenityType = amenity.Model.Amenity();
        return _.uniq((amenityType ? [amenityType] : []).concat(availableAmenityTypes()));
    }
}
function AmenityViewModel(amenity, autoEditNextAmenity, canEdit, ajax, data) {
    var client = ajax.Url(function () { return amenity.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(amenity, client), editing = s_js_1.default.data(s_js_1.default.sample(function () { return canEdit() && autoEditNextAmenity(); }));
    draft.Amenity = s_js_1.default.value(s_js_1.default.sample(amenity.Amenity));
    data.BerthAmenities.attach(draft, [draft.Amenity]);
    // TH: Set flag so that future amenities will be auto-editable upon creation.
    // This will take effect in the next tick, so it won't affect amenity view models that are constructed in this same tick.
    autoEditNextAmenity(true);
    return {
        Model: draft,
        Editing: editing,
        ToggleEditing: ToggleEditing,
        Delete: Delete
    };
    function ToggleEditing() {
        editing(!editing());
    }
    function Delete() {
        var key = amenity.Id();
        var req = client.Delete();
        req.then(function () {
            data.BerthAmenities.update(req.Date, [], [key]);
        });
    }
}
function CapabilitiesViewModel(berth, capabilities, ajax, data, capabilityAssignmentModel) {
    var client = ajax.Url(function () { return berth.BerthCapabilityAssignmentsUrl() || ''; }), assignedCapabilitiesIdx = nonuniqueIndex_1.default(berth.Capabilities, function (bca) { return bca.CapabilityId(); }), availableCapabilities = capabilities.filter(function (bca) {
        return bca.Active() && !assignedCapabilitiesIdx(bca.Id())().length;
    }), assignedCapabilities = berth.Capabilities.map(capabilityAssignmentModel);
    return {
        AvailableCapabilities: availableCapabilities,
        AvailableForSlot: AvailableForSlot,
        Capabilities: assignedCapabilities,
        Add: addCapability
    };
    function addCapability() {
        if (!availableCapabilities().length)
            return;
        var req = client.Post(new BerthCapabilityAssignment_1.BerthCapabilityAssignment({
            Id: 0,
            CapabilityId: availableCapabilities()[0].Id()
        }));
        req.then(function (_data) {
            data.BerthCapabilityAssignments.update1(req.Date, _data);
        });
    }
    function AvailableForSlot(capAssignment) {
        var cap = capAssignment.Model.Capability();
        return _.uniq((cap ? [cap] : []).concat(availableCapabilities()));
    }
}
function CapabilityAssignmentViewModel(capabilityAssignment, autoEditNextCapability, canEdit, ajax, data) {
    var client = ajax.Url(function () { return capabilityAssignment.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(capabilityAssignment, client), editing = s_js_1.default.data(s_js_1.default.sample(function () { return canEdit() && autoEditNextCapability(); }));
    draft.Capability = s_js_1.default.value(s_js_1.default.sample(capabilityAssignment.Capability));
    data.BerthCapabilityAssignments.attach(draft, [draft.Capability]);
    // TH: Set flag so that future capabilities will be auto-editable upon creation.
    // This will take effect in the next tick, so it won't affect view models that are constructed in this same tick.
    autoEditNextCapability(true);
    return {
        Model: draft,
        Editing: editing,
        ToggleEditing: ToggleEditing,
        Delete: Delete
    };
    function ToggleEditing() {
        editing(!editing());
    }
    function Delete() {
        var key = capabilityAssignment.Id(), req = client.Delete();
        req.then(function () {
            data.BerthCapabilityAssignments.update(req.Date, [], [key]);
        });
    }
}
function MeasurementsCore(berth) {
    var uom = s_js_1.default.data(s_js_1.default.sample(berth.Length.UOM)), 
    // TH: TODO: Review these conversions... Do we want feet and inches for the draft?
    lengthConversions = [{
            uom: UOM_1.default.Foot,
            decimalPlaces: 0
        }, {
            uom: UOM_1.default.Meter,
            decimalPlaces: 1
        }], depthConversions = [{
            uom: UOM_1.default.Foot,
            decimalPlaces: 1
        }, {
            uom: UOM_1.default.Meter,
            decimalPlaces: 2
        }];
    return { uom: uom, lengthConversions: lengthConversions, depthConversions: depthConversions };
}
function BerthMeasurementsViewModel(berth, _a) {
    var uom = _a.uom, lengthConversions = _a.lengthConversions, depthConversions = _a.depthConversions;
    var endMark = berth.StartMark.add(berth.Length), measurementsInFeet = uomIsFeet_1.uomIsFeet(uom), toggleableLength = model_1.ToggleableMeasurement({ backingMeasurement: berth.Length, uom: uom, conversions: lengthConversions }), toggleableLengthBuffer = model_1.ToggleableMeasurement({ backingMeasurement: berth.LengthBuffer, uom: uom, conversions: lengthConversions }), toggleableMaxDraft = model_1.ToggleableMeasurement({ backingMeasurement: berth.MaxDraftAllowed, uom: uom, conversions: depthConversions }), toggleableStartMark = model_1.ToggleableMeasurement({ backingMeasurement: berth.StartMark, uom: uom, conversions: lengthConversions }), toggleableEndMark = model_1.ToggleableMeasurement({ backingMeasurement: endMark, uom: uom, conversions: lengthConversions });
    return {
        MeasurementsInFeet: measurementsInFeet,
        ToggleableLength: toggleableLength,
        ToggleableLengthBuffer: toggleableLengthBuffer,
        ToggleableMaxDraft: toggleableMaxDraft,
        ToggleableStartMark: toggleableStartMark,
        ToggleableEndMark: toggleableEndMark
    };
}
function PierGroupMeasurementsViewModel(pierGroup, _a) {
    var uom = _a.uom, lengthConversions = _a.lengthConversions;
    var toggleableStartOverhang = model_1.ToggleableMeasurement({ backingMeasurement: pierGroup.StartOverhang, uom: uom, conversions: lengthConversions }), toggleableEndOverhang = model_1.ToggleableMeasurement({ backingMeasurement: pierGroup.EndOverhang, uom: uom, conversions: lengthConversions });
    return {
        ToggleableStartOverhang: toggleableStartOverhang,
        ToggleableEndOverhang: toggleableEndOverhang
    };
}
function PierGroupFootmarksPopup(pierGroup, _a, onCloseModal, ajax, entrypoints, pgFootmarksModel) {
    var displayUOM = _a.uom;
    var url = function () { return entrypoints.PierGroupFootmarks({ Id: pierGroup.Id() }); }, client = ajax.Url(url, {
        include: [function (r) { return r.Berths; }],
        useCache: true
    }), req = new SetPierGroupFootmarksRequest_1.SetPierGroupFootmarksRequest(), Footmarks = pgFootmarksModel({
        req: req,
        pierLengthUOM: function () { var _a, _b; return (_b = (_a = pierGroup.Port()) === null || _a === void 0 ? void 0 : _a.PierLengthUOM()) !== null && _b !== void 0 ? _b : null; },
        displayUOM: displayUOM
    }), Saving = s_js_1.default.value(false);
    // Initialize req.Berths based on current piergroup berth arrangement. Users can then edit
    // from there.
    s_js_1.default.sample(function () {
        var berths = pierGroup.Berths().slice();
        // The PierGroupFootmarks component assumes the order of the passed-in berths represents
        // the desired StartMark order, so sort by StartMark before passing berths into the
        // component.
        berths.sort(Berth_1.Berth.StartMarkOrder);
        req.Berths(berths.map(function (b) { return new SetPierGroupFootmarksRequest_1.SetBerthFootmarksRequest({
            Id: b.Id(),
            StartMark: {
                Num: b.StartMark.Num(),
                UOM: b.StartMark.UOM()
            },
            Length: {
                Num: b.Length.Num(),
                UOM: b.Length.UOM()
            }
        }); }));
    });
    return {
        Footmarks: Footmarks,
        CanSave: function () { return Footmarks.FootmarksAreValid(); },
        Save: Save,
        Saving: Saving,
        Cancel: onCloseModal
    };
    function Save() {
        if (Saving())
            return;
        Saving(true);
        client.Post(req).then(function () { return onCloseModal(); }).finally(function () { return Saving(false); });
    }
}
var DEFAULT_CHANGE_WINDOW_HOURS = 6;
function ConfigureChangeWindowPopup(pg, onCloseModal) {
    var ChangeWindowHours = s_js_1.default.value(DEFAULT_CHANGE_WINDOW_HOURS);
    return {
        ChangeWindowHours: ChangeWindowHours,
        Cancel: onCloseModal,
        Commit: Commit
    };
    function Commit() {
        s_js_1.default.freeze(function () {
            pg.AgentChangeWindowHours(ChangeWindowHours());
            onCloseModal();
        });
    }
}


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthProfileRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var view_1 = __webpack_require__(1056);
var view_2 = __webpack_require__(12);
var BerthProfileRoute = function (model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.BerthProfileView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
};
exports.BerthProfileRoute = BerthProfileRoute;
function inboundParams(request) {
    var id = parseInt(request.params['id'] || '', 10), editName = !!request.params['editName'];
    if (isNaN(id))
        throw new Error('BerthProfile: id param is required and must be numeric.');
    return { id: id, editName: editName };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = m.Id + '';
    if (m.AutoEditName())
        params['editName'] = 'true';
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthProfileView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var s_js_1 = __webpack_require__(0);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var ZoneCoordinates_1 = __webpack_require__(115);
var view_1 = __webpack_require__(55);
var view_2 = __webpack_require__(35);
var view_3 = __webpack_require__(22);
var view_4 = __webpack_require__(536);
var view_5 = __webpack_require__(539);
var view_6 = __webpack_require__(89);
var view_7 = __webpack_require__(152);
var view_8 = __webpack_require__(29);
var mapview_1 = __webpack_require__(1053);
exports.BerthProfileView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "berthprofile pc-page-fixedwidth" },
        React.createElement(HeaderView, { model: m }),
        React.createElement(PageLeftSide, { model: m }),
        React.createElement(PageRightSide, { model: m }),
        React.createElement(NotesEditor, { model: m }),
        React.createElement(EditFootmarksModal, { model: m }),
        React.createElement(ZoneExistsModal, { model: m }));
});
var HeaderView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var location = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Location();
    return (React.createElement("div", { className: "header-shell" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-link-small pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back")),
        location &&
            React.createElement("div", null, !location.EditingName() ?
                React.createElement("label", { className: "name pc-page-title", onClick: m.Model.Ref.CanEdit() ? location.ToggleEditingName : undefined }, location.Model.Name())
                :
                    React.createElement("input", { className: "name-edit", type: "text", value: location.Model.Name(), onChange: function (e) { return location.Model.Name(e.currentTarget.value); }, onBlur: location.ToggleEditingName, autoFocus: true }))));
});
var PageLeftSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "leftside" },
        React.createElement(mapview_1.MapView, { model: m }),
        React.createElement(LocationParticularsView, { model: m }),
        React.createElement(BerthAmenitiesView, { model: m }),
        React.createElement(BerthCapabilitiesView, { model: m }));
});
var LocationParticularsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: " particulars pc-card profile-body clearfix" },
        React.createElement("div", { className: "pc-card-header pc-card-title" }, "LOCATION PARTICULARS"),
        React.createElement(PortSelector, { model: m }),
        React.createElement("div", { className: "location" },
            React.createElement("table", { className: "interior" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "left" },
                            React.createElement("label", null, "Physical Address")),
                        React.createElement(BerthAddressView, { model: m })),
                    React.createElement("tr", null,
                        React.createElement("td", null, "\u00A0")),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "left" },
                            React.createElement("label", null, "Latitiude & Longitude")),
                        React.createElement(ZoneCoordinatesView, { model: m }))))));
});
var PortSelector = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var pierGroup = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup();
    return (React.createElement("div", { className: "port" },
        React.createElement("label", { className: "label-port" }, "Port"),
        (pierGroup === null || pierGroup === void 0 ? void 0 : pierGroup.Model.Port()) &&
            React.createElement("label", { className: "hashtag", hidden: pierGroup.Editing.Port(), onClick: m.Model.Ref.CanEdit() ? pierGroup.Editing.TogglePort : undefined }, pierGroup.Model.Port().Name()),
        (pierGroup === null || pierGroup === void 0 ? void 0 : pierGroup.Editing.Port()) &&
            React.createElement("div", { className: "port-selector" },
                React.createElement("select", { className: "pc-select", value: pierGroup.Model.PortId(), onChange: function (e) { return pierGroup.Model.PortId(+e.currentTarget.value); }, onBlur: pierGroup.Editing.TogglePort, autoFocus: true }, m.Model.Ref.Ports().map(function (port) {
                    return React.createElement("option", { key: port.Id(), value: port.Id() }, port.Name());
                })),
                React.createElement("span", { className: "pc-select-chevron" }))));
});
var BerthAddressView = supercritical_1.default(function (_a) {
    var _b, _c, _d;
    var m = _a.model;
    return React.createElement("td", { className: cx({
            'pc-show-editcontrols': !!((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Editing.Address()),
            'pc-show-viewcontrols': !((_c = m.Berth()) === null || _c === void 0 ? void 0 : _c.Editing.Address())
        }) },
        m.Model.Ref.CanEdit() && m.Berth() &&
            React.createElement("a", { href: "", className: "address-edit-link", onClick: eventWrappers_1.noDefault(m.Berth().Editing.ToggleAddress) }, m.Berth().Editing.Address() ? 'Done' : 'Edit'),
        ((_d = m.Berth()) === null || _d === void 0 ? void 0 : _d.PostalAddress()) && React.createElement(view_5.PostalAddressView, { model: m.Berth().PostalAddress() }));
});
var ZoneCoordinatesView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var location = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Location(), coords = location === null || location === void 0 ? void 0 : location.Coords();
    return (React.createElement("td", null,
        React.createElement("div", { className: "coords-shell" }, coords ?
            coords instanceof ZoneCoordinates_1.PolygonCoords ?
                coords.coords.map(function (latLong) {
                    return React.createElement("div", { className: "particulars-desc", key: latLong.toString() }, latLong.toString());
                }) :
                React.createElement("div", null,
                    React.createElement("div", { className: "particulars-desc" }, coords.latLong.toString()),
                    React.createElement("div", { className: "particulars-desc" },
                        "Radius ",
                        coords.radius,
                        "m")) :
            React.createElement("div", { className: "particulars-desc" }, "No zone coordinates selected"))));
});
var BerthAmenitiesView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "amenities pc-card profile-body clearfix" },
        React.createElement("div", { className: "pc-card-header pc-card-title" },
            "AMENITIES",
            ' ',
            m.Model.Ref.CanEdit()
                && m.Berth()
                && m.Berth().Amenities.AvailableAmenityTypes().length > 0 &&
                React.createElement("a", { className: "add-link", href: "", onClick: eventWrappers_1.noDefault(m.Berth().Amenities.Add) }, "+ Add New")),
        React.createElement("ul", { className: "amenity-list" }, (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Amenities.Amenities().map(function (amenity) {
            return React.createElement(BerthAmenityView, { amenity: amenity, model: m, key: amenity.Model.Id() });
        })));
});
var BerthAmenityView = supercritical_1.default(function (_a) {
    var _b;
    var a = _a.amenity, m = _a.model;
    var amenityType = a.Model.Amenity();
    return (React.createElement("li", null, !a.Editing() ?
        React.createElement("span", { className: "list-span", onClick: m.Model.Ref.CanEdit() ? a.ToggleEditing : undefined },
            React.createElement("label", { className: "amenity-type" }, amenityType === null || amenityType === void 0 ? void 0 : amenityType.Name()),
            React.createElement("label", { className: "amenity-desc" }, amenityType === null || amenityType === void 0 ? void 0 : amenityType.Description()),
            m.Model.Ref.CanEdit() &&
                React.createElement("a", { className: "amenity-delete pc-close-icon", onClick: eventWrappers_1.noPropagation(a.Delete) }))
        :
            React.createElement("span", { className: "list-span" },
                React.createElement("select", { className: "pc-select amenity-type-edit", value: a.Model.AmenityId(), onChange: function (e) { return a.Model.AmenityId(+e.currentTarget.value); } }, (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Amenities.AvailableForSlot(a).map(function (_amenityType) {
                    return React.createElement("option", { value: _amenityType.Id(), key: _amenityType.Id() }, _amenityType.Name());
                })),
                React.createElement("span", { className: "pc-select-chevron" }),
                React.createElement("a", { href: "", className: "amenity-delete", onClick: eventWrappers_1.noDefault(a.ToggleEditing) }, "Done"))));
});
var BerthCapabilitiesView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "capabilities pc-card profile-body clearfix" },
        React.createElement("div", { className: "pc-card-header pc-card-title" },
            "CAPABILITIES",
            ' ',
            m.Model.Ref.CanEdit()
                && m.Berth()
                && m.Berth().Capabilities.AvailableCapabilities().length > 0 &&
                React.createElement("a", { className: "add-link", href: "", onClick: eventWrappers_1.noDefault(m.Berth().Capabilities.Add) }, "+Add New")),
        React.createElement("ul", { className: "capability-list" }, (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Capabilities.Capabilities().map(function (cap) {
            return React.createElement(BerthCapabilityView, { capAssignment: cap, model: m, key: cap.Model.Id() });
        })));
});
var BerthCapabilityView = supercritical_1.default(function (_a) {
    var _b;
    var c = _a.capAssignment, m = _a.model;
    var cap = c.Model.Capability();
    return (React.createElement("li", null, !c.Editing() ?
        React.createElement("span", { className: "list-span", onClick: m.Model.Ref.CanEdit() ? c.ToggleEditing : undefined },
            React.createElement("label", { className: "capability-type" }, cap === null || cap === void 0 ? void 0 : cap.Name()),
            m.Model.Ref.CanEdit() &&
                React.createElement("a", { className: "capability-delete pc-close-icon", onClick: eventWrappers_1.noPropagation(c.Delete) }))
        :
            React.createElement("span", { className: "list-span" },
                React.createElement("select", { className: "pc-select capability-type-edit", value: c.Model.CapabilityId(), onChange: function (e) { return c.Model.CapabilityId(+e.currentTarget.value); } }, (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Capabilities.AvailableForSlot(c).map(function (_cap) {
                    return React.createElement("option", { value: _cap.Id(), key: _cap.Id() }, _cap.Name());
                })),
                React.createElement("span", { className: "pc-select-chevron" }),
                React.createElement("a", { href: "", className: "capability-delete", onClick: eventWrappers_1.noDefault(c.ToggleEditing) }, "Done"))));
});
var PageRightSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "rightside" },
        React.createElement("div", { className: "settings pc-card profile-body clearfix" },
            React.createElement("div", { className: "title selected" },
                React.createElement("label", { className: "selected" }, "SETTINGS")),
            React.createElement(SchedulingAuthorityView, { model: m }),
            React.createElement(BerthMeasurementsView, { model: m }),
            React.createElement(TimeBufferView, { model: m }),
            React.createElement(BerthTransitOffsetView, { model: m }),
            React.createElement(IsPortExternalView, { model: m }),
            React.createElement(AgentChangeWindowView, { model: m }),
            React.createElement(ConfigureChangeWindowModal, { model: m }),
            React.createElement(PreventAgentOverlapsView, { model: m }),
            React.createElement(RequireKnownVesselsView, { model: m })));
});
var SchedulingAuthorityView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "setting-top" },
        React.createElement("label", { className: "sched-auth setting-label pc-text-label" }, "Scheduling Authority"),
        m.Berth() &&
            React.createElement("label", { className: "authority pc-text-label", hidden: m.Berth().Editing.SchedulingAuthority(), onClick: m.Model.Ref.CanEdit() ? m.Berth().Editing.ToggleSchedulingAuthority : undefined }, m.Berth().Model.SchedulingAuthority() ? m.Berth().Model.SchedulingAuthority().Name() : 'None'),
        ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Editing.SchedulingAuthority()) &&
            React.createElement("div", { className: "select-shell" },
                React.createElement("select", { className: "pc-select", value: m.Berth().Model.SchedulingAuthorityId() === null ? '' : '' + m.Berth().Model.SchedulingAuthorityId(), onChange: function (e) { return m.Berth().Model.SchedulingAuthorityId(e.currentTarget.value === '' ? null : +e.currentTarget.value); }, onBlur: m.Berth().Editing.ToggleSchedulingAuthority, autoFocus: true },
                    React.createElement("option", { value: "", key: "" }, "None"),
                    m.Organizations().map(function (schedAuth) {
                        return React.createElement("option", { value: schedAuth.Id(), key: schedAuth.Id() }, schedAuth.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" })));
});
var BerthMeasurementsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "dimension" },
        React.createElement(UOMToggle, { model: m }),
        React.createElement(TotalLengthView, { model: m }),
        React.createElement(FootmarksView, { model: m }),
        React.createElement(MaxDraftAllowedView, { model: m }),
        React.createElement(SideToSelectorView, { model: m }),
        React.createElement(CompassPointsView, { model: m }),
        React.createElement(LengthBufferView, { model: m }),
        React.createElement(StartOverhangView, { model: m }),
        React.createElement(EndOverhangView, { model: m }));
});
var UOMToggle = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Berth() &&
        React.createElement("div", { className: "uom-selector" },
            React.createElement("label", { className: "text" }, "lengths in\u00A0"),
            React.createElement(view_6.ToggleButton, { className: "text", onLabel: "feet", offLabel: "meters", checked: m.Berth().Measurements.MeasurementsInFeet }));
});
var TotalLengthView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "maximum total-length" },
        React.createElement("div", null,
            React.createElement("label", { className: "dim-label" }, "Total Length"),
            m.Berth() && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().Measurements.ToggleableLength, textonly: true })),
        React.createElement("div", { className: "setting-desc" }, "The maximum linear distance that is available for scheduling."));
});
var FootmarksView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "footmark" },
        React.createElement("div", null,
            React.createElement("label", { className: "footmark-header" }, "Footmarks"),
            m.Model.Ref.CanEditPort() && ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) &&
                React.createElement("a", { href: "", className: "edit-footmarks-link", onClick: eventWrappers_1.noDefault(function () { return m.Berth().PierGroup().ShowEditFootmarks(true); }) }, "Edit")),
        React.createElement("div", { className: "setting" },
            React.createElement("label", { className: "footmark-label" }, "Begin"),
            m.Berth() && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().Measurements.ToggleableStartMark, textonly: true })),
        React.createElement("div", { className: "setting" },
            React.createElement("label", { className: "footmark-label" }, "End"),
            m.Berth() && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().Measurements.ToggleableEndMark, textonly: true })));
});
var EditFootmarksModal = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e;
    var m = _a.model;
    var popup = (_c = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) === null || _c === void 0 ? void 0 : _c.EditFootmarks();
    return (React.createElement(view_3.PCModal, { className: "edit-footmarks-modal", shown: function () { return !!popup; }, onBackDropClick: popup === null || popup === void 0 ? void 0 : popup.Cancel },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, (_e = (_d = m.Berth()) === null || _d === void 0 ? void 0 : _d.Location()) === null || _e === void 0 ? void 0 :
                _e.Model.Name(),
                "'s Group"),
            popup &&
                React.createElement("div", { className: "modal-body" },
                    React.createElement(view_4.PierGroupFootmarksView, { model: popup.Footmarks }),
                    React.createElement("div", { className: "buttons" },
                        React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(popup.Cancel) }, "Cancel"),
                        React.createElement("button", { className: "submit-btn pc-button pc-button-primary", onClick: eventWrappers_1.noDefault(popup.Save), disabled: !popup.CanSave() }, "Save"))))));
});
var MaxDraftAllowedView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "maximum" },
        React.createElement("div", null,
            React.createElement("label", { className: "dim-label" }, "Max Vessel Draft"),
            m.Berth() && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().Measurements.ToggleableMaxDraft, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Indicate the safest vessel draft to prevent scheduling vessels with deeper drafts."));
});
var SideToSelectorView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "maximum side-to-descr" },
            React.createElement("div", null,
                React.createElement("label", { className: "dim-label" }, "Side-To Settings")),
            React.createElement("div", { className: "setting-desc" },
                "When the ship is ",
                React.createElement("b", { className: "port side-to" }, "port side-to"),
                " at this berth, is the bow at the lower footmark or the higher footmark?")),
        React.createElement("div", { className: "side-to-selectors" },
            React.createElement("div", { className: "side-to-selector-option" },
                React.createElement("div", { className: cx('side-to-selector-btn', {
                        'side-to-selector-btn-selected': !!((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Model.PortSideVesselHasBowToLowFootmark())
                    }), onClick: m.Model.Ref.CanEdit() ? function () { var _a; return (_a = m.Berth()) === null || _a === void 0 ? void 0 : _a.Model.PortSideVesselHasBowToLowFootmark(true); } : undefined }),
                React.createElement("span", { className: "side-to-selector-label" }, "Low Footmark")),
            React.createElement("div", { className: "side-to-selector-option" },
                React.createElement("div", { className: cx('side-to-selector-btn', {
                        'side-to-selector-btn-selected': !!(m.Berth() && !m.Berth().Model.PortSideVesselHasBowToLowFootmark())
                    }), onClick: m.Model.Ref.CanEdit() ? function () { var _a; return (_a = m.Berth()) === null || _a === void 0 ? void 0 : _a.Model.PortSideVesselHasBowToLowFootmark(false); } : undefined }),
                React.createElement("span", { className: "side-to-selector-label" }, "High Footmark"))));
});
var CompassPointsView = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "maximum pier-orientation-descr" },
            React.createElement("div", null,
                React.createElement("label", { className: "dim-label" }, "Pier Orientation")),
            React.createElement("div", { className: "setting-desc" }, "Choose the cardinal point for the pier direction. If the footmarks increase from N to S, choose N for the low footmark.")),
        React.createElement("div", { className: "pier-orientation-selectors" },
            React.createElement("div", null,
                React.createElement("span", { className: "pier-orientation-selector-label" }, "Low"),
                ' ',
                React.createElement("span", { className: "pier-orientation-selector-view" }, m.Berth() && m.Berth().CompassPoints.LowFootmarkCompassAbbreviation()),
                ' ',
                React.createElement("div", { className: "pier-orientation-edit-container" },
                    m.Model.Ref.CanEdit() && m.Berth() &&
                        React.createElement("span", { className: "pier-orientation-selector-edit fa fa-chevron-down", onClick: m.Berth().CompassPoints.ToggleCompassPointsMenu }),
                    ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.CompassPoints.ShowCompassPointsMenu()) &&
                        React.createElement(view_2.PCDismissible, { className: "pier-orientation-compass-points-menu", onDismiss: m.Berth().CompassPoints.ToggleCompassPointsMenu }, m.Berth().CompassPoints.AvailablePoints.map(function (compass) {
                            return React.createElement("div", { className: cx('pier-orientation-compass-points-menu-item', {
                                    selected: m.Berth().Model.LowFootmarkCompassPoint() === compass.Id
                                }), onClick: function () { return m.Berth().CompassPoints.SelectCompassPoint(compass.Id); }, key: compass.Id }, compass.Abbreviation);
                        })))),
            React.createElement("div", { className: "pier-orientation-high-row" },
                React.createElement("span", { className: "pier-orientation-selector-label" }, "High"),
                ' ',
                React.createElement("span", { className: "pier-orientation-selector-view" }, (_c = m.Berth()) === null || _c === void 0 ? void 0 : _c.CompassPoints.HighFootmarkCompassAbbreviation()))));
});
var StartOverhangView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "maximum" },
        React.createElement("label", { className: "dim-label" }, "First Overhang"),
        ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().PierGroup().Measurements.ToggleableStartOverhang, disabled: !m.Model.Ref.CanEdit() }),
        React.createElement("div", { className: "setting-desc" }, "Designate the distance a vessel can extend outside the berth's first footmark."));
});
var EndOverhangView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "maximum" },
        React.createElement("label", { className: "dim-label" }, "Final Overhang"),
        ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().PierGroup().Measurements.ToggleableEndOverhang, disabled: !m.Model.Ref.CanEdit() }),
        React.createElement("div", { className: "setting-desc" }, "Designate the distance a vessel can extend outside the berth's final footmark."));
});
var LengthBufferView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "maximum" },
        React.createElement("div", null,
            React.createElement("label", { className: "dim-label" }, "Length Buffer"),
            m.Berth() && React.createElement(view_7.ToggleableMeasurementView, { model: m.Berth().Measurements.ToggleableLengthBuffer, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Assign extra space to a vessel's bow and stern to maintain space between vessels."));
});
var TimeBufferView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Time Buffer"),
            m.Berth() && React.createElement(view_1.NumericInput, { value: m.Berth().Model.TimeBuffer, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Specify the number of minutes required between reservations."));
});
var AutoCalculateBillsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Auto-calculate Bills"),
            React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Yes", offLabel: "No", checked: function () { return false; }, disabled: true })),
        React.createElement("div", { className: "setting-desc" }, "Select Yes to automatically calculate dockage and wharfage from the schedule. Select No when automatic billing doesn't apply, e.g. leased piers."));
});
var AvailableMooringHoursView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Available Mooring Hours"),
            m.Berth() &&
                React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Daylight", offLabel: "24/7", checked: m.Berth().Model.DaylightMooringOnly, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Note whether mooring is available 24/7 or only during daytime hours."));
});
var MultiVesselBerthingView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Multi-Vessel Berthing"),
            m.Berth() &&
                React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Multi", offLabel: "Single", checked: m.Berth().Model.MultiVesselBerthing, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Select Multi to allow multiple vessels to be scheduled across the pier. Choose Single to limit only one vessel to be scheduled at the pier.."));
});
var BerthTransitOffsetView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Berth Transit Offset"),
            m.Berth() && React.createElement(view_1.NumericInput, { value: m.Berth().Model.BerthTransitOffset, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Specify the average number of minutes from a common harbor entrance landmark to the berth. This offset is used to calculate the default inbound time."));
});
var IsPortExternalView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    var l = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Location();
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Is Port External"),
            l &&
                React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Yes", offLabel: "No", checked: l.Model.IsPortExternal, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Select Yes to indicate that this location is outside the port. E.g. anchorages.")));
});
var AgentChangeWindowView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "change-window-setting" },
            React.createElement("label", { className: "setting-label" }, "Reservation Window"),
            ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) &&
                React.createElement("span", null,
                    React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Yes", offLabel: "No", checked: m.Berth().PierGroup().ChangeWindowToggleChecked, disabled: !m.Model.Ref.CanEdit() }),
                    m.Berth().PierGroup().Model.AgentChangeWindowHours() !== null &&
                        React.createElement(ChangeWindowInput, { value: m.Berth().PierGroup().NonNullChangeWindow, disabled: !m.Model.Ref.CanEdit() }))),
        React.createElement(view_8.ValidationErrorView, { error: function () { var _a, _b; return (_b = (_a = m.Berth()) === null || _a === void 0 ? void 0 : _a.PierGroup()) === null || _b === void 0 ? void 0 : _b.Validation()['AgentChangeWindowHours']; } }),
        React.createElement("div", { className: "setting-desc" }, "Select Yes to set a window that reservations can be edited from their initial requests. Select No to avoid a reservation window restriction."));
});
var ConfigureChangeWindowModal = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var popup = (_c = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) === null || _c === void 0 ? void 0 : _c.ConfigureChangeWindowPopup();
    return (React.createElement(view_3.PCModal, { className: "configure-change-window-modal", shown: function () { return !!popup; }, onBackDropClick: popup === null || popup === void 0 ? void 0 : popup.Cancel },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Configure Reservation Window"),
            popup &&
                React.createElement("form", { className: "modal-body", onSubmit: eventWrappers_1.noDefault(popup.Commit) },
                    React.createElement("div", null,
                        React.createElement(ChangeWindowInput, { value: popup.ChangeWindowHours, autoFocus: true })),
                    React.createElement("div", { className: "buttons" },
                        React.createElement("a", { href: "", className: "cancel-btn", onClick: eventWrappers_1.noDefault(popup.Cancel) }, "Cancel"),
                        React.createElement("button", { className: "submit-btn pc-button pc-button-primary" }, "Save"))))));
});
var ChangeWindowInput = /** @class */ (function (_super) {
    __extends(ChangeWindowInput, _super);
    function ChangeWindowInput(props) {
        var _this = _super.call(this, props) || this;
        // Focus the input if requested. Do this w/ a timeout instead of a simple autoFocus property
        // to wait for the modal animation to complete in the case of the .configure-change-window-modal.
        _this.inputRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var autoFocus = _a.autoFocus;
            if (autoFocus) {
                var timeoutId_1 = setTimeout(function () {
                    el.focus();
                    el.select();
                }, ChangeWindowInput.FOCUS_DELAY_MS);
                s_js_1.default.cleanup(function () { return clearTimeout(timeoutId_1); });
            }
        });
        return _this;
    }
    ChangeWindowInput.prototype.srender = function (_a) {
        var value = _a.value, disabled = _a.disabled;
        return (React.createElement("span", { className: "change-window-input-container" },
            React.createElement(view_1.NumericInput, { inputRef: this.inputRef, className: "change-window-input", value: value, disabled: disabled }),
            React.createElement("span", { className: "change-window-uom" }, "hours")));
    };
    // Long enough for the animation on modal opening to complete
    ChangeWindowInput.FOCUS_DELAY_MS = 200;
    return ChangeWindowInput;
}(supercritical_1.SuperCriticalComponent));
var PreventAgentOverlapsView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Prevent Overlaps"),
            ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) &&
                React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Yes", offLabel: "No", checked: m.Berth().PierGroup().Model.PreventAgentOverlaps, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Select Yes to prevent reservations from being requested on top of other reservations. Select No to allow users to schedule reservations on top of others."));
});
var RequireKnownVesselsView = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "setting-label" }, "Require Known Vessels"),
            ((_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.PierGroup()) &&
                React.createElement(view_6.ToggleButton, { className: "toggler", onLabel: "Yes", offLabel: "No", checked: m.Berth().PierGroup().Model.RequireKnownVessels, disabled: !m.Model.Ref.CanEdit() })),
        React.createElement("div", { className: "setting-desc" }, "Select Yes to prevent reservations with length-only vessel submissions. Select No to allow length-only reservations."));
});
// TH 10/19/2016: Reverting Notes from a Quill HTML editor to a plain textarea b/c of XSS concerns.
// It looks like the latest version of Quill no longer exports HTML but a custom JSON format.
// http://quilljs.com/docs/api/
// So if we'd like to bring a rich text editor back in at some point, that might be a good way to go.
var NotesEditor = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "notes pc-card profile-body clearfix" },
        React.createElement("div", { className: "pc-card-header pc-card-title" }, "NOTES"),
        m.Berth() && React.createElement("textarea", { className: "editor", disabled: !m.Model.Ref.CanEdit(), value: m.Berth().Model.Notes() || '', onChange: function (e) { return m.Berth().Model.Notes(e.currentTarget.value); } }));
});
var ZoneExistsModal = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    var z = (_c = (_b = m.Berth()) === null || _b === void 0 ? void 0 : _b.Location()) === null || _c === void 0 ? void 0 : _c.ZoneOperationsModal();
    return (React.createElement(view_3.PCModal, { className: "zone-operations-modal", shown: function () { return !!z; } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" }, z && (z.Mode() === 0 /* PromptOverwrite */ ?
                React.createElement("div", null,
                    "Overwrite existing zone?",
                    React.createElement("br", null),
                    React.createElement("a", { href: "", className: "overwrite-choice", onClick: eventWrappers_1.noDefault(z.ConfirmOverwrite) }, "Yes"),
                    React.createElement("a", { href: "", className: "overwrite-choice", onClick: eventWrappers_1.noDefault(z.CancelLeafletEdit) }, "No"))
                : z.Mode() === 1 /* PromptManualEntry */ ?
                    React.createElement("div", null,
                        "How do you want to add an anchorage?",
                        React.createElement("br", null),
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(z.ContinueLeafletEdit) }, "Draw on map"),
                        React.createElement("br", null),
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return z.Mode(2 /* PerformManualEntry */); }) }, "Enter coordinates and radius"))
                    : z.Mode() === 2 /* PerformManualEntry */ ?
                        React.createElement("div", { className: "manualEntry" },
                            React.createElement("div", { className: "title" }, "Anchorage Details"),
                            React.createElement("label", { className: "header" }, "Latitude"),
                            React.createElement(view_1.NumericInput, { value: z.AnchorageLatitude }),
                            React.createElement("br", null),
                            React.createElement("label", { className: "header" }, "Longitude"),
                            React.createElement(view_1.NumericInput, { value: z.AnchorageLongitude }),
                            React.createElement("br", null),
                            React.createElement("label", { className: "header" }, "Radius"),
                            React.createElement(view_7.ToggleableMeasurementView, { model: z.ToggleableRadius }),
                            React.createElement(view_6.ToggleButton, { className: "uom", onLabel: "feet", offLabel: "meters", checked: z.AnchorageIsFeet }),
                            React.createElement("br", null),
                            z.ErrorMessage() && React.createElement("label", { className: "error" }, z.ErrorMessage()),
                            React.createElement("br", null),
                            React.createElement("a", { className: "commands", href: "", onClick: eventWrappers_1.noDefault(z.SaveManualEntry) }, "Save"),
                            React.createElement("a", { className: "commands", href: "", onClick: eventWrappers_1.noDefault(z.CancelLeafletEdit) }, "Cancel"))
                        : null)))));
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillExportSettings = void 0;
var s_js_1 = __webpack_require__(0);
function BillExportSettings(ajax, cache, _a) {
    var DraftModel = _a.DraftModel, LastExportDate = _a.LastExportDate, ApproveAndRecalculate = _a.ApproveAndRecalculate;
    var approveClient = ajax.Url(function () { return ApproveAndRecalculate.ApproveEndPoint({ BillingSystemId: ApproveAndRecalculate.BillingSystem().Id(), Id: DraftModel.Id() }); }), recalculateClient = ajax.Url(function () { return ApproveAndRecalculate.RecalculateEndPoint({ Id: DraftModel.Id() }); }), sendingRequest = s_js_1.default.data(false), billingStatus = s_js_1.default(function () {
        return DraftModel.Bills().length > 0 ? 0 /* Exported */ :
            DraftModel.ApprovalOfCharges() !== null ? 1 /* Approved */ :
                // TH 05/04/2017 -- We don't expect the Approve{Entity}Charges endpoints to check the
                // Billable flag. Essentially, Billable just drives whether the item appears on the
                // Billing Worklist. So we won't require that the Billable status actually be persisted.
                !DraftModel.Billable() ? 2 /* NonBillable */ :
                    3 /* Draft */;
    });
    return {
        DraftModel: DraftModel,
        SendingRequest: sendingRequest,
        LastExportDate: LastExportDate,
        ValidForApproval: ValidForApproval,
        CanRecalculate: function () { return !!ApproveAndRecalculate; },
        Approve: Approve,
        Recalculate: Recalculate,
        BillingStatus: billingStatus
    };
    function ValidForApproval() {
        return ApproveAndRecalculate &&
            ApproveAndRecalculate.BillingSystem() &&
            DraftModel.ApprovalOfCharges() === null &&
            DraftModel.Billable() &&
            ApproveAndRecalculate.JobComplete() &&
            // TH 05/04/2017 -- We expect the Approve{Entity}Charges endpoints to require that
            // the entity have a Customer. So it's important we make sure both the saved and
            // draft versions of the Customer are populated before we enable approving charges.
            !!ApproveAndRecalculate.PersistedModel.QBTracking.Customer() &&
            !!DraftModel.QBTracking.Customer();
    }
    function Approve() {
        return __awaiter(this, void 0, void 0, function () {
            var req, charges;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ApproveAndRecalculate)
                            throw new Error('Must specify ApproveAndRecalculate params to enable the Approve action.');
                        if (sendingRequest())
                            return [2 /*return*/];
                        sendingRequest(true);
                        req = approveClient.Post({});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        charges = _a.sent();
                        cache.ApprovalsOfCharges.update1(req.Date, charges);
                        return [3 /*break*/, 4];
                    case 3:
                        sendingRequest(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function Recalculate() {
        return __awaiter(this, void 0, void 0, function () {
            var approvalsKey, req, draftCharges_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ApproveAndRecalculate)
                            throw new Error('Must specify ApproveAndRecalculate params to enable the Recalculate action.');
                        if (sendingRequest())
                            return [2 /*return*/];
                        sendingRequest(true);
                        approvalsKey = DraftModel.ApprovalOfCharges().Id(), req = recalculateClient.Post({});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        draftCharges_1 = _a.sent();
                        s_js_1.default.freeze(function () {
                            cache.ApprovalsOfCharges.update(req.Date, [], [approvalsKey]);
                            ApproveAndRecalculate.DraftChargeCollections && ApproveAndRecalculate.DraftChargeCollections.update1(req.Date, draftCharges_1);
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        sendingRequest(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
exports.BillExportSettings = BillExportSettings;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigureRemindersCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ConfigureReminders_1 = __webpack_require__(567);
var ConfigureRemindersCache = /** @class */ (function (_super) {
    __extends(ConfigureRemindersCache, _super);
    function ConfigureRemindersCache(data) {
        var _this = _super.call(this) || this;
        _this.ConfigureReminders = PCCache_1.PCCollection(ConfigureReminders_1.ConfigureReminders);
        new DataCache_1.SharedKeyRelationship(_this.ConfigureReminders, data.Organizations, function (c) { return c.Organization; }, null);
        return _this;
    }
    return ConfigureRemindersCache;
}(DataCache_1.DataCache));
exports.ConfigureRemindersCache = ConfigureRemindersCache;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigureReminders = void 0;
var s_js_1 = __webpack_require__(0);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
function ConfigureReminders(loader, ajax, data, _a) {
    var id = _a.id;
    var model = loader({ OrganizationId: id }, 30).model, org = data.Organizations.update1(null, { Id: id }), client = ajax.Url(function () { return org.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(org, client), validation = validationWatcher_1.ValidationWatcher(client), firstReminderDirty = s_js_1.default.data(false), finalReminderDirty = s_js_1.default.data(false);
    return {
        Model: model,
        Organization: org,
        Validation: validation,
        FirstReminderWindow: reminderWithDefault(draft.FirstReminderWindow, model.DefaultReminders.DefaultFirstReminderWindow, firstReminderDirty),
        FinalReminderWindow: reminderWithDefault(draft.FinalReminderWindow, model.DefaultReminders.DefaultFinalReminderWindow, finalReminderDirty),
        FirstReminderDirty: firstReminderDirty,
        FinalReminderDirty: finalReminderDirty
    };
}
exports.ConfigureReminders = ConfigureReminders;
function reminderWithDefault(reminderWindow, defaultReminderWindow, reminderDirty) {
    return function (val) {
        if (val === undefined)
            return reminderWindow() !== null || reminderDirty() ?
                reminderWindow()
                : defaultReminderWindow();
        s_js_1.default.freeze(function () {
            reminderDirty(true);
            reminderWindow(val);
        });
        return val;
    };
}


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigureRemindersRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1061);
var view_2 = __webpack_require__(12);
function ConfigureRemindersRoute(model, appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ConfigureRemindersView, { model: model(inboundParams(request)) }))
    };
}
exports.ConfigureRemindersRoute = ConfigureRemindersRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0)
    };
}


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigureRemindersView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(55);
var orgheaderview_1 = __webpack_require__(131);
var view_2 = __webpack_require__(29);
exports.ConfigureRemindersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "configurereminders pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: '#!orgprofile?id=' + m.Organization.Id() }, "<< Back to Organization")),
        React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Organization }),
        React.createElement("div", { className: "main-page pc-card" },
            React.createElement("div", null,
                React.createElement("div", { className: "pc-card-title" }, "Configure Reminders")),
            React.createElement("div", { className: "reminders" },
                React.createElement(ReminderView, { reminder: m.FirstReminderWindow, reminderName: "First", validation: m.Validation, validationKey: "FirstReminderWindow", reminderDirty: m.FirstReminderDirty, defaultReminderWindow: m.Model.DefaultReminders.DefaultFirstReminderWindow }),
                React.createElement(ReminderView, { reminder: m.FinalReminderWindow, reminderName: "Final", validation: m.Validation, validationKey: "FinalReminderWindow", reminderDirty: m.FinalReminderDirty, defaultReminderWindow: m.Model.DefaultReminders.DefaultFinalReminderWindow }))));
});
var ReminderView = supercritical_1.default(function (_a) {
    var reminder = _a.reminder, reminderName = _a.reminderName, validation = _a.validation, validationKey = _a.validationKey, reminderDirty = _a.reminderDirty, defaultReminderWindow = _a.defaultReminderWindow;
    return React.createElement("div", null,
        React.createElement("div", { className: "reminder-configuration" },
            React.createElement("span", { className: "reminder-type" },
                reminderName,
                " Reminder"),
            React.createElement("span", { className: "reminder-verb" }, "goes out"),
            React.createElement(view_1.NullableNumericInput, { className: "reminder-value", value: reminder, onBlur: function () { return reminderDirty(false); } }),
            React.createElement("span", { className: "reminder-short-descr" }, "days before the Port Call's First Line."),
            React.createElement("div", { className: "reminder-long-descr" },
                "Specify when the ",
                reminderName,
                " Reminder gets emailed. By default, the email is sent",
                ' ',
                defaultReminderWindow(),
                ' ',
                "days before the First Line Date.")),
        React.createElement(view_2.ValidationErrorView, { error: function () { return validation()[validationKey]; } }));
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsActionsTab = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var autoSave_1 = __webpack_require__(31);
var draftSignals_1 = __webpack_require__(37);
var mutex_1 = __webpack_require__(204);
var Rights_1 = __webpack_require__(118);
var CoordinationProvider_1 = __webpack_require__(201);
var CoordinationProviderCurrency_1 = __webpack_require__(206);
var CoordinationCardAction;
(function (CoordinationCardAction) {
    CoordinationCardAction["CancelCoordination"] = "cancel-coordination";
    CoordinationCardAction["ChangeProvider"] = "change-provider";
})(CoordinationCardAction || (CoordinationCardAction = {}));
function CoordinationCardDetailsActionsTab(ajax, entrypoints, _a) {
    var CoordinationCard = _a.CoordinationCard, DismissDetails = _a.DismissDetails, Rights = _a.Rights;
    var client = ajax.Url(function () { var _a; return (_a = CoordinationCard.Url()) !== null && _a !== void 0 ? _a : ''; }, { useCache: true }), 
    // A mutex to prevent overlapping attempts to save changes, especially to the same entity
    saveMutex = new mutex_1.Mutex(), selectedAction = s_js_1.default.value(null), actionIsSelected = function (action) { return function (val) {
        if (val === undefined) {
            return selectedAction() === action;
        }
        else {
            var isSelected = s_js_1.default.sample(selectedAction) === action;
            if (val !== isSelected)
                selectedAction(val ? action : null);
            return val;
        }
    }; }, CancelCoordination = CancelCoordinationAction(DismissDetails, Rights, client, saveMutex, actionIsSelected(CoordinationCardAction.CancelCoordination)), ChangeProvider = ChangeProviderAction(CoordinationCard, DismissDetails, Rights, client, saveMutex, actionIsSelected(CoordinationCardAction.ChangeProvider)), HasAnyAvailableActions = function () {
        return CancelCoordination.IsAvailable()
            || ChangeProvider.AvailableProviders().length > 0;
    }, Loading = function () {
        return CancelCoordination.IsPerforming()
            || ChangeProvider.IsPerforming();
    };
    return {
        CoordinationCard: CoordinationCard,
        CancelCoordination: CancelCoordination,
        ChangeProvider: ChangeProvider,
        HasAnyAvailableActions: HasAnyAvailableActions,
        Loading: Loading
    };
}
exports.CoordinationCardDetailsActionsTab = CoordinationCardDetailsActionsTab;
function CancelCoordinationAction(DismissDetails, Rights, client, saveMutex, IsSelected) {
    var IsAvailable = function () { return (Rights() & Rights_1.CoordinationCardRights.Cancel) !== 0; }, IsPerforming = s_js_1.default.value(false);
    return {
        IsSelected: IsSelected,
        IsAvailable: IsAvailable,
        IsPerforming: function () { return IsPerforming(); },
        Perform: Perform
    };
    function Perform() {
        return __awaiter(this, void 0, void 0, function () {
            var guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (IsPerforming())
                            return [2 /*return*/];
                        IsPerforming(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, saveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, client.Delete()];
                    case 4:
                        _a.sent();
                        DismissDetails();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        IsPerforming(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
}
function ChangeProviderAction(CoordinationCard, DismissDetails, Rights, client, saveMutex, IsSelected) {
    var draft = draftSignals_1.DraftObject(CoordinationCard, ['ProviderId']), AvailableProviders = s_array_1.lift(function () {
        var _a, _b;
        return (Rights() & Rights_1.CoordinationCardRights.ChangeProvider) === 0 ?
            [] : (_b = (_a = CoordinationCard.Coordination()) === null || _a === void 0 ? void 0 : _a.Providers()) !== null && _b !== void 0 ? _b : [];
    })
        .filter(function (p) {
        return p.Currency() === CoordinationProviderCurrency_1.CoordinationProviderCurrency.Current &&
            p.ProviderId() !== CoordinationCard.ProviderId();
    })
        .sort(CoordinationProvider_1.CoordinationProvider.DisplayOrder), IsPerforming = s_js_1.default.value(false);
    s_js_1.default(function () {
        if (IsSelected()) {
            if (AvailableProviders().length > 0) {
                draft.object.ProviderId(AvailableProviders()[0].ProviderId());
            }
        }
        else {
            draft.methods.checkpoint().revert();
        }
    });
    return {
        IsSelected: IsSelected,
        Draft: draft.object,
        AvailableProviders: AvailableProviders,
        IsPerforming: function () { return IsPerforming(); },
        Perform: Perform
    };
    function Perform() {
        return __awaiter(this, void 0, void 0, function () {
            var guard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (IsPerforming())
                            return [2 /*return*/];
                        IsPerforming(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, saveMutex.acquire()];
                    case 2:
                        guard = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 6]);
                        return [4 /*yield*/, autoSave_1.SaveDraftObject(draft, client)];
                    case 4:
                        _a.sent();
                        DismissDetails();
                        return [3 /*break*/, 6];
                    case 5:
                        guard.release();
                        return [7 /*endfinally*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        IsPerforming(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
}


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var CoordinationCardDetailsResponse_1 = __webpack_require__(1243);
var PCCache_1 = __webpack_require__(17);
var CoordinationCardDetailsCache = /** @class */ (function (_super) {
    __extends(CoordinationCardDetailsCache, _super);
    function CoordinationCardDetailsCache(data) {
        var _this = _super.call(this) || this;
        _this.CoordinationCardDetailsResponses = PCCache_1.PCCollection(CoordinationCardDetailsResponse_1.CoordinationCardDetailsResponse);
        new DataCache_1.SharedKeyRelationship(_this.CoordinationCardDetailsResponses, data.CoordinationCards, function (r) { return r.CoordinationCard; }, null);
        return _this;
    }
    return CoordinationCardDetailsCache;
}(DataCache_1.DataCache));
exports.CoordinationCardDetailsCache = CoordinationCardDetailsCache;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledCoordinationCardDetailsSettingsTab = void 0;
function CancelledCoordinationCardDetailsSettingsTab(_a) {
    var CoordinationCard = _a.CoordinationCard;
    return { CoordinationCard: CoordinationCard };
}
exports.CancelledCoordinationCardDetailsSettingsTab = CancelledCoordinationCardDetailsSettingsTab;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledCoordinationCardDetailsSettingsTabView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var actionsview_1 = __webpack_require__(512);
exports.CancelledCoordinationCardDetailsSettingsTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "cancelledcoordinationcarddetailssettingstab" },
        React.createElement(actionsview_1.CoordinationDescriptionView, { coordination: m.CoordinationCard.Coordination }));
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledCoordinationCardDetailsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var cancelled_1 = __webpack_require__(513);
var view_1 = __webpack_require__(197);
var cancelledsettingsview_1 = __webpack_require__(1065);
var logview_1 = __webpack_require__(514);
var view_2 = __webpack_require__(267);
exports.CancelledCoordinationCardDetailsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "cancelledcoordinationcarddetails" },
        React.createElement(view_1.PCTabStripView, { model: m.TabStrip, ctrl: new view_1.TitledTabStripViewController(), extraContents: function () {
                return React.createElement(view_2.CoordinationCardDetailsCloseLink, { dismissDetails: m.DismissDetails });
            } }),
        React.createElement(view_1.PCTabContents, { model: m.TabStrip, ctrl: new TabContentsController(m) }),
        React.createElement(view_2.CoordinationCardDetailsLoadingIcon, { loading: m.Loading }));
});
var TabContentsController = /** @class */ (function (_super) {
    __extends(TabContentsController, _super);
    function TabContentsController(model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        return _this;
    }
    TabContentsController.prototype.renderTabContents = function (tab) {
        var m = this.model;
        if (tab === cancelled_1.TabLog)
            return React.createElement(logview_1.CoordinationCardDetailsLogTabView, { model: m.LogTab });
        else if (tab === cancelled_1.TabSettings)
            return React.createElement(cancelledsettingsview_1.CancelledCoordinationCardDetailsSettingsTabView, { model: m.SettingsTab });
        else
            throw new Error("Unknown tab with title '" + tab.Title + "'");
    };
    return TabContentsController;
}(view_1.TitledTabContentsController));


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsLogTab = void 0;
var s_js_1 = __webpack_require__(0);
function CoordinationCardDetailsLogTab(newCommentModel, eventLogModel, logUpdaterModel, _a) {
    var CoordinationCardSelf = _a.CoordinationCardSelf;
    var EventLog = eventLogModel({
        log: CoordinationCardSelf.Log,
        canComment: function () { return true; }
    }), NewComment = newCommentModel({
        url: CoordinationCardSelf.CommentsUrl
    }), LogUpdater = logUpdaterModel({ CoordinationCardSelf: CoordinationCardSelf }), 
    // Count number of times our LogUpdater's isRequesting signal flips from true to false, starting at 0 and
    // stopping at 1.
    logUpdatesCalc = s_js_1.default(function (_a) {
        var prevCount = _a[0], wasRequesting = _a[1];
        return prevCount >= 1 ? [1, wasRequesting] :
            [prevCount + (wasRequesting && !LogUpdater.isRequesting() ? 1 : 0), LogUpdater.isRequesting()];
    }, [0, s_js_1.default.sample(LogUpdater.isRequesting)]), 
    // For the purposes of telling calling code whether to show a loading spinner or not, we wanna say that
    // we're loading if we're making our first attempt to load the log but not for any later attempts.
    Loading = function () { return logUpdatesCalc()[0] === 0 && LogUpdater.isRequesting(); };
    return {
        EventLog: EventLog,
        NewComment: NewComment,
        LogUpdater: LogUpdater,
        Loading: Loading
    };
}
exports.CoordinationCardDetailsLogTab = CoordinationCardDetailsLogTab;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardLogUpdater = void 0;
var LOG_REFRESH_SECONDS = 20;
function CoordinationCardLogUpdater(entrypoints, data, logUpdaterModel, _a) {
    var CoordinationCardSelf = _a.CoordinationCardSelf;
    return logUpdaterModel({
        collection: data.CoordinationCardRelevances,
        url: function (_a) {
            var NeedSince = _a.NeedSince;
            return entrypoints.CoordinationCardLog({ Id: CoordinationCardSelf.Id(), NeedSince: NeedSince });
        },
        refreshSeconds: LOG_REFRESH_SECONDS
    });
}
exports.CoordinationCardLogUpdater = CoordinationCardLogUpdater;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsStatusTab = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var CoordinationCardStatuses_1 = __webpack_require__(110);
var CoordinationCardStatusUpdateRequest_1 = __webpack_require__(1248);
var EventType_1 = __webpack_require__(111);
function CoordinationCardDetailsStatusTab(tzutils, data, ajax, entrypoints, _a) {
    var CoordinationCard = _a.CoordinationCard, DismissDetails = _a.DismissDetails, HasEditStatus = _a.HasEditStatus;
    var 
    // NOTE: Here's a spot where we bypass the alt label if the current status is pending.
    CurrentStatusLabel = function () { return CoordinationCard.EffectiveStatusLabel(true); }, StatusExplanatoryEvent = s_js_1.default(function () {
        var _a, _b;
        // Find the event that best explains the current status. Could be one of several event types.
        var bestGuess = (_a = CoordinationCard.Self()) === null || _a === void 0 ? void 0 : _a.Events().filter(function (ev) {
            // Status update events can clearly explain the current status
            return ev.Type() === EventType_1.EventType.CCardStatusUpdate
                // If the status has never changed since the last (re)requested event, then that might
                // explain the current status.
                || ev.Type() === EventType_1.EventType.CCardRequested;
        }).reduce(function (currentGuess, nextEv) { return currentGuess === undefined || nextEv.Id() > currentGuess.Id() ? nextEv : currentGuess; }, undefined);
        // If best guess so far is a status update event, see if we can improve our guess.
        if ((bestGuess === null || bestGuess === void 0 ? void 0 : bestGuess.Type()) === EventType_1.EventType.CCardStatusUpdate)
            bestGuess = bestGuess.CCardStatusUpdateCause();
        // Finally, to defend against holes in our event history, only use our guess should its StatusId
        // match the current StatusId. Otherwise, in case of a mismatch, give priority to the current
        // StatusId.
        return ((_b = bestGuess === null || bestGuess === void 0 ? void 0 : bestGuess.CoordinationCardVersion()) === null || _b === void 0 ? void 0 : _b.StatusId()) === CoordinationCard.StatusId() ? bestGuess : null;
    }), 
    // clock for time ago language in detailed status explanation text
    statusExplanationClock = tzutils.clock(1000), StatusExplanationNow = function () { return statusExplanationClock.now(); }, StatusReasonExplanatoryEvent = s_js_1.default(function () {
        var _a;
        // StatusReason gets set at the same time as Status. So the event that explains the current status
        // SHOULD also explain the current StatusReason. Just do a defensive check to make sure the event's
        // StatusReason matches the current StatusReason, and again we'll give priority to the current
        // StatusReason in case of a mismatch.
        var ev = StatusExplanatoryEvent();
        return ((_a = ev === null || ev === void 0 ? void 0 : ev.CoordinationCardVersion()) === null || _a === void 0 ? void 0 : _a.StatusReason()) === CoordinationCard.StatusReason() ? ev : null;
    }), AvailableStatuses = s_array_1.lift(function () { return HasEditStatus() ? Array.from(data.CoordinationCardStatuses.items()) : []; })
        // Pending is never available as an option for admins to choose (it can only be the
        // result of an auto status reset).
        .filter(function (s) { return s.Id() !== CoordinationCardStatuses_1.CoordinationCardStatuses.Pending; })
        .map(function (s) { return AvailableStatus(CoordinationCard, s, function () { return pendingStatus(s); }); })
        .orderBy(function (s) { return s.Model.DisplayOrder(); }), pendingStatus = s_js_1.default.value(null), pendingStatusUpdate = s_js_1.default(function () {
        return pendingStatus() === null ? null : PendingStatusUpdate(CoordinationCard, pendingStatus(), ajax, entrypoints, DismissDetails, function () { return pendingStatus(null); });
    }), Loading = function () { var _a, _b; return (_b = (_a = pendingStatusUpdate()) === null || _a === void 0 ? void 0 : _a.Submitting()) !== null && _b !== void 0 ? _b : false; };
    return {
        CoordinationCard: CoordinationCard,
        CurrentStatusLabel: CurrentStatusLabel,
        StatusExplanatoryEvent: StatusExplanatoryEvent,
        StatusExplanationNow: StatusExplanationNow,
        StatusReasonExplanatoryEvent: StatusReasonExplanatoryEvent,
        AvailableStatuses: AvailableStatuses,
        PendingStatusUpdate: pendingStatusUpdate,
        Loading: Loading
    };
}
exports.CoordinationCardDetailsStatusTab = CoordinationCardDetailsStatusTab;
function AvailableStatus(ccard, status, Select) {
    var Label = function () { var _a, _b; return (_b = (_a = ccard.Coordination()) === null || _a === void 0 ? void 0 : _a.EffectiveStatusLabel(status)) !== null && _b !== void 0 ? _b : ''; };
    return {
        Model: status,
        Label: Label,
        Select: Select
    };
}
function PendingStatusUpdate(ccard, status, ajax, entrypoints, dismissDetails, dismissPendingUpdate) {
    var url = entrypoints.CoordinationCardStatusUpdates({ Id: ccard.Id() }), client = ajax.Url(url, { useCache: true }), Request = new CoordinationCardStatusUpdateRequest_1.CoordinationCardStatusUpdateRequest({
        StatusId: status.Id(),
        // When reconfirming the existing status, default to the existing status reason, if any, otherwise
        // start with an empty status reason.
        StatusReason: s_js_1.default.sample(function () { return ccard.StatusId() === status.Id() ? ccard.StatusReason() : null; })
    }), StatusLabel = function () { var _a, _b; return (_b = (_a = ccard.Coordination()) === null || _a === void 0 ? void 0 : _a.EffectiveStatusLabel(status)) !== null && _b !== void 0 ? _b : ''; }, IsStatusReasonRequired = function () { return status.Id() === CoordinationCardStatuses_1.CoordinationCardStatuses.Denied; }, CanSubmit = function () { return !!Request.StatusReason() || !IsStatusReasonRequired(); }, Submitting = s_js_1.default.value(false);
    return {
        Request: Request,
        StatusLabel: StatusLabel,
        IsStatusReasonRequired: IsStatusReasonRequired,
        CanSubmit: CanSubmit,
        Submit: Submit,
        Submitting: Submitting,
        Cancel: dismissPendingUpdate
    };
    function Submit() {
        if (Submitting())
            return;
        Submitting(true);
        client.Post(Request)
            .then(dismissDetails)
            .finally(function () { return Submitting(false); });
    }
}


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsStatusTabView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var CoordinationCardStatuses_1 = __webpack_require__(110);
var EventType_1 = __webpack_require__(111);
var view_1 = __webpack_require__(150);
exports.CoordinationCardDetailsStatusTabView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationcarddetailsstatustab" }, m.PendingStatusUpdate() ?
        React.createElement(PendingStatusUpdateView, { update: m.PendingStatusUpdate() }) :
        React.createElement(MainStatusView, { model: m }));
});
var PendingStatusUpdateView = supercritical_1.default(function (_a) {
    var update = _a.update;
    return React.createElement("div", null,
        React.createElement("div", { className: "status-summary" },
            React.createElement(view_1.CCardStatusIndicator, { statusId: update.Request.StatusId() }),
            React.createElement("span", { className: "status-summary-text" },
                React.createElement("span", { className: "status-label" }, update.StatusLabel()))),
        React.createElement(PendingStatusReason, { update: update }),
        React.createElement(PendingStatusUpdateControls, { update: update }));
});
var PendingStatusReason = supercritical_1.default(function (_a) {
    var _b;
    var update = _a.update;
    return React.createElement("div", { className: "pending-status-reason-shell" },
        React.createElement("textarea", { className: cx('pending-status-reason', {
                required: update.IsStatusReasonRequired()
            }), value: (_b = update.Request.StatusReason()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return update.Request.StatusReason(e.currentTarget.value || null); }, placeholder: "Comment (" + (update.IsStatusReasonRequired() ? 'required' : 'optional') + ")...", autoFocus: true, onFocus: function (e) { return e.currentTarget.select(); } }));
});
var PendingStatusUpdateControls = supercritical_1.default(function (_a) {
    var update = _a.update;
    return React.createElement("div", { className: "pending-status-update-ctrls" },
        React.createElement("button", { className: "pc-button submit-btn", onClick: update.Submit, disabled: !update.CanSubmit() }, "Update"),
        React.createElement("button", { className: "pc-button cancel-btn", onClick: update.Cancel }, "Cancel"));
});
var MainStatusView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "status-summary" },
            React.createElement(view_1.CCardStatusIndicator, { statusId: m.CoordinationCard.StatusId() }),
            React.createElement("span", { className: "status-summary-text" },
                React.createElement("span", { className: "status-label" }, m.CurrentStatusLabel()),
                ' ',
                React.createElement(StatusShortExplanation, { model: m }))),
        React.createElement(StatusDetailedExplanation, { model: m }),
        React.createElement(StatusReason, { model: m }),
        React.createElement(AvailableStatuses, { model: m }));
});
var StatusShortExplanation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("span", { className: "status-short-expl" }, StatusShortExplanationText(m));
});
function StatusShortExplanationText(m) {
    var _a, _b;
    if (m.CoordinationCard.StatusId() === CoordinationCardStatuses_1.CoordinationCardStatuses.Pending) {
        var provider = (_a = m.CoordinationCard.Provider()) === null || _a === void 0 ? void 0 : _a.Provider();
        return provider ? "from " + provider.Name() : '';
    }
    else {
        var expl = m.StatusExplanatoryEvent(), org = (_b = expl === null || expl === void 0 ? void 0 : expl.User()) === null || _b === void 0 ? void 0 : _b.Organization(), automation = expl === null || expl === void 0 ? void 0 : expl.Automation();
        return org ? "by " + org.Name() : automation ? "by " + automation.Name() : '';
    }
}
var StatusDetailedExplanation = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "status-detailed-expl" }, StatusDetailedExplanationText(m));
});
function StatusDetailedExplanationText(m) {
    var _a;
    var expl = m.StatusExplanatoryEvent();
    if (expl) {
        var timeAgo = tzmoment_1.tzmoment(expl.Date()).from(m.StatusExplanationNow()), actorName = expl.ActorAbbreviatedName();
        if (expl.Type() === EventType_1.EventType.CCardStatusUpdate) {
            if (((_a = expl.CoordinationCardVersion()) === null || _a === void 0 ? void 0 : _a.StatusId()) === CoordinationCardStatuses_1.CoordinationCardStatuses.Pending) {
                return "milestone updated " + timeAgo;
            }
            else {
                return "updated " + timeAgo + " by " + actorName;
            }
        }
        else if (expl.Type() === EventType_1.EventType.CCardRequested) {
            return "coordination requested " + timeAgo;
        }
        else if (expl.Type() === EventType_1.EventType.CCardProviderChanged) {
            return "provider changed " + timeAgo + " by " + actorName;
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
}
var StatusReason = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.CoordinationCard.StatusReason() ?
        React.createElement("div", { className: "status-reason" },
            React.createElement("span", { className: "author" }, StatusReasonAuthor(m)),
            ' ',
            m.CoordinationCard.StatusReason()) :
        null;
});
function StatusReasonAuthor(m) {
    var _a;
    var authorName = (_a = m.StatusReasonExplanatoryEvent()) === null || _a === void 0 ? void 0 : _a.ActorAbbreviatedName();
    return authorName ? authorName + ":" : '';
}
var AvailableStatuses = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.AvailableStatuses().length > 0 ?
        React.createElement("div", { className: "available-statuses" },
            React.createElement("div", { className: "available-statuses-title" }, "Select Status Update"),
            m.AvailableStatuses().map(function (s) {
                return React.createElement(AvailableStatusView, { status: s, key: s.Model.Id() });
            })) :
        null;
});
var AvailableStatusView = supercritical_1.default(function (_a) {
    var s = _a.status;
    return React.createElement("div", { className: "available-status", onClick: s.Select },
        React.createElement(view_1.CCardStatusIndicator, { statusId: s.Model.Id() }),
        React.createElement("span", { className: "status-label" }, s.Label()));
});


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationConfiguratorRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var view_1 = __webpack_require__(12);
var view_2 = __webpack_require__(1072);
function CoordinationConfiguratorRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(view_2.CoordinationConfiguratorView, { model: m })),
        reflectState: function () { return new componentLocation_1.Location(request.name, outboundParams(m)); }
    };
}
exports.CoordinationConfiguratorRoute = CoordinationConfiguratorRoute;
function inboundParams(request) {
    var id = request.params['id'];
    return {
        id: id ? +id : undefined
    };
}
function outboundParams(m) {
    var p = {};
    if (m.Model.Id())
        p['id'] = '' + m.Model.Id();
    return p;
}


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationConfiguratorView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var CoordinationEditingPolicy_1 = __webpack_require__(605);
var CoordinationProviderCurrency_1 = __webpack_require__(206);
var model_1 = __webpack_require__(516);
var view_1 = __webpack_require__(150);
var view_2 = __webpack_require__(40);
var view_3 = __webpack_require__(132);
var view_4 = __webpack_require__(91);
exports.CoordinationConfiguratorView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationconfigurator pc-page-fixedwidth" },
        React.createElement("div", { className: "header-row" },
            React.createElement(Header, { model: m }),
            React.createElement(SaveAndQuit, { model: m })),
        React.createElement("div", { className: "page-body" },
            React.createElement(Title, { model: m }),
            React.createElement(Description, { model: m }),
            React.createElement(AdminNotes, { model: m }),
            React.createElement(IsMandatory, { model: m }),
            React.createElement(Functions, { model: m }),
            React.createElement(AltStatusLabels, { model: m }),
            React.createElement(MilestoneTypes, { model: m }),
            React.createElement(MainLocations, { model: m }),
            React.createElement(RelatedLocations, { model: m }),
            React.createElement(Providers, { model: m })),
        React.createElement(view_2.PageLoadingIndicator, { loading: function () { return m.Loading() || m.SavingChanges(); } }));
});
var Header = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "header" },
        "Coordination Configurator",
        React.createElement("span", { className: "slash" }, "/"),
        m.Model.Title() || '[Card Title]');
});
var SaveAndQuit = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "save-quit" },
        React.createElement("div", null,
            React.createElement("button", { className: "pc-button save-button", disabled: !m.HasUnsavedChanges() || m.SavingChanges() || m.ClientValidationErrorsCount() > 0, onClick: eventWrappers_1.noDefault(m.SaveChanges) }, "Save Changes"),
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.QuitChanges) }, "Cancel")),
        m.ClientValidationErrorsCount() > 0 &&
            React.createElement("div", { className: "config-error" },
                m.ClientValidationErrorsCount(),
                " validation error",
                m.ClientValidationErrorsCount() === 1 ? '' : 's',
                " preventing save..."));
});
var Title = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row title-row" },
        React.createElement("label", { className: "config-row-label" }, "Title"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null,
                React.createElement("input", { className: "title-input pc-breaker-label", placeholder: "Text input", value: m.Model.Title(), onChange: function (e) { return m.Model.Title(e.currentTarget.value); } })),
            m.ServerValidation()['Title'] &&
                React.createElement("div", { className: "config-error" }, m.ServerValidation()['Title'].ErrorText)));
});
var Description = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row descr-row" },
        React.createElement("label", { className: "config-row-label" }, "Description"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null,
                React.createElement("input", { className: "descr-input pc-breaker-label", placeholder: "Text input", value: m.Model.Description(), onChange: function (e) { return m.Model.Description(e.currentTarget.value); } })),
            m.ServerValidation()['Description'] &&
                React.createElement("div", { className: "config-error" }, m.ServerValidation()['Description'].ErrorText)));
});
var AdminNotes = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "config-row admin-notes-row" },
        React.createElement("label", { className: "config-row-label" }, "Admin Notes"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null,
                React.createElement("input", { className: "admin-notes-input pc-breaker-label", placeholder: "Text input", value: (_b = m.Model.AdminNotes()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.Model.AdminNotes(e.currentTarget.value || null); } })),
            m.ServerValidation()['AdminNotes'] &&
                React.createElement("div", { className: "config-error" }, m.ServerValidation()['AdminNotes'].ErrorText),
            React.createElement("div", { className: "config-descr admin-notes-descr" }, "Optional notes that will only appear on the Coordination Configurator. You can use these to help distinguish between coordinations that might have the same Title but different Main/Related Locations.")));
});
var IsMandatory = supercritical_1.default(function (_a) {
    var _b;
    var m = _a.model;
    return React.createElement("div", { className: "config-row is-mandatory-row" },
        React.createElement("label", { className: "config-row-label" }, "Type"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null,
                React.createElement("label", { className: "pc-breaker" },
                    React.createElement("span", { className: "pc-breaker-button" },
                        React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: m.Model.IsMandatory(), onChange: function (e) { return m.Model.IsMandatory(e.currentTarget.checked); } }),
                        React.createElement("span", { className: "pc-breaker-light" })),
                    React.createElement("span", { className: "pc-breaker-label" }, "Mandatory: add to all PortCalls"))),
            React.createElement("div", null,
                React.createElement("label", { className: "pc-breaker" },
                    React.createElement("span", { className: "pc-breaker-button" },
                        React.createElement("input", { className: "pc-breaker-input", type: "radio", checked: !m.Model.IsMandatory(), onChange: function (e) { return m.Model.IsMandatory(!e.currentTarget.checked); } }),
                        React.createElement("span", { className: "pc-breaker-light" })),
                    React.createElement("span", { className: "pc-breaker-label" }, "Question: ask user if coordination is required"))),
            !m.Model.IsMandatory() &&
                React.createElement("div", { className: "agent-prompt-shell" },
                    React.createElement("input", { className: "agent-prompt-input", placeholder: "Question Text", value: (_b = m.Model.AgentPrompt()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.Model.AgentPrompt(e.currentTarget.value); } }),
                    m.ServerValidation()['AgentPrompt'] &&
                        React.createElement("div", { className: "config-error" }, m.ServerValidation()['AgentPrompt'].ErrorText),
                    React.createElement("span", { className: "config-descr agent-prompt-descr" }, "Enter the question the user needs to answer. Shorter is better. Example: Is pilotage required?"))));
});
var Functions = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row functions-row" },
        React.createElement("label", { className: "config-row-label" }, "Functions"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null,
                React.createElement("label", { className: "pc-breaker" },
                    React.createElement("span", { className: "pc-breaker-button" },
                        React.createElement("input", { className: "pc-breaker-input", type: "checkbox", checked: m.Model.AppearsOnTraffic(), onChange: function (e) { return m.Model.AppearsOnTraffic(e.currentTarget.checked); } }),
                        React.createElement("span", { className: "pc-breaker-light" })),
                    React.createElement("span", { className: "pc-breaker-label" }, "Appears on Traffic")))));
});
var AltStatusLabels = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row alt-status-labels-row" },
        React.createElement("label", { className: "config-row-label" }, "Status Labels"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", { className: "alt-status-labels-header" },
                React.createElement("span", { className: "config-descr alt-status-labels-col col-definition" }, "Default Definition/Label"),
                React.createElement("span", { className: "config-descr alt-status-labels-col col-alt-label" }, "Alternate Label")),
            React.createElement("div", { className: "alt-status-labels-body" }, m.CoordinationCardStatuses().map(function (status) {
                return React.createElement(AltStatusLabelRow, { status: status, key: status.Model.Id() });
            }))));
});
var AltStatusLabelRow = supercritical_1.default(function (_a) {
    var s = _a.status;
    return React.createElement("div", { className: "status-row" },
        React.createElement("div", null,
            React.createElement("span", { className: "alt-status-labels-col col-definition" },
                React.createElement(view_1.CCardStatusIndicator, { statusId: s.Model.Id() }),
                React.createElement("span", { className: "definition-text" }, s.Model.Definition())),
            React.createElement("span", { className: "alt-status-labels-col col-alt-label" },
                React.createElement("input", { className: "alt-label-input", value: s.AltLabelText() || (s.IsEditingLabel() ? '' : '--'), onChange: function (e) { return s.AltLabelText(e.currentTarget.value); }, onFocus: function () { return s.IsEditingLabel(true); }, onBlur: function () { return s.IsEditingLabel(false); } }))),
        s.ServerValidation()['Label'] &&
            React.createElement("div", { className: "config-error" }, s.ServerValidation()['Label'].ErrorText));
});
var MilestoneTypes = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row milestone-types-row" },
        React.createElement("label", { className: "config-row-label" }, "Milestones"),
        React.createElement("div", { className: "config-row-block" },
            React.createElement("div", null, m.MilestoneTypes().map(function (type) {
                return React.createElement(MilestoneTypeRow, { type: type, model: m, key: type.Model.Id() });
            })),
            React.createElement("div", { className: "config-descr milestone-types-descr" }, "Select all applicable milestones for this coordination."),
            m.NumMilestoneTypesSelected() === 0 &&
                React.createElement("div", { className: "config-error" }, "Caution: There are no milestones selected. You may save this coordination, but it won't be available for any PortCalls.")));
});
var MilestoneTypeRow = supercritical_1.default(function (_a) {
    var t = _a.type, m = _a.model;
    return React.createElement("div", { className: "type-row" },
        React.createElement("label", { className: "pc-breaker" },
            React.createElement("span", { className: "pc-breaker-button" },
                React.createElement("input", { className: "pc-breaker-input", type: "checkbox", checked: t.IsSelected(), onChange: function (e) { return t.IsSelected(e.currentTarget.checked); } }),
                React.createElement("span", { className: "pc-breaker-light" })),
            React.createElement("span", { className: "pc-breaker-label" }, t.Model.Name())));
});
var MainLocations = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row locations-row main-locations-row" },
        React.createElement("label", { className: "config-row-label" }, "Main Locations"),
        React.createElement("div", { className: "config-row-block" },
            m.Model.IsScopedByMainLocation() ?
                React.createElement(ExplicitLocations, { locations: m.MainLocations, addLocation: m.AddMainLocation, onApplyToAll: function () { return m.Model.IsScopedByMainLocation(false); } }) :
                React.createElement(AllLocations, { onSelectLocations: function () { return m.Model.IsScopedByMainLocation(true); } }),
            React.createElement("div", { className: "config-descr main-locations-descr" }, "The main locations for this coordination. A milestone's main location is always the location where that milestone is occurring, which may be a berth or may be the sea point and/or pilot area.")));
});
var RelatedLocations = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row locations-row related-locations-row" },
        React.createElement("label", { className: "config-row-label" }, "Related Locations"),
        React.createElement("div", { className: "config-row-block" },
            m.Model.IsScopedByRelatedLocation() ?
                React.createElement(ExplicitLocations, { locations: m.RelatedLocations, addLocation: m.AddRelatedLocation, onApplyToAll: function () { return m.Model.IsScopedByRelatedLocation(false); } }) :
                React.createElement(AllLocations, { onSelectLocations: function () { return m.Model.IsScopedByRelatedLocation(true); } }),
            React.createElement("div", { className: "config-descr related-locations-descr" }, "The related locations for this coordination. For milestones at a movement's departure point, the related location is the movement's arrival point. For milestones at a movement's arrival point, the related location is the movement's departure point.")));
});
var ExplicitLocations = supercritical_1.default(function (_a) {
    var locations = _a.locations, addLocation = _a.addLocation, onApplyToAll = _a.onApplyToAll;
    return React.createElement("div", null,
        React.createElement("div", { className: "locations-input-shell" },
            React.createElement(view_4.TypeaheadInput, { className: "pc-breaker-label add-location", model: addLocation.LocationSelector, placeholder: "Add a location..." }),
            React.createElement("a", { href: "", className: "locations-scope-toggle", onClick: eventWrappers_1.noDefault(onApplyToAll) }, "Apply to All Locations")),
        locations().length ?
            React.createElement("div", { className: "locations-selected-locations" }, locations().map(function (l) {
                // Keying by LocationId here as we expect the provided locations to already be filtered by
                // Type.
                return React.createElement(SelectedLocation, { location: l, key: l.Model.LocationId() });
            })) :
            React.createElement("div", { className: "config-error" }, "Caution: There are no locations selected. You may save this coordination, but it won't be available for any PortCalls."));
});
var SelectedLocation = supercritical_1.default(function (_a) {
    var l = _a.location;
    return React.createElement("div", { className: "locations-selected-location" },
        React.createElement("span", { className: "loc-name" }, l.Model.Location() && model_1.LocationDisplayKey(l.Model.Location())),
        React.createElement("a", { href: "", className: "loc-delete fa fa-times", onClick: eventWrappers_1.noDefault(l.Delete) }));
});
var AllLocations = supercritical_1.default(function (_a) {
    var onSelectLocations = _a.onSelectLocations;
    return React.createElement("div", { className: "locations-input-shell" },
        React.createElement("span", { className: "pc-breaker-label" }, "All (default)"),
        React.createElement("a", { href: "", className: "locations-scope-toggle", onClick: eventWrappers_1.noDefault(onSelectLocations) }, "Select Locations"));
});
var Providers = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "config-row providers-row" },
        React.createElement("label", { className: "config-row-label" }, "Providers"),
        React.createElement("div", { className: "config-row-block is-not-berth-assignment" },
            React.createElement("div", { className: "providers-table" },
                React.createElement(ProvidersTableHeader, null),
                React.createElement(view_3.PCSortable, { className: "providers-table-body", items: m.Providers, onSort: m.OnSortProviders, rowFactory: function (p) {
                        return React.createElement(SelectedProvider, { provider: p, key: p.Model.ProviderId() });
                    } })),
            !m.HasCurrentProvider() &&
                React.createElement("div", { className: "config-error" }, "At least one current provider is required."),
            React.createElement("div", { className: "add-provider-shell" },
                React.createElement(view_4.TypeaheadInput, { className: "pc-breaker-label add-provider", model: m.AddProvider.ProviderSelector, placeholder: "Add a provider..." }))));
});
var ProvidersTableHeader = supercritical_1.default(function () {
    return React.createElement("div", { className: "providers-table-header" },
        React.createElement("span", { className: "providers-table-col col-name" }, "Name"),
        React.createElement("span", { className: "providers-table-col col-editing-policy" }, "Edit Mode"),
        React.createElement("span", { className: "providers-table-col col-currency" }, "Status"),
        React.createElement("span", { className: "providers-table-col col-delete" }, "\u00A0"));
});
var SelectedProvider = supercritical_1.default(function (_a) {
    var _b;
    var p = _a.provider;
    return React.createElement("li", { className: "providers-table-row" },
        React.createElement("span", { className: "providers-table-col col-name" }, (_b = p.Model.Provider()) === null || _b === void 0 ? void 0 : _b.Name()),
        React.createElement("span", { className: "providers-table-col col-editing-policy" },
            React.createElement("select", { className: "providers-select-pill", 
                // NOTE: Setting up this <select> element to be specific to the AllowAgentStatusEdits bit w/in
                // the provider's EditingPolicy. If we add other bits that can be toggled on/off, we can either
                // add other <select> elements for those other bits or we can expand this <select> element to
                // cover more bits and include more logical combos in its list of <option>s.
                value: p.GetEditingPolicyBits(CoordinationEditingPolicy_1.CoordinationEditingPolicy.AllowAgentStatusEdits), onChange: function (e) { return p.SetEditingPolicyBits(CoordinationEditingPolicy_1.CoordinationEditingPolicy.AllowAgentStatusEdits, +e.currentTarget.value); } },
                React.createElement("option", { value: CoordinationEditingPolicy_1.CoordinationEditingPolicy.AllowAgentStatusEdits }, "Provider +"),
                React.createElement("option", { value: CoordinationEditingPolicy_1.CoordinationEditingPolicy.None }, "Provider Only"))),
        React.createElement("span", { className: "providers-table-col col-currency" },
            React.createElement("select", { className: "providers-select-pill", value: p.Model.Currency(), onChange: function (e) { return p.Model.Currency(+e.currentTarget.value); }, disabled: !p.IsPersisted }, CoordinationProviderCurrency_1.CoordinationProviderCurrencys.map(function (_a) {
                var Id = _a.Id;
                return React.createElement("option", { value: Id, key: Id }, CoordinationProviderCurrency_1.CoordinationProviderCurrencyDisplayName[Id]);
            }))),
        React.createElement("span", { className: "providers-table-col col-delete" }, !p.IsPersisted &&
            React.createElement("a", { href: "", className: "delete-btn fa fa-times", onClick: eventWrappers_1.noDefault(p.Delete) })));
});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationsOverview = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var autoSave_1 = __webpack_require__(31);
var draftSignals_1 = __webpack_require__(37);
var mutex_1 = __webpack_require__(204);
var Coordination_1 = __webpack_require__(200);
var CoordinationCurrency_1 = __webpack_require__(205);
function CoordinationsOverview(loader, domain, ajax, entrypoints, data, _params) {
    var Coordinations = domain.Coordinations
        .map(function (c) { return CoordinationViewModel(c, ajax); })
        .sort(function (c1, c2) { return Coordination_1.Coordination.DisplayOrder(c1.Model, c2.Model); }), MilestoneTypes = s_array_1.lift(function () { return Array.from(data.MilestoneTypes.items()); })
        .orderBy(function (t) { return t.DisplayOrder(); }), initialDataLoad = loader({ Id: s_js_1.default.sample(domain.Id) }), displayOrderSaver = DisplayOrderSaver(data, ajax, entrypoints, Coordinations);
    return {
        Coordinations: Coordinations,
        MilestoneTypes: MilestoneTypes,
        Loading: function () { return initialDataLoad.loading() || displayOrderSaver.SavingDisplayOrder() || Coordinations().some(function (c) { return c.SavingCurrency(); }); },
        OnSortCoordinations: OnSortCoordinations
    };
    function OnSortCoordinations(_movedCoordination, newOrder) {
        s_js_1.default.freeze(function () { return newOrder.forEach(function (c, i) { return c.Model.DisplayOrder(i); }); });
    }
}
exports.CoordinationsOverview = CoordinationsOverview;
function DisplayOrderSaver(data, ajax, entrypoints, Coordinations) {
    var client = ajax.Url(entrypoints.ReorderCoordinations), persistedOrder = Coordinations.sort(function (c1, c2) { return Coordination_1.Coordination.DisplayOrder(c1.Persisted, c2.Persisted); }), draftOrder = Coordinations.sort(function (c1, c2) { return Coordination_1.Coordination.DisplayOrder(c1.Model, c2.Model); }), 
    // Counter that increases monotonically whever there's a discrepancy between persisted order and draft
    // order.
    orderChangeCount = s_js_1.default.value(0), SavingDisplayOrder = s_js_1.default.value(false);
    s_js_1.default(function (lastCount) { return orderChangeCount(lastCount + (arrayEq(persistedOrder(), draftOrder()) ? 0 : 1)); }, s_js_1.default.sample(orderChangeCount));
    autoSave_1.AutoSaver(orderChangeCount, function () {
        SavingDisplayOrder(true);
        var checkpoints = draftOrder().map(function (c) { return c.DisplayOrderCheckpoint(); });
        return Promise.all(draftOrder().map(function (c) { return c.SaveMutex.acquire(); })).then(function (guards) { return Promise.resolve()
            .then(function () {
            var req = client.Post({
                Coordinations: draftOrder().map(function (c) { return ({ Id: c.Model.Id() }); })
            });
            return req.then(function (domainData) { return s_js_1.default.freeze(function () {
                data.Domains.update1(req.Date, domainData);
                checkpoints.forEach(function (c) { return c.revert(); });
            }); });
        })
            .finally(function () { return guards.forEach(function (guard) { return guard.release(); }); }); }).finally(function () { return SavingDisplayOrder(false); });
    }, 0);
    return { SavingDisplayOrder: SavingDisplayOrder };
}
function CoordinationViewModel(coordination, ajax) {
    var 
    // DisplayOrder and Currency in their own DraftObjects as we'll handle persisting them separately.
    displayOrderDraftObj = draftSignals_1.DraftObject(coordination, ['DisplayOrder']), displayOrderDraft = displayOrderDraftObj.object, currencyDraftObj = draftSignals_1.DraftObject(displayOrderDraft, ['Currency']), currencyDraft = currencyDraftObj.object, client = ajax.Url(function () { var _a; return (_a = coordination.Url()) !== null && _a !== void 0 ? _a : ''; }), 
    // A mutex to serialize any attempts to persist new DisplayOrder or Currency values. This isn't so much
    // to avoid server-side races -- we've partitioned our server-side code such that DisplayOrder and
    // Currency edits are handled by separate endpoints that avoid modifying each other's properties.
    // Instead, it's about avoiding client-side races updating our cached Coordination model after a
    // successful save.
    SaveMutex = new mutex_1.Mutex(), ShowActionsMenu = s_js_1.default.value(false), SavingCurrency = s_js_1.default.value(false);
    autoSave_1.AutoSaver(currencyDraftObj.methods.onWrite, function () {
        SavingCurrency(true);
        var checkpoint = currencyDraftObj.methods.checkpoint();
        return SaveMutex.acquire().then(function (guard) { return Promise.resolve()
            .then(function () { return client.Put(currencyDraft).then(function () { return checkpoint.commit(); }); })
            // Revert in case of errors to allow retrying
            .catch(function (err) { checkpoint.revert(); throw err; })
            .finally(function () { return guard.release(); }); }).finally(function () { return SavingCurrency(false); });
    }, 0);
    return {
        // displayOrderDraft and NOT currencyDraft. We won't update the displayed currency value in the main
        // table until that value has been persisted.
        Model: displayOrderDraft,
        Persisted: coordination,
        SaveMutex: SaveMutex,
        ShowActionsMenu: ShowActionsMenu,
        SavingCurrency: SavingCurrency,
        DisplayOrderCheckpoint: function () { return displayOrderDraftObj.methods.checkpoint(); },
        ApplicableForMilestoneType: ApplicableForMilestoneType,
        MenuAction: MenuAction,
        ToggleCurrency: ToggleCurrency
    };
    function ApplicableForMilestoneType(t) {
        return coordination.MilestoneTypes().some(function (ct) { return ct.MilestoneType() === t; });
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            ShowActionsMenu(false);
            action();
        }); };
    }
    function ToggleCurrency() {
        // TODO: A nice-to-have here would be detecting if the user is trying to restore a mandatory coordination
        // and if so spawning a confirmation popup to make sure they know that this might auto-create C-Cards.
        currencyDraft.Currency(s_js_1.default.sample(coordination.Currency) === CoordinationCurrency_1.CoordinationCurrency.Current ? CoordinationCurrency_1.CoordinationCurrency.Deprecated : CoordinationCurrency_1.CoordinationCurrency.Current);
    }
}
function arrayEq(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    for (var i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i])
            return false;
    }
    return true;
}


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationsOverviewRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(12);
var view_2 = __webpack_require__(1075);
function CoordinationsOverviewRoute(model, appWrapper, _request) {
    var m = model({});
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(view_2.CoordinationsOverviewView, { model: m }))
    };
}
exports.CoordinationsOverviewRoute = CoordinationsOverviewRoute;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationsOverviewView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var CoordinationCurrency_1 = __webpack_require__(205);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(35);
var view_3 = __webpack_require__(132);
exports.CoordinationsOverviewView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinationsoverview pc-page-fixedwidth" },
        React.createElement("div", { className: "header" }, "Coordination Configurator"),
        React.createElement("div", { className: "body" },
            React.createElement(TableHeader, { model: m }),
            React.createElement(TableBody, { model: m }),
            React.createElement(AddCoordinationLink, null)),
        React.createElement(view_1.PageLoadingIndicator, { loading: m.Loading }));
});
var TableHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "coordinations-table-header" },
        React.createElement("span", { className: "coordinations-col col-title" }, "Coordination Title"),
        React.createElement("span", { className: "coordinations-col col-admin-notes" }, "Admin Notes"),
        React.createElement("span", { className: "coordinations-col col-description" }, "Description"),
        React.createElement("span", { className: "coordinations-col col-currency" }, "Status"),
        m.MilestoneTypes().map(function (t) {
            return React.createElement("span", { className: "coordinations-col milestone-col", key: t.Id() }, t.Nickname());
        }),
        React.createElement("span", { className: "coordinations-col col-actions" }, "\u00A0"));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_3.PCSortable, { className: "coordinations-table-body", items: m.Coordinations, onSort: m.OnSortCoordinations, rowFactory: function (c) {
            return React.createElement(CoordinationRow, { coordination: c, model: m, key: c.Model.Id() });
        } });
});
var CoordinationRow = supercritical_1.default(function (_a) {
    var c = _a.coordination, m = _a.model;
    return React.createElement("li", { className: "coordinations-table-row" },
        React.createElement("span", { className: "coordinations-col col-title" }, c.Model.Title()),
        React.createElement("span", { className: "coordinations-col col-admin-notes" }, c.Model.AdminNotes()),
        React.createElement("span", { className: "coordinations-col col-description" }, c.Model.Description()),
        React.createElement("span", { className: "coordinations-col col-currency" }, CoordinationCurrency_1.CoordinationCurrencyDisplayName[c.Model.Currency()]),
        m.MilestoneTypes().map(function (t) {
            return React.createElement("span", { className: "coordinations-col milestone-col", key: t.Id() },
                React.createElement("span", { className: cx("milestone-indicator pc-breaker-light", {
                        "pc-breaker-active": c.ApplicableForMilestoneType(t)
                    }) }));
        }),
        React.createElement("span", { className: "coordinations-col col-actions" },
            React.createElement("a", { href: "", className: "fa fa-bars actions-link", onClick: eventWrappers_1.noDefault(function () { return c.ShowActionsMenu(true); }) }),
            React.createElement(CoordinationRowActionsMenu, { coordination: c })));
});
var CoordinationRowActionsMenu = supercritical_1.default(function (_a) {
    var c = _a.coordination;
    return c.ShowActionsMenu() ?
        React.createElement(view_2.PCDismissible, { className: "pc-card actions-menu", onDismiss: function () { return c.ShowActionsMenu(false); } },
            React.createElement("div", { className: "action-item" },
                React.createElement("a", { href: "#!coordinationconfigurator?id=" + c.Model.Id() }, "Configure")),
            React.createElement("div", { className: "action-item" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(c.MenuAction(c.ToggleCurrency)) }, c.Model.Currency() === CoordinationCurrency_1.CoordinationCurrency.Current ? "Deprecate" : "Restore"))) :
        null;
});
var AddCoordinationLink = supercritical_1.default(function () {
    return React.createElement("div", { className: "add-coordination-container" },
        React.createElement("a", { className: "add-coordination-link", href: "#!coordinationconfigurator" }, "+ Add Coordination"));
});


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CropImageView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(22);
__webpack_require__(1390);
// width and height of black background for image
var IMG_CONTAINER_WIDTH = 600, IMG_CONTAINER_HEIGHT = 400;
exports.CropImageView = supercritical_1.default(function (_a) {
    var _b;
    var modelContainer = _a.modelContainer;
    return React.createElement(view_1.PCModal, { className: "cropimage", shown: function () { return !!modelContainer(); }, onBackDropClick: (_b = modelContainer()) === null || _b === void 0 ? void 0 : _b.Cancel },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header pc-modal-header" },
                React.createElement("h2", { className: "modal-title pc-modal-title" }, "Edit Image")),
            modelContainer() && React.createElement(CropCanvas, { model: modelContainer() })));
});
var CropCanvas = /** @class */ (function (_super) {
    __extends(CropCanvas, _super);
    function CropCanvas(props) {
        var _this = _super.call(this, props) || this;
        _this.imageRef = supercritical_1.SuperCriticalReference(_this, InitImageCropper);
        return _this;
    }
    CropCanvas.prototype.srender = function (_a) {
        var m = _a.model;
        return (React.createElement("div", { className: "modal-body clearfix" },
            React.createElement("div", { className: "img-container" },
                React.createElement("img", { className: "raw-image", src: m.ImageUrl, ref: this.imageRef })),
            React.createElement("div", { className: "img-controls" },
                React.createElement("a", { className: "pc-cancel-link", onClick: m.Cancel }, "Cancel"),
                ' ',
                React.createElement("button", { className: "pc-button", onClick: m.SaveSelection }, "Save"))));
    };
    return CropCanvas;
}(supercritical_1.SuperCriticalComponent));
function InitImageCropper(_a, image) {
    var m = _a.model;
    var $image = $(image), $container = $image.closest('.img-container');
    // set container size
    $container.width(IMG_CONTAINER_WIDTH).height(IMG_CONTAINER_HEIGHT);
    var initializeJcrop = function () {
        $image.Jcrop({
            aspectRatio: 1,
            minSize: [m.MinSize, m.MinSize],
            boxWidth: IMG_CONTAINER_WIDTH - 2,
            boxHeight: IMG_CONTAINER_HEIGHT - 2,
            setSelect: m.InitialSelection.toArray(),
            allowSelect: false,
            keySupport: false,
            onSelect: function (c) { return m.OnJCropSelect(c); } // Use latest props in case props change
        }, onLayoutComplete);
        image.removeEventListener('load', initializeJcrop);
    };
    var onLayoutComplete = function () {
        //center jcrop in container
        var $jcrop = $container.find('.jcrop-holder'), jcropWidth = $jcrop.width(), jcropHeight = $jcrop.height();
        $jcrop.css({
            'left': '50%',
            'margin-left': (-jcropWidth / 2) + 'px',
            'margin-top': (-jcropHeight / 2) + 'px',
            'position': 'absolute',
            'top': '50%'
        });
    };
    image.addEventListener('load', initializeJcrop);
    s_js_1.default.cleanup(function () {
        image.removeEventListener('load', initializeJcrop);
        var jcrop = $image.data('Jcrop');
        if (jcrop)
            jcrop.destroy();
    });
}


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeSelector = void 0;
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var DefaultDateRanges = [
    1 /* ThisWeek */,
    2 /* LastWeek */,
    3 /* ThisMonth */,
    4 /* LastMonth */,
    5 /* ThisYear */,
    6 /* LastYear */,
    7 /* Custom */
];
function DateRangeSelector(tzutils, localization, _a) {
    var _range = _a.range, _allowedRanges = _a.allowedRanges, _from = _a.from, _to = _a.to;
    var allowedRanges = _allowedRanges || DefaultDateRanges;
    if (allowedRanges.indexOf(_range) === -1)
        throw new Error('Range ' + _range + ' not allowed for this DateRangeSelector.');
    var initialDates = getDatesFromRange(_range, tzutils), initialFrom = initialDates ? initialDates.from : _from || tzmoment_1.tzmomentMod(tzutils, _to || tzutils.now(), function (m) { return m.startOf('month'); }), initialTo = initialDates ? initialDates.to : _to || tzmoment_1.tzmomentMod(tzutils, initialFrom, function (m) { return m.add(1, 'month'); }), range = s_js_1.default.data(_range), fromDate = s_js_1.default.data(initialFrom), toDate = s_js_1.default.data(initialTo), 
    // we want the custom "To" field to list the last day *included* in range (inclusive), not the first day *past* the range (exclusive)
    // so customToDate tracks toDate but one day earlier
    customToDate = function (val) {
        return val === undefined
            ? tzmoment_1.tzmomentMod(tzutils, toDate(), function (m) { return m.subtract(1, 'day'); })
            : (toDate(tzmoment_1.tzmomentMod(tzutils, val, function (m) { return m.add(1, 'day'); })), val);
    };
    // Set dates based on range value
    s_js_1.default.on(range, function () {
        var dates = getDatesFromRange(range(), tzutils);
        if (dates) {
            fromDate(dates.from);
            toDate(dates.to);
        }
    }, null, true);
    return {
        Range: range,
        AllowedRanges: allowedRanges,
        FromDate: fromDate,
        ToDate: toDate,
        CustomToDate: customToDate,
        Localization: localization
    };
}
exports.DateRangeSelector = DateRangeSelector;
function getDatesFromRange(range, tzutils) {
    var from, to, now = tzutils.now();
    if (range === 0 /* AllDates */) {
        // TH 01/10/2017 -- Any sufficiently wide date range will do.
        from = new TZDate_1.default('1000-01-01T00:00Z');
        to = new TZDate_1.default('3000-01-01T00:00Z');
    }
    else if (range === 1 /* ThisWeek */ || range === 2 /* LastWeek */) {
        from = tzmoment_1.tzmomentMod(tzutils, now, function (m) { return m.startOf('week'); });
        if (range === 2 /* LastWeek */)
            from = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.subtract(1, 'week'); });
        to = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.add(1, 'week'); });
    }
    else if (range === 3 /* ThisMonth */ || range === 4 /* LastMonth */) {
        from = tzmoment_1.tzmomentMod(tzutils, now, function (m) { return m.startOf('month'); });
        if (range === 4 /* LastMonth */)
            from = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.subtract(1, 'month'); });
        to = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.add(1, 'month'); });
    }
    else if (range === 5 /* ThisYear */ || range === 6 /* LastYear */) {
        from = tzmoment_1.tzmomentMod(tzutils, now, function (m) { return m.startOf('year'); });
        if (range === 6 /* LastYear */)
            from = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.subtract(1, 'year'); });
        to = tzmoment_1.tzmomentMod(tzutils, from, function (m) { return m.add(1, 'year'); });
    }
    else if (range === 7 /* Custom */) {
        // Can't determine the dates when date range is custom.
        // Have to defer to user input instead.
        return null;
    }
    else {
        throw new Error('Unknown range value: ' + range);
    }
    return { from: from, to: to };
}


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgInitDateTime = void 0;
var s_js_1 = __webpack_require__(0);
var filterSignalWrites_1 = __webpack_require__(599);
var TZDate_1 = __webpack_require__(7);
var allowNonNull = function (val) { return val !== null; }, allowAny = function () { return true; };
/**
 * A datetime-valued signal whose date and time portions can be initialized separately, say via separate date
 * and time picker components. The combined signal won't be initialized until both its date and time portions
 * have been initialized. Read "ProgInit" as "progressively initialized."
 */
function ProgInitDateTime(seed, tzutils, allowClearing) {
    if (allowClearing === void 0) { allowClearing = false; }
    var DatePortion = filterSignalWrites_1.filterWrites(s_js_1.default.value(seed, TZDate_1.default.nullableEq), allowClearing ? allowAny : allowNonNull), TimePortion = filterSignalWrites_1.filterWrites(s_js_1.default.value(seed, TZDate_1.default.nullableEq), allowClearing ? allowAny : allowNonNull), merged = s_js_1.default(function () { return mergeDateAndTime(DatePortion(), TimePortion(), tzutils); }), Value = function (val) {
        return val === undefined ? merged() :
            val === null && !allowClearing ? s_js_1.default.sample(merged) :
                s_js_1.default.freeze(function () { return (DatePortion(val), TimePortion(val)); });
    };
    Value.DatePortion = DatePortion;
    Value.TimePortion = TimePortion;
    return Value;
}
exports.ProgInitDateTime = ProgInitDateTime;
function mergeDateAndTime(datePortion, timePortion, tzutils) {
    if (datePortion === null || timePortion === null)
        return null;
    var val = new TZDate_1.default(0);
    // Our usual trick for setting month and date together. See e.g. tzutils.tzify method.
    val.setDate(1);
    val.setFullYear(datePortion.getFullYear());
    val.setMonth(datePortion.getMonth());
    val.setDate(datePortion.getDate());
    val.setHours(timePortion.getHours());
    val.setMinutes(timePortion.getMinutes());
    val.setSeconds(timePortion.getSeconds());
    val.setMilliseconds(timePortion.getMilliseconds());
    // IMPORTANT: Set timezone offset when done, making sure to preserve walltime.
    tzutils.setTimezoneOffset(val, true);
    return val;
}


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMovementEndPopup = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
var debouncePromise_1 = __webpack_require__(1384);
var draftSignals_1 = __webpack_require__(37);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
function EditMovementEndPopup(Localization, domain, tzutils, _a) {
    var EndTime = _a.EndTime, StartTime = _a.StartTime, MovementType = _a.MovementType, OnClosePopup = _a.OnClosePopup, _b = _a.Validate, Validate = _b === void 0 ? function () { return Promise.resolve([]); } : _b;
    var DraftTime = draftSignals_1.DraftSignal(EndTime, TZDate_1.default.eq), draftStartTime = draftSignals_1.DraftSignal(StartTime, TZDate_1.default.eq), KeepTimesLinked = s_js_1.default.data(true), TransitDuration = transitDuration(StartTime, EndTime), NewTransitDurationIfUnlinked = transitDuration(StartTime, DraftTime), NewStartTimeIfLinked = function () {
        var newEndTime = DraftTime(), transitDur = TransitDuration();
        var newStartTime = tzutils.newDate(newEndTime.getTime() - transitDur * 60 * 1000);
        return newStartTime;
    }, newStartTime = function () { return KeepTimesLinked() ? NewStartTimeIfLinked() : StartTime(); }, validation = debouncePromise_1.debouncePromise(Validate, 300, []), Errors = s_js_1.default.data([]);
    // start validation process running, pipe output into Errors
    s_js_1.default(function () { return validation(newStartTime(), DraftTime()); });
    s_js_1.default(function () { return validation.current().then(Errors); });
    return {
        EndTime: EndTime,
        StartTime: StartTime,
        MovementType: MovementType,
        Localization: Localization,
        DraftTime: DraftTime,
        KeepTimesLinked: KeepTimesLinked,
        TransitDuration: TransitDuration,
        NewTransitDurationIfUnlinked: NewTransitDurationIfUnlinked,
        NewStartTimeIfLinked: NewStartTimeIfLinked,
        OnClosePopup: OnClosePopup,
        SaveTimes: SaveTimes,
        Errors: Errors,
        HasPilots: function () { return domain.HasActivePilots(); },
    };
    function SaveTimes() {
        // checkpoint our changes at the point user clicks save, in case they change
        // before we finish validation
        draftStartTime(s_js_1.default.sample(newStartTime));
        var draftTimeSnapshot = DraftTime.checkpoint(), draftStartTimeSnapshot = draftStartTime.checkpoint();
        validation.flush().then(function (errors) { return s_js_1.default.freeze(function () {
            if (errors.length === 0) {
                draftTimeSnapshot.commit();
                draftStartTimeSnapshot.commit();
                if (OnClosePopup)
                    OnClosePopup();
            }
        }); });
    }
    function transitDuration(startTime, endTime) {
        return function () {
            return tzmoment_1.tzmoment(endTime()).diff(tzmoment_1.tzmoment(startTime()), 'minutes');
        };
    }
}
exports.EditMovementEndPopup = EditMovementEndPopup;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMovementEndPopupView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(60);
var view_2 = __webpack_require__(22);
exports.EditMovementEndPopupView = supercritical_1.default(function (_a) {
    var _model = _a.model;
    var model = _model();
    return (React.createElement(view_2.PCModal, { shown: function () { return !!model; }, className: "editmovementendpopup", onBackDropClick: model === null || model === void 0 ? void 0 : model.OnClosePopup }, model && React.createElement("div", { className: cx("modal-content time-popup-body", {
            'time-popup-show-mvmt-in': model.MovementType === 'in',
            'time-popup-show-mvmt-out': model.MovementType === 'out',
            'time-popup-show-mvmt-shift': model.MovementType === 'shift'
        }) },
        React.createElement("div", { className: "time-popup-title" },
            React.createElement("span", { className: "time-popup-mvmt-in" }, "New First Line"),
            React.createElement("span", { className: "time-popup-mvmt-out" }, model.HasPilots() ? "New Pilot End (Disembark)" : "New Traffic End"),
            React.createElement("span", { className: "time-popup-mvmt-shift" }, "New First Line")),
        React.createElement("div", null,
            React.createElement(view_1.DateTimePicker, { value: model.DraftTime, localization: model.Localization })),
        React.createElement("div", { className: "time-popup-option-list" },
            React.createElement("div", { className: "time-popup-option", onClick: function (e) { return model.KeepTimesLinked(true); } },
                React.createElement("span", { className: cx("time-popup-option-btn", {
                        'time-popup-option-btn-selected': model.KeepTimesLinked()
                    }) }),
                React.createElement("div", { className: "time-popup-option-descr" },
                    React.createElement("div", null,
                        React.createElement("span", null, "Change "),
                        React.createElement("span", { className: "time-popup-mvmt-in" }, model.HasPilots() ? "Pilot Time" : "Traffic"),
                        React.createElement("span", { className: "time-popup-mvmt-out" }, "Departure (Last Line)"),
                        React.createElement("span", { className: "time-popup-mvmt-shift" }, "Departure (Last Line)"),
                        React.createElement("span", null, " to "),
                        React.createElement("span", null,
                            tzmoment_1.tzmoment(model.NewStartTimeIfLinked()).format('HH:mm'),
                            ".")),
                    React.createElement("div", null,
                        "Maintain planned transit duration of ",
                        model.TransitDuration(),
                        " minutes."))),
            React.createElement("div", { className: "time-popup-option", onClick: function (e) { return model.KeepTimesLinked(false); } },
                React.createElement("span", { className: cx("time-popup-option-btn", {
                        'time-popup-option-btn-selected': !model.KeepTimesLinked()
                    }) }),
                React.createElement("div", { className: "time-popup-option-descr" },
                    React.createElement("div", null,
                        React.createElement("span", null, "Keep "),
                        React.createElement("span", { className: "time-popup-mvmt-in" }, model.HasPilots() ? "Pilot Time" : "Traffic Time"),
                        React.createElement("span", { className: "time-popup-mvmt-out" }, "Departure (Last Line)"),
                        React.createElement("span", { className: "time-popup-mvmt-shift" }, "Departure (Last Line)"),
                        React.createElement("span", null, " at "),
                        React.createElement("span", null,
                            tzmoment_1.tzmoment(model.StartTime()).format('HH:mm'),
                            ".")),
                    React.createElement("div", null,
                        "Change planned transit duration to ",
                        model.NewTransitDurationIfUnlinked(),
                        " minutes.")))),
        React.createElement("div", { className: "time-popup-errors" }, model.Errors().map(function (err) { return React.createElement("div", null, err.ErrorText); })),
        React.createElement("div", { className: "time-popup-actions" },
            React.createElement("a", { href: "", className: "pc-cancel-link", onClick: eventWrappers_1.noDefault(model.OnClosePopup) }, "Cancel"),
            React.createElement("button", { className: "pc-button", onClick: model.SaveTimes }, "Change")))));
});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EditNewVesselOverrides = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var UOM_1 = __webpack_require__(25);
var Country_1 = __webpack_require__(283);
var Measurement_1 = __webpack_require__(11);
var model_1 = __webpack_require__(151);
// TH: Specifies display-time precision for toggleable PC and Vessel fields Length, Beam, Air Draft, and Deep Draft
var lengthConversions = [
    {
        uom: UOM_1.default.Foot,
        // TH: To display as feet and inches instead of as decimal feet, uncomment the feetAndInches property and comment out the decimalPlaces property.
        // That requires CSS tweaks to make room for the wider field, so in the interest of getting something in, I'm holding off for now.
        //feetAndInches: true
        decimalPlaces: 2
    },
    {
        uom: UOM_1.default.Meter,
        decimalPlaces: 1
    }
];
function EditNewVesselOverrides(data, _a) {
    var Overrides = _a.Overrides, ReadOnly = _a.ReadOnly, uom = _a.uom, onDismiss = _a.onDismiss;
    var toggleableUom = s_js_1.default.value(s_js_1.default.sample(uom)), ToggleableReadOnlyLength = s_js_1.default(function () { return ReadOnly().Length ? model_1.ToggleableMeasurement({
        backingMeasurement: new Measurement_1.NullableMeasurement(ReadOnly().Length),
        uom: toggleableUom,
        conversions: lengthConversions
    }) : null; }), ToggleableOverrideLength = model_1.ToggleableMeasurement({
        backingMeasurement: Overrides.Length,
        uom: toggleableUom,
        conversions: lengthConversions
    }), ToggleableReadOnlyBeam = s_js_1.default(function () { return ReadOnly().Beam ? model_1.ToggleableMeasurement({
        backingMeasurement: new Measurement_1.NullableMeasurement(ReadOnly().Beam),
        uom: toggleableUom,
        conversions: lengthConversions
    }) : null; }), ToggleableOverrideBeam = model_1.ToggleableMeasurement({
        backingMeasurement: Overrides.Beam,
        uom: toggleableUom,
        conversions: lengthConversions
    }), ToggleableReadOnlyMaxDraft = s_js_1.default(function () { return ReadOnly().MaxDraft ? model_1.ToggleableMeasurement({
        backingMeasurement: new Measurement_1.NullableMeasurement(ReadOnly().MaxDraft),
        uom: toggleableUom,
        conversions: lengthConversions
    }) : null; }), ToggleableOverrideMaxDraft = model_1.ToggleableMeasurement({
        backingMeasurement: Overrides.MaxDraft,
        uom: toggleableUom,
        conversions: lengthConversions
    }), UomInFeet = function (val) {
        if (val === undefined)
            return toggleableUom() === UOM_1.default.Foot;
        else {
            var uom = val ? UOM_1.default.Foot : UOM_1.default.Meter;
            toggleableUom(uom);
            return val;
        }
    }, Countries = s_array_1.lift(function () { return Array.from(data.Countries.items()); }).sort(Country_1.Country.SortOrder);
    return {
        Overrides: Overrides,
        ReadOnly: ReadOnly,
        ToggleableReadOnlyLength: ToggleableReadOnlyLength,
        ToggleableOverrideLength: ToggleableOverrideLength,
        ToggleableReadOnlyBeam: ToggleableReadOnlyBeam,
        ToggleableOverrideBeam: ToggleableOverrideBeam,
        ToggleableReadOnlyMaxDraft: ToggleableReadOnlyMaxDraft,
        ToggleableOverrideMaxDraft: ToggleableOverrideMaxDraft,
        UomInFeet: UomInFeet,
        Countries: Countries,
        Cancel: onDismiss
    };
}
exports.EditNewVesselOverrides = EditNewVesselOverrides;
;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EditNewVesselOverridesView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(152);
var view_2 = __webpack_require__(89);
exports.EditNewVesselOverridesView = supercritical_1.default(function (_a) {
    var _b = _a.model, ov = _b.Overrides, ReadOnly = _b.ReadOnly, ToggleableReadOnlyLength = _b.ToggleableReadOnlyLength, ToggleableOverrideLength = _b.ToggleableOverrideLength, ToggleableReadOnlyBeam = _b.ToggleableReadOnlyBeam, ToggleableOverrideBeam = _b.ToggleableOverrideBeam, ToggleableReadOnlyMaxDraft = _b.ToggleableReadOnlyMaxDraft, ToggleableOverrideMaxDraft = _b.ToggleableOverrideMaxDraft, UomInFeet = _b.UomInFeet, Countries = _b.Countries, Cancel = _b.Cancel;
    return React.createElement("div", { className: "vessel-info reserve-manual" },
        React.createElement("div", { className: "explanatory-text" },
            React.createElement("span", null, "Enter the vessel\u2019s particulars. You need to enter the name, gross tonnage, beam, length, and one identifier, such as IMO.")),
        React.createElement("div", { className: "manual-back" },
            React.createElement("a", { href: "#", onClick: eventWrappers_1.noDefault(Cancel) }, "Back to search")),
        React.createElement("div", { className: "identifier-left-container" },
            React.createElement("div", { className: "reserve-manual-row name" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label name-label" }, " Name "),
                ReadOnly().Name
                    ? React.createElement("input", { type: "text", value: ReadOnly().Name, disabled: true })
                    : React.createElement("input", { type: "text", value: ov.Name() || '', onChange: function (e) { return ov.Name(e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row imo" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label imo-label" }, " IMO "),
                ReadOnly().IMO
                    ? React.createElement("input", { type: "text", value: ReadOnly().IMO, disabled: true })
                    : React.createElement("input", { type: "text", value: ov.IMO() || '', onChange: function (e) { return ov.IMO(e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row mmsid" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label mmsid-label" }, " MMSID "),
                ReadOnly().MMSID
                    ? React.createElement("input", { type: "text", value: ReadOnly().MMSID, disabled: true })
                    : React.createElement("input", { type: "text", value: ov.MMSID() || '', onChange: function (e) { return ov.MMSID(e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row callsign" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label callsign-label" }, " Call Sign "),
                ReadOnly().CallSign
                    ? React.createElement("input", { type: "text", value: ReadOnly().CallSign, disabled: true })
                    : React.createElement("input", { type: "text", value: ov.CallSign() || '', onChange: function (e) { return ov.CallSign(e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row vin" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label vin-label" }, " VIN "),
                ReadOnly().VIN
                    ? React.createElement("input", { type: "text", value: ReadOnly().VIN, disabled: true })
                    : React.createElement("input", { type: "text", value: ov.VIN() || '', onChange: function (e) { return ov.VIN(e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row flag" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label flag-label" }, " Flag "),
                React.createElement("span", null,
                    ReadOnly().VesselFlagId !== undefined
                        ? React.createElement("select", { className: "pc-select country_dropdown", disabled: true, value: ReadOnly().VesselFlagId }, Countries().map(function (c) { return React.createElement("option", { key: c.Id(), value: c.Id() }, c.Name()); }))
                        : React.createElement("select", { className: "pc-select country_dropdown", value: ov.FlagId() === null ? '' : '' + ov.FlagId(), onChange: function (e) { return ov.FlagId(e.currentTarget.value === '' ? null : +e.currentTarget.value); } },
                            React.createElement("option", { value: "" }, "--"),
                            Countries().map(function (c) { return React.createElement("option", { key: c.Id(), value: c.Id() }, c.Name()); })),
                    React.createElement("span", { className: "pc-select-chevron" })))),
        React.createElement("div", { className: "identifier-right-container" },
            React.createElement("div", { className: "reserve-manual-row vessel-type" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label vessel-type-label" }, "Vessel Type"),
                React.createElement("span", null, ReadOnly().VesselType ?
                    React.createElement("input", { type: "text", value: ReadOnly().VesselType, disabled: true }) :
                    React.createElement("input", { type: "text", value: ov.VesselType() || '', onChange: function (e) { return ov.VesselType(e.currentTarget.value); } }))),
            React.createElement("div", { className: "reserve-manual-row gross-tonnage" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label gross-tonnage-label" }, "Gross Tonnage "),
                ReadOnly().GrossTonnage
                    ? React.createElement("input", { type: "text", value: ReadOnly().GrossTonnage.Num || '', disabled: true }) // TODO: real widget for entering gross tonnage
                    : React.createElement("input", { type: "text", value: ov.GrossTonnage.Num() || '', onChange: function (e) { return ov.GrossTonnage.Num(+e.currentTarget.value); }, placeholder: "Required*" })),
            React.createElement("div", { className: "reserve-manual-row length" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label length-label" }, "Length "),
                ToggleableReadOnlyLength()
                    ? React.createElement("div", { className: "length-textonly" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableReadOnlyLength(), textonly: true }))
                    : React.createElement("div", { className: "length-override" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableOverrideLength, textonly: false, placeholder: "Required*" }))),
            React.createElement("div", { className: "reserve-manual-row beam" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label beam-label" }, "Beam "),
                ToggleableReadOnlyBeam()
                    ? React.createElement("div", { className: "beam-textonly" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableReadOnlyBeam(), textonly: true }))
                    : React.createElement("div", { className: "beam-override" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableOverrideBeam, textonly: false, placeholder: "Required*" }))),
            React.createElement("div", { className: "reserve-manual-row maxdraft" },
                React.createElement("span", { className: "pc-text-smalllabel reserve-manual-label maxdraft-label" }, "Max Draft "),
                ToggleableReadOnlyMaxDraft()
                    ? React.createElement("div", { className: "maxdraft-textonly" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableReadOnlyMaxDraft(), textonly: true }))
                    : React.createElement("div", { className: "maxdraft-override" },
                        React.createElement(view_1.ToggleableMeasurementView, { model: ToggleableOverrideMaxDraft, textonly: false }))),
            React.createElement("div", { className: "uomselector uom" },
                React.createElement(view_2.ToggleButton, { onLabel: "Feet", offLabel: "Meters", checked: UomInFeet }))));
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LogUpdater = void 0;
var tzmoment_1 = __webpack_require__(9);
var pollster_1 = __webpack_require__(299);
// Utility for auto-updating the portcalllog component.
// Construct LogUpdater in your parent view and pass it into the portcalllog component.
// NOTE: Important -- please dispose the LogUpdater from your parent view. The portcalllog component does NOT dispose the LogUpdater automatically.
// Rule of thumb - whichever component constructs the LogUpdater should also dispose it.
function LogUpdater(ajax, tzutils, _a) {
    var collection = _a.collection, _url = _a.url, refreshSeconds = _a.refreshSeconds, refreshBackwardsMins = _a.refreshBackwardsMins;
    var lastUpdated = null;
    return new pollster_1.Pollster(updateLog, refreshSeconds * 1000);
    function updateLog() {
        // TH: We introduced async change detection to support generating change events from auto-saving text fields.
        // I.e. after a user edits a text field, it might take a few mins (depending on configuration) for that edit to be matierialized into a change Event.
        // But that Event will still have the timestamp of the last edit as its Date field.
        // (Since it seemed more accurate to set the Date to the last edit date rather than the detection date).
        // So we need to reach back several mins when we update the log, otherwise we'll miss those updates.
        var needSince = lastUpdated && tzmoment_1.tzmomentMod(tzutils, lastUpdated, function (m) { return m.subtract(refreshBackwardsMins || 0, 'minutes'); }), url = _url({ NeedSince: needSince && needSince.toJSON() }), 
        // TH 02/23/2017 -- Convention. We assume our Log endpoints return an array of Relevances.
        req = ajax.Url(url).Get();
        return req.then(function (json) {
            var ts = req.Date;
            lastUpdated = tzutils.newDate(+ts);
            collection.update(ts, json, []);
        });
    }
}
exports.LogUpdater = LogUpdater;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLog = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
function EventLog(tzutils, cache, personProfilePopupModel, newCommentModel, _a) {
    var log = _a.log, canComment = _a.canComment;
    // Mini DI kernel...
    var recipientModel = function (taggedUser) { return CommentRecipient(taggedUser, cache, personProfilePopupModel); }, commentModel = function (comment) { return LogEntryComment(comment, recipientModel); }, logEntryModel = function (entry) { return LogEntry(entry, function () { return canComment(entry); }, newCommentModel, commentModel); };
    var LogEntries = log
        .orderBy(function (entry) { var _a, _b; return (_b = (_a = entry.Event()) === null || _a === void 0 ? void 0 : _a.Date()) !== null && _b !== void 0 ? _b : null; })
        .reverse()
        .map(logEntryModel), clock = tzutils.clock(1000), Now = function () { return clock.now(); };
    return { LogEntries: LogEntries, Now: Now };
}
exports.EventLog = EventLog;
function LogEntry(Entry, CanComment, newCommentModel, commentModel) {
    var Comment = s_js_1.default(function () { var _a; return ((_a = Entry.Event()) === null || _a === void 0 ? void 0 : _a.Comment()) ? commentModel(Entry.Event().Comment()) : null; }), Comments = s_array_1.lift(function () { var _a, _b; return (_b = (_a = Entry.Event()) === null || _a === void 0 ? void 0 : _a.Comments()) !== null && _b !== void 0 ? _b : []; })
        .orderBy(function (c) { var _a, _b; return (_b = (_a = c.Event()) === null || _a === void 0 ? void 0 : _a.Date()) !== null && _b !== void 0 ? _b : null; })
        .reverse()
        .map(commentModel), showNewComment = s_js_1.default.value(false), NewComment = s_js_1.default(function () {
        if (showNewComment()) {
            var newComment = newCommentModel({
                url: function () { var _a, _b; return (_b = (_a = Entry.Event()) === null || _a === void 0 ? void 0 : _a.CommentsUrl()) !== null && _b !== void 0 ? _b : ''; }
            });
            // Hide the new comment view after posting a comment, which we detect by
            // listening for the newComment model resetting to a fresh comment draft.
            s_js_1.default.on(newComment.NewComment, function () { return showNewComment(false); }, undefined, true);
            return newComment;
        }
        else {
            return null;
        }
    });
    return {
        Entry: Entry,
        Comment: Comment,
        Comments: Comments,
        CanComment: CanComment,
        ToggleNewComment: function () { return showNewComment(!showNewComment()); },
        NewComment: NewComment
    };
}
function LogEntryComment(Comment, recipientModel) {
    var Recipients = Comment.TaggedUsers.map(recipientModel);
    return { Comment: Comment, Recipients: Recipients };
}
function CommentRecipient(taggedUser, cache, personProfilePopupModel) {
    var User = cache.PCUsers.update1(null, { Id: taggedUser.UserId() }), showProfile = s_js_1.default.value(false), ProfilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({
        id: taggedUser.UserId(),
        onHidePopup: function () { return showProfile(false); }
    }) : null; });
    return {
        User: User,
        ToggleProfile: function () { return showProfile(!showProfile()); },
        ProfilePopup: ProfilePopup
    };
}


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NewComment = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var uniqueIndex_1 = __webpack_require__(70);
var Comment_1 = __webpack_require__(282);
var TaggedCommentUser_1 = __webpack_require__(588);
var model_1 = __webpack_require__(153);
function NewComment(ajax, cache, personProfilePopupModel, uploadFileModel, _a) {
    var url = _a.url;
    var client = ajax.Url(url, { useCache: true, include: [function (c) { return c.TaggedUsers; }] }), NewComment = s_js_1.default.value(new Comment_1.Comment()), 
    // S.data not S.value so we can keep re-triggering focus as needed.
    MessageFocusTriggered = s_js_1.default.data(false), RecipientSelector = s_js_1.default(function () { return NewRecipientSelector(NewComment(), cache); }), Recipients = s_array_1.lift(function () { return NewComment().TaggedUsers(); })
        .map(function (t) { return CommentRecipient(NewComment, t, cache, personProfilePopupModel); }), FileUploader = uploadFileModel({
        onComplete: function (json) { return s_js_1.default.freeze(function () {
            NewComment().AttachmentUrl(json.Url);
            MessageFocusTriggered(true);
        }); }
    });
    return {
        NewComment: NewComment,
        MessageFocusTriggered: MessageFocusTriggered,
        RecipientSelector: RecipientSelector,
        Recipients: Recipients,
        FileUploader: FileUploader,
        CanSubmit: CanSubmit,
        Submit: Submit
    };
    function CanSubmit() {
        var _a;
        // Gotta have a URL to Post to and have to have specified some content.
        return !!url() && !!(((_a = NewComment().Message()) === null || _a === void 0 ? void 0 : _a.trim()) || NewComment().AttachmentUrl());
    }
    function Submit() {
        if (CanSubmit())
            client.Post(NewComment()).then(function () { return NewComment(new Comment_1.Comment()); });
    }
}
exports.NewComment = NewComment;
function NewRecipientSelector(comment, cache) {
    var _a;
    var selectedUserId = s_js_1.default.value(0), taggedUsersIdx = uniqueIndex_1.default(comment.TaggedUsers, function (t) { return t.UserId(); }), taggableUsers = (_a = s_array_1.lift(function () { return Array.from(cache.PCUsers.items()); })
        .filter(function (u) { return !taggedUsersIdx(u.Id())(); })
        .filter(function (u) { return u.Active(); })) !== null && _a !== void 0 ? _a : [], Selector = model_1.UserSelector({
        Users: taggableUsers,
        UserId: selectedUserId
    }), IsVisible = s_js_1.default.value(false), 
    // S.data not S.value so we can keep re-triggering focus as needed.
    SelectorFocusTriggered = s_js_1.default.data(false);
    s_js_1.default.on(selectedUserId, function () {
        if (selectedUserId()) {
            s_js_1.default.freeze(function () {
                comment.TaggedUsers.push(new TaggedCommentUser_1.TaggedCommentUser({ CommentId: 0, UserId: selectedUserId() }));
                Selector.data("");
            });
        }
    });
    return {
        Selector: Selector,
        IsVisible: IsVisible,
        Focus: Focus,
        SelectorFocusTriggered: SelectorFocusTriggered
    };
    function Focus() {
        s_js_1.default.freeze(function () {
            IsVisible(true);
            SelectorFocusTriggered(true);
        });
    }
}
function CommentRecipient(comment, taggedUser, cache, personProfilePopupModel) {
    var User = cache.PCUsers.update1(null, { Id: taggedUser.UserId() }), showProfile = s_js_1.default.value(false), ProfilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({
        id: taggedUser.UserId(),
        onHidePopup: function () { return showProfile(false); }
    }) : null; });
    return {
        User: User,
        ToggleProfile: function () { return showProfile(!showProfile()); },
        ProfilePopup: ProfilePopup,
        Delete: Delete
    };
    function Delete() {
        comment().TaggedUsers.remove(taggedUser);
    }
}


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalVesselSearch = void 0;
var s_js_1 = __webpack_require__(0);
var VesselServiceActive_1 = __webpack_require__(611);
var ExternalVesselSearchType_1 = __webpack_require__(608);
function ExternalVesselSearch(settings, ajax, entrypoints, _a) {
    var onSelect = _a.onSelect, onManualEntry = _a.onManualEntry, onDismiss = _a.onDismiss;
    var SearchResults = s_js_1.default.data(null), Searching = s_js_1.default.value(false), CanSearchCallSign = function () { return settings.LloydServiceActive() === VesselServiceActive_1.VesselServiceActive.Active || settings.PSixServiceActive() === VesselServiceActive_1.VesselServiceActive.Active; }, CanSearchImo = function () { return settings.LloydServiceActive() === VesselServiceActive_1.VesselServiceActive.Active || settings.MarineTrafficServiceActive() === VesselServiceActive_1.VesselServiceActive.Active; }, CanSearchMmsi = function () { return settings.LloydServiceActive() === VesselServiceActive_1.VesselServiceActive.Active || settings.MarineTrafficServiceActive() === VesselServiceActive_1.VesselServiceActive.Active; }, CanSearch = function () { return (CanSearchImo() || CanSearchMmsi() || CanSearchCallSign()); }, SearchType = s_js_1.default.data(s_js_1.default.sample(function () {
        return CanSearchImo() ? ExternalVesselSearchType_1.ExternalVesselSearchType.IMO :
            CanSearchMmsi() ? ExternalVesselSearchType_1.ExternalVesselSearchType.MMSI :
                CanSearchCallSign() ? ExternalVesselSearchType_1.ExternalVesselSearchType.CallSign :
                    ExternalVesselSearchType_1.ExternalVesselSearchType.IMO;
    })), Query = s_js_1.default.data(""), Placeholder = function () {
        var fields = [];
        if (CanSearchImo())
            fields.push("IMO");
        if (CanSearchCallSign())
            fields.push("Call Sign");
        if (CanSearchMmsi())
            fields.push("MMSID");
        return "Select " + fields.join(" or ") + " and enter the value";
    };
    return {
        Query: Query,
        Placeholder: Placeholder,
        CanSearchImo: CanSearchImo,
        CanSearchMmsi: CanSearchMmsi,
        CanSearchCallSign: CanSearchCallSign,
        CanSearch: CanSearch,
        SearchType: SearchType,
        Search: Search,
        SearchResults: SearchResults,
        Select: onSelect,
        ManualEnter: onManualEntry,
        Cancel: onDismiss,
        Searching: Searching
    };
    function Search() {
        SearchResults(null);
        Searching(true);
        var url = entrypoints.PortCallVesselServiceSearch({ Type: SearchType(), Query: Query() });
        ajax.Url(url).Get()
            .then(SearchResults)
            .finally(function () {
            return Searching(false);
        });
    }
}
exports.ExternalVesselSearch = ExternalVesselSearch;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalVesselSearchView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var Measurement_1 = __webpack_require__(11);
var ExternalVesselSearchType_1 = __webpack_require__(608);
exports.ExternalVesselSearchView = supercritical_1.default(function (_a) {
    var model = _a.model;
    var results = model.SearchResults();
    return (React.createElement("div", { className: "search-service-vessel" },
        React.createElement("div", { className: "service-search-vessel-filter" },
            React.createElement("div", { className: "search-service-vessel-criteria" },
                React.createElement("div", { className: "service-vessel-search" },
                    React.createElement("input", { className: "search-filter tt-input", type: "text", value: model.Query(), onChange: function (e) { return model.Query(e.currentTarget.value); }, placeholder: "Select IMO or MMSI or Call Sign and enter the identifier" })),
                React.createElement("div", { className: "search-id-type" },
                    React.createElement("div", { hidden: !model.CanSearchImo() },
                        React.createElement("input", { name: "searchTypeGroup", type: "radio", checked: model.SearchType() === ExternalVesselSearchType_1.ExternalVesselSearchType.IMO, onChange: function (e) { return e.currentTarget.checked && model.SearchType(ExternalVesselSearchType_1.ExternalVesselSearchType.IMO); } }),
                        "IMO"),
                    React.createElement("div", { hidden: !model.CanSearchMmsi() },
                        React.createElement("input", { name: "searchTypeGroup", type: "radio", checked: model.SearchType() === ExternalVesselSearchType_1.ExternalVesselSearchType.MMSI, onChange: function (e) { return e.currentTarget.checked && model.SearchType(ExternalVesselSearchType_1.ExternalVesselSearchType.MMSI); } }),
                        "MMSI"),
                    React.createElement("div", { hidden: !model.CanSearchCallSign() },
                        React.createElement("input", { name: "searchTypeGroup", type: "radio", checked: model.SearchType() === ExternalVesselSearchType_1.ExternalVesselSearchType.CallSign, onChange: function (e) { return e.currentTarget.checked && model.SearchType(ExternalVesselSearchType_1.ExternalVesselSearchType.CallSign); } }),
                        "Call Sign")),
                React.createElement("div", { className: "search-button" },
                    React.createElement("button", { type: "button", className: "pc-button", onClick: model.Search, disabled: !model.CanSearch() || model.Searching() }, "Search"))),
            React.createElement("div", { className: "import-menu" },
                React.createElement("div", { className: "manual-add-vessel" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(model.ManualEnter) }, "Manually enter a New Vessel")),
                React.createElement("br", null),
                React.createElement("div", { className: "back-to-existing" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(model.Cancel) }, "Back to search")))),
        React.createElement("div", { className: "search-service-vessel-result" }, results === null ? null :
            results.length === 0 ?
                React.createElement("div", { className: "no-results-found" },
                    React.createElement("span", null, "No Results Found")) :
                React.createElement("div", { className: "search-results" },
                    React.createElement("table", { className: "table" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null),
                                React.createElement("th", null, "Service"),
                                React.createElement("th", null, "Vessel Name"),
                                React.createElement("th", null, "IMO"),
                                React.createElement("th", null, "MMSI"),
                                React.createElement("th", null, "VIN"),
                                React.createElement("th", null, "Call Sign"),
                                React.createElement("th", null, "Vessel Type"),
                                React.createElement("th", null, "Draft"),
                                React.createElement("th", null, "Length"))),
                        React.createElement("tbody", null, results.map(function (v) {
                            return React.createElement("tr", { key: v.PSixServiceVesselId !== null ? 'psix-' + v.PSixServiceVesselId
                                    : v.LloydServiceVesselId !== null ? 'lloyds-' + v.LloydServiceVesselId
                                        : v.MarineTrafficServiceVesselId !== null ? 'marinetraffic-' + v.MarineTrafficServiceVesselId
                                            : '' },
                                React.createElement("td", null,
                                    React.createElement("button", { type: "button", className: "pc-button", onClick: function (e) { return model.Select(v); } }, "Select")),
                                React.createElement("td", null, vesselServiceType(v)),
                                React.createElement("td", null, v.Name),
                                React.createElement("td", null, v.IMO),
                                React.createElement("td", null, v.MMSID),
                                React.createElement("td", null, v.VIN),
                                React.createElement("td", null, v.CallSign),
                                React.createElement("td", null, v.PSixServiceVesselId ? '' : v.VesselType),
                                React.createElement("td", null, new Measurement_1.NullableMeasurement(v.MaxDraft).toString()),
                                React.createElement("td", null, new Measurement_1.NullableMeasurement(v.Length).toString()));
                        })))))));
});
function vesselServiceType(data) {
    return data.VesselId ? "Local Vessel" :
        data.MarineTrafficServiceVesselId ? "Marine Traffic" :
            data.PSixServiceVesselId ? "PSix Vessel" :
                data.LloydServiceVesselId ? "LLoyds" :
                    "";
}


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPassword = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var Accounts_1 = __webpack_require__(199);
function ForgotPassword(ajax, entrypoints) {
    var client = ajax.Url(entrypoints.ForgotPassword), validation = validationWatcher_1.ValidationWatcher(client), forgotPassword = new Accounts_1.ForgotPasswordRequest(), forgotPasswordRequest = s_js_1.default.data(null);
    return {
        ForgotPassword: forgotPassword,
        Validation: validation,
        ForgotPasswordRequest: forgotPasswordRequest,
        Submit: Submit
    };
    function Submit() {
        forgotPasswordRequest(client.Post(forgotPassword));
    }
}
exports.ForgotPassword = ForgotPassword;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1090);
var view_2 = __webpack_require__(12);
function ForgotPasswordRoute(model, appWrapper) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ForgotPasswordView, { model: model }))
    };
}
exports.ForgotPasswordRoute = ForgotPasswordRoute;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(29);
exports.ForgotPasswordView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "forgotpassword pc-page-fixedwidth" },
        React.createElement("div", { className: "forgotpassword-container pc-card" },
            React.createElement("h2", { className: "pc-card-header pc-card-title" }, "Forgot password"),
            m.ForgotPasswordRequest()
                && m.ForgotPasswordRequest().Response()
                && m.ForgotPasswordRequest().Response().Success ?
                React.createElement(ForgotPasswordSuccess, { model: m }) :
                React.createElement(ForgotPasswordForm, { model: m })));
});
var ForgotPasswordForm = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("form", null,
        React.createElement(view_1.ActionLoadingIndicator, { loading: function () { return !!m.ForgotPasswordRequest() && !m.ForgotPasswordRequest().Response(); } }),
        React.createElement("div", null, "Please enter your email. A password reset link will be emailed to you."),
        React.createElement("div", { className: "email form-group" },
            React.createElement("input", { className: "form-control pc-input-box", placeholder: "Email", autoFocus: true, value: m.ForgotPassword.Email(), onChange: function (e) { return m.ForgotPassword.Email(e.currentTarget.value); } }),
            React.createElement(view_2.ValidationErrorView, { error: function () { return m.Validation()['Email']; } })),
        React.createElement("div", { className: "control-btns form-group" },
            React.createElement("a", { href: "#", className: "pc-cancel-link" }, "Cancel"),
            React.createElement("button", { className: "pc-button", onClick: eventWrappers_1.noDefault(m.Submit) }, "Request Reset")));
});
var ForgotPasswordSuccess = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null,
            "A password reset link has been sent to",
            ' ',
            m.ForgotPassword.Email(),
            ".",
            ' ',
            "Check your email and follow the instructions there."),
        React.createElement("div", { className: "homepage-link" },
            React.createElement("a", { href: "#" }, "Back to homepage")));
});


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var HomePage_1 = __webpack_require__(1268);
var HomePageCache = /** @class */ (function (_super) {
    __extends(HomePageCache, _super);
    function HomePageCache(data) {
        var _this = _super.call(this) || this;
        _this.HomePageDateMovements = PCCache_1.PCCollection(HomePage_1.HomePageDateMovements);
        _this.HomePagePortMovements = PCCache_1.PCCollection(HomePage_1.HomePagePortMovements);
        _this.HomePageMovements = PCCache_1.PCCollection(HomePage_1.HomePageMovement);
        new DataCache_1.QueryResultsRelationship(_this.HomePageDateMovements, _this.HomePagePortMovements, function (d) { return d.Ports; });
        new DataCache_1.QueryResultsRelationship(_this.HomePagePortMovements, _this.HomePageMovements, function (p) { return p.Movements; });
        new DataCache_1.ForeignKeyRelationship(data.ItineraryPoints, _this.HomePageMovements, null, function (m) { return m.FromPoint; }, function (m) { return m.FromPointId(); });
        new DataCache_1.ForeignKeyRelationship(data.ItineraryPoints, _this.HomePageMovements, null, function (m) { return m.ToPoint; }, function (m) { return m.ToPointId(); });
        new DataCache_1.QueryResultsRelationship(_this.HomePageMovements, data.CoordinationCards, function (m) { return m.TrafficCoordinationCards; });
        return _this;
    }
    return HomePageCache;
}(DataCache_1.DataCache));
exports.HomePageCache = HomePageCache;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CruiseSchedule = void 0;
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var maybeLoader_1 = __webpack_require__(601);
var Measurement_1 = __webpack_require__(11);
var CruiseSchedule = function (ajax, portFilterer, entrypoints, shown) {
    var cruises = s_array_1.default([]), displayedCruises = portFilterer(cruises, function (c) { return c.Data.PortName || ''; }), loader = maybeLoader_1.maybeLoader(ajax, entrypoints.HomeCruise, function (ds) { return cruises(ds.map(function (d) { return new HomepageCruiseScheduleViewModel(d); })); }, shown);
    return {
        Loading: loader.Loading,
        PortCruiseSchedules: displayedCruises
    };
};
exports.CruiseSchedule = CruiseSchedule;
var HomepageCruiseScheduleViewModel = /** @class */ (function () {
    function HomepageCruiseScheduleViewModel(Data) {
        var _a;
        this.Data = Data;
        var cruiseVisits = (Data.CruiseVisits || []).map(function (v) { return new CruiseVisitViewModel(v); }), 
        // Use a Map to group cruise visits by year b/c...
        //  1) A Map is guaranteed to iterate entries in insertion order. The server gives
        //     us cruise visits in order by arrival date and then departure date, so we
        //     just wanna make sure to preserve that same order when grouping into years.
        //  2) A Map lets us use the numeric years as keys without being forced to stringify
        //     the years. That's nice, b/c it lets us treat stringifying the years (and
        //     choosing the format etc) as a view-layer concern.
        // In contrast, if we used a plain JS object to group cruise visits by year (or
        // used a utility like _.groupBy that's built on a plain JS object), then
        // iteration order would be more unpredictable (see https://stackoverflow.com/a/38218582)
        // and we'd be forced to stringify the years here instead of in our view layer.
        byYear = new Map();
        for (var _i = 0, cruiseVisits_1 = cruiseVisits; _i < cruiseVisits_1.length; _i++) {
            var visit = cruiseVisits_1[_i];
            var year = visit.Arrival.getFullYear();
            ((_a = byYear.get(year)) !== null && _a !== void 0 ? _a : setValue(byYear, year, [])).push(visit);
        }
        this.CruiseVisitYears = Array.from(byYear);
    }
    return HomepageCruiseScheduleViewModel;
}());
// Map<K, V>.set returns the map (for method chaining). This function just returns the new
// value instead.
function setValue(map, key, value) {
    map.set(key, value);
    return value;
}
var CruiseVisitViewModel = /** @class */ (function () {
    function CruiseVisitViewModel(Data) {
        this.Data = Data;
        this.Arrival = new TZDate_1.default(Data.Arrival);
        this.Departure = new TZDate_1.default(Data.Deparature);
        this.Length = new Measurement_1.Measurement(Data.Length);
    }
    CruiseVisitViewModel.prototype.DepartsOnSameDayAsArrival = function () {
        return this.Departure.getFullYear() === this.Arrival.getFullYear() &&
            this.Departure.getMonth() === this.Arrival.getMonth() &&
            this.Departure.getDate() === this.Arrival.getDate();
    };
    return CruiseVisitViewModel;
}());


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CruiseScheduleView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var loadingicon_1 = __webpack_require__(269);
var view_1 = __webpack_require__(52);
exports.CruiseScheduleView = supercritical_1.default(function (_a) {
    var model = _a.model, goToPortCall = _a.goToPortCall, domainUOM = _a.domainUOM;
    return React.createElement("div", { className: "homepage-cruiseschedule" },
        React.createElement(loadingicon_1.LoadingIcon, { loading: model.Loading }),
        React.createElement("ul", null, model.PortCruiseSchedules().map(function (c) {
            return React.createElement("li", { className: "port-group", key: c.Data.PortId },
                React.createElement("div", { className: "port-name" }, c.Data.PortName),
                React.createElement("ul", { className: "cruise-list" }, c.CruiseVisitYears.map(function (_a) {
                    var year = _a[0], visits = _a[1];
                    return React.createElement("li", { key: year },
                        React.createElement("div", { className: "year" }, year),
                        visits.map(function (v) {
                            return React.createElement("div", { className: "cruise", onClick: function (e) { return goToPortCall(v.Data); }, key: v.Data.ReservationId },
                                React.createElement("div", { className: "cruise-subsection" },
                                    React.createElement("div", { className: "cruise-col-dates" },
                                        React.createElement("div", { className: "arrival" }, tzmoment_1.tzmoment(v.Arrival).format('DD MMM - HH:mm')),
                                        React.createElement("div", { className: "departure" },
                                            "dep ",
                                            tzmoment_1.tzmoment(v.Departure).format(v.DepartsOnSameDayAsArrival() ? 'HH:mm' : 'DD MMM HH:mm'))),
                                    React.createElement("div", { className: "cruise-col-vessel-details" },
                                        React.createElement(view_1.PCTooltip, { title: function () { return v.Data.VesselName || ''; }, className: "cruise-col-tooltip" },
                                            React.createElement("div", { className: "vessel" }, v.Data.VesselName)),
                                        React.createElement("div", { className: "particulars" },
                                            React.createElement("span", { className: "length secondary-text" }, v.Length.convert(domainUOM).toString()),
                                            React.createElement("span", { className: "pipe light-text secondary-text" }, " | "),
                                            React.createElement("span", { className: "guests secondary-text" }, v.Data.ExpectedPassengerCount === null ? '' : v.Data.ExpectedPassengerCount + ' guests')))),
                                React.createElement("div", { className: "cruise-subsection reservation-details" },
                                    React.createElement("div", { className: "cruise-col-reservation-details" },
                                        React.createElement(view_1.PCTooltip, { title: function () { return v.Data.BerthName || ''; }, className: "cruise-col-tooltip" },
                                            React.createElement("div", { className: "berth" }, v.Data.BerthName)),
                                        React.createElement("div", { className: "last-port" },
                                            React.createElement("span", { className: "light-text secondary-text" }, "last port"),
                                            React.createElement("span", { className: "pipe light-text secondary-text" }, " | "),
                                            React.createElement("div", { className: "last-location secondary-text" }, v.Data.LastPortOfCall || '\u2014' /* em-dash */)))));
                        }));
                })));
        })));
});


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InPortVessels = void 0;
var s_array_1 = __webpack_require__(3);
var maybeLoader_1 = __webpack_require__(601);
var InPortVessels = function (ajax, date, portFilterer, entrypoints, shown) {
    var inPortVessels = s_array_1.default([]), displayedInPortVessels = portFilterer(inPortVessels, function (i) { return i.PortName || ''; }), loader = maybeLoader_1.maybeLoader(ajax, entrypoints.HomeInPort, inPortVessels, shown);
    return {
        Loading: loader.Loading,
        InPortVessels: displayedInPortVessels,
        Date: date
    };
};
exports.InPortVessels = InPortVessels;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InPortView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var TZDate_1 = __webpack_require__(7);
var loadingicon_1 = __webpack_require__(269);
exports.InPortView = supercritical_1.default(function (_a) {
    var model = _a.model, goToPortCall = _a.goToPortCall;
    return React.createElement("div", { className: "homepage-inport" },
        React.createElement(loadingicon_1.LoadingIcon, { loading: model.Loading }),
        React.createElement("ul", null, model.InPortVessels().map(function (p) {
            return React.createElement("li", null,
                React.createElement("label", { className: "port-name" }, p.PortName),
                React.createElement("ul", null,
                    p.InPortVessels.map(function (v) {
                        return React.createElement("li", { className: "vessel", onClick: function (e) { return goToPortCall(v); } },
                            React.createElement("label", { className: "berth" }, v.BerthName),
                            React.createElement("label", { className: "vessel" }, v.VesselName),
                            React.createElement("label", { className: "description" },
                                "departs ",
                                tzmoment_1.tzmoment(new TZDate_1.default(v.DepartureDate)).calendar(tzmoment_1.tzmoment(model.Date))));
                    }),
                    p.InPortVessels.length === 0
                        ? React.createElement("li", null,
                            React.createElement("label", { className: "no-inport-message" }, "No vessels at this port."))
                        : null));
        })));
});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
function Map(shown, locations, settings) {
    return {
        Shown: shown,
        Locations: locations,
        Settings: settings
    };
}
exports.Map = Map;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var L = __webpack_require__(142);
var supercritical_1 = __webpack_require__(4);
var escapeHtml_1 = __webpack_require__(293);
var ZoneCoordinates_1 = __webpack_require__(115);
var maptools_1 = __webpack_require__(529);
__webpack_require__(242);
var MapView = /** @class */ (function (_super) {
    __extends(MapView, _super);
    function MapView(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, loadMap);
        return _this;
    }
    MapView.prototype.srender = function (_a) {
        var model = _a.model;
        return (React.createElement("div", { className: "homepage-map" },
            React.createElement("div", { className: "map", ref: this.ref })));
    };
    return MapView;
}(supercritical_1.SuperCriticalComponent));
exports.MapView = MapView;
function loadMap(_a, el) {
    var m = _a.model;
    var map = L.map(el, { attributionControl: true });
    s_js_1.default.cleanup(function () { return map.remove(); });
    L.tileLayer(L.TileLayer.Provider.providers.Esri.url, L.TileLayer.Provider.providers.Esri.variants.WorldImagery.options).addTo(map);
    s_js_1.default(function () { return m.Locations().forEach(function (loc) {
        var coords = ZoneCoordinates_1.parseZoneCoordinates(loc.ZoneCoordinates(), loc.ZoneType()), center = maptools_1.drawLocation(map, coords);
        if (center) {
            var label_1 = drawLocationLabel(loc, center);
            map.addLayer(label_1);
            s_js_1.default.cleanup(function () { return map.removeLayer(label_1); });
        }
    }); });
    s_js_1.default(function () {
        // TH 12/19/2016 -- To avoid some UX jumpiness, don't call setView until we think we have map coords populated.
        if (m.Settings.Latitude() || m.Settings.Longitude() || m.Settings.Zoom()) {
            map.setView([m.Settings.Latitude(), m.Settings.Longitude()], m.Settings.Zoom());
        }
    });
    // b/c the map is not displayed when initially draw, Leaflet draws it with an incorrect size
    // so we tell it to redraw it once it appears
    s_js_1.default(function () {
        if (m.Shown())
            window.requestAnimationFrame(function () { return map.invalidateSize(false); });
    });
}
function drawLocationLabel(loc, pt) {
    var icon = L.divIcon({
        className: 'zone-label',
        iconSize: L.point(40, 20),
        iconAnchor: L.point(20, 20),
        popupAnchor: L.point(0, -20),
        html: '<div class="content-label">' + escapeHtml_1.default(loc.Name()) + '</div>'
    });
    return L.marker(pt, { icon: icon });
}


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Movements = void 0;
var s_js_1 = __webpack_require__(0);
var CoordinationCard_1 = __webpack_require__(109);
var Movements = function (loader, data, date, user, portFilterer, shown, tzutils, portcallScheduleModel) {
    var dateData = s_js_1.default(function () { return shown() ? loader({ Date: date().toJSON() }) : null; }), Loading = function () { return dateData() !== null && dateData().loading(); }, Ports = function () { return dateData() && dateData().model.Ports().map(PortMovementsModel) || []; }, DisplayedPorts = portFilterer(Ports, function (m) { return m.PortName(); }), SelectedMovement = s_js_1.default.value(null), MovementDetails = s_js_1.default(function () { return SelectedMovement() && MovementDetailsModel(SelectedMovement()); });
    return { Date: date, TZUtils: tzutils, Loading: Loading, DisplayedPorts: DisplayedPorts, MovementDetails: MovementDetails };
    function PortMovementsModel(port) {
        return {
            PortId: port.PortId,
            PortName: port.PortName,
            Movements: port.Movements.map(PortMovementModel).orderBy(function (m) { return +(m.MovementStartTime() || 0); })
        };
    }
    function PortMovementModel(m) {
        var 
        // movement has occured if it has either departure or arrival actual time  
        HasBegun = function () { return m.FromPoint() && m.FromPoint().Departure.Actual() !== null
            || m.ToPoint() && m.ToPoint().Arrival.Actual() !== null
            || false; }, MovementStartTime = function () {
            return m.FromPoint() === null ? null :
                m.FromPoint().Departure.Effective();
        }, MovementCompleteTime = function () {
            return m.ToPoint() === null ? null :
                m.ToPoint().Arrival.Actual();
        }, TrafficCoordinationCards = m.TrafficCoordinationCards
            .map(function (ccard) { return TrafficCoordinationCardModel(ccard); })
            .sort(function (ccard1, ccard2) {
            var _a;
            // C-Cards for arrival point first, then departure point, in usual C-Card display order
            // within each of those groups.
            return ccard1.Model.ScheduleDateId() === ccard2.Model.ScheduleDateId() ?
                // Both C-Cards are for the same milestone date. Sort in the usual C-Card order.
                CoordinationCard_1.CoordinationCard.DisplayOrder(ccard1.Model, ccard2.Model) :
                ((_a = ccard1.Model.ScheduleDate()) === null || _a === void 0 ? void 0 : _a.ItineraryPointId()) === m.FromPointId() ?
                    // ccard1 is for the from point. Assume that means ccard2 is for the to point
                    // (the server should only be sending us C-Cards for at most one milestone date
                    // per itinerary point per movement) and sort ccard1 before ccard2.
                    -1 :
                    // Otherwise, assume ccard1 is for the to point and ccard2 is for the from point.
                    1;
        });
        return {
            Model: m,
            HasBegun: HasBegun,
            MovementStartTime: MovementStartTime,
            MovementCompleteTime: MovementCompleteTime,
            TrafficCoordinationCards: TrafficCoordinationCards,
            ShowDetails: ShowDetails,
        };
        function ShowDetails() {
            if (s_js_1.default.sample(user))
                SelectedMovement(m);
        }
    }
    function TrafficCoordinationCardModel(ccard) {
        // Nothing for now (just future-proofing in case we find a reason to add extra properties/state later).
        return { Model: ccard };
    }
    function MovementDetailsModel(m) {
        var 
        // The server doesn't actually include the PortCall entity w/ its Movement object graph. So
        // upsert an empty PortCall object ourselves, to be filled in more by the PortCallSchedule
        // component when it loads its data.
        PortCall = data.PortCalls.update1(null, { Id: m.PortCallId() }), Schedule = portcallScheduleModel({ PortCall: PortCall }), ShowActionsMenu = s_js_1.default.value(false);
        return {
            Movement: m,
            Schedule: Schedule,
            ShowActionsMenu: ShowActionsMenu,
            ToggleActionsMenu: ToggleActionsMenu,
            Close: Close,
        };
        function ToggleActionsMenu() {
            ShowActionsMenu(!s_js_1.default.sample(ShowActionsMenu));
        }
        function Close() {
            if (s_js_1.default.sample(SelectedMovement) === m)
                SelectedMovement(null);
        }
    }
};
exports.Movements = Movements;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MovementsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var tzmoment_1 = __webpack_require__(9);
var TZDate_1 = __webpack_require__(7);
var view_1 = __webpack_require__(150);
var view_2 = __webpack_require__(22);
var view_3 = __webpack_require__(88);
var loadingicon_1 = __webpack_require__(269);
var view_4 = __webpack_require__(35);
exports.MovementsView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "homepage-movements" },
        React.createElement(loadingicon_1.LoadingIcon, { loading: model.Loading }),
        React.createElement(MovementDetailsPopup, { model: model }),
        React.createElement("ul", null, model.DisplayedPorts().map(function (p) {
            return React.createElement("li", { key: p.PortId() },
                React.createElement("label", { className: "port-name" }, p.PortName()),
                React.createElement("ul", null, p.Movements().map(function (m) {
                    var _a, _b, _c, _d;
                    return React.createElement("li", { key: m.Model.FromPointId(), className: "movement" + (m.HasBegun() ? " has-begun" : ""), onClick: m.ShowDetails },
                        React.createElement("div", { className: "movement-row" },
                            React.createElement("label", { className: "time" }, m.MovementStartTime() && tzmoment_1.tzmoment(m.MovementStartTime()).format('HH:mm')),
                            React.createElement("label", { className: "movement" }, m.Model.Type()),
                            React.createElement("label", { className: "vessel-name" }, m.Model.VesselName()),
                            React.createElement("span", { className: "location" },
                                React.createElement("label", { className: "from-name" }, (_b = (_a = m.Model.FromPoint()) === null || _a === void 0 ? void 0 : _a.Location()) === null || _b === void 0 ? void 0 : _b.Name()),
                                React.createElement("span", { className: "to-label pc-text-smalllabel", hidden: !m.Model.ToPoint() },
                                    ' ',
                                    "to",
                                    ' '),
                                React.createElement("label", { className: "to-name", hidden: !m.Model.ToPoint() }, (_d = (_c = m.Model.ToPoint()) === null || _c === void 0 ? void 0 : _c.Location()) === null || _d === void 0 ? void 0 : _d.Name())),
                            !m.HasBegun() && React.createElement(TrafficCCards, { movement: m }),
                            React.createElement(MovementCompleteTime, { movement: m, model: model }),
                            m.HasBegun() && !m.MovementCompleteTime() && React.createElement("span", { className: "last-column" }),
                            React.createElement("span", { className: "screen-size-phone-lg-spacer" })));
                })));
        })));
});
var MovementDetailsPopup = supercritical_1.default(function (_a) {
    var model = _a.model;
    var details = model.MovementDetails();
    return (React.createElement(view_2.PCModal, { className: "movement-details-modal", shown: function () { return !!details; }, onBackDropClick: details === null || details === void 0 ? void 0 : details.Close },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header" },
                React.createElement("a", { href: "", onClick: details ? eventWrappers_1.noDefault(details.Close) : undefined }, "<< Back"),
                React.createElement("span", { className: "details-actions-shell" },
                    React.createElement("a", { href: "", className: "details-actions-menu-btn fa fa-bars", onClick: details ? eventWrappers_1.noDefault(details.ToggleActionsMenu) : undefined }),
                    details && React.createElement(MovementDetailsActionsMenu, { details: details }))),
            React.createElement("div", { className: "modal-body" }, details && React.createElement(view_3.PortCallScheduleView, { model: details.Schedule })))));
});
var MovementDetailsActionsMenu = supercritical_1.default(function (_a) {
    var _b, _c, _d, _e, _f;
    var details = _a.details;
    if (details.ShowActionsMenu()) {
        var m = details.Movement, res = (_e = (_c = (_b = m.FromPoint()) === null || _b === void 0 ? void 0 : _b.BerthReservation()) !== null && _c !== void 0 ? _c : (_d = m.ToPoint()) === null || _d === void 0 ? void 0 : _d.BerthReservation()) !== null && _e !== void 0 ? _e : null, pt = (_f = res === null || res === void 0 ? void 0 : res.Itinerary()) !== null && _f !== void 0 ? _f : null;
        return (React.createElement(view_4.PCDismissible, { className: "pc-actions-menu pc-card details-actions-menu", onDismiss: function () { return details.ShowActionsMenu(false); } },
            res && pt &&
                React.createElement("div", { className: "action-item" },
                    React.createElement("a", { href: "#!schedulegrid?date=" + tzmoment_1.tzmoment(pt.Arrival.Effective())
                            .add(-1, 'days')
                            .format('YYYY-MM-DD') + "&resid=" + res.Id() }, "View on Berths")),
            React.createElement("div", { className: "action-item" },
                React.createElement("a", { href: "#!portcallprofile?id=" + m.PortCallId() }, "View PortCall"))));
    }
    else {
        return null;
    }
});
var TrafficCCards = supercritical_1.default(function (_a) {
    var m = _a.movement;
    return React.createElement("div", { className: "coordination-cards last-column" }, m.TrafficCoordinationCards().map(function (ccard) {
        return React.createElement(TrafficCCard, { ccard: ccard, key: ccard.Model.Id() });
    }));
});
var TrafficCCard = supercritical_1.default(function (_a) {
    var _b, _c;
    var ccard = _a.ccard;
    return React.createElement("div", { className: "coordination-card" },
        React.createElement(view_1.CCardStatusIndicator, { statusId: ccard.Model.StatusId() }),
        React.createElement("span", { className: "title" }, (_b = ccard.Model.Coordination()) === null || _b === void 0 ? void 0 : _b.Title()),
        React.createElement("span", { className: "status-label" },
            "(", (_c = ccard.Model.EffectiveStatusLabel()) !== null && _c !== void 0 ? _c : 'loading...',
            ")"));
});
var MovementCompleteTime = supercritical_1.default(function (_a) {
    var m = _a.movement, model = _a.model;
    var completionDateTime = m.MovementCompleteTime();
    if (completionDateTime === null)
        return null;
    var completionDate = tzmoment_1.tzmomentMod(model.TZUtils, completionDateTime, function (d) { return d.startOf('day'); }), dataDate = tzmoment_1.tzmomentMod(model.TZUtils, model.Date(), function (d) { return d.startOf('day'); }), isSameDay = TZDate_1.default.eq(completionDate, dataDate);
    return (React.createElement("label", { className: "mooring last-column" },
        m.Model.Type() === 'out' ? "cleared at" :
            m.Model.Type() === 'area' ? "arrived at" : "moored at",
        React.createElement("span", { className: "mooring-time" }, tzmoment_1.tzmoment(completionDateTime).format(isSameDay ? 'HH:mm' : 'HH:mm, MMM DD'))));
});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageRoute = void 0;
var React = __webpack_require__(2);
var model_1 = __webpack_require__(270);
var view_1 = __webpack_require__(1101);
var view_2 = __webpack_require__(12);
var componentLocation_1 = __webpack_require__(34);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var HomePageRoute = function (location, homepage, tzutils, appWrapper) {
    var model = homepage(inboundParams(location.params, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.HomePageView, { model: model })),
        reflectState: function () { return new componentLocation_1.Location(location.name, outboundParams(model, tzutils)); }
    };
};
exports.HomePageRoute = HomePageRoute;
function inboundParams(p, tzutils) {
    return {
        tab: 'tab' in p ? +(p['tab'] || 0) : model_1.HomePageTab.Movements,
        date: 'date' in p ? tzutils.setTimezoneOffset(new TZDate_1.default(p["date"] + "T00:00:00Z"), true) : tzutils.today(),
        port: p['port']
    };
}
function outboundParams(model, tzutils) {
    var p = {};
    if (model.Tab() !== model_1.HomePageTab.Movements)
        p['tab'] = model.Tab() + '';
    if (!TZDate_1.default.eq(model.Date(), tzutils.today()))
        p['date'] = tzmoment_1.tzmoment(model.Date()).format('YYYY-MM-DD');
    if (model.PortFilter())
        p['port'] = model.PortFilter();
    return p;
}


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(270);
var tzmoment_1 = __webpack_require__(9);
var mapview_1 = __webpack_require__(1097);
var cruisescheduleview_1 = __webpack_require__(1093);
var inportview_1 = __webpack_require__(1095);
var movementsview_1 = __webpack_require__(1099);
var view_1 = __webpack_require__(130);
var view_2 = __webpack_require__(91);
var view_3 = __webpack_require__(22);
exports.HomePageView = supercritical_1.default(function (_a) {
    var _b;
    var model = _a.model;
    var settings = model.Domain.Settings().Homepage.Banner;
    var domainUOM = (_b = model.Domain.Settings().Pier.DefaultLengthUOM()) !== null && _b !== void 0 ? _b : 'ft';
    return (React.createElement("div", { className: "homepage-shell" },
        React.createElement("div", { className: "homepage-header-backgrounds" },
            React.createElement("div", { className: "homepage-header-backgrounds-pic", style: { backgroundImage: settings.Url() && 'url(' + settings.Url() + ')' } }),
            React.createElement("div", { className: "homepage-header-backgrounds-green" })),
        React.createElement("div", { className: 'homepage pc-page-fixedwidth tab-' + model_1.HomePageTab[model.Tab()].toLowerCase() + (model.User() ? ' logged-in' : '') },
            React.createElement("div", { className: "homepage-header" },
                React.createElement("div", { className: "intro", style: { color: settings.TextColor() } },
                    React.createElement("div", { className: "title", style: { textShadow: settings.TextShadowColor() && '2px 2px 4px ' + settings.TextShadowColor() } }, model.Domain.HomePageTitle()),
                    React.createElement("div", { className: "description", style: { textShadow: settings.TextShadowColor() && '1px 1px 2px ' + settings.TextShadowColor() } }, model.Domain.HomePageSubtitle())),
                React.createElement("div", { className: "login" }, !model.User() && model.InitialDataLoaded() && React.createElement("button", { className: "pc-button login-button", onClick: function () { return model.ShowLogin(true); } }, "LOGIN")),
                React.createElement("div", { className: "map-image" },
                    React.createElement("img", { onClick: model.Tab.bind(null, model_1.HomePageTab.Map), src: model.Map.Settings.ImageUrl() || undefined }))),
            React.createElement("div", { className: "home-menu" },
                model.TabVisible(model_1.HomePageTab.Movements) ?
                    React.createElement("div", { className: "menu-item" + (model.Tab() === model_1.HomePageTab.Movements ? ' selected' : ''), onClick: model.Tab.bind(null, model_1.HomePageTab.Movements) },
                        React.createElement("label", { className: "menu-item-title" }, "TRAFFIC SCHEDULE"),
                        React.createElement("label", { className: "menu-item-description" }, "Daily arrivals, departures, and shifts")) : null,
                model.TabVisible(model_1.HomePageTab.InPort) ?
                    React.createElement("div", { className: "menu-item" + (model.Tab() === model_1.HomePageTab.InPort ? ' selected' : ''), onClick: model.Tab.bind(null, model_1.HomePageTab.InPort) },
                        React.createElement("label", { className: "menu-item-title" }, "VESSELS IN PORT"),
                        React.createElement("label", { className: "menu-item-description" }, "List of current vessels")) : null,
                model.TabVisible(model_1.HomePageTab.Cruise) ?
                    React.createElement("div", { className: "menu-item" + (model.Tab() === model_1.HomePageTab.Cruise ? ' selected' : ''), onClick: model.Tab.bind(null, model_1.HomePageTab.Cruise) },
                        React.createElement("label", { className: "menu-item-title" }, "CRUISE SCHEDULE"),
                        React.createElement("label", { className: "menu-item-description" }, "Yearly cruise ship schedules")) : null,
                model.TabVisible(model_1.HomePageTab.Map) ?
                    React.createElement("div", { className: "menu-item" + (model.Tab() === model_1.HomePageTab.Map ? ' selected' : ''), onClick: model.Tab.bind(null, model_1.HomePageTab.Map) },
                        React.createElement("label", { className: "menu-item-title" }, "VIEW MAP"),
                        React.createElement("label", { className: "menu-item-description" }, "View berth locations")) : null),
            model.Tab() === model_1.HomePageTab.Map ? null :
                React.createElement("div", { className: "selectors" },
                    model.NumberOfPorts() > 1 ?
                        React.createElement("div", { className: "port-picker" },
                            React.createElement(view_2.TypeaheadInput, { model: model.PortTypeahead, className: "filter-ctrl port-filter", placeholder: "View by island or port" }),
                            React.createElement("a", { href: "", className: "show-all", onClick: eventWrappers_1.noDefault(function () { return model.PortFilter(''); }) }, "Show All")) : null,
                    model.Tab() === model_1.HomePageTab.Movements ?
                        React.createElement("div", { className: "pc-date-arrowpicker" },
                            React.createElement("div", { className: "pc-button date-arrow", onClick: model.DatePrev },
                                React.createElement("span", { className: "glyphicon glyphicon-chevron-left" })),
                            React.createElement("div", { className: "pc-button date-text", onClick: model.DateToday }, "Today"),
                            React.createElement("div", { className: "pc-button date-arrow", onClick: model.DateNext },
                                React.createElement("span", { className: "glyphicon glyphicon-chevron-left mirror-glyphicon IE-mirror-glyphicon" }))) : null,
                    model.Tab() === model_1.HomePageTab.Movements ?
                        React.createElement("div", { className: "current-date" },
                            React.createElement("label", null,
                                "for ",
                                tzmoment_1.tzmoment(model.Date()).format('MMM D, YYYY'))) : null,
                    model.Tab() === model_1.HomePageTab.InPort ?
                        React.createElement("div", { className: "current-date" },
                            React.createElement("label", null,
                                "for ",
                                tzmoment_1.tzmoment(model.Now).format('MMM D, YYYY'))) : null,
                    model.Tab() === model_1.HomePageTab.Cruise ?
                        React.createElement("div", { className: "current-date" },
                            React.createElement("label", null, "for a rolling 18 months")) : null),
            React.createElement(movementsview_1.MovementsView, { model: model.Movements }),
            React.createElement(inportview_1.InPortView, { model: model.InPortVessels, goToPortCall: model.GoToPortCall }),
            React.createElement(cruisescheduleview_1.CruiseScheduleView, { model: model.CruiseSchedule, goToPortCall: model.GoToPortCall, domainUOM: domainUOM }),
            React.createElement(mapview_1.MapView, { model: model.Map }),
            React.createElement(view_1.LoginView, { modelContainer: model.Login })),
        !model.IsCompliant() ?
            React.createElement(view_3.PCModal, { className: "cookie-compliance", shown: function () { return !model.IsCompliant(); }, onBackDropClick: function () { } },
                React.createElement("div", { className: "modal-content" },
                    React.createElement("div", { className: "modal-body clearfix" },
                        React.createElement("h2", { className: "modal-title" }, "Cookie Compliance"),
                        React.createElement("div", null,
                            React.createElement("div", { className: "cookie-explanation" }, "When logging into PortCall, we only place one necessary cookie on your machine to make our site work properly. It merely helps us ensure you only see information you have permission to see. We never track your actions on the site, and we never sell your personal information to anyone."),
                            React.createElement("div", { className: "action-btns" },
                                React.createElement("button", { className: "pc-button", onClick: function () { return model.ShowCompliancy('compliant'); } }, "I understand."))))))
            : null));
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUsersCache = void 0;
var DataCache_1 = __webpack_require__(15);
var InviteUsersResponse_1 = __webpack_require__(1270);
var InviteUsersCache = /** @class */ (function (_super) {
    __extends(InviteUsersCache, _super);
    function InviteUsersCache(data) {
        var _this = _super.call(this) || this;
        // The InviteUsersController doesn't take any parameters. Use a dummy key to force this to be a singleton.
        _this.InviteUsersResponses = new DataCache_1.DataCacheCollection(InviteUsersResponse_1.InviteUsersResponse, InviteUsersResponse_1.InviteUsersResponse.update, function (r) { return 1; }, function (r) { return 1; });
        new DataCache_1.QueryResultsRelationship(_this.InviteUsersResponses, data.Roles, function (r) { return r.AssignableRoles; });
        new DataCache_1.QueryResultsRelationship(_this.InviteUsersResponses, data.Organizations, function (r) { return r.AvailableOrganizations; });
        return _this;
    }
    return InviteUsersCache;
}(DataCache_1.DataCache));
exports.InviteUsersCache = InviteUsersCache;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUsers = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var rolemapper_1 = __webpack_require__(496);
var Accounts_1 = __webpack_require__(199);
function InviteUsers(ajax, entrypoints, queryCache, _a) {
    var selectedOrganizationId = _a.selectedOrganizationId, onHidePopup = _a.onHidePopup;
    var model = queryCache.InviteUsersResponses.update1(null, {}), request = ajax.Url(entrypoints.InviteUsers).Get(), invitation = new Accounts_1.SendUserInviteRequest({
        OrganizationId: selectedOrganizationId || null
    }), client = ajax.Url(entrypoints.SendInvitation, {
        include: [function (i) { return i.InvitedUsers; }]
    }), validation = validationWatcher_1.ValidationWatcher(client), sendInvitationHttpRequest = s_js_1.default.data(null), invitedUserKey = 0, // give our InvitedUserViewModels an auto-incrementing key for use by React
    invitedUsers = invitation.InvitedUsers.map(function (invitedUser, _, i) { return InvitedUserViewModel(invitedUser, i); }, undefined, function (items, mapped, from, to) {
        for (var i = 0; i < from.length; i++) {
            mapped[from[i]].index(to[i]);
        }
    });
    request.done(function (data) {
        queryCache.InviteUsersResponses.update1(request.Date, data);
    });
    return {
        Model: model,
        Request: request,
        SendInvitationRequest: sendInvitationHttpRequest,
        Invitation: invitation,
        InvitedUsers: invitedUsers,
        Validation: validation,
        SelectDuplicateOrg: SelectDuplicateOrg,
        AddInvitedUser: AddInvitedUser,
        Submit: Submit,
        HidePopup: onHidePopup
    };
    function SelectDuplicateOrg(orgId) {
        s_js_1.default.freeze(function () {
            invitation.OrganizationId(orgId);
            invitation.IsNewOrganization(false);
        });
    }
    function AddInvitedUser() {
        var _validation = Object.assign({}, s_js_1.default.sample(validation));
        delete _validation['InvitedUsers'];
        s_js_1.default.freeze(function () {
            validation(_validation);
            invitation.InvitedUsers.push(new Accounts_1.SendUserInviteRequestInvitedUser());
        });
    }
    function Submit() {
        sendInvitationHttpRequest(client.Post(invitation));
    }
    function InvitedUserViewModel(invitedUser, initialIndex) {
        var roleMapper = rolemapper_1.RoleMapper(invitedUser.Roles), index = s_js_1.default.data(initialIndex), _validation = function () { return validation()[InvitedUserValidationKey(index())]; };
        return {
            Model: invitedUser,
            Delete: Delete,
            HasOrImpliesRole: roleMapper.HasOrImpliesRole,
            ImpliesOrMaterializesRole: roleMapper.ImpliesOrMaterializesRole,
            ToggleRole: function (roleId) { return roleMapper.ToggleRole(AddRole, RemoveRole, roleId); },
            EmailValidation: _validation,
            index: index,
            Key: invitedUserKey++
        };
        function AddRole(id) {
            invitedUser.Roles.push(id);
        }
        function RemoveRole(id) {
            invitedUser.Roles.remove(id);
        }
        function Delete() {
            // map validation messages to correct invited user
            var i = s_js_1.default.sample(index), v = Object.assign({}, s_js_1.default.sample(validation)), invitedUserErrors = {}, invitedUserErrorRegexp = /^InvitedUsers\[([0-9]+)\]\.Email$/;
            for (var key in v) {
                var match = invitedUserErrorRegexp.exec(key);
                if (match) {
                    invitedUserErrors[parseInt(match[1])] = v[key];
                }
            }
            for (var key in invitedUserErrors) {
                var j = parseInt(key);
                if (j >= i)
                    delete v[InvitedUserValidationKey(j)];
                if (j > i) {
                    v[InvitedUserValidationKey(j - 1)] = invitedUserErrors[j];
                }
            }
            s_js_1.default.freeze(function () {
                invitation.InvitedUsers.remove(invitedUser);
                validation(v);
            });
        }
    }
    function InvitedUserValidationKey(i) {
        return 'InvitedUsers[' + i + '].Email';
    }
}
exports.InviteUsers = InviteUsers;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalVesselSearch = void 0;
var s_js_1 = __webpack_require__(0);
var escapeHtml_1 = __webpack_require__(293);
var UOM_1 = __webpack_require__(25);
var Measurement_1 = __webpack_require__(11);
var model_1 = __webpack_require__(90);
var typeahead_server_side_1 = __webpack_require__(1189);
function LocalVesselSearch(pierSettings, ajax, entrypoints, data, _a) {
    var onSelect = _a.onSelect;
    var searchText = s_js_1.default.value(""), vesselTypeahead = new model_1.Typeahead({
        searchUrl: entrypoints.LocalVesselSearch,
        typeaheadOptions: {
            minLength: 3,
            highlight: true,
            hint: false
        },
        serverSideSearch: typeahead_server_side_1.TypeaheadServerSide(ajax),
        observable: searchText,
        displayKey: function (v) {
            return v.Name || '';
        },
        templates: {
            suggestion: function (v) {
                var _a;
                var vesselId = '<div style="margin:0 0 10px 18px; display:block;">' + (v.IMO && v.IMO.trim() ? '<span style="width:150px; display:inline-block; margin-top: 4px;">IMO: ' + escapeHtml_1.default(v.IMO) + '</span> ' :
                    v.MMSID && v.MMSID.trim() ? '<span style="width:150px; display:inline-block; margin-top: 4px;">MMSI: ' + escapeHtml_1.default(v.MMSID) + '</span> ' :
                        v.CallSign && v.CallSign.trim() ? '<span style="width:150px; display:inline-block; margin-top: 4px;">Call Sign: ' + escapeHtml_1.default(v.CallSign) + '</span> ' :
                            v.VIN && v.VIN.trim() ? '<span style="width:150px; display:inline-block; margin-top: 4px;">VIN: ' + escapeHtml_1.default(v.VIN) + '</span> ' :
                                ''), length = new Measurement_1.NullableMeasurement(v.Length).convert((_a = pierSettings.DefaultLengthUOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot).toString({ places: 0 }), flag = data.Countries.index(v.FlagId !== null ? v.FlagId : -1)();
                return escapeHtml_1.default(v.Name || '') + '  '
                    + vesselId
                    + '<span style="width: 125px; display: inline-block; margin-top: 4px;">Length: ' + escapeHtml_1.default(length) + '</span> '
                    + '<span style="width: 275px; display: inline-block; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;">Flag: ' + escapeHtml_1.default(flag ? flag.Name() : '--') + '</span></div>';
            }
        },
        onSearchResults: function (_vessels) {
            // TH: Anytime we get a vessel in search results, add it to the vessels cache
            // This is one main way vessels make it into the cache
            // AAH: how to get timestamp here?
            data.Vessels.update(new Date(), _vessels, []);
        },
        onSelect: function (d) {
            var vessel = data.Vessels.update1(null, d);
            onSelect(vessel);
        }
    });
    return {
        Typeahead: vesselTypeahead
    };
}
exports.LocalVesselSearch = LocalVesselSearch;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var s_js_1 = __webpack_require__(0);
var ChangePasswordRequest_1 = __webpack_require__(565);
function Login(ajax, entrypoints, cache, user, _a) {
    var useLandingPage = _a.useLandingPage, onHidePopup = _a.onHidePopup;
    var login = ajax.Url(entrypoints.Login), dataClient = ajax.Url(entrypoints.AuthorizedData), loginRequest = new ChangePasswordRequest_1.LoginRequest(), loginError = s_js_1.default.data(false);
    return {
        LoginRequest: loginRequest,
        LoginError: loginError,
        Login: Login,
        ForgotPassword: ForgotPassword,
        HidePopup: onHidePopup
    };
    function Login() {
        loginError(false);
        var req = login.Post(loginRequest);
        req.then(function () {
            return dataClient.Get();
        }).then(function (json) {
            var model = cache.AuthorizedData.update1(req.Date, json), userSummary = model.UserSummary();
            s_js_1.default.freeze(function () {
                user(userSummary);
                onHidePopup();
            });
            if (useLandingPage) {
                window.location.hash = userSummary.LandingPage() || '';
            }
            else {
                // The useLandingPage: false option is mainly used by the ajax errors component.
                // Reloading is for the benefit of users who've just gotten the login popup due to an auth error
                // and need to reload the window to retry their failed request.
                // This is a terrible sledge hammer - a much better solution would be to weave retry logic into
                // our ajax layer, such that we only need to retry the failed request and not reload the whole window.
                window.location.reload();
            }
        }).catch(function () {
            loginError(true);
        });
    }
    function ForgotPassword() {
        // close modal
        onHidePopup();
        window.location.hash = 'forgotpassword';
    }
}
exports.Login = Login;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageBerthsRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var model_1 = __webpack_require__(271);
var view_1 = __webpack_require__(1107);
var view_2 = __webpack_require__(12);
function ManageBerthsRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ManageBerthsView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.ManageBerthsRoute = ManageBerthsRoute;
function inboundParams(request) {
    var portId = request.params['portId'], mode = request.params['mode'];
    return {
        portId: portId ? +portId : null,
        mode: mode ? +mode : model_1.PageMode.View
    };
}
function outboundParams(request, m) {
    var p = {};
    if (m.SelectedPortId() !== null)
        p['portId'] = '' + m.SelectedPortId();
    if (m.PageMode() !== model_1.PageMode.View)
        p['mode'] = '' + m.PageMode();
    return new componentLocation_1.Location(request.name, p);
}


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageBerthsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(271);
var view_1 = __webpack_require__(132);
var view_2 = __webpack_require__(536);
exports.ManageBerthsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "manageberths pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "#!siteadminsettings" }, "<< Back to Site Admin Settings")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet pc-text-label-color" }),
            React.createElement("span", { className: "pc-text-label-color" }, "Site Admin Settings"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Manage Berths")),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body pc-card" },
        React.createElement(PageBodyTop, { model: m }),
        React.createElement(PageBodyLeft, { model: m }),
        React.createElement(PageBodyRight, { model: m }));
});
var PageBodyTop = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body-top" },
        React.createElement("h2", { className: "pc-card-title page-body-title" }, "Berths"),
        React.createElement("div", { className: "port-filter" },
            React.createElement("select", { className: "pc-select-secondary", value: m.SelectedPortId() || '', onChange: function (e) { return m.SelectedPortId(e.currentTarget.value ? +e.currentTarget.value : null); } },
                React.createElement("option", { value: "" }, "--"),
                m.Ports().map(function (p) {
                    return React.createElement("option", { key: p.Model.Id(), value: p.Model.Id() }, p.Model.Name());
                })),
            React.createElement("span", { className: "pc-select-chevron" })));
});
var PageBodyLeft = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "left-side" },
        React.createElement("ul", { className: "ports-in-domain" }, m.Ports().map(function (p) {
            return React.createElement(PortRow, { port: p, model: m, key: p.Model.Id() });
        })));
});
var PortRow = supercritical_1.default(function (_a) {
    var p = _a.port, m = _a.model;
    if (!p.Show())
        return null;
    return (React.createElement("li", null,
        React.createElement("div", { className: "port-header" }, p.Model.Name()),
        React.createElement(view_1.PCSortable, { className: "piergroups-in-port", onSort: p.OnSortPierGroups, items: p.PierGroups, rowFactory: function (pg) {
                return React.createElement(PierGroupRow, { pierGroup: pg, model: m, key: pg.Model.Id() });
            }, disabled: function () { return m.PageMode() !== model_1.PageMode.Arrange; } })));
});
var PierGroupRow = supercritical_1.default(function (_a) {
    var pg = _a.pierGroup, m = _a.model;
    return React.createElement("li", { className: cx({
            'cursor-auto': m.PageMode() !== model_1.PageMode.Arrange
        }) },
        React.createElement("a", { href: "", className: "unlink-btn", hidden: m.PageMode() !== model_1.PageMode.Link || pg.Berths().length === 1, onClick: eventWrappers_1.noDefault(pg.Unlink) }, "Unlink"),
        React.createElement("ul", { className: "berths-in-piergroup" }, pg.Berths().map(function (b) {
            return React.createElement(BerthRow, { berth: b, pierGroup: pg, model: m, key: b.Model.Id() });
        })));
});
var BerthRow = supercritical_1.default(function (_a) {
    var b = _a.berth, pg = _a.pierGroup, m = _a.model;
    return React.createElement("li", { className: cx({
            'cursor-click': m.PageMode() === model_1.PageMode.View,
            'cursor-auto': m.PageMode() !== model_1.PageMode.View && m.PageMode() !== model_1.PageMode.Arrange
        }), onClick: m.PageMode() === model_1.PageMode.View ? b.NavigateToProfile : undefined },
        React.createElement("span", { className: "berth-name" }, b.Model.Location() && b.Model.Location().Name()),
        React.createElement("input", { className: "link-btn", type: "checkbox", checked: b.SelectedForLinking(), onChange: function (e) { return b.SelectedForLinking(e.currentTarget.checked); }, hidden: m.PageMode() !== model_1.PageMode.Link || pg.Berths().length > 1 }));
});
var PageBodyRight = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "right-side" },
        React.createElement("div", { className: "page-description" }, "This is a list of all the berths and piers in the system. Berths will appear in this configuration throughout the site, such as on the Berths Timeline. Select a row to jump to that berth's profile."),
        React.createElement(ActionsView, { model: m }),
        React.createElement(EditLinkedBerthsView, { model: m }));
});
var ActionsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card right-side-card actions-box" },
        React.createElement("div", { className: "pc-card-header pc-card-title" }, "Actions"),
        React.createElement(ArrangeLink, { model: m }),
        React.createElement(LinkBerthsLink, { model: m }),
        React.createElement(AddBerthLink, { model: m }),
        React.createElement(RemoveBerthLink, { model: m }));
});
var ArrangeLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('action', { selected: m.PageMode() === model_1.PageMode.Arrange }) },
        React.createElement("a", { href: "", className: "done-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(model_1.PageMode.View); }), hidden: m.PageMode() !== model_1.PageMode.Arrange }, "Done"),
        React.createElement("a", { href: "", className: "main-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(model_1.PageMode.Arrange); }) }, "Arrange Berth Order"),
        React.createElement("div", { className: "description" }, "Drag berths into regions."));
});
var LinkBerthsLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: cx('action', { selected: m.PageMode() === model_1.PageMode.Link }) },
        React.createElement("a", { href: "", className: "done-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(model_1.PageMode.View); }), hidden: m.PageMode() !== model_1.PageMode.Link }, "Done"),
        React.createElement("a", { href: "", className: "main-link", onClick: eventWrappers_1.noDefault(function () { return m.PageMode(model_1.PageMode.Link); }) }, "Link Berths"),
        React.createElement("div", { className: "description" }, "Link two or more berths together so vessels can be scheduled across their total length. Select the berths, arrange them, and then Link them."));
});
var AddBerthLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action" },
        React.createElement("a", { href: "", className: "main-link", onClick: eventWrappers_1.noDefault(m.AddBerth.Add) }, "Add Berth"),
        React.createElement("div", { className: "description" }, "Create a new berth and edit that berth's profile. Enter its name, draw its zone, and fill in the appropriate fields."));
});
var RemoveBerthLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action" },
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { }) }, "Remove Berth"),
        React.createElement("div", { className: "description" }, "Remove a berth from the system. A historical record will remain for billing purposes."));
});
var EditLinkedBerthsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    if (m.PageMode() !== model_1.PageMode.Link)
        return null;
    var p = m.EditLinkedBerths.PortWithSelectedBerths();
    return p &&
        React.createElement("div", { className: "edit-linked-berths-order" },
            !m.EditLinkedBerths.InvalidBerthSelection() && p.SelectedBerths.CanLink() &&
                React.createElement("a", { href: "", className: "confirm", onClick: eventWrappers_1.noDefault(p.SelectedBerths.Link) }, "Link Berths"),
            React.createElement("h3", { className: "section-title" }, "Edit Order"),
            m.EditLinkedBerths.InvalidBerthSelection() ?
                React.createElement("div", { className: "invalid-linked-berths" }, "You cannot link berths from multiple ports. Please make another selection.") :
                React.createElement(view_2.PierGroupFootmarksView, { model: p.SelectedBerths.NewPierGroupFootmarks }));
});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MePage = void 0;
var s_js_1 = __webpack_require__(0);
var model_1 = __webpack_require__(274);
function MePage(user, loginModel, personProfilePageModel) {
    var showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: false, onHidePopup: function () { return showLogin(false); } }) : null; }), personProfilePage = s_js_1.default(function () {
        var u = user();
        if (u)
            return personProfilePageModel(new model_1.PersonProfilePageParams(u.Id()));
        return null;
    });
    // TH: Hmmm... The idea here was to prompt users for login if their cookie expires.
    // But this is interacting badly w/ the new behavior of loading the site while the user summary request is still in flight...
    // if (!S.sample(user)) showLogin(true);
    return {
        Login: login,
        PersonProfilePage: personProfilePage
    };
}
exports.MePage = MePage;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MePageRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1110);
var view_2 = __webpack_require__(12);
var MePageRoute = function (mepage, appWrapper) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper, navbarTab: 5 /* Me */ },
        React.createElement(view_1.MePageView, { model: mepage }))
}); };
exports.MePageRoute = MePageRoute;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MePageView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(535);
var view_2 = __webpack_require__(130);
exports.MePageView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        (function (ppp) { return ppp &&
            React.createElement(view_1.PersonProfilePageView, { model: ppp }); })(m.PersonProfilePage()),
        React.createElement(view_2.LoginView, { modelContainer: m.Login }));
});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MetroMapMilestone = exports.MetroMapFramework = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var EventType_1 = __webpack_require__(111);
var ScheduleDateType_1 = __webpack_require__(80);
function MetroMapFramework(_a) {
    var PortCall = _a.PortCall, MilestoneConstructor = _a.MilestoneConstructor;
    var MilestoneDates = s_array_1.lift(s_js_1.default(function () { return PortCall.MilestoneDates(); })), Milestones = MilestoneDates.map(function (Date) { return MilestoneConstructor({ Date: Date, MilestoneDates: MilestoneDates }); });
    return { Milestones: Milestones };
}
exports.MetroMapFramework = MetroMapFramework;
function MetroMapMilestone(_a) {
    var Date = _a.Date;
    var 
    // Either the next milestone date or, if this is the last milestone, the port departure date.
    NextDate = function () { var _a, _b, _c, _d; return (_d = (_a = Date.NextMilestoneDate()) !== null && _a !== void 0 ? _a : (_c = (_b = Date.PortCall()) === null || _b === void 0 ? void 0 : _b.Itinerary().find(function (pt) { return pt.IsPortDeparture(); })) === null || _c === void 0 ? void 0 : _c.ArrivalEntity()) !== null && _d !== void 0 ? _d : null; }, 
    // If this milestone date has an actual date logged, then try to find the event representing the logging
    // of that actual, so we can display info about who logged the actual and when.
    ActualLoggedEvent = s_js_1.default(function () {
        var _a, _b, _c, _d;
        var currentActual = Date.Actual();
        if (currentActual === null)
            return null;
        // NOTE: For now, we're NOT gonna try to support legacy LineTimeActualPortCallChange events here.
        // If the actual value is old enough to precede us adding the event types below, then we just won't
        // display any metadata about who logged that actual when.
        var expectedEventType = Date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ? EventType_1.EventType.IPArrivalLogged :
            Date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ? EventType_1.EventType.IPDepartureLogged :
                null;
        if (expectedEventType === null)
            return null;
        // Basically, we just wanna find the most recent event of the expected type.
        var bestGuess = (_c = (_b = (_a = Date.ItineraryPoint()) === null || _a === void 0 ? void 0 : _a.Self()) === null || _b === void 0 ? void 0 : _b.Events().filter(function (e) { return e.Type() === expectedEventType; }).reduce(function (mostRecent, next) {
            return mostRecent === null || next.AboutId() > mostRecent.AboutId() ? next : mostRecent;
        }, null)) !== null && _c !== void 0 ? _c : null;
        // As a final check, make sure the actual time that was logged matches the current actual time, to
        // defend against the possibility that we might've missed an event somehow.
        var ipv = (_d = bestGuess === null || bestGuess === void 0 ? void 0 : bestGuess.ItineraryPointVersion()) !== null && _d !== void 0 ? _d : null;
        if (ipv === null)
            return null; // Bail if we don't have enough data to perform this check.
        var loggedTime = Date.Type() === ScheduleDateType_1.ScheduleDateType.IPArrival ? ipv.Arrival.Actual() :
            Date.Type() === ScheduleDateType_1.ScheduleDateType.IPDeparture ? ipv.Departure.Actual() :
                null;
        return loggedTime === null ? null : TZDate_1.default.eq(currentActual, loggedTime) ? bestGuess : null;
    });
    return {
        Date: Date,
        NextDate: NextDate,
        ActualLoggedEvent: ActualLoggedEvent
    };
}
exports.MetroMapMilestone = MetroMapMilestone;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePageCache = void 0;
var DataCache_1 = __webpack_require__(15);
var MorePage_1 = __webpack_require__(1291);
var PilotsMorePage_1 = __webpack_require__(1321);
var PCCache_1 = __webpack_require__(17);
var MorePageCache = /** @class */ (function (_super) {
    __extends(MorePageCache, _super);
    function MorePageCache() {
        var _this = _super.call(this) || this;
        _this.MorePages = PCCache_1.PCCollection(MorePage_1.MorePage);
        _this.PilotsMorePages = PCCache_1.PCCollection(PilotsMorePage_1.PilotsMorePage);
        new DataCache_1.SharedKeyRelationship(_this.PilotsMorePages, _this.MorePages, function (p) { return p.MorePage; }, function (m) { return m.Pilots; });
        return _this;
    }
    return MorePageCache;
}(DataCache_1.DataCache));
exports.MorePageCache = MorePageCache;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePage = void 0;
var s_js_1 = __webpack_require__(0);
function MorePage(loader, domain, user, cache) {
    // TH 12/22/2016 -- Only attempt to load MorePage endpoint if we have a user...
    s_js_1.default(function () { return user() && loader({ UserId: user().Id() }, 30); });
    // ... but supply a model from the cache whether we have a user or not.
    // This is to handle logouts from the MorePage.
    var model = s_js_1.default(function () { return cache.MorePages.update1(null, { UserId: user() ? user().Id() : 0 }); });
    return {
        Model: model,
        Domain: domain,
        User: user
    };
}
exports.MorePage = MorePage;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePageRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1115);
var view_2 = __webpack_require__(12);
var MorePageRoute = function (morePage, appWrapper) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper, navbarTab: 3 /* More */ },
        React.createElement(view_1.MorePageView, { model: morePage }))
}); };
exports.MorePageRoute = MorePageRoute;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePageView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
exports.MorePageView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var links = [];
    if (showBerthManagersDashboardLink(m))
        links.push(React.createElement(BerthManagersDashboardLink, { model: m, key: "berth" }));
    if (showSiteAdminSettingsLink(m))
        links.push(React.createElement(SiteAdminSettingsLink, { key: "site-admin" }));
    if (showPilotSettingsLink(m))
        links.push(React.createElement(PilotSettingsLink, { model: m, key: "pilots" }));
    if (showVesselSearchLink(m))
        links.push(React.createElement(VesselSearchLink, { model: m, key: "vessel-search" }));
    /*<ReportsLink model={m} />*/ /* This was also commented out in the pre-typescript page */
    return (React.createElement("div", { className: "more pc-page-fixedwidth" },
        React.createElement("div", { className: "title" }, "More"),
        React.createElement("div", { className: "container" }, links.length ? links : React.createElement("div", null, "No items here"))));
});
var BerthManagersDashboardLink = supercritical_1.default(function (_a) {
    var User = _a.model.User;
    return React.createElement("div", { className: "menu-box" },
        React.createElement("a", { className: "menu-link", href: '#!berthmgrdashboard?id=' + (User() ? User().OrganizationId() : 0) },
            React.createElement("div", { className: "menu-img" },
                React.createElement("span", { className: "fa fa-dashboard" })),
            React.createElement("span", { className: "menu-item" },
                React.createElement("label", { className: "menu-title" }, "Berth Managers Dashboard"),
                React.createElement("br", null),
                React.createElement("span", { className: "menu-desc" }, "Manage reservations and services at your berths."))));
});
var SiteAdminSettingsLink = supercritical_1.default(function () {
    return React.createElement("div", { className: "menu-box" },
        React.createElement("a", { className: "menu-link", href: "#!siteadminsettings" },
            React.createElement("div", { className: "menu-img" },
                React.createElement("span", { className: "fa fa-cogs" })),
            React.createElement("span", { className: "menu-item" },
                React.createElement("label", { className: "menu-title" }, "Site Admin Settings"),
                React.createElement("br", null),
                React.createElement("span", { className: "menu-desc" }, "Edit port names, order, and capabilities.  Manage berths and their arrangements."))));
});
var PilotSettingsLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    // TH: The multiple pilot agency problem. Our solution is that each pilot agency gets its own settings page and settings link.
    // But for now, just show the link for the 1st Pilot Agency for which the user has permissions.
    // Will need to revise if ever have installation w/ multiple Pilot Agencies.
    return React.createElement("div", { className: "menu-box" },
        React.createElement("a", { className: "menu-link", href: '#!pilotsettings?id=' + m.Model().Pilots().CanManageSettingsAgencies()[0] },
            React.createElement("div", { className: "menu-img" },
                React.createElement("span", { className: "glyphicon glyphicon-cog" })),
            React.createElement("span", { className: "menu-item" },
                React.createElement("label", { className: "menu-title" }, "Pilot Settings"),
                React.createElement("br", null),
                React.createElement("span", { className: "menu-desc" }, "Manage Pilot lists and billing configurations."))));
});
var VesselSearchLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "menu-box" },
        React.createElement("a", { className: "menu-link", href: "#!vesselservicelisting" },
            React.createElement("div", { className: "menu-img" },
                React.createElement("span", { className: "icon-ship" })),
            React.createElement("span", { className: "menu-item" },
                React.createElement("label", { className: "menu-title" }, "Vessels"),
                React.createElement("br", null),
                React.createElement("span", { className: "menu-desc" }, "View a ship's particulars and portcalls."))));
});
var ReportsLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "menu-box" },
        React.createElement("a", { className: "menu-link", href: "#!reports" },
            React.createElement("img", { className: "menu-img", src: "Images/more-reports-icon.png" }),
            React.createElement("span", { className: "menu-item" },
                React.createElement("label", { className: "menu-title" }, "Reports"),
                React.createElement("br", null),
                React.createElement("span", { className: "menu-desc" }, "Get information summarizing a variety of port activities."))));
});
function showBerthManagersDashboardLink(m) {
    return m.Model().CanManageBerths();
}
function showSiteAdminSettingsLink(m) {
    return m.Model().CanSiteAdmin();
}
function showPilotSettingsLink(m) {
    return m.Domain.Settings() &&
        m.Domain.Settings().HasPilots() &&
        !!m.Model().Pilots() &&
        m.Model().Pilots().CanManageSettingsAgencies().length;
}
function showVesselSearchLink(m) {
    return m.Model().CanRequestBerths();
}


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
var s_js_1 = __webpack_require__(0);
function Navbar(domain, user, ajax, entrypoints) {
    var userAbbreviation = function () {
        var u = user();
        if (!u)
            return null;
        var firstName = u.FirstName(), lastName = u.LastName() || '', firstInitial = firstName ? firstName[0] + '. ' : '';
        return firstInitial + lastName;
    };
    var showActionsMenu = s_js_1.default.data(false);
    return {
        User: function () { return user(); },
        Logout: Logout,
        UserAbbreviation: userAbbreviation,
        Domain: domain,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu
    };
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function Logout() {
        ajax.Url(entrypoints.Logout).Post({}).then(function () {
            user(null);
            window.location.hash = '#';
        });
    }
}
exports.Navbar = Navbar;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(35);
;
{ /* DC 3/10/17
    Removing Traffic link
    TODO: Add a link to go to (their) Berth Manager's Dashboard if user is a BM
          Looks like we'll want server validation to check permissions and then show?
          Yes but will hold off on this. Added to Berths Action menu as the *solution*
  */
}
exports.NavbarView = supercritical_1.default(function (_a) {
    var m = _a.model, tab = _a.tab;
    return (React.createElement("div", { className: "navbar-component", role: "navigation" },
        React.createElement("div", { className: "top-bar" },
            React.createElement("div", { className: "navbar-content clearfix" },
                React.createElement(PortCallLinks, { model: m }),
                m.User() &&
                    React.createElement("div", { className: "user-info pc-text-background-color" },
                        React.createElement("span", null, m.UserAbbreviation()),
                        React.createElement("a", { className: "logout-link", href: "", onClick: eventWrappers_1.noDefault(m.Logout) }, "Logout")))),
        React.createElement("div", { className: "bottom-bar" },
            React.createElement("div", { className: "navbar-content clearfix" },
                React.createElement("div", { className: "homepage-link link-cell" },
                    React.createElement("a", { href: "#" }, m.Domain.DisplayableUrl().split('.').map(function (segment, i) {
                        return React.createElement("span", { key: i, className: cx({
                                'pc-text-accent': i % 2 === 0,
                                'pc-text-default-color': i % 2 === 1
                            }) }, (i > 0 ? '.' : '') + segment);
                    }))),
                React.createElement("div", null,
                    React.createElement(SiteLinks, { model: m, tab: tab })),
                React.createElement("div", { className: "navbar-mobile-shell" },
                    React.createElement(view_1.ActionsMenuButton, { onClick: m.ToggleActionsMenu }),
                    React.createElement(ActionsMenu, { model: m }))))));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_2.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return m.ShowActionsMenu(false); } },
                React.createElement(SiteLinks, { model: m }),
                React.createElement("div", null,
                    React.createElement(PortCallLinks, { model: m }),
                    m.User() &&
                        React.createElement("div", { className: "action-item" },
                            React.createElement("div", { className: "user-info pc-text-background-color" },
                                React.createElement("span", null, m.UserAbbreviation()))),
                    m.User() &&
                        React.createElement("div", { className: "action-item" },
                            React.createElement("div", { className: "user-info pc-text-background-color" },
                                React.createElement("a", { className: "logout-link", href: "", onClick: eventWrappers_1.noDefault(m.Logout) }, "Logout")))))) : null;
});
var SiteLinks = supercritical_1.default(function (_a) {
    var m = _a.model, tab = _a.tab;
    var user = m.User();
    if (!user)
        return null;
    var settings = m.Domain.Settings();
    return (React.createElement("ul", { className: "site-links nav-links" },
        React.createElement("li", { className: cx('link-cell', { active: tab === 0 /* Berths */ }) },
            React.createElement("a", { className: "", href: "#!schedulegrid" }, "Berths")),
        m.Domain.HasActivePilots() && user.CanViewPilotPages() &&
            // Only show Pilots link for the 1st Pilot Agency in the Domain
            // Will need to revise if ever have installation w/ multiple Pilot Agencies
            React.createElement("li", { className: cx('link-cell', { active: tab === 2 /* Pilots */ }) },
                React.createElement("a", { className: "", href: '#!dispatchdashboard?id=' + m.Domain.PilotAgencyIds()[0] }, "Pilots")),
        React.createElement("li", { className: cx('link-cell', { active: tab === 3 /* More */ }) },
            React.createElement("a", { className: "", href: "#!morepage" }, "More")),
        React.createElement("li", { className: "pipe-character " }, "|"),
        React.createElement("li", { className: cx('link-cell', { active: tab === 4 /* Everyone */ }) },
            React.createElement("a", { className: "", href: "#!organizations" }, "Everyone")),
        React.createElement("li", { className: cx('link-cell', { active: tab === 5 /* Me */ }) },
            React.createElement("a", { className: "", href: "#!mepage" }, "Me"))));
});
var PortCallLinks = supercritical_1.default(function (_a) {
    var m = _a.model;
    var user = m.User(), settings = m.Domain.Settings();
    return (React.createElement("ul", { className: "portcall-links nav-links" },
        React.createElement("li", null,
            React.createElement("a", { href: "http://portcall.com/" },
                React.createElement("span", { className: "pc-text-background-color" }, "Portcall"),
                React.createElement("span", { className: "pc-text-accent" }, ".com"))),
        React.createElement("li", null,
            React.createElement("a", { href: 'http://support.portcall.com/', target: "_blank" }, "Help"))));
});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderableLookups = void 0;
var s_js_1 = __webpack_require__(0);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
function OrderableLookups(ajax, params) {
    var items = params.items, orderProp = params.orderProp, itemKey = params.itemKey, deleteFn = params.deleteFn, autoEditItem = { item: null }, sortedItems = items.map(function (item) { return ItemViewModel(item, ajax, autoEditItem, deleteFn); })
        .sort(function (item1, item2) { return orderProp(item1.Model)() - orderProp(item2.Model)(); });
    return {
        Items: sortedItems,
        Add: Add,
        OnSortItems: OnSortItems,
        ItemKey: itemKey,
        ShowDeleteBtn: !!deleteFn,
        SupportsAdd: params.supportsAdd
    };
    function Add() {
        if (!params.supportsAdd)
            return;
        var addClient = params.addClient, cacheCollection = params.cacheCollection, itemFactory = params.itemFactory;
        var req = addClient.Post(itemFactory(s_js_1.default.sample(NextOrder)));
        req.then(function (data) { return s_js_1.default.freeze(function () {
            // TH 12/12/2016 -- Run this line inside an S.freeze so that the
            // assignment to autoEditItem.item takes effect before the ItemViewModel
            // that will happen in the next tick (due to the SArray.map call above).
            return autoEditItem.item = cacheCollection.update1(req.Date, data);
        }); });
    }
    function NextOrder() {
        return items().length > 0 ?
            Math.max.apply(Math, items().map(function (item) { return orderProp(item)(); })) + 1 : 0;
    }
    function OnSortItems(item, items) {
        s_js_1.default.freeze(function () {
            items.forEach(function (item, idx) { return orderProp(item.Model)(idx); });
        });
    }
}
exports.OrderableLookups = OrderableLookups;
function ItemViewModel(item, ajax, autoEditItem, deleteFn) {
    var client = ajax.Url(function () { return item.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(item, client), validation = validationWatcher_1.ValidationWatcher(client), shouldAutoEdit = item === autoEditItem.item, editing = s_js_1.default.data(shouldAutoEdit);
    if (shouldAutoEdit)
        autoEditItem.item = null;
    return {
        Model: draft,
        Editing: editing,
        Delete: Delete,
        Validation: validation
    };
    function Delete() {
        deleteFn && deleteFn(client, draft);
    }
}


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var OrganizationsResponse_1 = __webpack_require__(1296);
var OrganizationsCache = /** @class */ (function (_super) {
    __extends(OrganizationsCache, _super);
    function OrganizationsCache(data) {
        var _this = _super.call(this) || this;
        // The OrganizationsController doesn't take any parameters. Use a dummy key to force this to be a singleton.
        _this.OrganizationsResponses = new DataCache_1.DataCacheCollection(OrganizationsResponse_1.OrganizationsResponse, OrganizationsResponse_1.OrganizationsResponse.update, function (r) { return 1; }, function (r) { return 1; });
        new DataCache_1.QueryResultsRelationship(_this.OrganizationsResponses, data.Organizations, function (r) { return r.Organizations; });
        return _this;
    }
    return OrganizationsCache;
}(DataCache_1.DataCache));
exports.OrganizationsCache = OrganizationsCache;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Organizations = void 0;
var s_js_1 = __webpack_require__(0);
var diacriticals_1 = __webpack_require__(42);
var debounceSignal_1 = __webpack_require__(81);
function Organizations(ajax, entrypoints, user, domain, cache, queryCache, personProfilePopupModel, inviteUsersModel, userPermissionsModel) {
    var model = queryCache.OrganizationsResponses.update1(null, {}), showActionsMenu = s_js_1.default.data(false), showUserPermissions = s_js_1.default.data(false), userPermissions = s_js_1.default(function () {
        if (showUserPermissions()) {
            showActionsMenu(false);
            return userPermissionsModel({ onHidePopup: function () { return showUserPermissions(false); } });
        }
        return null;
    }), showInviteUsers = s_js_1.default.data(false), inviteUsers = s_js_1.default(function () {
        if (showInviteUsers()) {
            showActionsMenu(false);
            return inviteUsersModel({ onHidePopup: function () { return showInviteUsers(false); } });
        }
        return null;
    }), showManageOrgs = s_js_1.default.data(false), request = ajax.Url(entrypoints.Organizations).Get(), searchFilter = s_js_1.default.data(''), debouncedFilter = debounceSignal_1.debounceSignal(searchFilter), orgs = model.Organizations
        .filter(function (org) { return !debouncedFilter()
        || orgContainsSearchTerm(org)
        || org.Users().some(function (user) { return user.Active() && userContainsSearchTerm(user); }); })
        .sort(function (org1, org2) {
        var org1Name = org1.Name().toLowerCase(), org2Name = org2.Name().toLowerCase();
        return org1Name < org2Name ? -1 : org1Name > org2Name ? 1 : 0;
    })
        .map(OrganizationViewModel);
    s_js_1.default(function () {
        if (showManageOrgs())
            showActionsMenu(false);
    });
    request.done(function (data) {
        queryCache.OrganizationsResponses.update1(request.Date, data);
    });
    return {
        Request: request,
        Model: model,
        Organizations: orgs,
        SearchFilter: searchFilter,
        ShowUserPermissions: showUserPermissions,
        UserPermissions: userPermissions,
        ShowInviteUsers: showInviteUsers,
        InviteUsers: inviteUsers,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: function () { return showActionsMenu(!showActionsMenu()); },
        ShowManageOrgs: showManageOrgs,
        Domain: domain
    };
    function OrganizationViewModel(organization) {
        var client = ajax.Url(function () { return organization.Url() || ''; }), showConfirmDelete = s_js_1.default.data(false), users = organization.Users
            .filter(function (user) { return user.Active() && (!debouncedFilter()
            || orgContainsSearchTerm(organization)
            || userContainsSearchTerm(user)); })
            .sort(function (user1, user2) {
            var user1LastName = user1.LastName().toLowerCase(), user2LastName = user2.LastName().toLowerCase();
            if (user1LastName !== user2LastName)
                return user1LastName < user2LastName ? -1 : 1;
            var user1FirstName = user1.FirstName().toLowerCase(), user2FirstName = user2.FirstName().toLowerCase();
            return user1FirstName < user2FirstName ? -1 : user1FirstName > user2FirstName ? 1 : 0;
        })
            .map(PCUserViewModel);
        return {
            Model: organization,
            IsMyOrg: function () { return !!(user() && user().OrganizationId() === organization.Id()); },
            Users: users,
            ShowConfirmDelete: showConfirmDelete,
            Delete: Delete
        };
        function Delete() {
            organization.Active(false);
            client.Put(organization).done(function () {
                model.Organizations.remove(organization);
            });
        }
    }
    function PCUserViewModel(user) {
        var showProfile = s_js_1.default.data(false), profilePopup = s_js_1.default(function () { return showProfile() ? personProfilePopupModel({ id: user.Id(), onHidePopup: function () { return showProfile(false); } }) : null; });
        return {
            Model: user,
            ToggleProfile: function () { return showProfile(!showProfile()); },
            ProfilePopup: profilePopup
        };
    }
    function orgContainsSearchTerm(organization) {
        return diacriticals_1.CaseInsensitiveContains(organization.Name(), debouncedFilter());
    }
    function userContainsSearchTerm(user) {
        return diacriticals_1.CaseInsensitiveContains(user.FullName(), debouncedFilter());
    }
}
exports.Organizations = Organizations;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1122);
var view_2 = __webpack_require__(12);
var OrganizationsRoute = function (model, appWrapper) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper, navbarTab: 4 /* Everyone */ },
        React.createElement(view_1.OrganizationsView, { model: model }))
}); };
exports.OrganizationsRoute = OrganizationsRoute;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
var view_2 = __webpack_require__(52);
var view_3 = __webpack_require__(35);
var view_4 = __webpack_require__(1127);
var view_5 = __webpack_require__(78);
var view_6 = __webpack_require__(527);
var view_7 = __webpack_require__(550);
var view_8 = __webpack_require__(54);
// character limits at which tooltips will be enabled
var MAX_USER_NAME_CHARS = 18, MAX_ORG_NAME_CHARS = 20;
exports.OrganizationsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "organizations-page pc-page-fixedwidth" },
        React.createElement(ControlBar, { model: m }),
        React.createElement(OrgListView, { model: m }),
        React.createElement(PageModals, { model: m }));
});
var ControlBar = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "org-search pc-actions-links-header" },
        React.createElement("input", { type: "search", className: "search-query search-box", placeholder: "Search...", autoComplete: "off", value: m.SearchFilter(), onChange: function (e) { return m.SearchFilter(e.currentTarget.value); } }),
        React.createElement(view_8.ActionsMenuButton, { onClick: m.ToggleActionsMenu, hidden: !m.Model.CanManageOrgs() && !m.Model.CanEditPermissions() }),
        React.createElement(ActionsMenu, { model: m }));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
        React.createElement(view_3.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
            m.Model.CanManageOrgs() &&
                React.createElement("div", null,
                    React.createElement("div", { className: "menu-item action-item", onClick: function () { return m.ShowInviteUsers(true); } }, "Invite"),
                    React.createElement("div", { className: "menu-item-desc pc-action-item-descr" },
                        "Invite new users or organizations to join ",
                        m.Domain.DisplayableUrl(),
                        ".")),
            m.Model.CanEditPermissions() &&
                React.createElement("div", null,
                    React.createElement("div", { className: "menu-item action-item", onClick: function () { return m.ShowUserPermissions(true); } }, "Edit Permissions"),
                    React.createElement("div", { className: "menu-item-desc pc-action-item-descr" },
                        "Configure what people do within ",
                        m.Domain.DisplayableUrl(),
                        ".")),
            m.Model.CanManageOrgs() &&
                React.createElement("div", null,
                    React.createElement("div", { className: "menu-item action-item", onClick: function () { return m.ShowManageOrgs(true); } }, "Manage Organizations"),
                    React.createElement("div", { className: "menu-item-desc pc-action-item-descr" },
                        "Remove organizations that no longer contribute to ",
                        m.Domain.DisplayableUrl(),
                        ". Site Admins Only."))));
});
var OrgListView = /** @class */ (function (_super) {
    __extends(OrgListView, _super);
    function OrgListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columnLayoutTrigger = new view_4.PCColumnLayoutTrigger();
        return _this;
    }
    OrgListView.prototype.srender = function (_a) {
        var _this = this;
        var m = _a.model;
        return (React.createElement("div", { className: "org-list-container" },
            React.createElement(view_4.PCColumnLayout, { className: "org-list", gutterPx: 10, additionalTrigger: this.columnLayoutTrigger }, m.Organizations().map(function (org) {
                return React.createElement(OrganizationView, { model: org, key: org.Model.Id(), columnLayoutTrigger: _this.columnLayoutTrigger });
            }))));
    };
    return OrgListView;
}(supercritical_1.SuperCriticalComponent));
var OrganizationView = supercritical_1.default(function (_a) {
    var org = _a.model, columnLayoutTrigger = _a.columnLayoutTrigger;
    return React.createElement("div", { className: "pc-card org-card" },
        React.createElement(OrgHeader, { model: org }),
        React.createElement(OrgUsersView, { model: org, columnLayoutTrigger: columnLayoutTrigger }));
});
var OrgHeader = supercritical_1.default(function (_a) {
    var org = _a.model;
    return React.createElement("div", { className: "pc-card-header" },
        React.createElement("img", { className: "org-thumbnail", src: org.Model.Image.ThumbUrl() }),
        React.createElement(view_2.PCTooltip, { className: "org-name-container pc-text-fixedwidth pc-text-fixedwidth-tooltip", shown: function () { return org.Model.Name().length > MAX_ORG_NAME_CHARS; }, title: function () { return org.Model.Name(); } },
            React.createElement("a", { className: "org-name pc-text-smalllabel", href: '#!orgprofile?id=' + org.Model.Id() }, org.Model.Name() + ' (' + org.Users().length + ')'),
            React.createElement("div", { className: "my-org" }, org.IsMyOrg() ? 'My Organization' : '')));
});
var OrgUsersView = supercritical_1.default(function (_a) {
    var org = _a.model, columnLayoutTrigger = _a.columnLayoutTrigger;
    return React.createElement("div", { className: "user-list", ref: columnLayoutTrigger.ref /* re-trigger column layout when user list renders */ }, org.Users().map(function (user) {
        return React.createElement(UserView, { model: user, key: user.Model.Id() });
    }));
});
var UserView = supercritical_1.default(function (_a) {
    var user = _a.model;
    return React.createElement("div", { className: "user" },
        React.createElement("img", { className: "user-thumbnail", src: user.Model.Image.ThumbUrl() }),
        React.createElement(view_2.PCTooltip, { className: "user-name pc-text-fixedwidth pc-text-fixedwidth-tooltip", shown: function () { return (user.Model.FullName()).length > MAX_USER_NAME_CHARS; }, title: function () { return user.Model.FullName(); } },
            React.createElement("a", { href: "", className: "pc-text-smalltext", onClick: eventWrappers_1.noDefault(user.ToggleProfile) }, user.Model.FullName())),
        React.createElement(view_5.PersonProfilePopupView, { modelContainer: user.ProfilePopup }));
});
var PageModals = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(view_7.UserPermissionsView, { modelContainer: m.UserPermissions }),
        React.createElement(view_6.InviteUsersView, { modelContainer: m.InviteUsers }),
        React.createElement(ManageOrgsModal, { model: m }));
});
var ManageOrgsModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.PCModal, { className: "manage-orgs-modal", shown: function () { return m.ShowManageOrgs(); }, onBackDropClick: function () { return m === null || m === void 0 ? void 0 : m.ShowManageOrgs(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-header manageOrgsHeader" },
                React.createElement("button", { className: "close pc-modal-close", onClick: function () { return m.ShowManageOrgs(false); } },
                    React.createElement("span", null, "Close")),
                React.createElement("h2", { className: "modal-title pc-modal-title" }, "Manage Organizations")),
            React.createElement("div", { className: "manage-org-text pc-text-smalllabel" }, "Deleting an organization will permanently remove the organization and all of the associated user accounts."),
            React.createElement("div", { className: "modal-body manageOrgsBody" }, m.Organizations().map(function (org) {
                return React.createElement(ManageOrgsOrgView, { model: org, key: org.Model.Id() });
            }))));
});
var ManageOrgsOrgView = supercritical_1.default(function (_a) {
    var org = _a.model;
    return React.createElement("div", { className: "modal-org-list-item" },
        React.createElement("img", { className: "org-thumbnail", src: org.Model.Image.ThumbUrl() }),
        React.createElement(view_2.MaxLengthTooltip, { className: "org-name pc-text-fixedwidth pc-text-fixedwidth-tooltip", text: function () { return org.Model.Name(); }, maxLength: MAX_ORG_NAME_CHARS }),
        React.createElement(DeleteOrgConfirmation, { model: org }));
});
var DeleteOrgConfirmation = supercritical_1.default(function (_a) {
    var org = _a.model;
    return React.createElement("div", { className: "delete" }, !org.ShowConfirmDelete() ?
        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return org.ShowConfirmDelete(true); }) }, "Delete")
        :
            React.createElement("div", { className: "delete-shell" },
                React.createElement("div", { className: "delete-text" },
                    "Are you sure? All organization members will also be deleted.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "This cannot be undone.",
                    React.createElement("br", null)),
                React.createElement("div", { className: "action-btns" },
                    React.createElement("button", { className: "close pc-modal-close delete-close", onClick: function () { return org.ShowConfirmDelete(false); } }, "Cancel"),
                    React.createElement("button", { className: "pc-button", onClick: org.Delete }, "Delete"))));
});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProfileCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var OrgProfileResponse_1 = __webpack_require__(577);
var OrgProfileCache = /** @class */ (function (_super) {
    __extends(OrgProfileCache, _super);
    function OrgProfileCache(data) {
        var _this = _super.call(this) || this;
        _this.OrgProfileResponses = PCCache_1.PCCollection(OrgProfileResponse_1.OrgProfileResponse);
        new DataCache_1.SharedKeyRelationship(_this.OrgProfileResponses, data.Organizations, function (r) { return r.Organization; }, null);
        new DataCache_1.QueryResultsRelationship(_this.OrgProfileResponses, data.PierGroups, function (r) { return r.PierGroups; });
        new DataCache_1.QueryResultsRelationship(_this.OrgProfileResponses, data.Ports, function (r) { return r.Ports; });
        new DataCache_1.QueryResultsRelationship(_this.OrgProfileResponses, data.DefaultImages, function (r) { return r.Ref && r.Ref.DefaultImages; });
        return _this;
    }
    return OrgProfileCache;
}(DataCache_1.DataCache));
exports.OrgProfileCache = OrgProfileCache;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProfileRoute = void 0;
var React = __webpack_require__(2);
var model_1 = __webpack_require__(531);
var view_1 = __webpack_require__(1125);
var view_2 = __webpack_require__(12);
var OrgProfileRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.OrgProfileView, { model: model(convertParams(request)) }))
}); };
exports.OrgProfileRoute = OrgProfileRoute;
function convertParams(request) {
    var id = parseInt(request.params['id'] || '', 10);
    if (isNaN(id))
        throw new Error('OrgProfile: id param is required and must be numeric.');
    return new model_1.OrgProfileParams(id);
}


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProfileView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var PortCallUserRole_1 = __webpack_require__(136);
var orgheaderview_1 = __webpack_require__(131);
var view_1 = __webpack_require__(547);
var view_2 = __webpack_require__(539);
var view_3 = __webpack_require__(275);
var view_4 = __webpack_require__(29);
var view_5 = __webpack_require__(510);
var view_6 = __webpack_require__(78);
var view_7 = __webpack_require__(527);
var view_8 = __webpack_require__(550);
var cx = __webpack_require__(10);
exports.OrgProfileView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "orgprofile pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back")),
        m.Organization() && React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Organization().Model }),
        m.Organization() && React.createElement(view_1.SelectProfileImageView, { modelContainer: m.Organization().ImageSelector }),
        React.createElement(PageBody, { model: m }),
        React.createElement(PageModals, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { hidden: !!(m.Organization() && m.Organization().ImageSelector()) },
        React.createElement(PageLeftSide, { model: m }),
        React.createElement(ActionsSideBar, { model: m }));
});
var PageLeftSide = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "left-side" },
        React.createElement("div", { className: cx('pc-card profile-body', {
                'pc-show-editcontrols': m.Editing(),
                'pc-show-viewcontrols': !m.Editing()
            }) },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("span", { className: "pc-card-title" }, "Org Information")),
            React.createElement("div", { className: "left-column" },
                React.createElement(OrgDetails, { model: m }),
                React.createElement(OrgMembersView, { model: m }),
                React.createElement(OrgBerthsView, { model: m })),
            React.createElement("div", { className: "right-column" },
                React.createElement(view_5.BookingRateView, { bookingRate: m.Model.BookingRate }))));
});
var OrgDetails = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "orgdetails" },
        React.createElement("h3", { className: "profile-section-title" }, "Details"),
        m.Model.CanEdit() &&
            React.createElement("span", null,
                React.createElement("a", { href: "", className: "pc-input-viewcontrol", onClick: eventWrappers_1.noDefault(function () { return m.Editing(true); }) }, "Edit"),
                React.createElement("a", { href: "", className: "pc-input-editcontrol", onClick: eventWrappers_1.noDefault(function () { return m.Editing(false); }) }, "Done Editing")),
        (function (org) { return org &&
            React.createElement("div", { className: "editprofileimagelink pc-input-editcontrol" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(org.ShowSelectProfileImage) }, "Edit Profile Image")); })(m.Organization()),
        React.createElement(OrgNameView, { model: m }),
        React.createElement(OrgAddressView, { model: m }),
        React.createElement(OrgPhoneNumbersView, { model: m }));
});
var OrgNameView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "name details-row" },
        React.createElement("label", { className: "left-col" }, "Name"),
        React.createElement("div", { className: "right-col" },
            React.createElement("span", { className: "pc-input-viewcontrol pc-text-fixedwidth" }, m.Organization() && m.Organization().Model.Name()),
            (function (org) { return org &&
                React.createElement("span", null,
                    React.createElement("input", { className: "pc-input-editcontrol", type: "text", placeholder: "Name", value: org.Model.Name(), onChange: function (e) { return org.Model.Name(e.target.value); } }),
                    React.createElement(view_4.ValidationErrorView, { error: function () { return org.Validation()['Name']; } })); })(m.Organization())));
});
var OrgAddressView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "address details-row" },
        React.createElement("label", { className: "left-col" }, "Address"),
        (function (org) { return org &&
            React.createElement("div", { className: "right-col" },
                React.createElement("div", null,
                    React.createElement("a", { href: "", className: "pc-input-editcontrol profile-add-link", onClick: eventWrappers_1.noDefault(org.PostalAddresses.Add) }, "+Add")),
                React.createElement("div", { className: "postaladdresses" }, org.PostalAddresses.Addresses().map(function (addr) {
                    return React.createElement(view_2.PostalAddressView, { key: addr.Model.Id(), model: addr });
                }))); })(m.Organization()));
});
var OrgPhoneNumbersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "contacts details-row" },
        React.createElement("label", { className: "left-col" }, "Contacts"),
        (function (org) { return org &&
            React.createElement("div", { className: "right-col" },
                React.createElement("div", { className: "link-shell" },
                    React.createElement("a", { href: "", className: "pc-input-editcontrol profile-add-link", onClick: eventWrappers_1.noDefault(org.PhoneNumbers.Add) }, "+Add")),
                React.createElement("div", { className: "phonenumbers" }, org.PhoneNumbers.PhoneNumbers().map(function (pn) {
                    return React.createElement(view_3.PhoneNumberView, { key: pn.Model.Id(), model: pn });
                }))); })(m.Organization()));
});
var OrgMembersView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "orgmembers" },
        React.createElement("h3", { className: "profile-section-title" },
            "Members",
            ' ',
            m.Organization() ? '(' + m.Organization().Users().length + ')' : ''),
        m.Model.CanManageUsers() &&
            React.createElement("span", null,
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.ShowUserPermissions) }, "Manage"),
                React.createElement("span", { className: "pc-icon-bullet" }),
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.ShowInviteUsers) }, "Invite")),
        (function (org) { return org &&
            React.createElement("div", null, org.Users().map(function (user) {
                return React.createElement("div", { className: "member", key: user.Model.Id() },
                    React.createElement("img", { src: user.Model.Image.ThumbUrl() }),
                    React.createElement("a", { href: "", className: "name-text pc-text-fixedwidth pc-text-smalltext", onClick: eventWrappers_1.noDefault(user.ToggleProfile) }, user.Model.FullName()),
                    React.createElement(view_6.PersonProfilePopupView, { modelContainer: user.ProfilePopup }));
            })); })(m.Organization()));
});
var OrgBerthsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    if (m.Berths().length === 0)
        return null;
    return (React.createElement("div", { className: "orgberths" },
        React.createElement("h3", { className: "profile-section-title" },
            "Berths (",
            m.Berths().length,
            ")"),
        m.Model.CanAddBerth() &&
            React.createElement("a", { href: "", className: "addberth-link", onClick: eventWrappers_1.noDefault(m.AddBerth.Add) }, "+ Add Berth"),
        m.Ports().map(function (port) {
            return React.createElement("div", { className: "port", key: port.Model.Id() }, port.PierGroups().map(function (pg) {
                return React.createElement("div", { className: "pier-group", key: pg.Model.Id() }, pg.Berths().map(function (b) {
                    return React.createElement("div", { className: "berth", key: b.Id() },
                        React.createElement("a", { href: '#!berthprofile?id=' + b.Id() }, port.Model.Name() + ' \u2014 ' + (b.Location() ? b.Location().Name() : '')));
                }));
            }));
        })));
});
var ActionsSideBar = supercritical_1.default(function (_a) {
    var m = _a.model;
    if (!m.Model.CanManageBerths() || m.Berths().length === 0)
        return null;
    return (React.createElement("div", { className: "right-side" },
        React.createElement("div", { className: "pc-card profile-sidebar" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("span", { className: "pc-card-title" }, "Berth Manager Settings")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: "#!berthmgrdashboard?id=" + m.Id }, "Berth Manager's Dashboard"),
                React.createElement("div", { className: "text-details-blurb" }, "Manage reservations and services at your berths.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: "#!reservationsdashboard?orgId=" + m.Id + "&role=" + PortCallUserRole_1.PortCallUserRoleDisplayName[PortCallUserRole_1.PortCallUserRole.SchedulingAuthority] }, "Scheduler's Report"),
                React.createElement("div", { className: "text-details-blurb" }, "View list of reservations for which this organization is the Scheduling Authority.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: "#!batchesdashboard?orgId=" + m.Id + "&role=" + PortCallUserRole_1.PortCallUserRoleDisplayName[PortCallUserRole_1.PortCallUserRole.SchedulingAuthority] }, "Scheduler's Batch"),
                React.createElement("div", { className: "text-details-blurb" }, "View batches of reservations for which this organization is the Scheduling Authority.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: "#!berthclosuresdashboard?orgId=" + m.Id }, "Berth Closures"),
                React.createElement("div", { className: "text-details-blurb" }, "View closures at your berths.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: '#!topiccardtemplates?id=' + m.Id }, "Topic Cards"),
                React.createElement("div", { className: "text-details-blurb" }, "Create cards for pier-side services, berth manager approval, and other operational requirements.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: '#!amenitylistmgmt?id=' + m.Id }, "Amenities List"),
                React.createElement("div", { className: "text-details-blurb" }, "Configure amenities offered at your berths.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: '#!tarifflookups?id=' + m.Id }, "Tariff Activities"),
                React.createElement("div", { className: "text-details-blurb" }, "Configure tariff related activities, such as trade routes and cargo categories, at your berths.")),
            React.createElement("div", { className: "harbormaster-setting" },
                React.createElement("a", { href: '#!configurereminders?id=' + m.Id }, "Reminders"),
                React.createElement("div", { className: "text-details-blurb" }, "Specify reminder dates for scheduled PortCalls.")))));
});
var PageModals = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(view_8.UserPermissionsView, { modelContainer: m.UserPermissions }),
        React.createElement(view_7.InviteUsersView, { modelContainer: m.InviteUsers }));
});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCBounded = void 0;
var React = __webpack_require__(2);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
var PCBounded = /** @class */ (function (_super) {
    __extends(PCBounded, _super);
    function PCBounded(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, BoundElement);
        return _this;
    }
    PCBounded.prototype.srender = function (props) {
        return (React.createElement("div", { className: 'pc-bounded ' + (props.className ? props.className : ''), ref: this.ref }, props.children));
    };
    return PCBounded;
}(supercritical_1.SuperCriticalComponent));
exports.PCBounded = PCBounded;
function BoundElement(props, el) {
    var $el = $(el), $container = $(props.container), padding = props.padding || 0, $elOffset = $el.offset() || {
        left: 0,
        top: 0
    }, $elWidth = $el.width(), $elHeight = $el.height(), $containerOffset = $container.offset() || {
        left: 0,
        top: 0
    }, $containerWidth = $container.width(), $containerHeight = $container.height();
    $containerOffset.left = $containerOffset.left + $container.scrollLeft();
    $containerOffset.top = $containerOffset.top + $container.scrollTop();
    var newLeft, newTop;
    if ($elOffset.left + $elWidth + padding > $containerOffset.left + $containerWidth) {
        newLeft = Math.max($containerOffset.left + padding, $containerOffset.left + $containerWidth - $elWidth - padding);
    }
    if ($elOffset.left < $containerOffset.left + padding) {
        newLeft = $containerOffset.left + padding;
    }
    if ($elOffset.top + $elHeight + padding > $containerOffset.top + $containerHeight) {
        newTop = Math.max($containerOffset.top + padding, $containerOffset.top + $containerHeight - $elHeight - padding);
    }
    if ($elOffset.top < $containerOffset.top + padding) {
        newTop = $containerOffset.top + padding;
    }
    if (newLeft !== undefined || newTop !== undefined) {
        $el.offset({
            left: newLeft !== undefined ? newLeft : $elOffset.left,
            top: newTop !== undefined ? newTop : $elOffset.top
        });
    }
}


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCColumnLayout = exports.PCColumnLayoutTrigger = void 0;
var React = __webpack_require__(2);
var s_js_1 = __webpack_require__(0);
var $ = __webpack_require__(27);
var supercritical_1 = __webpack_require__(4);
var PCColumnLayoutTrigger = /** @class */ (function () {
    function PCColumnLayoutTrigger() {
        var _this = this;
        this.signal = s_js_1.default.data(null);
        this.ref = function (e) { return _this.signal(null); };
    }
    return PCColumnLayoutTrigger;
}());
exports.PCColumnLayoutTrigger = PCColumnLayoutTrigger;
var PCColumnLayout = /** @class */ (function (_super) {
    __extends(PCColumnLayout, _super);
    function PCColumnLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, LayoutPanels);
        return _this;
    }
    PCColumnLayout.prototype.srender = function (props) {
        return (React.createElement("div", { className: 'pc-columnlayout ' + props.className, ref: this.ref }, props.children));
    };
    return PCColumnLayout;
}(supercritical_1.SuperCriticalComponent));
exports.PCColumnLayout = PCColumnLayout;
function LayoutPanels(props, el) {
    // DC 06/08/2021 -- Updating this feature from 'lib/S' to 's-js' broke something with auto-resize after data loads.
    // Not sure if it's the OrgUsersView or OrgListView that triggers the layout update, but I think it has something to do with "default" behaviors.
    // At first I tried putting a timer on the 'load', 'hashchange', and 'keyup' events so I could force a resize thru 'scroll'. 
    // Added a timer on S's additional triggers, i.e. OrgUsersView I think, and it seems to do the job.
    window.addEventListener('resize', PerformLayout);
    s_js_1.default.cleanup(function () { return window.removeEventListener('resize', PerformLayout); });
    s_js_1.default(function () {
        props.additionalTrigger && props.additionalTrigger.signal();
        setTimeout(PerformLayout, 300);
    });
    function PerformLayout() {
        if (!el.children.length)
            return;
        var containerWidth = el.offsetWidth, $el = $(el), columnItems = $el.children(), colWidth = columnItems[0].offsetWidth, gutter = props.gutterPx || 0, colCount = Math.floor(containerWidth / (colWidth + gutter)), columns = [];
        for (var i = 0; i < colCount; i++) {
            columns.push(gutter);
        }
        for (var i = 0; i < columnItems.length; i++) {
            var min = Math.min.apply(Math, columns), index = columns.indexOf(min), leftPos = index * (colWidth + gutter), item = columnItems[i];
            $(item).css('position', 'absolute')
                .css('top', min + 'px')
                .css('left', leftPos + 'px');
            columns[index] = min + item.offsetHeight + gutter;
        }
        var max = Math.max.apply(Math, columns);
        $el.css('height', max + 'px');
    }
}


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingVesselServiceListingCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var VesselServiceListing_1 = __webpack_require__(595);
var PendingVesselServiceListingCache = /** @class */ (function (_super) {
    __extends(PendingVesselServiceListingCache, _super);
    function PendingVesselServiceListingCache(data) {
        var _this = _super.call(this) || this;
        _this.VesselServiceListings = PCCache_1.PCCollection(VesselServiceListing_1.VesselServiceListing);
        new DataCache_1.QueryResultsRelationship(_this.VesselServiceListings, data.Vessels, function (r) { return r.Vessels; });
        return _this;
    }
    return PendingVesselServiceListingCache;
}(DataCache_1.DataCache));
exports.PendingVesselServiceListingCache = PendingVesselServiceListingCache;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingVesselServiceListing = void 0;
function PendingVesselServiceListing(ajax, entrypoints, cache, _a) {
    var status = _a.status;
    var key = {
        Status: status,
        SearchString: null
    };
    var model = cache.VesselServiceListings.update1(null, key), request = ajax.Url(entrypoints.VesselServiceListing(key)).Get();
    request.done(function (json) {
        cache.VesselServiceListings.update1(request.Date, json);
    });
    return {
        Model: model,
        Vessels: model.Vessels.map(VesselModel),
    };
    function VesselModel(vessel) {
        return {
            Model: vessel,
            OnRowClick: function () { return window.location.hash = '#!vesselserviceconfigure?id=' + vessel.Id(); }
        };
    }
}
exports.PendingVesselServiceListing = PendingVesselServiceListing;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingVesselServiceListingRoute = void 0;
var React = __webpack_require__(2);
var VesselStatus_1 = __webpack_require__(138);
var view_1 = __webpack_require__(1131);
var view_2 = __webpack_require__(12);
var PendingVesselServiceListingRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.PendingVesselServiceListingView, { model: model(convertParams(request)) }))
}); };
exports.PendingVesselServiceListingRoute = PendingVesselServiceListingRoute;
function convertParams(request) {
    var statusParam = request.params['status'];
    return { status: parseVesselStatus(statusParam) };
}
function parseVesselStatus(strStatus) {
    if (strStatus === undefined)
        return null;
    for (var i = 0; i < VesselStatus_1.VesselStatuses.length; i++) {
        if (strStatus.toLowerCase() === VesselStatus_1.VesselStatuses[i].Name.toLowerCase()) {
            return VesselStatus_1.VesselStatuses[i].Id;
        }
    }
    throw new Error('Unknown VesselStatus string ' + strStatus);
}


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingVesselServiceListingView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var VesselStatus_1 = __webpack_require__(138);
function PageTitle(m) {
    return (m.Model.Status() === null ? '' : VesselStatus_1.VesselStatusDisplayName[m.Model.Status()] + ' ') + 'Vessels';
}
exports.PendingVesselServiceListingView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vesselservicelisting pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "#!siteadminsettings" }, "<< Back to Site Admin Settings")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet pc-text-label-color" }),
            React.createElement("span", { className: "pc-text-label-color" }, "Site Admin Settings"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, PageTitle(m))),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body pc-card" },
        React.createElement("h2", { className: "pc-card-title page-body-title" }, PageTitle(m)),
        React.createElement("table", { className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Vessel Name"),
                    React.createElement("th", null, "IMO"),
                    React.createElement("th", null, "MMSI"),
                    React.createElement("th", null, "Call Sign"),
                    React.createElement("th", null, "Gross Tonnage"),
                    React.createElement("th", null, "Length"),
                    React.createElement("th", null, "Beam"))),
            React.createElement(TableBody, { model: m })));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.Vessels().map(function (vessel) {
        return React.createElement(VesselRow, { vessel: vessel, key: vessel.Model.Id() });
    }));
});
var VesselRow = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("tr", { className: "vessel-row", onClick: v.OnRowClick },
        React.createElement("td", null, v.Model.Name()),
        React.createElement("td", null, v.Model.IMO()),
        React.createElement("td", null, v.Model.MMSID()),
        React.createElement("td", null, v.Model.CallSign()),
        React.createElement("td", null, v.Model.GrossTonnage.toString()),
        React.createElement("td", null, v.Model.Length.toString()),
        React.createElement("td", null, v.Model.Beam.toString()));
});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePageCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PersonProfilePageResponse_1 = __webpack_require__(581);
var PersonProfilePageCache = /** @class */ (function (_super) {
    __extends(PersonProfilePageCache, _super);
    function PersonProfilePageCache(data) {
        var _this = _super.call(this) || this;
        _this.PersonProfilePageResponses = PCCache_1.PCCollection(PersonProfilePageResponse_1.PersonProfilePageResponse);
        new DataCache_1.SharedKeyRelationship(_this.PersonProfilePageResponses, data.PCUsers, function (r) { return r.PCUser; }, null);
        new DataCache_1.QueryResultsRelationship(_this.PersonProfilePageResponses, data.PCUsers, function (r) { return r.InvitablePortCallEditors; });
        new DataCache_1.QueryResultsRelationship(_this.PersonProfilePageResponses, data.Notifications, function (r) { return r.Notifications; });
        new DataCache_1.QueryResultsRelationship(_this.PersonProfilePageResponses, data.Roles, function (r) { return r.Roles; });
        // TH 10/03/2016: Need the defensive check on r.Ref && r.Ref.DefaultImages b/c the DataCache will also apply this lambda to the incoming Options object (in a non-typesafe way),
        // and we wanna allow that options object not to set the Ref property.
        new DataCache_1.QueryResultsRelationship(_this.PersonProfilePageResponses, data.DefaultImages, function (r) { return r.Ref && r.Ref.DefaultImages; });
        return _this;
    }
    return PersonProfilePageCache;
}(DataCache_1.DataCache));
exports.PersonProfilePageCache = PersonProfilePageCache;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePageRoute = void 0;
var React = __webpack_require__(2);
var model_1 = __webpack_require__(274);
var view_1 = __webpack_require__(535);
var view_2 = __webpack_require__(12);
var PersonProfilePageRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.PersonProfilePageView, { model: model(convertParams(request)) }))
}); };
exports.PersonProfilePageRoute = PersonProfilePageRoute;
function convertParams(request) {
    var id = parseInt(request.params['id'] || '');
    if (isNaN(id))
        throw new Error('PersonProfilePage: id param is required and must be numeric.');
    return new model_1.PersonProfilePageParams(id);
}


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePopupCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PersonProfilePopupResponse_1 = __webpack_require__(1306);
var PersonProfilePopupCache = /** @class */ (function (_super) {
    __extends(PersonProfilePopupCache, _super);
    function PersonProfilePopupCache(data) {
        var _this = _super.call(this) || this;
        _this.PersonProfilePopupResponses = PCCache_1.PCCollection(PersonProfilePopupResponse_1.PersonProfilePopupResponse);
        new DataCache_1.SharedKeyRelationship(_this.PersonProfilePopupResponses, data.PCUsers, function (r) { return r.PCUser; }, null);
        return _this;
    }
    return PersonProfilePopupCache;
}(DataCache_1.DataCache));
exports.PersonProfilePopupCache = PersonProfilePopupCache;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePopup = void 0;
var s_js_1 = __webpack_require__(0);
function PersonProfilePopup(entrypoints, ajax, queryCache, phoneNumberModel, _a) {
    var id = _a.id, onHidePopup = _a.onHidePopup;
    var model = queryCache.PersonProfilePopupResponses.update1(null, { UserId: id }), url = entrypoints.PersonProfilePopup({ Id: id }), request = ajax.Url(url).Get(), user = s_js_1.default(function () { return model.PCUser() && PCUserViewModel(model.PCUser()); });
    request.done(function (data) {
        queryCache.PersonProfilePopupResponses.update1(request.Date, data);
    });
    return {
        UserId: id,
        Model: model,
        User: user,
        HidePopup: onHidePopup
    };
    function PCUserViewModel(user) {
        var showMoreNumbers = s_js_1.default.data(false), mainNumber = s_js_1.default(function () { return user.MainPhoneNumber() && phoneNumberModel(user.MainPhoneNumber(), function () { }); }), otherNumbers = s_js_1.default(function () { return user.OtherPhoneNumbers().map(function (p) { return phoneNumberModel(p, function () { }); }); });
        return {
            Model: user,
            MainNumber: mainNumber,
            OtherNumbers: otherNumbers,
            ShowMoreNumbers: showMoreNumbers,
            ToggleMoreNumbers: ToggleMoreNumbers
        };
        function ToggleMoreNumbers() {
            showMoreNumbers(!showMoreNumbers());
        }
    }
}
exports.PersonProfilePopup = PersonProfilePopup;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumber = void 0;
var autoSave_1 = __webpack_require__(31);
function PhoneNumber(ajax, phoneNumber, onDeleted) {
    var client = ajax.Url(function () { return phoneNumber.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(phoneNumber, client);
    return {
        Model: draft,
        Delete: Delete
    };
    function Delete() {
        var req = client.Delete();
        req.then(function () {
            return onDeleted(req.Date);
        });
    }
}
exports.PhoneNumber = PhoneNumber;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PierGroupFootmarks = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var zipMap_1 = __webpack_require__(301);
var Measurement_1 = __webpack_require__(11);
var model_1 = __webpack_require__(151);
var LENGTH_CONVERSIONS = [{
        uom: UOM_1.default.Foot,
        decimalPlaces: 0
    }, {
        uom: UOM_1.default.Meter,
        decimalPlaces: 1
    }];
function PierGroupFootmarks(data, _a) {
    var req = _a.req, pierLengthUOM = _a.pierLengthUOM, displayUOM = _a.displayUOM;
    var viewModelsToBerthReqs = new WeakMap(), lastBerthReq = function () { return req.Berths().length > 0 ? req.Berths()[req.Berths().length - 1] : undefined; }, Berths = zipMap_1.zipMap(req.Berths, 
    // Remove last berth and align w/ right edge of original Berths array. Has the effect of pairing
    // each berth with the previous berth.
    { arr: function () { return req.Berths().slice(0, req.Berths().length - 1); }, align: 'right' }, function (berthReq, prevReq) {
        var vm = BerthFootmarks(berthReq, prevReq, lastBerthReq, data, displayUOM);
        viewModelsToBerthReqs.set(vm, berthReq);
        return vm;
    }), uom = function () { var _a; return (_a = pierLengthUOM()) !== null && _a !== void 0 ? _a : UOM_1.default.Foot; };
    var pgLength = new Measurement_1.Measurement();
    pgLength.Num = (function (val) {
        if (val === undefined) {
            // When getting value, add up new berth lengths
            var totalLength = req.Berths().reduce(function (sum, berthReq) { return sum.add(berthReq.Length); }, new Measurement_1.Measurement({ Num: 0, UOM: uom() }));
            return totalLength.Num();
        }
        else {
            // When setting value, set last berth length
            s_js_1.default.sample(function () {
                var allReqs = req.Berths(), lastReq = allReqs[allReqs.length - 1];
                if (lastReq) {
                    var allReqsButLast = allReqs.slice(0, allReqs.length - 1), lengthExcludingLast = allReqsButLast.reduce(function (sum, berthReq) { return sum.add(berthReq.Length); }, new Measurement_1.Measurement({ Num: 0, UOM: uom() }));
                    lastReq.Length.set(new Measurement_1.Measurement({ Num: val, UOM: uom() }).subtract(lengthExcludingLast));
                }
                return val;
            });
        }
    });
    pgLength.UOM = uom;
    return {
        Berths: Berths,
        OnSortBerths: OnSortBerths,
        PierGroupLength: model_1.ToggleableMeasurement({
            backingMeasurement: pgLength,
            uom: displayUOM,
            conversions: LENGTH_CONVERSIONS
        }),
        // By definition, last berth length is valid when there are no berths (edge case).
        LastBerthLengthIsValid: function () { return Berths().length === 0 || Berths()[Berths().length - 1].LengthIsValid(); },
        FootmarksAreValid: function () { return Berths().every(function (b) { return b.LengthIsValid(); }); }
    };
    function OnSortBerths(_moved, berthFootmarkses) {
        s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
            var newBerthReqs = berthFootmarkses.map(function (vm) { return viewModelsToBerthReqs.get(vm); });
            // Keep the overall StartMark for the piergroup fixed when reordering berths.
            // This value will then cascade through the rest of the berths.
            if (newBerthReqs.length && req.Berths().length) {
                newBerthReqs[0].StartMark.set(req.Berths()[0].StartMark);
            }
            req.Berths(newBerthReqs);
        }); });
    }
}
exports.PierGroupFootmarks = PierGroupFootmarks;
function BerthFootmarks(berthReq, prevReq, 
// Can't be undefined b/c as long as we have at least one berth footmarks request, we will
// also have a LAST berth footmarks request.
lastReq, data, displayUOM) {
    // In the UI, we'll present a control for editing StartMark, but we'll actually translate
    // that into an edit to one or more berth Lengths. That way, changes always propagate
    // from one berth's Length to the next berth's StartMark, rather than vice versa. Means
    // that if the user reorders berths, then the Lengths stay fixed and the StartMarks update,
    // which is a nicer UX than keeping the StartMarks fixed and making the Lengths update.
    var startMark = new Measurement_1.Measurement();
    startMark.Num = (function (val) {
        if (val === undefined) {
            return berthReq.StartMark.Num();
        }
        else {
            s_js_1.default.sample(function () { return s_js_1.default.freeze(function () {
                var _a;
                if (!prevReq()) {
                    // For initial berths, make sure to set StartMark here as we won't set it otherwise. For
                    // non-initial berths, COULD set StartMark here, but we already have a separate S
                    // computation that sets this berth's StartMark from the previous berth's StartMark and
                    // Length, so we'll let that handle updating the StartMark.
                    berthReq.StartMark.Num(val);
                }
                // Then, for all berths, find the previous berth, rotating around to the last berth if this is
                // the initial berth....
                var prevWithRotation = (_a = prevReq()) !== null && _a !== void 0 ? _a : lastReq();
                // ...And make sure that previous berth is DIFFERENT from the current berth. That rules out the
                // case where we only have one berth. The logic below would try to increment and decrement that
                // one berth's Length by the same amounts, which would logically be a no-op except that we'd run
                // into S's restriction against setting the same S.value to two different values in the same
                // clock tick...
                if (prevWithRotation !== berthReq) {
                    // ...And if we found a different previous berth, decrement THIS berth's Length by the delta
                    // in StartMark values and increment the previous berth's Length by the same delta. The
                    // effect is that editing one StartMark value doesn't change any other StartMark values or
                    // the overall piergroup length, it just redistributes the piergroup length among the various
                    // berths in the piergroup.
                    // NOTE: We're reading the same StartMark.Num signal that we may have set above (for initial
                    // berths only). That's OK. We'll read the old value here, as we're in a big S.freeze block,
                    // so the new value won't have taken effect yet.
                    var delta = new Measurement_1.Measurement({ Num: val - berthReq.StartMark.Num(), UOM: berthReq.StartMark.UOM() });
                    berthReq.Length.set(berthReq.Length.subtract(delta));
                    prevWithRotation.Length.set(prevWithRotation.Length.add(delta));
                }
                return val;
            }); });
        }
    });
    // Don't try to support changing UOM.
    startMark.UOM = function () { return berthReq.StartMark.UOM(); };
    // Set this request's StartMark base on previous request's StartMark and Length
    s_js_1.default(function () {
        var prev = prevReq();
        if (prev) {
            var newStartMark_1 = prev.StartMark.add(prev.Length);
            s_js_1.default(function () {
                // Hmm... Measurement.prototype.set samples the passed-in Measurement's Num and
                // UOM, otherwise it'd be perfect here. Maybe worth revising .set not to sample,
                // so calling code can call directly if it doesn't want to sample or wrap the call
                // in S.sample(...) if it does?
                berthReq.StartMark.Num(newStartMark_1.Num());
                berthReq.StartMark.UOM(newStartMark_1.UOM());
            });
        }
    });
    return {
        Berth: data.Berths.update1(null, { Id: berthReq.Id() }),
        StartMark: model_1.ToggleableMeasurement({
            backingMeasurement: startMark,
            uom: displayUOM,
            conversions: LENGTH_CONVERSIONS
        }),
        Length: model_1.ToggleableMeasurement({
            backingMeasurement: new Measurement_1.ImmutableMeasurement({
                Num: function () { return berthReq.Length.Num(); },
                UOM: function () { return berthReq.Length.UOM(); }
            }),
            uom: displayUOM,
            conversions: LENGTH_CONVERSIONS
        }),
        // Just need lengths to be nonnegative. Zero we accept as a workaround for the fact
        // that we currently don't allow deleting berths (still need to figure out what the
        // implications for existing PortCalls would be).
        LengthIsValid: function () { return berthReq.Length.Num() >= 0; },
        // By definition, PrevLength is valid when there's no previous request.
        PrevLengthIsValid: function () { var _a, _b; return ((_b = (_a = prevReq()) === null || _a === void 0 ? void 0 : _a.Length.Num()) !== null && _b !== void 0 ? _b : 0) >= 0; }
    };
}


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallLogUpdater = void 0;
// TH: This replaces the old PortCallProfile_LogRefreshRate Web.config setting.
// There was no reason that setting needed to be in Web.config, and this makes the LogUpdater more self-contained.
// TODO: May wanna make this a parameter to the LogUpdater. Really whether to poll and how often depends on parent context.
var LOG_REFRESH_SECONDS = 20;
// Utility for auto-updating the portcalllog component.
// Construct LogUpdater in your parent view and pass it into the portcalllog component.
// NOTE: Important -- please dispose the LogUpdater from your parent view. The portcalllog component does NOT dispose the LogUpdater automatically.
// Rule of thumb - whichever component constructs the LogUpdater should also dispose it.
function PortCallLogUpdater(entrypoints, data, logUpdaterModel, _a) {
    var portcall = _a.portcall;
    return logUpdaterModel({
        collection: data.LogEvents,
        url: function (_a) {
            var NeedSince = _a.NeedSince;
            return entrypoints.ViewLogEvents({ Id: portcall.Id(), NeedSince: NeedSince });
        },
        refreshSeconds: LOG_REFRESH_SECONDS
    });
}
exports.PortCallLogUpdater = PortCallLogUpdater;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallLog = void 0;
function PortCallLog(newCommentModel, eventLogModel, _a) {
    var portcall = _a.portcall;
    var EventLog = eventLogModel({
        log: portcall.Log,
        canComment: function () { return true; }
    }), NewComment = newCommentModel({
        url: function () { var _a, _b; return (_b = (_a = portcall.Self()) === null || _a === void 0 ? void 0 : _a.CommentsUrl()) !== null && _b !== void 0 ? _b : ''; },
    });
    return { EventLog: EventLog, NewComment: NewComment };
}
exports.PortCallLog = PortCallLog;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallLogView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var newcommentview_1 = __webpack_require__(194);
var view_1 = __webpack_require__(268);
exports.PortCallLogView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "portcalllog" },
        React.createElement("div", { className: "pc-card log-post-section" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("span", { className: "pc-card-title" }, "Log")),
            React.createElement("div", { className: "log-description" },
                React.createElement("span", { className: "pc-text-tinylabel" }, "Record and track this PortCall's history and events.")),
            React.createElement(newcommentview_1.NewCommentView, { model: model.NewComment, topLevel: true })),
        React.createElement(view_1.EventLogView, { model: model.EventLog }));
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallProfileCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PortCallProfile_1 = __webpack_require__(1326);
var PortCallReport_1 = __webpack_require__(1327);
var PortCallProfileCache = /** @class */ (function (_super) {
    __extends(PortCallProfileCache, _super);
    function PortCallProfileCache(data) {
        var _this = _super.call(this) || this;
        _this.PortCallProfileResponses = PCCache_1.PCCollection(PortCallProfile_1.PortCallProfileResponse);
        _this.PortCallProfileTopicCards = PCCache_1.PCCollection(PortCallProfile_1.PortCallProfileTopicCard);
        _this.PortCallReports = PCCache_1.PCCollection(PortCallReport_1.PortCallReport);
        new DataCache_1.QueryResultsRelationship(_this.PortCallProfileResponses, _this.PortCallProfileTopicCards, function (r) { return r.TopicCards; });
        new DataCache_1.SharedKeyRelationship(_this.PortCallProfileResponses, data.PortCalls, function (q) { return q.PortCall; }, null);
        new DataCache_1.SharedKeyRelationship(_this.PortCallProfileTopicCards, data.TopicCards, function (c) { return c.Card; }, null);
        new DataCache_1.QueryResultRelationship(_this.PortCallReports, data.PortCalls, function (pc) { return pc.CurrentPC; });
        return _this;
    }
    return PortCallProfileCache;
}(DataCache_1.DataCache));
exports.PortCallProfileCache = PortCallProfileCache;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallReport = void 0;
var s_js_1 = __webpack_require__(0);
var UOM_1 = __webpack_require__(25);
var MeasurementInFeetAndInches_1 = __webpack_require__(134);
var tzmoment_1 = __webpack_require__(9);
var BerthReservation_1 = __webpack_require__(38);
var ItineraryPoint_1 = __webpack_require__(69);
function PortCallReport(ajax, entrypoints, cache, _a) {
    var _this = this;
    var pc = _a.pc, hideActionsMenu = _a.hideActionsMenu;
    var url = function () { return entrypoints.ViewPortCallReport({ PortCallId: pc.Id() }); }, client = ajax.Url(url), displayedPortCall = s_js_1.default.value(null), showReportUnavailableMsg = s_js_1.default.value(false), loading = s_js_1.default.value(false);
    // For doing dev on UI/styling. I found this useful since otherwise this component's UI is
    // only rendered while the print dialog is open. To use:
    //
    // 1) Set a breakpoint on the statement after this one.
    // 2) Open the PortCall profile.
    // 3) Your breakpoint will be hit. When that happens, run the following in your browser's dev
    //    console:
    //
    //    attachDevTools()
    //
    // 4) Continue from your breakpoint. Now, as long as that PortCall is there, you can run the
    //    following commands in your browser's dev console:
    //
    //    PortCallReportDevTools.ShowPrintView()
    //    PortCallReportDevTools.HidePrintView()
    //
    // 5) You may also find it helpful to emulate @media print. Instructions for how to do this
    //    in Chrome at https://stackoverflow.com/a/29962072. Summary:
    //       - Open dev tools
    //       - Open hamburger menu in top right corner (tooltip reads "Customize and control DevTools")
    //       - Go to More tools > Rendering
    //       - Find "Emulate CSS media" option (near bottom) and select "print"
    var attachDevTools = function () {
        window.PortCallReportDevTools = {
            ShowPrintView: function () { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = displayedPortCall;
                        return [4 /*yield*/, LoadPortCallReport()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            }); }); },
            HidePrintView: function () { return displayedPortCall(null); }
        };
    };
    return {
        DisplayedPortCall: s_js_1.default(function () {
            return displayedPortCall() &&
                PortCallReportViewModel(displayedPortCall().CurrentPC());
        }),
        ShowReportUnavailableMsg: showReportUnavailableMsg,
        Loading: loading,
        LinkAvailable: LinkAvailable,
        PrintOrder: PrintOrder
    };
    function LinkAvailable() {
        // 08/23/2021 -- Could become available once we have an Actual Departure.
        // if (pc && pc.ActiveReservations) console.log(pc.HasDeparted);
        return pc.Id() > 0;
    }
    function PrintOrder() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (loading())
                            return [2 /*return*/];
                        loading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = displayedPortCall;
                        return [4 /*yield*/, LoadPortCallReport()];
                    case 2:
                        _a.apply(void 0, [_b.sent()]);
                        try {
                            window.print();
                        }
                        finally {
                            displayedPortCall(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        s_js_1.default.freeze(function () {
                            loading(false);
                            hideActionsMenu();
                        });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    // NOTE: Tim originally tried using a CachedModelLoader here instead of this function.
    // Using this function instead so we can implement custom error handling logic based on
    // the response status. CachedModelLoader doesn't currently expose the error response
    // (well, unless you check ajax.LastResponse, but that makes it hard to know you've got the
    // right response).
    function LoadPortCallReport() {
        return __awaiter(this, void 0, void 0, function () {
            var req, orderData, ex_1, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = client.Get();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        orderData = _a.sent();
                        return [2 /*return*/, cache.PortCallReports.update1(req.Date, orderData)];
                    case 3:
                        ex_1 = _a.sent();
                        resp = req.Response();
                        // 404 signals that we couldn't find the original order data for this PortCall.
                        // That most likely means the PortCall predates our version tables. Show an
                        // appropriate error message.
                        if (resp && resp.Status === 404) {
                            showReportUnavailableMsg(true);
                        }
                        throw ex_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
exports.PortCallReport = PortCallReport;
function PortCallReportViewModel(pc) {
    var lengthUOM = function () { return pc.Port() && pc.Port().PierLengthUOM() || UOM_1.default.Foot; }, itinerary = pc.Itinerary.sort(ItineraryPoint_1.ItineraryPoint.EstimatedOrder), itineraryPoints = s_js_1.default(function () {
        var _itinerary = itinerary();
        return _itinerary.slice(0, -1).map(function (_, index) {
            var ip1 = _itinerary[index];
            var ip2 = _itinerary[index + 1];
            return ItineraryViewModel(ip1, ip2);
        });
    }), port = function () { return pc.Port() && pc.Port().Name(); }, 
    // 1d. Times (for each reservation)
    // 1di. First Arrival (aka Pilot Boarding) (Est. vs Act. [vs Eff.])
    // 1dii. InPort Arrival (aka First Line) (Est. vs Act. [vs Eff.])
    // 1diii. Departure (aka Last Line) (Est. vs Act. [vs Eff.])
    // 6. PJOs present (don't think we can get more than that?)
    pjos = pc.JobOrders().length, 
    // pjos = true,
    // 7. PortCall Id
    pcId = function () { return pc.Id(); };
    return {
        Model: pc,
        LengthDisplay: lengthDisplay(pc.VesselLength, lengthUOM),
        Vessel: s_js_1.default(function () { return pc.Vessel() && PortCallVesselViewModel(pc.Vessel(), lengthUOM); }),
        itinerary: itinerary,
        ItineraryPoints: itineraryPoints,
        Port: port,
        PJOs: pjos,
        PCId: pcId
    };
}
function PortCallVesselViewModel(vessel, lengthUOM) {
    return {
        Model: vessel,
        BeamDisplay: lengthDisplay(vessel.Beam, lengthUOM),
        GrossTonnageDisplay: function () { return vessel.GrossTonnage.toString({ units: false }); }
    };
}
function ItineraryViewModel(ip1, ip2) {
    var key = ip1.Id(), portArrivalIP = ip1.IsPortArrival() ? ip1 : null, portDepartureIP = ip1.IsPortDeparture() ? ip1 : null, berthReservationIP = ip1.IsPortArrival() || ip1.IsPortDeparture() ? null : ip1, isSameDayReservation = berthReservationIP && (tzmoment_1.tzmoment(berthReservationIP.Arrival.Estimated()).format('MMM D, YYYY') === tzmoment_1.tzmoment(berthReservationIP.Departure.Estimated()).format('MMM D, YYYY')) ? true : false, isSameDayTransit = ip1 && (tzmoment_1.tzmoment(ip1.Departure.Estimated()).format('MMM D, YYYY') === tzmoment_1.tzmoment(ip2.Arrival.Estimated()).format('MMM D, YYYY')), referenceReservation = function () { return ip1.BerthReservation(); };
    return {
        Key: key,
        PortArrival: portArrivalIP,
        PortDeparture: portDepartureIP,
        BerthRes: berthReservationIP,
        FirstLineEst: ip1.Arrival.Estimated,
        FirstLineAct: ip1.Arrival.Actual,
        LastLineEst: ip1.Departure.Estimated,
        LastLineAct: ip1.Departure.Actual,
        isSameDayReservation: isSameDayReservation,
        IsSameDayTransit: isSameDayTransit,
        Reservation: s_js_1.default(function () { return referenceReservation() && BerthReservationViewModel(referenceReservation()); })
    };
}
function BerthReservationViewModel(reservation) {
    return {
        // Rounding behavior intended to match the FootmarkAssignments widget
        FootmarkNum: function () { return Math.round(reservation.Footmark.Num()); },
        EndmarkNum: function () { return Math.round(reservation.EndMark.Num()); },
        SideToText: function () {
            return reservation.SideTo() === BerthReservation_1.VesselSide.Starboard ? 'Starboard' :
                reservation.SideTo() === BerthReservation_1.VesselSide.Port ? 'Port' :
                    BerthReservation_1.VesselSideDisplayName[reservation.SideTo()];
        },
        Cargo: function () { return reservation.CargoActivities(); },
        Cruise: function () { return reservation.CruiseActivities(); }
    };
}
function lengthDisplay(m, uom) {
    return function () { return uom() === UOM_1.default.Foot ?
        new MeasurementInFeetAndInches_1.MeasurementInFeetAndInches(m, 0)
            .toString({ unitsStyle: 'abbrev', padInchesLeft: false }) :
        m.convert(UOM_1.default.Meter).roundToNPlaces(0).toString(); };
}


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallReportView = exports.PrintPortCallReportLink = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(22);
exports.PrintPortCallReportLink = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.LinkAvailable() ?
        React.createElement("div", { className: "action-item" },
            React.createElement("div", null, m.Loading() ?
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { }) }, "Printing...") :
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.PrintOrder) }, "Print PortCall Report")),
            React.createElement("div", { className: "pc-action-item-descr" }, "Print a report for this portcall.")) :
        null;
});
exports.PortCallReportView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement(ReportUnavailablePopup, { model: m }),
        React.createElement(PortCallReportPrintView, { model: m }));
});
var ReportUnavailablePopup = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.PCModal, { shown: m.ShowReportUnavailableMsg, className: "portcall-report-unavailable", onBackDropClick: function () { return m === null || m === void 0 ? void 0 : m.ShowReportUnavailableMsg(false); } },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", null, "Sorry, the receipt you requested is not available for this portcall."),
            React.createElement("div", { className: "controls" },
                React.createElement("button", { className: "pc-button", onClick: function () { return m.ShowReportUnavailableMsg(false); } }, "OK"))));
});
var PortCallReportPrintView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var portcallReport = m.DisplayedPortCall();
    if (!portcallReport)
        return null;
    return (React.createElement("div", { className: "portcall-report" },
        React.createElement(PrintViewTitle, { portcall: portcallReport }),
        React.createElement(PrintViewSubtitle, { portcall: portcallReport }),
        React.createElement(PortCallReportSubmission, { portcall: portcallReport }),
        React.createElement(PortCallReportVessel, { portcall: portcallReport }),
        React.createElement(PortCallReportReservations, { portcall: portcallReport }),
        React.createElement(PortCallReportAgentAndBilling, { portcall: portcallReport })));
});
var PrintViewTitle = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("h1", { className: "portcall-report-title" },
        "PortCall Report \u2014",
        ' ',
        p.Model.DisplayVesselIdentifier(),
        '   ',
        React.createElement("span", { className: "portcall-report-title-date" },
            "(PC ",
            p.PCId(),
            ")"));
});
var PrintViewSubtitle = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("h4", { className: "portcall-report-subtitle" }, p.Port());
});
var PortCallReportSubmission = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    var requestor = p.Model.Requestor(), requestingOrg = requestor && requestor.Organization(), reservations = p.Model.Reservations(), requestDate = reservations.length ? reservations[0].RequestDate() : null;
    return (React.createElement("div", { className: "portcall-report-submission" },
        React.createElement("div", null,
            "Submitted by:",
            ' ',
            requestor && requestor.FullName(),
            ', ',
            requestingOrg && requestingOrg.Name()),
        React.createElement("div", null,
            "Date submitted:",
            ' ',
            React.createElement("span", { className: "submitted-date" }, requestDate && tzmoment_1.tzmoment(requestDate).format('DD MMM YYYY')))));
});
var PortCallReportVessel = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    var v = p.Vessel();
    return (React.createElement("div", { className: "portcall-report-section portcall-report-vessel" },
        React.createElement("h2", { className: "portcall-report-section-header" }, p.Model.DisplayVesselIdentifier()),
        React.createElement("div", { className: "portcall-report-section-body" },
            React.createElement("div", { className: "vessel-details" },
                React.createElement("div", { className: "details-left-col" },
                    React.createElement(LengthOverall, { portcall: p }),
                    React.createElement(Beam, { vessel: v }),
                    React.createElement(GrossTonnage, { vessel: v }),
                    React.createElement(Flag, { vessel: v }),
                    React.createElement(VesselType, { vessel: v })),
                React.createElement("div", { className: "details-right-col" },
                    React.createElement(IMO, { vessel: v }),
                    React.createElement(MMSID, { vessel: v }),
                    React.createElement(CallSign, { vessel: v }),
                    React.createElement(LastPort, { portcall: p }),
                    React.createElement(NextPort, { portcall: p }))))));
});
var LengthOverall = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Length Overall:"),
        React.createElement("span", { className: "vessel-section-item-value" }, p.LengthDisplay()));
});
var Beam = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Beam:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.BeamDisplay()));
});
var GrossTonnage = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Gross Tonnage:"),
        React.createElement("span", { className: "vessel-section-item-value" },
            v && v.GrossTonnageDisplay(),
            " grt"));
});
var Flag = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Flag:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.Flag() && v.Model.Flag().Name()));
});
var VesselType = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Vessel Type:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.VesselType()),
        v && v.Model.IsCruiseVessel() &&
            React.createElement("span", { className: "vessel-section-item-label" }, "This is a PortCall specific cruise ship."));
});
var IMO = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "IMO:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.IMO()));
});
var MMSID = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "MMSID:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.MMSID()));
});
var CallSign = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Call Sign:"),
        React.createElement("span", { className: "vessel-section-item-value" }, v && v.Model.CallSign()));
});
var LastPort = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Last Port:"),
        React.createElement("span", { className: "vessel-section-item-value" }, p.Model.LastPortOfCall()));
});
var NextPort = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("div", { className: "vessel-section-item" },
        React.createElement("span", { className: "vessel-section-item-label" }, "Next Port:"),
        React.createElement("span", { className: "vessel-section-item-value" }, p.Model.NextPortOfCall()));
});
var PortCallReportReservations = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("div", { className: "portcall-report-section portcall-report-reservations" },
        React.createElement("h2", { className: "portcall-report-section-header" }, "Reservations"),
        React.createElement("div", { className: "portcall-report-section-body" }, p.ItineraryPoints().map(function (ip) {
            return React.createElement(ItineraryView, { portcall: p, itineraryPoint: ip, key: ip.Key });
        })));
});
var ItineraryView = supercritical_1.default(function (_a) {
    var p = _a.portcall, ip = _a.itineraryPoint;
    var bRes = ip.BerthRes;
    return (React.createElement("div", { className: "portcall-report-itinerary" },
        ip.PortArrival &&
            React.createElement("div", { className: "itinerary-container" },
                React.createElement("div", { className: "itinerary-date-full" },
                    React.createElement("div", { className: "itinerary-date" }, tzmoment_1.tzmoment(ip.PortArrival.Departure.Estimated()).format('MMM D, YYYY'))),
                React.createElement("div", { className: "itinerary-time-container itinerary-col-headers" },
                    React.createElement("div", { className: "itinerary-time" }, "EST"),
                    React.createElement("div", { className: "itinerary-time" }, "ACT")),
                React.createElement("div", { className: "itinerary-details" }),
                React.createElement("div", { className: "itinerary-time-container" },
                    React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.PortArrival.Departure.Estimated()).format('HH:mm')),
                    ip.PortArrival.Departure.Actual() &&
                        React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.PortArrival.Departure.Actual()).format('HH:mm'))),
                React.createElement("div", { className: "itinerary-details" },
                    React.createElement("div", { className: "itinerary-location" },
                        React.createElement("div", { className: "itinerary-location-item" },
                            React.createElement("span", { className: "itinerary-location-first-arrival" }, "Area Arrival (Pilot Station)"))))),
        bRes && // Berth Res
            React.createElement("div", { className: "itinerary-container" },
                !ip.IsSameDayTransit &&
                    React.createElement("div", { className: "itinerary-date-full" },
                        React.createElement("div", { className: "itinerary-date" }, tzmoment_1.tzmoment(ip.FirstLineEst()).format('MMM D, YYYY'))),
                React.createElement("div", { className: "itinerary-time-container" },
                    React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.FirstLineEst()).format('HH:mm')),
                    ip.FirstLineAct() &&
                        React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.FirstLineAct()).format('HH:mm'))),
                React.createElement("div", { className: "itinerary-details" },
                    React.createElement("div", { className: "itinerary-location" },
                        React.createElement("div", { className: "itinerary-location-item" },
                            React.createElement("span", { className: "itinerary-location-item-label" }, "Arrival"),
                            React.createElement("span", { className: "itinerary-location-item-value" }, bRes && bRes.Location() && bRes.Location().Name()))),
                    React.createElement(BerthReservationView, { berthReservation: ip.Reservation() })),
                !ip.isSameDayReservation &&
                    React.createElement("div", { className: "itinerary-date-full" },
                        React.createElement("div", { className: "itinerary-date" }, tzmoment_1.tzmoment(ip.LastLineEst()).format('MMM D, YYYY'))),
                React.createElement("div", { className: "itinerary-time-container" },
                    React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.LastLineEst()).format('HH:mm')),
                    ip.LastLineAct() &&
                        React.createElement("div", { className: "itinerary-time" }, tzmoment_1.tzmoment(ip.LastLineAct()).format('HH:mm'))),
                React.createElement("div", { className: "itinerary-details" },
                    React.createElement("div", { className: "itinerary-location" },
                        React.createElement("div", { className: "itinerary-location-item" },
                            React.createElement("span", { className: "itinerary-location-item-label" }, "Departure")))))));
});
var BerthReservationView = supercritical_1.default(function (_a) {
    var berthRes = _a.berthReservation;
    var res = berthRes;
    return (React.createElement("div", { className: "res-details" },
        React.createElement("div", { className: "res-details-item" },
            React.createElement("span", { className: "res-details-item-label" }, "Side to:"),
            React.createElement("span", { className: "res-details-item-value" }, res && res.SideToText())),
        React.createElement("div", { className: "res-details-item" },
            React.createElement("span", { className: "res-details-item-label" }, "Footmarks:"),
            React.createElement("span", { className: "res-details-item-value" }, (res && res.FootmarkNum()) + " - " + (res && res.EndmarkNum()))),
        res && res.Cargo().length == 0 && res.Cruise().length == 0 &&
            React.createElement("div", { className: "res-details-item" },
                React.createElement("span", { className: "res-details-item-label" }, "Lay (no ops listed)")),
        res && res.Cargo().length > 0 &&
            React.createElement("div", { className: "res-details-inport-ops inport-ops-labels" },
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-activity" },
                    React.createElement("span", { className: "res-details-item-label" }, "Activity")),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cargo" },
                    React.createElement("span", { className: "res-details-item-label" }, "Cargo")),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-quantity" },
                    React.createElement("span", { className: "res-details-item-label" }, "Quantity"))),
        res && res.Cargo().map(function (c) {
            var _a, _b, _c;
            return React.createElement("div", { className: "res-details-inport-ops", key: c.Id() },
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-activity" },
                    React.createElement("span", { className: "res-details-item-value" }, (_a = c.ActivityType()) === null || _a === void 0 ? void 0 :
                        _a.Name(),
                        c.TradeRoute() && ' (' + ((_b = c.TradeRoute()) === null || _b === void 0 ? void 0 : _b.Name()) + ')')),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cargo" },
                    React.createElement("span", { className: "res-details-item-value" }, (_c = c.CargoCategory()) === null || _c === void 0 ? void 0 : _c.Name())),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-quantity" },
                    React.createElement("span", { className: "res-details-item-value" }, c.Quantity.Num() + ' ' + c.Quantity.UOM())));
        }),
        res && res.Cruise().length > 0 &&
            React.createElement("div", { className: "res-details-inport-ops inport-ops-labels" },
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-label" }, "Voyage #")),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-label" }, "Disembark")),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-label" }, "Embark")),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-label" }, "In-Transit"))),
        res && res.Cruise().map(function (c) {
            return React.createElement("div", { className: "res-details-inport-ops", key: c.Id() },
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-value" }, c.VoyageNumber())),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-value" }, c.Disembark())),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-value" }, c.Embark())),
                React.createElement("div", { className: "res-details-inport-ops-col inport-ops-cruise" },
                    React.createElement("span", { className: "res-details-item-value" }, c.InTransit())));
        })));
});
var PortCallReportAgentAndBilling = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    return React.createElement("div", { className: "portcall-report-section portcall-report-agent-jobs" },
        React.createElement("h2", { className: "portcall-report-section-header" },
            React.createElement("span", { className: "agent-header" }, "Agent")),
        React.createElement("div", { className: "portcall-report-section-body" },
            React.createElement(AgentView, { portcall: p })));
});
var AgentView = supercritical_1.default(function (_a) {
    var p = _a.portcall;
    var agent = p.Model.Agent();
    return (React.createElement("div", { className: "agent" }, agent &&
        React.createElement("div", null,
            React.createElement("div", { className: "agent-name" }, agent.FullName()),
            React.createElement("div", { className: "agent-contact-info" },
                React.createElement("div", null, agent.Organization() && agent.Organization().Name()),
                React.createElement("div", { className: "agent-email" }, agent.User() && agent.User().Email()),
                React.createElement("div", null, agent.MainPhoneNumber() && agent.MainPhoneNumber().Number())))));
});
// const JobOrdersEtc = SuperCritical(({ portcall: p} : { portcall : PortCallReportViewModel }) => {
//     const pjos = p.PJOs;
//     return (
//         <div className="jobs-etc">
//             {pjos > 0 &&
//                 <div>
//                    {pjos} Pilot Job Order{pjos > 0 ? 's ' : ' '}present
//                 </div>
//             }
//             {pjo &&
//                 <div>
//                     <BillToAddress pjo={pjo} />
//                     <ServicesView pjo={pjo} />
//                 </div>
//             }
//         </div>
//     );
// });
// const BillToAddress = SuperCritical(({ pjo } : { pjo : PortCallReportViewModel }) => {
//     const billToAddr = pjo.Model.BillToAddress();
//     return billToAddr ?
//         <div className="bill-to-address">
//             {pjo.Model.BillToAddress() || ''}
//         </div> :
//         null
// });
// const ServicesView = SuperCritical(({ pjo } : { pjo : PortCallReportViewModel }) =>
//     <div className="services">
//         <div className="services-item">
//             <span className="services-item-label">Tug:</span>
//             {/* <span className="services-item-value">{pjo.Model.TugCompany() && pjo.Model.TugCompany()!.Name()}</span> */}
//         </div>
//         <div className="services-item">
//             <span className="services-item-label">Tug #:</span>
//             {/* <span className="services-item-value">{pjo.Model.NumberOfTugs()}</span> */}
//         </div>
//         <div className="services-item">
//             <span className="services-item-label">Lines:</span>
//             {/* <span className="services-item-value">{pjo.Model.LineHandlingCompany() && pjo.Model.LineHandlingCompany()!.Name()}</span> */}
//         </div>
//         <div className="services-item">
//             <span className="services-item-label">Labor:</span>
//             {/* <span className="services-item-value">{pjo.Model.LaborStartTime() && tzmoment(pjo.Model.LaborStartTime()!).format("MMM D, YYYY [at] HH:mm")}</span> */}
//         </div>
//     </div>
// );
// const RemarksView = SuperCritical(({ portcall: p} : { portcall : PortCallReportViewModel }) =>
// Below the Agent info
//     <div className="remarks">
//         <span className="remarks-label">Remarks:</span>
//         <span className="remarks-value">
//             Remarks section just so I know.
//             {/* {p.TypicalPilotJobOrder() && p.TypicalPilotJobOrder()!.Model.Remarks()} */}
//         </span>
//     </div>
// );


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallProfileRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var model_1 = __webpack_require__(276);
var view_1 = __webpack_require__(1145);
var view_2 = __webpack_require__(12);
var TAB_PARAM_VESSEL = 'vessel', TAB_PARAM_PEOPLE = 'people', TAB_PARAM_LOG = 'log';
var PortCallProfileRoute = function (model, appwrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appwrapper, navbarTab: 0 /* Berths */ },
            React.createElement(view_1.PortCallProfileView, { model: m })),
        reflectState: function () { return new componentLocation_1.Location(request.name, outboundParams(m)); }
    };
};
exports.PortCallProfileRoute = PortCallProfileRoute;
function inboundParams(request) {
    return new model_1.PortCallProfileParams(+(request.params["id"] || 0), parseTab(request.params["tab"]));
}
function outboundParams(model) {
    var p = {};
    p["id"] = "" + model.Id();
    var s = model.TabStrip.State();
    // Update query string on the LEADING edge of any flip animation.
    if (s.state === 'settled-on-back') {
        p["tab"] = serializeTab(s.tab);
    }
    else if (s.state === 'flipping-to-back') {
        p["tab"] = serializeTab(s.toTab);
    }
    return p;
}
function parseTab(tabParam) {
    if (tabParam === TAB_PARAM_VESSEL)
        return model_1.TabVessel;
    else if (tabParam === TAB_PARAM_PEOPLE)
        return model_1.TabPeople;
    else if (tabParam === TAB_PARAM_LOG)
        return model_1.TabLog;
    else
        return undefined;
}
function serializeTab(tab) {
    if (tab === model_1.TabVessel)
        return TAB_PARAM_VESSEL;
    else if (tab === model_1.TabPeople)
        return TAB_PARAM_PEOPLE;
    else if (tab === model_1.TabLog)
        return TAB_PARAM_LOG;
    else
        return undefined;
}


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallProfileView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(276);
var view_1 = __webpack_require__(54);
var Rights_1 = __webpack_require__(118);
var TopicCardStatus_1 = __webpack_require__(137);
var view_2 = __webpack_require__(78);
var view_3 = __webpack_require__(1140);
var view_4 = __webpack_require__(528);
var view_5 = __webpack_require__(40);
var view_6 = __webpack_require__(29);
var view_7 = __webpack_require__(60);
var view_8 = __webpack_require__(152);
var view_9 = __webpack_require__(519);
var view_10 = __webpack_require__(35);
var view_11 = __webpack_require__(22);
var portcallheaderview_1 = __webpack_require__(537);
var view_12 = __webpack_require__(68);
var view_13 = __webpack_require__(530);
var view_14 = __webpack_require__(548);
var view_15 = __webpack_require__(154);
var view_16 = __webpack_require__(89);
var summaryCardView_1 = __webpack_require__(1215);
var view_17 = __webpack_require__(88);
var view_18 = __webpack_require__(546);
var view_19 = __webpack_require__(197);
var portcallreportview_1 = __webpack_require__(1143);
var ItineraryTabContents = supercritical_1.default(function (_a) {
    var model = _a.model;
    return (React.createElement("div", { className: "pcprofile-tab-contents itinerary-tab-contents" },
        React.createElement(view_17.PortCallScheduleView, { model: model.Schedule })));
});
var PeopleTabContents = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "pcprofile-tab-contents people-tab-contents" },
        React.createElement("div", { className: "back-tab-header" },
            React.createElement("i", { className: "back-tab-header-icon fa fa-group" }),
            React.createElement("span", { className: "back-tab-title" }, "People")),
        React.createElement("div", null,
            React.createElement("div", { className: "agent-section" },
                React.createElement("div", { className: "title" }, "Attending Agent"),
                React.createElement("div", null,
                    React.createElement(view_15.UserSelectorView, { model: model.People.AgentSelector, className: "agent-typeahead", disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0 }))),
            (model.Rights() & Rights_1.PortCallRights.Edit) === 0 ? null :
                React.createElement("div", { className: "add-editors-section" },
                    React.createElement("div", { className: "title" }, "Editors"),
                    React.createElement("div", null,
                        React.createElement(view_15.UserSelectorView, { className: "editors-typeahead", placeholder: "Invite Editor...", model: model.People.InvitedEditorSelector }),
                        " ",
                        React.createElement("button", { type: "button", className: "pc-button", onClick: function () { return model.People.InviteEditor(); } }, "add")))),
        [{ editors: model.People.AgencyEditors, title: 'Agency', showDelete: false },
            { editors: model.People.SchedulingAuthorityEditors, title: 'Scheduling Authority', showDelete: false },
            { editors: model.People.InvitedEditors, title: 'Invited Editors', showDelete: true }].map(function (e) {
            return React.createElement("div", { className: "section", key: e.title },
                React.createElement("div", { className: "title" }, e.title),
                React.createElement("div", { className: "spacer" }),
                React.createElement("ul", null, e.editors().map(function (p) {
                    return React.createElement("li", { className: "people-column", key: p.Id() },
                        React.createElement("img", { className: "thumb-img", src: p.Image.ThumbUrl() }),
                        React.createElement("div", { className: "person" },
                            React.createElement("a", { href: "", className: "pc-text-fixedwidth person-name", onClick: eventWrappers_1.noDefault(function () { return p.ToggleProfile(); }) }, p.Name()),
                            React.createElement("div", { className: "pc-text-smalllabel pc-text-fixedwidth person-org" }, p.Organization() ? p.Organization().Name() : '')),
                        !e.showDelete || (model.Rights() & Rights_1.PortCallRights.Edit) === 0 ? null : React.createElement("a", { href: "", className: "delete-btn pc-close-icon", onClick: eventWrappers_1.noDefault(function () { return p.DeleteInvitedEditorShare(); }) }),
                        React.createElement(view_2.PersonProfilePopupView, { modelContainer: p.ProfilePopup, boundingContainer: ".face.flipped", boundingPadding: 40 }));
                })));
        }));
});
var VesselTabContents = supercritical_1.default(function (_a) {
    var model = _a.model;
    var pc = model.PortCall, v = model.Vessel(), dos = v && v.DOS;
    return (React.createElement("div", { className: "pcprofile-tab-contents vessel-tab-contents" },
        React.createElement("div", { className: "back-tab-header" },
            React.createElement("i", { className: "back-tab-header-icon icon-ship" }),
            React.createElement("span", { className: "back-tab-title" }, "Vessel")),
        React.createElement("div", { className: "vessel-details" },
            React.createElement("div", { className: "vessel-actions" },
                React.createElement("div", { hidden: (model.Rights() & Rights_1.PortCallRights.Edit) === 0 },
                    React.createElement(view_4.LocalVesselSearchView, { model: model.VesselSearch }),
                    React.createElement("div", { className: "addl-links" },
                        React.createElement("div", { className: "addl-right" },
                            React.createElement("div", { hidden: (model.DomainRights() & Rights_1.DomainRights.AddVessel) === 0 },
                                React.createElement("span", { className: "pc-text-smalllabel" }, "Can't find the right vessel? "),
                                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return model.ShowExternalVesselSearchModal(true); }) }, "Add it."),
                                React.createElement("div", { className: "reservation-options-spacing" })),
                            v === null && React.createElement("span", { className: "pc-text-smalllabel" }, "Not the correct size? "),
                            v === null && React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function (e) { return model.ReserveByLengthModal.Show(true); }) }, "Edit the length."))))),
            React.createElement("div", { className: "vessel-info" },
                React.createElement("div", { className: "particulars" },
                    React.createElement("span", { className: "particulars-title" }, "Vessel Particulars")),
                React.createElement("div", { className: "name" },
                    React.createElement("span", { className: "value" }, pc.DisplayVesselIdentifier())),
                React.createElement("div", { className: "air-draft" },
                    React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Air Draft"),
                    React.createElement(view_8.ToggleableMeasurementView, { model: pc.ToggleableAirDraft, disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0 })),
                React.createElement("div", { className: "gross-tonnage" },
                    React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Gross Tonnage"),
                    React.createElement("span", { className: "pc-text-smalltext value" }, v && v.GrossTonnage.Num())),
                React.createElement("div", { className: "length" },
                    React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Length Overall"),
                    React.createElement("span", { className: "pc-text-smalltext value" }, v
                        ? React.createElement(view_8.ToggleableMeasurementView, { model: v.ToggleableLength, textonly: true })
                        : React.createElement(view_8.ToggleableMeasurementView, { model: pc.ToggleableVesselLength, textonly: true }))),
                React.createElement("div", { className: "beam" },
                    React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Beam"),
                    React.createElement("span", { className: "pc-text-smalltext value" }, v ? React.createElement(view_8.ToggleableMeasurementView, { model: v.ToggleableBeam, textonly: true }) : null)),
                React.createElement("div", { className: "deep-draft" },
                    React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Deep Draft"),
                    React.createElement(view_8.ToggleableMeasurementView, { model: pc.ToggleableDeepDraft, disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0 })),
                React.createElement("div", { className: "identifiers" },
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "IMO"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.IMO())),
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "MMSID"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.MMSID())),
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Call Sign"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.CallSign())),
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "VIN"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.VIN())),
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Vessel Type"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.VesselType())),
                    React.createElement("div", { className: "identifier-row" },
                        React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Flag"),
                        React.createElement("span", { className: "identifier-value pc-text-smalltext pc-text-fixedwidth" }, v && v.Flag() && v.Flag().Name()))),
                React.createElement("div", { className: "uomselector uom" },
                    React.createElement(view_16.ToggleButton, { checked: model.ToggleableUomIsFeet, onLabel: "Feet", offLabel: "Meters" })))),
        React.createElement("div", { className: "ports-and-dos" }, dos ? React.createElement("div", { className: "dos" },
            React.createElement("span", { className: "particulars-title" }, "Declaration of Security"),
            React.createElement("span", { className: "pc-text-tinylabel dos-desc" }, "Issued to validate the vessel."),
            React.createElement("div", { className: "dos-details" },
                React.createElement("div", { className: "dos-row" },
                    React.createElement("div", { className: "pc-text-smalllabel dos-label" }, "Effective"),
                    React.createElement(view_7.NullableDatePicker, { value: dos.EffectiveDate, disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0, localization: model.LocalizationContext })),
                React.createElement("div", { className: "dos-row" },
                    React.createElement("div", { className: "pc-text-smalllabel dos-label" }, "Expires"),
                    React.createElement(view_7.NullableDatePicker, { value: dos.ExpirationDate, disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0, localization: model.LocalizationContext })),
                React.createElement("div", { className: "dos-row" },
                    React.createElement("div", { className: "pc-text-smalllabel dos-label" }, "Issued by"),
                    React.createElement("input", { type: "text", className: "issuer", value: dos.IssuedBy() || '', disabled: (model.Rights() & Rights_1.PortCallRights.Edit) === 0, onChange: function (e) { return dos.IssuedBy(e.currentTarget.value); } })))) : null)));
});
var LogTabContents = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "pcprofile-tab-contents log-tab-contents" },
        React.createElement(view_3.PortCallLogView, { model: model.PortCallLog }));
});
var DeletePortCallModal = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement(view_11.PCModal, { className: "deleteportcall", shown: model.Show, onBackDropClick: function () { return model === null || model === void 0 ? void 0 : model.Show(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" },
                React.createElement("h2", { className: "modal-title" }, "Delete Port Call"),
                !model.ActionSuccess()
                    ? React.createElement("div", null,
                        React.createElement(view_5.ActionLoadingIndicator, { loading: function () { return !!model.Action() && !model.ActionSuccess(); } }),
                        React.createElement("div", null, "Are you sure you want to delete this PortCall?"),
                        React.createElement("div", { className: "action-btns" },
                            React.createElement("button", { className: "close pc-modal-close close-btn", onClick: function () { return model.Show(false); } }, "Cancel"),
                            React.createElement("button", { type: "button", className: "pc-button", onClick: model.Delete }, "Delete")))
                    : React.createElement("div", null,
                        React.createElement("div", { className: "confirmation-message" }, "This PortCall was successfully deleted."),
                        React.createElement("div", null,
                            React.createElement("button", { type: "button", className: "pc-button", onClick: model.DoneDeleting }, "OK"))))));
});
var CancelPortCallModal = supercritical_1.default(function (_a) {
    var _b;
    var model = _a.model;
    return React.createElement(view_11.PCModal, { className: "cancelportcall", shown: model.Show, onBackDropClick: function () { return model === null || model === void 0 ? void 0 : model.Show(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body clearfix" },
                React.createElement("h2", { className: "modal-title" }, "Cancel PortCall"),
                !model.Success() ?
                    React.createElement("div", null,
                        React.createElement(view_5.ActionLoadingIndicator, { loading: model.Working }),
                        React.createElement("div", null, "Are you sure you want to cancel this PortCall?"),
                        React.createElement("div", { className: "remarks-shell" },
                            React.createElement("textarea", { className: "remarks", value: (_b = model.Req.Remarks()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return model.Req.Remarks(e.currentTarget.value || null); }, placeholder: "These remarks will be sent to editors on this PortCall.", rows: 3 })),
                        React.createElement("div", { className: "action-btns" },
                            React.createElement("button", { className: "close pc-modal-close close-btn", onClick: function () { return model.Show(false); } }, "Close"),
                            React.createElement("button", { type: "button", className: "pc-button", onClick: model.Cancel }, "Cancel"))) :
                    React.createElement("div", null,
                        React.createElement("div", { className: "confirmation-message" }, "This PortCall was successfully cancelled."),
                        React.createElement("div", null,
                            React.createElement("button", { type: "button", className: "pc-button", onClick: function () { return model.Show(false); } }, "OK"))))));
});
var ReserveByLengthModal = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement(view_11.PCModal, { className: "reservebylength-modal", shown: model.Show, onBackDropClick: function () { return model === null || model === void 0 ? void 0 : model.Show(false); } },
        React.createElement("div", { className: "reserve-berth-modal modal-content pc-card pc-card-pcprofile profile-body clearfix" },
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Edit the Vessel Length"),
            React.createElement("div", { className: "modal-body details" },
                React.createElement("div", { className: "vessel-details" },
                    React.createElement("div", { className: "pc-text-smalllabel manual-description" }, "Enter the approximate length."),
                    React.createElement("div", { className: "vessel-info reserve-by-length" },
                        React.createElement("div", { className: "particulars" },
                            React.createElement("span", { className: "particulars-title" }, "Vessel Particulars ")),
                        React.createElement("div", { className: "name" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Name ")),
                        React.createElement("div", { className: "air-draft" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Air Draft "),
                            React.createElement(view_8.ToggleableMeasurementView, { model: model.ToggleableAirDraft })),
                        React.createElement("div", { className: "gross-tonnage" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Gross Tonnage ")),
                        React.createElement("div", { className: "length" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Length Overall "),
                            React.createElement(view_8.ToggleableMeasurementView, { model: model.ToggleableNewVesselLength })),
                        React.createElement("div", { className: "beam" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Beam "),
                            React.createElement("br", null)),
                        React.createElement("div", { className: "deep-draft" },
                            React.createElement("span", { className: "pc-text-smalllabel lbl" }, "Deep Draft "),
                            React.createElement(view_8.ToggleableMeasurementView, { model: model.ToggleableDeepDraft })),
                        React.createElement("div", { className: "identifiers" },
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "IMO")),
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "MMSID")),
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Call Sign")),
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "VIN")),
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Vessel Type")),
                            React.createElement("div", { className: "identifier-row" },
                                React.createElement("span", { className: "identifier-lbl pc-text-smalllabel" }, "Flag"))),
                        React.createElement("div", { className: "uomselector uom" },
                            React.createElement(view_16.ToggleButton, { onLabel: "Feet", offLabel: "Meters", checked: model.NewVesselIsFeet })))),
                React.createElement("div", { className: "buttons" },
                    React.createElement("a", { href: "", className: "cancel-link", onClick: eventWrappers_1.noDefault(function () { return model.Show(false); }) }, "Cancel Changes "),
                    React.createElement("input", { type: "button", className: "pc-button", value: "Change Length", onClick: model.SaveLength })))));
});
var ExternalVesselSearchModal = supercritical_1.default(function (_a) {
    var model = _a.model;
    var m = model();
    return (React.createElement(view_11.PCModal, { className: "servicevesselsearch-modal", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
        React.createElement("div", { className: "service-vessel-search-modal modal-content pc-card pc-card-pcprofile profile-body clearfix" },
            React.createElement("div", { className: "pc-card-header-button" }, m && React.createElement("a", { className: "cancel-vessel-search", onClick: m.Cancel }, "Cancel")),
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Add a Vessel"),
            React.createElement("div", { className: "modal-body details" }, m && React.createElement(view_13.NewVesselView, { model: m.NewVessel })),
            React.createElement("div", { className: "save-button" }, (m === null || m === void 0 ? void 0 : m.ShowSave()) ?
                React.createElement("button", { type: "button", className: "pc-button", onClick: m.Save, disabled: !m.NewVessel.CanSave() }, "Save") :
                null))));
});
var IssuesModal = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement(view_11.PCModal, { shown: model.Show, onBackDropClick: function () { return model === null || model === void 0 ? void 0 : model.Show(false); } },
        React.createElement("div", { className: "modal-content pc-card pc-card-pcprofile" },
            React.createElement("div", { className: "pc-card-header-button" },
                React.createElement("a", { className: "cancel-vessel-search", href: "", onClick: eventWrappers_1.noDefault(function () { return model.Show(false); }) }, "Close")),
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Conflicts"),
            React.createElement("div", { className: "modal-body" }, model.Issues().map(function (issue) {
                return React.createElement(view_12.IssueDescription, { key: issue.Id(), issue: issue });
            }))));
});
var ManageCoordinationsModal = supercritical_1.default(function (_a) {
    var model = _a.model;
    var m = model();
    return (React.createElement(view_11.PCModal, { className: "manage-coordinations-modal", shown: function () { return !!m; }, onBackDropClick: m === null || m === void 0 ? void 0 : m.Cancel },
        React.createElement("div", { className: "modal-content pc-card pc-card-pcprofile" },
            React.createElement("div", { className: "pc-card-header-button" }, m && React.createElement("a", { className: "close-modal", href: "", onClick: eventWrappers_1.noDefault(m.Cancel) }, "Close")),
            React.createElement("div", { className: "pc-card-header pc-card-title" }, "Manage Coordinations"),
            m &&
                React.createElement("div", { className: "modal-body" },
                    React.createElement("div", { className: "select-coordinations-shell" },
                        React.createElement(view_18.SelectCoordinationsView, { model: m.SelectCoordinations })),
                    React.createElement("div", { className: "submit-button-shell" },
                        React.createElement("button", { className: "pc-button submit-button", onClick: eventWrappers_1.noDefault(m.Submit), disabled: !m.CanSubmit() }, "Update")),
                    m.Submitting() && React.createElement("div", { className: "manage-coordinations-loading-indicator" })))));
});
var PortsOfCall = supercritical_1.default(function (_a) {
    var _b, _c;
    var m = _a.model;
    return React.createElement("div", { className: "pc-card pc-card-pcprofile ports-of-call" },
        React.createElement("div", { className: "pc-card-title light-card-title" }, "Last/Next Port of Call"),
        React.createElement("div", { className: "ports-details" },
            React.createElement("div", { className: "port-of-call" },
                React.createElement("label", { className: "port-of-call-label" }, "Last Port"),
                React.createElement("input", { className: "port-of-call-input", placeholder: "Port of Call", value: (_b = m.PortCall.LastPortOfCall()) !== null && _b !== void 0 ? _b : '', onChange: function (e) { return m.PortCall.LastPortOfCall(e.currentTarget.value); }, disabled: (m.Rights() & Rights_1.PortCallRights.Edit) === 0 })),
            React.createElement("div", { className: "port-of-call" },
                React.createElement("label", { className: "port-of-call-label" }, "Next Port"),
                React.createElement("input", { className: "port-of-call-input", placeholder: "Port of Call", value: (_c = m.PortCall.NextPortOfCall()) !== null && _c !== void 0 ? _c : '', onChange: function (e) { return m.PortCall.NextPortOfCall(e.currentTarget.value); }, disabled: (m.Rights() & Rights_1.PortCallRights.Edit) === 0 }))));
});
var TopicCardsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card pc-card-pcprofile topic-cards-container" },
        React.createElement("div", { className: "pc-card-title light-card-title" }, "Topic Cards"),
        React.createElement("div", { className: "pc-text-tinylabel" }, "Read through these cards and answer them accordingly."),
        React.createElement("div", null,
            React.createElement("div", { className: "card-count-container answered" },
                React.createElement("div", { className: "card-count" }, m.TopicCardModels().length),
                React.createElement("div", { className: "card-count-label" }, "Answered")),
            React.createElement("div", { className: "card-count-container confirmed" },
                React.createElement("div", { className: "card-count" }, m.TopicCardModels().filter(function (c) { return c.Model.Status() === TopicCardStatus_1.TopicCardStatus.Confirmed; }).length),
                React.createElement("div", { className: "card-count-label" }, "Confirmed")),
            React.createElement("div", { className: "card-count-container denied" },
                React.createElement("div", { className: "card-count" }, m.TopicCardModels().filter(function (c) { return c.Model.Status() === TopicCardStatus_1.TopicCardStatus.Denied; }).length),
                React.createElement("div", { className: "card-count-label" }, "Denied"))),
        React.createElement("div", { className: "card-page-link-container" },
            React.createElement("a", { href: "#!topiccards?id=" + m.PortCall.Id() },
                "View all (",
                m.TopicCardModels().length + m.ApplicableTopicCardTemplatesCount(),
                ")")),
        React.createElement("div", { className: "card-list" }, m.TopicCardModels().map(function (c) {
            return React.createElement(view_14.TopicCardListItemView, { model: c.ListItem, key: c.Model.Id(), onClick: c.GoToCard });
        })));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var model = _a.model;
    return model.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_10.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return model.ShowActionsMenu(false); } },
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: model.BerthTimelineUrl() }, "View on Berths")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "View this PortCall on the Berths Timeline.")),
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(model.People.WatchPortCall) }, model.People.IsWatching() ? 'Stop Watching PortCall' : 'Watch this PortCall')),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Receive notifications and emails on this PortCall's status and changes.")),
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return window.print(); }) }, "Print Itinerary")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Print off the PortCall Itinerary as it appears on this page.")),
                React.createElement(portcallreportview_1.PrintPortCallReportLink, { model: model.PortCallReport }),
                React.createElement("div", { className: "action-item", hidden: (model.Rights() & Rights_1.PortCallRights.Cancel) === 0 || model.PortCall.Cancelled() },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function (e) { return model.CancelPortCallModal.Show(true); }) }, "Cancel PortCall")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Remove this PortCall and all associated reservations from the schedule. This will remain on your profile as canceled.")),
                React.createElement("div", { className: "pc-admin-separator pc-card-admin-title", hidden: (model.Rights() & Rights_1.PortCallRights.Delete) === 0 && (model.Rights() & Rights_1.PortCallRights.EditUnlistedOverride) === 0 },
                    React.createElement("span", null, "Admin"),
                    React.createElement("div", { className: "pc-admin-line" })),
                React.createElement("div", { className: "action-item", hidden: (model.Rights() & Rights_1.PortCallRights.Delete) === 0 },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return model.DeletePortCallModal.Show(true); }) }, "Delete PortCall")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Permanently remove this PortCall and all associated reservations from the system. This cannot be undone.")),
                React.createElement("div", { className: "action-item", hidden: (model.Rights() & Rights_1.PortCallRights.EditUnlistedOverride) === 0 },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(model.PortCall.ToggleUnlistedOverride) }, model.PortCall.Unlisted() ? 'List PortCall' : 'Unlist PortCall')),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Unlisted PortCalls have limited visibility across the site.")))) : null;
});
// Keep in sync w/ permissions etc. checks in TabStripActionsMenu below.
function HasAnyTabStripActions(m) {
    return (m.Rights() & Rights_1.PortCallRights.Edit) !== 0;
}
var TabStripActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowTabStripActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_10.PCDismissible, { className: "pc-actions-menu pc-card tab-strip-actions-menu", onDismiss: function () { return m.ShowTabStripActionsMenu(false); } }, (m.Rights() & Rights_1.PortCallRights.Edit) !== 0 &&
                React.createElement("div", { className: "action-item" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.TabStripMenuAction(function () { return m.ShowManageCoordinationsModal(true); })) }, "Manage Coordinations")))) :
        null;
});
var PortCallProfileTabContentsController = /** @class */ (function (_super) {
    __extends(PortCallProfileTabContentsController, _super);
    function PortCallProfileTabContentsController(model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        return _this;
    }
    PortCallProfileTabContentsController.prototype.renderTabContents = function (tab) {
        if (tab === model_1.TabItinerary)
            return React.createElement(ItineraryTabContents, { model: this.model });
        else if (tab === model_1.TabVessel)
            return React.createElement(VesselTabContents, { model: this.model });
        else if (tab === model_1.TabPeople)
            return React.createElement(PeopleTabContents, { model: this.model });
        else if (tab === model_1.TabLog)
            return React.createElement(LogTabContents, { model: this.model });
        else
            throw new Error("Unknown tab with title '" + tab.Title + "'");
    };
    return PortCallProfileTabContentsController;
}(view_19.TitledTabContentsController));
exports.PortCallProfileView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: cx("portcall-profile pc-page-fixedwidth", {
            "allow-full-page-take-over": model.ShowPortCallReport()
        }) },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", onClick: eventWrappers_1.noDefault(model.GoBack) }, "<< Back"),
            React.createElement(view_1.ActionsMenuButton, { onClick: model.ToggleActionsMenu }),
            React.createElement(ActionsMenu, { model: model })),
        React.createElement(portcallheaderview_1.PortCallHeaderView, { portcall: model.PortCall, canEdit: function () { return (model.Rights() & Rights_1.PortCallRights.Edit) !== 0; }, issues: model.AllIssues, onIssueBadgeClick: function () { return model.IssuesModal.Show(true); } }),
        React.createElement("div", { className: "page-columns" },
            React.createElement("div", { className: "left-column" },
                React.createElement(view_19.PCTabStripView, { model: model.TabStrip, ctrl: new view_19.TitledTabStripViewController(), extraContents: function () {
                        return HasAnyTabStripActions(model) ?
                            React.createElement("span", { className: "tab-strip-actions-shell" },
                                React.createElement("a", { href: "", className: "fa fa-bars tab-strip-actions-menu-btn", onClick: eventWrappers_1.noDefault(model.ToggleTabStripActionsMenu) }),
                                React.createElement(TabStripActionsMenu, { model: model })) :
                            null;
                    } }),
                React.createElement(view_19.PCTabContents, { model: model.TabStrip, ctrl: new PortCallProfileTabContentsController(model) })),
            React.createElement("div", { className: "right-column" },
                React.createElement(summaryCardView_1.WartsilaEnrichmentsSummaryCardView, { model: model.WartsilaEnrichments, extraClassName: "pc-card-pcprofile" }),
                React.createElement(PortsOfCall, { model: model }),
                React.createElement(TopicCardsView, { model: model }))),
        React.createElement(IssuesModal, { model: model.IssuesModal }),
        React.createElement(DeletePortCallModal, { model: model.DeletePortCallModal }),
        React.createElement(CancelPortCallModal, { model: model.CancelPortCallModal }),
        React.createElement(ReserveByLengthModal, { model: model.ReserveByLengthModal }),
        React.createElement(ExternalVesselSearchModal, { model: model.ExternalVesselSearchModal }),
        React.createElement(ManageCoordinationsModal, { model: model.ManageCoordinationsModal }),
        React.createElement(view_9.DateTimeEditPopupView, { modelContainer: model.PilotTimeEditPopup, localization: model.LocalizationContext }),
        React.createElement(portcallreportview_1.PortCallReportView, { model: model.PortCallReport }),
        React.createElement(view_6.ErrorModal, { errors: model.AgentRestrictions, shown: model.ShowAgentRestrictions, title: "There are issues with your PortCall" }));
});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallScheduleCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PortCallScheduleResponse_1 = __webpack_require__(1328);
var PCCache_1 = __webpack_require__(17);
var PortCallScheduleCache = /** @class */ (function (_super) {
    __extends(PortCallScheduleCache, _super);
    function PortCallScheduleCache(data) {
        var _this = _super.call(this) || this;
        _this.PortCallScheduleResponses = PCCache_1.PCCollection(PortCallScheduleResponse_1.PortCallScheduleResponse);
        new DataCache_1.SharedKeyRelationship(_this.PortCallScheduleResponses, data.PortCalls, function (r) { return r.PortCall; }, null);
        return _this;
    }
    return PortCallScheduleCache;
}(DataCache_1.DataCache));
exports.PortCallScheduleCache = PortCallScheduleCache;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallScheduleHeader = void 0;
var s_array_1 = __webpack_require__(3);
function PortCallScheduleHeader(tzutils, _a) {
    var PortCall = _a.PortCall;
    var milestones = s_array_1.lift(function () { return PortCall.MilestoneDates(); })
        .map(ScheduleHeaderMilestoneDate);
    return {
        TZUtils: tzutils,
        PortCall: PortCall,
        FirstMilestone: function () { return milestones().length ? milestones()[0] : null; },
        LastMilestone: function () { return milestones().length ? milestones()[milestones().length - 1] : null; }
    };
}
exports.PortCallScheduleHeader = PortCallScheduleHeader;
function ScheduleHeaderMilestoneDate(Date) {
    return { Date: Date };
}


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalAddress = void 0;
var autoSave_1 = __webpack_require__(31);
function PostalAddress(ajax, postalAddress, deleteFn) {
    var client = ajax.Url(function () { return postalAddress.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(postalAddress, client);
    return {
        Model: draft,
        Delete: Delete,
        CanDelete: !!deleteFn
    };
    function Delete() {
        if (deleteFn) {
            var req_1 = client.Delete();
            req_1.then(function () {
                return deleteFn(req_1.Date);
            });
        }
    }
}
exports.PostalAddress = PostalAddress;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PastExports = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var callAll_1 = __webpack_require__(165);
var debounceSignal_1 = __webpack_require__(81);
var TZDate_1 = __webpack_require__(7);
var Currency_1 = __webpack_require__(164);
var diacriticals_1 = __webpack_require__(42);
var downloadData_1 = __webpack_require__(260);
var BillCoverageType_1 = __webpack_require__(1236);
var ExportPayload_1 = __webpack_require__(607);
var Charge_1 = __webpack_require__(108);
var model_1 = __webpack_require__(129);
var exportgrouplist_1 = __webpack_require__(133);
var FilterStorageKey = 'portcall.billing.pastexports.filter';
function PastExports(loader, ajax, entrypoints, cache, domain, dateRangeSelectorModel, exportGroupListModel, _a) {
    var id = _a.id, _expansionMode = _a.expansionMode, range = _a.range, from = _a.from, to = _a.to, _filter = _a.filter;
    var dateRangeSelector = dateRangeSelectorModel({ range: range, from: from, to: to }), key = function () { return ({
        Id: id,
        From: dateRangeSelector.FromDate().toJSON(),
        To: dateRangeSelector.ToDate().toJSON()
    }); }, load = s_js_1.default(function () { return loader(key()); }), model = function () { return load().model; }, loading = function () { return load().loading(); }, billingSystem = cache.BillingSystems.update1(null, { Id: id }), filter = s_js_1.default.data(_filter || localStorage[FilterStorageKey] || ''), debouncedFilter = debounceSignal_1.debounceSignal(filter), pageAction = s_js_1.default.data(0 /* View */), showActionsMenu = s_js_1.default.data(false), showConfirmExport = s_js_1.default.data(false), expansionMode = s_js_1.default.data(_expansionMode), billExportGroups = s_array_1.lift(function () { return model().Bills(); })
        .map(function (b) { return BillExportGroup(expansionMode, b); }), exportGroups = billExportGroups.map(function (g) { return g.ExportGroup; }), filteredExportGroups = exportGroups
        .filter(function (g) { return diacriticals_1.CaseInsensitiveContains(exportgrouplist_1.FilterData(g), debouncedFilter()); }), exportGroupList = exportGroupListModel({
        BillingSystem: billingSystem,
        ExportGroups: filteredExportGroups,
        ShowGroupSelectors: function () { return pageAction() === 1 /* SelectForExport */; }
    }), rowSelector = model_1.RowSelector(filteredExportGroups, function (g) { return g.SelectedForExport; }), rowExpander = model_1.RowExpander(expansionMode, exportGroups, filteredExportGroups, function (g) { return g.Expanded; }), exportConfirmationPopup = s_js_1.default.on(showConfirmExport, function () { return showConfirmExport() ? ExportConfirmationPopup(ajax, entrypoints, domain, billingSystem, billExportGroups(), function () { return pageAction(0 /* View */); }, function () { return showConfirmExport(false); }) : null; });
    s_js_1.default.on(callAll_1.callAll(debouncedFilter, pageAction), function () { return exportGroups().forEach(function (g) { return g.SelectedForExport(false); }); }, null, true);
    return {
        Model: model,
        Loading: loading,
        DateRangeSelector: dateRangeSelector,
        Filter: filter,
        PageAction: pageAction,
        RowExpander: rowExpander,
        ExportGroupList: exportGroupList,
        ShowActionsMenu: showActionsMenu,
        ShowConfirmExport: showConfirmExport,
        ExportConfirmationPopup: exportConfirmationPopup,
        RowSelector: rowSelector,
        MenuAction: function (action) { return function () { return s_js_1.default.freeze(function () {
            showActionsMenu(false);
            action();
        }); }; }
    };
}
exports.PastExports = PastExports;
function BillExportGroup(expansionMode, bill) {
    var vessel = s_js_1.default(function () {
        var b = bill.Bill();
        if (!b)
            return null;
        var pjos = b.Coverage()
            .filter(function (c) { return c.Type() === BillCoverageType_1.BillCoverageType.JobOrder && c.JobOrder() && c.JobOrder().PilotJobOrder(); })
            .map(function (c) { return c.JobOrder().PilotJobOrder(); });
        // TH 05/11/2017 -- We'll assume that if a Bill has any PJOs, then they all have the same vessel
        return pjos.length ? pjos[0].EffectiveVessel() : null;
    });
    return {
        Bill: bill,
        ExportGroup: {
            InvoiceNumber: function () { return bill.Bill() ? bill.Bill().InvoiceNumber() : ''; },
            VesselName: function () { return vessel() && vessel().Name(); },
            QBCustomerId: function () { return bill.Bill() && bill.Bill().QBTracking.Customer() || ''; },
            InvoiceDate: function () { return bill.Bill() && bill.Bill().InvoiceDate(); },
            ExportDate: bill.LastExportDate,
            UniqueKey: function () { return '' + bill.Id(); },
            Charges: s_array_1.lift(function () { return bill.Bill() ? bill.Bill().Items() : []; }),
            SelectedForExport: s_js_1.default.data(false),
            Expanded: s_js_1.default.data(s_js_1.default.sample(expansionMode) === 1 /* AutoExpand */)
        }
    };
}
function ExportConfirmationPopup(ajax, entrypoints, domain, billingSystem, billExportGroups, onExportFinished, onCancel) {
    var selectedBillGroups = billExportGroups.filter(function (g) { return g.ExportGroup.SelectedForExport(); }), allCharges = selectedBillGroups.reduce(function (charges, b) {
        return charges.concat(b.ExportGroup.Charges());
    }, []), exportTotal = Charge_1.TotalPriceForCharges(s_array_1.lift(function () { return allCharges; }), function () { return billingSystem.Currency() || Currency_1.default.USD; }, exportgrouplist_1.PRICE_PRECISION), exportClient = ajax.Url(function () { return entrypoints.QuickBooksReexport({ Id: billingSystem.Id() }); }), sendingExportRequest = s_js_1.default.data(false), exportFinishedStatus = s_js_1.default.data(null);
    return {
        NumberOfInvoices: selectedBillGroups.length,
        ExportTotal: exportTotal,
        Cancel: onCancel,
        SendExportRequest: SendExportRequest,
        SendingExportRequest: sendingExportRequest,
        ExportFinishedStatus: exportFinishedStatus,
        SupportHref: function () { return 'mailto:' + domain.SupportEmail(); }
    };
    function SendExportRequest() {
        return __awaiter(this, void 0, void 0, function () {
            var req, resp_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (sendingExportRequest())
                            return [2 /*return*/];
                        sendingExportRequest(true);
                        req = exportClient.Post({
                            BillIds: selectedBillGroups.map(function (g) { return g.Bill.Id(); })
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        resp_1 = _a.sent();
                        s_js_1.default.freeze(function () {
                            if (resp_1.Payload.Status === ExportPayload_1.ExportPayloadStatus.Formatted) {
                                var dataUri = "data:text/plain;charset=utf-8," + encodeURIComponent(resp_1.Payload.RawExport);
                                downloadData_1.downloadDataUri(dataUri, 'invoices.iif');
                                exportFinishedStatus({ success: true });
                            }
                            else {
                                // TH 05/11/2017 -- As for exports of new invoices, we'll handle the possibility that
                                // formatting might fail.
                                exportFinishedStatus({
                                    success: false,
                                    errorDetails: resp_1.Payload.ErrorMessage || 'Unexpected export error.'
                                });
                            }
                            // TH 05/11/2017 -- Update our LastExportDate.
                            // As for exports of new invoices, we won't cache the ExportPayload itself.
                            if (resp_1.NewExportDate !== null)
                                selectedBillGroups.forEach(function (g) { return g.Bill.LastExportDate(new TZDate_1.default(resp_1.NewExportDate)); });
                            onExportFinished();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        sendingExportRequest(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PastExportsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PastExportsResponse_1 = __webpack_require__(1304);
var PastExportsCache = /** @class */ (function (_super) {
    __extends(PastExportsCache, _super);
    function PastExportsCache(data) {
        var _this = _super.call(this) || this;
        _this.PastExportsResponses = PCCache_1.PCCollection(PastExportsResponse_1.PastExportsResponse);
        _this.PastExportsBills = PCCache_1.PCCollection(PastExportsResponse_1.PastExportsBill);
        new DataCache_1.OneToOneRelationship(_this.PastExportsResponses, data.BillingSystems, function (r) { return r.BillingSystem; }, null, function (r) { return r.Id(); });
        new DataCache_1.QueryResultsRelationship(_this.PastExportsResponses, _this.PastExportsBills, function (r) { return r.Bills; });
        new DataCache_1.SharedKeyRelationship(_this.PastExportsBills, data.Bills, function (b) { return b.Bill; }, null);
        return _this;
    }
    return PastExportsCache;
}(DataCache_1.DataCache));
exports.PastExportsCache = PastExportsCache;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PastExportsRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(87);
var routeParams_2 = __webpack_require__(77);
var pastexportsview_1 = __webpack_require__(1152);
var view_1 = __webpack_require__(12);
function PastExportsRoute(model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(pastexportsview_1.PastExportsView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.PastExportsRoute = PastExportsRoute;
function inboundParams(request, tzutils) {
    var id = +(request.params['id'] || 0), range = request.params['range'], from = request.params['from'], to = request.params['to'], expansionMode = request.params['expansion'], filter = request.params['filter'];
    return {
        id: id,
        range: range !== undefined ? routeParams_1.parseDateRange(range) : 3 /* ThisMonth */,
        from: from !== undefined ? routeParams_2.parseDate(from, tzutils) : undefined,
        to: to !== undefined ? routeParams_2.parseDate(to, tzutils) : undefined,
        expansionMode: expansionMode !== undefined ? +expansionMode : 0 /* AutoCollapse */,
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = m.Model().Id() + '';
    routeParams_1.outboundDateRangeParams(m.DateRangeSelector, params, 3 /* ThisMonth */, { range: 'range', from: 'from', to: 'to' });
    if (m.RowExpander.ExpansionMode() !== 0 /* AutoCollapse */)
        params['expansion'] = m.RowExpander.ExpansionMode() + '';
    if (m.Filter())
        params['filter'] = m.Filter();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PastExportsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var exportgrouplist_1 = __webpack_require__(133);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(54);
var view_3 = __webpack_require__(128);
var view_4 = __webpack_require__(106);
var exportgrouplistview_1 = __webpack_require__(540);
var exportselectioncontrols_1 = __webpack_require__(541);
var exporttoquickbookslink_1 = __webpack_require__(542);
var view_5 = __webpack_require__(35);
var view_6 = __webpack_require__(22);
exports.PastExportsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pastexports pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { href: "", className: "pc-back-link", onClick: eventWrappers_1.noDefault(function () { return window.history.back(); }) }, "<< Back"),
            React.createElement(view_2.ActionsMenuButton, { onClick: function () { return m.ShowActionsMenu(!m.ShowActionsMenu()); } }),
            React.createElement(ActionsContainer, { model: m })),
        React.createElement("div", { className: "pc-page-title" }, "Pilot Billing"),
        React.createElement(exportselectioncontrols_1.ExportSelectionControls, { model: m }),
        React.createElement(FilterControls, { model: m }),
        React.createElement(view_1.PageLoadingIndicator, { loading: m.Loading }),
        React.createElement(exportgrouplistview_1.ExportGroupListView, { model: m.ExportGroupList }),
        React.createElement(ExportConfirmationPopupView, { model: m }));
});
var ActionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
        React.createElement(view_5.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement(view_4.ExpandCollapseLink, { model: m.RowExpander, actionWrapper: m.MenuAction })),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Collapse all of the items for a compressed view.")),
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement(exporttoquickbookslink_1.ExportToQuickBooksLink, { model: m })),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Export the following items to QuickBooks."))));
});
var FilterControls = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "filter-controls" },
        React.createElement("span", { className: "subtitle" }, "Past Exports"),
        React.createElement("a", { className: "exports-nav-toggle-link", href: "#!pendingexports?id=" + m.Model().Id() + "&expansionMode=" + m.RowExpander.ExpansionMode() + "&filter=" + m.Filter() }, "Show Pending Exports"),
        React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter by \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }),
        React.createElement(view_3.DateRangeSelectorView, { model: m.DateRangeSelector }));
});
var ExportConfirmationPopupView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var popup = m.ExportConfirmationPopup();
    return (React.createElement(view_6.PCModal, { className: "export-confirmation-popup", shown: function () { return !!popup; } },
        React.createElement("div", { className: "export-confirmation-popup-content" },
            React.createElement("div", { className: "export-confirmation-header" }, "QuickBooks Export"),
            popup && (popup.ExportFinishedStatus() ?
                React.createElement(ExportConfirmationPostexportView, { model: m, popup: popup, finishedStatus: popup.ExportFinishedStatus() }) :
                React.createElement(ExportConfirmationPreexportView, { model: m, popup: popup })))));
});
var ExportConfirmationPreexportView = supercritical_1.default(function (_a) {
    var popup = _a.popup, m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "export-confirmation-body" },
            React.createElement("div", { className: "pc-text-smalllabel" }, "Export invoice data to a QuickBooks IIF file."),
            React.createElement(view_1.ActionLoadingIndicator, { loading: popup.SendingExportRequest }),
            React.createElement("div", { className: "export-setting pc-text-billing-label" },
                React.createElement("span", { className: "export-setting-label" }, "Number of invoices:"),
                React.createElement("span", { className: "export-setting-value" }, popup.NumberOfInvoices)),
            React.createElement("div", { className: "export-setting pc-text-billing-label" },
                React.createElement("span", { className: "export-setting-label" }, "Total value of all invoices:"),
                React.createElement("span", { className: "export-setting-value" }, popup.ExportTotal.toString({ places: exportgrouplist_1.PRICE_PRECISION })))),
        React.createElement("div", { className: "export-confirmation-footer" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(popup.Cancel) }, "No, don't export"),
            React.createElement("button", { className: "pc-button", onClick: popup.SendExportRequest }, "Export")));
});
var ExportConfirmationPostexportView = supercritical_1.default(function (_a) {
    var popup = _a.popup, finishedStatus = _a.finishedStatus, m = _a.model;
    return React.createElement("div", null,
        finishedStatus.success ?
            React.createElement(ExportConfirmationSuccessBody, null) :
            React.createElement(ExportConfirmationUnexpectedErrorBody, { errorDetails: finishedStatus.errorDetails, popup: popup }),
        React.createElement("div", { className: "export-confirmation-footer" },
            React.createElement("button", { className: "pc-button", onClick: popup.Cancel }, "OK")));
});
var ExportConfirmationSuccessBody = supercritical_1.default(function () {
    return React.createElement("div", { className: "export-confirmation-body" }, "Your invoices have been exported successfully. A download should have begun in your browser. Please import the downloaded IIF file into QuickBooks to finish the export. If the download does not begin in a few seconds, please try re-exporting your invoices.");
});
var ExportConfirmationUnexpectedErrorBody = supercritical_1.default(function (_a) {
    var errorDetails = _a.errorDetails, popup = _a.popup;
    return React.createElement("div", { className: "export-confirmation-body" },
        React.createElement("div", { className: "generic-message" },
            "We encountered an unexpected error formatting your QuickBooks IIF file for download. Please try re-exporting your invoices. If this problem persists, please contact",
            ' ',
            React.createElement("a", { href: popup.SupportHref() }, "Support"),
            ". We apologize for the inconvenience."),
        React.createElement("div", { className: "error-details" },
            "Error details:",
            React.createElement("br", null),
            React.createElement("textarea", { value: errorDetails, disabled: true, rows: 6 })));
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingExports = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var callAll_1 = __webpack_require__(165);
var debounceSignal_1 = __webpack_require__(81);
var TZDate_1 = __webpack_require__(7);
var Currency_1 = __webpack_require__(164);
var validationWatcher_1 = __webpack_require__(23);
var groupBy_1 = __webpack_require__(295);
var diacriticals_1 = __webpack_require__(42);
var downloadData_1 = __webpack_require__(260);
var ExportPayload_1 = __webpack_require__(607);
var QuickBooksExportRequest_1 = __webpack_require__(1333);
var Charge_1 = __webpack_require__(108);
var model_1 = __webpack_require__(129);
var exportgrouplist_1 = __webpack_require__(133);
var FilterStorageKey = 'portcall.billing.pendingexports.filter';
function PendingExports(loader, ajax, entrypoints, cache, domain, tzutils, localization, exportGroupListModel, _a) {
    var id = _a.id, _filter = _a.filter, _expansionMode = _a.expansionMode;
    var _b = loader({ Id: id }), model = _b.model, loading = _b.loading, billingSystem = cache.BillingSystems.update1(null, { Id: id }), filter = s_js_1.default.data(_filter || localStorage[FilterStorageKey] || ''), debouncedFilter = debounceSignal_1.debounceSignal(filter), pageAction = s_js_1.default.data(0 /* View */), showActionsMenu = s_js_1.default.data(false), showConfirmExport = s_js_1.default.data(false), expansionMode = s_js_1.default.data(_expansionMode), pjoGroupingKey = function (pjo) {
        var vesselId = pjo.EffectiveVessel() ? pjo.EffectiveVessel().Id() : null;
        // TH 05/05/2017 -- Group on vessel and customer.
        // We expect a null VesselId to be very rare here, although it's possible in theory.
        // We'll count two null VesselId's as matching (as long as customer matches of course).
        // For Customer, we expect the ApprovePilotJobOrderCharges endpoint to validate that
        // it's populated. So we shouldn't really get null or empty here.
        // If we do, treat null and empty string as the same.
        return (vesselId || 0) + "," + (pjo.QBTracking.Customer() || '');
    }, 
    // TH 05/05/2017 -- Group events on Customer only. Ditto PJOs on treatment of null and empty string.
    dispatchEventGroupingKey = function (de) { return de.QBTracking.Customer() || ''; }, exportablePJOs = model.ExportablePilotJobOrders.filter(function (pjo) { return !pjo.Bills().length; }), exportableEvents = model.ExportableDispatchEvents.filter(function (de) { return !de.Bills().length; }), pjoGroups = groupBy_1.groupBy(exportablePJOs, pjoGroupingKey)
        .map(function (grouping) { return PilotJobOrderExportGroup(cache, expansionMode, grouping); }), dispatchEventGroups = groupBy_1.groupBy(exportableEvents, dispatchEventGroupingKey)
        .map(function (grouping) { return DispatchEventExportGroup(expansionMode, grouping); }), exportGroups = pjoGroups.map(function (g) { return g.ExportGroup; })
        .concat(dispatchEventGroups.map(function (g) { return g.ExportGroup; })), filteredExportGroups = exportGroups
        .filter(function (g) { return diacriticals_1.CaseInsensitiveContains(exportgrouplist_1.FilterData(g), debouncedFilter()); }), exportGroupList = exportGroupListModel({
        BillingSystem: billingSystem,
        ExportGroups: filteredExportGroups,
        ShowGroupSelectors: function () { return pageAction() === 1 /* SelectForExport */; }
    }), rowSelector = model_1.RowSelector(filteredExportGroups, function (g) { return g.SelectedForExport; }), rowExpander = model_1.RowExpander(expansionMode, exportGroups, filteredExportGroups, function (g) { return g.Expanded; }), exportConfirmationPopup = s_js_1.default.on(showConfirmExport, function () { return showConfirmExport() ? ExportConfirmationPopup(ajax, entrypoints, cache, domain, tzutils.now(), billingSystem, pjoGroups(), dispatchEventGroups(), function () { return pageAction(0 /* View */); }, function () { return showConfirmExport(false); }) : null; });
    // TH 05/05/2017 -- Deselect all groups on change of filter or of page action.
    s_js_1.default.on(callAll_1.callAll(debouncedFilter, pageAction), function () { return exportGroups().forEach(function (g) { return g.SelectedForExport(false); }); }, null, true);
    return {
        Model: model,
        Loading: loading,
        Filter: filter,
        PageAction: pageAction,
        RowExpander: rowExpander,
        ExportGroupList: exportGroupList,
        ShowActionsMenu: showActionsMenu,
        ShowConfirmExport: showConfirmExport,
        ExportConfirmationPopup: exportConfirmationPopup,
        RowSelector: rowSelector,
        Localization: localization,
        MenuAction: function (action) { return function () { return s_js_1.default.freeze(function () {
            showActionsMenu(false);
            action();
        }); }; }
    };
}
exports.PendingExports = PendingExports;
function PilotJobOrderExportGroup(cache, expansionMode, _a) {
    var key = _a.key, items = _a.items;
    var re = /^(\d+),/, vesselId = +key.match(re)[1], customer = key.replace(re, ''), vessel = cache.Vessels.index(vesselId), sortedItems = items.orderBy(function (pjo) { return pjo.Start.Effective(); });
    return {
        VesselId: vesselId || null,
        PilotJobOrders: sortedItems,
        ExportGroup: {
            // TH 05/05/2017 -- Placeholder InvoiceNumber.
            // Keep in sync w/ PortCall.Services\Billing\InvoiceNumber.cs.
            InvoiceNumber: function () { return 'PC-Mxxxx'; },
            VesselName: function () { return vessel() && vessel().Name(); },
            QBCustomerId: function () { return customer; },
            InvoiceDate: function () { return null; },
            ExportDate: function () { return null; },
            UniqueKey: function () { return 'M' + key; },
            Charges: s_array_1.lift(sortedItems.reduce(function (charges, pjo) {
                return charges.concat(pjo.ApprovalOfCharges() ? pjo.ApprovalOfCharges().Charges() : []);
            }, function () { return []; })),
            SelectedForExport: s_js_1.default.data(false),
            Expanded: s_js_1.default.data(s_js_1.default.sample(expansionMode) === 1 /* AutoExpand */)
        }
    };
}
function DispatchEventExportGroup(expansionMode, _a) {
    var key = _a.key, items = _a.items;
    var sortedItems = items.orderBy(function (de) { return de.Start(); });
    return {
        DispatchEvents: sortedItems,
        ExportGroup: {
            // TH 05/05/2017 -- Placeholder InvoiceNumber.
            // Keep in sync w/ PortCall.Services\Billing\InvoiceNumber.cs.
            InvoiceNumber: function () { return 'PC-Exxxx'; },
            VesselName: function () { return null; },
            QBCustomerId: function () { return key; },
            InvoiceDate: function () { return null; },
            ExportDate: function () { return null; },
            UniqueKey: function () { return 'E' + key; },
            Charges: s_array_1.lift(sortedItems.reduce(function (charges, de) {
                return charges.concat(de.ApprovalOfCharges() ? de.ApprovalOfCharges().Charges() : []);
            }, function () { return []; })),
            SelectedForExport: s_js_1.default.data(false),
            Expanded: s_js_1.default.data(s_js_1.default.sample(expansionMode) === 1 /* AutoExpand */)
        }
    };
}
function ExportConfirmationPopup(ajax, entrypoints, cache, domain, now, billingSystem, pjoGroups, dispatchEventGroups, onExportFinished, onCancel) {
    var selectedPJOGroups = pjoGroups.filter(function (g) { return g.ExportGroup.SelectedForExport(); }), selectedDispatchEventGroups = dispatchEventGroups.filter(function (g) { return g.ExportGroup.SelectedForExport(); }), selectedPJOCharges = selectedPJOGroups.reduce(function (charges, pjo) {
        return charges.concat(pjo.ExportGroup.Charges());
    }, []), selectedEventCharges = selectedDispatchEventGroups.reduce(function (charges, de) {
        return charges.concat(de.ExportGroup.Charges());
    }, []), allCharges = selectedPJOCharges.concat(selectedEventCharges), exportTotal = Charge_1.TotalPriceForCharges(s_array_1.lift(function () { return allCharges; }), function () { return billingSystem.Currency() || Currency_1.default.USD; }, exportgrouplist_1.PRICE_PRECISION), exportRequest = new QuickBooksExportRequest_1.QuickBooksExportRequest({
        InvoiceDate: now.toJSON()
    }), exportClient = ajax.Url(entrypoints.QuickBooksExport({ Id: billingSystem.Id() })), sendingExportRequest = s_js_1.default.data(false), validation = validationWatcher_1.ValidationWatcher(exportClient), exportFinishedStatus = s_js_1.default.data(null);
    return {
        NumberOfInvoices: selectedPJOGroups.length + selectedDispatchEventGroups.length,
        ExportTotal: exportTotal,
        ExportRequest: exportRequest,
        Cancel: onCancel,
        SendExportRequest: SendExportRequest,
        SendingExportRequest: sendingExportRequest,
        Validation: validation,
        ExportFinishedStatus: exportFinishedStatus,
        SupportHref: function () { return 'mailto:' + domain.SupportEmail(); }
    };
    function SendExportRequest() {
        return __awaiter(this, void 0, void 0, function () {
            var charges, req, payload_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (sendingExportRequest())
                            return [2 /*return*/];
                        sendingExportRequest(true);
                        charges = {
                            GroupedPilotJobOrderCharges: selectedPJOGroups.map(function (g) { return ({
                                VesselId: g.VesselId,
                                QBTracking: {
                                    Customer: g.ExportGroup.QBCustomerId()
                                },
                                PilotJobOrders: g.PilotJobOrders().map(function (pjo) { return ({
                                    Id: pjo.Id(),
                                    ApprovalDate: pjo.ApprovalOfCharges() ?
                                        pjo.ApprovalOfCharges().ApprovalDate().toJSON() :
                                        new TZDate_1.default(0).toJSON()
                                }); })
                            }); }),
                            GroupedDispatchEventCharges: selectedDispatchEventGroups.map(function (g) { return ({
                                QBTracking: {
                                    Customer: g.ExportGroup.QBCustomerId()
                                },
                                DispatchEvents: g.DispatchEvents().map(function (de) { return ({
                                    Id: de.Id(),
                                    ApprovalDate: de.ApprovalOfCharges() ?
                                        de.ApprovalOfCharges().ApprovalDate().toJSON() :
                                        new TZDate_1.default(0).toJSON()
                                }); })
                            }); })
                        };
                        req = exportClient.Post(Object.assign(ExportRequestOptions(exportRequest), charges));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, req];
                    case 2:
                        payload_1 = _a.sent();
                        s_js_1.default.freeze(function () {
                            if (payload_1.Status === ExportPayload_1.ExportPayloadStatus.Formatted) {
                                var dataUri = "data:text/plain;charset=utf-8," + encodeURIComponent(payload_1.RawExport);
                                downloadData_1.downloadDataUri(dataUri, 'invoices.iif');
                                exportFinishedStatus({ success: true });
                            }
                            else {
                                // TH 05/09/2017 -- This represents a case where Bills were successfully
                                // generated for the requested export groups but there was an error
                                // generating the IIF file for those Bills.
                                // This most likely indicates bad seed data (missing item codes, mismatched
                                // currencies).
                                // We'll treat this like a partial success -- we did in fact generate the
                                // Bills for these items, so they'll show up on the PastExports page and
                                // we'll remove them from PendingExports.
                                // But instead of downloading the IIF file (which doesn't exist), we'll
                                // give users a popup saying that something unexpected happened and they
                                // should check PastExports and call support.
                                // This really shouldn't happen as long as our seed data is consistent.
                                // So I don't think our handling has to be perfect here.
                                exportFinishedStatus({
                                    success: false,
                                    errorDetails: payload_1.ErrorMessage || 'Unexpected export error.'
                                });
                            }
                            // TH 05/05/2017 -- Add any bills created to the cache.
                            // We won't cache the ExportPayload itself.
                            // I figure the IIF itself could get fairly large, and I'm not currently aware of
                            // any reason the client needs to hold onto it.
                            cache.BillExportPayloadAssignments.update(req.Date, payload_1.Bills, []);
                            onExportFinished();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        sendingExportRequest(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
function ExportRequestOptions(req) {
    return JSON.parse(JSON.stringify(req));
}


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingExportsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var PendingExportsResponse_1 = __webpack_require__(1305);
var PendingExportsCache = /** @class */ (function (_super) {
    __extends(PendingExportsCache, _super);
    function PendingExportsCache(data) {
        var _this = _super.call(this) || this;
        _this.PendingExportsResponses = PCCache_1.PCCollection(PendingExportsResponse_1.PendingExportsResponse);
        new DataCache_1.SharedKeyRelationship(_this.PendingExportsResponses, data.BillingSystems, function (r) { return r.BillingSystem; }, null);
        new DataCache_1.QueryResultsRelationship(_this.PendingExportsResponses, data.PilotJobOrders, function (r) { return r.ExportablePilotJobOrders; });
        new DataCache_1.QueryResultsRelationship(_this.PendingExportsResponses, data.DispatchEvents, function (r) { return r.ExportableDispatchEvents; });
        return _this;
    }
    return PendingExportsCache;
}(DataCache_1.DataCache));
exports.PendingExportsCache = PendingExportsCache;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingExportsRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var pendingexportsview_1 = __webpack_require__(1156);
var view_1 = __webpack_require__(12);
function PendingExportsRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(pendingexportsview_1.PendingExportsView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.PendingExportsRoute = PendingExportsRoute;
function inboundParams(request) {
    var id = +(request.params['id'] || 0), expansionMode = request.params['expansion'], filter = request.params['filter'];
    return {
        id: id,
        expansionMode: expansionMode !== undefined ? +expansionMode : 0 /* AutoCollapse */,
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = m.Model.Id() + '';
    if (m.RowExpander.ExpansionMode() !== 0 /* AutoCollapse */)
        params['expansion'] = m.RowExpander.ExpansionMode() + '';
    if (m.Filter())
        params['filter'] = m.Filter();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingExportsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var exportgrouplist_1 = __webpack_require__(133);
var view_1 = __webpack_require__(40);
var view_2 = __webpack_require__(54);
var view_3 = __webpack_require__(60);
var view_4 = __webpack_require__(106);
var exportgrouplistview_1 = __webpack_require__(540);
var exportselectioncontrols_1 = __webpack_require__(541);
var exporttoquickbookslink_1 = __webpack_require__(542);
var view_5 = __webpack_require__(35);
var view_6 = __webpack_require__(22);
exports.PendingExportsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pendingexports pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { href: "", className: "pc-back-link", onClick: eventWrappers_1.noDefault(function () { return window.history.back(); }) }, "<< Back"),
            React.createElement(view_2.ActionsMenuButton, { onClick: function () { return m.ShowActionsMenu(!m.ShowActionsMenu()); } }),
            React.createElement(ActionsContainer, { model: m })),
        React.createElement("div", { className: "pc-page-title" }, "Pilot Billing"),
        React.createElement(exportselectioncontrols_1.ExportSelectionControls, { model: m }),
        React.createElement(FilterControls, { model: m }),
        React.createElement(view_1.PageLoadingIndicator, { loading: m.Loading }),
        React.createElement(exportgrouplistview_1.ExportGroupListView, { model: m.ExportGroupList }),
        React.createElement(ExportConfirmationPopupView, { model: m }));
});
var ActionsContainer = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-actions" }, m.ShowActionsMenu() &&
        React.createElement(view_5.PCDismissible, { className: "pc-card pc-actions-menu", onDismiss: function () { return m.ShowActionsMenu(false); } },
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement(view_4.ExpandCollapseLink, { model: m.RowExpander, actionWrapper: m.MenuAction })),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Collapse all of the items for a compressed view.")),
            React.createElement("div", { className: "action-item" },
                React.createElement("div", null,
                    React.createElement(exporttoquickbookslink_1.ExportToQuickBooksLink, { model: m })),
                React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Export the following items to QuickBooks."))));
});
var FilterControls = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "filter-controls" },
        React.createElement("span", { className: "subtitle" }, "Pending Exports"),
        React.createElement("a", { className: "exports-nav-toggle-link", href: "#!pastexports?id=" + m.Model.Id() + "&expansionMode=" + m.RowExpander.ExpansionMode() + "&filter=" + m.Filter() }, "Show Past Exports"),
        React.createElement("input", { className: "pc-reports-filter", placeholder: "Filter by \u2014", value: m.Filter(), onChange: function (e) { return m.Filter(e.currentTarget.value); } }));
});
var ExportConfirmationPopupView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var popup = m.ExportConfirmationPopup();
    return (React.createElement(view_6.PCModal, { className: "export-confirmation-popup", shown: function () { return !!popup; } },
        React.createElement("div", { className: "export-confirmation-popup-content" },
            React.createElement("div", { className: "export-confirmation-header" }, "QuickBooks Export"),
            popup && (popup.ExportFinishedStatus() ?
                React.createElement(ExportConfirmationPostexportView, { model: m, popup: popup, finishedStatus: popup.ExportFinishedStatus() }) :
                React.createElement(ExportConfirmationPreexportView, { model: m, popup: popup })))));
});
var ExportConfirmationPreexportView = supercritical_1.default(function (_a) {
    var popup = _a.popup, m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "export-confirmation-body" },
            React.createElement("div", { className: "pc-text-smalllabel" }, "Export invoice data to a QuickBooks IIF file."),
            popup.Validation()['StalenessCheckFailed'] &&
                React.createElement("div", { className: "export-confirmation-validation alert alert-danger" }, "It looks like important billing details have changed since you loaded this page. Your invoices have not been exported. Please reload your browser and try again."),
            React.createElement(view_1.ActionLoadingIndicator, { loading: popup.SendingExportRequest }),
            React.createElement("div", { className: "export-setting pc-text-billing-label" },
                React.createElement("span", { className: "export-setting-label" }, "Number of invoices:"),
                React.createElement("span", { className: "export-setting-value" }, popup.NumberOfInvoices)),
            React.createElement("div", { className: "export-setting pc-text-billing-label" },
                React.createElement("span", { className: "export-setting-label" }, "Total value of all invoices:"),
                React.createElement("span", { className: "export-setting-value" }, popup.ExportTotal.toString({ places: exportgrouplist_1.PRICE_PRECISION }))),
            React.createElement("div", { className: "export-setting export-confirmation-invoice-date" },
                React.createElement("span", { className: "export-setting-label pc-text-billing-label" }, "Invoice date:"),
                React.createElement(view_3.DatePicker, { value: popup.ExportRequest.InvoiceDate, localization: m.Localization }))),
        React.createElement("div", { className: "export-confirmation-footer" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(popup.Cancel) }, "No, don't export"),
            React.createElement("button", { className: "pc-button", onClick: popup.SendExportRequest }, "Export")));
});
var ExportConfirmationPostexportView = supercritical_1.default(function (_a) {
    var popup = _a.popup, finishedStatus = _a.finishedStatus, m = _a.model;
    return React.createElement("div", null,
        finishedStatus.success ?
            React.createElement(ExportConfirmationSuccessBody, null) :
            React.createElement(ExportConfirmationUnexpectedErrorBody, { errorDetails: finishedStatus.errorDetails, popup: popup }),
        React.createElement("div", { className: "export-confirmation-footer" },
            React.createElement("button", { className: "pc-button", onClick: popup.Cancel }, "OK")));
});
var ExportConfirmationSuccessBody = supercritical_1.default(function () {
    return React.createElement("div", { className: "export-confirmation-body" }, "Your invoices have been exported successfully. A download should have begun in your browser. Please import the downloaded IIF file into QuickBooks to finish the export. If the download does not begin in a few seconds, please check the Past Exports view and try re-exporting your invoices from there.");
});
var ExportConfirmationUnexpectedErrorBody = supercritical_1.default(function (_a) {
    var errorDetails = _a.errorDetails, popup = _a.popup;
    return React.createElement("div", { className: "export-confirmation-body" },
        React.createElement("div", { className: "generic-message" },
            "We successfully generated your invoices but encountered an unexpected error formatting your QuickBooks IIF file for download. Please check for your invoices on the Past Exports view and try exporting again. If this problem persists, please contact",
            ' ',
            React.createElement("a", { href: popup.SupportHref() }, "Support"),
            ". We apologize for the inconvenience."),
        React.createElement("div", { className: "error-details" },
            "Error details:",
            React.createElement("br", null),
            React.createElement("textarea", { value: errorDetails, rows: 6 })));
});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboardCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ReservationsDashboardResponse_1 = __webpack_require__(1341);
var ReservationsDashboardCache = /** @class */ (function (_super) {
    __extends(ReservationsDashboardCache, _super);
    function ReservationsDashboardCache(data, rowCache) {
        var _this = _super.call(this) || this;
        _this.ReservationsDashboardResponses = PCCache_1.PCCollection(ReservationsDashboardResponse_1.ReservationsDashboardResponse);
        new DataCache_1.ForeignKeyRelationship(data.Organizations, _this.ReservationsDashboardResponses, null, function (r) { return r.Organization; }, function (r) { return r.OrganizationId(); });
        new DataCache_1.QueryResultsRelationship(_this.ReservationsDashboardResponses, rowCache.ReservationsDashboardRows, function (r) { return r.Rows; });
        return _this;
    }
    return ReservationsDashboardCache;
}(DataCache_1.DataCache));
exports.ReservationsDashboardCache = ReservationsDashboardCache;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboardRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(87);
var PortCallUserRole_1 = __webpack_require__(136);
var routeParams_2 = __webpack_require__(77);
var model_1 = __webpack_require__(543);
var view_1 = __webpack_require__(1159);
var view_2 = __webpack_require__(12);
var ReservationsDashboardRoute = function (model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ReservationsDashboardView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
};
exports.ReservationsDashboardRoute = ReservationsDashboardRoute;
function inboundParams(request, tzutils) {
    var orgId = request.params['orgId'], range = request.params['range'], role = request.params['role'], from = request.params['from'], to = request.params['to'], filter = request.params['filter'];
    return {
        orgId: orgId !== undefined ? +orgId : undefined,
        range: range !== undefined ? routeParams_1.parseDateRange(range) : 3 /* ThisMonth */,
        role: role !== undefined ? routeParams_2.parsePortCallUserRole(role) : undefined,
        from: from !== undefined ? routeParams_2.parseDate(from, tzutils) : undefined,
        to: to !== undefined ? routeParams_2.parseDate(to, tzutils) : undefined,
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['orgId'] = m.OrgId + '';
    routeParams_1.outboundDateRangeParams(m.DateRangeSelector, params, 3 /* ThisMonth */, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter())
        params['filter'] = m.Filter();
    if (m.Role() !== model_1.DefaultRole)
        params['role'] = PortCallUserRole_1.PortCallUserRoleDisplayName[m.Role()];
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboardView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(545);
exports.ReservationsDashboardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_1.ReservationsListBaseView, { model: m, className: "reservations-dashboard" });
});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsInBatchCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ReservationsInBatch_1 = __webpack_require__(1343);
var ReservationsInBatchCache = /** @class */ (function (_super) {
    __extends(ReservationsInBatchCache, _super);
    function ReservationsInBatchCache(data, rowCache) {
        var _this = _super.call(this) || this;
        _this.ReservationsInBatches = PCCache_1.PCCollection(ReservationsInBatch_1.ReservationsInBatch);
        new DataCache_1.ForeignKeyRelationship(data.RecurringBatches, _this.ReservationsInBatches, null, function (r) { return r.Batch; }, function (r) { return r.BatchId(); });
        new DataCache_1.ForeignKeyRelationship(data.Organizations, _this.ReservationsInBatches, null, function (r) { return r.Organization; }, function (r) { return r.OrganizationId(); });
        new DataCache_1.QueryResultsRelationship(_this.ReservationsInBatches, rowCache.ReservationsDashboardRows, function (r) { return r.Rows; });
        return _this;
    }
    return ReservationsInBatchCache;
}(DataCache_1.DataCache));
exports.ReservationsInBatchCache = ReservationsInBatchCache;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsInBatch = void 0;
var s_js_1 = __webpack_require__(0);
var batchFilterStorageKey = 'portcall.reservationsinbatch.filter';
function ReservationsInBatch(ajax, entrypoints, cache, user, baseModel, _a) {
    var batchId = _a.batchId, range = _a.range, from = _a.from, to = _a.to, filter = _a.filter;
    var showConfirmDeleteBatch = s_js_1.default.data(false), base = baseModel({
        cacheCollection: cache.ReservationsInBatches,
        modelKey: function (_a) {
            var FromDate = _a.FromDate, ToDate = _a.ToDate;
            return ({
                FromDate: FromDate,
                ToDate: ToDate,
                BatchId: batchId
            });
        },
        organizationRef: function (model) { return function () { return model().Organization(); }; },
        url: entrypoints.ReservationsInBatch,
        filterStorageKey: batchFilterStorageKey,
        range: range,
        allowedRanges: [
            0 /* AllDates */,
            3 /* ThisMonth */,
            4 /* LastMonth */,
            5 /* ThisYear */,
            6 /* LastYear */,
            7 /* Custom */
        ],
        from: from, to: to, filter: filter
    }), deletingBatch = s_js_1.default.data(false);
    return Object.assign({}, base, {
        BatchId: batchId,
        Batch: function () { return base.Model().Batch(); },
        ShowConfirmDeleteBatch: showConfirmDeleteBatch,
        ConfirmDeleteBatch: ConfirmDeleteBatch,
        DeleteBatch: DeleteBatch,
        DeletingBatch: deletingBatch
    });
    function ConfirmDeleteBatch() {
        s_js_1.default.freeze(function () {
            showConfirmDeleteBatch(true);
            base.ShowActionsMenu(false);
        });
    }
    function DeleteBatch() {
        var batch = s_js_1.default.sample(function () { return base.Model().Batch(); });
        if (!batch)
            return;
        deletingBatch(true);
        ajax.Url(function () { return batch.Url() || ''; }, { useCache: true }).Delete().then(function () {
            showConfirmDeleteBatch(false);
            // need to use a timeout otherwise modal hide animation doesn't finish
            // and semi-transparent modal backdrop is stuck on screen
            setTimeout(function () {
                window.history.back();
            }, 200);
        }).finally(function () { return deletingBatch(false); });
    }
}
exports.ReservationsInBatch = ReservationsInBatch;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsInBatchRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(77);
var routeParams_2 = __webpack_require__(87);
var view_1 = __webpack_require__(1163);
var view_2 = __webpack_require__(12);
var ReservationsInBatchRoute = function (model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ReservationsInBatchView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
};
exports.ReservationsInBatchRoute = ReservationsInBatchRoute;
function inboundParams(request, tzutils) {
    var batchId = +(request.params['batchId'] || 0), range = request.params['range'], from = request.params['from'], to = request.params['to'], filter = request.params['filter'];
    return {
        batchId: batchId,
        range: range !== undefined ? routeParams_2.parseDateRange(range) : 0 /* AllDates */,
        from: from !== undefined ? routeParams_1.parseDate(from, tzutils) : undefined,
        to: to !== undefined ? routeParams_1.parseDate(to, tzutils) : undefined,
        filter: filter
    };
}
function outboundParams(request, m) {
    var params = {};
    params['batchId'] = m.BatchId + '';
    routeParams_2.outboundDateRangeParams(m.DateRangeSelector, params, 0 /* AllDates */, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter())
        params['filter'] = m.Filter();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsInBatchView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(545);
var view_2 = __webpack_require__(22);
var view_3 = __webpack_require__(40);
exports.ReservationsInBatchView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "reservations-in-batch" },
        React.createElement(view_1.ReservationsListBaseView, { model: m, title: function () { return m.Batch() ? 'Batch #' + m.Batch().ReferenceNumber() : ''; }, actionsMenuFactory: actionsMenuFactory, csvExportFileName: function () { return 'batch' + (m.Batch() ? '_' + m.Batch().ReferenceNumber() : '') + '.csv'; } }),
        React.createElement(ConfirmDeleteBatchModal, { model: m })));
    function actionsMenuFactory(_a) {
        var printMenuItem = _a.printMenuItem, csvExportMenuItem = _a.csvExportMenuItem, cancelReservationsMenuItem = _a.cancelReservationsMenuItem, bookReservationsMenuItem = _a.bookReservationsMenuItem, adminSeparator = _a.adminSeparator;
        return (React.createElement("div", null,
            printMenuItem,
            csvExportMenuItem,
            cancelReservationsMenuItem,
            (m.AnyBookableRows() || m.Model().CanDelete()) && adminSeparator,
            bookReservationsMenuItem,
            m.Batch() && m.Model().CanDelete() && React.createElement(DeleteBatchMenuItem, { model: m })));
    }
});
var DeleteBatchMenuItem = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "action-item" },
        React.createElement("div", null,
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.ConfirmDeleteBatch) }, "Delete Batch")),
        React.createElement("div", { className: "pc-text-smalllabel pc-action-item-descr" }, "Delete all PortCalls in this batch. Caution."));
});
var ConfirmDeleteBatchModal = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(view_2.PCModal, { className: "confirm-delete-batch-modal", shown: m.ShowConfirmDeleteBatch, onBackDropClick: function () { return m === null || m === void 0 ? void 0 : m.ShowConfirmDeleteBatch(false); } },
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "modal-body" },
                React.createElement("h3", { className: "title" }, "Delete Batch"),
                React.createElement("div", null, "Are you sure you want to delete all the PortCalls and reservations in this batch?"),
                React.createElement("div", { className: "actions" },
                    React.createElement("a", { href: "", className: "cancel", onClick: eventWrappers_1.noDefault(function () { return !m.DeletingBatch() && m.ShowConfirmDeleteBatch(false); }) }, "Cancel"),
                    React.createElement("button", { className: "pc-button pc-button-primary", disabled: m.DeletingBatch(), onClick: m.DeleteBatch }, "Delete")),
                React.createElement(view_3.ActionLoadingIndicator, { loading: m.DeletingBatch }))));
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsListBaseCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ReservationsDashboardRow_1 = __webpack_require__(1342);
var ReservationsListBaseCache = /** @class */ (function (_super) {
    __extends(ReservationsListBaseCache, _super);
    function ReservationsListBaseCache(data) {
        var _this = _super.call(this) || this;
        _this.ReservationsDashboardRows = PCCache_1.PCCollection(ReservationsDashboardRow_1.ReservationsDashboardRow);
        new DataCache_1.SharedKeyRelationship(_this.ReservationsDashboardRows, data.BerthReservations, function (row) { return row.Reservation; }, null);
        return _this;
    }
    return ReservationsListBaseCache;
}(DataCache_1.DataCache));
exports.ReservationsListBaseCache = ReservationsListBaseCache;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var Accounts_1 = __webpack_require__(199);
function ResetPassword(ajax, entrypoints, loginModel, _a) {
    var userId = _a.userId, token = _a.token;
    var client = ajax.Url(entrypoints.ResetPassword), validation = validationWatcher_1.ValidationWatcher(client), resetPassword = new Accounts_1.ResetPasswordRequest({
        UserId: userId,
        Token: token
    }), resetPasswordRequest = s_js_1.default.data(null), showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: true, onHidePopup: function () { return showLogin(false); } }) : null; }), showPasswordValidation = s_js_1.default.data(false);
    return {
        ResetPassword: resetPassword,
        ResetPasswordRequest: resetPasswordRequest,
        Validation: validation,
        Submit: Submit,
        ShowLogin: showLogin,
        Login: login,
        ShowPasswordValidation: showPasswordValidation
    };
    function Submit() {
        resetPasswordRequest(client.Post(resetPassword));
    }
}
exports.ResetPassword = ResetPassword;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1167);
var view_2 = __webpack_require__(12);
function ResetPasswordRoute(model, appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.ResetPasswordView, { model: model(inboundParams(request)) }))
    };
}
exports.ResetPasswordRoute = ResetPasswordRoute;
function inboundParams(request) {
    return {
        userId: +(request.params['userId'] || 0),
        token: request.params['token'] || ''
    };
}


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(130);
var view_2 = __webpack_require__(532);
var view_3 = __webpack_require__(29);
exports.ResetPasswordView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "resetpassword pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-card resetpassword-container" },
            React.createElement("h2", { className: "pc-card-header pc-card-title" }, "Reset password"),
            m.ResetPasswordRequest()
                && m.ResetPasswordRequest().Response()
                && m.ResetPasswordRequest().Response().Success ?
                React.createElement(ResetPasswordSuccess, { model: m }) :
                m.Validation()['Token'] ?
                    React.createElement("div", null, "Your password reset link is invalid. This is probably because your link expired. Please try requesting another password reset link.") :
                    React.createElement(ResetPasswordForm, { model: m })),
        React.createElement(view_1.LoginView, { modelContainer: m.Login }));
});
var ResetPasswordForm = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("form", null,
        React.createElement("div", { className: "form-group" },
            React.createElement(view_2.PasswordEntry, { autoFocus: true, value: m.ResetPassword.NewPassword, showValidation: m.ShowPasswordValidation, placeholder: "New Password" }),
            React.createElement(view_3.ValidationErrorView, { error: function () { return m.Validation()['NewPassword']; } })),
        React.createElement("div", { className: "form-group" },
            React.createElement("input", { type: "password", className: "form-control pc-input-box", placeholder: "Confirm password", value: m.ResetPassword.ConfirmPassword() || '', onChange: function (e) { return m.ResetPassword.ConfirmPassword(e.currentTarget.value); } }),
            React.createElement(view_3.ValidationErrorView, { error: function () { return m.Validation()['ConfirmPassword']; } })),
        React.createElement("div", { className: "form-group form-buttons" },
            React.createElement("button", { className: "pc-button pc-button-primary", onClick: eventWrappers_1.noDefault(m.Submit) }, "Reset")));
});
var ResetPasswordSuccess = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", null, "Your password has been reset successfully."),
        React.createElement("div", { className: "login-link" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return m.ShowLogin(true); }) }, "Login")),
        React.createElement("div", null,
            React.createElement("a", { href: "#" }, "Back to homepage")));
});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreAccount = void 0;
var s_js_1 = __webpack_require__(0);
var validationWatcher_1 = __webpack_require__(23);
var UserSummary_1 = __webpack_require__(203);
var invitationerrors_1 = __webpack_require__(192);
function RestoreAccount(ajax, entrypoints, user, loginModel, _a) {
    var invitationId = _a.invitationId, token = _a.token;
    var client = ajax.Url(entrypoints.RestoreAccount), validation = validationWatcher_1.ValidationWatcher(client), request = client.Post({
        InvitationId: invitationId,
        Token: token
    }), showLogin = s_js_1.default.data(false), login = s_js_1.default(function () { return showLogin() ? loginModel({ useLandingPage: true, onHidePopup: function () { return showLogin(false); } }) : null; });
    // if get AlreadyActive error from server, update user object
    s_js_1.default(function () { return invitationerrors_1.HandleAlreadyActive(validation(), user); });
    // if account restoration succeeds, update user object
    request.then(function (userSummary) { return user(new UserSummary_1.UserSummary(userSummary)); });
    return {
        Validation: validation,
        Request: request,
        ShowLogin: showLogin,
        Login: login,
        User: user
    };
}
exports.RestoreAccount = RestoreAccount;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreAccountRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1170);
var view_2 = __webpack_require__(12);
function RestoreAccountRoute(model, appWrapper, request) {
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.RestoreAccountView, { model: model(inboundParams(request)) }))
    };
}
exports.RestoreAccountRoute = RestoreAccountRoute;
function inboundParams(request) {
    return {
        invitationId: +(request.params['invitationId'] || 0),
        token: request.params['token'] || ''
    };
}


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreAccountView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var invitationerrorsview_1 = __webpack_require__(501);
var invitationlinks_1 = __webpack_require__(263);
var view_1 = __webpack_require__(130);
exports.RestoreAccountView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "restoreaccount pc-page-fixedwidth" },
        m.Request.Response() ?
            React.createElement("div", { className: "pc-card restoreaccount-container" }, m.Request.Response().Success ?
                React.createElement(RestoreAccountSuccess, { model: m }) :
                React.createElement(invitationerrorsview_1.CommonInvitationErrorsView, { model: m, getError: function (key) { return m.Validation()[key]; }, tokenErrorText: "If you've already restored your account, try logging in." })) :
            null // TH TODO -- loadingindicator
    ,
        React.createElement(view_1.LoginView, { modelContainer: m.Login }));
});
var RestoreAccountSuccess = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", null,
        React.createElement("div", { className: "result-description" }, "Congratulations! Your account has been restored."),
        React.createElement(invitationlinks_1.ProfileAndLandingPageLinks, { model: m }));
});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleGridCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var ScheduleGrid_1 = __webpack_require__(1350);
var ScheduleGridUpdateResponse_1 = __webpack_require__(1351);
var ScheduleGridCache = /** @class */ (function (_super) {
    __extends(ScheduleGridCache, _super);
    function ScheduleGridCache(data) {
        var _this = _super.call(this) || this;
        _this.ScheduleGridResponses = PCCache_1.PCCollection(ScheduleGrid_1.ScheduleGridResponse);
        _this.ScheduleGridUpdateResponses = new DataCache_1.DataCacheCollection(ScheduleGridUpdateResponse_1.ScheduleGridUpdateResponse, ScheduleGridUpdateResponse_1.ScheduleGridUpdateResponse.update, function (i) { return 0; }, function (i) { return 0; }, { expectEmptyIds: true });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.BerthClosures, function (r) { return r.BerthClosures; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.BerthReservations, function (r) { return r.BerthReservations; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.ItineraryPoints, function (r) { return r.ItineraryPoints; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.PortCalls, function (r) { return r.PortCalls; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.UnlistedBerthReservations, function (r) { return r.UnlistedReservations; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridResponses, data.Vessels, function (r) { return r.Vessels; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.BerthClosures, function (r) { return r.BerthClosures; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.BerthReservations, function (r) { return r.BerthReservations; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.ItineraryPoints, function (r) { return r.ItineraryPoints; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.PortCalls, function (r) { return r.PortCalls; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.UnlistedBerthReservations, function (r) { return r.UnlistedReservations; });
        new DataCache_1.QueryResultsRelationship(_this.ScheduleGridUpdateResponses, data.Vessels, function (r) { return r.Vessels; });
        return _this;
    }
    return ScheduleGridCache;
}(DataCache_1.DataCache));
exports.ScheduleGridCache = ScheduleGridCache;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleGridRoute = void 0;
var s_js_1 = __webpack_require__(0);
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var TZDate_1 = __webpack_require__(7);
var tzmoment_1 = __webpack_require__(9);
var model_1 = __webpack_require__(277);
var view_1 = __webpack_require__(1173);
var view_2 = __webpack_require__(12);
var portFilterStorageKey = 'portcall.berthtimeline.portFilter', capabilityFilterStorageKey = 'portcall.berthtimeline.capabilityFilter';
var ScheduleGridRoute = function (modelFactory, tzutils, appwrapper, request) {
    var model = modelFactory(inboundParams(request.params, tzutils));
    s_js_1.default(function () { return localStorage[portFilterStorageKey] = model.PortFilter.Query(); });
    s_js_1.default(function () { return localStorage[capabilityFilterStorageKey] = model.CapabilityFilter.Query(); });
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appwrapper, navbarTab: 0 /* Berths */ },
            React.createElement(view_1.ScheduleGridView, { model: model })),
        reflectState: function () { return new componentLocation_1.Location(request.name, outboundParams(model, tzutils)); }
    };
};
exports.ScheduleGridRoute = ScheduleGridRoute;
function inboundParams(p, tzutils) {
    return new model_1.ScheduleGridParams(!!p["compact"], p["date"] ? tzutils.setTimezoneOffset(new TZDate_1.default(p["date"] + "T00:00:00Z"), true) : tzutils.today(), +(p["resid"] || 0) || null, +(p["uresid"] || p["buid"] || 0) || null, // Accept "buid" as a legacy synonym for "uresid" (used to call UnlistedBerthReservations "BerthUnavailables").
    +(p["bclid"] || 0) || null, p["port"] || localStorage[portFilterStorageKey] || '', p["capability"] || localStorage[capabilityFilterStorageKey] || '', +(p["mode"] || 0) || model_1.SelectMode.Details, !!p["backOnComplete"]);
}
function outboundParams(model, tzutils) {
    var p = {};
    if (model.CompactView())
        p["compact"] = "1";
    if (!TZDate_1.default.eq(model.DateRange.FromDate(), tzutils.today()))
        p["date"] = tzmoment_1.tzmoment(model.DateRange.FromDate()).format("YYYY-MM-DD");
    if (model.PortFilter.Query())
        p["port"] = model.PortFilter.Query();
    if (model.CapabilityFilter.Query())
        p["capability"] = model.CapabilityFilter.Query();
    var tool = model.CurrentTool();
    if (tool) {
        if (tool.TimelineItem) {
            if (tool.TimelineItem.Type === "BR" /* BerthReservation */)
                p["resid"] = tool.TimelineItem.Reservation.Id() + '';
            if (tool.TimelineItem.Type === "UR" /* UnlistedReservation */)
                p["uresid"] = tool.TimelineItem.UnlistedReservation.Id() + '';
            if (tool.TimelineItem.Type === "BCL" /* BerthClosure */)
                p["bclid"] = tool.TimelineItem.BerthClosure.Id() + '';
        }
        var mode = tool instanceof model_1.AddShiftTool ? model_1.SelectMode.AddShift :
            tool instanceof model_1.ChangeBerthTool ? model_1.SelectMode.ChangeBerth :
                tool instanceof model_1.ReservationOverlapsTool ? model_1.SelectMode.ViewOverlaps :
                    tool instanceof model_1.BerthClosureOverlapsTool ? model_1.SelectMode.ViewOverlaps :
                        tool instanceof model_1.EditTimeblockTool ? model_1.SelectMode.EditTimeblock :
                            undefined;
        if (mode !== undefined)
            p["mode"] = mode + '';
    }
    return p;
}


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateTimelinePositionCoords = exports.translateDrag = exports.translateEvent = exports.translateScale = exports.BerthClosureTitleInput = exports.BerthClosureEditForm = exports.AddBerthClosureModal = exports.OverlapsPopup = exports.BerthClosureOverlapsPopup = exports.ReservationOverlapsPopup = exports.ConfirmAddShiftPopup = exports.ChangeBerthPopup = exports.EditTimeBlockPopup = exports.NewReservationPopup = exports.ReservationDetailsPopup = exports.BerthClosureDetailsSaveControls = exports.BerthClosureDetailsActionsMenu = exports.BerthClosureDetailsDeleteConfirmation = exports.BerthClosureDetailsHeader = exports.BerthClosureDetailsPopup = exports.UnlistedReservationDetailsPopup = exports.BollardDescriptionTooltip = exports.Popup = exports.PierGroupToolPopup = exports.PierGroupAddShiftIndicator = exports.PierGroupNewReservation = exports.Reservation = exports.BerthClosureView = exports.UnlistedReservation = exports.PierGroupTimelineItems = exports.BerthFootmarkSelection = exports.PierGroupBollards = exports.PortBerth = exports.PortPierGroup = exports.PortPierGroups = exports.PortHeader = exports.PortView = exports.GridMain = exports.GridHeader = exports.Grid = exports.Filter = exports.ActionsMenu = exports.Header = exports.ScheduleGridView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var _ = __webpack_require__(67);
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
__webpack_require__(296);
var eventWrappers_1 = __webpack_require__(8);
var UOM_1 = __webpack_require__(25);
var Issue_1 = __webpack_require__(135);
var Measurement_1 = __webpack_require__(11);
var BerthReservation_1 = __webpack_require__(38);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(509);
var view_3 = __webpack_require__(91);
var view_4 = __webpack_require__(60);
var view_5 = __webpack_require__(68);
var view_6 = __webpack_require__(55);
var view_7 = __webpack_require__(35);
var view_8 = __webpack_require__(22);
var model_1 = __webpack_require__(277);
var view_9 = __webpack_require__(29);
/*
const DayWidth = 240,
    SCALE = {
        X: DayWidth / (24 * 60 * 60 * 1000), // px per millisecond, expressed as 240 px per day
        Y: {
            [UOM.Foot]: 30 / 100, // px per foot
            [UOM.Meter]: 1 // px per meter
        }
    };
*/
// static values
var COMPACT_BERTH_HEIGHT = 12, COMPACT_RES_HEIGHT = 38, COMPACT_OVERLAP_GAP = 6, MS_PER_DAY = 24 * 60 * 60 * 1000;
var scaleFactor = 1;
var setToolElTimeoutId;
var translateScale = function (tzero, trange, xrange, drange, yrange, tzutils) {
    var x = function (a, b) { return Math.round(((b || a).getTime() - (b ? a : tzero()).getTime()) / trange() * xrange()); }, y = function (m) { return m.convert(drange().UOM()).Num() / drange().Num() * yrange(); }, date = function (x) { return tzutils.newDate(tzero().getTime() + x / xrange() * trange()); }, pier = function (y) { return new Measurement_1.Measurement({ Num: y / yrange() * drange().Num(), UOM: drange().UOM() }); };
    return { x: x, y: y, date: date, pier: pier };
}, 
// translate a mouse event into the appropriate model properties: a piergroup, a piermark and a date
translateEvent = function (pgs, scale) { return function (click) {
    var pg = null, x = 0, y = 0;
    for (var _i = 0, _a = Array.from(pgs); _i < _a.length; _i++) {
        var kvp = _a[_i];
        var el = kvp[1]();
        if (el) {
            var rect = el.getBoundingClientRect();
            if (click.clientY > rect.top && click.clientY < rect.bottom) {
                pg = kvp[0];
                x = click.clientX - rect.left;
                y = click.clientY - rect.top;
                break;
            }
        }
    }
    return pg === null ? null : {
        PierGroup: pg,
        PierMark: scale.pier(y).convert(pg.Length.UOM()),
        Date: scale.date(x),
        X: click.pageX,
        Y: click.pageY
    };
}; }, 
// given a model drag function, which takes a GridLocation, and a function to translate mouse events to GridLocations,
// initiate a drag
translateDrag = function (txevent, drag) {
    var mousemove = function (e) {
        var loc = txevent(e);
        if (loc)
            drag(loc);
        e.preventDefault();
    }, mouseup = function (e) {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
    };
    document.addEventListener("mousemove", mousemove);
    document.addEventListener("mouseup", mouseup);
}, translateTimelinePositionCoords = function (compact, scale, berthHeights, resOffsets) { return function (pos) {
    var id = pos.UniqueKey(), berth = pos.Berth(), length = pos.Length(), start = pos.Start(), end = pos.End();
    return {
        x: start ? scale.x(start) : 0,
        y: !compact() ? scale.y(pos.PierMark) : (berth ? berthHeights[berth.Id()].y : 0) + (COMPACT_RES_HEIGHT + COMPACT_OVERLAP_GAP) * resOffsets[id] + COMPACT_BERTH_HEIGHT / 2,
        width: start && end ? Math.max(20, scale.x(start, end)) : 0,
        height: compact() ? COMPACT_RES_HEIGHT : length ? Math.max(10, scale.y(length)) : 0
    };
}; };
exports.ScheduleGridView = supercritical_1.default(function (_a) {
    var model = _a.model;
    return React.createElement("div", { className: "schedulegrid" },
        React.createElement(exports.Header, { model: model }),
        React.createElement(exports.Grid, { model: model }),
        React.createElement(view_9.ErrorModal, { errors: model.Validation, shown: model.ShowErrorModal, title: "There are issues with your reservation" }),
        React.createElement(exports.AddBerthClosureModal, { vm: model }));
}), exports.Header = supercritical_1.default(function (_a) {
    var vm = _a.model;
    return React.createElement("div", { className: "carousel-container" },
        React.createElement("div", { className: "pc-actions-links-header header" },
            React.createElement(exports.Filter, { portFilter: vm.PortFilter, capabilityFilter: vm.CapabilityFilter }),
            React.createElement(view_1.ActionsMenuButton, { onClick: vm.ToggleActionsMenu }),
            React.createElement(exports.ActionsMenu, { model: vm })));
}), exports.ActionsMenu = supercritical_1.default(function (_a) {
    var vm = _a.model;
    return vm.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_7.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return vm.ShowActionsMenu(false); } },
                vm.CanReserveBerths() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "#!addportcall" }, "Add PortCall")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Create a new PortCall.")),
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(vm.MenuAction(vm.ToggleCompactView)) }, vm.CompactView() ? 'View Standard Timeline' : 'View Compact Timeline')),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Change view between the compact and standard timeline.")),
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(vm.MenuAction(vm.ToggleTallTimeline)) }, vm.ShowTallTimeline() ? 'View Standard Timeline' : 'View Taller Timeline')),
                    React.createElement("div", { className: "pc-action-item-descr" }, "Change view between the tall and standard timeline.")),
                (vm.CanAddBerthClosures() || vm.CanManageBerths() && vm.User()) &&
                    React.createElement("div", { className: "pc-admin-separator pc-card-admin-title" },
                        "Admin ",
                        React.createElement("div", { className: "pc-admin-line" })),
                vm.CanAddBerthClosures() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(vm.MenuAction(function () { return vm.ShowAddBerthClosure(true); })) }, "Add Closure")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Add a closure to one of your berths.")),
                vm.CanManageBerths() && vm.User() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "#!berthmgrdashboard?id=" + vm.User().OrganizationId() }, "View Dashboard")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "Manage reservations and services at your berths.")))) : null;
}), exports.Filter = supercritical_1.default(function (_a) {
    var portFilter = _a.portFilter, capabilityFilter = _a.capabilityFilter;
    return React.createElement("span", { className: "filters" },
        portFilter.ShowFilter() ?
            React.createElement("div", { className: "filter-port" },
                React.createElement(view_3.TypeaheadInput, { model: portFilter.Typeahead, className: "filter-ctrl port-filter", placeholder: "View by island or port" }),
                React.createElement("a", { href: "", className: "show-all", onClick: eventWrappers_1.noDefault(function (e) { return portFilter.Query(''); }) }, "Show All"),
                React.createElement("span", { className: "pipe" }, "|")) : null,
        React.createElement(view_3.TypeaheadInput, { model: capabilityFilter.Typeahead, className: "filter-ctrl type-filter", placeholder: "View by berth type" }),
        React.createElement("a", { href: "", className: "show-all", onClick: eventWrappers_1.noDefault(function (e) { return capabilityFilter.Query(''); }) }, "Show All"));
}), exports.Grid = supercritical_1.default(function (_a) {
    var model = _a.model;
    var scale = exports.translateScale(model.DateRange.FromDate, model.DateRange.Duration, function () { return window.innerWidth - model_1.berthBarWidth(window.innerWidth); }, function () { return new Measurement_1.Measurement({ Num: 100, UOM: UOM_1.default.Foot }); }, function () { return 30 * (model.ShowTallTimeline() ? 2 : 1); }, model.TZUtils), itemEls = ElMap(), toolEl = s_js_1.default.data(null), gridEl = s_js_1.default.value(null);
    // Scroll to the selected timeline item whenever we have a pending request to do so and the element is
    // available.
    s_js_1.default(function (lastReqIdCompleted) {
        var _a, _b;
        var reqId = model.ScrollToToolReqId();
        if (reqId !== null && reqId !== lastReqIdCompleted) {
            var tool = model.CurrentTool(), el = (_b = (_a = toolEl()) === null || _a === void 0 ? void 0 : _a.el) !== null && _b !== void 0 ? _b : ((tool === null || tool === void 0 ? void 0 : tool.TimelineItem) ? getElMap(itemEls, tool.TimelineItem) : null), grid = gridEl();
            if (el && grid) {
                var box = el.getBoundingClientRect(), headerHeight = grid.getBoundingClientRect().top + window.scrollY;
                if (box.top < headerHeight) {
                    window.scrollBy(0, box.top - headerHeight - 50); // 50 = leave a bit of space
                }
                else if (box.bottom > window.innerHeight) {
                    window.scrollBy(0, box.bottom - window.innerHeight + 50);
                }
                return reqId;
            }
            else {
                return lastReqIdCompleted;
            }
        }
        else {
            return lastReqIdCompleted;
        }
    }, null);
    return React.createElement("div", { className: "grid" },
        React.createElement(exports.GridHeader, { model: model, scale: scale }),
        React.createElement(exports.GridMain, { model: model, scale: scale, itemEls: itemEls, toolEl: toolEl, gridEl: gridEl }));
}), exports.GridHeader = /** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.calendarRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
            var model = _a.model;
            _this.calendar = window.kendo.jQuery(el).kendoDatePicker({
                change: function () {
                    var selectedDate = model.TZUtils.tzify(this.value());
                    var diff = selectedDate.getTime() - s_js_1.default.sample(model.DateRange.FromDate).getTime();
                    var diffInDays = Math.round(diff / (24 * 60 * 60 * 1000));
                    model.DateRange.ShiftDate(diffInDays);
                },
                open: function () {
                    this.value(model.TZUtils.localify(s_js_1.default.sample(model.DateRange.FromDate)));
                }
            }).data('kendoDatePicker');
        });
        return _this;
    }
    class_1.prototype.srender = function (_a) {
        var _this = this;
        var vm = _a.model, scale = _a.scale;
        var dayHeaderWidth = window.innerWidth > 480 ? window.innerWidth - 200 : window.innerWidth - 120;
        return (React.createElement("div", { className: "date-header" },
            React.createElement("div", { className: "dateselector" },
                React.createElement("div", { id: "selectorDate", className: "date-calendar pointer-cursor", onClick: eventWrappers_1.noDefault(function () { return _this.calendar.open(); }) },
                    React.createElement("span", { className: "glyphicon glyphicon-calendar" })),
                React.createElement("div", { className: "date-arrow", onClick: eventWrappers_1.noDefault(function () { return vm.DateRange.ShiftDate(-1); }) },
                    React.createElement("span", { className: "glyphicon glyphicon-chevron-left" })),
                React.createElement("div", { className: "date-text pointer-cursor", onClick: eventWrappers_1.noDefault(function () { return vm.DateRange.GoToToday(); }) }, "Today"),
                React.createElement("div", { className: "date-arrow", onClick: eventWrappers_1.noDefault(function () { return vm.DateRange.ShiftDate(1); }) },
                    React.createElement("span", { className: "glyphicon glyphicon-chevron-left mirror-glyphicon IE-mirror-glyphicon" })),
                React.createElement("div", { ref: this.calendarRef, className: "datepicker-widget" })),
            React.createElement("svg", { className: "days", height: "34", width: dayHeaderWidth }, vm.DateRange.Days().map(function (day) {
                var x = scale.x(day.Day), dayWidth = scale.x(day.NextDay) - x;
                return (React.createElement("svg", { key: +day.Day, className: "day" + (day.Today ? ' today' : ''), y: "0", x: x, width: dayWidth },
                    React.createElement("text", { className: "date", y: "23", textAnchor: "middle", x: dayWidth / 2 }, tzmoment_1.tzmoment(day.Day).format('MMM D ddd'))));
            }))));
    };
    return class_1;
}(supercritical_1.SuperCriticalComponent)), exports.GridMain = supercritical_1.default(function (_a) {
    var vm = _a.model, scale = _a.scale, itemEls = _a.itemEls, toolEl = _a.toolEl, gridEl = _a.gridEl;
    return React.createElement("div", { className: "main" },
        React.createElement("div", { className: "ports", ref: function (el) { return el && gridEl(el); } }, vm.Ports().filter(function (port) { return port.IsDisplayed(); }).map(function (port) {
            return React.createElement(exports.PortView, { key: port.Port.Id(), port: port, vm: vm, scale: scale, itemEls: itemEls, toolEl: toolEl });
        })));
}), exports.PortView = supercritical_1.default(function (_a) {
    var port = _a.port, vm = _a.vm, scale = _a.scale, itemEls = _a.itemEls, toolEl = _a.toolEl;
    return React.createElement("div", { key: port.Port.Id(), className: "port" },
        React.createElement(exports.PortHeader, { port: port, scale: scale }),
        React.createElement(exports.PortPierGroups, { port: port, vm: vm, scale: scale, itemEls: itemEls, toolEl: toolEl }));
}), exports.PortHeader = supercritical_1.default(function (_a) {
    var port = _a.port, scale = _a.scale;
    return React.createElement("div", { className: "port-header" }, port.Port.Name());
}), exports.PortPierGroups = supercritical_1.default(function (_a) {
    var port = _a.port, vm = _a.vm, scale = _a.scale, itemEls = _a.itemEls, toolEl = _a.toolEl;
    var 
    // Each piergroup's root element
    pgEls = ElMap(), 
    // Each piergroup's .timeline-items element
    pgItemsEls = ElMap(), bollardEls = ElMap(), txevent = exports.translateEvent(pgItemsEls, scale), tool = port.Tool();
    return (React.createElement("div", { className: cx("piergroups", {
            'changing-berth': tool instanceof model_1.ChangeBerthTool && tool.Seeking(),
            'adding-shift': tool instanceof model_1.AddShiftTool && tool.Dragging()
        }), onMouseMove: tool instanceof model_1.AddShiftTool ? function (e) { return tool.Drag(txevent(e)); } : undefined }, port.PierGroups().filter(function (pg) { return pg.IsDisplayed(); }).map(function (pg) {
        return React.createElement(exports.PortPierGroup, { key: pg.PierGroup.Id(), pg: pg, pgEls: pgEls, pgItemsEls: pgItemsEls, bollardEls: bollardEls, itemEls: itemEls, toolEl: toolEl, vm: vm, txevent: txevent, scale: scale });
    })));
}), exports.PortPierGroup = supercritical_1.default(function (_a) {
    var pg = _a.pg, pgEls = _a.pgEls, pgItemsEls = _a.pgItemsEls, bollardEls = _a.bollardEls, itemEls = _a.itemEls, toolEl = _a.toolEl, vm = _a.vm, txevent = _a.txevent, scale = _a.scale;
    var compact = vm.CompactView(), berthHeights = {}, resOffsets = {};
    var pgHeight = 0;
    for (var _i = 0, _b = pg.Berths(); _i < _b.length; _i++) {
        var b = _b[_i];
        var height = 0;
        if (compact) {
            // in compact view, our berth is sized visually to the number of overlapping items in it
            // pg.TimelineItems() is sorted in date order, so we scan through it and keep track of the number
            // of overlapping items
            var overlaps = [], maxOverlaps = 0;
            var _loop_1 = function (item) {
                var pos = item.TimelinePosition();
                if (pos.Berth() === b && pos.Start() && pos.End()) {
                    // remove any items from the list of overlaps which are now past
                    overlaps = overlaps.filter(function (d) { return d >= pos.Start(); });
                    // store the overlap of the current item, so we can draw it with the right vertical offset
                    resOffsets[pos.UniqueKey()] = overlaps.length;
                    // add the current berth to record its occupancy of the berth
                    overlaps.push(pos.End());
                    // update max depth of overlaps if needed
                    if (overlaps.length > maxOverlaps)
                        maxOverlaps = overlaps.length;
                }
            };
            for (var _c = 0, _d = pg.TimelineItems(); _c < _d.length; _c++) {
                var item = _d[_c];
                _loop_1(item);
            }
            height = (maxOverlaps === 0 && b.Length.Num() === 0) ? 0 :
                COMPACT_BERTH_HEIGHT + (maxOverlaps * COMPACT_RES_HEIGHT) + (maxOverlaps > 1 ? COMPACT_OVERLAP_GAP * (maxOverlaps - 1) : 0);
        }
        else {
            height = scale.y(b.Length);
        }
        berthHeights[b.Id()] = { y: pgHeight, height: height };
        pgHeight += height;
    }
    var txPosCoords = exports.translateTimelinePositionCoords(vm.CompactView, scale, berthHeights, resOffsets);
    return (React.createElement("div", { className: "piergroup", ref: function (el) { return setElMap(pgEls, pg.PierGroup, el); } },
        React.createElement("svg", { className: "berths", width: model_1.berthBarWidth(window.innerWidth), height: pgHeight },
            pg.Berths().map(function (b) {
                return React.createElement(exports.PortBerth, { key: b.Id(), berth: b, y: berthHeights[b.Id()].y, height: berthHeights[b.Id()].height, scale: scale });
            }),
            !compact && React.createElement(exports.PierGroupBollards, { pg: pg, scale: scale, bollardEls: bollardEls }),
            React.createElement(exports.BerthFootmarkSelection, { tool: pg.Tool, txPosCoords: txPosCoords })),
        React.createElement(exports.PierGroupTimelineItems, { pg: pg, height: pgHeight, berthHeights: berthHeights, txPosCoords: txPosCoords, pgItemsEl: elMapSlot(pgItemsEls, pg.PierGroup), itemEls: itemEls, toolEl: toolEl, vm: vm, txevent: txevent, scale: scale }),
        React.createElement(exports.BollardDescriptionTooltip, { pg: pg, pgEl: elMapSlot(pgEls, pg.PierGroup), bollardEls: bollardEls })));
}), exports.PortBerth = supercritical_1.default(function (_a) {
    var berth = _a.berth, y = _a.y, height = _a.height, scale = _a.scale;
    var tickDelta = 100, tickShift = berth.StartMark.Num() % tickDelta ? (tickDelta - (berth.StartMark.Num() % tickDelta)) : 0, // if our start mark isn't aligned on a tick, we need to shift the first tick accordingly
    tickMarks = _.range(berth.StartMark.Num() + tickShift, berth.StartMark.Num() + berth.Length.Num(), tickDelta), ticks = tickMarks.map(function (m) { return ({
        Mark: m,
        Major: m % (tickDelta * 5) === 0 && (m - berth.StartMark.Num()) > tickDelta && (berth.StartMark.Num() + berth.Length.Num() - m) > tickDelta,
        Y: scale.y(new Measurement_1.Measurement({ Num: m - berth.StartMark.Num(), UOM: berth.StartMark.UOM() }))
    }); });
    return (React.createElement("svg", { className: "berth", x: "0", y: y, width: model_1.berthBarWidth(window.innerWidth), height: height },
        React.createElement("rect", { className: "berthbox", x: "0", y: "0", width: model_1.berthBarWidth(window.innerWidth), height: "100%" }),
        React.createElement("text", { className: "berthlabel", x: "10", y: height <= COMPACT_BERTH_HEIGHT ? 11 : 20 },
            React.createElement('a', {
                className: 'name',
                xlinkHref: '#!berthprofile?id=' + berth.Id()
            }, [berth.Location() ? berth.Location().Name() : '']),
            React.createElement("tspan", { className: "length" }, ' ' + berth.Length.toString({ places: 0 }))),
        height <= COMPACT_BERTH_HEIGHT ? null :
            React.createElement("g", null,
                React.createElement("text", { className: "startmark", x: model_1.berthBarWidth(window.innerWidth) - 10, y: "10", textAnchor: "end" }, berth.StartMark.toString({ units: false, places: 0 })),
                React.createElement("text", { className: "endmark", x: model_1.berthBarWidth(window.innerWidth) - 10, textAnchor: "end", y: height - 5 }, berth.StartMark.add(berth.Length).toString({ units: false, places: 0 }))),
        height <= COMPACT_BERTH_HEIGHT + COMPACT_RES_HEIGHT ? null : ticks.map(function (tick) {
            return React.createElement("g", { key: tick.Mark },
                React.createElement("line", { className: "tick", x1: model_1.berthBarWidth(window.innerWidth) - 5, x2: model_1.berthBarWidth(window.innerWidth), y1: tick.Y, y2: tick.Y }),
                tick.Major ? React.createElement("text", { className: "ticklabel", x: "190", textAnchor: "end", y: tick.Y + 4 }, tick.Mark) : null);
        })));
}), exports.PierGroupBollards = supercritical_1.default(function (_a) {
    var pg = _a.pg, scale = _a.scale, bollardEls = _a.bollardEls;
    // We lift bollards out to their own <g> element outside of each berth's svg.berth element so that
    // they're visible even if the bollard's designated Footmark actually matches a DIFFERENT berth in
    // the piergroup.
    return React.createElement("g", null, pg.Bollards().map(function (bol) {
        return React.createElement("circle", { ref: function (el) { return setElMap(bollardEls, bol, el); }, key: bol.Id(), className: cx('bollard', bol.CssClass()), cx: model_1.berthBarWidth(window.innerWidth) - 12, cy: scale.y(bol.PierMark), r: 4, 
            // We create a tooltip-like effect via JS so we can piggyback on the same popup positioning
            // logic that we use for the various ITimelineItemTool impls.
            onMouseEnter: function () { return pg.SelectBollard(bol); }, onMouseLeave: function () { return pg.DeselectBollard(bol); } });
    }));
}), exports.BerthFootmarkSelection = supercritical_1.default(function (_a) {
    var _tool = _a.tool, txPosCoords = _a.txPosCoords;
    var tool = _tool(), sel = tool && tool.TimelineItem ? tool.TimelineItem.FootmarkSelection() : null, fm = sel && sel.Footmark, pos = sel && sel.Position, length = pos && pos.Length(), coords = pos && txPosCoords(pos);
    return !tool || !coords || !fm || !length ? null :
        React.createElement("g", null,
            React.createElement("line", { className: "selectedtick", x1: model_1.berthBarWidth(window.innerWidth) - 20, x2: model_1.berthBarWidth(window.innerWidth), y1: coords.y, y2: coords.y }),
            React.createElement("text", { className: "selectedticklabel", x: model_1.berthBarWidth(window.innerWidth) - 25, textAnchor: "end", y: coords.y + 4 }, fm.toString({ units: false, places: 0 })),
            React.createElement("line", { className: "selectedtick", x1: model_1.berthBarWidth(window.innerWidth) - 20, x2: model_1.berthBarWidth(window.innerWidth), y1: coords.y + coords.height, y2: coords.y + coords.height }),
            React.createElement("text", { className: "selectedticklabel", x: model_1.berthBarWidth(window.innerWidth) - 25, textAnchor: "end", y: coords.y + coords.height + 4 }, fm.add(length).toString({ units: false, places: 0 })));
}), exports.PierGroupTimelineItems = supercritical_1.default(function (_a) {
    var pg = _a.pg, height = _a.height, berthHeights = _a.berthHeights, txPosCoords = _a.txPosCoords, pgItemsEl = _a.pgItemsEl, itemEls = _a.itemEls, toolEl = _a.toolEl, vm = _a.vm, txevent = _a.txevent, scale = _a.scale;
    var width = scale.x(vm.DateRange.FromDate(), vm.DateRange.ToDate()), nowX = scale.x(vm.DateRange.Now);
    return (React.createElement("div", { className: "timeline-items", style: { height: height + 'px' }, ref: function (el) { return el && pgItemsEl(el); } },
        React.createElement("svg", { width: width, height: height, onClick: eventWrappers_1.noDefault(function (e) { return vm.OpenSpaceClick(txevent(e)); }) },
            vm.DateRange.Days().map(function (day) {
                var x = scale.x(day.Day), dayWidth = scale.x(day.NextDay) - x;
                return React.createElement("g", { key: +day.Day },
                    day.IsLoaded() ? null :
                        React.createElement("g", null,
                            React.createElement("foreignObject", { y: "10", height: "24", width: "24", x: x + dayWidth / 2 - 12 },
                                React.createElement("div", { className: "day-loading-indicator" }))),
                    React.createElement("line", { className: "day-divider", y1: "0", y2: "100%", x1: x + dayWidth, x2: x + dayWidth }));
            }),
            React.createElement("line", { className: "now", y1: "0", y2: "100%", x1: nowX, x2: nowX }),
            pg.Berths().map(function (b) {
                var geo = berthHeights[b.Id()];
                return (React.createElement("g", { key: b.Id() },
                    React.createElement("line", { className: "berth-divider", x1: "0", x2: "100%", y1: geo.y, y2: geo.y }),
                    React.createElement("line", { className: "berth-divider", x1: "0", x2: "100%", y1: geo.y + geo.height, y2: geo.y + geo.height })));
            }),
            React.createElement("g", null,
                pg.TimelineItems().map(function (item) {
                    var pos = item.TimelinePosition(), coords = txPosCoords(pos), key = pos.UniqueKey();
                    return (item.Type === "BR" /* BerthReservation */ ?
                        React.createElement(exports.Reservation, { key: key, res: item, vm: vm, scale: scale, txevent: txevent, coords: coords, itemEls: itemEls }) :
                        item.Type === "UR" /* UnlistedReservation */ ?
                            React.createElement(exports.UnlistedReservation, { key: key, unlistedReservation: item, vm: vm, scale: scale, coords: coords, itemEls: itemEls }) :
                            item.Type === "BCL" /* BerthClosure */ ?
                                React.createElement(exports.BerthClosureView, { key: key, closure: item, vm: vm, scale: scale, coords: coords, itemEls: itemEls }) :
                                null);
                }),
                React.createElement(exports.PierGroupNewReservation, { pg: pg, scale: scale, txevent: txevent, toolEl: toolEl }),
                React.createElement(exports.PierGroupAddShiftIndicator, { pg: pg, scale: scale, toolEl: toolEl }))),
        React.createElement(exports.PierGroupToolPopup, { pg: pg, itemEls: itemEls, pgItemsEl: pgItemsEl, toolEl: toolEl, model: vm })));
}), exports.UnlistedReservation = supercritical_1.default(function (_a) {
    var model = _a.unlistedReservation, vm = _a.vm, scale = _a.scale, coords = _a.coords, itemEls = _a.itemEls;
    var ur = model.UnlistedReservation, pg = ur.Berth() && ur.Berth().PierGroup(), x = coords.x, y = coords.y, width = coords.width, height = coords.height, pgHeight = pg ? scale.y(pg.Length) : 0, visibleHeight = Math.min(height, pgHeight - y), clippath = 'uresclippath-' + ur.Id(), schedAuth = ur.Berth() && ur.Berth().SchedulingAuthorityId();
    return (React.createElement("g", { className: cx("unlisted-reservation-container", {
            // DC 09/14/2017 -- Suppress Unlisted / Unavailable information when no Scheduling Authority present
            'unlisted-reservation-and-hidden': !schedAuth
        }) },
        React.createElement("svg", { className: "unlisted-reservation", x: x, y: y, width: width, height: height, 
            // NOTE: We don't apply "overflow: visible" to this particular element, so the Firefox
            // "overflow: visible" bug noted for the Reservation component below doesn't apply.
            ref: function (el) { return setElMap(itemEls, model, el); } },
            React.createElement("defs", null,
                React.createElement("clipPath", { id: clippath },
                    React.createElement("rect", { x: "0", y: "1", rx: "2", ry: "2", width: width, height: height }))),
            React.createElement("rect", { className: "resbox", x: "0", y: "1", rx: "2", ry: "2", width: width, height: height }),
            React.createElement("text", { className: "name", x: Math.max(10, -x), y: visibleHeight / 2, clipPath: 'url(#' + clippath + ')' }, "Berth Unavailable"),
            React.createElement("text", { className: "length", x: Math.max(10, -x), y: (visibleHeight / 2) + 15, clipPath: 'url(#' + clippath + ')' }, ur.Length.toString({ places: 0 })),
            React.createElement("rect", { className: "selectbox", x: "0", y: "0", onClick: eventWrappers_1.noPropagation(function () { return vm.TimelineItemClick(model); }), width: width, height: height }))));
}), exports.BerthClosureView = supercritical_1.default(function (_a) {
    var model = _a.closure, vm = _a.vm, scale = _a.scale, coords = _a.coords, itemEls = _a.itemEls;
    var bcl = model.BerthClosure, pg = bcl.Berth() && bcl.Berth().PierGroup(), x = coords.x, y = coords.y, width = coords.width, height = coords.height, pgHeight = pg ? scale.y(pg.Length) : 0, visibleHeight = Math.min(height, pgHeight - y), clippath = 'bclclippath-' + bcl.Id(), 
    // status flags
    // Consider both this closure's issues and issues any reservations might have
    // b/c of this closure as part of this closure's issue count.
    issueCount = bcl.Issues().length + bcl.ReservationIssues().length, invalid = !model.ValidForSubmit();
    return (React.createElement("g", { className: "berth-closure-container" },
        React.createElement("svg", { className: cx("berth-closure", { invalid: invalid }), x: x, y: y, width: width, height: height },
            React.createElement("defs", null,
                React.createElement("clipPath", { id: clippath },
                    React.createElement("rect", { x: "0", y: "1", rx: "2", ry: "2", width: width, height: height }))),
            React.createElement("rect", { className: "resbox", x: "0", y: "1", rx: "2", ry: "2", width: width, height: height, 
                // We apply "overflow: visible" to the parent <svg> element for berth closures, so
                // need the same Firefox workaround as for the Reservation component below.
                ref: function (el) { return setElMap(itemEls, model, el); } }),
            issueCount > 0 &&
                React.createElement("svg", { className: "badge issue-badge", x: width - 30, y: "0", width: "30", height: "30" },
                    React.createElement("circle", { cx: "14", cy: "16", r: "10" }),
                    React.createElement("text", { x: "14", y: "16", textAnchor: "middle", ref: function (el) { return el && el.setAttribute('dominant-baseline', "central"); } }, issueCount)),
            React.createElement("text", { className: "name", x: Math.max(10, -x), y: visibleHeight / 2, clipPath: 'url(#' + clippath + ')' },
                "Closure \u2014 ",
                bcl.Title()),
            React.createElement("rect", { className: "selectbox", x: "0", y: "0", onClick: eventWrappers_1.noPropagation(function () { return vm.TimelineItemClick(model); }), width: width, height: height }))));
}), exports.Reservation = supercritical_1.default(function (_a) {
    var model = _a.res, vm = _a.vm, scale = _a.scale, txevent = _a.txevent, coords = _a.coords, itemEls = _a.itemEls;
    var res = model.Reservation, pt = model.ItineraryPoint, berth = res.Berth(), pg = berth && berth.PierGroup(), pc = pt.PortCall(), tool = model.Tool(), 
    // position
    compact = vm.CompactView(), x = coords.x, y = coords.y, width = coords.width, height = coords.height, pgHeight = pg ? scale.y(pg.Length) : 0, visibleHeight = Math.min(height, pgHeight - y), bufferX = scale.x(pt.Arrival.Effective(), tzmoment_1.tzmomentMod(vm.TZUtils, pt.Arrival.Effective(), function (d) { return d.add(berth ? berth.TimeBuffer() : 0, 'minutes'); })), bufferY = berth ? scale.y(berth.LengthBuffer) : 0, showBufferShadow = tool instanceof model_1.EditTimeblockTool
        || tool instanceof model_1.ChangeBerthTool
        // TODO: I'm not seeing a visible shadow for the AddShiftTool. I haven't dug into why.
        // Is a shadow still desirable for the AddShiftTool, or can we maybe cut this line?
        || tool instanceof model_1.AddShiftTool && tool.Dragging(), clippath = 'resclippath-' + res.Id(), 
    // status flags
    pending = res.Status() === BerthReservation_1.BerthReservationStatus.Requested || res.Status() === BerthReservation_1.BerthReservationStatus.Conflicted, conflicted = res.Status() === BerthReservation_1.BerthReservationStatus.Conflicted, issueCount = res.Issues().length, future = res.Status() == BerthReservation_1.BerthReservationStatus.Booked && pt.Arrival.Actual() === null, inport = pt.Arrival.Actual() !== null && pt.Departure.Actual() === null, departed = pt.Arrival.Actual() !== null && pt.Departure.Actual() !== null, editingTimeblock = tool instanceof model_1.EditTimeblockTool, canEditArrival = pt.Arrival.Actual() === null ? model.Edit() : model.EditActuals(), canEditDeparture = pt.Departure.Actual() === null ? model.Edit() : model.EditActuals(), canDragTimeblock = canEditArrival && canEditDeparture, invalid = _.keys(model.Validation()).length !== 0;
    return (React.createElement("g", { className: "berth-reservation-container" },
        React.createElement("svg", { className: cx("reservation", { pending: pending, conflicted: conflicted, future: future, inport: inport, departed: departed, 'editing-timeblock': editingTimeblock, 'can-drag-timeblock': canDragTimeblock, invalid: invalid }), x: x, y: y, width: width, height: height },
            React.createElement("defs", null,
                React.createElement("clipPath", { id: clippath },
                    React.createElement("rect", { x: "0", y: "1", rx: "2", ry: "2", width: width, height: height }))),
            showBufferShadow &&
                React.createElement("rect", { className: cx('buffer-shadow', {
                        'attention-grabber': tool instanceof model_1.ChangeBerthTool && tool.Seeking() && tool.AttentionGrabber.Active()
                    }), rx: "2", ry: "2", x: -bufferX, y: compact ? 0 : -bufferY, width: width + (2 * bufferX), height: height + (compact ? 0 : 2 * bufferY), 
                    // If we have a buffer shadow, then make IT the popup target to avoid covering up
                    // the shadow w/ the popup.
                    ref: function (el) { return setElMap(itemEls, model, el); } }),
            React.createElement("rect", { className: "resbox", x: "0", y: "1", rx: "2", ry: "2", width: width, height: height, 
                // Use this <rect> element as the target for any <Popup />'s related to this
                // reservation. On most browsers, it would work just fine to target the parent <svg>
                // element instead, but on Firefox that interferes w/ popup positioning b/c we give
                // that element "overflow: visible" via CSS, and Firefox apparently has a bug
                // calculating the bounding client rect for <svg> elements that:
                // 1. Are nested within some other SVG content, AND
                // 2. Have x > 0 or y > 0, AND
                // 3. Have "overflow: visible", AND
                // 4. Have some displayed content. As in, not empty, not just a <rect> w/ height and width
                //    === 0, not just a <rect> w/ "display: none" applied, etc.
                // If the conditions above are met, then calling getBoundingClientRect() on the relevant
                // <svg> element returns a rect whose width and/or height are larger than they should
                // be, apparently b/c they incorporate the width/height above and/or to the left of the
                // relevant <svg> element (and sometimes some of the width/height below and/or to the
                // right of that element too). You can see the same thing if you inspect the relevant
                // <svg> element in Firefox's dev tools; pay attention to the screen area that Firefox
                // highlights when you hover over the element.
                // I've filed a bug report w/ Firefox about this. See
                // https://bugzilla.mozilla.org/show_bug.cgi?id=1709251
                // Fortunately, targeting this <rect> element works just fine on Firefox and other
                // browsers too. The only wrinkle is we'll switch up our target if we're rendering a
                // buffer shadow for this reservation; see a few lines above.
                ref: showBufferShadow ? undefined : function (el) { return setElMap(itemEls, model, el); } }),
            res.Rafting() ?
                React.createElement("svg", { className: "badge rafting-badge", x: width - 56, y: "0", width: "30", height: "30" },
                    React.createElement("circle", { cx: "14", cy: "16", r: "10" }),
                    React.createElement("text", { x: "14", y: "16", textAnchor: "middle", ref: function (el) { return el && el.setAttribute('dominant-baseline', "central"); } }, "R"))
                : null,
            issueCount > 0 ?
                React.createElement("svg", { className: "badge issue-badge", x: width - 30, y: "0", width: "30", height: "30" },
                    React.createElement("circle", { cx: "14", cy: "16", r: "10" }),
                    React.createElement("text", { x: "14", y: "16", textAnchor: "middle", ref: function (el) { return el && el.setAttribute('dominant-baseline', "central"); } }, issueCount))
                : null,
            React.createElement("text", { className: "name", x: Math.max(10, -x), y: visibleHeight / 2, clipPath: 'url(#' + clippath + ')' }, pc === null || pc === void 0 ? void 0 : pc.DisplayVesselIdentifier()),
            React.createElement("text", { className: "length", x: Math.max(10, -x), y: (visibleHeight / 2) + 15, clipPath: 'url(#' + clippath + ')' }, res.Length.toString({ places: 0 })),
            React.createElement("rect", { className: "selectbox", x: "0", y: "0", onMouseDown: tool instanceof model_1.EditTimeblockTool && canDragTimeblock
                    ? eventWrappers_1.noDefault(function (e) { return exports.translateDrag(txevent, tool.StartDragReservation(txevent(e), compact)); })
                    : undefined, onClick: eventWrappers_1.noPropagation(function () { return vm.TimelineItemClick(model); }), width: width - 0, height: height - 0 }),
            tool instanceof model_1.EditTimeblockTool ?
                React.createElement("g", null,
                    !canEditArrival ? null : [
                        React.createElement("circle", { className: "resize-handle", cx: "0", cy: "50%", r: "3" }),
                        React.createElement("rect", { className: "resize-zone", x: "-5", y: "0", height: "100%", width: "10", onMouseDown: eventWrappers_1.noDefault(function () { return exports.translateDrag(txevent, tool.DragDate(true)); }) })
                    ],
                    !canEditDeparture ? null : [
                        React.createElement("circle", { className: "resize-handle", cy: "50%", r: "3", cx: width }),
                        React.createElement("rect", { className: "resize-zone", y: "0", height: "100%", width: "10", x: width - 5, onMouseDown: eventWrappers_1.noDefault(function () { return exports.translateDrag(txevent, tool.DragDate(false)); }) })
                    ])
                : null),
        y < 0 ? React.createElement("text", { className: "overhang", textAnchor: "middle", x: x + width / 2, y: 8 }, "overhang") : null,
        y + height > pgHeight ? React.createElement("text", { className: "overhang", textAnchor: "middle", x: x + width / 2, y: pgHeight - 8 }, "overhang") : null));
}), exports.PierGroupNewReservation = supercritical_1.default(function (_a) {
    var pg = _a.pg, scale = _a.scale, txevent = _a.txevent, toolEl = _a.toolEl;
    var tool = pg.Tool();
    if (!(tool instanceof model_1.NewReservationTool))
        return null;
    var x = scale.x(tool.Arrival()), y = scale.y(tool.PierMark), width = scale.x(tool.Arrival(), tool.Departure()), height = scale.y(tool.Length);
    return React.createElement("svg", { className: "new-reservation", x: x - 5, y: y, height: height, width: width + 10, ref: function (el) { return setToolEl(toolEl, tool, el); }, onClick: eventWrappers_1.noPropagation(function () { }) },
        React.createElement("rect", { className: "outline", x: "5", y: "0", height: "100%", width: width }),
        React.createElement("foreignObject", { x: "5", y: "0", width: width, height: height },
            React.createElement("div", { style: { paddingLeft: '5px', paddingRight: '5px', height: height + 'px', width: width + 'px' } },
                React.createElement("span", { className: "length-available" },
                    "Max Length Available: ",
                    React.createElement("br", null),
                    tool.Length.toString({ places: 0 })))),
        React.createElement("circle", { className: "resize-handle", cx: "5", cy: "50%", r: "3" }),
        React.createElement("circle", { className: "resize-handle", cy: "50%", r: "3", cx: width + 5 }),
        React.createElement("rect", { className: "resize-zone", x: "0", y: "0", height: "100%", width: "10", onMouseDown: eventWrappers_1.noDefault(function () { return exports.translateDrag(txevent, tool.StartDateDrag(true)); }) }),
        React.createElement("rect", { className: "resize-zone", y: "0", height: "100%", width: "10", x: width, onMouseDown: eventWrappers_1.noDefault(function () { return exports.translateDrag(txevent, tool.StartDateDrag(false)); }) }));
}), exports.PierGroupAddShiftIndicator = supercritical_1.default(function (_a) {
    var pg = _a.pg, scale = _a.scale, toolEl = _a.toolEl;
    var tool = pg.Tool();
    if (!(tool instanceof model_1.AddShiftTool))
        return null;
    var x = scale.x(tool.Arrival()), y = scale.y(tool.PierMark), height = scale.y(tool.NewReservation.Length), width = scale.x(tool.Arrival(), tool.Departure());
    return (React.createElement("svg", { className: "new-shift-location" + (tool.Dragging() && tool.AttentionGrabber.Active() ? " attention-grabber" : ""), x: x, y: y, height: height, width: width, onClick: eventWrappers_1.noDefault(function () { return tool.OpenSpaceClick(); }), ref: function (el) { return setToolEl(toolEl, tool, el); } },
        React.createElement("rect", { className: "outline", x: "0", y: "0", height: "100%", width: "100%" }),
        tool.Dragging() ? React.createElement("text", { className: "click-label", textAnchor: "end", x: width - 20, y: height / 2 + 4 }, "CLICK TO ADD SHIFT") : null));
}), exports.PierGroupToolPopup = supercritical_1.default(function (_a) {
    var pg = _a.pg, pgItemsEl = _a.pgItemsEl, itemEls = _a.itemEls, _toolEl = _a.toolEl, m = _a.model;
    var tool = pg.Tool(), itemEl = (tool === null || tool === void 0 ? void 0 : tool.TimelineItem) && elMapSlot(itemEls, tool.TimelineItem), toolEl = function () { var _a, _b; return (_b = (_a = _toolEl()) === null || _a === void 0 ? void 0 : _a.el) !== null && _b !== void 0 ? _b : null; };
    return (tool instanceof model_1.NewReservationTool ? React.createElement(exports.NewReservationPopup, { tool: tool, model: m, target: toolEl, container: pgItemsEl }) :
        tool instanceof model_1.AddShiftTool && !tool.Dragging() ? React.createElement(exports.ConfirmAddShiftPopup, { tool: tool, model: m, target: toolEl, container: pgItemsEl }) :
            tool instanceof model_1.ReservationDetailsTool ? React.createElement(exports.ReservationDetailsPopup, { tool: tool, target: itemEl, container: pgItemsEl }) :
                tool instanceof model_1.UnlistedReservationDetailsTool ? React.createElement(exports.UnlistedReservationDetailsPopup, { tool: tool, target: itemEl, container: pgItemsEl }) :
                    tool instanceof model_1.BerthClosureDetailsTool ? React.createElement(exports.BerthClosureDetailsPopup, { tool: tool, vm: m, target: itemEl, container: pgItemsEl }) :
                        tool instanceof model_1.EditTimeblockTool ? React.createElement(exports.EditTimeBlockPopup, { tool: tool, model: m, target: itemEl, container: pgItemsEl }) :
                            tool instanceof model_1.ChangeBerthTool && !tool.Seeking() ? React.createElement(exports.ChangeBerthPopup, { tool: tool, model: m, target: itemEl, container: pgItemsEl }) :
                                tool instanceof model_1.ReservationOverlapsTool ? React.createElement(exports.ReservationOverlapsPopup, { tool: tool, target: itemEl, container: pgItemsEl }) :
                                    tool instanceof model_1.BerthClosureOverlapsTool ? React.createElement(exports.BerthClosureOverlapsPopup, { tool: tool, target: itemEl, container: pgItemsEl }) :
                                        null);
}), exports.Popup = /** @class */ (function (_super) {
    __extends(class_2, _super);
    function class_2(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = supercritical_1.SuperCriticalReference(_this, function (_a, popup) {
            var className = _a.className, _target = _a.target, _container = _a.container;
            s_js_1.default(function () {
                // Set default className early so that when we detect bounding client rects below, any
                // width/height assigned via CSS targeting the given className is already reflected, even
                // if target and container are both already available on the initial run. But be careful
                // not to clobber any "above" or "below" className we might've applied on an earlier run
                // of this computation, as that can be a performance killer, at least on Chrome.
                var defaultClassName = cx('schedule-popup-container', className);
                if (popup.className.indexOf(defaultClassName) !== 0)
                    popup.className = defaultClassName;
                var target = _target(), container = _container();
                if (!target || !container)
                    return;
                var tgt = target.getBoundingClientRect(), pop = popup.getBoundingClientRect(), cont = container.getBoundingClientRect();
                var 
                // How much of the popup would currently be offscreen if we placed it below
                offscreenIfBelow = Math.max(tgt.bottom + pop.height - window.innerHeight, 0), 
                // How much of the popup would currently be offscreen if we placed it above
                offscreenIfAbove = Math.max(pop.height - tgt.top, 0), 
                // How much of the popup would overflow the top of the document if we placed it above
                offDocumentIfAbove = Math.max(pop.height - tgt.top - document.documentElement.scrollTop, 0), 
                // Go above if that lets more of the popup be on screen than going below would. But go
                // below if going above would result in the popup overflowing the top of the document,
                // since users can always scroll down to view the whole popup if it hangs off the bottom
                // of the document, while the popup just becomes inaccessible if it hangs off the top of
                // the document.
                above = offscreenIfAbove < offscreenIfBelow && offDocumentIfAbove === 0, mid = (Math.min(cont.right, tgt.right) + Math.max(cont.left, tgt.left)) / 2, left = Math.min(Math.max(mid - pop.width / 2 - cont.left, -cont.left), cont.width - pop.width), // Prioritizing popup's right side for when the popup is larger than the screen
                top = (above ? Math.max(tgt.top, 0) - pop.height : Math.min(tgt.bottom, cont.bottom)) - cont.top, caretLeft = mid - cont.left - left;
                popup.style.left = left + 'px';
                popup.style.top = top + 'px';
                popup.className = cx(defaultClassName, above ? 'above' : 'below');
                var caret = popup.childNodes[0];
                caret.style.left = caretLeft + "px";
            });
        });
        return _this;
    }
    class_2.prototype.srender = function (_a) {
        var children = _a.children;
        // DON'T set className here, as it can clobber the className set via our SuperCriticalReference above.
        return React.createElement("div", { ref: this.ref },
            React.createElement("div", { className: "popup-caret" }),
            React.createElement("div", { className: "popup-content" }, children));
    };
    return class_2;
}(supercritical_1.SuperCriticalComponent)), exports.BollardDescriptionTooltip = supercritical_1.default(function (_a) {
    var pg = _a.pg, pgEl = _a.pgEl, bollardEls = _a.bollardEls;
    var bol = pg.SelectedBollard(), descr = bol === null || bol === void 0 ? void 0 : bol.Description();
    return descr ?
        React.createElement(exports.Popup, { className: "bollard-description-tooltip", target: elMapSlot(bollardEls, bol), container: pgEl }, descr) :
        null;
}), exports.UnlistedReservationDetailsPopup = supercritical_1.default(function (_a) {
    var ur = _a.tool.UnlistedReservation.UnlistedReservation, target = _a.target, container = _a.container;
    var schedAuth = ur.Berth() && ur.Berth().SchedulingAuthorityId();
    return (React.createElement(exports.Popup, { className: "timeline-tool-popup", target: target, container: container },
        React.createElement("div", { className: cx("unlisted-reservation-details", {
                // DC 09/14/2017 -- Suppress Unlisted / Unavailable information when no Scheduling Authority present
                'unlisted-reservation-and-hidden': !schedAuth
            }) },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" }, "Berth Unavailable")),
            React.createElement("div", { className: "content" },
                React.createElement("span", { className: "berth-label" }, ur.Berth() && ur.Berth().Location() && ur.Berth().Location().Name()),
                React.createElement("div", { className: "line-time" },
                    React.createElement("span", { className: "line-label" }, "Start"),
                    React.createElement("span", { className: "line-time" }, tzmoment_1.tzmoment(ur.Start()).format('MM/DD/YYYY [at] HH:mm'))),
                React.createElement("div", { className: "line-time" },
                    React.createElement("span", { className: "line-label" }, "End"),
                    React.createElement("span", { className: "line-time" }, tzmoment_1.tzmoment(ur.End()).format('MM/DD/YYYY [at] HH:mm')))))));
}), exports.BerthClosureDetailsPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, vm = _a.vm, target = _a.target, container = _a.container;
    return (React.createElement(exports.Popup, { className: cx('timeline-tool-popup', {
            'attention-grabber': tool.AttentionGrabber.Active()
        }), target: target, container: container },
        React.createElement("div", { className: "berth-closure-details" },
            React.createElement(exports.BerthClosureDetailsHeader, { tool: tool }),
            React.createElement("div", { className: "content" },
                React.createElement(exports.BerthClosureEditForm, { closure: tool.BerthClosure, vm: vm }),
                React.createElement(exports.BerthClosureDetailsSaveControls, { tool: tool })))));
}), exports.BerthClosureDetailsHeader = supercritical_1.default(function (_a) {
    var tool = _a.tool;
    return React.createElement("div", { className: "header" },
        tool.ShowConfirmDelete() ?
            React.createElement(exports.BerthClosureDetailsDeleteConfirmation, { tool: tool }) :
            // Show actions menu toggle provided there's at least one action available.
            // Keep in sync w/ BerthClosureDetailsActionsMenu below.
            tool.BerthClosure.Edit() || (tool.BerthClosure.Overlaps().length > 0 && !tool.BerthClosure.HasUnsavedChanges()) ?
                React.createElement("a", { href: "", className: "berth-closure-actions-menu-btn fa fa-bars", onClick: eventWrappers_1.noDefault(function () { return tool.ToggleActionsMenu(); }) }) :
                null,
        React.createElement(exports.BerthClosureDetailsActionsMenu, { tool: tool }));
}), exports.BerthClosureDetailsDeleteConfirmation = supercritical_1.default(function (_a) {
    var tool = _a.tool;
    return React.createElement("div", { className: "delete-closure-confirmation" },
        React.createElement("span", null, "Are you sure?"),
        ' ',
        React.createElement("a", { className: "delete-closure-confirmation-yes", href: "", onClick: eventWrappers_1.noDefault(function () { return tool.DeleteClosure(); }) }, "Yes"),
        ' ',
        React.createElement("a", { className: "delete-closure-confirmation-no", href: "", onClick: eventWrappers_1.noDefault(function () { return tool.ShowConfirmDelete(false); }) }, "No"));
}), exports.BerthClosureDetailsActionsMenu = supercritical_1.default(function (_a) {
    var tool = _a.tool;
    return tool.ShowActionsMenu() ?
        React.createElement(view_7.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return tool.ShowActionsMenu(false); } },
            tool.BerthClosure.Edit() &&
                React.createElement("div", { className: "action-item" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(tool.MenuAction(function () { return tool.ShowConfirmDelete(true); })) }, "Delete Closure")),
            tool.BerthClosure.Overlaps().length > 0 && !tool.BerthClosure.HasUnsavedChanges() &&
                React.createElement("div", { className: "action-item" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(tool.MenuAction(function () { return tool.ViewOverlaps(); })) }, "View Conflicts"))) :
        null;
}), exports.BerthClosureDetailsSaveControls = supercritical_1.default(function (_a) {
    var tool = _a.tool;
    return tool.BerthClosure.Edit() ?
        React.createElement("div", { className: "save-controls" },
            React.createElement("button", { className: "pc-button pc-button-primary", onClick: function () { return tool.BerthClosure.CommitChanges(); }, disabled: !tool.BerthClosure.HasUnsavedChanges() || !tool.BerthClosure.ValidForSubmit() }, "Update"),
            tool.BerthClosure.HasUnsavedChanges() &&
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return tool.BerthClosure.RevertChanges(); }) }, "Quit changes")) :
        null;
}), exports.ReservationDetailsPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, target = _a.target, container = _a.container;
    var res = tool.Reservation.Reservation, pt = tool.Reservation.ItineraryPoint, pc = pt.PortCall(), hasActuals = pt.Arrival.Actual() !== null || pt.Departure.Actual() !== null, hasEstimates = pt.Arrival.Actual() === null || pt.Departure.Actual() === null, hasOverlaps = tool.Reservation.Overlaps().length > 0;
    return (React.createElement(exports.Popup, { className: cx('timeline-tool-popup', {
            invalid: res.Status() === BerthReservation_1.BerthReservationStatus.Conflicted
        }), target: target, container: container },
        React.createElement("div", { className: "reservation-details" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" }, pc && pc.DisplayVesselIdentifier()),
                React.createElement("a", { className: "action", href: '#portcallprofile?id=' + pt.PortCallId() }, "View PortCall")),
            React.createElement("div", { className: "content" },
                React.createElement(view_5.IssuesShortSummary, { issues: res.Issues }),
                hasOverlaps ?
                    React.createElement("div", { className: "view-overlaps", onClick: eventWrappers_1.noDefault(function (e) { return tool.ViewOverlaps(); }) },
                        React.createElement("a", null, "View Overlap Conflicts"))
                    : null,
                pc === null ? null : pc.ActiveReservations().map(function (ores) {
                    return ores.Id() === res.Id() ?
                        React.createElement("div", { key: ores.Id(), className: "this-shift" },
                            React.createElement("span", { className: "berth-label" }, pt.Location() && pt.Location().Name()),
                            React.createElement("div", { className: "line-time" },
                                React.createElement("span", { className: "line-label" }, "First Line"),
                                React.createElement("span", { className: "line-time" }, tzmoment_1.tzmoment(pt.Arrival.Effective()).format('MM/DD/YYYY [at] HH:mm')),
                                pt.Arrival.Actual() ? React.createElement("span", { className: "log-actual" }, "Actual") : null,
                                pt.Arrival.Actual() === null && tool.Reservation.EditActuals()
                                    ? React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return tool.LogActual(true); }) }, "Log\u00A0Actual")
                                    : null),
                            React.createElement("div", { className: "line-time" },
                                React.createElement("span", { className: "line-label" }, "Last Line"),
                                React.createElement("span", { className: "line-time" }, tzmoment_1.tzmoment(pt.Departure.Effective()).format('MM/DD/YYYY [at] HH:mm')),
                                pt.Departure.Actual() ? React.createElement("span", { className: "log-actual" }, "Actual") : null,
                                pt.Departure.Actual() === null && tool.Reservation.EditActuals()
                                    ? React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return tool.LogActual(false); }) }, "Log\u00A0Actual")
                                    : null))
                        : React.createElement("div", { key: ores.Id(), className: "other-shift", onClick: eventWrappers_1.noDefault(function () { return tool.ShiftReservation(ores); }) },
                            React.createElement("a", null,
                                "View Shift - ",
                                ores.Itinerary() && ores.Itinerary().Location() && ores.Itinerary().Location().Name(),
                                " (",
                                ores.Itinerary() && tzmoment_1.tzmoment(ores.Itinerary().Arrival.Effective()).format('M/DD'),
                                ")"));
                })),
            React.createElement("div", { className: "footer" },
                tool.Reservation.Edit() && !hasActuals ? React.createElement("a", { className: "left-link", onClick: eventWrappers_1.noDefault(function () { return tool.ChangeBerth(); }) }, "Change Berth") : null,
                tool.Reservation.Edit() && hasEstimates || tool.Reservation.EditActuals()
                    ? React.createElement("a", { className: "center-link", onClick: eventWrappers_1.noDefault(function () { return tool.EditTimeblock(); }) }, "Edit Timeblock")
                    : null,
                tool.Reservation.Edit() ? React.createElement("a", { className: "right-link", onClick: eventWrappers_1.noDefault(function () { return tool.AddShift(); }) }, "Add Shift") : null))));
}), exports.NewReservationPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, m = _a.model, target = _a.target, container = _a.container;
    return React.createElement(exports.Popup, { className: "timeline-tool-popup", target: target, container: container },
        React.createElement("div", { className: "new-reservation" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" }, "New PortCall"),
                React.createElement("a", { className: "action", href: "#", onClick: eventWrappers_1.noDefault(function () { return tool.Reserve(); }) }, "Reserve Berth")),
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "input-group-title" }, "Line Times"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "First Line"),
                    React.createElement(view_4.DateTimePicker, { value: tool.Arrival, localization: m.Localization })),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "Last Line"),
                    React.createElement(view_4.DateTimePicker, { value: tool.Departure, localization: m.Localization })))));
}), exports.EditTimeBlockPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, m = _a.model, target = _a.target, container = _a.container;
    var res = tool.Reservation.Reservation, pt = tool.Reservation.ItineraryPoint, pc = pt.PortCall();
    return (React.createElement(exports.Popup, { className: cx('timeline-tool-popup editing', {
            invalid: res.Status() === BerthReservation_1.BerthReservationStatus.Conflicted,
            'attention-grabber': tool.AttentionGrabber.Active()
        }), target: target, container: container },
        React.createElement("div", { className: "edit-timeblock" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" },
                    "Edit - ",
                    pc && pc.DisplayVesselIdentifier())),
            React.createElement("div", { className: "content no-top-border" },
                React.createElement("div", { className: "input-group-title" }, "Line Times"),
                React.createElement("div", { className: "input-group first-line" },
                    React.createElement("span", { className: "input-group-addon" }, "First Line"),
                    React.createElement(view_4.DateTimePicker, { value: pt.Arrival.Effective, disabled: !!(pt.Arrival.Actual() && !tool.Reservation.EditActuals()), localization: m.Localization }),
                    pt.Arrival.Actual() ? React.createElement("span", { className: "log-actual" }, "Actual") : null,
                    pt.Arrival.Actual() && tool.Reservation.EditActuals() ? React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return pt.Arrival.Actual(null); }) }, "Remove") : null,
                    pt.Arrival.Actual() === null && tool.Reservation.EditActuals() ? React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return tool.LogActual(true); }) }, "Log\u00A0Actual") : null),
                React.createElement("div", { className: "input-group last-line" },
                    React.createElement("span", { className: "input-group-addon" }, "Last Line"),
                    React.createElement(view_4.DateTimePicker, { value: pt.Departure.Effective, disabled: !!(pt.Departure.Actual() && !tool.Reservation.EditActuals()), localization: m.Localization }),
                    pt.Departure.Actual() ? React.createElement("span", { className: "log-actual" }, "Actual") : null,
                    tool.Reservation.EditActuals()
                        ? pt.Departure.Actual()
                            ? React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return pt.Departure.Actual(null); }) }, "Remove")
                            : React.createElement("a", { className: "log-actual", onClick: eventWrappers_1.noDefault(function () { return tool.LogActual(false); }) }, "Log\u00A0Actual")
                        : null)),
            React.createElement("div", { className: "footer" },
                React.createElement("div", { className: "mode-footer" },
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Confirm(); }) }, "Confirm"),
                    " ",
                    "\u2022",
                    " ",
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Cancel(); }) }, "Quit Changes"))))));
}), exports.ChangeBerthPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, m = _a.model, target = _a.target, container = _a.container;
    var pt = tool.Reservation.ItineraryPoint, pc = pt.PortCall();
    return (React.createElement(exports.Popup, { className: cx('timeline-tool-popup editing', {
            'attention-grabber': tool.AttentionGrabber.Active()
        }), target: target, container: container },
        React.createElement("div", { className: "change-berth" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" },
                    "Change Berth - ",
                    pc && pc.DisplayVesselIdentifier())),
            React.createElement("div", { className: "content no-top-border" },
                React.createElement("div", { className: "input-group-title" }, "Line Times"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "First Line"),
                    React.createElement(view_4.DateTimePicker, { value: pt.Arrival.Effective, localization: m.Localization })),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "Last Line"),
                    React.createElement(view_4.DateTimePicker, { value: pt.Departure.Effective, localization: m.Localization }))),
            React.createElement("div", { className: "footer" },
                React.createElement("div", { className: "mode-footer" },
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Confirm(); }) }, "Confirm"),
                    " ",
                    "\u2022",
                    " ",
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Cancel(); }) }, "Quit Changes"))))));
}), exports.ConfirmAddShiftPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, m = _a.model, target = _a.target, container = _a.container;
    return React.createElement(exports.Popup, { className: cx('timeline-tool-popup editing', {
            'attention-grabber': tool.AttentionGrabber.Active()
        }), target: target, container: container },
        React.createElement("div", { className: "confirm-add-shift" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" },
                    "Add Shift - ",
                    tool.PortCall.DisplayVesselIdentifier())),
            React.createElement("div", { className: "content no-top-border" },
                React.createElement("div", { className: "input-group-title" }, "Line Times"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "First Line"),
                    React.createElement(view_4.DateTimePicker, { value: tool.Arrival, localization: m.Localization })),
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "input-group-addon" }, "Last Line"),
                    React.createElement(view_4.DateTimePicker, { value: tool.Departure, localization: m.Localization }))),
            React.createElement("div", { className: "footer" },
                React.createElement("div", { className: "mode-footer" },
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Confirm(); }) }, "Confirm"),
                    " ",
                    "\u2022",
                    " ",
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function (e) { return tool.Dragging(true); }) }, "Keep Looking"),
                    " ",
                    "\u2022",
                    " ",
                    React.createElement("a", { onClick: eventWrappers_1.noDefault(function () { return tool.Cancel(); }) }, "Quit Changes")))));
}), exports.ReservationOverlapsPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, target = _a.target, container = _a.container;
    var res = tool.Reservation.Reservation, 
    // Include this res in overlap list
    thisOverlap = { key: 0, issue: null, resId: res.Id(), res: res, bclId: 0, bcl: null }, overlaps = s_array_1.lift(function () { return [thisOverlap]; }).concat(tool.Reservation.Overlaps.map(function (i) { return ({
        key: i.Id(),
        issue: { i: i, dir: IssueDirection.OwnIssue },
        resId: i.OtherReservationId(),
        res: i.OtherReservation(),
        bclId: i.BerthReservationBerthClosureId(),
        bcl: i.BerthReservationBerthClosure()
    }); }));
    return React.createElement(exports.OverlapsPopup, { overlaps: overlaps, tool: tool, target: target, container: container });
}), exports.BerthClosureOverlapsPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, target = _a.target, container = _a.container;
    var bcl = tool.BerthClosure.BerthClosure, 
    // Include this closure in overlap list
    thisOverlap = { key: 0, issue: null, resId: 0, res: null, bclId: bcl.Id(), bcl: bcl }, overlaps = s_array_1.lift(function () { return [thisOverlap]; }).concat(tool.BerthClosure.Overlaps.map(function (i) { return ({
        key: i.Id(),
        issue: { i: i, dir: i.BerthClosureId() ? IssueDirection.OwnIssue : IssueDirection.OthersIssue },
        resId: i.BerthReservationId(),
        res: i.BerthReservation(),
        bclId: i.OtherClosureId(),
        bcl: i.OtherClosure()
    }); }));
    return React.createElement(exports.OverlapsPopup, { overlaps: overlaps, tool: tool, target: target, container: container });
}), exports.OverlapsPopup = supercritical_1.default(function (_a) {
    var tool = _a.tool, _overlaps = _a.overlaps, target = _a.target, container = _a.container;
    var overlaps = _overlaps();
    // Sort overlaps by conflict priority.
    // For reservations, there's an easy transitive ordering based on ApprovedDate and RequestDate that
    // agrees w/ our server-side issue severity logic.
    // For berth closures things are messier: Our server-side issue severity logic depends on the overlap
    // issue's DetectDate vs the reservation's ApprovedDate, and it turns out there's no transitive ordering
    // of closures and reservations that agrees w/ that logic in all cases (let alone agrees w/ that logic AND
    // w/ our logic for reservation-to-reservation overlaps). An example: Imagine an initial state where there
    // are two reservations, R1 and R2, neither of which has been approved, and two closures C1 and C2 such
    // that C1 overlaps R1 but not R2 and C2 overlaps R2 but not R1. (It doesn't matter in this case whether
    // R1 and R2 overlap each other or whether C1 and C2 overlap each other). Next, R1 is approved, giving it
    // priority over C1 by our server-side rules. Next, R2 is approved, giving it priority over C2 by our
    // server-side rules and also priority over R1 should they overlap. Next, C1 is extended such that it now
    // overlaps R2 in addition to still overlapping R1. Finally, C2 is extended such that it now overlaps R1
    // in addition to still overlapping R2. By our server-side rules, R2 now has a conflict due to C1, and R1
    // now has a conflict due to C2, even though R1's overlap w/ C1 and R2's overlap w/ C2 both have severity
    // Information. I.e. in terms of the relationship > meaning "has conflict priority over," we simultaneously
    // have R1 > C1, C1 > R2, R2 > C2, and C2 > R1 (and R2 > R1 based on approved date). We can't represent
    // that in a single linear ordering, so we'll say that in general closures have priority over reservations,
    // w/ an extra twist to make sure we sort whichever item is the subject of this popup in the correct order.
    // Then, finally, there are unlisted reservations. These show up w/ neither res nor bcl populated.
    // We'll arbitrarily sort them btwn approved reservations and non-approved ones, on the assumption
    // that it isn't that important for agents and other non-berth-mgrs to understand exactly where
    // unlisted reservations fit in the priority order.
    overlaps.sort(function (a, b) {
        // Special handling for the subject of the overlaps popup: If one of the items being compared
        // is the subject of this overlaps popup (as indicated by its i property being null), then sort
        // based on the severity of the issue.
        return a.issue && !b.issue ? a.issue.dir * (a.issue.i.Severity() >= Issue_1.IssueSeverity.Conflict ? -1 : 1) :
            !a.issue && b.issue ? b.issue.dir * (b.issue.i.Severity() >= Issue_1.IssueSeverity.Conflict ? 1 : -1) :
                // Reservation-to-reservation -- Sort based on ApprovedDate and RequestDate
                a.res && b.res ?
                    a.res.ApprovedDate() && !b.res.ApprovedDate() ? -1 :
                        !a.res.ApprovedDate() && b.res.ApprovedDate() ? 1 :
                            a.res.ApprovedDate() && b.res.ApprovedDate() ? +b.res.ApprovedDate() - +a.res.ApprovedDate() :
                                +a.res.RequestDate() - +b.res.RequestDate() :
                    // Reservation-to-closure -- Just say the closure wins, even though the server-side rules are
                    // actually more nuanced than this.
                    a.res && b.bcl ? 1 :
                        a.bcl && b.res ? -1 :
                            // Reservation-to-unlisted reservation -- Sort based on ApprovedDate
                            a.res && !b.res ? a.res.ApprovedDate() ? -1 : 1 :
                                !a.res && b.res ? b.res.ApprovedDate() ? 1 : -1 :
                                    // Closure-to-closure -- Just call it a tie.
                                    a.bcl && b.bcl ? 0 :
                                        // Closure-to-unlisted reservation -- Just say the closure wins.
                                        a.bcl && !b.res ? -1 :
                                            !a.res && b.bcl ? 1 :
                                                // Unlisted reservation-to-unlisted reservation -- Just call it a tie.
                                                0;
    });
    return (React.createElement(exports.Popup, { className: "timeline-tool-popup invalid", target: target, container: container },
        React.createElement("div", { className: "reservation-overlaps" },
            React.createElement("div", { className: "header" },
                React.createElement("span", { className: "timeline-tool-popup-label" },
                    "Overlap Conflicts (",
                    overlaps.length,
                    ")")),
            React.createElement("div", { className: "content" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: "vessel-name" }, "Reservation Order"),
                            React.createElement("th", { className: "request-time" }, "Requested"),
                            React.createElement("th", { className: "approved-time" }, "Booked"))),
                    React.createElement("tbody", null, overlaps.map(function (o) {
                        var onClick = o.resId ? function () { return tool.ViewConflictingReservation(o.resId); } :
                            o.bclId ? function () { return tool.ViewConflictingBerthClosure(o.bclId); } :
                                undefined, vesselName = o.res ? o.res.PortCall() && o.res.PortCall().DisplayVesselIdentifier() :
                            // \u2014 == emdash
                            o.bcl ? "Closure \u2014 " + o.bcl.Title() :
                                'Berth Unavailable', requestDate = o.res && o.res.RequestDate(), approvedDate = o.res && o.res.ApprovedDate();
                        return (React.createElement("tr", { key: o.key, className: "overlap", onClick: onClick && eventWrappers_1.noDefault(onClick) },
                            React.createElement("td", { className: "vessel-name" }, vesselName),
                            React.createElement("td", { className: "request-time" }, requestDate && priorityDateFormat(requestDate, tool.Now())),
                            React.createElement("td", { className: "approved-time" }, approvedDate && priorityDateFormat(approvedDate, tool.Now()))));
                    })))),
            React.createElement("div", { className: "footer" }))));
    function priorityDateFormat(date, now) {
        var diff = +now - +date, mins = Math.floor(diff / 60 / 1000), hours = Math.floor(diff / 60 / 60 / 1000), days = Math.floor(diff / 24 / 60 / 60 / 1000);
        return (mins === 1 ? '1 minute ago' :
            mins < 240 ? mins + " minutes ago" :
                hours < 48 ? hours + " hours ago" :
                    days + " days ago");
    }
}), exports.AddBerthClosureModal = supercritical_1.default(function (_a) {
    var vm = _a.vm;
    var model = vm.AddBerthClosure();
    return (React.createElement(view_8.PCModal, { shown: function () { return !!model; }, className: "add-berth-closure-modal", onBackDropClick: function () { return vm === null || vm === void 0 ? void 0 : vm.ShowAddBerthClosure(false); } },
        React.createElement("div", { className: "modal-content pc-card" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return vm.ShowAddBerthClosure(false); }) }, "<< Back")),
            React.createElement("div", { className: "modal-body" }, model &&
                React.createElement("div", null,
                    React.createElement(exports.BerthClosureEditForm, { closure: model, vm: vm }),
                    React.createElement("div", { className: "add-berth-closure-buttons" },
                        React.createElement("button", { className: "submit-btn pc-button pc-button-primary", onClick: function () { return model.Submit(); }, disabled: !model.ValidForSubmit() }, "Submit")))))));
}), exports.BerthClosureEditForm = supercritical_1.default(function (_a) {
    var model = _a.closure, vm = _a.vm;
    return React.createElement("div", { className: "berth-closure-edit-form" },
        React.createElement("div", { className: "berth-closure-header" }, "Berth Closure"),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label pc-text-smalllabel" }, "Title"),
            React.createElement(exports.BerthClosureTitleInput, { closure: model }),
            React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['Title']; } })),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label datetime-label pc-text-smalllabel" }, "Start"),
            React.createElement(view_4.DateTimePicker, { value: model.BerthClosure.StartDate, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit(), localization: vm.Localization }),
            React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['StartDate']; } })),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label datetime-label pc-text-smalllabel" }, "End"),
            React.createElement(view_4.NullableDateTimePicker, { value: model.BerthClosure.EndDate, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit(), localization: vm.Localization }),
            React.createElement("span", { className: cx("berth-closure-enddate-right-content", { "invalid-enddate": !!model.Validation()['EndDate'] }) },
                React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['EndDate']; } }),
                React.createElement("div", null, (model instanceof model_1.AddBerthClosureModel || model.Edit()) && model.BerthClosure.EndDate() &&
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return model.BerthClosure.EndDate(null); }) }, "Close Indefinitely")))),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label pc-text-smalllabel" }, "Berth"),
            React.createElement(view_2.BerthSelectorView, { className: "berth-closure-input", model: model.BerthSelector, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit() }),
            React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['BerthId']; } })),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label pc-text-smalllabel" }, "Footmark Start"),
            React.createElement(view_6.NumericInput, { className: "berth-closure-numeric-input", value: model.StartmarkNum, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit() }),
            React.createElement("span", { className: "berth-closure-uom" }, model.BerthClosure.Footmark.UOM()),
            React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['Footmark']; } })),
        React.createElement("div", { className: "berth-closure-edit-row" },
            React.createElement("label", { className: "berth-closure-label pc-text-smalllabel" }, "Footmark End"),
            React.createElement(view_6.NumericInput, { className: "berth-closure-numeric-input", value: model.EndmarkNum, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit() }),
            React.createElement("span", { className: "berth-closure-uom" }, model.BerthClosure.Footmark.UOM()),
            React.createElement(view_9.LightErrorView, { error: function () { return model.Validation()['Length']; } })),
        (model instanceof model_1.AddBerthClosureModel || model.Edit()) &&
            React.createElement("div", { className: "berth-closure-edit-row" },
                React.createElement("label", { className: "berth-closure-label pc-text-smalllabel" }, "Remarks"),
                React.createElement("textarea", { className: "berth-closure-multiline-input", rows: 4, value: model.BerthClosure.Remarks() || '', onChange: function (e) { return model.BerthClosure.Remarks(e.currentTarget.value); }, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit() })));
}), exports.BerthClosureTitleInput = (_a = /** @class */ (function (_super) {
        __extends(BerthClosureTitleInput, _super);
        function BerthClosureTitleInput(props) {
            var _this = _super.call(this, props) || this;
            // Focus the title input when opening the Add Closure modal. Can't do this via a
            // simple autoFocus property b/c of timing: Need to focus the input AFTER the modal
            // animation is complete.
            _this.inputRef = supercritical_1.SuperCriticalReference(_this, function (_a, el) {
                var closure = _a.closure;
                if (closure instanceof model_1.AddBerthClosureModel) {
                    var timeoutId_1 = setTimeout(function () { return el.focus(); }, BerthClosureTitleInput.FOCUS_DELAY_MS);
                    s_js_1.default.cleanup(function () { return clearTimeout(timeoutId_1); });
                }
            });
            return _this;
        }
        BerthClosureTitleInput.prototype.srender = function (_a) {
            var model = _a.closure;
            return (React.createElement("input", { type: "text", className: "berth-closure-input", ref: this.inputRef, value: model.BerthClosure.Title(), onChange: function (e) { return model.BerthClosure.Title(e.currentTarget.value); }, disabled: !(model instanceof model_1.AddBerthClosureModel) && !model.Edit() }));
        };
        return BerthClosureTitleInput;
    }(supercritical_1.SuperCriticalComponent)),
    // Long enough for the animation on modal opening to complete
    _a.FOCUS_DELAY_MS = 200,
    _a), exports.translateScale = translateScale, 
// translate a mouse event into the appropriate model properties: a piergroup, a piermark and a date
exports.translateEvent = translateEvent, 
// given a model drag function, which takes a GridLocation, and a function to translate mouse events to GridLocations,
// initiate a drag
exports.translateDrag = translateDrag, exports.translateTimelinePositionCoords = translateTimelinePositionCoords;
var IssueDirection;
(function (IssueDirection) {
    // NOTE: The sign of these values is significant. Check references before editing.
    /**
     * The owner of the issue is the subject of the overlaps popup.
     */
    IssueDirection[IssueDirection["OwnIssue"] = 1] = "OwnIssue";
    /**
     * The issue is owned by another item and is CAUSED by the subject of the
     * overlaps popup.
     */
    IssueDirection[IssueDirection["OthersIssue"] = -1] = "OthersIssue";
})(IssueDirection || (IssueDirection = {}));
function ElMap() {
    return new Map();
}
function setElMap(map, n, el) {
    // B/c we're using arrow functions for a lot of our React refs above, React sees a new function object each
    // time the ref is set, and as a result React conservatively calls the old ref function w/ null immediately
    // before it calls the new ref function. But if we get two calls to this function in the same tick of S's clock,
    // one w/ el set to null and one w/ it populatd, S will throw b/c we're setting the same signal to two different
    // values in the same clock tick. So ignore calls in which el is null. This util is intended for entities that
    // live as long as this page does, so we don't care about leaking destroyed elements.
    if (el)
        elMapSlot(map, n)(el);
}
function getElMap(map, n) {
    return elMapSlot(map, n)();
}
function elMapSlot(map, n) {
    var slot = map.get(n) || s_js_1.default.data(null);
    if (!map.has(n))
        map.set(n, slot);
    return slot;
}
function setToolEl(toolEl, tool, el) {
    // Like setElMap above, we gotta handle the possibility that React might trigger back-to-back calls to this
    // function, one w/ el set to null and one w/ it populated. But unlike setElMap, we DO wanna catch the case
    // where a tool element is getting destroyed, b/c we wanna know if there's a current tool element or not.
    // So debounce our writes to the toolEl signal.
    window.clearTimeout(setToolElTimeoutId);
    setToolElTimeoutId = window.setTimeout(function () {
        if (el)
            toolEl({ tool: tool, el: el });
        else if (s_js_1.default.sample(function () { var _a; return (_a = toolEl()) === null || _a === void 0 ? void 0 : _a.tool; }) === tool)
            toolEl(null);
    });
}


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCoordinations = exports.ScheduleDateCoordinationSelectionStorage = exports.AddCCardsRequestCoordinationSelectionStorage = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var memoize_1 = __webpack_require__(297);
var notNullish_1 = __webpack_require__(94);
var uniqueIndex_1 = __webpack_require__(70);
var AddCoordinationCardsRequest_1 = __webpack_require__(554);
var CoordinationCard_1 = __webpack_require__(109);
var CoordinationCurrency_1 = __webpack_require__(205);
var CoordinationProviderCurrency_1 = __webpack_require__(206);
function CoordinationSelectionDataEq(d1, d2) {
    return d1.ProviderId === d2.ProviderId;
}
/**
 * A `CoordinationSelectionStorageFactory` implementation backed by the provided `AddCoordinationCardsRequest`
 * instance. This implementation uses a keying strategy that assumes that all milestone dates encountered have
 * unique Ids, so it's best suited for working with milestone dates that have already been persisted.
 */
function AddCCardsRequestCoordinationSelectionStorage(_a) {
    var Request = _a.Request;
    var ccardReqIndex = uniqueIndex_1.default(Request.RequestedCards, AddCoordinationCardRequestKey);
    return function (date) {
        var foundCoordinations = s_js_1.default(function () {
            var found = new Set();
            for (var _i = 0, _a = date.CoordinationCards(); _i < _a.length; _i++) {
                var c = _a[_i];
                if (c.Coordination())
                    found.add(c.Coordination());
            }
            return found;
        });
        return function (coordination) {
            var ccardReq = ccardReqIndex(function () { return AvailableCoordinationKey(date, coordination); }), selection = s_js_1.default(function () { return ccardReq() && {
                ProviderId: ccardReq().ProviderId()
            }; });
            return {
                Selection: function (sel) {
                    return sel === undefined ? selection() :
                        s_js_1.default.sample(function () {
                            if (sel === null) {
                                if (ccardReq())
                                    Request.RequestedCards.remove(ccardReq());
                            }
                            else {
                                if (ccardReq()) {
                                    ccardReq().ProviderId(sel.ProviderId);
                                }
                                else {
                                    Request.RequestedCards.push(new AddCoordinationCardsRequest_1.AddCoordinationCardRequest({
                                        ScheduleDateId: date.Id(),
                                        CoordinationId: coordination.Id(),
                                        ProviderId: sel.ProviderId
                                    }));
                                }
                            }
                            return sel;
                        });
                },
                DuplicatesExistingCCard: function () { return foundCoordinations().has(coordination); }
            };
        };
    };
}
exports.AddCCardsRequestCoordinationSelectionStorage = AddCCardsRequestCoordinationSelectionStorage;
// NOTE: Make sure AddCoordinationCardRequestKey and AvailableCoordinationKey produce matching key formats.
function AddCoordinationCardRequestKey(ccardReq) {
    return ccardReq.ScheduleDateId() + ":" + ccardReq.CoordinationId();
}
function AvailableCoordinationKey(Date, Coordination) {
    return Date.Id() + ":" + Coordination.Id();
}
/**
 * A `CoordinationSelectionStorageFactory` implementation that stores selected coordinations inside the
 * `CoordinationCards` collection of encountered milestone dates. This implementation assumes it will only
 * encounter milestone dates that haven't been persisted yet.
 */
function ScheduleDateCoordinationSelectionStorage(_a) {
    return function (date) { return function (coordination) {
        var ccard = s_js_1.default(function () { var _a; return (_a = date.CoordinationCards().find(function (ccard) { return ccard.CoordinationId() === coordination.Id(); })) !== null && _a !== void 0 ? _a : null; }), selection = s_js_1.default(function () { return ccard() && {
            ProviderId: ccard().ProviderId()
        }; });
        return {
            Selection: function (sel) {
                return sel === undefined ? selection() :
                    s_js_1.default.sample(function () {
                        if (sel === null) {
                            if (ccard())
                                date.CoordinationCards.remove(ccard());
                        }
                        else {
                            if (ccard()) {
                                ccard().ProviderId(sel.ProviderId);
                            }
                            else {
                                date.CoordinationCards.push(new CoordinationCard_1.CoordinationCard({
                                    Id: 0,
                                    CoordinationId: coordination.Id(),
                                    ProviderId: sel.ProviderId
                                }));
                            }
                        }
                        return sel;
                    });
            },
            // B/c we're assuming we're dealing w/ non-persisted date entities, we can also assume that there
            // are no existing C-Cards for this milestone date.
            DuplicatesExistingCCard: function () { return false; }
        };
    }; };
}
exports.ScheduleDateCoordinationSelectionStorage = ScheduleDateCoordinationSelectionStorage;
function SelectCoordinations(metroMapFrameworkModel, metroMapMilestoneModel, _a) {
    var PortCall = _a.PortCall, SelectionStorage = _a.SelectionStorage;
    var 
    // Mini DI kernel...
    providerModel = function (p) { return CoordinationProviderViewModel(p); }, coordinationModel = memoize_1.memoize(function (c) { return CoordinationViewModel(providerModel, c); }), availableCoordinationModel = AvailableCoordination, milestoneModel = function (params) { return SelectCoordinationsMilestone(metroMapMilestoneModel, SelectionStorage, coordinationModel, availableCoordinationModel, params); }, Framework = metroMapFrameworkModel({
        PortCall: PortCall,
        MilestoneConstructor: milestoneModel
    }), IsValidForSubmit = Framework.Milestones.every(function (m) { return m.IsValidForSubmit(); }), HasActionableContent = Framework.Milestones.some(function (m) { return m.HasActionableContent(); });
    return {
        Framework: Framework,
        IsValidForSubmit: IsValidForSubmit,
        HasActionableContent: HasActionableContent
    };
}
exports.SelectCoordinations = SelectCoordinations;
function CoordinationViewModel(providerModel, Coordination) {
    var AvailableProviders = Coordination
        .Providers
        .filter(function (p) { return p.Currency() === CoordinationProviderCurrency_1.CoordinationProviderCurrency.Current; })
        .map(providerModel)
        .orderBy(function (p) { return p.Provider.DisplayOrder(); });
    return { Coordination: Coordination, AvailableProviders: AvailableProviders };
}
function CoordinationProviderViewModel(Provider) {
    return { Provider: Provider };
}
function SelectCoordinationsMilestone(metroMapMilestoneModel, SelectionStorage, coordinationModel, availableCoordinationModel, params) {
    var Date = params.Date, metroMapMilestone = metroMapMilestoneModel(params), storage = SelectionStorage(Date), AvailableCoordinations = s_array_1.lift(function () { var _a, _b; return (_b = (_a = Date.MilestoneType()) === null || _a === void 0 ? void 0 : _a.Coordinations().map(function (c) { return c.Coordination(); }).filter(notNullish_1.notNullish)) !== null && _b !== void 0 ? _b : []; })
        .filter(function (c) {
        return c.Currency() === CoordinationCurrency_1.CoordinationCurrency.Current &&
            c.AppliesToScheduleDate(Date);
    })
        .map(function (c) { return ({ c: c, storage: storage(c) }); })
        .filter(function (_a) {
        var storage = _a.storage;
        return !storage.DuplicatesExistingCCard();
    })
        .map(function (_a) {
        var c = _a.c, storage = _a.storage;
        return availableCoordinationModel({
            Coordination: coordinationModel(c),
            Storage: storage
        });
    })
        .orderBy(function (c) { return c.Coordination.Coordination.DisplayOrder(); }), IsValidForSubmit = AvailableCoordinations.every(function (c) { return c.IsValidForSubmit(); }), HasActionableContent = AvailableCoordinations.some(function (c) { return c.HasActionableContent(); });
    return __assign(__assign({}, metroMapMilestone), { AvailableCoordinations: AvailableCoordinations,
        IsValidForSubmit: IsValidForSubmit,
        HasActionableContent: HasActionableContent });
}
function AvailableCoordinationStateEq(state1, state2) {
    return (!state1.selected && !state2.selected ||
        state1.selected && state2.selected && !state1.data && !state2.data ||
        state1.selected && state2.selected && !!state1.data && !!state2.data && CoordinationSelectionDataEq(state1.data, state2.data));
}
/**
 * Is this `AvailableCoordinationState` valid for submitting to the server. Rules out the state where the given
 * coordination has been provisionally selected but the user hasn't provided all necessary selection data yet.
 */
function IsStateValidForSubmit(state) {
    return !state.selected || !!state.data;
}
function AvailableCoordination(_a) {
    var Coordination = _a.Coordination, Storage = _a.Storage;
    var State = s_js_1.default.value({ selected: false }, AvailableCoordinationStateEq), IsValidForSubmit = function () { return IsStateValidForSubmit(State()); }, HasActionableContent = function () {
        // Non-mandatory coordinations are actionable b/c users can toggle them on/off
        return !Coordination.Coordination.IsMandatory() ||
            // Coordinations w/ at least 2 providers are actionable b/c users can choose the provider
            Coordination.AvailableProviders().length > 1;
    };
    s_js_1.default(function () {
        // Having stored selection data ALWAYS means that the current state is selected. Note that the converse
        // does NOT hold; we can be selected w/o having had all necessary selection data entered.
        var sel = Storage.Selection();
        if (sel)
            State({ selected: true, data: sel });
    });
    s_js_1.default(function () {
        // Make sure Mandatory coordinations are auto-selected.
        if (Coordination.Coordination.IsMandatory() && !State().selected)
            State({ selected: true });
    });
    s_js_1.default(function () {
        // Auto-select the sole provider if the current state is selected and there's only one provider.
        if (State().selected && Coordination.AvailableProviders().length === 1) {
            Request(Coordination.AvailableProviders()[0].Provider.ProviderId());
        }
    });
    return {
        Coordination: Coordination,
        State: function () { return State(); },
        IsValidForSubmit: IsValidForSubmit,
        HasActionableContent: HasActionableContent,
        Request: Request,
        CancelRequest: CancelRequest
    };
    /**
     * Request this coordination for this milestone date, optionally specifying the desired providerId.
     */
    function Request(providerId) {
        if (providerId === undefined) {
            // Set State directly.
            State({ selected: true });
        }
        else {
            // Set State indirectly by notifying our backing storage of the selection.
            Storage.Selection({ ProviderId: providerId });
        }
    }
    /** Cancel the pending request for this coordination for this milestone date, if any. */
    function CancelRequest() {
        s_js_1.default.freeze(function () { return (State({ selected: false }), Storage.Selection(null)); });
    }
}


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectProfileImage = void 0;
var s_js_1 = __webpack_require__(0);
var Image_1 = __webpack_require__(284);
var model_1 = __webpack_require__(517);
function SelectProfileImage(ajax, entrypoints, cropImageModel, uploadFileModel, params) {
    var cropImageParams = s_js_1.default.data(null), imageCropper = s_js_1.default(function () { return cropImageParams() && cropImageModel(cropImageParams()); }), fileUploader = uploadFileModel({
        onComplete: UploadComplete
    });
    return {
        FileUploader: fileUploader,
        Image: params.image,
        CropUploadedImage: CropUploadedImage,
        SelectUploadedImage: SelectUploadedImage,
        DefaultImages: params.defaultImages.map(DefaultImageViewModel),
        ImageCropper: imageCropper,
        Hide: params.onHide
    };
    function UploadComplete(data) {
        OpenCropper(data);
    }
    function CropUploadedImage() {
        s_js_1.default.sample(function () {
            return OpenCropper({
                Url: (params.image.RawUrl() || '').split('?')[0],
                ImageWidth: params.image.RawWidth(),
                ImageHeight: params.image.RawHeight()
            }, new model_1.CropSelection(params.image.CropX1(), params.image.CropY1(), params.image.CropX2(), params.image.CropY2()));
        });
    }
    function OpenCropper(data, initialSelection) {
        if (initialSelection === void 0) { initialSelection = null; }
        cropImageParams(s_js_1.default.sample(function () { return ({
            imageUrl: data.Url || '',
            imageHeight: data.ImageHeight,
            imageWidth: data.ImageWidth,
            initialSelection: initialSelection,
            minSize: params.minimumImageUploadImageSize(),
            saveUrl: params.saveCroppedUploadUrl,
            onComplete: CropComplete,
            onCloseModal: function () { return cropImageParams(null); }
        }); }));
    }
    function CropComplete(data) {
        Image_1.Image.update(params.image, data);
    }
    function SelectUploadedImage() {
        if (!s_js_1.default.sample(function () { return params.image.UploadProfileUrl(); }))
            throw new Error('Can\'t select the last uploaded image b/c no image has been uploaded');
        SelectImage(function () { return params.image.UploadProfileUrl(); }, function () { return params.image.UploadThumbUrl(); });
    }
    function DefaultImageViewModel(defaultImage) {
        return {
            Model: defaultImage,
            Select: Select
        };
        function Select() {
            SelectImage(function () { return defaultImage.ProfileUrl() || ''; }, function () { return defaultImage.ThumbUrl() || ''; });
        }
    }
    function SelectImage(profileUrl, thumbUrl) {
        s_js_1.default.freeze(function () { return s_js_1.default.sample(function () {
            params.image.ProfileUrl(profileUrl());
            params.image.ThumbUrl(thumbUrl());
        }); });
        params.saveImageSelection();
    }
}
exports.SelectProfileImage = SelectProfileImage;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteAdminSettingsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1177);
var view_2 = __webpack_require__(12);
var SiteAdminSettingsRoute = function (appWrapper) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.SiteAdminSettingsView, null))
}); };
exports.SiteAdminSettingsRoute = SiteAdminSettingsRoute;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteAdminSettingsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var VesselStatus_1 = __webpack_require__(138);
exports.SiteAdminSettingsView = supercritical_1.default(function () {
    return React.createElement("div", { className: "siteadminsettings pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "#!morepage" }, "<< Back to More")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Site Admin Settings")),
        React.createElement("div", { className: "page-body pc-card" },
            React.createElement("div", { className: "setting-shell" },
                React.createElement("div", { className: "setting-link" },
                    React.createElement("a", { href: "#!berthlookups" }, "Berth Lookups")),
                React.createElement("div", { className: "setting-description pc-text-smalllabel" }, "Add, edit, and rearrange the order of port names and capabilities.")),
            React.createElement("div", { className: "setting-shell" },
                React.createElement("div", { className: "setting-link" },
                    React.createElement("a", { href: "#!manageberths" }, "Manage Berths")),
                React.createElement("div", { className: "setting-description pc-text-smalllabel" }, "Add, remove, rearrange, link, and view all of the berths in the system.")),
            React.createElement("div", { className: "setting-shell" },
                React.createElement("div", { className: "setting-link" },
                    React.createElement("a", { href: "#!pendingvesselservicelisting?status=" + VesselStatus_1.VesselStatusDisplayName[VesselStatus_1.VesselStatus.Pending] }, "Manage Pending Vessels")),
                React.createElement("div", { className: "setting-description pc-text-smalllabel" }, "Link Pending Vessels to Service Vessels"))));
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffLookups = void 0;
var UOM_1 = __webpack_require__(25);
var CargoActivityType_1 = __webpack_require__(280);
var CargoCategory_1 = __webpack_require__(281);
var TradeRoute_1 = __webpack_require__(292);
function TariffLookups(loader, ajax, data, orderableLookupsModel, _a) {
    var id = _a.id;
    var model = loader({ Id: id }, 30).model, CargoActivityLookups = orderableLookupsModel({
        supportsAdd: true,
        addClient: ajax.Url(function () { var _a; return (_a = model.CargoActivityTypesUrl()) !== null && _a !== void 0 ? _a : ''; }),
        items: model.CargoActivityTypes.filter(function (t) { return t.Active(); }),
        cacheCollection: data.CargoActivityTypes,
        orderProp: function (t) { return t.DisplayOrder; },
        itemFactory: function (order) { return new CargoActivityType_1.CargoActivityType({
            Id: 0,
            Active: true,
            Name: '--',
            DisplayOrder: order
        }); },
        itemKey: function (i) { return i.Id(); },
        deleteFn: function (_client, draft) { return draft.Active(false); }
    }), TradeRouteLookups = orderableLookupsModel({
        supportsAdd: true,
        addClient: ajax.Url(function () { var _a; return (_a = model.TradeRoutesUrl()) !== null && _a !== void 0 ? _a : ''; }),
        items: model.TradeRoutes.filter(function (t) { return t.Active(); }),
        cacheCollection: data.TradeRoutes,
        orderProp: function (t) { return t.DisplayOrder; },
        itemFactory: function (order) { return new TradeRoute_1.TradeRoute({
            Id: 0,
            Active: true,
            Name: '--',
            DisplayOrder: order
        }); },
        itemKey: function (i) { return i.Id(); },
        deleteFn: function (_client, draft) { return draft.Active(false); }
    }), CargoCategoryLookups = orderableLookupsModel({
        supportsAdd: true,
        addClient: ajax.Url(function () { return model.CargoCategoriesUrl() || ''; }),
        items: model.CargoCategories.filter(function (c) { return c.Active(); }),
        cacheCollection: data.CargoCategories,
        orderProp: function (c) { return c.DisplayOrder; },
        itemFactory: function (order) { return new CargoCategory_1.CargoCategory({
            Id: 0,
            Active: true,
            Name: '--',
            UOM: UOM_1.default.Ounce,
            DisplayOrder: order
        }); },
        itemKey: function (c) { return c.Id(); },
        deleteFn: function (_client, draft) { return draft.Active(false); }
    }), UOMOptions = [];
    var _loop_1 = function (uom) {
        UOMOptions.push({ name: function () { return UOM_1.default.Name[uom] + " (" + uom + ")"; }, value: function () { return uom; } });
    };
    for (var uom in UOM_1.default.Name) {
        _loop_1(uom);
    }
    return {
        Model: model,
        CargoActivityLookups: CargoActivityLookups,
        TradeRouteLookups: TradeRouteLookups,
        CargoCategoryLookups: CargoCategoryLookups,
        UOMOptions: UOMOptions
    };
}
exports.TariffLookups = TariffLookups;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffLookupsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1180);
var view_2 = __webpack_require__(12);
var TariffLookupsRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.TariffLookupsView, { model: model(inboundParams(request)) }))
}); };
exports.TariffLookupsRoute = TariffLookupsRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0)
    };
}


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffLookupsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var orgheaderview_1 = __webpack_require__(131);
var view_1 = __webpack_require__(273);
exports.TariffLookupsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "tarifflookups pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: '#!orgprofile?id=' + m.Model.Id() }, "<< Back to Organization")),
        React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Model }),
        React.createElement("div", { className: "page-body pc-card" },
            React.createElement(CargoActivitiesView, { model: m }),
            React.createElement(TradeRoutesView, { model: m }),
            React.createElement(CargoCategoriesView, { model: m })));
});
var CargoActivitiesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "cargoactivities" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Activities"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "List the cargo activities available at your berths. These options appear in the In Port Ops tab of the Berth Assignment details."),
        React.createElement(view_1.OrderableLookupsView, { model: m.CargoActivityLookups, columns: [{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: function (t) { return t.Name; }
                }], addBtnText: "+Add Activity" })));
});
var TradeRoutesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "traderoutes" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Trade Routes"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "List where your berths' cargo comes from and goes to. These routes appear in the In Port Ops tab of the Berth Assignment details. Leave empty to remove the Trade Routes field from the In Port Ops tab."),
        React.createElement(view_1.OrderableLookupsView, { model: m.TradeRouteLookups, columns: [{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: function (t) { return t.Name; }
                }], addBtnText: "+Add New Trade Route" })));
});
var CargoCategoriesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return (React.createElement("div", { className: "cargocategories" },
        React.createElement("h2", { className: "pc-card-title lookup-section-title" }, "Cargo Categories"),
        React.createElement("div", { className: "lookup-description pc-text-smalllabel" }, "List the categories of cargo at your berths. Each category has its own unit of measure. These categories appear in the In Port Ops tab of the Berth Assignment details."),
        React.createElement(view_1.OrderableLookupsView, { model: m.CargoCategoryLookups, columns: [{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: function (c) { return c.Name; }
                }, {
                    type: 'select',
                    title: 'Unit of Measure',
                    className: 'uom',
                    validationKey: 'UOM',
                    itemProp: function (c) { return c.UOM; },
                    options: function () { return m.UOMOptions; }
                }], addBtnText: "+Add Cargo Type" })));
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardListItem = void 0;
var s_js_1 = __webpack_require__(0);
function TopicCardListItem(tzutils, _a) {
    var draft = _a.draft, canConfirm = _a.canConfirm, clock = _a.clock;
    var comments = draft.Comments.sort(function (c1, c2) {
        // Sort by event date descending, w/ unknown events at the end
        return c1.Event() ?
            c2.Event() ?
                +c2.Event().Date() - +c1.Event().Date() :
                1 :
            c2.Event() ?
                -1 :
                0;
    }), mostRecentComment = s_js_1.default(function () { return comments().length > 0 ? comments()[0] : null; }), lastUpdated = s_js_1.default(function () { return mostRecentComment() && mostRecentComment().Event() && mostRecentComment().Event().Date() > draft.LastAnswer() ?
        mostRecentComment().Event().Date() : draft.LastAnswer(); });
    return {
        Model: draft,
        LastUpdated: lastUpdated,
        Now: function () { return clock.now(); },
        CanConfirm: canConfirm,
        Confirm: Confirm, Deny: Deny, WithdrawConfirmation: WithdrawConfirmation, WithdrawDenial: WithdrawDenial
    };
    function Confirm() {
        draft.ConfirmedDate(tzutils.now());
    }
    function Deny() {
        draft.DeniedDate(tzutils.now());
    }
    function WithdrawConfirmation() {
        draft.ConfirmedDate(null);
    }
    function WithdrawDenial() {
        s_js_1.default.freeze(function () {
            draft.DeniedDate(null);
            draft.ConfirmedDate(null);
        });
    }
}
exports.TopicCardListItem = TopicCardListItem;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var TopicCardsResponse_1 = __webpack_require__(593);
var TopicCardsCache = /** @class */ (function (_super) {
    __extends(TopicCardsCache, _super);
    function TopicCardsCache(data) {
        var _this = _super.call(this) || this;
        _this.TopicCardsResponses = PCCache_1.PCCollection(TopicCardsResponse_1.TopicCardsResponse);
        _this.TopicCardViewModels = PCCache_1.PCCollection(TopicCardsResponse_1.TopicCardViewModel);
        _this.ApplicableTopicCardTemplates = PCCache_1.PCCollection(TopicCardsResponse_1.ApplicableTopicCardTemplate);
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardsResponses, _this.TopicCardViewModels, function (r) { return r.TopicCards; }, null, function (c) { return c.PortCallId(); });
        new DataCache_1.ForeignKeyRelationship(_this.TopicCardsResponses, _this.ApplicableTopicCardTemplates, function (r) { return r.ApplicableTemplates; }, null, function (t) { return t.PortCallId(); });
        new DataCache_1.SharedKeyRelationship(_this.TopicCardsResponses, data.PortCalls, function (r) { return r.PortCall; }, null);
        new DataCache_1.SharedKeyRelationship(_this.TopicCardViewModels, data.TopicCards, function (vm) { return vm.Card; }, null);
        new DataCache_1.ForeignKeyRelationship(data.TopicCardTemplates, _this.ApplicableTopicCardTemplates, null, function (t) { return t.Template; }, function (t) { return t.TemplateId(); });
        new DataCache_1.ForeignKeyRelationship(data.Berths, _this.ApplicableTopicCardTemplates, null, function (t) { return t.Berth; }, function (t) { return t.BerthId(); });
        return _this;
    }
    return TopicCardsCache;
}(DataCache_1.DataCache));
exports.TopicCardsCache = TopicCardsCache;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCards = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var uniqueIndex_1 = __webpack_require__(70);
var Comment_1 = __webpack_require__(282);
var NewTopicCardRequest_1 = __webpack_require__(1292);
var TopicCard_1 = __webpack_require__(589);
var TopicCardQuestionType_1 = __webpack_require__(210);
var TopicCardsResponse_1 = __webpack_require__(593);
var TopicCardSelectedOption_1 = __webpack_require__(590);
function IsAnsweredCardKey(key) {
    return key.CardId !== undefined;
}
function TopicCards(loader, entrypoints, ajax, data, cache, domain, tzutils, localization, uploadFileModel, profilePopupModel, topicCardListItemModel, _a) {
    var id = _a.id, _cardKey = _a.selectedCard;
    var model = loader({ Id: id }, 30).model, portcall = data.PortCalls.update1(null, { Id: id }), addedCardIds = new Set(), removedTemplateIds = new Set(), serverTopicCardsIdx = uniqueIndex_1.default(model.TopicCards, function (c) { return c.Id(); }), clock = tzutils.clock(1000), // Clock for time ago text on answered card items and card logs
    cardParams = s_array_1.default([]), newTopicCardUrl = entrypoints.NewTopicCard({ Id: id }), selectedCardKey = s_js_1.default.data(_cardKey), cards = cardParams
        .map(function (params) { return TopicCardOrTemplate(params, ajax, data, cache, clock, newTopicCardUrl, serverTopicCardsIdx, addedCardIds, removedTemplateIds, selectedCardKey, uploadFileModel, profilePopupModel, topicCardListItemModel); })
        .sort(function (c1, c2) {
        return c1.Model.Title().toLowerCase() < c2.Model.Title().toLowerCase() ? -1
            : c1.Model.Title().toLowerCase() > c2.Model.Title().toLowerCase() ? 1
                : 0;
    }), answeredCards = cards.filter(function (c) { return c.IsAnswered(); }), defaultCards = cards.filter(function (c) { return !c.IsAnswered(); }), selectedCard = cards.find(function (c) {
        var sel = selectedCardKey();
        return IsAnsweredCardKey(sel) ?
            c.IsAnswered() && c.Model.Id() === sel.CardId
            : !c.IsAnswered() && c.Template.TemplateId() === sel.TemplateId && c.Template.BerthId() === sel.BerthId;
    }), showActionsMenu = s_js_1.default.data(false);
    portcall.TopicCards.forEach(function (card) {
        // Discover a new TopicCard...
        // If the user just answered this card, do nothing (we already have a TopicCardOrTemplate object for it).
        // Otherwise, add it.
        if (!addedCardIds.has(card.Id()))
            cardParams.push({ card: card });
    }, function (card) {
        // Don't expect TopicCards to ever get removed (they can't be deleted). Do nothing.
    });
    model.ApplicableTemplates.forEach(function (template) {
        // Discover a new ApplicableTopicCardTemplate...
        // Make a new TopicCardOrTemplate object for it.
        cardParams.push({ template: template });
    }, function (template) {
        // Removing an ApplicableTopicCardTemplate...
        // If the user just answered this template, do nothing (we want to keep the answered TopicCardOrTemplate object).
        // Otherwise, remove it.
        if (!removedTemplateIds.has(TopicCardsResponse_1.ApplicableTopicCardTemplate.key(template))) {
            var param = cardParams().find(function (p) { return p.template === template; });
            if (param)
                cardParams.remove(param);
        }
    });
    return {
        Id: id,
        Model: model,
        PortCall: portcall,
        AnsweredCards: answeredCards,
        DefaultCards: defaultCards,
        SelectedCardKey: selectedCardKey,
        SelectedCard: selectedCard,
        Domain: domain,
        Localization: localization,
        ShowActionsMenu: showActionsMenu,
        ToggleActionsMenu: ToggleActionsMenu,
        GetOrgId: GetOrgId,
        Now: function () { return clock.now(); },
        GoBack: function () { return window.history.back(); }
    };
    function ToggleActionsMenu() {
        showActionsMenu(!showActionsMenu());
    }
    function MenuAction(action) {
        return function () { return s_js_1.default.freeze(function () {
            action();
            showActionsMenu(false);
        }); };
    }
    function CanManageServices() {
        return model.CanManageServices();
    }
    function GetOrgId() {
        return model.GetOrgId();
    }
}
exports.TopicCards = TopicCards;
var cardOrTemplateReactKey = 0;
// A single model that can represent an answered TopicCard or an unanswered TopicCardTemplate
function TopicCardOrTemplate(_a, ajax, data, cache, clock, answerTemplateUrl, serverTopicCardsIdx, addedCardIds, removedTemplateIds, selectedCardKey, uploadFileModel, profilePopupModel, topicCardListItemModel) {
    var _card = _a.card, template = _a.template;
    var isAnswered = s_js_1.default.data(!!_card), card = _card || CardFromTemplate(template, isAnswered), client = ajax.Url(function () { return card.Url() || ''; }, { useCache: true }), answerTemplateClient = ajax.Url(answerTemplateUrl, {
        include: [function (r) { return r.Card; }, function (r) { return card.Comments; }]
    }), _b = draftSignals_1.DraftObject(card, [
        'ConfirmedDate',
        'DeniedDate',
        'IsYes',
        'TimeEntry.Response'
    ]), draft = _b.object, draftMethods = _b.methods, serverCard = serverTopicCardsIdx(card.Id), canEdit = function () {
        // i.e. permission to edit answered cards and answer unanswered cards
        return isAnswered() ?
            serverCard() ?
                serverCard().CanEdit() :
                false :
            template.CanAnswer();
    }, canComment = function () {
        // Anyone can comment on answered cards. Need answer permissions to comment on a template.
        return isAnswered() || template.CanAnswer();
    }, 
    // Can't confirm/deny unanswered cards
    canConfirm = function () { return serverCard() ? serverCard().CanConfirm() : false; }, canViewAttachments = function () {
        return serverCard() ?
            serverCard().CanConfirm() || serverCard().CanEdit() :
            false;
    }, listItem = topicCardListItemModel({ draft: draft, canConfirm: canConfirm, clock: clock }), newCardRequest = new NewTopicCardRequest_1.NewTopicCardRequest();
    var answerTemplateTask = null;
    var pendingAnswer = function () { return isAnswered() ? Promise.resolve() : answerTemplateTask ? answerTemplateTask : null; }, log = TopicCardOrTemplateLog(card, ajax, AnswerTemplate, pendingAnswer, uploadFileModel, profilePopupModel), selectedOption = s_js_1.default(function () { return card.SelectedOption() && TopicCardSelectedOptionModel(card.SelectedOption(), ajax, AnswerTemplate, pendingAnswer); });
    if (template) {
        // Initialize the newCardRequest object
        s_js_1.default(function () {
            if (!isAnswered()) {
                if (selectedOption())
                    newCardRequest.SelectedTemplateOptionId(selectedOption().OptionId());
                else
                    newCardRequest.SelectedTemplateOptionId(null);
            }
        });
        newCardRequest.Card(draft);
    }
    autoSave_1.AutoSaver(draftMethods.onWrite, Save);
    return {
        ReactKey: cardOrTemplateReactKey++,
        // key used when selecting this card from the card list
        SelectionKey: function () { return isAnswered() ? { CardId: card.Id() } : { TemplateId: template.TemplateId(), BerthId: template.BerthId() }; },
        Model: draft,
        ListItem: listItem,
        IsAnswered: isAnswered,
        Template: template,
        SelectedOption: selectedOption,
        Options: CardOrTemplateChildren(card.Options, function (t) { return t.Options; })
            .sort(function (o1, o2) { return o1.DisplayOrder() - o2.DisplayOrder(); }),
        AvailableAttachments: CardOrTemplateChildren(card.AvailableAttachments, function (t) { return t.Attachments; })
            .sort(function (a1, a2) { return a1.DisplayOrder() - a2.DisplayOrder(); }),
        People: CardOrTemplateChildren(card.People, function (t) { return t.People; })
            .filter(function (ua) { return !!ua.User() && ua.User().Active(); })
            .sort(function (ua1, ua2) {
            return ua1.User() ?
                ua2.User() ?
                    ua1.User().LastName().toLowerCase() < ua2.User().LastName().toLowerCase() ?
                        -1 :
                        ua1.User().LastName().toLowerCase() > ua2.User().LastName().toLowerCase() ?
                            1 :
                            0 :
                    -1 : // sort unpopulated users last
                ua2.User() ?
                    1 :
                    0;
        })
            .map(function (ua) { return UserAssignmentModel(ua, profilePopupModel); }),
        Log: log,
        CanEdit: canEdit,
        CanComment: canComment,
        CanConfirm: canConfirm,
        CanViewAttachments: canViewAttachments
    };
    function Save() {
        var checkpoint = draftMethods.checkpoint();
        return pendingAnswer() ?
            pendingAnswer().then(function () { return client.Put(draft); }).then(function () {
                checkpoint.commit();
            })
            : AnswerTemplate().then(function () {
                checkpoint.revert();
            });
    }
    function AnswerTemplate() {
        var templateKey = TopicCardsResponse_1.ApplicableTopicCardTemplate.key(template);
        var req = answerTemplateClient.Post(newCardRequest);
        return answerTemplateTask = req.then(function (json) { return s_js_1.default.freeze(function () {
            isAnswered(true);
            var ts = req.Date;
            data.TopicCards.update1(ts, json.Card, card);
            cache.TopicCardViewModels.update1(ts, Object.assign({}, json, { Card: null }));
            cache.ApplicableTopicCardTemplates.update(ts, [], [templateKey]);
            // Set flags so we know not to add/remove TopicCardOrTemplate models for the new TopicCard and the old ApplicableTopicCardTemplate
            addedCardIds.add(json.Id);
            removedTemplateIds.add(templateKey);
            // Also need to keep the current card selected
            selectedCardKey({ CardId: json.Id });
        }); });
    }
    function CardOrTemplateChildren(cardCollection, templateCollection) {
        return s_array_1.lift(function () { return isAnswered() ? cardCollection() : template.Template() ? templateCollection(template.Template())() : []; });
    }
}
function TopicCardSelectedOptionModel(selectedOption, ajax, answerTemplate, pendingAnswer) {
    var _a = draftSignals_1.DraftObject(selectedOption), draft = _a.object, draftMethods = _a.methods, client = ajax.Url(function () { return selectedOption.Url() || ''; }, { useCache: true });
    autoSave_1.AutoSaver(draftMethods.onWrite, Save);
    return draft;
    function Save() {
        var checkpoint = draftMethods.checkpoint();
        return pendingAnswer() ?
            pendingAnswer().then(function () { return client.Put(draft); }).then(function () {
                checkpoint.commit();
            })
            : answerTemplate().then(function () {
                checkpoint.revert();
            });
    }
}
function UserAssignmentModel(assignment, profilePopupModel) {
    var user = s_js_1.default(function () { return assignment.User() && UserModel(assignment.User(), profilePopupModel); });
    return {
        Model: assignment,
        User: user
    };
}
// Comments and TopicCardChanges
function TopicCardOrTemplateLog(card, ajax, answerTemplate, pendingAnswer, uploadFileModel, profilePopupModel) {
    var newComment = s_js_1.default.data(new Comment_1.Comment()), uploadFile = uploadFileModel({
        onComplete: function (json) { return newComment().AttachmentUrl(json.Url); }
    }), addCommentClient = ajax.Url(function () { return card.CommentsUrl() || ''; }, { useCache: true }), comments = card.Comments.map(function (c) { return CommentModel(c, profilePopupModel); }), changes = card.Changes.map(function (c) { return ChangeModel(c, profilePopupModel); }), combinedLog = comments
        .concat(changes)
        .sort(function (e1, e2) {
        return e1.Model.Event() ?
            e2.Model.Event() ?
                +e2.Model.Event().Date() - +e1.Model.Event().Date() :
                -1 : // sort unpopulated events last
            e2.Model.Event() ?
                1 :
                0;
    });
    return {
        LogEntries: combinedLog,
        NewComment: newComment,
        UploadFile: uploadFile,
        AddComment: AddComment
    };
    function AddComment() {
        var req = pendingAnswer() ?
            pendingAnswer().then(function () { return addCommentClient.Post(newComment()); })
            : AnswerTemplateWithComment();
        req.then(function () { return newComment(new Comment_1.Comment()); });
    }
    function AnswerTemplateWithComment() {
        card.Comments([newComment()]);
        return answerTemplate();
    }
}
function CommentModel(comment, profilePopupModel) {
    var commenter = s_js_1.default(function () { var _a; return ((_a = comment.Event()) === null || _a === void 0 ? void 0 : _a.User()) ? UserModel(comment.Event().User(), profilePopupModel) : null; });
    return {
        Model: comment,
        Commenter: commenter,
        Type: 'comment'
    };
}
function ChangeModel(change, profilePopupModel) {
    var changer = s_js_1.default(function () { return change.Event() && change.Event().User() && UserModel(change.Event().User(), profilePopupModel); });
    return {
        Model: change,
        Changer: changer,
        Type: 'change'
    };
}
function UserModel(user, profilePopupModel) {
    var showProfile = s_js_1.default.data(false), profilePopup = s_js_1.default(function () { return showProfile() ? profilePopupModel({ id: user.Id(), onHidePopup: function () { return showProfile(false); } }) : null; });
    return {
        Model: user,
        ToggleProfile: function () { return showProfile(!showProfile()); },
        ProfilePopup: profilePopup
    };
}
function CardFromTemplate(template, isAnswered) {
    var card = new TopicCard_1.TopicCard(s_js_1.default.sample(function () {
        return template.Template() ? template.Template().ToAnswerData(template.Berth) : { Id: 0 };
    }));
    s_js_1.default(function () {
        // TH 12/06/2016 -- Don't need to update from template anymore once the user answers the card.
        if (isAnswered())
            return;
        var t = template.Template();
        if (!t)
            return;
        // TH 12/08/2016 -- Our strategy is to do a shallow copy from the TopicCardTemplate to the
        // new TopicCard. So our view code will read TopicCard properties from the new card object.
        // But for child collections (Options, Attachments, People), we'll bind to the Template
        // collections until the card gets answered.
        TopicCard_1.TopicCard.update(card, t.ToAnswerData(template.Berth));
        s_js_1.default(function () {
            if (t.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.MultipleChoice) {
                var _options = t.Options().slice().sort(function (o1, o2) { return o1.DisplayOrder() - o2.DisplayOrder(); });
                card.SelectedOption(new TopicCardSelectedOption_1.TopicCardSelectedOption({
                    Id: 0,
                    // TH 12/06/2016 -- Select the first option by default.
                    // This is really an abuse of our schema, b/c TopicCardSelectedOption.OptionId
                    // is supposed to be a FK to a TopicCardOption, not a TopicCardTemplateOption.
                    // We'll use the TopicCardTemplateOption Id to pass w/ the NewTopicCardRequest,
                    // then switch to correctly using the TopicCardOption Id once the card gets answered.
                    OptionId: _options.length > 0 ? _options[0].Id() : 0
                }));
            }
            else {
                card.SelectedOption(null);
            }
        });
    });
    return card;
}


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardsRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var view_1 = __webpack_require__(12);
var view_2 = __webpack_require__(1185);
function TopicCardsRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(view_2.TopicCardsView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.TopicCardsRoute = TopicCardsRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0),
        selectedCard: request.params['templateId'] ?
            { TemplateId: +request.params['templateId'], BerthId: +(request.params['berthId'] || 0) || null }
            : { CardId: +(request.params['cardId'] || 0) }
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = '' + m.Id;
    var sel = m.SelectedCardKey();
    if (sel.CardId)
        params['cardId'] = '' + sel.CardId;
    if (sel.TemplateId)
        params['templateId'] = '' + sel.TemplateId;
    if (sel.BerthId)
        params['berthId'] = '' + sel.BerthId;
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardsView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var tzmoment_1 = __webpack_require__(9);
var TopicCardChangeType_1 = __webpack_require__(1402);
var TopicCardQuestionType_1 = __webpack_require__(210);
var TopicCardStatus_1 = __webpack_require__(137);
var view_1 = __webpack_require__(54);
var view_2 = __webpack_require__(60);
var view_3 = __webpack_require__(105);
var view_4 = __webpack_require__(533);
var view_5 = __webpack_require__(35);
var view_6 = __webpack_require__(52);
var view_7 = __webpack_require__(78);
var portcallheaderview_1 = __webpack_require__(537);
var view_8 = __webpack_require__(89);
var view_9 = __webpack_require__(548);
var view_10 = __webpack_require__(198);
exports.TopicCardsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "topiccards pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back"),
            React.createElement(view_1.ActionsMenuButton, { onClick: m.ToggleActionsMenu }),
            React.createElement(ActionsMenu, { model: m })),
        React.createElement(portcallheaderview_1.PortCallHeaderView, { portcall: m.PortCall, canEdit: m.Model.CanEditPortCall }),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card page-body" },
        React.createElement("div", { className: "pc-card-header pc-card-title" }, "Cards"),
        React.createElement(CardList, { model: m }),
        React.createElement(SelectedCardView, { model: m }));
});
var CardList = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "card-list" },
        React.createElement(CardSublist, { model: m, cards: m.AnsweredCards, title: "Answered" }),
        React.createElement(CardSublist, { model: m, cards: m.DefaultCards, title: "Default" }));
});
var CardSublist = supercritical_1.default(function (_a) {
    var m = _a.model, cards = _a.cards, title = _a.title;
    return React.createElement("div", { className: "card-sublist" },
        React.createElement("div", { className: "card-sublist-header pc-card-title" }, title),
        cards().map(function (card) {
            return React.createElement(CardListItem, { model: m, card: card, key: card.ReactKey });
        }));
});
var CardListItem = supercritical_1.default(function (_a) {
    var m = _a.model, card = _a.card;
    return React.createElement(view_4.PCAutoScroll, { keepInView: function () { return m.SelectedCard() === card; }, scrollParent: scrollParent, retriggerScroll: function () { m.AnsweredCards(); m.DefaultCards(); } /* Re-trigger if either sublist changes */ },
        React.createElement(view_9.TopicCardListItemView, { className: cx({ selected: m.SelectedCard() === card }), model: card.ListItem, hideLastUpdate: function () { return !card.IsAnswered(); }, onClick: function () { return m.SelectedCardKey(card.SelectionKey()); } }));
});
function scrollParent(el) {
    var parent = el.parentElement;
    while (parent && !parent.classList.contains('card-list')) {
        parent = parent.parentElement;
    }
    return parent;
}
var SelectedCardView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var c = m.SelectedCard();
    if (!c)
        return null;
    return (React.createElement("div", { className: "selected-card-edit" },
        React.createElement(CardTitle, { card: c }),
        React.createElement(CardBody, { model: m, card: c })));
});
var CardTitle = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "selected-card-title card-section-header" }, c.Model.Title());
});
var CardBody = supercritical_1.default(function (_a) {
    var m = _a.model, c = _a.card;
    return React.createElement("div", { className: "selected-card-body" },
        React.createElement("div", { className: "selected-card-particulars" },
            React.createElement(CardQuestionAndAnswer, { card: c }),
            React.createElement(CardTimeEntry, { model: m, card: c }),
            React.createElement(CardPeople, { card: c }),
            React.createElement(CardAvailableAttachments, { card: c }),
            React.createElement(CardRemarks, { card: c })),
        React.createElement(CardLog, { model: m, card: c }));
});
var CardQuestionAndAnswer = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "card-section card-question-and-answer" },
        React.createElement("div", { className: "card-section-body" },
            React.createElement("div", null, c.Model.Question()),
            React.createElement(CardAnswerView, { card: c })));
});
var CardAnswerView = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "card-answer" },
        c.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.YesNo &&
            React.createElement(view_8.ToggleButton, { checked: c.Model.IsYes, onLabel: "Yes", offLabel: "No", disabled: !c.CanEdit() }),
        c.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.MultipleChoice && c.Options().map(function (o) {
            return React.createElement(CardOptionView, { card: c, option: o, key: o.Id() });
        }));
});
var CardOptionView = supercritical_1.default(function (_a) {
    var c = _a.card, o = _a.option;
    var selected = c.SelectedOption();
    if (!selected)
        return null;
    return (React.createElement("div", { className: "card-option-row" },
        React.createElement("label", { className: "pc-radio pc-text-tinylabel" },
            React.createElement("input", { type: "radio", checked: selected.OptionId() === o.Id(), onChange: function (e) { return e.currentTarget.checked && selected.OptionId(o.Id()); }, disabled: !c.CanEdit() }),
            React.createElement("span", { className: "pc-radio-button" }),
            ' ',
            React.createElement("span", { className: "pc-text-tinylabel" }, o.Text()))));
});
var CardTimeEntry = supercritical_1.default(function (_a) {
    var m = _a.model, c = _a.card;
    if (!c.Model.TimeEntry.HasTimeEntry())
        return null;
    return (React.createElement("div", { className: "card-section card-time-entry" },
        React.createElement("div", { className: "card-section-header" }, c.Model.TimeEntry.EffectiveLabel()),
        React.createElement("div", { className: "card-section-body" },
            React.createElement(view_2.NullableDateTimePicker, { value: c.Model.TimeEntry.Response, disabled: !c.CanEdit(), localization: m.Localization }))));
});
var CardPeople = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "card-section card-people" },
        React.createElement("div", { className: "card-section-header" }, "People"),
        React.createElement("div", { className: "card-section-body" }, c.People().map(function (u) {
            return React.createElement(UserAssignmentView, { userAssignment: u, key: u.Model.UserId() });
        })));
});
var UserAssignmentView = supercritical_1.default(function (_a) {
    var u = _a.userAssignment;
    return React.createElement("div", { className: "user-assignment-row" },
        React.createElement(UserView, { user: u.User }));
});
var CardAvailableAttachments = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "card-section card-attachments" },
        React.createElement("div", { className: "card-section-header" }, "Attachments"),
        React.createElement("div", { className: "card-section-body" }, c.AvailableAttachments().map(function (a) {
            return React.createElement(CardAttachmentView, { attachment: a, canViewAttachments: true, key: a.Id() });
        })));
});
var CardAttachmentView = supercritical_1.default(function (_a) {
    var a = _a.attachment, canViewAttachments = _a.canViewAttachments;
    return React.createElement(AttachmentOrCommentAttachment, { url: a.AttachmentUrl(), filename: a.FileName(), canViewAttachments: canViewAttachments });
});
var CardRemarks = supercritical_1.default(function (_a) {
    var c = _a.card;
    return React.createElement("div", { className: "card-section card-remarks" },
        React.createElement("div", { className: "card-section-header" }, "Remarks"),
        React.createElement("div", { className: "card-section-body" }, c.Model.Remarks()));
});
var CardLog = supercritical_1.default(function (_a) {
    var m = _a.model, c = _a.card;
    return React.createElement("div", { className: "card-log" },
        React.createElement(NewCommentView, { card: c }),
        React.createElement("div", { className: "card-log-list" }, c.IsAnswered() && c.Log.LogEntries().map(function (e) {
            return React.createElement(CardLogEntryView, { model: m, entry: e, card: c, key: e.Model.EventId() });
        })));
});
var NewCommentView = supercritical_1.default(function (_a) {
    var c = _a.card;
    if (!c.CanComment())
        return null;
    return (React.createElement("div", { className: "new-comment" },
        React.createElement("div", null,
            React.createElement("textarea", { className: "new-comment-input", value: c.Log.NewComment().Message() || '', onChange: function (e) { return c.Log.NewComment().Message(e.currentTarget.value); }, placeholder: "Add a Comment", rows: 2 })),
        React.createElement("div", { className: "new-comment-controls" },
            c.Log.NewComment().AttachmentUrl() ?
                React.createElement("span", { className: "current-attachment" },
                    React.createElement("span", { className: "attachment-filename pc-text-fixedwidth" }, c.Log.NewComment().AttachmentFileName()),
                    React.createElement("a", { href: "", className: "remove-attachment pc-close-icon", onClick: eventWrappers_1.noDefault(function () { return c.Log.NewComment().AttachmentUrl(null); }) }))
                : React.createElement("span", { className: "add-attachment" },
                    React.createElement("label", { className: "add-attachment-link", htmlFor: c.Log.UploadFile.FileInputId() },
                        React.createElement("a", { className: "fa fa-paperclip" })),
                    React.createElement(view_10.UploadFileView, { model: c.Log.UploadFile })),
            React.createElement("button", { className: "add-comment-button pc-button", onClick: c.Log.AddComment, disabled: !c.Log.NewComment().Message() && !c.Log.NewComment().AttachmentUrl() }, "Add"))));
});
var CardLogEntryView = supercritical_1.default(function (_a) {
    var m = _a.model, e = _a.entry, c = _a.card;
    return React.createElement("div", { className: "card-log-entry" }, e.Type === 'comment' ?
        React.createElement(CommentView, { model: m, comment: e, card: c })
        : React.createElement(ChangeView, { model: m, change: e, card: c }));
});
var CommentView = supercritical_1.default(function (_a) {
    var m = _a.model, c = _a.comment, ca = _a.card;
    return React.createElement("div", null,
        React.createElement(UserAndTimestamp, { model: m, user: c.Commenter, hasUser: function () { return true; }, event: c.Model.Event }),
        React.createElement("div", null, c.Model.Message()),
        c.Model.AttachmentUrl() &&
            React.createElement(AttachmentOrCommentAttachment, { url: c.Model.AttachmentUrl(), filename: c.Model.AttachmentFileName(), canViewAttachments: ca.CanViewAttachments() }));
});
var ChangeView = supercritical_1.default(function (_a) {
    var m = _a.model, c = _a.change, card = _a.card;
    return React.createElement("div", null,
        React.createElement(UserAndTimestamp, { model: m, user: c.Changer, hasUser: function () { return !!(c.Model.Event() && c.Model.Event().UserId()); }, event: c.Model.Event }),
        React.createElement("div", null, c.Model.Type() === TopicCardChangeType_1.TopicCardChangeType.Creation ?
            CreationChangeText(c, card)
            : c.Model.Type() === TopicCardChangeType_1.TopicCardChangeType.YesNoAnswer ?
                YesNoAnswerChangeText(c.Model.NewIsYes)
                : c.Model.Type() === TopicCardChangeType_1.TopicCardChangeType.TimeEntry ?
                    TimeEntryChangeText(c.Model.NewTimeEntryResponse, card)
                    : c.Model.Type() === TopicCardChangeType_1.TopicCardChangeType.Status ?
                        StatusChangeText(c)
                        : c.Model.Type() === TopicCardChangeType_1.TopicCardChangeType.SelectedOption ?
                            SelectedOptionChangeText(c.Model.NewSelectedOption)
                            : null));
});
var UserAndTimestamp = supercritical_1.default(function (_a) {
    var m = _a.model, user = _a.user, hasUser = _a.hasUser, event = _a.event;
    return React.createElement("div", { className: "user-and-timestamp" },
        React.createElement("span", { className: "user-name" }, hasUser() ?
            React.createElement(UserView, { user: user })
            : React.createElement("span", { className: "domain-name" }, m.Domain.DisplayableUrl())),
        event() &&
            React.createElement(view_6.TimeAgoTooltip, { className: "timestamp pc-text-smalllabel pc-text-fixedwidth pc-text-fixedwidth-tooltip", date: event().Date, now: m.Now, useAbbreviatedTimeAgo: true }));
});
var UserView = supercritical_1.default(function (_a) {
    var user = _a.user;
    return user() &&
        React.createElement("span", { className: "user-view" },
            React.createElement("a", { href: "", className: "user-name pc-text-fixedwidth", onClick: eventWrappers_1.noDefault(user().ToggleProfile) }, user().Model.FullName()),
            React.createElement(view_7.PersonProfilePopupView, { modelContainer: user().ProfilePopup }));
});
var AttachmentOrCommentAttachment = supercritical_1.default(function (_a) {
    var url = _a.url, filename = _a.filename, canViewAttachments = _a.canViewAttachments;
    return React.createElement("div", { className: "card-attachment-row" }, canViewAttachments ?
        React.createElement("div", null,
            React.createElement(view_3.DownloadLink, { href: url, className: "attachment-icon fa fa-paperclip" }),
            React.createElement(view_3.DownloadLink, { href: url, className: "attachment-filename pc-text-fixedwidth" }, filename))
        :
            React.createElement("div", { className: "pc-text-fixedwidth" }, filename));
});
var ActionsMenu = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.ShowActionsMenu() ?
        React.createElement("div", { className: "pc-actions" },
            React.createElement(view_5.PCDismissible, { className: "pc-actions-menu pc-card", onDismiss: function () { return m.ShowActionsMenu(false); } },
                React.createElement("div", { className: "action-item" },
                    React.createElement("div", null,
                        React.createElement("a", { href: "#!portcallprofile?id=" + m.PortCall.Id() }, "View PortCall Profile")),
                    React.createElement("div", { className: "pc-action-item-descr" }, "View this PortCall's Profile.")),
                m.Model.CanManageServices() &&
                    React.createElement("div", { className: "action-item" },
                        React.createElement("div", null,
                            React.createElement("a", { href: "#!berthmgrdashboard?id=" + m.Model.GetOrgId() + "&tab=1", hidden: false }, "View on Services Dashboard")),
                        React.createElement("div", { className: "pc-action-item-descr" }, "View the services requested at your piers and jetties.")))) : null;
});
function CreationChangeText(c, card) {
    return (c.Model.OriginalCommentEventId() ? "Answered card with comment."
        : c.Model.OriginalTimeEntryResponse() ? TimeEntryChangeText(c.Model.OriginalTimeEntryResponse, card)
            : card.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.YesNo ? YesNoAnswerChangeText(c.Model.OriginalIsYes)
                : card.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.MultipleChoice ? SelectedOptionChangeText(c.Model.OriginalSelectedOption)
                    : 'Answered card.');
}
function YesNoAnswerChangeText(newIsYes) {
    return "Updated card to " + (newIsYes() ? 'Yes' : 'No') + ".";
}
function TimeEntryChangeText(newTimeEntryResponse, card) {
    return newTimeEntryResponse() ?
        "Updated " + card.Model.TimeEntry.EffectiveLabel() + " to " + tzmoment_1.tzmoment(newTimeEntryResponse()).format('MM/DD/YYYY [at] HH:mm') + "."
        : "Removed " + card.Model.TimeEntry.EffectiveLabel() + ".";
}
function StatusChangeText(c) {
    return (c.Model.NewStatus() === TopicCardStatus_1.TopicCardStatus.Confirmed ? 'Confirmed this service.'
        : c.Model.NewStatus() === TopicCardStatus_1.TopicCardStatus.Denied ? 'Denied this service.'
            : c.Model.NewStatus() === TopicCardStatus_1.TopicCardStatus.PendingReview ?
                c.Model.Event() && c.Model.Event().UserId() ?
                    "Withdrew service " + (c.Model.OldStatus() === TopicCardStatus_1.TopicCardStatus.Confirmed ? 'confirmation' : 'denial') + "."
                    : 'Reset status to pending.'
                : '');
}
function SelectedOptionChangeText(newSelectedOption) {
    return "Updated card to " + (newSelectedOption() && newSelectedOption().Text()) + ".";
}


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplates = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var Promise = __webpack_require__(41);
var draftSignals_1 = __webpack_require__(37);
var autoSave_1 = __webpack_require__(31);
var validationWatcher_1 = __webpack_require__(23);
var TopicCardQuestionType_1 = __webpack_require__(210);
var TopicCardTemplateOption_1 = __webpack_require__(591);
var TopicCardTemplateUserAssignment_1 = __webpack_require__(592);
var model_1 = __webpack_require__(153);
function TopicCardTemplates(loader, ajax, data, uploadFileModel, _a) {
    var id = _a.id, templateId = _a.templateId;
    var _b = loader({ Id: id }, 30), model = _b.model, loading = _b.loading, templatesClient = ajax.Url(function () { return model.TopicCardTemplatesUrl() || ''; }), selectedTemplateId = s_js_1.default.data(templateId), amenityTypes = model.BerthAmenityTypes.sort(function (a1, a2) { return a1.Order() - a2.Order(); }), templates = model.TopicCardTemplates
        .map(function (t) { return TopicCardTemplate(ajax, data, amenityTypes, uploadFileModel, function () { return selectedTemplateId(0); }, t, loading); })
        .filter(function (t) { return t.Model.Active(); })
        .sort(function (t1, t2) {
        return t1.Model.EffectiveTitle().toLowerCase() < t2.Model.EffectiveTitle().toLowerCase() ? -1
            : t1.Model.EffectiveTitle().toLowerCase() > t2.Model.EffectiveTitle().toLowerCase() ? 1
                : 0;
    }), selectedTemplate = templates.find(function (t) { return t.Model.Id() === selectedTemplateId(); });
    return {
        Id: id,
        Model: model,
        TopicCardTemplates: templates,
        SelectedTemplateId: selectedTemplateId,
        SelectedTemplate: selectedTemplate,
        AddTemplate: AddTemplate
    };
    function AddTemplate() {
        var req = templatesClient.Post({
            Id: 0,
            Active: true,
            Question: '--',
            QuestionType: TopicCardQuestionType_1.TopicCardQuestionType.YesNo,
            Title: '--'
        });
        req.then(function (json) {
            s_js_1.default.freeze(function () {
                data.TopicCardTemplates.update1(req.Date, json);
                selectedTemplateId(json.Id);
            });
        });
    }
}
exports.TopicCardTemplates = TopicCardTemplates;
function TopicCardTemplate(ajax, data, amenityTypes, uploadFileModel, deselectTemplate, template, loading) {
    var client = ajax.Url(function () { return template.Url() || ''; }), validation = validationWatcher_1.ValidationWatcher(client), draft = autoSave_1.AutoSavingDraftObject(template, client, [
        'AmenityTypeId',
        'Active',
        'Question',
        'QuestionType',
        'Remarks',
        'TimeEntry.HasTimeEntry',
        'TimeEntry.Label',
        'Title'
    ]), amenityLink = TopicCardTemplateAmenityLink(amenityTypes, draft), options = TopicCardTemplateOptionsSection(ajax, data, template, loading), people = TopicCardTemplatePeopleSection(ajax, data, template), attachments = TopicCardTemplateAttachmentsSection(ajax, data, uploadFileModel, template);
    draft.AmenityType = s_js_1.default.value(s_js_1.default.sample(template.AmenityType));
    data.TopicCardTemplates.attach(draft, [draft.AmenityType]);
    return {
        Model: draft,
        Validation: validation,
        AmenityLink: amenityLink,
        Options: options,
        People: people,
        Attachments: attachments,
        Delete: Delete
    };
    function Delete() {
        s_js_1.default.freeze(function () {
            draft.Active(false);
            deselectTemplate();
        });
    }
}
function TopicCardTemplateAmenityLink(amenityTypes, draft) {
    var showDropdown = s_js_1.default.data(s_js_1.default.sample(draft.AmenityTypeId) !== null), availableAmenityTypes = amenityTypes.filter(function (a) { return a.Active() || a.Id() === draft.AmenityTypeId(); });
    return {
        ShowDropdown: showDropdown,
        AvailableAmenityTypes: availableAmenityTypes,
        UndoAmenity: UndoAmenity
    };
    function UndoAmenity() {
        s_js_1.default.freeze(function () {
            draft.AmenityTypeId(null);
            showDropdown(false);
        });
    }
}
// Minimum number of slots shown for a template
var MIN_SLOTS = 3;
function TopicCardTemplateOptionsSection(ajax, data, template, loading // Is the page loading?
) {
    var addOptionsClient = ajax.Url(function () { return template.OptionsUrl() || ''; }), slotParams = s_array_1.default([]), slots = slotParams.map(function (params) { return TopicCardTemplateOptionSlot(ajax, data, addOptionsClient, params); });
    s_js_1.default(function () {
        // TH 12/07/2016 -- Switch between two different sources of updates for our slotParams.
        // While the page is loading, slotParams updates live from template.Options.
        // That way we get the latest options from the server.
        // After we're done loading, stop updating from template.Options, and instead switch on
        // logic for adding empty slots, that way users can start adding new options.
        // NOTE: This depends on the fact that the CachedModelLoader updates the loading signal
        // after an async delay from when it updates the cache.
        // So we'll always get a moment of time where template.Options is up-to-date and loading is still true.
        if (loading()) {
            var liveOptions_1 = template.Options
                .sort(function (o1, o2) { return o1.DisplayOrder() - o2.DisplayOrder(); })
                .map(function (o) { return ({ option: o, persisted: true }); });
            s_js_1.default(function () { return slotParams(liveOptions_1()); });
        }
        else {
            var lastSlot = slots().length > 0 ? slots()[slots().length - 1] : undefined;
            var displayOrder = lastSlot ? lastSlot.Model.DisplayOrder() + 1 : 0;
            for (var i = slots().length; i < MIN_SLOTS || lastSlot && lastSlot.IsPersisted() && i < slots().length + 1; i++) {
                slotParams.push({
                    option: new TopicCardTemplateOption_1.TopicCardTemplateOption({ Id: 0, DisplayOrder: displayOrder++ }),
                    persisted: false
                });
            }
        }
    });
    return {
        Slots: slots,
        DeleteSlot: DeleteSlot
    };
    function DeleteSlot(_slot) {
        _slot.Delete(function () { return slotParams.remove(_slot.Params); });
    }
}
var slotId = 0;
function TopicCardTemplateOptionSlot(ajax, data, addClient, params) {
    // TH 11/30/2016 -- Support UX where typing into the text box upserts the option and clearing the text box deletes it.
    // All w/ a debounced save (via autoSave.ts).
    var option = params.option, initialPersisted = params.persisted, isPersisted = s_js_1.default.data(initialPersisted), client = ajax.Url(function () { return option.Url() || ''; }), validation = validationWatcher_1.ValidationWatcher(client), _a = draftSignals_1.DraftObject(option), draft = _a.object, draftMethods = _a.methods;
    autoSave_1.AutoSaver(draftMethods.onWrite, Save);
    return {
        // TH -- Give each slot a unique id for React keying purposes
        SlotId: slotId++,
        Params: params,
        Model: draft,
        Validation: validation,
        IsPersisted: isPersisted,
        Delete: Delete
    };
    function Save() {
        var checkpoint = draftMethods.checkpoint();
        // "Saving" an unpersisted option w/ no Text is a noop
        if (!isPersisted() && !draft.Text()) {
            checkpoint.revert();
            return Promise.resolve();
        }
        if (isPersisted()) {
            return client.Put(draft).then(function () {
                checkpoint.commit();
            });
        }
        else {
            var req_1 = addClient.Post(draft);
            return req_1.then(function (json) { return s_js_1.default.freeze(function () {
                isPersisted(true);
                // TH 12/01/2016 -- NOTE Passing the unpersisted option object as the template param.
                data.TopicCardTemplateOptions.update1(req_1.Date, json, option);
                checkpoint.revert();
            }); });
        }
    }
    function Delete(removeSlot) {
        var id = option.Id(), req = client.Delete();
        req.then(function () { return s_js_1.default.freeze(function () {
            data.TopicCardTemplateOptions.update(req.Date, [], [id]);
            removeSlot();
        }); });
    }
}
function TopicCardTemplatePeopleSection(ajax, data, template) {
    var availableUsers = s_js_1.default(function () { return Array.from(data.PCUsers.items())
        .filter(function (u) {
        var assignmentKey = TopicCardTemplateUserAssignment_1.TopicCardTemplateUserAssignment.dataKey({ TemplateId: template.Id(), UserId: u.Id() });
        // Only active users who aren't assigned to this template
        return u.Active() && !data.TopicCardTemplateUserAssignments.index(assignmentKey)();
    }); }), selectedUserId = s_js_1.default.value(0), userSelector = model_1.UserSelector({
        Users: availableUsers,
        UserId: selectedUserId
    });
    var lastRequest = Promise.resolve();
    s_js_1.default(function () {
        if (selectedUserId()) {
            var url = (template.PeopleUrlBase() || '').replace('{userId}', '' + selectedUserId()), client_1 = ajax.Url(url);
            lastRequest.finally(function () {
                var req = client_1.Put({});
                lastRequest = req.then(function (json) {
                    data.TopicCardTemplateUserAssignments.update1(req.Date, json);
                });
            });
            // Clear typeahead value
            userSelector.data('');
        }
    });
    return {
        People: template.People
            .filter(function (ua) { return !!ua.User() && ua.User().Active(); })
            .sort(function (ua1, ua2) {
            return ua1.User() ?
                ua2.User() ?
                    ua1.User().LastName().toLowerCase() < ua2.User().LastName().toLowerCase() ?
                        -1 :
                        ua1.User().LastName().toLowerCase() > ua2.User().LastName().toLowerCase() ?
                            1 :
                            0 :
                    -1 : // sort unpopulated users last
                ua2.User() ?
                    1 :
                    0;
        })
            .map(function (p) { return TopicCardTemplateUserAssignment(ajax, data, p); }),
        UserSelector: userSelector
    };
}
function TopicCardTemplateUserAssignment(ajax, data, assignment) {
    var client = ajax.Url(function () { return assignment.Url() || ''; });
    return {
        Model: assignment,
        Delete: Delete
    };
    function Delete() {
        var id = TopicCardTemplateUserAssignment_1.TopicCardTemplateUserAssignment.key(assignment), req = client.Delete();
        req.then(function () {
            data.TopicCardTemplateUserAssignments.update(req.Date, [], [id]);
        });
    }
}
function TopicCardTemplateAttachmentsSection(ajax, data, uploadFileModel, template) {
    var client = ajax.Url(function () { return template.AttachmentsUrl() || ''; }), saving = s_js_1.default.data(false), uploadFile = uploadFileModel({
        onComplete: function (_a) {
            var Url = _a.Url;
            saving(true);
            var req = client.Post({
                Id: 0,
                AttachmentUrl: Url || '',
                DisplayOrder: NextDisplayOrder()
            });
            req.then(function (json) {
                data.TopicCardTemplateAttachments.update1(req.Date, json);
            }).finally(function () { return saving(false); });
        }
    });
    return {
        Attachments: template.Attachments
            .sort(function (a1, a2) { return a1.DisplayOrder() - a2.DisplayOrder(); })
            .map(function (a) { return TopicCardTemplateAttachment(ajax, data, a); }),
        Saving: saving,
        UploadFile: uploadFile
    };
    function NextDisplayOrder() {
        return template.Attachments().length > 0 ?
            Math.max.apply(Math, template.Attachments().map(function (a) { return a.DisplayOrder(); })) + 1 : 0;
    }
}
function TopicCardTemplateAttachment(ajax, data, attachment) {
    var client = ajax.Url(function () { return attachment.Url() || ''; });
    return {
        Model: attachment,
        Delete: Delete
    };
    function Delete() {
        var id = attachment.Id(), req = client.Delete();
        req.then(function () {
            data.TopicCardTemplateAttachments.update(req.Date, [], [id]);
        });
    }
}


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplatesRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var view_1 = __webpack_require__(12);
var view_2 = __webpack_require__(1188);
function TopicCardTemplatesRoute(model, appWrapper, request) {
    var m = model(inboundParams(request));
    return {
        view: React.createElement(view_1.AppWrapperView, { model: appWrapper },
            React.createElement(view_2.TopicCardTemplatesView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
}
exports.TopicCardTemplatesRoute = TopicCardTemplatesRoute;
function inboundParams(request) {
    return {
        id: +(request.params['id'] || 0),
        templateId: +(request.params['templateId'] || 0) // coerce undefined to 0, which is what we want - indicates no template selected
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = '' + m.Id;
    if (m.SelectedTemplateId())
        params['templateId'] = '' + m.SelectedTemplateId();
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplatesView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var eventWrappers_1 = __webpack_require__(8);
var supercritical_1 = __webpack_require__(4);
var TopicCardQuestionType_1 = __webpack_require__(210);
var view_1 = __webpack_require__(105);
var orgheaderview_1 = __webpack_require__(131);
var view_2 = __webpack_require__(533);
var view_3 = __webpack_require__(89);
var view_4 = __webpack_require__(29);
var view_5 = __webpack_require__(154);
var view_6 = __webpack_require__(198);
exports.TopicCardTemplatesView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "topiccardtemplates pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: '#!orgprofile?id=' + m.Model.Id() }, "<< Back to Organization")),
        React.createElement(orgheaderview_1.OrgHeaderView, { organization: m.Model }),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card page-body" },
        React.createElement("div", { className: "pc-card-header" },
            React.createElement("a", { href: "", className: "add-card-link", onClick: eventWrappers_1.noDefault(m.AddTemplate) }, "Add a new card"),
            React.createElement("span", { className: "pc-card-title" }, "Topic Cards")),
        React.createElement(TemplateList, { model: m }),
        React.createElement(SelectedTemplateView, { model: m }));
});
var TemplateList = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "template-list" }, m.TopicCardTemplates().map(function (t) {
        return React.createElement(TemplateListItem, { model: m, template: t, key: t.Model.Id() });
    }));
});
var TemplateListItem = supercritical_1.default(function (_a) {
    var m = _a.model, t = _a.template;
    return React.createElement(view_2.PCAutoScroll, { className: cx('pc-topic-card-list-item', {
            selected: m.SelectedTemplate() === t
        }), onClick: function () { return m.SelectedTemplateId(t.Model.Id()); }, keepInView: function () { return m.SelectedTemplate() === t; }, retriggerScroll: m.TopicCardTemplates /* retrigger auto-scroll if template sort changes */ },
        React.createElement("div", { className: "card-title" }, t.Model.EffectiveTitle()),
        React.createElement("div", { className: "card-remarks" }, t.Model.EffectiveRemarks() || '\u00A0' /* &nbsp; */));
});
var SelectedTemplateView = supercritical_1.default(function (_a) {
    var m = _a.model;
    var t = m.SelectedTemplate();
    if (!t)
        return null;
    return (React.createElement("div", { className: "selected-template-edit" },
        React.createElement(TitleAndAmenity, { template: t }),
        React.createElement(QuestionAndQuestionType, { template: t }),
        React.createElement(TimeEntryView, { template: t }),
        React.createElement(PeopleView, { template: t }),
        React.createElement(AttachmentsView, { template: t }),
        React.createElement(RemarksView, { template: t }),
        React.createElement("div", { className: "delete-card-container" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(t.Delete) }, "Delete Card"))));
});
var TitleAndAmenity = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement(TitleEdit, { template: t }),
            React.createElement(AmenityEdit, { template: t })),
        React.createElement("div", { className: "template-row-description-column" }, "Enter the title of the topic card. If you link a card to an amenity, the amenity name will automatically be used for the title and will be un-editable."));
});
var TitleEdit = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-title" },
        React.createElement("input", { className: "template-edit-control", value: t.Model.EffectiveTitle(), onChange: function (e) { return t.Model.Title(e.currentTarget.value); }, disabled: t.Model.AmenityTypeId() !== null }),
        React.createElement(view_4.ValidationErrorView, { error: function () { return t.Validation()['Title']; } }));
});
var AmenityEdit = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-amenity-type" }, t.AmenityLink.ShowDropdown() ?
        React.createElement("div", null,
            React.createElement("div", { className: "amenity-dropdown-container" },
                React.createElement("select", { className: "pc-select template-edit-control", value: t.Model.AmenityTypeId() === null ? '' : '' + t.Model.AmenityTypeId(), onChange: function (e) { return t.Model.AmenityTypeId(e.currentTarget.value === '' ? null : +e.currentTarget.value); } },
                    React.createElement("option", { value: "" }, "--"),
                    t.AmenityLink.AvailableAmenityTypes().map(function (a) {
                        return React.createElement("option", { value: a.Id(), key: a.Id() }, a.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" })),
            React.createElement("div", { className: "undo-amenity-link-container" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(t.AmenityLink.UndoAmenity) }, "Undo Amenity")))
        : React.createElement("div", { className: "show-amenity-link-container" },
            React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(function () { return t.AmenityLink.ShowDropdown(true); }) }, "+Choose topic from Amenity List")));
});
var QuestionAndQuestionType = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement(Question, { template: t }),
            React.createElement(QuestionType, { template: t })),
        React.createElement("div", { className: "template-row-description-column" }, "Ask a question and select the answer type below. The answer indicated will be the default answer on all cards."));
});
var Question = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-question" },
        React.createElement("textarea", { className: "template-edit-control", value: t.Model.Question(), onChange: function (e) { return t.Model.Question(e.currentTarget.value); } }),
        React.createElement(view_4.ValidationErrorView, { error: function () { return t.Validation()['Question']; } }));
});
var QuestionType = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-question-type" },
        React.createElement("div", { className: "template-edit-separator" }),
        React.createElement("div", { className: "template-question-type-select" },
            React.createElement("label", { className: "question-type-section-label pc-text-smalllabel" }, "answer"),
            React.createElement(QuestionTypeRadio, { template: t, questionType: TopicCardQuestionType_1.TopicCardQuestionType.YesNo, label: "yes/no" }),
            React.createElement(QuestionTypeRadio, { template: t, questionType: TopicCardQuestionType_1.TopicCardQuestionType.MultipleChoice, label: "multiple choice" })),
        React.createElement("div", { className: "template-question-answer-choices" },
            t.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.YesNo &&
                React.createElement(view_3.ToggleButton, { checked: function () { return false; }, onLabel: "Yes", offLabel: "No", disabled: true }),
            t.Model.QuestionType() === TopicCardQuestionType_1.TopicCardQuestionType.MultipleChoice &&
                React.createElement(CardOptionsEdit, { template: t })));
});
var QuestionTypeRadio = supercritical_1.default(function (_a) {
    var t = _a.template, questionType = _a.questionType, label = _a.label;
    return React.createElement("label", { className: "pc-radio pc-text-tinylabel question-type-radio" },
        React.createElement("input", { type: "radio", checked: t.Model.QuestionType() === questionType, onChange: function (e) { return e.currentTarget.checked && t.Model.QuestionType(questionType); } }),
        React.createElement("span", { className: "pc-radio-button" }),
        ' ',
        React.createElement("span", { className: "pc-text-tinylabel" }, label));
});
var CardOptionsEdit = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-card-options" }, t.Options.Slots().map(function (slot, idx) {
        return React.createElement(CardOptionSlotView, { slot: slot, template: t, isFirst: idx === 0, key: slot.SlotId });
    }));
});
var CardOptionSlotView = supercritical_1.default(function (_a) {
    var s = _a.slot, t = _a.template, isFirst = _a.isFirst;
    return React.createElement("div", { className: "template-card-option-slot" },
        React.createElement("div", null,
            React.createElement("span", { className: "pc-radio option-radio" },
                React.createElement("input", { type: "radio", checked: isFirst, disabled: true }),
                React.createElement("span", { className: "pc-radio-button" })),
            ' ',
            React.createElement("input", { className: "template-edit-control option-text", placeholder: isFirst ? 'default answer...' : 'answer...', value: s.Model.Text(), onChange: function (e) { return s.Model.Text(e.currentTarget.value); } }),
            ' ',
            s.IsPersisted() && React.createElement("a", { href: "", className: "pc-close-icon", onClick: eventWrappers_1.noDefault(function () { return t.Options.DeleteSlot(s); }) })),
        React.createElement(view_4.ValidationErrorView, { error: function () { return s.Validation()['Text']; } }));
});
var TimeEntryView = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement("div", { className: "template-time-entry" },
                React.createElement("div", { className: "template-edit-separator" }),
                React.createElement(HasTimeEntryView, { template: t }),
                React.createElement(TimeEntryLabelView, { template: t }))),
        React.createElement("div", { className: "template-row-description-column" }, "Indicate if this card has a time associated with it. Times are editable on individual cards."));
});
var HasTimeEntryView = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", null,
        React.createElement("label", { className: "time-entry-section-label pc-text-smalllabel" }, "time"),
        React.createElement(view_3.ToggleButton, { checked: t.Model.TimeEntry.HasTimeEntry, onLabel: "Yes", offLabel: "No" }));
});
var TimeEntryLabelView = supercritical_1.default(function (_a) {
    var t = _a.template;
    if (!t.Model.TimeEntry.HasTimeEntry())
        return null;
    return (React.createElement("div", { className: "time-entry-label-edit" },
        React.createElement("input", { className: "template-edit-control", value: t.Model.TimeEntry.Label() || '', onChange: function (e) { return t.Model.TimeEntry.Label(e.currentTarget.value); } })));
});
var PeopleView = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement("div", { className: "template-people" },
                React.createElement("div", { className: "template-edit-separator" }),
                React.createElement("div", null,
                    React.createElement("label", { className: "pc-text-smalllabel" }, "people")),
                React.createElement("div", { className: "template-people-list" }, t.People.People().map(function (ua) {
                    return React.createElement(UserAssignmentView, { userAssignment: ua, key: ua.Model.UserId() });
                })),
                React.createElement(view_5.UserSelectorView, { className: "template-edit-control", model: t.People.UserSelector, placeholder: "Add a person" }))),
        React.createElement("div", { className: "template-row-description-column" }, "Add people to a card to receive notifications on updates and changes to a card."));
});
var UserAssignmentView = supercritical_1.default(function (_a) {
    var u = _a.userAssignment;
    return React.createElement("div", null,
        React.createElement("span", { className: "pc-text-fixedwidth user-name" }, u.Model.User() && u.Model.User().FullName()),
        React.createElement("a", { href: "", className: "pc-close-icon", onClick: eventWrappers_1.noDefault(u.Delete) }));
});
var AttachmentsView = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement("div", { className: "template-attachments" },
                React.createElement("div", { className: "template-edit-separator" }),
                React.createElement("div", null,
                    React.createElement("label", { className: "pc-text-smalllabel" }, "attachments")),
                React.createElement("div", { className: "template-attachments-list" }, t.Attachments.Attachments().map(function (a) {
                    return React.createElement(TemplateAttachmentView, { attachment: a, key: a.Model.Id() });
                })),
                React.createElement("div", null,
                    React.createElement("label", { className: "add-attachment-link", htmlFor: t.Attachments.UploadFile.FileInputId() },
                        React.createElement("a", null, "+ Add Attachment")),
                    React.createElement(view_6.UploadFileView, { model: t.Attachments.UploadFile })))),
        React.createElement("div", { className: "template-row-description-column" }, "Add attachments to a card for people to download and re-upload."));
});
var TemplateAttachmentView = supercritical_1.default(function (_a) {
    var a = _a.attachment;
    return React.createElement("div", null,
        React.createElement(view_1.DownloadLink, { href: a.Model.AttachmentUrl(), className: "attachment-icon fa fa-paperclip" }),
        React.createElement(view_1.DownloadLink, { href: a.Model.AttachmentUrl(), className: "attachment-filename pc-text-fixedwidth" }, a.Model.FileName()),
        React.createElement("a", { href: "", className: "pc-close-icon", onClick: eventWrappers_1.noDefault(a.Delete) }));
});
var RemarksView = supercritical_1.default(function (_a) {
    var t = _a.template;
    return React.createElement("div", { className: "template-row" },
        React.createElement("div", { className: "template-row-edit-column" },
            React.createElement("div", { className: "template-remarks" },
                React.createElement("div", { className: "template-edit-separator" }),
                React.createElement("div", { className: "template-remarks-section-label-container" },
                    React.createElement("label", { className: "pc-text-smalllabel" }, "remarks")),
                React.createElement("div", null,
                    React.createElement("textarea", { className: "template-edit-control", value: t.Model.EffectiveRemarks() || '', onChange: function (e) { return t.Model.Remarks(e.currentTarget.value); }, disabled: t.Model.AmenityTypeId() !== null })))),
        React.createElement("div", { className: "template-row-description-column" }, "Enter any remarks or details about this card. If you link a card to an amenity, the amenity description will automatically be used for the remarks and will be un-editable."));
});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeaheadServerSide = void 0;
function TypeaheadServerSide(ajax) {
    // Our custom transport layer for managing server-side typeahead searches.
    // This is in place of Twitter's Bloodhound, which feels bloated for our purposes. See https://github.com/twitter/typeahead.js/blob/master/doc/bloodhound.md
    return {
        RequestQueue: RequestQueue,
        ApiConventions: SearchApiConventions
    };
    // Pool search requests.
    // At most one request is in flight at a time.
    // When that request finishes, send the next request with the most recent query parameter.
    function RequestQueue(apiConventions) {
        var sending = false, nextQuery, nextCb, lastQuerySent;
        return {
            add: add
        };
        function add(query, cb) {
            nextQuery = query;
            nextCb = cb;
            if (!sending)
                _send();
        }
        function _send() {
            sending = true;
            lastQuerySent = nextQuery;
            ajax.Url(apiConventions.formatUrl(nextQuery)).Get().then(_done(nextCb)).finally(function () {
                if (nextQuery !== lastQuerySent)
                    _send();
                else
                    sending = false;
            });
        }
        function _done(cb) {
            return function (resp) { cb(apiConventions.getMatchesArray(resp)); };
        }
    }
    // Our conventions for search endpoints
    function SearchApiConventions(baseUrl) {
        return {
            formatUrl: function (query) {
                // Convention - search endpoints should take the search term as the q parameter in the query string
                return baseUrl + '?q=' + encodeURIComponent(query);
            },
            getMatchesArray: function (resp) {
                // Convention - search endpoints should return an array of match objects
                return resp;
            }
        };
    }
}
exports.TypeaheadServerSide = TypeaheadServerSide;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UIThemeSetter = void 0;
var s_js_1 = __webpack_require__(0);
/**
 * NOTE: the localStorage key names are also embedded into the index.tmpl.html file, so if you change them here, be sure to change index.tmpl.html as well
 */
var CSSFILE_LOCALSTORAGE_KEY = "UIThemeCssFile", CSSCLASSES_LOCALSTORAGE_KEY = "UIThemeCssClasses", CSSFILE_DEFAULT = "dist/Content/Site.css", CSSCLASSES_DEFAULT = "";
var UIThemeSetter = function (initialDataLoaded, user, domainSettings) {
    var userTheme = function () { return user() && user().EffectiveUITheme(); }, anonTheme = function () { return domainSettings.DefaultUITheme(); }, 
    // before initial load, precedence is cached theme > anonymous theme defined in environment.config.js > default
    // after initial load, it's user theme > anonymous theme > default
    CssFile = function () {
        return !initialDataLoaded() && CSSFILE_LOCALSTORAGE_KEY in localStorage ? localStorage[CSSFILE_LOCALSTORAGE_KEY] :
            userTheme() ? userTheme().CssFile() :
                anonTheme() ? anonTheme().CssFile() :
                    CSSFILE_DEFAULT;
    }, CssClasses = function () {
        return !initialDataLoaded() && CSSCLASSES_LOCALSTORAGE_KEY in localStorage ? localStorage[CSSCLASSES_LOCALSTORAGE_KEY] :
            userTheme() ? userTheme().CssClasses() :
                anonTheme() ? anonTheme().CssClasses() :
                    CSSCLASSES_DEFAULT;
    };
    // as soon as we've got a theme loaded, keep it cached in local storage.  we'll use this right off the bat on the next load, 
    // (see code in index.tmpl.html) before we've even gotten the user's data from the server.  
    // that way we avoid a flash of the wrong theme for returning users.
    s_js_1.default(function () {
        if (initialDataLoaded()) {
            localStorage[CSSFILE_LOCALSTORAGE_KEY] = CssFile();
            localStorage[CSSCLASSES_LOCALSTORAGE_KEY] = CssClasses();
        }
    });
    return { CssFile: CssFile, CssClasses: CssClasses };
};
exports.UIThemeSetter = UIThemeSetter;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UIThemeSetterView = void 0;
var supercritical_1 = __webpack_require__(4);
var build_1 = __webpack_require__(973);
exports.UIThemeSetterView = supercritical_1.default(function (_a) {
    var model = _a.model;
    // not a view in the traditional definition, as it's modifying elements outside of the React root
    var 
    // use PORTCALLBUILDID as a cache busting token
    file = model.CssFile() + "?version=" + build_1.PORTCALLBUILDID, classes = model.CssClasses(), style = document.getElementById("pc-stylesheet");
    // we set attribute not style.href property b/c property may have been converted to an absolute url,
    // meaning it differs from file but not meaningfully.
    if (style && style.getAttribute('href') !== file)
        style.setAttribute('href', file);
    document.body.className = classes;
    return null;
});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var UserPermissionsResponse_1 = __webpack_require__(1369);
var UserPermissionsCache = /** @class */ (function (_super) {
    __extends(UserPermissionsCache, _super);
    function UserPermissionsCache(data) {
        var _this = _super.call(this) || this;
        _this.UserPermissionsResponses = PCCache_1.PCCollection(UserPermissionsResponse_1.UserPermissionsResponse);
        new DataCache_1.QueryResultsRelationship(_this.UserPermissionsResponses, data.Roles, function (r) { return r.AssignableRoles; });
        new DataCache_1.QueryResultsRelationship(_this.UserPermissionsResponses, data.PCUsers, function (r) { return r.Users; });
        return _this;
    }
    return UserPermissionsCache;
}(DataCache_1.DataCache));
exports.UserPermissionsCache = UserPermissionsCache;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissions = void 0;
var s_js_1 = __webpack_require__(0);
var _ = __webpack_require__(67);
var UserRole_1 = __webpack_require__(594);
var PCRoles_1 = __webpack_require__(286);
var rolemapper_1 = __webpack_require__(496);
function UserPermissions(ajax, entrypoints, cache, queryCache, domain, _a) {
    var organizationId = _a.organizationId, onHidePopup = _a.onHidePopup;
    var model = queryCache.UserPermissionsResponses.update1(null, { OrganizationId: organizationId || 0 }), url = entrypoints.UserPermissions({ Id: organizationId || 0 }), request = ajax.Url(url).Get(), canAssignSiteAdmin = function () { return model.AssignableRoles().some(function (r) { return r.Id() == PCRoles_1.PCRoles.SiteAdmin; }); }, selectedForDeleteUser = s_js_1.default.data(null), deleteUserModal = s_js_1.default(function () { return selectedForDeleteUser() && DeleteUserViewModel(selectedForDeleteUser()); });
    request.done(function (data) {
        queryCache.UserPermissionsResponses.update1(request.Date, data);
    });
    return {
        Model: model,
        Users: model.Users.map(function (user) { return PCUserViewModel(user, model.AssignableRoles); }),
        CanAssignSiteAdmin: canAssignSiteAdmin,
        HidePopup: onHidePopup,
        DeleteUserModal: deleteUserModal,
        HasPilots: function () { return domain.HasActivePilots(); }
    };
    function PCUserViewModel(user, assignableRoles) {
        var _user = s_js_1.default(function () { return user.User() && UserViewModel(user.User(), assignableRoles); });
        return {
            Model: user,
            User: _user,
            ConfirmDeleteUser: function () { return selectedForDeleteUser(user); }
        };
    }
    function UserViewModel(u, assignableRoles) {
        var roleDrafts = assignableRoles.map(function (r) { return UserRoleDraft(u, r); }), draftRoleIds = roleDrafts.filter(function (draft) { return draft.DraftStatus(); }).map(function (draft) { return draft.Role.Id(); }), otherAssignedIds = u.Roles.filter(function (ur) { return !assignableRoles().some(function (r) { return ur.Role() === r; }); }).map(function (ur) { return ur.RoleId(); }), roleMapper = rolemapper_1.RoleMapper(draftRoleIds.concat(otherAssignedIds));
        return {
            Model: u,
            HasOrImpliesRole: roleMapper.HasOrImpliesRole,
            ImpliesOrMaterializesRole: roleMapper.ImpliesOrMaterializesRole,
            ToggleRole: function (roleId) { return roleMapper.ToggleRole(modifyRole(function (join) { return join.Add(); }), modifyRole(function (join) { return join.Remove(); }), roleId); }
        };
        function modifyRole(action) {
            return function (roleId) {
                var draft = findRoleDraft(roleId);
                if (!draft)
                    return;
                action(draft);
            };
        }
        function findRoleDraft(roleId) {
            return s_js_1.default.sample(function () { return _.find(roleDrafts(), function (draft) { return draft.Role.Id() === roleId; }); });
        }
    }
    // Maintain separate draft state and persisted state for UserRoles
    function UserRoleDraft(u, r) {
        var client = ajax.Url(function () { return (u.RolesUrlBase() || '').replace('{RoleId}', '' + r.Id()); }), key = function () { return UserRole_1.UserRole.dataKey({
            UserId: u.Id(),
            RoleId: r.Id()
        }); }, persistedUserRole = cache.UserRoles.index(key), persistedStatus = function () { return !!persistedUserRole(); }, draftStatus = s_js_1.default.data(false), dirty = s_js_1.default.data(false), userChanges = false; // Has the user made changes since the last request was sent
        s_js_1.default(function () {
            if (!dirty())
                draftStatus(persistedStatus());
        });
        return {
            Role: r,
            DraftStatus: draftStatus,
            Add: Add,
            Remove: Remove
        };
        function Add() {
            userChanges = true;
            s_js_1.default.freeze(function () {
                draftStatus(true);
                if (!s_js_1.default.sample(dirty)) {
                    dirty(true);
                    sendPutRequest();
                }
            });
        }
        function Remove() {
            userChanges = true;
            s_js_1.default.freeze(function () {
                draftStatus(false);
                if (!s_js_1.default.sample(dirty)) {
                    dirty(true);
                    sendDeleteRequest();
                }
            });
        }
        function sendPutRequest() {
            wrapRequest(function () {
                var req = client.Put({});
                return req.then(function (data) {
                    cache.UserRoles.update1(req.Date, data);
                });
            });
        }
        function sendDeleteRequest() {
            wrapRequest(function () {
                var req = client.Delete();
                return req.then(function () {
                    cache.UserRoles.update(req.Date, [], [s_js_1.default.sample(key)]);
                });
            });
        }
        function wrapRequest(req) {
            userChanges = false;
            req().finally(function () {
                var _draftStatus = s_js_1.default.sample(draftStatus), _persistedStatus = s_js_1.default.sample(persistedStatus);
                if (userChanges && _draftStatus !== _persistedStatus) {
                    _draftStatus ? sendPutRequest() : sendDeleteRequest();
                }
                else {
                    dirty(false);
                    userChanges = false;
                }
            });
        }
    }
    function DeleteUserViewModel(user) {
        var action = s_js_1.default.data(null), actionSuccess = function () {
            return !!(action() && action().Response() && action().Response().Success);
        };
        return {
            User: user,
            ActionSuccess: actionSuccess,
            Delete: Delete,
            HideModal: function () { return selectedForDeleteUser(null); }
        };
        function Delete() {
            user.Active(false);
            var req = ajax.Url(function () { return user.Url() || ''; }).Put(user);
            req.then(function () { return model.Users.remove(user); });
            action(req);
        }
    }
}
exports.UserPermissions = UserPermissions;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselPortCallsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var VesselPortCallResponse_1 = __webpack_require__(1373);
var VesselPortCallsCache = /** @class */ (function (_super) {
    __extends(VesselPortCallsCache, _super);
    function VesselPortCallsCache(data) {
        var _this = _super.call(this) || this;
        _this.VesselPortCallResponses = PCCache_1.PCCollection(VesselPortCallResponse_1.VesselPortCallResponse);
        new DataCache_1.ForeignKeyRelationship(data.Vessels, _this.VesselPortCallResponses, null, function (e) { return e.Vessel; }, function (e) { return e.VesselId(); });
        new DataCache_1.QueryResultsRelationship(_this.VesselPortCallResponses, data.PortCalls, function (r) { return r.PortCalls; });
        return _this;
    }
    return VesselPortCallsCache;
}(DataCache_1.DataCache));
exports.VesselPortCallsCache = VesselPortCallsCache;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselPortCallsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var view_1 = __webpack_require__(128);
var view_2 = __webpack_require__(68);
var model_1 = __webpack_require__(551);
exports.VesselPortCallsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body" },
        React.createElement("div", { className: "main-page" },
            React.createElement(VesselPortCallsHeaderView, { model: m }),
            React.createElement(VesselPortCallsDetailView, { model: m })));
});
var VesselPortCallsHeaderView = supercritical_1.default(function (_a) {
    var model = _a.model;
    var m = model.Model();
    return React.createElement("div", { className: "port-calls-header" },
        React.createElement("div", { className: "vessel-name" },
            React.createElement("div", { className: "vessel-name-text" },
                React.createElement("span", null, m.Vessel() && m.Vessel().Name()))),
        React.createElement("div", { className: "filter-criteria" },
            React.createElement(view_1.DateRangeSelectorView, { model: model.DateRangeSelector })));
});
var VesselPortCallsDetailView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-table" },
        React.createElement("table", { className: "table" },
            React.createElement(TableBody, { model: model_1.PortCallsViewModel(m.Model().PortCalls) })));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.PortCalls().map(function (port) {
        return [
            React.createElement(PortCallHeader, { model: port, key: port.PortCall.Id() })
        ].concat(port.Itineraries().map(function (i) {
            return React.createElement(PortCallDetailView, { model: i, portcall: port, key: i.Itinerary.Id() });
        })).concat(React.createElement(PortCallSpacer, null));
    }));
});
var PortCallHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tr", { className: "port-header", onClick: m.NavigateToPortCall },
        React.createElement("td", null, m.MinDate()),
        React.createElement("td", null, m.PortName()),
        React.createElement("td", { className: "pc-text-label-color" }, "Voyage"),
        React.createElement("td", null, m.VoyageNumber()),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null));
});
var PortCallDetailView = supercritical_1.default(function (_a) {
    var m = _a.model, pc = _a.portcall;
    return React.createElement("tr", { onClick: pc.NavigateToPortCall },
        React.createElement("td", null, m.HasIssues() ? React.createElement(view_2.IssueCountBadge, { issues: m.Issues }) : ''),
        React.createElement("td", null, m.LocationName()),
        React.createElement("td", { className: "pc-text-label-color" }, "Arrive"),
        React.createElement("td", null, m.Arrival),
        React.createElement("td", { className: "pc-text-label-color" }, m.Itinerary.Id() == (pc.LastReservation() && pc.LastReservation().Id()) ? 'Depart' : 'Shift'),
        React.createElement("td", null, m.Departure),
        React.createElement("td", null, m.HasIssues() ? React.createElement(view_2.IssuesShortSummary, { issues: m.Issues }) : m.ReservationStatus));
});
var PortCallSpacer = supercritical_1.default(function () {
    return React.createElement("tr", { className: "portcall-spacer" },
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null));
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceConfigureCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var LloydServiceSearch_1 = __webpack_require__(1280);
var MarineTrafficServiceSearch_1 = __webpack_require__(1287);
var PSixServiceSearch_1 = __webpack_require__(1299);
var VesselServiceConfigure_1 = __webpack_require__(1374);
var VesselServiceConfigureCache = /** @class */ (function (_super) {
    __extends(VesselServiceConfigureCache, _super);
    function VesselServiceConfigureCache(data) {
        var _this = _super.call(this) || this;
        _this.LloydServiceSearches = PCCache_1.PCCollection(LloydServiceSearch_1.LloydServiceSearch);
        _this.MarineTrafficServiceSearches = PCCache_1.PCCollection(MarineTrafficServiceSearch_1.MarineTrafficServiceSearch);
        _this.PSixServiceSearches = PCCache_1.PCCollection(PSixServiceSearch_1.PSixServiceSearch);
        _this.VesselServiceConfigures = PCCache_1.PCCollection(VesselServiceConfigure_1.VesselServiceConfigure);
        new DataCache_1.QueryResultsRelationship(_this.LloydServiceSearches, data.LloydServiceVessels, function (s) { return s.Results; });
        new DataCache_1.QueryResultsRelationship(_this.MarineTrafficServiceSearches, data.MarineTrafficServiceVessels, function (s) { return s.Results; });
        new DataCache_1.QueryResultsRelationship(_this.PSixServiceSearches, data.PSixServiceVessels, function (s) { return s.Results; });
        new DataCache_1.QueryResultsRelationship(_this.VesselServiceConfigures, data.Vessels, function (c) { return c.DuplicateVessels; });
        new DataCache_1.SharedKeyRelationship(_this.VesselServiceConfigures, data.Vessels, function (c) { return c.Vessel; }, null);
        return _this;
    }
    return VesselServiceConfigureCache;
}(DataCache_1.DataCache));
exports.VesselServiceConfigureCache = VesselServiceConfigureCache;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceConfigure = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var uniqueIndex_1 = __webpack_require__(70);
function VesselServiceConfigure(ajax, entrypoints, cache, vesselServiceSettings, _a) {
    var id = _a.id;
    var model = cache.VesselServiceConfigures.update1(null, { VesselId: id }), request = ajax.Url(entrypoints.VesselServiceConfigure({ Id: id })).Get(), lloydSearch = LloydSearchModel(), marineTrafficSearch = MarineTrafficSearchModel(), pSixSearch = PSixSearchModel(), selectedDuplicateVesselId = s_js_1.default.data(null);
    s_js_1.default(function () {
        var vessel = model.Vessel();
        if (!vessel)
            return;
        // Populate search terms from vessel info
        s_js_1.default(function () {
            if (vessel.IMO()) {
                var imo = +vessel.IMO();
                if (!isNaN(imo)) {
                    if (!s_js_1.default.sample(marineTrafficSearch.IMO))
                        marineTrafficSearch.IMO(imo);
                    if (!s_js_1.default.sample(lloydSearch.IMO))
                        lloydSearch.IMO(imo);
                }
            }
        });
        s_js_1.default(function () {
            if (vessel.MMSID()) {
                var mmsid = +vessel.MMSID();
                if (!isNaN(mmsid)) {
                    if (!s_js_1.default.sample(marineTrafficSearch.MMSID))
                        marineTrafficSearch.MMSID(mmsid);
                    if (!s_js_1.default.sample(lloydSearch.MMSID))
                        lloydSearch.MMSID(mmsid);
                }
            }
        });
        s_js_1.default(function () {
            if (vessel.Name() && !s_js_1.default.sample(pSixSearch.VesselName))
                pSixSearch.VesselName(vessel.Name());
        });
        s_js_1.default(function () {
            if (vessel.CallSign() && !s_js_1.default.sample(pSixSearch.CallSign))
                pSixSearch.CallSign(vessel.CallSign());
            if (vessel.CallSign() && !s_js_1.default.sample(lloydSearch.CallSign))
                lloydSearch.CallSign(vessel.CallSign());
        });
        s_js_1.default(function () {
            if (vessel.VIN() && !s_js_1.default.sample(pSixSearch.VIN))
                pSixSearch.VIN(vessel.VIN());
        });
        // End populate search terms
        // Populate selected result ids from vessel info
        s_js_1.default(function () { return lloydSearch.SelectedResultId(vessel.LloydServiceVesselId()); });
        s_js_1.default(function () { return marineTrafficSearch.SelectedResultId(vessel.MarineTrafficServiceVesselId()); });
        s_js_1.default(function () { return pSixSearch.SelectedResultId(vessel.PSixServiceVesselId()); });
    });
    request.done(function (json) {
        cache.VesselServiceConfigures.update1(request.Date, json);
    });
    return {
        Model: model,
        VesselServiceSettings: vesselServiceSettings,
        LloydSearch: lloydSearch,
        MarineTrafficSearch: marineTrafficSearch,
        PSixSearch: pSixSearch,
        SelectedDuplicateVesselId: selectedDuplicateVesselId,
        GoToOverrides: function () { return window.location.hash = '#!vesselserviceprofile?id=' + id; },
        GoBack: function () { return window.history.back(); }
    };
    function SearchModelBase(url, cacheCollection, resultModel, resultsRef, serviceVesselIdRef) {
        var isSearching = s_js_1.default.data(false), searchKey = s_js_1.default.data(null), currentSearch = s_js_1.default(function () { return searchKey() && cacheCollection.update1(null, searchKey()); }), results = s_js_1.default(function () { return currentSearch() ?
            resultsRef(currentSearch())
                .map(function (result) { return resultModel(result, function () { return searchKey(); }); })
                // Descending sort on SearchResultWeight
                .sort(function (res1, res2) { return res2.SearchResultWeight() - res1.SearchResultWeight(); })
            : s_array_1.default([]); }), resultsIdx = s_js_1.default(function () { return uniqueIndex_1.default(results(), function (r) { return r.Model.Id(); }); }), selectedResultId = s_js_1.default.data(null);
        // Send search request when search key set
        s_js_1.default(function () {
            if (searchKey() && !s_js_1.default.sample(isSearching)) {
                isSearching(true);
                var req_1 = ajax.Url(url(searchKey())).Get();
                req_1.then(function (json) {
                    cacheCollection.update1(req_1.Date, json);
                }).finally(function () { return isSearching(false); });
            }
        });
        return {
            IsSearching: isSearching,
            Results: function () { return results()(); },
            SelectedResultId: selectedResultId,
            SearchKey: searchKey,
            Link: Link,
            SelectCurrentVessel: SelectCurrentVessel,
            SelectedIdIsCurrent: SelectedIdIsCurrent,
            CurrentVesselInResults: CurrentVesselInResults
        };
        function Link() {
            var vessel = s_js_1.default.sample(model.Vessel);
            if (!vessel)
                return;
            serviceVesselIdRef(vessel)(s_js_1.default.sample(selectedResultId));
            ajax.Url(function () { return vessel.Url() || ''; }, { useCache: true }).Put(vessel);
        }
        function SelectCurrentVessel() {
            var vessel = s_js_1.default.sample(model.Vessel);
            if (!vessel)
                return;
            selectedResultId(s_js_1.default.sample(serviceVesselIdRef(vessel)));
        }
        function SelectedIdIsCurrent() {
            var vessel = model.Vessel();
            if (!vessel)
                return false;
            var serviceVesselId = serviceVesselIdRef(vessel)();
            return selectedResultId() === serviceVesselId;
        }
        function CurrentVesselInResults() {
            var vessel = model.Vessel();
            if (!vessel)
                return false;
            var serviceVesselId = serviceVesselIdRef(vessel)() || 0;
            return !!resultsIdx()(serviceVesselId)();
        }
    }
    function LloydSearchModel() {
        var imo = s_js_1.default.data(null), mmsid = s_js_1.default.data(null), 
        //Defaulting callSign to empty string.  WebApi causes this to be seen as a null.  Adding fix to API to account for this
        callSign = s_js_1.default.data(''), searchModelBase = SearchModelBase(entrypoints.LloydsSearch, cache.LloydServiceSearches, LloydSearchResult, function (s) { return s.Results; }, function (v) { return v.LloydServiceVesselId; });
        return Object.assign({}, searchModelBase, {
            IMO: imo,
            MMSID: mmsid,
            CallSign: callSign,
            Search: Search,
            CanSearch: function () { return !searchModelBase.IsSearching() && !!(imo() || mmsid() || callSign()); }
        });
        function Search() {
            searchModelBase.SearchKey(s_js_1.default.sample(function () { return ({
                IMO: imo(),
                MMSID: mmsid(),
                CallSign: callSign() ? callSign() : null
            }); }));
        }
    }
    function MarineTrafficSearchModel() {
        var imo = s_js_1.default.data(null), mmsid = s_js_1.default.data(null), searchModelBase = SearchModelBase(entrypoints.MarineTrafficSearch, cache.MarineTrafficServiceSearches, MarineTrafficSearchResult, function (s) { return s.Results; }, function (v) { return v.MarineTrafficServiceVesselId; });
        return Object.assign({}, searchModelBase, {
            IMO: imo,
            MMSID: mmsid,
            Search: Search,
            CanSearch: function () { return !searchModelBase.IsSearching() && !!(imo() || mmsid()); }
        });
        function Search() {
            searchModelBase.SearchKey(s_js_1.default.sample(function () { return ({
                IMO: imo(),
                MMSID: mmsid()
            }); }));
        }
    }
    function PSixSearchModel() {
        var vesselName = s_js_1.default.data(''), callSign = s_js_1.default.data(''), hin = s_js_1.default.data(''), vin = s_js_1.default.data(''), searchModelBase = SearchModelBase(entrypoints.PSixSearch, cache.PSixServiceSearches, PSixSearchResult, function (s) { return s.Results; }, function (v) { return v.PSixServiceVesselId; });
        return Object.assign({}, searchModelBase, {
            VesselName: vesselName,
            CallSign: callSign,
            HIN: hin,
            VIN: vin,
            Search: Search,
            CanSearch: function () { return !searchModelBase.IsSearching() && !!(vesselName() || callSign() || hin() || vin()); }
        });
        function Search() {
            searchModelBase.SearchKey(s_js_1.default.sample(function () { return ({
                // TH 11/2/2016: Bugfix -- Coerce empty string to null.
                // This is b/c we pass these parameters to the server via the query string, and WebAPI parses empty query string values as null,
                // not the empty string. W/o this fix, we were getting key mismatches btwn this key and the server response whenever one of the search terms was empty,
                // leading to our search results not updating.
                VesselName: vesselName() ? vesselName() : null,
                CallSign: callSign() ? callSign() : null,
                HIN: hin() ? hin() : null,
                VIN: vin() ? vin() : null
            }); }));
        }
    }
    function LloydSearchResult(vessel, searchKey) {
        return {
            Model: vessel,
            SearchResultWeight: function () { return LloydOrMarineTrafficSearchResultWeight(vessel, searchKey()); }
        };
    }
    function MarineTrafficSearchResult(vessel, searchKey) {
        return {
            Model: vessel,
            SearchResultWeight: function () { return LloydOrMarineTrafficSearchResultWeight(vessel, searchKey()); }
        };
    }
    function PSixSearchResult(vessel, searchKey) {
        return {
            Model: vessel,
            SearchResultWeight: function () { return PSixSearchResultWeight(vessel, searchKey()); }
        };
    }
    function LloydOrMarineTrafficSearchResultWeight(vessel, searchKey) {
        var weight = 0;
        if (searchKey.IMO !== null && '' + searchKey.IMO === vessel.IMO())
            weight++;
        if (searchKey.MMSID !== null && '' + searchKey.MMSID === vessel.MMSID())
            weight++;
        return weight;
    }
    function PSixSearchResultWeight(vessel, searchKey) {
        var weight = 0;
        if (searchKey.VesselName && vessel.Name() && searchKey.VesselName.toUpperCase() === vessel.Name().toUpperCase())
            weight++;
        if (searchKey.CallSign && vessel.CallSign() && searchKey.CallSign.toUpperCase() === vessel.CallSign().toUpperCase())
            weight++;
        if (searchKey.HIN && vessel.HullIdentificationNumber() && searchKey.HIN.toUpperCase() === vessel.HullIdentificationNumber().toUpperCase())
            weight++;
        if (searchKey.VIN && vessel.VIN() && searchKey.VIN.toUpperCase() === vessel.VIN().toUpperCase())
            weight++;
        return weight;
    }
}
exports.VesselServiceConfigure = VesselServiceConfigure;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceConfigureRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1199);
var view_2 = __webpack_require__(12);
var VesselServiceConfigureRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.VesselServiceConfigureView, { model: model(convertParams(request)) }))
}); };
exports.VesselServiceConfigureRoute = VesselServiceConfigureRoute;
function convertParams(request) {
    return {
        id: +(request.params['id'] || 0)
    };
}


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceConfigureView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var VesselServiceActive_1 = __webpack_require__(611);
var view_1 = __webpack_require__(55);
exports.VesselServiceConfigureView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vesselservice-configure pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("span", { className: "pc-text-label-color" }, "More"),
            React.createElement("span", { className: "pc-icon-bullet" }),
            React.createElement("span", null, "Vessel Configuration")),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body" },
        React.createElement(VesselBasicsCard, { model: m }),
        React.createElement(DuplicateVesselsView, { model: m }),
        React.createElement(LloydServiceSearchView, { model: m }),
        React.createElement(MarineTrafficServiceSearchView, { model: m }),
        React.createElement(PSixServiceSearchView, { model: m }));
});
var VesselBasicsCard = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card" },
        React.createElement(VesselBasicsHeader, { model: m }),
        React.createElement(VesselBasicsBody, { model: m }));
});
var VesselBasicsHeader = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "pc-card-header" },
        React.createElement("div", { className: "vessel-name" },
            React.createElement("span", { className: "pc-card-title" }, m.Model.Vessel() && m.Model.Vessel().Name()),
            React.createElement("div", { className: "vessel-profile-button" },
                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.GoToOverrides) }, "Vessel Profile"))));
});
var VesselBasicsBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vessel-details" },
        React.createElement("div", { className: "left-side" },
            React.createElement("div", { className: "imo" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "IMO"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().IMO())),
            React.createElement("div", { className: "vin" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "VIN"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().VIN())),
            React.createElement("div", { className: "mmsid" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "MMSID"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().MMSID())),
            React.createElement("div", { className: "callsign" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "Call Sign"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().CallSign()))),
        React.createElement("div", { className: "right-side" },
            React.createElement("div", { className: "vessel-type" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "Vessel Type"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().VesselType())),
            React.createElement("div", { className: "gross-tonnage" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "Gross Tonnage"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().GrossTonnage.toString({ units: false }))),
            React.createElement("div", { className: "length" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "Length Overall"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().Length.toString())),
            React.createElement("div", { className: "beam" },
                React.createElement("div", { className: "pc-text-smalllabel identifier" }, "Beam"),
                React.createElement("div", { className: "pc-text-smalltext value" }, m.Model.Vessel() && m.Model.Vessel().Beam.toString()))));
});
var DuplicateVesselsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Model.DuplicateVessels().length === 0 ? null :
        React.createElement("div", { className: "pc-card" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("span", { className: "pc-card-title" }, "Potential Duplicate Vessel")),
            React.createElement("div", { className: "duplicate-search-results" },
                React.createElement("table", { className: "table" },
                    React.createElement(DuplicateVesselsTableHead, null),
                    React.createElement(DuplicateVesselsTableBody, { model: m }))),
            React.createElement("div", null,
                React.createElement("button", { className: "pc-button pc-button-default hide-for-now", 
                    // TH: Click action? There was none in the pre-typescript page...
                    disabled: m.SelectedDuplicateVesselId() === null }, "Merge")));
});
var DuplicateVesselsTableHead = supercritical_1.default(function () {
    return React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", null),
            React.createElement("th", null, "Vessel Name"),
            React.createElement("th", null, "IMO"),
            React.createElement("th", null, "MMSI"),
            React.createElement("th", null, "Call Sign"),
            React.createElement("th", null, "Beam"),
            React.createElement("th", null, "Length")));
});
var DuplicateVesselsTableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null,
        m.Model.DuplicateVessels().map(function (v) {
            return React.createElement(DuplicateVesselsTableRow, { vessel: v, model: m, key: v.Id() });
        }),
        m.Model.DuplicateVessels().length > 0 &&
            React.createElement(DuplicateVesselsNoneRow, { model: m }));
});
var DuplicateVesselsTableRow = supercritical_1.default(function (_a) {
    var v = _a.vessel, m = _a.model;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: m.SelectedDuplicateVesselId() === v.Id(), onChange: function (e) { return e.currentTarget.checked && m.SelectedDuplicateVesselId(v.Id()); } })),
        React.createElement("td", null,
            React.createElement("span", { className: cx({
                    highlight: !!(m.Model.Vessel() && m.Model.Vessel().Name() === v.Name())
                }) }, v.Name())),
        React.createElement("td", null,
            React.createElement("span", { className: cx({
                    highlight: !!(m.Model.Vessel() && m.Model.Vessel().IMO() === v.IMO())
                }) }, v.IMO())),
        React.createElement("td", null,
            React.createElement("span", { className: cx({
                    highlight: !!(m.Model.Vessel() && m.Model.Vessel().MMSID() === v.MMSID())
                }) }, v.MMSID())),
        React.createElement("td", null,
            React.createElement("span", { className: cx({
                    highlight: !!(m.Model.Vessel() && m.Model.Vessel().CallSign() === v.CallSign())
                }) }, v.CallSign())),
        React.createElement("td", null, v.Beam.toString()),
        React.createElement("td", null, v.Length.toString()));
});
var DuplicateVesselsNoneRow = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: m.SelectedDuplicateVesselId() === null, onChange: function (e) { return e.currentTarget.checked && m.SelectedDuplicateVesselId(null); } })),
        React.createElement("td", null, "None"),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null));
});
var SearchViewBase = /** @class */ (function (_super) {
    __extends(SearchViewBase, _super);
    function SearchViewBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchViewBase.prototype.active = function (m) {
        return this.activeSetting(m.VesselServiceSettings) === VesselServiceActive_1.VesselServiceActive.Active;
    };
    SearchViewBase.prototype.currentServiceVessel = function (m) {
        return m.Model.Vessel() && this.serviceVesselRef(m.Model.Vessel());
    };
    SearchViewBase.prototype.hasResultsOrCurrentVesselRow = function (search, m) {
        return search.Results().length > 0 || !search.CurrentVesselInResults() && !!this.currentServiceVessel(m);
    };
    SearchViewBase.prototype.srender = function (_a) {
        var _this = this;
        var m = _a.model;
        var search = this.searchModel(m), currentServiceVessel = this.currentServiceVessel(m);
        return !this.active(m) ? null :
            React.createElement("div", { className: "pc-card" },
                React.createElement("div", { className: "pc-card-header" },
                    React.createElement("span", { className: "pc-card-title" }, this.title)),
                React.createElement("div", null,
                    React.createElement("div", null,
                        this.searchCriteria(search),
                        React.createElement("button", { className: "pc-button pc-button-default", disabled: !search.CanSearch(), onClick: search.Search }, "Search")),
                    React.createElement("div", { className: "search-results" },
                        React.createElement("table", { className: "table" },
                            this.tableHead(),
                            React.createElement("tbody", null,
                                search.Results().map(function (result) { return _this.searchResultRow(result, search); }),
                                !search.CurrentVesselInResults()
                                    && currentServiceVessel
                                    && this.currentVesselRow(currentServiceVessel, search),
                                this.hasResultsOrCurrentVesselRow(search, m) && this.noneRow(search))),
                        React.createElement("div", null,
                            this.hasResultsOrCurrentVesselRow(search, m) &&
                                React.createElement("button", { className: "pc-button pc-button-default", onClick: search.Link, disabled: search.SelectedIdIsCurrent() }, "Link"),
                            ' ',
                            !search.SelectedIdIsCurrent() &&
                                React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(search.SelectCurrentVessel) }, "Cancel")))));
    };
    return SearchViewBase;
}(supercritical_1.SuperCriticalComponent));
var LloydServiceSearchView = /** @class */ (function (_super) {
    __extends(LloydServiceSearchView, _super);
    function LloydServiceSearchView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'Lloyds Search';
        return _this;
    }
    LloydServiceSearchView.prototype.searchModel = function (m) {
        return m.LloydSearch;
    };
    LloydServiceSearchView.prototype.activeSetting = function (settings) {
        return settings.LloydServiceActive();
    };
    LloydServiceSearchView.prototype.serviceVesselRef = function (vessel) {
        return vessel.LloydServiceVessel();
    };
    LloydServiceSearchView.prototype.searchCriteria = function (search) {
        return (React.createElement(LloydSearchCriteria, { search: search }));
    };
    LloydServiceSearchView.prototype.tableHead = function () {
        return (React.createElement(LloydOrMarineTrafficTableHead, null));
    };
    LloydServiceSearchView.prototype.searchResultRow = function (result, search) {
        return (React.createElement(LloydOrMarineTrafficSearchResultRow, { result: result, search: search, key: result.Model.Id() }));
    };
    LloydServiceSearchView.prototype.currentVesselRow = function (vessel, search) {
        return (React.createElement(LloydOrMarineTrafficCurrentVesselRow, { vessel: vessel, search: search }));
    };
    LloydServiceSearchView.prototype.noneRow = function (search) {
        return (React.createElement(LloydOrMarineTrafficNoneRow, { search: search }));
    };
    return LloydServiceSearchView;
}(SearchViewBase));
var MarineTrafficServiceSearchView = /** @class */ (function (_super) {
    __extends(MarineTrafficServiceSearchView, _super);
    function MarineTrafficServiceSearchView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'Marine Traffic Search';
        return _this;
    }
    MarineTrafficServiceSearchView.prototype.searchModel = function (m) {
        return m.MarineTrafficSearch;
    };
    MarineTrafficServiceSearchView.prototype.activeSetting = function (settings) {
        return settings.MarineTrafficServiceActive();
    };
    MarineTrafficServiceSearchView.prototype.serviceVesselRef = function (vessel) {
        return vessel.MarineTrafficServiceVessel();
    };
    MarineTrafficServiceSearchView.prototype.searchCriteria = function (search) {
        return (React.createElement(LloydOrMarineTrafficSearchCriteria, { search: search }));
    };
    MarineTrafficServiceSearchView.prototype.tableHead = function () {
        return (React.createElement(LloydOrMarineTrafficTableHead, null));
    };
    MarineTrafficServiceSearchView.prototype.searchResultRow = function (result, search) {
        return (React.createElement(LloydOrMarineTrafficSearchResultRow, { result: result, search: search, key: result.Model.Id() }));
    };
    MarineTrafficServiceSearchView.prototype.currentVesselRow = function (vessel, search) {
        return (React.createElement(LloydOrMarineTrafficCurrentVesselRow, { vessel: vessel, search: search }));
    };
    MarineTrafficServiceSearchView.prototype.noneRow = function (search) {
        return (React.createElement(LloydOrMarineTrafficNoneRow, { search: search }));
    };
    return MarineTrafficServiceSearchView;
}(SearchViewBase));
var LloydOrMarineTrafficSearchCriteria = supercritical_1.default(function (_a) {
    var search = _a.search;
    return React.createElement("div", { className: "search-criteria" },
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "IMO"),
            ' ',
            React.createElement(view_1.NullableNumericInput, { placeholder: "IMO", value: search.IMO })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "MMSID"),
            ' ',
            React.createElement(view_1.NullableNumericInput, { placeholder: "MMSID", value: search.MMSID })));
});
var LloydSearchCriteria = supercritical_1.default(function (_a) {
    var search = _a.search;
    return React.createElement("div", { className: "search-criteria" },
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "IMO"),
            ' ',
            React.createElement(view_1.NullableNumericInput, { placeholder: "IMO", value: search.IMO })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "MMSID"),
            ' ',
            React.createElement(view_1.NullableNumericInput, { placeholder: "MMSID", value: search.MMSID })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "Call Sign"),
            ' ',
            React.createElement("input", { type: "text", placeholder: "Call Sign", value: search.CallSign(), onChange: function (e) { return search.CallSign(e.currentTarget.value); } })));
});
var LloydOrMarineTrafficTableHead = supercritical_1.default(function () {
    return React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", null),
            React.createElement("th", null, "sw"),
            React.createElement("th", null, "Vessel Name"),
            React.createElement("th", null, "IMO"),
            React.createElement("th", null, "MMSI"),
            React.createElement("th", null, "Call Sign"),
            React.createElement("th", null, "Vessel Type"),
            React.createElement("th", null, "Max Draft"),
            React.createElement("th", null, "Length")));
});
var LloydOrMarineTrafficSearchResultRow = supercritical_1.default(function (_a) {
    var result = _a.result, search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: result.Model.Id() === search.SelectedResultId(), onChange: function (e) { return e.currentTarget.checked && search.SelectedResultId(result.Model.Id()); } })),
        React.createElement("td", null, result.SearchResultWeight()),
        React.createElement("td", null, result.Model.Name()),
        React.createElement("td", null, result.Model.IMO()),
        React.createElement("td", null, result.Model.MMSID()),
        React.createElement("td", null, result.Model.CallSign()),
        React.createElement("td", null, result.Model.VesselType()),
        React.createElement("td", null, result.Model.MaxDraft.toString()),
        React.createElement("td", null, result.Model.Length.toString()));
});
var LloydOrMarineTrafficCurrentVesselRow = supercritical_1.default(function (_a) {
    var v = _a.vessel, search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: search.SelectedIdIsCurrent(), onChange: function (e) { return e.currentTarget.checked && search.SelectCurrentVessel(); } })),
        React.createElement("td", null),
        React.createElement("td", null, v.Name()),
        React.createElement("td", null, v.IMO()),
        React.createElement("td", null, v.MMSID()),
        React.createElement("td", null, v.CallSign()),
        React.createElement("td", null, v.VesselType()),
        React.createElement("td", null, v.MaxDraft.toString()),
        React.createElement("td", null, v.Length.toString()));
});
var LloydOrMarineTrafficNoneRow = supercritical_1.default(function (_a) {
    var search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: search.SelectedResultId() === null, onChange: function (e) { return e.currentTarget.checked && search.SelectedResultId(null); } })),
        React.createElement("td", null),
        React.createElement("td", null, "None"),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null));
});
var PSixServiceSearchView = /** @class */ (function (_super) {
    __extends(PSixServiceSearchView, _super);
    function PSixServiceSearchView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'PSix Search';
        return _this;
    }
    PSixServiceSearchView.prototype.searchModel = function (m) {
        return m.PSixSearch;
    };
    PSixServiceSearchView.prototype.activeSetting = function (settings) {
        return settings.PSixServiceActive();
    };
    PSixServiceSearchView.prototype.serviceVesselRef = function (vessel) {
        return vessel.PSixServiceVessel();
    };
    PSixServiceSearchView.prototype.searchCriteria = function (search) {
        return (React.createElement(PSixSearchCriteria, { search: search }));
    };
    PSixServiceSearchView.prototype.tableHead = function () {
        return (React.createElement(PSixTableHead, null));
    };
    PSixServiceSearchView.prototype.searchResultRow = function (result, search) {
        return (React.createElement(PSixSearchResultRow, { result: result, search: search, key: result.Model.Id() }));
    };
    PSixServiceSearchView.prototype.currentVesselRow = function (vessel, search) {
        return (React.createElement(PSixCurrentVesselRow, { vessel: vessel, search: search }));
    };
    PSixServiceSearchView.prototype.noneRow = function (search) {
        return (React.createElement(PSixNoneRow, { search: search }));
    };
    return PSixServiceSearchView;
}(SearchViewBase));
var PSixSearchCriteria = supercritical_1.default(function (_a) {
    var search = _a.search;
    return React.createElement("div", { className: "search-criteria" },
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "Vessel Name"),
            ' ',
            React.createElement("input", { type: "text", placeholder: "Vessel Name", value: search.VesselName(), onChange: function (e) { return search.VesselName(e.currentTarget.value); } })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "Call Sign"),
            ' ',
            React.createElement("input", { type: "text", placeholder: "Call Sign", value: search.CallSign(), onChange: function (e) { return search.CallSign(e.currentTarget.value); } })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "HIN"),
            ' ',
            React.createElement("input", { type: "text", placeholder: "HIN", value: search.HIN(), onChange: function (e) { return search.HIN(e.currentTarget.value); } })),
        React.createElement("div", { className: "search-criterion" },
            React.createElement("span", { className: "pc-text-smalllabel" }, "VIN"),
            ' ',
            React.createElement("input", { type: "text", placeholder: "VIN", value: search.VIN(), onChange: function (e) { return search.VIN(e.currentTarget.value); } })));
});
var PSixTableHead = supercritical_1.default(function () {
    return React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", null),
            React.createElement("th", null, "sw"),
            React.createElement("th", null, "Vessel Name"),
            React.createElement("th", null, "IMO"),
            React.createElement("th", null, "MMSI"),
            React.createElement("th", null, "VIN"),
            React.createElement("th", null, "HIN"),
            React.createElement("th", null, "Call Sign"),
            React.createElement("th", null, "Max Draft"),
            React.createElement("th", null, "Length")));
});
var PSixSearchResultRow = supercritical_1.default(function (_a) {
    var result = _a.result, search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: result.Model.Id() === search.SelectedResultId(), onChange: function (e) { return e.currentTarget.checked && search.SelectedResultId(result.Model.Id()); } })),
        React.createElement("td", null, result.SearchResultWeight()),
        React.createElement("td", null, result.Model.Name()),
        React.createElement("td", null, result.Model.IMO()),
        React.createElement("td", null, result.Model.MMSID()),
        React.createElement("td", null, result.Model.VIN()),
        React.createElement("td", null, result.Model.HullIdentificationNumber()),
        React.createElement("td", null, result.Model.CallSign()),
        React.createElement("td", null, result.Model.MaxDraft.toString()),
        React.createElement("td", null, result.Model.Length.toString()));
});
var PSixCurrentVesselRow = supercritical_1.default(function (_a) {
    var v = _a.vessel, search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: search.SelectedIdIsCurrent(), onChange: function (e) { return e.currentTarget.checked && search.SelectCurrentVessel(); } })),
        React.createElement("td", null),
        React.createElement("td", null, v.Name()),
        React.createElement("td", null, v.IMO()),
        React.createElement("td", null, v.MMSID()),
        React.createElement("td", null, v.VIN()),
        React.createElement("td", null, v.HullIdentificationNumber()),
        React.createElement("td", null, v.CallSign()),
        React.createElement("td", null, v.MaxDraft.toString()),
        React.createElement("td", null, v.Length.toString()));
});
var PSixNoneRow = supercritical_1.default(function (_a) {
    var search = _a.search;
    return React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("input", { type: "radio", checked: search.SelectedResultId() === null, onChange: function (e) { return e.currentTarget.checked && search.SelectedResultId(null); } })),
        React.createElement("td", null),
        React.createElement("td", null, "None"),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null),
        React.createElement("td", null));
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceListingCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var VesselServiceListing_1 = __webpack_require__(595);
var VesselServiceListingCache = /** @class */ (function (_super) {
    __extends(VesselServiceListingCache, _super);
    function VesselServiceListingCache(data) {
        var _this = _super.call(this) || this;
        _this.VesselServiceListings = PCCache_1.PCCollection(VesselServiceListing_1.VesselServiceListing);
        new DataCache_1.QueryResultsRelationship(_this.VesselServiceListings, data.Vessels, function (r) { return r.Vessels; });
        return _this;
    }
    return VesselServiceListingCache;
}(DataCache_1.DataCache));
exports.VesselServiceListingCache = VesselServiceListingCache;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceListing = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var debounceSignal_1 = __webpack_require__(81);
function VesselServiceListing(ajax, entrypoints, cache, _a) {
    var status = _a.status;
    var searchText = s_js_1.default.data("");
    var key = function () { return ({
        Status: status,
        SearchString: searchText()
    }); };
    var model = s_js_1.default(function () { return cache.VesselServiceListings.update1(null, key()); });
    s_js_1.default.on(debounceSignal_1.debounceSignal(searchText), function () {
        if (searchText().length >= 3) {
            var searchRequest = ajax.Url(entrypoints.VesselServiceListing(key())).Get();
            searchRequest.done(function (json) {
                cache.VesselServiceListings.update1(searchRequest.Date, json);
            });
        }
    });
    return {
        Model: model,
        Vessels: s_array_1.lift(function () { return model().Vessels(); }).map(VesselModel),
        SearchText: searchText,
        GoBack: function () { return window.history.back(); }
    };
    function VesselModel(vessel) {
        return {
            Model: vessel,
            OnRowClick: function () { return window.location.hash = '#!vesselserviceprofile?id=' + vessel.Id(); }
        };
    }
}
exports.VesselServiceListing = VesselServiceListing;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceListingRoute = void 0;
var React = __webpack_require__(2);
var VesselStatus_1 = __webpack_require__(138);
var view_1 = __webpack_require__(1203);
var view_2 = __webpack_require__(12);
var VesselServiceListingRoute = function (model, appWrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
        React.createElement(view_1.VesselServiceListingView, { model: model(convertParams(request)) }))
}); };
exports.VesselServiceListingRoute = VesselServiceListingRoute;
function convertParams(request) {
    var statusParam = request.params['status'];
    return { status: parseVesselStatus(statusParam) };
}
function parseVesselStatus(strStatus) {
    if (strStatus === undefined)
        return null;
    for (var i = 0; i < VesselStatus_1.VesselStatuses.length; i++) {
        if (strStatus.toLowerCase() === VesselStatus_1.VesselStatuses[i].Name.toLowerCase()) {
            return VesselStatus_1.VesselStatuses[i].Id;
        }
    }
    throw new Error('Unknown VesselStatus string ' + strStatus);
}


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceListingView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var VesselStatus_1 = __webpack_require__(138);
function PageTitle(m) {
    return (m.Model().Status() === null ? '' : VesselStatus_1.VesselStatusDisplayName[m.Model().Status()] + ' ') + 'Vessels';
}
exports.VesselServiceListingView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vesselservicelisting pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("div", { className: "vessel-search-breadcrumb" },
                React.createElement("span", { className: "pc-text-label-color" }, "More"),
                React.createElement("span", { className: "pc-icon-bullet" }),
                React.createElement("span", null, PageTitle(m))),
            React.createElement("div", { className: "vessel-search-text" },
                React.createElement("input", { value: m.SearchText(), placeholder: "Search for a vessel by name, callsign, IMO, or MMSI", onChange: function (e) { return m.SearchText(e.currentTarget.value); } }))),
        React.createElement(PageBody, { model: m }));
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body pc-card" },
        React.createElement("table", { className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Vessel Name"),
                    React.createElement("th", null, "IMO"),
                    React.createElement("th", null, "MMSI"),
                    React.createElement("th", null, "Call Sign"),
                    React.createElement("th", null, "Vessel Type"),
                    React.createElement("th", null, "Gross Tonnage"),
                    React.createElement("th", null, "Length"),
                    React.createElement("th", null, "Beam"),
                    React.createElement("th", null, "Max Draft"))),
            React.createElement(TableBody, { model: m })));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null, m.Vessels().map(function (vessel) {
        return React.createElement(VesselRow, { vessel: vessel, key: vessel.Model.Id() });
    }));
});
var VesselRow = supercritical_1.default(function (_a) {
    var v = _a.vessel;
    return React.createElement("tr", { className: "vessel-row", onClick: v.OnRowClick },
        React.createElement("td", null, v.Model.Name()),
        React.createElement("td", null, v.Model.IMO()),
        React.createElement("td", null, v.Model.MMSID()),
        React.createElement("td", null, v.Model.CallSign()),
        React.createElement("td", null, v.Model.VesselType()),
        React.createElement("td", null, v.Model.GrossTonnage.toString()),
        React.createElement("td", null, v.Model.Length.toString()),
        React.createElement("td", null, v.Model.Beam.toString()),
        React.createElement("td", null, v.Model.MaxDraft.toString()));
});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceOverrideCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var VesselServiceOverrideResponse_1 = __webpack_require__(1375);
var VesselServiceOverrideCache = /** @class */ (function (_super) {
    __extends(VesselServiceOverrideCache, _super);
    function VesselServiceOverrideCache(data) {
        var _this = _super.call(this) || this;
        _this.VesselServiceOverrideResponses = PCCache_1.PCCollection(VesselServiceOverrideResponse_1.VesselServiceOverrideResponse);
        new DataCache_1.SharedKeyRelationship(_this.VesselServiceOverrideResponses, data.Vessels, function (o) { return o.Vessel; }, null);
        return _this;
    }
    return VesselServiceOverrideCache;
}(DataCache_1.DataCache));
exports.VesselServiceOverrideCache = VesselServiceOverrideCache;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceOverride = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var autoSave_1 = __webpack_require__(31);
var Country_1 = __webpack_require__(283);
var defaultVesselPrecedenceOrder = [function (v) { return v.LloydServiceVessel; }, function (v) { return v.MarineTrafficServiceVessel; }, function (v) { return v.PSixServiceVessel; }];
function VesselServiceOverride(ajax, entrypoints, data, cache, _a) {
    var id = _a.id;
    var model = cache.VesselServiceOverrideResponses.update1(null, { VesselId: id }), url = entrypoints.VesselServiceOverride({ Id: id }), request = ajax.Url(url).Get(), vessel = s_js_1.default(function () { return model.Vessel() === null ? null : VesselViewModel(model.Vessel()); });
    request.done(function (json) {
        return cache.VesselServiceOverrideResponses.update1(request.Date, json);
    });
    return {
        Model: model,
        Vessel: vessel,
        Countries: s_array_1.lift(function () { return Array.from(data.Countries.items()); }).sort(Country_1.Country.SortOrder),
        GoBack: function () { return window.history.back(); },
        EditSources: function () { return window.location.hash = '#!vesselserviceconfigure?id=' + id; }
    };
    function VesselViewModel(vessel) {
        var override = s_js_1.default(function () { return vessel.OverrideServiceVessel() && OverrideServiceVesselViewModel(vessel.OverrideServiceVessel()); }), client = ajax.Url(function () { return vessel.Url() || ''; }), draft = autoSave_1.AutoSavingDraftObject(vessel, client, ['Status']), 
        // TH: NOTE -- The precedences for flagId and in the return statement reflect the server-side VesselPrecedenceService.
        flagId = applyNumericOverride(function (v) { return v.FlagId; });
        return {
            Model: draft,
            OverrideServiceVessel: override,
            Name: applyStringOverride(function (v) { return v.Name; }),
            VIN: applyStringOverride(function (v) { return v.VIN; }, [function (v) { return v.PSixServiceVessel; }]),
            IMO: applyStringOverride(function (v) { return v.IMO; }),
            MMSID: applyStringOverride(function (v) { return v.MMSID; }),
            CallSign: applyStringOverride(function (v) { return v.CallSign; }),
            Beam: applyMeasurementOverride(function (v) { return v.Beam; }),
            Length: applyMeasurementOverride(function (v) { return v.Length; }),
            GrossTonnage: applyMeasurementOverride(function (v) { return v.GrossTonnage; }, [function (v) { return v.MarineTrafficServiceVessel; }, function (v) { return v.LloydServiceVessel; }, function (v) { return v.PSixServiceVessel; }]),
            IsGovernmentVessel: applyBooleanOverride(function (v) { return v.IsGovernmentVessel; }),
            VesselType: applyStringOverride(function (v) { return v.VesselType; }, [function (v) { return v.LloydServiceVessel; }, function (v) { return v.MarineTrafficServiceVessel; }]),
            IsCruiseVessel: applyBooleanOverride(function (v) { return v.IsCruiseVessel; }),
            MaxDraft: applyMeasurementOverride(function (v) { return v.MaxDraft; }),
            ExpectedPassengerCount: applyNumericOverride(function (v) { return v.ExpectedPassengerCount; }),
            Flag: data.Countries.index(function () { return flagId() === null ? -1 : flagId(); })
        };
        function applyStringOverride(prop, precedences) {
            return applyOverride(function (res) { return !!res; }, function (p) { return p(); }, prop, precedences);
        }
        function applyMeasurementOverride(prop, precedences) {
            return applyOverride(function (res) { return res.Num() !== null; }, function (p) { return p; }, prop, precedences);
        }
        function applyBooleanOverride(prop, precedences) {
            return applyOverride(function (res) { return res !== null; }, function (p) { return p(); }, prop, precedences);
        }
        function applyNumericOverride(prop, precedences) {
            return applyOverride(function (res) { return res !== null; }, function (p) { return p(); }, prop, precedences);
        }
        function applyOverride(populated, accessor, prop, precedences) {
            var _precedences = precedences || defaultVesselPrecedenceOrder;
            return function () {
                var o = override() && override().Model;
                if (o && populated(accessor(prop(o))))
                    return accessor(prop(o));
                for (var i = 0; i < _precedences.length; i++) {
                    var p = _precedences[i](vessel)();
                    if (p && populated(accessor(prop(p))))
                        return accessor(prop(p));
                }
                return accessor(prop(vessel));
            };
        }
    }
    function OverrideServiceVesselViewModel(overrideServiceVessel) {
        var client = ajax.Url(function () { return overrideServiceVessel.Url() || ''; }, { useCache: true }), draft = autoSave_1.AutoSavingDraftObject(overrideServiceVessel, client, [
            'Beam.Num',
            'CallSign',
            'FlagId',
            'GrossTonnage.Num',
            'IMO',
            'IsGovernmentVessel',
            'Length.Num',
            'MMSID',
            'Name',
            'VIN',
            'MaxDraft.Num',
            'VesselType',
            'IsCruiseVessel',
            'ExpectedPassengerCount'
        ]), callSign = coerceEmptyToNull(draft.CallSign), name = coerceEmptyToNull(draft.Name), imo = coerceEmptyToNull(draft.IMO), vesselType = coerceEmptyToNull(draft.VesselType);
        draft.Flag = s_js_1.default.value(s_js_1.default.sample(overrideServiceVessel.Flag));
        data.OverrideServiceVessels.attach(draft, [draft.Flag]);
        return {
            Model: draft,
            CallSign: callSign,
            Name: name,
            IMO: imo,
            VesselType: vesselType
        };
        function coerceEmptyToNull(signal) {
            return function (val) {
                if (val === undefined)
                    return signal();
                return signal(val === '' ? null : val);
            };
        }
    }
}
exports.VesselServiceOverride = VesselServiceOverride;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceOverrideView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var PSixServiceVessel_1 = __webpack_require__(580);
var VesselStatus_1 = __webpack_require__(138);
var view_1 = __webpack_require__(55);
var cx = __webpack_require__(10);
exports.VesselServiceOverrideView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement(PageBody, { model: m });
});
var PageBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "page-body" },
        React.createElement("div", { className: "pc-card main-page" },
            React.createElement("div", { className: "pc-card-header" },
                React.createElement("div", { className: "pc-card-title-vessel" },
                    React.createElement("span", { className: "pc-card-title" }, m.Vessel() && m.Vessel().Name())),
                m.Model.CanEdit() && React.createElement("div", { className: "pc-card-manage-sources" },
                    React.createElement("a", { href: "", onClick: eventWrappers_1.noDefault(m.EditSources) }, "Edit Sources"))),
            React.createElement("div", { className: "profile" },
                React.createElement("table", { className: "table" },
                    React.createElement(TableHead, null),
                    React.createElement(TableBody, { model: m })))));
});
var TableHead = supercritical_1.default(function () {
    return React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { className: "table-header-name" }),
            React.createElement("th", { className: "table-header-column" }, "Vessel"),
            React.createElement("th", { className: "table-header-column" }, "Override"),
            React.createElement("th", { className: "table-header-column" }, "Lloyd"),
            React.createElement("th", { className: "table-header-column" }, "Marine Traffic"),
            React.createElement("th", { className: "table-header-column" }, "PSix")));
});
var TableBody = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tbody", null,
        React.createElement(StringOverrideRow, { model: m, label: "Name", inputPlaceholder: "Vessel Name", vesselProp: function (v) { return v.Name; }, overrideProp: function (o) { return o.Name; }, serviceVesselProp: function (sv) { return sv.Name; } }),
        React.createElement(StringOverrideRow, { model: m, label: "IMO", vesselProp: function (v) { return v.IMO; }, overrideProp: function (o) { return o.IMO; }, serviceVesselProp: function (sv) { return sv.IMO; } }),
        React.createElement(StringOverrideRow, { model: m, label: "MMSID", vesselProp: function (v) { return v.MMSID; }, overrideProp: function (o) { return o.Model.MMSID; }, serviceVesselProp: function (sv) { return sv.MMSID; } }),
        React.createElement(StringOverrideRow, { model: m, label: "VIN", vesselProp: function (v) { return v.VIN; }, overrideProp: function (o) { return o.Model.VIN; }, serviceVesselProp: function (sv) { return sv.VIN; } }),
        React.createElement(StringOverrideRow, { model: m, label: "Call Sign", vesselProp: function (v) { return v.CallSign; }, overrideProp: function (o) { return o.Model.CallSign; }, serviceVesselProp: function (sv) { return sv.CallSign; } }),
        React.createElement(MeasurementOverrideRow, { model: m, label: "Beam", vesselProp: function (v) { return v.Beam; }, overrideProp: function (o) { return o.Model.Beam; }, serviceVesselProp: function (sv) { return sv.Beam; } }),
        React.createElement(MeasurementOverrideRow, { model: m, label: "Length", vesselProp: function (v) { return v.Length; }, overrideProp: function (o) { return o.Model.Length; }, serviceVesselProp: function (sv) { return sv.Length; } }),
        React.createElement(UnitlessMeasurementOverrideRow, { model: m, label: "Gross Tonnage", vesselProp: function (v) { return v.GrossTonnage; }, overrideProp: function (o) { return o.Model.GrossTonnage; }, serviceVesselProp: function (sv) { return sv.GrossTonnage; } }),
        React.createElement(MeasurementOverrideRow, { model: m, label: "Max Draft", vesselProp: function (v) { return v.MaxDraft; }, overrideProp: function (o) { return o.Model.MaxDraft; }, serviceVesselProp: function (sv) { return sv.MaxDraft; } }),
        React.createElement(StringOverrideRow, { model: m, label: "Vessel Type", vesselProp: function (v) { return v.VesselType; }, overrideProp: function (o) { return o.VesselType; }, 
            // Even though we collect VesselType for PSixServiceVessels, the value is apparently so unreliable
            // that it's not worth displaying in the UI. Our server-side precedence service also ignores it.
            serviceVesselProp: function (sv) { return sv instanceof PSixServiceVessel_1.PSixServiceVessel ? (function () { return ''; }) : sv.VesselType; } }),
        React.createElement(BooleanOverrideRow, { model: m, label: "Cruise Vessel", vesselProp: function (v) { return v.IsCruiseVessel; }, overrideProp: function (o) { return o.Model.IsCruiseVessel; }, serviceVesselProp: function (sv) { return sv.IsCruiseVessel; } }),
        React.createElement(IntegerOverrideRow, { model: m, label: "Guests", vesselProp: function (v) { return v.ExpectedPassengerCount; }, overrideProp: function (o) { return o.Model.ExpectedPassengerCount; }, serviceVesselProp: function (sv) { return sv.ExpectedPassengerCount; } }),
        React.createElement(BooleanOverrideRow, { model: m, label: "Government Vessel", vesselProp: function (v) { return v.IsGovernmentVessel; }, overrideProp: function (o) { return o.Model.IsGovernmentVessel; }, serviceVesselProp: function (sv) { return sv.IsGovernmentVessel; } }),
        React.createElement(VesselFlagRow, { model: m }),
        React.createElement(VesselStatusRow, { model: m }));
});
var VesselFlagRow = supercritical_1.default(function (_a) {
    var m = _a.model;
    var overrideFlagId = m.Vessel()
        && m.Vessel().OverrideServiceVessel()
        && m.Vessel().OverrideServiceVessel().Model.FlagId, serviceVesselProp = function (v) { return function () { return v.Flag() && v.Flag().Name(); }; };
    return (React.createElement("tr", null,
        React.createElement("td", { className: "vessel-particular-label" }, "Flag"),
        React.createElement("td", { className: "vessel-particular-detail" }, m.Vessel() && m.Vessel().Flag() && m.Vessel().Flag().Name()),
        React.createElement("td", { className: "vessel-particular-override flag" }, m.Vessel() && m.Vessel().OverrideServiceVessel() && (m.Model.CanEdit() ?
            React.createElement("span", null,
                React.createElement("select", { className: "pc-select-secondary country_dropdown", value: overrideFlagId() === null ? '' : '' + overrideFlagId(), onChange: function (e) { return overrideFlagId(e.currentTarget.value === '' ? null : +e.currentTarget.value); } },
                    React.createElement("option", { value: "" }, "---"),
                    m.Countries().map(function (c) {
                        return React.createElement("option", { key: c.Id(), value: c.Id() }, c.Name());
                    })),
                React.createElement("span", { className: "pc-select-chevron" }))
            : m.Vessel().OverrideServiceVessel().Model.Flag()
                && m.Vessel().OverrideServiceVessel().Model.Flag().Name())),
        React.createElement("td", { className: "vessel-particular-detail" }, m.Vessel() && m.Vessel().Model.LloydServiceVessel() && m.Vessel().Model.LloydServiceVessel().Flag() && m.Vessel().Model.LloydServiceVessel().Flag().Name()),
        React.createElement(StringServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: function (v) { return v.MarineTrafficServiceVessel(); } }),
        React.createElement(StringServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: function (v) { return v.PSixServiceVessel(); } })));
});
var VesselStatusRow = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("tr", null,
        React.createElement("td", { className: "vessel-particular-label" }, "Vessel Status"),
        React.createElement("td", { className: "vessel-particular-detail status" }, m.Vessel() && (m.Model.CanEdit() ?
            React.createElement("span", null,
                React.createElement("select", { className: "pc-select-secondary status_dropdown", value: m.Vessel().Model.Status(), onChange: function (e) { return m.Vessel().Model.Status(+e.currentTarget.value); } }, VesselStatus_1.VesselStatuses.map(function (_a) {
                    var Id = _a.Id, Name = _a.Name;
                    return React.createElement("option", { key: Id, value: Id }, Name);
                })),
                React.createElement("span", { className: "pc-select-chevron" }))
            : VesselStatus_1.VesselStatusDisplayName[m.Vessel().Model.Status()])),
        React.createElement("td", { className: "vessel-particular-override" }),
        React.createElement("td", { className: "vessel-particular-detail" }),
        React.createElement("td", { className: "vessel-particular-detail" }),
        React.createElement("td", { className: "vessel-particular-detail" }));
});
var OverrideRow = /** @class */ (function (_super) {
    __extends(OverrideRow, _super);
    function OverrideRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverrideRow.prototype.srender = function (_a) {
        var m = _a.model, label = _a.label, inputPlaceholder = _a.inputPlaceholder, vesselProp = _a.vesselProp, overrideProp = _a.overrideProp, serviceVesselProp = _a.serviceVesselProp;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "vessel-particular-label" }, label),
            React.createElement("td", { className: "vessel-particular-detail" }, m.Vessel() && this.vesselDisplay(vesselProp(m.Vessel()))),
            React.createElement("td", { className: cx("vessel-particular-override", {
                    'no-override': !m.Model.CanEdit()
                }) }, m.Vessel() && m.Vessel().OverrideServiceVessel() && (m.Model.CanEdit() ?
                this.overrideInputElement(overrideProp(m.Vessel().OverrideServiceVessel()), inputPlaceholder || label, m)
                : this.overrideDisplay(overrideProp(m.Vessel().OverrideServiceVessel()), m))),
            this.serviceVesselCell(m, serviceVesselProp, function (v) { return v.LloydServiceVessel(); }),
            this.serviceVesselCell(m, serviceVesselProp, function (v) { return v.MarineTrafficServiceVessel(); }),
            this.serviceVesselCell(m, serviceVesselProp, function (v) { return v.PSixServiceVessel(); })));
    };
    return OverrideRow;
}(supercritical_1.SuperCriticalComponent));
var StringOverrideRow = /** @class */ (function (_super) {
    __extends(StringOverrideRow, _super);
    function StringOverrideRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringOverrideRow.prototype.vesselDisplay = function (val) {
        return val() || '';
    };
    StringOverrideRow.prototype.overrideDisplay = function (val) {
        return val() || '';
    };
    StringOverrideRow.prototype.overrideInputElement = function (val, placeholder) {
        return (React.createElement("input", { placeholder: placeholder, value: val() || '', onChange: function (e) { return val(e.currentTarget.value); } }));
    };
    StringOverrideRow.prototype.serviceVesselCell = function (m, serviceVesselProp, serviceVesselRef) {
        return (React.createElement(StringServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: serviceVesselRef }));
    };
    return StringOverrideRow;
}(OverrideRow));
var NumericOverrideRow = /** @class */ (function (_super) {
    __extends(NumericOverrideRow, _super);
    function NumericOverrideRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumericOverrideRow.prototype.vesselDisplay = function (val) {
        return NumberOrBlank(val());
    };
    NumericOverrideRow.prototype.overrideDisplay = function (val) {
        return NumberOrBlank(val());
    };
    NumericOverrideRow.prototype.overrideInputElement = function (val, placeholder) {
        return (React.createElement(view_1.NullableNumericInput, { placeholder: placeholder, value: val }));
    };
    NumericOverrideRow.prototype.serviceVesselCell = function (m, serviceVesselProp, serviceVesselRef) {
        return (React.createElement(NumericServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: serviceVesselRef }));
    };
    return NumericOverrideRow;
}(OverrideRow));
var IntegerOverrideRow = /** @class */ (function (_super) {
    __extends(IntegerOverrideRow, _super);
    function IntegerOverrideRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntegerOverrideRow.prototype.overrideInputElement = function (val, placeholder) {
        return (React.createElement(view_1.NullableIntegerInput, { placeholder: placeholder, value: val }));
    };
    return IntegerOverrideRow;
}(NumericOverrideRow));
var MeasurementOverrideRow = /** @class */ (function (_super) {
    __extends(MeasurementOverrideRow, _super);
    function MeasurementOverrideRow(props, showUnits) {
        if (showUnits === void 0) { showUnits = true; }
        var _this = _super.call(this, props) || this;
        _this.showUnits = showUnits;
        return _this;
    }
    MeasurementOverrideRow.prototype.vesselDisplay = function (val) {
        return val().toString({ units: this.showUnits });
    };
    MeasurementOverrideRow.prototype.overrideDisplay = function (val) {
        return val.toString({ units: this.showUnits });
    };
    MeasurementOverrideRow.prototype.overrideInputElement = function (val, placeholder) {
        return (React.createElement("span", null,
            React.createElement(view_1.NullableNumericInput, { placeholder: placeholder, value: val.Num }),
            ' ',
            this.showUnits && React.createElement("span", null, val.UOM())));
    };
    MeasurementOverrideRow.prototype.serviceVesselCell = function (m, serviceVesselProp, serviceVesselRef) {
        return this.showUnits ?
            React.createElement(MeasurementServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: serviceVesselRef })
            : React.createElement(UnitlessMeasurementServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: serviceVesselRef });
    };
    return MeasurementOverrideRow;
}(OverrideRow));
var UnitlessMeasurementOverrideRow = /** @class */ (function (_super) {
    __extends(UnitlessMeasurementOverrideRow, _super);
    function UnitlessMeasurementOverrideRow(props) {
        return _super.call(this, props, false) || this;
    }
    return UnitlessMeasurementOverrideRow;
}(MeasurementOverrideRow));
var BooleanOverrideRow = /** @class */ (function (_super) {
    __extends(BooleanOverrideRow, _super);
    function BooleanOverrideRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BooleanOverrideRow.prototype.vesselDisplay = function (val) {
        return (React.createElement("input", { type: "checkbox", checked: !!val(), disabled: true }));
    };
    BooleanOverrideRow.prototype.overrideDisplay = function (val) {
        return YesNoUnknown(val());
    };
    BooleanOverrideRow.prototype.overrideInputElement = function (val, placeholder) {
        return (
        // TH 11/11/2016 -- We used to use an <input type="checkbox"> here
        // Switching to a <select> to distinguish null from false.
        React.createElement("span", null,
            React.createElement("select", { className: "pc-select-secondary", value: val() ? 1 : val() === false ? -1 : 0, onChange: function (e) { return val(e.currentTarget.value === '1' ? true : e.currentTarget.value === '-1' ? false : null); } },
                React.createElement("option", { value: 0 }, "--"),
                React.createElement("option", { value: 1 }, "Yes"),
                React.createElement("option", { value: -1 }, "No")),
            React.createElement("span", { className: "pc-select-chevron" })));
    };
    BooleanOverrideRow.prototype.serviceVesselCell = function (m, serviceVesselProp, serviceVesselRef) {
        return (React.createElement(BooleanServiceVesselCell, { model: m, serviceVesselProp: serviceVesselProp, serviceVesselRef: serviceVesselRef }));
    };
    return BooleanOverrideRow;
}(OverrideRow));
var ServiceVesselCell = /** @class */ (function (_super) {
    __extends(ServiceVesselCell, _super);
    function ServiceVesselCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceVesselCell.prototype.srender = function (_a) {
        var m = _a.model, serviceVesselProp = _a.serviceVesselProp, serviceVesselRef = _a.serviceVesselRef;
        var serviceVessel = m.Vessel() && serviceVesselRef(m.Vessel().Model);
        return (React.createElement("td", { className: "vessel-particular-detail" }, serviceVessel && this.display(serviceVesselProp(serviceVessel))));
    };
    return ServiceVesselCell;
}(supercritical_1.SuperCriticalComponent));
var StringServiceVesselCell = /** @class */ (function (_super) {
    __extends(StringServiceVesselCell, _super);
    function StringServiceVesselCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringServiceVesselCell.prototype.display = function (val) {
        return val() || '';
    };
    return StringServiceVesselCell;
}(ServiceVesselCell));
var NumericServiceVesselCell = /** @class */ (function (_super) {
    __extends(NumericServiceVesselCell, _super);
    function NumericServiceVesselCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumericServiceVesselCell.prototype.display = function (val) {
        return NumberOrBlank(val());
    };
    return NumericServiceVesselCell;
}(ServiceVesselCell));
var MeasurementServiceVesselCell = /** @class */ (function (_super) {
    __extends(MeasurementServiceVesselCell, _super);
    function MeasurementServiceVesselCell(props, showUnits) {
        if (showUnits === void 0) { showUnits = true; }
        var _this = _super.call(this, props) || this;
        _this.showUnits = showUnits;
        return _this;
    }
    MeasurementServiceVesselCell.prototype.display = function (val) {
        return val.toString({ units: this.showUnits });
    };
    return MeasurementServiceVesselCell;
}(ServiceVesselCell));
var UnitlessMeasurementServiceVesselCell = /** @class */ (function (_super) {
    __extends(UnitlessMeasurementServiceVesselCell, _super);
    function UnitlessMeasurementServiceVesselCell(props) {
        return _super.call(this, props, false) || this;
    }
    return UnitlessMeasurementServiceVesselCell;
}(MeasurementServiceVesselCell));
var BooleanServiceVesselCell = /** @class */ (function (_super) {
    __extends(BooleanServiceVesselCell, _super);
    function BooleanServiceVesselCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BooleanServiceVesselCell.prototype.display = function (val) {
        // TH: 11/11/2016 -- We used to use an <input type="checkbox"> here.
        // Switching to Yes/No/empty to distinguish null (as in unknown) from false (as in known to be false).
        return YesNoUnknown(val());
    };
    return BooleanServiceVesselCell;
}(ServiceVesselCell));
function NumberOrBlank(val) {
    return val === null ? '' : val.toLocaleString();
}
function YesNoUnknown(val) {
    return val ? 'Yes' : val === false ? 'No' : '';
}


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceProfileRoute = void 0;
var React = __webpack_require__(2);
var componentLocation_1 = __webpack_require__(34);
var routeParams_1 = __webpack_require__(77);
var routeParams_2 = __webpack_require__(87);
var model_1 = __webpack_require__(278);
var view_1 = __webpack_require__(1208);
var view_2 = __webpack_require__(12);
var VesselServiceProfileRoute = function (model, appWrapper, tzutils, request) {
    var m = model(inboundParams(request, tzutils));
    return {
        view: React.createElement(view_2.AppWrapperView, { model: appWrapper },
            React.createElement(view_1.VesselServiceProfileView, { model: m })),
        reflectState: function () { return outboundParams(request, m); }
    };
};
exports.VesselServiceProfileRoute = VesselServiceProfileRoute;
function inboundParams(request, tzutils) {
    var id = +(request.params['id'] || 0), mode = request.params['mode'], range = request.params['range'], from = request.params['from'], to = request.params['to'];
    return {
        id: id,
        mode: mode ? +mode : model_1.VesselServiceProfileMode.Particulars,
        range: range !== undefined ? routeParams_2.parseDateRange(range) : 3 /* ThisMonth */,
        from: from !== undefined ? routeParams_1.parseDate(from, tzutils) : undefined,
        to: to !== undefined ? routeParams_1.parseDate(to, tzutils) : undefined
    };
}
function outboundParams(request, m) {
    var params = {};
    params['id'] = m.Id + '';
    if (m.Mode() !== model_1.VesselServiceProfileMode.Particulars)
        params['mode'] = m.Mode() + '';
    routeParams_2.outboundDateRangeParams(m.VesselPortCalls.DateRangeSelector, params, 3 /* ThisMonth */, { range: 'range', from: 'from', to: 'to' });
    return new componentLocation_1.Location(request.name, params);
}


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceProfileView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var model_1 = __webpack_require__(278);
var view_1 = __webpack_require__(1206);
var view_2 = __webpack_require__(1195);
exports.VesselServiceProfileView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "vessel-service-override pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(m.GoBack) }, "<< Back")),
        React.createElement("h1", { className: "pc-page-title" },
            React.createElement("div", { className: "profile-breadcrumb" },
                React.createElement("span", { className: "pc-text-label-color" }, "More"),
                React.createElement("span", { className: "pc-icon-bullet pc-text-label-color" }),
                React.createElement("span", { className: "pc-text-label-color" }, "Vessels"),
                React.createElement("span", { className: "pc-icon-bullet" }),
                React.createElement("span", null, "Profile")),
            React.createElement("div", { className: "profile-menu" },
                React.createElement("div", { className: "profile-menu-item profile-menu-particulars" }, m.Mode() === model_1.VesselServiceProfileMode.Particulars ? React.createElement("span", null, "Particulars") : React.createElement("a", { href: "", className: "pc-text-label-color", onClick: eventWrappers_1.noDefault(m.GoParticulars) }, "Particulars")),
                React.createElement("div", { className: "profile-menu-item profile-menu-portcalls" }, m.Mode() === model_1.VesselServiceProfileMode.PortCalls ? React.createElement("span", null, "PortCalls") : React.createElement("a", { href: "", className: "pc-text-label-color", onClick: eventWrappers_1.noDefault(m.GoPortCalls) }, "PortCalls")))),
        m.Mode() === model_1.VesselServiceProfileMode.Particulars && React.createElement(view_1.VesselServiceOverrideView, { model: m.VesselServiceOverride }),
        m.Mode() === model_1.VesselServiceProfileMode.PortCalls && React.createElement(view_2.VesselPortCallsView, { model: m.VesselPortCalls }));
});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsCache = void 0;
var DataCache_1 = __webpack_require__(15);
var PCCache_1 = __webpack_require__(17);
var WartsilaEnrichmentsResponse_1 = __webpack_require__(1378);
var WartsilaEnrichmentsCache = /** @class */ (function (_super) {
    __extends(WartsilaEnrichmentsCache, _super);
    function WartsilaEnrichmentsCache(data) {
        var _this = _super.call(this) || this;
        _this.WartsilaEnrichmentsResponses = PCCache_1.PCCollection(WartsilaEnrichmentsResponse_1.WartsilaEnrichmentsResponse);
        new DataCache_1.SharedKeyRelationship(_this.WartsilaEnrichmentsResponses, data.PortCalls, function (r) { return r.PortCall; }, null);
        new DataCache_1.QueryResultRelationship(_this.WartsilaEnrichmentsResponses, data.WartsilaEnhancedEstimateQueries, function (r) { return r.RelevantQuery; });
        return _this;
    }
    return WartsilaEnrichmentsCache;
}(DataCache_1.DataCache));
exports.WartsilaEnrichmentsCache = WartsilaEnrichmentsCache;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsEstimateDetails = void 0;
var s_js_1 = __webpack_require__(0);
var tzmoment_1 = __webpack_require__(9);
var EnhancedEstimateQuery_1 = __webpack_require__(303);
var AutomationSystemType_1 = __webpack_require__(556);
function WartsilaEnrichmentsEstimateDetails(data, ajax, entrypoints, tzutils, _a) {
    var _this = this;
    var model = _a.model, readyForInitialRefresh = _a.readyForInitialRefresh;
    var 
    // Clock for displaying time ago for time of last known vessel location.
    // Once a minute is plenty fast.
    clock = tzutils.clock(60 * 1000), automation = s_js_1.default(function () {
        var automations = Array.from(data.AutomationSystems.items()).filter(function (sys) {
            return sys.Type() === AutomationSystemType_1.AutomationSystemType.WartsilaEnhancedEstimates &&
                sys.Active();
        });
        return automations.length ? automations[0] : null;
    }), initialRefreshPendingOrInProgress = s_js_1.default.value(true), estimateRefresher = s_js_1.default(function () { return automation() ?
        EstimateRefreshViewModel(model, automation(), clock, ajax, entrypoints) : null; }), initialRefreshInitiated = s_js_1.default.value(false);
    s_js_1.default(function () { return __awaiter(_this, void 0, void 0, function () {
        var refresher, pc, arrivalPt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!initialRefreshInitiated()) return [3 /*break*/, 10];
                    refresher = estimateRefresher();
                    if (!refresher) return [3 /*break*/, 10];
                    initialRefreshInitiated(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 10]);
                    return [4 /*yield*/, readyForInitialRefresh];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 3:
                    pc = model.PortCall(), arrivalPt = pc && pc.Itinerary().find(function (pt) { return pt.IsPortArrival(); }) || null;
                    if (!(!model.RelevantQuery() &&
                        arrivalPt &&
                        arrivalPt.Arrival.Actual() === null &&
                        arrivalPt.Arrival.Estimated() < tzmoment_1.tzmomentMod(tzutils, tzutils.now(), function (d) { return d.add(48, 'hours'); }))) return [3 /*break*/, 8];
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, , 6, 7]);
                    return [4 /*yield*/, refresher.RefreshEstimate()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    initialRefreshPendingOrInProgress(false);
                    return [7 /*endfinally*/];
                case 7: return [3 /*break*/, 9];
                case 8:
                    initialRefreshPendingOrInProgress(false);
                    _a.label = 9;
                case 9: return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); });
    return {
        RelevantQuery: s_js_1.default(function () { return model.RelevantQuery() === null ? null : EnhancedEstimateQueryViewModel(model.RelevantQuery(), clock); }),
        EstimateRefresher: estimateRefresher,
        InitialRefreshPendingOrInProgress: function () { return initialRefreshPendingOrInProgress(); },
        AnyRefreshPendingOrInProgress: function () { return initialRefreshPendingOrInProgress() ||
            !!estimateRefresher() && estimateRefresher().Refreshing(); }
    };
}
exports.WartsilaEnrichmentsEstimateDetails = WartsilaEnrichmentsEstimateDetails;
function EnhancedEstimateQueryViewModel(model, clock) {
    return {
        Model: model,
        Result: s_js_1.default(function () { return model.Result() === null ? null : EnhancedEstimateViewModel(model.Result(), clock); })
    };
}
function EnhancedEstimateViewModel(model, clock) {
    return {
        Model: model,
        // If we somehow didn't get a TimeOfKnownVesselLocation from the ETA endpoint,
        // go with the time the query was created, which should be accurate to within
        // an hour or so.
        Timestamp: function () { return model.TimeOfKnownVesselLocation() || model.Query() && model.Query().CreationDate(); },
        Clock: clock
    };
}
function EstimateRefreshViewModel(model, automation, clock, ajax, entrypoints) {
    var 
    // NOTE -- Switching to S.data instead of S.value to avoid a known (to AH et al) bug
    // in S. See https://github.com/adamhaile/surplus/issues/65
    // AH has a fix pending, but in the meantime, S.data avoids the issue.
    // Also note that there are many other spots where we use this same pattern to
    // prevent overlapping requests from fast clicks.From a quick glance, looks like they
    // all use S.data already.
    refreshing = s_js_1.default.data(false), failedRefreshAttempt = s_js_1.default.value(null), failedRefreshAttemptVM = s_js_1.default(function () {
        return failedRefreshAttempt() ? {
            query: EnhancedEstimateQueryViewModel(failedRefreshAttempt(), clock),
            dismiss: function () { failedRefreshAttempt(null); }
        } : null;
    }), url = entrypoints.WartsilaRefreshEstimate({ PCId: model.Id(), AutomationId: automation.Id() }), client = ajax.Url(url, {
        useCache: true
    });
    return {
        FailedRefreshAttempt: failedRefreshAttemptVM,
        RefreshEstimate: RefreshEstimate,
        Refreshing: function () { return refreshing(); }
    };
    function RefreshEstimate() {
        return __awaiter(this, void 0, void 0, function () {
            var req, wartsilaUpdates_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (refreshing())
                            return [2 /*return*/];
                        refreshing(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        req = client.Post({});
                        return [4 /*yield*/, req];
                    case 2:
                        wartsilaUpdates_1 = (_a.sent()).WartsilaEntities();
                        s_js_1.default.freeze(function () {
                            var oldQuery = model.RelevantQuery(), newQuery = wartsilaUpdates_1 && wartsilaUpdates_1.EnhancedEstimateQueries().length ?
                                wartsilaUpdates_1.EnhancedEstimateQueries()[0] : null;
                            if (!newQuery)
                                throw new Error("Expected the DataCacheUpdate to include a new EnhancedEstimateQuery");
                            if (isMoreRelevant(newQuery, oldQuery)) {
                                model.RelevantQuery(newQuery);
                                failedRefreshAttempt(null); // Clear any previous failure message
                            }
                            else {
                                failedRefreshAttempt(newQuery);
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        refreshing(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
}
function isMoreRelevant(newQuery, oldQuery) {
    // New query is more relevant than the old one provided
    //   - There was no old query, OR
    //   - The old query was unsuccessful. Any more recent query is more relevant in this case, OR
    //   - The new query is successful.
    return oldQuery === null ||
        oldQuery.Status() !== EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Succeeded ||
        newQuery.Status() === EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Succeeded;
}


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsMap = void 0;
var s_js_1 = __webpack_require__(0);
function WartsilaEnrichmentsMap(_a) {
    var model = _a.model;
    return {
        RelevantQuery: s_js_1.default(function () { return model.RelevantQuery() === null ? null : EnhancedEstimateQueryViewModel(model.RelevantQuery()); })
    };
}
exports.WartsilaEnrichmentsMap = WartsilaEnrichmentsMap;
function EnhancedEstimateQueryViewModel(model) {
    return {
        Model: model,
        Result: s_js_1.default(function () { return model.Result() === null ? null : EnhancedEstimateViewModel(model.Result()); })
    };
}
function EnhancedEstimateViewModel(model) {
    return {
        Model: model,
    };
}


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichments = void 0;
function WartsilaEnrichments(loader, data, estimateDetailsModel, mapModel, _a) {
    var id = _a.id;
    var _b = loader({ Id: id }, 120), model = _b.model, modelLoading = _b.loading, task = _b.task, portcall = data.PortCalls.update1(null, { Id: id }), estimateDetails = estimateDetailsModel({ model: model, readyForInitialRefresh: task }), map = mapModel({ model: model });
    return {
        PortCall: portcall,
        EstimateDetails: estimateDetails,
        Map: map,
        Loading: function () { return modelLoading() || estimateDetails.AnyRefreshPendingOrInProgress(); }
    };
}
exports.WartsilaEnrichments = WartsilaEnrichments;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsRoute = void 0;
var React = __webpack_require__(2);
var view_1 = __webpack_require__(1216);
var view_2 = __webpack_require__(12);
var WartsilaEnrichmentsRoute = function (model, appwrapper, request) { return ({
    view: React.createElement(view_2.AppWrapperView, { model: appwrapper, navbarTab: 0 /* Berths */ },
        React.createElement(view_1.WartsilaEnrichmentsView, { model: model(convertParams(request)) }))
}); };
exports.WartsilaEnrichmentsRoute = WartsilaEnrichmentsRoute;
function convertParams(request) {
    return {
        id: +(request.params["id"] || 0)
    };
}


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsSummaryCard = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var EnhancedEstimateQuery_1 = __webpack_require__(303);
var AutomationSystemType_1 = __webpack_require__(556);
function WartsilaEnrichmentsSummaryCard(loader, data, estimateDetailsModel, mapModel, _a) {
    var portcall = _a.portcall, readyForInitialRefresh = _a.readyForInitialRefresh;
    var 
    // All WartsilaEnhancedEstimates automations for this domain
    automations = s_array_1.lift(function () { return Array.from(data.AutomationSystems.items()); })
        .filter(function (sys) {
        return sys.Type() === AutomationSystemType_1.AutomationSystemType.WartsilaEnhancedEstimates &&
            sys.Active();
    }), 
    // Having card content is conditional on having a WartsilaEnhancedEstimates automation configured
    content = s_js_1.default(function () { return automations().length ? SummaryCardContent(loader, estimateDetailsModel, mapModel, portcall, readyForInitialRefresh) : null; });
    return {
        Content: content
    };
}
exports.WartsilaEnrichmentsSummaryCard = WartsilaEnrichmentsSummaryCard;
function SummaryCardContent(loader, estimateDetailsModel, mapModel, portcall, readyForInitialRefresh) {
    var _this = this;
    var _a = loader({ Id: portcall.Id() }, 120), model = _a.model, modelLoading = _a.loading, task = _a.task, estimateDetails = estimateDetailsModel({
        model: model,
        // Ready for initial refresh when calling code says we're ready and we've loaded our model
        readyForInitialRefresh: (function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 4]);
                        return [4 /*yield*/, readyForInitialRefresh];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, task];
                    case 3:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })()
    }), map = mapModel({ model: model });
    return {
        Id: portcall.Id(),
        HasSuccessfulQuery: function () { return !!model.RelevantQuery() && model.RelevantQuery().Status() === EnhancedEstimateQuery_1.EnhancedEstimateQueryStatus.Succeeded; },
        EstimateDetails: estimateDetails,
        Map: map,
        Loading: function () { return modelLoading() || estimateDetails.AnyRefreshPendingOrInProgress(); }
    };
}


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsSummaryCardView = void 0;
var React = __webpack_require__(2);
var cx = __webpack_require__(10);
var supercritical_1 = __webpack_require__(4);
var estimateDetailsView_1 = __webpack_require__(552);
var mapview_1 = __webpack_require__(553);
exports.WartsilaEnrichmentsSummaryCardView = supercritical_1.default(function (_a) {
    var m = _a.model, extraClassName = _a.extraClassName;
    return m.Content() && React.createElement(ContentView, { model: m.Content(), className: extraClassName });
});
var ContentView = supercritical_1.default(function (_a) {
    var m = _a.model, className = _a.className;
    return React.createElement("div", { className: cx('wartsila-enrichments summary-card pc-card', className, {
            'full-view': m.HasSuccessfulQuery()
        }) },
        React.createElement("div", { className: "wartsila-logo icon-wartsila-logo" }),
        React.createElement("div", { className: "summary-main" },
            React.createElement("div", { className: "enrichments-header" },
                React.createElement("a", { className: "enrichments-title", href: "#!wartsilaenrichments?id=" + m.Id }, "W\u00E4rtsil\u00E4 Enrichments")),
            m.HasSuccessfulQuery() &&
                // For the summary card, only show estimate details and map in case we have a
                // successful query. If the user's wondering why we don't have an estimate to display,
                // they can drill into the standalone wartsilaenrichments page to see error details etc.
                React.createElement("div", null,
                    React.createElement(estimateDetailsView_1.EstimateDetailsCondensedView, { model: m.EstimateDetails }),
                    React.createElement(mapview_1.MapView, { model: m.Map })),
            React.createElement(LoadingIndicator, { model: m })));
});
var LoadingIndicator = supercritical_1.default(function (_a) {
    var m = _a.model;
    return m.Loading() ? React.createElement("div", { className: "enrichments-loading-indicator" }) : null;
});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsView = void 0;
var React = __webpack_require__(2);
var supercritical_1 = __webpack_require__(4);
var eventWrappers_1 = __webpack_require__(8);
var view_1 = __webpack_require__(40);
var estimateDetailsView_1 = __webpack_require__(552);
var mapview_1 = __webpack_require__(553);
exports.WartsilaEnrichmentsView = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("div", { className: "wartsilaenrichments pc-page-fixedwidth" },
        React.createElement("div", { className: "pc-actions-links-header" },
            React.createElement("a", { className: "pc-back-link", href: "", onClick: eventWrappers_1.noDefault(function () { return window.history.back(); }) }, "<< Back")),
        React.createElement(Header, { model: m }),
        React.createElement("div", { className: "enrichments-body" },
            React.createElement(mapview_1.MapView, { model: m.Map }),
            React.createElement(estimateDetailsView_1.EstimateDetailsCardView, { model: m.EstimateDetails })),
        React.createElement(view_1.PageLoadingIndicator, { loading: m.Loading }));
});
var Header = supercritical_1.default(function (_a) {
    var m = _a.model;
    return React.createElement("h1", { className: "enrichments-header pc-page-title" },
        React.createElement("span", { className: "pc-text-label-color" }, "W\u00E4rtsil\u00E4 Enrichments"),
        React.createElement("span", { className: "pc-icon-bullet" }),
        React.createElement("span", { className: "vessel-name" }, m.PortCall.DisplayVesselIdentifier()));
});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1404), exports);


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1405), exports);


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1407), exports);


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1408), exports);


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1410), exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1411), exports);


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovedCharge = void 0;
var ApprovedCharge_1 = __webpack_require__(1412);
var Charge_1 = __webpack_require__(108);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var ApprovedCharge = /** @class */ (function (_super) {
    __extends(ApprovedCharge, _super);
    function ApprovedCharge(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.QBTracking = QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTrackingWithDefaults(_this.QBTrackingOverrides, function () { return _this.StandardItem() && _this.StandardItem().QBTracking; });
        _this.Total = Charge_1.TotalPriceForCharge(_this);
        return _this;
    }
    ApprovedCharge.prototype.NumberOfUnits = function () {
        return Charge_1.NumberOfUnits(this);
    };
    return ApprovedCharge;
}(ApprovedCharge_1.ApprovedCharge));
exports.ApprovedCharge = ApprovedCharge;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1413), exports);


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1414), exports);


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1415), exports);


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1417), exports);


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1421), exports);


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1425), exports);


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1427), exports);


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservationPITDataKey = exports.BerthReservationPITKey = void 0;
var BerthReservation_1 = __webpack_require__(79);
var PITUtils_1 = __webpack_require__(92);
exports.BerthReservationPITKey = PITUtils_1.makePITKey(BerthReservation_1.BerthReservation.key);
exports.BerthReservationPITDataKey = PITUtils_1.makePITDataKey(BerthReservation_1.BerthReservation.dataKey);


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1429), exports);


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservationVersion = void 0;
var BerthReservationVersion_1 = __webpack_require__(1430);
var BerthReservation_1 = __webpack_require__(38);
var ExtraDataUtils_1 = __webpack_require__(202);
var BerthReservationVersion = /** @class */ (function (_super) {
    __extends(BerthReservationVersion, _super);
    function BerthReservationVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BerthReservationVersion.prototype.ExtraData = function () {
        return ExtraDataUtils_1.parseIfNonNull(this.ExtraDataJSON());
    };
    BerthReservationVersion.prototype.Status = function () {
        // Status field is derived from other fields
        return this.CancelledDate() !== null ? BerthReservation_1.BerthReservationStatus.Cancelled :
            this.ConflictCount() > 0 ? BerthReservation_1.BerthReservationStatus.Conflicted :
                this.ApprovedDate() !== null ? BerthReservation_1.BerthReservationStatus.Booked :
                    BerthReservation_1.BerthReservationStatus.Requested;
    };
    return BerthReservationVersion;
}(BerthReservationVersion_1.BerthReservationVersion));
exports.BerthReservationVersion = BerthReservationVersion;


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1431), exports);


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1432), exports);


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCoverageType = void 0;
// BillCoverageType values, hand-synched w/ PortCall.Models\Billing\BillCoverage.cs.
var BillCoverageType;
(function (BillCoverageType) {
    BillCoverageType["JobOrder"] = "JO";
    BillCoverageType["DispatchEvent"] = "DE";
})(BillCoverageType = exports.BillCoverageType || (exports.BillCoverageType = {}));


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1433), exports);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillItem = void 0;
var BillItem_1 = __webpack_require__(1434);
var Charge_1 = __webpack_require__(108);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var BillItem = /** @class */ (function (_super) {
    __extends(BillItem, _super);
    function BillItem(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.QBTracking = QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTrackingWithDefaults(_this.QBTrackingOverrides, function () { return _this.StandardItem() && _this.StandardItem().QBTracking; });
        _this.Total = Charge_1.TotalPriceForCharge(_this);
        return _this;
    }
    BillItem.prototype.NumberOfUnits = function () {
        return Charge_1.NumberOfUnits(this);
    };
    return BillItem;
}(BillItem_1.BillItem));
exports.BillItem = BillItem;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1435), exports);


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1437), exports);


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1438), exports);


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1440), exports);


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1445), exports);


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardPITDataKey = exports.CoordinationCardPITKey = void 0;
var CoordinationCard_1 = __webpack_require__(109);
var PITUtils_1 = __webpack_require__(92);
exports.CoordinationCardPITKey = PITUtils_1.makePITKey(CoordinationCard_1.CoordinationCard.key);
exports.CoordinationCardPITDataKey = PITUtils_1.makePITDataKey(CoordinationCard_1.CoordinationCard.dataKey);


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1446), exports);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1447), exports);


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1448), exports);


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1449), exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardVersion = void 0;
var CoordinationCardVersion_1 = __webpack_require__(617);
var CoordinationCard_1 = __webpack_require__(109);
__exportStar(__webpack_require__(617), exports);
var CoordinationCardVersion = /** @class */ (function (_super) {
    __extends(CoordinationCardVersion, _super);
    function CoordinationCardVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoordinationCardVersion.prototype.EffectiveStatusLabel = function (bypassAltPendingLabel) {
        return CoordinationCard_1.CoordinationCard.EffectiveStatusLabelImpl(this, bypassAltPendingLabel);
    };
    return CoordinationCardVersion;
}(CoordinationCardVersion_1.CoordinationCardVersion));
exports.CoordinationCardVersion = CoordinationCardVersion;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1455), exports);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1456), exports);


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1458), exports);


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchDashboard = exports.DispatchDashboardCorePermissions = void 0;
var DispatchDashboard_1 = __webpack_require__(619);
var DispatchDashboard_2 = __webpack_require__(619);
Object.defineProperty(exports, "DispatchDashboardCorePermissions", { enumerable: true, get: function () { return DispatchDashboard_2.DispatchDashboardCorePermissions; } });
var DispatchDashboard = /** @class */ (function (_super) {
    __extends(DispatchDashboard, _super);
    function DispatchDashboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DispatchDashboard.prototype.CanAddPilotJobOrders = function () {
        return !!this.CorePermissions() && this.CorePermissions().CanAddPilotJobOrders();
    };
    DispatchDashboard.prototype.CanExportSchedule = function () {
        return !!this.CorePermissions() && this.CorePermissions().CanExportSchedule();
    };
    DispatchDashboard.prototype.CanManageBills = function () {
        return !!this.CorePermissions() && this.CorePermissions().CanManageBills();
    };
    DispatchDashboard.prototype.CanManageDispatchEvents = function () {
        return !!this.CorePermissions() && this.CorePermissions().CanManageDispatchEvents();
    };
    DispatchDashboard.prototype.CanReserveBerths = function () {
        return !!this.CorePermissions() && this.CorePermissions().CanReserveBerths();
    };
    return DispatchDashboard;
}(DispatchDashboard_1.DispatchDashboard));
exports.DispatchDashboard = DispatchDashboard;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1460), exports);


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1461), exports);


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1462), exports);


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSummary = void 0;
var DomainSummary_1 = __webpack_require__(1464);
var DomainSummary = /** @class */ (function (_super) {
    __extends(DomainSummary, _super);
    function DomainSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Does this domain not only have the Pilots module enabled but also have active Pilot Agencies using it.
     */
    DomainSummary.prototype.HasActivePilots = function () {
        return this.Settings() !== null && this.Settings().HasPilots() && this.PilotAgencyIds().length > 0;
    };
    return DomainSummary;
}(DomainSummary_1.DomainSummary));
exports.DomainSummary = DomainSummary;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftCharge = void 0;
var DraftCharge_1 = __webpack_require__(1465);
var Charge_1 = __webpack_require__(108);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
// TH 05/04/2017 -- NOTE: I originally defined DraftCharge in the same .cs file as DraftChargeCollection.
// That caused a problem w/ our client-side TS models.
// The issue is that I added custom methods to DraftCharge here.
// As a result, the DraftChargeCollection in server/models referenced the wrong version of DraftCharge.
// I.e., it referenced the version from server/models instead of from data/models.
// This caused typing errors downstream.
// That's currently a limitation in our _models.tst. And even if we changed _models.tst, we'd end
// up creating circular references between server/models and data/models that would require some thought.
// For now, my way of avoiding the issue was just to split the server-side classes into two separate files,
// thus generating separate files in server/models and data/models too.
var DraftCharge = /** @class */ (function (_super) {
    __extends(DraftCharge, _super);
    function DraftCharge(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.QBTracking = QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTrackingWithDefaults(_this.QBTrackingOverrides, function () { return _this.StandardItem() && _this.StandardItem().QBTracking; });
        _this.Total = Charge_1.TotalPriceForCharge(_this);
        return _this;
    }
    DraftCharge.prototype.NumberOfUnits = function () {
        return Charge_1.NumberOfUnits(this);
    };
    return DraftCharge;
}(DraftCharge_1.DraftCharge));
exports.DraftCharge = DraftCharge;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1466), exports);


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndMark = void 0;
var s_js_1 = __webpack_require__(0);
var Measurement_1 = __webpack_require__(11);
var EndMark = /** @class */ (function (_super) {
    __extends(EndMark, _super);
    function EndMark(reservation) {
        var _this = _super.call(this) || this;
        _this.Num = function (v) {
            if (v === undefined) {
                return reservation.Footmark.add(reservation.Length).Num();
            }
            else {
                var newFootmark = s_js_1.default.sample(function () {
                    return new Measurement_1.Measurement({ Num: v, UOM: reservation.Footmark.UOM() })
                        .subtract(reservation.Length)
                        .Num();
                });
                reservation.Footmark.Num(newFootmark);
                return v;
            }
        };
        _this.UOM = function () { return reservation.Footmark.UOM(); };
        return _this;
    }
    return EndMark;
}(Measurement_1.Measurement));
exports.EndMark = EndMark;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedEstimate = void 0;
var s_js_1 = __webpack_require__(0);
var EnhancedEstimate_1 = __webpack_require__(1467);
var GeoJSONPosition_1 = __webpack_require__(1267);
var EnhancedEstimate = /** @class */ (function (_super) {
    __extends(EnhancedEstimate, _super);
    function EnhancedEstimate(data) {
        if (data === void 0) { data = { Id: 0 }; }
        var _this = _super.call(this, data) || this;
        _this.EstimatedRoute((data.EstimatedRoute || []).map(GeoJSONPosition_1.GeoJSONPosition.fromGeoJSONData));
        return _this;
    }
    EnhancedEstimate.update = function (obj, data) {
        var _this = this;
        s_js_1.default.freeze(function () {
            _super.update.call(_this, obj, data);
            // EstimatedRoute is a strange field b/c it's really a data field stored as JSON
            // in the db, but for serialization we send it as a JSON array rather than a
            // JSON string containing more JSON. So our typewriter-generated model thinks of
            // it as a collection of child models and doesn't update it from its update method.
            // So override the inherited update method here.
            if (data.EstimatedRoute !== undefined) {
                obj.EstimatedRoute((data.EstimatedRoute || []).map(GeoJSONPosition_1.GeoJSONPosition.fromGeoJSONData));
            }
        });
    };
    return EnhancedEstimate;
}(EnhancedEstimate_1.EnhancedEstimate));
exports.EnhancedEstimate = EnhancedEstimate;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1468), exports);


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
var CoordinationCardStatuses_1 = __webpack_require__(110);
var Event_1 = __webpack_require__(1469);
var EventType_1 = __webpack_require__(111);
var Event = /** @class */ (function (_super) {
    __extends(Event, _super);
    function Event() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Event.prototype.ActorName = function () {
        var _a, _b, _c, _d;
        return (_d = (_b = (_a = this.User()) === null || _a === void 0 ? void 0 : _a.FullName()) !== null && _b !== void 0 ? _b : (_c = this.Automation()) === null || _c === void 0 ? void 0 : _c.Name()) !== null && _d !== void 0 ? _d : null;
    };
    Event.prototype.ActorAbbreviatedName = function () {
        var _a, _b, _c, _d;
        return (_d = (_b = (_a = this.User()) === null || _a === void 0 ? void 0 : _a.AbbreviatedName()) !== null && _b !== void 0 ? _b : (_c = this.Automation()) === null || _c === void 0 ? void 0 : _c.Name()) !== null && _d !== void 0 ? _d : null;
    };
    /**
     * Return the event that we think best explains why this C-Card status update happened.
     */
    Event.prototype.CCardStatusUpdateCause = function () {
        // Throw on incorrect EventType on the thinking that calling code should be able to check this easily.
        if (this.Type() !== EventType_1.EventType.CCardStatusUpdate) {
            throw new Error("CCardStatusUpdateCause requires event type " + EventType_1.EventType.CCardStatusUpdate + " but instead found type " + this.Type() + ".");
        }
        var lazyGuess = this;
        var ccv = this.CoordinationCardVersion();
        // Give up trying to improve our guess if we don't have enough data loaded.
        if (ccv === null)
            return lazyGuess;
        // A status update to any status besides Pending is sui generis. No reason to look any further.
        if (ccv.StatusId() !== CoordinationCardStatuses_1.CoordinationCardStatuses.Pending)
            return lazyGuess;
        // We expect provider changes to trigger status resets. If we find a provider change, call that the
        // reason.
        var betterGuess = ccv.EventsAbout().find(function (ev) { return ev.Type() === EventType_1.EventType.CCardProviderChanged; });
        if (betterGuess)
            return betterGuess;
        // TODO: Could try to dig further, like look up contemporaneous changes to the given PortCall's itinerary
        // and try to give a really granular answer. But in practice, our main use case for this method is to
        // distinguish status resets due to a specific known change to this C-Card entity (like provider change)
        // vs status resets due to any number of possible milestone updates. So giving up here is fine for now.
        return lazyGuess;
    };
    return Event;
}(Event_1.Event));
exports.Event = Event;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1470), exports);


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1471), exports);


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1472), exports);


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSONPosition = void 0;
var ZoneCoordinates_1 = __webpack_require__(115);
var GeoJSONPosition = /** @class */ (function (_super) {
    __extends(GeoJSONPosition, _super);
    function GeoJSONPosition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GeoJSONPosition.fromGeoJSONData = function (_a) {
        var lon = _a[0], lat = _a[1];
        return new GeoJSONPosition(lat, lon);
    };
    return GeoJSONPosition;
}(ZoneCoordinates_1.LatLong));
exports.GeoJSONPosition = GeoJSONPosition;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1473), exports);


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1476), exports);


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1477), exports);


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPointPITDataKey = exports.ItineraryPointPITKey = void 0;
var ItineraryPoint_1 = __webpack_require__(69);
var PITUtils_1 = __webpack_require__(92);
exports.ItineraryPointPITKey = PITUtils_1.makePITKey(ItineraryPoint_1.ItineraryPoint.key);
exports.ItineraryPointPITDataKey = PITUtils_1.makePITDataKey(ItineraryPoint_1.ItineraryPoint.dataKey);


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1480), exports);


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPointVersion = void 0;
var ItineraryPointVersion_1 = __webpack_require__(1481);
var ExtraDataUtils_1 = __webpack_require__(202);
var ItineraryPointVersion = /** @class */ (function (_super) {
    __extends(ItineraryPointVersion, _super);
    function ItineraryPointVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItineraryPointVersion.prototype.ExtraData = function () {
        return ExtraDataUtils_1.parseIfNonNull(this.ExtraDataJSON());
    };
    return ItineraryPointVersion;
}(ItineraryPointVersion_1.ItineraryPointVersion));
exports.ItineraryPointVersion = ItineraryPointVersion;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrderPITDataKey = exports.JobOrderPITKey = void 0;
var JobOrder_1 = __webpack_require__(576);
var PITUtils_1 = __webpack_require__(92);
exports.JobOrderPITKey = PITUtils_1.makePITKey(JobOrder_1.JobOrder.key);
exports.JobOrderPITDataKey = PITUtils_1.makePITDataKey(JobOrder_1.JobOrder.dataKey);


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1483), exports);


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrderVersion = void 0;
var JobOrderVersion_1 = __webpack_require__(1484);
var JobOrderVersion = /** @class */ (function (_super) {
    __extends(JobOrderVersion, _super);
    function JobOrderVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // aah: for now, since there are only PJO JOs, just type to only PJOV extra data
    JobOrderVersion.prototype.ExtraData = function () {
        var json = this.ExtraDataJSON();
        return json && JSON.parse(json);
    };
    return JobOrderVersion;
}(JobOrderVersion_1.JobOrderVersion));
exports.JobOrderVersion = JobOrderVersion;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1485), exports);


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1486), exports);


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1487), exports);


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1488), exports);


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1489), exports);


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1490), exports);


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1491), exports);


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1492), exports);


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1493), exports);


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1494), exports);


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1495), exports);


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1496), exports);


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1497), exports);


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1499), exports);


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1501), exports);


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1502), exports);


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1503), exports);


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1504), exports);


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1506), exports);


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1507), exports);


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1508), exports);


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCUser = void 0;
var PCUser_1 = __webpack_require__(1510);
var PhoneNumberKind_1 = __webpack_require__(208);
var PCUser = /** @class */ (function (_super) {
    __extends(PCUser, _super);
    function PCUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PCUser.prototype.FullName = function () {
        return this.FirstName() + ' ' + this.LastName();
    };
    PCUser.prototype.AbbreviatedName = function () {
        return (this.FirstName() ? this.FirstName()[0] + ". " : '') + this.LastName();
    };
    PCUser.prototype.EffectiveUITheme = function () {
        return this.UITheme() || this.DefaultUITheme();
    };
    PCUser.prototype.DefaultUITheme = function () {
        var org = this.Organization(), orgTheme = org && org.UITheme();
        if (orgTheme)
            return orgTheme;
        var domain = org && org.Domain(), dsettings = domain && domain.Settings(), defaultTheme = dsettings && dsettings.DefaultUITheme();
        return defaultTheme;
    };
    PCUser.prototype.MainPhoneNumber = function () {
        var numbers = this.PhoneNumbers(), mobiles = numbers.filter(function (pn) { return pn.Kind() === PhoneNumberKind_1.PhoneNumberKind.Mobile; });
        // Logic for "main" phone number taken from personprofilepopup
        return mobiles[0] || numbers[0] || null;
    };
    PCUser.prototype.OtherPhoneNumbers = function () {
        var main = this.MainPhoneNumber();
        return this.PhoneNumbers().filter(function (pn) { return pn !== main; });
    };
    return PCUser;
}(PCUser_1.PCUser));
exports.PCUser = PCUser;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1512), exports);


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1514), exports);


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1515), exports);


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1516), exports);


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1517), exports);


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1518), exports);


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1519), exports);


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1521), exports);


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PierGroup = void 0;
var PierGroup_1 = __webpack_require__(1523);
var Berth_1 = __webpack_require__(107);
var PierGroup = /** @class */ (function (_super) {
    __extends(PierGroup, _super);
    function PierGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PierGroup.prototype.Reservations = function () {
        var bs = this.Berths(), reses = [];
        for (var _i = 0, bs_1 = bs; _i < bs_1.length; _i++) {
            var b = bs_1[_i];
            reses = reses.concat(b.Reservations());
        }
        return reses;
    };
    PierGroup.prototype.UnlistedReservations = function () {
        var bs = this.Berths(), unlistedReservations = [];
        for (var _i = 0, bs_2 = bs; _i < bs_2.length; _i++) {
            var b = bs_2[_i];
            unlistedReservations = unlistedReservations.concat(b.UnlistedReservations());
        }
        return unlistedReservations;
    };
    PierGroup.prototype.BerthClosures = function () {
        var bs = this.Berths(), closures = [];
        for (var _i = 0, bs_3 = bs; _i < bs_3.length; _i++) {
            var b = bs_3[_i];
            closures = closures.concat(b.Closures());
        }
        return closures;
    };
    /**
     * Determine the berth from this piergroup that is most utilized by the given span of
     * pier.
     * @param footmark The starting footmark of the span of pier.
     * @param length The length of the span of pier.
     */
    // NOTE: We also implement this logic in C#. See PortCall.Models\Port\PierGroup.cs. Make sure to keep the
    // two implementations in sync.
    PierGroup.prototype.MostUtilizedBerth = function (footmark, length) {
        if (length.Num() < 0)
            throw new Error("Length must be nonnegative");
        // Do all computations in terms of this PierGroup's Length UOM
        var uom = this.Length.UOM(), spanStart = footmark.convert(uom).Num(), spanLength = length.convert(uom).Num(), spanEnd = spanStart + spanLength;
        // Traverse in StartMark order to give a deterministic winner in case of ties (first berth in StartMark order wins).
        // Also, filter out zero-length berths (degenerate case), as they would give a denominator of zero below.
        var berths = this.Berths().filter(function (b) { return b.Length.Num() > 0; });
        berths.sort(Berth_1.Berth.StartMarkOrder);
        var winner = null;
        // Actually, any negative value will do b/c the loop below always produces fractionOccupied >= 0.
        var maxFractionOccupied = -Infinity;
        for (var i = 0; i < berths.length; i++) {
            // The general idea is that we say the most utilized berth is the one that has the highest fraction of
            // berth length occupied.
            var berthStart = berths[i].StartMark.convert(uom).Num(), berthLength = berths[i].Length.convert(uom).Num(), berthEnd = berthStart + berthLength;
            // spanLength           -- smallest of the 4 when span is contained completely inside of berth
            // berthLength          -- smallest of the 4 when berth is contained completely inside of span
            // berthEnd - spanStart -- smallest of the 4 when span intersects end of berth but not start
            // spanEnd - berthStart -- smallest of the 4 when span intersects start of berth but not end
            // Taking max with 0    -- Min of 4 values above will be negative when span and berth don't intersect. Count that as 0.
            var lengthOccupied = Math.max(0, Math.min(spanLength, berthLength, berthEnd - spanStart, spanEnd - berthStart)), fractionOccupied = lengthOccupied / berthLength;
            if (fractionOccupied > maxFractionOccupied) {
                // Normal case. Found a berth w/ a larger fraction occupied. That's our current best berth.
                winner = berths[i];
                maxFractionOccupied = fractionOccupied;
            }
            else if (i === berths.length - 1 && berthEnd <= spanStart) {
                // Special case. If the provided footmark is beyond the end of the piergroup, then all berths will have a
                // fraction occupied of 0 and our normal first-berth-wins-in-case-of-ties logic will select the first berth
                // as the winner. But we wanna say the last berth is actually the winner in that case.
                winner = berths[i];
            }
            else if (spanLength === 0 && berthStart <= spanStart && spanStart < berthEnd) {
                // Degenerate case. If provided length is 0, then all berths will have a fraction occupied of 0. In that case,
                // say the winner is whichever berth contains the provided starting footmark (which will also be the ending
                // footmark since length is 0).
                winner = berths[i];
            }
        }
        // Another degenerate case. The only way winner can be null at this point is if berths is empty. If that's b/c we
        // filtered out zero-length berths above and no other berths were left, then just declare the first berth the winner.
        if (winner === null && this.Berths().length > 0)
            winner = this.Berths()[0];
        return winner;
    };
    return PierGroup;
}(PierGroup_1.PierGroup));
exports.PierGroup = PierGroup;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1524), exports);


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pilot = void 0;
var Pilot_1 = __webpack_require__(1525);
var Pilot = /** @class */ (function (_super) {
    __extends(Pilot, _super);
    function Pilot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pilot.prototype.EffectiveCode = function () {
        return this.Code() || (this.User() ? this.User().FirstName()[0] + this.User().LastName()[0] : '');
    };
    return Pilot;
}(Pilot_1.Pilot));
exports.Pilot = Pilot;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1526), exports);


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1529), exports);


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderChange = void 0;
var PilotJobOrderChange_1 = __webpack_require__(1530);
var PortCall_1 = __webpack_require__(161);
var PilotJobOrderChange = /** @class */ (function (_super) {
    __extends(PilotJobOrderChange, _super);
    function PilotJobOrderChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PilotJobOrderChange.prototype.DisplayVesselIdentifier = function () {
        var _this = this;
        return PortCall_1.VesselIdentifier(function () { return _this.Vessel(); }, function () { return _this.Agent(); }, this.Length);
    };
    return PilotJobOrderChange;
}(PilotJobOrderChange_1.PilotJobOrderChange));
exports.PilotJobOrderChange = PilotJobOrderChange;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1531), exports);


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1532), exports);


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderPITDataKey = exports.PilotJobOrderPITKey = void 0;
var PilotJobOrder_1 = __webpack_require__(160);
var PITUtils_1 = __webpack_require__(92);
exports.PilotJobOrderPITKey = PITUtils_1.makePITKey(PilotJobOrder_1.PilotJobOrder.key);
exports.PilotJobOrderPITDataKey = PITUtils_1.makePITDataKey(PilotJobOrder_1.PilotJobOrder.dataKey);


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1533), exports);


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderVersion = void 0;
var PilotJobOrderVersion_1 = __webpack_require__(1535);
var ExtraDataUtils_1 = __webpack_require__(202);
var PilotJobOrderVersion = /** @class */ (function (_super) {
    __extends(PilotJobOrderVersion, _super);
    function PilotJobOrderVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PilotJobOrderVersion.prototype.ExtraData = function () {
        return ExtraDataUtils_1.parseIfNonNull(this.ExtraDataJSON());
    };
    return PilotJobOrderVersion;
}(PilotJobOrderVersion_1.PilotJobOrderVersion));
exports.PilotJobOrderVersion = PilotJobOrderVersion;


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1536), exports);


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1538), exports);


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1539), exports);


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1540), exports);


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1541), exports);


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1542), exports);


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1545), exports);


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallPITDataKey = exports.PortCallPITKey = void 0;
var PortCall_1 = __webpack_require__(161);
var PITUtils_1 = __webpack_require__(92);
exports.PortCallPITKey = PITUtils_1.makePITKey(PortCall_1.PortCall.key);
exports.PortCallPITDataKey = PITUtils_1.makePITDataKey(PortCall_1.PortCall.dataKey);


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1546), exports);


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1547), exports);


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1548), exports);


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1549), exports);


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallVersion = void 0;
var PortCallVersion_1 = __webpack_require__(1550);
var ExtraDataUtils_1 = __webpack_require__(202);
var PortCallVersion = /** @class */ (function (_super) {
    __extends(PortCallVersion, _super);
    function PortCallVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PortCallVersion.prototype.ExtraData = function () {
        return ExtraDataUtils_1.parseIfNonNull(this.ExtraDataJSON());
    };
    return PortCallVersion;
}(PortCallVersion_1.PortCallVersion));
exports.PortCallVersion = PortCallVersion;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1553), exports);


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1554), exports);


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1555), exports);


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1558), exports);


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1560), exports);


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1561), exports);


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchPITDataKey = exports.RecurringBatchPITKey = void 0;
var RecurringBatch_1 = __webpack_require__(288);
var PITUtils_1 = __webpack_require__(92);
exports.RecurringBatchPITKey = PITUtils_1.makePITKey(RecurringBatch_1.RecurringBatch.key);
exports.RecurringBatchPITDataKey = PITUtils_1.makePITDataKey(RecurringBatch_1.RecurringBatch.dataKey);


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1562), exports);


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1563), exports);


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1564), exports);


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1565), exports);


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1566), exports);


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1567), exports);


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1568), exports);


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1569), exports);


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1570), exports);


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDatePITDataKey = exports.ScheduleDatePITKey = void 0;
var ScheduleDateEntity_1 = __webpack_require__(289);
var PITUtils_1 = __webpack_require__(92);
exports.ScheduleDatePITKey = PITUtils_1.makePITKey(ScheduleDateEntity_1.ScheduleDateEntity.key);
exports.ScheduleDatePITDataKey = PITUtils_1.makePITDataKey(ScheduleDateEntity_1.ScheduleDateEntity.dataKey);


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1574), exports);


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1575), exports);


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1576), exports);


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1577), exports);


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1578), exports);


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1580), exports);


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1581), exports);


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1582), exports);


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1583), exports);


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardAvailableAttachment = void 0;
var fileurls_1 = __webpack_require__(261);
var TopicCardAvailableAttachment_1 = __webpack_require__(1586);
var TopicCardAvailableAttachment = /** @class */ (function (_super) {
    __extends(TopicCardAvailableAttachment, _super);
    function TopicCardAvailableAttachment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicCardAvailableAttachment.prototype.FileName = function () {
        return fileurls_1.fileNameFromUrl(this.AttachmentUrl());
    };
    return TopicCardAvailableAttachment;
}(TopicCardAvailableAttachment_1.TopicCardAvailableAttachment));
exports.TopicCardAvailableAttachment = TopicCardAvailableAttachment;


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1587), exports);


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1588), exports);


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplate = void 0;
var TopicCardTemplate_1 = __webpack_require__(1590);
var TopicCardTemplate = /** @class */ (function (_super) {
    __extends(TopicCardTemplate, _super);
    function TopicCardTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicCardTemplate.prototype.EffectiveTitle = function () {
        return this.AmenityTypeId() === null ? this.Title()
            : "Amenity | " + (this.AmenityType() ? this.AmenityType().Name() : '');
    };
    TopicCardTemplate.prototype.EffectiveRemarks = function () {
        return this.AmenityTypeId() === null ? this.Remarks()
            : this.AmenityType() && this.AmenityType().Description();
    };
    TopicCardTemplate.prototype.TitleForAnswer = function (berth) {
        return this.AmenityTypeId() === null ?
            this.Title() :
            berth() ?
                (berth().Location() ? berth().Location().Name() : '') + " | " + (this.AmenityType() ? this.AmenityType().Name() : '')
                : '';
    };
    TopicCardTemplate.prototype.ToAnswerData = function (berth) {
        return {
            Id: 0,
            TemplateId: this.Id(),
            AmenityTypeId: this.AmenityTypeId(),
            BerthId: berth() ? berth().Id() : null,
            Title: this.TitleForAnswer(berth),
            Question: this.Question(),
            QuestionType: this.QuestionType(),
            TimeEntry: {
                HasTimeEntry: this.TimeEntry.HasTimeEntry(),
                Label: this.TimeEntry.Label()
            },
            Remarks: this.Remarks()
        };
    };
    return TopicCardTemplate;
}(TopicCardTemplate_1.TopicCardTemplate));
exports.TopicCardTemplate = TopicCardTemplate;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplateAttachment = void 0;
var fileurls_1 = __webpack_require__(261);
var TopicCardTemplateAttachment_1 = __webpack_require__(1591);
var TopicCardTemplateAttachment = /** @class */ (function (_super) {
    __extends(TopicCardTemplateAttachment, _super);
    function TopicCardTemplateAttachment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicCardTemplateAttachment.prototype.FileName = function () {
        return fileurls_1.fileNameFromUrl(this.AttachmentUrl());
    };
    return TopicCardTemplateAttachment;
}(TopicCardTemplateAttachment_1.TopicCardTemplateAttachment));
exports.TopicCardTemplateAttachment = TopicCardTemplateAttachment;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1593), exports);


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTimeEntry = void 0;
var TopicCardTimeEntry_1 = __webpack_require__(1595);
var TopicCardTimeEntry = /** @class */ (function (_super) {
    __extends(TopicCardTimeEntry, _super);
    function TopicCardTimeEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopicCardTimeEntry.prototype.EffectiveLabel = function () {
        return this.Label() || 'Time';
    };
    return TopicCardTimeEntry;
}(TopicCardTimeEntry_1.TopicCardTimeEntry));
exports.TopicCardTimeEntry = TopicCardTimeEntry;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1596), exports);


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1598), exports);


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1599), exports);


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlistedBerthReservation = void 0;
var UnlistedBerthReservation_1 = __webpack_require__(1600);
var PierMark_1 = __webpack_require__(159);
var UnlistedBerthReservation = /** @class */ (function (_super) {
    __extends(UnlistedBerthReservation, _super);
    function UnlistedBerthReservation(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data || { Id: 0 }) || this;
        _this.PierMark = new PierMark_1.PierMark(_this.Footmark, _this.Berth);
        return _this;
    }
    return UnlistedBerthReservation;
}(UnlistedBerthReservation_1.UnlistedBerthReservation));
exports.UnlistedBerthReservation = UnlistedBerthReservation;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1601), exports);


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1602), exports);


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1605), exports);


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1606), exports);


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselChangeType = void 0;
// VesselChangeType values, hand-sync'ed with PortCall.Models\Vessels\VesselChange.cs
var VesselChangeType;
(function (VesselChangeType) {
    VesselChangeType["BowThrusterPresent"] = "BT";
    VesselChangeType["BowThrusterSize"] = "BS";
})(VesselChangeType = exports.VesselChangeType || (exports.VesselChangeType = {}));


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1607), exports);


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1608), exports);


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1610), exports);


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1611), exports);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1612), exports);


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1613), exports);


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// CD.Ajax - a utility wrapper for jQuery's $.ajax 
//
// Cd.Ajax().Url(fooUrl).Get().done(function (data) { ... });
Object.defineProperty(exports, "__esModule", { value: true });
var s_js_1 = __webpack_require__(0);
var jsonizeSignals_1 = __webpack_require__(600);
var sumSignal_1 = __webpack_require__(602);
var $ = __webpack_require__(27);
var Promise = __webpack_require__(41);
;
exports.default = Ajax;
function Ajax(dataCache) {
    var ajax = {
        LastRequest: sumSignal_1.sumSignal(Promise.resolve(null)),
        LastResponse: s_js_1.default.data(null),
        Url: Url
    };
    return ajax;
    function Url(address, mappingOptions) {
        if (mappingOptions === void 0) { mappingOptions = {}; }
        var url = {
            Get: Method("GET"),
            Post: Method('POST'),
            Put: Method("PUT"),
            Delete: Method('DELETE'),
            LastRequest: sumSignal_1.sumSignal(Promise.resolve(null)),
            LastResponse: s_js_1.default.data(null)
        };
        return url;
        function Method(type) {
            return function (obj) {
                var response = s_js_1.default.data(null), request = new Promise(function (resolve, reject) {
                    // NOTE: FormData is undefined on IE9 or below
                    // NOTE: in modern browsers we could use .__proto__ property instead
                    // But .__proto__ is undefined in IE10
                    var isFormData = FormData.prototype.isPrototypeOf(obj), data = type === "GET" || obj === undefined ? undefined :
                        isFormData ? obj :
                            mappingOptions.include ? jsonizeSignals_1.jsonizeSignals(obj, mappingOptions.include) :
                                JSON.stringify(obj), useCache = mappingOptions.useCache && type !== "GET", ajaxOptions = {
                        type: type,
                        url: unwrap(address),
                        data: data,
                        contentType: isFormData ? false : 'application/json; charset=utf-8',
                        // xhrFields.withCredentials tells the browser to send along cookies,
                        // even if this is a CORS request
                        xhrFields: {
                            withCredentials: true
                        },
                        processData: false
                    }, usedCache = false;
                    if (useCache) {
                        ajaxOptions.accepts = { datacache: "application/x-pcc-data-cache" };
                        ajaxOptions.converters = { "json datacache": function (data) {
                                // TH 02/06/2017 -- Update: making the dataCache a parameter to Ajax instead of part of
                                // the mappingOptions to IAjax.Url.
                                // My main goal is to catch typos on the useCache option.
                                // NOTE: Currently, this version will allow you to specify useCache: true even if your response
                                // type on the ajax.Url call doesn't match the dataCache's update method.
                                // Fixing that would probably require adding a type param to the IAjax interface, which feels
                                // like overkill currently.
                                usedCache = true;
                                return dataCache.update(request.Date, data);
                            } };
                        ajaxOptions.dataType = 'datacache';
                    }
                    // The next line enables sending CORS requests on IE9
                    $.support.cors = true;
                    $.ajax(ajaxOptions)
                        .done(function (data, textStatus, xhr) {
                        var _response = {
                            Success: true,
                            Status: xhr.status,
                            Data: data,
                            Request: request,
                            Xhr: xhr,
                            Date: getDateHeader(xhr),
                            UsedCache: usedCache
                        };
                        s_js_1.default.freeze(function () {
                            resolve(data);
                            response(_response);
                            url.LastResponse(_response);
                            ajax.LastResponse(_response);
                        });
                    }).fail(function (xhr) {
                        var data = xhr.responseText;
                        // see if we can parse the response as JSON data
                        try {
                            data = JSON.parse(data);
                        }
                        catch (ex) {
                        }
                        var _response = {
                            Success: false,
                            Status: xhr.status,
                            Data: data,
                            Request: request,
                            Xhr: xhr,
                            Date: getDateHeader(xhr),
                            UsedCache: usedCache
                        };
                        s_js_1.default.freeze(function () {
                            reject(data);
                            response(_response);
                            url.LastResponse(_response);
                            ajax.LastResponse(_response);
                        });
                    });
                });
                request.Type = type;
                request.Url = unwrap(address);
                request.Response = response;
                request.Date = new Date();
                s_js_1.default.freeze(function () {
                    url.LastRequest(function (_) { return request; });
                    ajax.LastRequest(function (_) { return request; });
                });
                return request;
            };
        }
    }
}
function unwrap(o) {
    return o instanceof Function ? s_js_1.default.sample(o) : o;
}
function getDateHeader(xhr) {
    var date = xhr.getResponseHeader("Date");
    return date ? new Date(date) : null;
}


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedModelLoader = exports.ModelDataClient = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
function ModelDataClient(ajax, url) {
    return function (data) {
        var req = ajax.Url(url(data)).Get();
        return req.then(function (data) { return ({ data: data, timestamp: req.Date }); });
    };
}
exports.ModelDataClient = ModelDataClient;
function CachedModelLoader(cache, client) {
    var active = {}, tasks = {};
    return loader;
    function loader(data, refreshSeconds) {
        if (refreshSeconds === void 0) { refreshSeconds = 0; }
        var key = cache.dataKey(data), model = cache.update1(null, data), ts = cache.timestamp(key), loading, task;
        if (refreshSeconds === 0 || ts === undefined || (Date.now() - ts.getTime()) > refreshSeconds * 1000) {
            if (active[key]) {
                loading = active[key];
                task = tasks[key];
            }
            else {
                loading = active[key] = s_js_1.default.data(true);
                task = tasks[key] = client(data)
                    .then(function (resp) { return cache.update1(resp.timestamp, resp.data); })
                    .finally(function () {
                    active[key] = undefined;
                    tasks[key] = undefined;
                    loading(false);
                });
            }
        }
        else {
            loading = s_js_1.default.data(false);
            task = Promise.resolve(model);
        }
        return { model: model, loading: loading, task: task };
    }
}
exports.CachedModelLoader = CachedModelLoader;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableComparer = void 0;
// Imitates the C# Systems.Collection.Generic.NullableComparer<T> class.
// For doing client-side equivalents of server-side OrderBy(...) or ThenBy(...) calls using nullable types.
// See http://labs.developerfusion.co.uk/SourceViewer/browse.aspx?assembly=SSCLI&namespace=System.Collections.Generic&type=NullableComparer
// See https://msdn.microsoft.com/en-us/library/azhsac5f(v=vs.110).aspx
var NullableComparer = function (x, y) {
    if (x !== null) {
        if (y !== null) {
            return x < y ? -1 : x > y ? 1 : 0;
        }
        return 1;
    }
    if (y !== null) {
        return -1;
    }
    return 0;
};
exports.NullableComparer = NullableComparer;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronousNonuniqueIndex = exports.SynchronousUniqueIndex = exports.SynchronousIndex = void 0;
var s_js_1 = __webpack_require__(0);
var SynchronousSet_1 = __webpack_require__(597);
var SynchronousIndex = function (key, empty, add, del, read, init) {
    var table = ({}), disposers = new Map(), index = ref;
    index.add = _add;
    index.delete = _delete;
    if (init)
        for (var _i = 0, _a = Array.from(s_js_1.default.sample(init)); _i < _a.length; _i++) {
            var i = _a[_i];
            _add(i);
        }
    s_js_1.default.cleanup(function () { return disposers.forEach(function (disposer) { return disposer(); }); });
    return index;
    function slot(id) {
        var s = table[id];
        return s ? s : table[id] = { changed: s_js_1.default.data(true), value: empty(id) };
    }
    function ref(id) {
        return function index() {
            var s = slot(id instanceof Function ? id() : id);
            s.changed();
            return read(s.value);
        };
    }
    function _add(item) {
        if (!disposers.has(item)) {
            s_js_1.default.root(function (dispose) {
                disposers.set(item, dispose);
                s_js_1.default(function (oldId) {
                    var id = key(item);
                    if (id !== oldId) {
                        // Treat null as a special key value meaning "don't slot me."
                        if (oldId !== null)
                            updateSlot(oldId, item, del);
                        if (id !== null)
                            updateSlot(id, item, add);
                    }
                    return id;
                }, null);
            });
        }
    }
    function _delete(item) {
        var disposer = disposers.get(item);
        if (disposer) {
            disposers.delete(item);
            disposer();
            var id = key(item);
            if (id !== null)
                updateSlot(id, item, del);
        }
    }
    function updateSlot(id, item, fn) {
        var s = slot(id);
        if (fn(s.value, item))
            s.changed(true);
    }
};
exports.SynchronousIndex = SynchronousIndex;
var SynchronousUniqueIndex = function (key, init) {
    var changed = s_js_1.default.data(true), changes = [];
    var changeCount = 0;
    s_js_1.default.root(function () { return s_js_1.default.on(changed, function () {
        var errors = "";
        for (var i = 0; i < changeCount; i++) {
            var s = changes[i];
            if (s.count > 1) {
                errors += "key: " + s.id + ", value: " + s.value + ". ";
                s.count = 1;
            }
        }
        changeCount = 0;
        if (errors)
            throw new Error("SynchronousUniqueIndex collision(s): " + errors);
    }); });
    return exports.SynchronousIndex(key, function (id) { return ({ id: id, value: null, count: 0 }); }, function (s, i) { return (s.value !== i && (changed(true), changes[changeCount++] = s, s.value = i, s.count++, true)); }, function (s, i) { return (s.value !== null && (changed(true), changes[changeCount++] = s, s.value = null, s.count--, true)); }, function (s) { return s.value; }, init);
};
exports.SynchronousUniqueIndex = SynchronousUniqueIndex;
var SynchronousNonuniqueIndex = function (key, init) {
    return exports.SynchronousIndex(key, function (id) { return SynchronousSet_1.SynchronousSet(); }, function (s, i) { return s_js_1.default.sample(s).has(i) ? false : (s.add(i), true); }, function (s, i) { return s.delete(i); }, function (s) { return s(); }, init);
};
exports.SynchronousNonuniqueIndex = SynchronousNonuniqueIndex;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = void 0;
var s_js_1 = __webpack_require__(0);
var Router = /** @class */ (function () {
    function Router(routes, location, defaultLocation) {
        var _this = this;
        this.routes = routes;
        this.running = s_js_1.default.data(false);
        var currentState = defaultLocation;
        var request = s_js_1.default.data(currentState), locationWatcher = s_js_1.default(function () {
            var loc = location();
            if (loc && !currentState.eq(loc))
                request(currentState = loc);
        }), route = s_js_1.default(function () {
            if (!_this.running())
                return null;
            var req = request(), route = _this.routes[req.name];
            if (!route)
                throw new Error("no route defined with name " + req.name);
            return route(req);
        }), stateReflector = s_js_1.default(function () {
            var r = route(), state = r && r.reflectState && r.reflectState();
            if (state)
                location(currentState = state, true);
        });
        this.route = route;
    }
    return Router;
}());
exports.Router = Router;


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.debouncePromise = void 0;
var s_js_1 = __webpack_require__(0);
var Promise = __webpack_require__(41);
/**
 * Debounce the given function, returning a Promise which resolves with the value returned
 * by the function when it finally runs.
 * Multiple calls before the function runs return the same Promise.
 * The current Promise (whether resolved or pending) is available in the .current() signal.
 * Immediate execution can be forced by calling .flush().
 *
 * __ Example timeline, with `wait` of 5 dots __
 *
 * calls    :      c c c c               c c           c
 * waiting  :       . . . .....           . .....       ..
 * fn execs :                  x                 x        x
 * current(): |---||-----------=========||-------=====||--=======
 * flush()  :                      f                      f
 *
 * Notes:
 * - lifespans of Promises demonstrated by spans |---| in `current()`
 * - in those spans, '=' means Promise is resolved, b/c `fn` has run
 * - 1st `flush()` is a no-op since Promise is already resolved
 * - 2nd `flush()` forces early run of `fn`
 *
 * Be aware that if your `fn` returns a Promise and you do `debounced.current().then(() => ...)`,
 * your code will actually wait not just until `fn` runs but until the Promise it returns resolves,
 * due to the fact that resolving a Promise with a another Promise waits on the second Promise too.
 *
 * @param fn the function to debounce
 * @param wait how much quiet to wait for before running `fn`
 * @param init the value of the initial promise, before `fn` has been run
 */
function debouncePromise(fn, wait, init) {
    var timeoutId = 0, // current setTimeout() id, or 0 if none active
    lastArgs = null, // last args passsed in, cached to use when we call `fn`
    promise = Promise.resolve(init), // current promise, plus its resolve/reject fns
    resolve = null, reject = null;
    var current = s_js_1.default.data(promise), startNewPromise = function () { return current(promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    })); }, debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeoutId !== 0) {
            clearTimeout(timeoutId);
        }
        else {
            startNewPromise();
        }
        lastArgs = args;
        timeoutId = setTimeout(exec, wait);
        return promise;
    }, exec = function () {
        var _resolve = resolve, _reject = reject;
        timeoutId = 0;
        try {
            _resolve(fn.apply(void 0, lastArgs));
        }
        catch (ex) {
            _reject(ex);
        }
    }, flush = function () {
        var _promise = promise;
        if (timeoutId !== 0) {
            clearTimeout(timeoutId);
            exec();
        }
        return _promise;
    };
    debounced.current = function () { return current(); };
    debounced.flush = flush;
    return debounced;
}
exports.debouncePromise = debouncePromise;
;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftArray = exports.MergeByKey = exports.MergeByObjectIdentity = void 0;
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
/**
 * A function that can be supplied as the `merge` parameter to `DraftArray`. This can be a good choice of
 * `merge` function for making a draft version of a collection of **one-to-many** child entities. With this
 * `merge` value, after an update to the original array, the `DraftArray` will contain...
 * - All items from the original array that have not been removed in the draft version. This includes any new
 *   items that have yet to appear in the draft version. These items are sorted as they appear in the original
 *   array.
 * - Next, all items from the draft array that do not appear in the original array. The "do not appear" test
 *   is based on **object identity.** These items are sorted as they appear in the draft array.
 */
function MergeByObjectIdentity(fromOriginal, fromDraft) {
    var inOriginal = new Set(fromOriginal);
    return fromOriginal.concat(fromDraft.filter(function (item) { return !inOriginal.has(item); }));
}
exports.MergeByObjectIdentity = MergeByObjectIdentity;
/**
 * Produces a function that can be supplied as the `merge` parameter to `DraftArray`. This can be a good choice
 * of `merge` function for making a draft version of a collection of **many-to-many** child entities. With this
 * `merge` value, after an update to the original array, the `DraftArray` will contain...
 * - All items from the original array that have not been removed in the draft version. This includes any new
 *   items that have yet to appear in the draft version. These items are sorted as they appear in the original
 *   array.
 * - Next, all items from the draft array that do not appear in the original array. The "do not appear" test
 *   is based on the provided `keyFn`. These items are sorted as they appear in the draft array.
 * @param keyFn A key function to use for the "do not appear" test (see above). E.g., if making a draft version
 * of a collection of many-to-many child entities, the key function would reference the child entities' FK
 * property pointing to the **other** side of the many-to-many relationship.
 */
function MergeByKey(keyFn) {
    return function (fromOriginal, fromDraft) {
        var inOriginal = new Set(fromOriginal.map(function (item) { return keyFn(item); }));
        return fromOriginal.concat(fromDraft.filter(function (item) { return !inOriginal.has(keyFn(item)); }));
    };
}
exports.MergeByKey = MergeByKey;
/**
 * A utility for maintaining a draft version of an array-valued signal. Similar to the functionality provided
 * by our `DraftSignal` utility, with some key differences:
 * - The signal produced by this utility satisfies the full `SArray.ArrayDataSignal` interface.
 * - When a `DraftSignal` is in caching mode, it ignores **all** changes to the original signal. In contrast,
 *   even when this `DraftArray` signal is in caching mode, it can still accept updates from the original array
 *   signal, subject to a few limitations:
 *   - This draft array signal maintains a cache of items from the original array signal that have been removed
 *     from the draft version of the array. Those removed items will continue to be absent from the draft array
 *     while it remains in caching mode. This cache of removed items is keyed by **object identity.**
 *   - The exact behavior by which a `DraftArray` in caching mode accepts updates from the original signal is
 *     controlled by the `merge` parameter to `DraftArray`.
 */
function DraftArray(original, merge) {
    var isCaching = s_js_1.default.value(false), 
    // CAUTION: Have to .slice() here and in several places below to avoid our draft array signal
    // inadvertently referencing the same internal JS array as our original array signal. That's b/c
    // SArrays handle mutations by mutating their internal JS array, so if our original and draft signals
    // referenced the same internal JS array, we'd get all kinds of weirdness about mutations to one signal
    // becoming immediately visible when reading the OTHER signal.
    draft = s_array_1.default(s_js_1.default.sample(original).slice());
    // Items from the original array that have been removed in the draft version
    var removed = new WeakSet();
    // Various flags...
    // - For tracking checkpoints...
    var version = 0, committedVersion = 0;
    // - For ignoring changes to our original array if we know those changes to originate from us...
    var origCompVersion = 0, ignoredOrigCompVersion = 0;
    // - For ignoring changes to our draft array if we know those changes to originate from us...
    var draftCompVersion = 0, ignoredDraftCompversion = 0;
    // Update the draft array as the original array changes
    s_js_1.default.on(original, function () {
        if (origCompVersion++ !== ignoredOrigCompVersion) {
            draft(isCaching() ?
                merge(original().filter(function (item) { return !removed.has(item); }), draft()) :
                // CAUTION: Here's another one of those .slice() spots. See above.
                original().slice());
            // Ignore this write to our draft array
            ignoredDraftCompversion = draftCompVersion;
        }
    });
    s_js_1.default.on(draft, function (prevDraft) {
        var _draft = draft();
        if (draftCompVersion++ !== ignoredDraftCompversion && !arrayEq(_draft, prevDraft)) {
            s_js_1.default.freeze(function () {
                version++;
                isCaching(true);
                var inLatest = new Set(_draft);
                // Item can't be removed if it's shown (back) up in draft array.
                for (var _i = 0, _draft_1 = _draft; _i < _draft_1.length; _i++) {
                    var item = _draft_1[_i];
                    removed.delete(item);
                }
                // If item was previously in the draft array and now isn't, mark it as removed.
                for (var _a = 0, prevDraft_1 = prevDraft; _a < prevDraft_1.length; _a++) {
                    var item = prevDraft_1[_a];
                    if (!inLatest.has(item))
                        removed.add(item);
                }
            });
        }
        // CAUTION: Here's another one of those .slice() spots. In this case, if we didn't .slice(), then the
        // next time S ran our computation function, prevDraft would evaluate to the SAME internal JS array
        // referenced by our draft array signal, so it would ALREADY contain the mutations visible in our
        // draft array signal. That would defeat the whole purpose of taking prevDraft as a parameter here.
        return _draft.slice();
    }, s_js_1.default.sample(draft).slice()); // Gotta .slice() in our seed value too!
    return {
        signal: draft,
        methods: {
            isCaching: function () { return isCaching(); },
            onWrite: function () { draft(); },
            checkpoint: checkpoint
        }
    };
    function checkpoint() {
        var 
        // CAUTION: Here's yet another .slice() spot. In this case, if we didn't .slice(), then
        // a) We might try to set our original array signal to the same internal JS array as our draft
        //    array signal when we commit this checkpoint, which would give rise to the same problem of
        //    sharing an internal JS array mentioned above.
        // b) If calling code were to mutate our draft array signal after this checkpoint is taken but
        //    before it's committed, then those mutations would be visible in the array we pass into our
        //    original array signal, which would bypass our version checking. This is why we need to
        //    .slice() here and NOT inside our commit method below.
        checkpointValue = s_js_1.default.sample(draft).slice(), checkpointVersion = version;
        return { commit: commit, revert: revert };
        function commit() {
            s_js_1.default.freeze(function () {
                if (committedVersion < checkpointVersion) {
                    committedVersion = checkpointVersion;
                    original(checkpointValue);
                    // Ignore this write to our original array
                    ignoredOrigCompVersion = origCompVersion;
                }
                if (checkpointVersion === version) {
                    removed = new WeakSet();
                    isCaching(false);
                }
            });
        }
        function revert() {
            if (checkpointVersion === version && s_js_1.default.sample(isCaching)) {
                s_js_1.default.freeze(function () {
                    removed = new WeakSet();
                    isCaching(false);
                    // CAUTION: Here's yet another .slice() spot.
                    draft(s_js_1.default.sample(original).slice());
                    // Ignore this write to our draft array
                    ignoredDraftCompversion = draftCompVersion;
                });
            }
        }
    }
}
exports.DraftArray = DraftArray;
function arrayEq(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    for (var i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i])
            return false;
    }
    return true;
}


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFileSize = void 0;
/**
 * Format a numeric file size in bytes into a displayable string.
 *
 * size -- {Number} The size in bytes
 *
 * places -- {Number} The number of places to show to the right of the decimal.
 *           Must be >= 0.
 *
 *           default: 2
 */
function formatFileSize(size, places) {
    if (places === undefined)
        places = 2;
    if (size < 1024)
        return size.toFixed(places) + 'B';
    size = size / 1024;
    if (size < 1024)
        return size.toFixed(places) + 'KB';
    size = size / 1024;
    if (size < 1024)
        return size.toFixed(places) + 'MB';
    size = size / 1024;
    if (size < 1024)
        return size.toFixed(places) + 'GB';
    size = size / 1024;
    if (size < 1024)
        return size.toFixed(places) + 'TB';
    throw new Error('Only sizes up to 1024TB supported');
}
exports.formatFileSize = formatFileSize;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.formatInterval = void 0;
function formatInterval(start, end) {
    var msecs = +end - +start, mins = Math.floor(Math.abs(msecs) / 60 / 1000), hrs = Math.floor(mins / 60), minsRemainder = mins % 60;
    var signText = msecs < 0 ? 'neg. ' : '', hrsText = hrs ? hrs + ' hr ' : '', minsText = minsRemainder || !hrs ? minsRemainder + ' min' : '';
    return (signText + hrsText + minsText).trim();
}
exports.formatInterval = formatInterval;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HashComponentLocationParser = void 0;
var componentLocation_1 = __webpack_require__(34);
var hashRx = /^#?!?([^?]*)(?:\?([^?]*))?$/, queryItemRx = /^([^=]+)=([^=]*)$/;
var HashComponentLocationParser = /** @class */ (function () {
    function HashComponentLocationParser() {
    }
    HashComponentLocationParser.prototype.parse = function (str) {
        var m = hashRx.exec(str);
        if (!m)
            return null;
        var name = m[1], queryStr = m[2], params = {};
        if (queryStr) {
            queryStr.split('&').map(function (segment) { return queryItemRx.exec(segment); })
                .filter(function (queryItem) { return queryItem; })
                .map(function (queryItem) { return queryItem.map(decodeURIComponent); })
                .forEach(function (_a) {
                var key = _a[1], val = _a[2];
                params[key] = val;
            });
        }
        return new componentLocation_1.Location(decodeURIComponent(name), params);
    };
    HashComponentLocationParser.prototype.serialize = function (req) {
        return '!' + encodeURIComponent(req.name)
            + Object.keys(req.params).map(function (k, i) { return (i ? '&' : '?') + encodeURIComponent(k) + '=' + encodeURIComponent(req.params[k]); }).join('');
    };
    return HashComponentLocationParser;
}());
exports.HashComponentLocationParser = HashComponentLocationParser;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HashSignal = void 0;
var s_js_1 = __webpack_require__(0);
// Represent the browser's hash field as a signal
// changes when the hash changes, changes the hash when it is changed
var HashSignal = function () {
    var _hash = s_js_1.default.data(window.location.hash), onHashChange = function (e) {
        return _hash(window.location.hash);
    }, registration = s_js_1.default(function () {
        // wrap event registration in a computation, so that it can be disposed
        window.addEventListener("hashchange", onHashChange);
        s_js_1.default.cleanup(function () { return window.removeEventListener("hashchange", onHashChange); });
    }), hash = function (str, inplace) {
        registration(); // allows S.dispose(hash) to dispose the registration
        if (arguments.length === 0)
            return _hash();
        else {
            var hash_1 = '#' + str;
            if (inplace)
                window.location.replace(hash_1);
            else
                window.location.assign(hash_1);
            return str;
        }
    };
    return hash;
};
exports.HashSignal = HashSignal;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(27);
var oldjquery = window.jQuery;
window.jQuery = $;
__webpack_require__(627);
window.jQuery = oldjquery;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(27);
var oldjquery = window.jQuery;
window.jQuery = $;
__webpack_require__(626);
window.jQuery = oldjquery;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
// small utility to handle loading data from the server into an observable,
// with observables to indicate current status.
// returns Promises from actions to allow chaining
var s_js_1 = __webpack_require__(0);
function Loader(ajax, url, target) {
    var client = ajax.Url(url), loading = s_js_1.default.data(false), error = s_js_1.default.data(false), loaded = s_js_1.default.data(false), request = null;
    return {
        Loading: loading,
        Loaded: loaded,
        Error: error,
        Load: load,
        Reload: reload
    };
    function load() {
        if (!request)
            reload();
        return request;
    }
    function reload() {
        loading(true);
        return request = client.Get()
            .then(function (data) {
            s_js_1.default.freeze(function () {
                target(data);
                loaded(true);
            });
        })
            .error(error)
            .finally(function () { loading(false); });
    }
    ;
}
exports.Loader = Loader;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_DURATIONS_ABBR_LOCALE = void 0;
var moment = __webpack_require__(6);
exports.EN_DURATIONS_ABBR_LOCALE = 'en-durations-abbr';
// Optional: define other locale names here...
// Remember the original locale
var oldLocale = moment.locale();
// Momentjs locale for abbreviated durations (e.g. '2d' instead of '2 days'). Used on portcallprofile.js.
// Example usage: moment(lastline).locale('en-durations-abbr').from(tzutils.now())
moment.locale(exports.EN_DURATIONS_ABBR_LOCALE, {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: 'a few seconds',
        m: '1min',
        mm: '%dmin',
        h: '1hr',
        hh: '%dhr',
        d: '1d',
        dd: '%dd',
        M: '1mo',
        MM: '%dmo',
        y: '1yr',
        yy: '%dyr'
    }
});
// Optional: define other locales here.
// Finally, switch back to the original locale to reduce changes to global state.
moment.locale(oldLocale);


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSignal = void 0;
var s_js_1 = __webpack_require__(0);
function RequestSignal(hash, parse, serialize) {
    var _request = s_js_1.default(function () { return parse(hash()); });
    return function request(loc, inplace) {
        return arguments.length === 0 ? _request() : (hash(serialize(loc), inplace), loc);
    };
}
exports.RequestSignal = RequestSignal;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TZUtils = void 0;
var s_js_1 = __webpack_require__(0);
var moment = __webpack_require__(6);
var TZDate_1 = __webpack_require__(7);
__webpack_require__(883);
var TZUtils = /** @class */ (function () {
    function TZUtils(timezone) {
        this.timezone = timezone;
    }
    // return a TZDate for the current time in the domain's timezone
    TZUtils.prototype.now = function () {
        return this.setTimezoneOffset(new Date(), false);
    };
    // return a TZDate for the start of today in the domain's timezone
    TZUtils.prototype.today = function () {
        var t = this.now();
        t.setHours(0), t.setMinutes(0), t.setSeconds(0), t.setMilliseconds(0);
        // If today is a dst boundary day, then midnight might've had a different offset than
        // now. Have to re-set offset in case.
        return this.setTimezoneOffset(t, true);
    };
    // return a TZDate for the specified numeric timestamp in the domain's timezone
    TZUtils.prototype.newDate = function (ts) {
        return this.setTimezoneOffset(new Date(ts), false);
    };
    // return a TZDate set to the correct timezone for the desired date
    TZUtils.prototype.setTimezoneOffset = function (date, changeUtc) {
        var tzdate = date instanceof TZDate_1.default ? date : new TZDate_1.default(+date, 0);
        // use the moment timezone library to figure out the correct timezone offset for the selected date
        var offset = this.timezone ? -moment(tzdate).tz(this.timezone).utcOffset() : date.getTimezoneOffset();
        // if date is in the wrong timezone, correct it
        if (tzdate.getTimezoneOffset() != offset) {
            tzdate.setTimezoneOffset(offset, changeUtc);
        }
        return tzdate;
    };
    // Clock w/ a now property set to tzutils.now.
    //   frequency -- frequency at which clock should tick in ms
    //
    // Calling clock.now in the context of a computed or pureComputed always returns tzutils.now,
    // plus creates a subscription to rerun the computation every time the clock ticks
    TZUtils.prototype.clock = function (frequency) {
        var _this = this;
        var tick = s_js_1.default.data(null), now = function () { return _this.now(); }, interval = window.setInterval(function () { tick(null); }, frequency);
        s_js_1.default.cleanup(dispose);
        return {
            now: function () {
                // TH: The reason we don't just make an observable set to tzutils.now is that an observable wouldn't always be up-to-date.
                // I.e., an observable woud only be up-to-date when the clock ticks,
                // but if a caller came along and evaluated clock.now in between ticks, it'd get an old value.
                // Setting things up our way instead means calling clock.now always returns tzutils.now, whether or not the clock is in between ticks.
                tick();
                return now();
            },
            dispose: dispose
        };
        function dispose() {
            window.clearInterval(interval);
        }
    };
    // convert a TZDate to a browser-local date
    TZUtils.prototype.localify = function (date) {
        return date instanceof TZDate_1.default ? date.toBrowserLocalDate() : date;
    };
    // opposite of localify: convert the given Date object to a TZDate with the same local values but in the correct TZ
    TZUtils.prototype.tzify = function (date) {
        if (date instanceof TZDate_1.default)
            return this.setTimezoneOffset(date, true);
        var t = this.now();
        t.setDate(1); // bugfix: if the target month has fewer days than the current month, and if now() is in those final days, setting the target month moves us to the *following* month
        t.setFullYear(date.getFullYear());
        t.setMonth(date.getMonth());
        t.setDate(date.getDate());
        t.setHours(date.getHours());
        t.setMinutes(date.getMinutes());
        t.setSeconds(date.getSeconds());
        t.setMilliseconds(date.getMilliseconds());
        // if date is the opposite side of a dst change, have to re-set timezone
        t = this.setTimezoneOffset(t, true);
        return t;
    };
    return TZUtils;
}());
exports.TZUtils = TZUtils;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DateDisplayOrders = exports.DateDisplayOrderDisplayName = exports.DateDisplayOrder = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\DateTimeDisplaySettings.cs
var DateDisplayOrder;
(function (DateDisplayOrder) {
    DateDisplayOrder[DateDisplayOrder["MonthDayYear"] = 0] = "MonthDayYear";
    DateDisplayOrder[DateDisplayOrder["DayMonthYear"] = 1] = "DayMonthYear";
    DateDisplayOrder[DateDisplayOrder["YearMonthDay"] = 2] = "YearMonthDay";
})(DateDisplayOrder = exports.DateDisplayOrder || (exports.DateDisplayOrder = {}));
exports.DateDisplayOrderDisplayName = {
    0: 'MonthDayYear',
    1: 'DayMonthYear',
    2: 'YearMonthDay'
};
exports.DateDisplayOrders = [
    { Id: DateDisplayOrder.MonthDayYear, Name: 'MonthDayYear' },
    { Id: DateDisplayOrder.DayMonthYear, Name: 'DayMonthYear' },
    { Id: DateDisplayOrder.YearMonthDay, Name: 'YearMonthDay' }
];


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageTabVisibilitys = exports.HomepageTabVisibilityDisplayName = exports.HomepageTabVisibility = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\HomepageSettings.cs
var HomepageTabVisibility;
(function (HomepageTabVisibility) {
    HomepageTabVisibility[HomepageTabVisibility["Public"] = 0] = "Public";
    HomepageTabVisibility[HomepageTabVisibility["LoggedIn"] = 10] = "LoggedIn";
    HomepageTabVisibility[HomepageTabVisibility["Off"] = 20] = "Off";
})(HomepageTabVisibility = exports.HomepageTabVisibility || (exports.HomepageTabVisibility = {}));
exports.HomepageTabVisibilityDisplayName = {
    0: 'Public',
    10: 'LoggedIn',
    20: 'Off'
};
exports.HomepageTabVisibilitys = [
    { Id: HomepageTabVisibility.Public, Name: 'Public' },
    { Id: HomepageTabVisibility.LoggedIn, Name: 'LoggedIn' },
    { Id: HomepageTabVisibility.Off, Name: 'Off' }
];


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotAssignmentChangeActions = exports.PilotAssignmentChangeActionDisplayName = exports.PilotAssignmentChangeAction = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.Models\ChangeDetection\PilotJobOrderChange.cs
var PilotAssignmentChangeAction;
(function (PilotAssignmentChangeAction) {
    PilotAssignmentChangeAction[PilotAssignmentChangeAction["Add"] = 0] = "Add";
    PilotAssignmentChangeAction[PilotAssignmentChangeAction["Remove"] = 10] = "Remove";
})(PilotAssignmentChangeAction = exports.PilotAssignmentChangeAction || (exports.PilotAssignmentChangeAction = {}));
exports.PilotAssignmentChangeActionDisplayName = {
    0: 'Add',
    10: 'Remove'
};
exports.PilotAssignmentChangeActions = [
    { Id: PilotAssignmentChangeAction.Add, Name: 'Add' },
    { Id: PilotAssignmentChangeAction.Remove, Name: 'Remove' }
];


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderChangeTypes = exports.PilotJobOrderChangeTypeDisplayName = exports.PilotJobOrderChangeType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderChange\ApiPilotJobOrderChange.cs
var PilotJobOrderChangeType;
(function (PilotJobOrderChangeType) {
    PilotJobOrderChangeType[PilotJobOrderChangeType["Creation"] = 1] = "Creation";
    PilotJobOrderChangeType[PilotJobOrderChangeType["StartEstimated"] = 2] = "StartEstimated";
    PilotJobOrderChangeType[PilotJobOrderChangeType["EndEstimated"] = 3] = "EndEstimated";
    PilotJobOrderChangeType[PilotJobOrderChangeType["StartActual"] = 4] = "StartActual";
    PilotJobOrderChangeType[PilotJobOrderChangeType["EndActual"] = 5] = "EndActual";
    PilotJobOrderChangeType[PilotJobOrderChangeType["StartTimeConfirmed"] = 6] = "StartTimeConfirmed";
    PilotJobOrderChangeType[PilotJobOrderChangeType["DeepDraftConfirmed"] = 7] = "DeepDraftConfirmed";
    PilotJobOrderChangeType[PilotJobOrderChangeType["PilotAssignment"] = 8] = "PilotAssignment";
    PilotJobOrderChangeType[PilotJobOrderChangeType["PilotConfirmed"] = 9] = "PilotConfirmed";
    PilotJobOrderChangeType[PilotJobOrderChangeType["AirDraft"] = 10] = "AirDraft";
    PilotJobOrderChangeType[PilotJobOrderChangeType["DeepDraft"] = 11] = "DeepDraft";
    PilotJobOrderChangeType[PilotJobOrderChangeType["Remarks"] = 12] = "Remarks";
    PilotJobOrderChangeType[PilotJobOrderChangeType["TugCompany"] = 13] = "TugCompany";
    PilotJobOrderChangeType[PilotJobOrderChangeType["LineHandlingCompany"] = 14] = "LineHandlingCompany";
    PilotJobOrderChangeType[PilotJobOrderChangeType["LaborStartTime"] = 15] = "LaborStartTime";
    PilotJobOrderChangeType[PilotJobOrderChangeType["BowThrusterOperational"] = 16] = "BowThrusterOperational";
    PilotJobOrderChangeType[PilotJobOrderChangeType["CancelledDate_DEPRECATED_20180517"] = 17] = "CancelledDate_DEPRECATED_20180517";
})(PilotJobOrderChangeType = exports.PilotJobOrderChangeType || (exports.PilotJobOrderChangeType = {}));
exports.PilotJobOrderChangeTypeDisplayName = {
    1: 'Creation',
    2: 'StartEstimated',
    3: 'EndEstimated',
    4: 'StartActual',
    5: 'EndActual',
    6: 'StartTimeConfirmed',
    7: 'DeepDraftConfirmed',
    8: 'PilotAssignment',
    9: 'PilotConfirmed',
    10: 'AirDraft',
    11: 'DeepDraft',
    12: 'Remarks',
    13: 'TugCompany',
    14: 'LineHandlingCompany',
    15: 'LaborStartTime',
    16: 'BowThrusterOperational',
    17: 'CancelledDate_DEPRECATED_20180517'
};
exports.PilotJobOrderChangeTypes = [
    { Id: PilotJobOrderChangeType.Creation, Name: 'Creation' },
    { Id: PilotJobOrderChangeType.StartEstimated, Name: 'StartEstimated' },
    { Id: PilotJobOrderChangeType.EndEstimated, Name: 'EndEstimated' },
    { Id: PilotJobOrderChangeType.StartActual, Name: 'StartActual' },
    { Id: PilotJobOrderChangeType.EndActual, Name: 'EndActual' },
    { Id: PilotJobOrderChangeType.StartTimeConfirmed, Name: 'StartTimeConfirmed' },
    { Id: PilotJobOrderChangeType.DeepDraftConfirmed, Name: 'DeepDraftConfirmed' },
    { Id: PilotJobOrderChangeType.PilotAssignment, Name: 'PilotAssignment' },
    { Id: PilotJobOrderChangeType.PilotConfirmed, Name: 'PilotConfirmed' },
    { Id: PilotJobOrderChangeType.AirDraft, Name: 'AirDraft' },
    { Id: PilotJobOrderChangeType.DeepDraft, Name: 'DeepDraft' },
    { Id: PilotJobOrderChangeType.Remarks, Name: 'Remarks' },
    { Id: PilotJobOrderChangeType.TugCompany, Name: 'TugCompany' },
    { Id: PilotJobOrderChangeType.LineHandlingCompany, Name: 'LineHandlingCompany' },
    { Id: PilotJobOrderChangeType.LaborStartTime, Name: 'LaborStartTime' },
    { Id: PilotJobOrderChangeType.BowThrusterOperational, Name: 'BowThrusterOperational' },
    { Id: PilotJobOrderChangeType.CancelledDate_DEPRECATED_20180517, Name: 'CancelledDate_DEPRECATED_20180517' }
];


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareScopes = exports.ShareScopeDisplayName = exports.ShareScope = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\Shares\ApiShare.cs
var ShareScope;
(function (ShareScope) {
    ShareScope[ShareScope["Public"] = 1] = "Public";
    ShareScope[ShareScope["User"] = 2] = "User";
    ShareScope[ShareScope["Organization"] = 3] = "Organization";
})(ShareScope = exports.ShareScope || (exports.ShareScope = {}));
exports.ShareScopeDisplayName = {
    1: 'Public',
    2: 'User',
    3: 'Organization'
};
exports.ShareScopes = [
    { Id: ShareScope.Public, Name: 'Public' },
    { Id: ShareScope.User, Name: 'User' },
    { Id: ShareScope.Organization, Name: 'Organization' }
];


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareTypes = exports.ShareTypeDisplayName = exports.ShareType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.Models\Sharing\Share.cs
var ShareType;
(function (ShareType) {
    ShareType[ShareType["Viewer"] = 1] = "Viewer";
    ShareType[ShareType["Editor"] = 2] = "Editor";
    ShareType[ShareType["Owner"] = 61440] = "Owner";
    ShareType[ShareType["All"] = 65535] = "All";
    ShareType[ShareType["None"] = 0] = "None";
})(ShareType = exports.ShareType || (exports.ShareType = {}));
exports.ShareTypeDisplayName = {
    1: 'Viewer',
    2: 'Editor',
    61440: 'Owner',
    65535: 'All',
    0: 'None'
};
exports.ShareTypes = [
    { Id: ShareType.Viewer, Name: 'Viewer' },
    { Id: ShareType.Editor, Name: 'Editor' },
    { Id: ShareType.Owner, Name: 'Owner' },
    { Id: ShareType.All, Name: 'All' },
    { Id: ShareType.None, Name: 'None' }
];


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardChangeTypes = exports.TopicCardChangeTypeDisplayName = exports.TopicCardChangeType = void 0;
// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\TopicCardChange\ApiTopicCardChange.cs
var TopicCardChangeType;
(function (TopicCardChangeType) {
    TopicCardChangeType[TopicCardChangeType["Creation"] = 0] = "Creation";
    TopicCardChangeType[TopicCardChangeType["YesNoAnswer"] = 1] = "YesNoAnswer";
    TopicCardChangeType[TopicCardChangeType["TimeEntry"] = 2] = "TimeEntry";
    TopicCardChangeType[TopicCardChangeType["Status"] = 3] = "Status";
    TopicCardChangeType[TopicCardChangeType["SelectedOption"] = 4] = "SelectedOption";
})(TopicCardChangeType = exports.TopicCardChangeType || (exports.TopicCardChangeType = {}));
exports.TopicCardChangeTypeDisplayName = {
    0: 'Creation',
    1: 'YesNoAnswer',
    2: 'TimeEntry',
    3: 'Status',
    4: 'SelectedOption'
};
exports.TopicCardChangeTypes = [
    { Id: TopicCardChangeType.Creation, Name: 'Creation' },
    { Id: TopicCardChangeType.YesNoAnswer, Name: 'YesNoAnswer' },
    { Id: TopicCardChangeType.TimeEntry, Name: 'TimeEntry' },
    { Id: TopicCardChangeType.Status, Name: 'Status' },
    { Id: TopicCardChangeType.SelectedOption, Name: 'SelectedOption' }
];


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreAccountRequest = exports.CheckInvitationRequest = exports.AcceptInvitationRequest = exports.SendUserInviteRequestInvitedUser = exports.SendUserInviteRequest = exports.ResetPasswordRequest = exports.SendPasswordResetRequest = exports.ForgotPasswordRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Account\PortcallAccountBindingModels.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ForgotPasswordRequest = /** @class */ (function () {
    function ForgotPasswordRequest(data) {
        if (data === void 0) { data = null; }
        this.Email = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Email !== undefined ? data.Email : ''));
    }
    ForgotPasswordRequest.key = function (obj) {
        return;
    };
    ForgotPasswordRequest.dataKey = function (obj) {
        return;
    };
    ForgotPasswordRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Email !== undefined)
                obj.Email(data.Email);
        });
    };
    return ForgotPasswordRequest;
}());
exports.ForgotPasswordRequest = ForgotPasswordRequest;
var SendPasswordResetRequest = /** @class */ (function () {
    function SendPasswordResetRequest(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
    }
    SendPasswordResetRequest.key = function (obj) {
        return;
    };
    SendPasswordResetRequest.dataKey = function (obj) {
        return;
    };
    SendPasswordResetRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
        });
    };
    return SendPasswordResetRequest;
}());
exports.SendPasswordResetRequest = SendPasswordResetRequest;
var ResetPasswordRequest = /** @class */ (function () {
    function ResetPasswordRequest(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.ConfirmPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.NewPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewPassword !== undefined ? data.NewPassword : ''));
        this.Token = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Token !== undefined ? data.Token : ''));
    }
    ResetPasswordRequest.key = function (obj) {
        return;
    };
    ResetPasswordRequest.dataKey = function (obj) {
        return;
    };
    ResetPasswordRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.ConfirmPassword !== undefined)
                obj.ConfirmPassword(data.ConfirmPassword);
            if (data.NewPassword !== undefined)
                obj.NewPassword(data.NewPassword);
            if (data.Token !== undefined)
                obj.Token(data.Token);
        });
    };
    return ResetPasswordRequest;
}());
exports.ResetPasswordRequest = ResetPasswordRequest;
var SendUserInviteRequest = /** @class */ (function () {
    function SendUserInviteRequest(data) {
        if (data === void 0) { data = null; }
        this.InvitedUsers = s_array_1.default([]);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : null));
        this.IsNewOrganization = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsNewOrganization !== undefined ? data.IsNewOrganization : false));
        this.OrganizationName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationName !== undefined ? data.OrganizationName : null));
    }
    SendUserInviteRequest.key = function (obj) {
        return;
    };
    SendUserInviteRequest.dataKey = function (obj) {
        return;
    };
    SendUserInviteRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.IsNewOrganization !== undefined)
                obj.IsNewOrganization(data.IsNewOrganization);
            if (data.OrganizationName !== undefined)
                obj.OrganizationName(data.OrganizationName);
        });
    };
    return SendUserInviteRequest;
}());
exports.SendUserInviteRequest = SendUserInviteRequest;
var SendUserInviteRequestInvitedUser = /** @class */ (function () {
    function SendUserInviteRequestInvitedUser(data) {
        if (data === void 0) { data = null; }
        this.Email = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Email !== undefined ? data.Email : ''));
        this.Roles = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.Roles !== undefined ? data.Roles : []));
    }
    SendUserInviteRequestInvitedUser.key = function (obj) {
        return;
    };
    SendUserInviteRequestInvitedUser.dataKey = function (obj) {
        return;
    };
    SendUserInviteRequestInvitedUser.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Email !== undefined)
                obj.Email(data.Email);
            if (data.Roles !== undefined)
                obj.Roles(data.Roles);
        });
    };
    return SendUserInviteRequestInvitedUser;
}());
exports.SendUserInviteRequestInvitedUser = SendUserInviteRequestInvitedUser;
var AcceptInvitationRequest = /** @class */ (function () {
    function AcceptInvitationRequest(data) {
        if (data === void 0) { data = null; }
        this.InvitationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvitationId !== undefined ? data.InvitationId : 0));
        this.ConfirmPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.FirstName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstName !== undefined ? data.FirstName : ''));
        this.LastName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastName !== undefined ? data.LastName : ''));
        this.Password = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Password !== undefined ? data.Password : ''));
        this.Token = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Token !== undefined ? data.Token : ''));
    }
    AcceptInvitationRequest.key = function (obj) {
        return;
    };
    AcceptInvitationRequest.dataKey = function (obj) {
        return;
    };
    AcceptInvitationRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.InvitationId !== undefined)
                obj.InvitationId(data.InvitationId);
            if (data.ConfirmPassword !== undefined)
                obj.ConfirmPassword(data.ConfirmPassword);
            if (data.FirstName !== undefined)
                obj.FirstName(data.FirstName);
            if (data.LastName !== undefined)
                obj.LastName(data.LastName);
            if (data.Password !== undefined)
                obj.Password(data.Password);
            if (data.Token !== undefined)
                obj.Token(data.Token);
        });
    };
    return AcceptInvitationRequest;
}());
exports.AcceptInvitationRequest = AcceptInvitationRequest;
var CheckInvitationRequest = /** @class */ (function () {
    function CheckInvitationRequest(data) {
        if (data === void 0) { data = null; }
        this.InvitationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvitationId !== undefined ? data.InvitationId : 0));
        this.Token = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Token !== undefined ? data.Token : ''));
    }
    CheckInvitationRequest.key = function (obj) {
        return;
    };
    CheckInvitationRequest.dataKey = function (obj) {
        return;
    };
    CheckInvitationRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.InvitationId !== undefined)
                obj.InvitationId(data.InvitationId);
            if (data.Token !== undefined)
                obj.Token(data.Token);
        });
    };
    return CheckInvitationRequest;
}());
exports.CheckInvitationRequest = CheckInvitationRequest;
var RestoreAccountRequest = /** @class */ (function () {
    function RestoreAccountRequest(data) {
        if (data === void 0) { data = null; }
        this.InvitationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvitationId !== undefined ? data.InvitationId : 0));
        this.Token = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Token !== undefined ? data.Token : ''));
    }
    RestoreAccountRequest.key = function (obj) {
        return;
    };
    RestoreAccountRequest.dataKey = function (obj) {
        return;
    };
    RestoreAccountRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.InvitationId !== undefined)
                obj.InvitationId(data.InvitationId);
            if (data.Token !== undefined)
                obj.Token(data.Token);
        });
    };
    return RestoreAccountRequest;
}());
exports.RestoreAccountRequest = RestoreAccountRequest;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AcknowledgePilotJobOrdersRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\AcknowledgePilotJobOrdersRequest.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var AcknowledgePilotJobOrdersRequest = /** @class */ (function () {
    function AcknowledgePilotJobOrdersRequest(data) {
        if (data === void 0) { data = null; }
        this.PilotJobOrderIds = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.PilotJobOrderIds !== undefined ? data.PilotJobOrderIds : []));
    }
    AcknowledgePilotJobOrdersRequest.key = function (obj) {
        return;
    };
    AcknowledgePilotJobOrdersRequest.dataKey = function (obj) {
        return;
    };
    AcknowledgePilotJobOrdersRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PilotJobOrderIds !== undefined)
                obj.PilotJobOrderIds(data.PilotJobOrderIds);
        });
    };
    return AcknowledgePilotJobOrdersRequest;
}());
exports.AcknowledgePilotJobOrdersRequest = AcknowledgePilotJobOrdersRequest;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFeedNewReservation = exports.ActivityFeedResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\ActivityFeedResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ActivityFeedResponse = /** @class */ (function () {
    function ActivityFeedResponse(data) {
        if (data === void 0) { data = null; }
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.ChangedBatches = s_array_1.default([]);
        this.ChangedReservations = s_array_1.default([]);
        this.ChangedTopicCards = s_array_1.default([]);
        this.ConflictedBatches = s_array_1.default([]);
        this.ConflictedReservations = s_array_1.default([]);
        this.NewBatches = s_array_1.default([]);
        this.NewReservations = s_array_1.default([]);
        this.OpenReservations = s_array_1.default([]);
    }
    ActivityFeedResponse.key = function (obj) {
        return obj.OrganizationId();
    };
    ActivityFeedResponse.dataKey = function (obj) {
        return obj.OrganizationId;
    };
    ActivityFeedResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
        });
    };
    return ActivityFeedResponse;
}());
exports.ActivityFeedResponse = ActivityFeedResponse;
var ActivityFeedNewReservation = /** @class */ (function () {
    function ActivityFeedNewReservation(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Requestor = s_js_1.default.value(null);
        this.RequestorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Reservation = s_js_1.default.value(null);
    }
    ActivityFeedNewReservation.key = function (obj) {
        return obj.Id();
    };
    ActivityFeedNewReservation.dataKey = function (obj) {
        return obj.Id;
    };
    ActivityFeedNewReservation.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.RequestorId !== undefined)
                obj.RequestorId(data.RequestorId);
        });
    };
    return ActivityFeedNewReservation;
}());
exports.ActivityFeedNewReservation = ActivityFeedNewReservation;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCoordinationCardRequest = exports.AddCoordinationCardsRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\SelectCoordinations\AddCoordinationCardsRequest.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var AddCoordinationCardsRequest = /** @class */ (function () {
    function AddCoordinationCardsRequest(data) {
        if (data === void 0) { data = null; }
        this.RequestedCards = s_array_1.default([]);
    }
    AddCoordinationCardsRequest.key = function (obj) {
        return;
    };
    AddCoordinationCardsRequest.dataKey = function (obj) {
        return;
    };
    AddCoordinationCardsRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return AddCoordinationCardsRequest;
}());
exports.AddCoordinationCardsRequest = AddCoordinationCardsRequest;
var AddCoordinationCardRequest = /** @class */ (function () {
    function AddCoordinationCardRequest(data) {
        if (data === void 0) { data = null; }
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.ProviderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
    }
    AddCoordinationCardRequest.key = function (obj) {
        return;
    };
    AddCoordinationCardRequest.dataKey = function (obj) {
        return;
    };
    AddCoordinationCardRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined)
                obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined)
                obj.ScheduleDateId(data.ScheduleDateId);
        });
    };
    return AddCoordinationCardRequest;
}());
exports.AddCoordinationCardRequest = AddCoordinationCardRequest;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPortCallRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewPortCall\AddPortCallRequest.cs
var s_js_1 = __webpack_require__(0);
var AddPortCallRequest = /** @class */ (function () {
    function AddPortCallRequest(data) {
        if (data === void 0) { data = null; }
        this.AddVessel = s_js_1.default.value(null);
        this.BatchRequest = s_js_1.default.value(null);
        this.PortCall = s_js_1.default.value(null);
    }
    AddPortCallRequest.key = function (obj) {
        return;
    };
    AddPortCallRequest.dataKey = function (obj) {
        return;
    };
    AddPortCallRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return AddPortCallRequest;
}());
exports.AddPortCallRequest = AddPortCallRequest;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AddVesselRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\AddVessel\AddVesselRequest.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var AddVesselRequest = /** @class */ (function () {
    function AddVesselRequest(data) {
        if (data === void 0) { data = null; }
        this.LloydServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LloydServiceVesselId !== undefined ? data.LloydServiceVesselId : null));
        this.MarineTrafficServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MarineTrafficServiceVesselId !== undefined ? data.MarineTrafficServiceVesselId : null));
        this.OverrideServiceVessel = s_js_1.default.value(null);
        this.PSixServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PSixServiceVesselId !== undefined ? data.PSixServiceVesselId : null));
    }
    AddVesselRequest.key = function (obj) {
        return;
    };
    AddVesselRequest.dataKey = function (obj) {
        return;
    };
    AddVesselRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.LloydServiceVesselId !== undefined)
                obj.LloydServiceVesselId(data.LloydServiceVesselId);
            if (data.MarineTrafficServiceVesselId !== undefined)
                obj.MarineTrafficServiceVesselId(data.MarineTrafficServiceVesselId);
            if (data.PSixServiceVesselId !== undefined)
                obj.PSixServiceVesselId(data.PSixServiceVesselId);
        });
    };
    return AddVesselRequest;
}());
exports.AddVesselRequest = AddVesselRequest;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AgencyCode = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\AgencyCode\ApiAgencyCode.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var AgencyCode = /** @class */ (function () {
    function AgencyCode(data) {
        if (data === void 0) { data = null; }
        this.CodedOrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CodedOrganizationId !== undefined ? data.CodedOrganizationId : 0));
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.CodedOrganization = s_js_1.default.value(null);
        this.PilotAgency = s_js_1.default.value(null);
        this.Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Code !== undefined ? data.Code : ''));
    }
    AgencyCode.key = function (obj) {
        return obj.CodedOrganizationId() + '\u2618' + obj.PilotAgencyId();
    };
    AgencyCode.dataKey = function (obj) {
        return obj.CodedOrganizationId + '\u2618' + obj.PilotAgencyId;
    };
    AgencyCode.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CodedOrganizationId !== undefined)
                obj.CodedOrganizationId(data.CodedOrganizationId);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.Code !== undefined)
                obj.Code(data.Code);
        });
    };
    return AgencyCode;
}());
exports.AgencyCode = AgencyCode;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentRestrictionSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\AgentRestrictionSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var AgentRestrictionSettings = /** @class */ (function () {
    function AgentRestrictionSettings(data) {
        if (data === void 0) { data = null; }
        this.PreventAgentDoubleBookings = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PreventAgentDoubleBookings !== undefined ? data.PreventAgentDoubleBookings : false));
    }
    AgentRestrictionSettings.key = function (obj) {
        return;
    };
    AgentRestrictionSettings.dataKey = function (obj) {
        return;
    };
    AgentRestrictionSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PreventAgentDoubleBookings !== undefined)
                obj.PreventAgentDoubleBookings(data.PreventAgentDoubleBookings);
        });
    };
    return AgentRestrictionSettings;
}());
exports.AgentRestrictionSettings = AgentRestrictionSettings;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalOfCharges = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ApprovalOfCharges\ApiApprovalOfCharges.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ApprovalOfCharges = /** @class */ (function () {
    function ApprovalOfCharges(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.BillingSystemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Charges = s_array_1.default([]);
        this.DispatchEvent = s_js_1.default.value(null);
        this.DispatchEventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DispatchEventId !== undefined ? data.DispatchEventId : 0));
        this.JobOrder = s_js_1.default.value(null);
        this.JobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.ApprovalDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalDate !== undefined ? new TZDate_1.default(data.ApprovalDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    ApprovalOfCharges.key = function (obj) {
        return obj.Id();
    };
    ApprovalOfCharges.dataKey = function (obj) {
        return obj.Id;
    };
    ApprovalOfCharges.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillingSystemId !== undefined)
                obj.BillingSystemId(data.BillingSystemId);
            if (data.DispatchEventId !== undefined)
                obj.DispatchEventId(data.DispatchEventId);
            if (data.JobOrderId !== undefined)
                obj.JobOrderId(data.JobOrderId);
            if (data.ApprovalDate !== undefined)
                obj.ApprovalDate(new TZDate_1.default(data.ApprovalDate));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return ApprovalOfCharges;
}());
exports.ApprovalOfCharges = ApprovalOfCharges;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovedCharge = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ApprovedCharge\ApiApprovedCharge.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Price_1 = __webpack_require__(162);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var ApprovedCharge = /** @class */ (function () {
    function ApprovedCharge(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Approval = s_js_1.default.value(null);
        this.ApprovalId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalId !== undefined ? data.ApprovalId : 0));
        this.StandardItem = s_js_1.default.value(null);
        this.StandardItemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardItemId !== undefined ? data.StandardItemId : null));
        this.StandardRate = s_js_1.default.value(null);
        this.StandardRateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardRateId !== undefined ? data.StandardRateId : null));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTrackingOverrides = data && data.QBTrackingOverrides !== undefined ? new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking(data.QBTrackingOverrides) : new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement_1.Measurement(data.Quantity) : new Measurement_1.Measurement();
        this.Unit = data && data.Unit !== undefined ? new Measurement_1.Measurement(data.Unit) : new Measurement_1.Measurement();
        this.UnitPrice = data && data.UnitPrice !== undefined ? new Price_1.Price(data.UnitPrice) : new Price_1.Price();
    }
    ApprovedCharge.key = function (obj) {
        return obj.Id();
    };
    ApprovedCharge.dataKey = function (obj) {
        return obj.Id;
    };
    ApprovedCharge.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ApprovalId !== undefined)
                obj.ApprovalId(data.ApprovalId);
            if (data.StandardItemId !== undefined)
                obj.StandardItemId(data.StandardItemId);
            if (data.StandardRateId !== undefined)
                obj.StandardRateId(data.StandardRateId);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.QBTrackingOverrides !== undefined)
                QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking.update(obj.QBTrackingOverrides, data.QBTrackingOverrides);
            if (data.Quantity !== undefined)
                Measurement_1.Measurement.update(obj.Quantity, data.Quantity);
            if (data.Unit !== undefined)
                Measurement_1.Measurement.update(obj.Unit, data.Unit);
            if (data.UnitPrice !== undefined)
                Price_1.Price.update(obj.UnitPrice, data.UnitPrice);
        });
    };
    return ApprovedCharge;
}());
exports.ApprovedCharge = ApprovedCharge;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedData = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Data\AuthorizedDataController.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var AuthorizedData = /** @class */ (function () {
    function AuthorizedData(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Domain = s_js_1.default.value(null);
        this.UserSummary = s_js_1.default.value(null);
    }
    AuthorizedData.key = function (obj) {
        return obj.Id();
    };
    AuthorizedData.dataKey = function (obj) {
        return obj.Id;
    };
    AuthorizedData.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return AuthorizedData;
}());
exports.AuthorizedData = AuthorizedData;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationSystem = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\AutomationSystem\ApiAutomationSystem.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var AutomationSystem = /** @class */ (function () {
    function AutomationSystem(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    AutomationSystem.key = function (obj) {
        return obj.Id();
    };
    AutomationSystem.dataKey = function (obj) {
        return obj.Id;
    };
    AutomationSystem.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return AutomationSystem;
}());
exports.AutomationSystem = AutomationSystem;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Barge = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Barge\ApiBarge.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Barge = /** @class */ (function () {
    function Barge(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PortCalls = s_array_1.default([]);
        this.AuditKey = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AuditKey !== undefined ? data.AuditKey : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
    }
    Barge.key = function (obj) {
        return obj.Id();
    };
    Barge.dataKey = function (obj) {
        return obj.Id;
    };
    Barge.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AuditKey !== undefined)
                obj.AuditKey(data.AuditKey);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return Barge;
}());
exports.Barge = Barge;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchRecurrencePeriod = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\PortCall\BatchRecurrencePeriod.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BatchRecurrencePeriod = /** @class */ (function () {
    function BatchRecurrencePeriod(data) {
        if (data === void 0) { data = null; }
        this.CustomDays = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CustomDays !== undefined ? data.CustomDays : 0));
        this.Frequency = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Frequency !== undefined ? data.Frequency : 0));
    }
    BatchRecurrencePeriod.key = function (obj) {
        return;
    };
    BatchRecurrencePeriod.dataKey = function (obj) {
        return;
    };
    BatchRecurrencePeriod.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CustomDays !== undefined)
                obj.CustomDays(data.CustomDays);
            if (data.Frequency !== undefined)
                obj.Frequency(data.Frequency);
        });
    };
    return BatchRecurrencePeriod;
}());
exports.BatchRecurrencePeriod = BatchRecurrencePeriod;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchesDashboard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BatchesDashboard\BatchesDashboardViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BatchesDashboard = /** @class */ (function () {
    function BatchesDashboard(data) {
        if (data === void 0) { data = null; }
        this.FromDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromDate !== undefined ? new TZDate_1.default(data.FromDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Role = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Role !== undefined ? data.Role : 0));
        this.ToDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToDate !== undefined ? new TZDate_1.default(data.ToDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Batches = s_array_1.default([]);
        this.Organization = s_js_1.default.value(null);
    }
    BatchesDashboard.key = function (obj) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.Role() + '\u2618' + obj.ToDate().toJSON();
    };
    BatchesDashboard.dataKey = function (obj) {
        return new TZDate_1.default(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.Role + '\u2618' + new TZDate_1.default(obj.ToDate).toJSON();
    };
    BatchesDashboard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromDate !== undefined)
                obj.FromDate(new TZDate_1.default(data.FromDate));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Role !== undefined)
                obj.Role(data.Role);
            if (data.ToDate !== undefined)
                obj.ToDate(new TZDate_1.default(data.ToDate));
        });
    };
    return BatchesDashboard;
}());
exports.BatchesDashboard = BatchesDashboard;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Berth = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Berth\ApiBerth.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Berth = /** @class */ (function () {
    function Berth(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Amenities = s_array_1.default([]);
        this.AmenitiesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AmenitiesUrl !== undefined ? data.AmenitiesUrl : null));
        this.BerthCapabilityAssignmentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthCapabilityAssignmentsUrl !== undefined ? data.BerthCapabilityAssignmentsUrl : null));
        this.BollardPositions = s_array_1.default([]);
        this.Capabilities = s_array_1.default([]);
        this.Closures = s_array_1.default([]);
        this.Issues = s_array_1.default([]);
        this.Location = s_js_1.default.value(null);
        this.PierGroup = s_js_1.default.value(null);
        this.PierGroupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PierGroupId !== undefined ? data.PierGroupId : 0));
        this.PostalAddress = s_js_1.default.value(null);
        this.PostalAddressId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PostalAddressId !== undefined ? data.PostalAddressId : 0));
        this.SchedulingAuthority = s_js_1.default.value(null);
        this.SchedulingAuthorityId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SchedulingAuthorityId !== undefined ? data.SchedulingAuthorityId : null));
        this.Stream = s_array_1.default([]);
        this.TopicCards = s_array_1.default([]);
        this.AutoCalculateBills = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AutoCalculateBills !== undefined ? data.AutoCalculateBills : false));
        this.BerthTransitOffset = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthTransitOffset !== undefined ? data.BerthTransitOffset : 0));
        this.BerthType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthType !== undefined ? data.BerthType : 0));
        this.DaylightMooringOnly = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DaylightMooringOnly !== undefined ? data.DaylightMooringOnly : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.LengthBuffer = data && data.LengthBuffer !== undefined ? new Measurement_1.Measurement(data.LengthBuffer) : new Measurement_1.Measurement();
        this.LowFootmarkCompassPoint = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LowFootmarkCompassPoint !== undefined ? data.LowFootmarkCompassPoint : 0));
        this.MaxDraftAllowed = data && data.MaxDraftAllowed !== undefined ? new Measurement_1.Measurement(data.MaxDraftAllowed) : new Measurement_1.Measurement();
        this.MultiVesselBerthing = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MultiVesselBerthing !== undefined ? data.MultiVesselBerthing : false));
        this.Notes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Notes !== undefined ? data.Notes : null));
        this.PierMark = data && data.PierMark !== undefined ? new Measurement_1.Measurement(data.PierMark) : new Measurement_1.Measurement();
        this.PortName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortName !== undefined ? data.PortName : null));
        this.PortSideVesselHasBowToLowFootmark = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortSideVesselHasBowToLowFootmark !== undefined ? data.PortSideVesselHasBowToLowFootmark : false));
        this.StartMark = data && data.StartMark !== undefined ? new Measurement_1.Measurement(data.StartMark) : new Measurement_1.Measurement();
        this.TimeBuffer = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TimeBuffer !== undefined ? data.TimeBuffer : 0));
    }
    Berth.key = function (obj) {
        return obj.Id();
    };
    Berth.dataKey = function (obj) {
        return obj.Id;
    };
    Berth.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AmenitiesUrl !== undefined)
                obj.AmenitiesUrl(data.AmenitiesUrl);
            if (data.BerthCapabilityAssignmentsUrl !== undefined)
                obj.BerthCapabilityAssignmentsUrl(data.BerthCapabilityAssignmentsUrl);
            if (data.PierGroupId !== undefined)
                obj.PierGroupId(data.PierGroupId);
            if (data.PostalAddressId !== undefined)
                obj.PostalAddressId(data.PostalAddressId);
            if (data.SchedulingAuthorityId !== undefined)
                obj.SchedulingAuthorityId(data.SchedulingAuthorityId);
            if (data.AutoCalculateBills !== undefined)
                obj.AutoCalculateBills(data.AutoCalculateBills);
            if (data.BerthTransitOffset !== undefined)
                obj.BerthTransitOffset(data.BerthTransitOffset);
            if (data.BerthType !== undefined)
                obj.BerthType(data.BerthType);
            if (data.DaylightMooringOnly !== undefined)
                obj.DaylightMooringOnly(data.DaylightMooringOnly);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.LengthBuffer !== undefined)
                Measurement_1.Measurement.update(obj.LengthBuffer, data.LengthBuffer);
            if (data.LowFootmarkCompassPoint !== undefined)
                obj.LowFootmarkCompassPoint(data.LowFootmarkCompassPoint);
            if (data.MaxDraftAllowed !== undefined)
                Measurement_1.Measurement.update(obj.MaxDraftAllowed, data.MaxDraftAllowed);
            if (data.MultiVesselBerthing !== undefined)
                obj.MultiVesselBerthing(data.MultiVesselBerthing);
            if (data.Notes !== undefined)
                obj.Notes(data.Notes);
            if (data.PierMark !== undefined)
                Measurement_1.Measurement.update(obj.PierMark, data.PierMark);
            if (data.PortName !== undefined)
                obj.PortName(data.PortName);
            if (data.PortSideVesselHasBowToLowFootmark !== undefined)
                obj.PortSideVesselHasBowToLowFootmark(data.PortSideVesselHasBowToLowFootmark);
            if (data.StartMark !== undefined)
                Measurement_1.Measurement.update(obj.StartMark, data.StartMark);
            if (data.TimeBuffer !== undefined)
                obj.TimeBuffer(data.TimeBuffer);
        });
    };
    return Berth;
}());
exports.Berth = Berth;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAmenity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthAmenity\ApiBerthAmenity.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BerthAmenity = /** @class */ (function () {
    function BerthAmenity(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Amenity = s_js_1.default.value(null);
        this.AmenityId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AmenityId !== undefined ? data.AmenityId : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }
    BerthAmenity.key = function (obj) {
        return obj.Id();
    };
    BerthAmenity.dataKey = function (obj) {
        return obj.Id;
    };
    BerthAmenity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AmenityId !== undefined)
                obj.AmenityId(data.AmenityId);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
        });
    };
    return BerthAmenity;
}());
exports.BerthAmenity = BerthAmenity;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAmenityType = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthAmenityType\ApiBerthAmenityType.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var BerthAmenityType = /** @class */ (function () {
    function BerthAmenityType(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berths = s_array_1.default([]);
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.TopicCards = s_array_1.default([]);
        this.TopicCardTemplates = s_array_1.default([]);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
    }
    BerthAmenityType.key = function (obj) {
        return obj.Id();
    };
    BerthAmenityType.dataKey = function (obj) {
        return obj.Id;
    };
    BerthAmenityType.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Order !== undefined)
                obj.Order(data.Order);
        });
    };
    return BerthAmenityType;
}());
exports.BerthAmenityType = BerthAmenityType;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthAssignmentDetailsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthAssignmentDetails\BerthAssignmentDetailsResponse.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BerthAssignmentDetailsResponse = /** @class */ (function () {
    function BerthAssignmentDetailsResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BerthReservation = s_js_1.default.value(null);
        this.PCRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PCRights !== undefined ? data.PCRights : 0));
    }
    BerthAssignmentDetailsResponse.key = function (obj) {
        return obj.Id();
    };
    BerthAssignmentDetailsResponse.dataKey = function (obj) {
        return obj.Id;
    };
    BerthAssignmentDetailsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PCRights !== undefined)
                obj.PCRights(data.PCRights);
        });
    };
    return BerthAssignmentDetailsResponse;
}());
exports.BerthAssignmentDetailsResponse = BerthAssignmentDetailsResponse;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthCapability = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthCapability\ApiBerthCapability.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var BerthCapability = /** @class */ (function () {
    function BerthCapability(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berths = s_array_1.default([]);
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
    }
    BerthCapability.key = function (obj) {
        return obj.Id();
    };
    BerthCapability.dataKey = function (obj) {
        return obj.Id;
    };
    BerthCapability.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Order !== undefined)
                obj.Order(data.Order);
        });
    };
    return BerthCapability;
}());
exports.BerthCapability = BerthCapability;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthCapabilityAssignment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthCapabilityAssignment\ApiBerthCapabilityAssignment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BerthCapabilityAssignment = /** @class */ (function () {
    function BerthCapabilityAssignment(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Capability = s_js_1.default.value(null);
        this.CapabilityId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CapabilityId !== undefined ? data.CapabilityId : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }
    BerthCapabilityAssignment.key = function (obj) {
        return obj.Id();
    };
    BerthCapabilityAssignment.dataKey = function (obj) {
        return obj.Id;
    };
    BerthCapabilityAssignment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.CapabilityId !== undefined)
                obj.CapabilityId(data.CapabilityId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
        });
    };
    return BerthCapabilityAssignment;
}());
exports.BerthCapabilityAssignment = BerthCapabilityAssignment;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosure = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthClosure\ApiBerthClosure.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var BerthClosure = /** @class */ (function () {
    function BerthClosure(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Issues = s_array_1.default([]);
        this.OthersIssues = s_array_1.default([]);
        this.ReservationIssues = s_array_1.default([]);
        this.EndDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EndDate !== undefined ? data.EndDate === null ? null : new TZDate_1.default(data.EndDate) : null, TZDate_1.default.nullableEq));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement_1.Measurement(data.Footmark) : new Measurement_1.Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.StartDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StartDate !== undefined ? new TZDate_1.default(data.StartDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Title = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Title !== undefined ? data.Title : ''));
    }
    BerthClosure.key = function (obj) {
        return obj.Id();
    };
    BerthClosure.dataKey = function (obj) {
        return obj.Id;
    };
    BerthClosure.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.EndDate !== undefined)
                obj.EndDate(data.EndDate === null ? null : new TZDate_1.default(data.EndDate));
            if (data.Footmark !== undefined)
                Measurement_1.Measurement.update(obj.Footmark, data.Footmark);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.StartDate !== undefined)
                obj.StartDate(new TZDate_1.default(data.StartDate));
            if (data.Title !== undefined)
                obj.Title(data.Title);
        });
    };
    return BerthClosure;
}());
exports.BerthClosure = BerthClosure;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthClosuresDashboard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthClosuresDashboard\BerthClosuresDashboardViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BerthClosuresDashboard = /** @class */ (function () {
    function BerthClosuresDashboard(data) {
        if (data === void 0) { data = null; }
        this.FromDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromDate !== undefined ? new TZDate_1.default(data.FromDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.ToDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToDate !== undefined ? new TZDate_1.default(data.ToDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Closures = s_array_1.default([]);
        this.Organization = s_js_1.default.value(null);
    }
    BerthClosuresDashboard.key = function (obj) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.ToDate().toJSON();
    };
    BerthClosuresDashboard.dataKey = function (obj) {
        return new TZDate_1.default(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + new TZDate_1.default(obj.ToDate).toJSON();
    };
    BerthClosuresDashboard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromDate !== undefined)
                obj.FromDate(new TZDate_1.default(data.FromDate));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.ToDate !== undefined)
                obj.ToDate(new TZDate_1.default(data.ToDate));
        });
    };
    return BerthClosuresDashboard;
}());
exports.BerthClosuresDashboard = BerthClosuresDashboard;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthProfileResponseRef = exports.BerthProfileResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthProfile\BerthProfileViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var BerthProfileResponse_1 = __webpack_require__(562);
var BerthProfileResponse = /** @class */ (function () {
    function BerthProfileResponse(data) {
        if (data === void 0) { data = null; }
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Berth = s_js_1.default.value(null);
        this.Ref = data && data.Ref !== undefined ? new BerthProfileResponse_1.BerthProfileResponseRef(data.Ref) : new BerthProfileResponse_1.BerthProfileResponseRef();
    }
    BerthProfileResponse.key = function (obj) {
        return obj.BerthId();
    };
    BerthProfileResponse.dataKey = function (obj) {
        return obj.BerthId;
    };
    BerthProfileResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.Ref !== undefined)
                BerthProfileResponse_1.BerthProfileResponseRef.update(obj.Ref, data.Ref);
        });
    };
    return BerthProfileResponse;
}());
exports.BerthProfileResponse = BerthProfileResponse;
var BerthProfileResponseRef = /** @class */ (function () {
    function BerthProfileResponseRef(data) {
        if (data === void 0) { data = null; }
        this.AmenityTypes = s_array_1.default([]);
        this.Capabilities = s_array_1.default([]);
        this.Organizations = s_array_1.default([]);
        this.Ports = s_array_1.default([]);
        this.ActivityRefreshRate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ActivityRefreshRate !== undefined ? data.ActivityRefreshRate : 0));
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditPort = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditPort !== undefined ? data.CanEditPort : false));
        this.CanEditSchedulingAuthority = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditSchedulingAuthority !== undefined ? data.CanEditSchedulingAuthority : false));
    }
    BerthProfileResponseRef.key = function (obj) {
        return;
    };
    BerthProfileResponseRef.dataKey = function (obj) {
        return;
    };
    BerthProfileResponseRef.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ActivityRefreshRate !== undefined)
                obj.ActivityRefreshRate(data.ActivityRefreshRate);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
            if (data.CanEditPort !== undefined)
                obj.CanEditPort(data.CanEditPort);
            if (data.CanEditSchedulingAuthority !== undefined)
                obj.CanEditSchedulingAuthority(data.CanEditSchedulingAuthority);
        });
    };
    return BerthProfileResponseRef;
}());
exports.BerthProfileResponseRef = BerthProfileResponseRef;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthRelevance = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthRelevance\ApiBerthRelevance.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BerthRelevance = /** @class */ (function () {
    function BerthRelevance(data) {
        if (data === void 0) { data = null; }
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.Berth = s_js_1.default.value(null);
        this.Event = s_js_1.default.value(null);
    }
    BerthRelevance.key = function (obj) {
        return obj.BerthId() + '\u2618' + obj.EventId();
    };
    BerthRelevance.dataKey = function (obj) {
        return obj.BerthId + '\u2618' + obj.EventId;
    };
    BerthRelevance.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
        });
    };
    return BerthRelevance;
}());
exports.BerthRelevance = BerthRelevance;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservation = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthReservation\ApiBerthReservation.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var BerthReservation = /** @class */ (function () {
    function BerthReservation(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.CargoActivities = s_array_1.default([]);
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.CruiseActivities = s_array_1.default([]);
        this.Issues = s_array_1.default([]);
        this.Itinerary = s_js_1.default.value(null);
        this.OthersIssues = s_array_1.default([]);
        this.RaftedVessels = s_array_1.default([]);
        this.Self = s_js_1.default.value(null);
        this.Version = s_js_1.default.value(null);
        this.ApprovedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovedDate !== undefined ? data.ApprovedDate === null ? null : new TZDate_1.default(data.ApprovedDate) : null, TZDate_1.default.nullableEq));
        this.CancellationRemarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CancellationRemarks !== undefined ? data.CancellationRemarks : null));
        this.CancelledDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CancelledDate !== undefined ? data.CancelledDate === null ? null : new TZDate_1.default(data.CancelledDate) : null, TZDate_1.default.nullableEq));
        this.ConflictCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConflictCount !== undefined ? data.ConflictCount : 0));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement_1.Measurement(data.Footmark) : new Measurement_1.Measurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HasLayOpsOnly = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HasLayOpsOnly !== undefined ? data.HasLayOpsOnly : false));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.Rafting = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Rafting !== undefined ? data.Rafting : false));
        this.RequestDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestDate !== undefined ? new TZDate_1.default(data.RequestDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.SideTo = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SideTo !== undefined ? data.SideTo : 0));
    }
    BerthReservation.key = function (obj) {
        return obj.Id();
    };
    BerthReservation.dataKey = function (obj) {
        return obj.Id;
    };
    BerthReservation.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.ApprovedDate !== undefined)
                obj.ApprovedDate(data.ApprovedDate === null ? null : new TZDate_1.default(data.ApprovedDate));
            if (data.CancellationRemarks !== undefined)
                obj.CancellationRemarks(data.CancellationRemarks);
            if (data.CancelledDate !== undefined)
                obj.CancelledDate(data.CancelledDate === null ? null : new TZDate_1.default(data.CancelledDate));
            if (data.ConflictCount !== undefined)
                obj.ConflictCount(data.ConflictCount);
            if (data.Footmark !== undefined)
                Measurement_1.Measurement.update(obj.Footmark, data.Footmark);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HasLayOpsOnly !== undefined)
                obj.HasLayOpsOnly(data.HasLayOpsOnly);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.Rafting !== undefined)
                obj.Rafting(data.Rafting);
            if (data.RequestDate !== undefined)
                obj.RequestDate(new TZDate_1.default(data.RequestDate));
            if (data.SideTo !== undefined)
                obj.SideTo(data.SideTo);
        });
    };
    return BerthReservation;
}());
exports.BerthReservation = BerthReservation;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservationSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthReservation\ApiBerthReservationSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var BerthReservationSelf = /** @class */ (function () {
    function BerthReservationSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Events = s_array_1.default([]);
        this.Itinerary = s_js_1.default.value(null);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    BerthReservationSelf.key = function (obj) {
        return obj.Id();
    };
    BerthReservationSelf.dataKey = function (obj) {
        return obj.Id;
    };
    BerthReservationSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return BerthReservationSelf;
}());
exports.BerthReservationSelf = BerthReservationSelf;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BerthReservationVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthReservation\ApiBerthReservationVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var BerthReservationVersion = /** @class */ (function () {
    function BerthReservationVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.NextVersion = s_array_1.default([]);
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.ApprovedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovedDate !== undefined ? data.ApprovedDate === null ? null : new TZDate_1.default(data.ApprovedDate) : null, TZDate_1.default.nullableEq));
        this.CancellationRemarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CancellationRemarks !== undefined ? data.CancellationRemarks : null));
        this.CancelledDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CancelledDate !== undefined ? data.CancelledDate === null ? null : new TZDate_1.default(data.CancelledDate) : null, TZDate_1.default.nullableEq));
        this.ConflictCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConflictCount !== undefined ? data.ConflictCount : 0));
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement_1.Measurement(data.Footmark) : new Measurement_1.Measurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.Rafting = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Rafting !== undefined ? data.Rafting : false));
        this.RequestDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestDate !== undefined ? new TZDate_1.default(data.RequestDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.SideTo = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SideTo !== undefined ? data.SideTo : 0));
    }
    BerthReservationVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    BerthReservationVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    BerthReservationVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.ApprovedDate !== undefined)
                obj.ApprovedDate(data.ApprovedDate === null ? null : new TZDate_1.default(data.ApprovedDate));
            if (data.CancellationRemarks !== undefined)
                obj.CancellationRemarks(data.CancellationRemarks);
            if (data.CancelledDate !== undefined)
                obj.CancelledDate(data.CancelledDate === null ? null : new TZDate_1.default(data.CancelledDate));
            if (data.ConflictCount !== undefined)
                obj.ConflictCount(data.ConflictCount);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined)
                obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Footmark !== undefined)
                Measurement_1.Measurement.update(obj.Footmark, data.Footmark);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.Rafting !== undefined)
                obj.Rafting(data.Rafting);
            if (data.RequestDate !== undefined)
                obj.RequestDate(new TZDate_1.default(data.RequestDate));
            if (data.SideTo !== undefined)
                obj.SideTo(data.SideTo);
        });
    };
    return BerthReservationVersion;
}());
exports.BerthReservationVersion = BerthReservationVersion;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Bill = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Bill\ApiBill.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var Bill = /** @class */ (function () {
    function Bill(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.BillingSystemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Coverage = s_array_1.default([]);
        this.ExportPayloads = s_array_1.default([]);
        this.Items = s_array_1.default([]);
        this.To = s_js_1.default.value(null);
        this.ToId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToId !== undefined ? data.ToId : null));
        this.CreationDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreationDate !== undefined ? new TZDate_1.default(data.CreationDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InvoiceDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvoiceDate !== undefined ? new TZDate_1.default(data.InvoiceDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.InvoiceNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvoiceNumber !== undefined ? data.InvoiceNumber : ''));
        this.JobDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobDate !== undefined ? new TZDate_1.default(data.JobDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
        this.ToAddress = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToAddress !== undefined ? data.ToAddress : null));
    }
    Bill.key = function (obj) {
        return obj.Id();
    };
    Bill.dataKey = function (obj) {
        return obj.Id;
    };
    Bill.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillingSystemId !== undefined)
                obj.BillingSystemId(data.BillingSystemId);
            if (data.ToId !== undefined)
                obj.ToId(data.ToId);
            if (data.CreationDate !== undefined)
                obj.CreationDate(new TZDate_1.default(data.CreationDate));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.InvoiceDate !== undefined)
                obj.InvoiceDate(new TZDate_1.default(data.InvoiceDate));
            if (data.InvoiceNumber !== undefined)
                obj.InvoiceNumber(data.InvoiceNumber);
            if (data.JobDate !== undefined)
                obj.JobDate(new TZDate_1.default(data.JobDate));
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.ToAddress !== undefined)
                obj.ToAddress(data.ToAddress);
        });
    };
    return Bill;
}());
exports.Bill = Bill;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCoverage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillCoverage\ApiBillCoverage.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BillCoverage = /** @class */ (function () {
    function BillCoverage(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Bill = s_js_1.default.value(null);
        this.BillId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillId !== undefined ? data.BillId : 0));
        this.DispatchEvent = s_js_1.default.value(null);
        this.DispatchEventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DispatchEventId !== undefined ? data.DispatchEventId : 0));
        this.JobOrder = s_js_1.default.value(null);
        this.JobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    BillCoverage.key = function (obj) {
        return obj.Id();
    };
    BillCoverage.dataKey = function (obj) {
        return obj.Id;
    };
    BillCoverage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillId !== undefined)
                obj.BillId(data.BillId);
            if (data.DispatchEventId !== undefined)
                obj.DispatchEventId(data.DispatchEventId);
            if (data.JobOrderId !== undefined)
                obj.JobOrderId(data.JobOrderId);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return BillCoverage;
}());
exports.BillCoverage = BillCoverage;


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillExportPayloadAssignment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillExportPayloadAssignment\ApiBillExportPayloadAssignment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var BillExportPayloadAssignment = /** @class */ (function () {
    function BillExportPayloadAssignment(data) {
        if (data === void 0) { data = null; }
        this.BillId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillId !== undefined ? data.BillId : 0));
        this.ExportPayloadId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExportPayloadId !== undefined ? data.ExportPayloadId : 0));
        this.Bill = s_js_1.default.value(null);
        this.ExportPayload = s_js_1.default.value(null);
    }
    BillExportPayloadAssignment.key = function (obj) {
        return obj.BillId() + '\u2618' + obj.ExportPayloadId();
    };
    BillExportPayloadAssignment.dataKey = function (obj) {
        return obj.BillId + '\u2618' + obj.ExportPayloadId;
    };
    BillExportPayloadAssignment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BillId !== undefined)
                obj.BillId(data.BillId);
            if (data.ExportPayloadId !== undefined)
                obj.ExportPayloadId(data.ExportPayloadId);
        });
    };
    return BillExportPayloadAssignment;
}());
exports.BillExportPayloadAssignment = BillExportPayloadAssignment;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillItem = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillItem\ApiBillItem.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Price_1 = __webpack_require__(162);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var BillItem = /** @class */ (function () {
    function BillItem(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Bill = s_js_1.default.value(null);
        this.BillId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillId !== undefined ? data.BillId : 0));
        this.StandardItem = s_js_1.default.value(null);
        this.StandardItemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardItemId !== undefined ? data.StandardItemId : null));
        this.StandardRate = s_js_1.default.value(null);
        this.StandardRateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardRateId !== undefined ? data.StandardRateId : null));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTrackingOverrides = data && data.QBTrackingOverrides !== undefined ? new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking(data.QBTrackingOverrides) : new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement_1.Measurement(data.Quantity) : new Measurement_1.Measurement();
        this.Unit = data && data.Unit !== undefined ? new Measurement_1.Measurement(data.Unit) : new Measurement_1.Measurement();
        this.UnitPrice = data && data.UnitPrice !== undefined ? new Price_1.Price(data.UnitPrice) : new Price_1.Price();
    }
    BillItem.key = function (obj) {
        return obj.Id();
    };
    BillItem.dataKey = function (obj) {
        return obj.Id;
    };
    BillItem.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillId !== undefined)
                obj.BillId(data.BillId);
            if (data.StandardItemId !== undefined)
                obj.StandardItemId(data.StandardItemId);
            if (data.StandardRateId !== undefined)
                obj.StandardRateId(data.StandardRateId);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.QBTrackingOverrides !== undefined)
                QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking.update(obj.QBTrackingOverrides, data.QBTrackingOverrides);
            if (data.Quantity !== undefined)
                Measurement_1.Measurement.update(obj.Quantity, data.Quantity);
            if (data.Unit !== undefined)
                Measurement_1.Measurement.update(obj.Unit, data.Unit);
            if (data.UnitPrice !== undefined)
                Price_1.Price.update(obj.UnitPrice, data.UnitPrice);
        });
    };
    return BillItem;
}());
exports.BillItem = BillItem;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingSystem = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillingSystem\ApiBillingSystem.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksBillingSystemTracking_1 = __webpack_require__(1332);
var BillingSystem = /** @class */ (function () {
    function BillingSystem(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ApprovalsOfCharges = s_array_1.default([]);
        this.Bills = s_array_1.default([]);
        this.ExportPayloads = s_array_1.default([]);
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.SpecialRates = s_array_1.default([]);
        this.StandardItems = s_array_1.default([]);
        this.Currency = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Currency !== undefined ? data.Currency : ''));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksBillingSystemTracking_1.QuickBooksBillingSystemTracking(data.QBTracking) : new QuickBooksBillingSystemTracking_1.QuickBooksBillingSystemTracking();
    }
    BillingSystem.key = function (obj) {
        return obj.Id();
    };
    BillingSystem.dataKey = function (obj) {
        return obj.Id;
    };
    BillingSystem.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Currency !== undefined)
                obj.Currency(data.Currency);
            if (data.QBTracking !== undefined)
                QuickBooksBillingSystemTracking_1.QuickBooksBillingSystemTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return BillingSystem;
}());
exports.BillingSystem = BillingSystem;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BowThruster = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Vessels\BowThruster.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var BowThruster = /** @class */ (function () {
    function BowThruster(data) {
        if (data === void 0) { data = null; }
        this.Present = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Present !== undefined ? data.Present : null));
        this.Size = data && data.Size !== undefined ? new Measurement_1.NullableMeasurement(data.Size) : new Measurement_1.NullableMeasurement();
    }
    BowThruster.key = function (obj) {
        return;
    };
    BowThruster.dataKey = function (obj) {
        return;
    };
    BowThruster.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Present !== undefined)
                obj.Present(data.Present);
            if (data.Size !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Size, data.Size);
        });
    };
    return BowThruster;
}());
exports.BowThruster = BowThruster;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelPortCallRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ModifyPortCall\CancelPortCallRequest.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CancelPortCallRequest = /** @class */ (function () {
    function CancelPortCallRequest(data) {
        if (data === void 0) { data = null; }
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
    }
    CancelPortCallRequest.key = function (obj) {
        return;
    };
    CancelPortCallRequest.dataKey = function (obj) {
        return;
    };
    CancelPortCallRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
        });
    };
    return CancelPortCallRequest;
}());
exports.CancelPortCallRequest = CancelPortCallRequest;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelReservationsRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ModifyReservations\CancelReservationsRequest.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var CancelReservationsRequest = /** @class */ (function () {
    function CancelReservationsRequest(data) {
        if (data === void 0) { data = null; }
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.ReservationIds = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.ReservationIds !== undefined ? data.ReservationIds : []));
    }
    CancelReservationsRequest.key = function (obj) {
        return;
    };
    CancelReservationsRequest.dataKey = function (obj) {
        return;
    };
    CancelReservationsRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.ReservationIds !== undefined)
                obj.ReservationIds(data.ReservationIds);
        });
    };
    return CancelReservationsRequest;
}());
exports.CancelReservationsRequest = CancelReservationsRequest;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoActivity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoActivity\ApiCargoActivity.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var CargoActivity = /** @class */ (function () {
    function CargoActivity(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ActivityType = s_js_1.default.value(null);
        this.ActivityTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ActivityTypeId !== undefined ? data.ActivityTypeId : null));
        this.CargoCategory = s_js_1.default.value(null);
        this.CargoCategoryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CargoCategoryId !== undefined ? data.CargoCategoryId : null));
        this.Reservation = s_js_1.default.value(null);
        this.ReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReservationId !== undefined ? data.ReservationId : 0));
        this.TradeRoute = s_js_1.default.value(null);
        this.TradeRouteId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TradeRouteId !== undefined ? data.TradeRouteId : null));
        this.Quantity = data && data.Quantity !== undefined ? new Measurement_1.NullableMeasurement(data.Quantity) : new Measurement_1.NullableMeasurement();
    }
    CargoActivity.key = function (obj) {
        return obj.Id();
    };
    CargoActivity.dataKey = function (obj) {
        return obj.Id;
    };
    CargoActivity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ActivityTypeId !== undefined)
                obj.ActivityTypeId(data.ActivityTypeId);
            if (data.CargoCategoryId !== undefined)
                obj.CargoCategoryId(data.CargoCategoryId);
            if (data.ReservationId !== undefined)
                obj.ReservationId(data.ReservationId);
            if (data.TradeRouteId !== undefined)
                obj.TradeRouteId(data.TradeRouteId);
            if (data.Quantity !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Quantity, data.Quantity);
        });
    };
    return CargoActivity;
}());
exports.CargoActivity = CargoActivity;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Change = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Change\ApiChange.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Change = /** @class */ (function () {
    function Change(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Automation = s_js_1.default.value(null);
        this.BerthReservationVersions = s_array_1.default([]);
        this.CoordinationCardVersions = s_array_1.default([]);
        this.EventsAbout = s_array_1.default([]);
        this.EventsCreated = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.ItineraryPointVersions = s_array_1.default([]);
        this.JobOrderVersions = s_array_1.default([]);
        this.PortCallVersions = s_array_1.default([]);
        this.RecurringBatchVersions = s_array_1.default([]);
        this.ScheduleDateVersions = s_array_1.default([]);
        this.User = s_js_1.default.value(null);
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    Change.key = function (obj) {
        return obj.Id();
    };
    Change.dataKey = function (obj) {
        return obj.Id;
    };
    Change.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
        });
    };
    return Change;
}());
exports.Change = Change;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRequest = exports.ChangePasswordRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\App\Account\AccountBindingModels.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var ChangePasswordRequest = /** @class */ (function () {
    function ChangePasswordRequest(data) {
        if (data === void 0) { data = null; }
        this.ConfirmPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.NewPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewPassword !== undefined ? data.NewPassword : ''));
        this.OldPassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldPassword !== undefined ? data.OldPassword : ''));
    }
    ChangePasswordRequest.key = function (obj) {
        return;
    };
    ChangePasswordRequest.dataKey = function (obj) {
        return;
    };
    ChangePasswordRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ConfirmPassword !== undefined)
                obj.ConfirmPassword(data.ConfirmPassword);
            if (data.NewPassword !== undefined)
                obj.NewPassword(data.NewPassword);
            if (data.OldPassword !== undefined)
                obj.OldPassword(data.OldPassword);
        });
    };
    return ChangePasswordRequest;
}());
exports.ChangePasswordRequest = ChangePasswordRequest;
var LoginRequest = /** @class */ (function () {
    function LoginRequest(data) {
        if (data === void 0) { data = null; }
        this.Password = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Password !== undefined ? data.Password : ''));
        this.UserName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserName !== undefined ? data.UserName : ''));
    }
    LoginRequest.key = function (obj) {
        return;
    };
    LoginRequest.dataKey = function (obj) {
        return;
    };
    LoginRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Password !== undefined)
                obj.Password(data.Password);
            if (data.UserName !== undefined)
                obj.UserName(data.UserName);
        });
    };
    return LoginRequest;
}());
exports.LoginRequest = LoginRequest;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Comment\ApiComment.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Comment = /** @class */ (function () {
    function Comment(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AttachmentUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : null));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.SubjectCoordinationCard = s_js_1.default.value(null);
        this.SubjectCoordinationCardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SubjectCoordinationCardId !== undefined ? data.SubjectCoordinationCardId : null));
        this.SubjectEvent = s_js_1.default.value(null);
        this.SubjectEventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SubjectEventId !== undefined ? data.SubjectEventId : null));
        this.SubjectJobOrder = s_js_1.default.value(null);
        this.SubjectJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SubjectJobOrderId !== undefined ? data.SubjectJobOrderId : null));
        this.SubjectPortCall = s_js_1.default.value(null);
        this.SubjectPortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SubjectPortCallId !== undefined ? data.SubjectPortCallId : null));
        this.SubjectTopicCard = s_js_1.default.value(null);
        this.SubjectTopicCardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SubjectTopicCardId !== undefined ? data.SubjectTopicCardId : null));
        this.TaggedUsers = s_array_1.default([]);
        this.Message = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Message !== undefined ? data.Message : null));
    }
    Comment.key = function (obj) {
        return obj.Id();
    };
    Comment.dataKey = function (obj) {
        return obj.Id;
    };
    Comment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AttachmentUrl !== undefined)
                obj.AttachmentUrl(data.AttachmentUrl);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.SubjectCoordinationCardId !== undefined)
                obj.SubjectCoordinationCardId(data.SubjectCoordinationCardId);
            if (data.SubjectEventId !== undefined)
                obj.SubjectEventId(data.SubjectEventId);
            if (data.SubjectJobOrderId !== undefined)
                obj.SubjectJobOrderId(data.SubjectJobOrderId);
            if (data.SubjectPortCallId !== undefined)
                obj.SubjectPortCallId(data.SubjectPortCallId);
            if (data.SubjectTopicCardId !== undefined)
                obj.SubjectTopicCardId(data.SubjectTopicCardId);
            if (data.Message !== undefined)
                obj.Message(data.Message);
        });
    };
    return Comment;
}());
exports.Comment = Comment;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultReminders = exports.ConfigureReminders = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ConfigureReminders\ConfigureRemindersViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var ConfigureReminders_1 = __webpack_require__(567);
var ConfigureReminders = /** @class */ (function () {
    function ConfigureReminders(data) {
        if (data === void 0) { data = null; }
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Organization = s_js_1.default.value(null);
        this.DefaultReminders = data && data.DefaultReminders !== undefined ? new ConfigureReminders_1.DefaultReminders(data.DefaultReminders) : new ConfigureReminders_1.DefaultReminders();
    }
    ConfigureReminders.key = function (obj) {
        return obj.OrganizationId();
    };
    ConfigureReminders.dataKey = function (obj) {
        return obj.OrganizationId;
    };
    ConfigureReminders.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.DefaultReminders !== undefined)
                ConfigureReminders_1.DefaultReminders.update(obj.DefaultReminders, data.DefaultReminders);
        });
    };
    return ConfigureReminders;
}());
exports.ConfigureReminders = ConfigureReminders;
var DefaultReminders = /** @class */ (function () {
    function DefaultReminders(data) {
        if (data === void 0) { data = null; }
        this.DefaultFinalReminderWindow = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultFinalReminderWindow !== undefined ? data.DefaultFinalReminderWindow : 0));
        this.DefaultFirstReminderWindow = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultFirstReminderWindow !== undefined ? data.DefaultFirstReminderWindow : 0));
    }
    DefaultReminders.key = function (obj) {
        return;
    };
    DefaultReminders.dataKey = function (obj) {
        return;
    };
    DefaultReminders.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.DefaultFinalReminderWindow !== undefined)
                obj.DefaultFinalReminderWindow(data.DefaultFinalReminderWindow);
            if (data.DefaultFirstReminderWindow !== undefined)
                obj.DefaultFirstReminderWindow(data.DefaultFirstReminderWindow);
        });
    };
    return DefaultReminders;
}());
exports.DefaultReminders = DefaultReminders;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationAltStatusLabel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationAltStatusLabel\ApiCoordinationAltStatusLabel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationAltStatusLabel = /** @class */ (function () {
    function CoordinationAltStatusLabel(data) {
        if (data === void 0) { data = null; }
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.StatusId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusId !== undefined ? data.StatusId : 0));
        this.Coordination = s_js_1.default.value(null);
        this.Status = s_js_1.default.value(null);
        this.Label = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Label !== undefined ? data.Label : ''));
    }
    CoordinationAltStatusLabel.key = function (obj) {
        return obj.CoordinationId() + '\u2618' + obj.StatusId();
    };
    CoordinationAltStatusLabel.dataKey = function (obj) {
        return obj.CoordinationId + '\u2618' + obj.StatusId;
    };
    CoordinationAltStatusLabel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.StatusId !== undefined)
                obj.StatusId(data.StatusId);
            if (data.Label !== undefined)
                obj.Label(data.Label);
        });
    };
    return CoordinationAltStatusLabel;
}());
exports.CoordinationAltStatusLabel = CoordinationAltStatusLabel;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardDetailsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\CCardDetails\CoordinationCardDetailsResponse.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardDetailsResponse = /** @class */ (function () {
    function CoordinationCardDetailsResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.CoordinationCard = s_js_1.default.value(null);
        this.Rights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Rights !== undefined ? data.Rights : 0));
    }
    CoordinationCardDetailsResponse.key = function (obj) {
        return obj.Id();
    };
    CoordinationCardDetailsResponse.dataKey = function (obj) {
        return obj.Id;
    };
    CoordinationCardDetailsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Rights !== undefined)
                obj.Rights(data.Rights);
        });
    };
    return CoordinationCardDetailsResponse;
}());
exports.CoordinationCardDetailsResponse = CoordinationCardDetailsResponse;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardRelevance = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCardRelevance\ApiCoordinationCardRelevance.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardRelevance = /** @class */ (function () {
    function CoordinationCardRelevance(data) {
        if (data === void 0) { data = null; }
        this.CoordinationCardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationCardId !== undefined ? data.CoordinationCardId : 0));
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.CoordinationCard = s_js_1.default.value(null);
        this.Event = s_js_1.default.value(null);
    }
    CoordinationCardRelevance.key = function (obj) {
        return obj.CoordinationCardId() + '\u2618' + obj.EventId();
    };
    CoordinationCardRelevance.dataKey = function (obj) {
        return obj.CoordinationCardId + '\u2618' + obj.EventId;
    };
    CoordinationCardRelevance.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationCardId !== undefined)
                obj.CoordinationCardId(data.CoordinationCardId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
        });
    };
    return CoordinationCardRelevance;
}());
exports.CoordinationCardRelevance = CoordinationCardRelevance;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCardSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardSelf = /** @class */ (function () {
    function CoordinationCardSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Comments = s_array_1.default([]);
        this.CommentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentsUrl !== undefined ? data.CommentsUrl : ''));
        this.Events = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Log = s_array_1.default([]);
        this.Versions = s_array_1.default([]);
    }
    CoordinationCardSelf.key = function (obj) {
        return obj.Id();
    };
    CoordinationCardSelf.dataKey = function (obj) {
        return obj.Id;
    };
    CoordinationCardSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CommentsUrl !== undefined)
                obj.CommentsUrl(data.CommentsUrl);
        });
    };
    return CoordinationCardSelf;
}());
exports.CoordinationCardSelf = CoordinationCardSelf;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardStatus = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCardStatus\ApiCoordinationCardStatus.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardStatus = /** @class */ (function () {
    function CoordinationCardStatus(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DefaultLabel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultLabel !== undefined ? data.DefaultLabel : ''));
        this.Definition = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Definition !== undefined ? data.Definition : ''));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }
    CoordinationCardStatus.key = function (obj) {
        return obj.Id();
    };
    CoordinationCardStatus.dataKey = function (obj) {
        return obj.Id;
    };
    CoordinationCardStatus.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DefaultLabel !== undefined)
                obj.DefaultLabel(data.DefaultLabel);
            if (data.Definition !== undefined)
                obj.Definition(data.Definition);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
        });
    };
    return CoordinationCardStatus;
}());
exports.CoordinationCardStatus = CoordinationCardStatus;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationCardStatusUpdateRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\CCardStatusUpdates\CoordinationCardStatusUpdateRequest.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationCardStatusUpdateRequest = /** @class */ (function () {
    function CoordinationCardStatusUpdateRequest(data) {
        if (data === void 0) { data = null; }
        this.StatusId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusId !== undefined ? data.StatusId : 0));
        this.StatusReason = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }
    CoordinationCardStatusUpdateRequest.key = function (obj) {
        return;
    };
    CoordinationCardStatusUpdateRequest.dataKey = function (obj) {
        return;
    };
    CoordinationCardStatusUpdateRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.StatusId !== undefined)
                obj.StatusId(data.StatusId);
            if (data.StatusReason !== undefined)
                obj.StatusReason(data.StatusReason);
        });
    };
    return CoordinationCardStatusUpdateRequest;
}());
exports.CoordinationCardStatusUpdateRequest = CoordinationCardStatusUpdateRequest;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationLocation = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationLocation\ApiCoordinationLocation.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationLocation = /** @class */ (function () {
    function CoordinationLocation(data) {
        if (data === void 0) { data = null; }
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.LocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LocationId !== undefined ? data.LocationId : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
        this.Coordination = s_js_1.default.value(null);
        this.Location = s_js_1.default.value(null);
    }
    CoordinationLocation.key = function (obj) {
        return obj.CoordinationId() + '\u2618' + obj.LocationId() + '\u2618' + obj.Type();
    };
    CoordinationLocation.dataKey = function (obj) {
        return obj.CoordinationId + '\u2618' + obj.LocationId + '\u2618' + obj.Type;
    };
    CoordinationLocation.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.LocationId !== undefined)
                obj.LocationId(data.LocationId);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return CoordinationLocation;
}());
exports.CoordinationLocation = CoordinationLocation;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinationMilestoneType = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationMilestoneType\ApiCoordinationMilestoneType.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CoordinationMilestoneType = /** @class */ (function () {
    function CoordinationMilestoneType(data) {
        if (data === void 0) { data = null; }
        this.CoordinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.MilestoneTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : 0));
        this.Coordination = s_js_1.default.value(null);
        this.MilestoneType = s_js_1.default.value(null);
    }
    CoordinationMilestoneType.key = function (obj) {
        return obj.CoordinationId() + '\u2618' + obj.MilestoneTypeId();
    };
    CoordinationMilestoneType.dataKey = function (obj) {
        return obj.CoordinationId + '\u2618' + obj.MilestoneTypeId;
    };
    CoordinationMilestoneType.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CoordinationId !== undefined)
                obj.CoordinationId(data.CoordinationId);
            if (data.MilestoneTypeId !== undefined)
                obj.MilestoneTypeId(data.MilestoneTypeId);
        });
    };
    return CoordinationMilestoneType;
}());
exports.CoordinationMilestoneType = CoordinationMilestoneType;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Country\ApiCountry.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Country = /** @class */ (function () {
    function Country(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Code !== undefined ? data.Code : ''));
        this.IsoAlpha3Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsoAlpha3Code !== undefined ? data.IsoAlpha3Code : ''));
        this.IsoNumericCode = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsoNumericCode !== undefined ? data.IsoNumericCode : ''));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.SortOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SortOrder !== undefined ? data.SortOrder : 0));
    }
    Country.key = function (obj) {
        return obj.Id();
    };
    Country.dataKey = function (obj) {
        return obj.Id;
    };
    Country.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.Code !== undefined)
                obj.Code(data.Code);
            if (data.IsoAlpha3Code !== undefined)
                obj.IsoAlpha3Code(data.IsoAlpha3Code);
            if (data.IsoNumericCode !== undefined)
                obj.IsoNumericCode(data.IsoNumericCode);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.SortOrder !== undefined)
                obj.SortOrder(data.SortOrder);
        });
    };
    return Country;
}());
exports.Country = Country;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CruiseActivity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CruiseActivity\ApiCruiseActivity.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var CruiseActivity = /** @class */ (function () {
    function CruiseActivity(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Reservation = s_js_1.default.value(null);
        this.ReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReservationId !== undefined ? data.ReservationId : 0));
        this.Crew = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Crew !== undefined ? data.Crew : null));
        this.Disembark = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Disembark !== undefined ? data.Disembark : null));
        this.Embark = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Embark !== undefined ? data.Embark : null));
        this.InTransit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InTransit !== undefined ? data.InTransit : null));
        this.VoyageNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }
    CruiseActivity.key = function (obj) {
        return obj.Id();
    };
    CruiseActivity.dataKey = function (obj) {
        return obj.Id;
    };
    CruiseActivity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ReservationId !== undefined)
                obj.ReservationId(data.ReservationId);
            if (data.Crew !== undefined)
                obj.Crew(data.Crew);
            if (data.Disembark !== undefined)
                obj.Disembark(data.Disembark);
            if (data.Embark !== undefined)
                obj.Embark(data.Embark);
            if (data.InTransit !== undefined)
                obj.InTransit(data.InTransit);
            if (data.VoyageNumber !== undefined)
                obj.VoyageNumber(data.VoyageNumber);
        });
    };
    return CruiseActivity;
}());
exports.CruiseActivity = CruiseActivity;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DataCacheUpdateEntities = exports.DataCacheUpdate = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DataCache\ApiDataCacheUpdate.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var DataCacheUpdate_1 = __webpack_require__(572);
var DataCacheUpdate = /** @class */ (function () {
    function DataCacheUpdate(data) {
        if (data === void 0) { data = null; }
        this.Deletes = data && data.Deletes !== undefined ? new DataCacheUpdate_1.DataCacheUpdateEntities(data.Deletes) : new DataCacheUpdate_1.DataCacheUpdateEntities();
        this.Timestamp = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Timestamp !== undefined ? new TZDate_1.default(data.Timestamp) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Updates = data && data.Updates !== undefined ? new DataCacheUpdate_1.DataCacheUpdateEntities(data.Updates) : new DataCacheUpdate_1.DataCacheUpdateEntities();
    }
    DataCacheUpdate.key = function (obj) {
        return;
    };
    DataCacheUpdate.dataKey = function (obj) {
        return;
    };
    DataCacheUpdate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Deletes !== undefined)
                DataCacheUpdate_1.DataCacheUpdateEntities.update(obj.Deletes, data.Deletes);
            if (data.Timestamp !== undefined)
                obj.Timestamp(new TZDate_1.default(data.Timestamp));
            if (data.Updates !== undefined)
                DataCacheUpdate_1.DataCacheUpdateEntities.update(obj.Updates, data.Updates);
        });
    };
    return DataCacheUpdate;
}());
exports.DataCacheUpdate = DataCacheUpdate;
var DataCacheUpdateEntities = /** @class */ (function () {
    function DataCacheUpdateEntities(data) {
        if (data === void 0) { data = null; }
        this.BerthCapabilities = s_array_1.default([]);
        this.BerthCapabilityAssignments = s_array_1.default([]);
        this.BerthClosures = s_array_1.default([]);
        this.BerthReservations = s_array_1.default([]);
        this.BerthReservationVersions = s_array_1.default([]);
        this.Berths = s_array_1.default([]);
        this.CargoActivities = s_array_1.default([]);
        this.Comments = s_array_1.default([]);
        this.CoordinationCardRelevances = s_array_1.default([]);
        this.CoordinationCards = s_array_1.default([]);
        this.CoordinationCardSelves = s_array_1.default([]);
        this.CoordinationCardVersions = s_array_1.default([]);
        this.Countries = s_array_1.default([]);
        this.CruiseActivities = s_array_1.default([]);
        this.Events = s_array_1.default([]);
        this.Issues = s_array_1.default([]);
        this.ItineraryPoints = s_array_1.default([]);
        this.ItineraryPointVersions = s_array_1.default([]);
        this.Locations = s_array_1.default([]);
        this.LogEvents = s_array_1.default([]);
        this.Organizations = s_array_1.default([]);
        this.OverrideServiceVessels = s_array_1.default([]);
        this.PierGroups = s_array_1.default([]);
        this.PilotEntities = s_js_1.default.value(null);
        this.PortCallChanges = s_array_1.default([]);
        this.PortCalls = s_array_1.default([]);
        this.PortCallVersions = s_array_1.default([]);
        this.Ports = s_array_1.default([]);
        this.RecurringBatches = s_array_1.default([]);
        this.ScheduleDateEvents = s_array_1.default([]);
        this.ScheduleDates = s_array_1.default([]);
        this.Shares = s_array_1.default([]);
        this.TaggedCommentUsers = s_array_1.default([]);
        this.TopicCardAvailableAttachments = s_array_1.default([]);
        this.TopicCardChanges = s_array_1.default([]);
        this.TopicCardOptions = s_array_1.default([]);
        this.TopicCards = s_array_1.default([]);
        this.TopicCardSelectedOptions = s_array_1.default([]);
        this.Users = s_array_1.default([]);
        this.VesselChanges = s_array_1.default([]);
        this.Vessels = s_array_1.default([]);
        this.WartsilaEntities = s_js_1.default.value(null);
    }
    DataCacheUpdateEntities.key = function (obj) {
        return;
    };
    DataCacheUpdateEntities.dataKey = function (obj) {
        return;
    };
    DataCacheUpdateEntities.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return DataCacheUpdateEntities;
}());
exports.DataCacheUpdateEntities = DataCacheUpdateEntities;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\VesselResult\DataSetVersion.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var DataSetVersion = /** @class */ (function () {
    function DataSetVersion(data) {
        if (data === void 0) { data = null; }
        this.Value = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Value !== undefined ? data.Value : null));
    }
    DataSetVersion.key = function (obj) {
        return;
    };
    DataSetVersion.dataKey = function (obj) {
        return;
    };
    DataSetVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Value !== undefined)
                obj.Value(data.Value);
        });
    };
    return DataSetVersion;
}());
exports.DataSetVersion = DataSetVersion;


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeDisplaySettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\DateTimeDisplaySettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var DateTimeDisplaySettings = /** @class */ (function () {
    function DateTimeDisplaySettings(data) {
        if (data === void 0) { data = null; }
        this.DateOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DateOrder !== undefined ? data.DateOrder : 0));
        this.DateSeparator = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DateSeparator !== undefined ? data.DateSeparator : ''));
        this.TimeSeparator = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TimeSeparator !== undefined ? data.TimeSeparator : ''));
    }
    DateTimeDisplaySettings.key = function (obj) {
        return;
    };
    DateTimeDisplaySettings.dataKey = function (obj) {
        return;
    };
    DateTimeDisplaySettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.DateOrder !== undefined)
                obj.DateOrder(data.DateOrder);
            if (data.DateSeparator !== undefined)
                obj.DateSeparator(data.DateSeparator);
            if (data.TimeSeparator !== undefined)
                obj.TimeSeparator(data.TimeSeparator);
        });
    };
    return DateTimeDisplaySettings;
}());
exports.DateTimeDisplaySettings = DateTimeDisplaySettings;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclarationOfSecurity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Vessels\Vessel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var DeclarationOfSecurity = /** @class */ (function () {
    function DeclarationOfSecurity(data) {
        if (data === void 0) { data = null; }
        this.EffectiveDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EffectiveDate !== undefined ? data.EffectiveDate === null ? null : new TZDate_1.default(data.EffectiveDate) : null, TZDate_1.default.nullableEq));
        this.ExpirationDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpirationDate !== undefined ? data.ExpirationDate === null ? null : new TZDate_1.default(data.ExpirationDate) : null, TZDate_1.default.nullableEq));
        this.IssuedBy = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IssuedBy !== undefined ? data.IssuedBy : null));
        this.ReceivedBy = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReceivedBy !== undefined ? data.ReceivedBy : null));
    }
    DeclarationOfSecurity.key = function (obj) {
        return;
    };
    DeclarationOfSecurity.dataKey = function (obj) {
        return;
    };
    DeclarationOfSecurity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.EffectiveDate !== undefined)
                obj.EffectiveDate(data.EffectiveDate === null ? null : new TZDate_1.default(data.EffectiveDate));
            if (data.ExpirationDate !== undefined)
                obj.ExpirationDate(data.ExpirationDate === null ? null : new TZDate_1.default(data.ExpirationDate));
            if (data.IssuedBy !== undefined)
                obj.IssuedBy(data.IssuedBy);
            if (data.ReceivedBy !== undefined)
                obj.ReceivedBy(data.ReceivedBy);
        });
    };
    return DeclarationOfSecurity;
}());
exports.DeclarationOfSecurity = DeclarationOfSecurity;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultImage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DefaultImage\ApiDefaultImage.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var DefaultImage = /** @class */ (function () {
    function DefaultImage(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ProfileUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProfileUrl !== undefined ? data.ProfileUrl : null));
        this.ThumbUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ThumbUrl !== undefined ? data.ThumbUrl : null));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    DefaultImage.key = function (obj) {
        return obj.Id();
    };
    DefaultImage.dataKey = function (obj) {
        return obj.Id;
    };
    DefaultImage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ProfileUrl !== undefined)
                obj.ProfileUrl(data.ProfileUrl);
            if (data.ThumbUrl !== undefined)
                obj.ThumbUrl(data.ThumbUrl);
            if (data.Order !== undefined)
                obj.Order(data.Order);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return DefaultImage;
}());
exports.DefaultImage = DefaultImage;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchEvent = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\DispatchEvent\ApiDispatchEvent.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var DispatchEvent = /** @class */ (function () {
    function DispatchEvent(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this._approvalsOfCharges = s_array_1.default([]);
        this.Bills = s_array_1.default([]);
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Billable = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Billable !== undefined ? data.Billable : false));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : ''));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
        this.Start = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Start !== undefined ? new TZDate_1.default(data.Start) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    DispatchEvent.key = function (obj) {
        return obj.Id();
    };
    DispatchEvent.dataKey = function (obj) {
        return obj.Id;
    };
    DispatchEvent.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Billable !== undefined)
                obj.Billable(data.Billable);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Start !== undefined)
                obj.Start(new TZDate_1.default(data.Start));
        });
    };
    return DispatchEvent;
}());
exports.DispatchEvent = DispatchEvent;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchEventDetailsBilling = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchEventDetailsBillingViewModel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var DispatchEventDetailsBilling = /** @class */ (function () {
    function DispatchEventDetailsBilling(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DispatchEvent = s_js_1.default.value(null);
        this.LastExportDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate) : null, TZDate_1.default.nullableEq));
    }
    DispatchEventDetailsBilling.key = function (obj) {
        return obj.Id();
    };
    DispatchEventDetailsBilling.dataKey = function (obj) {
        return obj.Id;
    };
    DispatchEventDetailsBilling.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.LastExportDate !== undefined)
                obj.LastExportDate(data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate));
        });
    };
    return DispatchEventDetailsBilling;
}());
exports.DispatchEventDetailsBilling = DispatchEventDetailsBilling;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Domain\ApiDomain.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Domain = /** @class */ (function () {
    function Domain(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AutomationSystems = s_array_1.default([]);
        this.BerthCapabilities = s_array_1.default([]);
        this.BerthCapabilitiesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthCapabilitiesUrl !== undefined ? data.BerthCapabilitiesUrl : null));
        this.Coordinations = s_array_1.default([]);
        this.CoordinationsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationsUrl !== undefined ? data.CoordinationsUrl : null));
        this.DisplayableUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayableUrl !== undefined ? data.DisplayableUrl : ''));
        this.FrontEndRootUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FrontEndRootUrl !== undefined ? data.FrontEndRootUrl : ''));
        this.GeoActivities = s_array_1.default([]);
        this.Organizations = s_array_1.default([]);
        this.Ports = s_array_1.default([]);
        this.Settings = s_js_1.default.value(null);
        this.Stream = s_array_1.default([]);
        this.HomePageSubtitle = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HomePageSubtitle !== undefined ? data.HomePageSubtitle : null));
        this.HomePageTitle = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HomePageTitle !== undefined ? data.HomePageTitle : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.SystemEmailAddress = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SystemEmailAddress !== undefined ? data.SystemEmailAddress : ''));
        this.TimeZone = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TimeZone !== undefined ? data.TimeZone : ''));
    }
    Domain.key = function (obj) {
        return obj.Id();
    };
    Domain.dataKey = function (obj) {
        return obj.Id;
    };
    Domain.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthCapabilitiesUrl !== undefined)
                obj.BerthCapabilitiesUrl(data.BerthCapabilitiesUrl);
            if (data.CoordinationsUrl !== undefined)
                obj.CoordinationsUrl(data.CoordinationsUrl);
            if (data.DisplayableUrl !== undefined)
                obj.DisplayableUrl(data.DisplayableUrl);
            if (data.FrontEndRootUrl !== undefined)
                obj.FrontEndRootUrl(data.FrontEndRootUrl);
            if (data.HomePageSubtitle !== undefined)
                obj.HomePageSubtitle(data.HomePageSubtitle);
            if (data.HomePageTitle !== undefined)
                obj.HomePageTitle(data.HomePageTitle);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.SystemEmailAddress !== undefined)
                obj.SystemEmailAddress(data.SystemEmailAddress);
            if (data.TimeZone !== undefined)
                obj.TimeZone(data.TimeZone);
        });
    };
    return Domain;
}());
exports.Domain = Domain;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainRelevance = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DomainRelevance\ApiDomainRelevance.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var DomainRelevance = /** @class */ (function () {
    function DomainRelevance(data) {
        if (data === void 0) { data = null; }
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.Domain = s_js_1.default.value(null);
        this.Event = s_js_1.default.value(null);
    }
    DomainRelevance.key = function (obj) {
        return obj.DomainId() + '\u2618' + obj.EventId();
    };
    DomainRelevance.dataKey = function (obj) {
        return obj.DomainId + '\u2618' + obj.EventId;
    };
    DomainRelevance.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
        });
    };
    return DomainRelevance;
}());
exports.DomainRelevance = DomainRelevance;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadImageSettings = exports.UploadFileSettings = exports.UploadSettings = exports.DomainSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DomainSettings\ApiDomainSettings.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var AgentRestrictionSettings_1 = __webpack_require__(1221);
var DateTimeDisplaySettings_1 = __webpack_require__(1251);
var DomainSettings_1 = __webpack_require__(574);
var HomepageSettings_1 = __webpack_require__(575);
var MapSettings_1 = __webpack_require__(1285);
var MarinerCloudSettings_1 = __webpack_require__(1289);
var PierSettings_1 = __webpack_require__(1308);
var PushNotificationSettings_1 = __webpack_require__(1331);
var VesselServiceSettings_1 = __webpack_require__(1376);
var DomainSettings = /** @class */ (function () {
    function DomainSettings(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DefaultUITheme = s_js_1.default.value(null);
        this.DefaultUIThemeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultUIThemeId !== undefined ? data.DefaultUIThemeId : 0));
        this.AgentRestrictions = data && data.AgentRestrictions !== undefined ? new AgentRestrictionSettings_1.AgentRestrictionSettings(data.AgentRestrictions) : new AgentRestrictionSettings_1.AgentRestrictionSettings();
        this.DateTimeDisplay = data && data.DateTimeDisplay !== undefined ? new DateTimeDisplaySettings_1.DateTimeDisplaySettings(data.DateTimeDisplay) : new DateTimeDisplaySettings_1.DateTimeDisplaySettings();
        this.HasPilots = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HasPilots !== undefined ? data.HasPilots : false));
        this.Homepage = data && data.Homepage !== undefined ? new HomepageSettings_1.HomepageSettings(data.Homepage) : new HomepageSettings_1.HomepageSettings();
        this.Map = data && data.Map !== undefined ? new MapSettings_1.MapSettings(data.Map) : new MapSettings_1.MapSettings();
        this.MarinerCloudSettings = data && data.MarinerCloudSettings !== undefined ? new MarinerCloudSettings_1.MarinerCloudSettings(data.MarinerCloudSettings) : new MarinerCloudSettings_1.MarinerCloudSettings();
        this.Pier = data && data.Pier !== undefined ? new PierSettings_1.PierSettings(data.Pier) : new PierSettings_1.PierSettings();
        this.PushNotifications = data && data.PushNotifications !== undefined ? new PushNotificationSettings_1.PushNotificationSettings(data.PushNotifications) : new PushNotificationSettings_1.PushNotificationSettings();
        this.Uploads = data && data.Uploads !== undefined ? new DomainSettings_1.UploadSettings(data.Uploads) : new DomainSettings_1.UploadSettings();
        this.VesselServiceSettings = data && data.VesselServiceSettings !== undefined ? new VesselServiceSettings_1.VesselServiceSettings(data.VesselServiceSettings) : new VesselServiceSettings_1.VesselServiceSettings();
    }
    DomainSettings.key = function (obj) {
        return obj.Id();
    };
    DomainSettings.dataKey = function (obj) {
        return obj.Id;
    };
    DomainSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DefaultUIThemeId !== undefined)
                obj.DefaultUIThemeId(data.DefaultUIThemeId);
            if (data.AgentRestrictions !== undefined)
                AgentRestrictionSettings_1.AgentRestrictionSettings.update(obj.AgentRestrictions, data.AgentRestrictions);
            if (data.DateTimeDisplay !== undefined)
                DateTimeDisplaySettings_1.DateTimeDisplaySettings.update(obj.DateTimeDisplay, data.DateTimeDisplay);
            if (data.HasPilots !== undefined)
                obj.HasPilots(data.HasPilots);
            if (data.Homepage !== undefined)
                HomepageSettings_1.HomepageSettings.update(obj.Homepage, data.Homepage);
            if (data.Map !== undefined)
                MapSettings_1.MapSettings.update(obj.Map, data.Map);
            if (data.MarinerCloudSettings !== undefined)
                MarinerCloudSettings_1.MarinerCloudSettings.update(obj.MarinerCloudSettings, data.MarinerCloudSettings);
            if (data.Pier !== undefined)
                PierSettings_1.PierSettings.update(obj.Pier, data.Pier);
            if (data.PushNotifications !== undefined)
                PushNotificationSettings_1.PushNotificationSettings.update(obj.PushNotifications, data.PushNotifications);
            if (data.Uploads !== undefined)
                DomainSettings_1.UploadSettings.update(obj.Uploads, data.Uploads);
            if (data.VesselServiceSettings !== undefined)
                VesselServiceSettings_1.VesselServiceSettings.update(obj.VesselServiceSettings, data.VesselServiceSettings);
        });
    };
    return DomainSettings;
}());
exports.DomainSettings = DomainSettings;
var UploadSettings = /** @class */ (function () {
    function UploadSettings(data) {
        if (data === void 0) { data = null; }
        this.File = data && data.File !== undefined ? new DomainSettings_1.UploadFileSettings(data.File) : new DomainSettings_1.UploadFileSettings();
        this.Image = data && data.Image !== undefined ? new DomainSettings_1.UploadImageSettings(data.Image) : new DomainSettings_1.UploadImageSettings();
    }
    UploadSettings.key = function (obj) {
        return;
    };
    UploadSettings.dataKey = function (obj) {
        return;
    };
    UploadSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.File !== undefined)
                DomainSettings_1.UploadFileSettings.update(obj.File, data.File);
            if (data.Image !== undefined)
                DomainSettings_1.UploadImageSettings.update(obj.Image, data.Image);
        });
    };
    return UploadSettings;
}());
exports.UploadSettings = UploadSettings;
var UploadFileSettings = /** @class */ (function () {
    function UploadFileSettings(data) {
        if (data === void 0) { data = null; }
        this.AllowedExtensions = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AllowedExtensions !== undefined ? data.AllowedExtensions : []));
        this.MaximumFileSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MaximumFileSize !== undefined ? data.MaximumFileSize : 0));
    }
    UploadFileSettings.key = function (obj) {
        return;
    };
    UploadFileSettings.dataKey = function (obj) {
        return;
    };
    UploadFileSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.AllowedExtensions !== undefined)
                obj.AllowedExtensions(data.AllowedExtensions);
            if (data.MaximumFileSize !== undefined)
                obj.MaximumFileSize(data.MaximumFileSize);
        });
    };
    return UploadFileSettings;
}());
exports.UploadFileSettings = UploadFileSettings;
var UploadImageSettings = /** @class */ (function () {
    function UploadImageSettings(data) {
        if (data === void 0) { data = null; }
        this.AllowedExtensions = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AllowedExtensions !== undefined ? data.AllowedExtensions : []));
        this.MaximumFileSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MaximumFileSize !== undefined ? data.MaximumFileSize : 0));
        this.MinimumImageSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MinimumImageSize !== undefined ? data.MinimumImageSize : 0));
        this.ProfileSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProfileSize !== undefined ? data.ProfileSize : 0));
        this.ThumbSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ThumbSize !== undefined ? data.ThumbSize : 0));
    }
    UploadImageSettings.key = function (obj) {
        return;
    };
    UploadImageSettings.dataKey = function (obj) {
        return;
    };
    UploadImageSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.AllowedExtensions !== undefined)
                obj.AllowedExtensions(data.AllowedExtensions);
            if (data.MaximumFileSize !== undefined)
                obj.MaximumFileSize(data.MaximumFileSize);
            if (data.MinimumImageSize !== undefined)
                obj.MinimumImageSize(data.MinimumImageSize);
            if (data.ProfileSize !== undefined)
                obj.ProfileSize(data.ProfileSize);
            if (data.ThumbSize !== undefined)
                obj.ThumbSize(data.ThumbSize);
        });
    };
    return UploadImageSettings;
}());
exports.UploadImageSettings = UploadImageSettings;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSummary = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\DomainSummary\DomainSummary.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var DomainSummary = /** @class */ (function () {
    function DomainSummary(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DisplayableUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayableUrl !== undefined ? data.DisplayableUrl : ''));
        this.Settings = s_js_1.default.value(null);
        this.HomePageSubtitle = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HomePageSubtitle !== undefined ? data.HomePageSubtitle : null));
        this.HomePageTitle = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HomePageTitle !== undefined ? data.HomePageTitle : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.PilotAgencyIds = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.PilotAgencyIds !== undefined ? data.PilotAgencyIds : []));
        this.Server = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Server !== undefined ? data.Server : ''));
        this.SupportEmail = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SupportEmail !== undefined ? data.SupportEmail : null));
        this.TimeZone = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TimeZone !== undefined ? data.TimeZone : ''));
    }
    DomainSummary.key = function (obj) {
        return obj.Id();
    };
    DomainSummary.dataKey = function (obj) {
        return obj.Id;
    };
    DomainSummary.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DisplayableUrl !== undefined)
                obj.DisplayableUrl(data.DisplayableUrl);
            if (data.HomePageSubtitle !== undefined)
                obj.HomePageSubtitle(data.HomePageSubtitle);
            if (data.HomePageTitle !== undefined)
                obj.HomePageTitle(data.HomePageTitle);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.PilotAgencyIds !== undefined)
                obj.PilotAgencyIds(data.PilotAgencyIds);
            if (data.Server !== undefined)
                obj.Server(data.Server);
            if (data.SupportEmail !== undefined)
                obj.SupportEmail(data.SupportEmail);
            if (data.TimeZone !== undefined)
                obj.TimeZone(data.TimeZone);
        });
    };
    return DomainSummary;
}());
exports.DomainSummary = DomainSummary;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftCharge = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\DraftCharge.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Price_1 = __webpack_require__(162);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var DraftCharge = /** @class */ (function () {
    function DraftCharge(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Approval = s_js_1.default.value(null);
        this.ApprovalId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalId !== undefined ? data.ApprovalId : 0));
        this.ChargeCollection = s_js_1.default.value(null);
        this.ChargeCollectionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChargeCollectionId !== undefined ? data.ChargeCollectionId : 0));
        this.StandardItem = s_js_1.default.value(null);
        this.StandardItemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardItemId !== undefined ? data.StandardItemId : null));
        this.StandardRate = s_js_1.default.value(null);
        this.StandardRateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardRateId !== undefined ? data.StandardRateId : null));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTrackingOverrides = data && data.QBTrackingOverrides !== undefined ? new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking(data.QBTrackingOverrides) : new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement_1.Measurement(data.Quantity) : new Measurement_1.Measurement();
        this.Unit = data && data.Unit !== undefined ? new Measurement_1.Measurement(data.Unit) : new Measurement_1.Measurement();
        this.UnitPrice = data && data.UnitPrice !== undefined ? new Price_1.Price(data.UnitPrice) : new Price_1.Price();
    }
    DraftCharge.key = function (obj) {
        return obj.Id();
    };
    DraftCharge.dataKey = function (obj) {
        return obj.Id;
    };
    DraftCharge.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ApprovalId !== undefined)
                obj.ApprovalId(data.ApprovalId);
            if (data.ChargeCollectionId !== undefined)
                obj.ChargeCollectionId(data.ChargeCollectionId);
            if (data.StandardItemId !== undefined)
                obj.StandardItemId(data.StandardItemId);
            if (data.StandardRateId !== undefined)
                obj.StandardRateId(data.StandardRateId);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.QBTrackingOverrides !== undefined)
                QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking.update(obj.QBTrackingOverrides, data.QBTrackingOverrides);
            if (data.Quantity !== undefined)
                Measurement_1.Measurement.update(obj.Quantity, data.Quantity);
            if (data.Unit !== undefined)
                Measurement_1.Measurement.update(obj.Unit, data.Unit);
            if (data.UnitPrice !== undefined)
                Price_1.Price.update(obj.UnitPrice, data.UnitPrice);
        });
    };
    return DraftCharge;
}());
exports.DraftCharge = DraftCharge;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftChargeCollection = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\DraftChargeCollection.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var DraftChargeCollection = /** @class */ (function () {
    function DraftChargeCollection(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Charges = s_array_1.default([]);
    }
    DraftChargeCollection.key = function (obj) {
        return obj.Id();
    };
    DraftChargeCollection.dataKey = function (obj) {
        return obj.Id;
    };
    DraftChargeCollection.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return DraftChargeCollection;
}());
exports.DraftChargeCollection = DraftChargeCollection;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedEstimate = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\EnhancedEstimate\ApiEnhancedEstimate.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var EnhancedEstimate = /** @class */ (function () {
    function EnhancedEstimate(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.EstimatedRoute = s_array_1.default([]);
        this.Query = s_js_1.default.value(null);
        this.EstimatedArrival = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EstimatedArrival !== undefined ? data.EstimatedArrival === null ? null : new TZDate_1.default(data.EstimatedArrival) : null, TZDate_1.default.nullableEq));
        this.EstimatedDistanceRemaining = data && data.EstimatedDistanceRemaining !== undefined ? new Measurement_1.NullableMeasurement(data.EstimatedDistanceRemaining) : new Measurement_1.NullableMeasurement();
        this.TimeOfKnownVesselLocation = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TimeOfKnownVesselLocation !== undefined ? data.TimeOfKnownVesselLocation === null ? null : new TZDate_1.default(data.TimeOfKnownVesselLocation) : null, TZDate_1.default.nullableEq));
    }
    EnhancedEstimate.key = function (obj) {
        return obj.Id();
    };
    EnhancedEstimate.dataKey = function (obj) {
        return obj.Id;
    };
    EnhancedEstimate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.EstimatedArrival !== undefined)
                obj.EstimatedArrival(data.EstimatedArrival === null ? null : new TZDate_1.default(data.EstimatedArrival));
            if (data.EstimatedDistanceRemaining !== undefined)
                Measurement_1.NullableMeasurement.update(obj.EstimatedDistanceRemaining, data.EstimatedDistanceRemaining);
            if (data.TimeOfKnownVesselLocation !== undefined)
                obj.TimeOfKnownVesselLocation(data.TimeOfKnownVesselLocation === null ? null : new TZDate_1.default(data.TimeOfKnownVesselLocation));
        });
    };
    return EnhancedEstimate;
}());
exports.EnhancedEstimate = EnhancedEstimate;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedEstimateQuery = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\EnhancedEstimateQuery\ApiEnhancedEstimateQuery.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var EnhancedEstimateQuery = /** @class */ (function () {
    function EnhancedEstimateQuery(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Automation = s_js_1.default.value(null);
        this.AutomationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AutomationId !== undefined ? data.AutomationId : 0));
        this.Destination = s_js_1.default.value(null);
        this.DestinationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DestinationId !== undefined ? data.DestinationId : null));
        this.PortCallSelf = s_js_1.default.value(null);
        this.PortCallSelfId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallSelfId !== undefined ? data.PortCallSelfId : 0));
        this.Result = s_js_1.default.value(null);
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.CreationDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreationDate !== undefined ? new TZDate_1.default(data.CreationDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DestinationZoneCoordinates = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DestinationZoneCoordinates !== undefined ? data.DestinationZoneCoordinates : null));
        this.DestinationZoneType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DestinationZoneType !== undefined ? data.DestinationZoneType : null));
        this.FailureDetails = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FailureDetails !== undefined ? data.FailureDetails : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IMORaw = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMORaw !== undefined ? data.IMORaw : null));
        this.Status = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Status !== undefined ? data.Status : 0));
        this.UnactionableReason = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UnactionableReason !== undefined ? data.UnactionableReason : 0));
    }
    EnhancedEstimateQuery.key = function (obj) {
        return obj.Id();
    };
    EnhancedEstimateQuery.dataKey = function (obj) {
        return obj.Id;
    };
    EnhancedEstimateQuery.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AutomationId !== undefined)
                obj.AutomationId(data.AutomationId);
            if (data.DestinationId !== undefined)
                obj.DestinationId(data.DestinationId);
            if (data.PortCallSelfId !== undefined)
                obj.PortCallSelfId(data.PortCallSelfId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.CreationDate !== undefined)
                obj.CreationDate(new TZDate_1.default(data.CreationDate));
            if (data.DestinationZoneCoordinates !== undefined)
                obj.DestinationZoneCoordinates(data.DestinationZoneCoordinates);
            if (data.DestinationZoneType !== undefined)
                obj.DestinationZoneType(data.DestinationZoneType);
            if (data.FailureDetails !== undefined)
                obj.FailureDetails(data.FailureDetails);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IMORaw !== undefined)
                obj.IMORaw(data.IMORaw);
            if (data.Status !== undefined)
                obj.Status(data.Status);
            if (data.UnactionableReason !== undefined)
                obj.UnactionableReason(data.UnactionableReason);
        });
    };
    return EnhancedEstimateQuery;
}());
exports.EnhancedEstimateQuery = EnhancedEstimateQuery;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Event\ApiEvent.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Event = /** @class */ (function () {
    function Event(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.About = s_js_1.default.value(null);
        this.AboutId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AboutId !== undefined ? data.AboutId : 0));
        this.Automation = s_js_1.default.value(null);
        this.AutomationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AutomationId !== undefined ? data.AutomationId : null));
        this.BerthReservation = s_js_1.default.value(null);
        this.BerthReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthReservationId !== undefined ? data.BerthReservationId : null));
        this.BerthReservationReferenceVersion = s_js_1.default.value(null);
        this.BerthReservationVersion = s_js_1.default.value(null);
        this.Berths = s_array_1.default([]);
        this.Comment = s_js_1.default.value(null);
        this.Comments = s_array_1.default([]);
        this.CommentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.CoordinationCard = s_js_1.default.value(null);
        this.CoordinationCardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoordinationCardId !== undefined ? data.CoordinationCardId : null));
        this.CoordinationCardReferenceVersion = s_js_1.default.value(null);
        this.CoordinationCards = s_array_1.default([]);
        this.CoordinationCardVersion = s_js_1.default.value(null);
        this.Created = s_js_1.default.value(null);
        this.CreatedId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedId !== undefined ? data.CreatedId : 0));
        this.Domains = s_array_1.default([]);
        this.GeoActivity = s_js_1.default.value(null);
        this.ItineraryPoint = s_js_1.default.value(null);
        this.ItineraryPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : null));
        this.ItineraryPointReferenceVersion = s_js_1.default.value(null);
        this.ItineraryPointVersion = s_js_1.default.value(null);
        this.JobOrder = s_js_1.default.value(null);
        this.JobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobOrderId !== undefined ? data.JobOrderId : null));
        this.JobOrderReferenceVersion = s_js_1.default.value(null);
        this.JobOrderVersion = s_js_1.default.value(null);
        this.Notifications = s_array_1.default([]);
        this.PilotJobOrderCancellation = s_js_1.default.value(null);
        this.PilotJobOrderChange = s_js_1.default.value(null);
        this.PilotJobOrders = s_array_1.default([]);
        this.PilotShiphandlingNote = s_js_1.default.value(null);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallChange = s_js_1.default.value(null);
        this.PortCallDeletion = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.PortCallReferenceVersion = s_js_1.default.value(null);
        this.PortCalls = s_array_1.default([]);
        this.PortCallVersion = s_js_1.default.value(null);
        this.PortCDMRelevances = s_array_1.default([]);
        this.RecurringBatch = s_js_1.default.value(null);
        this.RecurringBatchChange = s_js_1.default.value(null);
        this.RecurringBatchDeletion = s_js_1.default.value(null);
        this.RecurringBatchId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchId !== undefined ? data.RecurringBatchId : null));
        this.RecurringBatchReferenceVersion = s_js_1.default.value(null);
        this.RecurringBatchVersion = s_js_1.default.value(null);
        this.Reference = s_js_1.default.value(null);
        this.ReferenceId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReferenceId !== undefined ? data.ReferenceId : null));
        this.TopicCardChange = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : null));
        this.VesselChange = s_js_1.default.value(null);
        this.Data = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Data !== undefined ? data.Data : null));
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    Event.key = function (obj) {
        return obj.Id();
    };
    Event.dataKey = function (obj) {
        return obj.Id;
    };
    Event.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AboutId !== undefined)
                obj.AboutId(data.AboutId);
            if (data.AutomationId !== undefined)
                obj.AutomationId(data.AutomationId);
            if (data.BerthReservationId !== undefined)
                obj.BerthReservationId(data.BerthReservationId);
            if (data.CommentsUrl !== undefined)
                obj.CommentsUrl(data.CommentsUrl);
            if (data.CoordinationCardId !== undefined)
                obj.CoordinationCardId(data.CoordinationCardId);
            if (data.CreatedId !== undefined)
                obj.CreatedId(data.CreatedId);
            if (data.ItineraryPointId !== undefined)
                obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined)
                obj.JobOrderId(data.JobOrderId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.RecurringBatchId !== undefined)
                obj.RecurringBatchId(data.RecurringBatchId);
            if (data.ReferenceId !== undefined)
                obj.ReferenceId(data.ReferenceId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.Data !== undefined)
                obj.Data(data.Data);
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return Event;
}());
exports.Event = Event;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportDelivery = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ExportDelivery\ApiExportDelivery.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ExportDelivery = /** @class */ (function () {
    function ExportDelivery(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ExportPayload = s_js_1.default.value(null);
        this.ExportPayloadId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExportPayloadId !== undefined ? data.ExportPayloadId : 0));
        this.ErrorMessage = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ErrorMessage !== undefined ? data.ErrorMessage : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InitiatedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InitiatedDate !== undefined ? new TZDate_1.default(data.InitiatedDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Status = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Status !== undefined ? data.Status : 0));
    }
    ExportDelivery.key = function (obj) {
        return obj.Id();
    };
    ExportDelivery.dataKey = function (obj) {
        return obj.Id;
    };
    ExportDelivery.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ExportPayloadId !== undefined)
                obj.ExportPayloadId(data.ExportPayloadId);
            if (data.ErrorMessage !== undefined)
                obj.ErrorMessage(data.ErrorMessage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.InitiatedDate !== undefined)
                obj.InitiatedDate(new TZDate_1.default(data.InitiatedDate));
            if (data.Status !== undefined)
                obj.Status(data.Status);
        });
    };
    return ExportDelivery;
}());
exports.ExportDelivery = ExportDelivery;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportPayload = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ExportPayload\ApiExportPayload.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ExportPayload = /** @class */ (function () {
    function ExportPayload(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.BillingSystemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Bills = s_array_1.default([]);
        this.Deliveries = s_array_1.default([]);
        this.CreatedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedDate !== undefined ? new TZDate_1.default(data.CreatedDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ErrorMessage = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ErrorMessage !== undefined ? data.ErrorMessage : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RawExport = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawExport !== undefined ? data.RawExport : null));
        this.Status = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Status !== undefined ? data.Status : 0));
        this.TargetType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TargetType !== undefined ? data.TargetType : 0));
    }
    ExportPayload.key = function (obj) {
        return obj.Id();
    };
    ExportPayload.dataKey = function (obj) {
        return obj.Id;
    };
    ExportPayload.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillingSystemId !== undefined)
                obj.BillingSystemId(data.BillingSystemId);
            if (data.CreatedDate !== undefined)
                obj.CreatedDate(new TZDate_1.default(data.CreatedDate));
            if (data.ErrorMessage !== undefined)
                obj.ErrorMessage(data.ErrorMessage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.RawExport !== undefined)
                obj.RawExport(data.RawExport);
            if (data.Status !== undefined)
                obj.Status(data.Status);
            if (data.TargetType !== undefined)
                obj.TargetType(data.TargetType);
        });
    };
    return ExportPayload;
}());
exports.ExportPayload = ExportPayload;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoActivity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\GeoActivity\ApiGeoActivity.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var GeoActivity = /** @class */ (function () {
    function GeoActivity(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.LocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LocationId !== undefined ? data.LocationId : null));
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.PortLocation = s_js_1.default.value(null);
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.Message = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Message !== undefined ? data.Message : null));
        this.TriggerType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TriggerType !== undefined ? data.TriggerType : 0));
    }
    GeoActivity.key = function (obj) {
        return obj.Id();
    };
    GeoActivity.dataKey = function (obj) {
        return obj.Id;
    };
    GeoActivity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.LocationId !== undefined)
                obj.LocationId(data.LocationId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.Message !== undefined)
                obj.Message(data.Message);
            if (data.TriggerType !== undefined)
                obj.TriggerType(data.TriggerType);
        });
    };
    return GeoActivity;
}());
exports.GeoActivity = GeoActivity;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageCruiseVisit = exports.HomePageCruiseSchedule = exports.HomePageInPortVessel = exports.HomePagePortInPortVessels = exports.HomePageMovement = exports.HomePagePortMovements = exports.HomePageDateMovements = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Home\ViewModels.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var HomePageDateMovements = /** @class */ (function () {
    function HomePageDateMovements(data) {
        if (data === void 0) { data = null; }
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Ports = s_array_1.default([]);
    }
    HomePageDateMovements.key = function (obj) {
        return obj.Date().toJSON();
    };
    HomePageDateMovements.dataKey = function (obj) {
        return new TZDate_1.default(obj.Date).toJSON();
    };
    HomePageDateMovements.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
        });
    };
    return HomePageDateMovements;
}());
exports.HomePageDateMovements = HomePageDateMovements;
var HomePagePortMovements = /** @class */ (function () {
    function HomePagePortMovements(data) {
        if (data === void 0) { data = null; }
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.Movements = s_array_1.default([]);
        this.PortName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortName !== undefined ? data.PortName : null));
    }
    HomePagePortMovements.key = function (obj) {
        return obj.Date().toJSON() + '\u2618' + obj.PortId();
    };
    HomePagePortMovements.dataKey = function (obj) {
        return new TZDate_1.default(obj.Date).toJSON() + '\u2618' + obj.PortId;
    };
    HomePagePortMovements.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.PortName !== undefined)
                obj.PortName(data.PortName);
        });
    };
    return HomePagePortMovements;
}());
exports.HomePagePortMovements = HomePagePortMovements;
var HomePageMovement = /** @class */ (function () {
    function HomePageMovement(data) {
        if (data === void 0) { data = null; }
        this.FromPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.FromPoint = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.ToPoint = s_js_1.default.value(null);
        this.ToPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TrafficCoordinationCards = s_array_1.default([]);
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditActuals = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditActuals !== undefined ? data.CanEditActuals : false));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    HomePageMovement.key = function (obj) {
        return obj.FromPointId();
    };
    HomePageMovement.dataKey = function (obj) {
        return obj.FromPointId;
    };
    HomePageMovement.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromPointId !== undefined)
                obj.FromPointId(data.FromPointId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.ToPointId !== undefined)
                obj.ToPointId(data.ToPointId);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
            if (data.CanEditActuals !== undefined)
                obj.CanEditActuals(data.CanEditActuals);
            if (data.Type !== undefined)
                obj.Type(data.Type);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return HomePageMovement;
}());
exports.HomePageMovement = HomePageMovement;
var HomePagePortInPortVessels = /** @class */ (function () {
    function HomePagePortInPortVessels(data) {
        if (data === void 0) { data = null; }
        this.InPortVessels = s_array_1.default([]);
        this.PortName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortName !== undefined ? data.PortName : null));
    }
    HomePagePortInPortVessels.key = function (obj) {
        return;
    };
    HomePagePortInPortVessels.dataKey = function (obj) {
        return;
    };
    HomePagePortInPortVessels.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortName !== undefined)
                obj.PortName(data.PortName);
        });
    };
    return HomePagePortInPortVessels;
}());
exports.HomePagePortInPortVessels = HomePagePortInPortVessels;
var HomePageInPortVessel = /** @class */ (function () {
    function HomePageInPortVessel(data) {
        if (data === void 0) { data = null; }
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.BerthName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthName !== undefined ? data.BerthName : null));
        this.DepartureDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DepartureDate !== undefined ? new TZDate_1.default(data.DepartureDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    HomePageInPortVessel.key = function (obj) {
        return;
    };
    HomePageInPortVessel.dataKey = function (obj) {
        return;
    };
    HomePageInPortVessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.BerthName !== undefined)
                obj.BerthName(data.BerthName);
            if (data.DepartureDate !== undefined)
                obj.DepartureDate(new TZDate_1.default(data.DepartureDate));
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return HomePageInPortVessel;
}());
exports.HomePageInPortVessel = HomePageInPortVessel;
var HomePageCruiseSchedule = /** @class */ (function () {
    function HomePageCruiseSchedule(data) {
        if (data === void 0) { data = null; }
        this.CruiseVisits = s_array_1.default([]);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.PortName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortName !== undefined ? data.PortName : null));
    }
    HomePageCruiseSchedule.key = function (obj) {
        return;
    };
    HomePageCruiseSchedule.dataKey = function (obj) {
        return;
    };
    HomePageCruiseSchedule.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.PortName !== undefined)
                obj.PortName(data.PortName);
        });
    };
    return HomePageCruiseSchedule;
}());
exports.HomePageCruiseSchedule = HomePageCruiseSchedule;
var HomePageCruiseVisit = /** @class */ (function () {
    function HomePageCruiseVisit(data) {
        if (data === void 0) { data = null; }
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.ReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReservationId !== undefined ? data.ReservationId : 0));
        this.Arrival = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Arrival !== undefined ? new TZDate_1.default(data.Arrival) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.BerthName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthName !== undefined ? data.BerthName : null));
        this.Deparature = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deparature !== undefined ? new TZDate_1.default(data.Deparature) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.LastPortOfCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    HomePageCruiseVisit.key = function (obj) {
        return;
    };
    HomePageCruiseVisit.dataKey = function (obj) {
        return;
    };
    HomePageCruiseVisit.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.ReservationId !== undefined)
                obj.ReservationId(data.ReservationId);
            if (data.Arrival !== undefined)
                obj.Arrival(new TZDate_1.default(data.Arrival));
            if (data.BerthName !== undefined)
                obj.BerthName(data.BerthName);
            if (data.Deparature !== undefined)
                obj.Deparature(new TZDate_1.default(data.Deparature));
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.LastPortOfCall !== undefined)
                obj.LastPortOfCall(data.LastPortOfCall);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return HomePageCruiseVisit;
}());
exports.HomePageCruiseVisit = HomePageCruiseVisit;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageBannerSettings = exports.HomepageSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\HomepageSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var HomepageSettings_1 = __webpack_require__(575);
var HomepageSettings = /** @class */ (function () {
    function HomepageSettings(data) {
        if (data === void 0) { data = null; }
        this.Banner = data && data.Banner !== undefined ? new HomepageSettings_1.HomepageBannerSettings(data.Banner) : new HomepageSettings_1.HomepageBannerSettings();
        this.CruiseVisibility = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CruiseVisibility !== undefined ? data.CruiseVisibility : 0));
        this.InPortVisibility = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InPortVisibility !== undefined ? data.InPortVisibility : 0));
        this.MapVisibility = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MapVisibility !== undefined ? data.MapVisibility : 0));
        this.MovementsVisibility = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MovementsVisibility !== undefined ? data.MovementsVisibility : 0));
    }
    HomepageSettings.key = function (obj) {
        return;
    };
    HomepageSettings.dataKey = function (obj) {
        return;
    };
    HomepageSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Banner !== undefined)
                HomepageSettings_1.HomepageBannerSettings.update(obj.Banner, data.Banner);
            if (data.CruiseVisibility !== undefined)
                obj.CruiseVisibility(data.CruiseVisibility);
            if (data.InPortVisibility !== undefined)
                obj.InPortVisibility(data.InPortVisibility);
            if (data.MapVisibility !== undefined)
                obj.MapVisibility(data.MapVisibility);
            if (data.MovementsVisibility !== undefined)
                obj.MovementsVisibility(data.MovementsVisibility);
        });
    };
    return HomepageSettings;
}());
exports.HomepageSettings = HomepageSettings;
var HomepageBannerSettings = /** @class */ (function () {
    function HomepageBannerSettings(data) {
        if (data === void 0) { data = null; }
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.TextColor = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TextColor !== undefined ? data.TextColor : null));
        this.TextShadowColor = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TextShadowColor !== undefined ? data.TextShadowColor : null));
    }
    HomepageBannerSettings.key = function (obj) {
        return;
    };
    HomepageBannerSettings.dataKey = function (obj) {
        return;
    };
    HomepageBannerSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.TextColor !== undefined)
                obj.TextColor(data.TextColor);
            if (data.TextShadowColor !== undefined)
                obj.TextShadowColor(data.TextShadowColor);
        });
    };
    return HomepageBannerSettings;
}());
exports.HomepageBannerSettings = HomepageBannerSettings;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Image.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Image = /** @class */ (function () {
    function Image(data) {
        if (data === void 0) { data = null; }
        this.ProfileUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ProfileUrl !== undefined ? data.ProfileUrl : ''));
        this.RawUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawUrl !== undefined ? data.RawUrl : null));
        this.ThumbUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ThumbUrl !== undefined ? data.ThumbUrl : ''));
        this.UploadProfileUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UploadProfileUrl !== undefined ? data.UploadProfileUrl : null));
        this.UploadThumbUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UploadThumbUrl !== undefined ? data.UploadThumbUrl : null));
        this.CropX1 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropX1 !== undefined ? data.CropX1 : 0));
        this.CropX2 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropX2 !== undefined ? data.CropX2 : 0));
        this.CropY1 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropY1 !== undefined ? data.CropY1 : 0));
        this.CropY2 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropY2 !== undefined ? data.CropY2 : 0));
        this.RawHeight = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawHeight !== undefined ? data.RawHeight : 0));
        this.RawWidth = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawWidth !== undefined ? data.RawWidth : 0));
    }
    Image.key = function (obj) {
        return;
    };
    Image.dataKey = function (obj) {
        return;
    };
    Image.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ProfileUrl !== undefined)
                obj.ProfileUrl(data.ProfileUrl);
            if (data.RawUrl !== undefined)
                obj.RawUrl(data.RawUrl);
            if (data.ThumbUrl !== undefined)
                obj.ThumbUrl(data.ThumbUrl);
            if (data.UploadProfileUrl !== undefined)
                obj.UploadProfileUrl(data.UploadProfileUrl);
            if (data.UploadThumbUrl !== undefined)
                obj.UploadThumbUrl(data.UploadThumbUrl);
            if (data.CropX1 !== undefined)
                obj.CropX1(data.CropX1);
            if (data.CropX2 !== undefined)
                obj.CropX2(data.CropX2);
            if (data.CropY1 !== undefined)
                obj.CropY1(data.CropY1);
            if (data.CropY2 !== undefined)
                obj.CropY2(data.CropY2);
            if (data.RawHeight !== undefined)
                obj.RawHeight(data.RawHeight);
            if (data.RawWidth !== undefined)
                obj.RawWidth(data.RawWidth);
        });
    };
    return Image;
}());
exports.Image = Image;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialData = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Data\InitialDataController.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var InitialData = /** @class */ (function () {
    function InitialData(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AutomationSystems = s_array_1.default([]);
        this.CoordinationCardStatuses = s_array_1.default([]);
        this.Countries = s_array_1.default([]);
        this.Domain = s_js_1.default.value(null);
        this.DomainSummary = s_js_1.default.value(null);
        this.MilestoneTypes = s_array_1.default([]);
        this.Pilots = s_js_1.default.value(null);
        this.Roles = s_array_1.default([]);
        this.UIThemes = s_array_1.default([]);
        this.UserSummary = s_js_1.default.value(null);
    }
    InitialData.key = function (obj) {
        return obj.Id();
    };
    InitialData.dataKey = function (obj) {
        return obj.Id;
    };
    InitialData.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return InitialData;
}());
exports.InitialData = InitialData;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUsersResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\InviteUsers\InviteUsersViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var InviteUsersResponse = /** @class */ (function () {
    function InviteUsersResponse(data) {
        if (data === void 0) { data = null; }
        this.AssignableRoles = s_array_1.default([]);
        this.AvailableOrganizations = s_array_1.default([]);
        this.CanManageOrgs = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageOrgs !== undefined ? data.CanManageOrgs : false));
    }
    InviteUsersResponse.key = function (obj) {
        return;
    };
    InviteUsersResponse.dataKey = function (obj) {
        return;
    };
    InviteUsersResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CanManageOrgs !== undefined)
                obj.CanManageOrgs(data.CanManageOrgs);
        });
    };
    return InviteUsersResponse;
}());
exports.InviteUsersResponse = InviteUsersResponse;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Issue = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Issue\ApiIssue.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Issue = /** @class */ (function () {
    function Issue(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthClosure = s_js_1.default.value(null);
        this.BerthClosureId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthClosureId !== undefined ? data.BerthClosureId : 0));
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.BerthReservation = s_js_1.default.value(null);
        this.BerthReservationBerthClosure = s_js_1.default.value(null);
        this.BerthReservationBerthClosureId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthReservationBerthClosureId !== undefined ? data.BerthReservationBerthClosureId : 0));
        this.BerthReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthReservationId !== undefined ? data.BerthReservationId : 0));
        this.EnteredDate = s_js_1.default.value(null);
        this.EnteredDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EnteredDateId !== undefined ? data.EnteredDateId : 0));
        this.OtherClosure = s_js_1.default.value(null);
        this.OtherClosureId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OtherClosureId !== undefined ? data.OtherClosureId : 0));
        this.OtherReservation = s_js_1.default.value(null);
        this.OtherReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OtherReservationId !== undefined ? data.OtherReservationId : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.PilotJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.ScheduleDate = s_js_1.default.value(null);
        this.ScheduleDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.ConfirmDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConfirmDate !== undefined ? new TZDate_1.default(data.ConfirmDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DetectDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DetectDate !== undefined ? new TZDate_1.default(data.DetectDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DiscrepantDateField = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DiscrepantDateField !== undefined ? data.DiscrepantDateField : 0));
        this.Severity = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Severity !== undefined ? data.Severity : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    Issue.key = function (obj) {
        return obj.Id();
    };
    Issue.dataKey = function (obj) {
        return obj.Id;
    };
    Issue.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthClosureId !== undefined)
                obj.BerthClosureId(data.BerthClosureId);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.BerthReservationBerthClosureId !== undefined)
                obj.BerthReservationBerthClosureId(data.BerthReservationBerthClosureId);
            if (data.BerthReservationId !== undefined)
                obj.BerthReservationId(data.BerthReservationId);
            if (data.EnteredDateId !== undefined)
                obj.EnteredDateId(data.EnteredDateId);
            if (data.OtherClosureId !== undefined)
                obj.OtherClosureId(data.OtherClosureId);
            if (data.OtherReservationId !== undefined)
                obj.OtherReservationId(data.OtherReservationId);
            if (data.PilotJobOrderId !== undefined)
                obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.ScheduleDateId !== undefined)
                obj.ScheduleDateId(data.ScheduleDateId);
            if (data.ConfirmDate !== undefined)
                obj.ConfirmDate(new TZDate_1.default(data.ConfirmDate));
            if (data.DetectDate !== undefined)
                obj.DetectDate(new TZDate_1.default(data.DetectDate));
            if (data.DiscrepantDateField !== undefined)
                obj.DiscrepantDateField(data.DiscrepantDateField);
            if (data.Severity !== undefined)
                obj.Severity(data.Severity);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return Issue;
}());
exports.Issue = Issue;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPoint = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ItineraryPoint\ApiItineraryPoint.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDate_1 = __webpack_require__(93);
var ItineraryPoint = /** @class */ (function () {
    function ItineraryPoint(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.ArrivalPilotJobOrders = s_array_1.default([]);
        this.BerthReservation = s_js_1.default.value(null);
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.DeparturePilotJobOrders = s_array_1.default([]);
        this.Location = s_js_1.default.value(null);
        this.LocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LocationId !== undefined ? data.LocationId : 0));
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Schedule = s_array_1.default([]);
        this.Self = s_js_1.default.value(null);
        this.Version = s_js_1.default.value(null);
        this.Arrival = data && data.Arrival !== undefined ? new ScheduleDate_1.ScheduleDate(data.Arrival) : new ScheduleDate_1.ScheduleDate();
        this.Departure = data && data.Departure !== undefined ? new ScheduleDate_1.ScheduleDate(data.Departure) : new ScheduleDate_1.ScheduleDate();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsPortArrival = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsPortArrival !== undefined ? data.IsPortArrival : false));
        this.IsPortDeparture = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsPortDeparture !== undefined ? data.IsPortDeparture : false));
    }
    ItineraryPoint.key = function (obj) {
        return obj.Id();
    };
    ItineraryPoint.dataKey = function (obj) {
        return obj.Id;
    };
    ItineraryPoint.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.LocationId !== undefined)
                obj.LocationId(data.LocationId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.Arrival !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Arrival, data.Arrival);
            if (data.Departure !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Departure, data.Departure);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IsPortArrival !== undefined)
                obj.IsPortArrival(data.IsPortArrival);
            if (data.IsPortDeparture !== undefined)
                obj.IsPortDeparture(data.IsPortDeparture);
        });
    };
    return ItineraryPoint;
}());
exports.ItineraryPoint = ItineraryPoint;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPointSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ItineraryPoint\ApiItineraryPointSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ItineraryPointSelf = /** @class */ (function () {
    function ItineraryPointSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BerthReservation = s_js_1.default.value(null);
        this.Events = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    ItineraryPointSelf.key = function (obj) {
        return obj.Id();
    };
    ItineraryPointSelf.dataKey = function (obj) {
        return obj.Id;
    };
    ItineraryPointSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return ItineraryPointSelf;
}());
exports.ItineraryPointSelf = ItineraryPointSelf;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryPointVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ItineraryPoint\ApiItineraryPointVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDate_1 = __webpack_require__(93);
var ItineraryPointVersion = /** @class */ (function () {
    function ItineraryPointVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.LocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LocationId !== undefined ? data.LocationId : 0));
        this.NextVersion = s_array_1.default([]);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.Arrival = data && data.Arrival !== undefined ? new ScheduleDate_1.ScheduleDate(data.Arrival) : new ScheduleDate_1.ScheduleDate();
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Departure = data && data.Departure !== undefined ? new ScheduleDate_1.ScheduleDate(data.Departure) : new ScheduleDate_1.ScheduleDate();
        this.ExtraDataJSON = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsPortArrival = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsPortArrival !== undefined ? data.IsPortArrival : false));
        this.IsPortDeparture = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsPortDeparture !== undefined ? data.IsPortDeparture : false));
    }
    ItineraryPointVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    ItineraryPointVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    ItineraryPointVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.LocationId !== undefined)
                obj.LocationId(data.LocationId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.Arrival !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Arrival, data.Arrival);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.Departure !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Departure, data.Departure);
            if (data.ExtraDataJSON !== undefined)
                obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IsPortArrival !== undefined)
                obj.IsPortArrival(data.IsPortArrival);
            if (data.IsPortDeparture !== undefined)
                obj.IsPortDeparture(data.IsPortDeparture);
        });
    };
    return ItineraryPointVersion;
}());
exports.ItineraryPointVersion = ItineraryPointVersion;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrder = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrder.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var JobOrder = /** @class */ (function () {
    function JobOrder(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this._approvalsOfCharges = s_array_1.default([]);
        this.Bills = s_array_1.default([]);
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Schedule = s_array_1.default([]);
        this.Self = s_js_1.default.value(null);
        this.Version = s_js_1.default.value(null);
        this.Billable = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Billable !== undefined ? data.Billable : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
    }
    JobOrder.key = function (obj) {
        return obj.Id();
    };
    JobOrder.dataKey = function (obj) {
        return obj.Id;
    };
    JobOrder.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.Billable !== undefined)
                obj.Billable(data.Billable);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return JobOrder;
}());
exports.JobOrder = JobOrder;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrderSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrderSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var JobOrderSelf = /** @class */ (function () {
    function JobOrderSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Comments = s_array_1.default([]);
        this.CommentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Events = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    JobOrderSelf.key = function (obj) {
        return obj.Id();
    };
    JobOrderSelf.dataKey = function (obj) {
        return obj.Id;
    };
    JobOrderSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CommentsUrl !== undefined)
                obj.CommentsUrl(data.CommentsUrl);
        });
    };
    return JobOrderSelf;
}());
exports.JobOrderSelf = JobOrderSelf;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOrderVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrderVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var JobOrderVersion = /** @class */ (function () {
    function JobOrderVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.NextVersion = s_array_1.default([]);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.Billable = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Billable !== undefined ? data.Billable : false));
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
    }
    JobOrderVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    JobOrderVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    JobOrderVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.Billable !== undefined)
                obj.Billable(data.Billable);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined)
                obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return JobOrderVersion;
}());
exports.JobOrderVersion = JobOrderVersion;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingPage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LandingPage\ApiLandingPage.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var LandingPage = /** @class */ (function () {
    function LandingPage(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Hash = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Hash !== undefined ? data.Hash : null));
        this.IsDefault = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsDefault !== undefined ? data.IsDefault : false));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
    }
    LandingPage.key = function (obj) {
        return obj.Id();
    };
    LandingPage.dataKey = function (obj) {
        return obj.Id;
    };
    LandingPage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Hash !== undefined)
                obj.Hash(data.Hash);
            if (data.IsDefault !== undefined)
                obj.IsDefault(data.IsDefault);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return LandingPage;
}());
exports.LandingPage = LandingPage;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHandlingCompany = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\LineHandlingCompany\ApiLineHandlingCompany.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var LineHandlingCompany = /** @class */ (function () {
    function LineHandlingCompany(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.PilotJobOrders = s_array_1.default([]);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Code !== undefined ? data.Code : ''));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    LineHandlingCompany.key = function (obj) {
        return obj.Id();
    };
    LineHandlingCompany.dataKey = function (obj) {
        return obj.Id;
    };
    LineHandlingCompany.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Code !== undefined)
                obj.Code(data.Code);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return LineHandlingCompany;
}());
exports.LineHandlingCompany = LineHandlingCompany;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LloydResult = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LloydResult\ApiLloydResult.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var DataSetVersion_1 = __webpack_require__(1250);
var LloydResult = /** @class */ (function () {
    function LloydResult(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ServiceVessels = s_array_1.default([]);
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.Breadth = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Breadth !== undefined ? data.Breadth : null));
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.CoreShipInd = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CoreShipInd !== undefined ? data.CoreShipInd : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DataSetVersion = data && data.DataSetVersion !== undefined ? new DataSetVersion_1.DataSetVersion(data.DataSetVersion) : new DataSetVersion_1.DataSetVersion();
        this.DateOfBuild = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DateOfBuild !== undefined ? data.DateOfBuild : null));
        this.Deadweight = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deadweight !== undefined ? data.Deadweight : null));
        this.Depth = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Depth !== undefined ? data.Depth : null));
        this.Draught = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Draught !== undefined ? data.Draught : null));
        this.FlagCode = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagCode !== undefined ? data.FlagCode : null));
        this.FlagName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagName !== undefined ? data.FlagName : null));
        this.GrossTonnage = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.GrossTonnage !== undefined ? data.GrossTonnage : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IHSLRorIMOShipNo = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IHSLRorIMOShipNo !== undefined ? data.IHSLRorIMOShipNo : null));
        this.KeelToMastHeight = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.KeelToMastHeight !== undefined ? data.KeelToMastHeight : null));
        this.LastUpdateDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastUpdateDate !== undefined ? new TZDate_1.default(data.LastUpdateDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.LengthOverallLOA = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LengthOverallLOA !== undefined ? data.LengthOverallLOA : null));
        this.MMSI = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSI !== undefined ? data.MMSI : null));
        this.OfficialNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.Operator = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Operator !== undefined ? data.Operator : null));
        this.PassengerCapacity = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PassengerCapacity !== undefined ? data.PassengerCapacity : null));
        this.ShipName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShipName !== undefined ? data.ShipName : null));
        this.ShipStatus = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShipStatus !== undefined ? data.ShipStatus : null));
        this.ShiptypeLevel2 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShiptypeLevel2 !== undefined ? data.ShiptypeLevel2 : null));
        this.ShiptypeLevel3 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShiptypeLevel3 !== undefined ? data.ShiptypeLevel3 : null));
        this.ShiptypeLevel4 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShiptypeLevel4 !== undefined ? data.ShiptypeLevel4 : null));
        this.ShiptypeLevel5 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShiptypeLevel5 !== undefined ? data.ShiptypeLevel5 : null));
        this.ShiptypeLevel5HullType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ShiptypeLevel5HullType !== undefined ? data.ShiptypeLevel5HullType : null));
        this.TEU = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TEU !== undefined ? data.TEU : null));
        this.ThrustersDescriptiveNarrative = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ThrustersDescriptiveNarrative !== undefined ? data.ThrustersDescriptiveNarrative : null));
        this.YearOfBuild = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.YearOfBuild !== undefined ? data.YearOfBuild : null));
    }
    LloydResult.key = function (obj) {
        return obj.Id();
    };
    LloydResult.dataKey = function (obj) {
        return obj.Id;
    };
    LloydResult.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.Breadth !== undefined)
                obj.Breadth(data.Breadth);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.CoreShipInd !== undefined)
                obj.CoreShipInd(data.CoreShipInd);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.DataSetVersion !== undefined)
                DataSetVersion_1.DataSetVersion.update(obj.DataSetVersion, data.DataSetVersion);
            if (data.DateOfBuild !== undefined)
                obj.DateOfBuild(data.DateOfBuild);
            if (data.Deadweight !== undefined)
                obj.Deadweight(data.Deadweight);
            if (data.Depth !== undefined)
                obj.Depth(data.Depth);
            if (data.Draught !== undefined)
                obj.Draught(data.Draught);
            if (data.FlagCode !== undefined)
                obj.FlagCode(data.FlagCode);
            if (data.FlagName !== undefined)
                obj.FlagName(data.FlagName);
            if (data.GrossTonnage !== undefined)
                obj.GrossTonnage(data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IHSLRorIMOShipNo !== undefined)
                obj.IHSLRorIMOShipNo(data.IHSLRorIMOShipNo);
            if (data.KeelToMastHeight !== undefined)
                obj.KeelToMastHeight(data.KeelToMastHeight);
            if (data.LastUpdateDate !== undefined)
                obj.LastUpdateDate(new TZDate_1.default(data.LastUpdateDate));
            if (data.LengthOverallLOA !== undefined)
                obj.LengthOverallLOA(data.LengthOverallLOA);
            if (data.MMSI !== undefined)
                obj.MMSI(data.MMSI);
            if (data.OfficialNumber !== undefined)
                obj.OfficialNumber(data.OfficialNumber);
            if (data.Operator !== undefined)
                obj.Operator(data.Operator);
            if (data.PassengerCapacity !== undefined)
                obj.PassengerCapacity(data.PassengerCapacity);
            if (data.ShipName !== undefined)
                obj.ShipName(data.ShipName);
            if (data.ShipStatus !== undefined)
                obj.ShipStatus(data.ShipStatus);
            if (data.ShiptypeLevel2 !== undefined)
                obj.ShiptypeLevel2(data.ShiptypeLevel2);
            if (data.ShiptypeLevel3 !== undefined)
                obj.ShiptypeLevel3(data.ShiptypeLevel3);
            if (data.ShiptypeLevel4 !== undefined)
                obj.ShiptypeLevel4(data.ShiptypeLevel4);
            if (data.ShiptypeLevel5 !== undefined)
                obj.ShiptypeLevel5(data.ShiptypeLevel5);
            if (data.ShiptypeLevel5HullType !== undefined)
                obj.ShiptypeLevel5HullType(data.ShiptypeLevel5HullType);
            if (data.TEU !== undefined)
                obj.TEU(data.TEU);
            if (data.ThrustersDescriptiveNarrative !== undefined)
                obj.ThrustersDescriptiveNarrative(data.ThrustersDescriptiveNarrative);
            if (data.YearOfBuild !== undefined)
                obj.YearOfBuild(data.YearOfBuild);
        });
    };
    return LloydResult;
}());
exports.LloydResult = LloydResult;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LloydServiceSearch = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\LloydServiceSearchResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var LloydServiceSearch = /** @class */ (function () {
    function LloydServiceSearch(data) {
        if (data === void 0) { data = null; }
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.Results = s_array_1.default([]);
    }
    LloydServiceSearch.key = function (obj) {
        return (obj.CallSign() === null ? '\u2603' : obj.CallSign()) + '\u2618' + (obj.IMO() === null ? NaN : obj.IMO()) + '\u2618' + (obj.MMSID() === null ? NaN : obj.MMSID());
    };
    LloydServiceSearch.dataKey = function (obj) {
        return (obj.CallSign === null ? '\u2603' : obj.CallSign) + '\u2618' + (obj.IMO === null ? NaN : obj.IMO) + '\u2618' + (obj.MMSID === null ? NaN : obj.MMSID);
    };
    LloydServiceSearch.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
        });
    };
    return LloydServiceSearch;
}());
exports.LloydServiceSearch = LloydServiceSearch;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LloydServiceVessel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LloydServiceVessel\ApiLloydServiceVessel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BowThruster_1 = __webpack_require__(155);
var DeclarationOfSecurity_1 = __webpack_require__(156);
var Measurement_1 = __webpack_require__(11);
var LloydServiceVessel = /** @class */ (function () {
    function LloydServiceVessel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Flag = s_js_1.default.value(null);
        this.FlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagId !== undefined ? data.FlagId : null));
        this.LloydFlag = s_js_1.default.value(null);
        this.LloydFlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LloydFlagId !== undefined ? data.LloydFlagId : null));
        this.VesselResult = s_js_1.default.value(null);
        this.VesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.Alias = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Alias !== undefined ? data.Alias : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster_1.BowThruster(data.BowThruster) : new BowThruster_1.BowThruster();
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.ConstructionCompleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConstructionCompleted !== undefined ? data.ConstructionCompleted : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Depth = data && data.Depth !== undefined ? new Measurement_1.NullableMeasurement(data.Depth) : new Measurement_1.NullableMeasurement();
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity_1.DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity_1.DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : null));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new Measurement_1.NullableMeasurement(data.MaxDraft) : new Measurement_1.NullableMeasurement();
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.ModifiedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ModifiedOnUtc !== undefined ? new TZDate_1.default(data.ModifiedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.OfficialNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.PortOfRegistry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.StateNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StateNumber !== undefined ? data.StateNumber : null));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
    }
    LloydServiceVessel.key = function (obj) {
        return obj.Id();
    };
    LloydServiceVessel.dataKey = function (obj) {
        return obj.Id;
    };
    LloydServiceVessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.FlagId !== undefined)
                obj.FlagId(data.FlagId);
            if (data.LloydFlagId !== undefined)
                obj.LloydFlagId(data.LloydFlagId);
            if (data.VesselResultId !== undefined)
                obj.VesselResultId(data.VesselResultId);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.Alias !== undefined)
                obj.Alias(data.Alias);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined)
                BowThruster_1.BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.ConstructionCompleted !== undefined)
                obj.ConstructionCompleted(data.ConstructionCompleted);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Depth !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Depth, data.Depth);
            if (data.DOS !== undefined)
                DeclarationOfSecurity_1.DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined)
                obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined)
                obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined)
                obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
            if (data.ModifiedOnUtc !== undefined)
                obj.ModifiedOnUtc(new TZDate_1.default(data.ModifiedOnUtc));
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.OfficialNumber !== undefined)
                obj.OfficialNumber(data.OfficialNumber);
            if (data.PortOfRegistry !== undefined)
                obj.PortOfRegistry(data.PortOfRegistry);
            if (data.StateNumber !== undefined)
                obj.StateNumber(data.StateNumber);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return LloydServiceVessel;
}());
exports.LloydServiceVessel = LloydServiceVessel;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Location\ApiLocation.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Location = /** @class */ (function () {
    function Location(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berth = s_js_1.default.value(null);
        this.ContainingLocation = s_js_1.default.value(null);
        this.ContainingLocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ContainingLocationId !== undefined ? data.ContainingLocationId : null));
        this.GeoActivities = s_array_1.default([]);
        this.Itinerary = s_array_1.default([]);
        this.Port = s_js_1.default.value(null);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.DefaultPortEntry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultPortEntry !== undefined ? data.DefaultPortEntry : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsPortExternal = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsPortExternal !== undefined ? data.IsPortExternal : false));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.PortCDMName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCDMName !== undefined ? data.PortCDMName : null));
        this.PortEntry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortEntry !== undefined ? data.PortEntry : false));
        this.ZoneCoordinates = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ZoneCoordinates !== undefined ? data.ZoneCoordinates : null));
        this.ZoneType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ZoneType !== undefined ? data.ZoneType : null));
    }
    Location.key = function (obj) {
        return obj.Id();
    };
    Location.dataKey = function (obj) {
        return obj.Id;
    };
    Location.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ContainingLocationId !== undefined)
                obj.ContainingLocationId(data.ContainingLocationId);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.DefaultPortEntry !== undefined)
                obj.DefaultPortEntry(data.DefaultPortEntry);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IsPortExternal !== undefined)
                obj.IsPortExternal(data.IsPortExternal);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.PortCDMName !== undefined)
                obj.PortCDMName(data.PortCDMName);
            if (data.PortEntry !== undefined)
                obj.PortEntry(data.PortEntry);
            if (data.ZoneCoordinates !== undefined)
                obj.ZoneCoordinates(data.ZoneCoordinates);
            if (data.ZoneType !== undefined)
                obj.ZoneType(data.ZoneType);
        });
    };
    return Location;
}());
exports.Location = Location;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEvent = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\LogEvent\ApiLogEvent.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var LogEvent = /** @class */ (function () {
    function LogEvent(data) {
        if (data === void 0) { data = null; }
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Event = s_js_1.default.value(null);
        this.PortCall = s_js_1.default.value(null);
    }
    LogEvent.key = function (obj) {
        return obj.EventId() + '\u2618' + obj.PortCallId();
    };
    LogEvent.dataKey = function (obj) {
        return obj.EventId + '\u2618' + obj.PortCallId;
    };
    LogEvent.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
        });
    };
    return LogEvent;
}());
exports.LogEvent = LogEvent;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagePilotLookups = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\ManagePilotLookups\ManagePilotLookupsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ManagePilotLookups = /** @class */ (function () {
    function ManagePilotLookups(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Organizations = s_array_1.default([]);
        this.PilotAgency = s_js_1.default.value(null);
        this.Pilots = s_array_1.default([]);
    }
    ManagePilotLookups.key = function (obj) {
        return obj.Id();
    };
    ManagePilotLookups.dataKey = function (obj) {
        return obj.Id;
    };
    ManagePilotLookups.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return ManagePilotLookups;
}());
exports.ManagePilotLookups = ManagePilotLookups;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MapSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\MapSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var MapSettings = /** @class */ (function () {
    function MapSettings(data) {
        if (data === void 0) { data = null; }
        this.ImageUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ImageUrl !== undefined ? data.ImageUrl : null));
        this.Latitude = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Latitude !== undefined ? data.Latitude : 0));
        this.Longitude = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Longitude !== undefined ? data.Longitude : 0));
        this.Zoom = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Zoom !== undefined ? data.Zoom : 0));
    }
    MapSettings.key = function (obj) {
        return;
    };
    MapSettings.dataKey = function (obj) {
        return;
    };
    MapSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ImageUrl !== undefined)
                obj.ImageUrl(data.ImageUrl);
            if (data.Latitude !== undefined)
                obj.Latitude(data.Latitude);
            if (data.Longitude !== undefined)
                obj.Longitude(data.Longitude);
            if (data.Zoom !== undefined)
                obj.Zoom(data.Zoom);
        });
    };
    return MapSettings;
}());
exports.MapSettings = MapSettings;


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MarineTrafficResult = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MarineTrafficResult\ApiMarineTrafficResult.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var MarineTrafficResult = /** @class */ (function () {
    function MarineTrafficResult(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ServiceVessels = s_array_1.default([]);
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.BreadthExtreme = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BreadthExtreme !== undefined ? data.BreadthExtreme : null));
        this.Build = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Build !== undefined ? data.Build : null));
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DisplacementSummer = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplacementSummer !== undefined ? data.DisplacementSummer : null));
        this.Draught = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Draught !== undefined ? data.Draught : null));
        this.Flag = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Flag !== undefined ? data.Flag : null));
        this.FuelConsumption = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FuelConsumption !== undefined ? data.FuelConsumption : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.LengthOverall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LengthOverall !== undefined ? data.LengthOverall : null));
        this.LiquidOil = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LiquidOil !== undefined ? data.LiquidOil : null));
        this.Manager = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Manager !== undefined ? data.Manager : null));
        this.MMSI = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSI !== undefined ? data.MMSI : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.Owner = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Owner !== undefined ? data.Owner : null));
        this.PlaceOfBuild = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PlaceOfBuild !== undefined ? data.PlaceOfBuild : null));
        this.RawXml = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawXml !== undefined ? data.RawXml : null));
        this.SpeedMax = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SpeedMax !== undefined ? data.SpeedMax : null));
        this.SpeedService = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SpeedService !== undefined ? data.SpeedService : null));
        this.SummerDwt = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SummerDwt !== undefined ? data.SummerDwt : null));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
    }
    MarineTrafficResult.key = function (obj) {
        return obj.Id();
    };
    MarineTrafficResult.dataKey = function (obj) {
        return obj.Id;
    };
    MarineTrafficResult.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.BreadthExtreme !== undefined)
                obj.BreadthExtreme(data.BreadthExtreme);
            if (data.Build !== undefined)
                obj.Build(data.Build);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.DisplacementSummer !== undefined)
                obj.DisplacementSummer(data.DisplacementSummer);
            if (data.Draught !== undefined)
                obj.Draught(data.Draught);
            if (data.Flag !== undefined)
                obj.Flag(data.Flag);
            if (data.FuelConsumption !== undefined)
                obj.FuelConsumption(data.FuelConsumption);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.LengthOverall !== undefined)
                obj.LengthOverall(data.LengthOverall);
            if (data.LiquidOil !== undefined)
                obj.LiquidOil(data.LiquidOil);
            if (data.Manager !== undefined)
                obj.Manager(data.Manager);
            if (data.MMSI !== undefined)
                obj.MMSI(data.MMSI);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Owner !== undefined)
                obj.Owner(data.Owner);
            if (data.PlaceOfBuild !== undefined)
                obj.PlaceOfBuild(data.PlaceOfBuild);
            if (data.RawXml !== undefined)
                obj.RawXml(data.RawXml);
            if (data.SpeedMax !== undefined)
                obj.SpeedMax(data.SpeedMax);
            if (data.SpeedService !== undefined)
                obj.SpeedService(data.SpeedService);
            if (data.SummerDwt !== undefined)
                obj.SummerDwt(data.SummerDwt);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
        });
    };
    return MarineTrafficResult;
}());
exports.MarineTrafficResult = MarineTrafficResult;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MarineTrafficServiceSearch = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\MarineTrafficServiceSearchResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var MarineTrafficServiceSearch = /** @class */ (function () {
    function MarineTrafficServiceSearch(data) {
        if (data === void 0) { data = null; }
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.Results = s_array_1.default([]);
    }
    MarineTrafficServiceSearch.key = function (obj) {
        return (obj.IMO() === null ? NaN : obj.IMO()) + '\u2618' + (obj.MMSID() === null ? NaN : obj.MMSID());
    };
    MarineTrafficServiceSearch.dataKey = function (obj) {
        return (obj.IMO === null ? NaN : obj.IMO) + '\u2618' + (obj.MMSID === null ? NaN : obj.MMSID);
    };
    MarineTrafficServiceSearch.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
        });
    };
    return MarineTrafficServiceSearch;
}());
exports.MarineTrafficServiceSearch = MarineTrafficServiceSearch;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MarineTrafficServiceVessel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MarineTrafficServiceVessel\ApiMarineTrafficServiceVessel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BowThruster_1 = __webpack_require__(155);
var DeclarationOfSecurity_1 = __webpack_require__(156);
var Measurement_1 = __webpack_require__(11);
var MarineTrafficServiceVessel = /** @class */ (function () {
    function MarineTrafficServiceVessel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Flag = s_js_1.default.value(null);
        this.FlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagId !== undefined ? data.FlagId : null));
        this.VesselResult = s_js_1.default.value(null);
        this.VesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.Alias = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Alias !== undefined ? data.Alias : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster_1.BowThruster(data.BowThruster) : new BowThruster_1.BowThruster();
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.ConstructionCompleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConstructionCompleted !== undefined ? data.ConstructionCompleted : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Depth = data && data.Depth !== undefined ? new Measurement_1.NullableMeasurement(data.Depth) : new Measurement_1.NullableMeasurement();
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity_1.DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity_1.DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : null));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new Measurement_1.NullableMeasurement(data.MaxDraft) : new Measurement_1.NullableMeasurement();
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.ModifiedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ModifiedOnUtc !== undefined ? new TZDate_1.default(data.ModifiedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.OfficialNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.PortOfRegistry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.StateNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StateNumber !== undefined ? data.StateNumber : null));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
    }
    MarineTrafficServiceVessel.key = function (obj) {
        return obj.Id();
    };
    MarineTrafficServiceVessel.dataKey = function (obj) {
        return obj.Id;
    };
    MarineTrafficServiceVessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.FlagId !== undefined)
                obj.FlagId(data.FlagId);
            if (data.VesselResultId !== undefined)
                obj.VesselResultId(data.VesselResultId);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.Alias !== undefined)
                obj.Alias(data.Alias);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined)
                BowThruster_1.BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.ConstructionCompleted !== undefined)
                obj.ConstructionCompleted(data.ConstructionCompleted);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Depth !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Depth, data.Depth);
            if (data.DOS !== undefined)
                DeclarationOfSecurity_1.DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined)
                obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined)
                obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined)
                obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
            if (data.ModifiedOnUtc !== undefined)
                obj.ModifiedOnUtc(new TZDate_1.default(data.ModifiedOnUtc));
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.OfficialNumber !== undefined)
                obj.OfficialNumber(data.OfficialNumber);
            if (data.PortOfRegistry !== undefined)
                obj.PortOfRegistry(data.PortOfRegistry);
            if (data.StateNumber !== undefined)
                obj.StateNumber(data.StateNumber);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return MarineTrafficServiceVessel;
}());
exports.MarineTrafficServiceVessel = MarineTrafficServiceVessel;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MarinerCloudSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\MarinerCloudSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var MarinerCloudSettings = /** @class */ (function () {
    function MarinerCloudSettings(data) {
        if (data === void 0) { data = null; }
        this.BaseEndpoint = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BaseEndpoint !== undefined ? data.BaseEndpoint : null));
        this.Password = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Password !== undefined ? data.Password : null));
        this.Username = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Username !== undefined ? data.Username : null));
    }
    MarinerCloudSettings.key = function (obj) {
        return;
    };
    MarinerCloudSettings.dataKey = function (obj) {
        return;
    };
    MarinerCloudSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BaseEndpoint !== undefined)
                obj.BaseEndpoint(data.BaseEndpoint);
            if (data.Password !== undefined)
                obj.Password(data.Password);
            if (data.Username !== undefined)
                obj.Username(data.Username);
        });
    };
    return MarinerCloudSettings;
}());
exports.MarinerCloudSettings = MarinerCloudSettings;


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableMeasurement = exports.Measurement = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Measurement.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement = /** @class */ (function () {
    function Measurement(data) {
        if (data === void 0) { data = null; }
        this.Num = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Num !== undefined ? data.Num : 0));
        this.UOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UOM !== undefined ? data.UOM : ''));
    }
    Measurement.key = function (obj) {
        return;
    };
    Measurement.dataKey = function (obj) {
        return;
    };
    Measurement.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Num !== undefined)
                obj.Num(data.Num);
            if (data.UOM !== undefined)
                obj.UOM(data.UOM);
        });
    };
    return Measurement;
}());
exports.Measurement = Measurement;
var NullableMeasurement = /** @class */ (function () {
    function NullableMeasurement(data) {
        if (data === void 0) { data = null; }
        this.Num = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Num !== undefined ? data.Num : null));
        this.UOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UOM !== undefined ? data.UOM : null));
    }
    NullableMeasurement.key = function (obj) {
        return;
    };
    NullableMeasurement.dataKey = function (obj) {
        return;
    };
    NullableMeasurement.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Num !== undefined)
                obj.Num(data.Num);
            if (data.UOM !== undefined)
                obj.UOM(data.UOM);
        });
    };
    return NullableMeasurement;
}());
exports.NullableMeasurement = NullableMeasurement;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneType = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MilestoneType\ApiMilestoneType.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var MilestoneType = /** @class */ (function () {
    function MilestoneType(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Coordinations = s_array_1.default([]);
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.Nickname = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Nickname !== undefined ? data.Nickname : ''));
    }
    MilestoneType.key = function (obj) {
        return obj.Id();
    };
    MilestoneType.dataKey = function (obj) {
        return obj.Id;
    };
    MilestoneType.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Nickname !== undefined)
                obj.Nickname(data.Nickname);
        });
    };
    return MilestoneType;
}());
exports.MilestoneType = MilestoneType;


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingPilotJobOrder = exports.MissingPilotJobOrdersResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\MissingPilotJobOrdersViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var MissingPilotJobOrdersResponse = /** @class */ (function () {
    function MissingPilotJobOrdersResponse(data) {
        if (data === void 0) { data = null; }
        this.From = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.From !== undefined ? new TZDate_1.default(data.From) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.To = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.To !== undefined ? new TZDate_1.default(data.To) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.MissingPilotJobOrders = s_array_1.default([]);
    }
    MissingPilotJobOrdersResponse.key = function (obj) {
        return obj.From().toJSON() + '\u2618' + (obj.PortCallId() === null ? NaN : obj.PortCallId()) + '\u2618' + obj.To().toJSON();
    };
    MissingPilotJobOrdersResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.From).toJSON() + '\u2618' + (obj.PortCallId === null ? NaN : obj.PortCallId) + '\u2618' + new TZDate_1.default(obj.To).toJSON();
    };
    MissingPilotJobOrdersResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.From !== undefined)
                obj.From(new TZDate_1.default(data.From));
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.To !== undefined)
                obj.To(new TZDate_1.default(data.To));
        });
    };
    return MissingPilotJobOrdersResponse;
}());
exports.MissingPilotJobOrdersResponse = MissingPilotJobOrdersResponse;
var MissingPilotJobOrder = /** @class */ (function () {
    function MissingPilotJobOrder(data) {
        if (data === void 0) { data = null; }
        this.FromPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.ToPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.FromName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromName !== undefined ? data.FromName : null));
        this.ToName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToName !== undefined ? data.ToName : null));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    MissingPilotJobOrder.key = function (obj) {
        return obj.FromPointId() + '\u2618' + obj.ToPointId();
    };
    MissingPilotJobOrder.dataKey = function (obj) {
        return obj.FromPointId + '\u2618' + obj.ToPointId;
    };
    MissingPilotJobOrder.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromPointId !== undefined)
                obj.FromPointId(data.FromPointId);
            if (data.ToPointId !== undefined)
                obj.ToPointId(data.ToPointId);
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
            if (data.FromName !== undefined)
                obj.FromName(data.FromName);
            if (data.ToName !== undefined)
                obj.ToName(data.ToName);
            if (data.Type !== undefined)
                obj.Type(data.Type);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return MissingPilotJobOrder;
}());
exports.MissingPilotJobOrder = MissingPilotJobOrder;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\MorePage\MorePageViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var MorePage = /** @class */ (function () {
    function MorePage(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Pilots = s_js_1.default.value(null);
        this.CanManageBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanRequestBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanRequestBerths !== undefined ? data.CanRequestBerths : false));
        this.CanSiteAdmin = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanSiteAdmin !== undefined ? data.CanSiteAdmin : false));
    }
    MorePage.key = function (obj) {
        return obj.UserId();
    };
    MorePage.dataKey = function (obj) {
        return obj.UserId;
    };
    MorePage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.CanManageBerths !== undefined)
                obj.CanManageBerths(data.CanManageBerths);
            if (data.CanRequestBerths !== undefined)
                obj.CanRequestBerths(data.CanRequestBerths);
            if (data.CanSiteAdmin !== undefined)
                obj.CanSiteAdmin(data.CanSiteAdmin);
        });
    };
    return MorePage;
}());
exports.MorePage = MorePage;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NewTopicCardRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewTopicCard\NewTopicCardRequest.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var NewTopicCardRequest = /** @class */ (function () {
    function NewTopicCardRequest(data) {
        if (data === void 0) { data = null; }
        this.Card = s_js_1.default.value(null);
        this.SelectedTemplateOptionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SelectedTemplateOptionId !== undefined ? data.SelectedTemplateOptionId : null));
    }
    NewTopicCardRequest.key = function (obj) {
        return;
    };
    NewTopicCardRequest.dataKey = function (obj) {
        return;
    };
    NewTopicCardRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.SelectedTemplateOptionId !== undefined)
                obj.SelectedTemplateOptionId(data.SelectedTemplateOptionId);
        });
    };
    return NewTopicCardRequest;
}());
exports.NewTopicCardRequest = NewTopicCardRequest;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Notification\ApiNotification.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Notification = /** @class */ (function () {
    function Notification(data) {
        if (data === void 0) { data = null; }
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Event = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
        this.Email = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Email !== undefined ? data.Email : false));
        this.EmailDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EmailDate !== undefined ? data.EmailDate === null ? null : new TZDate_1.default(data.EmailDate) : null, TZDate_1.default.nullableEq));
        this.Push = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Push !== undefined ? data.Push : false));
        this.PushDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PushDate !== undefined ? data.PushDate === null ? null : new TZDate_1.default(data.PushDate) : null, TZDate_1.default.nullableEq));
        this.Web = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Web !== undefined ? data.Web : false));
        this.WebDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.WebDate !== undefined ? data.WebDate === null ? null : new TZDate_1.default(data.WebDate) : null, TZDate_1.default.nullableEq));
    }
    Notification.key = function (obj) {
        return obj.EventId() + '\u2618' + obj.UserId();
    };
    Notification.dataKey = function (obj) {
        return obj.EventId + '\u2618' + obj.UserId;
    };
    Notification.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.Email !== undefined)
                obj.Email(data.Email);
            if (data.EmailDate !== undefined)
                obj.EmailDate(data.EmailDate === null ? null : new TZDate_1.default(data.EmailDate));
            if (data.Push !== undefined)
                obj.Push(data.Push);
            if (data.PushDate !== undefined)
                obj.PushDate(data.PushDate === null ? null : new TZDate_1.default(data.PushDate));
            if (data.Web !== undefined)
                obj.Web(data.Web);
            if (data.WebDate !== undefined)
                obj.WebDate(data.WebDate === null ? null : new TZDate_1.default(data.WebDate));
        });
    };
    return Notification;
}());
exports.Notification = Notification;


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsForecastPortDay = exports.OperationsForecastPort = exports.OperationsForecastResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\OperationsForecastResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var OperationsForecastResponse = /** @class */ (function () {
    function OperationsForecastResponse(data) {
        if (data === void 0) { data = null; }
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Ports = s_array_1.default([]);
    }
    OperationsForecastResponse.key = function (obj) {
        return obj.Date().toJSON() + '\u2618' + obj.OrganizationId();
    };
    OperationsForecastResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.Date).toJSON() + '\u2618' + obj.OrganizationId;
    };
    OperationsForecastResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
        });
    };
    return OperationsForecastResponse;
}());
exports.OperationsForecastResponse = OperationsForecastResponse;
var OperationsForecastPort = /** @class */ (function () {
    function OperationsForecastPort(data) {
        if (data === void 0) { data = null; }
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.Days = s_array_1.default([]);
        this.Port = s_js_1.default.value(null);
    }
    OperationsForecastPort.key = function (obj) {
        return obj.OrganizationId() + '\u2618' + obj.PortId();
    };
    OperationsForecastPort.dataKey = function (obj) {
        return obj.OrganizationId + '\u2618' + obj.PortId;
    };
    OperationsForecastPort.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
        });
    };
    return OperationsForecastPort;
}());
exports.OperationsForecastPort = OperationsForecastPort;
var OperationsForecastPortDay = /** @class */ (function () {
    function OperationsForecastPortDay(data) {
        if (data === void 0) { data = null; }
        this.Day = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Day !== undefined ? new TZDate_1.default(data.Day) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.Arrivals = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Arrivals !== undefined ? data.Arrivals : 0));
        this.Departures = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Departures !== undefined ? data.Departures : 0));
        this.ScheduledVessels = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduledVessels !== undefined ? data.ScheduledVessels : 0));
        this.Services = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Services !== undefined ? data.Services : 0));
        this.Shifts = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Shifts !== undefined ? data.Shifts : 0));
    }
    OperationsForecastPortDay.key = function (obj) {
        return obj.Day().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.PortId();
    };
    OperationsForecastPortDay.dataKey = function (obj) {
        return new TZDate_1.default(obj.Day).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.PortId;
    };
    OperationsForecastPortDay.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Day !== undefined)
                obj.Day(new TZDate_1.default(data.Day));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.Arrivals !== undefined)
                obj.Arrivals(data.Arrivals);
            if (data.Departures !== undefined)
                obj.Departures(data.Departures);
            if (data.ScheduledVessels !== undefined)
                obj.ScheduledVessels(data.ScheduledVessels);
            if (data.Services !== undefined)
                obj.Services(data.Services);
            if (data.Shifts !== undefined)
                obj.Shifts(data.Shifts);
        });
    };
    return OperationsForecastPortDay;
}());
exports.OperationsForecastPortDay = OperationsForecastPortDay;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProfileResponseRef = exports.OrgProfileResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\OrgProfile\OrgProfileViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var OrgProfileResponse_1 = __webpack_require__(577);
var OrgProfileResponse = /** @class */ (function () {
    function OrgProfileResponse(data) {
        if (data === void 0) { data = null; }
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Organization = s_js_1.default.value(null);
        this.PierGroups = s_array_1.default([]);
        this.Ports = s_array_1.default([]);
        this.BookingRate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BookingRate !== undefined ? data.BookingRate : null));
        this.CanAddBerth = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAddBerth !== undefined ? data.CanAddBerth : false));
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanManageBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanManageUsers = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageUsers !== undefined ? data.CanManageUsers : false));
        this.Ref = data && data.Ref !== undefined ? new OrgProfileResponse_1.OrgProfileResponseRef(data.Ref) : new OrgProfileResponse_1.OrgProfileResponseRef();
    }
    OrgProfileResponse.key = function (obj) {
        return obj.OrganizationId();
    };
    OrgProfileResponse.dataKey = function (obj) {
        return obj.OrganizationId;
    };
    OrgProfileResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.BookingRate !== undefined)
                obj.BookingRate(data.BookingRate);
            if (data.CanAddBerth !== undefined)
                obj.CanAddBerth(data.CanAddBerth);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
            if (data.CanManageBerths !== undefined)
                obj.CanManageBerths(data.CanManageBerths);
            if (data.CanManageUsers !== undefined)
                obj.CanManageUsers(data.CanManageUsers);
            if (data.Ref !== undefined)
                OrgProfileResponse_1.OrgProfileResponseRef.update(obj.Ref, data.Ref);
        });
    };
    return OrgProfileResponse;
}());
exports.OrgProfileResponse = OrgProfileResponse;
var OrgProfileResponseRef = /** @class */ (function () {
    function OrgProfileResponseRef(data) {
        if (data === void 0) { data = null; }
        this.DefaultImages = s_array_1.default([]);
        this.AllowedImageUploadExtensions = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AllowedImageUploadExtensions !== undefined ? data.AllowedImageUploadExtensions : []));
        this.MaximumImageUploadFileSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MaximumImageUploadFileSize !== undefined ? data.MaximumImageUploadFileSize : 0));
        this.MinimumImageUploadImageSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MinimumImageUploadImageSize !== undefined ? data.MinimumImageUploadImageSize : 0));
    }
    OrgProfileResponseRef.key = function (obj) {
        return;
    };
    OrgProfileResponseRef.dataKey = function (obj) {
        return;
    };
    OrgProfileResponseRef.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.AllowedImageUploadExtensions !== undefined)
                obj.AllowedImageUploadExtensions(data.AllowedImageUploadExtensions);
            if (data.MaximumImageUploadFileSize !== undefined)
                obj.MaximumImageUploadFileSize(data.MaximumImageUploadFileSize);
            if (data.MinimumImageUploadImageSize !== undefined)
                obj.MinimumImageUploadImageSize(data.MinimumImageUploadImageSize);
        });
    };
    return OrgProfileResponseRef;
}());
exports.OrgProfileResponseRef = OrgProfileResponseRef;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Organization\ApiOrganization.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Image_1 = __webpack_require__(284);
var Organization = /** @class */ (function () {
    function Organization(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AgencyCodesAsCodedOrganization = s_array_1.default([]);
        this.BerthAmenityTypes = s_array_1.default([]);
        this.BerthAmenityTypesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthAmenityTypesUrl !== undefined ? data.BerthAmenityTypesUrl : null));
        this.BillingSystems = s_array_1.default([]);
        this.BillsAsCustomer = s_array_1.default([]);
        this.CargoActivityTypes = s_array_1.default([]);
        this.CargoActivityTypesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CargoActivityTypesUrl !== undefined ? data.CargoActivityTypesUrl : null));
        this.CargoCategories = s_array_1.default([]);
        this.CargoCategoriesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CargoCategoriesUrl !== undefined ? data.CargoCategoriesUrl : null));
        this.CoordinationsProvided = s_array_1.default([]);
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.ManagedBerths = s_array_1.default([]);
        this.PhoneNumbers = s_array_1.default([]);
        this.PhoneNumbersUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PhoneNumbersUrl !== undefined ? data.PhoneNumbersUrl : null));
        this.PilotAgency = s_js_1.default.value(null);
        this.PostalAddresses = s_array_1.default([]);
        this.PostalAddressesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PostalAddressesUrl !== undefined ? data.PostalAddressesUrl : null));
        this.Shares = s_array_1.default([]);
        this.TopicCardTemplates = s_array_1.default([]);
        this.TopicCardTemplatesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TopicCardTemplatesUrl !== undefined ? data.TopicCardTemplatesUrl : null));
        this.TradeRoutes = s_array_1.default([]);
        this.TradeRoutesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TradeRoutesUrl !== undefined ? data.TradeRoutesUrl : null));
        this.UITheme = s_js_1.default.value(null);
        this.UIThemeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UIThemeId !== undefined ? data.UIThemeId : null));
        this.Users = s_array_1.default([]);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.FinalReminderWindow = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FinalReminderWindow !== undefined ? data.FinalReminderWindow : null));
        this.FirstReminderWindow = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstReminderWindow !== undefined ? data.FirstReminderWindow : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Image = data && data.Image !== undefined ? new Image_1.Image(data.Image) : new Image_1.Image();
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    Organization.key = function (obj) {
        return obj.Id();
    };
    Organization.dataKey = function (obj) {
        return obj.Id;
    };
    Organization.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.BerthAmenityTypesUrl !== undefined)
                obj.BerthAmenityTypesUrl(data.BerthAmenityTypesUrl);
            if (data.CargoActivityTypesUrl !== undefined)
                obj.CargoActivityTypesUrl(data.CargoActivityTypesUrl);
            if (data.CargoCategoriesUrl !== undefined)
                obj.CargoCategoriesUrl(data.CargoCategoriesUrl);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.PhoneNumbersUrl !== undefined)
                obj.PhoneNumbersUrl(data.PhoneNumbersUrl);
            if (data.PostalAddressesUrl !== undefined)
                obj.PostalAddressesUrl(data.PostalAddressesUrl);
            if (data.TopicCardTemplatesUrl !== undefined)
                obj.TopicCardTemplatesUrl(data.TopicCardTemplatesUrl);
            if (data.TradeRoutesUrl !== undefined)
                obj.TradeRoutesUrl(data.TradeRoutesUrl);
            if (data.UIThemeId !== undefined)
                obj.UIThemeId(data.UIThemeId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.FinalReminderWindow !== undefined)
                obj.FinalReminderWindow(data.FinalReminderWindow);
            if (data.FirstReminderWindow !== undefined)
                obj.FirstReminderWindow(data.FirstReminderWindow);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Image !== undefined)
                Image_1.Image.update(obj.Image, data.Image);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return Organization;
}());
exports.Organization = Organization;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Organizations\OrganizationsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var OrganizationsResponse = /** @class */ (function () {
    function OrganizationsResponse(data) {
        if (data === void 0) { data = null; }
        this.Organizations = s_array_1.default([]);
        this.CanEditPermissions = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditPermissions !== undefined ? data.CanEditPermissions : false));
        this.CanManageOrgs = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageOrgs !== undefined ? data.CanManageOrgs : false));
    }
    OrganizationsResponse.key = function (obj) {
        return;
    };
    OrganizationsResponse.dataKey = function (obj) {
        return;
    };
    OrganizationsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CanEditPermissions !== undefined)
                obj.CanEditPermissions(data.CanEditPermissions);
            if (data.CanManageOrgs !== undefined)
                obj.CanManageOrgs(data.CanManageOrgs);
        });
    };
    return OrganizationsResponse;
}());
exports.OrganizationsResponse = OrganizationsResponse;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginalPilotOrder = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\ViewOriginalPilotOrder\ViewOriginalPilotOrderViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var OriginalPilotOrder = /** @class */ (function () {
    function OriginalPilotOrder(data) {
        if (data === void 0) { data = null; }
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.OriginalOrder = s_js_1.default.value(null);
    }
    OriginalPilotOrder.key = function (obj) {
        return obj.PortCallId();
    };
    OriginalPilotOrder.dataKey = function (obj) {
        return obj.PortCallId;
    };
    OriginalPilotOrder.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
        });
    };
    return OriginalPilotOrder;
}());
exports.OriginalPilotOrder = OriginalPilotOrder;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideServiceVessel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\OverrideServiceVessel\ApiOverrideServiceVessel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BowThruster_1 = __webpack_require__(155);
var DeclarationOfSecurity_1 = __webpack_require__(156);
var Measurement_1 = __webpack_require__(11);
var OverrideServiceVessel = /** @class */ (function () {
    function OverrideServiceVessel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Flag = s_js_1.default.value(null);
        this.FlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagId !== undefined ? data.FlagId : null));
        this.Vessel = s_js_1.default.value(null);
        this.Alias = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Alias !== undefined ? data.Alias : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster_1.BowThruster(data.BowThruster) : new BowThruster_1.BowThruster();
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.ConstructionCompleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConstructionCompleted !== undefined ? data.ConstructionCompleted : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Depth = data && data.Depth !== undefined ? new Measurement_1.NullableMeasurement(data.Depth) : new Measurement_1.NullableMeasurement();
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity_1.DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity_1.DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : null));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new Measurement_1.NullableMeasurement(data.MaxDraft) : new Measurement_1.NullableMeasurement();
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.ModifiedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ModifiedOnUtc !== undefined ? new TZDate_1.default(data.ModifiedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.OfficialNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.PortOfRegistry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.StateNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StateNumber !== undefined ? data.StateNumber : null));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
    }
    OverrideServiceVessel.key = function (obj) {
        return obj.Id();
    };
    OverrideServiceVessel.dataKey = function (obj) {
        return obj.Id;
    };
    OverrideServiceVessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.FlagId !== undefined)
                obj.FlagId(data.FlagId);
            if (data.Alias !== undefined)
                obj.Alias(data.Alias);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined)
                BowThruster_1.BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.ConstructionCompleted !== undefined)
                obj.ConstructionCompleted(data.ConstructionCompleted);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Depth !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Depth, data.Depth);
            if (data.DOS !== undefined)
                DeclarationOfSecurity_1.DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined)
                obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined)
                obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined)
                obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
            if (data.ModifiedOnUtc !== undefined)
                obj.ModifiedOnUtc(new TZDate_1.default(data.ModifiedOnUtc));
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.OfficialNumber !== undefined)
                obj.OfficialNumber(data.OfficialNumber);
            if (data.PortOfRegistry !== undefined)
                obj.PortOfRegistry(data.PortOfRegistry);
            if (data.StateNumber !== undefined)
                obj.StateNumber(data.StateNumber);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return OverrideServiceVessel;
}());
exports.OverrideServiceVessel = OverrideServiceVessel;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PCUser = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PCUser\ApiPCUser.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Image_1 = __webpack_require__(284);
var PCUser = /** @class */ (function () {
    function PCUser(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AnsweredTopicCards = s_array_1.default([]);
        this.CommentsTaggedIn = s_array_1.default([]);
        this.LloydVesselServiceQueries = s_array_1.default([]);
        this.MarineTrafficVesselServiceQueries = s_array_1.default([]);
        this.Notifications = s_array_1.default([]);
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PhoneNumbers = s_array_1.default([]);
        this.PhoneNumbersUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PhoneNumbersUrl !== undefined ? data.PhoneNumbersUrl : null));
        this.PortCallEditors = s_array_1.default([]);
        this.PortCalls = s_array_1.default([]);
        this.PortCallsAsAgent = s_array_1.default([]);
        this.PortCallsAsRequestor = s_array_1.default([]);
        this.PSixVesselServiceQueries = s_array_1.default([]);
        this.Shares = s_array_1.default([]);
        this.TopicCards = s_array_1.default([]);
        this.TopicCardTemplates = s_array_1.default([]);
        this.UITheme = s_js_1.default.value(null);
        this.UIThemeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UIThemeId !== undefined ? data.UIThemeId : null));
        this.User = s_js_1.default.value(null);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.FirstName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstName !== undefined ? data.FirstName : ''));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Image = data && data.Image !== undefined ? new Image_1.Image(data.Image) : new Image_1.Image();
        this.JobDescription = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobDescription !== undefined ? data.JobDescription : null));
        this.LandingPage = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LandingPage !== undefined ? data.LandingPage : null));
        this.LastName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastName !== undefined ? data.LastName : ''));
        this.NotificationEmail = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NotificationEmail !== undefined ? data.NotificationEmail : null));
        this.PortCallEditorsUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallEditorsUrlBase !== undefined ? data.PortCallEditorsUrlBase : null));
        this.PrivateContactInfo = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrivateContactInfo !== undefined ? data.PrivateContactInfo : false));
    }
    PCUser.key = function (obj) {
        return obj.Id();
    };
    PCUser.dataKey = function (obj) {
        return obj.Id;
    };
    PCUser.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.PhoneNumbersUrl !== undefined)
                obj.PhoneNumbersUrl(data.PhoneNumbersUrl);
            if (data.UIThemeId !== undefined)
                obj.UIThemeId(data.UIThemeId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.FirstName !== undefined)
                obj.FirstName(data.FirstName);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Image !== undefined)
                Image_1.Image.update(obj.Image, data.Image);
            if (data.JobDescription !== undefined)
                obj.JobDescription(data.JobDescription);
            if (data.LandingPage !== undefined)
                obj.LandingPage(data.LandingPage);
            if (data.LastName !== undefined)
                obj.LastName(data.LastName);
            if (data.NotificationEmail !== undefined)
                obj.NotificationEmail(data.NotificationEmail);
            if (data.PortCallEditorsUrlBase !== undefined)
                obj.PortCallEditorsUrlBase(data.PortCallEditorsUrlBase);
            if (data.PrivateContactInfo !== undefined)
                obj.PrivateContactInfo(data.PrivateContactInfo);
        });
    };
    return PCUser;
}());
exports.PCUser = PCUser;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PCUserPortCallEditor = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PCUserPortCallEditor\ApiPCUserPortCallEditor.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PCUserPortCallEditor = /** @class */ (function () {
    function PCUserPortCallEditor(data) {
        if (data === void 0) { data = null; }
        this.PortCallEditorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallEditorId !== undefined ? data.PortCallEditorId : 0));
        this.PortCallOwnerId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallOwnerId !== undefined ? data.PortCallOwnerId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PortCallEditor = s_js_1.default.value(null);
        this.PortCallOwner = s_js_1.default.value(null);
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }
    PCUserPortCallEditor.key = function (obj) {
        return obj.PortCallEditorId() + '\u2618' + obj.PortCallOwnerId();
    };
    PCUserPortCallEditor.dataKey = function (obj) {
        return obj.PortCallEditorId + '\u2618' + obj.PortCallOwnerId;
    };
    PCUserPortCallEditor.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortCallEditorId !== undefined)
                obj.PortCallEditorId(data.PortCallEditorId);
            if (data.PortCallOwnerId !== undefined)
                obj.PortCallOwnerId(data.PortCallOwnerId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
        });
    };
    return PCUserPortCallEditor;
}());
exports.PCUserPortCallEditor = PCUserPortCallEditor;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixServiceSearch = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\PSixServiceSearchResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PSixServiceSearch = /** @class */ (function () {
    function PSixServiceSearch(data) {
        if (data === void 0) { data = null; }
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.HIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HIN !== undefined ? data.HIN : null));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
        this.Results = s_array_1.default([]);
    }
    PSixServiceSearch.key = function (obj) {
        return (obj.CallSign() === null ? '\u2603' : obj.CallSign()) + '\u2618' + (obj.HIN() === null ? '\u2603' : obj.HIN()) + '\u2618' + (obj.VesselName() === null ? '\u2603' : obj.VesselName()) + '\u2618' + (obj.VIN() === null ? '\u2603' : obj.VIN());
    };
    PSixServiceSearch.dataKey = function (obj) {
        return (obj.CallSign === null ? '\u2603' : obj.CallSign) + '\u2618' + (obj.HIN === null ? '\u2603' : obj.HIN) + '\u2618' + (obj.VesselName === null ? '\u2603' : obj.VesselName) + '\u2618' + (obj.VIN === null ? '\u2603' : obj.VIN);
    };
    PSixServiceSearch.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.HIN !== undefined)
                obj.HIN(data.HIN);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return PSixServiceSearch;
}());
exports.PSixServiceSearch = PSixServiceSearch;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixServiceVessel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixServiceVessel\ApiPSixServiceVessel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BowThruster_1 = __webpack_require__(155);
var DeclarationOfSecurity_1 = __webpack_require__(156);
var Measurement_1 = __webpack_require__(11);
var PSixServiceVessel = /** @class */ (function () {
    function PSixServiceVessel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Flag = s_js_1.default.value(null);
        this.FlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagId !== undefined ? data.FlagId : null));
        this.VesselResult = s_js_1.default.value(null);
        this.VesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.Alias = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Alias !== undefined ? data.Alias : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster_1.BowThruster(data.BowThruster) : new BowThruster_1.BowThruster();
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.ConstructionCompleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConstructionCompleted !== undefined ? data.ConstructionCompleted : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Depth = data && data.Depth !== undefined ? new Measurement_1.NullableMeasurement(data.Depth) : new Measurement_1.NullableMeasurement();
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity_1.DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity_1.DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : null));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new Measurement_1.NullableMeasurement(data.MaxDraft) : new Measurement_1.NullableMeasurement();
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.ModifiedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ModifiedOnUtc !== undefined ? new TZDate_1.default(data.ModifiedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.OfficialNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.PortOfRegistry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.StateNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StateNumber !== undefined ? data.StateNumber : null));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
    }
    PSixServiceVessel.key = function (obj) {
        return obj.Id();
    };
    PSixServiceVessel.dataKey = function (obj) {
        return obj.Id;
    };
    PSixServiceVessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.FlagId !== undefined)
                obj.FlagId(data.FlagId);
            if (data.VesselResultId !== undefined)
                obj.VesselResultId(data.VesselResultId);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.Alias !== undefined)
                obj.Alias(data.Alias);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined)
                BowThruster_1.BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.ConstructionCompleted !== undefined)
                obj.ConstructionCompleted(data.ConstructionCompleted);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Depth !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Depth, data.Depth);
            if (data.DOS !== undefined)
                DeclarationOfSecurity_1.DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined)
                obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined)
                obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined)
                obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
            if (data.ModifiedOnUtc !== undefined)
                obj.ModifiedOnUtc(new TZDate_1.default(data.ModifiedOnUtc));
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.OfficialNumber !== undefined)
                obj.OfficialNumber(data.OfficialNumber);
            if (data.PortOfRegistry !== undefined)
                obj.PortOfRegistry(data.PortOfRegistry);
            if (data.StateNumber !== undefined)
                obj.StateNumber(data.StateNumber);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return PSixServiceVessel;
}());
exports.PSixServiceVessel = PSixServiceVessel;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixVesselDimension = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselDimension\ApiPSixVesselDimension.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PSixVesselDimension = /** @class */ (function () {
    function PSixVesselDimension(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DimensionTypeLookupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DimensionTypeLookupId !== undefined ? data.DimensionTypeLookupId : 0));
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselResult = s_js_1.default.value(null);
        this.VesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.BreadthInFeet = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BreadthInFeet !== undefined ? data.BreadthInFeet : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.DepthInFeet = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DepthInFeet !== undefined ? data.DepthInFeet : null));
        this.DimensionTypeLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DimensionTypeLookupName !== undefined ? data.DimensionTypeLookupName : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LengthInFeet = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LengthInFeet !== undefined ? data.LengthInFeet : null));
    }
    PSixVesselDimension.key = function (obj) {
        return obj.Id();
    };
    PSixVesselDimension.dataKey = function (obj) {
        return obj.Id;
    };
    PSixVesselDimension.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.DimensionTypeLookupId !== undefined)
                obj.DimensionTypeLookupId(data.DimensionTypeLookupId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.VesselResultId !== undefined)
                obj.VesselResultId(data.VesselResultId);
            if (data.BreadthInFeet !== undefined)
                obj.BreadthInFeet(data.BreadthInFeet);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.DepthInFeet !== undefined)
                obj.DepthInFeet(data.DepthInFeet);
            if (data.DimensionTypeLookupName !== undefined)
                obj.DimensionTypeLookupName(data.DimensionTypeLookupName);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.LengthInFeet !== undefined)
                obj.LengthInFeet(data.LengthInFeet);
        });
    };
    return PSixVesselDimension;
}());
exports.PSixVesselDimension = PSixVesselDimension;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixVesselParticular = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselParticular\ApiPSixVesselParticular.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PSixVesselParticular = /** @class */ (function () {
    function PSixVesselParticular(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.CountryLookupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CountryLookupId !== undefined ? data.CountryLookupId : null));
        this.IdentificationTypeLookupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IdentificationTypeLookupId !== undefined ? data.IdentificationTypeLookupId : 0));
        this.VesselResult = s_js_1.default.value(null);
        this.CountryLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CountryLookupName !== undefined ? data.CountryLookupName : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Identification = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Identification !== undefined ? data.Identification : null));
        this.IdentificationTypeLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IdentificationTypeLookupName !== undefined ? data.IdentificationTypeLookupName : null));
        this.ServiceType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ServiceType !== undefined ? data.ServiceType : null));
        this.StatusLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusLookupName !== undefined ? data.StatusLookupName : null));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    PSixVesselParticular.key = function (obj) {
        return obj.Id();
    };
    PSixVesselParticular.dataKey = function (obj) {
        return obj.Id;
    };
    PSixVesselParticular.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CountryLookupId !== undefined)
                obj.CountryLookupId(data.CountryLookupId);
            if (data.IdentificationTypeLookupId !== undefined)
                obj.IdentificationTypeLookupId(data.IdentificationTypeLookupId);
            if (data.CountryLookupName !== undefined)
                obj.CountryLookupName(data.CountryLookupName);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Identification !== undefined)
                obj.Identification(data.Identification);
            if (data.IdentificationTypeLookupName !== undefined)
                obj.IdentificationTypeLookupName(data.IdentificationTypeLookupName);
            if (data.ServiceType !== undefined)
                obj.ServiceType(data.ServiceType);
            if (data.StatusLookupName !== undefined)
                obj.StatusLookupName(data.StatusLookupName);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return PSixVesselParticular;
}());
exports.PSixVesselParticular = PSixVesselParticular;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixVesselResult = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselResult\ApiPSixVesselResult.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PSixVesselResult = /** @class */ (function () {
    function PSixVesselResult(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Dimensions = s_array_1.default([]);
        this.PSixVesselParticulars = s_js_1.default.value(null);
        this.ServiceVessels = s_array_1.default([]);
        this.Tonnages = s_array_1.default([]);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselServiceQuery = s_js_1.default.value(null);
        this.VesselServiceQueryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
        this.ConstructionCompletedYear = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConstructionCompletedYear !== undefined ? data.ConstructionCompletedYear : null));
        this.CountryLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CountryLookupName !== undefined ? data.CountryLookupName : null));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.Identification = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Identification !== undefined ? data.Identification : ''));
        this.ManufacturerHullNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ManufacturerHullNumber !== undefined ? data.ManufacturerHullNumber : null));
        this.OutOfServiceDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OutOfServiceDate !== undefined ? data.OutOfServiceDate === null ? null : new TZDate_1.default(data.OutOfServiceDate) : null, TZDate_1.default.nullableEq));
        this.ServiceType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ServiceType !== undefined ? data.ServiceType : null));
        this.StatusLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StatusLookupName !== undefined ? data.StatusLookupName : null));
        this.VesselCallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselCallSign !== undefined ? data.VesselCallSign : null));
        this.VesselName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselName !== undefined ? data.VesselName : null));
    }
    PSixVesselResult.key = function (obj) {
        return obj.Id();
    };
    PSixVesselResult.dataKey = function (obj) {
        return obj.Id;
    };
    PSixVesselResult.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.VesselServiceQueryId !== undefined)
                obj.VesselServiceQueryId(data.VesselServiceQueryId);
            if (data.ConstructionCompletedYear !== undefined)
                obj.ConstructionCompletedYear(data.ConstructionCompletedYear);
            if (data.CountryLookupName !== undefined)
                obj.CountryLookupName(data.CountryLookupName);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined)
                obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.Identification !== undefined)
                obj.Identification(data.Identification);
            if (data.ManufacturerHullNumber !== undefined)
                obj.ManufacturerHullNumber(data.ManufacturerHullNumber);
            if (data.OutOfServiceDate !== undefined)
                obj.OutOfServiceDate(data.OutOfServiceDate === null ? null : new TZDate_1.default(data.OutOfServiceDate));
            if (data.ServiceType !== undefined)
                obj.ServiceType(data.ServiceType);
            if (data.StatusLookupName !== undefined)
                obj.StatusLookupName(data.StatusLookupName);
            if (data.VesselCallSign !== undefined)
                obj.VesselCallSign(data.VesselCallSign);
            if (data.VesselName !== undefined)
                obj.VesselName(data.VesselName);
        });
    };
    return PSixVesselResult;
}());
exports.PSixVesselResult = PSixVesselResult;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PSixVesselTonnage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselTonnage\ApiPSixVesselTonnage.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PSixVesselTonnage = /** @class */ (function () {
    function PSixVesselTonnage(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.PSixVesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PSixVesselResultId !== undefined ? data.PSixVesselResultId : 0));
        this.TonnageTypeLookupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TonnageTypeLookupId !== undefined ? data.TonnageTypeLookupId : 0));
        this.TonnageUnitOfMeasurementFilterLookupId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TonnageUnitOfMeasurementFilterLookupId !== undefined ? data.TonnageUnitOfMeasurementFilterLookupId : 0));
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselResult = s_js_1.default.value(null);
        this.VesselResultId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.CreatedOnUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CreatedOnUtc !== undefined ? new TZDate_1.default(data.CreatedOnUtc) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.MeasureOfWeight = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MeasureOfWeight !== undefined ? data.MeasureOfWeight : null));
        this.TonnageTypeLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TonnageTypeLookupName !== undefined ? data.TonnageTypeLookupName : null));
        this.UnitOfMeasureLookupName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UnitOfMeasureLookupName !== undefined ? data.UnitOfMeasureLookupName : null));
    }
    PSixVesselTonnage.key = function (obj) {
        return obj.Id();
    };
    PSixVesselTonnage.dataKey = function (obj) {
        return obj.Id;
    };
    PSixVesselTonnage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PSixVesselResultId !== undefined)
                obj.PSixVesselResultId(data.PSixVesselResultId);
            if (data.TonnageTypeLookupId !== undefined)
                obj.TonnageTypeLookupId(data.TonnageTypeLookupId);
            if (data.TonnageUnitOfMeasurementFilterLookupId !== undefined)
                obj.TonnageUnitOfMeasurementFilterLookupId(data.TonnageUnitOfMeasurementFilterLookupId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.VesselResultId !== undefined)
                obj.VesselResultId(data.VesselResultId);
            if (data.CreatedOnUtc !== undefined)
                obj.CreatedOnUtc(new TZDate_1.default(data.CreatedOnUtc));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.MeasureOfWeight !== undefined)
                obj.MeasureOfWeight(data.MeasureOfWeight);
            if (data.TonnageTypeLookupName !== undefined)
                obj.TonnageTypeLookupName(data.TonnageTypeLookupName);
            if (data.UnitOfMeasureLookupName !== undefined)
                obj.UnitOfMeasureLookupName(data.UnitOfMeasureLookupName);
        });
    };
    return PSixVesselTonnage;
}());
exports.PSixVesselTonnage = PSixVesselTonnage;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PastExportsBill = exports.PastExportsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\Billing\PastExportsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PastExportsResponse = /** @class */ (function () {
    function PastExportsResponse(data) {
        if (data === void 0) { data = null; }
        this.From = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.From !== undefined ? new TZDate_1.default(data.From) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.To = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.To !== undefined ? new TZDate_1.default(data.To) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.BillingSystem = s_js_1.default.value(null);
        this.Bills = s_array_1.default([]);
    }
    PastExportsResponse.key = function (obj) {
        return obj.From().toJSON() + '\u2618' + obj.Id() + '\u2618' + obj.To().toJSON();
    };
    PastExportsResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.From).toJSON() + '\u2618' + obj.Id + '\u2618' + new TZDate_1.default(obj.To).toJSON();
    };
    PastExportsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.From !== undefined)
                obj.From(new TZDate_1.default(data.From));
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.To !== undefined)
                obj.To(new TZDate_1.default(data.To));
        });
    };
    return PastExportsResponse;
}());
exports.PastExportsResponse = PastExportsResponse;
var PastExportsBill = /** @class */ (function () {
    function PastExportsBill(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Bill = s_js_1.default.value(null);
        this.LastExportDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate) : null, TZDate_1.default.nullableEq));
    }
    PastExportsBill.key = function (obj) {
        return obj.Id();
    };
    PastExportsBill.dataKey = function (obj) {
        return obj.Id;
    };
    PastExportsBill.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.LastExportDate !== undefined)
                obj.LastExportDate(data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate));
        });
    };
    return PastExportsBill;
}());
exports.PastExportsBill = PastExportsBill;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingExportsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\Billing\PendingExportsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PendingExportsResponse = /** @class */ (function () {
    function PendingExportsResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.ExportableDispatchEvents = s_array_1.default([]);
        this.ExportablePilotJobOrders = s_array_1.default([]);
    }
    PendingExportsResponse.key = function (obj) {
        return obj.Id();
    };
    PendingExportsResponse.dataKey = function (obj) {
        return obj.Id;
    };
    PendingExportsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return PendingExportsResponse;
}());
exports.PendingExportsResponse = PendingExportsResponse;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePageResponseRef = exports.PersonProfilePageResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PersonProfilePage\PersonProfilePageViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PersonProfilePageResponse_1 = __webpack_require__(581);
var PersonProfilePageResponse = /** @class */ (function () {
    function PersonProfilePageResponse(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.InvitablePortCallEditors = s_array_1.default([]);
        this.LandingPages = s_array_1.default([]);
        this.Notifications = s_array_1.default([]);
        this.PCUser = s_js_1.default.value(null);
        this.Roles = s_array_1.default([]);
        this.BookingRate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BookingRate !== undefined ? data.BookingRate : null));
        this.CanAdmin = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAdmin !== undefined ? data.CanAdmin : false));
        this.CanChangePassword = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanChangePassword !== undefined ? data.CanChangePassword : false));
        this.CanMarkNotificationsAsViewed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanMarkNotificationsAsViewed !== undefined ? data.CanMarkNotificationsAsViewed : false));
        this.Ref = data && data.Ref !== undefined ? new PersonProfilePageResponse_1.PersonProfilePageResponseRef(data.Ref) : new PersonProfilePageResponse_1.PersonProfilePageResponseRef();
    }
    PersonProfilePageResponse.key = function (obj) {
        return obj.UserId();
    };
    PersonProfilePageResponse.dataKey = function (obj) {
        return obj.UserId;
    };
    PersonProfilePageResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.BookingRate !== undefined)
                obj.BookingRate(data.BookingRate);
            if (data.CanAdmin !== undefined)
                obj.CanAdmin(data.CanAdmin);
            if (data.CanChangePassword !== undefined)
                obj.CanChangePassword(data.CanChangePassword);
            if (data.CanMarkNotificationsAsViewed !== undefined)
                obj.CanMarkNotificationsAsViewed(data.CanMarkNotificationsAsViewed);
            if (data.Ref !== undefined)
                PersonProfilePageResponse_1.PersonProfilePageResponseRef.update(obj.Ref, data.Ref);
        });
    };
    return PersonProfilePageResponse;
}());
exports.PersonProfilePageResponse = PersonProfilePageResponse;
var PersonProfilePageResponseRef = /** @class */ (function () {
    function PersonProfilePageResponseRef(data) {
        if (data === void 0) { data = null; }
        this.DefaultImages = s_array_1.default([]);
        this.AllowedImageUploadExtensions = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AllowedImageUploadExtensions !== undefined ? data.AllowedImageUploadExtensions : []));
        this.MaximumImageUploadFileSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MaximumImageUploadFileSize !== undefined ? data.MaximumImageUploadFileSize : 0));
        this.MinimumImageUploadImageSize = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MinimumImageUploadImageSize !== undefined ? data.MinimumImageUploadImageSize : 0));
    }
    PersonProfilePageResponseRef.key = function (obj) {
        return;
    };
    PersonProfilePageResponseRef.dataKey = function (obj) {
        return;
    };
    PersonProfilePageResponseRef.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.AllowedImageUploadExtensions !== undefined)
                obj.AllowedImageUploadExtensions(data.AllowedImageUploadExtensions);
            if (data.MaximumImageUploadFileSize !== undefined)
                obj.MaximumImageUploadFileSize(data.MaximumImageUploadFileSize);
            if (data.MinimumImageUploadImageSize !== undefined)
                obj.MinimumImageUploadImageSize(data.MinimumImageUploadImageSize);
        });
    };
    return PersonProfilePageResponseRef;
}());
exports.PersonProfilePageResponseRef = PersonProfilePageResponseRef;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonProfilePopupResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PersonProfilePopup\PersonProfilePopupViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PersonProfilePopupResponse = /** @class */ (function () {
    function PersonProfilePopupResponse(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.PCUser = s_js_1.default.value(null);
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }
    PersonProfilePopupResponse.key = function (obj) {
        return obj.UserId();
    };
    PersonProfilePopupResponse.dataKey = function (obj) {
        return obj.UserId;
    };
    PersonProfilePopupResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
        });
    };
    return PersonProfilePopupResponse;
}());
exports.PersonProfilePopupResponse = PersonProfilePopupResponse;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumber = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PhoneNumber\ApiPhoneNumber.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PhoneNumber = /** @class */ (function () {
    function PhoneNumber(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Kind = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Kind !== undefined ? data.Kind : 0));
        this.Number = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Number !== undefined ? data.Number : ''));
    }
    PhoneNumber.key = function (obj) {
        return obj.Id();
    };
    PhoneNumber.dataKey = function (obj) {
        return obj.Id;
    };
    PhoneNumber.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Kind !== undefined)
                obj.Kind(data.Kind);
            if (data.Number !== undefined)
                obj.Number(data.Number);
        });
    };
    return PhoneNumber;
}());
exports.PhoneNumber = PhoneNumber;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PierGroup = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PierGroup\ApiPierGroup.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PierGroup = /** @class */ (function () {
    function PierGroup(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Berths = s_array_1.default([]);
        this.Port = s_js_1.default.value(null);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.AgentChangeWindowHours = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgentChangeWindowHours !== undefined ? data.AgentChangeWindowHours : null));
        this.EndOverhang = data && data.EndOverhang !== undefined ? new Measurement_1.Measurement(data.EndOverhang) : new Measurement_1.Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
        this.PreventAgentOverlaps = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PreventAgentOverlaps !== undefined ? data.PreventAgentOverlaps : false));
        this.RequireKnownVessels = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequireKnownVessels !== undefined ? data.RequireKnownVessels : false));
        this.StartOverhang = data && data.StartOverhang !== undefined ? new Measurement_1.Measurement(data.StartOverhang) : new Measurement_1.Measurement();
    }
    PierGroup.key = function (obj) {
        return obj.Id();
    };
    PierGroup.dataKey = function (obj) {
        return obj.Id;
    };
    PierGroup.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.AgentChangeWindowHours !== undefined)
                obj.AgentChangeWindowHours(data.AgentChangeWindowHours);
            if (data.EndOverhang !== undefined)
                Measurement_1.Measurement.update(obj.EndOverhang, data.EndOverhang);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.Order !== undefined)
                obj.Order(data.Order);
            if (data.PreventAgentOverlaps !== undefined)
                obj.PreventAgentOverlaps(data.PreventAgentOverlaps);
            if (data.RequireKnownVessels !== undefined)
                obj.RequireKnownVessels(data.RequireKnownVessels);
            if (data.StartOverhang !== undefined)
                Measurement_1.Measurement.update(obj.StartOverhang, data.StartOverhang);
        });
    };
    return PierGroup;
}());
exports.PierGroup = PierGroup;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PierSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\PierSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PierSettings = /** @class */ (function () {
    function PierSettings(data) {
        if (data === void 0) { data = null; }
        this.DefaultDepthUOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultDepthUOM !== undefined ? data.DefaultDepthUOM : null));
        this.DefaultLengthUOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DefaultLengthUOM !== undefined ? data.DefaultLengthUOM : null));
    }
    PierSettings.key = function (obj) {
        return;
    };
    PierSettings.dataKey = function (obj) {
        return;
    };
    PierSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.DefaultDepthUOM !== undefined)
                obj.DefaultDepthUOM(data.DefaultDepthUOM);
            if (data.DefaultLengthUOM !== undefined)
                obj.DefaultLengthUOM(data.DefaultLengthUOM);
        });
    };
    return PierSettings;
}());
exports.PierSettings = PierSettings;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Pilot = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\Pilot\ApiPilot.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Pilot = /** @class */ (function () {
    function Pilot(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PilotJobOrders = s_array_1.default([]);
        this.Section = s_js_1.default.value(null);
        this.SectionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SectionId !== undefined ? data.SectionId : null));
        this.User = s_js_1.default.value(null);
        this.Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Code !== undefined ? data.Code : null));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
    }
    Pilot.key = function (obj) {
        return obj.Id();
    };
    Pilot.dataKey = function (obj) {
        return obj.Id;
    };
    Pilot.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.SectionId !== undefined)
                obj.SectionId(data.SectionId);
            if (data.Code !== undefined)
                obj.Code(data.Code);
            if (data.Order !== undefined)
                obj.Order(data.Order);
        });
    };
    return Pilot;
}());
exports.Pilot = Pilot;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotAgency = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotAgency\ApiPilotAgency.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PilotAgency = /** @class */ (function () {
    function PilotAgency(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AgencyCodes = s_array_1.default([]);
        this.DispatchEvents = s_array_1.default([]);
        this.DispatchEventsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DispatchEventsUrl !== undefined ? data.DispatchEventsUrl : null));
        this.JobOrders = s_array_1.default([]);
        this.LineHandlingCompanies = s_array_1.default([]);
        this.LineHandlingCompaniesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LineHandlingCompaniesUrl !== undefined ? data.LineHandlingCompaniesUrl : null));
        this.Organization = s_js_1.default.value(null);
        this.Sections = s_array_1.default([]);
        this.SectionsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SectionsUrl !== undefined ? data.SectionsUrl : null));
        this.TugCompanies = s_array_1.default([]);
        this.TugCompaniesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TugCompaniesUrl !== undefined ? data.TugCompaniesUrl : null));
        this.AgencyCodesUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgencyCodesUrlBase !== undefined ? data.AgencyCodesUrlBase : null));
    }
    PilotAgency.key = function (obj) {
        return obj.Id();
    };
    PilotAgency.dataKey = function (obj) {
        return obj.Id;
    };
    PilotAgency.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.DispatchEventsUrl !== undefined)
                obj.DispatchEventsUrl(data.DispatchEventsUrl);
            if (data.LineHandlingCompaniesUrl !== undefined)
                obj.LineHandlingCompaniesUrl(data.LineHandlingCompaniesUrl);
            if (data.SectionsUrl !== undefined)
                obj.SectionsUrl(data.SectionsUrl);
            if (data.TugCompaniesUrl !== undefined)
                obj.TugCompaniesUrl(data.TugCompaniesUrl);
            if (data.AgencyCodesUrlBase !== undefined)
                obj.AgencyCodesUrlBase(data.AgencyCodesUrlBase);
        });
    };
    return PilotAgency;
}());
exports.PilotAgency = PilotAgency;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotAssignment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotAssignment\ApiPilotAssignment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotAssignment = /** @class */ (function () {
    function PilotAssignment(data) {
        if (data === void 0) { data = null; }
        this.PilotId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotId !== undefined ? data.PilotId : 0));
        this.PilotJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Pilot = s_js_1.default.value(null);
        this.PilotJobOrder = s_js_1.default.value(null);
        this.AssignmentOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AssignmentOrder !== undefined ? data.AssignmentOrder : 0));
        this.PilotConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotConfirmed !== undefined ? data.PilotConfirmed : false));
    }
    PilotAssignment.key = function (obj) {
        return obj.PilotId() + '\u2618' + obj.PilotJobOrderId();
    };
    PilotAssignment.dataKey = function (obj) {
        return obj.PilotId + '\u2618' + obj.PilotJobOrderId;
    };
    PilotAssignment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PilotId !== undefined)
                obj.PilotId(data.PilotId);
            if (data.PilotJobOrderId !== undefined)
                obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AssignmentOrder !== undefined)
                obj.AssignmentOrder(data.AssignmentOrder);
            if (data.PilotConfirmed !== undefined)
                obj.PilotConfirmed(data.PilotConfirmed);
        });
    };
    return PilotAssignment;
}());
exports.PilotAssignment = PilotAssignment;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrder = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrder\ApiPilotJobOrder.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var ScheduleDate_1 = __webpack_require__(93);
var PilotJobOrder = /** @class */ (function () {
    function PilotJobOrder(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this._approvalsOfCharges = s_array_1.default([]);
        this.Bills = s_array_1.default([]);
        this.Cancellation = s_js_1.default.value(null);
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = s_array_1.default([]);
        this.FromPoint = s_js_1.default.value(null);
        this.FromPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.Issues = s_array_1.default([]);
        this.JobOrder = s_js_1.default.value(null);
        this.LineHandlingCompany = s_js_1.default.value(null);
        this.LineHandlingCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LineHandlingCompanyId !== undefined ? data.LineHandlingCompanyId : null));
        this.Log = s_array_1.default([]);
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Pilots = s_array_1.default([]);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Schedule = s_array_1.default([]);
        this.Self = s_js_1.default.value(null);
        this.ToPoint = s_js_1.default.value(null);
        this.ToPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TugCompany = s_js_1.default.value(null);
        this.TugCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TugCompanyId !== undefined ? data.TugCompanyId : null));
        this.UserPreferences = s_array_1.default([]);
        this.Version = s_js_1.default.value(null);
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.AcknowledgedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AcknowledgedDate !== undefined ? data.AcknowledgedDate === null ? null : new TZDate_1.default(data.AcknowledgedDate) : null, TZDate_1.default.nullableEq));
        this.AirDraft = data && data.AirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.AirDraft) : new Measurement_1.NullableMeasurement();
        this.Billable = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Billable !== undefined ? data.Billable : false));
        this.BillToAddress = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillToAddress !== undefined ? data.BillToAddress : null));
        this.BillToAgent = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillToAgent !== undefined ? data.BillToAgent : false));
        this.BowThrusterOperational = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BowThrusterOperational !== undefined ? data.BowThrusterOperational : null));
        this.DeepDraft = data && data.DeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.DeepDraft) : new Measurement_1.NullableMeasurement();
        this.DeepDraftConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DeepDraftConfirmed !== undefined ? data.DeepDraftConfirmed : false));
        this.End = data && data.End !== undefined ? new ScheduleDate_1.ScheduleDate(data.End) : new ScheduleDate_1.ScheduleDate();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LaborStartTime = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LaborStartTime !== undefined ? data.LaborStartTime === null ? null : new TZDate_1.default(data.LaborStartTime) : null, TZDate_1.default.nullableEq));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.NumberOfTugs = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NumberOfTugs !== undefined ? data.NumberOfTugs : 0));
        this.PilotsUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotsUrlBase !== undefined ? data.PilotsUrlBase : null));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.Start = data && data.Start !== undefined ? new ScheduleDate_1.ScheduleDate(data.Start) : new ScheduleDate_1.ScheduleDate();
        this.StartTimeConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StartTimeConfirmed !== undefined ? data.StartTimeConfirmed : false));
        this.UserPreferencesUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserPreferencesUrlBase !== undefined ? data.UserPreferencesUrlBase : null));
    }
    PilotJobOrder.key = function (obj) {
        return obj.Id();
    };
    PilotJobOrder.dataKey = function (obj) {
        return obj.Id;
    };
    PilotJobOrder.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.FromPointId !== undefined)
                obj.FromPointId(data.FromPointId);
            if (data.LineHandlingCompanyId !== undefined)
                obj.LineHandlingCompanyId(data.LineHandlingCompanyId);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.ToPointId !== undefined)
                obj.ToPointId(data.ToPointId);
            if (data.TugCompanyId !== undefined)
                obj.TugCompanyId(data.TugCompanyId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.AcknowledgedDate !== undefined)
                obj.AcknowledgedDate(data.AcknowledgedDate === null ? null : new TZDate_1.default(data.AcknowledgedDate));
            if (data.AirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.Billable !== undefined)
                obj.Billable(data.Billable);
            if (data.BillToAddress !== undefined)
                obj.BillToAddress(data.BillToAddress);
            if (data.BillToAgent !== undefined)
                obj.BillToAgent(data.BillToAgent);
            if (data.BowThrusterOperational !== undefined)
                obj.BowThrusterOperational(data.BowThrusterOperational);
            if (data.DeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.DeepDraftConfirmed !== undefined)
                obj.DeepDraftConfirmed(data.DeepDraftConfirmed);
            if (data.End !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.End, data.End);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.LaborStartTime !== undefined)
                obj.LaborStartTime(data.LaborStartTime === null ? null : new TZDate_1.default(data.LaborStartTime));
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.NumberOfTugs !== undefined)
                obj.NumberOfTugs(data.NumberOfTugs);
            if (data.PilotsUrlBase !== undefined)
                obj.PilotsUrlBase(data.PilotsUrlBase);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.Start !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Start, data.Start);
            if (data.StartTimeConfirmed !== undefined)
                obj.StartTimeConfirmed(data.StartTimeConfirmed);
            if (data.UserPreferencesUrlBase !== undefined)
                obj.UserPreferencesUrlBase(data.UserPreferencesUrlBase);
        });
    };
    return PilotJobOrder;
}());
exports.PilotJobOrder = PilotJobOrder;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderCancellation = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderCancellation\ApiPilotJobOrderCancellation.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotJobOrderCancellation = /** @class */ (function () {
    function PilotJobOrderCancellation(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.PointInTime = s_js_1.default.value(null);
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
    }
    PilotJobOrderCancellation.key = function (obj) {
        return obj.Id();
    };
    PilotJobOrderCancellation.dataKey = function (obj) {
        return obj.Id;
    };
    PilotJobOrderCancellation.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
        });
    };
    return PilotJobOrderCancellation;
}());
exports.PilotJobOrderCancellation = PilotJobOrderCancellation;


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderChange = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderChange\ApiPilotJobOrderChange.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PilotJobOrderChange = /** @class */ (function () {
    function PilotJobOrderChange(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Agent = s_js_1.default.value(null);
        this.AgentId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.FromLocation = s_js_1.default.value(null);
        this.FromLocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromLocationId !== undefined ? data.FromLocationId : 0));
        this.NewLineHandlingCompany = s_js_1.default.value(null);
        this.NewLineHandlingCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewLineHandlingCompanyId !== undefined ? data.NewLineHandlingCompanyId : null));
        this.NewTugCompany = s_js_1.default.value(null);
        this.NewTugCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewTugCompanyId !== undefined ? data.NewTugCompanyId : null));
        this.OldLineHandlingCompany = s_js_1.default.value(null);
        this.OldLineHandlingCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldLineHandlingCompanyId !== undefined ? data.OldLineHandlingCompanyId : null));
        this.OldTugCompany = s_js_1.default.value(null);
        this.OldTugCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldTugCompanyId !== undefined ? data.OldTugCompanyId : null));
        this.Pilot = s_js_1.default.value(null);
        this.PilotId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotId !== undefined ? data.PilotId : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.PilotJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.ToLocation = s_js_1.default.value(null);
        this.ToLocationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToLocationId !== undefined ? data.ToLocationId : 0));
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.Action = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Action !== undefined ? data.Action : 0));
        this.EndEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EndEstimated !== undefined ? new TZDate_1.default(data.EndEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.NewAirDraft = data && data.NewAirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.NewAirDraft) : new Measurement_1.NullableMeasurement();
        this.NewBowThrusterOperational = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewBowThrusterOperational !== undefined ? data.NewBowThrusterOperational : null));
        this.NewCancelledDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewCancelledDate !== undefined ? data.NewCancelledDate === null ? null : new TZDate_1.default(data.NewCancelledDate) : null, TZDate_1.default.nullableEq));
        this.NewDeepDraft = data && data.NewDeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.NewDeepDraft) : new Measurement_1.NullableMeasurement();
        this.NewDeepDraftConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewDeepDraftConfirmed !== undefined ? data.NewDeepDraftConfirmed : false));
        this.NewEndActual = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewEndActual !== undefined ? data.NewEndActual === null ? null : new TZDate_1.default(data.NewEndActual) : null, TZDate_1.default.nullableEq));
        this.NewEndEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewEndEstimated !== undefined ? new TZDate_1.default(data.NewEndEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.NewLaborStartTime = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewLaborStartTime !== undefined ? data.NewLaborStartTime === null ? null : new TZDate_1.default(data.NewLaborStartTime) : null, TZDate_1.default.nullableEq));
        this.NewPilotConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewPilotConfirmed !== undefined ? data.NewPilotConfirmed : false));
        this.NewRemarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewRemarks !== undefined ? data.NewRemarks : null));
        this.NewStartActual = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewStartActual !== undefined ? data.NewStartActual === null ? null : new TZDate_1.default(data.NewStartActual) : null, TZDate_1.default.nullableEq));
        this.NewStartEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewStartEstimated !== undefined ? new TZDate_1.default(data.NewStartEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.NewStartTimeConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewStartTimeConfirmed !== undefined ? data.NewStartTimeConfirmed : false));
        this.OldAirDraft = data && data.OldAirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.OldAirDraft) : new Measurement_1.NullableMeasurement();
        this.OldBowThrusterOperational = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldBowThrusterOperational !== undefined ? data.OldBowThrusterOperational : null));
        this.OldCancelledDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldCancelledDate !== undefined ? data.OldCancelledDate === null ? null : new TZDate_1.default(data.OldCancelledDate) : null, TZDate_1.default.nullableEq));
        this.OldDeepDraft = data && data.OldDeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.OldDeepDraft) : new Measurement_1.NullableMeasurement();
        this.OldEndActual = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldEndActual !== undefined ? data.OldEndActual === null ? null : new TZDate_1.default(data.OldEndActual) : null, TZDate_1.default.nullableEq));
        this.OldEndEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldEndEstimated !== undefined ? new TZDate_1.default(data.OldEndEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OldLaborStartTime = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldLaborStartTime !== undefined ? data.OldLaborStartTime === null ? null : new TZDate_1.default(data.OldLaborStartTime) : null, TZDate_1.default.nullableEq));
        this.OldRemarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldRemarks !== undefined ? data.OldRemarks : null));
        this.OldStartActual = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldStartActual !== undefined ? data.OldStartActual === null ? null : new TZDate_1.default(data.OldStartActual) : null, TZDate_1.default.nullableEq));
        this.OldStartEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldStartEstimated !== undefined ? new TZDate_1.default(data.OldStartEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.StartEstimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StartEstimated !== undefined ? new TZDate_1.default(data.StartEstimated) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    PilotJobOrderChange.key = function (obj) {
        return obj.Id();
    };
    PilotJobOrderChange.dataKey = function (obj) {
        return obj.Id;
    };
    PilotJobOrderChange.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AgentId !== undefined)
                obj.AgentId(data.AgentId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.FromLocationId !== undefined)
                obj.FromLocationId(data.FromLocationId);
            if (data.NewLineHandlingCompanyId !== undefined)
                obj.NewLineHandlingCompanyId(data.NewLineHandlingCompanyId);
            if (data.NewTugCompanyId !== undefined)
                obj.NewTugCompanyId(data.NewTugCompanyId);
            if (data.OldLineHandlingCompanyId !== undefined)
                obj.OldLineHandlingCompanyId(data.OldLineHandlingCompanyId);
            if (data.OldTugCompanyId !== undefined)
                obj.OldTugCompanyId(data.OldTugCompanyId);
            if (data.PilotId !== undefined)
                obj.PilotId(data.PilotId);
            if (data.PilotJobOrderId !== undefined)
                obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.ToLocationId !== undefined)
                obj.ToLocationId(data.ToLocationId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.Action !== undefined)
                obj.Action(data.Action);
            if (data.EndEstimated !== undefined)
                obj.EndEstimated(new TZDate_1.default(data.EndEstimated));
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.NewAirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.NewAirDraft, data.NewAirDraft);
            if (data.NewBowThrusterOperational !== undefined)
                obj.NewBowThrusterOperational(data.NewBowThrusterOperational);
            if (data.NewCancelledDate !== undefined)
                obj.NewCancelledDate(data.NewCancelledDate === null ? null : new TZDate_1.default(data.NewCancelledDate));
            if (data.NewDeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.NewDeepDraft, data.NewDeepDraft);
            if (data.NewDeepDraftConfirmed !== undefined)
                obj.NewDeepDraftConfirmed(data.NewDeepDraftConfirmed);
            if (data.NewEndActual !== undefined)
                obj.NewEndActual(data.NewEndActual === null ? null : new TZDate_1.default(data.NewEndActual));
            if (data.NewEndEstimated !== undefined)
                obj.NewEndEstimated(new TZDate_1.default(data.NewEndEstimated));
            if (data.NewLaborStartTime !== undefined)
                obj.NewLaborStartTime(data.NewLaborStartTime === null ? null : new TZDate_1.default(data.NewLaborStartTime));
            if (data.NewPilotConfirmed !== undefined)
                obj.NewPilotConfirmed(data.NewPilotConfirmed);
            if (data.NewRemarks !== undefined)
                obj.NewRemarks(data.NewRemarks);
            if (data.NewStartActual !== undefined)
                obj.NewStartActual(data.NewStartActual === null ? null : new TZDate_1.default(data.NewStartActual));
            if (data.NewStartEstimated !== undefined)
                obj.NewStartEstimated(new TZDate_1.default(data.NewStartEstimated));
            if (data.NewStartTimeConfirmed !== undefined)
                obj.NewStartTimeConfirmed(data.NewStartTimeConfirmed);
            if (data.OldAirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.OldAirDraft, data.OldAirDraft);
            if (data.OldBowThrusterOperational !== undefined)
                obj.OldBowThrusterOperational(data.OldBowThrusterOperational);
            if (data.OldCancelledDate !== undefined)
                obj.OldCancelledDate(data.OldCancelledDate === null ? null : new TZDate_1.default(data.OldCancelledDate));
            if (data.OldDeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.OldDeepDraft, data.OldDeepDraft);
            if (data.OldEndActual !== undefined)
                obj.OldEndActual(data.OldEndActual === null ? null : new TZDate_1.default(data.OldEndActual));
            if (data.OldEndEstimated !== undefined)
                obj.OldEndEstimated(new TZDate_1.default(data.OldEndEstimated));
            if (data.OldLaborStartTime !== undefined)
                obj.OldLaborStartTime(data.OldLaborStartTime === null ? null : new TZDate_1.default(data.OldLaborStartTime));
            if (data.OldRemarks !== undefined)
                obj.OldRemarks(data.OldRemarks);
            if (data.OldStartActual !== undefined)
                obj.OldStartActual(data.OldStartActual === null ? null : new TZDate_1.default(data.OldStartActual));
            if (data.OldStartEstimated !== undefined)
                obj.OldStartEstimated(new TZDate_1.default(data.OldStartEstimated));
            if (data.StartEstimated !== undefined)
                obj.StartEstimated(new TZDate_1.default(data.StartEstimated));
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return PilotJobOrderChange;
}());
exports.PilotJobOrderChange = PilotJobOrderChange;


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderDetails = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotJobOrderDetails\PilotJobOrderDetailsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PilotJobOrderDetails = /** @class */ (function () {
    function PilotJobOrderDetails(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.AssignablePilotIds = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AssignablePilotIds !== undefined ? data.AssignablePilotIds : []));
        this.CanAcknowledge = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAcknowledge !== undefined ? data.CanAcknowledge : false));
        this.CanAddShift = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAddShift !== undefined ? data.CanAddShift : false));
        this.CanAddShiphandlingNote = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAddShiphandlingNote !== undefined ? data.CanAddShiphandlingNote : false));
        this.CanCancel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanCancel !== undefined ? data.CanCancel : false));
        this.CanChangeVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanChangeVessel !== undefined ? data.CanChangeVessel : false));
        this.CanDelete = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanDelete !== undefined ? data.CanDelete : false));
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditBowThrusterOperational = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditBowThrusterOperational !== undefined ? data.CanEditBowThrusterOperational : false));
        this.CanEditDeepDraftConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditDeepDraftConfirmed !== undefined ? data.CanEditDeepDraftConfirmed : false));
        this.CanEditDrafts = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditDrafts !== undefined ? data.CanEditDrafts : false));
        this.CanEditPortCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditPortCall !== undefined ? data.CanEditPortCall : false));
        this.CanEditServices = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditServices !== undefined ? data.CanEditServices : false));
        this.CanEditStartTimeConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditStartTimeConfirmed !== undefined ? data.CanEditStartTimeConfirmed : false));
        this.CanEditTimes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditTimes !== undefined ? data.CanEditTimes : false));
        this.CanEditVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditVessel !== undefined ? data.CanEditVessel : false));
        this.CanManageBills = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageBills !== undefined ? data.CanManageBills : false));
        this.CanViewFullPilotAssignments = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanViewFullPilotAssignments !== undefined ? data.CanViewFullPilotAssignments : false));
    }
    PilotJobOrderDetails.key = function (obj) {
        return obj.Id();
    };
    PilotJobOrderDetails.dataKey = function (obj) {
        return obj.Id;
    };
    PilotJobOrderDetails.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AssignablePilotIds !== undefined)
                obj.AssignablePilotIds(data.AssignablePilotIds);
            if (data.CanAcknowledge !== undefined)
                obj.CanAcknowledge(data.CanAcknowledge);
            if (data.CanAddShift !== undefined)
                obj.CanAddShift(data.CanAddShift);
            if (data.CanAddShiphandlingNote !== undefined)
                obj.CanAddShiphandlingNote(data.CanAddShiphandlingNote);
            if (data.CanCancel !== undefined)
                obj.CanCancel(data.CanCancel);
            if (data.CanChangeVessel !== undefined)
                obj.CanChangeVessel(data.CanChangeVessel);
            if (data.CanDelete !== undefined)
                obj.CanDelete(data.CanDelete);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
            if (data.CanEditBowThrusterOperational !== undefined)
                obj.CanEditBowThrusterOperational(data.CanEditBowThrusterOperational);
            if (data.CanEditDeepDraftConfirmed !== undefined)
                obj.CanEditDeepDraftConfirmed(data.CanEditDeepDraftConfirmed);
            if (data.CanEditDrafts !== undefined)
                obj.CanEditDrafts(data.CanEditDrafts);
            if (data.CanEditPortCall !== undefined)
                obj.CanEditPortCall(data.CanEditPortCall);
            if (data.CanEditServices !== undefined)
                obj.CanEditServices(data.CanEditServices);
            if (data.CanEditStartTimeConfirmed !== undefined)
                obj.CanEditStartTimeConfirmed(data.CanEditStartTimeConfirmed);
            if (data.CanEditTimes !== undefined)
                obj.CanEditTimes(data.CanEditTimes);
            if (data.CanEditVessel !== undefined)
                obj.CanEditVessel(data.CanEditVessel);
            if (data.CanManageBills !== undefined)
                obj.CanManageBills(data.CanManageBills);
            if (data.CanViewFullPilotAssignments !== undefined)
                obj.CanViewFullPilotAssignments(data.CanViewFullPilotAssignments);
        });
    };
    return PilotJobOrderDetails;
}());
exports.PilotJobOrderDetails = PilotJobOrderDetails;


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderDetailsBilling = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotJobOrderDetails\PilotJobOrderDetailsBillingViewModel.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var PilotJobOrderDetailsBilling = /** @class */ (function () {
    function PilotJobOrderDetailsBilling(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.DraftCharges = s_js_1.default.value(null);
        this.PilotJobOrder = s_js_1.default.value(null);
        this.LastExportDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate) : null, TZDate_1.default.nullableEq));
    }
    PilotJobOrderDetailsBilling.key = function (obj) {
        return obj.Id();
    };
    PilotJobOrderDetailsBilling.dataKey = function (obj) {
        return obj.Id;
    };
    PilotJobOrderDetailsBilling.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.LastExportDate !== undefined)
                obj.LastExportDate(data.LastExportDate === null ? null : new TZDate_1.default(data.LastExportDate));
        });
    };
    return PilotJobOrderDetailsBilling;
}());
exports.PilotJobOrderDetailsBilling = PilotJobOrderDetailsBilling;


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderRelevance = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderRelevance\ApiPilotJobOrderRelevance.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotJobOrderRelevance = /** @class */ (function () {
    function PilotJobOrderRelevance(data) {
        if (data === void 0) { data = null; }
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.PilotJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.Event = s_js_1.default.value(null);
        this.PilotJobOrder = s_js_1.default.value(null);
    }
    PilotJobOrderRelevance.key = function (obj) {
        return obj.EventId() + '\u2618' + obj.PilotJobOrderId();
    };
    PilotJobOrderRelevance.dataKey = function (obj) {
        return obj.EventId + '\u2618' + obj.PilotJobOrderId;
    };
    PilotJobOrderRelevance.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.PilotJobOrderId !== undefined)
                obj.PilotJobOrderId(data.PilotJobOrderId);
        });
    };
    return PilotJobOrderRelevance;
}());
exports.PilotJobOrderRelevance = PilotJobOrderRelevance;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderUserPreferences = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderUserPreferences\ApiPilotJobOrderUserPreferences.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotJobOrderUserPreferences = /** @class */ (function () {
    function PilotJobOrderUserPreferences(data) {
        if (data === void 0) { data = null; }
        this.PilotJobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.PilotJobOrder = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
        this.RemarksVisible = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RemarksVisible !== undefined ? data.RemarksVisible : false));
    }
    PilotJobOrderUserPreferences.key = function (obj) {
        return obj.PilotJobOrderId() + '\u2618' + obj.UserId();
    };
    PilotJobOrderUserPreferences.dataKey = function (obj) {
        return obj.PilotJobOrderId + '\u2618' + obj.UserId;
    };
    PilotJobOrderUserPreferences.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PilotJobOrderId !== undefined)
                obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.RemarksVisible !== undefined)
                obj.RemarksVisible(data.RemarksVisible);
        });
    };
    return PilotJobOrderUserPreferences;
}());
exports.PilotJobOrderUserPreferences = PilotJobOrderUserPreferences;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotJobOrderVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrder\ApiPilotJobOrderVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var ScheduleDate_1 = __webpack_require__(93);
var PilotJobOrderVersion = /** @class */ (function () {
    function PilotJobOrderVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.FromPoint = s_js_1.default.value(null);
        this.FromPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.LineHandlingCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LineHandlingCompanyId !== undefined ? data.LineHandlingCompanyId : null));
        this.NextVersion = s_array_1.default([]);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.ToPoint = s_js_1.default.value(null);
        this.ToPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TugCompanyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TugCompanyId !== undefined ? data.TugCompanyId : null));
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.AcknowledgedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AcknowledgedDate !== undefined ? data.AcknowledgedDate === null ? null : new TZDate_1.default(data.AcknowledgedDate) : null, TZDate_1.default.nullableEq));
        this.AirDraft = data && data.AirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.AirDraft) : new Measurement_1.NullableMeasurement();
        this.Billable = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Billable !== undefined ? data.Billable : false));
        this.BillToAddress = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillToAddress !== undefined ? data.BillToAddress : null));
        this.BillToAgent = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillToAgent !== undefined ? data.BillToAgent : false));
        this.BowThrusterOperational = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BowThrusterOperational !== undefined ? data.BowThrusterOperational : null));
        this.DeepDraft = data && data.DeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.DeepDraft) : new Measurement_1.NullableMeasurement();
        this.DeepDraftConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DeepDraftConfirmed !== undefined ? data.DeepDraftConfirmed : false));
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.End = data && data.End !== undefined ? new ScheduleDate_1.ScheduleDate(data.End) : new ScheduleDate_1.ScheduleDate();
        this.ExtraDataJSON = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LaborStartTime = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LaborStartTime !== undefined ? data.LaborStartTime === null ? null : new TZDate_1.default(data.LaborStartTime) : null, TZDate_1.default.nullableEq));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.NumberOfTugs = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NumberOfTugs !== undefined ? data.NumberOfTugs : 0));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.Start = data && data.Start !== undefined ? new ScheduleDate_1.ScheduleDate(data.Start) : new ScheduleDate_1.ScheduleDate();
        this.StartTimeConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StartTimeConfirmed !== undefined ? data.StartTimeConfirmed : false));
    }
    PilotJobOrderVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    PilotJobOrderVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    PilotJobOrderVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.FromPointId !== undefined)
                obj.FromPointId(data.FromPointId);
            if (data.LineHandlingCompanyId !== undefined)
                obj.LineHandlingCompanyId(data.LineHandlingCompanyId);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.ToPointId !== undefined)
                obj.ToPointId(data.ToPointId);
            if (data.TugCompanyId !== undefined)
                obj.TugCompanyId(data.TugCompanyId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.AcknowledgedDate !== undefined)
                obj.AcknowledgedDate(data.AcknowledgedDate === null ? null : new TZDate_1.default(data.AcknowledgedDate));
            if (data.AirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.Billable !== undefined)
                obj.Billable(data.Billable);
            if (data.BillToAddress !== undefined)
                obj.BillToAddress(data.BillToAddress);
            if (data.BillToAgent !== undefined)
                obj.BillToAgent(data.BillToAgent);
            if (data.BowThrusterOperational !== undefined)
                obj.BowThrusterOperational(data.BowThrusterOperational);
            if (data.DeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.DeepDraftConfirmed !== undefined)
                obj.DeepDraftConfirmed(data.DeepDraftConfirmed);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.End !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.End, data.End);
            if (data.ExtraDataJSON !== undefined)
                obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.LaborStartTime !== undefined)
                obj.LaborStartTime(data.LaborStartTime === null ? null : new TZDate_1.default(data.LaborStartTime));
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.NumberOfTugs !== undefined)
                obj.NumberOfTugs(data.NumberOfTugs);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.Start !== undefined)
                ScheduleDate_1.ScheduleDate.update(obj.Start, data.Start);
            if (data.StartTimeConfirmed !== undefined)
                obj.StartTimeConfirmed(data.StartTimeConfirmed);
        });
    };
    return PilotJobOrderVersion;
}());
exports.PilotJobOrderVersion = PilotJobOrderVersion;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotSection = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotSection\ApiPilotSection.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PilotSection = /** @class */ (function () {
    function PilotSection(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Pilots = s_array_1.default([]);
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
    }
    PilotSection.key = function (obj) {
        return obj.Id();
    };
    PilotSection.dataKey = function (obj) {
        return obj.Id;
    };
    PilotSection.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Order !== undefined)
                obj.Order(data.Order);
        });
    };
    return PilotSection;
}());
exports.PilotSection = PilotSection;


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotShiphandlingNote = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotShiphandlingNote\ApiPilotShiphandlingNote.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotShiphandlingNote = /** @class */ (function () {
    function PilotShiphandlingNote(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.Noter = s_js_1.default.value(null);
        this.NoterId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NoterId !== undefined ? data.NoterId : 0));
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.Message = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Message !== undefined ? data.Message : null));
    }
    PilotShiphandlingNote.key = function (obj) {
        return obj.Id();
    };
    PilotShiphandlingNote.dataKey = function (obj) {
        return obj.Id;
    };
    PilotShiphandlingNote.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.NoterId !== undefined)
                obj.NoterId(data.NoterId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.Message !== undefined)
                obj.Message(data.Message);
        });
    };
    return PilotShiphandlingNote;
}());
exports.PilotShiphandlingNote = PilotShiphandlingNote;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsDataCacheUpdateEntities = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\DataCache\PilotsDataCacheUpdateEntities.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var PilotsDataCacheUpdateEntities = /** @class */ (function () {
    function PilotsDataCacheUpdateEntities(data) {
        if (data === void 0) { data = null; }
        this.PilotAgencies = s_array_1.default([]);
        this.PilotAssignments = s_array_1.default([]);
        this.PilotJobOrderChanges = s_array_1.default([]);
        this.PilotJobOrderRelevances = s_array_1.default([]);
        this.PilotJobOrders = s_array_1.default([]);
        this.PilotJobOrderVersions = s_array_1.default([]);
        this.Pilots = s_array_1.default([]);
        this.PilotSections = s_array_1.default([]);
        this.PilotShiphandlingNotes = s_array_1.default([]);
    }
    PilotsDataCacheUpdateEntities.key = function (obj) {
        return;
    };
    PilotsDataCacheUpdateEntities.dataKey = function (obj) {
        return;
    };
    PilotsDataCacheUpdateEntities.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return PilotsDataCacheUpdateEntities;
}());
exports.PilotsDataCacheUpdateEntities = PilotsDataCacheUpdateEntities;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsInitialData = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Extensions\PilotsInitialDataExtension.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PilotsInitialData = /** @class */ (function () {
    function PilotsInitialData(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.InitialData = s_js_1.default.value(null);
        this.PilotAgencies = s_array_1.default([]);
        this.Pilots = s_array_1.default([]);
    }
    PilotsInitialData.key = function (obj) {
        return obj.Id();
    };
    PilotsInitialData.dataKey = function (obj) {
        return obj.Id;
    };
    PilotsInitialData.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return PilotsInitialData;
}());
exports.PilotsInitialData = PilotsInitialData;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsMorePage = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Extensions\PilotsMorePageExtension.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PilotsMorePage = /** @class */ (function () {
    function PilotsMorePage(data) {
        if (data === void 0) { data = null; }
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.MorePage = s_js_1.default.value(null);
        this.CanManageSettingsAgencies = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.CanManageSettingsAgencies !== undefined ? data.CanManageSettingsAgencies : []));
    }
    PilotsMorePage.key = function (obj) {
        return obj.UserId();
    };
    PilotsMorePage.dataKey = function (obj) {
        return obj.UserId;
    };
    PilotsMorePage.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.CanManageSettingsAgencies !== undefined)
                obj.CanManageSettingsAgencies(data.CanManageSettingsAgencies);
        });
    };
    return PilotsMorePage;
}());
exports.PilotsMorePage = PilotsMorePage;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PilotsNavbar = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotsNavbar\PilotsNavbarViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PilotsNavbar = /** @class */ (function () {
    function PilotsNavbar(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AcknowledgeCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AcknowledgeCount !== undefined ? data.AcknowledgeCount : 0));
        this.CanViewRotation = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanViewRotation !== undefined ? data.CanViewRotation : false));
    }
    PilotsNavbar.key = function (obj) {
        return obj.Id();
    };
    PilotsNavbar.dataKey = function (obj) {
        return obj.Id;
    };
    PilotsNavbar.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AcknowledgeCount !== undefined)
                obj.AcknowledgeCount(data.AcknowledgeCount);
            if (data.CanViewRotation !== undefined)
                obj.CanViewRotation(data.CanViewRotation);
        });
    };
    return PilotsNavbar;
}());
exports.PilotsNavbar = PilotsNavbar;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Port = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Port\ApiPort.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Port = /** @class */ (function () {
    function Port(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Domain = s_js_1.default.value(null);
        this.DomainId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Locations = s_array_1.default([]);
        this.PierGroups = s_array_1.default([]);
        this.PortCalls = s_array_1.default([]);
        this.PortCDMDestination = s_js_1.default.value(null);
        this.RecurringBatches = s_array_1.default([]);
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.InboundDemarcationName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InboundDemarcationName !== undefined ? data.InboundDemarcationName : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
        this.PierDepthUOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PierDepthUOM !== undefined ? data.PierDepthUOM : null));
        this.PierLengthUOM = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PierLengthUOM !== undefined ? data.PierLengthUOM : null));
        this.UNLOCODE = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UNLOCODE !== undefined ? data.UNLOCODE : null));
    }
    Port.key = function (obj) {
        return obj.Id();
    };
    Port.dataKey = function (obj) {
        return obj.Id;
    };
    Port.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.DomainId !== undefined)
                obj.DomainId(data.DomainId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.InboundDemarcationName !== undefined)
                obj.InboundDemarcationName(data.InboundDemarcationName);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Order !== undefined)
                obj.Order(data.Order);
            if (data.PierDepthUOM !== undefined)
                obj.PierDepthUOM(data.PierDepthUOM);
            if (data.PierLengthUOM !== undefined)
                obj.PierLengthUOM(data.PierLengthUOM);
            if (data.UNLOCODE !== undefined)
                obj.UNLOCODE(data.UNLOCODE);
        });
    };
    return Port;
}());
exports.Port = Port;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCall = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCall.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PortCall = /** @class */ (function () {
    function PortCall(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Agent = s_js_1.default.value(null);
        this.AgentId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Barge = s_js_1.default.value(null);
        this.BargeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BargeId !== undefined ? data.BargeId : null));
        this.Batch = s_js_1.default.value(null);
        this.BatchId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BatchId !== undefined ? data.BatchId : null));
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = s_array_1.default([]);
        this.ChangesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangesUrl !== undefined ? data.ChangesUrl : null));
        this.GeoActivities = s_array_1.default([]);
        this.Itinerary = s_array_1.default([]);
        this.JobOrders = s_array_1.default([]);
        this.Log = s_array_1.default([]);
        this.Port = s_js_1.default.value(null);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.Requestor = s_js_1.default.value(null);
        this.RequestorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Schedule = s_array_1.default([]);
        this.Self = s_js_1.default.value(null);
        this.Sharing = s_js_1.default.value(null);
        this.SharingId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SharingId !== undefined ? data.SharingId : 0));
        this.TopicCards = s_array_1.default([]);
        this.Version = s_js_1.default.value(null);
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.AirDraft = data && data.AirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.AirDraft) : new Measurement_1.NullableMeasurement();
        this.DeepDraft = data && data.DeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.DeepDraft) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LastPortOfCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new Measurement_1.NullableMeasurement(data.LengthOnlyLength) : new Measurement_1.NullableMeasurement();
        this.NextPortOfCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NextPortOfCall !== undefined ? data.NextPortOfCall : null));
        this.Unlisted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Unlisted !== undefined ? data.Unlisted : false));
        this.UnlistedOverride = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UnlistedOverride !== undefined ? data.UnlistedOverride : null));
        this.VoyageNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }
    PortCall.key = function (obj) {
        return obj.Id();
    };
    PortCall.dataKey = function (obj) {
        return obj.Id;
    };
    PortCall.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AgentId !== undefined)
                obj.AgentId(data.AgentId);
            if (data.BargeId !== undefined)
                obj.BargeId(data.BargeId);
            if (data.BatchId !== undefined)
                obj.BatchId(data.BatchId);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.ChangesUrl !== undefined)
                obj.ChangesUrl(data.ChangesUrl);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.RequestorId !== undefined)
                obj.RequestorId(data.RequestorId);
            if (data.SharingId !== undefined)
                obj.SharingId(data.SharingId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.AirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.DeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.LastPortOfCall !== undefined)
                obj.LastPortOfCall(data.LastPortOfCall);
            if (data.LengthOnlyLength !== undefined)
                Measurement_1.NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.NextPortOfCall !== undefined)
                obj.NextPortOfCall(data.NextPortOfCall);
            if (data.Unlisted !== undefined)
                obj.Unlisted(data.Unlisted);
            if (data.UnlistedOverride !== undefined)
                obj.UnlistedOverride(data.UnlistedOverride);
            if (data.VoyageNumber !== undefined)
                obj.VoyageNumber(data.VoyageNumber);
        });
    };
    return PortCall;
}());
exports.PortCall = PortCall;


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallChange = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCallChange\ApiPortCallChange.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PortCallChange = /** @class */ (function () {
    function PortCallChange(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.InvitedEditor = s_js_1.default.value(null);
        this.InvitedEditorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvitedEditorId !== undefined ? data.InvitedEditorId : 0));
        this.NewAgent = s_js_1.default.value(null);
        this.NewAgentId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewAgentId !== undefined ? data.NewAgentId : 0));
        this.NewBarge = s_js_1.default.value(null);
        this.NewBargeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewBargeId !== undefined ? data.NewBargeId : 0));
        this.NewBerth = s_js_1.default.value(null);
        this.NewBerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewBerthId !== undefined ? data.NewBerthId : 0));
        this.NewVessel = s_js_1.default.value(null);
        this.NewVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewVesselId !== undefined ? data.NewVesselId : null));
        this.OldBerth = s_js_1.default.value(null);
        this.OldBerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldBerthId !== undefined ? data.OldBerthId : 0));
        this.OldVessel = s_js_1.default.value(null);
        this.OldVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldVesselId !== undefined ? data.OldVesselId : null));
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.RecurringBatchChange = s_js_1.default.value(null);
        this.RecurringBatchChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchChangeId !== undefined ? data.RecurringBatchChangeId : null));
        this.Reservation = s_js_1.default.value(null);
        this.ReservationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReservationId !== undefined ? data.ReservationId : 0));
        this.ScheduleEvents = s_array_1.default([]);
        this.Watcher = s_js_1.default.value(null);
        this.WatcherId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.WatcherId !== undefined ? data.WatcherId : 0));
        this.ActualTime = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ActualTime !== undefined ? new TZDate_1.default(data.ActualTime) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ApprovalCardTitle = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalCardTitle !== undefined ? data.ApprovalCardTitle : null));
        this.EditorAction = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EditorAction !== undefined ? data.EditorAction : 0));
        this.Field = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Field !== undefined ? data.Field : 0));
        this.FirstLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstLine !== undefined ? new TZDate_1.default(data.FirstLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.LastLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastLine !== undefined ? new TZDate_1.default(data.LastLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.NewFirstLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewFirstLine !== undefined ? new TZDate_1.default(data.NewFirstLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.NewFootmark = data && data.NewFootmark !== undefined ? new Measurement_1.Measurement(data.NewFootmark) : new Measurement_1.Measurement();
        this.NewLastLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewLastLine !== undefined ? new TZDate_1.default(data.NewLastLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.NewLength = data && data.NewLength !== undefined ? new Measurement_1.Measurement(data.NewLength) : new Measurement_1.Measurement();
        this.NewSide = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewSide !== undefined ? data.NewSide : 0));
        this.NewStatus = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewStatus !== undefined ? data.NewStatus : 0));
        this.OldFirstLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldFirstLine !== undefined ? new TZDate_1.default(data.OldFirstLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OldFootmark = data && data.OldFootmark !== undefined ? new Measurement_1.Measurement(data.OldFootmark) : new Measurement_1.Measurement();
        this.OldLastLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldLastLine !== undefined ? new TZDate_1.default(data.OldLastLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OldLength = data && data.OldLength !== undefined ? new Measurement_1.Measurement(data.OldLength) : new Measurement_1.Measurement();
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
        this.WatcherAction = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.WatcherAction !== undefined ? data.WatcherAction : 0));
    }
    PortCallChange.key = function (obj) {
        return obj.Id();
    };
    PortCallChange.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallChange.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.InvitedEditorId !== undefined)
                obj.InvitedEditorId(data.InvitedEditorId);
            if (data.NewAgentId !== undefined)
                obj.NewAgentId(data.NewAgentId);
            if (data.NewBargeId !== undefined)
                obj.NewBargeId(data.NewBargeId);
            if (data.NewBerthId !== undefined)
                obj.NewBerthId(data.NewBerthId);
            if (data.NewVesselId !== undefined)
                obj.NewVesselId(data.NewVesselId);
            if (data.OldBerthId !== undefined)
                obj.OldBerthId(data.OldBerthId);
            if (data.OldVesselId !== undefined)
                obj.OldVesselId(data.OldVesselId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.RecurringBatchChangeId !== undefined)
                obj.RecurringBatchChangeId(data.RecurringBatchChangeId);
            if (data.ReservationId !== undefined)
                obj.ReservationId(data.ReservationId);
            if (data.WatcherId !== undefined)
                obj.WatcherId(data.WatcherId);
            if (data.ActualTime !== undefined)
                obj.ActualTime(new TZDate_1.default(data.ActualTime));
            if (data.ApprovalCardTitle !== undefined)
                obj.ApprovalCardTitle(data.ApprovalCardTitle);
            if (data.EditorAction !== undefined)
                obj.EditorAction(data.EditorAction);
            if (data.Field !== undefined)
                obj.Field(data.Field);
            if (data.FirstLine !== undefined)
                obj.FirstLine(new TZDate_1.default(data.FirstLine));
            if (data.LastLine !== undefined)
                obj.LastLine(new TZDate_1.default(data.LastLine));
            if (data.NewFirstLine !== undefined)
                obj.NewFirstLine(new TZDate_1.default(data.NewFirstLine));
            if (data.NewFootmark !== undefined)
                Measurement_1.Measurement.update(obj.NewFootmark, data.NewFootmark);
            if (data.NewLastLine !== undefined)
                obj.NewLastLine(new TZDate_1.default(data.NewLastLine));
            if (data.NewLength !== undefined)
                Measurement_1.Measurement.update(obj.NewLength, data.NewLength);
            if (data.NewSide !== undefined)
                obj.NewSide(data.NewSide);
            if (data.NewStatus !== undefined)
                obj.NewStatus(data.NewStatus);
            if (data.OldFirstLine !== undefined)
                obj.OldFirstLine(new TZDate_1.default(data.OldFirstLine));
            if (data.OldFootmark !== undefined)
                Measurement_1.Measurement.update(obj.OldFootmark, data.OldFootmark);
            if (data.OldLastLine !== undefined)
                obj.OldLastLine(new TZDate_1.default(data.OldLastLine));
            if (data.OldLength !== undefined)
                Measurement_1.Measurement.update(obj.OldLength, data.OldLength);
            if (data.Type !== undefined)
                obj.Type(data.Type);
            if (data.WatcherAction !== undefined)
                obj.WatcherAction(data.WatcherAction);
        });
    };
    return PortCallChange;
}());
exports.PortCallChange = PortCallChange;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallDeletion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCallDeletion\ApiPortCallDeletion.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PortCallDeletion = /** @class */ (function () {
    function PortCallDeletion(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.RecurringBatchChange = s_js_1.default.value(null);
        this.RecurringBatchChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchChangeId !== undefined ? data.RecurringBatchChangeId : null));
        this.RecurringBatchDeletion = s_js_1.default.value(null);
        this.RecurringBatchDeletionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchDeletionId !== undefined ? data.RecurringBatchDeletionId : null));
        this.Requestor = s_js_1.default.value(null);
        this.RequestorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.FirstLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstLine !== undefined ? new TZDate_1.default(data.FirstLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.LastLine = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastLine !== undefined ? new TZDate_1.default(data.LastLine) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new Measurement_1.NullableMeasurement(data.LengthOnlyLength) : new Measurement_1.NullableMeasurement();
        this.PortCallGuid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallGuid !== undefined ? data.PortCallGuid : '00000000-0000-0000-0000-000000000000'));
        this.RecurringBatchGuid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchGuid !== undefined ? data.RecurringBatchGuid : null));
        this.RecurringBatchReferenceNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchReferenceNumber !== undefined ? data.RecurringBatchReferenceNumber : null));
    }
    PortCallDeletion.key = function (obj) {
        return obj.Id();
    };
    PortCallDeletion.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallDeletion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.RecurringBatchChangeId !== undefined)
                obj.RecurringBatchChangeId(data.RecurringBatchChangeId);
            if (data.RecurringBatchDeletionId !== undefined)
                obj.RecurringBatchDeletionId(data.RecurringBatchDeletionId);
            if (data.RequestorId !== undefined)
                obj.RequestorId(data.RequestorId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.FirstLine !== undefined)
                obj.FirstLine(new TZDate_1.default(data.FirstLine));
            if (data.LastLine !== undefined)
                obj.LastLine(new TZDate_1.default(data.LastLine));
            if (data.LengthOnlyLength !== undefined)
                Measurement_1.NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.PortCallGuid !== undefined)
                obj.PortCallGuid(data.PortCallGuid);
            if (data.RecurringBatchGuid !== undefined)
                obj.RecurringBatchGuid(data.RecurringBatchGuid);
            if (data.RecurringBatchReferenceNumber !== undefined)
                obj.RecurringBatchReferenceNumber(data.RecurringBatchReferenceNumber);
        });
    };
    return PortCallDeletion;
}());
exports.PortCallDeletion = PortCallDeletion;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallProfileTopicCard = exports.PortCallProfileResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PortCallProfile\PortCallProfileViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PortCallProfileResponse = /** @class */ (function () {
    function PortCallProfileResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.PortCall = s_js_1.default.value(null);
        this.TopicCards = s_array_1.default([]);
        this.ApplicableTopicCardTemplatesCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApplicableTopicCardTemplatesCount !== undefined ? data.ApplicableTopicCardTemplatesCount : 0));
        this.AssignableAgents = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.AssignableAgents !== undefined ? data.AssignableAgents : []));
        this.DomainRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DomainRights !== undefined ? data.DomainRights : 0));
        this.Rights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Rights !== undefined ? data.Rights : 0));
        this.SchedulingAuthorityEditors = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.SchedulingAuthorityEditors !== undefined ? data.SchedulingAuthorityEditors : []));
    }
    PortCallProfileResponse.key = function (obj) {
        return obj.Id();
    };
    PortCallProfileResponse.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallProfileResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ApplicableTopicCardTemplatesCount !== undefined)
                obj.ApplicableTopicCardTemplatesCount(data.ApplicableTopicCardTemplatesCount);
            if (data.AssignableAgents !== undefined)
                obj.AssignableAgents(data.AssignableAgents);
            if (data.DomainRights !== undefined)
                obj.DomainRights(data.DomainRights);
            if (data.Rights !== undefined)
                obj.Rights(data.Rights);
            if (data.SchedulingAuthorityEditors !== undefined)
                obj.SchedulingAuthorityEditors(data.SchedulingAuthorityEditors);
        });
    };
    return PortCallProfileResponse;
}());
exports.PortCallProfileResponse = PortCallProfileResponse;
var PortCallProfileTopicCard = /** @class */ (function () {
    function PortCallProfileTopicCard(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Card = s_js_1.default.value(null);
        this.CanConfirm = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanConfirm !== undefined ? data.CanConfirm : false));
    }
    PortCallProfileTopicCard.key = function (obj) {
        return obj.Id();
    };
    PortCallProfileTopicCard.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallProfileTopicCard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CanConfirm !== undefined)
                obj.CanConfirm(data.CanConfirm);
        });
    };
    return PortCallProfileTopicCard;
}());
exports.PortCallProfileTopicCard = PortCallProfileTopicCard;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallReport = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ViewPortCallReport\ViewPortCallReportViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PortCallReport = /** @class */ (function () {
    function PortCallReport(data) {
        if (data === void 0) { data = null; }
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.CurrentPC = s_js_1.default.value(null);
    }
    PortCallReport.key = function (obj) {
        return obj.PortCallId();
    };
    PortCallReport.dataKey = function (obj) {
        return obj.PortCallId;
    };
    PortCallReport.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
        });
    };
    return PortCallReport;
}());
exports.PortCallReport = PortCallReport;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallScheduleResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PortCallSchedule\PortCallScheduleResponse.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PortCallScheduleResponse = /** @class */ (function () {
    function PortCallScheduleResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.PortCall = s_js_1.default.value(null);
        this.Rights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Rights !== undefined ? data.Rights : 0));
    }
    PortCallScheduleResponse.key = function (obj) {
        return obj.Id();
    };
    PortCallScheduleResponse.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallScheduleResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Rights !== undefined)
                obj.Rights(data.Rights);
        });
    };
    return PortCallScheduleResponse;
}());
exports.PortCallScheduleResponse = PortCallScheduleResponse;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCallSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var PortCallSelf = /** @class */ (function () {
    function PortCallSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Comments = s_array_1.default([]);
        this.CommentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Events = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    PortCallSelf.key = function (obj) {
        return obj.Id();
    };
    PortCallSelf.dataKey = function (obj) {
        return obj.Id;
    };
    PortCallSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CommentsUrl !== undefined)
                obj.CommentsUrl(data.CommentsUrl);
        });
    };
    return PortCallSelf;
}());
exports.PortCallSelf = PortCallSelf;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PortCallVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCallVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var PortCallVersion = /** @class */ (function () {
    function PortCallVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AgentId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Batch = s_js_1.default.value(null);
        this.BatchId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BatchId !== undefined ? data.BatchId : null));
        this.Change = s_js_1.default.value(null);
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.NextVersion = s_array_1.default([]);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.RequestorId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Self = s_js_1.default.value(null);
        this.SharingId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SharingId !== undefined ? data.SharingId : 0));
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.AirDraft = data && data.AirDraft !== undefined ? new Measurement_1.NullableMeasurement(data.AirDraft) : new Measurement_1.NullableMeasurement();
        this.DeepDraft = data && data.DeepDraft !== undefined ? new Measurement_1.NullableMeasurement(data.DeepDraft) : new Measurement_1.NullableMeasurement();
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LastPortOfCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new Measurement_1.NullableMeasurement(data.LengthOnlyLength) : new Measurement_1.NullableMeasurement();
        this.NextPortOfCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NextPortOfCall !== undefined ? data.NextPortOfCall : null));
        this.Unlisted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Unlisted !== undefined ? data.Unlisted : false));
        this.UnlistedOverride = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UnlistedOverride !== undefined ? data.UnlistedOverride : null));
        this.VoyageNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }
    PortCallVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    PortCallVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    PortCallVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AgentId !== undefined)
                obj.AgentId(data.AgentId);
            if (data.BatchId !== undefined)
                obj.BatchId(data.BatchId);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.RequestorId !== undefined)
                obj.RequestorId(data.RequestorId);
            if (data.SharingId !== undefined)
                obj.SharingId(data.SharingId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.AirDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.DeepDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined)
                obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.LastPortOfCall !== undefined)
                obj.LastPortOfCall(data.LastPortOfCall);
            if (data.LengthOnlyLength !== undefined)
                Measurement_1.NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.NextPortOfCall !== undefined)
                obj.NextPortOfCall(data.NextPortOfCall);
            if (data.Unlisted !== undefined)
                obj.Unlisted(data.Unlisted);
            if (data.UnlistedOverride !== undefined)
                obj.UnlistedOverride(data.UnlistedOverride);
            if (data.VoyageNumber !== undefined)
                obj.VoyageNumber(data.VoyageNumber);
        });
    };
    return PortCallVersion;
}());
exports.PortCallVersion = PortCallVersion;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalAddress = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PostalAddress\ApiPostalAddress.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PostalAddress = /** @class */ (function () {
    function PostalAddress(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Country = s_js_1.default.value(null);
        this.CountryId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CountryId !== undefined ? data.CountryId : 0));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : null));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : null));
        this.Address = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Address !== undefined ? data.Address : ''));
        this.AptSte = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AptSte !== undefined ? data.AptSte : null));
        this.City = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.City !== undefined ? data.City : ''));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.PostalCode = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PostalCode !== undefined ? data.PostalCode : ''));
        this.StateProv = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StateProv !== undefined ? data.StateProv : ''));
    }
    PostalAddress.key = function (obj) {
        return obj.Id();
    };
    PostalAddress.dataKey = function (obj) {
        return obj.Id;
    };
    PostalAddress.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.CountryId !== undefined)
                obj.CountryId(data.CountryId);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.Address !== undefined)
                obj.Address(data.Address);
            if (data.AptSte !== undefined)
                obj.AptSte(data.AptSte);
            if (data.City !== undefined)
                obj.City(data.City);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.PostalCode !== undefined)
                obj.PostalCode(data.PostalCode);
            if (data.StateProv !== undefined)
                obj.StateProv(data.StateProv);
        });
    };
    return PostalAddress;
}());
exports.PostalAddress = PostalAddress;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NullablePrice = exports.Price = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Price.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Price = /** @class */ (function () {
    function Price(data) {
        if (data === void 0) { data = null; }
        this.Cur = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Cur !== undefined ? data.Cur : ''));
        this.Num = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Num !== undefined ? data.Num : 0));
    }
    Price.key = function (obj) {
        return;
    };
    Price.dataKey = function (obj) {
        return;
    };
    Price.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Cur !== undefined)
                obj.Cur(data.Cur);
            if (data.Num !== undefined)
                obj.Num(data.Num);
        });
    };
    return Price;
}());
exports.Price = Price;
var NullablePrice = /** @class */ (function () {
    function NullablePrice(data) {
        if (data === void 0) { data = null; }
        this.Cur = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Cur !== undefined ? data.Cur : null));
        this.Num = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Num !== undefined ? data.Num : null));
    }
    NullablePrice.key = function (obj) {
        return;
    };
    NullablePrice.dataKey = function (obj) {
        return;
    };
    NullablePrice.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Cur !== undefined)
                obj.Cur(data.Cur);
            if (data.Num !== undefined)
                obj.Num(data.Num);
        });
    };
    return NullablePrice;
}());
exports.NullablePrice = NullablePrice;


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\PushNotificationSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var PushNotificationSettings = /** @class */ (function () {
    function PushNotificationSettings(data) {
        if (data === void 0) { data = null; }
        this.SendAsEmail = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SendAsEmail !== undefined ? data.SendAsEmail : false));
    }
    PushNotificationSettings.key = function (obj) {
        return;
    };
    PushNotificationSettings.dataKey = function (obj) {
        return;
    };
    PushNotificationSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.SendAsEmail !== undefined)
                obj.SendAsEmail(data.SendAsEmail);
        });
    };
    return PushNotificationSettings;
}());
exports.PushNotificationSettings = PushNotificationSettings;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksBillingSystemTracking = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksBillingSystemTracking.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksBillingSystemTracking = /** @class */ (function () {
    function QuickBooksBillingSystemTracking(data) {
        if (data === void 0) { data = null; }
        this.InvoiceAccount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvoiceAccount !== undefined ? data.InvoiceAccount : null));
        this.Terms = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Terms !== undefined ? data.Terms : null));
    }
    QuickBooksBillingSystemTracking.key = function (obj) {
        return;
    };
    QuickBooksBillingSystemTracking.dataKey = function (obj) {
        return;
    };
    QuickBooksBillingSystemTracking.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.InvoiceAccount !== undefined)
                obj.InvoiceAccount(data.InvoiceAccount);
            if (data.Terms !== undefined)
                obj.Terms(data.Terms);
        });
    };
    return QuickBooksBillingSystemTracking;
}());
exports.QuickBooksBillingSystemTracking = QuickBooksBillingSystemTracking;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.QBExportableDispatchEvent = exports.QBExportablePilotJobOrder = exports.QBGroupedDispatchEventCharges = exports.QBGroupedPilotJobOrderCharges = exports.QuickBooksExportRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\QuickBooks\QuickBooksExportRequest.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking_1 = __webpack_require__(114);
var QuickBooksExportRequest = /** @class */ (function () {
    function QuickBooksExportRequest(data) {
        if (data === void 0) { data = null; }
        this.GroupedDispatchEventCharges = s_array_1.default([]);
        this.GroupedPilotJobOrderCharges = s_array_1.default([]);
        this.InvoiceDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.InvoiceDate !== undefined ? new TZDate_1.default(data.InvoiceDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    QuickBooksExportRequest.key = function (obj) {
        return;
    };
    QuickBooksExportRequest.dataKey = function (obj) {
        return;
    };
    QuickBooksExportRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.InvoiceDate !== undefined)
                obj.InvoiceDate(new TZDate_1.default(data.InvoiceDate));
        });
    };
    return QuickBooksExportRequest;
}());
exports.QuickBooksExportRequest = QuickBooksExportRequest;
var QBGroupedPilotJobOrderCharges = /** @class */ (function () {
    function QBGroupedPilotJobOrderCharges(data) {
        if (data === void 0) { data = null; }
        this.PilotJobOrders = s_array_1.default([]);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : null));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
    }
    QBGroupedPilotJobOrderCharges.key = function (obj) {
        return;
    };
    QBGroupedPilotJobOrderCharges.dataKey = function (obj) {
        return;
    };
    QBGroupedPilotJobOrderCharges.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return QBGroupedPilotJobOrderCharges;
}());
exports.QBGroupedPilotJobOrderCharges = QBGroupedPilotJobOrderCharges;
var QBGroupedDispatchEventCharges = /** @class */ (function () {
    function QBGroupedDispatchEventCharges(data) {
        if (data === void 0) { data = null; }
        this.DispatchEvents = s_array_1.default([]);
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking_1.QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking_1.QuickBooksJobTracking();
    }
    QBGroupedDispatchEventCharges.key = function (obj) {
        return;
    };
    QBGroupedDispatchEventCharges.dataKey = function (obj) {
        return;
    };
    QBGroupedDispatchEventCharges.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.QBTracking !== undefined)
                QuickBooksJobTracking_1.QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return QBGroupedDispatchEventCharges;
}());
exports.QBGroupedDispatchEventCharges = QBGroupedDispatchEventCharges;
var QBExportablePilotJobOrder = /** @class */ (function () {
    function QBExportablePilotJobOrder(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ApprovalDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalDate !== undefined ? new TZDate_1.default(data.ApprovalDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    QBExportablePilotJobOrder.key = function (obj) {
        return obj.Id();
    };
    QBExportablePilotJobOrder.dataKey = function (obj) {
        return obj.Id;
    };
    QBExportablePilotJobOrder.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ApprovalDate !== undefined)
                obj.ApprovalDate(new TZDate_1.default(data.ApprovalDate));
        });
    };
    return QBExportablePilotJobOrder;
}());
exports.QBExportablePilotJobOrder = QBExportablePilotJobOrder;
var QBExportableDispatchEvent = /** @class */ (function () {
    function QBExportableDispatchEvent(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ApprovalDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ApprovalDate !== undefined ? new TZDate_1.default(data.ApprovalDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    QBExportableDispatchEvent.key = function (obj) {
        return obj.Id();
    };
    QBExportableDispatchEvent.dataKey = function (obj) {
        return obj.Id;
    };
    QBExportableDispatchEvent.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ApprovalDate !== undefined)
                obj.ApprovalDate(new TZDate_1.default(data.ApprovalDate));
        });
    };
    return QBExportableDispatchEvent;
}());
exports.QBExportableDispatchEvent = QBExportableDispatchEvent;


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksInventoryItemTracking = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksInventoryItemTracking.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksInventoryItemTracking = /** @class */ (function () {
    function QuickBooksInventoryItemTracking(data) {
        if (data === void 0) { data = null; }
        this.Account = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Account !== undefined ? data.Account : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
    }
    QuickBooksInventoryItemTracking.key = function (obj) {
        return;
    };
    QuickBooksInventoryItemTracking.dataKey = function (obj) {
        return;
    };
    QuickBooksInventoryItemTracking.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Account !== undefined)
                obj.Account(data.Account);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return QuickBooksInventoryItemTracking;
}());
exports.QuickBooksInventoryItemTracking = QuickBooksInventoryItemTracking;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksJobTracking = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksJobTracking.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksJobTracking = /** @class */ (function () {
    function QuickBooksJobTracking(data) {
        if (data === void 0) { data = null; }
        this.Customer = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Customer !== undefined ? data.Customer : null));
    }
    QuickBooksJobTracking.key = function (obj) {
        return;
    };
    QuickBooksJobTracking.dataKey = function (obj) {
        return;
    };
    QuickBooksJobTracking.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Customer !== undefined)
                obj.Customer(data.Customer);
        });
    };
    return QuickBooksJobTracking;
}());
exports.QuickBooksJobTracking = QuickBooksJobTracking;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Rate = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Rate\ApiRate.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var Price_1 = __webpack_require__(162);
var Rate = /** @class */ (function () {
    function Rate(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.BillingSystemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.StandardItem = s_js_1.default.value(null);
        this.StandardItemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StandardItemId !== undefined ? data.StandardItemId : 0));
        this.MaxQuantity = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MaxQuantity !== undefined ? data.MaxQuantity : null));
        this.MinQuantity = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MinQuantity !== undefined ? data.MinQuantity : null));
        this.Price = data && data.Price !== undefined ? new Price_1.Price(data.Price) : new Price_1.Price();
        this.Quantity = data && data.Quantity !== undefined ? new Measurement_1.Measurement(data.Quantity) : new Measurement_1.Measurement();
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    Rate.key = function (obj) {
        return obj.Id();
    };
    Rate.dataKey = function (obj) {
        return obj.Id;
    };
    Rate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillingSystemId !== undefined)
                obj.BillingSystemId(data.BillingSystemId);
            if (data.StandardItemId !== undefined)
                obj.StandardItemId(data.StandardItemId);
            if (data.MaxQuantity !== undefined)
                obj.MaxQuantity(data.MaxQuantity);
            if (data.MinQuantity !== undefined)
                obj.MinQuantity(data.MinQuantity);
            if (data.Price !== undefined)
                Price_1.Price.update(obj.Price, data.Price);
            if (data.Quantity !== undefined)
                Measurement_1.Measurement.update(obj.Quantity, data.Quantity);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return Rate;
}());
exports.Rate = Rate;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatch = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatch.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BatchRecurrencePeriod_1 = __webpack_require__(279);
var RecurringBatch = /** @class */ (function () {
    function RecurringBatch(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = s_array_1.default([]);
        this.Port = s_js_1.default.value(null);
        this.PortCalls = s_array_1.default([]);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.Self = s_js_1.default.value(null);
        this.Version = s_js_1.default.value(null);
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod_1.BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod_1.BatchRecurrencePeriod();
        this.ReferenceNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestDate !== undefined ? new TZDate_1.default(data.RequestDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    RecurringBatch.key = function (obj) {
        return obj.Id();
    };
    RecurringBatch.dataKey = function (obj) {
        return obj.Id;
    };
    RecurringBatch.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.RecurrencePeriod !== undefined)
                BatchRecurrencePeriod_1.BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.ReferenceNumber !== undefined)
                obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined)
                obj.RequestDate(new TZDate_1.default(data.RequestDate));
        });
    };
    return RecurringBatch;
}());
exports.RecurringBatch = RecurringBatch;


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchChange = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatchChange\ApiRecurringBatchChange.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var RecurringBatchChange = /** @class */ (function () {
    function RecurringBatchChange(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Batch = s_js_1.default.value(null);
        this.BatchId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BatchId !== undefined ? data.BatchId : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallDeletions = s_array_1.default([]);
        this.ReservationChanges = s_array_1.default([]);
        this.OldPortCallCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldPortCallCount !== undefined ? data.OldPortCallCount : 0));
        this.Recipient = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Recipient !== undefined ? data.Recipient : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    RecurringBatchChange.key = function (obj) {
        return obj.Id();
    };
    RecurringBatchChange.dataKey = function (obj) {
        return obj.Id;
    };
    RecurringBatchChange.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BatchId !== undefined)
                obj.BatchId(data.BatchId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.OldPortCallCount !== undefined)
                obj.OldPortCallCount(data.OldPortCallCount);
            if (data.Recipient !== undefined)
                obj.Recipient(data.Recipient);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return RecurringBatchChange;
}());
exports.RecurringBatchChange = RecurringBatchChange;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchDeletion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatchDeletion\ApiRecurringBatchDeletion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BatchRecurrencePeriod_1 = __webpack_require__(279);
var RecurringBatchDeletion = /** @class */ (function () {
    function RecurringBatchDeletion(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallDeletions = s_array_1.default([]);
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod_1.BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod_1.BatchRecurrencePeriod();
        this.RecurringBatchGuid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RecurringBatchGuid !== undefined ? data.RecurringBatchGuid : '00000000-0000-0000-0000-000000000000'));
        this.ReferenceNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestDate !== undefined ? new TZDate_1.default(data.RequestDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ReservationCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReservationCount !== undefined ? data.ReservationCount : 0));
    }
    RecurringBatchDeletion.key = function (obj) {
        return obj.Id();
    };
    RecurringBatchDeletion.dataKey = function (obj) {
        return obj.Id;
    };
    RecurringBatchDeletion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.RecurrencePeriod !== undefined)
                BatchRecurrencePeriod_1.BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.RecurringBatchGuid !== undefined)
                obj.RecurringBatchGuid(data.RecurringBatchGuid);
            if (data.ReferenceNumber !== undefined)
                obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined)
                obj.RequestDate(new TZDate_1.default(data.RequestDate));
            if (data.ReservationCount !== undefined)
                obj.ReservationCount(data.ReservationCount);
        });
    };
    return RecurringBatchDeletion;
}());
exports.RecurringBatchDeletion = RecurringBatchDeletion;


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewPortCall\RecurringBatchRequest.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var RecurringBatchRequest = /** @class */ (function () {
    function RecurringBatchRequest(data) {
        if (data === void 0) { data = null; }
        this.Batch = s_js_1.default.value(null);
        this.StopDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.StopDate !== undefined ? new TZDate_1.default(data.StopDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    RecurringBatchRequest.key = function (obj) {
        return;
    };
    RecurringBatchRequest.dataKey = function (obj) {
        return;
    };
    RecurringBatchRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.StopDate !== undefined)
                obj.StopDate(new TZDate_1.default(data.StopDate));
        });
    };
    return RecurringBatchRequest;
}());
exports.RecurringBatchRequest = RecurringBatchRequest;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatchSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var RecurringBatchSelf = /** @class */ (function () {
    function RecurringBatchSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Events = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    RecurringBatchSelf.key = function (obj) {
        return obj.Id();
    };
    RecurringBatchSelf.dataKey = function (obj) {
        return obj.Id;
    };
    RecurringBatchSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return RecurringBatchSelf;
}());
exports.RecurringBatchSelf = RecurringBatchSelf;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringBatchVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatchVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var BatchRecurrencePeriod_1 = __webpack_require__(279);
var RecurringBatchVersion = /** @class */ (function () {
    function RecurringBatchVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.EventsAbout = s_array_1.default([]);
        this.EventsReferencing = s_array_1.default([]);
        this.NextVersion = s_array_1.default([]);
        this.PortId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortId !== undefined ? data.PortId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod_1.BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod_1.BatchRecurrencePeriod();
        this.ReferenceNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RequestDate !== undefined ? new TZDate_1.default(data.RequestDate) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    RecurringBatchVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    RecurringBatchVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    RecurringBatchVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PortId !== undefined)
                obj.PortId(data.PortId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.RecurrencePeriod !== undefined)
                BatchRecurrencePeriod_1.BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.ReferenceNumber !== undefined)
                obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined)
                obj.RequestDate(new TZDate_1.default(data.RequestDate));
        });
    };
    return RecurringBatchVersion;
}());
exports.RecurringBatchVersion = RecurringBatchVersion;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboardResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsDashboard\ReservationsDashboardViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ReservationsDashboardResponse = /** @class */ (function () {
    function ReservationsDashboardResponse(data) {
        if (data === void 0) { data = null; }
        this.FromDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromDate !== undefined ? new TZDate_1.default(data.FromDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Role = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Role !== undefined ? data.Role : 0));
        this.ToDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToDate !== undefined ? new TZDate_1.default(data.ToDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Organization = s_js_1.default.value(null);
        this.Rows = s_array_1.default([]);
    }
    ReservationsDashboardResponse.key = function (obj) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.Role() + '\u2618' + obj.ToDate().toJSON();
    };
    ReservationsDashboardResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.Role + '\u2618' + new TZDate_1.default(obj.ToDate).toJSON();
    };
    ReservationsDashboardResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromDate !== undefined)
                obj.FromDate(new TZDate_1.default(data.FromDate));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Role !== undefined)
                obj.Role(data.Role);
            if (data.ToDate !== undefined)
                obj.ToDate(new TZDate_1.default(data.ToDate));
        });
    };
    return ReservationsDashboardResponse;
}());
exports.ReservationsDashboardResponse = ReservationsDashboardResponse;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsDashboardRow = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsListBase\ReservationsListViewModelBase.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var ReservationsDashboardRow = /** @class */ (function () {
    function ReservationsDashboardRow(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Reservation = s_js_1.default.value(null);
        this.CanBook = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanBook !== undefined ? data.CanBook : false));
        this.CanCancel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanCancel !== undefined ? data.CanCancel : false));
    }
    ReservationsDashboardRow.key = function (obj) {
        return obj.Id();
    };
    ReservationsDashboardRow.dataKey = function (obj) {
        return obj.Id;
    };
    ReservationsDashboardRow.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CanBook !== undefined)
                obj.CanBook(data.CanBook);
            if (data.CanCancel !== undefined)
                obj.CanCancel(data.CanCancel);
        });
    };
    return ReservationsDashboardRow;
}());
exports.ReservationsDashboardRow = ReservationsDashboardRow;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationsInBatch = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsInBatch\ReservationsInBatchViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ReservationsInBatch = /** @class */ (function () {
    function ReservationsInBatch(data) {
        if (data === void 0) { data = null; }
        this.BatchId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BatchId !== undefined ? data.BatchId : 0));
        this.FromDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromDate !== undefined ? new TZDate_1.default(data.FromDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ToDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToDate !== undefined ? new TZDate_1.default(data.ToDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Batch = s_js_1.default.value(null);
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Rows = s_array_1.default([]);
        this.CanDelete = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanDelete !== undefined ? data.CanDelete : false));
    }
    ReservationsInBatch.key = function (obj) {
        return obj.BatchId() + '\u2618' + obj.FromDate().toJSON() + '\u2618' + obj.ToDate().toJSON();
    };
    ReservationsInBatch.dataKey = function (obj) {
        return obj.BatchId + '\u2618' + new TZDate_1.default(obj.FromDate).toJSON() + '\u2618' + new TZDate_1.default(obj.ToDate).toJSON();
    };
    ReservationsInBatch.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BatchId !== undefined)
                obj.BatchId(data.BatchId);
            if (data.FromDate !== undefined)
                obj.FromDate(new TZDate_1.default(data.FromDate));
            if (data.ToDate !== undefined)
                obj.ToDate(new TZDate_1.default(data.ToDate));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.CanDelete !== undefined)
                obj.CanDelete(data.CanDelete);
        });
    };
    return ReservationsInBatch;
}());
exports.ReservationsInBatch = ReservationsInBatch;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\Role\ApiRole.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Role = /** @class */ (function () {
    function Role(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Users = s_array_1.default([]);
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.Order = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Order !== undefined ? data.Order : 0));
    }
    Role.key = function (obj) {
        return obj.Id();
    };
    Role.dataKey = function (obj) {
        return obj.Id;
    };
    Role.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.Order !== undefined)
                obj.Order(data.Order);
        });
    };
    return Role;
}());
exports.Role = Role;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RotationDashboard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\RotationDashboard\RotationDashboardViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var RotationDashboard = /** @class */ (function () {
    function RotationDashboard(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Navbar = s_js_1.default.value(null);
        this.PilotAgency = s_js_1.default.value(null);
        this.Pilots = s_array_1.default([]);
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }
    RotationDashboard.key = function (obj) {
        return obj.Id();
    };
    RotationDashboard.dataKey = function (obj) {
        return obj.Id;
    };
    RotationDashboard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
        });
    };
    return RotationDashboard;
}());
exports.RotationDashboard = RotationDashboard;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveImageRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Services\FileUploads\SaveImageBindingModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var SaveImageRequest = /** @class */ (function () {
    function SaveImageRequest(data) {
        if (data === void 0) { data = null; }
        this.RawUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RawUrl !== undefined ? data.RawUrl : null));
        this.CropX1 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropX1 !== undefined ? data.CropX1 : 0));
        this.CropX2 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropX2 !== undefined ? data.CropX2 : 0));
        this.CropY1 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropY1 !== undefined ? data.CropY1 : 0));
        this.CropY2 = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CropY2 !== undefined ? data.CropY2 : 0));
    }
    SaveImageRequest.key = function (obj) {
        return;
    };
    SaveImageRequest.dataKey = function (obj) {
        return;
    };
    SaveImageRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.RawUrl !== undefined)
                obj.RawUrl(data.RawUrl);
            if (data.CropX1 !== undefined)
                obj.CropX1(data.CropX1);
            if (data.CropX2 !== undefined)
                obj.CropX2(data.CropX2);
            if (data.CropY1 !== undefined)
                obj.CropY1(data.CropY1);
            if (data.CropY2 !== undefined)
                obj.CropY2(data.CropY2);
        });
    };
    return SaveImageRequest;
}());
exports.SaveImageRequest = SaveImageRequest;


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDate = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\Schedule\ScheduleDate.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDate = /** @class */ (function () {
    function ScheduleDate(data) {
        if (data === void 0) { data = null; }
        this.Actual = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Actual !== undefined ? data.Actual === null ? null : new TZDate_1.default(data.Actual) : null, TZDate_1.default.nullableEq));
        this.Anchor = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Anchor !== undefined ? new TZDate_1.default(data.Anchor) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Estimated = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Estimated !== undefined ? new TZDate_1.default(data.Estimated) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    ScheduleDate.key = function (obj) {
        return;
    };
    ScheduleDate.dataKey = function (obj) {
        return;
    };
    ScheduleDate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Actual !== undefined)
                obj.Actual(data.Actual === null ? null : new TZDate_1.default(data.Actual));
            if (data.Anchor !== undefined)
                obj.Anchor(new TZDate_1.default(data.Anchor));
            if (data.Estimated !== undefined)
                obj.Estimated(new TZDate_1.default(data.Estimated));
        });
    };
    return ScheduleDate;
}());
exports.ScheduleDate = ScheduleDate;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateEntity = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateEntity.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDateEntity = /** @class */ (function () {
    function ScheduleDateEntity(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.CoordinationCards = s_array_1.default([]);
        this.Events = s_array_1.default([]);
        this.Issues = s_array_1.default([]);
        this.ItineraryPoint = s_js_1.default.value(null);
        this.ItineraryPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : 0));
        this.JobOrder = s_js_1.default.value(null);
        this.JobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.MilestoneType = s_js_1.default.value(null);
        this.MilestoneTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : null));
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Self = s_js_1.default.value(null);
        this.Version = s_js_1.default.value(null);
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    ScheduleDateEntity.key = function (obj) {
        return obj.Id();
    };
    ScheduleDateEntity.dataKey = function (obj) {
        return obj.Id;
    };
    ScheduleDateEntity.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.ItineraryPointId !== undefined)
                obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined)
                obj.JobOrderId(data.JobOrderId);
            if (data.MilestoneTypeId !== undefined)
                obj.MilestoneTypeId(data.MilestoneTypeId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return ScheduleDateEntity;
}());
exports.ScheduleDateEntity = ScheduleDateEntity;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateEvent = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDateEvent\ApiScheduleDateEvent.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDateEvent = /** @class */ (function () {
    function ScheduleDateEvent(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ScheduleChange = s_js_1.default.value(null);
        this.ScheduleChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleChangeId !== undefined ? data.ScheduleChangeId : 0));
        this.ScheduleDate = s_js_1.default.value(null);
        this.ScheduleDateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.ScheduleDateIssues = s_array_1.default([]);
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? data.Date === null ? null : new TZDate_1.default(data.Date) : null, TZDate_1.default.nullableEq));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    ScheduleDateEvent.key = function (obj) {
        return obj.Id();
    };
    ScheduleDateEvent.dataKey = function (obj) {
        return obj.Id;
    };
    ScheduleDateEvent.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ScheduleChangeId !== undefined)
                obj.ScheduleChangeId(data.ScheduleChangeId);
            if (data.ScheduleDateId !== undefined)
                obj.ScheduleDateId(data.ScheduleDateId);
            if (data.Date !== undefined)
                obj.Date(data.Date === null ? null : new TZDate_1.default(data.Date));
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return ScheduleDateEvent;
}());
exports.ScheduleDateEvent = ScheduleDateEvent;


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateSelf = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateSelf.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDateSelf = /** @class */ (function () {
    function ScheduleDateSelf(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.CoordinationCardVersions = s_array_1.default([]);
        this.DeletedCoordinationCardVersions = s_array_1.default([]);
        this.Live = s_js_1.default.value(null);
        this.Versions = s_array_1.default([]);
    }
    ScheduleDateSelf.key = function (obj) {
        return obj.Id();
    };
    ScheduleDateSelf.dataKey = function (obj) {
        return obj.Id;
    };
    ScheduleDateSelf.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return ScheduleDateSelf;
}());
exports.ScheduleDateSelf = ScheduleDateSelf;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleDateVersion = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateVersion.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleDateVersion = /** @class */ (function () {
    function ScheduleDateVersion(data) {
        if (data === void 0) { data = null; }
        this.ChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Change = s_js_1.default.value(null);
        this.ItineraryPoint = s_js_1.default.value(null);
        this.ItineraryPointId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : 0));
        this.JobOrder = s_js_1.default.value(null);
        this.JobOrderId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.MilestoneTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : null));
        this.NextVersion = s_array_1.default([]);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = s_js_1.default.value(null);
        this.PrevChangeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = s_js_1.default.value(null);
        this.Self = s_js_1.default.value(null);
        this.Deleted = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    ScheduleDateVersion.key = function (obj) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    };
    ScheduleDateVersion.dataKey = function (obj) {
        return obj.ChangeId + '\u2618' + obj.Id;
    };
    ScheduleDateVersion.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.ChangeId !== undefined)
                obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.ItineraryPointId !== undefined)
                obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined)
                obj.JobOrderId(data.JobOrderId);
            if (data.MilestoneTypeId !== undefined)
                obj.MilestoneTypeId(data.MilestoneTypeId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined)
                obj.PrevChangeId(data.PrevChangeId);
            if (data.Deleted !== undefined)
                obj.Deleted(data.Deleted);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return ScheduleDateVersion;
}());
exports.ScheduleDateVersion = ScheduleDateVersion;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleGridResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\ScheduleGridViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleGridResponse = /** @class */ (function () {
    function ScheduleGridResponse(data) {
        if (data === void 0) { data = null; }
        this.From = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.From !== undefined ? new TZDate_1.default(data.From) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.To = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.To !== undefined ? new TZDate_1.default(data.To) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.BerthClosures = s_array_1.default([]);
        this.BerthReservations = s_array_1.default([]);
        this.ItineraryPoints = s_array_1.default([]);
        this.PortCalls = s_array_1.default([]);
        this.UnlistedReservations = s_array_1.default([]);
        this.Vessels = s_array_1.default([]);
        this.BerthClosureRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthClosureRights !== undefined ? data.BerthClosureRights : {}));
        this.BerthRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthRights !== undefined ? data.BerthRights : {}));
        this.CanManageBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanReserveBerths = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanReserveBerths !== undefined ? data.CanReserveBerths : false));
        this.PortCallRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallRights !== undefined ? data.PortCallRights : {}));
    }
    ScheduleGridResponse.key = function (obj) {
        return obj.From().toJSON() + '\u2618' + obj.To().toJSON();
    };
    ScheduleGridResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.From).toJSON() + '\u2618' + new TZDate_1.default(obj.To).toJSON();
    };
    ScheduleGridResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.From !== undefined)
                obj.From(new TZDate_1.default(data.From));
            if (data.To !== undefined)
                obj.To(new TZDate_1.default(data.To));
            if (data.BerthClosureRights !== undefined)
                obj.BerthClosureRights(data.BerthClosureRights);
            if (data.BerthRights !== undefined)
                obj.BerthRights(data.BerthRights);
            if (data.CanManageBerths !== undefined)
                obj.CanManageBerths(data.CanManageBerths);
            if (data.CanReserveBerths !== undefined)
                obj.CanReserveBerths(data.CanReserveBerths);
            if (data.PortCallRights !== undefined)
                obj.PortCallRights(data.PortCallRights);
        });
    };
    return ScheduleGridResponse;
}());
exports.ScheduleGridResponse = ScheduleGridResponse;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleGridUpdateResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\UpdateResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var ScheduleGridUpdateResponse = /** @class */ (function () {
    function ScheduleGridUpdateResponse(data) {
        if (data === void 0) { data = null; }
        this.BerthClosures = s_array_1.default([]);
        this.BerthReservations = s_array_1.default([]);
        this.ItineraryPoints = s_array_1.default([]);
        this.PortCalls = s_array_1.default([]);
        this.UnlistedReservations = s_array_1.default([]);
        this.Vessels = s_array_1.default([]);
        this.BerthClosureRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthClosureRights !== undefined ? data.BerthClosureRights : {}));
        this.PortCallRights = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallRights !== undefined ? data.PortCallRights : {}));
    }
    ScheduleGridUpdateResponse.key = function (obj) {
        return;
    };
    ScheduleGridUpdateResponse.dataKey = function (obj) {
        return;
    };
    ScheduleGridUpdateResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BerthClosureRights !== undefined)
                obj.BerthClosureRights(data.BerthClosureRights);
            if (data.PortCallRights !== undefined)
                obj.PortCallRights(data.PortCallRights);
        });
    };
    return ScheduleGridUpdateResponse;
}());
exports.ScheduleGridUpdateResponse = ScheduleGridUpdateResponse;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesDashboardResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\ServicesDashboardResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var ServicesDashboardResponse = /** @class */ (function () {
    function ServicesDashboardResponse(data) {
        if (data === void 0) { data = null; }
        this.Date = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Date !== undefined ? new TZDate_1.default(data.Date) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Services = s_array_1.default([]);
    }
    ServicesDashboardResponse.key = function (obj) {
        return obj.Date().toJSON() + '\u2618' + obj.OrganizationId();
    };
    ServicesDashboardResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.Date).toJSON() + '\u2618' + obj.OrganizationId;
    };
    ServicesDashboardResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Date !== undefined)
                obj.Date(new TZDate_1.default(data.Date));
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
        });
    };
    return ServicesDashboardResponse;
}());
exports.ServicesDashboardResponse = ServicesDashboardResponse;


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SetBerthFootmarksRequest = exports.SetPierGroupFootmarksRequest = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PierGroupFootmarks\SetPierGroupFootmarksRequest.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var SetPierGroupFootmarksRequest = /** @class */ (function () {
    function SetPierGroupFootmarksRequest(data) {
        if (data === void 0) { data = null; }
        this.Berths = s_array_1.default([]);
    }
    SetPierGroupFootmarksRequest.key = function (obj) {
        return;
    };
    SetPierGroupFootmarksRequest.dataKey = function (obj) {
        return;
    };
    SetPierGroupFootmarksRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return SetPierGroupFootmarksRequest;
}());
exports.SetPierGroupFootmarksRequest = SetPierGroupFootmarksRequest;
var SetBerthFootmarksRequest = /** @class */ (function () {
    function SetBerthFootmarksRequest(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.StartMark = data && data.StartMark !== undefined ? new Measurement_1.Measurement(data.StartMark) : new Measurement_1.Measurement();
    }
    SetBerthFootmarksRequest.key = function (obj) {
        return obj.Id();
    };
    SetBerthFootmarksRequest.dataKey = function (obj) {
        return obj.Id;
    };
    SetBerthFootmarksRequest.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.StartMark !== undefined)
                Measurement_1.Measurement.update(obj.StartMark, data.StartMark);
        });
    };
    return SetBerthFootmarksRequest;
}());
exports.SetBerthFootmarksRequest = SetBerthFootmarksRequest;


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Shares\ApiShare.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Share = /** @class */ (function () {
    function Share(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Token = s_js_1.default.value(null);
        this.TokenId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TokenId !== undefined ? data.TokenId : 0));
        this.User = s_js_1.default.value(null);
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Scope = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Scope !== undefined ? data.Scope : 0));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    Share.key = function (obj) {
        return obj.Id();
    };
    Share.dataKey = function (obj) {
        return obj.Id;
    };
    Share.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.TokenId !== undefined)
                obj.TokenId(data.TokenId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Scope !== undefined)
                obj.Scope(data.Scope);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return Share;
}());
exports.Share = Share;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingToken = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\SharingToken\ApiSharingToken.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var SharingToken = /** @class */ (function () {
    function SharingToken(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Shares = s_array_1.default([]);
        this.SharesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SharesUrl !== undefined ? data.SharesUrl : null));
    }
    SharingToken.key = function (obj) {
        return obj.Id();
    };
    SharingToken.dataKey = function (obj) {
        return obj.Id;
    };
    SharingToken.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.SharesUrl !== undefined)
                obj.SharesUrl(data.SharesUrl);
        });
    };
    return SharingToken;
}());
exports.SharingToken = SharingToken;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItem = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\StandardItem\ApiStandardItem.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var QuickBooksInventoryItemTracking_1 = __webpack_require__(113);
var StandardItem = /** @class */ (function () {
    function StandardItem(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.BillingSystem = s_js_1.default.value(null);
        this.BillingSystemId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Rates = s_array_1.default([]);
        this.Type = s_js_1.default.value(null);
        this.TypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TypeId !== undefined ? data.TypeId : null));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking(data.QBTracking) : new QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking();
    }
    StandardItem.key = function (obj) {
        return obj.Id();
    };
    StandardItem.dataKey = function (obj) {
        return obj.Id;
    };
    StandardItem.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BillingSystemId !== undefined)
                obj.BillingSystemId(data.BillingSystemId);
            if (data.TypeId !== undefined)
                obj.TypeId(data.TypeId);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.QBTracking !== undefined)
                QuickBooksInventoryItemTracking_1.QuickBooksInventoryItemTracking.update(obj.QBTracking, data.QBTracking);
        });
    };
    return StandardItem;
}());
exports.StandardItem = StandardItem;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItemType = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\StandardItemType\ApiStandardItemType.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var StandardItemType = /** @class */ (function () {
    function StandardItemType(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : '00000000-0000-0000-0000-000000000000'));
        this.Items = s_array_1.default([]);
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
    }
    StandardItemType.key = function (obj) {
        return obj.Id();
    };
    StandardItemType.dataKey = function (obj) {
        return obj.Id;
    };
    StandardItemType.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return StandardItemType;
}());
exports.StandardItemType = StandardItemType;


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TaggedCommentUser = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TaggedCommentUser\ApiTaggedCommentUser.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TaggedCommentUser = /** @class */ (function () {
    function TaggedCommentUser(data) {
        if (data === void 0) { data = null; }
        this.CommentId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentId !== undefined ? data.CommentId : 0));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Comment = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
    }
    TaggedCommentUser.key = function (obj) {
        return obj.CommentId() + '\u2618' + obj.UserId();
    };
    TaggedCommentUser.dataKey = function (obj) {
        return obj.CommentId + '\u2618' + obj.UserId;
    };
    TaggedCommentUser.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CommentId !== undefined)
                obj.CommentId(data.CommentId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
        });
    };
    return TaggedCommentUser;
}());
exports.TaggedCommentUser = TaggedCommentUser;


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCard = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCard\ApiTopicCard.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTimeEntry_1 = __webpack_require__(1363);
var TopicCard = /** @class */ (function () {
    function TopicCard(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AmenityType = s_js_1.default.value(null);
        this.AmenityTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AmenityTypeId !== undefined ? data.AmenityTypeId : null));
        this.AnsweredBy = s_js_1.default.value(null);
        this.AnsweredById = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AnsweredById !== undefined ? data.AnsweredById : null));
        this.AvailableAttachments = s_array_1.default([]);
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : null));
        this.Changes = s_array_1.default([]);
        this.Comments = s_array_1.default([]);
        this.CommentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Options = s_array_1.default([]);
        this.People = s_array_1.default([]);
        this.PortCall = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.SelectedOption = s_js_1.default.value(null);
        this.Template = s_js_1.default.value(null);
        this.TemplateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.ConfirmedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ConfirmedDate !== undefined ? data.ConfirmedDate === null ? null : new TZDate_1.default(data.ConfirmedDate) : null, TZDate_1.default.nullableEq));
        this.DeniedDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DeniedDate !== undefined ? data.DeniedDate === null ? null : new TZDate_1.default(data.DeniedDate) : null, TZDate_1.default.nullableEq));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsYes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsYes !== undefined ? data.IsYes : false));
        this.LastAnswer = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastAnswer !== undefined ? new TZDate_1.default(data.LastAnswer) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Question = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Question !== undefined ? data.Question : ''));
        this.QuestionType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.QuestionType !== undefined ? data.QuestionType : 0));
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.TimeEntry = data && data.TimeEntry !== undefined ? new TopicCardTimeEntry_1.TopicCardTimeEntry(data.TimeEntry) : new TopicCardTimeEntry_1.TopicCardTimeEntry();
        this.Title = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Title !== undefined ? data.Title : ''));
    }
    TopicCard.key = function (obj) {
        return obj.Id();
    };
    TopicCard.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCard.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AmenityTypeId !== undefined)
                obj.AmenityTypeId(data.AmenityTypeId);
            if (data.AnsweredById !== undefined)
                obj.AnsweredById(data.AnsweredById);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.CommentsUrl !== undefined)
                obj.CommentsUrl(data.CommentsUrl);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.TemplateId !== undefined)
                obj.TemplateId(data.TemplateId);
            if (data.ConfirmedDate !== undefined)
                obj.ConfirmedDate(data.ConfirmedDate === null ? null : new TZDate_1.default(data.ConfirmedDate));
            if (data.DeniedDate !== undefined)
                obj.DeniedDate(data.DeniedDate === null ? null : new TZDate_1.default(data.DeniedDate));
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IsYes !== undefined)
                obj.IsYes(data.IsYes);
            if (data.LastAnswer !== undefined)
                obj.LastAnswer(new TZDate_1.default(data.LastAnswer));
            if (data.Question !== undefined)
                obj.Question(data.Question);
            if (data.QuestionType !== undefined)
                obj.QuestionType(data.QuestionType);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.TimeEntry !== undefined)
                TopicCardTimeEntry_1.TopicCardTimeEntry.update(obj.TimeEntry, data.TimeEntry);
            if (data.Title !== undefined)
                obj.Title(data.Title);
        });
    };
    return TopicCard;
}());
exports.TopicCard = TopicCard;


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardAvailableAttachment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardAvailableAttachment\ApiTopicCardAvailableAttachment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardAvailableAttachment = /** @class */ (function () {
    function TopicCardAvailableAttachment(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.AttachmentUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : ''));
        this.Card = s_js_1.default.value(null);
        this.CardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CardId !== undefined ? data.CardId : 0));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }
    TopicCardAvailableAttachment.key = function (obj) {
        return obj.Id();
    };
    TopicCardAvailableAttachment.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardAvailableAttachment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.AttachmentUrl !== undefined)
                obj.AttachmentUrl(data.AttachmentUrl);
            if (data.CardId !== undefined)
                obj.CardId(data.CardId);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
        });
    };
    return TopicCardAvailableAttachment;
}());
exports.TopicCardAvailableAttachment = TopicCardAvailableAttachment;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardChange = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardChange\ApiTopicCardChange.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardChange = /** @class */ (function () {
    function TopicCardChange(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Card = s_js_1.default.value(null);
        this.CardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CardId !== undefined ? data.CardId : 0));
        this.Comments = s_array_1.default([]);
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.NewSelectedOption = s_js_1.default.value(null);
        this.NewSelectedOptionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewSelectedOptionId !== undefined ? data.NewSelectedOptionId : 0));
        this.OldSelectedOption = s_js_1.default.value(null);
        this.OldSelectedOptionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldSelectedOptionId !== undefined ? data.OldSelectedOptionId : 0));
        this.OriginalCommentEvent = s_js_1.default.value(null);
        this.OriginalCommentEventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OriginalCommentEventId !== undefined ? data.OriginalCommentEventId : null));
        this.OriginalSelectedOption = s_js_1.default.value(null);
        this.OriginalSelectedOptionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OriginalSelectedOptionId !== undefined ? data.OriginalSelectedOptionId : null));
        this.NewIsYes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewIsYes !== undefined ? data.NewIsYes : false));
        this.NewStatus = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewStatus !== undefined ? data.NewStatus : 0));
        this.NewTimeEntryResponse = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewTimeEntryResponse !== undefined ? data.NewTimeEntryResponse === null ? null : new TZDate_1.default(data.NewTimeEntryResponse) : null, TZDate_1.default.nullableEq));
        this.OldStatus = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldStatus !== undefined ? data.OldStatus : 0));
        this.OldTimeEntryResponse = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldTimeEntryResponse !== undefined ? data.OldTimeEntryResponse === null ? null : new TZDate_1.default(data.OldTimeEntryResponse) : null, TZDate_1.default.nullableEq));
        this.OriginalIsYes = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OriginalIsYes !== undefined ? data.OriginalIsYes : false));
        this.OriginalTimeEntryResponse = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OriginalTimeEntryResponse !== undefined ? data.OriginalTimeEntryResponse === null ? null : new TZDate_1.default(data.OriginalTimeEntryResponse) : null, TZDate_1.default.nullableEq));
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : 0));
    }
    TopicCardChange.key = function (obj) {
        return obj.Id();
    };
    TopicCardChange.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardChange.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CardId !== undefined)
                obj.CardId(data.CardId);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.NewSelectedOptionId !== undefined)
                obj.NewSelectedOptionId(data.NewSelectedOptionId);
            if (data.OldSelectedOptionId !== undefined)
                obj.OldSelectedOptionId(data.OldSelectedOptionId);
            if (data.OriginalCommentEventId !== undefined)
                obj.OriginalCommentEventId(data.OriginalCommentEventId);
            if (data.OriginalSelectedOptionId !== undefined)
                obj.OriginalSelectedOptionId(data.OriginalSelectedOptionId);
            if (data.NewIsYes !== undefined)
                obj.NewIsYes(data.NewIsYes);
            if (data.NewStatus !== undefined)
                obj.NewStatus(data.NewStatus);
            if (data.NewTimeEntryResponse !== undefined)
                obj.NewTimeEntryResponse(data.NewTimeEntryResponse === null ? null : new TZDate_1.default(data.NewTimeEntryResponse));
            if (data.OldStatus !== undefined)
                obj.OldStatus(data.OldStatus);
            if (data.OldTimeEntryResponse !== undefined)
                obj.OldTimeEntryResponse(data.OldTimeEntryResponse === null ? null : new TZDate_1.default(data.OldTimeEntryResponse));
            if (data.OriginalIsYes !== undefined)
                obj.OriginalIsYes(data.OriginalIsYes);
            if (data.OriginalTimeEntryResponse !== undefined)
                obj.OriginalTimeEntryResponse(data.OriginalTimeEntryResponse === null ? null : new TZDate_1.default(data.OriginalTimeEntryResponse));
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return TopicCardChange;
}());
exports.TopicCardChange = TopicCardChange;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardOption = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardOption\ApiTopicCardOption.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardOption = /** @class */ (function () {
    function TopicCardOption(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Card = s_js_1.default.value(null);
        this.CardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CardId !== undefined ? data.CardId : 0));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Text = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Text !== undefined ? data.Text : ''));
    }
    TopicCardOption.key = function (obj) {
        return obj.Id();
    };
    TopicCardOption.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardOption.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CardId !== undefined)
                obj.CardId(data.CardId);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Text !== undefined)
                obj.Text(data.Text);
        });
    };
    return TopicCardOption;
}());
exports.TopicCardOption = TopicCardOption;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardSelectedOption = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardSelectedOption\ApiTopicCardSelectedOption.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardSelectedOption = /** @class */ (function () {
    function TopicCardSelectedOption(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Card = s_js_1.default.value(null);
        this.Option = s_js_1.default.value(null);
        this.OptionId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OptionId !== undefined ? data.OptionId : 0));
    }
    TopicCardSelectedOption.key = function (obj) {
        return obj.Id();
    };
    TopicCardSelectedOption.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardSelectedOption.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.OptionId !== undefined)
                obj.OptionId(data.OptionId);
        });
    };
    return TopicCardSelectedOption;
}());
exports.TopicCardSelectedOption = TopicCardSelectedOption;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplate = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplate\ApiTopicCardTemplate.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTemplateTimeEntry_1 = __webpack_require__(1362);
var TopicCardTemplate = /** @class */ (function () {
    function TopicCardTemplate(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AmenityType = s_js_1.default.value(null);
        this.AmenityTypeId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AmenityTypeId !== undefined ? data.AmenityTypeId : null));
        this.Attachments = s_array_1.default([]);
        this.AttachmentsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AttachmentsUrl !== undefined ? data.AttachmentsUrl : null));
        this.Options = s_array_1.default([]);
        this.OptionsUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OptionsUrl !== undefined ? data.OptionsUrl : null));
        this.Organization = s_js_1.default.value(null);
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.People = s_array_1.default([]);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.PeopleUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PeopleUrlBase !== undefined ? data.PeopleUrlBase : null));
        this.Question = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Question !== undefined ? data.Question : ''));
        this.QuestionType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.QuestionType !== undefined ? data.QuestionType : 0));
        this.Remarks = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Remarks !== undefined ? data.Remarks : null));
        this.TimeEntry = data && data.TimeEntry !== undefined ? new TopicCardTemplateTimeEntry_1.TopicCardTemplateTimeEntry(data.TimeEntry) : new TopicCardTemplateTimeEntry_1.TopicCardTemplateTimeEntry();
        this.Title = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Title !== undefined ? data.Title : ''));
    }
    TopicCardTemplate.key = function (obj) {
        return obj.Id();
    };
    TopicCardTemplate.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardTemplate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AmenityTypeId !== undefined)
                obj.AmenityTypeId(data.AmenityTypeId);
            if (data.AttachmentsUrl !== undefined)
                obj.AttachmentsUrl(data.AttachmentsUrl);
            if (data.OptionsUrl !== undefined)
                obj.OptionsUrl(data.OptionsUrl);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.PeopleUrlBase !== undefined)
                obj.PeopleUrlBase(data.PeopleUrlBase);
            if (data.Question !== undefined)
                obj.Question(data.Question);
            if (data.QuestionType !== undefined)
                obj.QuestionType(data.QuestionType);
            if (data.Remarks !== undefined)
                obj.Remarks(data.Remarks);
            if (data.TimeEntry !== undefined)
                TopicCardTemplateTimeEntry_1.TopicCardTemplateTimeEntry.update(obj.TimeEntry, data.TimeEntry);
            if (data.Title !== undefined)
                obj.Title(data.Title);
        });
    };
    return TopicCardTemplate;
}());
exports.TopicCardTemplate = TopicCardTemplate;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplateAttachment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateAttachment\ApiTopicCardTemplateAttachment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTemplateAttachment = /** @class */ (function () {
    function TopicCardTemplateAttachment(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.AttachmentUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : ''));
        this.Template = s_js_1.default.value(null);
        this.TemplateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }
    TopicCardTemplateAttachment.key = function (obj) {
        return obj.Id();
    };
    TopicCardTemplateAttachment.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardTemplateAttachment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AttachmentUrl !== undefined)
                obj.AttachmentUrl(data.AttachmentUrl);
            if (data.TemplateId !== undefined)
                obj.TemplateId(data.TemplateId);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
        });
    };
    return TopicCardTemplateAttachment;
}());
exports.TopicCardTemplateAttachment = TopicCardTemplateAttachment;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplateOption = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateOption\ApiTopicCardTempateOptions.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTemplateOption = /** @class */ (function () {
    function TopicCardTemplateOption(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Template = s_js_1.default.value(null);
        this.TemplateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.DisplayOrder = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Text = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Text !== undefined ? data.Text : ''));
    }
    TopicCardTemplateOption.key = function (obj) {
        return obj.Id();
    };
    TopicCardTemplateOption.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardTemplateOption.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.TemplateId !== undefined)
                obj.TemplateId(data.TemplateId);
            if (data.DisplayOrder !== undefined)
                obj.DisplayOrder(data.DisplayOrder);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.Text !== undefined)
                obj.Text(data.Text);
        });
    };
    return TopicCardTemplateOption;
}());
exports.TopicCardTemplateOption = TopicCardTemplateOption;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplateTimeEntry = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\TopicCards\TopicCardTemplateTimeEntry.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTemplateTimeEntry = /** @class */ (function () {
    function TopicCardTemplateTimeEntry(data) {
        if (data === void 0) { data = null; }
        this.HasTimeEntry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HasTimeEntry !== undefined ? data.HasTimeEntry : false));
        this.Label = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Label !== undefined ? data.Label : null));
    }
    TopicCardTemplateTimeEntry.key = function (obj) {
        return;
    };
    TopicCardTemplateTimeEntry.dataKey = function (obj) {
        return;
    };
    TopicCardTemplateTimeEntry.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.HasTimeEntry !== undefined)
                obj.HasTimeEntry(data.HasTimeEntry);
            if (data.Label !== undefined)
                obj.Label(data.Label);
        });
    };
    return TopicCardTemplateTimeEntry;
}());
exports.TopicCardTemplateTimeEntry = TopicCardTemplateTimeEntry;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTemplateUserAssignment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateUserAssignment\ApiTopicCardTemplateUserAssignment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTemplateUserAssignment = /** @class */ (function () {
    function TopicCardTemplateUserAssignment(data) {
        if (data === void 0) { data = null; }
        this.TemplateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Template = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
    }
    TopicCardTemplateUserAssignment.key = function (obj) {
        return obj.TemplateId() + '\u2618' + obj.UserId();
    };
    TopicCardTemplateUserAssignment.dataKey = function (obj) {
        return obj.TemplateId + '\u2618' + obj.UserId;
    };
    TopicCardTemplateUserAssignment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.TemplateId !== undefined)
                obj.TemplateId(data.TemplateId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
        });
    };
    return TopicCardTemplateUserAssignment;
}());
exports.TopicCardTemplateUserAssignment = TopicCardTemplateUserAssignment;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardTimeEntry = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\TopicCards\TopicCardTimeEntry.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardTimeEntry = /** @class */ (function () {
    function TopicCardTimeEntry(data) {
        if (data === void 0) { data = null; }
        this.HasTimeEntry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.HasTimeEntry !== undefined ? data.HasTimeEntry : false));
        this.Label = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Label !== undefined ? data.Label : null));
        this.Response = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Response !== undefined ? data.Response === null ? null : new TZDate_1.default(data.Response) : null, TZDate_1.default.nullableEq));
    }
    TopicCardTimeEntry.key = function (obj) {
        return;
    };
    TopicCardTimeEntry.dataKey = function (obj) {
        return;
    };
    TopicCardTimeEntry.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.HasTimeEntry !== undefined)
                obj.HasTimeEntry(data.HasTimeEntry);
            if (data.Label !== undefined)
                obj.Label(data.Label);
            if (data.Response !== undefined)
                obj.Response(data.Response === null ? null : new TZDate_1.default(data.Response));
        });
    };
    return TopicCardTimeEntry;
}());
exports.TopicCardTimeEntry = TopicCardTimeEntry;


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCardUserAssignment = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardUserAssignment\ApiTopicCardUserAssignment.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardUserAssignment = /** @class */ (function () {
    function TopicCardUserAssignment(data) {
        if (data === void 0) { data = null; }
        this.CardId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CardId !== undefined ? data.CardId : 0));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Card = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
    }
    TopicCardUserAssignment.key = function (obj) {
        return obj.CardId() + '\u2618' + obj.UserId();
    };
    TopicCardUserAssignment.dataKey = function (obj) {
        return obj.CardId + '\u2618' + obj.UserId;
    };
    TopicCardUserAssignment.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.CardId !== undefined)
                obj.CardId(data.CardId);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
        });
    };
    return TopicCardUserAssignment;
}());
exports.TopicCardUserAssignment = TopicCardUserAssignment;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicableTopicCardTemplate = exports.TopicCardViewModel = exports.TopicCardsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\TopicCards\TopicCardsResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var TopicCardsResponse = /** @class */ (function () {
    function TopicCardsResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.ApplicableTemplates = s_array_1.default([]);
        this.GetOrgId = jsonableObservable_1.jsonableObservable(s_array_1.default(data && data.GetOrgId !== undefined ? data.GetOrgId : []));
        this.PortCall = s_js_1.default.value(null);
        this.TopicCards = s_array_1.default([]);
        this.CanEditPortCall = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEditPortCall !== undefined ? data.CanEditPortCall : false));
        this.CanManageServices = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanManageServices !== undefined ? data.CanManageServices : false));
    }
    TopicCardsResponse.key = function (obj) {
        return obj.Id();
    };
    TopicCardsResponse.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.GetOrgId !== undefined)
                obj.GetOrgId(data.GetOrgId);
            if (data.CanEditPortCall !== undefined)
                obj.CanEditPortCall(data.CanEditPortCall);
            if (data.CanManageServices !== undefined)
                obj.CanManageServices(data.CanManageServices);
        });
    };
    return TopicCardsResponse;
}());
exports.TopicCardsResponse = TopicCardsResponse;
var TopicCardViewModel = /** @class */ (function () {
    function TopicCardViewModel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Card = s_js_1.default.value(null);
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.CanConfirm = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanConfirm !== undefined ? data.CanConfirm : false));
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }
    TopicCardViewModel.key = function (obj) {
        return obj.Id();
    };
    TopicCardViewModel.dataKey = function (obj) {
        return obj.Id;
    };
    TopicCardViewModel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.CanConfirm !== undefined)
                obj.CanConfirm(data.CanConfirm);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
        });
    };
    return TopicCardViewModel;
}());
exports.TopicCardViewModel = TopicCardViewModel;
var ApplicableTopicCardTemplate = /** @class */ (function () {
    function ApplicableTopicCardTemplate(data) {
        if (data === void 0) { data = null; }
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : null));
        this.PortCallId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.TemplateId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.Berth = s_js_1.default.value(null);
        this.Template = s_js_1.default.value(null);
        this.CanAnswer = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanAnswer !== undefined ? data.CanAnswer : false));
    }
    ApplicableTopicCardTemplate.key = function (obj) {
        return (obj.BerthId() === null ? NaN : obj.BerthId()) + '\u2618' + obj.PortCallId() + '\u2618' + obj.TemplateId();
    };
    ApplicableTopicCardTemplate.dataKey = function (obj) {
        return (obj.BerthId === null ? NaN : obj.BerthId) + '\u2618' + obj.PortCallId + '\u2618' + obj.TemplateId;
    };
    ApplicableTopicCardTemplate.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.PortCallId !== undefined)
                obj.PortCallId(data.PortCallId);
            if (data.TemplateId !== undefined)
                obj.TemplateId(data.TemplateId);
            if (data.CanAnswer !== undefined)
                obj.CanAnswer(data.CanAnswer);
        });
    };
    return ApplicableTopicCardTemplate;
}());
exports.ApplicableTopicCardTemplate = ApplicableTopicCardTemplate;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TugCompany = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\TugCompany\ApiTugCompany.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var TugCompany = /** @class */ (function () {
    function TugCompany(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PilotAgency = s_js_1.default.value(null);
        this.PilotAgencyId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.PilotJobOrders = s_array_1.default([]);
        this.Active = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Active !== undefined ? data.Active : false));
        this.Code = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Code !== undefined ? data.Code : ''));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    TugCompany.key = function (obj) {
        return obj.Id();
    };
    TugCompany.dataKey = function (obj) {
        return obj.Id;
    };
    TugCompany.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.PilotAgencyId !== undefined)
                obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Active !== undefined)
                obj.Active(data.Active);
            if (data.Code !== undefined)
                obj.Code(data.Code);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return TugCompany;
}());
exports.TugCompany = TugCompany;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UITheme = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\UITheme\ApiUITheme.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var UITheme = /** @class */ (function () {
    function UITheme(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.CssClasses = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CssClasses !== undefined ? data.CssClasses : ''));
        this.CssFile = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CssFile !== undefined ? data.CssFile : ''));
        this.Description = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Description !== undefined ? data.Description : ''));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : ''));
    }
    UITheme.key = function (obj) {
        return obj.Id();
    };
    UITheme.dataKey = function (obj) {
        return obj.Id;
    };
    UITheme.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.CssClasses !== undefined)
                obj.CssClasses(data.CssClasses);
            if (data.CssFile !== undefined)
                obj.CssFile(data.CssFile);
            if (data.Description !== undefined)
                obj.Description(data.Description);
            if (data.Name !== undefined)
                obj.Name(data.Name);
        });
    };
    return UITheme;
}());
exports.UITheme = UITheme;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlistedBerthReservation = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\UnlistedBerthReservation.cs
var s_js_1 = __webpack_require__(0);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var UnlistedBerthReservation = /** @class */ (function () {
    function UnlistedBerthReservation(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Berth = s_js_1.default.value(null);
        this.BerthId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.End = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.End !== undefined ? new TZDate_1.default(data.End) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement_1.Measurement(data.Footmark) : new Measurement_1.Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement_1.Measurement(data.Length) : new Measurement_1.Measurement();
        this.Start = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Start !== undefined ? new TZDate_1.default(data.Start) : new TZDate_1.default(0), TZDate_1.default.eq));
    }
    UnlistedBerthReservation.key = function (obj) {
        return obj.Id();
    };
    UnlistedBerthReservation.dataKey = function (obj) {
        return obj.Id;
    };
    UnlistedBerthReservation.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.BerthId !== undefined)
                obj.BerthId(data.BerthId);
            if (data.End !== undefined)
                obj.End(new TZDate_1.default(data.End));
            if (data.Footmark !== undefined)
                Measurement_1.Measurement.update(obj.Footmark, data.Footmark);
            if (data.Length !== undefined)
                Measurement_1.Measurement.update(obj.Length, data.Length);
            if (data.Start !== undefined)
                obj.Start(new TZDate_1.default(data.Start));
        });
    };
    return UnlistedBerthReservation;
}());
exports.UnlistedBerthReservation = UnlistedBerthReservation;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\User\ApiUser.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var User = /** @class */ (function () {
    function User(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.PCUser = s_js_1.default.value(null);
        this.Roles = s_array_1.default([]);
        this.AccessFailedCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AccessFailedCount !== undefined ? data.AccessFailedCount : 0));
        this.Email = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Email !== undefined ? data.Email : null));
        this.EmailConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EmailConfirmed !== undefined ? data.EmailConfirmed : false));
        this.LockoutEnabled = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LockoutEnabled !== undefined ? data.LockoutEnabled : false));
        this.LockoutEndDateUtc = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LockoutEndDateUtc !== undefined ? data.LockoutEndDateUtc === null ? null : new TZDate_1.default(data.LockoutEndDateUtc) : null, TZDate_1.default.nullableEq));
        this.PasswordHash = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PasswordHash !== undefined ? data.PasswordHash : null));
        this.PhoneNumber = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PhoneNumber !== undefined ? data.PhoneNumber : null));
        this.PhoneNumberConfirmed = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PhoneNumberConfirmed !== undefined ? data.PhoneNumberConfirmed : false));
        this.RolesUrlBase = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RolesUrlBase !== undefined ? data.RolesUrlBase : null));
        this.SecurityStamp = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SecurityStamp !== undefined ? data.SecurityStamp : null));
        this.TwoFactorEnabled = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.TwoFactorEnabled !== undefined ? data.TwoFactorEnabled : false));
        this.UserName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserName !== undefined ? data.UserName : null));
    }
    User.key = function (obj) {
        return obj.Id();
    };
    User.dataKey = function (obj) {
        return obj.Id;
    };
    User.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.AccessFailedCount !== undefined)
                obj.AccessFailedCount(data.AccessFailedCount);
            if (data.Email !== undefined)
                obj.Email(data.Email);
            if (data.EmailConfirmed !== undefined)
                obj.EmailConfirmed(data.EmailConfirmed);
            if (data.LockoutEnabled !== undefined)
                obj.LockoutEnabled(data.LockoutEnabled);
            if (data.LockoutEndDateUtc !== undefined)
                obj.LockoutEndDateUtc(data.LockoutEndDateUtc === null ? null : new TZDate_1.default(data.LockoutEndDateUtc));
            if (data.PasswordHash !== undefined)
                obj.PasswordHash(data.PasswordHash);
            if (data.PhoneNumber !== undefined)
                obj.PhoneNumber(data.PhoneNumber);
            if (data.PhoneNumberConfirmed !== undefined)
                obj.PhoneNumberConfirmed(data.PhoneNumberConfirmed);
            if (data.RolesUrlBase !== undefined)
                obj.RolesUrlBase(data.RolesUrlBase);
            if (data.SecurityStamp !== undefined)
                obj.SecurityStamp(data.SecurityStamp);
            if (data.TwoFactorEnabled !== undefined)
                obj.TwoFactorEnabled(data.TwoFactorEnabled);
            if (data.UserName !== undefined)
                obj.UserName(data.UserName);
        });
    };
    return User;
}());
exports.User = User;


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\UserPermissions\UserPermissionsViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var UserPermissionsResponse = /** @class */ (function () {
    function UserPermissionsResponse(data) {
        if (data === void 0) { data = null; }
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.AssignableRoles = s_array_1.default([]);
        this.Users = s_array_1.default([]);
    }
    UserPermissionsResponse.key = function (obj) {
        return obj.OrganizationId();
    };
    UserPermissionsResponse.dataKey = function (obj) {
        return obj.OrganizationId;
    };
    UserPermissionsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
        });
    };
    return UserPermissionsResponse;
}());
exports.UserPermissionsResponse = UserPermissionsResponse;


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\UserRole\ApiUserRole.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var UserRole = /** @class */ (function () {
    function UserRole(data) {
        if (data === void 0) { data = null; }
        this.RoleId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.RoleId !== undefined ? data.RoleId : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserId !== undefined ? data.UserId : 0));
        this.Role = s_js_1.default.value(null);
        this.User = s_js_1.default.value(null);
    }
    UserRole.key = function (obj) {
        return obj.RoleId() + '\u2618' + obj.UserId();
    };
    UserRole.dataKey = function (obj) {
        return obj.RoleId + '\u2618' + obj.UserId;
    };
    UserRole.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.RoleId !== undefined)
                obj.RoleId(data.RoleId);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.UserId !== undefined)
                obj.UserId(data.UserId);
        });
    };
    return UserRole;
}());
exports.UserRole = UserRole;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSummary = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\UserSummary\UserSummary.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var UserSummary = /** @class */ (function () {
    function UserSummary(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.OrganizationId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.CanViewPilotPages = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanViewPilotPages !== undefined ? data.CanViewPilotPages : false));
        this.FirstName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FirstName !== undefined ? data.FirstName : null));
        this.LandingPage = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LandingPage !== undefined ? data.LandingPage : null));
        this.LastName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LastName !== undefined ? data.LastName : null));
        this.OrganizationName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OrganizationName !== undefined ? data.OrganizationName : null));
        this.UserName = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.UserName !== undefined ? data.UserName : null));
    }
    UserSummary.key = function (obj) {
        return obj.Id();
    };
    UserSummary.dataKey = function (obj) {
        return obj.Id;
    };
    UserSummary.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.OrganizationId !== undefined)
                obj.OrganizationId(data.OrganizationId);
            if (data.CanViewPilotPages !== undefined)
                obj.CanViewPilotPages(data.CanViewPilotPages);
            if (data.FirstName !== undefined)
                obj.FirstName(data.FirstName);
            if (data.LandingPage !== undefined)
                obj.LandingPage(data.LandingPage);
            if (data.LastName !== undefined)
                obj.LastName(data.LastName);
            if (data.OrganizationName !== undefined)
                obj.OrganizationName(data.OrganizationName);
            if (data.UserName !== undefined)
                obj.UserName(data.UserName);
        });
    };
    return UserSummary;
}());
exports.UserSummary = UserSummary;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Vessel = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Vessel\ApiVessel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var BowThruster_1 = __webpack_require__(155);
var DeclarationOfSecurity_1 = __webpack_require__(156);
var Measurement_1 = __webpack_require__(11);
var Vessel = /** @class */ (function () {
    function Vessel(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Url !== undefined ? data.Url : null));
        this.Changes = s_array_1.default([]);
        this.Flag = s_js_1.default.value(null);
        this.FlagId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FlagId !== undefined ? data.FlagId : null));
        this.LloydServiceVessel = s_js_1.default.value(null);
        this.LloydServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LloydServiceVesselId !== undefined ? data.LloydServiceVesselId : null));
        this.MarineTrafficServiceVessel = s_js_1.default.value(null);
        this.MarineTrafficServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MarineTrafficServiceVesselId !== undefined ? data.MarineTrafficServiceVesselId : null));
        this.OverrideServiceVessel = s_js_1.default.value(null);
        this.PilotShiphandlingNotes = s_array_1.default([]);
        this.PilotShiphandlingNotesUrl = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PilotShiphandlingNotesUrl !== undefined ? data.PilotShiphandlingNotesUrl : null));
        this.PortCalls = s_array_1.default([]);
        this.PSixServiceVessel = s_js_1.default.value(null);
        this.PSixServiceVesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PSixServiceVesselId !== undefined ? data.PSixServiceVesselId : null));
        this.Alias = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Alias !== undefined ? data.Alias : null));
        this.AuditKey = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.AuditKey !== undefined ? data.AuditKey : null));
        this.Beam = data && data.Beam !== undefined ? new Measurement_1.NullableMeasurement(data.Beam) : new Measurement_1.NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster_1.BowThruster(data.BowThruster) : new BowThruster_1.BowThruster();
        this.CallSign = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CallSign !== undefined ? data.CallSign : null));
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity_1.DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity_1.DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new Measurement_1.NullableMeasurement(data.GrossTonnage) : new Measurement_1.NullableMeasurement();
        this.Guid = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IMO = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : false));
        this.Length = data && data.Length !== undefined ? new Measurement_1.NullableMeasurement(data.Length) : new Measurement_1.NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new Measurement_1.NullableMeasurement(data.MaxDraft) : new Measurement_1.NullableMeasurement();
        this.MMSID = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MMSID !== undefined ? data.MMSID : null));
        this.Name = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Name !== undefined ? data.Name : null));
        this.PortOfRegistry = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.Status = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Status !== undefined ? data.Status : 0));
        this.VesselType = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VIN !== undefined ? data.VIN : null));
    }
    Vessel.key = function (obj) {
        return obj.Id();
    };
    Vessel.dataKey = function (obj) {
        return obj.Id;
    };
    Vessel.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.Url !== undefined)
                obj.Url(data.Url);
            if (data.FlagId !== undefined)
                obj.FlagId(data.FlagId);
            if (data.LloydServiceVesselId !== undefined)
                obj.LloydServiceVesselId(data.LloydServiceVesselId);
            if (data.MarineTrafficServiceVesselId !== undefined)
                obj.MarineTrafficServiceVesselId(data.MarineTrafficServiceVesselId);
            if (data.PilotShiphandlingNotesUrl !== undefined)
                obj.PilotShiphandlingNotesUrl(data.PilotShiphandlingNotesUrl);
            if (data.PSixServiceVesselId !== undefined)
                obj.PSixServiceVesselId(data.PSixServiceVesselId);
            if (data.Alias !== undefined)
                obj.Alias(data.Alias);
            if (data.AuditKey !== undefined)
                obj.AuditKey(data.AuditKey);
            if (data.Beam !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined)
                BowThruster_1.BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined)
                obj.CallSign(data.CallSign);
            if (data.DOS !== undefined)
                DeclarationOfSecurity_1.DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined)
                obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined)
                Measurement_1.NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined)
                obj.Guid(data.Guid);
            if (data.IMO !== undefined)
                obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined)
                obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined)
                obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined)
                Measurement_1.NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined)
                Measurement_1.NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined)
                obj.MMSID(data.MMSID);
            if (data.Name !== undefined)
                obj.Name(data.Name);
            if (data.PortOfRegistry !== undefined)
                obj.PortOfRegistry(data.PortOfRegistry);
            if (data.Status !== undefined)
                obj.Status(data.Status);
            if (data.VesselType !== undefined)
                obj.VesselType(data.VesselType);
            if (data.VIN !== undefined)
                obj.VIN(data.VIN);
        });
    };
    return Vessel;
}());
exports.Vessel = Vessel;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselChange = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\VesselChange\ApiVesselChange.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var Measurement_1 = __webpack_require__(11);
var VesselChange = /** @class */ (function () {
    function VesselChange(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.Event = s_js_1.default.value(null);
        this.EventId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.EventId !== undefined ? data.EventId : 0));
        this.Vessel = s_js_1.default.value(null);
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.NewBowThrusterPresent = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.NewBowThrusterPresent !== undefined ? data.NewBowThrusterPresent : null));
        this.NewBowThrusterSize = data && data.NewBowThrusterSize !== undefined ? new Measurement_1.NullableMeasurement(data.NewBowThrusterSize) : new Measurement_1.NullableMeasurement();
        this.OldBowThrusterPresent = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.OldBowThrusterPresent !== undefined ? data.OldBowThrusterPresent : null));
        this.OldBowThrusterSize = data && data.OldBowThrusterSize !== undefined ? new Measurement_1.NullableMeasurement(data.OldBowThrusterSize) : new Measurement_1.NullableMeasurement();
        this.Type = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Type !== undefined ? data.Type : null));
    }
    VesselChange.key = function (obj) {
        return obj.Id();
    };
    VesselChange.dataKey = function (obj) {
        return obj.Id;
    };
    VesselChange.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
            if (data.EventId !== undefined)
                obj.EventId(data.EventId);
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.NewBowThrusterPresent !== undefined)
                obj.NewBowThrusterPresent(data.NewBowThrusterPresent);
            if (data.NewBowThrusterSize !== undefined)
                Measurement_1.NullableMeasurement.update(obj.NewBowThrusterSize, data.NewBowThrusterSize);
            if (data.OldBowThrusterPresent !== undefined)
                obj.OldBowThrusterPresent(data.OldBowThrusterPresent);
            if (data.OldBowThrusterSize !== undefined)
                Measurement_1.NullableMeasurement.update(obj.OldBowThrusterSize, data.OldBowThrusterSize);
            if (data.Type !== undefined)
                obj.Type(data.Type);
        });
    };
    return VesselChange;
}());
exports.VesselChange = VesselChange;


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselPortCallResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselPortCall\VesselPortCallResponse.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var TZDate_1 = __webpack_require__(7);
var jsonableObservable_1 = __webpack_require__(1);
var VesselPortCallResponse = /** @class */ (function () {
    function VesselPortCallResponse(data) {
        if (data === void 0) { data = null; }
        this.FromDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.FromDate !== undefined ? new TZDate_1.default(data.FromDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.ToDate = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.ToDate !== undefined ? new TZDate_1.default(data.ToDate) : new TZDate_1.default(0), TZDate_1.default.eq));
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.PortCalls = s_array_1.default([]);
        this.Vessel = s_js_1.default.value(null);
    }
    VesselPortCallResponse.key = function (obj) {
        return obj.FromDate().toJSON() + '\u2618' + obj.ToDate().toJSON() + '\u2618' + obj.VesselId();
    };
    VesselPortCallResponse.dataKey = function (obj) {
        return new TZDate_1.default(obj.FromDate).toJSON() + '\u2618' + new TZDate_1.default(obj.ToDate).toJSON() + '\u2618' + obj.VesselId;
    };
    VesselPortCallResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.FromDate !== undefined)
                obj.FromDate(new TZDate_1.default(data.FromDate));
            if (data.ToDate !== undefined)
                obj.ToDate(new TZDate_1.default(data.ToDate));
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
        });
    };
    return VesselPortCallResponse;
}());
exports.VesselPortCallResponse = VesselPortCallResponse;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceConfigure = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselServiceConfigure\VesselServiceConfigureResult.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var VesselServiceConfigure = /** @class */ (function () {
    function VesselServiceConfigure(data) {
        if (data === void 0) { data = null; }
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.DuplicateVessels = s_array_1.default([]);
        this.Vessel = s_js_1.default.value(null);
    }
    VesselServiceConfigure.key = function (obj) {
        return obj.VesselId();
    };
    VesselServiceConfigure.dataKey = function (obj) {
        return obj.VesselId;
    };
    VesselServiceConfigure.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
        });
    };
    return VesselServiceConfigure;
}());
exports.VesselServiceConfigure = VesselServiceConfigure;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceListing = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\VesselServiceListingViewModel.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var jsonableObservable_1 = __webpack_require__(1);
var VesselServiceListing = /** @class */ (function () {
    function VesselServiceListing(data) {
        if (data === void 0) { data = null; }
        this.SearchString = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.SearchString !== undefined ? data.SearchString : null));
        this.Status = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Status !== undefined ? data.Status : null));
        this.Vessels = s_array_1.default([]);
    }
    VesselServiceListing.key = function (obj) {
        return (obj.SearchString() === null ? '\u2603' : obj.SearchString()) + '\u2618' + (obj.Status() === null ? NaN : obj.Status());
    };
    VesselServiceListing.dataKey = function (obj) {
        return (obj.SearchString === null ? '\u2603' : obj.SearchString) + '\u2618' + (obj.Status === null ? NaN : obj.Status);
    };
    VesselServiceListing.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.SearchString !== undefined)
                obj.SearchString(data.SearchString);
            if (data.Status !== undefined)
                obj.Status(data.Status);
        });
    };
    return VesselServiceListing;
}());
exports.VesselServiceListing = VesselServiceListing;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceOverrideResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselServiceOverride\VesselServiceOverrideViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var VesselServiceOverrideResponse = /** @class */ (function () {
    function VesselServiceOverrideResponse(data) {
        if (data === void 0) { data = null; }
        this.VesselId = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.VesselId !== undefined ? data.VesselId : 0));
        this.Vessel = s_js_1.default.value(null);
        this.CanEdit = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }
    VesselServiceOverrideResponse.key = function (obj) {
        return obj.VesselId();
    };
    VesselServiceOverrideResponse.dataKey = function (obj) {
        return obj.VesselId;
    };
    VesselServiceOverrideResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.VesselId !== undefined)
                obj.VesselId(data.VesselId);
            if (data.CanEdit !== undefined)
                obj.CanEdit(data.CanEdit);
        });
    };
    return VesselServiceOverrideResponse;
}());
exports.VesselServiceOverrideResponse = VesselServiceOverrideResponse;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselServiceSettings = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\VesselServiceSettings.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var VesselServiceSettings = /** @class */ (function () {
    function VesselServiceSettings(data) {
        if (data === void 0) { data = null; }
        this.LloydServiceActive = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LloydServiceActive !== undefined ? data.LloydServiceActive : 0));
        this.LloydsRefreshThresholdDays = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.LloydsRefreshThresholdDays !== undefined ? data.LloydsRefreshThresholdDays : 0));
        this.MarineTrafficRefreshThresholdDays = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MarineTrafficRefreshThresholdDays !== undefined ? data.MarineTrafficRefreshThresholdDays : 0));
        this.MarineTrafficServiceActive = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.MarineTrafficServiceActive !== undefined ? data.MarineTrafficServiceActive : 0));
        this.PSixRefreshThresholdDays = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PSixRefreshThresholdDays !== undefined ? data.PSixRefreshThresholdDays : 0));
        this.PSixServiceActive = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.PSixServiceActive !== undefined ? data.PSixServiceActive : 0));
    }
    VesselServiceSettings.key = function (obj) {
        return;
    };
    VesselServiceSettings.dataKey = function (obj) {
        return;
    };
    VesselServiceSettings.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.LloydServiceActive !== undefined)
                obj.LloydServiceActive(data.LloydServiceActive);
            if (data.LloydsRefreshThresholdDays !== undefined)
                obj.LloydsRefreshThresholdDays(data.LloydsRefreshThresholdDays);
            if (data.MarineTrafficRefreshThresholdDays !== undefined)
                obj.MarineTrafficRefreshThresholdDays(data.MarineTrafficRefreshThresholdDays);
            if (data.MarineTrafficServiceActive !== undefined)
                obj.MarineTrafficServiceActive(data.MarineTrafficServiceActive);
            if (data.PSixRefreshThresholdDays !== undefined)
                obj.PSixRefreshThresholdDays(data.PSixRefreshThresholdDays);
            if (data.PSixServiceActive !== undefined)
                obj.PSixServiceActive(data.PSixServiceActive);
        });
    };
    return VesselServiceSettings;
}());
exports.VesselServiceSettings = VesselServiceSettings;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaDataCacheUpdateEntities = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\DataCache\WartsilaDataCacheUpdateEntities.cs
var s_js_1 = __webpack_require__(0);
var s_array_1 = __webpack_require__(3);
var WartsilaDataCacheUpdateEntities = /** @class */ (function () {
    function WartsilaDataCacheUpdateEntities(data) {
        if (data === void 0) { data = null; }
        this.EnhancedEstimateQueries = s_array_1.default([]);
        this.EnhancedEstimates = s_array_1.default([]);
    }
    WartsilaDataCacheUpdateEntities.key = function (obj) {
        return;
    };
    WartsilaDataCacheUpdateEntities.dataKey = function (obj) {
        return;
    };
    WartsilaDataCacheUpdateEntities.update = function (obj, data) {
        s_js_1.default.freeze(function () {
        });
    };
    return WartsilaDataCacheUpdateEntities;
}());
exports.WartsilaDataCacheUpdateEntities = WartsilaDataCacheUpdateEntities;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WartsilaEnrichmentsResponse = void 0;
// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\App\WartsilaEnrichments\WartsilaEnrichmentsViewModel.cs
var s_js_1 = __webpack_require__(0);
var jsonableObservable_1 = __webpack_require__(1);
var WartsilaEnrichmentsResponse = /** @class */ (function () {
    function WartsilaEnrichmentsResponse(data) {
        if (data === void 0) { data = null; }
        this.Id = jsonableObservable_1.jsonableObservable(s_js_1.default.value(data && data.Id !== undefined ? data.Id : 0));
        this.PortCall = s_js_1.default.value(null);
        this.RelevantQuery = s_js_1.default.value(null);
    }
    WartsilaEnrichmentsResponse.key = function (obj) {
        return obj.Id();
    };
    WartsilaEnrichmentsResponse.dataKey = function (obj) {
        return obj.Id;
    };
    WartsilaEnrichmentsResponse.update = function (obj, data) {
        s_js_1.default.freeze(function () {
            if (data.Id !== undefined)
                obj.Id(data.Id);
        });
    };
    return WartsilaEnrichmentsResponse;
}());
exports.WartsilaEnrichmentsResponse = WartsilaEnrichmentsResponse;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/bundle.js